(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {
'use strict';
angular.module('tmh.dynamicLocale', []).config(['$provide', function($provide) {
  function makeStateful($delegate) {
    $delegate.$stateful = true;
    return $delegate;
  }

  $provide.decorator('dateFilter', ['$delegate', makeStateful]);
  $provide.decorator('numberFilter', ['$delegate', makeStateful]);
  $provide.decorator('currencyFilter', ['$delegate', makeStateful]);

}])
.constant('tmhDynamicLocale.STORAGE_KEY', 'tmhDynamicLocale.locale')
.provider('tmhDynamicLocale', ['tmhDynamicLocale.STORAGE_KEY', function(STORAGE_KEY) {

  var defaultLocale,
    localeLocationPattern = 'angular/i18n/angular-locale_{{locale}}.js',
    nodeToAppend,
    storageFactory = 'tmhDynamicLocaleStorageCache',
    storage,
    storageKey = STORAGE_KEY,
    storageGet = 'get',
    storagePut = 'put',
    promiseCache = {},
    activeLocale,
    extraProperties = {};

  /**
   * Loads a script asynchronously
   *
   * @param {string} url The url for the script
   @ @param {function} callback A function to be called once the script is loaded
   */
  function loadScript(url, callback, errorCallback, $timeout) {
    var script = document.createElement('script'),
      element = nodeToAppend ? nodeToAppend : document.getElementsByTagName("body")[0],
      removed = false;

    script.type = 'text/javascript';
    if (script.readyState) { // IE
      script.onreadystatechange = function () {
        if (script.readyState === 'complete' ||
            script.readyState === 'loaded') {
          script.onreadystatechange = null;
          $timeout(
            function () {
              if (removed) return;
              removed = true;
              if (script.parentNode === element) {
                element.removeChild(script);
              }
              callback();
            }, 30, false);
        }
      };
    } else { // Others
      script.onload = function () {
        if (removed) return;
        removed = true;
        if (script.parentNode === element) {
          element.removeChild(script);
        }
        callback();
      };
      script.onerror = function () {
        if (removed) return;
        removed = true;
        if (script.parentNode === element) {
          element.removeChild(script);
        }
        errorCallback();
      };
    }
    script.src = url;
    script.async = true;
    element.appendChild(script);
  }

  /**
   * Loads a locale and replaces the properties from the current locale with the new locale information
   *
   * @param {string} localeUrl The path to the new locale
   * @param {Object} $locale The locale at the curent scope
   * @param {string} localeId The locale id to load
   * @param {Object} $rootScope The application $rootScope
   * @param {Object} $q The application $q
   * @param {Object} localeCache The current locale cache
   * @param {Object} $timeout The application $timeout
   */
  function loadLocale(localeUrl, $locale, localeId, $rootScope, $q, localeCache, $timeout) {

    function overrideValues(oldObject, newObject) {
      if (activeLocale !== localeId) {
        return;
      }
      angular.forEach(oldObject, function(value, key) {
        if (!newObject[key]) {
          delete oldObject[key];
        } else if (angular.isArray(newObject[key])) {
          oldObject[key].length = newObject[key].length;
        }
      });
      angular.forEach(newObject, function(value, key) {
        if (angular.isArray(newObject[key]) || angular.isObject(newObject[key])) {
          if (!oldObject[key]) {
            oldObject[key] = angular.isArray(newObject[key]) ? [] : {};
          }
          overrideValues(oldObject[key], newObject[key]);
        } else {
          oldObject[key] = newObject[key];
        }
      });
    }


    if (promiseCache[localeId]) {
      activeLocale = localeId;
      return promiseCache[localeId];
    }

    var cachedLocale,
      deferred = $q.defer();
    if (localeId === activeLocale) {
      deferred.resolve($locale);
    } else if ((cachedLocale = localeCache.get(localeId))) {
      activeLocale = localeId;
      $rootScope.$evalAsync(function() {
        overrideValues($locale, cachedLocale);
        storage[storagePut](storageKey, localeId);
        $rootScope.$broadcast('$localeChangeSuccess', localeId, $locale);
        deferred.resolve($locale);
      });
    } else {
      activeLocale = localeId;
      promiseCache[localeId] = deferred.promise;
      loadScript(localeUrl, function() {
        // Create a new injector with the new locale
        var localInjector = angular.injector(['ngLocale']),
          externalLocale = localInjector.get('$locale');

        overrideValues($locale, externalLocale);
        localeCache.put(localeId, externalLocale);
        delete promiseCache[localeId];

        $rootScope.$applyAsync(function() {
          storage[storagePut](storageKey, localeId);
          $rootScope.$broadcast('$localeChangeSuccess', localeId, $locale);
          deferred.resolve($locale);
        });
      }, function() {
        delete promiseCache[localeId];

        $rootScope.$applyAsync(function() {
          if (activeLocale === localeId) {
            activeLocale = $locale.id;
          }
          $rootScope.$broadcast('$localeChangeError', localeId);
          deferred.reject(localeId);
        });
      }, $timeout);
    }
    return deferred.promise;
  }

  this.localeLocationPattern = function(value) {
    if (value) {
      localeLocationPattern = value;
      return this;
    } else {
      return localeLocationPattern;
    }
  };

  this.appendScriptTo = function(nodeElement) {
    nodeToAppend = nodeElement;
  };

  this.useStorage = function(storageName) {
    storageFactory = storageName;
    storageGet = 'get';
    storagePut = 'put';
  };

  this.useCookieStorage = function() {
    if (angular.version.minor < 7) {
      this.useStorage('$cookieStore');
    } else {
      this.useStorage('$cookies');
      storageGet = 'getObject';
      storagePut = 'putObject';
    }
  };

  this.defaultLocale = function(value) {
    defaultLocale = value;
  };

  this.storageKey = function(value) {
    if (value) {
      storageKey = value;
      return this;
    } else {
      return storageKey;
    }
  };

  this.addLocalePatternValue = function(key, value) {
    extraProperties[key] = value;
  };

  this.$get = ['$rootScope', '$injector', '$interpolate', '$locale', '$q', 'tmhDynamicLocaleCache', '$timeout', function($rootScope, $injector, interpolate, locale, $q, tmhDynamicLocaleCache, $timeout) {
    var localeLocation = interpolate(localeLocationPattern);

    storage = $injector.get(storageFactory);
    $rootScope.$evalAsync(function() {
      var initialLocale;
      if ((initialLocale = (storage[storageGet](storageKey) || defaultLocale))) {
        loadLocaleFn(initialLocale);
      }
    });
    return {
      /**
       * @ngdoc method
       * @description
       * @param {string} value Sets the locale to the new locale. Changing the locale will trigger
       *    a background task that will retrieve the new locale and configure the current $locale
       *    instance with the information from the new locale
       */
      set: loadLocaleFn,
      /**
       * @ngdoc method
       * @description Returns the configured locale
       */
      get: function() {
        return activeLocale;
      }
    };

    function loadLocaleFn(localeId) {
      var baseProperties = {locale: localeId, angularVersion: angular.version.full};
      return loadLocale(localeLocation(angular.extend({}, extraProperties, baseProperties)), locale, localeId, $rootScope, $q, tmhDynamicLocaleCache, $timeout);
    }
  }];
}]).provider('tmhDynamicLocaleCache', function() {
  this.$get = ['$cacheFactory', function($cacheFactory) {
    return $cacheFactory('tmh.dynamicLocales');
  }];
}).provider('tmhDynamicLocaleStorageCache', function() {
  this.$get = ['$cacheFactory', function($cacheFactory) {
    return $cacheFactory('tmh.dynamicLocales.store');
  }];
}).run(['tmhDynamicLocale', angular.noop]);

return 'tmh.dynamicLocale';

}));

},{}],2:[function(require,module,exports){
/**
 * @license AngularJS v1.7.9
 * (c) 2010-2018 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

var forEach;
var isArray;
var isString;
var jqLite;

/**
 * @ngdoc module
 * @name ngMessages
 * @description
 *
 * The `ngMessages` module provides enhanced support for displaying messages within templates
 * (typically within forms or when rendering message objects that return key/value data).
 * Instead of relying on JavaScript code and/or complex ng-if statements within your form template to
 * show and hide error messages specific to the state of an input field, the `ngMessages` and
 * `ngMessage` directives are designed to handle the complexity, inheritance and priority
 * sequencing based on the order of how the messages are defined in the template.
 *
 * Currently, the ngMessages module only contains the code for the `ngMessages`, `ngMessagesInclude`
 * `ngMessage`, `ngMessageExp` and `ngMessageDefault` directives.
 *
 * ## Usage
 * The `ngMessages` directive allows keys in a key/value collection to be associated with a child element
 * (or 'message') that will show or hide based on the truthiness of that key's value in the collection. A common use
 * case for `ngMessages` is to display error messages for inputs using the `$error` object exposed by the
 * {@link ngModel ngModel} directive.
 *
 * The child elements of the `ngMessages` directive are matched to the collection keys by a `ngMessage` or
 * `ngMessageExp` directive. The value of these attributes must match a key in the collection that is provided by
 * the `ngMessages` directive.
 *
 * Consider the following example, which illustrates a typical use case of `ngMessages`. Within the form `myForm` we
 * have a text input named `myField` which is bound to the scope variable `field` using the {@link ngModel ngModel}
 * directive.
 *
 * The `myField` field is a required input of type `email` with a maximum length of 15 characters.
 *
 * ```html
 * <form name="myForm">
 *   <label>
 *     Enter text:
 *     <input type="email" ng-model="field" name="myField" required maxlength="15" />
 *   </label>
 *   <div ng-messages="myForm.myField.$error" role="alert">
 *     <div ng-message="required">Please enter a value for this field.</div>
 *     <div ng-message="email">This field must be a valid email address.</div>
 *     <div ng-message="maxlength">This field can be at most 15 characters long.</div>
 *   </div>
 * </form>
 * ```
 *
 * In order to show error messages corresponding to `myField` we first create an element with an `ngMessages` attribute
 * set to the `$error` object owned by the `myField` input in our `myForm` form.
 *
 * Within this element we then create separate elements for each of the possible errors that `myField` could have.
 * The `ngMessage` attribute is used to declare which element(s) will appear for which error - for example,
 * setting `ng-message="required"` specifies that this particular element should be displayed when there
 * is no value present for the required field `myField` (because the key `required` will be `true` in the object
 * `myForm.myField.$error`).
 *
 * ### Message order
 *
 * By default, `ngMessages` will only display one message for a particular key/value collection at any time. If more
 * than one message (or error) key is currently true, then which message is shown is determined by the order of messages
 * in the HTML template code (messages declared first are prioritised). This mechanism means the developer does not have
 * to prioritize messages using custom JavaScript code.
 *
 * Given the following error object for our example (which informs us that the field `myField` currently has both the
 * `required` and `email` errors):
 *
 * ```javascript
 * <!-- keep in mind that ngModel automatically sets these error flags -->
 * myField.$error = { required : true, email: true, maxlength: false };
 * ```
 * The `required` message will be displayed to the user since it appears before the `email` message in the DOM.
 * Once the user types a single character, the `required` message will disappear (since the field now has a value)
 * but the `email` message will be visible because it is still applicable.
 *
 * ### Displaying multiple messages at the same time
 *
 * While `ngMessages` will by default only display one error element at a time, the `ng-messages-multiple` attribute can
 * be applied to the `ngMessages` container element to cause it to display all applicable error messages at once:
 *
 * ```html
 * <!-- attribute-style usage -->
 * <div ng-messages="myForm.myField.$error" ng-messages-multiple>...</div>
 *
 * <!-- element-style usage -->
 * <ng-messages for="myForm.myField.$error" multiple>...</ng-messages>
 * ```
 *
 * ## Reusing and Overriding Messages
 * In addition to prioritization, ngMessages also allows for including messages from a remote or an inline
 * template. This allows for generic collection of messages to be reused across multiple parts of an
 * application.
 *
 * ```html
 * <script type="text/ng-template" id="error-messages">
 *   <div ng-message="required">This field is required</div>
 *   <div ng-message="minlength">This field is too short</div>
 * </script>
 *
 * <div ng-messages="myForm.myField.$error" role="alert">
 *   <div ng-messages-include="error-messages"></div>
 * </div>
 * ```
 *
 * However, including generic messages may not be useful enough to match all input fields, therefore,
 * `ngMessages` provides the ability to override messages defined in the remote template by redefining
 * them within the directive container.
 *
 * ```html
 * <!-- a generic template of error messages known as "my-custom-messages" -->
 * <script type="text/ng-template" id="my-custom-messages">
 *   <div ng-message="required">This field is required</div>
 *   <div ng-message="minlength">This field is too short</div>
 * </script>
 *
 * <form name="myForm">
 *   <label>
 *     Email address
 *     <input type="email"
 *            id="email"
 *            name="myEmail"
 *            ng-model="email"
 *            minlength="5"
 *            required />
 *   </label>
 *   <!-- any ng-message elements that appear BEFORE the ng-messages-include will
 *        override the messages present in the ng-messages-include template -->
 *   <div ng-messages="myForm.myEmail.$error" role="alert">
 *     <!-- this required message has overridden the template message -->
 *     <div ng-message="required">You did not enter your email address</div>
 *
 *     <!-- this is a brand new message and will appear last in the prioritization -->
 *     <div ng-message="email">Your email address is invalid</div>
 *
 *     <!-- and here are the generic error messages -->
 *     <div ng-messages-include="my-custom-messages"></div>
 *   </div>
 * </form>
 * ```
 *
 * In the example HTML code above the message that is set on required will override the corresponding
 * required message defined within the remote template. Therefore, with particular input fields (such
 * email addresses, date fields, autocomplete inputs, etc...), specialized error messages can be applied
 * while more generic messages can be used to handle other, more general input errors.
 *
 * ## Dynamic Messaging
 * ngMessages also supports using expressions to dynamically change key values. Using arrays and
 * repeaters to list messages is also supported. This means that the code below will be able to
 * fully adapt itself and display the appropriate message when any of the expression data changes:
 *
 * ```html
 * <form name="myForm">
 *   <label>
 *     Email address
 *     <input type="email"
 *            name="myEmail"
 *            ng-model="email"
 *            minlength="5"
 *            required />
 *   </label>
 *   <div ng-messages="myForm.myEmail.$error" role="alert">
 *     <div ng-message="required">You did not enter your email address</div>
 *     <div ng-repeat="errorMessage in errorMessages">
 *       <!-- use ng-message-exp for a message whose key is given by an expression -->
 *       <div ng-message-exp="errorMessage.type">{{ errorMessage.text }}</div>
 *     </div>
 *   </div>
 * </form>
 * ```
 *
 * The `errorMessage.type` expression can be a string value or it can be an array so
 * that multiple errors can be associated with a single error message:
 *
 * ```html
 *   <label>
 *     Email address
 *     <input type="email"
 *            ng-model="data.email"
 *            name="myEmail"
 *            ng-minlength="5"
 *            ng-maxlength="100"
 *            required />
 *   </label>
 *   <div ng-messages="myForm.myEmail.$error" role="alert">
 *     <div ng-message-exp="'required'">You did not enter your email address</div>
 *     <div ng-message-exp="['minlength', 'maxlength']">
 *       Your email must be between 5 and 100 characters long
 *     </div>
 *   </div>
 * ```
 *
 * Feel free to use other structural directives such as ng-if and ng-switch to further control
 * what messages are active and when. Be careful, if you place ng-message on the same element
 * as these structural directives, AngularJS may not be able to determine if a message is active
 * or not. Therefore it is best to place the ng-message on a child element of the structural
 * directive.
 *
 * ```html
 * <div ng-messages="myForm.myEmail.$error" role="alert">
 *   <div ng-if="showRequiredError">
 *     <div ng-message="required">Please enter something</div>
 *   </div>
 * </div>
 * ```
 *
 * ## Animations
 * If the `ngAnimate` module is active within the application then the `ngMessages`, `ngMessage` and
 * `ngMessageExp` directives will trigger animations whenever any messages are added and removed from
 * the DOM by the `ngMessages` directive.
 *
 * Whenever the `ngMessages` directive contains one or more visible messages then the `.ng-active` CSS
 * class will be added to the element. The `.ng-inactive` CSS class will be applied when there are no
 * messages present. Therefore, CSS transitions and keyframes as well as JavaScript animations can
 * hook into the animations whenever these classes are added/removed.
 *
 * Let's say that our HTML code for our messages container looks like so:
 *
 * ```html
 * <div ng-messages="myMessages" class="my-messages" role="alert">
 *   <div ng-message="alert" class="some-message">...</div>
 *   <div ng-message="fail" class="some-message">...</div>
 * </div>
 * ```
 *
 * Then the CSS animation code for the message container looks like so:
 *
 * ```css
 * .my-messages {
 *   transition:1s linear all;
 * }
 * .my-messages.ng-active {
 *   // messages are visible
 * }
 * .my-messages.ng-inactive {
 *   // messages are hidden
 * }
 * ```
 *
 * Whenever an inner message is attached (becomes visible) or removed (becomes hidden) then the enter
 * and leave animation is triggered for each particular element bound to the `ngMessage` directive.
 *
 * Therefore, the CSS code for the inner messages looks like so:
 *
 * ```css
 * .some-message {
 *   transition:1s linear all;
 * }
 *
 * .some-message.ng-enter {}
 * .some-message.ng-enter.ng-enter-active {}
 *
 * .some-message.ng-leave {}
 * .some-message.ng-leave.ng-leave-active {}
 * ```
 *
 * {@link ngAnimate See the ngAnimate docs} to learn how to use JavaScript animations or to learn
 * more about ngAnimate.
 *
 * ## Displaying a default message
 * If the ngMessages renders no inner ngMessage directive (i.e. when none of the truthy
 * keys are matched by a defined message), then it will render a default message
 * using the {@link ngMessageDefault} directive.
 * Note that matched messages will always take precedence over unmatched messages. That means
 * the default message will not be displayed when another message is matched. This is also
 * true for `ng-messages-multiple`.
 *
 * ```html
 * <div ng-messages="myForm.myField.$error" role="alert">
 *   <div ng-message="required">This field is required</div>
 *   <div ng-message="minlength">This field is too short</div>
 *   <div ng-message-default>This field has an input error</div>
 * </div>
 * ```
 *

 */
angular.module('ngMessages', [], function initAngularHelpers() {
  // Access helpers from AngularJS core.
  // Do it inside a `config` block to ensure `window.angular` is available.
  forEach = angular.forEach;
  isArray = angular.isArray;
  isString = angular.isString;
  jqLite = angular.element;
})
  .info({ angularVersion: '1.7.9' })

  /**
   * @ngdoc directive
   * @module ngMessages
   * @name ngMessages
   * @restrict AE
   *
   * @description
   * `ngMessages` is a directive that is designed to show and hide messages based on the state
   * of a key/value object that it listens on. The directive itself complements error message
   * reporting with the `ngModel` $error object (which stores a key/value state of validation errors).
   *
   * `ngMessages` manages the state of internal messages within its container element. The internal
   * messages use the `ngMessage` directive and will be inserted/removed from the page depending
   * on if they're present within the key/value object. By default, only one message will be displayed
   * at a time and this depends on the prioritization of the messages within the template. (This can
   * be changed by using the `ng-messages-multiple` or `multiple` attribute on the directive container.)
   *
   * A remote template can also be used (With {@link ngMessagesInclude}) to promote message
   * reusability and messages can also be overridden.
   *
   * A default message can also be displayed when no `ngMessage` directive is inserted, using the
   * {@link ngMessageDefault} directive.
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-message="stringValue">...</ANY>
   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
   *   <ANY ng-message-exp="expressionValue">...</ANY>
   *   <ANY ng-message-default>...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-message when="stringValue">...</ng-message>
   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
   *   <ng-message when-exp="expressionValue">...</ng-message>
   *   <ng-message-default>...</ng-message-default>
   * </ng-messages>
   * ```
   *
   * @param {string} ngMessages an AngularJS expression evaluating to a key/value object
   *                 (this is typically the $error object on an ngModel instance).
   * @param {string=} ngMessagesMultiple|multiple when set, all messages will be displayed with true
   *
   * @example
   * <example name="ngMessages-directive" module="ngMessagesExample"
   *          deps="angular-messages.js"
   *          animations="true" fixBase="true">
   *   <file name="index.html">
   *     <form name="myForm">
   *       <label>
   *         Enter your name:
   *         <input type="text"
   *                name="myName"
   *                ng-model="name"
   *                ng-minlength="5"
   *                ng-maxlength="20"
   *                required />
   *       </label>
   *       <pre>myForm.myName.$error = {{ myForm.myName.$error | json }}</pre>
   *
   *       <div ng-messages="myForm.myName.$error" style="color:maroon" role="alert">
   *         <div ng-message="required">You did not enter a field</div>
   *         <div ng-message="minlength">Your field is too short</div>
   *         <div ng-message="maxlength">Your field is too long</div>
   *         <div ng-message-default>This field has an input error</div>
   *       </div>
   *     </form>
   *   </file>
   *   <file name="script.js">
   *     angular.module('ngMessagesExample', ['ngMessages']);
   *   </file>
   * </example>
   */
  .directive('ngMessages', ['$animate', function($animate) {
    var ACTIVE_CLASS = 'ng-active';
    var INACTIVE_CLASS = 'ng-inactive';

    return {
      require: 'ngMessages',
      restrict: 'AE',
      controller: ['$element', '$scope', '$attrs', function NgMessagesCtrl($element, $scope, $attrs) {
        var ctrl = this;
        var latestKey = 0;
        var nextAttachId = 0;

        this.getAttachId = function getAttachId() { return nextAttachId++; };

        var messages = this.messages = {};
        var renderLater, cachedCollection;

        this.render = function(collection) {
          collection = collection || {};

          renderLater = false;
          cachedCollection = collection;

          // this is true if the attribute is empty or if the attribute value is truthy
          var multiple = isAttrTruthy($scope, $attrs.ngMessagesMultiple) ||
                         isAttrTruthy($scope, $attrs.multiple);

          var unmatchedMessages = [];
          var matchedKeys = {};
          var truthyKeys = 0;
          var messageItem = ctrl.head;
          var messageFound = false;
          var totalMessages = 0;

          // we use != instead of !== to allow for both undefined and null values
          while (messageItem != null) {
            totalMessages++;
            var messageCtrl = messageItem.message;

            var messageUsed = false;
            if (!messageFound) {
              forEach(collection, function(value, key) {
                if (truthy(value) && !messageUsed) {
                  truthyKeys++;

                  if (messageCtrl.test(key)) {
                    // this is to prevent the same error name from showing up twice
                    if (matchedKeys[key]) return;
                    matchedKeys[key] = true;

                    messageUsed = true;
                    messageCtrl.attach();
                  }
                }
              });
            }

            if (messageUsed) {
              // unless we want to display multiple messages then we should
              // set a flag here to avoid displaying the next message in the list
              messageFound = !multiple;
            } else {
              unmatchedMessages.push(messageCtrl);
            }

            messageItem = messageItem.next;
          }

          forEach(unmatchedMessages, function(messageCtrl) {
            messageCtrl.detach();
          });

          var messageMatched = unmatchedMessages.length !== totalMessages;
          var attachDefault = ctrl.default && !messageMatched && truthyKeys > 0;

          if (attachDefault) {
            ctrl.default.attach();
          } else if (ctrl.default) {
            ctrl.default.detach();
          }

          if (messageMatched || attachDefault) {
            $animate.setClass($element, ACTIVE_CLASS, INACTIVE_CLASS);
          } else {
            $animate.setClass($element, INACTIVE_CLASS, ACTIVE_CLASS);
          }
        };

        $scope.$watchCollection($attrs.ngMessages || $attrs['for'], ctrl.render);

        this.reRender = function() {
          if (!renderLater) {
            renderLater = true;
            $scope.$evalAsync(function() {
              if (renderLater && cachedCollection) {
                ctrl.render(cachedCollection);
              }
            });
          }
        };

        this.register = function(comment, messageCtrl, isDefault) {
          if (isDefault) {
            ctrl.default = messageCtrl;
          } else {
            var nextKey = latestKey.toString();
            messages[nextKey] = {
              message: messageCtrl
            };
            insertMessageNode($element[0], comment, nextKey);
            comment.$$ngMessageNode = nextKey;
            latestKey++;
          }

          ctrl.reRender();
        };

        this.deregister = function(comment, isDefault) {
          if (isDefault) {
            delete ctrl.default;
          } else {
            var key = comment.$$ngMessageNode;
            delete comment.$$ngMessageNode;
            removeMessageNode($element[0], comment, key);
            delete messages[key];
          }
          ctrl.reRender();
        };

        function findPreviousMessage(parent, comment) {
          var prevNode = comment;
          var parentLookup = [];

          while (prevNode && prevNode !== parent) {
            var prevKey = prevNode.$$ngMessageNode;
            if (prevKey && prevKey.length) {
              return messages[prevKey];
            }

            // dive deeper into the DOM and examine its children for any ngMessage
            // comments that may be in an element that appears deeper in the list
            if (prevNode.childNodes.length && parentLookup.indexOf(prevNode) === -1) {
              parentLookup.push(prevNode);
              prevNode = prevNode.childNodes[prevNode.childNodes.length - 1];
            } else if (prevNode.previousSibling) {
              prevNode = prevNode.previousSibling;
            } else {
              prevNode = prevNode.parentNode;
              parentLookup.push(prevNode);
            }
          }
        }

        function insertMessageNode(parent, comment, key) {
          var messageNode = messages[key];
          if (!ctrl.head) {
            ctrl.head = messageNode;
          } else {
            var match = findPreviousMessage(parent, comment);
            if (match) {
              messageNode.next = match.next;
              match.next = messageNode;
            } else {
              messageNode.next = ctrl.head;
              ctrl.head = messageNode;
            }
          }
        }

        function removeMessageNode(parent, comment, key) {
          var messageNode = messages[key];

          // This message node may have already been removed by a call to deregister()
          if (!messageNode) return;

          var match = findPreviousMessage(parent, comment);
          if (match) {
            match.next = messageNode.next;
          } else {
            ctrl.head = messageNode.next;
          }
        }
      }]
    };

    function isAttrTruthy(scope, attr) {
     return (isString(attr) && attr.length === 0) || //empty attribute
            truthy(scope.$eval(attr));
    }

    function truthy(val) {
      return isString(val) ? val.length : !!val;
    }
  }])

  /**
   * @ngdoc directive
   * @name ngMessagesInclude
   * @restrict AE
   * @scope
   *
   * @description
   * `ngMessagesInclude` is a directive with the purpose to import existing ngMessage template
   * code from a remote template and place the downloaded template code into the exact spot
   * that the ngMessagesInclude directive is placed within the ngMessages container. This allows
   * for a series of pre-defined messages to be reused and also allows for the developer to
   * determine what messages are overridden due to the placement of the ngMessagesInclude directive.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-messages-include="remoteTplString">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-messages-include src="expressionValue1">...</ng-messages-include>
   * </ng-messages>
   * ```
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @param {string} ngMessagesInclude|src a string value corresponding to the remote template.
   */
  .directive('ngMessagesInclude',
    ['$templateRequest', '$document', '$compile', function($templateRequest, $document, $compile) {

    return {
      restrict: 'AE',
      require: '^^ngMessages', // we only require this for validation sake
      link: function($scope, element, attrs) {
        var src = attrs.ngMessagesInclude || attrs.src;
        $templateRequest(src).then(function(html) {
          if ($scope.$$destroyed) return;

          if (isString(html) && !html.trim()) {
            // Empty template - nothing to compile
            replaceElementWithMarker(element, src);
          } else {
            // Non-empty template - compile and link
            $compile(html)($scope, function(contents) {
              element.after(contents);
              replaceElementWithMarker(element, src);
            });
          }
        });
      }
    };

    // Helpers
    function replaceElementWithMarker(element, src) {
      // A comment marker is placed for debugging purposes
      var comment = $compile.$$createComment ?
          $compile.$$createComment('ngMessagesInclude', src) :
          $document[0].createComment(' ngMessagesInclude: ' + src + ' ');
      var marker = jqLite(comment);
      element.after(marker);

      // Don't pollute the DOM anymore by keeping an empty directive element
      element.remove();
    }
  }])

  /**
   * @ngdoc directive
   * @name ngMessage
   * @restrict AE
   * @scope
   * @priority 1
   *
   * @description
   * `ngMessage` is a directive with the purpose to show and hide a particular message.
   * For `ngMessage` to operate, a parent `ngMessages` directive on a parent DOM element
   * must be situated since it determines which messages are visible based on the state
   * of the provided key/value map that `ngMessages` listens on.
   *
   * More information about using `ngMessage` can be found in the
   * {@link module:ngMessages `ngMessages` module documentation}.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-message="stringValue">...</ANY>
   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-message when="stringValue">...</ng-message>
   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
   * </ng-messages>
   * ```
   *
   * @param {expression} ngMessage|when a string value corresponding to the message key.
   */
  .directive('ngMessage', ngMessageDirectiveFactory())


  /**
   * @ngdoc directive
   * @name ngMessageExp
   * @restrict AE
   * @priority 1
   * @scope
   *
   * @description
   * `ngMessageExp` is the same as {@link directive:ngMessage `ngMessage`}, but instead of a static
   * value, it accepts an expression to be evaluated for the message key.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression">
   *   <ANY ng-message-exp="expressionValue">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression">
   *   <ng-message when-exp="expressionValue">...</ng-message>
   * </ng-messages>
   * ```
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @param {expression} ngMessageExp|whenExp an expression value corresponding to the message key.
   */
  .directive('ngMessageExp', ngMessageDirectiveFactory())

  /**
   * @ngdoc directive
   * @name ngMessageDefault
   * @restrict AE
   * @scope
   *
   * @description
   * `ngMessageDefault` is a directive with the purpose to show and hide a default message for
   * {@link directive:ngMessages}, when none of provided messages matches.
   *
   * More information about using `ngMessageDefault` can be found in the
   * {@link module:ngMessages `ngMessages` module documentation}.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-message="stringValue">...</ANY>
   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
   *   <ANY ng-message-default>...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-message when="stringValue">...</ng-message>
   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
   *   <ng-message-default>...</ng-message-default>
   * </ng-messages>
   *
  */
  .directive('ngMessageDefault', ngMessageDirectiveFactory(true));

function ngMessageDirectiveFactory(isDefault) {
  return ['$animate', function($animate) {
    return {
      restrict: 'AE',
      transclude: 'element',
      priority: 1, // must run before ngBind, otherwise the text is set on the comment
      terminal: true,
      require: '^^ngMessages',
      link: function(scope, element, attrs, ngMessagesCtrl, $transclude) {
        var commentNode, records, staticExp, dynamicExp;

        if (!isDefault) {
          commentNode = element[0];
          staticExp = attrs.ngMessage || attrs.when;
          dynamicExp = attrs.ngMessageExp || attrs.whenExp;

          var assignRecords = function(items) {
            records = items
                ? (isArray(items)
                      ? items
                      : items.split(/[\s,]+/))
                : null;
            ngMessagesCtrl.reRender();
          };

          if (dynamicExp) {
            assignRecords(scope.$eval(dynamicExp));
            scope.$watchCollection(dynamicExp, assignRecords);
          } else {
            assignRecords(staticExp);
          }
        }

        var currentElement, messageCtrl;
        ngMessagesCtrl.register(commentNode, messageCtrl = {
          test: function(name) {
            return contains(records, name);
          },
          attach: function() {
            if (!currentElement) {
              $transclude(function(elm, newScope) {
                $animate.enter(elm, null, element);
                currentElement = elm;

                // Each time we attach this node to a message we get a new id that we can match
                // when we are destroying the node later.
                var $$attachId = currentElement.$$attachId = ngMessagesCtrl.getAttachId();

                // in the event that the element or a parent element is destroyed
                // by another structural directive then it's time
                // to deregister the message from the controller
                currentElement.on('$destroy', function() {
                  // If the message element was removed via a call to `detach` then `currentElement` will be null
                  // So this handler only handles cases where something else removed the message element.
                  if (currentElement && currentElement.$$attachId === $$attachId) {
                    ngMessagesCtrl.deregister(commentNode, isDefault);
                    messageCtrl.detach();
                  }
                  newScope.$destroy();
                });
              });
            }
          },
          detach: function() {
            if (currentElement) {
              var elm = currentElement;
              currentElement = null;
              $animate.leave(elm);
            }
          }
        }, isDefault);

        // We need to ensure that this directive deregisters itself when it no longer exists
        // Normally this is done when the attached element is destroyed; but if this directive
        // gets removed before we attach the message to the DOM there is nothing to watch
        // in which case we must deregister when the containing scope is destroyed.
        scope.$on('$destroy', function() {
          ngMessagesCtrl.deregister(commentNode, isDefault);
        });
      }
    };
  }];

  function contains(collection, key) {
    if (collection) {
      return isArray(collection)
          ? collection.indexOf(key) >= 0
          : collection.hasOwnProperty(key);
    }
  }
}


})(window, window.angular);

},{}],3:[function(require,module,exports){
require('./angular-messages');
module.exports = 'ngMessages';

},{"./angular-messages":2}],4:[function(require,module,exports){
require('./release/angular-recaptcha.js');
module.exports = 'vcRecaptcha';

},{"./release/angular-recaptcha.js":5}],5:[function(require,module,exports){
/**
 * @license angular-recaptcha build:2018-05-09
 * https://github.com/vividcortex/angular-recaptcha
 * Copyright (c) 2018 VividCortex
**/

/*global angular, Recaptcha */
(function (ng) {
    'use strict';

    ng.module('vcRecaptcha', []);

}(angular));

/*global angular */
(function (ng) {
    'use strict';

    function throwNoKeyException() {
        throw new Error('You need to set the "key" attribute to your public reCaptcha key. If you don\'t have a key, please get one from https://www.google.com/recaptcha/admin/create');
    }

    var app = ng.module('vcRecaptcha');

    /**
     * An angular service to wrap the reCaptcha API
     */
    app.provider('vcRecaptchaService', function(){
        var provider = this;
        var config = {};
        provider.onLoadFunctionName = 'vcRecaptchaApiLoaded';

        /**
         * Sets the reCaptcha configuration values which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param defaults  object which overrides the current defaults object.
         */
        provider.setDefaults = function(defaults){
            ng.copy(defaults, config);
        };

        /**
         * Sets the reCaptcha key which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param siteKey  the reCaptcha public key (refer to the README file if you don't know what this is).
         */
        provider.setSiteKey = function(siteKey){
            config.key = siteKey;
        };

        /**
         * Sets the reCaptcha theme which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param theme  The reCaptcha theme.
         */
        provider.setTheme = function(theme){
            config.theme = theme;
        };

        /**
         * Sets the reCaptcha stoken which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param stoken  The reCaptcha stoken.
         */
        provider.setStoken = function(stoken){
            config.stoken = stoken;
        };

        /**
         * Sets the reCaptcha size which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param size  The reCaptcha size.
         */
        provider.setSize = function(size){
            config.size = size;
        };

        /**
         * Sets the reCaptcha type which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param type  The reCaptcha type.
         */
        provider.setType = function(type){
            config.type = type;
        };

        /**
         * Sets the reCaptcha language which will be used by default is not specified in a specific directive instance.
         *
         * @param lang  The reCaptcha language.
         */
        provider.setLang = function(lang){
            config.lang = lang;
        };

        /**
         * Sets the reCaptcha badge position which will be used by default if not specified in a specific directive instance.
         *
         * @param badge  The reCaptcha badge position.
         */
        provider.setBadge = function(badge){
            config.badge = badge;
        };

        /**
         * Sets the reCaptcha configuration values which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param onLoadFunctionName  string name which overrides the name of the onload function. Should match what is in the recaptcha script querystring onload value.
         */
        provider.setOnLoadFunctionName = function(onLoadFunctionName){
            provider.onLoadFunctionName = onLoadFunctionName;
        };

        provider.$get = ['$rootScope','$window', '$q', '$document', '$interval', function ($rootScope, $window, $q, $document, $interval) {
            var deferred = $q.defer(), promise = deferred.promise, instances = {}, recaptcha;

            $window.vcRecaptchaApiLoadedCallback = $window.vcRecaptchaApiLoadedCallback || [];

            var callback = function () {
                recaptcha = $window.grecaptcha;

                deferred.resolve(recaptcha);
            };

            $window.vcRecaptchaApiLoadedCallback.push(callback);

            $window[provider.onLoadFunctionName] = function () {
                $window.vcRecaptchaApiLoadedCallback.forEach(function(callback) {
                    callback();
                });
            };


            function getRecaptcha() {
                if (!!recaptcha) {
                    return $q.when(recaptcha);
                }

                return promise;
            }

            function validateRecaptchaInstance() {
                if (!recaptcha) {
                    throw new Error('reCaptcha has not been loaded yet.');
                }
            }

            function isRenderFunctionAvailable() {
                return ng.isFunction(($window.grecaptcha || {}).render);
            }


            // Check if grecaptcha.render is not defined already.
            if (isRenderFunctionAvailable()) {
                callback();
            } else if ($window.document.querySelector('script[src^="https://www.google.com/recaptcha/api.js"]')) {
                // wait for script to be loaded.
                var intervalWait = $interval(function() {
                    if (isRenderFunctionAvailable()) {
                        $interval.cancel(intervalWait);
                        callback();
                    }
                }, 25);
            } else {
                // Generate link on demand
                var script = $window.document.createElement('script');
                script.async = true;
                script.defer = true;
                script.src = 'https://www.google.com/recaptcha/api.js?onload='+provider.onLoadFunctionName+'&render=explicit';
                $document.find('body')[0].appendChild(script);
            }

            return {

                /**
                 * Creates a new reCaptcha object
                 *
                 * @param elm  the DOM element where to put the captcha
                 * @param conf the captcha object configuration
                 * @throws NoKeyException    if no key is provided in the provider config or the directive instance (via attribute)
                 */
                create: function (elm, conf) {

                    conf.sitekey = conf.key || config.key;
                    conf.theme = conf.theme || config.theme;
                    conf.stoken = conf.stoken || config.stoken;
                    conf.size = conf.size || config.size;
                    conf.type = conf.type || config.type;
                    conf.hl = conf.lang || config.lang;
                    conf.badge = conf.badge || config.badge;

                    if (!conf.sitekey) {
                        throwNoKeyException();
                    }
                    return getRecaptcha().then(function (recaptcha) {
                        var widgetId = recaptcha.render(elm, conf);
                        instances[widgetId] = elm;
                        return widgetId;
                    });
                },

                /**
                 * Reloads the reCaptcha
                 */
                reload: function (widgetId) {
                    validateRecaptchaInstance();

                    recaptcha.reset(widgetId);

                    // Let everyone know this widget has been reset.
                    $rootScope.$broadcast('reCaptchaReset', widgetId);
                },

                /**
                 * Executes the reCaptcha
                 */
                execute: function (widgetId) {
                    validateRecaptchaInstance();

                    recaptcha.execute(widgetId);
                },

                /**
                 * Get/Set reCaptcha language
                 */
                useLang: function (widgetId, lang) {
                    var instance = instances[widgetId];

                    if (instance) {
                        var iframe = instance.querySelector('iframe');
                        if (lang) {
                            // Setter
                            if (iframe && iframe.src) {
                                var s = iframe.src;
                                if (/[?&]hl=/.test(s)) {
                                    s = s.replace(/([?&]hl=)\w+/, '$1' + lang);
                                } else {
                                    s += ((s.indexOf('?') === -1) ? '?' : '&') + 'hl=' + lang;
                                }

                                iframe.src = s;
                            }
                        } else {
                            // Getter
                            if (iframe && iframe.src && /[?&]hl=\w+/.test(iframe.src)) {
                                return iframe.src.replace(/.+[?&]hl=(\w+)([^\w].+)?/, '$1');
                            } else {
                                return null;
                            }
                        }
                    } else {
                        throw new Error('reCaptcha Widget ID not exists', widgetId);
                    }
                },

                /**
                 * Gets the response from the reCaptcha widget.
                 *
                 * @see https://developers.google.com/recaptcha/docs/display#js_api
                 *
                 * @returns {String}
                 */
                getResponse: function (widgetId) {
                    validateRecaptchaInstance();

                    return recaptcha.getResponse(widgetId);
                },

                /**
                 * Gets reCaptcha instance and configuration
                 */
                getInstance: function (widgetId) {
                    return instances[widgetId];
                },

                /**
                 * Destroy reCaptcha instance.
                 */
                destroy: function (widgetId) {
                    delete instances[widgetId];
                }
            };

        }];
    });

}(angular));

/*global angular, Recaptcha */
(function (ng) {
    'use strict';

    var app = ng.module('vcRecaptcha');

    app.directive('vcRecaptcha', ['$document', '$timeout', 'vcRecaptchaService', function ($document, $timeout, vcRecaptcha) {

        return {
            restrict: 'A',
            require: "?^^form",
            scope: {
                response: '=?ngModel',
                key: '=?',
                stoken: '=?',
                theme: '=?',
                size: '=?',
                type: '=?',
                lang: '=?',
                badge: '=?',
                tabindex: '=?',
                required: '=?',
                onCreate: '&',
                onSuccess: '&',
                onExpire: '&'
            },
            link: function (scope, elm, attrs, ctrl) {
                scope.widgetId = null;

                if(ctrl && ng.isDefined(attrs.required)){
                    scope.$watch('required', validate);
                }

                var removeCreationListener = scope.$watch('key', function (key) {
                    var callback = function (gRecaptchaResponse) {
                        // Safe $apply
                        $timeout(function () {
                            scope.response = gRecaptchaResponse;
                            validate();

                            // Notify about the response availability
                            scope.onSuccess({response: gRecaptchaResponse, widgetId: scope.widgetId});
                        });
                    };

                    vcRecaptcha.create(elm[0], {

                        callback: callback,
                        key: key,
                        stoken: scope.stoken || attrs.stoken || null,
                        theme: scope.theme || attrs.theme || null,
                        type: scope.type || attrs.type || null,
                        lang: scope.lang || attrs.lang || null,
                        tabindex: scope.tabindex || attrs.tabindex || null,
                        size: scope.size || attrs.size || null,
                        badge: scope.badge || attrs.badge || null,
                        'expired-callback': expired

                    }).then(function (widgetId) {
                        // The widget has been created
                        validate();
                        scope.widgetId = widgetId;
                        scope.onCreate({widgetId: widgetId});

                        scope.$on('$destroy', destroy);

                        scope.$on('reCaptchaReset', function(event, resetWidgetId){
                          if(ng.isUndefined(resetWidgetId) || widgetId === resetWidgetId){
                            scope.response = "";
                            validate();
                          }
                        })

                    });

                    // Remove this listener to avoid creating the widget more than once.
                    removeCreationListener();
                });

                function destroy() {
                  if (ctrl) {
                    // reset the validity of the form if we were removed
                    ctrl.$setValidity('recaptcha', null);
                  }

                  cleanup();
                }

                function expired(){
                    // Safe $apply
                    $timeout(function () {
                        scope.response = "";
                        validate();

                        // Notify about the response availability
                        scope.onExpire({ widgetId: scope.widgetId });
                    });
                }

                function validate(){
                    if(ctrl){
                        ctrl.$setValidity('recaptcha', scope.required === false ? null : Boolean(scope.response));
                    }
                }

                function cleanup(){
                  vcRecaptcha.destroy(scope.widgetId);

                  // removes elements reCaptcha added.
                  ng.element($document[0].querySelectorAll('.pls-container')).parent().remove();
                }
            }
        };
    }]);

}(angular));

},{}],6:[function(require,module,exports){
/*!
 * angular-translate - v2.18.1 - 2018-05-19
 * 
 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

$translateMissingTranslationHandlerLog.$inject = ['$log'];
angular.module('pascalprecht.translate')

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateMissingTranslationHandlerLog
 * @requires $log
 *
 * @description
 * Uses angular's `$log` service to give a warning when trying to translate a
 * translation id which doesn't exist.
 *
 * @returns {function} Handler function
 */
.factory('$translateMissingTranslationHandlerLog', $translateMissingTranslationHandlerLog);

function $translateMissingTranslationHandlerLog ($log) {

  'use strict';

  return function (translationId) {
    $log.warn('Translation for ' + translationId + ' doesn\'t exist');
  };
}

$translateMissingTranslationHandlerLog.displayName = '$translateMissingTranslationHandlerLog';
return 'pascalprecht.translate';

}));

},{}],7:[function(require,module,exports){
/*!
 * angular-translate - v2.18.1 - 2018-05-19
 * 
 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

angular.module('pascalprecht.translate')
/**
 * @ngdoc object
 * @name pascalprecht.translate.$translatePartialLoaderProvider
 *
 * @description
 * By using a $translatePartialLoaderProvider you can configure a list of a needed
 * translation parts directly during the configuration phase of your application's
 * lifetime. All parts you add by using this provider would be loaded by
 * angular-translate at the startup as soon as possible.
 */
  .provider('$translatePartialLoader', $translatePartialLoader);

function $translatePartialLoader() {

  'use strict';

  /**
   * @constructor
   * @name Part
   *
   * @description
   * Represents Part object to add and set parts at runtime.
   */
  function Part(name, priority, urlTemplate) {
    this.name = name;
    this.isActive = true;
    this.tables = {};
    this.priority = priority || 0;
    this.langPromises = {};
    this.urlTemplate = urlTemplate;
  }

  /**
   * @name parseUrl
   * @method
   *
   * @description
   * Returns a parsed url template string and replaces given target lang
   * and part name it.
   *
   * @param {string|function} urlTemplate - Either a string containing an url pattern (with
   *                                        '{part}' and '{lang}') or a function(part, lang)
   *                                        returning a string.
   * @param {string} targetLang - Language key for language to be used.
   * @return {string} Parsed url template string
   */
  Part.prototype.parseUrl = function (urlTemplate, targetLang) {
    if (angular.isFunction(urlTemplate)) {
      return urlTemplate(this.name, targetLang);
    }
    return urlTemplate.replace(/\{part\}/g, this.name).replace(/\{lang\}/g, targetLang);
  };

  Part.prototype.getTable = function (lang, $q, $http, $httpOptions, urlTemplate, errorHandler) {

    //locals
    var self = this;
    var lastLangPromise = this.langPromises[lang];
    var deferred = $q.defer();

    //private helper helpers
    var fetchData = function () {
      return $http(
        angular.extend({
            method : 'GET',
            url : self.parseUrl(self.urlTemplate || urlTemplate, lang)
          },
          $httpOptions)
      );
    };

    //private helper
    var handleNewData = function (data) {
      self.tables[lang] = data;
      deferred.resolve(data);
    };

    //private helper
    var rejectDeferredWithPartName = function () {
      deferred.reject(self.name);
    };

    //private helper
    var tryGettingThisTable = function () {
      //data fetching logic
      fetchData().then(
        function (result) {
          handleNewData(result.data);
        },
        function (errorResponse) {
          if (errorHandler) {
            errorHandler(self.name, lang, errorResponse).then(handleNewData, rejectDeferredWithPartName);
          } else {
            rejectDeferredWithPartName();
          }
        });
    };

    //loading logic
    if (!this.tables[lang]) {
      //let's try loading the data
      if (!lastLangPromise) {
        //this is the first request - just go ahead and hit the server
        tryGettingThisTable();
      } else {
        //this is an additional request after one or more unfinished or failed requests
        //chain the deferred off the previous request's promise so that this request conditionally executes
        //if the previous request succeeds then the result will be passed through, but if it fails then this request will try again and hit the server
        lastLangPromise.then(deferred.resolve, tryGettingThisTable);
      }
      //retain a reference to the last promise so we can continue the chain if another request is made before any succeed
      //you can picture the promise chain as a singly-linked list (formed by the .then handler queues) that's traversed by the execution context
      this.langPromises[lang] = deferred.promise;
    }
    else {
      //the part has already been loaded - if lastLangPromise is also undefined then the table has been populated using setPart
      //this breaks the promise chain because we're not tying langDeferred's outcome to a previous call's promise handler queues, but we don't care because there's no asynchronous execution context to keep track of anymore
      deferred.resolve(this.tables[lang]);
    }
    return deferred.promise;
  };

  var parts = {};

  function hasPart(name) {
    return Object.prototype.hasOwnProperty.call(parts, name);
  }

  function isStringValid(str) {
    return angular.isString(str) && str !== '';
  }

  function isPartAvailable(name) {
    if (!isStringValid(name)) {
      throw new TypeError('Invalid type of a first argument, a non-empty string expected.');
    }

    return (hasPart(name) && parts[name].isActive);
  }

  function deepExtend(dst, src) {
    for (var property in src) {
      if (src[property] && src[property].constructor &&
        src[property].constructor === Object) {
        dst[property] = dst[property] || {};
        deepExtend(dst[property], src[property]);
      } else {
        dst[property] = src[property];
      }
    }
    return dst;
  }

  function getPrioritizedParts() {
    var prioritizedParts = [];
    for (var part in parts) {
      if (parts[part].isActive) {
        prioritizedParts.push(parts[part]);
      }
    }
    prioritizedParts.sort(function (a, b) {
      return a.priority - b.priority;
    });
    return prioritizedParts;
  }


  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translatePartialLoaderProvider#addPart
   * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
   *
   * @description
   * Registers a new part of the translation table to be loaded once the
   * `angular-translate` gets into runtime phase. It does not actually load any
   * translation data, but only registers a part to be loaded in the future.
   *
   * @param {string} name A name of the part to add
   * @param {int} [priority=0] Sets the load priority of this part.
   *
   * @returns {object} $translatePartialLoaderProvider, so this method is chainable
   * @throws {TypeError} The method could throw a **TypeError** if you pass the param
   * of the wrong type. Please, note that the `name` param has to be a
   * non-empty **string**.
   */
  this.addPart = function (name, priority, urlTemplate) {
    if (!isStringValid(name)) {
      throw new TypeError('Couldn\'t add part, part name has to be a string!');
    }

    if (!hasPart(name)) {
      parts[name] = new Part(name, priority, urlTemplate);
    }
    parts[name].isActive = true;

    return this;
  };

  /**
   * @ngdocs function
   * @name pascalprecht.translate.$translatePartialLoaderProvider#setPart
   * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
   *
   * @description
   * Sets a translation table to the specified part. This method does not make the
   * specified part available, but only avoids loading this part from the server.
   *
   * @param {string} lang A language of the given translation table
   * @param {string} part A name of the target part
   * @param {object} table A translation table to set to the specified part
   *
   * @return {object} $translatePartialLoaderProvider, so this method is chainable
   * @throws {TypeError} The method could throw a **TypeError** if you pass params
   * of the wrong type. Please, note that the `lang` and `part` params have to be a
   * non-empty **string**s and the `table` param has to be an object.
   */
  this.setPart = function (lang, part, table) {
    if (!isStringValid(lang)) {
      throw new TypeError('Couldn\'t set part.`lang` parameter has to be a string!');
    }
    if (!isStringValid(part)) {
      throw new TypeError('Couldn\'t set part.`part` parameter has to be a string!');
    }
    if (typeof table !== 'object' || table === null) {
      throw new TypeError('Couldn\'t set part. `table` parameter has to be an object!');
    }

    if (!hasPart(part)) {
      parts[part] = new Part(part);
      parts[part].isActive = false;
    }

    parts[part].tables[lang] = table;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translatePartialLoaderProvider#deletePart
   * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
   *
   * @description
   * Removes the previously added part of the translation data. So, `angular-translate` will not
   * load it at the startup.
   *
   * @param {string} name A name of the part to delete
   *
   * @returns {object} $translatePartialLoaderProvider, so this method is chainable
   *
   * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
   * type. Please, note that the `name` param has to be a non-empty **string**.
   */
  this.deletePart = function (name) {
    if (!isStringValid(name)) {
      throw new TypeError('Couldn\'t delete part, first arg has to be string.');
    }

    if (hasPart(name)) {
      parts[name].isActive = false;
    }

    return this;
  };


  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translatePartialLoaderProvider#isPartAvailable
   * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
   *
   * @description
   * Checks if the specific part is available. A part becomes available after it was added by the
   * `addPart` method. Available parts would be loaded from the server once the `angular-translate`
   * asks the loader to that.
   *
   * @param {string} name A name of the part to check
   *
   * @returns {boolean} Returns **true** if the part is available now and **false** if not.
   *
   * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
   * type. Please, note that the `name` param has to be a non-empty **string**.
   */
  this.isPartAvailable = isPartAvailable;

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translatePartialLoader
   *
   * @requires $q
   * @requires $http
   * @requires $injector
   * @requires $rootScope
   * @requires $translate
   *
   * @description
   *
   * @param {object} options Options object
   *
   * @throws {TypeError}
   */
  this.$get = ['$rootScope', '$injector', '$q', '$http', '$log',
    function ($rootScope, $injector, $q, $http, $log) {

      /**
       * @ngdoc event
       * @name pascalprecht.translate.$translatePartialLoader#$translatePartialLoaderStructureChanged
       * @eventOf pascalprecht.translate.$translatePartialLoader
       * @eventType broadcast on root scope
       *
       * @description
       * A $translatePartialLoaderStructureChanged event is called when a state of the loader was
       * changed somehow. It could mean either some part is added or some part is deleted. Anyway when
       * you get this event the translation table is not longer current and has to be updated.
       *
       * @param {string} name A name of the part which is a reason why the event was fired
       */

      var service = function (options) {
        if (!isStringValid(options.key)) {
          throw new TypeError('Unable to load data, a key is not a non-empty string.');
        }

        if (!isStringValid(options.urlTemplate) && !angular.isFunction(options.urlTemplate)) {
          throw new TypeError('Unable to load data, a urlTemplate is not a non-empty string or not a function.');
        }

        var errorHandler = options.loadFailureHandler;
        if (errorHandler !== undefined) {
          if (!angular.isString(errorHandler)) {
            throw new Error('Unable to load data, a loadFailureHandler is not a string.');
          } else {
            errorHandler = $injector.get(errorHandler);
          }
        }

        var loaders = [],
          prioritizedParts = getPrioritizedParts();

        angular.forEach(prioritizedParts, function (part) {
          loaders.push(
            part.getTable(options.key, $q, $http, options.$http, options.urlTemplate, errorHandler)
          );
          part.urlTemplate = part.urlTemplate || options.urlTemplate;
        });

        // workaround for #1781
        var structureHasBeenChangedWhileLoading = false;
        var dirtyCheckEventCloser = $rootScope.$on('$translatePartialLoaderStructureChanged', function () {
          structureHasBeenChangedWhileLoading = true;
        });

        return $q.all(loaders)
          .then(function () {
            dirtyCheckEventCloser();
            if (structureHasBeenChangedWhileLoading) {
              if (!options.__retries) {
                // the part structure has been changed while loading (the origin ones)
                // this can happen if an addPart/removePart has been invoked right after a $translate.use(lang)
                // TODO maybe we can optimize this with the actual list of missing parts
                options.__retries = (options.__retries || 0) + 1;
                return service(options);
              } else {
                // the part structure has been changed again while loading (retried one)
                // because this could an infinite loop, this will not load another one again
                $log.warn('The partial loader has detected a multiple structure change (with addPort/removePart) ' +
                  'while loading translations. You should consider using promises of $translate.use(lang) and ' +
                  '$translate.refresh(). Also parts should be added/removed right before an explicit refresh ' +
                  'if possible.');
              }
            }
            var table = {};
            prioritizedParts = getPrioritizedParts();
            angular.forEach(prioritizedParts, function (part) {
              deepExtend(table, part.tables[options.key]);
            });
            return table;
          }, function () {
            dirtyCheckEventCloser();
            return $q.reject(options.key);
          });
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#addPart
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Registers a new part of the translation table. This method does not actually perform any xhr
       * requests to get translation data. The new parts will be loaded in order of priority from the server next time
       * `angular-translate` asks the loader to load translations.
       *
       * @param {string} name A name of the part to add
       * @param {int} [priority=0] Sets the load priority of this part.
       *
       * @returns {object} $translatePartialLoader, so this method is chainable
       *
       * @fires {$translatePartialLoaderStructureChanged} The $translatePartialLoaderStructureChanged
       * event would be fired by this method in case the new part affected somehow on the loaders
       * state. This way it means that there are a new translation data available to be loaded from
       * the server.
       *
       * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
       * type. Please, note that the `name` param has to be a non-empty **string**.
       */
      service.addPart = function (name, priority, urlTemplate) {
        if (!isStringValid(name)) {
          throw new TypeError('Couldn\'t add part, first arg has to be a string');
        }

        if (!hasPart(name)) {
          parts[name] = new Part(name, priority, urlTemplate);
          $rootScope.$emit('$translatePartialLoaderStructureChanged', name);
        } else if (!parts[name].isActive) {
          parts[name].isActive = true;
          $rootScope.$emit('$translatePartialLoaderStructureChanged', name);
        }

        return service;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#deletePart
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Deletes the previously added part of the translation data. The target part could be deleted
       * either logically or physically. When the data is deleted logically it is not actually deleted
       * from the browser, but the loader marks it as not active and prevents it from affecting on the
       * translations. If the deleted in such way part is added again, the loader will use the
       * previously loaded data rather than loading it from the server once more time. But if the data
       * is deleted physically, the loader will completely remove all information about it. So in case
       * of recycling this part will be loaded from the server again.
       *
       * @param {string} name A name of the part to delete
       * @param {boolean=} [removeData=false] An indicator if the loader has to remove a loaded
       * translation data physically. If the `removeData` if set to **false** the loaded data will not be
       * deleted physically and might be reused in the future to prevent an additional xhr requests.
       *
       * @returns {object} $translatePartialLoader, so this method is chainable
       *
       * @fires {$translatePartialLoaderStructureChanged} The $translatePartialLoaderStructureChanged
       * event would be fired by this method in case a part deletion process affects somehow on the
       * loaders state. This way it means that some part of the translation data is now deprecated and
       * the translation table has to be recompiled with the remaining translation parts.
       *
       * @throws {TypeError} The method could throw a **TypeError** if you pass some param of the
       * wrong type. Please, note that the `name` param has to be a non-empty **string** and
       * the `removeData` param has to be either **undefined** or **boolean**.
       */
      service.deletePart = function (name, removeData) {
        if (!isStringValid(name)) {
          throw new TypeError('Couldn\'t delete part, first arg has to be string');
        }

        if (removeData === undefined) {
          removeData = false;
        } else if (typeof removeData !== 'boolean') {
          throw new TypeError('Invalid type of a second argument, a boolean expected.');
        }

        if (hasPart(name)) {
          var wasActive = parts[name].isActive;
          if (removeData) {
            var $translate = $injector.get('$translate');
            var cache = $translate.loaderCache();
            if (typeof(cache) === 'string') {
              // getting on-demand instance of loader
              cache = $injector.get(cache);
            }
            // Purging items from cache...
            if (typeof(cache) === 'object') {
              angular.forEach(parts[name].tables, function (value, key) {
                cache.remove(parts[name].parseUrl(parts[name].urlTemplate, key));
              });
            }
            delete parts[name];
          } else {
            parts[name].isActive = false;
          }
          if (wasActive) {
            $rootScope.$emit('$translatePartialLoaderStructureChanged', name);
          }
        }

        return service;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#isPartLoaded
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Checks if the registered translation part is loaded into the translation table.
       *
       * @param {string} name A name of the part
       * @param {string} lang A key of the language
       *
       * @returns {boolean} Returns **true** if the translation of the part is loaded to the translation table and **false** if not.
       *
       * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
       * type. Please, note that the `name` and `lang` params have to be non-empty **string**.
       */
      service.isPartLoaded = function (name, lang) {
        return angular.isDefined(parts[name]) && angular.isDefined(parts[name].tables[lang]);
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#getRegisteredParts
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Gets names of the parts that were added with the `addPart`.
       *
       * @returns {array} Returns array of registered parts, if none were registered then an empty array is returned.
       */
      service.getRegisteredParts = function () {
        var registeredParts = [];
        angular.forEach(parts, function (p) {
          if (p.isActive) {
            registeredParts.push(p.name);
          }
        });
        return registeredParts;
      };


      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#isPartAvailable
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Checks if a target translation part is available. The part becomes available just after it was
       * added by the `addPart` method. Part's availability does not mean that it was loaded from the
       * server, but only that it was added to the loader. The available part might be loaded next
       * time the loader is called.
       *
       * @param {string} name A name of the part to delete
       *
       * @returns {boolean} Returns **true** if the part is available now and **false** if not.
       *
       * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
       * type. Please, note that the `name` param has to be a non-empty **string**.
       */
      service.isPartAvailable = isPartAvailable;

      return service;

    }];

}

$translatePartialLoader.displayName = '$translatePartialLoader';
return 'pascalprecht.translate';

}));

},{}],8:[function(require,module,exports){
/*!
 * angular-translate - v2.18.1 - 2018-05-19
 * 
 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

$translateStaticFilesLoader.$inject = ['$q', '$http'];
angular.module('pascalprecht.translate')
/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateStaticFilesLoader
 * @requires $q
 * @requires $http
 *
 * @description
 * Creates a loading function for a typical static file url pattern:
 * "lang-en_US.json", "lang-de_DE.json", etc. Using this builder,
 * the response of these urls must be an object of key-value pairs.
 *
 * @param {object} options Options object, which gets prefix, suffix, key, and fileMap
 */
.factory('$translateStaticFilesLoader', $translateStaticFilesLoader);

function $translateStaticFilesLoader($q, $http) {

  'use strict';

  return function (options) {

    if (!options || (!angular.isArray(options.files) && (!angular.isString(options.prefix) || !angular.isString(options.suffix)))) {
      throw new Error('Couldn\'t load static files, no files and prefix or suffix specified!');
    }

    if (!options.files) {
      options.files = [{
        prefix: options.prefix,
        suffix: options.suffix
      }];
    }

    var load = function (file) {
      if (!file || (!angular.isString(file.prefix) || !angular.isString(file.suffix))) {
        throw new Error('Couldn\'t load static file, no prefix or suffix specified!');
      }

      var fileUrl = [
        file.prefix,
        options.key,
        file.suffix
      ].join('');

      if (angular.isObject(options.fileMap) && options.fileMap[fileUrl]) {
        fileUrl = options.fileMap[fileUrl];
      }

      return $http(angular.extend({
        url: fileUrl,
        method: 'GET'
      }, options.$http))
        .then(function(result) {
          return result.data;
        }, function () {
          return $q.reject(options.key);
        });
    };

    var promises = [],
        length = options.files.length;

    for (var i = 0; i < length; i++) {
      promises.push(load({
        prefix: options.files[i].prefix,
        key: options.key,
        suffix: options.files[i].suffix
      }));
    }

    return $q.all(promises)
      .then(function (data) {
        var length = data.length,
            mergedData = {};

        for (var i = 0; i < length; i++) {
          for (var key in data[i]) {
            mergedData[key] = data[i][key];
          }
        }

        return mergedData;
      });
  };
}

$translateStaticFilesLoader.displayName = '$translateStaticFilesLoader';
return 'pascalprecht.translate';

}));

},{}],9:[function(require,module,exports){
/*!
 * angular-translate - v2.18.1 - 2018-05-19
 * 
 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

/**
 * @ngdoc overview
 * @name pascalprecht.translate
 *
 * @description
 * The main module which holds everything together.
 */
runTranslate.$inject = ['$translate'];
$translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
$translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
translateDirective.$inject = ['$translate', '$interpolate', '$compile', '$parse', '$rootScope'];
translateAttrDirective.$inject = ['$translate', '$rootScope'];
translateCloakDirective.$inject = ['$translate', '$rootScope'];
translateFilterFactory.$inject = ['$parse', '$translate'];
$translationCache.$inject = ['$cacheFactory'];
angular.module('pascalprecht.translate', ['ng'])
  .run(runTranslate);

function runTranslate($translate) {

  'use strict';

  var key = $translate.storageKey(),
    storage = $translate.storage();

  var fallbackFromIncorrectStorageValue = function () {
    var preferred = $translate.preferredLanguage();
    if (angular.isString(preferred)) {
      $translate.use(preferred);
      // $translate.use() will also remember the language.
      // So, we don't need to call storage.put() here.
    } else {
      storage.put(key, $translate.use());
    }
  };

  fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';

  if (storage) {
    if (!storage.get(key)) {
      fallbackFromIncorrectStorageValue();
    } else {
      $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
    }
  } else if (angular.isString($translate.preferredLanguage())) {
    $translate.use($translate.preferredLanguage());
  }
}

runTranslate.displayName = 'runTranslate';

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateSanitizationProvider
 *
 * @description
 *
 * Configurations for $translateSanitization
 */
angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);

function $translateSanitizationProvider () {

  'use strict';

  var $sanitize,
      $sce,
      currentStrategy = null, // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
      hasConfiguredStrategy = false,
      hasShownNoStrategyConfiguredWarning = false,
      strategies;

  /**
   * Definition of a sanitization strategy function
   * @callback StrategyFunction
   * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
   * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
   * @return {string|object}
   */

  /**
   * @ngdoc property
   * @name strategies
   * @propertyOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Following strategies are built-in:
   * <dl>
   *   <dt>sanitize</dt>
   *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
   *   <dt>escape</dt>
   *   <dd>Escapes HTML in the translation</dd>
   *   <dt>sanitizeParameters</dt>
   *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
   *   <dt>escapeParameters</dt>
   *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
   *   <dt>escaped</dt>
   *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
   * </dl>
   *
   */

  strategies = {
    sanitize: function (value, mode/*, context*/) {
      if (mode === 'text') {
        value = htmlSanitizeValue(value);
      }
      return value;
    },
    escape: function (value, mode/*, context*/) {
      if (mode === 'text') {
        value = htmlEscapeValue(value);
      }
      return value;
    },
    sanitizeParameters: function (value, mode/*, context*/) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlSanitizeValue);
      }
      return value;
    },
    escapeParameters: function (value, mode/*, context*/) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlEscapeValue);
      }
      return value;
    },
    sce: function (value, mode, context) {
      if (mode === 'text') {
        value = htmlTrustValue(value);
      } else if (mode === 'params') {
        if (context !== 'filter') {
          // do html escape in filter context #1101
          value = mapInterpolationParameters(value, htmlEscapeValue);
        }
      }
      return value;
    },
    sceParameters: function (value, mode/*, context*/) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlTrustValue);
      }
      return value;
    }
  };
  // Support legacy strategy name 'escaped' for backwards compatibility.
  // TODO should be removed in 3.0
  strategies.escaped = strategies.escapeParameters;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Adds a sanitization strategy to the list of known strategies.
   *
   * @param {string} strategyName - unique key for a strategy
   * @param {StrategyFunction} strategyFunction - strategy function
   * @returns {object} this
   */
  this.addStrategy = function (strategyName, strategyFunction) {
    strategies[strategyName] = strategyFunction;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Removes a sanitization strategy from the list of known strategies.
   *
   * @param {string} strategyName - unique key for a strategy
   * @returns {object} this
   */
  this.removeStrategy = function (strategyName) {
    delete strategies[strategyName];
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
   *
   * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
   * @returns {object} this
   */
  this.useStrategy = function (strategy) {
    hasConfiguredStrategy = true;
    currentStrategy = strategy;
    return this;
  };

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translateSanitization
   * @requires $injector
   * @requires $log
   *
   * @description
   * Sanitizes interpolation parameters and translated texts.
   *
   */
  this.$get = ['$injector', '$log', function ($injector, $log) {

    var cachedStrategyMap = {};

    var applyStrategies = function (value, mode, context, selectedStrategies) {
      angular.forEach(selectedStrategies, function (selectedStrategy) {
        if (angular.isFunction(selectedStrategy)) {
          value = selectedStrategy(value, mode, context);
        } else if (angular.isFunction(strategies[selectedStrategy])) {
          value = strategies[selectedStrategy](value, mode, context);
        } else if (angular.isString(strategies[selectedStrategy])) {
          if (!cachedStrategyMap[strategies[selectedStrategy]]) {
            try {
              cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
            } catch (e) {
              cachedStrategyMap[strategies[selectedStrategy]] = function() {};
              throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
            }
          }
          value = cachedStrategyMap[strategies[selectedStrategy]](value, mode, context);
        } else {
          throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
        }
      });
      return value;
    };

    // TODO: should be removed in 3.0
    var showNoStrategyConfiguredWarning = function () {
      if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
        $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
        hasShownNoStrategyConfiguredWarning = true;
      }
    };

    if ($injector.has('$sanitize')) {
      $sanitize = $injector.get('$sanitize');
    }
    if ($injector.has('$sce')) {
      $sce = $injector.get('$sce');
    }

    return {
      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateSanitization#useStrategy
       * @methodOf pascalprecht.translate.$translateSanitization
       *
       * @description
       * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
       *
       * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
       */
      useStrategy: (function (self) {
        return function (strategy) {
          self.useStrategy(strategy);
        };
      })(this),

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateSanitization#sanitize
       * @methodOf pascalprecht.translate.$translateSanitization
       *
       * @description
       * Sanitizes a value.
       *
       * @param {string|object} value The value which should be sanitized.
       * @param {string} mode The current sanitization mode, either 'params' or 'text'.
       * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
       * @param {string} [context] The context of this call: filter, service. Default is service
       * @returns {string|object} sanitized value
       */
      sanitize: function (value, mode, strategy, context) {
        if (!currentStrategy) {
          showNoStrategyConfiguredWarning();
        }

        if (!strategy && strategy !== null) {
          strategy = currentStrategy;
        }

        if (!strategy) {
          return value;
        }

        if (!context) {
          context = 'service';
        }

        var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
        return applyStrategies(value, mode, context, selectedStrategies);
      }
    };
  }];

  var htmlEscapeValue = function (value) {
    var element = angular.element('<div></div>');
    element.text(value); // not chainable, see #1044
    return element.html();
  };

  var htmlSanitizeValue = function (value) {
    if (!$sanitize) {
      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
    }
    return $sanitize(value);
  };

  var htmlTrustValue = function (value) {
    if (!$sce) {
      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sce service.');
    }
    return $sce.trustAsHtml(value);
  };

  var mapInterpolationParameters = function (value, iteratee, stack) {
    if (angular.isDate(value)) {
      return value;
    } else if (angular.isObject(value)) {
      var result = angular.isArray(value) ? [] : {};

      if (!stack) {
        stack = [];
      } else {
        if (stack.indexOf(value) > -1) {
          throw new Error('pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object');
        }
      }

      stack.push(value);
      angular.forEach(value, function (propertyValue, propertyKey) {

        /* Skipping function properties. */
        if (angular.isFunction(propertyValue)) {
          return;
        }

        result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee, stack);
      });
      stack.splice(-1, 1); // remove last

      return result;
    } else if (angular.isNumber(value)) {
      return value;
    } else if (value === true || value === false) {
      return value;
    } else if (!angular.isUndefined(value) && value !== null) {
      return iteratee(value);
    } else {
      return value;
    }
  };
}

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateProvider
 * @description
 *
 * $translateProvider allows developers to register translation-tables, asynchronous loaders
 * and similar to configure translation behavior directly inside of a module.
 *
 */
angular.module('pascalprecht.translate')
  .constant('pascalprechtTranslateOverrider', {})
  .provider('$translate', $translate);

function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {

  'use strict';

  var $translationTable = {},
    $preferredLanguage,
    $availableLanguageKeys = [],
    $languageKeyAliases,
    $fallbackLanguage,
    $fallbackWasString,
    $uses,
    $nextLang,
    $storageFactory,
    $storageKey = $STORAGE_KEY,
    $storagePrefix,
    $missingTranslationHandlerFactory,
    $interpolationFactory,
    $interpolatorFactories = [],
    $loaderFactory,
    $cloakClassName = 'translate-cloak',
    $loaderOptions,
    $notFoundIndicatorLeft,
    $notFoundIndicatorRight,
    $postCompilingEnabled = false,
    $forceAsyncReloadEnabled = false,
    $nestedObjectDelimeter = '.',
    $isReady = false,
    $keepContent = false,
    loaderCache,
    directivePriority = 0,
    statefulFilter = true,
    postProcessFn,
    uniformLanguageTagResolver = 'default',
    languageTagResolver = {
      'default' : function (tag) {
        return (tag || '').split('-').join('_');
      },
      java : function (tag) {
        var temp = (tag || '').split('-').join('_');
        var parts = temp.split('_');
        return parts.length > 1 ? (parts[0].toLowerCase() + '_' + parts[1].toUpperCase()) : temp;
      },
      bcp47 : function (tag) {
        var temp = (tag || '').split('_').join('-');
        var parts = temp.split('-');

        switch (parts.length) {
          case 1: // language only
            parts[0] = parts[0].toLowerCase();
            break;
          case 2: // language-script or language-region
            parts[0] = parts[0].toLowerCase();
            if (parts[1].length === 4) { // parts[1] is script
              parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
            } else { // parts[1] is region
              parts[1] = parts[1].toUpperCase();
            }
            break;
          case 3: // language-script-region
            parts[0] = parts[0].toLowerCase();
            parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
            parts[2] = parts[2].toUpperCase();
            break;
          default:
            return temp;
        }

        return parts.join('-');
      },
      'iso639-1' : function (tag) {
        var temp = (tag || '').split('_').join('-');
        var parts = temp.split('-');
        return parts[0].toLowerCase();
      }
    };

  var version = '2.18.1';

  // tries to determine the browsers language
  var getFirstBrowserLanguage = function () {

    // internal purpose only
    if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
      return pascalprechtTranslateOverrider.getLocale();
    }

    var nav = $windowProvider.$get().navigator,
      browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
      i,
      language;

    // support for HTML 5.1 "navigator.languages"
    if (angular.isArray(nav.languages)) {
      for (i = 0; i < nav.languages.length; i++) {
        language = nav.languages[i];
        if (language && language.length) {
          return language;
        }
      }
    }

    // support for other well known properties in browsers
    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
      language = nav[browserLanguagePropertyKeys[i]];
      if (language && language.length) {
        return language;
      }
    }

    return null;
  };
  getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';

  // tries to determine the browsers locale
  var getLocale = function () {
    var locale = getFirstBrowserLanguage() || '';
    if (languageTagResolver[uniformLanguageTagResolver]) {
      locale = languageTagResolver[uniformLanguageTagResolver](locale);
    }
    return locale;
  };
  getLocale.displayName = 'angular-translate/service: getLocale';

  /**
   * @name indexOf
   * @private
   *
   * @description
   * indexOf polyfill. Kinda sorta.
   *
   * @param {array} array Array to search in.
   * @param {string} searchElement Element to search for.
   *
   * @returns {int} Index of search element.
   */
  var indexOf = function (array, searchElement) {
    for (var i = 0, len = array.length; i < len; i++) {
      if (array[i] === searchElement) {
        return i;
      }
    }
    return -1;
  };

  /**
   * @name trim
   * @private
   *
   * @description
   * trim polyfill
   *
   * @returns {string} The string stripped of whitespace from both ends
   */
  var trim = function () {
    return this.toString().replace(/^\s+|\s+$/g, '');
  };

  /**
   * @name lowercase
   * @private
   *
   * @description
   * Return the lowercase string only if the type is string
   *
   * @returns {string} The string all in lowercase
   */
  var lowercase = function (string) {
    return angular.isString(string) ? string.toLowerCase() : string;
  };

  var negotiateLocale = function (preferred) {
    if (!preferred) {
      return;
    }

    var avail = [],
      locale = lowercase(preferred),
      i = 0,
      n = $availableLanguageKeys.length;

    for (; i < n; i++) {
      avail.push(lowercase($availableLanguageKeys[i]));
    }

    // Check for an exact match in our list of available keys
    i = indexOf(avail, locale);
    if (i > -1) {
      return $availableLanguageKeys[i];
    }

    if ($languageKeyAliases) {
      var alias;
      for (var langKeyAlias in $languageKeyAliases) {
        if ($languageKeyAliases.hasOwnProperty(langKeyAlias)) {
          var hasWildcardKey = false;
          var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) &&
            lowercase(langKeyAlias) === lowercase(preferred);

          if (langKeyAlias.slice(-1) === '*') {
            hasWildcardKey = lowercase(langKeyAlias.slice(0, -1)) === lowercase(preferred.slice(0, langKeyAlias.length - 1));
          }
          if (hasExactKey || hasWildcardKey) {
            alias = $languageKeyAliases[langKeyAlias];
            if (indexOf(avail, lowercase(alias)) > -1) {
              return alias;
            }
          }
        }
      }
    }

    // Check for a language code without region
    var parts = preferred.split('_');

    if (parts.length > 1 && indexOf(avail, lowercase(parts[0])) > -1) {
      return parts[0];
    }

    // If everything fails, return undefined.
    return;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#translations
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a new translation table for specific language key.
   *
   * To register a translation table for specific language, pass a defined language
   * key as first parameter.
   *
   * <pre>
   *  // register translation table for language: 'de_DE'
   *  $translateProvider.translations('de_DE', {
   *    'GREETING': 'Hallo Welt!'
   *  });
   *
   *  // register another one
   *  $translateProvider.translations('en_US', {
   *    'GREETING': 'Hello world!'
   *  });
   * </pre>
   *
   * When registering multiple translation tables for for the same language key,
   * the actual translation table gets extended. This allows you to define module
   * specific translation which only get added, once a specific module is loaded in
   * your app.
   *
   * Invoking this method with no arguments returns the translation table which was
   * registered with no language key. Invoking it with a language key returns the
   * related translation table.
   *
   * @param {string} langKey A language key.
   * @param {object} translationTable A plain old JavaScript object that represents a translation table.
   *
   */
  var translations = function (langKey, translationTable) {

    if (!langKey && !translationTable) {
      return $translationTable;
    }

    if (langKey && !translationTable) {
      if (angular.isString(langKey)) {
        return $translationTable[langKey];
      }
    } else {
      if (!angular.isObject($translationTable[langKey])) {
        $translationTable[langKey] = {};
      }
      angular.extend($translationTable[langKey], flatObject(translationTable));
    }
    return this;
  };

  this.translations = translations;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#cloakClassName
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   *
   * Let's you change the class name for `translate-cloak` directive.
   * Default class name is `translate-cloak`.
   *
   * @param {string} name translate-cloak class name
   */
  this.cloakClassName = function (name) {
    if (!name) {
      return $cloakClassName;
    }
    $cloakClassName = name;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   *
   * Let's you change the delimiter for namespaced translations.
   * Default delimiter is `.`.
   *
   * @param {string} delimiter namespace separator
   */
  this.nestedObjectDelimeter = function (delimiter) {
    if (!delimiter) {
      return $nestedObjectDelimeter;
    }
    $nestedObjectDelimeter = delimiter;
    return this;
  };

  /**
   * @name flatObject
   * @private
   *
   * @description
   * Flats an object. This function is used to flatten given translation data with
   * namespaces, so they are later accessible via dot notation.
   */
  var flatObject = function (data, path, result, prevKey) {
    var key, keyWithPath, keyWithShortPath, val;

    if (!path) {
      path = [];
    }
    if (!result) {
      result = {};
    }
    for (key in data) {
      if (!Object.prototype.hasOwnProperty.call(data, key)) {
        continue;
      }
      val = data[key];
      if (angular.isObject(val)) {
        flatObject(val, path.concat(key), result, key);
      } else {
        keyWithPath = path.length ? ('' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key) : key;
        if (path.length && key === prevKey) {
          // Create shortcut path (foo.bar == foo.bar.bar)
          keyWithShortPath = '' + path.join($nestedObjectDelimeter);
          // Link it to original path
          result[keyWithShortPath] = '@:' + keyWithPath;
        }
        result[keyWithPath] = val;
      }
    }
    return result;
  };
  flatObject.displayName = 'flatObject';

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#addInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Adds interpolation services to angular-translate, so it can manage them.
   *
   * @param {object} factory Interpolation service factory
   */
  this.addInterpolation = function (factory) {
    $interpolatorFactories.push(factory);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use interpolation functionality of messageformat.js.
   * This is useful when having high level pluralization and gender selection.
   */
  this.useMessageFormatInterpolation = function () {
    return this.useInterpolation('$translateMessageFormatInterpolation');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate which interpolation style to use as default, application-wide.
   * Simply pass a factory/service name. The interpolation service has to implement
   * the correct interface.
   *
   * @param {string} factory Interpolation service name.
   */
  this.useInterpolation = function (factory) {
    $interpolationFactory = factory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Simply sets a sanitation strategy type.
   *
   * @param {string} value Strategy type.
   */
  this.useSanitizeValueStrategy = function (value) {
    $translateSanitizationProvider.useStrategy(value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#preferredLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which of the registered translation tables to use for translation
   * at initial startup by passing a language key. Similar to `$translateProvider#use`
   * only that it says which language to **prefer**.
   * It is recommended to call this after {@link pascalprecht.translate.$translate#fallbackLanguage fallbackLanguage()}.
   *
   * @param {string} langKey A language key.
   */
  this.preferredLanguage = function (langKey) {
    if (langKey) {
      setupPreferredLanguage(langKey);
      return this;
    }
    return $preferredLanguage;
  };
  var setupPreferredLanguage = function (langKey) {
    if (langKey) {
      $preferredLanguage = langKey;
    }
    return $preferredLanguage;
  };
  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found. E.g. when
   * setting the indicator as 'X' and one tries to translate a translation id
   * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
   *
   * Internally this methods sets a left indicator and a right indicator using
   * `$translateProvider.translationNotFoundIndicatorLeft()` and
   * `$translateProvider.translationNotFoundIndicatorRight()`.
   *
   * **Note**: These methods automatically add a whitespace between the indicators
   * and the translation id.
   *
   * @param {string} indicator An indicator, could be any string.
   */
  this.translationNotFoundIndicator = function (indicator) {
    this.translationNotFoundIndicatorLeft(indicator);
    this.translationNotFoundIndicatorRight(indicator);
    return this;
  };

  /**
   * ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found left to the
   * translation id.
   *
   * @param {string} indicator An indicator.
   */
  this.translationNotFoundIndicatorLeft = function (indicator) {
    if (!indicator) {
      return $notFoundIndicatorLeft;
    }
    $notFoundIndicatorLeft = indicator;
    return this;
  };

  /**
   * ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found right to the
   * translation id.
   *
   * @param {string} indicator An indicator.
   */
  this.translationNotFoundIndicatorRight = function (indicator) {
    if (!indicator) {
      return $notFoundIndicatorRight;
    }
    $notFoundIndicatorRight = indicator;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#fallbackLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which of the registered translation tables to use when missing translations
   * at initial startup by passing a language key. Similar to `$translateProvider#use`
   * only that it says which language to **fallback**.
   *
   * @param {string||array} langKey A language key.
   *
   */
  this.fallbackLanguage = function (langKey) {
    fallbackStack(langKey);
    return this;
  };

  var fallbackStack = function (langKey) {
    if (langKey) {
      if (angular.isString(langKey)) {
        $fallbackWasString = true;
        $fallbackLanguage = [langKey];
      } else if (angular.isArray(langKey)) {
        $fallbackWasString = false;
        $fallbackLanguage = langKey;
      }
      if (angular.isString($preferredLanguage) && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
        $fallbackLanguage.push($preferredLanguage);
      }

      return this;
    } else {
      if ($fallbackWasString) {
        return $fallbackLanguage[0];
      } else {
        return $fallbackLanguage;
      }
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#use
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Set which translation table to use for translation by given language key. When
   * trying to 'use' a language which isn't provided, it'll throw an error.
   *
   * You actually don't have to use this method since `$translateProvider#preferredLanguage`
   * does the job too.
   *
   * @param {string} langKey A language key.
   */
  this.use = function (langKey) {
    if (langKey) {
      if (!$translationTable[langKey] && (!$loaderFactory)) {
        // only throw an error, when not loading translation data asynchronously
        throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
      }
      $uses = langKey;
      return this;
    }
    return $uses;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#resolveClientLocale
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
   *
   * @returns {string} the current client/browser language key
   */
  this.resolveClientLocale = function () {
    return getLocale();
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#storageKey
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which key must represent the choosed language by a user in the storage.
   *
   * @param {string} key A key for the storage.
   */
  var storageKey = function (key) {
    if (!key) {
      if ($storagePrefix) {
        return $storagePrefix + $storageKey;
      }
      return $storageKey;
    }
    $storageKey = key;
    return this;
  };

  this.storageKey = storageKey;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useUrlLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
   *
   * @param {string} url Url
   * @param {Object=} options Optional configuration object
   */
  this.useUrlLoader = function (url, options) {
    return this.useLoader('$translateUrlLoader', angular.extend({url : url}, options));
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
   *
   * @param {Object=} options Optional configuration object
   */
  this.useStaticFilesLoader = function (options) {
    return this.useLoader('$translateStaticFilesLoader', options);
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use any other service as loader.
   *
   * @param {string} loaderFactory Factory name to use
   * @param {Object=} options Optional configuration object
   */
  this.useLoader = function (loaderFactory, options) {
    $loaderFactory = loaderFactory;
    $loaderOptions = options || {};
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLocalStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
   *
   */
  this.useLocalStorage = function () {
    return this.useStorage('$translateLocalStorage');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useCookieStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
   */
  this.useCookieStorage = function () {
    return this.useStorage('$translateCookieStorage');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use custom service as storage layer.
   */
  this.useStorage = function (storageFactory) {
    $storageFactory = storageFactory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#storagePrefix
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets prefix for storage key.
   *
   * @param {string} prefix Storage key prefix
   */
  this.storagePrefix = function (prefix) {
    if (!prefix) {
      return prefix;
    }
    $storagePrefix = prefix;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use built-in log handler when trying to translate
   * a translation Id which doesn't exist.
   *
   * This is actually a shortcut method for `useMissingTranslationHandler()`.
   *
   */
  this.useMissingTranslationHandlerLog = function () {
    return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Expects a factory name which later gets instantiated with `$injector`.
   * This method can be used to tell angular-translate to use a custom
   * missingTranslationHandler. Just build a factory which returns a function
   * and expects a translation id as argument.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.useMissingTranslationHandler('customHandler');
   *  });
   *
   *  app.factory('customHandler', function (dep1, dep2) {
   *    return function (translationId) {
   *      // something with translationId and dep1 and dep2
   *    };
   *  });
   * </pre>
   *
   * @param {string} factory Factory name
   */
  this.useMissingTranslationHandler = function (factory) {
    $missingTranslationHandlerFactory = factory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#usePostCompiling
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If post compiling is enabled, all translated values will be processed
   * again with AngularJS' $compile.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.usePostCompiling(true);
   *  });
   * </pre>
   *
   * @param {string} factory Factory name
   */
  this.usePostCompiling = function (value) {
    $postCompilingEnabled = !(!value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#forceAsyncReload
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If force async reload is enabled, async loader will always be called
   * even if $translationTable already contains the language key, adding
   * possible new entries to the $translationTable.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.forceAsyncReload(true);
   *  });
   * </pre>
   *
   * @param {boolean} value - valid values are true or false
   */
  this.forceAsyncReload = function (value) {
    $forceAsyncReloadEnabled = !(!value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate which language tag should be used as a result when determining
   * the current browser language.
   *
   * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
   *
   * <pre>
   * $translateProvider
   *   .uniformLanguageTag('bcp47')
   *   .determinePreferredLanguage()
   * </pre>
   *
   * The resolver currently supports:
   * * default
   *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
   *     en-US => en_US
   *     en_US => en_US
   *     en-us => en_us
   * * java
   *     like default, but the second part will be always in uppercase
   *     en-US => en_US
   *     en_US => en_US
   *     en-us => en_US
   * * BCP 47 (RFC 4646 & 4647)
   *     EN => en
   *     en-US => en-US
   *     en_US => en-US
   *     en-us => en-US
   *     sr-latn => sr-Latn
   *     sr-latn-rs => sr-Latn-RS
   *
   * See also:
   * * http://en.wikipedia.org/wiki/IETF_language_tag
   * * http://www.w3.org/International/core/langtags/
   * * http://tools.ietf.org/html/bcp47
   *
   * @param {string|object} options - options (or standard)
   * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
   */
  this.uniformLanguageTag = function (options) {

    if (!options) {
      options = {};
    } else if (angular.isString(options)) {
      options = {
        standard : options
      };
    }

    uniformLanguageTagResolver = options.standard;

    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to try to determine on its own which language key
   * to set as preferred language. When `fn` is given, angular-translate uses it
   * to determine a language key, otherwise it uses the built-in `getLocale()`
   * method.
   *
   * The `getLocale()` returns a language key in the format `[lang]_[country]` or
   * `[lang]` depending on what the browser provides.
   *
   * Use this method at your own risk, since not all browsers return a valid
   * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
   *
   * @param {Function=} fn Function to determine a browser's locale
   */
  this.determinePreferredLanguage = function (fn) {

    var locale = (fn && angular.isFunction(fn)) ? fn() : getLocale();

    if (!$availableLanguageKeys.length) {
      $preferredLanguage = locale;
    } else {
      $preferredLanguage = negotiateLocale(locale) || locale;
    }

    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a set of language keys the app will work with. Use this method in
   * combination with
   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
   * When available languages keys are registered, angular-translate
   * tries to find the best fitting language key depending on the browsers locale,
   * considering your language key convention.
   *
   * @param {object} languageKeys Array of language keys the your app will use
   * @param {object=} aliases Alias map.
   */
  this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
    if (languageKeys) {
      $availableLanguageKeys = languageKeys;
      if (aliases) {
        $languageKeyAliases = aliases;
      }
      return this;
    }
    return $availableLanguageKeys;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLoaderCache
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a cache for internal $http based loaders.
   * {@link pascalprecht.translate.$translationCache $translationCache}.
   * When false the cache will be disabled (default). When true or undefined
   * the cache will be a default (see $cacheFactory). When an object it will
   * be treat as a cache object itself: the usage is $http({cache: cache})
   *
   * @param {object} cache boolean, string or cache-object
   */
  this.useLoaderCache = function (cache) {
    if (cache === false) {
      // disable cache
      loaderCache = undefined;
    } else if (cache === true) {
      // enable cache using AJS defaults
      loaderCache = true;
    } else if (typeof(cache) === 'undefined') {
      // enable cache using default
      loaderCache = '$translationCache';
    } else if (cache) {
      // enable cache using given one (see $cacheFactory)
      loaderCache = cache;
    }
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#directivePriority
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets the default priority of the translate directive. The standard value is `0`.
   * Calling this function without an argument will return the current value.
   *
   * @param {number} priority for the translate-directive
   */
  this.directivePriority = function (priority) {
    if (priority === undefined) {
      // getter
      return directivePriority;
    } else {
      // setter with chaining
      directivePriority = priority;
      return this;
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#statefulFilter
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
   * have to explicit define this behavior.
   * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
   * meaning being stateful.
   * Calling this function without an argument will return the current value.
   *
   * @param {boolean} state - defines the state of the filter
   */
  this.statefulFilter = function (state) {
    if (state === undefined) {
      // getter
      return statefulFilter;
    } else {
      // setter with chaining
      statefulFilter = state;
      return this;
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#postProcess
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * The post processor will be intercept right after the translation result. It can modify the result.
   *
   * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
   */
  this.postProcess = function (fn) {
    if (fn) {
      postProcessFn = fn;
    } else {
      postProcessFn = undefined;
    }
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#keepContent
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If keepContent is set to true than translate directive will always use innerHTML
   * as a default translation
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.keepContent(true);
   *  });
   * </pre>
   *
   * @param {boolean} value - valid values are true or false
   */
  this.keepContent = function (value) {
    $keepContent = !(!value);
    return this;
  };

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translate
   * @requires $interpolate
   * @requires $log
   * @requires $rootScope
   * @requires $q
   *
   * @description
   * The `$translate` service is the actual core of angular-translate. It expects a translation id
   * and optional interpolate parameters to translate contents.
   *
   * <pre>
   *  $translate('HEADLINE_TEXT').then(function (translation) {
   *    $scope.translatedText = translation;
   *  });
   * </pre>
   *
   * @param {string|array} translationId A token which represents a translation id
   *                                     This can be optionally an array of translation ids which
   *                                     results that the function returns an object where each key
   *                                     is the translation id and the value the translation.
   * @param {object=} [interpolateParams={}] An object hash for dynamic values
   * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
   * @param {string=} [defaultTranslationText=undefined] the optional default translation text that is written as
   *                                        as default text in case it is not found in any configured language
   * @param {string=} [forceLanguage=false] A language to be used instead of the current language
   * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
   * @returns {object} promise
   */
  this.$get = ['$log', '$injector', '$rootScope', '$q', function ($log, $injector, $rootScope, $q) {

    var Storage,
      defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
      pendingLoader = false,
      interpolatorHashMap = {},
      langPromises = {},
      fallbackIndex,
      startFallbackIteration;

    var $translate = function (translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy) {
      if (!$uses && $preferredLanguage) {
        $uses = $preferredLanguage;
      }
      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;

      // Check forceLanguage is present
      if (forceLanguage) {
        loadTranslationsIfMissing(forceLanguage);
      }

      // Duck detection: If the first argument is an array, a bunch of translations was requested.
      // The result is an object.
      if (angular.isArray(translationId)) {
        // Inspired by Q.allSettled by Kris Kowal
        // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
        // This transforms all promises regardless resolved or rejected
        var translateAll = function (translationIds) {
          var results = {}; // storing the actual results
          var promises = []; // promises to wait for
          // Wraps the promise a) being always resolved and b) storing the link id->value
          var translate = function (translationId) {
            var deferred = $q.defer();
            var regardless = function (value) {
              results[translationId] = value;
              deferred.resolve([translationId, value]);
            };
            // we don't care whether the promise was resolved or rejected; just store the values
            $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy).then(regardless, regardless);
            return deferred.promise;
          };
          for (var i = 0, c = translationIds.length; i < c; i++) {
            promises.push(translate(translationIds[i]));
          }
          // wait for all (including storing to results)
          return $q.all(promises).then(function () {
            // return the results
            return results;
          });
        };
        return translateAll(translationId);
      }

      var deferred = $q.defer();

      // trim off any whitespace
      if (translationId) {
        translationId = trim.apply(translationId);
      }

      var promiseToWaitFor = (function () {
        var promise = langPromises[uses] || langPromises[$preferredLanguage];

        fallbackIndex = 0;

        if ($storageFactory && !promise) {
          // looks like there's no pending promise for $preferredLanguage or
          // $uses. Maybe there's one pending for a language that comes from
          // storage.
          var langKey = Storage.get($storageKey);
          promise = langPromises[langKey];

          if ($fallbackLanguage && $fallbackLanguage.length) {
            var index = indexOf($fallbackLanguage, langKey);
            // maybe the language from storage is also defined as fallback language
            // we increase the fallback language index to not search in that language
            // as fallback, since it's probably the first used language
            // in that case the index starts after the first element
            fallbackIndex = (index === 0) ? 1 : 0;

            // but we can make sure to ALWAYS fallback to preferred language at least
            if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
              $fallbackLanguage.push($preferredLanguage);
            }
          }
        }
        return promise;
      }());

      if (!promiseToWaitFor) {
        // no promise to wait for? okay. Then there's no loader registered
        // nor is a one pending for language that comes from storage.
        // We can just translate.
        determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
      } else {
        var promiseResolved = function () {
          // $uses may have changed while waiting
          if (!forceLanguage) {
            uses = $uses;
          }
          determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
        };
        promiseResolved.displayName = 'promiseResolved';

        promiseToWaitFor['finally'](promiseResolved)['catch'](angular.noop); // we don't care about errors here, already handled
      }
      return deferred.promise;
    };

    /**
     * @name applyNotFoundIndicators
     * @private
     *
     * @description
     * Applies not fount indicators to given translation id, if needed.
     * This function gets only executed, if a translation id doesn't exist,
     * which is why a translation id is expected as argument.
     *
     * @param {string} translationId Translation id.
     * @returns {string} Same as given translation id but applied with not found
     * indicators.
     */
    var applyNotFoundIndicators = function (translationId) {
      // applying notFoundIndicators
      if ($notFoundIndicatorLeft) {
        translationId = [$notFoundIndicatorLeft, translationId].join(' ');
      }
      if ($notFoundIndicatorRight) {
        translationId = [translationId, $notFoundIndicatorRight].join(' ');
      }
      return translationId;
    };

    /**
     * @name useLanguage
     * @private
     *
     * @description
     * Makes actual use of a language by setting a given language key as used
     * language and informs registered interpolators to also use the given
     * key as locale.
     *
     * @param {string} key Locale key.
     */
    var useLanguage = function (key) {
      $uses = key;

      // make sure to store new language key before triggering success event
      if ($storageFactory) {
        Storage.put($translate.storageKey(), $uses);
      }

      $rootScope.$emit('$translateChangeSuccess', {language : key});

      // inform default interpolator
      defaultInterpolator.setLocale($uses);

      var eachInterpolator = function (interpolator, id) {
        interpolatorHashMap[id].setLocale($uses);
      };
      eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';

      // inform all others too!
      angular.forEach(interpolatorHashMap, eachInterpolator);
      $rootScope.$emit('$translateChangeEnd', {language : key});
    };

    /**
     * @name loadAsync
     * @private
     *
     * @description
     * Kicks off registered async loader using `$injector` and applies existing
     * loader options. When resolved, it updates translation tables accordingly
     * or rejects with given language key.
     *
     * @param {string} key Language key.
     * @return {Promise} A promise.
     */
    var loadAsync = function (key) {
      if (!key) {
        throw 'No language key specified for loading.';
      }

      var deferred = $q.defer();

      $rootScope.$emit('$translateLoadingStart', {language : key});
      pendingLoader = true;

      var cache = loaderCache;
      if (typeof(cache) === 'string') {
        // getting on-demand instance of loader
        cache = $injector.get(cache);
      }

      var loaderOptions = angular.extend({}, $loaderOptions, {
        key : key,
        $http : angular.extend({}, {
          cache : cache
        }, $loaderOptions.$http)
      });

      var onLoaderSuccess = function (data) {
        var translationTable = {};
        $rootScope.$emit('$translateLoadingSuccess', {language : key});

        if (angular.isArray(data)) {
          angular.forEach(data, function (table) {
            angular.extend(translationTable, flatObject(table));
          });
        } else {
          angular.extend(translationTable, flatObject(data));
        }
        pendingLoader = false;
        deferred.resolve({
          key : key,
          table : translationTable
        });
        $rootScope.$emit('$translateLoadingEnd', {language : key});
      };
      onLoaderSuccess.displayName = 'onLoaderSuccess';

      var onLoaderError = function (key) {
        $rootScope.$emit('$translateLoadingError', {language : key});
        deferred.reject(key);
        $rootScope.$emit('$translateLoadingEnd', {language : key});
      };
      onLoaderError.displayName = 'onLoaderError';

      $injector.get($loaderFactory)(loaderOptions)
        .then(onLoaderSuccess, onLoaderError);

      return deferred.promise;
    };

    if ($storageFactory) {
      Storage = $injector.get($storageFactory);

      if (!Storage.get || !Storage.put) {
        throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
      }
    }

    // if we have additional interpolations that were added via
    // $translateProvider.addInterpolation(), we have to map'em
    if ($interpolatorFactories.length) {
      var eachInterpolationFactory = function (interpolatorFactory) {
        var interpolator = $injector.get(interpolatorFactory);
        // setting initial locale for each interpolation service
        interpolator.setLocale($preferredLanguage || $uses);
        // make'em recognizable through id
        interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
      };
      eachInterpolationFactory.displayName = 'interpolationFactoryAdder';

      angular.forEach($interpolatorFactories, eachInterpolationFactory);
    }

    /**
     * @name getTranslationTable
     * @private
     *
     * @description
     * Returns a promise that resolves to the translation table
     * or is rejected if an error occurred.
     *
     * @param langKey
     * @returns {Q.promise}
     */
    var getTranslationTable = function (langKey) {
      var deferred = $q.defer();
      if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
        deferred.resolve($translationTable[langKey]);
      } else if (langPromises[langKey]) {
        var onResolve = function (data) {
          translations(data.key, data.table);
          deferred.resolve(data.table);
        };
        onResolve.displayName = 'translationTableResolver';
        langPromises[langKey].then(onResolve, deferred.reject);
      } else {
        deferred.reject();
      }
      return deferred.promise;
    };

    /**
     * @name getFallbackTranslation
     * @private
     *
     * @description
     * Returns a promise that will resolve to the translation
     * or be rejected if no translation was found for the language.
     * This function is currently only used for fallback language translation.
     *
     * @param langKey The language to translate to.
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {Q.promise}
     */
    var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      var deferred = $q.defer();

      var onResolve = function (translationTable) {
        if (Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
          Interpolator.setLocale(langKey);
          var translation = translationTable[translationId];
          if (translation.substr(0, 2) === '@:') {
            getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator, sanitizeStrategy)
              .then(deferred.resolve, deferred.reject);
          } else {
            var interpolatedValue = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'service', sanitizeStrategy, translationId);
            interpolatedValue = applyPostProcessing(translationId, translationTable[translationId], interpolatedValue, interpolateParams, langKey);

            deferred.resolve(interpolatedValue);

          }
          Interpolator.setLocale($uses);
        } else {
          deferred.reject();
        }
      };
      onResolve.displayName = 'fallbackTranslationResolver';

      getTranslationTable(langKey).then(onResolve, deferred.reject);

      return deferred.promise;
    };

    /**
     * @name getFallbackTranslationInstant
     * @private
     *
     * @description
     * Returns a translation
     * This function is currently only used for fallback language translation.
     *
     * @param langKey The language to translate to.
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy sanitize strategy override
     *
     * @returns {string} translation
     */
    var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      var result, translationTable = $translationTable[langKey];

      if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
        Interpolator.setLocale(langKey);
        result = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'filter', sanitizeStrategy, translationId);
        result = applyPostProcessing(translationId, translationTable[translationId], result, interpolateParams, langKey, sanitizeStrategy);
        // workaround for TrustedValueHolderType
        if (!angular.isString(result) && angular.isFunction(result.$$unwrapTrustedValue)) {
          var result2 = result.$$unwrapTrustedValue();
          if (result2.substr(0, 2) === '@:') {
            return getFallbackTranslationInstant(langKey, result2.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
          }
        } else if (result.substr(0, 2) === '@:') {
          return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
        }
        Interpolator.setLocale($uses);
      }

      return result;
    };


    /**
     * @name translateByHandler
     * @private
     *
     * Translate by missing translation handler.
     *
     * @param translationId
     * @param interpolateParams
     * @param defaultTranslationText
     * @param sanitizeStrategy sanitize strategy override
     *
     * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
     * absent
     */
    var translateByHandler = function (translationId, interpolateParams, defaultTranslationText, sanitizeStrategy) {
      // If we have a handler factory - we might also call it here to determine if it provides
      // a default text for a translationid that can't be found anywhere in our tables
      if ($missingTranslationHandlerFactory) {
        return $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams, defaultTranslationText, sanitizeStrategy);
      } else {
        return translationId;
      }
    };

    /**
     * @name resolveForFallbackLanguage
     * @private
     *
     * Recursive helper function for fallbackTranslation that will sequentially look
     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
     *
     * @param fallbackLanguageIndex
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param defaultTranslationText
     * @param sanitizeStrategy
     * @returns {Q.promise} Promise that will resolve to the translation.
     */
    var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
      var deferred = $q.defer();

      if (fallbackLanguageIndex < $fallbackLanguage.length) {
        var langKey = $fallbackLanguage[fallbackLanguageIndex];
        getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy).then(
          function (data) {
            deferred.resolve(data);
          },
          function () {
            // Look in the next fallback language for a translation.
            // It delays the resolving by passing another promise to resolve.
            return resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(deferred.resolve, deferred.reject);
          }
        );
      } else {
        // No translation found in any fallback language
        // if a default translation text is set in the directive, then return this as a result
        if (defaultTranslationText) {
          deferred.resolve(defaultTranslationText);
        } else {
          var missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);

          // if no default translation is set and an error handler is defined, send it to the handler
          // and then return the result if it isn't undefined
          if ($missingTranslationHandlerFactory && missingTranslationHandlerTranslation) {
            deferred.resolve(missingTranslationHandlerTranslation);
          } else {
            deferred.reject(applyNotFoundIndicators(translationId));
          }
        }
      }
      return deferred.promise;
    };

    /**
     * @name resolveForFallbackLanguageInstant
     * @private
     *
     * Recursive helper function for fallbackTranslation that will sequentially look
     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
     *
     * @param fallbackLanguageIndex
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {string} translation
     */
    var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      var result;

      if (fallbackLanguageIndex < $fallbackLanguage.length) {
        var langKey = $fallbackLanguage[fallbackLanguageIndex];
        result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy);
        if (!result && result !== '') {
          result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
        }
      }
      return result;
    };

    /**
     * Translates with the usage of the fallback languages.
     *
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param defaultTranslationText
     * @param sanitizeStrategy
     * @returns {Q.promise} Promise, that resolves to the translation.
     */
    var fallbackTranslation = function (translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
      // Start with the fallbackLanguage with index 0
      return resolveForFallbackLanguage((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy);
    };

    /**
     * Translates with the usage of the fallback languages.
     *
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {String} translation
     */
    var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      // Start with the fallbackLanguage with index 0
      return resolveForFallbackLanguageInstant((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, sanitizeStrategy);
    };

    var determineTranslation = function (translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy) {

      var deferred = $q.defer();

      var table = uses ? $translationTable[uses] : $translationTable,
        Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;

      // if the translation id exists, we can just interpolate it
      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
        var translation = table[translationId];

        // If using link, rerun $translate with linked translationId and return it
        if (translation.substr(0, 2) === '@:') {

          $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy)
            .then(deferred.resolve, deferred.reject);
        } else {
          //
          var resolvedTranslation = Interpolator.interpolate(translation, interpolateParams, 'service', sanitizeStrategy, translationId);
          resolvedTranslation = applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses);
          deferred.resolve(resolvedTranslation);
        }
      } else {
        var missingTranslationHandlerTranslation;
        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
        if ($missingTranslationHandlerFactory && !pendingLoader) {
          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
        }

        // since we couldn't translate the inital requested translation id,
        // we try it now with one or more fallback languages, if fallback language(s) is
        // configured.
        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
          fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy)
            .then(function (translation) {
              deferred.resolve(translation);
            }, function (_translationId) {
              deferred.reject(applyNotFoundIndicators(_translationId));
            });
        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
          // looks like the requested translation id doesn't exists.
          // Now, if there is a registered handler for missing translations and no
          // asyncLoader is pending, we execute the handler
          if (defaultTranslationText) {
            deferred.resolve(defaultTranslationText);
          } else {
            deferred.resolve(missingTranslationHandlerTranslation);
          }
        } else {
          if (defaultTranslationText) {
            deferred.resolve(defaultTranslationText);
          } else {
            deferred.reject(applyNotFoundIndicators(translationId));
          }
        }
      }
      return deferred.promise;
    };

    var determineTranslationInstant = function (translationId, interpolateParams, interpolationId, uses, sanitizeStrategy) {

      var result, table = uses ? $translationTable[uses] : $translationTable,
        Interpolator = defaultInterpolator;

      // if the interpolation id exists use custom interpolator
      if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
        Interpolator = interpolatorHashMap[interpolationId];
      }

      // if the translation id exists, we can just interpolate it
      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
        var translation = table[translationId];

        // If using link, rerun $translate with linked translationId and return it
        if (translation.substr(0, 2) === '@:') {
          result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId, uses, sanitizeStrategy);
        } else {
          result = Interpolator.interpolate(translation, interpolateParams, 'filter', sanitizeStrategy, translationId);
          result = applyPostProcessing(translationId, translation, result, interpolateParams, uses, sanitizeStrategy);
        }
      } else {
        var missingTranslationHandlerTranslation;
        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
        if ($missingTranslationHandlerFactory && !pendingLoader) {
          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
        }

        // since we couldn't translate the inital requested translation id,
        // we try it now with one or more fallback languages, if fallback language(s) is
        // configured.
        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
          fallbackIndex = 0;
          result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy);
        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
          // looks like the requested translation id doesn't exists.
          // Now, if there is a registered handler for missing translations and no
          // asyncLoader is pending, we execute the handler
          result = missingTranslationHandlerTranslation;
        } else {
          result = applyNotFoundIndicators(translationId);
        }
      }

      return result;
    };

    var clearNextLangAndPromise = function (key) {
      if ($nextLang === key) {
        $nextLang = undefined;
      }
      langPromises[key] = undefined;
    };

    var applyPostProcessing = function (translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy) {
      var fn = postProcessFn;

      if (fn) {

        if (typeof(fn) === 'string') {
          // getting on-demand instance
          fn = $injector.get(fn);
        }
        if (fn) {
          return fn(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy);
        }
      }

      return resolvedTranslation;
    };

    var loadTranslationsIfMissing = function (key) {
      if (!$translationTable[key] && $loaderFactory && !langPromises[key]) {
        langPromises[key] = loadAsync(key).then(function (translation) {
          translations(translation.key, translation.table);
          return translation;
        });
      }
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#preferredLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key for the preferred language.
     *
     * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
     *
     * @return {string} preferred language key
     */
    $translate.preferredLanguage = function (langKey) {
      if (langKey) {
        setupPreferredLanguage(langKey);
      }
      return $preferredLanguage;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#cloakClassName
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the configured class name for `translate-cloak` directive.
     *
     * @return {string} cloakClassName
     */
    $translate.cloakClassName = function () {
      return $cloakClassName;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#nestedObjectDelimeter
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the configured delimiter for nested namespaces.
     *
     * @return {string} nestedObjectDelimeter
     */
    $translate.nestedObjectDelimeter = function () {
      return $nestedObjectDelimeter;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#fallbackLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key for the fallback languages or sets a new fallback stack.
     * It is recommended to call this before {@link pascalprecht.translate.$translateProvider#preferredLanguage preferredLanguage()}.
     *
     * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
     *
     * @return {string||array} fallback language key
     */
    $translate.fallbackLanguage = function (langKey) {
      if (langKey !== undefined && langKey !== null) {
        fallbackStack(langKey);

        // as we might have an async loader initiated and a new translation language might have been defined
        // we need to add the promise to the stack also. So - iterate.
        if ($loaderFactory) {
          if ($fallbackLanguage && $fallbackLanguage.length) {
            for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
              if (!langPromises[$fallbackLanguage[i]]) {
                langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
              }
            }
          }
        }
        $translate.use($translate.use());
      }
      if ($fallbackWasString) {
        return $fallbackLanguage[0];
      } else {
        return $fallbackLanguage;
      }

    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#useFallbackLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Sets the first key of the fallback language stack to be used for translation.
     * Therefore all languages in the fallback array BEFORE this key will be skipped!
     *
     * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
     * get back to the whole stack
     */
    $translate.useFallbackLanguage = function (langKey) {
      if (langKey !== undefined && langKey !== null) {
        if (!langKey) {
          startFallbackIteration = 0;
        } else {
          var langKeyPosition = indexOf($fallbackLanguage, langKey);
          if (langKeyPosition > -1) {
            startFallbackIteration = langKeyPosition;
          }
        }

      }

    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#proposedLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key of language that is currently loaded asynchronously.
     *
     * @return {string} language key
     */
    $translate.proposedLanguage = function () {
      return $nextLang;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#storage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns registered storage.
     *
     * @return {object} Storage
     */
    $translate.storage = function () {
      return Storage;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#negotiateLocale
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns a language key based on available languages and language aliases. If a
     * language key cannot be resolved, returns undefined.
     *
     * If no or a falsy key is given, returns undefined.
     *
     * @param {string} [key] Language key
     * @return {string|undefined} Language key or undefined if no language key is found.
     */
    $translate.negotiateLocale = negotiateLocale;

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#use
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Tells angular-translate which language to use by given language key. This method is
     * used to change language at runtime. It also takes care of storing the language
     * key in a configured store to let your app remember the choosed language.
     *
     * When trying to 'use' a language which isn't available it tries to load it
     * asynchronously with registered loaders.
     *
     * Returns promise object with loaded language file data or string of the currently used language.
     *
     * If no or a falsy key is given it returns the currently used language key.
     * The returned string will be ```undefined``` if setting up $translate hasn't finished.
     * @example
     * $translate.use("en_US").then(function(data){
       *   $scope.text = $translate("HELLO");
       * });
     *
     * @param {string=} key Language key
     * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
     */
    $translate.use = function (key) {
      if (!key) {
        return $uses;
      }

      var deferred = $q.defer();
      deferred.promise.then(null, angular.noop); // AJS "Possibly unhandled rejection"

      $rootScope.$emit('$translateChangeStart', {language : key});

      // Try to get the aliased language key
      var aliasedKey = negotiateLocale(key);
      // Ensure only registered language keys will be loaded
      if ($availableLanguageKeys.length > 0 && !aliasedKey) {
        return $q.reject(key);
      }

      if (aliasedKey) {
        key = aliasedKey;
      }

      // if there isn't a translation table for the language we've requested,
      // we load it asynchronously
      $nextLang = key;
      if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
        langPromises[key] = loadAsync(key).then(function (translation) {
          translations(translation.key, translation.table);
          deferred.resolve(translation.key);
          if ($nextLang === key) {
            useLanguage(translation.key);
          }
          return translation;
        }, function (key) {
          $rootScope.$emit('$translateChangeError', {language : key});
          deferred.reject(key);
          $rootScope.$emit('$translateChangeEnd', {language : key});
          return $q.reject(key);
        });
        langPromises[key]['finally'](function () {
          clearNextLangAndPromise(key);
        })['catch'](angular.noop); // we don't care about errors (clearing)
      } else if (langPromises[key]) {
        // we are already loading this asynchronously
        // resolve our new deferred when the old langPromise is resolved
        langPromises[key].then(function (translation) {
          if ($nextLang === translation.key) {
            useLanguage(translation.key);
          }
          deferred.resolve(translation.key);
          return translation;
        }, function (key) {
          // find first available fallback language if that request has failed
          if (!$uses && $fallbackLanguage && $fallbackLanguage.length > 0 && $fallbackLanguage[0] !== key) {
            return $translate.use($fallbackLanguage[0]).then(deferred.resolve, deferred.reject);
          } else {
            return deferred.reject(key);
          }
        });
      } else {
        deferred.resolve(key);
        useLanguage(key);
      }

      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#resolveClientLocale
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
     *
     * @returns {string} the current client/browser language key
     */
    $translate.resolveClientLocale = function () {
      return getLocale();
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#storageKey
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the key for the storage.
     *
     * @return {string} storage key
     */
    $translate.storageKey = function () {
      return storageKey();
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isPostCompilingEnabled
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether post compiling is enabled or not
     *
     * @return {bool} storage key
     */
    $translate.isPostCompilingEnabled = function () {
      return $postCompilingEnabled;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether force async reload is enabled or not
     *
     * @return {boolean} forceAsyncReload value
     */
    $translate.isForceAsyncReloadEnabled = function () {
      return $forceAsyncReloadEnabled;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isKeepContent
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether keepContent or not
     *
     * @return {boolean} keepContent value
     */
    $translate.isKeepContent = function () {
      return $keepContent;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#refresh
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
     * the module will drop all existent translation tables and load new version of those which
     * are currently in use.
     *
     * Refresh means that the module will drop target translation table and try to load it again.
     *
     * In case there are no loaders registered the refresh() method will throw an Error.
     *
     * If the module is able to refresh translation tables refresh() method will broadcast
     * $translateRefreshStart and $translateRefreshEnd events.
     *
     * @example
     * // this will drop all currently existent translation tables and reload those which are
     * // currently in use
     * $translate.refresh();
     * // this will refresh a translation table for the en_US language
     * $translate.refresh('en_US');
     *
     * @param {string} langKey A language key of the table, which has to be refreshed
     *
     * @return {promise} Promise, which will be resolved in case a translation tables refreshing
     * process is finished successfully, and reject if not.
     */
    $translate.refresh = function (langKey) {
      if (!$loaderFactory) {
        throw new Error('Couldn\'t refresh translation table, no loader registered!');
      }

      $rootScope.$emit('$translateRefreshStart', {language : langKey});

      var deferred = $q.defer(), updatedLanguages = {};

      //private helper
      function loadNewData(languageKey) {
        var promise = loadAsync(languageKey);
        //update the load promise cache for this language
        langPromises[languageKey] = promise;
        //register a data handler for the promise
        promise.then(function (data) {
            //clear the cache for this language
            $translationTable[languageKey] = {};
            //add the new data for this language
            translations(languageKey, data.table);
            //track that we updated this language
            updatedLanguages[languageKey] = true;
          },
          //handle rejection to appease the $q validation
          angular.noop);
        return promise;
      }

      //set up post-processing
      deferred.promise.then(
        function () {
          for (var key in $translationTable) {
            if ($translationTable.hasOwnProperty(key)) {
              //delete cache entries that were not updated
              if (!(key in updatedLanguages)) {
                delete $translationTable[key];
              }
            }
          }
          if ($uses) {
            useLanguage($uses);
          }
        },
        //handle rejection to appease the $q validation
        angular.noop
      )['finally'](
        function () {
          $rootScope.$emit('$translateRefreshEnd', {language : langKey});
        }
      );

      if (!langKey) {
        // if there's no language key specified we refresh ALL THE THINGS!
        var languagesToReload = $fallbackLanguage && $fallbackLanguage.slice() || [];
        if ($uses && languagesToReload.indexOf($uses) === -1) {
          languagesToReload.push($uses);
        }
        $q.all(languagesToReload.map(loadNewData)).then(deferred.resolve, deferred.reject);

      } else if ($translationTable[langKey]) {
        //just refresh the specified language cache
        loadNewData(langKey).then(deferred.resolve, deferred.reject);

      } else {
        deferred.reject();
      }

      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#instant
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns a translation instantly from the internal state of loaded translation. All rules
     * regarding the current language, the preferred language of even fallback languages will be
     * used except any promise handling. If a language was not found, an asynchronous loading
     * will be invoked in the background.
     *
     * @param {string|array} translationId A token which represents a translation id
     *                                     This can be optionally an array of translation ids which
     *                                     results that the function's promise returns an object where
     *                                     each key is the translation id and the value the translation.
     * @param {object=} [interpolateParams={}] Params
     * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
     * @param {string=} [forceLanguage=false] A language to be used instead of the current language
     * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
     *
     * @return {string|object} translation
     */
    $translate.instant = function (translationId, interpolateParams, interpolationId, forceLanguage, sanitizeStrategy) {

      // we don't want to re-negotiate $uses
      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;

      // Detect undefined and null values to shorten the execution and prevent exceptions
      if (translationId === null || angular.isUndefined(translationId)) {
        return translationId;
      }

      // Check forceLanguage is present
      if (forceLanguage) {
        loadTranslationsIfMissing(forceLanguage);
      }

      // Duck detection: If the first argument is an array, a bunch of translations was requested.
      // The result is an object.
      if (angular.isArray(translationId)) {
        var results = {};
        for (var i = 0, c = translationId.length; i < c; i++) {
          results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId, forceLanguage, sanitizeStrategy);
        }
        return results;
      }

      // We discarded unacceptable values. So we just need to verify if translationId is empty String
      if (angular.isString(translationId) && translationId.length < 1) {
        return translationId;
      }

      // trim off any whitespace
      if (translationId) {
        translationId = trim.apply(translationId);
      }

      var result, possibleLangKeys = [];
      if ($preferredLanguage) {
        possibleLangKeys.push($preferredLanguage);
      }
      if (uses) {
        possibleLangKeys.push(uses);
      }
      if ($fallbackLanguage && $fallbackLanguage.length) {
        possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
      }
      for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
        var possibleLangKey = possibleLangKeys[j];
        if ($translationTable[possibleLangKey]) {
          if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
            result = determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy);
          }
        }
        if (typeof result !== 'undefined') {
          break;
        }
      }

      if (!result && result !== '') {
        if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
          result = applyNotFoundIndicators(translationId);
        } else {
          // Return translation of default interpolator if not found anything.
          result = defaultInterpolator.interpolate(translationId, interpolateParams, 'filter', sanitizeStrategy);

          // looks like the requested translation id doesn't exists.
          // Now, if there is a registered handler for missing translations and no
          // asyncLoader is pending, we execute the handler
          var missingTranslationHandlerTranslation;
          if ($missingTranslationHandlerFactory && !pendingLoader) {
            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
          }

          if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
            result = missingTranslationHandlerTranslation;
          }
        }
      }

      return result;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#versionInfo
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the current version information for the angular-translate library
     *
     * @return {string} angular-translate version
     */
    $translate.versionInfo = function () {
      return version;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#loaderCache
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the defined loaderCache.
     *
     * @return {boolean|string|object} current value of loaderCache
     */
    $translate.loaderCache = function () {
      return loaderCache;
    };

    // internal purpose only
    $translate.directivePriority = function () {
      return directivePriority;
    };

    // internal purpose only
    $translate.statefulFilter = function () {
      return statefulFilter;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isReady
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether the service is "ready" to translate (i.e. loading 1st language).
     *
     * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
     *
     * @return {boolean} current value of ready
     */
    $translate.isReady = function () {
      return $isReady;
    };

    var $onReadyDeferred = $q.defer();
    $onReadyDeferred.promise.then(function () {
      $isReady = true;
    });

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#onReady
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Calls the function provided or resolved the returned promise after the service is "ready" to translate (i.e. loading 1st language).
     *
     * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
     *
     * @param {Function=} fn Function to invoke when service is ready
     * @return {object} Promise resolved when service is ready
     */
    $translate.onReady = function (fn) {
      var deferred = $q.defer();
      if (angular.isFunction(fn)) {
        deferred.promise.then(fn);
      }
      if ($isReady) {
        deferred.resolve();
      } else {
        $onReadyDeferred.promise.then(deferred.resolve);
      }
      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * This function simply returns the registered language keys being defined before in the config phase
     * With this, an application can use the array to provide a language selection dropdown or similar
     * without any additional effort
     *
     * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
     */
    $translate.getAvailableLanguageKeys = function () {
      if ($availableLanguageKeys.length > 0) {
        return $availableLanguageKeys;
      }
      return null;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#getTranslationTable
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns translation table by the given language key.
     *
     * Unless a language is provided it returns a translation table of the current one.
     * Note: If translation dictionary is currently downloading or in progress
     * it will return null.
     *
     * @param {string} langKey A token which represents a translation id
     *
     * @return {object} a copy of angular-translate $translationTable
     */
    $translate.getTranslationTable = function (langKey) {
      langKey = langKey || $translate.use();
      if (langKey && $translationTable[langKey]) {
        return angular.copy($translationTable[langKey]);
      }
      return null;
    };

    // Whenever $translateReady is being fired, this will ensure the state of $isReady
    var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
      $onReadyDeferred.resolve();
      globalOnReadyListener(); // one time only
      globalOnReadyListener = null;
    });
    var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
      $onReadyDeferred.resolve();
      globalOnChangeListener(); // one time only
      globalOnChangeListener = null;
    });

    if ($loaderFactory) {

      // If at least one async loader is defined and there are no
      // (default) translations available we should try to load them.
      if (angular.equals($translationTable, {})) {
        if ($translate.use()) {
          $translate.use($translate.use());
        }
      }

      // Also, if there are any fallback language registered, we start
      // loading them asynchronously as soon as we can.
      if ($fallbackLanguage && $fallbackLanguage.length) {
        var processAsyncResult = function (translation) {
          translations(translation.key, translation.table);
          $rootScope.$emit('$translateChangeEnd', {language : translation.key});
          return translation;
        };
        for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
          var fallbackLanguageId = $fallbackLanguage[i];
          if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
            langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
          }
        }
      }
    } else {
      $rootScope.$emit('$translateReady', {language : $translate.use()});
    }

    return $translate;
  }];
}

$translate.displayName = 'displayName';

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateDefaultInterpolation
 * @requires $interpolate
 *
 * @description
 * Uses angular's `$interpolate` services to interpolate strings against some values.
 *
 * Be aware to configure a proper sanitization strategy.
 *
 * See also:
 * * {@link pascalprecht.translate.$translateSanitization}
 *
 * @return {object} $translateDefaultInterpolation Interpolator service
 */
angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);

function $translateDefaultInterpolation ($interpolate, $translateSanitization) {

  'use strict';

  var $translateInterpolator = {},
      $locale,
      $identifier = 'default';

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Sets current locale (this is currently not use in this interpolation).
   *
   * @param {string} locale Language key or locale.
   */
  $translateInterpolator.setLocale = function (locale) {
    $locale = locale;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Returns an identifier for this interpolation service.
   *
   * @returns {string} $identifier
   */
  $translateInterpolator.getInterpolationIdentifier = function () {
    return $identifier;
  };

  /**
   * @deprecated will be removed in 3.0
   * @see {@link pascalprecht.translate.$translateSanitization}
   */
  $translateInterpolator.useSanitizeValueStrategy = function (value) {
    $translateSanitization.useStrategy(value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Interpolates given value agains given interpolate params using angulars
   * `$interpolate` service.
   *
   * Since AngularJS 1.5, `value` must not be a string but can be anything input.
   *
   * @param {string} value translation
   * @param {object} [interpolationParams={}] interpolation params
   * @param {string} [context=undefined] current context (filter, directive, service)
   * @param {string} [sanitizeStrategy=undefined] sanitize strategy (use default unless set)
   * @param {string} translationId current translationId
   *
   * @returns {string} interpolated string
   */
  $translateInterpolator.interpolate = function (value, interpolationParams, context, sanitizeStrategy, translationId) { // jshint ignore:line
    interpolationParams = interpolationParams || {};
    interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy, context);

    var interpolatedText;
    if (angular.isNumber(value)) {
      // numbers are safe
      interpolatedText = '' + value;
    } else if (angular.isString(value)) {
      // strings must be interpolated (that's the job here)
      interpolatedText = $interpolate(value)(interpolationParams);
      interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy, context);
    } else {
      // neither a number or a string, cant interpolate => empty string
      interpolatedText = '';
    }

    return interpolatedText;
  };

  return $translateInterpolator;
}

$translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';

angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translate
 * @requires $interpolate,
 * @requires $compile,
 * @requires $parse,
 * @requires $rootScope
 * @restrict AE
 *
 * @description
 * Translates given translation id either through attribute or DOM content.
 * Internally it uses $translate service to translate the translation id. It possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate Translation id which could be either string or interpolated string.
 * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
 * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
 * @param {string=} translate-default will be used unless translation was successful
 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
 * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
 * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <pre translate="TRANSLATION_ID"></pre>
        <pre translate>TRANSLATION_ID</pre>
        <pre translate translate-attr-title="TRANSLATION_ID"></pre>
        <pre translate="{{translationId}}"></pre>
        <pre translate>{{translationId}}</pre>
        <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
        <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
        <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
        <pre translate translate-values="{{values}}">WITH_VALUES</pre>
        <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
        <pre translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hi"></pre>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}',
          'WITH_CAMEL_CASE_KEY': 'The interpolation key is camel cased: {{camelCaseKey}}'
        }).preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
    <file name="scenario.js">
      it('should translate', function () {
        inject(function ($rootScope, $compile) {
          $rootScope.translationId = 'TRANSLATION_ID';

          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.attr('title')).toBe('Hello there!');

          element = $compile('<p translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hello"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('The interpolation key is camel cased: Hello');
        });
      });
    </file>
   </example>
 */
.directive('translate', translateDirective);
function translateDirective($translate, $interpolate, $compile, $parse, $rootScope) {

  'use strict';

  /**
   * @name trim
   * @private
   *
   * @description
   * trim polyfill
   *
   * @returns {string} The string stripped of whitespace from both ends
   */
  var trim = function() {
    return this.toString().replace(/^\s+|\s+$/g, '');
  };

  /**
   * @name lowercase
   * @private
   *
   * @description
   * Return the lowercase string only if the type is string
   *
   * @returns {string} The string all in lowercase
   */
  var lowercase = function (string) {
    return angular.isString(string) ? string.toLowerCase() : string;
  };

  return {
    restrict: 'AE',
    scope: true,
    priority: $translate.directivePriority(),
    compile: function (tElement, tAttr) {

      var translateValuesExist = (tAttr.translateValues) ?
        tAttr.translateValues : undefined;

      var translateInterpolation = (tAttr.translateInterpolation) ?
        tAttr.translateInterpolation : undefined;

      var translateSanitizeStrategyExist = (tAttr.translateSanitizeStrategy) ?
        tAttr.translateSanitizeStrategy : undefined;

      var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);

      var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
          watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';

      return function linkFn(scope, iElement, iAttr) {

        scope.interpolateParams = {};
        scope.preText = '';
        scope.postText = '';
        scope.translateNamespace = getTranslateNamespace(scope);
        var translationIds = {};

        var initInterpolationParams = function (interpolateParams, iAttr, tAttr) {
          // initial setup
          if (iAttr.translateValues) {
            angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
          }
          // initially fetch all attributes if existing and fill the params
          if (translateValueExist) {
            for (var attr in tAttr) {
              if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
                var attributeName = lowercase(attr.substr(14, 1)) + attr.substr(15);
                interpolateParams[attributeName] = tAttr[attr];
              }
            }
          }
        };

        // Ensures any change of the attribute "translate" containing the id will
        // be re-stored to the scope's "translationId".
        // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
        var observeElementTranslation = function (translationId) {

          // Remove any old watcher
          if (angular.isFunction(observeElementTranslation._unwatchOld)) {
            observeElementTranslation._unwatchOld();
            observeElementTranslation._unwatchOld = undefined;
          }

          if (angular.equals(translationId , '') || !angular.isDefined(translationId)) {
            var iElementText = trim.apply(iElement.text());

            // Resolve translation id by inner html if required
            var interpolateMatches = iElementText.match(interpolateRegExp);
            // Interpolate translation id if required
            if (angular.isArray(interpolateMatches)) {
              scope.preText = interpolateMatches[1];
              scope.postText = interpolateMatches[3];
              translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
              var watcherMatches = iElementText.match(watcherRegExp);
              if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
                observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
                  translationIds.translate = newValue;
                  updateTranslations();
                });
              }
            } else {
              // do not assigne the translation id if it is empty.
              translationIds.translate = !iElementText ? undefined : iElementText;
            }
          } else {
            translationIds.translate = translationId;
          }
          updateTranslations();
        };

        var observeAttributeTranslation = function (translateAttr) {
          iAttr.$observe(translateAttr, function (translationId) {
            translationIds[translateAttr] = translationId;
            updateTranslations();
          });
        };

        // initial setup with values
        initInterpolationParams(scope.interpolateParams, iAttr, tAttr);

        var firstAttributeChangedEvent = true;
        iAttr.$observe('translate', function (translationId) {
          if (typeof translationId === 'undefined') {
            // case of element "<translate>xyz</translate>"
            observeElementTranslation('');
          } else {
            // case of regular attribute
            if (translationId !== '' || !firstAttributeChangedEvent) {
              translationIds.translate = translationId;
              updateTranslations();
            }
          }
          firstAttributeChangedEvent = false;
        });

        for (var translateAttr in iAttr) {
          if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr' && translateAttr.length > 13) {
            observeAttributeTranslation(translateAttr);
          }
        }

        iAttr.$observe('translateDefault', function (value) {
          scope.defaultText = value;
          updateTranslations();
        });

        if (translateSanitizeStrategyExist) {
          iAttr.$observe('translateSanitizeStrategy', function (value) {
            scope.sanitizeStrategy = $parse(value)(scope.$parent);
            updateTranslations();
          });
        }

        if (translateValuesExist) {
          iAttr.$observe('translateValues', function (interpolateParams) {
            if (interpolateParams) {
              scope.$parent.$watch(function () {
                angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
              });
            }
          });
        }

        if (translateValueExist) {
          var observeValueAttribute = function (attrName) {
            iAttr.$observe(attrName, function (value) {
              var attributeName = lowercase(attrName.substr(14, 1)) + attrName.substr(15);
              scope.interpolateParams[attributeName] = value;
            });
          };
          for (var attr in iAttr) {
            if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
              observeValueAttribute(attr);
            }
          }
        }

        // Master update function
        var updateTranslations = function () {
          for (var key in translationIds) {
            if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
              updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
            }
          }
        };

        // Put translation processing function outside loop
        var updateTranslation = function(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
          if (translationId) {
            // if translation id starts with '.' and translateNamespace given, prepend namespace
            if (translateNamespace && translationId.charAt(0) === '.') {
              translationId = translateNamespace + translationId;
            }

            $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText, scope.translateLanguage, scope.sanitizeStrategy)
              .then(function (translation) {
                applyTranslation(translation, scope, true, translateAttr);
              }, function (translationId) {
                applyTranslation(translationId, scope, false, translateAttr);
              });
          } else {
            // as an empty string cannot be translated, we can solve this using successful=false
            applyTranslation(translationId, scope, false, translateAttr);
          }
        };

        var applyTranslation = function (value, scope, successful, translateAttr) {
          if (!successful) {
            if (typeof scope.defaultText !== 'undefined') {
              value = scope.defaultText;
            }
          }
          if (translateAttr === 'translate') {
            // default translate into innerHTML
            if (successful || (!successful && !$translate.isKeepContent() && typeof iAttr.translateKeepContent === 'undefined')) {
              iElement.empty().append(scope.preText + value + scope.postText);
            }
            var globallyEnabled = $translate.isPostCompilingEnabled();
            var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
            var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
            if ((globallyEnabled && !locallyDefined) || locallyEnabled) {
              $compile(iElement.contents())(scope);
            }
          } else {
            // translate attribute
            var attributeName = iAttr.$attr[translateAttr];
            if (attributeName.substr(0, 5) === 'data-') {
              // ensure html5 data prefix is stripped
              attributeName = attributeName.substr(5);
            }
            attributeName = attributeName.substr(15);
            iElement.attr(attributeName, value);
          }
        };

        if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
          scope.$watch('interpolateParams', updateTranslations, true);
        }

        // Replaced watcher on translateLanguage with event listener
        scope.$on('translateLanguageChanged', updateTranslations);

        // Ensures the text will be refreshed after the current language was changed
        // w/ $translate.use(...)
        var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);

        // ensure translation will be looked up at least one
        if (iElement.text().length) {
          if (iAttr.translate) {
            observeElementTranslation(iAttr.translate);
          } else {
            observeElementTranslation('');
          }
        } else if (iAttr.translate) {
          // ensure attribute will be not skipped
          observeElementTranslation(iAttr.translate);
        }
        updateTranslations();
        scope.$on('$destroy', unbind);
      };
    }
  };
}

/**
 * Returns the scope's namespace.
 * @private
 * @param scope
 * @returns {string}
 */
function getTranslateNamespace(scope) {
  'use strict';
  if (scope.translateNamespace) {
    return scope.translateNamespace;
  }
  if (scope.$parent) {
    return getTranslateNamespace(scope.$parent);
  }
}

translateDirective.displayName = 'translateDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translate-attr
 * @restrict A
 *
 * @description
 * Translates attributes like translate-attr-ATTR, but with an object like ng-class.
 * Internally it uses `translate` service to translate translation id. It possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate-attr Object literal mapping attributes to translation ids.
 * @param {string=} translate-values Values to pass into the translation ids. Can be passed as object literal string.
 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{value: 5}" />

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}',
        }).preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
    <file name="scenario.js">
      it('should translate', function () {
        inject(function ($rootScope, $compile) {
          $rootScope.translationId = 'TRANSLATION_ID';

          element = $compile('<input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{ value: 5 }" />')($rootScope);
          $rootScope.$digest();
          expect(element.attr('placeholder)).toBe('Hello there!');
          expect(element.attr('title)).toBe('The following value is dynamic: 5');
        });
      });
    </file>
   </example>
 */
.directive('translateAttr', translateAttrDirective);
function translateAttrDirective($translate, $rootScope) {

  'use strict';

  return {
    restrict: 'A',
    priority: $translate.directivePriority(),
    link: function linkFn(scope, element, attr) {

      var translateAttr,
          translateValues,
          translateSanitizeStrategy,
          previousAttributes = {};

      // Main update translations function
      var updateTranslations = function () {
        angular.forEach(translateAttr, function (translationId, attributeName) {
          if (!translationId) {
            return;
          }
          previousAttributes[attributeName] = true;

          // if translation id starts with '.' and translateNamespace given, prepend namespace
          if (scope.translateNamespace && translationId.charAt(0) === '.') {
            translationId = scope.translateNamespace + translationId;
          }
          $translate(translationId, translateValues, attr.translateInterpolation, undefined, scope.translateLanguage, translateSanitizeStrategy)
            .then(function (translation) {
              element.attr(attributeName, translation);
            }, function (translationId) {
              element.attr(attributeName, translationId);
            });
        });

        // Removing unused attributes that were previously used
        angular.forEach(previousAttributes, function (flag, attributeName) {
          if (!translateAttr[attributeName]) {
            element.removeAttr(attributeName);
            delete previousAttributes[attributeName];
          }
        });
      };

      // Watch for attribute changes
      watchAttribute(
        scope,
        attr.translateAttr,
        function (newValue) { translateAttr = newValue; },
        updateTranslations
      );
      // Watch for value changes
      watchAttribute(
        scope,
        attr.translateValues,
        function (newValue) { translateValues = newValue; },
        updateTranslations
      );
      // Watch for sanitize strategy changes
      watchAttribute(
        scope,
        attr.translateSanitizeStrategy,
        function (newValue) { translateSanitizeStrategy = newValue; },
        updateTranslations
      );

      if (attr.translateValues) {
        scope.$watch(attr.translateValues, updateTranslations, true);
      }

      // Replaced watcher on translateLanguage with event listener
      scope.$on('translateLanguageChanged', updateTranslations);

      // Ensures the text will be refreshed after the current language was changed
      // w/ $translate.use(...)
      var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);

      updateTranslations();
      scope.$on('$destroy', unbind);
    }
  };
}

function watchAttribute(scope, attribute, valueCallback, changeCallback) {
  'use strict';
  if (!attribute) {
    return;
  }
  if (attribute.substr(0, 2) === '::') {
    attribute = attribute.substr(2);
  } else {
    scope.$watch(attribute, function(newValue) {
      valueCallback(newValue);
      changeCallback();
    }, true);
  }
  valueCallback(scope.$eval(attribute));
}

translateAttrDirective.displayName = 'translateAttrDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateCloak
 * @requires $translate
 * @restrict A
 *
 * $description
 * Adds a `translate-cloak` class name to the given element where this directive
 * is applied initially and removes it, once a loader has finished loading.
 *
 * This directive can be used to prevent initial flickering when loading translation
 * data asynchronously.
 *
 * The class name is defined in
 * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
 *
 * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
 *                                  or hiding the cloak. Basically it relies on the translation
 *                                  resolve.
 */
.directive('translateCloak', translateCloakDirective);

function translateCloakDirective($translate, $rootScope) {

  'use strict';

  return {
    compile : function (tElement) {
      var applyCloak = function (element) {
          element.addClass($translate.cloakClassName());
        },
        removeCloak = function (element) {
          element.removeClass($translate.cloakClassName());
        };
      applyCloak(tElement);

      return function linkFn(scope, iElement, iAttr) {
        //Create bound functions that incorporate the active DOM element.
        var iRemoveCloak = removeCloak.bind(this, iElement), iApplyCloak = applyCloak.bind(this, iElement);
        if (iAttr.translateCloak && iAttr.translateCloak.length) {
          // Register a watcher for the defined translation allowing a fine tuned cloak
          iAttr.$observe('translateCloak', function (translationId) {
            $translate(translationId).then(iRemoveCloak, iApplyCloak);
          });
          $rootScope.$on('$translateChangeSuccess', function () {
            $translate(iAttr.translateCloak).then(iRemoveCloak, iApplyCloak);
          });
        } else {
          $translate.onReady(iRemoveCloak);
        }
      };
    }
  };
}

translateCloakDirective.displayName = 'translateCloakDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateNamespace
 * @restrict A
 *
 * @description
 * Translates given translation id either through attribute or DOM content.
 * Internally it uses `translate` filter to translate translation id. It is possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate namespace name which could be either string or interpolated string.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div translate-namespace="CONTENT">

        <div>
            <h1 translate>.HEADERS.TITLE</h1>
            <h1 translate>.HEADERS.WELCOME</h1>
        </div>

        <div translate-namespace=".HEADERS">
            <h1 translate>.TITLE</h1>
            <h1 translate>.WELCOME</h1>
        </div>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'CONTENT': {
            'HEADERS': {
                TITLE: 'Title'
            }
          },
          'CONTENT.HEADERS.WELCOME': 'Welcome'
        }).preferredLanguage('en');

      });

    </file>
   </example>
 */
.directive('translateNamespace', translateNamespaceDirective);

function translateNamespaceDirective() {

  'use strict';

  return {
    restrict: 'A',
    scope: true,
    compile: function () {
      return {
        pre: function (scope, iElement, iAttrs) {
          scope.translateNamespace = _getTranslateNamespace(scope);

          if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
            scope.translateNamespace += iAttrs.translateNamespace;
          } else {
            scope.translateNamespace = iAttrs.translateNamespace;
          }
        }
      };
    }
  };
}

/**
 * Returns the scope's namespace.
 * @private
 * @param scope
 * @returns {string}
 */
function _getTranslateNamespace(scope) {
  'use strict';
  if (scope.translateNamespace) {
    return scope.translateNamespace;
  }
  if (scope.$parent) {
    return _getTranslateNamespace(scope.$parent);
  }
}

translateNamespaceDirective.displayName = 'translateNamespaceDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateLanguage
 * @restrict A
 *
 * @description
 * Forces the language to the directives in the underlying scope.
 *
 * @param {string=} translate language that will be negotiated.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div>

        <div>
            <h1 translate>HELLO</h1>
        </div>

        <div translate-language="de">
            <h1 translate>HELLO</h1>
        </div>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider
          .translations('en',{
            'HELLO': 'Hello world!'
          })
          .translations('de',{
            'HELLO': 'Hallo Welt!'
          })
          .preferredLanguage('en');

      });

    </file>
   </example>
 */
.directive('translateLanguage', translateLanguageDirective);

function translateLanguageDirective() {

  'use strict';

  return {
    restrict: 'A',
    scope: true,
    compile: function () {
      return function linkFn(scope, iElement, iAttrs) {

        iAttrs.$observe('translateLanguage', function (newTranslateLanguage) {
          scope.translateLanguage = newTranslateLanguage;
        });

        scope.$watch('translateLanguage', function(){
          scope.$broadcast('translateLanguageChanged');
        });
      };
    }
  };
}

translateLanguageDirective.displayName = 'translateLanguageDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc filter
 * @name pascalprecht.translate.filter:translate
 * @requires $parse
 * @requires pascalprecht.translate.$translate
 * @function
 *
 * @description
 * Uses `$translate` service to translate contents. Accepts interpolate parameters
 * to pass dynamized values though translation.
 *
 * @param {string} translationId A translation id to be translated.
 * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
 *
 * @returns {string} Translated text.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
        <pre>{{ translationId | translate }}</pre>
        <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
        <pre>{{ 'WITH_VALUES' | translate:values }}</pre>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en', {
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}'
        });
        $translateProvider.preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
   </example>
 */
.filter('translate', translateFilterFactory);

function translateFilterFactory($parse, $translate) {

  'use strict';

  var translateFilter = function (translationId, interpolateParams, interpolation, forceLanguage) {
    if (!angular.isObject(interpolateParams)) {
      var ctx = this || {
        '__SCOPE_IS_NOT_AVAILABLE': 'More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f'
        };
      interpolateParams = $parse(interpolateParams)(ctx);
    }

    return $translate.instant(translationId, interpolateParams, interpolation, forceLanguage);
  };

  if ($translate.statefulFilter()) {
    translateFilter.$stateful = true;
  }

  return translateFilter;
}

translateFilterFactory.displayName = 'translateFilterFactory';

angular.module('pascalprecht.translate')

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translationCache
 * @requires $cacheFactory
 *
 * @description
 * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
 * can load translation tables directly into the cache by consuming the
 * `$translationCache` service directly.
 *
 * @return {object} $cacheFactory object.
 */
  .factory('$translationCache', $translationCache);

function $translationCache($cacheFactory) {

  'use strict';

  return $cacheFactory('translations');
}

$translationCache.displayName = '$translationCache';
return 'pascalprecht.translate';

}));

},{}],10:[function(require,module,exports){
'use strict'

exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}

},{}],11:[function(require,module,exports){
(function (Buffer){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = require('base64-js')
var ieee754 = require('ieee754')

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function () { return 42 } }
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  buf.__proto__ = Buffer.prototype
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

// Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
if (typeof Symbol !== 'undefined' && Symbol.species != null &&
    Buffer[Symbol.species] === Buffer) {
  Object.defineProperty(Buffer, Symbol.species, {
    value: null,
    configurable: true,
    enumerable: false,
    writable: false
  })
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayLike(value)
  }

  if (value == null) {
    throw TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Buffer.prototype.__proto__ = Uint8Array.prototype
Buffer.__proto__ = Uint8Array

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  buf.__proto__ = Buffer.prototype
  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      buf = Buffer.from(buf)
    }
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
        : (firstByte > 0xBF) ? 2
          : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  newBuf.__proto__ = Buffer.prototype
  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (var i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

}).call(this,require("buffer").Buffer)
},{"base64-js":10,"buffer":11,"ieee754":27}],12:[function(require,module,exports){
(function (Buffer){
var clone = (function() {
'use strict';

function _instanceof(obj, type) {
  return type != null && obj instanceof type;
}

var nativeMap;
try {
  nativeMap = Map;
} catch(_) {
  // maybe a reference error because no `Map`. Give it a dummy value that no
  // value will ever be an instanceof.
  nativeMap = function() {};
}

var nativeSet;
try {
  nativeSet = Set;
} catch(_) {
  nativeSet = function() {};
}

var nativePromise;
try {
  nativePromise = Promise;
} catch(_) {
  nativePromise = function() {};
}

/**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/
function clone(parent, circular, depth, prototype, includeNonEnumerable) {
  if (typeof circular === 'object') {
    depth = circular.depth;
    prototype = circular.prototype;
    includeNonEnumerable = circular.includeNonEnumerable;
    circular = circular.circular;
  }
  // maintain two arrays for circular references, where corresponding parents
  // and children have the same index
  var allParents = [];
  var allChildren = [];

  var useBuffer = typeof Buffer != 'undefined';

  if (typeof circular == 'undefined')
    circular = true;

  if (typeof depth == 'undefined')
    depth = Infinity;

  // recurse this function so we don't reset allParents and allChildren
  function _clone(parent, depth) {
    // cloning null always returns null
    if (parent === null)
      return null;

    if (depth === 0)
      return parent;

    var child;
    var proto;
    if (typeof parent != 'object') {
      return parent;
    }

    if (_instanceof(parent, nativeMap)) {
      child = new nativeMap();
    } else if (_instanceof(parent, nativeSet)) {
      child = new nativeSet();
    } else if (_instanceof(parent, nativePromise)) {
      child = new nativePromise(function (resolve, reject) {
        parent.then(function(value) {
          resolve(_clone(value, depth - 1));
        }, function(err) {
          reject(_clone(err, depth - 1));
        });
      });
    } else if (clone.__isArray(parent)) {
      child = [];
    } else if (clone.__isRegExp(parent)) {
      child = new RegExp(parent.source, __getRegExpFlags(parent));
      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
    } else if (clone.__isDate(parent)) {
      child = new Date(parent.getTime());
    } else if (useBuffer && Buffer.isBuffer(parent)) {
      if (Buffer.allocUnsafe) {
        // Node.js >= 4.5.0
        child = Buffer.allocUnsafe(parent.length);
      } else {
        // Older Node.js versions
        child = new Buffer(parent.length);
      }
      parent.copy(child);
      return child;
    } else if (_instanceof(parent, Error)) {
      child = Object.create(parent);
    } else {
      if (typeof prototype == 'undefined') {
        proto = Object.getPrototypeOf(parent);
        child = Object.create(proto);
      }
      else {
        child = Object.create(prototype);
        proto = prototype;
      }
    }

    if (circular) {
      var index = allParents.indexOf(parent);

      if (index != -1) {
        return allChildren[index];
      }
      allParents.push(parent);
      allChildren.push(child);
    }

    if (_instanceof(parent, nativeMap)) {
      parent.forEach(function(value, key) {
        var keyChild = _clone(key, depth - 1);
        var valueChild = _clone(value, depth - 1);
        child.set(keyChild, valueChild);
      });
    }
    if (_instanceof(parent, nativeSet)) {
      parent.forEach(function(value) {
        var entryChild = _clone(value, depth - 1);
        child.add(entryChild);
      });
    }

    for (var i in parent) {
      var attrs;
      if (proto) {
        attrs = Object.getOwnPropertyDescriptor(proto, i);
      }

      if (attrs && attrs.set == null) {
        continue;
      }
      child[i] = _clone(parent[i], depth - 1);
    }

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(parent);
      for (var i = 0; i < symbols.length; i++) {
        // Don't need to worry about cloning a symbol because it is a primitive,
        // like a number or string.
        var symbol = symbols[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
          continue;
        }
        child[symbol] = _clone(parent[symbol], depth - 1);
        if (!descriptor.enumerable) {
          Object.defineProperty(child, symbol, {
            enumerable: false
          });
        }
      }
    }

    if (includeNonEnumerable) {
      var allPropertyNames = Object.getOwnPropertyNames(parent);
      for (var i = 0; i < allPropertyNames.length; i++) {
        var propertyName = allPropertyNames[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
        if (descriptor && descriptor.enumerable) {
          continue;
        }
        child[propertyName] = _clone(parent[propertyName], depth - 1);
        Object.defineProperty(child, propertyName, {
          enumerable: false
        });
      }
    }

    return child;
  }

  return _clone(parent, depth);
}

/**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */
clone.clonePrototype = function clonePrototype(parent) {
  if (parent === null)
    return null;

  var c = function () {};
  c.prototype = parent;
  return new c();
};

// private utility functions

function __objToStr(o) {
  return Object.prototype.toString.call(o);
}
clone.__objToStr = __objToStr;

function __isDate(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Date]';
}
clone.__isDate = __isDate;

function __isArray(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Array]';
}
clone.__isArray = __isArray;

function __isRegExp(o) {
  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
}
clone.__isRegExp = __isRegExp;

function __getRegExpFlags(re) {
  var flags = '';
  if (re.global) flags += 'g';
  if (re.ignoreCase) flags += 'i';
  if (re.multiline) flags += 'm';
  return flags;
}
clone.__getRegExpFlags = __getRegExpFlags;

return clone;
})();

if (typeof module === 'object' && module.exports) {
  module.exports = clone;
}

}).call(this,require("buffer").Buffer)
},{"buffer":11}],13:[function(require,module,exports){
/**
 * @overview NPM Module index: include all the core modules, I18n files will be loaded on the fly.
 * @author Gregory Wild-Smith <gregory@wild-smith.com>
 */
require("./src/core/i18n.js");
require("./src/core/core.js");
require("./src/core/core-prototypes.js");
require("./src/core/sugarpak.js");
require("./src/core/format_parser.js");
require("./src/core/parsing_operators.js");
require("./src/core/parsing_translator.js");
require("./src/core/parsing_grammar.js");
require("./src/core/parser.js");
require("./src/core/extras.js");
require("./src/core/time_period.js");
require("./src/core/time_span.js");
/*
 * Notice that there is no model.export or exports. This is not required as it modifies the Date object and it's prototypes.
 */
},{"./src/core/core-prototypes.js":14,"./src/core/core.js":15,"./src/core/extras.js":16,"./src/core/format_parser.js":17,"./src/core/i18n.js":18,"./src/core/parser.js":19,"./src/core/parsing_grammar.js":20,"./src/core/parsing_operators.js":21,"./src/core/parsing_translator.js":22,"./src/core/sugarpak.js":23,"./src/core/time_period.js":24,"./src/core/time_span.js":25}],14:[function(require,module,exports){
(function () {
	var $D = Date,
		$P = $D.prototype,
		p = function (s, l) {
			if (!l) {
				l = 2;
			}
			return ("000" + s).slice(l * -1);
		};

	var validateConfigObject = function (obj) {
		var result = {}, self = this, prop, testFunc;
		testFunc = function (prop, func, value) {
			if (prop === "day") {
				var month = (obj.month !== undefined) ? obj.month : self.getMonth();
				var year = (obj.year !== undefined) ? obj.year : self.getFullYear();
				return $D[func](value, year, month);
			} else {
				return $D[func](value);
			}
		};
		for (prop in obj) {
			if (hasOwnProperty.call(obj, prop)) {
				var func = "validate" + prop.charAt(0).toUpperCase() + prop.slice(1);

				if ($D[func] && obj[prop] !== null && testFunc(prop, func, obj[prop])) {
					result[prop] = obj[prop];
				}
			}
		}
		return result;
	};
	/**
	 * Resets the time of this Date object to 12:00 AM (00:00), which is the start of the day.
	 * @param {Boolean}  .clone() this date instance before clearing Time
	 * @return {Date}    this
	 */
	$P.clearTime = function () {
		this.setHours(0);
		this.setMinutes(0);
		this.setSeconds(0);
		this.setMilliseconds(0);
		return this;
	};

	/**
	 * Resets the time of this Date object to the current time ('now').
	 * @return {Date}    this
	 */
	$P.setTimeToNow = function () {
		var n = new Date();
		this.setHours(n.getHours());
		this.setMinutes(n.getMinutes());
		this.setSeconds(n.getSeconds());
		this.setMilliseconds(n.getMilliseconds());
		return this;
	};
	/**
	 * Returns a new Date object that is an exact date and time copy of the original instance.
	 * @return {Date}    A new Date instance
	 */
	$P.clone = function () {
		return new Date(this.getTime());
	};

	/**
	 * Compares this instance to a Date object and returns an number indication of their relative values.  
	 * @param {Date}     Date object to compare [Required]
	 * @return {Number}  -1 = this is lessthan date. 0 = values are equal. 1 = this is greaterthan date.
	 */
	$P.compareTo = function (date) {
		return Date.compare(this, date);
	};

	/**
	 * Compares this instance to another Date object and returns true if they are equal.  
	 * @param {Date}     Date object to compare. If no date to compare, new Date() [now] is used.
	 * @return {Boolean} true if dates are equal. false if they are not equal.
	 */
	$P.equals = function (date) {
		return Date.equals(this, (date !== undefined ? date : new Date()));
	};

	/**
	 * Determines if this instance is between a range of two dates or equal to either the start or end dates.
	 * @param {Date}     Start of range [Required]
	 * @param {Date}     End of range [Required]
	 * @return {Boolean} true is this is between or equal to the start and end dates, else false
	 */
	$P.between = function (start, end) {
		return this.getTime() >= start.getTime() && this.getTime() <= end.getTime();
	};

	/**
	 * Determines if this date occurs after the date to compare to.
	 * @param {Date}     Date object to compare. If no date to compare, new Date() ("now") is used.
	 * @return {Boolean} true if this date instance is greater than the date to compare to (or "now"), otherwise false.
	 */
	$P.isAfter = function (date) {
		return this.compareTo(date || new Date()) === 1;
	};

	/**
	 * Determines if this date occurs before the date to compare to.
	 * @param {Date}     Date object to compare. If no date to compare, new Date() ("now") is used.
	 * @return {Boolean} true if this date instance is less than the date to compare to (or "now").
	 */
	$P.isBefore = function (date) {
		return (this.compareTo(date || new Date()) === -1);
	};

	/**
	 * Determines if the current Date instance occurs today.
	 * @return {Boolean} true if this date instance is 'today', otherwise false.
	 */
	
	/**
	 * Determines if the current Date instance occurs on the same Date as the supplied 'date'. 
	 * If no 'date' to compare to is provided, the current Date instance is compared to 'today'. 
	 * @param {date}     Date object to compare. If no date to compare, the current Date ("now") is used.
	 * @return {Boolean} true if this Date instance occurs on the same Day as the supplied 'date'.
	 */
	$P.isToday = $P.isSameDay = function (date) {
		return this.clone().clearTime().equals((date || new Date()).clone().clearTime());
	};
	
	/**
	 * Adds the specified number of milliseconds to this instance. 
	 * @param {Number}   The number of milliseconds to add. The number can be positive or negative [Required]
	 * @return {Date}    this
	 */
	$P.addMilliseconds = function (value) {
		if (!value) { return this; }
		this.setTime(this.getTime() + value * 1);
		return this;
	};

	/**
	 * Adds the specified number of seconds to this instance. 
	 * @param {Number}   The number of seconds to add. The number can be positive or negative [Required]
	 * @return {Date}    this
	 */
	$P.addSeconds = function (value) {
		if (!value) { return this; }
		return this.addMilliseconds(value * 1000);
	};

	/**
	 * Adds the specified number of seconds to this instance. 
	 * @param {Number}   The number of seconds to add. The number can be positive or negative [Required]
	 * @return {Date}    this
	 */
	$P.addMinutes = function (value) {
		if (!value) { return this; }
		return this.addMilliseconds(value * 60000); // 60*1000
	};

	/**
	 * Adds the specified number of hours to this instance. 
	 * @param {Number}   The number of hours to add. The number can be positive or negative [Required]
	 * @return {Date}    this
	 */
	$P.addHours = function (value) {
		if (!value) { return this; }
		return this.addMilliseconds(value * 3600000); // 60*60*1000
	};

	/**
	 * Adds the specified number of days to this instance. 
	 * @param {Number}   The number of days to add. The number can be positive or negative [Required]
	 * @return {Date}    this
	 */
	$P.addDays = function (value) {
		if (!value) { return this; }
		this.setDate(this.getDate() + value * 1);
		return this;
	};

	/**
	 * Adds the specified number of weekdays (ie - not sat or sun) to this instance. 
	 * @param {Number}   The number of days to add. The number can be positive or negative [Required]
	 * @return {Date}    this
	 */
	$P.addWeekdays = function (value) {
		if (!value) { return this; }
		var day = this.getDay();
		var weeks = (Math.ceil(Math.abs(value)/7));
		if (day === 0 || day === 6) {
			if (value > 0) {
				this.next().monday();
				this.addDays(-1);
				day = this.getDay();
			}
		}

		if (value < 0) {
			while (value < 0) {
				this.addDays(-1);
				day = this.getDay();
				if (day !== 0 && day !== 6) {
					value++;
				}
			}
			return this;
		} else if (value > 5 || (6-day) <= value) {
			value = value + (weeks * 2);
		}

		return this.addDays(value);
	};

	/**
	 * Adds the specified number of weeks to this instance. 
	 * @param {Number}   The number of weeks to add. The number can be positive or negative [Required]
	 * @return {Date}    this
	 */
	$P.addWeeks = function (value) {
		if (!value) { return this; }
		return this.addDays(value * 7);
	};


	/**
	 * Adds the specified number of months to this instance. 
	 * @param {Number}   The number of months to add. The number can be positive or negative [Required]
	 * @return {Date}    this
	 */
	$P.addMonths = function (value) {
		if (!value) { return this; }
		var n = this.getDate();
		this.setDate(1);
		this.setMonth(this.getMonth() + value * 1);
		this.setDate(Math.min(n, $D.getDaysInMonth(this.getFullYear(), this.getMonth())));
		return this;
	};

	$P.addQuarters = function (value) {
		if (!value) { return this; }
		// note this will take you to the same point in the quarter as you are now.
		// i.e. - if you are 15 days into the quarter you'll be 15 days into the resulting one.
		// bonus: this allows adding fractional quarters
		return this.addMonths(value * 3);
	};

	/**
	 * Adds the specified number of years to this instance. 
	 * @param {Number}   The number of years to add. The number can be positive or negative [Required]
	 * @return {Date}    this
	 */
	$P.addYears = function (value) {
		if (!value) { return this; }
		return this.addMonths(value * 12);
	};

	/**
	 * Adds (or subtracts) to the value of the years, months, weeks, days, hours, minutes, seconds, milliseconds of the date instance using given configuration object. Positive and Negative values allowed.
	 * Example
	<pre><code>
	Date.today().add( { days: 1, months: 1 } )
	 
	new Date().add( { years: -1 } )
	</code></pre> 
	 * @param {Object}   Configuration object containing attributes (months, days, etc.)
	 * @return {Date}    this
	 */
	$P.add = function (config) {
		if (typeof config === "number") {
			this._orient = config;
			return this;
		}
		
		var x = config;

		if (x.day) {
			// If we should be a different date than today (eg: for 'tomorrow -1d', etc).
			// Should only effect parsing, not direct usage (eg, Finish and FinishExact)
			if ((x.day - this.getDate()) !== 0) {
				this.setDate(x.day);
			}
		}
		if (x.milliseconds) {
			this.addMilliseconds(x.milliseconds);
		}
		if (x.seconds) {
			this.addSeconds(x.seconds);
		}
		if (x.minutes) {
			this.addMinutes(x.minutes);
		}
		if (x.hours) {
			this.addHours(x.hours);
		}
		if (x.weeks) {
			this.addWeeks(x.weeks);
		}
		if (x.months) {
			this.addMonths(x.months);
		}
		if (x.years) {
			this.addYears(x.years);
		}
		if (x.days) {
			this.addDays(x.days);
		}
		return this;
	};
	
	/**
	 * Get the week number. Week one (1) is the week which contains the first Thursday of the year. Monday is considered the first day of the week.
	 * The .getWeek() function does NOT convert the date to UTC. The local datetime is used. 
	 * Please use .getISOWeek() to get the week of the UTC converted date.
	 * @return {Number}  1 to 53
	 */
	$P.getWeek = function (utc) {
		// Create a copy of this date object  
		var self, target = new Date(this.valueOf());
		if (utc) {
			target.addMinutes(target.getTimezoneOffset());
			self = target.clone();
		} else {
			self = this;
		}
		// ISO week date weeks start on monday  
		// so correct the day number  
		var dayNr = (self.getDay() + 6) % 7;
		// ISO 8601 states that week 1 is the week  
		// with the first thursday of that year.  
		// Set the target date to the thursday in the target week  
		target.setDate(target.getDate() - dayNr + 3);
		// Store the millisecond value of the target date  
		var firstThursday = target.valueOf();
		// Set the target to the first thursday of the year  
		// First set the target to january first  
		target.setMonth(0, 1);
		// Not a thursday? Correct the date to the next thursday  
		if (target.getDay() !== 4) {
			target.setMonth(0, 1 + ((4 - target.getDay()) + 7) % 7);
		}
		// The weeknumber is the number of weeks between the   
		// first thursday of the year and the thursday in the target week  
		return 1 + Math.ceil((firstThursday - target) / 604800000); // 604800000 = 7 * 24 * 3600 * 1000  
	};
	
	/**
	 * Get the ISO 8601 week number. Week one ("01") is the week which contains the first Thursday of the year. Monday is considered the first day of the week.
	 * The .getISOWeek() function does convert the date to it's UTC value. Please use .getWeek() to get the week of the local date.
	 * @return {String}  "01" to "53"
	 */
	$P.getISOWeek = function () {
		return p(this.getWeek(true));
	};

	/**
	 * Moves the date to Monday of the week set. Week one (1) is the week which contains the first Thursday of the year.
	 * @param {Number}   A Number (1 to 53) that represents the week of the year.
	 * @return {Date}    this
	 */
	$P.setWeek = function (n) {
		if ((n - this.getWeek()) === 0) {
			if (this.getDay() !== 1) {
				return this.moveToDayOfWeek(1, (this.getDay() > 1 ? -1 : 1));
			} else {
				return this;
			}
		} else {
			return this.moveToDayOfWeek(1, (this.getDay() > 1 ? -1 : 1)).addWeeks(n - this.getWeek());
		}
	};

	$P.setQuarter = function (qtr) {
		var month = Math.abs(((qtr-1) * 3) + 1);
		return this.setMonth(month, 1);
	};

	$P.getQuarter = function () {
		return Date.getQuarter(this);
	};

	$P.getDaysLeftInQuarter = function () {
		return Date.getDaysLeftInQuarter(this);
	};

	/**
	 * Moves the date to the next n'th occurrence of the dayOfWeek starting from the beginning of the month. The number (-1) is a magic number and will return the last occurrence of the dayOfWeek in the month.
	 * @param {Number}   The dayOfWeek to move to
	 * @param {Number}   The n'th occurrence to move to. Use (-1) to return the last occurrence in the month
	 * @return {Date}    this
	 */
	$P.moveToNthOccurrence = function (dayOfWeek, occurrence) {
		if (dayOfWeek === "Weekday") {
			if (occurrence > 0) {
				this.moveToFirstDayOfMonth();
				if (this.is().weekday()) {
					occurrence -= 1;
				}
			} else if (occurrence < 0) {
				this.moveToLastDayOfMonth();
				if (this.is().weekday()) {
					occurrence += 1;
				}
			} else {
				return this;
			}
			return this.addWeekdays(occurrence);
		}
		var shift = 0;
		if (occurrence > 0) {
			shift = occurrence - 1;
		}
		else if (occurrence === -1) {
			this.moveToLastDayOfMonth();
			if (this.getDay() !== dayOfWeek) {
				this.moveToDayOfWeek(dayOfWeek, -1);
			}
			return this;
		}
		return this.moveToFirstDayOfMonth().addDays(-1).moveToDayOfWeek(dayOfWeek, +1).addWeeks(shift);
	};


	var moveToN = function (getFunc, addFunc, nVal) {
		return function (value, orient) {
			var diff = (value - this[getFunc]() + nVal * (orient || +1)) % nVal;
			return this[addFunc]((diff === 0) ? diff += nVal * (orient || +1) : diff);
		};
	};
	/**
	 * Move to the next or last dayOfWeek based on the orient value.
	 * @param {Number}   The dayOfWeek to move to
	 * @param {Number}   Forward (+1) or Back (-1). Defaults to +1. [Optional]
	 * @return {Date}    this
	 */
	$P.moveToDayOfWeek = moveToN("getDay", "addDays", 7);
	/**
	 * Move to the next or last month based on the orient value.
	 * @param {Number}   The month to move to. 0 = January, 11 = December
	 * @param {Number}   Forward (+1) or Back (-1). Defaults to +1. [Optional]
	 * @return {Date}    this
	 */
	$P.moveToMonth = moveToN("getMonth", "addMonths", 12);
	/**
	 * Get the Ordinate of the current day ("th", "st", "rd").
	 * @return {String} 
	 */
	$P.getOrdinate = function () {
		var num = this.getDate();
		return ord(num);
	};
	/**
	 * Get the Ordinal day (numeric day number) of the year, adjusted for leap year.
	 * @return {Number} 1 through 365 (366 in leap years)
	 */
	$P.getOrdinalNumber = function () {
		return Math.ceil((this.clone().clearTime() - new Date(this.getFullYear(), 0, 1)) / 86400000) + 1;
	};

	/**
	 * Get the time zone abbreviation of the current date.
	 * @return {String} The abbreviated time zone name (e.g. "EST")
	 */
	$P.getTimezone = function () {
		return $D.getTimezoneAbbreviation(this.getUTCOffset(), this.isDaylightSavingTime());
	};

	$P.setTimezoneOffset = function (offset) {
		var here = this.getTimezoneOffset(), there = Number(offset) * -6 / 10;
		return (there || there === 0) ? this.addMinutes(there - here) : this;
	};

	$P.setTimezone = function (offset) {
		return this.setTimezoneOffset($D.getTimezoneOffset(offset));
	};

	/**
	 * Indicates whether Daylight Saving Time is observed in the current time zone.
	 * @return {Boolean} true|false
	 */
	$P.hasDaylightSavingTime = function () {
		return (Date.today().set({month: 0, day: 1}).getTimezoneOffset() !== Date.today().set({month: 6, day: 1}).getTimezoneOffset());
	};
	
	/**
	 * Indicates whether this Date instance is within the Daylight Saving Time range for the current time zone.
	 * @return {Boolean} true|false
	 */
	$P.isDaylightSavingTime = function () {
		return Date.today().set({month: 0, day: 1}).getTimezoneOffset() !== this.getTimezoneOffset();
	};

	/**
	 * Get the offset from UTC of the current date.
	 * @return {String} The 4-character offset string prefixed with + or - (e.g. "-0500")
	 */
	$P.getUTCOffset = function (offset) {
		var n = (offset || this.getTimezoneOffset()) * -10 / 6, r;
		if (n < 0) {
			r = (n - 10000).toString();
			return r.charAt(0) + r.substr(2);
		} else {
			r = (n + 10000).toString();
			return "+" + r.substr(1);
		}
	};

	/**
	 * Returns the number of milliseconds between this date and date.
	 * @param {Date} Defaults to now
	 * @return {Number} The diff in milliseconds
	 */
	$P.getElapsed = function (date) {
		return (date || new Date()) - this;
	};

	/**
	 * Set the value of year, month, day, hour, minute, second, millisecond of date instance using given configuration object.
	 * Example
	<pre><code>
	Date.today().set( { day: 20, month: 1 } )

	new Date().set( { millisecond: 0 } )
	</code></pre>
	 * 
	 * @param {Object}   Configuration object containing attributes (month, day, etc.)
	 * @return {Date}    this
	 */
	$P.set = function (config) {
		config = validateConfigObject.call(this, config);
		var key;
		for (key in config) {
			if (hasOwnProperty.call(config, key)) {
				var name = key.charAt(0).toUpperCase() + key.slice(1);
				var addFunc, getFunc;
				if (key !== "week" && key !== "month" && key !== "timezone" && key !== "timezoneOffset") {
					name += "s";
				}
				addFunc = "add" + name;
				getFunc = "get" + name;
				if (key === "month") {
					addFunc = addFunc + "s";
				} else if (key === "year"){
					getFunc = "getFullYear";
				}
				if (key !== "day" && key !== "timezone" && key !== "timezoneOffset"  && key !== "week" &&  key !== "hour") {
						this[addFunc](config[key] - this[getFunc]());
				} else if ( key === "timezone"|| key === "timezoneOffset" || key === "week" || key === "hour") {
					this["set"+name](config[key]);
				}
			}
		}
		// day has to go last because you can't validate the day without first knowing the month
		if (config.day) {
			this.addDays(config.day - this.getDate());
		}
		
		return this;
	};

	/**
	 * Moves the date to the first day of the month.
	 * @return {Date}    this
	 */
	$P.moveToFirstDayOfMonth = function () {
		return this.set({ day: 1 });
	};

	/**
	 * Moves the date to the last day of the month.
	 * @return {Date}    this
	 */
	$P.moveToLastDayOfMonth = function () {
		return this.set({ day: $D.getDaysInMonth(this.getFullYear(), this.getMonth())});
	};


	/**
	 * Converts the value of the current Date object to its equivalent string representation.
	 * Format Specifiers
	 * CUSTOM DATE AND TIME FORMAT STRINGS
	 * Format  Description                                                                  Example
	 * ------  ---------------------------------------------------------------------------  -----------------------
	 * s      The seconds of the minute between 0-59.                                      "0" to "59"
	 * ss     The seconds of the minute with leading zero if required.                     "00" to "59"
	 * 
	 * m      The minute of the hour between 0-59.                                         "0"  or "59"
	 * mm     The minute of the hour with leading zero if required.                        "00" or "59"
	 * 
	 * h      The hour of the day between 1-12.                                            "1"  to "12"
	 * hh     The hour of the day with leading zero if required.                           "01" to "12"
	 * 
	 * H      The hour of the day between 0-23.                                            "0"  to "23"
	 * HH     The hour of the day with leading zero if required.                           "00" to "23"
	 * 
	 * d      The day of the month between 1 and 31.                                       "1"  to "31"
	 * dd     The day of the month with leading zero if required.                          "01" to "31"
	 * ddd    Abbreviated day name. Date.CultureInfo.abbreviatedDayNames.                                "Mon" to "Sun" 
	 * dddd   The full day name. Date.CultureInfo.dayNames.                                              "Monday" to "Sunday"
	 * 
	 * M      The month of the year between 1-12.                                          "1" to "12"
	 * MM     The month of the year with leading zero if required.                         "01" to "12"
	 * MMM    Abbreviated month name. Date.CultureInfo.abbreviatedMonthNames.                            "Jan" to "Dec"
	 * MMMM   The full month name. Date.CultureInfo.monthNames.                                          "January" to "December"
	 *
	 * yy     The year as a two-digit number.                                              "99" or "08"
	 * yyyy   The full four digit year.                                                    "1999" or "2008"
	 * 
	 * t      Displays the first character of the A.M./P.M. designator.                    "A" or "P"
	 *		Date.CultureInfo.amDesignator or Date.CultureInfo.pmDesignator
	 * tt     Displays the A.M./P.M. designator.                                           "AM" or "PM"
	 *		Date.CultureInfo.amDesignator or Date.CultureInfo.pmDesignator
	 * 
	 * S      The ordinal suffix ("st, "nd", "rd" or "th") of the current day.            "st, "nd", "rd" or "th"
	 *
	 * STANDARD DATE AND TIME FORMAT STRINGS
	 * Format  Description                                                                  Example
	 *------  ---------------------------------------------------------------------------  -----------------------
	 * d      The CultureInfo shortDate Format Pattern                                     "M/d/yyyy"
	 * D      The CultureInfo longDate Format Pattern                                      "dddd, MMMM dd, yyyy"
	 * F      The CultureInfo fullDateTime Format Pattern                                  "dddd, MMMM dd, yyyy h:mm:ss tt"
	 * m      The CultureInfo monthDay Format Pattern                                      "MMMM dd"
	 * r      The CultureInfo rfc1123 Format Pattern                                       "ddd, dd MMM yyyy HH:mm:ss GMT"
	 * s      The CultureInfo sortableDateTime Format Pattern                              "yyyy-MM-ddTHH:mm:ss"
	 * t      The CultureInfo shortTime Format Pattern                                     "h:mm tt"
	 * T      The CultureInfo longTime Format Pattern                                      "h:mm:ss tt"
	 * u      The CultureInfo universalSortableDateTime Format Pattern                     "yyyy-MM-dd HH:mm:ssZ"
	 * y      The CultureInfo yearMonth Format Pattern                                     "MMMM, yyyy"
	 *
	 * @param {String}   A format string consisting of one or more format spcifiers [Optional].
	 * @return {String}  A string representation of the current Date object.
	 */
	
	var ord = function (n) {
		switch (n * 1) {
		case 1:
		case 21:
		case 31:
			return "st";
		case 2:
		case 22:
			return "nd";
		case 3:
		case 23:
			return "rd";
		default:
			return "th";
		}
	};
	var parseStandardFormats = function (format) {
		var y, c = Date.CultureInfo.formatPatterns;
		switch (format) {
			case "d":
				return this.toString(c.shortDate);
			case "D":
				return this.toString(c.longDate);
			case "F":
				return this.toString(c.fullDateTime);
			case "m":
				return this.toString(c.monthDay);
			case "r":
			case "R":
				y = this.clone().addMinutes(this.getTimezoneOffset());
				return y.toString(c.rfc1123) + " GMT";
			case "s":
				return this.toString(c.sortableDateTime);
			case "t":
				return this.toString(c.shortTime);
			case "T":
				return this.toString(c.longTime);
			case "u":
				y = this.clone().addMinutes(this.getTimezoneOffset());
				return y.toString(c.universalSortableDateTime);
			case "y":
				return this.toString(c.yearMonth);
			default:
				return false;
		}
	};
	var parseFormatStringsClosure = function (context) {
		return function (m) {
			if (m.charAt(0) === "\\") {
				return m.replace("\\", "");
			}
			switch (m) {
				case "hh":
					return p(context.getHours() < 13 ? (context.getHours() === 0 ? 12 : context.getHours()) : (context.getHours() - 12));
				case "h":
					return context.getHours() < 13 ? (context.getHours() === 0 ? 12 : context.getHours()) : (context.getHours() - 12);
				case "HH":
					return p(context.getHours());
				case "H":
					return context.getHours();
				case "mm":
					return p(context.getMinutes());
				case "m":
					return context.getMinutes();
				case "ss":
					return p(context.getSeconds());
				case "s":
					return context.getSeconds();
				case "yyyy":
					return p(context.getFullYear(), 4);
				case "yy":
					return p(context.getFullYear());
				case "y":
					return context.getFullYear();
				case "E":
				case "dddd":
					return Date.CultureInfo.dayNames[context.getDay()];
				case "ddd":
					return Date.CultureInfo.abbreviatedDayNames[context.getDay()];
				case "dd":
					return p(context.getDate());
				case "d":
					return context.getDate();
				case "MMMM":
					return Date.CultureInfo.monthNames[context.getMonth()];
				case "MMM":
					return Date.CultureInfo.abbreviatedMonthNames[context.getMonth()];
				case "MM":
					return p((context.getMonth() + 1));
				case "M":
					return context.getMonth() + 1;
				case "t":
					return context.getHours() < 12 ? Date.CultureInfo.amDesignator.substring(0, 1) : Date.CultureInfo.pmDesignator.substring(0, 1);
				case "tt":
					return context.getHours() < 12 ? Date.CultureInfo.amDesignator : Date.CultureInfo.pmDesignator;
				case "S":
					return ord(context.getDate());
				case "W":
					return context.getWeek();
				case "WW":
					return context.getISOWeek();
				case "Q":
					return "Q" + context.getQuarter();
				case "q":
					return String(context.getQuarter());
				case "z":
					return context.getTimezone();
				case "Z":
				case "X":
					return Date.getTimezoneOffset(context.getTimezone());
				case "ZZ": // Timezone offset in seconds
					return context.getTimezoneOffset() * -60;
				case "u":
					return context.getDay();
				case "L":
					return ($D.isLeapYear(context.getFullYear())) ? 1 : 0;
				case "B":
					// Swatch Internet Time (.beats)
					return "@"+((context.getUTCSeconds() + (context.getUTCMinutes()*60) + ((context.getUTCHours()+1)*3600))/86.4);
				default:
					return m;
			}
		};
	};
	$P.toString = function (format, ignoreStandards) {
		
		// Standard Date and Time Format Strings. Formats pulled from CultureInfo file and
		// may vary by culture. 
		if (!ignoreStandards && format && format.length === 1) {
			output = parseStandardFormats.call(this, format);
			if (output) {
				return output;
			}
		}
		var parseFormatStrings = parseFormatStringsClosure(this);
		return format ? format.replace(/((\\)?(dd?d?d?|MM?M?M?|yy?y?y?|hh?|HH?|mm?|ss?|tt?|S|q|Q|WW?W?W?)(?![^\[]*\]))/g, parseFormatStrings).replace(/\[|\]/g, "") : this._toString();
	};

}());
},{}],15:[function(require,module,exports){
(function () {
	var $D = Date,
		$P = $D.prototype,
		p = function (s, l) {
			if (!l) {
				l = 2;
			}
			return ("000" + s).slice(l * -1);
		};
	
	if (typeof window !== "undefined" && typeof window.console !== "undefined" && typeof window.console.log !== "undefined") {
		$D.console = console; // used only to raise non-critical errors if available
	} else {
		// set mock so we don't give errors.
		$D.console = {
			log: function(){},
			error: function(){}
		};
	}
	$D.Config = $D.Config || {};

	$D.initOverloads = function() {
		/** 
		 * Overload of Date.now. Allows an alternate call for Date.now where it returns the 
		 * current Date as an object rather than just milliseconds since the Unix Epoch.
		 *
		 * Also provides an implementation of now() for browsers (IE<9) that don't have it.
		 * 
		 * Backwards compatible so with work with either:
		 *  Date.now() [returns ms]
		 * or
		 *  Date.now(true) [returns Date]
		 */
		if (!$D.now) {
			$D._now = function now() {
				return new Date().getTime();
			};
		} else if (!$D._now) {
			$D._now = $D.now;
		}

		$D.now = function (returnObj) {
			if (returnObj) {
				return $D.present();
			} else {
				return $D._now();
			}
		};

		if ( !$P.toISOString ) {
			$P.toISOString = function() {
				return this.getUTCFullYear() +
				"-" + p(this.getUTCMonth() + 1) +
				"-" + p(this.getUTCDate()) +
				"T" + p(this.getUTCHours()) +
				":" + p(this.getUTCMinutes()) +
				":" + p(this.getUTCSeconds()) +
				"." + String( (this.getUTCMilliseconds()/1000).toFixed(3)).slice(2, 5) +
				"Z";
			};
		}
		
		// private
		if ( $P._toString === undefined ){
			$P._toString = $P.toString;
		}

	};
	$D.initOverloads();


	/** 
	 * Gets a date that is set to the current date. The time is set to the start of the day (00:00 or 12:00 AM).
	 * @return {Date}    The current date.
	 */
	$D.today = function () {
		return new Date().clearTime();
	};

	/** 
	 * Gets a date that is set to the current date and time (same as new Date, but chainable)
	 * @return {Date}    The current date.
	 */
	$D.present = function () {
		return new Date();
	};

	/**
	 * Compares the first date to the second date and returns an number indication of their relative values.  
	 * @param {Date}     First Date object to compare [Required].
	 * @param {Date}     Second Date object to compare to [Required].
	 * @return {Number}  -1 = date1 is lessthan date2. 0 = values are equal. 1 = date1 is greaterthan date2.
	 */
	$D.compare = function (date1, date2) {
		if (isNaN(date1) || isNaN(date2)) {
			throw new Error(date1 + " - " + date2);
		} else if (date1 instanceof Date && date2 instanceof Date) {
			return (date1 < date2) ? -1 : (date1 > date2) ? 1 : 0;
		} else {
			throw new TypeError(date1 + " - " + date2);
		}
	};
	
	/**
	 * Compares the first Date object to the second Date object and returns true if they are equal.  
	 * @param {Date}     First Date object to compare [Required]
	 * @param {Date}     Second Date object to compare to [Required]
	 * @return {Boolean} true if dates are equal. false if they are not equal.
	 */
	$D.equals = function (date1, date2) {
		return (date1.compareTo(date2) === 0);
	};

	/**
	 * Gets the language appropriate day name when given the day number(0-6)
	 * eg - 0 == Sunday
	 * @return {String}  The day name
	 */
	$D.getDayName = function (n) {
		return Date.CultureInfo.dayNames[n];
	};

	/**
	 * Gets the day number (0-6) if given a CultureInfo specific string which is a valid dayName, abbreviatedDayName or shortestDayName (two char).
	 * @param {String}   The name of the day (eg. "Monday, "Mon", "tuesday", "tue", "We", "we").
	 * @return {Number}  The day number
	 */
	$D.getDayNumberFromName = function (name) {
		var n = Date.CultureInfo.dayNames, m = Date.CultureInfo.abbreviatedDayNames, o = Date.CultureInfo.shortestDayNames, s = name.toLowerCase();
		for (var i = 0; i < n.length; i++) {
			if (n[i].toLowerCase() === s || m[i].toLowerCase() === s || o[i].toLowerCase() === s) {
				return i;
			}
		}
		return -1;
	};
	
	/**
	 * Gets the month number (0-11) if given a Culture Info specific string which is a valid monthName or abbreviatedMonthName.
	 * @param {String}   The name of the month (eg. "February, "Feb", "october", "oct").
	 * @return {Number}  The day number
	 */
	$D.getMonthNumberFromName = function (name) {
		var n = Date.CultureInfo.monthNames, m = Date.CultureInfo.abbreviatedMonthNames, s = name.toLowerCase();
		for (var i = 0; i < n.length; i++) {
			if (n[i].toLowerCase() === s || m[i].toLowerCase() === s) {
				return i;
			}
		}
		return -1;
	};

	/**
	 * Gets the language appropriate month name when given the month number(0-11)
	 * eg - 0 == January
	 * @return {String}  The month name
	 */
	$D.getMonthName = function (n) {
		return Date.CultureInfo.monthNames[n];
	};

	/**
	 * Determines if the current date instance is within a LeapYear.
	 * @param {Number}   The year.
	 * @return {Boolean} true if date is within a LeapYear, otherwise false.
	 */
	$D.isLeapYear = function (year) {
		return ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
	};

	/**
	 * Gets the number of days in the month, given a year and month value. Automatically corrects for LeapYear.
	 * @param {Number}   The year.
	 * @param {Number}   The month (0-11).
	 * @return {Number}  The number of days in the month.
	 */
	$D.getDaysInMonth = function (year, month) {
		if (!month && $D.validateMonth(year)) {
				month = year;
				year = Date.today().getFullYear();
		}
		return [31, ($D.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
	};

	$P.getDaysInMonth = function () {
		return $D.getDaysInMonth(this.getFullYear(), this.getMonth());
	};
 
	$D.getTimezoneAbbreviation = function (offset, dst) {
		var p, n = (dst || false) ? Date.CultureInfo.abbreviatedTimeZoneDST : Date.CultureInfo.abbreviatedTimeZoneStandard;
		for (p in n) {
			if (n.hasOwnProperty(p)) {
				if (n[p] === offset) {
					return p;
				}
			}
		}
		return null;
	};
	
	$D.getTimezoneOffset = function (name, dst) {
		var i, a =[], z = Date.CultureInfo.timezones;
		if (!name) { name = (new Date()).getTimezone();}
		for (i = 0; i < z.length; i++) {
			if (z[i].name === name.toUpperCase()) {
				a.push(i);
			}
		}
		if (!z[a[0]]) {
			return null;
		}
		if (a.length === 1 || !dst) {
			return z[a[0]].offset;
		} else {
			for (i=0; i < a.length; i++) {
				if (z[a[i]].dst) {
					return z[a[i]].offset;
				}
			}
		}
	};

	$D.getQuarter = function (d) {
		d = d || new Date(); // If no date supplied, use today
		var q = [1,2,3,4];
		return q[Math.floor(d.getMonth() / 3)]; // ~~~ is a bitwise op. Faster than Math.floor
	};

	$D.getDaysLeftInQuarter = function (d) {
		d = d || new Date();
		var qEnd = new Date(d);
		qEnd.setMonth(qEnd.getMonth() + 3 - qEnd.getMonth() % 3, 0);
		return Math.floor((qEnd - d) / 8.64e7);
	};

	// private
	var validate = function (n, min, max, name) {
		name = name ? name : "Object";
		if (typeof n === "undefined") {
			return false;
		} else if (typeof n !== "number") {
			throw new TypeError(n + " is not a Number.");
		} else if (n < min || n > max) {
			// As failing validation is *not* an exceptional circumstance 
			// lets not throw a RangeError Exception here. 
			// It's semantically correct but it's not sensible.
			return false;
		}
		return true;
	};

	/**
	 * Validates the number is within an acceptable range for milliseconds [0-999].
	 * @param {Number}   The number to check if within range.
	 * @return {Boolean} true if within range, otherwise false.
	 */
	$D.validateMillisecond = function (value) {
		return validate(value, 0, 999, "millisecond");
	};

	/**
	 * Validates the number is within an acceptable range for seconds [0-59].
	 * @param {Number}   The number to check if within range.
	 * @return {Boolean} true if within range, otherwise false.
	 */
	$D.validateSecond = function (value) {
		return validate(value, 0, 59, "second");
	};

	/**
	 * Validates the number is within an acceptable range for minutes [0-59].
	 * @param {Number}   The number to check if within range.
	 * @return {Boolean} true if within range, otherwise false.
	 */
	$D.validateMinute = function (value) {
		return validate(value, 0, 59, "minute");
	};

	/**
	 * Validates the number is within an acceptable range for hours [0-23].
	 * @param {Number}   The number to check if within range.
	 * @return {Boolean} true if within range, otherwise false.
	 */
	$D.validateHour = function (value) {
		return validate(value, 0, 23, "hour");
	};

	/**
	 * Validates the number is within an acceptable range for the days in a month [0-MaxDaysInMonth].
	 * @param {Number}   The number to check if within range.
	 * @return {Boolean} true if within range, otherwise false.
	 */
	$D.validateDay = function (value, year, month) {
		if (year === undefined || year === null || month === undefined || month === null) { return false;}
		return validate(value, 1, $D.getDaysInMonth(year, month), "day");
	};

	/**
	 * Validates the number is within an acceptable range for months [0-11].
	 * @param {Number}   The number to check if within range.
	 * @return {Boolean} true if within range, otherwise false.
	 */
	$D.validateWeek = function (value) {
		return validate(value, 0, 53, "week");
	};

	/**
	 * Validates the number is within an acceptable range for months [0-11].
	 * @param {Number}   The number to check if within range.
	 * @return {Boolean} true if within range, otherwise false.
	 */
	$D.validateMonth = function (value) {
		return validate(value, 0, 11, "month");
	};

	/**
	 * Validates the number is within an acceptable range for years.
	 * @param {Number}   The number to check if within range.
	 * @return {Boolean} true if within range, otherwise false.
	 */
	$D.validateYear = function (value) {
		/**
		 * Per ECMAScript spec the range of times supported by Date objects is 
		 * exactly -100,000,000 days to +100,000,000 days measured relative to 
		 * midnight at the beginning of 01 January, 1970 UTC. 
		 * This gives a range of 8,640,000,000,000,000 milliseconds to either 
		 * side of 01 January, 1970 UTC.
		 *
		 * Earliest possible date: Tue, 20 Apr 271,822 B.C. 00:00:00 UTC
		 * Latest possible date: Sat, 13 Sep 275,760 00:00:00 UTC
		 */
		return validate(value, -271822, 275760, "year");
	};
	$D.validateTimezone = function(value) {
		var timezones = {"ACDT":1,"ACST":1,"ACT":1,"ADT":1,"AEDT":1,"AEST":1,"AFT":1,"AKDT":1,"AKST":1,"AMST":1,"AMT":1,"ART":1,"AST":1,"AWDT":1,"AWST":1,"AZOST":1,"AZT":1,"BDT":1,"BIOT":1,"BIT":1,"BOT":1,"BRT":1,"BST":1,"BTT":1,"CAT":1,"CCT":1,"CDT":1,"CEDT":1,"CEST":1,"CET":1,"CHADT":1,"CHAST":1,"CHOT":1,"ChST":1,"CHUT":1,"CIST":1,"CIT":1,"CKT":1,"CLST":1,"CLT":1,"COST":1,"COT":1,"CST":1,"CT":1,"CVT":1,"CWST":1,"CXT":1,"DAVT":1,"DDUT":1,"DFT":1,"EASST":1,"EAST":1,"EAT":1,"ECT":1,"EDT":1,"EEDT":1,"EEST":1,"EET":1,"EGST":1,"EGT":1,"EIT":1,"EST":1,"FET":1,"FJT":1,"FKST":1,"FKT":1,"FNT":1,"GALT":1,"GAMT":1,"GET":1,"GFT":1,"GILT":1,"GIT":1,"GMT":1,"GST":1,"GYT":1,"HADT":1,"HAEC":1,"HAST":1,"HKT":1,"HMT":1,"HOVT":1,"HST":1,"ICT":1,"IDT":1,"IOT":1,"IRDT":1,"IRKT":1,"IRST":1,"IST":1,"JST":1,"KGT":1,"KOST":1,"KRAT":1,"KST":1,"LHST":1,"LINT":1,"MAGT":1,"MART":1,"MAWT":1,"MDT":1,"MET":1,"MEST":1,"MHT":1,"MIST":1,"MIT":1,"MMT":1,"MSK":1,"MST":1,"MUT":1,"MVT":1,"MYT":1,"NCT":1,"NDT":1,"NFT":1,"NPT":1,"NST":1,"NT":1,"NUT":1,"NZDT":1,"NZST":1,"OMST":1,"ORAT":1,"PDT":1,"PET":1,"PETT":1,"PGT":1,"PHOT":1,"PHT":1,"PKT":1,"PMDT":1,"PMST":1,"PONT":1,"PST":1,"PYST":1,"PYT":1,"RET":1,"ROTT":1,"SAKT":1,"SAMT":1,"SAST":1,"SBT":1,"SCT":1,"SGT":1,"SLST":1,"SRT":1,"SST":1,"SYOT":1,"TAHT":1,"THA":1,"TFT":1,"TJT":1,"TKT":1,"TLT":1,"TMT":1,"TOT":1,"TVT":1,"UCT":1,"ULAT":1,"UTC":1,"UYST":1,"UYT":1,"UZT":1,"VET":1,"VLAT":1,"VOLT":1,"VOST":1,"VUT":1,"WAKT":1,"WAST":1,"WAT":1,"WEDT":1,"WEST":1,"WET":1,"WST":1,"YAKT":1,"YEKT":1,"Z":1};
		return (timezones[value] === 1);
	};
	$D.validateTimezoneOffset= function(value) {
		// timezones go from +14hrs to -12hrs, the +X hours are negative offsets.
		return (value > -841 && value < 721);
	};

}());

},{}],16:[function(require,module,exports){
(function () {
	var $D = Date,
		$P = $D.prototype,
		// $C = $D.CultureInfo, // not used atm
		p = function (s, l) {
			if (!l) {
				l = 2;
			}
			return ("000" + s).slice(l * -1);
		};
	/**
	 * Converts a PHP format string to Java/.NET format string.
	 * A PHP format string can be used with ._format or .format.
	 * A Java/.NET format string can be used with .toString().
	 * The .parseExact function will only accept a Java/.NET format string
	 *
	 * Example
	 * var f1 = "%m/%d/%y"
	 * var f2 = Date.normalizeFormat(f1);	// "MM/dd/yy"
	 *
	 * new Date().format(f1);	// "04/13/08"
	 * new Date()._format(f1);	// "04/13/08"
	 * new Date().toString(f2);	// "04/13/08"
	 *
	 * var date = Date.parseExact("04/13/08", f2); // Sun Apr 13 2008
	 *
	 * @param {String}   A PHP format string consisting of one or more format spcifiers.
	 * @return {String}  The PHP format converted to a Java/.NET format string.
	 */
	 var normalizerSubstitutions = {
		"d" : "dd",
		"%d": "dd",
		"D" : "ddd",
		"%a": "ddd",
		"j" : "dddd",
		"l" : "dddd",
		"%A": "dddd",
		"S" : "S",
		"F" : "MMMM",
		"%B": "MMMM",
		"m" : "MM",
		"%m": "MM",
		"M" : "MMM",
		"%b": "MMM",
		"%h": "MMM",
		"n" : "M",
		"Y" : "yyyy",
		"%Y": "yyyy",
		"y" : "yy",
		"%y": "yy",
		"g" : "h",
		"%I": "h",
		"G" : "H",
		"h" : "hh",
		"H" : "HH",
		"%H": "HH",
		"i" : "mm",
		"%M": "mm",
		"s" : "ss",
		"%S": "ss",
		"%r": "hh:mm tt",
		"%R": "H:mm",
		"%T": "H:mm:ss",
		"%X": "t",
		"%x": "d",
		"%e": "d",
		"%D": "MM/dd/yy",
		"%n": "\\n",
		"%t": "\\t",
		"e" : "z",
		"T" : "z",
		"%z": "z",
		"%Z": "z",
		"Z" : "ZZ",
		"N" : "u",
		"w" : "u",
		"%w": "u",
		"W" : "W",
		"%V": "W"
	};
	var normalizer = {
		substitutes: function (m) {
			return normalizerSubstitutions[m];
		},
		interpreted: function (m, x) {
			var y;
			switch (m) {
				case "%u":
					return x.getDay() + 1;
				case "z":
					return x.getOrdinalNumber();
				case "%j":
					return p(x.getOrdinalNumber(), 3);
				case "%U":
					var d1 = x.clone().set({month: 0, day: 1}).addDays(-1).moveToDayOfWeek(0),
						d2 = x.clone().addDays(1).moveToDayOfWeek(0, -1);
					return (d2 < d1) ? "00" : p((d2.getOrdinalNumber() - d1.getOrdinalNumber()) / 7 + 1);

				case "%W":
					return p(x.getWeek());
				case "t":
					return $D.getDaysInMonth(x.getFullYear(), x.getMonth());
				case "o":
				case "%G":
					return x.setWeek(x.getISOWeek()).toString("yyyy");
				case "%g":
					return x._format("%G").slice(-2);
				case "a":
				case "%p":
					return t("tt").toLowerCase();
				case "A":
					return t("tt").toUpperCase();
				case "u":
					return p(x.getMilliseconds(), 3);
				case "I":
					return (x.isDaylightSavingTime()) ? 1 : 0;
				case "O":
					return x.getUTCOffset();
				case "P":
					y = x.getUTCOffset();
					return y.substring(0, y.length - 2) + ":" + y.substring(y.length - 2);
				case "B":
					var now = new Date();
					return Math.floor(((now.getHours() * 3600) + (now.getMinutes() * 60) + now.getSeconds() + (now.getTimezoneOffset() + 60) * 60) / 86.4);
				case "c":
					return x.toISOString().replace(/\"/g, "");
				case "U":
					return $D.strtotime("now");
				case "%c":
					return t("d") + " " + t("t");
				case "%C":
					return Math.floor(x.getFullYear() / 100 + 1);
			}
		},
		shouldOverrideDefaults: function (m) {
			switch (m) {
				case "%e":
					return true;
				default:
					return false;
			}
		},
		parse: function (m, context) {
			var formatString, c = context || new Date();
			formatString = normalizer.substitutes(m);
			if (formatString) {
				return formatString;
			}
			formatString = normalizer.interpreted(m, c);

			if (formatString) {
				return formatString;
			} else {
				return m;
			}
		}
	};

	$D.normalizeFormat = function (format, context) {
		return format.replace(/(%|\\)?.|%%/g, function(t){
				return normalizer.parse(t, context);
		});
	};
	/**
	 * Format a local Unix timestamp according to locale settings
	 *
	 * Example:
	 * Date.strftime("%m/%d/%y", new Date());		// "04/13/08"
	 * Date.strftime("c", "2008-04-13T17:52:03Z");	// "04/13/08"
	 *
	 * @param {String}   A format string consisting of one or more format spcifiers [Optional].
	 * @param {Number|String}   The number representing the number of seconds that have elapsed since January 1, 1970 (local time).
	 * @return {String}  A string representation of the current Date object.
	 */
	$D.strftime = function (format, time) {
		var d = Date.parse(time);
		return d._format(format);
	};
	/**
	 * Parse any textual datetime description into a Unix timestamp.
	 * A Unix timestamp is the number of seconds that have elapsed since January 1, 1970 (midnight UTC/GMT).
	 *
	 * Example:
	 * Date.strtotime("04/13/08");				// 1208044800
	 * Date.strtotime("1970-01-01T00:00:00Z");	// 0
	 *
	 * @param {String}   A format string consisting of one or more format spcifiers [Optional].
	 * @param {Object}   A string or date object.
	 * @return {String}  A string representation of the current Date object.
	 */
	$D.strtotime = function (time) {
		var d = $D.parse(time);
		return Math.round($D.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds()) / 1000);
	};
	/**
	 * Converts the value of the current Date object to its equivalent string representation using a PHP/Unix style of date format specifiers.
	 * Format Specifiers
	 * Format  Description																	Example
	 * ------  ---------------------------------------------------------------------------	-----------------------
	 * %a		abbreviated weekday name according to the current localed					"Mon" through "Sun"
	 * %A		full weekday name according to the current localed							"Sunday" through "Saturday"
	 * %b		abbreviated month name according to the current localed						"Jan" through "Dec"
	 * %B		full month name according to the current locale								"January" through "December"
	 * %c		preferred date and time representation for the current locale				"4/13/2008 12:33 PM"
	 * %C		century number (the year divided by 100 and truncated to an integer)		"00" to "99"
	 * %d		day of the month as a decimal number										"01" to "31"
	 * %D		same as %m/%d/%y															"04/13/08"
	 * %e		day of the month as a decimal number, a single digit is preceded by a space	"1" to "31"
	 * %g		like %G, but without the century											"08"
	 * %G		The 4-digit year corresponding to the ISO week number (see %V).				"2008"
	 *		This has the same format and value as %Y, except that if the ISO week number
	 *		belongs to the previous or next year, that year is used instead.
	 * %h		same as %b																	"Jan" through "Dec"
	 * %H		hour as a decimal number using a 24-hour clock.								"00" to "23"
	 * %I		hour as a decimal number using a 12-hour clock.								"01" to "12"
	 * %j		day of the year as a decimal number.										"001" to "366"
	 * %m		month as a decimal number.													"01" to "12"
	 * %M		minute as a decimal number.													"00" to "59"
	 * %n		newline character		"\n"
	 * %p		either "am" or "pm" according to the given time value, or the				"am" or "pm"
	 *		corresponding strings for the current locale.
	 * %r		time in a.m. and p.m. notation												"8:44 PM"
	 * %R		time in 24 hour notation													"20:44"
	 * %S		second as a decimal number													"00" to "59"
	 * %t		tab character																"\t"
	 * %T		current time, equal to %H:%M:%S												"12:49:11"
	 * %u		weekday as a decimal number ["1", "7"], with "1" representing Monday		"1" to "7"
	 * %U		week number of the current year as a decimal number, starting with the		"0" to ("52" or "53")
	 *		first Sunday as the first day of the first week
	 * %V		The ISO 8601:1988 week number of the current year as a decimal number,		"00" to ("52" or "53")
	 *		range 01 to 53, where week 1 is the first week that has at least 4 days
	 *		in the current year, and with Monday as the first day of the week.
	 *		(Use %G or %g for the year component that corresponds to the week number
	 *		for the specified timestamp.)
	 * %W		week number of the current year as a decimal number, starting with the		"00" to ("52" or "53")
	 *		first Monday as the first day of the first week
	 * %w		day of the week as a decimal, Sunday being "0"								"0" to "6"
	 * %x		preferred date representation for the current locale without the time		"4/13/2008"
	 * %X		preferred time representation for the current locale without the date		"12:53:05"
	 * %y		year as a decimal number without a century									"00" "99"
	 * %Y		year as a decimal number including the century								"2008"
	 * %Z		time zone or name or abbreviation											"UTC", "EST", "PST"
	 * %z		same as %Z
	 * %%		a literal "%" characters													"%"
	 * d		Day of the month, 2 digits with leading zeros								"01" to "31"
	 * D		A textual representation of a day, three letters							"Mon" through "Sun"
	 * j		Day of the month without leading zeros										"1" to "31"
	 * l		A full textual representation of the day of the week (lowercase "L")		"Sunday" through "Saturday"
	 * N		ISO-8601 numeric representation of the day of the week (added in PHP 5.1.0)	"1" (for Monday) through "7" (for Sunday)
	 * S		English ordinal suffix for the day of the month, 2 characters				"st", "nd", "rd" or "th". Works well with j
	 * w		Numeric representation of the day of the week								"0" (for Sunday) through "6" (for Saturday)
	 * z		The day of the year (starting from "0")										"0" through "365"
	 * W		ISO-8601 week number of year, weeks starting on Monday						"00" to ("52" or "53")
	 * F		A full textual representation of a month, such as January or March			"January" through "December"
	 * m		Numeric representation of a month, with leading zeros						"01" through "12"
	 * M		A short textual representation of a month, three letters					"Jan" through "Dec"
	 * n		Numeric representation of a month, without leading zeros					"1" through "12"
	 * t		Number of days in the given month											"28" through "31"
	 * L		Whether it's a leap year													"1" if it is a leap year, "0" otherwise
	 * o		ISO-8601 year number. This has the same value as Y, except that if the		"2008"
	 *		ISO week number (W) belongs to the previous or next year, that year
	 *		is used instead.
	 * Y		A full numeric representation of a year, 4 digits							"2008"
	 * y		A two digit representation of a year										"08"
	 * a		Lowercase Ante meridiem and Post meridiem									"am" or "pm"
	 * A		Uppercase Ante meridiem and Post meridiem									"AM" or "PM"
	 * B		Swatch Internet time														"000" through "999"
	 * g		12-hour format of an hour without leading zeros								"1" through "12"
	 * G		24-hour format of an hour without leading zeros								"0" through "23"
	 * h		12-hour format of an hour with leading zeros								"01" through "12"
	 * H		24-hour format of an hour with leading zeros								"00" through "23"
	 * i		Minutes with leading zeros													"00" to "59"
	 * s		Seconds, with leading zeros													"00" through "59"
	 * u		Milliseconds																"54321"
	 * e		Timezone identifier															"UTC", "EST", "PST"
	 * I		Whether or not the date is in daylight saving time (uppercase i)			"1" if Daylight Saving Time, "0" otherwise
	 * O		Difference to Greenwich time (GMT) in hours									"+0200", "-0600"
	 * P		Difference to Greenwich time (GMT) with colon between hours and minutes		"+02:00", "-06:00"
	 * T		Timezone abbreviation														"UTC", "EST", "PST"
	 * Z		Timezone offset in seconds. The offset for timezones west of UTC is			"-43200" through "50400"
	 *			always negative, and for those east of UTC is always positive.
	 * c		ISO 8601 date																"2004-02-12T15:19:21+00:00"
	 * r		RFC 2822 formatted date														"Thu, 21 Dec 2000 16:01:07 +0200"
	 * U		Seconds since the Unix Epoch (January 1 1970 00:00:00 GMT)					"0"
	 * @param {String}   A format string consisting of one or more format spcifiers [Optional].
	 * @return {String}  A string representation of the current Date object.
	 */
	var formatReplace = function (context) {
		return function (m) {
			var formatString, override = false;
			if (m.charAt(0) === "\\" || m.substring(0, 2) === "%%") {
				return m.replace("\\", "").replace("%%", "%");
			}

			override = normalizer.shouldOverrideDefaults(m);
			formatString = $D.normalizeFormat(m, context);
			if (formatString) {
				return context.toString(formatString, override);
			}
		};
	};
	$P._format = function (format) {
		var formatter = formatReplace(this);
		if (!format) {
			return this._toString();
		} else {
			return format.replace(/(%|\\)?.|%%/g, formatter);
		}
	};

	if (!$P.format) {
		$P.format = $P._format;
	}
}());
},{}],17:[function(require,module,exports){
(function () {
	"use strict";
	Date.Parsing = {
		Exception: function (s) {
			this.message = "Parse error at '" + s.substring(0, 10) + " ...'";
		}
	};
	var $P = Date.Parsing;
	var dayOffsets = {
		standard: [0,31,59,90,120,151,181,212,243,273,304,334],
		leap: [0,31,60,91,121,152,182,213,244,274,305,335]
	};

	$P.isLeapYear = function(year) {
		return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
	};

	var utils = {
		multiReplace : function (str, hash ) {
			var key;
			for (key in hash) {
				if (Object.prototype.hasOwnProperty.call(hash, key)) {
					var regex;
					if (typeof hash[key] === "function") {

					} else {
						regex = (hash[key] instanceof RegExp) ? hash[key] : new RegExp(hash[key], "g");
					}
					str = str.replace(regex, key);
				}
			}
			return str;
		},
		getDayOfYearFromWeek : function (obj) {
			var d, jan4, offset;
			obj.weekDay = (!obj.weekDay && obj.weekDay !== 0) ? 1 : obj.weekDay;
			d = new Date(obj.year, 0, 4);
			jan4 = d.getDay() === 0 ? 7 : d.getDay(); // JS is 0 indexed on Sunday.
			offset = jan4+3;
			obj.dayOfYear = ((obj.week * 7) + (obj.weekDay === 0 ? 7 : obj.weekDay))-offset;
			return obj;
		},
		getDayOfYear : function (obj, dayOffset) {
			if (!obj.dayOfYear) {
				obj = utils.getDayOfYearFromWeek(obj);
			}
			for (var i=0;i <= dayOffset.length;i++) {
				if (obj.dayOfYear < dayOffset[i] || i === dayOffset.length) {
					obj.day = obj.day ? obj.day : (obj.dayOfYear - dayOffset[i-1]);
					break;
				} else {
					obj.month = i;
				}
			}
			return obj;
		},
		adjustForTimeZone : function (obj, date) {
			var offset;
			if (obj.zone.toUpperCase() === "Z" || (obj.zone_hours === 0 && obj.zone_minutes === 0)) {
				// it's UTC/GML so work out the current timeszone offset
				offset = -date.getTimezoneOffset();
			} else {
				offset = (obj.zone_hours*60) + (obj.zone_minutes || 0);
				if (obj.zone_sign === "+") {
					offset *= -1;
				}
				offset -= date.getTimezoneOffset();
			}
			date.setMinutes(date.getMinutes()+offset);
			return date;
		},
		setDefaults : function (obj) {
			obj.year = obj.year || Date.today().getFullYear();
			obj.hours = obj.hours || 0;
			obj.minutes = obj.minutes || 0;
			obj.seconds = obj.seconds || 0;
			obj.milliseconds = obj.milliseconds || 0;
			if (!(!obj.month && (obj.week || obj.dayOfYear))) {
				// if we have a month, or if we don't but don't have the day calculation data
				obj.month = obj.month || 0;
				obj.day = obj.day || 1;
			}
			return obj;
		},
		dataNum: function (data, mod, explict, postProcess) {
			var dataNum = data*1;
			if (mod) {
				if (postProcess) {
					return data ? mod(data)*1 : data;
				} else {
					return data ? mod(dataNum) : data;
				}
			} else if (!explict){
				return data ? dataNum : data;
			} else {
				return (data && typeof data !== "undefined") ? dataNum : data;
			}
		},
		timeDataProcess: function (obj) {
			var timeObj = {};
			for (var x in obj.data) {
				if (obj.data.hasOwnProperty(x)) {
					timeObj[x] = obj.ignore[x] ? obj.data[x] : utils.dataNum(obj.data[x], obj.mods[x], obj.explict[x], obj.postProcess[x]);
				}
			}
			if (obj.data.secmins) {
				obj.data.secmins = obj.data.secmins.replace(",", ".") * 60;
				if (!timeObj.minutes) {
					timeObj.minutes = obj.data.secmins;
				} else if (!timeObj.seconds) {
					timeObj.seconds = obj.data.secmins;
				}
				delete obj.secmins;
			}
			return timeObj;
		},
		buildTimeObjectFromData: function (data) {
			var time = utils.timeDataProcess({
				data: {
					year : data[1],
					month : data[5],
					day : data[7],
					week : data[8],
					dayOfYear : data[10],
					hours : data[15],
					zone_hours : data[23],
					zone_minutes : data[24],
					zone : data[21],
					zone_sign : data[22],
					weekDay : data[9],
					minutes: data[16],
					seconds: data[19],
					milliseconds: data[20],
					secmins: data[18]
				},
				mods: {
					month: function(data) {
						return data-1;
					},
					weekDay: function (data) {
						data = Math.abs(data);
						return (data === 7 ? 0 : data);
					},
					minutes: function (data) {
						return data.replace(":","");
					},
					seconds: function (data) {
						return Math.floor( (data.replace(":","").replace(",","."))*1 );
					},
					milliseconds: function (data) {
						return (data.replace(",",".")*1000);
					}
				},
				postProcess: {
					minutes: true,
					seconds: true,
					milliseconds: true
				},
				explict: {
					zone_hours: true,
					zone_minutes: true
				},
				ignore: {
					zone: true,
					zone_sign: true,
					secmins: true
				}
			});
			return time;
		},
		addToHash: function (hash, keys, data) {
			keys = keys;
			data = data;
			var len = keys.length;
			for (var i = 0; i < len; i++) {
			  hash[keys[i]] = data[i];
			}
			return hash;
		},
		combineRegex: function (r1, r2) {
			return new RegExp("(("+r1.source+")\\s("+r2.source+"))");
		},
		getDateNthString: function(add, last, inc){
			if (add) {
				return Date.today().addDays(inc).toString("d");
			} else if (last) {
				return Date.today().last()[inc]().toString("d");
			}

		},
		buildRegexData: function (array) {
			var arr = [];
			var len = array.length;
			for (var i=0; i < len; i++) {
				if (Object.prototype.toString.call(array[i]) === '[object Array]') { // oldIE compat version of Array.isArray
					arr.push(this.combineRegex(array[i][0], array[i][1]));
				} else {
					arr.push(array[i]);
				}
			}
			return arr;
		}
	};

	$P.processTimeObject = function (obj) {
		var date, dayOffset;

		utils.setDefaults(obj);
		dayOffset = ($P.isLeapYear(obj.year)) ? dayOffsets.leap : dayOffsets.standard;

		if (!obj.month && (obj.week || obj.dayOfYear)) {
			utils.getDayOfYear(obj, dayOffset);
		} else {
			obj.dayOfYear = dayOffset[obj.month] + obj.day;
		}

		date = new Date(obj.year, obj.month, obj.day, obj.hours, obj.minutes, obj.seconds, obj.milliseconds);

		if (obj.zone) {
			utils.adjustForTimeZone(obj, date); // adjust (and calculate) for timezone
		}
		return date;
	};

	$P.ISO = {
		regex : /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-4])((:?)[0-5]\d)?|24\:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?\s?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/,
		parse : function (s) {
			var time, data = s.match(this.regex);
			if (!data || !data.length) {
				return null;
			}

			time = utils.buildTimeObjectFromData(data);

			if (!time.year || (!time.year && (!time.month && !time.day) && (!time.week && !time.dayOfYear)) ) {
				return null;
			}
			return $P.processTimeObject(time);
		}
	};

	$P.Numeric = {
		isNumeric: function (e){return!isNaN(parseFloat(e))&&isFinite(e);},
		regex: /\b([0-1]?[0-9])([0-3]?[0-9])([0-2]?[0-9]?[0-9][0-9])\b/i,
		parse: function (s) {
			var data, i,
				time = {},
				order = Date.CultureInfo.dateElementOrder.split("");
			if (!(this.isNumeric(s)) || // if it's non-numeric OR
				(s[0] === "+" && s[0] === "-")) {			// It's an arithmatic string (eg +/-1000)
				return null;
			}
			if (s.length < 5 && s.indexOf(".") < 0 && s.indexOf("/") < 0) { // assume it's just a year.
				time.year = s;
				return $P.processTimeObject(time);
			}
			data = s.match(this.regex);
			if (!data || !data.length) {
				return null;
			}
			for (i=0; i < order.length; i++) {
				switch(order[i]) {
					case "d":
						time.day = data[i+1];
						break;
					case "m":
						time.month = (data[i+1]-1);
						break;
					case "y":
						time.year = data[i+1];
						break;
				}
			}
			return $P.processTimeObject(time);
		}
	};

	$P.Normalizer = {
		regexData: function () {
			var $R = Date.CultureInfo.regexPatterns;
			return utils.buildRegexData([
				$R.tomorrow,
				$R.yesterday,
				[$R.past, $R.mon],
				[$R.past, $R.tue],
				[$R.past, $R.wed],
				[$R.past, $R.thu],
				[$R.past, $R.fri],
				[$R.past, $R.sat],
				[$R.past, $R.sun]
			]);
		},
		basicReplaceHash : function() {
			var $R = Date.CultureInfo.regexPatterns;
			return {
				"January": $R.jan.source,
				"February": $R.feb,
				"March": $R.mar,
				"April": $R.apr,
				"May": $R.may,
				"June": $R.jun,
				"July": $R.jul,
				"August": $R.aug,
				"September": $R.sep,
				"October": $R.oct,
				"November": $R.nov,
				"December": $R.dec,
				"": /\bat\b/gi,
				" ": /\s{2,}/,
				"am": $R.inTheMorning,
				"9am": $R.thisMorning,
				"pm": $R.inTheEvening,
				"7pm":$R.thisEvening
			};
		},
		keys : function(){
			return [
				utils.getDateNthString(true, false, 1),				// tomorrow
				utils.getDateNthString(true, false, -1),			// yesterday
				utils.getDateNthString(false, true, "monday"),		//last mon
				utils.getDateNthString(false, true, "tuesday"),		//last tues
				utils.getDateNthString(false, true, "wednesday"),	//last wed
				utils.getDateNthString(false, true, "thursday"),	//last thurs
				utils.getDateNthString(false, true, "friday"),		//last fri
				utils.getDateNthString(false, true, "saturday"),	//last sat
				utils.getDateNthString(false, true, "sunday")		//last sun
			];
		},
		buildRegexFunctions: function () {
			var $R = Date.CultureInfo.regexPatterns;
			var __ = Date.i18n.__;
			var tomorrowRE = new RegExp("(\\b\\d\\d?("+__("AM")+"|"+__("PM")+")? )("+$R.tomorrow.source.slice(1)+")", "i"); // adapted tomorrow regex for AM PM relative dates
			var todayRE = new RegExp($R.today.source + "(?!\\s*([+-]))\\b"); // today, but excludes the math operators (eg "today + 2h")

			this.replaceFuncs = [
				[todayRE, function (full) {
					return (full.length > 1) ? Date.today().toString("d") : full;
				}],
				[tomorrowRE,
				function(full, m1) {
					var t = Date.today().addDays(1).toString("d");
					return (t + " " + m1);
				}],
				[$R.amThisMorning, function(str, am){return am;}],
				[$R.pmThisEvening, function(str, pm){return pm;}]
			];

		},
		buildReplaceData: function () {
			this.buildRegexFunctions();
			this.replaceHash = utils.addToHash(this.basicReplaceHash(), this.keys(), this.regexData());
		},
		stringReplaceFuncs: function (s) {
			for (var i=0; i < this.replaceFuncs.length; i++) {
				s = s.replace(this.replaceFuncs[i][0], this.replaceFuncs[i][1]);
			}
			return s;
		},
		parse: function (s) {
			s = this.stringReplaceFuncs(s);
			s = utils.multiReplace(s, this.replaceHash);

			try {
				var n = s.split(/([\s\-\.\,\/\x27]+)/);
				if (n.length === 3 &&
					$P.Numeric.isNumeric(n[0]) &&
					$P.Numeric.isNumeric(n[2]) &&
					(n[2].length >= 4)) {
						// ok, so we're dealing with x/year. But that's not a full date.
						// This fixes wonky dateElementOrder parsing when set to dmy order.
						if (Date.CultureInfo.dateElementOrder[0] === "d") {
							s = "1/" + n[0] + "/" + n[2]; // set to 1st of month and normalize the seperator
						}
				}
			} catch (e) {}

			return s;
		}
	};
	$P.Normalizer.buildReplaceData();
}());
},{}],18:[function(require,module,exports){
(function () {
	var $D = Date;
	var lang = Date.CultureStrings ? Date.CultureStrings.lang : null;
	var loggedKeys = {}; // for debug purposes.
	var getText = {
		getFromKey: function (key, countryCode) {
			var output;
			if (Date.CultureStrings && Date.CultureStrings[countryCode] && Date.CultureStrings[countryCode][key]) {
				output = Date.CultureStrings[countryCode][key];
			} else {
				output = getText.buildFromDefault(key);
			}
			if (key.charAt(0) === "/") { // Assume it's a regex
				output = getText.buildFromRegex(key, countryCode);
			}
			return output;
		},
		getFromObjectValues: function (obj, countryCode) {
			var key, output = {};
			for(key in obj) {
				if (obj.hasOwnProperty(key)) {
					output[key] = getText.getFromKey(obj[key], countryCode);
				}
			}
			return output;
		},
		getFromObjectKeys: function (obj, countryCode) {
			var key, output = {};
			for(key in obj) {
				if (obj.hasOwnProperty(key)) {
					output[getText.getFromKey(key, countryCode)] = obj[key];
				}
			}
			return output;
		},
		getFromArray: function (arr, countryCode) {
			var output = [];
			for (var i=0; i < arr.length; i++){
				if (i in arr) {
					output[i] = getText.getFromKey(arr[i], countryCode);
				}
			}
			return output;
		},
		buildFromDefault: function (key) {
			var output, length, split, last;
			switch(key) {
				case "name":
					output = "en-US";
					break;
				case "englishName":
					output = "English (United States)";
					break;
				case "nativeName":
					output = "English (United States)";
					break;
				case "twoDigitYearMax":
					output = 2049;
					break;
				case "firstDayOfWeek":
					output = 0;
					break;
				default:
					output = key;
					split = key.split("_");
					length = split.length;
					if (length > 1 && key.charAt(0) !== "/") {
						// if the key isn't a regex and it has a split.
						last = split[(length - 1)].toLowerCase();
						if (last === "initial" || last === "abbr") {
							output = split[0];
						}
					}
					break;
			}
			return output;
		},
		buildFromRegex: function (key, countryCode) {
			var output;
			if (Date.CultureStrings && Date.CultureStrings[countryCode] && Date.CultureStrings[countryCode][key]) {
				output = new RegExp(Date.CultureStrings[countryCode][key], "i");
			} else {
				output = new RegExp(key.replace(new RegExp("/", "g"),""), "i");
			}
			return output;
		}
	};

	var shallowMerge = function (obj1, obj2) {
		for (var attrname in obj2) {
			if (obj2.hasOwnProperty(attrname)) {
				obj1[attrname] = obj2[attrname];
			}
		}
	};

	var __ = function (key, language) {
		var countryCode = (language) ? language : lang;
		loggedKeys[key] = key;
		if (typeof key === "object") {
			if (key instanceof Array) {
				return getText.getFromArray(key, countryCode);
			} else {
				return getText.getFromObjectKeys(key, countryCode);
			}
		} else {
			return getText.getFromKey(key, countryCode);
		}
	};
	
	var loadI18nScript = function (code) {
		// paatterned after jQuery's getScript.
		var url = Date.Config.i18n + code + ".js";
		var head = document.getElementsByTagName("head")[0] || document.documentElement;
		var script = document.createElement("script");
		script.src = url;

		var completed = false;
		var events = {
			done: function (){} // placeholder function
		};
		// Attach handlers for all browsers
		script.onload = script.onreadystatechange = function() {
			if ( !completed && (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") ) {
				events.done();
				head.removeChild(script);
			}
		};

		setTimeout(function() {
			head.insertBefore(script, head.firstChild);
		}, 0); // allows return to execute first
		
		return {
			done: function (cb) {
				events.done = function() {
					if (cb) {
						setTimeout(cb,0);
					}
				};
			}
		};
	};

	var buildInfo = {
		buildFromMethodHash: function (obj) {
			var key;
			for(key in obj) {
				if (obj.hasOwnProperty(key)) {
					obj[key] = buildInfo[obj[key]]();
				}
			}
			return obj;
		},
		timeZoneDST: function () {
			var DST = {
				"CHADT": "+1345",
				"NZDT": "+1300",
				"AEDT": "+1100",
				"ACDT": "+1030",
				"AZST": "+0500",
				"IRDT": "+0430",
				"EEST": "+0300",
				"CEST": "+0200",
				"BST": "+0100",
				"PMDT": "-0200",
				"ADT": "-0300",
				"NDT": "-0230",
				"EDT": "-0400",
				"CDT": "-0500",
				"MDT": "-0600",
				"PDT": "-0700",
				"AKDT": "-0800",
				"HADT": "-0900"
			};
			return __(DST);
		},
		timeZoneStandard: function () {
			var standard = {
				"LINT": "+1400",
				"TOT": "+1300",
				"CHAST": "+1245",
				"NZST": "+1200",
				"NFT": "+1130",
				"SBT": "+1100",
				"AEST": "+1000",
				"ACST": "+0930",
				"JST": "+0900",
				"CWST": "+0845",
				"CT": "+0800",
				"ICT": "+0700",
				"MMT": "+0630",
				"BST": "+0600",
				"NPT": "+0545",
				"IST": "+0530",
				"PKT": "+0500",
				"AFT": "+0430",
				"MSK": "+0400",
				"IRST": "+0330",
				"FET": "+0300",
				"EET": "+0200",
				"CET": "+0100",
				"GMT": "+0000",
				"UTC": "+0000",
				"CVT": "-0100",
				"GST": "-0200",
				"BRT": "-0300",
				"NST": "-0330",
				"AST": "-0400",
				"EST": "-0500",
				"CST": "-0600",
				"MST": "-0700",
				"PST": "-0800",
				"AKST": "-0900",
				"MIT": "-0930",
				"HST": "-1000",
				"SST": "-1100",
				"BIT": "-1200"
			};
			return __(standard);
		},
		timeZones: function (data) {
			var zone;
			data.timezones = [];
			for (zone in data.abbreviatedTimeZoneStandard) {
				if (data.abbreviatedTimeZoneStandard.hasOwnProperty(zone)) {
					data.timezones.push({ name: zone, offset: data.abbreviatedTimeZoneStandard[zone]});
				}
			}
			for (zone in data.abbreviatedTimeZoneDST) {
				if (data.abbreviatedTimeZoneDST.hasOwnProperty(zone)) {
					data.timezones.push({ name: zone, offset: data.abbreviatedTimeZoneDST[zone], dst: true});
				}
			}
			return data.timezones;
		},
		days: function () {
			return __(["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]);
		},
		dayAbbr: function () {
			return __(["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]);
		},
		dayShortNames: function () {
			return __(["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]);
		},
		dayFirstLetters: function () {
			return __(["S_Sun_Initial", "M_Mon_Initial", "T_Tues_Initial", "W_Wed_Initial", "T_Thu_Initial", "F_Fri_Initial", "S_Sat_Initial"]);
		},
		months: function () {
			return __(["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]);
		},
		monthAbbr: function () {
			return __(["Jan_Abbr", "Feb_Abbr", "Mar_Abbr", "Apr_Abbr", "May_Abbr", "Jun_Abbr", "Jul_Abbr", "Aug_Abbr", "Sep_Abbr", "Oct_Abbr", "Nov_Abbr", "Dec_Abbr"]);
		},
		formatPatterns: function () {
			return getText.getFromObjectValues({
				shortDate: "M/d/yyyy",
				longDate: "dddd, MMMM dd, yyyy",
				shortTime: "h:mm tt",
				longTime: "h:mm:ss tt",
				fullDateTime: "dddd, MMMM dd, yyyy h:mm:ss tt",
				sortableDateTime: "yyyy-MM-ddTHH:mm:ss",
				universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ",
				rfc1123: "ddd, dd MMM yyyy HH:mm:ss",
				monthDay: "MMMM dd",
				yearMonth: "MMMM, yyyy"
			}, Date.i18n.currentLanguage());
		},
		regex: function () {
			return getText.getFromObjectValues({
				inTheMorning: "/( in the )(morn(ing)?)\\b/",
				thisMorning: "/(this )(morn(ing)?)\\b/",
				amThisMorning: "/(\b\\d(am)? )(this )(morn(ing)?)/",
				inTheEvening: "/( in the )(even(ing)?)\\b/",
				thisEvening: "/(this )(even(ing)?)\\b/",
				pmThisEvening: "/(\b\\d(pm)? )(this )(even(ing)?)/",
				jan: "/jan(uary)?/",
				feb: "/feb(ruary)?/",
				mar: "/mar(ch)?/",
				apr: "/apr(il)?/",
				may: "/may/",
				jun: "/jun(e)?/",
				jul: "/jul(y)?/",
				aug: "/aug(ust)?/",
				sep: "/sep(t(ember)?)?/",
				oct: "/oct(ober)?/",
				nov: "/nov(ember)?/",
				dec: "/dec(ember)?/",
				sun: "/^su(n(day)?)?/",
				mon: "/^mo(n(day)?)?/",
				tue: "/^tu(e(s(day)?)?)?/",
				wed: "/^we(d(nesday)?)?/",
				thu: "/^th(u(r(s(day)?)?)?)?/",
				fri: "/fr(i(day)?)?/",
				sat: "/^sa(t(urday)?)?/",
				future: "/^next/",
				past: "/^last|past|prev(ious)?/",
				add: "/^(\\+|aft(er)?|from|hence)/",
				subtract: "/^(\\-|bef(ore)?|ago)/",
				yesterday: "/^yes(terday)?/",
				today: "/^t(od(ay)?)?/",
				tomorrow: "/^tom(orrow)?/",
				now: "/^n(ow)?/",
				millisecond: "/^ms|milli(second)?s?/",
				second: "/^sec(ond)?s?/",
				minute: "/^mn|min(ute)?s?/",
				hour: "/^h(our)?s?/",
				week: "/^w(eek)?s?/",
				month: "/^m(onth)?s?/",
				day: "/^d(ay)?s?/",
				year: "/^y(ear)?s?/",
				shortMeridian: "/^(a|p)/",
				longMeridian: "/^(a\\.?m?\\.?|p\\.?m?\\.?)/",
				timezone: "/^((e(s|d)t|c(s|d)t|m(s|d)t|p(s|d)t)|((gmt)?\\s*(\\+|\\-)\\s*\\d\\d\\d\\d?)|gmt|utc)/",
				ordinalSuffix: "/^\\s*(st|nd|rd|th)/",
				timeContext: "/^\\s*(\\:|a(?!u|p)|p)/"
			}, Date.i18n.currentLanguage());
		}
	};

	var CultureInfo = function () {
		var info = getText.getFromObjectValues({
			name: "name",
			englishName: "englishName",
			nativeName: "nativeName",
			amDesignator: "AM",
			pmDesignator: "PM",
			firstDayOfWeek: "firstDayOfWeek",
			twoDigitYearMax: "twoDigitYearMax",
			dateElementOrder: "mdy"
		}, Date.i18n.currentLanguage());

		var constructedInfo = buildInfo.buildFromMethodHash({
			dayNames: "days",
			abbreviatedDayNames: "dayAbbr",
			shortestDayNames: "dayShortNames",
			firstLetterDayNames: "dayFirstLetters",
			monthNames: "months",
			abbreviatedMonthNames: "monthAbbr",
			formatPatterns: "formatPatterns",
			regexPatterns: "regex",
			abbreviatedTimeZoneDST: "timeZoneDST",
			abbreviatedTimeZoneStandard: "timeZoneStandard"
		});

		shallowMerge(info, constructedInfo);
		buildInfo.timeZones(info);
		return info;
	};

	$D.i18n = {
		__: function (key, lang) {
			return __(key, lang);
		},
		currentLanguage: function () {
			return lang || "en-US";
		},
		setLanguage: function (code, force, cb) {
			var async = false;
			if (force || code === "en-US" || (!!Date.CultureStrings && !!Date.CultureStrings[code])) {
				lang = code;
				Date.CultureStrings = Date.CultureStrings || {};
				Date.CultureStrings.lang = code;
				Date.CultureInfo = new CultureInfo();
			} else {
				if (!(!!Date.CultureStrings && !!Date.CultureStrings[code])) {
					if (typeof exports !== "undefined" && this.exports !== exports) {
						// we're in a Node enviroment, load it using require
						try {
							require("../i18n/" + code + ".js");
							lang = code;
							Date.CultureStrings.lang = code;
							Date.CultureInfo = new CultureInfo();
						} catch (e) {
							// var str = "The language for '" + code + "' could not be loaded by Node. It likely does not exist.";
							throw new Error("The DateJS IETF language tag '" + code + "' could not be loaded by Node. It likely does not exist.");
						}
					} else if (Date.Config && Date.Config.i18n) {
						// we know the location of the files, so lets load them					
						async = true;
						loadI18nScript(code).done(function(){
							lang = code;
							Date.CultureStrings = Date.CultureStrings || {};
							Date.CultureStrings.lang = code;
							Date.CultureInfo = new CultureInfo();
							$D.Parsing.Normalizer.buildReplaceData(); // because this is async
							if ($D.Grammar) {
								$D.Grammar.buildGrammarFormats(); // so we can parse those strings...
							}
							if (cb) {
								setTimeout(cb,0);
							}
						});
					} else {
						Date.console.error("The DateJS IETF language tag '" + code + "' is not available and has not been loaded.");
						return false;
					}
				}
			}
			$D.Parsing.Normalizer.buildReplaceData(); // rebuild normalizer strings
			if ($D.Grammar) {
				$D.Grammar.buildGrammarFormats(); // so we can parse those strings...
			}
			if (!async && cb) {
				setTimeout(cb,0);
			}
		},
		getLoggedKeys: function () {
			return loggedKeys;
		},
		updateCultureInfo: function () {
			Date.CultureInfo = new CultureInfo();
		}
	};
	$D.i18n.updateCultureInfo(); // run automatically
}());
},{}],19:[function(require,module,exports){
(function () {
	var $D = Date;

	/**
	 * @desc Converts the specified string value into its JavaScript Date equivalent using CultureInfo specific format information.
	 * 
	 * Example
	<pre><code>
	///////////
	// Dates //
	///////////

	// 15-Oct-2004
	var d1 = Date.parse("10/15/2004");

	// 15-Oct-2004
	var d1 = Date.parse("15-Oct-2004");

	// 15-Oct-2004
	var d1 = Date.parse("2004.10.15");

	//Fri Oct 15, 2004
	var d1 = Date.parse("Fri Oct 15, 2004");

	///////////
	// Times //
	///////////

	// Today at 10 PM.
	var d1 = Date.parse("10 PM");

	// Today at 10:30 PM.
	var d1 = Date.parse("10:30 P.M.");

	// Today at 6 AM.
	var d1 = Date.parse("06am");

	/////////////////////
	// Dates and Times //
	/////////////////////

	// 8-July-2004 @ 10:30 PM
	var d1 = Date.parse("July 8th, 2004, 10:30 PM");

	// 1-July-2004 @ 10:30 PM
	var d1 = Date.parse("2004-07-01T22:30:00");

	////////////////////
	// Relative Dates //
	////////////////////

	// Returns today's date. The string "today" is culture specific.
	var d1 = Date.parse("today");

	// Returns yesterday's date. The string "yesterday" is culture specific.
	var d1 = Date.parse("yesterday");

	// Returns the date of the next thursday.
	var d1 = Date.parse("Next thursday");

	// Returns the date of the most previous monday.
	var d1 = Date.parse("last monday");

	// Returns today's day + one year.
	var d1 = Date.parse("next year");

	///////////////
	// Date Math //
	///////////////

	// Today + 2 days
	var d1 = Date.parse("t+2");

	// Today + 2 days
	var d1 = Date.parse("today + 2 days");

	// Today + 3 months
	var d1 = Date.parse("t+3m");

	// Today - 1 year
	var d1 = Date.parse("today - 1 year");

	// Today - 1 year
	var d1 = Date.parse("t-1y"); 


	/////////////////////////////
	// Partial Dates and Times //
	/////////////////////////////

	// July 15th of this year.
	var d1 = Date.parse("July 15");

	// 15th day of current day and year.
	var d1 = Date.parse("15");

	// July 1st of current year at 10pm.
	var d1 = Date.parse("7/1 10pm");
	</code></pre>
	 *
	 * @param {String}   The string value to convert into a Date object [Required]
	 * @return {Date}    A Date object or null if the string cannot be converted into a Date.
	 */
	var parseUtils = {
		removeOrds: function (s) {
			ords = s.match(/\b(\d+)(?:st|nd|rd|th)\b/); // find ordinal matches
			s = ((ords && ords.length === 2) ? s.replace(ords[0], ords[1]) : s);
			return s;
		},
		grammarParser: function (s) {
			var r = null;
			try {
				r = $D.Grammar.start.call({}, s.replace(/^\s*(\S*(\s+\S+)*)\s*$/, "$1"));
			} catch (e) {
				return null;
			}
			
			return ((r[1].length === 0) ? r[0] : null);
		},
		nativeFallback: function(s) {
			var t;
			try {
				// ok we haven't parsed it, last ditch attempt with the built-in parser.
				t = Date._parse(s);
				return (t || t === 0) ? new Date(t) : null;
			} catch (e) {
				return null;
			}
		}
	};
	function parse (s) {
		var d;
		if (!s) {
			return null;
		}
		if (s instanceof Date) {
			return s.clone();
		}
		if (s.length >= 4 && s.charAt(0) !== "0" && s.charAt(0) !== "+"&& s.charAt(0) !== "-") { // ie: 2004 will pass, 0800 won't.
			//  Start with specific formats
			d = $D.Parsing.ISO.parse(s) || $D.Parsing.Numeric.parse(s);
		}
		if (d instanceof Date && !isNaN(d.getTime())) {
			return d;
		} else {
			// find ordinal dates (1st, 3rd, 8th, etc and remove them as they cause parsing issues)
			s = $D.Parsing.Normalizer.parse(parseUtils.removeOrds(s));
			d = parseUtils.grammarParser(s);
			if (d !== null) {
				return d;
			} else {
				return parseUtils.nativeFallback(s);
			}
		}
	}

	if (!$D._parse) {
		$D._parse = $D.parse;
	}
	$D.parse = parse;

	Date.getParseFunction = function (fx) {
		var fns = Date.Grammar.allformats(fx);
		return function (s) {
			var r = null;
			for (var i = 0; i < fns.length; i++) {
				try {
					r = fns[i].call({}, s);
				} catch (e) {
					continue;
				}
				if (r[1].length === 0) {
					return r[0];
				}
			}
			return null;
		};
	};
	
	/**
	 * Converts the specified string value into its JavaScript Date equivalent using the specified format {String} or formats {Array} and the CultureInfo specific format information.
	 * The format of the string value must match one of the supplied formats exactly.
	 * 
	 * Example
	<pre><code>
	// 15-Oct-2004
	var d1 = Date.parseExact("10/15/2004", "M/d/yyyy");

	// 15-Oct-2004
	var d1 = Date.parse("15-Oct-2004", "M-ddd-yyyy");

	// 15-Oct-2004
	var d1 = Date.parse("2004.10.15", "yyyy.MM.dd");

	// Multiple formats
	var d1 = Date.parseExact("10/15/2004", ["M/d/yyyy", "MMMM d, yyyy"]);
	</code></pre>
	 *
	 * @param {String}   The string value to convert into a Date object [Required].
	 * @param {Object}   The expected format {String} or an array of expected formats {Array} of the date string [Required].
	 * @return {Date}    A Date object or null if the string cannot be converted into a Date.
	 */
	$D.parseExact = function (s, fx) {
		return $D.getParseFunction(fx)(s);
	};
}());

},{}],20:[function(require,module,exports){
(function () {
	var $D = Date;
	$D.Grammar = {};
	var _ = $D.Parsing.Operators, g = $D.Grammar, t = $D.Translator, _fn;
	// Allow rolling up into general purpose rules
	_fn = function () {
		return _.each(_.any.apply(null, arguments), _.not(g.ctoken2("timeContext")));
	};
	
	g.datePartDelimiter = _.rtoken(/^([\s\-\.\,\/\x27]+)/);
	g.timePartDelimiter = _.stoken(":");
	g.whiteSpace = _.rtoken(/^\s*/);
	g.generalDelimiter = _.rtoken(/^(([\s\,]|at|@|on)+)/);
  
	var _C = {};
	g.ctoken = function (keys) {
		var fn = _C[keys];
		if (! fn) {
			var c = Date.CultureInfo.regexPatterns;
			var kx = keys.split(/\s+/), px = [];
			for (var i = 0; i < kx.length ; i++) {
				px.push(_.replace(_.rtoken(c[kx[i]]), kx[i]));
			}
			fn = _C[keys] = _.any.apply(null, px);
		}
		return fn;
	};
	g.ctoken2 = function (key) {
		return _.rtoken(Date.CultureInfo.regexPatterns[key]);
	};
	var cacheProcessRtoken = function (key, token, type, eachToken) {
		if (eachToken) {
			g[key] = _.cache(_.process(_.each(_.rtoken(token),_.optional(g.ctoken2(eachToken))), type));
		} else {
			g[key] = _.cache(_.process(_.rtoken(token), type));
		}
	};
	var cacheProcessCtoken = function (token, type) {
		return _.cache(_.process(g.ctoken2(token), type));
	};
	var _F = {}; //function cache

	var _get = function (f) {
		_F[f] = (_F[f] || g.format(f)[0]);
		return _F[f];
	};

	g.allformats = function (fx) {
		var rx = [];
		if (fx instanceof Array) {
			for (var i = 0; i < fx.length; i++) {
				rx.push(_get(fx[i]));
			}
		} else {
			rx.push(_get(fx));
		}
		return rx;
	};
  
	g.formats = function (fx) {
		if (fx instanceof Array) {
			var rx = [];
			for (var i = 0 ; i < fx.length ; i++) {
				rx.push(_get(fx[i]));
			}
			return _.any.apply(null, rx);
		} else {
			return _get(fx);
		}
	};

	var grammarFormats = {
		 timeFormats: function(){
			var i,
			RTokenKeys = [
				"h",
				"hh",
				"H",
				"HH",
				"m",
				"mm",
				"s",
				"ss",
				"ss.s",
				"z",
				"zz"
			],
			RToken = [
				/^(0[0-9]|1[0-2]|[1-9])/,
				/^(0[0-9]|1[0-2])/,
				/^([0-1][0-9]|2[0-3]|[0-9])/,
				/^([0-1][0-9]|2[0-3])/,
				/^([0-5][0-9]|[0-9])/,
				/^[0-5][0-9]/,
				/^([0-5][0-9]|[0-9])/,
				/^[0-5][0-9]/,
				/^[0-5][0-9]\.[0-9]{1,3}/,
				/^((\+|\-)\s*\d\d\d\d)|((\+|\-)\d\d\:?\d\d)/,
				/^((\+|\-)\s*\d\d\d\d)|((\+|\-)\d\d\:?\d\d)/
			],
			tokens = [
				t.hour,
				t.hour,
				t.hour,
				t.minute,
				t.minute,
				t.second,
				t.second,
				t.secondAndMillisecond,
				t.timezone,
				t.timezone,
				t.timezone
			];

			for (i=0; i < RTokenKeys.length; i++) {
				cacheProcessRtoken(RTokenKeys[i], RToken[i], tokens[i]);
			}

			g.hms = _.cache(_.sequence([g.H, g.m, g.s], g.timePartDelimiter));

			g.t = cacheProcessCtoken("shortMeridian", t.meridian);
			g.tt = cacheProcessCtoken("longMeridian", t.meridian);
			g.zzz = cacheProcessCtoken("timezone", t.timezone);

			g.timeSuffix = _.each(_.ignore(g.whiteSpace), _.set([ g.tt, g.zzz ]));
			g.time = _.each(_.optional(_.ignore(_.stoken("T"))), g.hms, g.timeSuffix);
		 },
		 dateFormats: function () {
			// pre-loaded rules for different date part order preferences
			var _setfn = function () {
				return  _.set(arguments, g.datePartDelimiter);
			};
			var i,
			RTokenKeys = [
				"d",
				"dd",
				"M",
				"MM",
				"y",
				"yy",
				"yyy",
				"yyyy"
			],
			RToken = [
				/^([0-2]\d|3[0-1]|\d)/,
				/^([0-2]\d|3[0-1])/,
				/^(1[0-2]|0\d|\d)/,
				/^(1[0-2]|0\d)/,
				/^(\d+)/,
				/^(\d\d)/,
				/^(\d\d?\d?\d?)/,
				/^(\d\d\d\d)/
			],
			tokens = [
				t.day,
				t.day,
				t.month,
				t.month,
				t.year,
				t.year,
				t.year,
				t.year
			],
			eachToken = [
				"ordinalSuffix",
				"ordinalSuffix"
			];
			for (i=0; i < RTokenKeys.length; i++) {
				cacheProcessRtoken(RTokenKeys[i], RToken[i], tokens[i], eachToken[i]);
			}

			g.MMM = g.MMMM = _.cache(_.process(g.ctoken("jan feb mar apr may jun jul aug sep oct nov dec"), t.month));
			g.ddd = g.dddd = _.cache(_.process(g.ctoken("sun mon tue wed thu fri sat"),
				function (s) {
					return function () {
						this.weekday = s;
					};
				}
			));

			g.day = _fn(g.d, g.dd);
			g.month = _fn(g.M, g.MMM);
			g.year = _fn(g.yyyy, g.yy);

			g.mdy = _setfn(g.ddd, g.month, g.day, g.year);
			g.ymd = _setfn(g.ddd, g.year, g.month, g.day);
			g.dmy = _setfn(g.ddd, g.day, g.month, g.year);
						
			g.date = function (s) {
				return ((g[Date.CultureInfo.dateElementOrder] || g.mdy).call(this, s));
			};
		 },
		 relative: function () {
			// relative date / time expressions
			g.orientation = _.process(g.ctoken("past future"),
				function (s) {
					return function () {
						this.orient = s;
					};
				}
			);

			g.operator = _.process(g.ctoken("add subtract"),
				function (s) {
					return function () {
						this.operator = s;
					};
				}
			);
			g.rday = _.process(g.ctoken("yesterday tomorrow today now"), t.rday);
			g.unit = _.process(g.ctoken("second minute hour day week month year"),
				function (s) {
					return function () {
						this.unit = s;
					};
				}
			);
		 }
	};

	g.buildGrammarFormats = function () {
		// these need to be rebuilt every time the language changes.
		_C = {};

		grammarFormats.timeFormats();
		grammarFormats.dateFormats();
		grammarFormats.relative();

		
		g.value = _.process(_.rtoken(/^([-+]?\d+)?(st|nd|rd|th)?/),
			function (s) {
				return function () {
					this.value = s.replace(/\D/g, "");
				};
			}
		);
		g.expression = _.set([g.rday, g.operator, g.value, g.unit, g.orientation, g.ddd, g.MMM ]);

		g.format = _.process(_.many(
			_.any(
				// translate format specifiers into grammar rules
				_.process(
					_.rtoken(/^(dd?d?d?(?!e)|MM?M?M?|yy?y?y?|hh?|HH?|mm?|ss?|tt?|zz?z?)/),
						function (fmt) {
							if (g[fmt]) {
								return g[fmt];
							} else {
								throw $D.Parsing.Exception(fmt);
							}
						}
					),
					// translate separator tokens into token rules
					_.process(_.rtoken(/^[^dMyhHmstz]+/), // all legal separators 
						function (s) {
							return _.ignore(_.stoken(s));
						}
					)
				)
			),
			// construct the parser ...
			function (rules) {
				return _.process(_.each.apply(null, rules), t.finishExact);
			}
		);

		// starting rule for general purpose grammar
		g._start = _.process(_.set([ g.date, g.time, g.expression ],
		g.generalDelimiter, g.whiteSpace), t.finish);
	};

	g.buildGrammarFormats();
	// parsing date format specifiers - ex: "h:m:s tt" 
	// this little guy will generate a custom parser based
	// on the format string, ex: g.format("h:m:s tt")
	// check for these formats first
	g._formats = g.formats([
		"\"yyyy-MM-ddTHH:mm:ssZ\"",
		"yyyy-MM-ddTHH:mm:ss.sz",
		"yyyy-MM-ddTHH:mm:ssZ",
		"yyyy-MM-ddTHH:mm:ssz",
		"yyyy-MM-ddTHH:mm:ss",
		"yyyy-MM-ddTHH:mmZ",
		"yyyy-MM-ddTHH:mmz",
		"yyyy-MM-ddTHH:mm",
		"ddd, MMM dd, yyyy H:mm:ss tt",
		"ddd MMM d yyyy HH:mm:ss zzz",
		"MMddyyyy",
		"ddMMyyyy",
		"Mddyyyy",
		"ddMyyyy",
		"Mdyyyy",
		"dMyyyy",
		"yyyy",
		"Mdyy",
		"dMyy",
		"d"
	]);
	
	// real starting rule: tries selected formats first, 
	// then general purpose rule
	g.start = function (s) {
		try {
			var r = g._formats.call({}, s);
			if (r[1].length === 0) {
				return r;
			}
		} catch (e) {}
		return g._start.call({}, s);
	};
}());
},{}],21:[function(require,module,exports){
(function () {
	var $P = Date.Parsing;
	var _ = $P.Operators = {
		//
		// Tokenizers
		//
		rtoken: function (r) { // regex token
			return function (s) {
				var mx = s.match(r);
				if (mx) {
					return ([ mx[0], s.substring(mx[0].length) ]);
				} else {
					throw new $P.Exception(s);
				}
			};
		},
		token: function () { // whitespace-eating token
			return function (s) {
				return _.rtoken(new RegExp("^\\s*" + s + "\\s*"))(s);
			};
		},
		stoken: function (s) { // string token
			return _.rtoken(new RegExp("^" + s));
		},

		// Atomic Operators

		until: function (p) {
			return function (s) {
				var qx = [], rx = null;
				while (s.length) {
					try {
						rx = p.call(this, s);
					} catch (e) {
						qx.push(rx[0]);
						s = rx[1];
						continue;
					}
					break;
				}
				return [ qx, s ];
			};
		},
		many: function (p) {
			return function (s) {
				var rx = [], r = null;
				while (s.length) {
					try {
						r = p.call(this, s);
					} catch (e) {
						return [ rx, s ];
					}
					rx.push(r[0]);
					s = r[1];
				}
				return [ rx, s ];
			};
		},

		// generator operators -- see below
		optional: function (p) {
			return function (s) {
				var r = null;
				try {
					r = p.call(this, s);
				} catch (e) {
					return [ null, s ];
				}
				return [ r[0], r[1] ];
			};
		},
		not: function (p) {
			return function (s) {
				try {
					p.call(this, s);
				} catch (e) {
					return [null, s];
				}
				throw new $P.Exception(s);
			};
		},
		ignore: function (p) {
			return p ?
			function (s) {
				var r = null;
				r = p.call(this, s);
				return [null, r[1]];
			} : null;
		},
		product: function () {
			var px = arguments[0],
			qx = Array.prototype.slice.call(arguments, 1), rx = [];
			for (var i = 0 ; i < px.length ; i++) {
				rx.push(_.each(px[i], qx));
			}
			return rx;
		},
		cache: function (rule) {
			var cache = {}, cache_length = 0, cache_keys = [], CACHE_MAX = Date.Config.CACHE_MAX || 100000, r = null;
			var cacheCheck = function () {
				if (cache_length === CACHE_MAX) {
					// kill several keys, don't want to have to do this all the time...
					for (var i=0; i < 10; i++) {
						var key = cache_keys.shift();
						if (key) {
							delete cache[key];
							cache_length--;
						}
					}
				}
			};
			return function (s) {
				cacheCheck();
				try {
					r = cache[s] = (cache[s] || rule.call(this, s));
				} catch (e) {
					r = cache[s] = e;
				}
				cache_length++;
				cache_keys.push(s);
				if (r instanceof $P.Exception) {
					throw r;
				} else {
					return r;
				}
			};
		},

		// vector operators -- see below
		any: function () {
			var px = arguments;
			return function (s) {
				var r = null;
				for (var i = 0; i < px.length; i++) {
					if (px[i] == null) {
						continue;
					}
					try {
						r = (px[i].call(this, s));
					} catch (e) {
						r = null;
					}
					if (r) {
						return r;
					}
				}
				throw new $P.Exception(s);
			};
		},
		each: function () {
			var px = arguments;
			return function (s) {
				var rx = [], r = null;
				for (var i = 0; i < px.length ; i++) {
					if (px[i] == null) {
						continue;
					}
					try {
						r = (px[i].call(this, s));
					} catch (e) {
						throw new $P.Exception(s);
					}
					rx.push(r[0]);
					s = r[1];
				}
				return [ rx, s];
			};
		},
		all: function () {
			var px = arguments, _ = _;
			return _.each(_.optional(px));
		},

		// delimited operators
		sequence: function (px, d, c) {
			d = d || _.rtoken(/^\s*/);
			c = c || null;
			
			if (px.length === 1) {
				return px[0];
			}
			return function (s) {
				var r = null, q = null;
				var rx = [];
				for (var i = 0; i < px.length ; i++) {
					try {
						r = px[i].call(this, s);
					} catch (e) {
						break;
					}
					rx.push(r[0]);
					try {
						q = d.call(this, r[1]);
					} catch (ex) {
						q = null;
						break;
					}
					s = q[1];
				}
				if (!r) {
					throw new $P.Exception(s);
				}
				if (q) {
					throw new $P.Exception(q[1]);
				}
				if (c) {
					try {
						r = c.call(this, r[1]);
					} catch (ey) {
						throw new $P.Exception(r[1]);
					}
				}
				return [ rx, (r?r[1]:s) ];
			};
		},

		//
		// Composite Operators
		//

		between: function (d1, p, d2) {
			d2 = d2 || d1;
			var _fn = _.each(_.ignore(d1), p, _.ignore(d2));
			return function (s) {
				var rx = _fn.call(this, s);
				return [[rx[0][0], r[0][2]], rx[1]];
			};
		},
		list: function (p, d, c) {
			d = d || _.rtoken(/^\s*/);
			c = c || null;
			return (p instanceof Array ?
				_.each(_.product(p.slice(0, -1), _.ignore(d)), p.slice(-1), _.ignore(c)) :
				_.each(_.many(_.each(p, _.ignore(d))), px, _.ignore(c)));
		},
		set: function (px, d, c) {
			d = d || _.rtoken(/^\s*/);
			c = c || null;
			return function (s) {
				// r is the current match, best the current 'best' match
				// which means it parsed the most amount of input
				var r = null, p = null, q = null, rx = null, best = [[], s], last = false;
				// go through the rules in the given set
				for (var i = 0; i < px.length ; i++) {

					// last is a flag indicating whether this must be the last element
					// if there is only 1 element, then it MUST be the last one
					q = null;
					p = null;
					r = null;
					last = (px.length === 1);
					// first, we try simply to match the current pattern
					// if not, try the next pattern
					try {
						r = px[i].call(this, s);
					} catch (e) {
						continue;
					}
					// since we are matching against a set of elements, the first
					// thing to do is to add r[0] to matched elements
					rx = [[r[0]], r[1]];
					// if we matched and there is still input to parse and 
					// we don't already know this is the last element,
					// we're going to next check for the delimiter ...
					// if there's none, or if there's no input left to parse
					// than this must be the last element after all ...
					if (r[1].length > 0 && ! last) {
						try {
							q = d.call(this, r[1]);
						} catch (ex) {
							last = true;
						}
					} else {
						last = true;
					}

					// if we parsed the delimiter and now there's no more input,
					// that means we shouldn't have parsed the delimiter at all
					// so don't update r and mark this as the last element ...
					if (!last && q[1].length === 0) {
						last = true;
					}


					// so, if this isn't the last element, we're going to see if
					// we can get any more matches from the remaining (unmatched)
					// elements ...
					if (!last) {
						// build a list of the remaining rules we can match against,
						// i.e., all but the one we just matched against
						var qx = [];
						for (var j = 0; j < px.length ; j++) {
							if (i !== j) {
								qx.push(px[j]);
							}
						}

						// now invoke recursively set with the remaining input
						// note that we don't include the closing delimiter ...
						// we'll check for that ourselves at the end
						p = _.set(qx, d).call(this, q[1]);

						// if we got a non-empty set as a result ...
						// (otw rx already contains everything we want to match)
						if (p[0].length > 0) {
							// update current result, which is stored in rx ...
							// basically, pick up the remaining text from p[1]
							// and concat the result from p[0] so that we don't
							// get endless nesting ...
							rx[0] = rx[0].concat(p[0]);
							rx[1] = p[1];
						}
					}

					// at this point, rx either contains the last matched element
					// or the entire matched set that starts with this element.

					// now we just check to see if this variation is better than
					// our best so far, in terms of how much of the input is parsed
					if (rx[1].length < best[1].length) {
						best = rx;
					}

					// if we've parsed all the input, then we're finished
					if (best[1].length === 0) {
						break;
					}
				}

				// so now we've either gone through all the patterns trying them
				// as the initial match; or we found one that parsed the entire
				// input string ...

				// if best has no matches, just return empty set ...
				if (best[0].length === 0) {
					return best;
				}

				// if a closing delimiter is provided, then we have to check it also
				if (c) {
					// we try this even if there is no remaining input because the pattern
					// may well be optional or match empty input ...
					try {
						q = c.call(this, best[1]);
					} catch (ey) {
						throw new $P.Exception(best[1]);
					}

					// it parsed ... be sure to update the best match remaining input
					best[1] = q[1];
				}
				// if we're here, either there was no closing delimiter or we parsed it
				// so now we have the best match; just return it!
				return best;
			};
		},
		forward: function (gr, fname) {
			return function (s) {
				return gr[fname].call(this, s);
			};
		},

		//
		// Translation Operators
		//
		replace: function (rule, repl) {
			return function (s) {
				var r = rule.call(this, s);
				return [repl, r[1]];
			};
		},
		process: function (rule, fn) {
			return function (s) {
				var r = rule.call(this, s);
				return [fn.call(this, r[0]), r[1]];
			};
		},
		min: function (min, rule) {
			return function (s) {
				var rx = rule.call(this, s);
				if (rx[0].length < min) {
					throw new $P.Exception(s);
				}
				return rx;
			};
		}
	};
	

	// Generator Operators And Vector Operators

	// Generators are operators that have a signature of F(R) => R,
	// taking a given rule and returning another rule, such as 
	// ignore, which parses a given rule and throws away the result.

	// Vector operators are those that have a signature of F(R1,R2,...) => R,
	// take a list of rules and returning a new rule, such as each.

	// Generator operators are converted (via the following _generator
	// function) into functions that can also take a list or array of rules
	// and return an array of new rules as though the function had been
	// called on each rule in turn (which is what actually happens).

	// This allows generators to be used with vector operators more easily.
	// Example:
	// each(ignore(foo, bar)) instead of each(ignore(foo), ignore(bar))

	// This also turns generators into vector operators, which allows
	// constructs like:
	// not(cache(foo, bar))
	
	var _generator = function (op) {
		function gen() {
			var args = null, rx = [], px, i;
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			} else if (arguments[0] instanceof Array) {
				args = arguments[0];
			}
			if (args) {
				px = args.shift();
				if (px.length > 0) {
					args.unshift(px[i]);
					rx.push(op.apply(null, args));
					args.shift();
					return rx;
				}
			} else {
				return op.apply(null, arguments);
			}
		}

		return gen;
	};
	
	var gx = "optional not ignore cache".split(/\s/);
	
	for (var i = 0 ; i < gx.length ; i++) {
		_[gx[i]] = _generator(_[gx[i]]);
	}

	var _vector = function (op) {
		return function () {
			if (arguments[0] instanceof Array) {
				return op.apply(null, arguments[0]);
			} else {
				return op.apply(null, arguments);
			}
		};
	};
	
	var vx = "each any all".split(/\s/);
	
	for (var j = 0 ; j < vx.length ; j++) {
		_[vx[j]] = _vector(_[vx[j]]);
	}
	
}());
},{}],22:[function(require,module,exports){
(function () {
	var $D = Date;

	var flattenAndCompact = function (ax) {
		var rx = [];
		for (var i = 0; i < ax.length; i++) {
			if (ax[i] instanceof Array) {
				rx = rx.concat(flattenAndCompact(ax[i]));
			} else {
				if (ax[i]) {
					rx.push(ax[i]);
				}
			}
		}
		return rx;
	};

	var parseMeridian = function () {
		if (this.meridian && (this.hour || this.hour === 0)) {
			if (this.meridian === "a" && this.hour > 11 && Date.Config.strict24hr){
				throw "Invalid hour and meridian combination";
			} else if (this.meridian === "p" && this.hour < 12 && Date.Config.strict24hr){
				throw "Invalid hour and meridian combination";
			} else if (this.meridian === "p" && this.hour < 12) {
				this.hour = this.hour + 12;
			} else if (this.meridian === "a" && this.hour === 12) {
				this.hour = 0;
			}
		}
	};

	var setDefaults = function () {
		var now = new Date();
		if ((this.hour || this.minute) && (!this.month && !this.year && !this.day)) {
			this.day = now.getDate();
		}

		if (!this.year) {
			this.year = now.getFullYear();
		}
		
		if (!this.month && this.month !== 0) {
			this.month = now.getMonth();
		}
		
		if (!this.day) {
			this.day = 1;
		}
		
		if (!this.hour) {
			this.hour = 0;
		}
		
		if (!this.minute) {
			this.minute = 0;
		}

		if (!this.second) {
			this.second = 0;
		}
		if (!this.millisecond) {
			this.millisecond = 0;
		}
	};

	var finishUtils = {
		getToday: function () {
			 if (this.now || "hour minute second".indexOf(this.unit) !== -1) {
				return new Date();
			} else {
				return $D.today();
			}
		},
		setDaysFromWeekday: function (today, orient){
			var gap;
			orient = orient || 1;
			this.unit = "day";
			gap = ($D.getDayNumberFromName(this.weekday) - today.getDay());
			this.days = gap ? ((gap + (orient * 7)) % 7) : (orient * 7);
			return this;
		},
		setMonthsFromMonth: function (today, orient) {
			var gap;
			orient = orient || 1;
			this.unit = "month";
			gap = (this.month - today.getMonth());
			this.months = gap ? ((gap + (orient * 12)) % 12) : (orient * 12);
			this.month = null;
			return this;
		},
		setDMYFromWeekday: function () {
			var d = Date[this.weekday]();
			this.day = d.getDate();
			if (!this.month) {
				this.month = d.getMonth();
			}
			this.year = d.getFullYear();
			return this;
		},
		setUnitValue: function (orient) {
			if (!this.value && this.operator && this.operator !== null && this[this.unit + "s"] && this[this.unit + "s"] !== null) {
				this[this.unit + "s"] = this[this.unit + "s"] + ((this.operator === "add") ? 1 : -1) + (this.value||0) * orient;
			} else if (this[this.unit + "s"] == null || this.operator != null) {
				if (!this.value) {
					this.value = 1;
				}
				this[this.unit + "s"] = this.value * orient;
			}
		},
		generateDateFromWeeks: function () {
			var weekday = (this.weekday !== undefined) ? this.weekday : "today";
			var d = Date[weekday]().addWeeks(this.weeks);
			if (this.now) {
				d.setTimeToNow();
			}
			return d;
		}
	};

	$D.Translator = {
		hour: function (s) {
			return function () {
				this.hour = Number(s);
			};
		},
		minute: function (s) {
			return function () {
				this.minute = Number(s);
			};
		},
		second: function (s) {
			return function () {
				this.second = Number(s);
			};
		},
		/* for ss.s format */
		secondAndMillisecond: function (s) {
			return function () {
				var mx = s.match(/^([0-5][0-9])\.([0-9]{1,3})/);
				this.second = Number(mx[1]);
				this.millisecond = Number(mx[2]);
			};
		},
		meridian: function (s) {
			return function () {
				this.meridian = s.slice(0, 1).toLowerCase();
			};
		},
		timezone: function (s) {
			return function () {
				var n = s.replace(/[^\d\+\-]/g, "");
				if (n.length) {
					this.timezoneOffset = Number(n);
				} else {
					this.timezone = s.toLowerCase();
				}
			};
		},
		day: function (x) {
			var s = x[0];
			return function () {
				this.day = Number(s.match(/\d+/)[0]);
				if (this.day < 1) {
					throw "invalid day";
				}
			};
		},
		month: function (s) {
			return function () {
				this.month = (s.length === 3) ? "jan feb mar apr may jun jul aug sep oct nov dec".indexOf(s)/4 : Number(s) - 1;
				if (this.month < 0) {
					throw "invalid month";
				}
			};
		},
		year: function (s) {
			return function () {
				var n = Number(s);
				this.year = ((s.length > 2) ? n :
					(n + (((n + 2000) < Date.CultureInfo.twoDigitYearMax) ? 2000 : 1900)));
			};
		},
		rday: function (s) {
			return function () {
				switch (s) {
					case "yesterday":
						this.days = -1;
						break;
					case "tomorrow":
						this.days = 1;
						break;
					case "today":
						this.days = 0;
						break;
					case "now":
						this.days = 0;
						this.now = true;
						break;
				}
			};
		},
		finishExact: function (x) {
			var d;
			x = (x instanceof Array) ? x : [x];

			for (var i = 0 ; i < x.length ; i++) {
				if (x[i]) {
					x[i].call(this);
				}
			}
			
			setDefaults.call(this);
			parseMeridian.call(this);

			if (this.day > $D.getDaysInMonth(this.year, this.month)) {
				throw new RangeError(this.day + " is not a valid value for days.");
			}

			d = new Date(this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
			if (this.year < 100) {
				d.setFullYear(this.year); // means years less that 100 are process correctly. JS will parse it otherwise as 1900-1999.
			}
			if (this.timezone) {
				d.set({ timezone: this.timezone });
			} else if (this.timezoneOffset) {
				d.set({ timezoneOffset: this.timezoneOffset });
			}
			
			return d;
		},
		finish: function (x) {
			var today, expression, orient, temp;

			x = (x instanceof Array) ? flattenAndCompact(x) : [ x ];

			if (x.length === 0) {
				return null;
			}

			for (var i = 0 ; i < x.length ; i++) {
				if (typeof x[i] === "function") {
					x[i].call(this);
				}
			}
			if (this.now && !this.unit && !this.operator) {
				return new Date();
			} else {
				today = finishUtils.getToday.call(this);
			}
			
			expression = !!(this.days && this.days !== null || this.orient || this.operator);
			orient = ((this.orient === "past" || this.operator === "subtract") ? -1 : 1);

			if (this.month && this.unit === "week") {
				this.value = this.month + 1;
				delete this.month;
				delete this.day;
			}

			if ((this.month || this.month === 0) && "year day hour minute second".indexOf(this.unit) !== -1) {
				if (!this.value) {
					this.value = this.month + 1;
				}
				this.month = null;
				expression = true;
			}

			if (!expression && this.weekday && !this.day && !this.days) {
				finishUtils.setDMYFromWeekday.call(this);
			}

			if (expression && this.weekday && this.unit !== "month" && this.unit !== "week") {
				finishUtils.setDaysFromWeekday.call(this, today, orient);
			}

			if (this.weekday && this.unit !== "week" && !this.day && !this.days) {
				temp = Date[this.weekday]();
				this.day = temp.getDate();
				if (temp.getMonth() !== today.getMonth()) {
					this.month = temp.getMonth();
				}
			}

			if (this.month && this.unit === "day" && this.operator) {
				if (!this.value) {
					this.value = (this.month + 1);
				}
				this.month = null;
			}

			if (this.value != null && this.month != null && this.year != null) {
				this.day = this.value * 1;
			}

			if (this.month && !this.day && this.value) {
				today.set({ day: this.value * 1 });
				if (!expression) {
					this.day = this.value * 1;
				}
			}

			if (!this.month && this.value && this.unit === "month" && !this.now) {
				this.month = this.value;
				expression = true;
			}

			if (expression && (this.month || this.month === 0) && this.unit !== "year") {
				finishUtils.setMonthsFromMonth.call(this, today, orient);
			}

			if (!this.unit) {
				this.unit = "day";
			}

			finishUtils.setUnitValue.call(this, orient);
			parseMeridian.call(this);
			
			if ((this.month || this.month === 0) && !this.day) {
				this.day = 1;
			}

			if (!this.orient && !this.operator && this.unit === "week" && this.value && !this.day && !this.month) {
				return Date.today().setWeek(this.value);
			}

			if (this.unit === "week" && this.weeks && !this.day && !this.month) {
				return finishUtils.generateDateFromWeeks.call(this);
			}

			if (expression && this.timezone && this.day && this.days) {
				this.day = this.days;
			}

			if (expression){
				today.add(this);
			} else {
				today.set(this);
			}
			
			if (this.timezone) {
				this.timezone = this.timezone.toUpperCase();
				var offset = $D.getTimezoneOffset(this.timezone);
				var timezone;
				if (today.hasDaylightSavingTime()) {
					// lets check that we're being sane with timezone setting
					timezone = $D.getTimezoneAbbreviation(offset, today.isDaylightSavingTime());
					if (timezone !== this.timezone) {
						// bugger, we're in a place where things like EST vs EDT matters.
						if (today.isDaylightSavingTime()) {
							today.addHours(-1);
						} else {
							today.addHours(1);
						}
					}
				}
				today.setTimezoneOffset(offset);
			}

			return today;
		}
	};
}());
},{}],23:[function(require,module,exports){
/*************************************************************
 * SugarPak - Domain Specific Language -  Syntactical Sugar  *
 *************************************************************/
 
(function () {
	var $D = Date, $P = $D.prototype, $N = Number.prototype;

	// private
	$P._orient = +1;

	// private
	$P._nth = null;

	// private
	$P._is = false;

	// private
	$P._same = false;
	
	// private
	$P._isSecond = false;

	// private
	$N._dateElement = "days";

	/** 
	 * Moves the date to the next instance of a date as specified by the subsequent date element function (eg. .day(), .month()), month name function (eg. .january(), .jan()) or day name function (eg. .friday(), fri()).
	 * Example
	<pre><code>
	Date.today().next().friday();
	Date.today().next().fri();
	Date.today().next().march();
	Date.today().next().mar();
	Date.today().next().week();
	</code></pre>
	 * 
	 * @return {Date}    date
	 */
	$P.next = function () {
		this._move = true;
		this._orient = +1;
		return this;
	};

	/** 
	 * Creates a new Date (Date.today()) and moves the date to the next instance of the date as specified by the subsequent date element function (eg. .day(), .month()), month name function (eg. .january(), .jan()) or day name function (eg. .friday(), fri()).
	 * Example
	<pre><code>
	Date.next().friday();
	Date.next().fri();
	Date.next().march();
	Date.next().mar();
	Date.next().week();
	</code></pre>
	 * 
	 * @return {Date}    date
	 */
	$D.next = function () {
		return $D.today().next();
	};

	/** 
	 * Moves the date to the previous instance of a date as specified by the subsequent date element function (eg. .day(), .month()), month name function (eg. .january(), .jan()) or day name function (eg. .friday(), fri()).
	 * Example
	<pre><code>
	Date.today().last().friday();
	Date.today().last().fri();
	Date.today().last().march();
	Date.today().last().mar();
	Date.today().last().week();
	</code></pre>
	 *  
	 * @return {Date}    date
	 */
	$P.last = $P.prev = $P.previous = function () {
		this._move = true;
		this._orient = -1;
		return this;
	};

	/** 
	 * Creates a new Date (Date.today()) and moves the date to the previous instance of the date as specified by the subsequent date element function (eg. .day(), .month()), month name function (eg. .january(), .jan()) or day name function (eg. .friday(), fri()).
	 * Example
	<pre><code>
	Date.last().friday();
	Date.last().fri();
	Date.previous().march();
	Date.prev().mar();
	Date.last().week();
	</code></pre>
	 *  
	 * @return {Date}    date
	 */
	$D.last = $D.prev = $D.previous = function () {
		return $D.today().last();
	};

	/** 
	 * Performs a equality check when followed by either a month name, day name or .weekday() function.
	 * Example
	<pre><code>
	Date.today().is().friday(); // true|false
	Date.today().is().fri();
	Date.today().is().march();
	Date.today().is().mar();
	</code></pre>
	 *  
	 * @return {Boolean}    true|false
	 */
	$P.is = function () {
		this._is = true;
		return this;
	};

	/** 
	 * Determines if two date objects occur on/in exactly the same instance of the subsequent date part function.
	 * The function .same() must be followed by a date part function (example: .day(), .month(), .year(), etc).
	 *
	 * An optional Date can be passed in the date part function. If now date is passed as a parameter, 'Now' is used. 
	 *
	 * The following example demonstrates how to determine if two dates fall on the exact same day.
	 *
	 * Example
	<pre><code>
	var d1 = Date.today(); // today at 00:00
	var d2 = new Date();   // exactly now.

	// Do they occur on the same day?
	d1.same().day(d2); // true
	
	// Do they occur on the same hour?
	d1.same().hour(d2); // false, unless d2 hour is '00' (midnight).
	
	// What if it's the same day, but one year apart?
	var nextYear = Date.today().add(1).year();

	d1.same().day(nextYear); // false, because the dates must occur on the exact same day. 
	</code></pre>
	 *
	 * Scenario: Determine if a given date occurs during some week period 2 months from now. 
	 *
	 * Example
	<pre><code>
	var future = Date.today().add(2).months();
	return someDate.same().week(future); // true|false;
	</code></pre>
	 *  
	 * @return {Boolean}    true|false
	 */
	$P.same = function () {
		this._same = true;
		this._isSecond = false;
		return this;
	};

	/** 
	 * Determines if the current date/time occurs during Today. Must be preceded by the .is() function.
	 * Example
	<pre><code>
	someDate.is().today();    // true|false
	new Date().is().today();  // true
	Date.today().is().today();// true
	Date.today().add(-1).day().is().today(); // false
	</code></pre>
	 *  
	 * @return {Boolean}    true|false
	 */
	$P.today = function () {
		return this.same().day();
	};

	/** 
	 * Determines if the current date is a weekday. This function must be preceded by the .is() function.
	 * Example
	<pre><code>
	Date.today().is().weekday(); // true|false
	</code></pre>
	 *  
	 * @return {Boolean}    true|false
	 */
	$P.weekday = function () {
		if (this._nth) {
			return df("Weekday").call(this);
		}
		if (this._move) {
			return this.addWeekdays(this._orient);
		}
		if (this._is) {
			this._is = false;
			return (!this.is().sat() && !this.is().sun());
		}
		return false;
	};
	/** 
	 * Determines if the current date is on the weekend. This function must be preceded by the .is() function.
	 * Example
	<pre><code>
	Date.today().is().weekend(); // true|false
	</code></pre>
	 *  
	 * @return {Boolean}    true|false
	 */
	$P.weekend = function () {
		if (this._is) {
			this._is = false;
			return (this.is().sat() || this.is().sun());
		}
		return false;
	};

	/** 
	 * Sets the Time of the current Date instance. A string "6:15 pm" or config object {hour:18, minute:15} are accepted.
	 * Example
	<pre><code>
	// Set time to 6:15pm with a String
	Date.today().at("6:15pm");

	// Set time to 6:15pm with a config object
	Date.today().at({hour:18, minute:15});
	</code></pre>
	 *  
	 * @return {Date}    date
	 */
	$P.at = function (time) {
		return (typeof time === "string") ? $D.parse(this.toString("d") + " " + time) : this.set(time);
	};
		
	/** 
	 * Creates a new Date() and adds this (Number) to the date based on the preceding date element function (eg. second|minute|hour|day|month|year).
	 * Example
	<pre><code>
	// Undeclared Numbers must be wrapped with parentheses. Requirment of JavaScript.
	(3).days().fromNow();
	(6).months().fromNow();

	// Declared Number variables do not require parentheses. 
	var n = 6;
	n.months().fromNow();
	</code></pre>
	 *  
	 * @return {Date}    A new Date instance
	 */
	$N.fromNow = $N.after = function (date) {
		var c = {};
		c[this._dateElement] = this;
		return ((!date) ? new Date() : date.clone()).add(c);
	};

	/** 
	 * Creates a new Date() and subtract this (Number) from the date based on the preceding date element function (eg. second|minute|hour|day|month|year).
	 * Example
	<pre><code>
	// Undeclared Numbers must be wrapped with parentheses. Requirment of JavaScript.
	(3).days().ago();
	(6).months().ago();

	// Declared Number variables do not require parentheses. 
	var n = 6;
	n.months().ago();
	</code></pre>
	 *  
	 * @return {Date}    A new Date instance
	 */
	$N.ago = $N.before = function (date) {
		var c = {},
		s = (this._dateElement[this._dateElement.length-1] !== "s") ? this._dateElement + "s" : this._dateElement;
		c[s] = this * -1;
		return ((!date) ? new Date() : date.clone()).add(c);
	};

	// Do NOT modify the following string tokens. These tokens are used to build dynamic functions.
	// All culture-specific strings can be found in the CultureInfo files.
	var dx = ("sunday monday tuesday wednesday thursday friday saturday").split(/\s/),
		mx = ("january february march april may june july august september october november december").split(/\s/),
		px = ("Millisecond Second Minute Hour Day Week Month Year Quarter Weekday").split(/\s/),
		pxf = ("Milliseconds Seconds Minutes Hours Date Week Month FullYear Quarter").split(/\s/),
		nth = ("final first second third fourth fifth").split(/\s/),
		de;

   /** 
	 * Returns an object literal of all the date parts.
	 * Example
	<pre><code>
	var o = new Date().toObject();
	
	// { year: 2008, month: 4, week: 20, day: 13, hour: 18, minute: 9, second: 32, millisecond: 812 }
	
	// The object properties can be referenced directly from the object.
	
	alert(o.day);  // alerts "13"
	alert(o.year); // alerts "2008"
	</code></pre>
	 *  
	 * @return {Date}    An object literal representing the original date object.
	 */
	$P.toObject = function () {
		var o = {};
		for (var i = 0; i < px.length; i++) {
			if (this["get" + pxf[i]]) {
				o[px[i].toLowerCase()] = this["get" + pxf[i]]();
			}
		}
		return o;
	};
   
   /** 
	 * Returns a date created from an object literal. Ignores the .week property if set in the config. 
	 * Example
	<pre><code>
	var o = new Date().toObject();
	
	return Date.fromObject(o); // will return the same date. 

	var o2 = {month: 1, day: 20, hour: 18}; // birthday party!
	Date.fromObject(o2);
	</code></pre>
	 *  
	 * @return {Date}    An object literal representing the original date object.
	 */
	$D.fromObject = function(config) {
		config.week = null;
		return Date.today().set(config);
	};
		
	// Create day name functions and abbreviated day name functions (eg. monday(), friday(), fri()).
	
	var df = function (n) {
		return function () {
			if (this._is) {
				this._is = false;
				return this.getDay() === n;
			}
			if (this._move) { this._move = null; }
			if (this._nth !== null) {
				// If the .second() function was called earlier, remove the _orient 
				// from the date, and then continue.
				// This is required because 'second' can be used in two different context.
				// 
				// Example
				//
				//   Date.today().add(1).second();
				//   Date.march().second().monday();
				// 
				// Things get crazy with the following...
				//   Date.march().add(1).second().second().monday(); // but it works!!
				//  
				if (this._isSecond) {
					this.addSeconds(this._orient * -1);
				}
				// make sure we reset _isSecond
				this._isSecond = false;

				var ntemp = this._nth;
				this._nth = null;
				var temp = this.clone().moveToLastDayOfMonth();
				this.moveToNthOccurrence(n, ntemp);
				if (this > temp) {
					throw new RangeError($D.getDayName(n) + " does not occur " + ntemp + " times in the month of " + $D.getMonthName(temp.getMonth()) + " " + temp.getFullYear() + ".");
				}
				return this;
			}
			return this.moveToDayOfWeek(n, this._orient);
		};
	};
	
	var sdf = function (n) {
		return function () {
			var t = $D.today(), shift = n - t.getDay();
			if (n === 0 && Date.CultureInfo.firstDayOfWeek === 1 && t.getDay() !== 0) {
				shift = shift + 7;
			}
			return t.addDays(shift);
		};
	};
	

	
	// Create month name functions and abbreviated month name functions (eg. january(), march(), mar()).
	var month_instance_functions = function (n) {
		return function () {
			if (this._is) {
				this._is = false;
				return this.getMonth() === n;
			}
			return this.moveToMonth(n, this._orient);
		};
	};
	
	var month_static_functions = function (n) {
		return function () {
			return $D.today().set({ month: n, day: 1 });
		};
	};
	
	var processTerms = function (names, staticFunc, instanceFunc) {
		for (var i = 0; i < names.length; i++) {
			// Create constant static Name variables.
			$D[names[i].toUpperCase()] = $D[names[i].toUpperCase().substring(0, 3)] = i;
			// Create Name functions.
			$D[names[i]] = $D[names[i].substring(0, 3)] = staticFunc(i);
			// Create Name instance functions.
			$P[names[i]] = $P[names[i].substring(0, 3)] = instanceFunc(i);
		}

	};

	processTerms(dx, sdf, df);
	processTerms(mx, month_static_functions, month_instance_functions);
	
	// Create date element functions and plural date element functions used with Date (eg. day(), days(), months()).
	var ef = function (j) {
		return function () {
			// if the .second() function was called earlier, the _orient 
			// has alread been added. Just return this and reset _isSecond.
			if (this._isSecond) {
				this._isSecond = false;
				return this;
			}

			if (this._same) {
				this._same = this._is = false;
				var o1 = this.toObject(),
					o2 = (arguments[0] || new Date()).toObject(),
					v = "",
					k = j.toLowerCase();

				// the substr trick with -1 doesn't work in IE8 or less
				k = (k[k.length-1] === "s") ? k.substring(0,k.length-1) : k;
					
				for (var m = (px.length - 1); m > -1; m--) {
					v = px[m].toLowerCase();
					if (o1[v] !== o2[v]) {
						return false;
					}
					if (k === v) {
						break;
					}
				}
				return true;
			}
			
			if (j.substring(j.length - 1) !== "s") {
				j += "s";
			}
			if (this._move) { this._move = null; }
			return this["add" + j](this._orient);
		};
	};
	
	
	var nf = function (n) {
		return function () {
			this._dateElement = n;
			return this;
		};
	};
   
	for (var k = 0; k < px.length; k++) {
		de = px[k].toLowerCase();
		if(de !== "weekday") {
			// Create date element functions and plural date element functions used with Date (eg. day(), days(), months()).
			$P[de] = $P[de + "s"] = ef(px[k]);
			
			// Create date element functions and plural date element functions used with Number (eg. day(), days(), months()).
			$N[de] = $N[de + "s"] = nf(de + "s");
		}
	}
	
	$P._ss = ef("Second");
	
	var nthfn = function (n) {
		return function (dayOfWeek) {
			if (this._same) {
				return this._ss(arguments[0]);
			}
			if (dayOfWeek || dayOfWeek === 0) {
				return this.moveToNthOccurrence(dayOfWeek, n);
			}
			this._nth = n;

			// if the operator is 'second' add the _orient, then deal with it later...
			if (n === 2 && (dayOfWeek === undefined || dayOfWeek === null)) {
				this._isSecond = true;
				return this.addSeconds(this._orient);
			}
			return this;
		};
	};

	for (var l = 0; l < nth.length; l++) {
		$P[nth[l]] = (l === 0) ? nthfn(-1) : nthfn(l);
	}
}());

},{}],24:[function(require,module,exports){
(function () {
	"use strict";
	var attrs = ["years", "months", "days", "hours", "minutes", "seconds", "milliseconds"];
	var gFn = function (attr) {
		return function () {
			return this[attr];
		};
	};
	
	var sFn = function (attr) {
		return function (val) {
			this[attr] = val;
			return this;
		};
	};
	var addSetFuncs = function (context, attrs) {
		for (var i = 0; i < attrs.length ; i++) {
			var $a = attrs[i], $b = $a.slice(0, 1).toUpperCase() + $a.slice(1);
			context.prototype[$a] = 0;
			context.prototype["get" + $b] = gFn($a);
			context.prototype["set" + $b] = sFn($a);
		}
	};

	var setMonthsAndYears = function (orient, d1, d2, context) {
		function inc() {
			d1.addMonths(-orient);
			context.months++;
			if (context.months === 12) {
				context.years++;
				context.months = 0;
			}
		}
		if (orient === +1) {
			while (d1 > d2) {
				inc();
			}
		} else {
			while (d1 < d2) {
				inc();
			}
		}
		context.months--;
		context.months *= orient;
		context.years *= orient;
	};

	var adjustForDST = function(orient, startDate, endDate) {
		var hasDSTMismatch = (false === (startDate.isDaylightSavingTime() === endDate.isDaylightSavingTime()));
		if (hasDSTMismatch && orient === 1) {
			startDate.addHours(-1);
		} else if (hasDSTMismatch) {
			startDate.addHours(1);
		}
	};
	/**
	 * TimePeriod(startDate, endDate);
	 * TimePeriod(years, months, days, hours, minutes, seconds, milliseconds);
	 */
	var TimePeriod = function (years, months, days, hours, minutes, seconds, milliseconds) {
		if (arguments.length === 7) {
			this.set(years, months, days, hours, minutes, seconds, milliseconds);
		} else if (arguments.length === 2 && arguments[0] instanceof Date && arguments[1] instanceof Date) {
			var startDate = arguments[0].clone();
			var endDate = arguments[1].clone();
			var orient = (startDate > endDate) ? +1 : -1;
			this.dates = {
				start: arguments[0].clone(),
				end: arguments[1].clone()
			};

			setMonthsAndYears(orient, startDate, endDate, this);
			adjustForDST(orient, startDate, endDate);
			// // TODO - adjust for DST
			var diff = endDate - startDate;
			if (diff !== 0) {
				var ts = new TimeSpan(diff);
				this.set(this.years, this.months, ts.getDays(), ts.getHours(), ts.getMinutes(), ts.getSeconds(), ts.getMilliseconds());
			}
		}
		return this;
	};
	// create all the set functions.
	addSetFuncs(TimePeriod, attrs);
	TimePeriod.prototype.set = function (years, months, days, hours, minutes, seconds, milliseconds){
		this.setYears(years || this.getYears());
		this.setMonths(months || this.getMonths());
		this.setDays(days || this.getDays());
		this.setHours(hours || this.getHours());
		this.setMinutes(minutes || this.getMinutes());
		this.setSeconds(seconds || this.getSeconds());
		this.setMilliseconds(milliseconds || this.getMilliseconds());
	};

	Date.TimePeriod = TimePeriod;

	if (typeof window !== "undefined") {
		// keeping API compatible for v1.x 
		window.TimePeriod = TimePeriod;
	}
}());
},{}],25:[function(require,module,exports){
(function () {
	"use strict";
	var gFn = function (attr) {
		return function () {
			return this[attr];
		};
	};
	
	var sFn = function (attr) {
		return function (val) {
			this[attr] = val;
			return this;
		};
	};
	var attrs = ["years", "months", "days", "hours", "minutes", "seconds", "milliseconds"];
	var addSetFuncs = function (context, attrs) {
		for (var i = 0; i < attrs.length ; i++) {
			var $a = attrs[i], $b = $a.slice(0, 1).toUpperCase() + $a.slice(1);
			context.prototype[$a] = 0;
			context.prototype["get" + $b] = gFn($a);
			context.prototype["set" + $b] = sFn($a);
		}
	};
	/**
	 * new TimeSpan(milliseconds);
	 * new TimeSpan(days, hours, minutes, seconds);
	 * new TimeSpan(days, hours, minutes, seconds, milliseconds);
	 */
	var TimeSpan = function (days, hours, minutes, seconds, milliseconds) {
		if (arguments.length === 1 && typeof days === "number") {
			var orient = (days < 0) ? -1 : +1;
			var millsLeft = Math.abs(days);
			this.setDays(Math.floor(millsLeft / 86400000) * orient);
			millsLeft = millsLeft % 86400000;
			this.setHours(Math.floor(millsLeft / 3600000) * orient);
			millsLeft = millsLeft % 3600000;
			this.setMinutes(Math.floor(millsLeft / 60000) * orient);
			millsLeft = millsLeft % 60000;
			this.setSeconds(Math.floor(millsLeft / 1000) * orient);
			millsLeft = millsLeft % 1000;
			this.setMilliseconds(millsLeft * orient);
		} else {
			this.set(days, hours, minutes, seconds, milliseconds);
		}

		this.getTotalMilliseconds = function () {
			return	(this.getDays() * 86400000) +
					(this.getHours() * 3600000) +
					(this.getMinutes() * 60000) +
					(this.getSeconds() * 1000);
		};
		
		this.compareTo = function (time) {
			var t1 = new Date(1970, 1, 1, this.getHours(), this.getMinutes(), this.getSeconds()), t2;
			if (time === null) {
				t2 = new Date(1970, 1, 1, 0, 0, 0);
			}
			else {
				t2 = new Date(1970, 1, 1, time.getHours(), time.getMinutes(), time.getSeconds());
			}
			return (t1 < t2) ? -1 : (t1 > t2) ? 1 : 0;
		};

		this.equals = function (time) {
			return (this.compareTo(time) === 0);
		};

		this.add = function (time) {
			return (time === null) ? this : this.addSeconds(time.getTotalMilliseconds() / 1000);
		};

		this.subtract = function (time) {
			return (time === null) ? this : this.addSeconds(-time.getTotalMilliseconds() / 1000);
		};

		this.addDays = function (n) {
			return new TimeSpan(this.getTotalMilliseconds() + (n * 86400000));
		};

		this.addHours = function (n) {
			return new TimeSpan(this.getTotalMilliseconds() + (n * 3600000));
		};

		this.addMinutes = function (n) {
			return new TimeSpan(this.getTotalMilliseconds() + (n * 60000));
		};

		this.addSeconds = function (n) {
			return new TimeSpan(this.getTotalMilliseconds() + (n * 1000));
		};

		this.addMilliseconds = function (n) {
			return new TimeSpan(this.getTotalMilliseconds() + n);
		};

		this.get12HourHour = function () {
			return (this.getHours() > 12) ? this.getHours() - 12 : (this.getHours() === 0) ? 12 : this.getHours();
		};

		this.getDesignator = function () {
			return (this.getHours() < 12) ? Date.CultureInfo.amDesignator : Date.CultureInfo.pmDesignator;
		};

		this.toString = function (format) {
			this._toString = function () {
				if (this.getDays() !== null && this.getDays() > 0) {
					return this.getDays() + "." + this.getHours() + ":" + this.p(this.getMinutes()) + ":" + this.p(this.getSeconds());
				} else {
					return this.getHours() + ":" + this.p(this.getMinutes()) + ":" + this.p(this.getSeconds());
				}
			};
			
			this.p = function (s) {
				return (s.toString().length < 2) ? "0" + s : s;
			};
			
			var me = this;
			
			return format ? format.replace(/dd?|HH?|hh?|mm?|ss?|tt?/g,
			function (format) {
				switch (format) {
				case "d":
					return me.getDays();
				case "dd":
					return me.p(me.getDays());
				case "H":
					return me.getHours();
				case "HH":
					return me.p(me.getHours());
				case "h":
					return me.get12HourHour();
				case "hh":
					return me.p(me.get12HourHour());
				case "m":
					return me.getMinutes();
				case "mm":
					return me.p(me.getMinutes());
				case "s":
					return me.getSeconds();
				case "ss":
					return me.p(me.getSeconds());
				case "t":
					return ((me.getHours() < 12) ? Date.CultureInfo.amDesignator : Date.CultureInfo.pmDesignator).substring(0, 1);
				case "tt":
					return (me.getHours() < 12) ? Date.CultureInfo.amDesignator : Date.CultureInfo.pmDesignator;
				}
			}
			) : this._toString();
		};
		return this;
	};
	addSetFuncs(TimeSpan, attrs.slice(2));
	TimeSpan.prototype.set = function (days, hours, minutes, seconds, milliseconds){
		this.setDays(days || this.getDays());
		this.setHours(hours || this.getHours());
		this.setMinutes(minutes || this.getMinutes());
		this.setSeconds(seconds || this.getSeconds());
		this.setMilliseconds(milliseconds || this.getMilliseconds());
	};


	/**
	 * Gets the time of day for this date instances. 
	 * @return {TimeSpan} TimeSpan
	 */
	Date.prototype.getTimeOfDay = function () {
		return new TimeSpan(0, this.getHours(), this.getMinutes(), this.getSeconds(), this.getMilliseconds());
	};

	Date.TimeSpan = TimeSpan;

	if (typeof window !== "undefined" ) {
		// keeping API compatible for v1.x 
		window.TimeSpan = TimeSpan;
	}
}());
},{}],26:[function(require,module,exports){
(function (global){
(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.libphonenumber = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
var COMPILED = !0, goog = goog || {};
goog.global = this || self;
goog.isDef = function(a) {
  return void 0 !== a;
};
goog.isString = function(a) {
  return "string" == typeof a;
};
goog.isBoolean = function(a) {
  return "boolean" == typeof a;
};
goog.isNumber = function(a) {
  return "number" == typeof a;
};
goog.exportPath_ = function(a, b, c) {
  a = a.split(".");
  c = c || goog.global;
  a[0] in c || "undefined" == typeof c.execScript || c.execScript("var " + a[0]);
  for (var d; a.length && (d = a.shift());) {
    a.length || void 0 === b ? c = c[d] && c[d] !== Object.prototype[d] ? c[d] : c[d] = {} : c[d] = b;
  }
};
goog.define = function(a, b) {
  var c = b;
  if (!COMPILED) {
    var d = goog.global.CLOSURE_UNCOMPILED_DEFINES, e = goog.global.CLOSURE_DEFINES;
    d && void 0 === d.nodeType && Object.prototype.hasOwnProperty.call(d, a) ? c = d[a] : e && void 0 === e.nodeType && Object.prototype.hasOwnProperty.call(e, a) && (c = e[a]);
  }
  return c;
};
goog.FEATURESET_YEAR = 2012;
goog.DEBUG = !0;
goog.LOCALE = "en";
goog.TRUSTED_SITE = !0;
goog.STRICT_MODE_COMPATIBLE = !1;
goog.DISALLOW_TEST_ONLY_CODE = COMPILED && !goog.DEBUG;
goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = !1;
goog.provide = function(a) {
  if (goog.isInModuleLoader_()) {
    throw Error("goog.provide cannot be used within a module.");
  }
  if (!COMPILED && goog.isProvided_(a)) {
    throw Error('Namespace "' + a + '" already declared.');
  }
  goog.constructNamespace_(a);
};
goog.constructNamespace_ = function(a, b) {
  if (!COMPILED) {
    delete goog.implicitNamespaces_[a];
    for (var c = a; (c = c.substring(0, c.lastIndexOf("."))) && !goog.getObjectByName(c);) {
      goog.implicitNamespaces_[c] = !0;
    }
  }
  goog.exportPath_(a, b);
};
goog.getScriptNonce = function(a) {
  if (a && a != goog.global) {
    return goog.getScriptNonce_(a.document);
  }
  null === goog.cspNonce_ && (goog.cspNonce_ = goog.getScriptNonce_(goog.global.document));
  return goog.cspNonce_;
};
goog.NONCE_PATTERN_ = /^[\w+/_-]+[=]{0,2}$/;
goog.cspNonce_ = null;
goog.getScriptNonce_ = function(a) {
  return (a = a.querySelector && a.querySelector("script[nonce]")) && (a = a.nonce || a.getAttribute("nonce")) && goog.NONCE_PATTERN_.test(a) ? a : "";
};
goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/;
goog.module = function(a) {
  if ("string" !== typeof a || !a || -1 == a.search(goog.VALID_MODULE_RE_)) {
    throw Error("Invalid module identifier");
  }
  if (!goog.isInGoogModuleLoader_()) {
    throw Error("Module " + a + " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
  }
  if (goog.moduleLoaderState_.moduleName) {
    throw Error("goog.module may only be called once per module.");
  }
  goog.moduleLoaderState_.moduleName = a;
  if (!COMPILED) {
    if (goog.isProvided_(a)) {
      throw Error('Namespace "' + a + '" already declared.');
    }
    delete goog.implicitNamespaces_[a];
  }
};
goog.module.get = function(a) {
  return goog.module.getInternal_(a);
};
goog.module.getInternal_ = function(a) {
  if (!COMPILED) {
    if (a in goog.loadedModules_) {
      return goog.loadedModules_[a].exports;
    }
    if (!goog.implicitNamespaces_[a]) {
      return a = goog.getObjectByName(a), null != a ? a : null;
    }
  }
  return null;
};
goog.ModuleType = {ES6:"es6", GOOG:"goog"};
goog.moduleLoaderState_ = null;
goog.isInModuleLoader_ = function() {
  return goog.isInGoogModuleLoader_() || goog.isInEs6ModuleLoader_();
};
goog.isInGoogModuleLoader_ = function() {
  return !!goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.GOOG;
};
goog.isInEs6ModuleLoader_ = function() {
  if (goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.ES6) {
    return !0;
  }
  var a = goog.global.$jscomp;
  return a ? "function" != typeof a.getCurrentModulePath ? !1 : !!a.getCurrentModulePath() : !1;
};
goog.module.declareLegacyNamespace = function() {
  if (!COMPILED && !goog.isInGoogModuleLoader_()) {
    throw Error("goog.module.declareLegacyNamespace must be called from within a goog.module");
  }
  if (!COMPILED && !goog.moduleLoaderState_.moduleName) {
    throw Error("goog.module must be called prior to goog.module.declareLegacyNamespace.");
  }
  goog.moduleLoaderState_.declareLegacyNamespace = !0;
};
goog.declareModuleId = function(a) {
  if (!COMPILED) {
    if (!goog.isInEs6ModuleLoader_()) {
      throw Error("goog.declareModuleId may only be called from within an ES6 module");
    }
    if (goog.moduleLoaderState_ && goog.moduleLoaderState_.moduleName) {
      throw Error("goog.declareModuleId may only be called once per module.");
    }
    if (a in goog.loadedModules_) {
      throw Error('Module with namespace "' + a + '" already exists.');
    }
  }
  if (goog.moduleLoaderState_) {
    goog.moduleLoaderState_.moduleName = a;
  } else {
    var b = goog.global.$jscomp;
    if (!b || "function" != typeof b.getCurrentModulePath) {
      throw Error('Module with namespace "' + a + '" has been loaded incorrectly.');
    }
    b = b.require(b.getCurrentModulePath());
    goog.loadedModules_[a] = {exports:b, type:goog.ModuleType.ES6, moduleId:a};
  }
};
goog.setTestOnly = function(a) {
  if (goog.DISALLOW_TEST_ONLY_CODE) {
    throw a = a || "", Error("Importing test-only code into non-debug environment" + (a ? ": " + a : "."));
  }
};
goog.forwardDeclare = function(a) {
};
COMPILED || (goog.isProvided_ = function(a) {
  return a in goog.loadedModules_ || !goog.implicitNamespaces_[a] && null != goog.getObjectByName(a);
}, goog.implicitNamespaces_ = {"goog.module":!0});
goog.getObjectByName = function(a, b) {
  for (var c = a.split("."), d = b || goog.global, e = 0; e < c.length; e++) {
    if (d = d[c[e]], null == d) {
      return null;
    }
  }
  return d;
};
goog.globalize = function(a, b) {
  var c = b || goog.global, d;
  for (d in a) {
    c[d] = a[d];
  }
};
goog.addDependency = function(a, b, c, d) {
  !COMPILED && goog.DEPENDENCIES_ENABLED && goog.debugLoader_.addDependency(a, b, c, d);
};
goog.ENABLE_DEBUG_LOADER = !0;
goog.logToConsole_ = function(a) {
  goog.global.console && goog.global.console.error(a);
};
goog.require = function(a) {
  if (!COMPILED) {
    goog.ENABLE_DEBUG_LOADER && goog.debugLoader_.requested(a);
    if (goog.isProvided_(a)) {
      if (goog.isInModuleLoader_()) {
        return goog.module.getInternal_(a);
      }
    } else {
      if (goog.ENABLE_DEBUG_LOADER) {
        var b = goog.moduleLoaderState_;
        goog.moduleLoaderState_ = null;
        try {
          goog.debugLoader_.load_(a);
        } finally {
          goog.moduleLoaderState_ = b;
        }
      }
    }
    return null;
  }
};
goog.requireType = function(a) {
  return {};
};
goog.basePath = "";
goog.nullFunction = function() {
};
goog.abstractMethod = function() {
  throw Error("unimplemented abstract method");
};
goog.addSingletonGetter = function(a) {
  a.instance_ = void 0;
  a.getInstance = function() {
    if (a.instance_) {
      return a.instance_;
    }
    goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = a);
    return a.instance_ = new a;
  };
};
goog.instantiatedSingletons_ = [];
goog.LOAD_MODULE_USING_EVAL = !0;
goog.SEAL_MODULE_EXPORTS = goog.DEBUG;
goog.loadedModules_ = {};
goog.DEPENDENCIES_ENABLED = !COMPILED && goog.ENABLE_DEBUG_LOADER;
goog.TRANSPILE = "detect";
goog.ASSUME_ES_MODULES_TRANSPILED = !1;
goog.TRANSPILE_TO_LANGUAGE = "";
goog.TRANSPILER = "transpile.js";
goog.hasBadLetScoping = null;
goog.useSafari10Workaround = function() {
  if (null == goog.hasBadLetScoping) {
    try {
      var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
    } catch (b) {
      a = !1;
    }
    goog.hasBadLetScoping = a;
  }
  return goog.hasBadLetScoping;
};
goog.workaroundSafari10EvalBug = function(a) {
  return "(function(){" + a + "\n;})();\n";
};
goog.loadModule = function(a) {
  var b = goog.moduleLoaderState_;
  try {
    goog.moduleLoaderState_ = {moduleName:"", declareLegacyNamespace:!1, type:goog.ModuleType.GOOG};
    if (goog.isFunction(a)) {
      var c = a.call(void 0, {});
    } else {
      if ("string" === typeof a) {
        goog.useSafari10Workaround() && (a = goog.workaroundSafari10EvalBug(a)), c = goog.loadModuleFromSource_.call(void 0, a);
      } else {
        throw Error("Invalid module definition");
      }
    }
    var d = goog.moduleLoaderState_.moduleName;
    if ("string" === typeof d && d) {
      goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(d, c) : goog.SEAL_MODULE_EXPORTS && Object.seal && "object" == typeof c && null != c && Object.seal(c), goog.loadedModules_[d] = {exports:c, type:goog.ModuleType.GOOG, moduleId:goog.moduleLoaderState_.moduleName};
    } else {
      throw Error('Invalid module name "' + d + '"');
    }
  } finally {
    goog.moduleLoaderState_ = b;
  }
};
goog.loadModuleFromSource_ = function(a) {
  eval(a);
  return {};
};
goog.normalizePath_ = function(a) {
  a = a.split("/");
  for (var b = 0; b < a.length;) {
    "." == a[b] ? a.splice(b, 1) : b && ".." == a[b] && a[b - 1] && ".." != a[b - 1] ? a.splice(--b, 2) : b++;
  }
  return a.join("/");
};
goog.loadFileSync_ = function(a) {
  if (goog.global.CLOSURE_LOAD_FILE_SYNC) {
    return goog.global.CLOSURE_LOAD_FILE_SYNC(a);
  }
  try {
    var b = new goog.global.XMLHttpRequest;
    b.open("get", a, !1);
    b.send();
    return 0 == b.status || 200 == b.status ? b.responseText : null;
  } catch (c) {
    return null;
  }
};
goog.transpile_ = function(a, b, c) {
  var d = goog.global.$jscomp;
  d || (goog.global.$jscomp = d = {});
  var e = d.transpile;
  if (!e) {
    var f = goog.basePath + goog.TRANSPILER, g = goog.loadFileSync_(f);
    if (g) {
      (function() {
        (0,eval)(g + "\n//# sourceURL=" + f);
      }).call(goog.global);
      if (goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile) {
        throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: ' + JSON.stringify(goog.global.$gwtExport));
      }
      goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile;
      d = goog.global.$jscomp;
      e = d.transpile;
    }
  }
  e || (e = d.transpile = function(a, b) {
    goog.logToConsole_(b + " requires transpilation but no transpiler was found.");
    return a;
  });
  return e(a, b, c);
};
goog.typeOf = function(a) {
  var b = typeof a;
  if ("object" == b) {
    if (a) {
      if (a instanceof Array) {
        return "array";
      }
      if (a instanceof Object) {
        return b;
      }
      var c = Object.prototype.toString.call(a);
      if ("[object Window]" == c) {
        return "object";
      }
      if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) {
        return "array";
      }
      if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) {
        return "function";
      }
    } else {
      return "null";
    }
  } else {
    if ("function" == b && "undefined" == typeof a.call) {
      return "object";
    }
  }
  return b;
};
goog.isNull = function(a) {
  return null === a;
};
goog.isDefAndNotNull = function(a) {
  return null != a;
};
goog.isArray = function(a) {
  return "array" == goog.typeOf(a);
};
goog.isArrayLike = function(a) {
  var b = goog.typeOf(a);
  return "array" == b || "object" == b && "number" == typeof a.length;
};
goog.isDateLike = function(a) {
  return goog.isObject(a) && "function" == typeof a.getFullYear;
};
goog.isFunction = function(a) {
  return "function" == goog.typeOf(a);
};
goog.isObject = function(a) {
  var b = typeof a;
  return "object" == b && null != a || "function" == b;
};
goog.getUid = function(a) {
  return a[goog.UID_PROPERTY_] || (a[goog.UID_PROPERTY_] = ++goog.uidCounter_);
};
goog.hasUid = function(a) {
  return !!a[goog.UID_PROPERTY_];
};
goog.removeUid = function(a) {
  null !== a && "removeAttribute" in a && a.removeAttribute(goog.UID_PROPERTY_);
  try {
    delete a[goog.UID_PROPERTY_];
  } catch (b) {
  }
};
goog.UID_PROPERTY_ = "closure_uid_" + (1e9 * Math.random() >>> 0);
goog.uidCounter_ = 0;
goog.getHashCode = goog.getUid;
goog.removeHashCode = goog.removeUid;
goog.cloneObject = function(a) {
  var b = goog.typeOf(a);
  if ("object" == b || "array" == b) {
    if ("function" === typeof a.clone) {
      return a.clone();
    }
    b = "array" == b ? [] : {};
    for (var c in a) {
      b[c] = goog.cloneObject(a[c]);
    }
    return b;
  }
  return a;
};
goog.bindNative_ = function(a, b, c) {
  return a.call.apply(a.bind, arguments);
};
goog.bindJs_ = function(a, b, c) {
  if (!a) {
    throw Error();
  }
  if (2 < arguments.length) {
    var d = Array.prototype.slice.call(arguments, 2);
    return function() {
      var c = Array.prototype.slice.call(arguments);
      Array.prototype.unshift.apply(c, d);
      return a.apply(b, c);
    };
  }
  return function() {
    return a.apply(b, arguments);
  };
};
goog.bind = function(a, b, c) {
  Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_;
  return goog.bind.apply(null, arguments);
};
goog.partial = function(a, b) {
  var c = Array.prototype.slice.call(arguments, 1);
  return function() {
    var b = c.slice();
    b.push.apply(b, arguments);
    return a.apply(this, b);
  };
};
goog.mixin = function(a, b) {
  for (var c in b) {
    a[c] = b[c];
  }
};
goog.now = goog.TRUSTED_SITE && Date.now || function() {
  return +new Date;
};
goog.globalEval = function(a) {
  if (goog.global.execScript) {
    goog.global.execScript(a, "JavaScript");
  } else {
    if (goog.global.eval) {
      if (null == goog.evalWorksForGlobals_) {
        try {
          goog.global.eval("var _evalTest_ = 1;");
        } catch (d) {
        }
        if ("undefined" != typeof goog.global._evalTest_) {
          try {
            delete goog.global._evalTest_;
          } catch (d) {
          }
          goog.evalWorksForGlobals_ = !0;
        } else {
          goog.evalWorksForGlobals_ = !1;
        }
      }
      if (goog.evalWorksForGlobals_) {
        goog.global.eval(a);
      } else {
        var b = goog.global.document, c = b.createElement("script");
        c.type = "text/javascript";
        c.defer = !1;
        c.appendChild(b.createTextNode(a));
        b.head.appendChild(c);
        b.head.removeChild(c);
      }
    } else {
      throw Error("goog.globalEval not available");
    }
  }
};
goog.evalWorksForGlobals_ = null;
goog.getCssName = function(a, b) {
  if ("." == String(a).charAt(0)) {
    throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + a);
  }
  var c = function(a) {
    return goog.cssNameMapping_[a] || a;
  }, d = function(a) {
    a = a.split("-");
    for (var b = [], d = 0; d < a.length; d++) {
      b.push(c(a[d]));
    }
    return b.join("-");
  };
  d = goog.cssNameMapping_ ? "BY_WHOLE" == goog.cssNameMappingStyle_ ? c : d : function(a) {
    return a;
  };
  d = b ? a + "-" + d(b) : d(a);
  return goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(d) : d;
};
goog.setCssNameMapping = function(a, b) {
  goog.cssNameMapping_ = a;
  goog.cssNameMappingStyle_ = b;
};
!COMPILED && goog.global.CLOSURE_CSS_NAME_MAPPING && (goog.cssNameMapping_ = goog.global.CLOSURE_CSS_NAME_MAPPING);
goog.getMsg = function(a, b, c) {
  c && c.html && (a = a.replace(/</g, "&lt;"));
  b && (a = a.replace(/\{\$([^}]+)}/g, function(a, c) {
    return null != b && c in b ? b[c] : a;
  }));
  return a;
};
goog.getMsgWithFallback = function(a, b) {
  return a;
};
goog.exportSymbol = function(a, b, c) {
  goog.exportPath_(a, b, c);
};
goog.exportProperty = function(a, b, c) {
  a[b] = c;
};
goog.inherits = function(a, b) {
  function c() {
  }
  c.prototype = b.prototype;
  a.superClass_ = b.prototype;
  a.prototype = new c;
  a.prototype.constructor = a;
  a.base = function(a, c, f) {
    for (var d = Array(arguments.length - 2), e = 2; e < arguments.length; e++) {
      d[e - 2] = arguments[e];
    }
    return b.prototype[c].apply(a, d);
  };
};
goog.base = function(a, b, c) {
  var d = arguments.callee.caller;
  if (goog.STRICT_MODE_COMPATIBLE || goog.DEBUG && !d) {
    throw Error("arguments.caller not defined.  goog.base() cannot be used with strict mode code. See http://www.ecma-international.org/ecma-262/5.1/#sec-C");
  }
  if ("undefined" !== typeof d.superClass_) {
    for (var e = Array(arguments.length - 1), f = 1; f < arguments.length; f++) {
      e[f - 1] = arguments[f];
    }
    return d.superClass_.constructor.apply(a, e);
  }
  if ("string" != typeof b && "symbol" != typeof b) {
    throw Error("method names provided to goog.base must be a string or a symbol");
  }
  e = Array(arguments.length - 2);
  for (f = 2; f < arguments.length; f++) {
    e[f - 2] = arguments[f];
  }
  f = !1;
  for (var g = a.constructor.prototype; g; g = Object.getPrototypeOf(g)) {
    if (g[b] === d) {
      f = !0;
    } else {
      if (f) {
        return g[b].apply(a, e);
      }
    }
  }
  if (a[b] === d) {
    return a.constructor.prototype[b].apply(a, e);
  }
  throw Error("goog.base called from a method of one name to a method of a different name");
};
goog.scope = function(a) {
  if (goog.isInModuleLoader_()) {
    throw Error("goog.scope is not supported within a module.");
  }
  a.call(goog.global);
};
COMPILED || (goog.global.COMPILED = COMPILED);
goog.defineClass = function(a, b) {
  var c = b.constructor, d = b.statics;
  c && c != Object.prototype.constructor || (c = function() {
    throw Error("cannot instantiate an interface (no constructor defined).");
  });
  c = goog.defineClass.createSealingConstructor_(c, a);
  a && goog.inherits(c, a);
  delete b.constructor;
  delete b.statics;
  goog.defineClass.applyProperties_(c.prototype, b);
  null != d && (d instanceof Function ? d(c) : goog.defineClass.applyProperties_(c, d));
  return c;
};
goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG;
goog.defineClass.createSealingConstructor_ = function(a, b) {
  if (!goog.defineClass.SEAL_CLASS_INSTANCES) {
    return a;
  }
  var c = !goog.defineClass.isUnsealable_(b), d = function() {
    var b = a.apply(this, arguments) || this;
    b[goog.UID_PROPERTY_] = b[goog.UID_PROPERTY_];
    this.constructor === d && c && Object.seal instanceof Function && Object.seal(b);
    return b;
  };
  return d;
};
goog.defineClass.isUnsealable_ = function(a) {
  return a && a.prototype && a.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_];
};
goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
goog.defineClass.applyProperties_ = function(a, b) {
  for (var c in b) {
    Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
  }
  for (var d = 0; d < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; d++) {
    c = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[d], Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
  }
};
goog.tagUnsealableClass = function(a) {
  !COMPILED && goog.defineClass.SEAL_CLASS_INSTANCES && (a.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_] = !0);
};
goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_ = "goog_defineClass_legacy_unsealable";
!COMPILED && goog.DEPENDENCIES_ENABLED && (goog.inHtmlDocument_ = function() {
  var a = goog.global.document;
  return null != a && "write" in a;
}, goog.isDocumentLoading_ = function() {
  var a = goog.global.document;
  return a.attachEvent ? "complete" != a.readyState : "loading" == a.readyState;
}, goog.findBasePath_ = function() {
  if (void 0 != goog.global.CLOSURE_BASE_PATH && "string" === typeof goog.global.CLOSURE_BASE_PATH) {
    goog.basePath = goog.global.CLOSURE_BASE_PATH;
  } else {
    if (goog.inHtmlDocument_()) {
      var a = goog.global.document, b = a.currentScript;
      a = b ? [b] : a.getElementsByTagName("SCRIPT");
      for (b = a.length - 1; 0 <= b; --b) {
        var c = a[b].src, d = c.lastIndexOf("?");
        d = -1 == d ? c.length : d;
        if ("base.js" == c.substr(d - 7, 7)) {
          goog.basePath = c.substr(0, d - 7);
          break;
        }
      }
    }
  }
}, goog.findBasePath_(), goog.Transpiler = function() {
  this.requiresTranspilation_ = null;
  this.transpilationTarget_ = goog.TRANSPILE_TO_LANGUAGE;
}, goog.Transpiler.prototype.createRequiresTranspilation_ = function() {
  function a(a, b) {
    e ? d[a] = !0 : b() ? (c = a, d[a] = !1) : e = d[a] = !0;
  }
  function b(a) {
    try {
      return !!eval(a);
    } catch (h) {
      return !1;
    }
  }
  var c = "es3", d = {es3:!1}, e = !1, f = goog.global.navigator && goog.global.navigator.userAgent ? goog.global.navigator.userAgent : "";
  a("es5", function() {
    return b("[1,].length==1");
  });
  a("es6", function() {
    return f.match(/Edge\/(\d+)(\.\d)*/i) ? !1 : b('(()=>{"use strict";class X{constructor(){if(new.target!=String)throw 1;this.x=42}}let q=Reflect.construct(X,[],String);if(q.x!=42||!(q instanceof String))throw 1;for(const a of[2,3]){if(a==2)continue;function f(z={a}){let a=0;return z.a}{function f(){return 0;}}return f()==3}})()');
  });
  a("es7", function() {
    return b("2 ** 2 == 4");
  });
  a("es8", function() {
    return b("async () => 1, true");
  });
  a("es9", function() {
    return b("({...rest} = {}), true");
  });
  a("es_next", function() {
    return !1;
  });
  return {target:c, map:d};
}, goog.Transpiler.prototype.needsTranspile = function(a, b) {
  if ("always" == goog.TRANSPILE) {
    return !0;
  }
  if ("never" == goog.TRANSPILE) {
    return !1;
  }
  if (!this.requiresTranspilation_) {
    var c = this.createRequiresTranspilation_();
    this.requiresTranspilation_ = c.map;
    this.transpilationTarget_ = this.transpilationTarget_ || c.target;
  }
  if (a in this.requiresTranspilation_) {
    return this.requiresTranspilation_[a] ? !0 : !goog.inHtmlDocument_() || "es6" != b || "noModule" in goog.global.document.createElement("script") ? !1 : !0;
  }
  throw Error("Unknown language mode: " + a);
}, goog.Transpiler.prototype.transpile = function(a, b) {
  return goog.transpile_(a, b, this.transpilationTarget_);
}, goog.transpiler_ = new goog.Transpiler, goog.protectScriptTag_ = function(a) {
  return a.replace(/<\/(SCRIPT)/ig, "\\x3c/$1");
}, goog.DebugLoader_ = function() {
  this.dependencies_ = {};
  this.idToPath_ = {};
  this.written_ = {};
  this.loadingDeps_ = [];
  this.depsToLoad_ = [];
  this.paused_ = !1;
  this.factory_ = new goog.DependencyFactory(goog.transpiler_);
  this.deferredCallbacks_ = {};
  this.deferredQueue_ = [];
}, goog.DebugLoader_.prototype.bootstrap = function(a, b) {
  function c() {
    d && (goog.global.setTimeout(d, 0), d = null);
  }
  var d = b;
  if (a.length) {
    for (var e = [], f = 0; f < a.length; f++) {
      var g = this.getPathFromDeps_(a[f]);
      if (!g) {
        throw Error("Unregonized namespace: " + a[f]);
      }
      e.push(this.dependencies_[g]);
    }
    g = goog.require;
    var h = 0;
    for (f = 0; f < a.length; f++) {
      g(a[f]), e[f].onLoad(function() {
        ++h == a.length && c();
      });
    }
  } else {
    c();
  }
}, goog.DebugLoader_.prototype.loadClosureDeps = function() {
  this.depsToLoad_.push(this.factory_.createDependency(goog.normalizePath_(goog.basePath + "deps.js"), "deps.js", [], [], {}, !1));
  this.loadDeps_();
}, goog.DebugLoader_.prototype.requested = function(a, b) {
  var c = this.getPathFromDeps_(a);
  if (c && (b || this.areDepsLoaded_(this.dependencies_[c].requires))) {
    var d = this.deferredCallbacks_[c];
    d && (delete this.deferredCallbacks_[c], d());
  }
}, goog.DebugLoader_.prototype.setDependencyFactory = function(a) {
  this.factory_ = a;
}, goog.DebugLoader_.prototype.load_ = function(a) {
  if (this.getPathFromDeps_(a)) {
    var b = this, c = [], d = function(a) {
      var e = b.getPathFromDeps_(a);
      if (!e) {
        throw Error("Bad dependency path or symbol: " + a);
      }
      if (!b.written_[e]) {
        b.written_[e] = !0;
        a = b.dependencies_[e];
        for (e = 0; e < a.requires.length; e++) {
          goog.isProvided_(a.requires[e]) || d(a.requires[e]);
        }
        c.push(a);
      }
    };
    d(a);
    a = !!this.depsToLoad_.length;
    this.depsToLoad_ = this.depsToLoad_.concat(c);
    this.paused_ || a || this.loadDeps_();
  } else {
    throw a = "goog.require could not find: " + a, goog.logToConsole_(a), Error(a);
  }
}, goog.DebugLoader_.prototype.loadDeps_ = function() {
  for (var a = this, b = this.paused_; this.depsToLoad_.length && !b;) {
    (function() {
      var c = !1, d = a.depsToLoad_.shift(), e = !1;
      a.loading_(d);
      var f = {pause:function() {
        if (c) {
          throw Error("Cannot call pause after the call to load.");
        }
        b = !0;
      }, resume:function() {
        c ? a.resume_() : b = !1;
      }, loaded:function() {
        if (e) {
          throw Error("Double call to loaded.");
        }
        e = !0;
        a.loaded_(d);
      }, pending:function() {
        for (var b = [], c = 0; c < a.loadingDeps_.length; c++) {
          b.push(a.loadingDeps_[c]);
        }
        return b;
      }, setModuleState:function(a) {
        goog.moduleLoaderState_ = {type:a, moduleName:"", declareLegacyNamespace:!1};
      }, registerEs6ModuleExports:function(a, b, c) {
        c && (goog.loadedModules_[c] = {exports:b, type:goog.ModuleType.ES6, moduleId:c || ""});
      }, registerGoogModuleExports:function(a, b) {
        goog.loadedModules_[a] = {exports:b, type:goog.ModuleType.GOOG, moduleId:a};
      }, clearModuleState:function() {
        goog.moduleLoaderState_ = null;
      }, defer:function(b) {
        if (c) {
          throw Error("Cannot register with defer after the call to load.");
        }
        a.defer_(d, b);
      }, areDepsLoaded:function() {
        return a.areDepsLoaded_(d.requires);
      }};
      try {
        d.load(f);
      } finally {
        c = !0;
      }
    })();
  }
  b && this.pause_();
}, goog.DebugLoader_.prototype.pause_ = function() {
  this.paused_ = !0;
}, goog.DebugLoader_.prototype.resume_ = function() {
  this.paused_ && (this.paused_ = !1, this.loadDeps_());
}, goog.DebugLoader_.prototype.loading_ = function(a) {
  this.loadingDeps_.push(a);
}, goog.DebugLoader_.prototype.loaded_ = function(a) {
  for (var b = 0; b < this.loadingDeps_.length; b++) {
    if (this.loadingDeps_[b] == a) {
      this.loadingDeps_.splice(b, 1);
      break;
    }
  }
  for (b = 0; b < this.deferredQueue_.length; b++) {
    if (this.deferredQueue_[b] == a.path) {
      this.deferredQueue_.splice(b, 1);
      break;
    }
  }
  if (this.loadingDeps_.length == this.deferredQueue_.length && !this.depsToLoad_.length) {
    for (; this.deferredQueue_.length;) {
      this.requested(this.deferredQueue_.shift(), !0);
    }
  }
  a.loaded();
}, goog.DebugLoader_.prototype.areDepsLoaded_ = function(a) {
  for (var b = 0; b < a.length; b++) {
    var c = this.getPathFromDeps_(a[b]);
    if (!c || !(c in this.deferredCallbacks_ || goog.isProvided_(a[b]))) {
      return !1;
    }
  }
  return !0;
}, goog.DebugLoader_.prototype.getPathFromDeps_ = function(a) {
  return a in this.idToPath_ ? this.idToPath_[a] : a in this.dependencies_ ? a : null;
}, goog.DebugLoader_.prototype.defer_ = function(a, b) {
  this.deferredCallbacks_[a.path] = b;
  this.deferredQueue_.push(a.path);
}, goog.LoadController = function() {
}, goog.LoadController.prototype.pause = function() {
}, goog.LoadController.prototype.resume = function() {
}, goog.LoadController.prototype.loaded = function() {
}, goog.LoadController.prototype.pending = function() {
}, goog.LoadController.prototype.registerEs6ModuleExports = function(a, b, c) {
}, goog.LoadController.prototype.setModuleState = function(a) {
}, goog.LoadController.prototype.clearModuleState = function() {
}, goog.LoadController.prototype.defer = function(a) {
}, goog.LoadController.prototype.areDepsLoaded = function() {
}, goog.Dependency = function(a, b, c, d, e) {
  this.path = a;
  this.relativePath = b;
  this.provides = c;
  this.requires = d;
  this.loadFlags = e;
  this.loaded_ = !1;
  this.loadCallbacks_ = [];
}, goog.Dependency.prototype.getPathName = function() {
  var a = this.path, b = a.indexOf("://");
  0 <= b && (a = a.substring(b + 3), b = a.indexOf("/"), 0 <= b && (a = a.substring(b + 1)));
  return a;
}, goog.Dependency.prototype.onLoad = function(a) {
  this.loaded_ ? a() : this.loadCallbacks_.push(a);
}, goog.Dependency.prototype.loaded = function() {
  this.loaded_ = !0;
  var a = this.loadCallbacks_;
  this.loadCallbacks_ = [];
  for (var b = 0; b < a.length; b++) {
    a[b]();
  }
}, goog.Dependency.defer_ = !1, goog.Dependency.callbackMap_ = {}, goog.Dependency.registerCallback_ = function(a) {
  var b = Math.random().toString(32);
  goog.Dependency.callbackMap_[b] = a;
  return b;
}, goog.Dependency.unregisterCallback_ = function(a) {
  delete goog.Dependency.callbackMap_[a];
}, goog.Dependency.callback_ = function(a, b) {
  if (a in goog.Dependency.callbackMap_) {
    for (var c = goog.Dependency.callbackMap_[a], d = [], e = 1; e < arguments.length; e++) {
      d.push(arguments[e]);
    }
    c.apply(void 0, d);
  } else {
    throw Error("Callback key " + a + " does not exist (was base.js loaded more than once?).");
  }
}, goog.Dependency.prototype.load = function(a) {
  if (goog.global.CLOSURE_IMPORT_SCRIPT) {
    goog.global.CLOSURE_IMPORT_SCRIPT(this.path) ? a.loaded() : a.pause();
  } else {
    if (goog.inHtmlDocument_()) {
      var b = goog.global.document;
      if ("complete" == b.readyState && !goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING) {
        if (/\bdeps.js$/.test(this.path)) {
          a.loaded();
          return;
        }
        throw Error('Cannot write "' + this.path + '" after document load');
      }
      if (!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING && goog.isDocumentLoading_()) {
        var c = goog.Dependency.registerCallback_(function(b) {
          goog.DebugLoader_.IS_OLD_IE_ && "complete" != b.readyState || (goog.Dependency.unregisterCallback_(c), a.loaded());
        }), d = !goog.DebugLoader_.IS_OLD_IE_ && goog.getScriptNonce() ? ' nonce="' + goog.getScriptNonce() + '"' : "";
        d = '<script src="' + this.path + '" ' + (goog.DebugLoader_.IS_OLD_IE_ ? "onreadystatechange" : "onload") + "=\"goog.Dependency.callback_('" + c + '\', this)" type="text/javascript" ' + (goog.Dependency.defer_ ? "defer" : "") + d + ">\x3c/script>";
        b.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(d) : d);
      } else {
        var e = b.createElement("script");
        e.defer = goog.Dependency.defer_;
        e.async = !1;
        e.type = "text/javascript";
        (d = goog.getScriptNonce()) && e.setAttribute("nonce", d);
        goog.DebugLoader_.IS_OLD_IE_ ? (a.pause(), e.onreadystatechange = function() {
          if ("loaded" == e.readyState || "complete" == e.readyState) {
            a.loaded(), a.resume();
          }
        }) : e.onload = function() {
          e.onload = null;
          a.loaded();
        };
        e.src = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScriptURL(this.path) : this.path;
        b.head.appendChild(e);
      }
    } else {
      goog.logToConsole_("Cannot use default debug loader outside of HTML documents."), "deps.js" == this.relativePath ? (goog.logToConsole_("Consider setting CLOSURE_IMPORT_SCRIPT before loading base.js, or setting CLOSURE_NO_DEPS to true."), a.loaded()) : a.pause();
    }
  }
}, goog.Es6ModuleDependency = function(a, b, c, d, e) {
  goog.Dependency.call(this, a, b, c, d, e);
}, goog.inherits(goog.Es6ModuleDependency, goog.Dependency), goog.Es6ModuleDependency.prototype.load = function(a) {
  function b(a, b) {
    var c = b ? '<script type="module" crossorigin>' + b + "\x3c/script>" : '<script type="module" crossorigin src="' + a + '">\x3c/script>';
    d.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(c) : c);
  }
  function c(a, b) {
    var c = d.createElement("script");
    c.defer = !0;
    c.async = !1;
    c.type = "module";
    c.setAttribute("crossorigin", !0);
    var e = goog.getScriptNonce();
    e && c.setAttribute("nonce", e);
    b ? c.textContent = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScript(b) : b : c.src = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScriptURL(a) : a;
    d.head.appendChild(c);
  }
  if (goog.global.CLOSURE_IMPORT_SCRIPT) {
    goog.global.CLOSURE_IMPORT_SCRIPT(this.path) ? a.loaded() : a.pause();
  } else {
    if (goog.inHtmlDocument_()) {
      var d = goog.global.document, e = this;
      if (goog.isDocumentLoading_()) {
        var f = b;
        goog.Dependency.defer_ = !0;
      } else {
        f = c;
      }
      var g = goog.Dependency.registerCallback_(function() {
        goog.Dependency.unregisterCallback_(g);
        a.setModuleState(goog.ModuleType.ES6);
      });
      f(void 0, 'goog.Dependency.callback_("' + g + '")');
      f(this.path, void 0);
      var h = goog.Dependency.registerCallback_(function(b) {
        goog.Dependency.unregisterCallback_(h);
        a.registerEs6ModuleExports(e.path, b, goog.moduleLoaderState_.moduleName);
      });
      f(void 0, 'import * as m from "' + this.path + '"; goog.Dependency.callback_("' + h + '", m)');
      var k = goog.Dependency.registerCallback_(function() {
        goog.Dependency.unregisterCallback_(k);
        a.clearModuleState();
        a.loaded();
      });
      f(void 0, 'goog.Dependency.callback_("' + k + '")');
    } else {
      goog.logToConsole_("Cannot use default debug loader outside of HTML documents."), a.pause();
    }
  }
}, goog.TransformedDependency = function(a, b, c, d, e) {
  goog.Dependency.call(this, a, b, c, d, e);
  this.contents_ = null;
  this.lazyFetch_ = !goog.inHtmlDocument_() || !("noModule" in goog.global.document.createElement("script"));
}, goog.inherits(goog.TransformedDependency, goog.Dependency), goog.TransformedDependency.prototype.load = function(a) {
  function b() {
    e.contents_ = goog.loadFileSync_(e.path);
    e.contents_ && (e.contents_ = e.transform(e.contents_), e.contents_ && (e.contents_ += "\n//# sourceURL=" + e.path));
  }
  function c() {
    e.lazyFetch_ && b();
    if (e.contents_) {
      f && a.setModuleState(goog.ModuleType.ES6);
      try {
        var c = e.contents_;
        e.contents_ = null;
        goog.globalEval(c);
        if (f) {
          var d = goog.moduleLoaderState_.moduleName;
        }
      } finally {
        f && a.clearModuleState();
      }
      f && goog.global.$jscomp.require.ensure([e.getPathName()], function() {
        a.registerEs6ModuleExports(e.path, goog.global.$jscomp.require(e.getPathName()), d);
      });
      a.loaded();
    }
  }
  function d() {
    var a = goog.global.document, b = goog.Dependency.registerCallback_(function() {
      goog.Dependency.unregisterCallback_(b);
      c();
    }), d = '<script type="text/javascript">' + goog.protectScriptTag_('goog.Dependency.callback_("' + b + '");') + "\x3c/script>";
    a.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(d) : d);
  }
  var e = this;
  if (goog.global.CLOSURE_IMPORT_SCRIPT) {
    b(), this.contents_ && goog.global.CLOSURE_IMPORT_SCRIPT("", this.contents_) ? (this.contents_ = null, a.loaded()) : a.pause();
  } else {
    var f = this.loadFlags.module == goog.ModuleType.ES6;
    this.lazyFetch_ || b();
    var g = 1 < a.pending().length, h = g && goog.DebugLoader_.IS_OLD_IE_;
    g = goog.Dependency.defer_ && (g || goog.isDocumentLoading_());
    if (h || g) {
      a.defer(function() {
        c();
      });
    } else {
      var k = goog.global.document;
      h = goog.inHtmlDocument_() && "ActiveXObject" in goog.global;
      if (f && goog.inHtmlDocument_() && goog.isDocumentLoading_() && !h) {
        goog.Dependency.defer_ = !0;
        a.pause();
        var l = k.onreadystatechange;
        k.onreadystatechange = function() {
          "interactive" == k.readyState && (k.onreadystatechange = l, c(), a.resume());
          goog.isFunction(l) && l.apply(void 0, arguments);
        };
      } else {
        !goog.DebugLoader_.IS_OLD_IE_ && goog.inHtmlDocument_() && goog.isDocumentLoading_() ? d() : c();
      }
    }
  }
}, goog.TransformedDependency.prototype.transform = function(a) {
}, goog.TranspiledDependency = function(a, b, c, d, e, f) {
  goog.TransformedDependency.call(this, a, b, c, d, e);
  this.transpiler = f;
}, goog.inherits(goog.TranspiledDependency, goog.TransformedDependency), goog.TranspiledDependency.prototype.transform = function(a) {
  return this.transpiler.transpile(a, this.getPathName());
}, goog.PreTranspiledEs6ModuleDependency = function(a, b, c, d, e) {
  goog.TransformedDependency.call(this, a, b, c, d, e);
}, goog.inherits(goog.PreTranspiledEs6ModuleDependency, goog.TransformedDependency), goog.PreTranspiledEs6ModuleDependency.prototype.transform = function(a) {
  return a;
}, goog.GoogModuleDependency = function(a, b, c, d, e, f, g) {
  goog.TransformedDependency.call(this, a, b, c, d, e);
  this.needsTranspile_ = f;
  this.transpiler_ = g;
}, goog.inherits(goog.GoogModuleDependency, goog.TransformedDependency), goog.GoogModuleDependency.prototype.transform = function(a) {
  this.needsTranspile_ && (a = this.transpiler_.transpile(a, this.getPathName()));
  return goog.LOAD_MODULE_USING_EVAL && void 0 !== goog.global.JSON ? "goog.loadModule(" + goog.global.JSON.stringify(a + "\n//# sourceURL=" + this.path + "\n") + ");" : 'goog.loadModule(function(exports) {"use strict";' + a + "\n;return exports});\n//# sourceURL=" + this.path + "\n";
}, goog.DebugLoader_.IS_OLD_IE_ = !(goog.global.atob || !goog.global.document || !goog.global.document.all), goog.DebugLoader_.prototype.addDependency = function(a, b, c, d) {
  b = b || [];
  a = a.replace(/\\/g, "/");
  var e = goog.normalizePath_(goog.basePath + a);
  d && "boolean" !== typeof d || (d = d ? {module:goog.ModuleType.GOOG} : {});
  c = this.factory_.createDependency(e, a, b, c, d, goog.transpiler_.needsTranspile(d.lang || "es3", d.module));
  this.dependencies_[e] = c;
  for (c = 0; c < b.length; c++) {
    this.idToPath_[b[c]] = e;
  }
  this.idToPath_[a] = e;
}, goog.DependencyFactory = function(a) {
  this.transpiler = a;
}, goog.DependencyFactory.prototype.createDependency = function(a, b, c, d, e, f) {
  return e.module == goog.ModuleType.GOOG ? new goog.GoogModuleDependency(a, b, c, d, e, f, this.transpiler) : f ? new goog.TranspiledDependency(a, b, c, d, e, this.transpiler) : e.module == goog.ModuleType.ES6 ? "never" == goog.TRANSPILE && goog.ASSUME_ES_MODULES_TRANSPILED ? new goog.PreTranspiledEs6ModuleDependency(a, b, c, d, e) : new goog.Es6ModuleDependency(a, b, c, d, e) : new goog.Dependency(a, b, c, d, e);
}, goog.debugLoader_ = new goog.DebugLoader_, goog.loadClosureDeps = function() {
  goog.debugLoader_.loadClosureDeps();
}, goog.setDependencyFactory = function(a) {
  goog.debugLoader_.setDependencyFactory(a);
}, goog.global.CLOSURE_NO_DEPS || goog.debugLoader_.loadClosureDeps(), goog.bootstrap = function(a, b) {
  goog.debugLoader_.bootstrap(a, b);
});
goog.TRUSTED_TYPES_POLICY_NAME = "";
goog.identity_ = function(a) {
  return a;
};
goog.createTrustedTypesPolicy = function(a) {
  var b = null, c = goog.global.trustedTypes || goog.global.TrustedTypes;
  if (!c || !c.createPolicy) {
    return b;
  }
  try {
    b = c.createPolicy(a, {createHTML:goog.identity_, createScript:goog.identity_, createScriptURL:goog.identity_, createURL:goog.identity_});
  } catch (d) {
    goog.logToConsole_(d.message);
  }
  return b;
};
goog.TRUSTED_TYPES_POLICY_ = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#base") : null;
goog.string = {};
goog.string.StringBuffer = function(a, b) {
  null != a && this.append.apply(this, arguments);
};
goog.string.StringBuffer.prototype.buffer_ = "";
goog.string.StringBuffer.prototype.set = function(a) {
  this.buffer_ = "" + a;
};
goog.string.StringBuffer.prototype.append = function(a, b, c) {
  this.buffer_ += String(a);
  if (null != b) {
    for (var d = 1; d < arguments.length; d++) {
      this.buffer_ += arguments[d];
    }
  }
  return this;
};
goog.string.StringBuffer.prototype.clear = function() {
  this.buffer_ = "";
};
goog.string.StringBuffer.prototype.getLength = function() {
  return this.buffer_.length;
};
goog.string.StringBuffer.prototype.toString = function() {
  return this.buffer_;
};
goog.debug = {};
goog.debug.Error = function(a) {
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, goog.debug.Error);
  } else {
    var b = Error().stack;
    b && (this.stack = b);
  }
  a && (this.message = String(a));
  this.reportErrorToServer = !0;
};
goog.inherits(goog.debug.Error, Error);
goog.debug.Error.prototype.name = "CustomError";
goog.dom = {};
goog.dom.NodeType = {ELEMENT:1, ATTRIBUTE:2, TEXT:3, CDATA_SECTION:4, ENTITY_REFERENCE:5, ENTITY:6, PROCESSING_INSTRUCTION:7, COMMENT:8, DOCUMENT:9, DOCUMENT_TYPE:10, DOCUMENT_FRAGMENT:11, NOTATION:12};
goog.asserts = {};
goog.asserts.ENABLE_ASSERTS = goog.DEBUG;
goog.asserts.AssertionError = function(a, b) {
  goog.debug.Error.call(this, goog.asserts.subs_(a, b));
  this.messagePattern = a;
};
goog.inherits(goog.asserts.AssertionError, goog.debug.Error);
goog.asserts.AssertionError.prototype.name = "AssertionError";
goog.asserts.DEFAULT_ERROR_HANDLER = function(a) {
  throw a;
};
goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER;
goog.asserts.subs_ = function(a, b) {
  for (var c = a.split("%s"), d = "", e = c.length - 1, f = 0; f < e; f++) {
    d += c[f] + (f < b.length ? b[f] : "%s");
  }
  return d + c[e];
};
goog.asserts.doAssertFailure_ = function(a, b, c, d) {
  var e = "Assertion failed";
  if (c) {
    e += ": " + c;
    var f = d;
  } else {
    a && (e += ": " + a, f = b);
  }
  a = new goog.asserts.AssertionError("" + e, f || []);
  goog.asserts.errorHandler_(a);
};
goog.asserts.setErrorHandler = function(a) {
  goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = a);
};
goog.asserts.assert = function(a, b, c) {
  goog.asserts.ENABLE_ASSERTS && !a && goog.asserts.doAssertFailure_("", null, b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertExists = function(a, b, c) {
  goog.asserts.ENABLE_ASSERTS && null == a && goog.asserts.doAssertFailure_("Expected to exist: %s.", [a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.fail = function(a, b) {
  goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1)));
};
goog.asserts.assertNumber = function(a, b, c) {
  goog.asserts.ENABLE_ASSERTS && "number" !== typeof a && goog.asserts.doAssertFailure_("Expected number but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertString = function(a, b, c) {
  goog.asserts.ENABLE_ASSERTS && "string" !== typeof a && goog.asserts.doAssertFailure_("Expected string but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertFunction = function(a, b, c) {
  goog.asserts.ENABLE_ASSERTS && !goog.isFunction(a) && goog.asserts.doAssertFailure_("Expected function but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertObject = function(a, b, c) {
  goog.asserts.ENABLE_ASSERTS && !goog.isObject(a) && goog.asserts.doAssertFailure_("Expected object but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertArray = function(a, b, c) {
  goog.asserts.ENABLE_ASSERTS && !goog.isArray(a) && goog.asserts.doAssertFailure_("Expected array but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertBoolean = function(a, b, c) {
  goog.asserts.ENABLE_ASSERTS && "boolean" !== typeof a && goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertElement = function(a, b, c) {
  !goog.asserts.ENABLE_ASSERTS || goog.isObject(a) && a.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_("Expected Element but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertInstanceof = function(a, b, c, d) {
  !goog.asserts.ENABLE_ASSERTS || a instanceof b || goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.", [goog.asserts.getType_(b), goog.asserts.getType_(a)], c, Array.prototype.slice.call(arguments, 3));
  return a;
};
goog.asserts.assertFinite = function(a, b, c) {
  !goog.asserts.ENABLE_ASSERTS || "number" == typeof a && isFinite(a) || goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.", [a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertObjectPrototypeIsIntact = function() {
  for (var a in Object.prototype) {
    goog.asserts.fail(a + " should not be enumerable in Object.prototype.");
  }
};
goog.asserts.getType_ = function(a) {
  return a instanceof Function ? a.displayName || a.name || "unknown type name" : a instanceof Object ? a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a) : null === a ? "null" : typeof a;
};
goog.array = {};
goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE;
goog.array.ASSUME_NATIVE_FUNCTIONS = 2012 < goog.FEATURESET_YEAR;
goog.array.peek = function(a) {
  return a[a.length - 1];
};
goog.array.last = goog.array.peek;
goog.array.indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function(a, b, c) {
  goog.asserts.assert(null != a.length);
  return Array.prototype.indexOf.call(a, b, c);
} : function(a, b, c) {
  c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;
  if ("string" === typeof a) {
    return "string" !== typeof b || 1 != b.length ? -1 : a.indexOf(b, c);
  }
  for (; c < a.length; c++) {
    if (c in a && a[c] === b) {
      return c;
    }
  }
  return -1;
};
goog.array.lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function(a, b, c) {
  goog.asserts.assert(null != a.length);
  return Array.prototype.lastIndexOf.call(a, b, null == c ? a.length - 1 : c);
} : function(a, b, c) {
  c = null == c ? a.length - 1 : c;
  0 > c && (c = Math.max(0, a.length + c));
  if ("string" === typeof a) {
    return "string" !== typeof b || 1 != b.length ? -1 : a.lastIndexOf(b, c);
  }
  for (; 0 <= c; c--) {
    if (c in a && a[c] === b) {
      return c;
    }
  }
  return -1;
};
goog.array.forEach = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function(a, b, c) {
  goog.asserts.assert(null != a.length);
  Array.prototype.forEach.call(a, b, c);
} : function(a, b, c) {
  for (var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++) {
    f in e && b.call(c, e[f], f, a);
  }
};
goog.array.forEachRight = function(a, b, c) {
  var d = a.length, e = "string" === typeof a ? a.split("") : a;
  for (--d; 0 <= d; --d) {
    d in e && b.call(c, e[d], d, a);
  }
};
goog.array.filter = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function(a, b, c) {
  goog.asserts.assert(null != a.length);
  return Array.prototype.filter.call(a, b, c);
} : function(a, b, c) {
  for (var d = a.length, e = [], f = 0, g = "string" === typeof a ? a.split("") : a, h = 0; h < d; h++) {
    if (h in g) {
      var k = g[h];
      b.call(c, k, h, a) && (e[f++] = k);
    }
  }
  return e;
};
goog.array.map = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function(a, b, c) {
  goog.asserts.assert(null != a.length);
  return Array.prototype.map.call(a, b, c);
} : function(a, b, c) {
  for (var d = a.length, e = Array(d), f = "string" === typeof a ? a.split("") : a, g = 0; g < d; g++) {
    g in f && (e[g] = b.call(c, f[g], g, a));
  }
  return e;
};
goog.array.reduce = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function(a, b, c, d) {
  goog.asserts.assert(null != a.length);
  d && (b = goog.bind(b, d));
  return Array.prototype.reduce.call(a, b, c);
} : function(a, b, c, d) {
  var e = c;
  goog.array.forEach(a, function(c, g) {
    e = b.call(d, e, c, g, a);
  });
  return e;
};
goog.array.reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function(a, b, c, d) {
  goog.asserts.assert(null != a.length);
  goog.asserts.assert(null != b);
  d && (b = goog.bind(b, d));
  return Array.prototype.reduceRight.call(a, b, c);
} : function(a, b, c, d) {
  var e = c;
  goog.array.forEachRight(a, function(c, g) {
    e = b.call(d, e, c, g, a);
  });
  return e;
};
goog.array.some = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function(a, b, c) {
  goog.asserts.assert(null != a.length);
  return Array.prototype.some.call(a, b, c);
} : function(a, b, c) {
  for (var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++) {
    if (f in e && b.call(c, e[f], f, a)) {
      return !0;
    }
  }
  return !1;
};
goog.array.every = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function(a, b, c) {
  goog.asserts.assert(null != a.length);
  return Array.prototype.every.call(a, b, c);
} : function(a, b, c) {
  for (var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++) {
    if (f in e && !b.call(c, e[f], f, a)) {
      return !1;
    }
  }
  return !0;
};
goog.array.count = function(a, b, c) {
  var d = 0;
  goog.array.forEach(a, function(a, f, g) {
    b.call(c, a, f, g) && ++d;
  }, c);
  return d;
};
goog.array.find = function(a, b, c) {
  b = goog.array.findIndex(a, b, c);
  return 0 > b ? null : "string" === typeof a ? a.charAt(b) : a[b];
};
goog.array.findIndex = function(a, b, c) {
  for (var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++) {
    if (f in e && b.call(c, e[f], f, a)) {
      return f;
    }
  }
  return -1;
};
goog.array.findRight = function(a, b, c) {
  b = goog.array.findIndexRight(a, b, c);
  return 0 > b ? null : "string" === typeof a ? a.charAt(b) : a[b];
};
goog.array.findIndexRight = function(a, b, c) {
  var d = a.length, e = "string" === typeof a ? a.split("") : a;
  for (--d; 0 <= d; d--) {
    if (d in e && b.call(c, e[d], d, a)) {
      return d;
    }
  }
  return -1;
};
goog.array.contains = function(a, b) {
  return 0 <= goog.array.indexOf(a, b);
};
goog.array.isEmpty = function(a) {
  return 0 == a.length;
};
goog.array.clear = function(a) {
  if (!goog.isArray(a)) {
    for (var b = a.length - 1; 0 <= b; b--) {
      delete a[b];
    }
  }
  a.length = 0;
};
goog.array.insert = function(a, b) {
  goog.array.contains(a, b) || a.push(b);
};
goog.array.insertAt = function(a, b, c) {
  goog.array.splice(a, c, 0, b);
};
goog.array.insertArrayAt = function(a, b, c) {
  goog.partial(goog.array.splice, a, c, 0).apply(null, b);
};
goog.array.insertBefore = function(a, b, c) {
  var d;
  2 == arguments.length || 0 > (d = goog.array.indexOf(a, c)) ? a.push(b) : goog.array.insertAt(a, b, d);
};
goog.array.remove = function(a, b) {
  var c = goog.array.indexOf(a, b), d;
  (d = 0 <= c) && goog.array.removeAt(a, c);
  return d;
};
goog.array.removeLast = function(a, b) {
  var c = goog.array.lastIndexOf(a, b);
  return 0 <= c ? (goog.array.removeAt(a, c), !0) : !1;
};
goog.array.removeAt = function(a, b) {
  goog.asserts.assert(null != a.length);
  return 1 == Array.prototype.splice.call(a, b, 1).length;
};
goog.array.removeIf = function(a, b, c) {
  b = goog.array.findIndex(a, b, c);
  return 0 <= b ? (goog.array.removeAt(a, b), !0) : !1;
};
goog.array.removeAllIf = function(a, b, c) {
  var d = 0;
  goog.array.forEachRight(a, function(e, f) {
    b.call(c, e, f, a) && goog.array.removeAt(a, f) && d++;
  });
  return d;
};
goog.array.concat = function(a) {
  return Array.prototype.concat.apply([], arguments);
};
goog.array.join = function(a) {
  return Array.prototype.concat.apply([], arguments);
};
goog.array.toArray = function(a) {
  var b = a.length;
  if (0 < b) {
    for (var c = Array(b), d = 0; d < b; d++) {
      c[d] = a[d];
    }
    return c;
  }
  return [];
};
goog.array.clone = goog.array.toArray;
goog.array.extend = function(a, b) {
  for (var c = 1; c < arguments.length; c++) {
    var d = arguments[c];
    if (goog.isArrayLike(d)) {
      var e = a.length || 0, f = d.length || 0;
      a.length = e + f;
      for (var g = 0; g < f; g++) {
        a[e + g] = d[g];
      }
    } else {
      a.push(d);
    }
  }
};
goog.array.splice = function(a, b, c, d) {
  goog.asserts.assert(null != a.length);
  return Array.prototype.splice.apply(a, goog.array.slice(arguments, 1));
};
goog.array.slice = function(a, b, c) {
  goog.asserts.assert(null != a.length);
  return 2 >= arguments.length ? Array.prototype.slice.call(a, b) : Array.prototype.slice.call(a, b, c);
};
goog.array.removeDuplicates = function(a, b, c) {
  b = b || a;
  var d = function(a) {
    return goog.isObject(a) ? "o" + goog.getUid(a) : (typeof a).charAt(0) + a;
  };
  c = c || d;
  d = {};
  for (var e = 0, f = 0; f < a.length;) {
    var g = a[f++], h = c(g);
    Object.prototype.hasOwnProperty.call(d, h) || (d[h] = !0, b[e++] = g);
  }
  b.length = e;
};
goog.array.binarySearch = function(a, b, c) {
  return goog.array.binarySearch_(a, c || goog.array.defaultCompare, !1, b);
};
goog.array.binarySelect = function(a, b, c) {
  return goog.array.binarySearch_(a, b, !0, void 0, c);
};
goog.array.binarySearch_ = function(a, b, c, d, e) {
  for (var f = 0, g = a.length, h; f < g;) {
    var k = f + (g - f >>> 1);
    var l = c ? b.call(e, a[k], k, a) : b(d, a[k]);
    0 < l ? f = k + 1 : (g = k, h = !l);
  }
  return h ? f : -f - 1;
};
goog.array.sort = function(a, b) {
  a.sort(b || goog.array.defaultCompare);
};
goog.array.stableSort = function(a, b) {
  for (var c = Array(a.length), d = 0; d < a.length; d++) {
    c[d] = {index:d, value:a[d]};
  }
  var e = b || goog.array.defaultCompare;
  goog.array.sort(c, function(a, b) {
    return e(a.value, b.value) || a.index - b.index;
  });
  for (d = 0; d < a.length; d++) {
    a[d] = c[d].value;
  }
};
goog.array.sortByKey = function(a, b, c) {
  var d = c || goog.array.defaultCompare;
  goog.array.sort(a, function(a, c) {
    return d(b(a), b(c));
  });
};
goog.array.sortObjectsByKey = function(a, b, c) {
  goog.array.sortByKey(a, function(a) {
    return a[b];
  }, c);
};
goog.array.isSorted = function(a, b, c) {
  b = b || goog.array.defaultCompare;
  for (var d = 1; d < a.length; d++) {
    var e = b(a[d - 1], a[d]);
    if (0 < e || 0 == e && c) {
      return !1;
    }
  }
  return !0;
};
goog.array.equals = function(a, b, c) {
  if (!goog.isArrayLike(a) || !goog.isArrayLike(b) || a.length != b.length) {
    return !1;
  }
  var d = a.length;
  c = c || goog.array.defaultCompareEquality;
  for (var e = 0; e < d; e++) {
    if (!c(a[e], b[e])) {
      return !1;
    }
  }
  return !0;
};
goog.array.compare3 = function(a, b, c) {
  c = c || goog.array.defaultCompare;
  for (var d = Math.min(a.length, b.length), e = 0; e < d; e++) {
    var f = c(a[e], b[e]);
    if (0 != f) {
      return f;
    }
  }
  return goog.array.defaultCompare(a.length, b.length);
};
goog.array.defaultCompare = function(a, b) {
  return a > b ? 1 : a < b ? -1 : 0;
};
goog.array.inverseDefaultCompare = function(a, b) {
  return -goog.array.defaultCompare(a, b);
};
goog.array.defaultCompareEquality = function(a, b) {
  return a === b;
};
goog.array.binaryInsert = function(a, b, c) {
  c = goog.array.binarySearch(a, b, c);
  return 0 > c ? (goog.array.insertAt(a, b, -(c + 1)), !0) : !1;
};
goog.array.binaryRemove = function(a, b, c) {
  b = goog.array.binarySearch(a, b, c);
  return 0 <= b ? goog.array.removeAt(a, b) : !1;
};
goog.array.bucket = function(a, b, c) {
  for (var d = {}, e = 0; e < a.length; e++) {
    var f = a[e], g = b.call(c, f, e, a);
    void 0 !== g && (d[g] || (d[g] = [])).push(f);
  }
  return d;
};
goog.array.toObject = function(a, b, c) {
  var d = {};
  goog.array.forEach(a, function(e, f) {
    d[b.call(c, e, f, a)] = e;
  });
  return d;
};
goog.array.range = function(a, b, c) {
  var d = [], e = 0, f = a;
  c = c || 1;
  void 0 !== b && (e = a, f = b);
  if (0 > c * (f - e)) {
    return [];
  }
  if (0 < c) {
    for (a = e; a < f; a += c) {
      d.push(a);
    }
  } else {
    for (a = e; a > f; a += c) {
      d.push(a);
    }
  }
  return d;
};
goog.array.repeat = function(a, b) {
  for (var c = [], d = 0; d < b; d++) {
    c[d] = a;
  }
  return c;
};
goog.array.flatten = function(a) {
  for (var b = [], c = 0; c < arguments.length; c++) {
    var d = arguments[c];
    if (goog.isArray(d)) {
      for (var e = 0; e < d.length; e += 8192) {
        var f = goog.array.slice(d, e, e + 8192);
        f = goog.array.flatten.apply(null, f);
        for (var g = 0; g < f.length; g++) {
          b.push(f[g]);
        }
      }
    } else {
      b.push(d);
    }
  }
  return b;
};
goog.array.rotate = function(a, b) {
  goog.asserts.assert(null != a.length);
  a.length && (b %= a.length, 0 < b ? Array.prototype.unshift.apply(a, a.splice(-b, b)) : 0 > b && Array.prototype.push.apply(a, a.splice(0, -b)));
  return a;
};
goog.array.moveItem = function(a, b, c) {
  goog.asserts.assert(0 <= b && b < a.length);
  goog.asserts.assert(0 <= c && c < a.length);
  b = Array.prototype.splice.call(a, b, 1);
  Array.prototype.splice.call(a, c, 0, b[0]);
};
goog.array.zip = function(a) {
  if (!arguments.length) {
    return [];
  }
  for (var b = [], c = arguments[0].length, d = 1; d < arguments.length; d++) {
    arguments[d].length < c && (c = arguments[d].length);
  }
  for (d = 0; d < c; d++) {
    for (var e = [], f = 0; f < arguments.length; f++) {
      e.push(arguments[f][d]);
    }
    b.push(e);
  }
  return b;
};
goog.array.shuffle = function(a, b) {
  for (var c = b || Math.random, d = a.length - 1; 0 < d; d--) {
    var e = Math.floor(c() * (d + 1)), f = a[d];
    a[d] = a[e];
    a[e] = f;
  }
};
goog.array.copyByIndex = function(a, b) {
  var c = [];
  goog.array.forEach(b, function(b) {
    c.push(a[b]);
  });
  return c;
};
goog.array.concatMap = function(a, b, c) {
  return goog.array.concat.apply([], goog.array.map(a, b, c));
};
goog.object = {};
goog.object.is = function(a, b) {
  return a === b ? 0 !== a || 1 / a === 1 / b : a !== a && b !== b;
};
goog.object.forEach = function(a, b, c) {
  for (var d in a) {
    b.call(c, a[d], d, a);
  }
};
goog.object.filter = function(a, b, c) {
  var d = {}, e;
  for (e in a) {
    b.call(c, a[e], e, a) && (d[e] = a[e]);
  }
  return d;
};
goog.object.map = function(a, b, c) {
  var d = {}, e;
  for (e in a) {
    d[e] = b.call(c, a[e], e, a);
  }
  return d;
};
goog.object.some = function(a, b, c) {
  for (var d in a) {
    if (b.call(c, a[d], d, a)) {
      return !0;
    }
  }
  return !1;
};
goog.object.every = function(a, b, c) {
  for (var d in a) {
    if (!b.call(c, a[d], d, a)) {
      return !1;
    }
  }
  return !0;
};
goog.object.getCount = function(a) {
  var b = 0, c;
  for (c in a) {
    b++;
  }
  return b;
};
goog.object.getAnyKey = function(a) {
  for (var b in a) {
    return b;
  }
};
goog.object.getAnyValue = function(a) {
  for (var b in a) {
    return a[b];
  }
};
goog.object.contains = function(a, b) {
  return goog.object.containsValue(a, b);
};
goog.object.getValues = function(a) {
  var b = [], c = 0, d;
  for (d in a) {
    b[c++] = a[d];
  }
  return b;
};
goog.object.getKeys = function(a) {
  var b = [], c = 0, d;
  for (d in a) {
    b[c++] = d;
  }
  return b;
};
goog.object.getValueByKeys = function(a, b) {
  var c = goog.isArrayLike(b), d = c ? b : arguments;
  for (c = c ? 0 : 1; c < d.length; c++) {
    if (null == a) {
      return;
    }
    a = a[d[c]];
  }
  return a;
};
goog.object.containsKey = function(a, b) {
  return null !== a && b in a;
};
goog.object.containsValue = function(a, b) {
  for (var c in a) {
    if (a[c] == b) {
      return !0;
    }
  }
  return !1;
};
goog.object.findKey = function(a, b, c) {
  for (var d in a) {
    if (b.call(c, a[d], d, a)) {
      return d;
    }
  }
};
goog.object.findValue = function(a, b, c) {
  return (b = goog.object.findKey(a, b, c)) && a[b];
};
goog.object.isEmpty = function(a) {
  for (var b in a) {
    return !1;
  }
  return !0;
};
goog.object.clear = function(a) {
  for (var b in a) {
    delete a[b];
  }
};
goog.object.remove = function(a, b) {
  var c;
  (c = b in a) && delete a[b];
  return c;
};
goog.object.add = function(a, b, c) {
  if (null !== a && b in a) {
    throw Error('The object already contains the key "' + b + '"');
  }
  goog.object.set(a, b, c);
};
goog.object.get = function(a, b, c) {
  return null !== a && b in a ? a[b] : c;
};
goog.object.set = function(a, b, c) {
  a[b] = c;
};
goog.object.setIfUndefined = function(a, b, c) {
  return b in a ? a[b] : a[b] = c;
};
goog.object.setWithReturnValueIfNotSet = function(a, b, c) {
  if (b in a) {
    return a[b];
  }
  c = c();
  return a[b] = c;
};
goog.object.equals = function(a, b) {
  for (var c in a) {
    if (!(c in b) || a[c] !== b[c]) {
      return !1;
    }
  }
  for (var d in b) {
    if (!(d in a)) {
      return !1;
    }
  }
  return !0;
};
goog.object.clone = function(a) {
  var b = {}, c;
  for (c in a) {
    b[c] = a[c];
  }
  return b;
};
goog.object.unsafeClone = function(a) {
  var b = goog.typeOf(a);
  if ("object" == b || "array" == b) {
    if (goog.isFunction(a.clone)) {
      return a.clone();
    }
    b = "array" == b ? [] : {};
    for (var c in a) {
      b[c] = goog.object.unsafeClone(a[c]);
    }
    return b;
  }
  return a;
};
goog.object.transpose = function(a) {
  var b = {}, c;
  for (c in a) {
    b[a[c]] = c;
  }
  return b;
};
goog.object.PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
goog.object.extend = function(a, b) {
  for (var c, d, e = 1; e < arguments.length; e++) {
    d = arguments[e];
    for (c in d) {
      a[c] = d[c];
    }
    for (var f = 0; f < goog.object.PROTOTYPE_FIELDS_.length; f++) {
      c = goog.object.PROTOTYPE_FIELDS_[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
    }
  }
};
goog.object.create = function(a) {
  var b = arguments.length;
  if (1 == b && goog.isArray(arguments[0])) {
    return goog.object.create.apply(null, arguments[0]);
  }
  if (b % 2) {
    throw Error("Uneven number of arguments");
  }
  for (var c = {}, d = 0; d < b; d += 2) {
    c[arguments[d]] = arguments[d + 1];
  }
  return c;
};
goog.object.createSet = function(a) {
  var b = arguments.length;
  if (1 == b && goog.isArray(arguments[0])) {
    return goog.object.createSet.apply(null, arguments[0]);
  }
  for (var c = {}, d = 0; d < b; d++) {
    c[arguments[d]] = !0;
  }
  return c;
};
goog.object.createImmutableView = function(a) {
  var b = a;
  Object.isFrozen && !Object.isFrozen(a) && (b = Object.create(a), Object.freeze(b));
  return b;
};
goog.object.isImmutableView = function(a) {
  return !!Object.isFrozen && Object.isFrozen(a);
};
goog.object.getAllPropertyNames = function(a, b, c) {
  if (!a) {
    return [];
  }
  if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) {
    return goog.object.getKeys(a);
  }
  for (var d = {}; a && (a !== Object.prototype || b) && (a !== Function.prototype || c);) {
    for (var e = Object.getOwnPropertyNames(a), f = 0; f < e.length; f++) {
      d[e[f]] = !0;
    }
    a = Object.getPrototypeOf(a);
  }
  return goog.object.getKeys(d);
};
goog.object.getSuperClass = function(a) {
  return (a = Object.getPrototypeOf(a.prototype)) && a.constructor;
};
goog.dom.asserts = {};
goog.dom.asserts.assertIsLocation = function(a) {
  if (goog.asserts.ENABLE_ASSERTS) {
    var b = goog.dom.asserts.getWindow_(a);
    b && (!a || !(a instanceof b.Location) && a instanceof b.Element) && goog.asserts.fail("Argument is not a Location (or a non-Element mock); got: %s", goog.dom.asserts.debugStringForType_(a));
  }
  return a;
};
goog.dom.asserts.assertIsElementType_ = function(a, b) {
  if (goog.asserts.ENABLE_ASSERTS) {
    var c = goog.dom.asserts.getWindow_(a);
    c && "undefined" != typeof c[b] && (a && (a instanceof c[b] || !(a instanceof c.Location || a instanceof c.Element)) || goog.asserts.fail("Argument is not a %s (or a non-Element, non-Location mock); got: %s", b, goog.dom.asserts.debugStringForType_(a)));
  }
  return a;
};
goog.dom.asserts.assertIsHTMLAnchorElement = function(a) {
  return goog.dom.asserts.assertIsElementType_(a, "HTMLAnchorElement");
};
goog.dom.asserts.assertIsHTMLButtonElement = function(a) {
  return goog.dom.asserts.assertIsElementType_(a, "HTMLButtonElement");
};
goog.dom.asserts.assertIsHTMLLinkElement = function(a) {
  return goog.dom.asserts.assertIsElementType_(a, "HTMLLinkElement");
};
goog.dom.asserts.assertIsHTMLImageElement = function(a) {
  return goog.dom.asserts.assertIsElementType_(a, "HTMLImageElement");
};
goog.dom.asserts.assertIsHTMLAudioElement = function(a) {
  return goog.dom.asserts.assertIsElementType_(a, "HTMLAudioElement");
};
goog.dom.asserts.assertIsHTMLVideoElement = function(a) {
  return goog.dom.asserts.assertIsElementType_(a, "HTMLVideoElement");
};
goog.dom.asserts.assertIsHTMLInputElement = function(a) {
  return goog.dom.asserts.assertIsElementType_(a, "HTMLInputElement");
};
goog.dom.asserts.assertIsHTMLTextAreaElement = function(a) {
  return goog.dom.asserts.assertIsElementType_(a, "HTMLTextAreaElement");
};
goog.dom.asserts.assertIsHTMLCanvasElement = function(a) {
  return goog.dom.asserts.assertIsElementType_(a, "HTMLCanvasElement");
};
goog.dom.asserts.assertIsHTMLEmbedElement = function(a) {
  return goog.dom.asserts.assertIsElementType_(a, "HTMLEmbedElement");
};
goog.dom.asserts.assertIsHTMLFormElement = function(a) {
  return goog.dom.asserts.assertIsElementType_(a, "HTMLFormElement");
};
goog.dom.asserts.assertIsHTMLFrameElement = function(a) {
  return goog.dom.asserts.assertIsElementType_(a, "HTMLFrameElement");
};
goog.dom.asserts.assertIsHTMLIFrameElement = function(a) {
  return goog.dom.asserts.assertIsElementType_(a, "HTMLIFrameElement");
};
goog.dom.asserts.assertIsHTMLObjectElement = function(a) {
  return goog.dom.asserts.assertIsElementType_(a, "HTMLObjectElement");
};
goog.dom.asserts.assertIsHTMLScriptElement = function(a) {
  return goog.dom.asserts.assertIsElementType_(a, "HTMLScriptElement");
};
goog.dom.asserts.debugStringForType_ = function(a) {
  if (goog.isObject(a)) {
    try {
      return a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a);
    } catch (b) {
      return "<object could not be stringified>";
    }
  } else {
    return void 0 === a ? "undefined" : null === a ? "null" : typeof a;
  }
};
goog.dom.asserts.getWindow_ = function(a) {
  try {
    var b = a && a.ownerDocument, c = b && (b.defaultView || b.parentWindow);
    c = c || goog.global;
    if (c.Element && c.Location) {
      return c;
    }
  } catch (d) {
  }
  return null;
};
goog.functions = {};
goog.functions.constant = function(a) {
  return function() {
    return a;
  };
};
goog.functions.FALSE = function() {
  return !1;
};
goog.functions.TRUE = function() {
  return !0;
};
goog.functions.NULL = function() {
  return null;
};
goog.functions.identity = function(a, b) {
  return a;
};
goog.functions.error = function(a) {
  return function() {
    throw Error(a);
  };
};
goog.functions.fail = function(a) {
  return function() {
    throw a;
  };
};
goog.functions.lock = function(a, b) {
  b = b || 0;
  return function() {
    return a.apply(this, Array.prototype.slice.call(arguments, 0, b));
  };
};
goog.functions.nth = function(a) {
  return function() {
    return arguments[a];
  };
};
goog.functions.partialRight = function(a, b) {
  var c = Array.prototype.slice.call(arguments, 1);
  return function() {
    var b = Array.prototype.slice.call(arguments);
    b.push.apply(b, c);
    return a.apply(this, b);
  };
};
goog.functions.withReturnValue = function(a, b) {
  return goog.functions.sequence(a, goog.functions.constant(b));
};
goog.functions.equalTo = function(a, b) {
  return function(c) {
    return b ? a == c : a === c;
  };
};
goog.functions.compose = function(a, b) {
  var c = arguments, d = c.length;
  return function() {
    var a;
    d && (a = c[d - 1].apply(this, arguments));
    for (var b = d - 2; 0 <= b; b--) {
      a = c[b].call(this, a);
    }
    return a;
  };
};
goog.functions.sequence = function(a) {
  var b = arguments, c = b.length;
  return function() {
    for (var a, e = 0; e < c; e++) {
      a = b[e].apply(this, arguments);
    }
    return a;
  };
};
goog.functions.and = function(a) {
  var b = arguments, c = b.length;
  return function() {
    for (var a = 0; a < c; a++) {
      if (!b[a].apply(this, arguments)) {
        return !1;
      }
    }
    return !0;
  };
};
goog.functions.or = function(a) {
  var b = arguments, c = b.length;
  return function() {
    for (var a = 0; a < c; a++) {
      if (b[a].apply(this, arguments)) {
        return !0;
      }
    }
    return !1;
  };
};
goog.functions.not = function(a) {
  return function() {
    return !a.apply(this, arguments);
  };
};
goog.functions.create = function(a, b) {
  var c = function() {
  };
  c.prototype = a.prototype;
  c = new c;
  a.apply(c, Array.prototype.slice.call(arguments, 1));
  return c;
};
goog.functions.CACHE_RETURN_VALUE = !0;
goog.functions.cacheReturnValue = function(a) {
  var b = !1, c;
  return function() {
    if (!goog.functions.CACHE_RETURN_VALUE) {
      return a();
    }
    b || (c = a(), b = !0);
    return c;
  };
};
goog.functions.once = function(a) {
  var b = a;
  return function() {
    if (b) {
      var a = b;
      b = null;
      a();
    }
  };
};
goog.functions.debounce = function(a, b, c) {
  var d = 0;
  return function(e) {
    goog.global.clearTimeout(d);
    var f = arguments;
    d = goog.global.setTimeout(function() {
      a.apply(c, f);
    }, b);
  };
};
goog.functions.throttle = function(a, b, c) {
  var d = 0, e = !1, f = [], g = function() {
    d = 0;
    e && (e = !1, h());
  }, h = function() {
    d = goog.global.setTimeout(g, b);
    a.apply(c, f);
  };
  return function(a) {
    f = arguments;
    d ? e = !0 : h();
  };
};
goog.functions.rateLimit = function(a, b, c) {
  var d = 0, e = function() {
    d = 0;
  };
  return function(f) {
    d || (d = goog.global.setTimeout(e, b), a.apply(c, arguments));
  };
};
goog.dom.HtmlElement = function() {
};
goog.dom.TagName = function(a) {
  this.tagName_ = a;
};
goog.dom.TagName.prototype.toString = function() {
  return this.tagName_;
};
goog.dom.TagName.A = new goog.dom.TagName("A");
goog.dom.TagName.ABBR = new goog.dom.TagName("ABBR");
goog.dom.TagName.ACRONYM = new goog.dom.TagName("ACRONYM");
goog.dom.TagName.ADDRESS = new goog.dom.TagName("ADDRESS");
goog.dom.TagName.APPLET = new goog.dom.TagName("APPLET");
goog.dom.TagName.AREA = new goog.dom.TagName("AREA");
goog.dom.TagName.ARTICLE = new goog.dom.TagName("ARTICLE");
goog.dom.TagName.ASIDE = new goog.dom.TagName("ASIDE");
goog.dom.TagName.AUDIO = new goog.dom.TagName("AUDIO");
goog.dom.TagName.B = new goog.dom.TagName("B");
goog.dom.TagName.BASE = new goog.dom.TagName("BASE");
goog.dom.TagName.BASEFONT = new goog.dom.TagName("BASEFONT");
goog.dom.TagName.BDI = new goog.dom.TagName("BDI");
goog.dom.TagName.BDO = new goog.dom.TagName("BDO");
goog.dom.TagName.BIG = new goog.dom.TagName("BIG");
goog.dom.TagName.BLOCKQUOTE = new goog.dom.TagName("BLOCKQUOTE");
goog.dom.TagName.BODY = new goog.dom.TagName("BODY");
goog.dom.TagName.BR = new goog.dom.TagName("BR");
goog.dom.TagName.BUTTON = new goog.dom.TagName("BUTTON");
goog.dom.TagName.CANVAS = new goog.dom.TagName("CANVAS");
goog.dom.TagName.CAPTION = new goog.dom.TagName("CAPTION");
goog.dom.TagName.CENTER = new goog.dom.TagName("CENTER");
goog.dom.TagName.CITE = new goog.dom.TagName("CITE");
goog.dom.TagName.CODE = new goog.dom.TagName("CODE");
goog.dom.TagName.COL = new goog.dom.TagName("COL");
goog.dom.TagName.COLGROUP = new goog.dom.TagName("COLGROUP");
goog.dom.TagName.COMMAND = new goog.dom.TagName("COMMAND");
goog.dom.TagName.DATA = new goog.dom.TagName("DATA");
goog.dom.TagName.DATALIST = new goog.dom.TagName("DATALIST");
goog.dom.TagName.DD = new goog.dom.TagName("DD");
goog.dom.TagName.DEL = new goog.dom.TagName("DEL");
goog.dom.TagName.DETAILS = new goog.dom.TagName("DETAILS");
goog.dom.TagName.DFN = new goog.dom.TagName("DFN");
goog.dom.TagName.DIALOG = new goog.dom.TagName("DIALOG");
goog.dom.TagName.DIR = new goog.dom.TagName("DIR");
goog.dom.TagName.DIV = new goog.dom.TagName("DIV");
goog.dom.TagName.DL = new goog.dom.TagName("DL");
goog.dom.TagName.DT = new goog.dom.TagName("DT");
goog.dom.TagName.EM = new goog.dom.TagName("EM");
goog.dom.TagName.EMBED = new goog.dom.TagName("EMBED");
goog.dom.TagName.FIELDSET = new goog.dom.TagName("FIELDSET");
goog.dom.TagName.FIGCAPTION = new goog.dom.TagName("FIGCAPTION");
goog.dom.TagName.FIGURE = new goog.dom.TagName("FIGURE");
goog.dom.TagName.FONT = new goog.dom.TagName("FONT");
goog.dom.TagName.FOOTER = new goog.dom.TagName("FOOTER");
goog.dom.TagName.FORM = new goog.dom.TagName("FORM");
goog.dom.TagName.FRAME = new goog.dom.TagName("FRAME");
goog.dom.TagName.FRAMESET = new goog.dom.TagName("FRAMESET");
goog.dom.TagName.H1 = new goog.dom.TagName("H1");
goog.dom.TagName.H2 = new goog.dom.TagName("H2");
goog.dom.TagName.H3 = new goog.dom.TagName("H3");
goog.dom.TagName.H4 = new goog.dom.TagName("H4");
goog.dom.TagName.H5 = new goog.dom.TagName("H5");
goog.dom.TagName.H6 = new goog.dom.TagName("H6");
goog.dom.TagName.HEAD = new goog.dom.TagName("HEAD");
goog.dom.TagName.HEADER = new goog.dom.TagName("HEADER");
goog.dom.TagName.HGROUP = new goog.dom.TagName("HGROUP");
goog.dom.TagName.HR = new goog.dom.TagName("HR");
goog.dom.TagName.HTML = new goog.dom.TagName("HTML");
goog.dom.TagName.I = new goog.dom.TagName("I");
goog.dom.TagName.IFRAME = new goog.dom.TagName("IFRAME");
goog.dom.TagName.IMG = new goog.dom.TagName("IMG");
goog.dom.TagName.INPUT = new goog.dom.TagName("INPUT");
goog.dom.TagName.INS = new goog.dom.TagName("INS");
goog.dom.TagName.ISINDEX = new goog.dom.TagName("ISINDEX");
goog.dom.TagName.KBD = new goog.dom.TagName("KBD");
goog.dom.TagName.KEYGEN = new goog.dom.TagName("KEYGEN");
goog.dom.TagName.LABEL = new goog.dom.TagName("LABEL");
goog.dom.TagName.LEGEND = new goog.dom.TagName("LEGEND");
goog.dom.TagName.LI = new goog.dom.TagName("LI");
goog.dom.TagName.LINK = new goog.dom.TagName("LINK");
goog.dom.TagName.MAIN = new goog.dom.TagName("MAIN");
goog.dom.TagName.MAP = new goog.dom.TagName("MAP");
goog.dom.TagName.MARK = new goog.dom.TagName("MARK");
goog.dom.TagName.MATH = new goog.dom.TagName("MATH");
goog.dom.TagName.MENU = new goog.dom.TagName("MENU");
goog.dom.TagName.MENUITEM = new goog.dom.TagName("MENUITEM");
goog.dom.TagName.META = new goog.dom.TagName("META");
goog.dom.TagName.METER = new goog.dom.TagName("METER");
goog.dom.TagName.NAV = new goog.dom.TagName("NAV");
goog.dom.TagName.NOFRAMES = new goog.dom.TagName("NOFRAMES");
goog.dom.TagName.NOSCRIPT = new goog.dom.TagName("NOSCRIPT");
goog.dom.TagName.OBJECT = new goog.dom.TagName("OBJECT");
goog.dom.TagName.OL = new goog.dom.TagName("OL");
goog.dom.TagName.OPTGROUP = new goog.dom.TagName("OPTGROUP");
goog.dom.TagName.OPTION = new goog.dom.TagName("OPTION");
goog.dom.TagName.OUTPUT = new goog.dom.TagName("OUTPUT");
goog.dom.TagName.P = new goog.dom.TagName("P");
goog.dom.TagName.PARAM = new goog.dom.TagName("PARAM");
goog.dom.TagName.PICTURE = new goog.dom.TagName("PICTURE");
goog.dom.TagName.PRE = new goog.dom.TagName("PRE");
goog.dom.TagName.PROGRESS = new goog.dom.TagName("PROGRESS");
goog.dom.TagName.Q = new goog.dom.TagName("Q");
goog.dom.TagName.RP = new goog.dom.TagName("RP");
goog.dom.TagName.RT = new goog.dom.TagName("RT");
goog.dom.TagName.RTC = new goog.dom.TagName("RTC");
goog.dom.TagName.RUBY = new goog.dom.TagName("RUBY");
goog.dom.TagName.S = new goog.dom.TagName("S");
goog.dom.TagName.SAMP = new goog.dom.TagName("SAMP");
goog.dom.TagName.SCRIPT = new goog.dom.TagName("SCRIPT");
goog.dom.TagName.SECTION = new goog.dom.TagName("SECTION");
goog.dom.TagName.SELECT = new goog.dom.TagName("SELECT");
goog.dom.TagName.SMALL = new goog.dom.TagName("SMALL");
goog.dom.TagName.SOURCE = new goog.dom.TagName("SOURCE");
goog.dom.TagName.SPAN = new goog.dom.TagName("SPAN");
goog.dom.TagName.STRIKE = new goog.dom.TagName("STRIKE");
goog.dom.TagName.STRONG = new goog.dom.TagName("STRONG");
goog.dom.TagName.STYLE = new goog.dom.TagName("STYLE");
goog.dom.TagName.SUB = new goog.dom.TagName("SUB");
goog.dom.TagName.SUMMARY = new goog.dom.TagName("SUMMARY");
goog.dom.TagName.SUP = new goog.dom.TagName("SUP");
goog.dom.TagName.SVG = new goog.dom.TagName("SVG");
goog.dom.TagName.TABLE = new goog.dom.TagName("TABLE");
goog.dom.TagName.TBODY = new goog.dom.TagName("TBODY");
goog.dom.TagName.TD = new goog.dom.TagName("TD");
goog.dom.TagName.TEMPLATE = new goog.dom.TagName("TEMPLATE");
goog.dom.TagName.TEXTAREA = new goog.dom.TagName("TEXTAREA");
goog.dom.TagName.TFOOT = new goog.dom.TagName("TFOOT");
goog.dom.TagName.TH = new goog.dom.TagName("TH");
goog.dom.TagName.THEAD = new goog.dom.TagName("THEAD");
goog.dom.TagName.TIME = new goog.dom.TagName("TIME");
goog.dom.TagName.TITLE = new goog.dom.TagName("TITLE");
goog.dom.TagName.TR = new goog.dom.TagName("TR");
goog.dom.TagName.TRACK = new goog.dom.TagName("TRACK");
goog.dom.TagName.TT = new goog.dom.TagName("TT");
goog.dom.TagName.U = new goog.dom.TagName("U");
goog.dom.TagName.UL = new goog.dom.TagName("UL");
goog.dom.TagName.VAR = new goog.dom.TagName("VAR");
goog.dom.TagName.VIDEO = new goog.dom.TagName("VIDEO");
goog.dom.TagName.WBR = new goog.dom.TagName("WBR");
goog.dom.tags = {};
goog.dom.tags.VOID_TAGS_ = {area:!0, base:!0, br:!0, col:!0, command:!0, embed:!0, hr:!0, img:!0, input:!0, keygen:!0, link:!0, meta:!0, param:!0, source:!0, track:!0, wbr:!0};
goog.dom.tags.isVoidTag = function(a) {
  return !0 === goog.dom.tags.VOID_TAGS_[a];
};
goog.html = {};
goog.html.trustedtypes = {};
goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#html") : null;
goog.string.TypedString = function() {
};
goog.string.Const = function(a, b) {
  this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ = a === goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ && b || "";
  this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ = goog.string.Const.TYPE_MARKER_;
};
goog.string.Const.prototype.implementsGoogStringTypedString = !0;
goog.string.Const.prototype.getTypedStringValue = function() {
  return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
};
goog.DEBUG && (goog.string.Const.prototype.toString = function() {
  return "Const{" + this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ + "}";
});
goog.string.Const.unwrap = function(a) {
  if (a instanceof goog.string.Const && a.constructor === goog.string.Const && a.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ === goog.string.Const.TYPE_MARKER_) {
    return a.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
  }
  goog.asserts.fail("expected object of type Const, got '" + a + "'");
  return "type_error:Const";
};
goog.string.Const.from = function(a) {
  return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_, a);
};
goog.string.Const.TYPE_MARKER_ = {};
goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ = {};
goog.string.Const.EMPTY = goog.string.Const.from("");
goog.html.SafeScript = function() {
  this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = "";
  this.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
};
goog.html.SafeScript.prototype.implementsGoogStringTypedString = !0;
goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
goog.html.SafeScript.fromConstant = function(a) {
  a = goog.string.Const.unwrap(a);
  return 0 === a.length ? goog.html.SafeScript.EMPTY : goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SafeScript.fromConstantAndArgs = function(a, b) {
  for (var c = [], d = 1; d < arguments.length; d++) {
    c.push(goog.html.SafeScript.stringify_(arguments[d]));
  }
  return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("(" + goog.string.Const.unwrap(a) + ")(" + c.join(", ") + ");");
};
goog.html.SafeScript.fromJson = function(a) {
  return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(goog.html.SafeScript.stringify_(a));
};
goog.html.SafeScript.prototype.getTypedStringValue = function() {
  return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString();
};
goog.DEBUG && (goog.html.SafeScript.prototype.toString = function() {
  return "SafeScript{" + this.privateDoNotAccessOrElseSafeScriptWrappedValue_ + "}";
});
goog.html.SafeScript.unwrap = function(a) {
  return goog.html.SafeScript.unwrapTrustedScript(a).toString();
};
goog.html.SafeScript.unwrapTrustedScript = function(a) {
  if (a instanceof goog.html.SafeScript && a.constructor === goog.html.SafeScript && a.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_) {
    return a.privateDoNotAccessOrElseSafeScriptWrappedValue_;
  }
  goog.asserts.fail("expected object of type SafeScript, got '" + a + "' of type " + goog.typeOf(a));
  return "type_error:SafeScript";
};
goog.html.SafeScript.stringify_ = function(a) {
  return JSON.stringify(a).replace(/</g, "\\x3c");
};
goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse = function(a) {
  return (new goog.html.SafeScript).initSecurityPrivateDoNotAccessOrElse_(a);
};
goog.html.SafeScript.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(a) {
  this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScript(a) : a;
  return this;
};
goog.html.SafeScript.EMPTY = goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("");
goog.fs = {};
goog.fs.url = {};
goog.fs.url.createObjectUrl = function(a) {
  return goog.fs.url.getUrlObject_().createObjectURL(a);
};
goog.fs.url.revokeObjectUrl = function(a) {
  goog.fs.url.getUrlObject_().revokeObjectURL(a);
};
goog.fs.url.getUrlObject_ = function() {
  var a = goog.fs.url.findUrlObject_();
  if (null != a) {
    return a;
  }
  throw Error("This browser doesn't seem to support blob URLs");
};
goog.fs.url.findUrlObject_ = function() {
  return void 0 !== goog.global.URL && void 0 !== goog.global.URL.createObjectURL ? goog.global.URL : void 0 !== goog.global.webkitURL && void 0 !== goog.global.webkitURL.createObjectURL ? goog.global.webkitURL : void 0 !== goog.global.createObjectURL ? goog.global : null;
};
goog.fs.url.browserSupportsObjectUrls = function() {
  return null != goog.fs.url.findUrlObject_();
};
goog.i18n = {};
goog.i18n.bidi = {};
goog.i18n.bidi.FORCE_RTL = !1;
goog.i18n.bidi.IS_RTL = goog.i18n.bidi.FORCE_RTL || ("ar" == goog.LOCALE.substring(0, 2).toLowerCase() || "fa" == goog.LOCALE.substring(0, 2).toLowerCase() || "he" == goog.LOCALE.substring(0, 2).toLowerCase() || "iw" == goog.LOCALE.substring(0, 2).toLowerCase() || "ps" == goog.LOCALE.substring(0, 2).toLowerCase() || "sd" == goog.LOCALE.substring(0, 2).toLowerCase() || "ug" == goog.LOCALE.substring(0, 2).toLowerCase() || "ur" == goog.LOCALE.substring(0, 2).toLowerCase() || "yi" == goog.LOCALE.substring(0, 
2).toLowerCase()) && (2 == goog.LOCALE.length || "-" == goog.LOCALE.substring(2, 3) || "_" == goog.LOCALE.substring(2, 3)) || 3 <= goog.LOCALE.length && "ckb" == goog.LOCALE.substring(0, 3).toLowerCase() && (3 == goog.LOCALE.length || "-" == goog.LOCALE.substring(3, 4) || "_" == goog.LOCALE.substring(3, 4)) || 7 <= goog.LOCALE.length && ("-" == goog.LOCALE.substring(2, 3) || "_" == goog.LOCALE.substring(2, 3)) && ("adlm" == goog.LOCALE.substring(3, 7).toLowerCase() || "arab" == goog.LOCALE.substring(3, 
7).toLowerCase() || "hebr" == goog.LOCALE.substring(3, 7).toLowerCase() || "nkoo" == goog.LOCALE.substring(3, 7).toLowerCase() || "rohg" == goog.LOCALE.substring(3, 7).toLowerCase() || "thaa" == goog.LOCALE.substring(3, 7).toLowerCase()) || 8 <= goog.LOCALE.length && ("-" == goog.LOCALE.substring(3, 4) || "_" == goog.LOCALE.substring(3, 4)) && ("adlm" == goog.LOCALE.substring(4, 8).toLowerCase() || "arab" == goog.LOCALE.substring(4, 8).toLowerCase() || "hebr" == goog.LOCALE.substring(4, 8).toLowerCase() || 
"nkoo" == goog.LOCALE.substring(4, 8).toLowerCase() || "rohg" == goog.LOCALE.substring(4, 8).toLowerCase() || "thaa" == goog.LOCALE.substring(4, 8).toLowerCase());
goog.i18n.bidi.Format = {LRE:"\u202a", RLE:"\u202b", PDF:"\u202c", LRM:"\u200e", RLM:"\u200f"};
goog.i18n.bidi.Dir = {LTR:1, RTL:-1, NEUTRAL:0};
goog.i18n.bidi.RIGHT = "right";
goog.i18n.bidi.LEFT = "left";
goog.i18n.bidi.I18N_RIGHT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.LEFT : goog.i18n.bidi.RIGHT;
goog.i18n.bidi.I18N_LEFT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT;
goog.i18n.bidi.toDir = function(a, b) {
  return "number" == typeof a ? 0 < a ? goog.i18n.bidi.Dir.LTR : 0 > a ? goog.i18n.bidi.Dir.RTL : b ? null : goog.i18n.bidi.Dir.NEUTRAL : null == a ? null : a ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
};
goog.i18n.bidi.ltrChars_ = "A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0900-\u1fff\u200e\u2c00-\ud801\ud804-\ud839\ud83c-\udbff\uf900-\ufb1c\ufe00-\ufe6f\ufefd-\uffff";
goog.i18n.bidi.rtlChars_ = "\u0591-\u06ef\u06fa-\u08ff\u200f\ud802-\ud803\ud83a-\ud83b\ufb1d-\ufdff\ufe70-\ufefc";
goog.i18n.bidi.htmlSkipReg_ = /<[^>]*>|&[^;]+;/g;
goog.i18n.bidi.stripHtmlIfNeeded_ = function(a, b) {
  return b ? a.replace(goog.i18n.bidi.htmlSkipReg_, "") : a;
};
goog.i18n.bidi.rtlCharReg_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "]");
goog.i18n.bidi.ltrCharReg_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "]");
goog.i18n.bidi.hasAnyRtl = function(a, b) {
  return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
};
goog.i18n.bidi.hasRtlChar = goog.i18n.bidi.hasAnyRtl;
goog.i18n.bidi.hasAnyLtr = function(a, b) {
  return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
};
goog.i18n.bidi.ltrRe_ = new RegExp("^[" + goog.i18n.bidi.ltrChars_ + "]");
goog.i18n.bidi.rtlRe_ = new RegExp("^[" + goog.i18n.bidi.rtlChars_ + "]");
goog.i18n.bidi.isRtlChar = function(a) {
  return goog.i18n.bidi.rtlRe_.test(a);
};
goog.i18n.bidi.isLtrChar = function(a) {
  return goog.i18n.bidi.ltrRe_.test(a);
};
goog.i18n.bidi.isNeutralChar = function(a) {
  return !goog.i18n.bidi.isLtrChar(a) && !goog.i18n.bidi.isRtlChar(a);
};
goog.i18n.bidi.ltrDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.rtlChars_ + "]*[" + goog.i18n.bidi.ltrChars_ + "]");
goog.i18n.bidi.rtlDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.ltrChars_ + "]*[" + goog.i18n.bidi.rtlChars_ + "]");
goog.i18n.bidi.startsWithRtl = function(a, b) {
  return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
};
goog.i18n.bidi.isRtlText = goog.i18n.bidi.startsWithRtl;
goog.i18n.bidi.startsWithLtr = function(a, b) {
  return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
};
goog.i18n.bidi.isLtrText = goog.i18n.bidi.startsWithLtr;
goog.i18n.bidi.isRequiredLtrRe_ = /^http:\/\/.*/;
goog.i18n.bidi.isNeutralText = function(a, b) {
  a = goog.i18n.bidi.stripHtmlIfNeeded_(a, b);
  return goog.i18n.bidi.isRequiredLtrRe_.test(a) || !goog.i18n.bidi.hasAnyLtr(a) && !goog.i18n.bidi.hasAnyRtl(a);
};
goog.i18n.bidi.ltrExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "][^" + goog.i18n.bidi.rtlChars_ + "]*$");
goog.i18n.bidi.rtlExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "][^" + goog.i18n.bidi.ltrChars_ + "]*$");
goog.i18n.bidi.endsWithLtr = function(a, b) {
  return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
};
goog.i18n.bidi.isLtrExitText = goog.i18n.bidi.endsWithLtr;
goog.i18n.bidi.endsWithRtl = function(a, b) {
  return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
};
goog.i18n.bidi.isRtlExitText = goog.i18n.bidi.endsWithRtl;
goog.i18n.bidi.rtlLocalesRe_ = /^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i;
goog.i18n.bidi.isRtlLanguage = function(a) {
  return goog.i18n.bidi.rtlLocalesRe_.test(a);
};
goog.i18n.bidi.bracketGuardTextRe_ = /(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g;
goog.i18n.bidi.guardBracketInText = function(a, b) {
  var c = (void 0 === b ? goog.i18n.bidi.hasAnyRtl(a) : b) ? goog.i18n.bidi.Format.RLM : goog.i18n.bidi.Format.LRM;
  return a.replace(goog.i18n.bidi.bracketGuardTextRe_, c + "$&" + c);
};
goog.i18n.bidi.enforceRtlInHtml = function(a) {
  return "<" == a.charAt(0) ? a.replace(/<\w+/, "$& dir=rtl") : "\n<span dir=rtl>" + a + "</span>";
};
goog.i18n.bidi.enforceRtlInText = function(a) {
  return goog.i18n.bidi.Format.RLE + a + goog.i18n.bidi.Format.PDF;
};
goog.i18n.bidi.enforceLtrInHtml = function(a) {
  return "<" == a.charAt(0) ? a.replace(/<\w+/, "$& dir=ltr") : "\n<span dir=ltr>" + a + "</span>";
};
goog.i18n.bidi.enforceLtrInText = function(a) {
  return goog.i18n.bidi.Format.LRE + a + goog.i18n.bidi.Format.PDF;
};
goog.i18n.bidi.dimensionsRe_ = /:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g;
goog.i18n.bidi.leftRe_ = /left/gi;
goog.i18n.bidi.rightRe_ = /right/gi;
goog.i18n.bidi.tempRe_ = /%%%%/g;
goog.i18n.bidi.mirrorCSS = function(a) {
  return a.replace(goog.i18n.bidi.dimensionsRe_, ":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_, "%%%%").replace(goog.i18n.bidi.rightRe_, goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_, goog.i18n.bidi.RIGHT);
};
goog.i18n.bidi.doubleQuoteSubstituteRe_ = /([\u0591-\u05f2])"/g;
goog.i18n.bidi.singleQuoteSubstituteRe_ = /([\u0591-\u05f2])'/g;
goog.i18n.bidi.normalizeHebrewQuote = function(a) {
  return a.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_, "$1\u05f4").replace(goog.i18n.bidi.singleQuoteSubstituteRe_, "$1\u05f3");
};
goog.i18n.bidi.wordSeparatorRe_ = /\s+/;
goog.i18n.bidi.hasNumeralsRe_ = /[\d\u06f0-\u06f9]/;
goog.i18n.bidi.rtlDetectionThreshold_ = 0.40;
goog.i18n.bidi.estimateDirection = function(a, b) {
  for (var c = 0, d = 0, e = !1, f = goog.i18n.bidi.stripHtmlIfNeeded_(a, b).split(goog.i18n.bidi.wordSeparatorRe_), g = 0; g < f.length; g++) {
    var h = f[g];
    goog.i18n.bidi.startsWithRtl(h) ? (c++, d++) : goog.i18n.bidi.isRequiredLtrRe_.test(h) ? e = !0 : goog.i18n.bidi.hasAnyLtr(h) ? d++ : goog.i18n.bidi.hasNumeralsRe_.test(h) && (e = !0);
  }
  return 0 == d ? e ? goog.i18n.bidi.Dir.LTR : goog.i18n.bidi.Dir.NEUTRAL : c / d > goog.i18n.bidi.rtlDetectionThreshold_ ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
};
goog.i18n.bidi.detectRtlDirectionality = function(a, b) {
  return goog.i18n.bidi.estimateDirection(a, b) == goog.i18n.bidi.Dir.RTL;
};
goog.i18n.bidi.setElementDirAndAlign = function(a, b) {
  a && (b = goog.i18n.bidi.toDir(b)) && (a.style.textAlign = b == goog.i18n.bidi.Dir.RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, a.dir = b == goog.i18n.bidi.Dir.RTL ? "rtl" : "ltr");
};
goog.i18n.bidi.setElementDirByTextDirectionality = function(a, b) {
  switch(goog.i18n.bidi.estimateDirection(b)) {
    case goog.i18n.bidi.Dir.LTR:
      a.dir = "ltr";
      break;
    case goog.i18n.bidi.Dir.RTL:
      a.dir = "rtl";
      break;
    default:
      a.removeAttribute("dir");
  }
};
goog.i18n.bidi.DirectionalString = function() {
};
goog.html.TrustedResourceUrl = function(a, b, c) {
  this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = a === goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ && b || "";
  this.trustedURL_ = a === goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ && c || null;
  this.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
};
goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString = !0;
goog.html.TrustedResourceUrl.prototype.getTypedStringValue = function() {
  return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString();
};
goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString = !0;
goog.html.TrustedResourceUrl.prototype.getDirection = function() {
  return goog.i18n.bidi.Dir.LTR;
};
goog.html.TrustedResourceUrl.prototype.cloneWithParams = function(a, b) {
  var c = goog.html.TrustedResourceUrl.unwrap(this);
  c = goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(c);
  var d = c[3] || "";
  return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(c[1] + goog.html.TrustedResourceUrl.stringifyParams_("?", c[2] || "", a) + goog.html.TrustedResourceUrl.stringifyParams_("#", d, b));
};
goog.DEBUG && (goog.html.TrustedResourceUrl.prototype.toString = function() {
  return "TrustedResourceUrl{" + this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ + "}";
});
goog.html.TrustedResourceUrl.unwrap = function(a) {
  return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(a).toString();
};
goog.html.TrustedResourceUrl.unwrapTrustedScriptURL = function(a) {
  if (a instanceof goog.html.TrustedResourceUrl && a.constructor === goog.html.TrustedResourceUrl && a.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_) {
    return a.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_;
  }
  goog.asserts.fail("expected object of type TrustedResourceUrl, got '" + a + "' of type " + goog.typeOf(a));
  return "type_error:TrustedResourceUrl";
};
goog.html.TrustedResourceUrl.unwrapTrustedURL = function(a) {
  return a.trustedURL_ ? a.trustedURL_ : goog.html.TrustedResourceUrl.unwrap(a);
};
goog.html.TrustedResourceUrl.format = function(a, b) {
  var c = goog.string.Const.unwrap(a);
  if (!goog.html.TrustedResourceUrl.BASE_URL_.test(c)) {
    throw Error("Invalid TrustedResourceUrl format: " + c);
  }
  var d = c.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_, function(a, d) {
    if (!Object.prototype.hasOwnProperty.call(b, d)) {
      throw Error('Found marker, "' + d + '", in format string, "' + c + '", but no valid label mapping found in args: ' + JSON.stringify(b));
    }
    var e = b[d];
    return e instanceof goog.string.Const ? goog.string.Const.unwrap(e) : encodeURIComponent(String(e));
  });
  return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(d);
};
goog.html.TrustedResourceUrl.FORMAT_MARKER_ = /%{(\w+)}/g;
goog.html.TrustedResourceUrl.BASE_URL_ = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i;
goog.html.TrustedResourceUrl.URL_PARAM_PARSER_ = /^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/;
goog.html.TrustedResourceUrl.formatWithParams = function(a, b, c, d) {
  return goog.html.TrustedResourceUrl.format(a, b).cloneWithParams(c, d);
};
goog.html.TrustedResourceUrl.fromConstant = function(a) {
  return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a));
};
goog.html.TrustedResourceUrl.fromConstants = function(a) {
  for (var b = "", c = 0; c < a.length; c++) {
    b += goog.string.Const.unwrap(a[c]);
  }
  return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b);
};
goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse = function(a) {
  var b = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScriptURL(a) : a;
  a = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createURL(a) : null;
  return new goog.html.TrustedResourceUrl(goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_, b, a);
};
goog.html.TrustedResourceUrl.stringifyParams_ = function(a, b, c) {
  if (null == c) {
    return b;
  }
  if ("string" === typeof c) {
    return c ? a + encodeURIComponent(c) : "";
  }
  for (var d in c) {
    var e = c[d];
    e = goog.isArray(e) ? e : [e];
    for (var f = 0; f < e.length; f++) {
      var g = e[f];
      null != g && (b || (b = a), b += (b.length > a.length ? "&" : "") + encodeURIComponent(d) + "=" + encodeURIComponent(String(g)));
    }
  }
  return b;
};
goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {};
goog.string.internal = {};
goog.string.internal.startsWith = function(a, b) {
  return 0 == a.lastIndexOf(b, 0);
};
goog.string.internal.endsWith = function(a, b) {
  var c = a.length - b.length;
  return 0 <= c && a.indexOf(b, c) == c;
};
goog.string.internal.caseInsensitiveStartsWith = function(a, b) {
  return 0 == goog.string.internal.caseInsensitiveCompare(b, a.substr(0, b.length));
};
goog.string.internal.caseInsensitiveEndsWith = function(a, b) {
  return 0 == goog.string.internal.caseInsensitiveCompare(b, a.substr(a.length - b.length, b.length));
};
goog.string.internal.caseInsensitiveEquals = function(a, b) {
  return a.toLowerCase() == b.toLowerCase();
};
goog.string.internal.isEmptyOrWhitespace = function(a) {
  return /^[\s\xa0]*$/.test(a);
};
goog.string.internal.trim = goog.TRUSTED_SITE && String.prototype.trim ? function(a) {
  return a.trim();
} : function(a) {
  return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
};
goog.string.internal.caseInsensitiveCompare = function(a, b) {
  var c = String(a).toLowerCase(), d = String(b).toLowerCase();
  return c < d ? -1 : c == d ? 0 : 1;
};
goog.string.internal.newLineToBr = function(a, b) {
  return a.replace(/(\r\n|\r|\n)/g, b ? "<br />" : "<br>");
};
goog.string.internal.htmlEscape = function(a, b) {
  if (b) {
    a = a.replace(goog.string.internal.AMP_RE_, "&amp;").replace(goog.string.internal.LT_RE_, "&lt;").replace(goog.string.internal.GT_RE_, "&gt;").replace(goog.string.internal.QUOT_RE_, "&quot;").replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;").replace(goog.string.internal.NULL_RE_, "&#0;");
  } else {
    if (!goog.string.internal.ALL_RE_.test(a)) {
      return a;
    }
    -1 != a.indexOf("&") && (a = a.replace(goog.string.internal.AMP_RE_, "&amp;"));
    -1 != a.indexOf("<") && (a = a.replace(goog.string.internal.LT_RE_, "&lt;"));
    -1 != a.indexOf(">") && (a = a.replace(goog.string.internal.GT_RE_, "&gt;"));
    -1 != a.indexOf('"') && (a = a.replace(goog.string.internal.QUOT_RE_, "&quot;"));
    -1 != a.indexOf("'") && (a = a.replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;"));
    -1 != a.indexOf("\x00") && (a = a.replace(goog.string.internal.NULL_RE_, "&#0;"));
  }
  return a;
};
goog.string.internal.AMP_RE_ = /&/g;
goog.string.internal.LT_RE_ = /</g;
goog.string.internal.GT_RE_ = />/g;
goog.string.internal.QUOT_RE_ = /"/g;
goog.string.internal.SINGLE_QUOTE_RE_ = /'/g;
goog.string.internal.NULL_RE_ = /\x00/g;
goog.string.internal.ALL_RE_ = /[\x00&<>"']/;
goog.string.internal.whitespaceEscape = function(a, b) {
  return goog.string.internal.newLineToBr(a.replace(/  /g, " &#160;"), b);
};
goog.string.internal.contains = function(a, b) {
  return -1 != a.indexOf(b);
};
goog.string.internal.caseInsensitiveContains = function(a, b) {
  return goog.string.internal.contains(a.toLowerCase(), b.toLowerCase());
};
goog.string.internal.compareVersions = function(a, b) {
  for (var c = 0, d = goog.string.internal.trim(String(a)).split("."), e = goog.string.internal.trim(String(b)).split("."), f = Math.max(d.length, e.length), g = 0; 0 == c && g < f; g++) {
    var h = d[g] || "", k = e[g] || "";
    do {
      h = /(\d*)(\D*)(.*)/.exec(h) || ["", "", "", ""];
      k = /(\d*)(\D*)(.*)/.exec(k) || ["", "", "", ""];
      if (0 == h[0].length && 0 == k[0].length) {
        break;
      }
      c = 0 == h[1].length ? 0 : parseInt(h[1], 10);
      var l = 0 == k[1].length ? 0 : parseInt(k[1], 10);
      c = goog.string.internal.compareElements_(c, l) || goog.string.internal.compareElements_(0 == h[2].length, 0 == k[2].length) || goog.string.internal.compareElements_(h[2], k[2]);
      h = h[3];
      k = k[3];
    } while (0 == c);
  }
  return c;
};
goog.string.internal.compareElements_ = function(a, b) {
  return a < b ? -1 : a > b ? 1 : 0;
};
goog.html.SafeUrl = function(a, b) {
  this.privateDoNotAccessOrElseSafeUrlWrappedValue_ = a === goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ && b || "";
  this.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
};
goog.html.SafeUrl.INNOCUOUS_STRING = "about:invalid#zClosurez";
goog.html.SafeUrl.prototype.implementsGoogStringTypedString = !0;
goog.html.SafeUrl.prototype.getTypedStringValue = function() {
  return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString();
};
goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString = !0;
goog.html.SafeUrl.prototype.getDirection = function() {
  return goog.i18n.bidi.Dir.LTR;
};
goog.DEBUG && (goog.html.SafeUrl.prototype.toString = function() {
  return "SafeUrl{" + this.privateDoNotAccessOrElseSafeUrlWrappedValue_ + "}";
});
goog.html.SafeUrl.unwrap = function(a) {
  return goog.html.SafeUrl.unwrapTrustedURL(a).toString();
};
goog.html.SafeUrl.unwrapTrustedURL = function(a) {
  if (a instanceof goog.html.SafeUrl && a.constructor === goog.html.SafeUrl && a.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_) {
    return a.privateDoNotAccessOrElseSafeUrlWrappedValue_;
  }
  goog.asserts.fail("expected object of type SafeUrl, got '" + a + "' of type " + goog.typeOf(a));
  return "type_error:SafeUrl";
};
goog.html.SafeUrl.fromConstant = function(a) {
  return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a));
};
goog.html.SAFE_MIME_TYPE_PATTERN_ = /^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-wav|wav|webm)|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|text\/csv|video\/(?:mpeg|mp4|ogg|webm|quicktime))(?:;\w+=(?:\w+|"[\w;=]+"))*$/i;
goog.html.SafeUrl.isSafeMimeType = function(a) {
  return goog.html.SAFE_MIME_TYPE_PATTERN_.test(a);
};
goog.html.SafeUrl.fromBlob = function(a) {
  a = goog.html.SAFE_MIME_TYPE_PATTERN_.test(a.type) ? goog.fs.url.createObjectUrl(a) : goog.html.SafeUrl.INNOCUOUS_STRING;
  return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.DATA_URL_PATTERN_ = /^data:([^,]*);base64,[a-z0-9+\/]+=*$/i;
goog.html.SafeUrl.fromDataUrl = function(a) {
  a = a.replace(/(%0A|%0D)/g, "");
  var b = a.match(goog.html.DATA_URL_PATTERN_);
  b = b && goog.html.SAFE_MIME_TYPE_PATTERN_.test(b[1]);
  return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b ? a : goog.html.SafeUrl.INNOCUOUS_STRING);
};
goog.html.SafeUrl.fromTelUrl = function(a) {
  goog.string.internal.caseInsensitiveStartsWith(a, "tel:") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
  return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SIP_URL_PATTERN_ = /^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i;
goog.html.SafeUrl.fromSipUrl = function(a) {
  goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(a)) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
  return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SafeUrl.fromFacebookMessengerUrl = function(a) {
  goog.string.internal.caseInsensitiveStartsWith(a, "fb-messenger://share") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
  return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SafeUrl.fromWhatsAppUrl = function(a) {
  goog.string.internal.caseInsensitiveStartsWith(a, "whatsapp://send") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
  return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SafeUrl.fromSmsUrl = function(a) {
  goog.string.internal.caseInsensitiveStartsWith(a, "sms:") && goog.html.SafeUrl.isSmsUrlBodyValid_(a) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
  return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SafeUrl.isSmsUrlBodyValid_ = function(a) {
  var b = a.indexOf("#");
  0 < b && (a = a.substring(0, b));
  b = a.match(/[?&]body=/gi);
  if (!b) {
    return !0;
  }
  if (1 < b.length) {
    return !1;
  }
  a = a.match(/[?&]body=([^&]*)/)[1];
  if (!a) {
    return !0;
  }
  try {
    decodeURIComponent(a);
  } catch (c) {
    return !1;
  }
  return /^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(a);
};
goog.html.SafeUrl.fromSshUrl = function(a) {
  goog.string.internal.caseInsensitiveStartsWith(a, "ssh://") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
  return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SafeUrl.sanitizeChromeExtensionUrl = function(a, b) {
  return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//, a, b);
};
goog.html.SafeUrl.sanitizeFirefoxExtensionUrl = function(a, b) {
  return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//, a, b);
};
goog.html.SafeUrl.sanitizeEdgeExtensionUrl = function(a, b) {
  return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//, a, b);
};
goog.html.SafeUrl.sanitizeExtensionUrl_ = function(a, b, c) {
  (a = a.exec(b)) ? (a = a[1], -1 == (c instanceof goog.string.Const ? [goog.string.Const.unwrap(c)] : c.map(function(a) {
    return goog.string.Const.unwrap(a);
  })).indexOf(a) && (b = goog.html.SafeUrl.INNOCUOUS_STRING)) : b = goog.html.SafeUrl.INNOCUOUS_STRING;
  return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b);
};
goog.html.SafeUrl.fromTrustedResourceUrl = function(a) {
  return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(a));
};
goog.html.SAFE_URL_PATTERN_ = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
goog.html.SafeUrl.SAFE_URL_PATTERN = goog.html.SAFE_URL_PATTERN_;
goog.html.SafeUrl.sanitize = function(a) {
  if (a instanceof goog.html.SafeUrl) {
    return a;
  }
  a = "object" == typeof a && a.implementsGoogStringTypedString ? a.getTypedStringValue() : String(a);
  goog.html.SAFE_URL_PATTERN_.test(a) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
  return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SafeUrl.sanitizeAssertUnchanged = function(a, b) {
  if (a instanceof goog.html.SafeUrl) {
    return a;
  }
  a = "object" == typeof a && a.implementsGoogStringTypedString ? a.getTypedStringValue() : String(a);
  if (b && /^data:/i.test(a)) {
    var c = goog.html.SafeUrl.fromDataUrl(a);
    if (c.getTypedStringValue() == a) {
      return c;
    }
  }
  goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(a), "%s does not match the safe URL pattern", a) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
  return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse = function(a) {
  return new goog.html.SafeUrl(goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_, goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createURL(a) : a);
};
goog.html.SafeUrl.ABOUT_BLANK = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank");
goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {};
goog.html.SafeStyle = function() {
  this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = "";
  this.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
};
goog.html.SafeStyle.prototype.implementsGoogStringTypedString = !0;
goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
goog.html.SafeStyle.fromConstant = function(a) {
  a = goog.string.Const.unwrap(a);
  if (0 === a.length) {
    return goog.html.SafeStyle.EMPTY;
  }
  goog.asserts.assert(goog.string.internal.endsWith(a, ";"), "Last character of style string is not ';': " + a);
  goog.asserts.assert(goog.string.internal.contains(a, ":"), "Style string must contain at least one ':', to specify a \"name: value\" pair: " + a);
  return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SafeStyle.prototype.getTypedStringValue = function() {
  return this.privateDoNotAccessOrElseSafeStyleWrappedValue_;
};
goog.DEBUG && (goog.html.SafeStyle.prototype.toString = function() {
  return "SafeStyle{" + this.privateDoNotAccessOrElseSafeStyleWrappedValue_ + "}";
});
goog.html.SafeStyle.unwrap = function(a) {
  if (a instanceof goog.html.SafeStyle && a.constructor === goog.html.SafeStyle && a.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_) {
    return a.privateDoNotAccessOrElseSafeStyleWrappedValue_;
  }
  goog.asserts.fail("expected object of type SafeStyle, got '" + a + "' of type " + goog.typeOf(a));
  return "type_error:SafeStyle";
};
goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse = function(a) {
  return (new goog.html.SafeStyle).initSecurityPrivateDoNotAccessOrElse_(a);
};
goog.html.SafeStyle.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(a) {
  this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = a;
  return this;
};
goog.html.SafeStyle.EMPTY = goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse("");
goog.html.SafeStyle.INNOCUOUS_STRING = "zClosurez";
goog.html.SafeStyle.create = function(a) {
  var b = "", c;
  for (c in a) {
    if (!/^[-_a-zA-Z0-9]+$/.test(c)) {
      throw Error("Name allows only [-_a-zA-Z0-9], got: " + c);
    }
    var d = a[c];
    null != d && (d = goog.isArray(d) ? goog.array.map(d, goog.html.SafeStyle.sanitizePropertyValue_).join(" ") : goog.html.SafeStyle.sanitizePropertyValue_(d), b += c + ":" + d + ";");
  }
  return b ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b) : goog.html.SafeStyle.EMPTY;
};
goog.html.SafeStyle.sanitizePropertyValue_ = function(a) {
  if (a instanceof goog.html.SafeUrl) {
    return 'url("' + goog.html.SafeUrl.unwrap(a).replace(/</g, "%3c").replace(/[\\"]/g, "\\$&") + '")';
  }
  a = a instanceof goog.string.Const ? goog.string.Const.unwrap(a) : goog.html.SafeStyle.sanitizePropertyValueString_(String(a));
  if (/[{;}]/.test(a)) {
    throw new goog.asserts.AssertionError("Value does not allow [{;}], got: %s.", [a]);
  }
  return a;
};
goog.html.SafeStyle.sanitizePropertyValueString_ = function(a) {
  var b = a.replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.URL_RE_, "url");
  if (goog.html.SafeStyle.VALUE_RE_.test(b)) {
    if (goog.html.SafeStyle.COMMENT_RE_.test(a)) {
      return goog.asserts.fail("String value disallows comments, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
    }
    if (!goog.html.SafeStyle.hasBalancedQuotes_(a)) {
      return goog.asserts.fail("String value requires balanced quotes, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
    }
    if (!goog.html.SafeStyle.hasBalancedSquareBrackets_(a)) {
      return goog.asserts.fail("String value requires balanced square brackets and one identifier per pair of brackets, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
    }
  } else {
    return goog.asserts.fail("String value allows only " + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + " and simple functions, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
  }
  return goog.html.SafeStyle.sanitizeUrl_(a);
};
goog.html.SafeStyle.hasBalancedQuotes_ = function(a) {
  for (var b = !0, c = !0, d = 0; d < a.length; d++) {
    var e = a.charAt(d);
    "'" == e && c ? b = !b : '"' == e && b && (c = !c);
  }
  return b && c;
};
goog.html.SafeStyle.hasBalancedSquareBrackets_ = function(a) {
  for (var b = !0, c = /^[-_a-zA-Z0-9]$/, d = 0; d < a.length; d++) {
    var e = a.charAt(d);
    if ("]" == e) {
      if (b) {
        return !1;
      }
      b = !0;
    } else {
      if ("[" == e) {
        if (!b) {
          return !1;
        }
        b = !1;
      } else {
        if (!b && !c.test(e)) {
          return !1;
        }
      }
    }
  }
  return b;
};
goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ = "[-,.\"'%_!# a-zA-Z0-9\\[\\]]";
goog.html.SafeStyle.VALUE_RE_ = new RegExp("^" + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + "+$");
goog.html.SafeStyle.URL_RE_ = RegExp("\\b(url\\([ \t\n]*)('[ -&(-\\[\\]-~]*'|\"[ !#-\\[\\]-~]*\"|[!#-&*-\\[\\]-~]*)([ \t\n]*\\))", "g");
goog.html.SafeStyle.ALLOWED_FUNCTIONS_ = "calc cubic-bezier fit-content hsl hsla matrix minmax repeat rgb rgba (rotate|scale|translate)(X|Y|Z|3d)?".split(" ");
goog.html.SafeStyle.FUNCTIONS_RE_ = new RegExp("\\b(" + goog.html.SafeStyle.ALLOWED_FUNCTIONS_.join("|") + ")\\([-+*/0-9a-z.%\\[\\], ]+\\)", "g");
goog.html.SafeStyle.COMMENT_RE_ = /\/\*/;
goog.html.SafeStyle.sanitizeUrl_ = function(a) {
  return a.replace(goog.html.SafeStyle.URL_RE_, function(a, c, d, e) {
    var b = "";
    d = d.replace(/^(['"])(.*)\1$/, function(a, c, d) {
      b = c;
      return d;
    });
    a = goog.html.SafeUrl.sanitize(d).getTypedStringValue();
    return c + b + a + b + e;
  });
};
goog.html.SafeStyle.concat = function(a) {
  var b = "", c = function(a) {
    goog.isArray(a) ? goog.array.forEach(a, c) : b += goog.html.SafeStyle.unwrap(a);
  };
  goog.array.forEach(arguments, c);
  return b ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b) : goog.html.SafeStyle.EMPTY;
};
goog.html.SafeStyleSheet = function() {
  this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = "";
  this.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
};
goog.html.SafeStyleSheet.prototype.implementsGoogStringTypedString = !0;
goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
goog.html.SafeStyleSheet.createRule = function(a, b) {
  if (goog.string.internal.contains(a, "<")) {
    throw Error("Selector does not allow '<', got: " + a);
  }
  var c = a.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g, "");
  if (!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(c)) {
    throw Error("Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: " + a);
  }
  if (!goog.html.SafeStyleSheet.hasBalancedBrackets_(c)) {
    throw Error("() and [] in selector must be balanced, got: " + a);
  }
  b instanceof goog.html.SafeStyle || (b = goog.html.SafeStyle.create(b));
  c = a + "{" + goog.html.SafeStyle.unwrap(b).replace(/</g, "\\3C ") + "}";
  return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(c);
};
goog.html.SafeStyleSheet.hasBalancedBrackets_ = function(a) {
  for (var b = {"(":")", "[":"]"}, c = [], d = 0; d < a.length; d++) {
    var e = a[d];
    if (b[e]) {
      c.push(b[e]);
    } else {
      if (goog.object.contains(b, e) && c.pop() != e) {
        return !1;
      }
    }
  }
  return 0 == c.length;
};
goog.html.SafeStyleSheet.concat = function(a) {
  var b = "", c = function(a) {
    goog.isArray(a) ? goog.array.forEach(a, c) : b += goog.html.SafeStyleSheet.unwrap(a);
  };
  goog.array.forEach(arguments, c);
  return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b);
};
goog.html.SafeStyleSheet.fromConstant = function(a) {
  a = goog.string.Const.unwrap(a);
  if (0 === a.length) {
    return goog.html.SafeStyleSheet.EMPTY;
  }
  goog.asserts.assert(!goog.string.internal.contains(a, "<"), "Forbidden '<' character in style sheet string: " + a);
  return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SafeStyleSheet.prototype.getTypedStringValue = function() {
  return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
};
goog.DEBUG && (goog.html.SafeStyleSheet.prototype.toString = function() {
  return "SafeStyleSheet{" + this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ + "}";
});
goog.html.SafeStyleSheet.unwrap = function(a) {
  if (a instanceof goog.html.SafeStyleSheet && a.constructor === goog.html.SafeStyleSheet && a.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_) {
    return a.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
  }
  goog.asserts.fail("expected object of type SafeStyleSheet, got '" + a + "' of type " + goog.typeOf(a));
  return "type_error:SafeStyleSheet";
};
goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse = function(a) {
  return (new goog.html.SafeStyleSheet).initSecurityPrivateDoNotAccessOrElse_(a);
};
goog.html.SafeStyleSheet.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(a) {
  this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = a;
  return this;
};
goog.html.SafeStyleSheet.EMPTY = goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse("");
goog.labs = {};
goog.labs.userAgent = {};
goog.labs.userAgent.util = {};
goog.labs.userAgent.util.getNativeUserAgentString_ = function() {
  var a = goog.labs.userAgent.util.getNavigator_();
  return a && (a = a.userAgent) ? a : "";
};
goog.labs.userAgent.util.getNavigator_ = function() {
  return goog.global.navigator;
};
goog.labs.userAgent.util.userAgent_ = goog.labs.userAgent.util.getNativeUserAgentString_();
goog.labs.userAgent.util.setUserAgent = function(a) {
  goog.labs.userAgent.util.userAgent_ = a || goog.labs.userAgent.util.getNativeUserAgentString_();
};
goog.labs.userAgent.util.getUserAgent = function() {
  return goog.labs.userAgent.util.userAgent_;
};
goog.labs.userAgent.util.matchUserAgent = function(a) {
  var b = goog.labs.userAgent.util.getUserAgent();
  return goog.string.internal.contains(b, a);
};
goog.labs.userAgent.util.matchUserAgentIgnoreCase = function(a) {
  var b = goog.labs.userAgent.util.getUserAgent();
  return goog.string.internal.caseInsensitiveContains(b, a);
};
goog.labs.userAgent.util.extractVersionTuples = function(a) {
  for (var b = RegExp("(\\w[\\w ]+)/([^\\s]+)\\s*(?:\\((.*?)\\))?", "g"), c = [], d; d = b.exec(a);) {
    c.push([d[1], d[2], d[3] || void 0]);
  }
  return c;
};
goog.labs.userAgent.browser = {};
goog.labs.userAgent.browser.matchOpera_ = function() {
  return goog.labs.userAgent.util.matchUserAgent("Opera");
};
goog.labs.userAgent.browser.matchIE_ = function() {
  return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
};
goog.labs.userAgent.browser.matchEdgeHtml_ = function() {
  return goog.labs.userAgent.util.matchUserAgent("Edge");
};
goog.labs.userAgent.browser.matchEdgeChromium_ = function() {
  return goog.labs.userAgent.util.matchUserAgent("Edg/");
};
goog.labs.userAgent.browser.matchOperaChromium_ = function() {
  return goog.labs.userAgent.util.matchUserAgent("OPR");
};
goog.labs.userAgent.browser.matchFirefox_ = function() {
  return goog.labs.userAgent.util.matchUserAgent("Firefox") || goog.labs.userAgent.util.matchUserAgent("FxiOS");
};
goog.labs.userAgent.browser.matchSafari_ = function() {
  return goog.labs.userAgent.util.matchUserAgent("Safari") && !(goog.labs.userAgent.browser.matchChrome_() || goog.labs.userAgent.browser.matchCoast_() || goog.labs.userAgent.browser.matchOpera_() || goog.labs.userAgent.browser.matchEdgeHtml_() || goog.labs.userAgent.browser.matchEdgeChromium_() || goog.labs.userAgent.browser.matchOperaChromium_() || goog.labs.userAgent.browser.matchFirefox_() || goog.labs.userAgent.browser.isSilk() || goog.labs.userAgent.util.matchUserAgent("Android"));
};
goog.labs.userAgent.browser.matchCoast_ = function() {
  return goog.labs.userAgent.util.matchUserAgent("Coast");
};
goog.labs.userAgent.browser.matchIosWebview_ = function() {
  return (goog.labs.userAgent.util.matchUserAgent("iPad") || goog.labs.userAgent.util.matchUserAgent("iPhone")) && !goog.labs.userAgent.browser.matchSafari_() && !goog.labs.userAgent.browser.matchChrome_() && !goog.labs.userAgent.browser.matchCoast_() && !goog.labs.userAgent.browser.matchFirefox_() && goog.labs.userAgent.util.matchUserAgent("AppleWebKit");
};
goog.labs.userAgent.browser.matchChrome_ = function() {
  return (goog.labs.userAgent.util.matchUserAgent("Chrome") || goog.labs.userAgent.util.matchUserAgent("CriOS")) && !goog.labs.userAgent.browser.matchEdgeHtml_();
};
goog.labs.userAgent.browser.matchAndroidBrowser_ = function() {
  return goog.labs.userAgent.util.matchUserAgent("Android") && !(goog.labs.userAgent.browser.isChrome() || goog.labs.userAgent.browser.isFirefox() || goog.labs.userAgent.browser.isOpera() || goog.labs.userAgent.browser.isSilk());
};
goog.labs.userAgent.browser.isOpera = goog.labs.userAgent.browser.matchOpera_;
goog.labs.userAgent.browser.isIE = goog.labs.userAgent.browser.matchIE_;
goog.labs.userAgent.browser.isEdge = goog.labs.userAgent.browser.matchEdgeHtml_;
goog.labs.userAgent.browser.isEdgeChromium = goog.labs.userAgent.browser.matchEdgeChromium_;
goog.labs.userAgent.browser.isOperaChromium = goog.labs.userAgent.browser.matchOperaChromium_;
goog.labs.userAgent.browser.isFirefox = goog.labs.userAgent.browser.matchFirefox_;
goog.labs.userAgent.browser.isSafari = goog.labs.userAgent.browser.matchSafari_;
goog.labs.userAgent.browser.isCoast = goog.labs.userAgent.browser.matchCoast_;
goog.labs.userAgent.browser.isIosWebview = goog.labs.userAgent.browser.matchIosWebview_;
goog.labs.userAgent.browser.isChrome = goog.labs.userAgent.browser.matchChrome_;
goog.labs.userAgent.browser.isAndroidBrowser = goog.labs.userAgent.browser.matchAndroidBrowser_;
goog.labs.userAgent.browser.isSilk = function() {
  return goog.labs.userAgent.util.matchUserAgent("Silk");
};
goog.labs.userAgent.browser.getVersion = function() {
  function a(a) {
    a = goog.array.find(a, d);
    return c[a] || "";
  }
  var b = goog.labs.userAgent.util.getUserAgent();
  if (goog.labs.userAgent.browser.isIE()) {
    return goog.labs.userAgent.browser.getIEVersion_(b);
  }
  b = goog.labs.userAgent.util.extractVersionTuples(b);
  var c = {};
  goog.array.forEach(b, function(a) {
    c[a[0]] = a[1];
  });
  var d = goog.partial(goog.object.containsKey, c);
  return goog.labs.userAgent.browser.isOpera() ? a(["Version", "Opera"]) : goog.labs.userAgent.browser.isEdge() ? a(["Edge"]) : goog.labs.userAgent.browser.isEdgeChromium() ? a(["Edg"]) : goog.labs.userAgent.browser.isChrome() ? a(["Chrome", "CriOS"]) : (b = b[2]) && b[1] || "";
};
goog.labs.userAgent.browser.isVersionOrHigher = function(a) {
  return 0 <= goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(), a);
};
goog.labs.userAgent.browser.getIEVersion_ = function(a) {
  var b = /rv: *([\d\.]*)/.exec(a);
  if (b && b[1]) {
    return b[1];
  }
  b = "";
  var c = /MSIE +([\d\.]+)/.exec(a);
  if (c && c[1]) {
    if (a = /Trident\/(\d.\d)/.exec(a), "7.0" == c[1]) {
      if (a && a[1]) {
        switch(a[1]) {
          case "4.0":
            b = "8.0";
            break;
          case "5.0":
            b = "9.0";
            break;
          case "6.0":
            b = "10.0";
            break;
          case "7.0":
            b = "11.0";
        }
      } else {
        b = "7.0";
      }
    } else {
      b = c[1];
    }
  }
  return b;
};
goog.html.SafeHtml = function() {
  this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = "";
  this.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
  this.dir_ = null;
};
goog.html.SafeHtml.ENABLE_ERROR_MESSAGES = goog.DEBUG;
goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE = !0;
goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString = !0;
goog.html.SafeHtml.prototype.getDirection = function() {
  return this.dir_;
};
goog.html.SafeHtml.prototype.implementsGoogStringTypedString = !0;
goog.html.SafeHtml.prototype.getTypedStringValue = function() {
  return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString();
};
goog.DEBUG && (goog.html.SafeHtml.prototype.toString = function() {
  return "SafeHtml{" + this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ + "}";
});
goog.html.SafeHtml.unwrap = function(a) {
  return goog.html.SafeHtml.unwrapTrustedHTML(a).toString();
};
goog.html.SafeHtml.unwrapTrustedHTML = function(a) {
  if (a instanceof goog.html.SafeHtml && a.constructor === goog.html.SafeHtml && a.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_) {
    return a.privateDoNotAccessOrElseSafeHtmlWrappedValue_;
  }
  goog.asserts.fail("expected object of type SafeHtml, got '" + a + "' of type " + goog.typeOf(a));
  return "type_error:SafeHtml";
};
goog.html.SafeHtml.htmlEscape = function(a) {
  if (a instanceof goog.html.SafeHtml) {
    return a;
  }
  var b = "object" == typeof a, c = null;
  b && a.implementsGoogI18nBidiDirectionalString && (c = a.getDirection());
  a = b && a.implementsGoogStringTypedString ? a.getTypedStringValue() : String(a);
  return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(a), c);
};
goog.html.SafeHtml.htmlEscapePreservingNewlines = function(a) {
  if (a instanceof goog.html.SafeHtml) {
    return a;
  }
  a = goog.html.SafeHtml.htmlEscape(a);
  return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(a)), a.getDirection());
};
goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces = function(a) {
  if (a instanceof goog.html.SafeHtml) {
    return a;
  }
  a = goog.html.SafeHtml.htmlEscape(a);
  return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(a)), a.getDirection());
};
goog.html.SafeHtml.from = goog.html.SafeHtml.htmlEscape;
goog.html.SafeHtml.VALID_NAMES_IN_TAG_ = /^[a-zA-Z0-9-]+$/;
goog.html.SafeHtml.URL_ATTRIBUTES_ = {action:!0, cite:!0, data:!0, formaction:!0, href:!0, manifest:!0, poster:!0, src:!0};
goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_ = {APPLET:!0, BASE:!0, EMBED:!0, IFRAME:!0, LINK:!0, MATH:!0, META:!0, OBJECT:!0, SCRIPT:!0, STYLE:!0, SVG:!0, TEMPLATE:!0};
goog.html.SafeHtml.create = function(a, b, c) {
  goog.html.SafeHtml.verifyTagName(String(a));
  return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(a), b, c);
};
goog.html.SafeHtml.verifyTagName = function(a) {
  if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(a)) {
    throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "Invalid tag name <" + a + ">." : "");
  }
  if (a.toUpperCase() in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_) {
    throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "Tag name <" + a + "> is not allowed for SafeHtml." : "");
  }
};
goog.html.SafeHtml.createIframe = function(a, b, c, d) {
  a && goog.html.TrustedResourceUrl.unwrap(a);
  var e = {};
  e.src = a || null;
  e.srcdoc = b && goog.html.SafeHtml.unwrap(b);
  a = goog.html.SafeHtml.combineAttributes(e, {sandbox:""}, c);
  return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", a, d);
};
goog.html.SafeHtml.createSandboxIframe = function(a, b, c, d) {
  if (!goog.html.SafeHtml.canUseSandboxIframe()) {
    throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "The browser does not support sandboxed iframes." : "");
  }
  var e = {};
  e.src = a ? goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a)) : null;
  e.srcdoc = b || null;
  e.sandbox = "";
  a = goog.html.SafeHtml.combineAttributes(e, {}, c);
  return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", a, d);
};
goog.html.SafeHtml.canUseSandboxIframe = function() {
  return goog.global.HTMLIFrameElement && "sandbox" in goog.global.HTMLIFrameElement.prototype;
};
goog.html.SafeHtml.createScriptSrc = function(a, b) {
  goog.html.TrustedResourceUrl.unwrap(a);
  var c = goog.html.SafeHtml.combineAttributes({src:a}, {}, b);
  return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", c);
};
goog.html.SafeHtml.createScript = function(a, b) {
  for (var c in b) {
    var d = c.toLowerCase();
    if ("language" == d || "src" == d || "text" == d || "type" == d) {
      throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Cannot set "' + d + '" attribute' : "");
    }
  }
  c = "";
  a = goog.array.concat(a);
  for (d = 0; d < a.length; d++) {
    c += goog.html.SafeScript.unwrap(a[d]);
  }
  c = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c, goog.i18n.bidi.Dir.NEUTRAL);
  return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", b, c);
};
goog.html.SafeHtml.createStyle = function(a, b) {
  var c = goog.html.SafeHtml.combineAttributes({type:"text/css"}, {}, b), d = "";
  a = goog.array.concat(a);
  for (var e = 0; e < a.length; e++) {
    d += goog.html.SafeStyleSheet.unwrap(a[e]);
  }
  d = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(d, goog.i18n.bidi.Dir.NEUTRAL);
  return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style", c, d);
};
goog.html.SafeHtml.createMetaRefresh = function(a, b) {
  var c = goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a));
  (goog.labs.userAgent.browser.isIE() || goog.labs.userAgent.browser.isEdge()) && goog.string.internal.contains(c, ";") && (c = "'" + c.replace(/'/g, "%27") + "'");
  return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta", {"http-equiv":"refresh", content:(b || 0) + "; url=" + c});
};
goog.html.SafeHtml.getAttrNameAndValue_ = function(a, b, c) {
  if (c instanceof goog.string.Const) {
    c = goog.string.Const.unwrap(c);
  } else {
    if ("style" == b.toLowerCase()) {
      if (goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE) {
        c = goog.html.SafeHtml.getStyleValue_(c);
      } else {
        throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "style" not supported.' : "");
      }
    } else {
      if (/^on/i.test(b)) {
        throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "' + b + '" requires goog.string.Const value, "' + c + '" given.' : "");
      }
      if (b.toLowerCase() in goog.html.SafeHtml.URL_ATTRIBUTES_) {
        if (c instanceof goog.html.TrustedResourceUrl) {
          c = goog.html.TrustedResourceUrl.unwrap(c);
        } else {
          if (c instanceof goog.html.SafeUrl) {
            c = goog.html.SafeUrl.unwrap(c);
          } else {
            if ("string" === typeof c) {
              c = goog.html.SafeUrl.sanitize(c).getTypedStringValue();
            } else {
              throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "' + b + '" on tag "' + a + '" requires goog.html.SafeUrl, goog.string.Const, or string, value "' + c + '" given.' : "");
            }
          }
        }
      }
    }
  }
  c.implementsGoogStringTypedString && (c = c.getTypedStringValue());
  goog.asserts.assert("string" === typeof c || "number" === typeof c, "String or number value expected, got " + typeof c + " with value: " + c);
  return b + '="' + goog.string.internal.htmlEscape(String(c)) + '"';
};
goog.html.SafeHtml.getStyleValue_ = function(a) {
  if (!goog.isObject(a)) {
    throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'The "style" attribute requires goog.html.SafeStyle or map of style properties, ' + typeof a + " given: " + a : "");
  }
  a instanceof goog.html.SafeStyle || (a = goog.html.SafeStyle.create(a));
  return goog.html.SafeStyle.unwrap(a);
};
goog.html.SafeHtml.createWithDir = function(a, b, c, d) {
  b = goog.html.SafeHtml.create(b, c, d);
  b.dir_ = a;
  return b;
};
goog.html.SafeHtml.join = function(a, b) {
  var c = goog.html.SafeHtml.htmlEscape(a), d = c.getDirection(), e = [], f = function(a) {
    goog.isArray(a) ? goog.array.forEach(a, f) : (a = goog.html.SafeHtml.htmlEscape(a), e.push(goog.html.SafeHtml.unwrap(a)), a = a.getDirection(), d == goog.i18n.bidi.Dir.NEUTRAL ? d = a : a != goog.i18n.bidi.Dir.NEUTRAL && d != a && (d = null));
  };
  goog.array.forEach(b, f);
  return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(e.join(goog.html.SafeHtml.unwrap(c)), d);
};
goog.html.SafeHtml.concat = function(a) {
  return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY, Array.prototype.slice.call(arguments));
};
goog.html.SafeHtml.concatWithDir = function(a, b) {
  var c = goog.html.SafeHtml.concat(goog.array.slice(arguments, 1));
  c.dir_ = a;
  return c;
};
goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse = function(a, b) {
  return (new goog.html.SafeHtml).initSecurityPrivateDoNotAccessOrElse_(a, b);
};
goog.html.SafeHtml.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(a, b) {
  this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createHTML(a) : a;
  this.dir_ = b;
  return this;
};
goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse = function(a, b, c) {
  var d = null;
  var e = "<" + a + goog.html.SafeHtml.stringifyAttributes(a, b);
  null == c ? c = [] : goog.isArray(c) || (c = [c]);
  goog.dom.tags.isVoidTag(a.toLowerCase()) ? (goog.asserts.assert(!c.length, "Void tag <" + a + "> does not allow content."), e += ">") : (d = goog.html.SafeHtml.concat(c), e += ">" + goog.html.SafeHtml.unwrap(d) + "</" + a + ">", d = d.getDirection());
  (a = b && b.dir) && (d = /^(ltr|rtl|auto)$/i.test(a) ? goog.i18n.bidi.Dir.NEUTRAL : null);
  return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(e, d);
};
goog.html.SafeHtml.stringifyAttributes = function(a, b) {
  var c = "";
  if (b) {
    for (var d in b) {
      if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(d)) {
        throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Invalid attribute name "' + d + '".' : "");
      }
      var e = b[d];
      null != e && (c += " " + goog.html.SafeHtml.getAttrNameAndValue_(a, d, e));
    }
  }
  return c;
};
goog.html.SafeHtml.combineAttributes = function(a, b, c) {
  var d = {}, e;
  for (e in a) {
    goog.asserts.assert(e.toLowerCase() == e, "Must be lower case"), d[e] = a[e];
  }
  for (e in b) {
    goog.asserts.assert(e.toLowerCase() == e, "Must be lower case"), d[e] = b[e];
  }
  if (c) {
    for (e in c) {
      var f = e.toLowerCase();
      if (f in a) {
        throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Cannot override "' + f + '" attribute, got "' + e + '" with value "' + c[e] + '"' : "");
      }
      f in b && delete d[f];
      d[e] = c[e];
    }
  }
  return d;
};
goog.html.SafeHtml.DOCTYPE_HTML = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>", goog.i18n.bidi.Dir.NEUTRAL);
goog.html.SafeHtml.EMPTY = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("", goog.i18n.bidi.Dir.NEUTRAL);
goog.html.SafeHtml.BR = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>", goog.i18n.bidi.Dir.NEUTRAL);
goog.html.uncheckedconversions = {};
goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract = function(a, b, c) {
  goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
  goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
  return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(b, c || null);
};
goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract = function(a, b) {
  goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
  goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
  return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(b);
};
goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract = function(a, b) {
  goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
  goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
  return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b);
};
goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract = function(a, b) {
  goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
  goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
  return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b);
};
goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract = function(a, b) {
  goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
  goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
  return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b);
};
goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract = function(a, b) {
  goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
  goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
  return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b);
};
goog.dom.safe = {};
goog.dom.safe.InsertAdjacentHtmlPosition = {AFTERBEGIN:"afterbegin", AFTEREND:"afterend", BEFOREBEGIN:"beforebegin", BEFOREEND:"beforeend"};
goog.dom.safe.insertAdjacentHtml = function(a, b, c) {
  a.insertAdjacentHTML(b, goog.html.SafeHtml.unwrapTrustedHTML(c));
};
goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_ = {MATH:!0, SCRIPT:!0, STYLE:!0, SVG:!0, TEMPLATE:!0};
goog.dom.safe.isInnerHtmlCleanupRecursive_ = goog.functions.cacheReturnValue(function() {
  if (goog.DEBUG && "undefined" === typeof document) {
    return !1;
  }
  var a = document.createElement("div"), b = document.createElement("div");
  b.appendChild(document.createElement("div"));
  a.appendChild(b);
  if (goog.DEBUG && !a.firstChild) {
    return !1;
  }
  b = a.firstChild.firstChild;
  a.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY);
  return !b.parentElement;
});
goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse = function(a, b) {
  if (goog.dom.safe.isInnerHtmlCleanupRecursive_()) {
    for (; a.lastChild;) {
      a.removeChild(a.lastChild);
    }
  }
  a.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(b);
};
goog.dom.safe.setInnerHtml = function(a, b) {
  if (goog.asserts.ENABLE_ASSERTS) {
    var c = a.tagName.toUpperCase();
    if (goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[c]) {
      throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of " + a.tagName + ".");
    }
  }
  goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(a, b);
};
goog.dom.safe.setOuterHtml = function(a, b) {
  a.outerHTML = goog.html.SafeHtml.unwrapTrustedHTML(b);
};
goog.dom.safe.setFormElementAction = function(a, b) {
  var c = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
  goog.dom.asserts.assertIsHTMLFormElement(a).action = goog.html.SafeUrl.unwrapTrustedURL(c);
};
goog.dom.safe.setButtonFormAction = function(a, b) {
  var c = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
  goog.dom.asserts.assertIsHTMLButtonElement(a).formAction = goog.html.SafeUrl.unwrapTrustedURL(c);
};
goog.dom.safe.setInputFormAction = function(a, b) {
  var c = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
  goog.dom.asserts.assertIsHTMLInputElement(a).formAction = goog.html.SafeUrl.unwrapTrustedURL(c);
};
goog.dom.safe.setStyle = function(a, b) {
  a.style.cssText = goog.html.SafeStyle.unwrap(b);
};
goog.dom.safe.documentWrite = function(a, b) {
  a.write(goog.html.SafeHtml.unwrapTrustedHTML(b));
};
goog.dom.safe.setAnchorHref = function(a, b) {
  goog.dom.asserts.assertIsHTMLAnchorElement(a);
  var c = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
  a.href = goog.html.SafeUrl.unwrapTrustedURL(c);
};
goog.dom.safe.setImageSrc = function(a, b) {
  goog.dom.asserts.assertIsHTMLImageElement(a);
  if (b instanceof goog.html.SafeUrl) {
    var c = b;
  } else {
    c = /^data:image\//i.test(b), c = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
  }
  a.src = goog.html.SafeUrl.unwrapTrustedURL(c);
};
goog.dom.safe.setAudioSrc = function(a, b) {
  goog.dom.asserts.assertIsHTMLAudioElement(a);
  if (b instanceof goog.html.SafeUrl) {
    var c = b;
  } else {
    c = /^data:audio\//i.test(b), c = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
  }
  a.src = goog.html.SafeUrl.unwrapTrustedURL(c);
};
goog.dom.safe.setVideoSrc = function(a, b) {
  goog.dom.asserts.assertIsHTMLVideoElement(a);
  if (b instanceof goog.html.SafeUrl) {
    var c = b;
  } else {
    c = /^data:video\//i.test(b), c = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
  }
  a.src = goog.html.SafeUrl.unwrapTrustedURL(c);
};
goog.dom.safe.setEmbedSrc = function(a, b) {
  goog.dom.asserts.assertIsHTMLEmbedElement(a);
  a.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
};
goog.dom.safe.setFrameSrc = function(a, b) {
  goog.dom.asserts.assertIsHTMLFrameElement(a);
  a.src = goog.html.TrustedResourceUrl.unwrapTrustedURL(b);
};
goog.dom.safe.setIframeSrc = function(a, b) {
  goog.dom.asserts.assertIsHTMLIFrameElement(a);
  a.src = goog.html.TrustedResourceUrl.unwrapTrustedURL(b);
};
goog.dom.safe.setIframeSrcdoc = function(a, b) {
  goog.dom.asserts.assertIsHTMLIFrameElement(a);
  a.srcdoc = goog.html.SafeHtml.unwrapTrustedHTML(b);
};
goog.dom.safe.setLinkHrefAndRel = function(a, b, c) {
  goog.dom.asserts.assertIsHTMLLinkElement(a);
  a.rel = c;
  goog.string.internal.caseInsensitiveContains(c, "stylesheet") ? (goog.asserts.assert(b instanceof goog.html.TrustedResourceUrl, 'URL must be TrustedResourceUrl because "rel" contains "stylesheet"'), a.href = goog.html.TrustedResourceUrl.unwrapTrustedURL(b)) : a.href = b instanceof goog.html.TrustedResourceUrl ? goog.html.TrustedResourceUrl.unwrapTrustedURL(b) : b instanceof goog.html.SafeUrl ? goog.html.SafeUrl.unwrapTrustedURL(b) : goog.html.SafeUrl.unwrapTrustedURL(goog.html.SafeUrl.sanitizeAssertUnchanged(b));
};
goog.dom.safe.setObjectData = function(a, b) {
  goog.dom.asserts.assertIsHTMLObjectElement(a);
  a.data = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
};
goog.dom.safe.setScriptSrc = function(a, b) {
  goog.dom.asserts.assertIsHTMLScriptElement(a);
  a.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
  var c = goog.getScriptNonce();
  c && a.setAttribute("nonce", c);
};
goog.dom.safe.setScriptContent = function(a, b) {
  goog.dom.asserts.assertIsHTMLScriptElement(a);
  a.text = goog.html.SafeScript.unwrapTrustedScript(b);
  var c = goog.getScriptNonce();
  c && a.setAttribute("nonce", c);
};
goog.dom.safe.setLocationHref = function(a, b) {
  goog.dom.asserts.assertIsLocation(a);
  var c = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
  a.href = goog.html.SafeUrl.unwrapTrustedURL(c);
};
goog.dom.safe.assignLocation = function(a, b) {
  goog.dom.asserts.assertIsLocation(a);
  var c = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
  a.assign(goog.html.SafeUrl.unwrapTrustedURL(c));
};
goog.dom.safe.replaceLocation = function(a, b) {
  goog.dom.asserts.assertIsLocation(a);
  var c = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
  a.replace(goog.html.SafeUrl.unwrapTrustedURL(c));
};
goog.dom.safe.openInWindow = function(a, b, c, d, e) {
  a = a instanceof goog.html.SafeUrl ? a : goog.html.SafeUrl.sanitizeAssertUnchanged(a);
  return (b || goog.global).open(goog.html.SafeUrl.unwrapTrustedURL(a), c ? goog.string.Const.unwrap(c) : "", d, e);
};
goog.dom.safe.parseFromStringHtml = function(a, b) {
  return goog.dom.safe.parseFromString(a, b, "text/html");
};
goog.dom.safe.parseFromString = function(a, b, c) {
  return a.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(b), c);
};
goog.dom.safe.createImageFromBlob = function(a) {
  if (!/^image\/.*/g.test(a.type)) {
    throw Error("goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.");
  }
  var b = goog.global.URL.createObjectURL(a);
  a = new goog.global.Image;
  a.onload = function() {
    goog.global.URL.revokeObjectURL(b);
  };
  goog.dom.safe.setImageSrc(a, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Image blob URL."), b));
  return a;
};
goog.string.DETECT_DOUBLE_ESCAPING = !1;
goog.string.FORCE_NON_DOM_HTML_UNESCAPING = !1;
goog.string.Unicode = {NBSP:"\u00a0"};
goog.string.startsWith = goog.string.internal.startsWith;
goog.string.endsWith = goog.string.internal.endsWith;
goog.string.caseInsensitiveStartsWith = goog.string.internal.caseInsensitiveStartsWith;
goog.string.caseInsensitiveEndsWith = goog.string.internal.caseInsensitiveEndsWith;
goog.string.caseInsensitiveEquals = goog.string.internal.caseInsensitiveEquals;
goog.string.subs = function(a, b) {
  for (var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;) {
    d += c.shift() + e.shift();
  }
  return d + c.join("%s");
};
goog.string.collapseWhitespace = function(a) {
  return a.replace(/[\s\xa0]+/g, " ").replace(/^\s+|\s+$/g, "");
};
goog.string.isEmptyOrWhitespace = goog.string.internal.isEmptyOrWhitespace;
goog.string.isEmptyString = function(a) {
  return 0 == a.length;
};
goog.string.isEmpty = goog.string.isEmptyOrWhitespace;
goog.string.isEmptyOrWhitespaceSafe = function(a) {
  return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(a));
};
goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe;
goog.string.isBreakingWhitespace = function(a) {
  return !/[^\t\n\r ]/.test(a);
};
goog.string.isAlpha = function(a) {
  return !/[^a-zA-Z]/.test(a);
};
goog.string.isNumeric = function(a) {
  return !/[^0-9]/.test(a);
};
goog.string.isAlphaNumeric = function(a) {
  return !/[^a-zA-Z0-9]/.test(a);
};
goog.string.isSpace = function(a) {
  return " " == a;
};
goog.string.isUnicodeChar = function(a) {
  return 1 == a.length && " " <= a && "~" >= a || "\u0080" <= a && "\ufffd" >= a;
};
goog.string.stripNewlines = function(a) {
  return a.replace(/(\r\n|\r|\n)+/g, " ");
};
goog.string.canonicalizeNewlines = function(a) {
  return a.replace(/(\r\n|\r|\n)/g, "\n");
};
goog.string.normalizeWhitespace = function(a) {
  return a.replace(/\xa0|\s/g, " ");
};
goog.string.normalizeSpaces = function(a) {
  return a.replace(/\xa0|[ \t]+/g, " ");
};
goog.string.collapseBreakingSpaces = function(a) {
  return a.replace(/[\t\r\n ]+/g, " ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, "");
};
goog.string.trim = goog.string.internal.trim;
goog.string.trimLeft = function(a) {
  return a.replace(/^[\s\xa0]+/, "");
};
goog.string.trimRight = function(a) {
  return a.replace(/[\s\xa0]+$/, "");
};
goog.string.caseInsensitiveCompare = goog.string.internal.caseInsensitiveCompare;
goog.string.numberAwareCompare_ = function(a, b, c) {
  if (a == b) {
    return 0;
  }
  if (!a) {
    return -1;
  }
  if (!b) {
    return 1;
  }
  for (var d = a.toLowerCase().match(c), e = b.toLowerCase().match(c), f = Math.min(d.length, e.length), g = 0; g < f; g++) {
    c = d[g];
    var h = e[g];
    if (c != h) {
      return a = parseInt(c, 10), !isNaN(a) && (b = parseInt(h, 10), !isNaN(b) && a - b) ? a - b : c < h ? -1 : 1;
    }
  }
  return d.length != e.length ? d.length - e.length : a < b ? -1 : 1;
};
goog.string.intAwareCompare = function(a, b) {
  return goog.string.numberAwareCompare_(a, b, /\d+|\D+/g);
};
goog.string.floatAwareCompare = function(a, b) {
  return goog.string.numberAwareCompare_(a, b, /\d+|\.\d+|\D+/g);
};
goog.string.numerateCompare = goog.string.floatAwareCompare;
goog.string.urlEncode = function(a) {
  return encodeURIComponent(String(a));
};
goog.string.urlDecode = function(a) {
  return decodeURIComponent(a.replace(/\+/g, " "));
};
goog.string.newLineToBr = goog.string.internal.newLineToBr;
goog.string.htmlEscape = function(a, b) {
  a = goog.string.internal.htmlEscape(a, b);
  goog.string.DETECT_DOUBLE_ESCAPING && (a = a.replace(goog.string.E_RE_, "&#101;"));
  return a;
};
goog.string.E_RE_ = /e/g;
goog.string.unescapeEntities = function(a) {
  return goog.string.contains(a, "&") ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && "document" in goog.global ? goog.string.unescapeEntitiesUsingDom_(a) : goog.string.unescapePureXmlEntities_(a) : a;
};
goog.string.unescapeEntitiesWithDocument = function(a, b) {
  return goog.string.contains(a, "&") ? goog.string.unescapeEntitiesUsingDom_(a, b) : a;
};
goog.string.unescapeEntitiesUsingDom_ = function(a, b) {
  var c = {"&amp;":"&", "&lt;":"<", "&gt;":">", "&quot;":'"'};
  var d = b ? b.createElement("div") : goog.global.document.createElement("div");
  return a.replace(goog.string.HTML_ENTITY_PATTERN_, function(a, b) {
    var e = c[a];
    if (e) {
      return e;
    }
    if ("#" == b.charAt(0)) {
      var f = Number("0" + b.substr(1));
      isNaN(f) || (e = String.fromCharCode(f));
    }
    e || (goog.dom.safe.setInnerHtml(d, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Single HTML entity."), a + " ")), e = d.firstChild.nodeValue.slice(0, -1));
    return c[a] = e;
  });
};
goog.string.unescapePureXmlEntities_ = function(a) {
  return a.replace(/&([^;]+);/g, function(a, c) {
    switch(c) {
      case "amp":
        return "&";
      case "lt":
        return "<";
      case "gt":
        return ">";
      case "quot":
        return '"';
      default:
        if ("#" == c.charAt(0)) {
          var b = Number("0" + c.substr(1));
          if (!isNaN(b)) {
            return String.fromCharCode(b);
          }
        }
        return a;
    }
  });
};
goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g;
goog.string.whitespaceEscape = function(a, b) {
  return goog.string.newLineToBr(a.replace(/  /g, " &#160;"), b);
};
goog.string.preserveSpaces = function(a) {
  return a.replace(/(^|[\n ]) /g, "$1" + goog.string.Unicode.NBSP);
};
goog.string.stripQuotes = function(a, b) {
  for (var c = b.length, d = 0; d < c; d++) {
    var e = 1 == c ? b : b.charAt(d);
    if (a.charAt(0) == e && a.charAt(a.length - 1) == e) {
      return a.substring(1, a.length - 1);
    }
  }
  return a;
};
goog.string.truncate = function(a, b, c) {
  c && (a = goog.string.unescapeEntities(a));
  a.length > b && (a = a.substring(0, b - 3) + "...");
  c && (a = goog.string.htmlEscape(a));
  return a;
};
goog.string.truncateMiddle = function(a, b, c, d) {
  c && (a = goog.string.unescapeEntities(a));
  if (d && a.length > b) {
    d > b && (d = b);
    var e = a.length - d;
    a = a.substring(0, b - d) + "..." + a.substring(e);
  } else {
    a.length > b && (d = Math.floor(b / 2), e = a.length - d, a = a.substring(0, d + b % 2) + "..." + a.substring(e));
  }
  c && (a = goog.string.htmlEscape(a));
  return a;
};
goog.string.specialEscapeChars_ = {"\x00":"\\0", "\b":"\\b", "\f":"\\f", "\n":"\\n", "\r":"\\r", "\t":"\\t", "\x0B":"\\x0B", '"':'\\"', "\\":"\\\\", "<":"\\u003C"};
goog.string.jsEscapeCache_ = {"'":"\\'"};
goog.string.quote = function(a) {
  a = String(a);
  for (var b = ['"'], c = 0; c < a.length; c++) {
    var d = a.charAt(c), e = d.charCodeAt(0);
    b[c + 1] = goog.string.specialEscapeChars_[d] || (31 < e && 127 > e ? d : goog.string.escapeChar(d));
  }
  b.push('"');
  return b.join("");
};
goog.string.escapeString = function(a) {
  for (var b = [], c = 0; c < a.length; c++) {
    b[c] = goog.string.escapeChar(a.charAt(c));
  }
  return b.join("");
};
goog.string.escapeChar = function(a) {
  if (a in goog.string.jsEscapeCache_) {
    return goog.string.jsEscapeCache_[a];
  }
  if (a in goog.string.specialEscapeChars_) {
    return goog.string.jsEscapeCache_[a] = goog.string.specialEscapeChars_[a];
  }
  var b = a.charCodeAt(0);
  if (31 < b && 127 > b) {
    var c = a;
  } else {
    if (256 > b) {
      if (c = "\\x", 16 > b || 256 < b) {
        c += "0";
      }
    } else {
      c = "\\u", 4096 > b && (c += "0");
    }
    c += b.toString(16).toUpperCase();
  }
  return goog.string.jsEscapeCache_[a] = c;
};
goog.string.contains = goog.string.internal.contains;
goog.string.caseInsensitiveContains = goog.string.internal.caseInsensitiveContains;
goog.string.countOf = function(a, b) {
  return a && b ? a.split(b).length - 1 : 0;
};
goog.string.removeAt = function(a, b, c) {
  var d = a;
  0 <= b && b < a.length && 0 < c && (d = a.substr(0, b) + a.substr(b + c, a.length - b - c));
  return d;
};
goog.string.remove = function(a, b) {
  return a.replace(b, "");
};
goog.string.removeAll = function(a, b) {
  var c = new RegExp(goog.string.regExpEscape(b), "g");
  return a.replace(c, "");
};
goog.string.replaceAll = function(a, b, c) {
  b = new RegExp(goog.string.regExpEscape(b), "g");
  return a.replace(b, c.replace(/\$/g, "$$$$"));
};
goog.string.regExpEscape = function(a) {
  return String(a).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
};
goog.string.repeat = String.prototype.repeat ? function(a, b) {
  return a.repeat(b);
} : function(a, b) {
  return Array(b + 1).join(a);
};
goog.string.padNumber = function(a, b, c) {
  a = void 0 !== c ? a.toFixed(c) : String(a);
  c = a.indexOf(".");
  -1 == c && (c = a.length);
  return goog.string.repeat("0", Math.max(0, b - c)) + a;
};
goog.string.makeSafe = function(a) {
  return null == a ? "" : String(a);
};
goog.string.buildString = function(a) {
  return Array.prototype.join.call(arguments, "");
};
goog.string.getRandomString = function() {
  return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
};
goog.string.compareVersions = goog.string.internal.compareVersions;
goog.string.hashCode = function(a) {
  for (var b = 0, c = 0; c < a.length; ++c) {
    b = 31 * b + a.charCodeAt(c) >>> 0;
  }
  return b;
};
goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0;
goog.string.createUniqueString = function() {
  return "goog_" + goog.string.uniqueStringCounter_++;
};
goog.string.toNumber = function(a) {
  var b = Number(a);
  return 0 == b && goog.string.isEmptyOrWhitespace(a) ? NaN : b;
};
goog.string.isLowerCamelCase = function(a) {
  return /^[a-z]+([A-Z][a-z]*)*$/.test(a);
};
goog.string.isUpperCamelCase = function(a) {
  return /^([A-Z][a-z]*)+$/.test(a);
};
goog.string.toCamelCase = function(a) {
  return String(a).replace(/\-([a-z])/g, function(a, c) {
    return c.toUpperCase();
  });
};
goog.string.toSelectorCase = function(a) {
  return String(a).replace(/([A-Z])/g, "-$1").toLowerCase();
};
goog.string.toTitleCase = function(a, b) {
  var c = "string" === typeof b ? goog.string.regExpEscape(b) : "\\s";
  return a.replace(new RegExp("(^" + (c ? "|[" + c + "]+" : "") + ")([a-z])", "g"), function(a, b, c) {
    return b + c.toUpperCase();
  });
};
goog.string.capitalize = function(a) {
  return String(a.charAt(0)).toUpperCase() + String(a.substr(1)).toLowerCase();
};
goog.string.parseInt = function(a) {
  isFinite(a) && (a = String(a));
  return "string" === typeof a ? /^\s*-?0x/i.test(a) ? parseInt(a, 16) : parseInt(a, 10) : NaN;
};
goog.string.splitLimit = function(a, b, c) {
  a = a.split(b);
  for (var d = []; 0 < c && a.length;) {
    d.push(a.shift()), c--;
  }
  a.length && d.push(a.join(b));
  return d;
};
goog.string.lastComponent = function(a, b) {
  if (b) {
    "string" == typeof b && (b = [b]);
  } else {
    return a;
  }
  for (var c = -1, d = 0; d < b.length; d++) {
    if ("" != b[d]) {
      var e = a.lastIndexOf(b[d]);
      e > c && (c = e);
    }
  }
  return -1 == c ? a : a.slice(c + 1);
};
goog.string.editDistance = function(a, b) {
  var c = [], d = [];
  if (a == b) {
    return 0;
  }
  if (!a.length || !b.length) {
    return Math.max(a.length, b.length);
  }
  for (var e = 0; e < b.length + 1; e++) {
    c[e] = e;
  }
  for (e = 0; e < a.length; e++) {
    d[0] = e + 1;
    for (var f = 0; f < b.length; f++) {
      d[f + 1] = Math.min(d[f] + 1, c[f + 1] + 1, c[f] + Number(a[e] != b[f]));
    }
    for (f = 0; f < c.length; f++) {
      c[f] = d[f];
    }
  }
  return d[b.length];
};
goog.proto2 = {};
goog.proto2.Descriptor = function(a, b, c) {
  this.messageType_ = a;
  this.name_ = b.name || null;
  this.fullName_ = b.fullName || null;
  this.containingType_ = b.containingType;
  this.fields_ = {};
  for (a = 0; a < c.length; a++) {
    b = c[a], this.fields_[b.getTag()] = b;
  }
};
goog.proto2.Descriptor.prototype.getName = function() {
  return this.name_;
};
goog.proto2.Descriptor.prototype.getFullName = function() {
  return this.fullName_;
};
goog.proto2.Descriptor.prototype.getContainingType = function() {
  return this.containingType_ ? this.containingType_.getDescriptor() : null;
};
goog.proto2.Descriptor.prototype.getFields = function() {
  var a = goog.object.getValues(this.fields_);
  goog.array.sort(a, function(a, c) {
    return a.getTag() - c.getTag();
  });
  return a;
};
goog.proto2.Descriptor.prototype.getFieldsMap = function() {
  return this.fields_;
};
goog.proto2.Descriptor.prototype.findFieldByName = function(a) {
  return goog.object.findValue(this.fields_, function(b, c, d) {
    return b.getName() == a;
  }) || null;
};
goog.proto2.Descriptor.prototype.findFieldByTag = function(a) {
  goog.asserts.assert(goog.string.isNumeric(a));
  return this.fields_[parseInt(a, 10)] || null;
};
goog.proto2.Descriptor.prototype.createMessageInstance = function() {
  return new this.messageType_;
};
goog.proto2.FieldDescriptor = function(a, b, c) {
  this.parent_ = a;
  goog.asserts.assert(goog.string.isNumeric(b));
  this.tag_ = b;
  this.name_ = c.name;
  this.isPacked_ = !!c.packed;
  this.isRepeated_ = !!c.repeated;
  this.isRequired_ = !!c.required;
  this.fieldType_ = c.fieldType;
  this.nativeType_ = c.type;
  this.deserializationConversionPermitted_ = !1;
  switch(this.fieldType_) {
    case goog.proto2.FieldDescriptor.FieldType.INT64:
    case goog.proto2.FieldDescriptor.FieldType.UINT64:
    case goog.proto2.FieldDescriptor.FieldType.FIXED64:
    case goog.proto2.FieldDescriptor.FieldType.SFIXED64:
    case goog.proto2.FieldDescriptor.FieldType.SINT64:
    case goog.proto2.FieldDescriptor.FieldType.FLOAT:
    case goog.proto2.FieldDescriptor.FieldType.DOUBLE:
      this.deserializationConversionPermitted_ = !0;
  }
  this.defaultValue_ = c.defaultValue;
};
goog.proto2.FieldDescriptor.FieldType = {DOUBLE:1, FLOAT:2, INT64:3, UINT64:4, INT32:5, FIXED64:6, FIXED32:7, BOOL:8, STRING:9, GROUP:10, MESSAGE:11, BYTES:12, UINT32:13, ENUM:14, SFIXED32:15, SFIXED64:16, SINT32:17, SINT64:18};
goog.proto2.FieldDescriptor.prototype.getTag = function() {
  return this.tag_;
};
goog.proto2.FieldDescriptor.prototype.getContainingType = function() {
  return this.parent_.prototype.getDescriptor();
};
goog.proto2.FieldDescriptor.prototype.getName = function() {
  return this.name_;
};
goog.proto2.FieldDescriptor.prototype.getDefaultValue = function() {
  if (void 0 === this.defaultValue_) {
    var a = this.nativeType_;
    if (a === Boolean) {
      this.defaultValue_ = !1;
    } else {
      if (a === Number) {
        this.defaultValue_ = 0;
      } else {
        if (a === String) {
          this.defaultValue_ = this.deserializationConversionPermitted_ ? "0" : "";
        } else {
          return new a;
        }
      }
    }
  }
  return this.defaultValue_;
};
goog.proto2.FieldDescriptor.prototype.getFieldType = function() {
  return this.fieldType_;
};
goog.proto2.FieldDescriptor.prototype.getNativeType = function() {
  return this.nativeType_;
};
goog.proto2.FieldDescriptor.prototype.deserializationConversionPermitted = function() {
  return this.deserializationConversionPermitted_;
};
goog.proto2.FieldDescriptor.prototype.getFieldMessageType = function() {
  return this.nativeType_.prototype.getDescriptor();
};
goog.proto2.FieldDescriptor.prototype.isCompositeType = function() {
  return this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.MESSAGE || this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.GROUP;
};
goog.proto2.FieldDescriptor.prototype.isPacked = function() {
  return this.isPacked_;
};
goog.proto2.FieldDescriptor.prototype.isRepeated = function() {
  return this.isRepeated_;
};
goog.proto2.FieldDescriptor.prototype.isRequired = function() {
  return this.isRequired_;
};
goog.proto2.FieldDescriptor.prototype.isOptional = function() {
  return !this.isRepeated_ && !this.isRequired_;
};
goog.proto2.Message = function() {
  this.values_ = {};
  this.fields_ = this.getDescriptor().getFieldsMap();
  this.deserializedFields_ = this.lazyDeserializer_ = null;
};
goog.proto2.Message.FieldType = {DOUBLE:1, FLOAT:2, INT64:3, UINT64:4, INT32:5, FIXED64:6, FIXED32:7, BOOL:8, STRING:9, GROUP:10, MESSAGE:11, BYTES:12, UINT32:13, ENUM:14, SFIXED32:15, SFIXED64:16, SINT32:17, SINT64:18};
goog.proto2.Message.prototype.initializeForLazyDeserializer = function(a, b) {
  this.lazyDeserializer_ = a;
  this.values_ = b;
  this.deserializedFields_ = {};
};
goog.proto2.Message.prototype.setUnknown = function(a, b) {
  goog.asserts.assert(!this.fields_[a], "Field is not unknown in this message");
  goog.asserts.assert(1 <= a, "Tag " + a + ' has value "' + b + '" in descriptor ' + this.getDescriptor().getName());
  goog.asserts.assert(null !== b, "Value cannot be null");
  this.values_[a] = b;
  this.deserializedFields_ && delete this.deserializedFields_[a];
};
goog.proto2.Message.prototype.forEachUnknown = function(a, b) {
  var c = b || this, d;
  for (d in this.values_) {
    var e = Number(d);
    this.fields_[e] || a.call(c, e, this.values_[d]);
  }
};
goog.proto2.Message.prototype.getDescriptor = goog.abstractMethod;
goog.proto2.Message.prototype.has = function(a) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  return this.has$Value(a.getTag());
};
goog.proto2.Message.prototype.arrayOf = function(a) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  return this.array$Values(a.getTag());
};
goog.proto2.Message.prototype.countOf = function(a) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  return this.count$Values(a.getTag());
};
goog.proto2.Message.prototype.get = function(a, b) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  return this.get$Value(a.getTag(), b);
};
goog.proto2.Message.prototype.getOrDefault = function(a, b) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  return this.get$ValueOrDefault(a.getTag(), b);
};
goog.proto2.Message.prototype.set = function(a, b) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  this.set$Value(a.getTag(), b);
};
goog.proto2.Message.prototype.add = function(a, b) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  this.add$Value(a.getTag(), b);
};
goog.proto2.Message.prototype.clear = function(a) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  this.clear$Field(a.getTag());
};
goog.proto2.Message.prototype.equals = function(a) {
  if (!a || this.constructor != a.constructor) {
    return !1;
  }
  for (var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++) {
    var d = b[c], e = d.getTag();
    if (this.has$Value(e) != a.has$Value(e)) {
      return !1;
    }
    if (this.has$Value(e)) {
      var f = d.isCompositeType(), g = this.getValueForTag_(e);
      e = a.getValueForTag_(e);
      if (d.isRepeated()) {
        if (g.length != e.length) {
          return !1;
        }
        for (d = 0; d < g.length; d++) {
          var h = g[d], k = e[d];
          if (f ? !h.equals(k) : h != k) {
            return !1;
          }
        }
      } else {
        if (f ? !g.equals(e) : g != e) {
          return !1;
        }
      }
    }
  }
  return !0;
};
goog.proto2.Message.prototype.copyFrom = function(a) {
  goog.asserts.assert(this.constructor == a.constructor, "The source message must have the same type.");
  this != a && (this.values_ = {}, this.deserializedFields_ && (this.deserializedFields_ = {}), this.mergeFrom(a));
};
goog.proto2.Message.prototype.mergeFrom = function(a) {
  goog.asserts.assert(this.constructor == a.constructor, "The source message must have the same type.");
  for (var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++) {
    var d = b[c], e = d.getTag();
    if (a.has$Value(e)) {
      this.deserializedFields_ && delete this.deserializedFields_[d.getTag()];
      var f = d.isCompositeType();
      if (d.isRepeated()) {
        d = a.array$Values(e);
        for (var g = 0; g < d.length; g++) {
          this.add$Value(e, f ? d[g].clone() : d[g]);
        }
      } else {
        d = a.getValueForTag_(e), f ? (f = this.getValueForTag_(e)) ? f.mergeFrom(d) : this.set$Value(e, d.clone()) : this.set$Value(e, d);
      }
    }
  }
};
goog.proto2.Message.prototype.clone = function() {
  var a = new this.constructor;
  a.copyFrom(this);
  return a;
};
goog.proto2.Message.prototype.initDefaults = function(a) {
  for (var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++) {
    var d = b[c], e = d.getTag(), f = d.isCompositeType();
    this.has$Value(e) || d.isRepeated() || (f ? this.values_[e] = new (d.getNativeType()) : a && (this.values_[e] = d.getDefaultValue()));
    if (f) {
      if (d.isRepeated()) {
        for (d = this.array$Values(e), e = 0; e < d.length; e++) {
          d[e].initDefaults(a);
        }
      } else {
        this.get$Value(e).initDefaults(a);
      }
    }
  }
};
goog.proto2.Message.prototype.has$Value = function(a) {
  return null != this.values_[a];
};
goog.proto2.Message.prototype.getValueForTag_ = function(a) {
  var b = this.values_[a];
  return null == b ? null : this.lazyDeserializer_ ? a in this.deserializedFields_ ? this.deserializedFields_[a] : (b = this.lazyDeserializer_.deserializeField(this, this.fields_[a], b), this.deserializedFields_[a] = b) : b;
};
goog.proto2.Message.prototype.get$Value = function(a, b) {
  var c = this.getValueForTag_(a);
  if (this.fields_[a].isRepeated()) {
    var d = b || 0;
    goog.asserts.assert(0 <= d && d < c.length, "Given index %s is out of bounds.  Repeated field length: %s", d, c.length);
    return c[d];
  }
  return c;
};
goog.proto2.Message.prototype.get$ValueOrDefault = function(a, b) {
  return this.has$Value(a) ? this.get$Value(a, b) : this.fields_[a].getDefaultValue();
};
goog.proto2.Message.prototype.array$Values = function(a) {
  return this.getValueForTag_(a) || [];
};
goog.proto2.Message.prototype.count$Values = function(a) {
  return this.fields_[a].isRepeated() ? this.has$Value(a) ? this.values_[a].length : 0 : this.has$Value(a) ? 1 : 0;
};
goog.proto2.Message.prototype.set$Value = function(a, b) {
  goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[a], b);
  this.values_[a] = b;
  this.deserializedFields_ && (this.deserializedFields_[a] = b);
};
goog.proto2.Message.prototype.add$Value = function(a, b) {
  goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[a], b);
  this.values_[a] || (this.values_[a] = []);
  this.values_[a].push(b);
  this.deserializedFields_ && delete this.deserializedFields_[a];
};
goog.proto2.Message.prototype.checkFieldType_ = function(a, b) {
  a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM ? goog.asserts.assertNumber(b) : goog.asserts.assert(Object(b).constructor == a.getNativeType());
};
goog.proto2.Message.prototype.clear$Field = function(a) {
  delete this.values_[a];
  this.deserializedFields_ && delete this.deserializedFields_[a];
};
goog.proto2.Message.createDescriptor = function(a, b) {
  var c = [], d = b[0], e;
  for (e in b) {
    0 != e && c.push(new goog.proto2.FieldDescriptor(a, e, b[e]));
  }
  return new goog.proto2.Descriptor(a, d, c);
};
goog.proto2.Serializer = function() {
};
goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS = !1;
goog.proto2.Serializer.prototype.serialize = goog.abstractMethod;
goog.proto2.Serializer.prototype.getSerializedValue = function(a, b) {
  return a.isCompositeType() ? this.serialize(b) : "number" !== typeof b || isFinite(b) ? b : b.toString();
};
goog.proto2.Serializer.prototype.deserialize = function(a, b) {
  var c = a.createMessageInstance();
  this.deserializeTo(c, b);
  goog.asserts.assert(c instanceof goog.proto2.Message);
  return c;
};
goog.proto2.Serializer.prototype.deserializeTo = goog.abstractMethod;
goog.proto2.Serializer.prototype.getDeserializedValue = function(a, b) {
  if (a.isCompositeType()) {
    return b instanceof goog.proto2.Message ? b : this.deserialize(a.getFieldMessageType(), b);
  }
  if (a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM) {
    if (goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS && "string" === typeof b) {
      var c = a.getNativeType();
      if (c.hasOwnProperty(b)) {
        return c[b];
      }
    }
    return "string" === typeof b && goog.proto2.Serializer.INTEGER_REGEX.test(b) && (c = Number(b), 0 < c) ? c : b;
  }
  if (!a.deserializationConversionPermitted()) {
    return b;
  }
  c = a.getNativeType();
  if (c === String) {
    if ("number" === typeof b) {
      return String(b);
    }
  } else {
    if (c === Number && "string" === typeof b && ("Infinity" === b || "-Infinity" === b || "NaN" === b || goog.proto2.Serializer.INTEGER_REGEX.test(b))) {
      return Number(b);
    }
  }
  return b;
};
goog.proto2.Serializer.INTEGER_REGEX = /^-?[0-9]+$/;
goog.proto2.LazyDeserializer = function() {
};
goog.inherits(goog.proto2.LazyDeserializer, goog.proto2.Serializer);
goog.proto2.LazyDeserializer.prototype.deserialize = function(a, b) {
  var c = a.createMessageInstance();
  c.initializeForLazyDeserializer(this, b);
  goog.asserts.assert(c instanceof goog.proto2.Message);
  return c;
};
goog.proto2.LazyDeserializer.prototype.deserializeTo = function(a, b) {
  throw Error("Unimplemented");
};
goog.proto2.LazyDeserializer.prototype.deserializeField = goog.abstractMethod;
goog.proto2.PbLiteSerializer = function() {
};
goog.inherits(goog.proto2.PbLiteSerializer, goog.proto2.LazyDeserializer);
goog.proto2.PbLiteSerializer.prototype.zeroIndexing_ = !1;
goog.proto2.PbLiteSerializer.prototype.setZeroIndexed = function(a) {
  this.zeroIndexing_ = a;
};
goog.proto2.PbLiteSerializer.prototype.serialize = function(a) {
  for (var b = a.getDescriptor().getFields(), c = [], d = this.zeroIndexing_, e = 0; e < b.length; e++) {
    var f = b[e];
    if (a.has(f)) {
      var g = f.getTag();
      g = d ? g - 1 : g;
      if (f.isRepeated()) {
        c[g] = [];
        for (var h = 0; h < a.countOf(f); h++) {
          c[g][h] = this.getSerializedValue(f, a.get(f, h));
        }
      } else {
        c[g] = this.getSerializedValue(f, a.get(f));
      }
    }
  }
  a.forEachUnknown(function(a, b) {
    c[d ? a - 1 : a] = b;
  });
  return c;
};
goog.proto2.PbLiteSerializer.prototype.deserializeField = function(a, b, c) {
  if (null == c) {
    return c;
  }
  if (b.isRepeated()) {
    a = [];
    goog.asserts.assert(goog.isArray(c), "Value must be array: %s", c);
    for (var d = 0; d < c.length; d++) {
      a[d] = this.getDeserializedValue(b, c[d]);
    }
    return a;
  }
  return this.getDeserializedValue(b, c);
};
goog.proto2.PbLiteSerializer.prototype.getSerializedValue = function(a, b) {
  return a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? b ? 1 : 0 : goog.proto2.Serializer.prototype.getSerializedValue.apply(this, arguments);
};
goog.proto2.PbLiteSerializer.prototype.getDeserializedValue = function(a, b) {
  return a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? (goog.asserts.assert("number" === typeof b || "boolean" === typeof b, "Value is expected to be a number or boolean"), !!b) : goog.proto2.Serializer.prototype.getDeserializedValue.apply(this, arguments);
};
goog.proto2.PbLiteSerializer.prototype.deserialize = function(a, b) {
  var c = b;
  if (this.zeroIndexing_) {
    c = [];
    for (var d in b) {
      c[parseInt(d, 10) + 1] = b[d];
    }
  }
  return goog.proto2.PbLiteSerializer.superClass_.deserialize.call(this, a, c);
};
/*

 Protocol Buffer 2 Copyright 2008 Google Inc.
 All other code copyright its respective owners.
 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
var i18n = {phonenumbers:{}};
i18n.phonenumbers.NumberFormat = function() {
  goog.proto2.Message.call(this);
};
goog.inherits(i18n.phonenumbers.NumberFormat, goog.proto2.Message);
i18n.phonenumbers.NumberFormat.descriptor_ = null;
i18n.phonenumbers.NumberFormat.prototype.getPattern = function() {
  return this.get$Value(1);
};
i18n.phonenumbers.NumberFormat.prototype.getPatternOrDefault = function() {
  return this.get$ValueOrDefault(1);
};
i18n.phonenumbers.NumberFormat.prototype.setPattern = function(a) {
  this.set$Value(1, a);
};
i18n.phonenumbers.NumberFormat.prototype.hasPattern = function() {
  return this.has$Value(1);
};
i18n.phonenumbers.NumberFormat.prototype.patternCount = function() {
  return this.count$Values(1);
};
i18n.phonenumbers.NumberFormat.prototype.clearPattern = function() {
  this.clear$Field(1);
};
i18n.phonenumbers.NumberFormat.prototype.getFormat = function() {
  return this.get$Value(2);
};
i18n.phonenumbers.NumberFormat.prototype.getFormatOrDefault = function() {
  return this.get$ValueOrDefault(2);
};
i18n.phonenumbers.NumberFormat.prototype.setFormat = function(a) {
  this.set$Value(2, a);
};
i18n.phonenumbers.NumberFormat.prototype.hasFormat = function() {
  return this.has$Value(2);
};
i18n.phonenumbers.NumberFormat.prototype.formatCount = function() {
  return this.count$Values(2);
};
i18n.phonenumbers.NumberFormat.prototype.clearFormat = function() {
  this.clear$Field(2);
};
i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPattern = function(a) {
  return this.get$Value(3, a);
};
i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPatternOrDefault = function(a) {
  return this.get$ValueOrDefault(3, a);
};
i18n.phonenumbers.NumberFormat.prototype.addLeadingDigitsPattern = function(a) {
  this.add$Value(3, a);
};
i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternArray = function() {
  return this.array$Values(3);
};
i18n.phonenumbers.NumberFormat.prototype.hasLeadingDigitsPattern = function() {
  return this.has$Value(3);
};
i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternCount = function() {
  return this.count$Values(3);
};
i18n.phonenumbers.NumberFormat.prototype.clearLeadingDigitsPattern = function() {
  this.clear$Field(3);
};
i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRule = function() {
  return this.get$Value(4);
};
i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRuleOrDefault = function() {
  return this.get$ValueOrDefault(4);
};
i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixFormattingRule = function(a) {
  this.set$Value(4, a);
};
i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixFormattingRule = function() {
  return this.has$Value(4);
};
i18n.phonenumbers.NumberFormat.prototype.nationalPrefixFormattingRuleCount = function() {
  return this.count$Values(4);
};
i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixFormattingRule = function() {
  this.clear$Field(4);
};
i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormatting = function() {
  return this.get$Value(6);
};
i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormattingOrDefault = function() {
  return this.get$ValueOrDefault(6);
};
i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixOptionalWhenFormatting = function(a) {
  this.set$Value(6, a);
};
i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixOptionalWhenFormatting = function() {
  return this.has$Value(6);
};
i18n.phonenumbers.NumberFormat.prototype.nationalPrefixOptionalWhenFormattingCount = function() {
  return this.count$Values(6);
};
i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixOptionalWhenFormatting = function() {
  this.clear$Field(6);
};
i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRule = function() {
  return this.get$Value(5);
};
i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRuleOrDefault = function() {
  return this.get$ValueOrDefault(5);
};
i18n.phonenumbers.NumberFormat.prototype.setDomesticCarrierCodeFormattingRule = function(a) {
  this.set$Value(5, a);
};
i18n.phonenumbers.NumberFormat.prototype.hasDomesticCarrierCodeFormattingRule = function() {
  return this.has$Value(5);
};
i18n.phonenumbers.NumberFormat.prototype.domesticCarrierCodeFormattingRuleCount = function() {
  return this.count$Values(5);
};
i18n.phonenumbers.NumberFormat.prototype.clearDomesticCarrierCodeFormattingRule = function() {
  this.clear$Field(5);
};
i18n.phonenumbers.PhoneNumberDesc = function() {
  goog.proto2.Message.call(this);
};
goog.inherits(i18n.phonenumbers.PhoneNumberDesc, goog.proto2.Message);
i18n.phonenumbers.PhoneNumberDesc.descriptor_ = null;
i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPattern = function() {
  return this.get$Value(2);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPatternOrDefault = function() {
  return this.get$ValueOrDefault(2);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.setNationalNumberPattern = function(a) {
  this.set$Value(2, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.hasNationalNumberPattern = function() {
  return this.has$Value(2);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.nationalNumberPatternCount = function() {
  return this.count$Values(2);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.clearNationalNumberPattern = function() {
  this.clear$Field(2);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLength = function(a) {
  return this.get$Value(9, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthOrDefault = function(a) {
  return this.get$ValueOrDefault(9, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLength = function(a) {
  this.add$Value(9, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthArray = function() {
  return this.array$Values(9);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLength = function() {
  return this.has$Value(9);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthCount = function() {
  return this.count$Values(9);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLength = function() {
  this.clear$Field(9);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnly = function(a) {
  return this.get$Value(10, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnlyOrDefault = function(a) {
  return this.get$ValueOrDefault(10, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLengthLocalOnly = function(a) {
  this.add$Value(10, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyArray = function() {
  return this.array$Values(10);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLengthLocalOnly = function() {
  return this.has$Value(10);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyCount = function() {
  return this.count$Values(10);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLengthLocalOnly = function() {
  this.clear$Field(10);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumber = function() {
  return this.get$Value(6);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumberOrDefault = function() {
  return this.get$ValueOrDefault(6);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.setExampleNumber = function(a) {
  this.set$Value(6, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.hasExampleNumber = function() {
  return this.has$Value(6);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.exampleNumberCount = function() {
  return this.count$Values(6);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.clearExampleNumber = function() {
  this.clear$Field(6);
};
i18n.phonenumbers.PhoneMetadata = function() {
  goog.proto2.Message.call(this);
};
goog.inherits(i18n.phonenumbers.PhoneMetadata, goog.proto2.Message);
i18n.phonenumbers.PhoneMetadata.descriptor_ = null;
i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDesc = function() {
  return this.get$Value(1);
};
i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDescOrDefault = function() {
  return this.get$ValueOrDefault(1);
};
i18n.phonenumbers.PhoneMetadata.prototype.setGeneralDesc = function(a) {
  this.set$Value(1, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasGeneralDesc = function() {
  return this.has$Value(1);
};
i18n.phonenumbers.PhoneMetadata.prototype.generalDescCount = function() {
  return this.count$Values(1);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearGeneralDesc = function() {
  this.clear$Field(1);
};
i18n.phonenumbers.PhoneMetadata.prototype.getFixedLine = function() {
  return this.get$Value(2);
};
i18n.phonenumbers.PhoneMetadata.prototype.getFixedLineOrDefault = function() {
  return this.get$ValueOrDefault(2);
};
i18n.phonenumbers.PhoneMetadata.prototype.setFixedLine = function(a) {
  this.set$Value(2, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasFixedLine = function() {
  return this.has$Value(2);
};
i18n.phonenumbers.PhoneMetadata.prototype.fixedLineCount = function() {
  return this.count$Values(2);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearFixedLine = function() {
  this.clear$Field(2);
};
i18n.phonenumbers.PhoneMetadata.prototype.getMobile = function() {
  return this.get$Value(3);
};
i18n.phonenumbers.PhoneMetadata.prototype.getMobileOrDefault = function() {
  return this.get$ValueOrDefault(3);
};
i18n.phonenumbers.PhoneMetadata.prototype.setMobile = function(a) {
  this.set$Value(3, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasMobile = function() {
  return this.has$Value(3);
};
i18n.phonenumbers.PhoneMetadata.prototype.mobileCount = function() {
  return this.count$Values(3);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearMobile = function() {
  this.clear$Field(3);
};
i18n.phonenumbers.PhoneMetadata.prototype.getTollFree = function() {
  return this.get$Value(4);
};
i18n.phonenumbers.PhoneMetadata.prototype.getTollFreeOrDefault = function() {
  return this.get$ValueOrDefault(4);
};
i18n.phonenumbers.PhoneMetadata.prototype.setTollFree = function(a) {
  this.set$Value(4, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasTollFree = function() {
  return this.has$Value(4);
};
i18n.phonenumbers.PhoneMetadata.prototype.tollFreeCount = function() {
  return this.count$Values(4);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearTollFree = function() {
  this.clear$Field(4);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRate = function() {
  return this.get$Value(5);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRateOrDefault = function() {
  return this.get$ValueOrDefault(5);
};
i18n.phonenumbers.PhoneMetadata.prototype.setPremiumRate = function(a) {
  this.set$Value(5, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasPremiumRate = function() {
  return this.has$Value(5);
};
i18n.phonenumbers.PhoneMetadata.prototype.premiumRateCount = function() {
  return this.count$Values(5);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearPremiumRate = function() {
  this.clear$Field(5);
};
i18n.phonenumbers.PhoneMetadata.prototype.getSharedCost = function() {
  return this.get$Value(6);
};
i18n.phonenumbers.PhoneMetadata.prototype.getSharedCostOrDefault = function() {
  return this.get$ValueOrDefault(6);
};
i18n.phonenumbers.PhoneMetadata.prototype.setSharedCost = function(a) {
  this.set$Value(6, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasSharedCost = function() {
  return this.has$Value(6);
};
i18n.phonenumbers.PhoneMetadata.prototype.sharedCostCount = function() {
  return this.count$Values(6);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearSharedCost = function() {
  this.clear$Field(6);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumber = function() {
  return this.get$Value(7);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumberOrDefault = function() {
  return this.get$ValueOrDefault(7);
};
i18n.phonenumbers.PhoneMetadata.prototype.setPersonalNumber = function(a) {
  this.set$Value(7, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasPersonalNumber = function() {
  return this.has$Value(7);
};
i18n.phonenumbers.PhoneMetadata.prototype.personalNumberCount = function() {
  return this.count$Values(7);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearPersonalNumber = function() {
  this.clear$Field(7);
};
i18n.phonenumbers.PhoneMetadata.prototype.getVoip = function() {
  return this.get$Value(8);
};
i18n.phonenumbers.PhoneMetadata.prototype.getVoipOrDefault = function() {
  return this.get$ValueOrDefault(8);
};
i18n.phonenumbers.PhoneMetadata.prototype.setVoip = function(a) {
  this.set$Value(8, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasVoip = function() {
  return this.has$Value(8);
};
i18n.phonenumbers.PhoneMetadata.prototype.voipCount = function() {
  return this.count$Values(8);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearVoip = function() {
  this.clear$Field(8);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPager = function() {
  return this.get$Value(21);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPagerOrDefault = function() {
  return this.get$ValueOrDefault(21);
};
i18n.phonenumbers.PhoneMetadata.prototype.setPager = function(a) {
  this.set$Value(21, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasPager = function() {
  return this.has$Value(21);
};
i18n.phonenumbers.PhoneMetadata.prototype.pagerCount = function() {
  return this.count$Values(21);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearPager = function() {
  this.clear$Field(21);
};
i18n.phonenumbers.PhoneMetadata.prototype.getUan = function() {
  return this.get$Value(25);
};
i18n.phonenumbers.PhoneMetadata.prototype.getUanOrDefault = function() {
  return this.get$ValueOrDefault(25);
};
i18n.phonenumbers.PhoneMetadata.prototype.setUan = function(a) {
  this.set$Value(25, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasUan = function() {
  return this.has$Value(25);
};
i18n.phonenumbers.PhoneMetadata.prototype.uanCount = function() {
  return this.count$Values(25);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearUan = function() {
  this.clear$Field(25);
};
i18n.phonenumbers.PhoneMetadata.prototype.getEmergency = function() {
  return this.get$Value(27);
};
i18n.phonenumbers.PhoneMetadata.prototype.getEmergencyOrDefault = function() {
  return this.get$ValueOrDefault(27);
};
i18n.phonenumbers.PhoneMetadata.prototype.setEmergency = function(a) {
  this.set$Value(27, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasEmergency = function() {
  return this.has$Value(27);
};
i18n.phonenumbers.PhoneMetadata.prototype.emergencyCount = function() {
  return this.count$Values(27);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearEmergency = function() {
  this.clear$Field(27);
};
i18n.phonenumbers.PhoneMetadata.prototype.getVoicemail = function() {
  return this.get$Value(28);
};
i18n.phonenumbers.PhoneMetadata.prototype.getVoicemailOrDefault = function() {
  return this.get$ValueOrDefault(28);
};
i18n.phonenumbers.PhoneMetadata.prototype.setVoicemail = function(a) {
  this.set$Value(28, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasVoicemail = function() {
  return this.has$Value(28);
};
i18n.phonenumbers.PhoneMetadata.prototype.voicemailCount = function() {
  return this.count$Values(28);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearVoicemail = function() {
  this.clear$Field(28);
};
i18n.phonenumbers.PhoneMetadata.prototype.getShortCode = function() {
  return this.get$Value(29);
};
i18n.phonenumbers.PhoneMetadata.prototype.getShortCodeOrDefault = function() {
  return this.get$ValueOrDefault(29);
};
i18n.phonenumbers.PhoneMetadata.prototype.setShortCode = function(a) {
  this.set$Value(29, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasShortCode = function() {
  return this.has$Value(29);
};
i18n.phonenumbers.PhoneMetadata.prototype.shortCodeCount = function() {
  return this.count$Values(29);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearShortCode = function() {
  this.clear$Field(29);
};
i18n.phonenumbers.PhoneMetadata.prototype.getStandardRate = function() {
  return this.get$Value(30);
};
i18n.phonenumbers.PhoneMetadata.prototype.getStandardRateOrDefault = function() {
  return this.get$ValueOrDefault(30);
};
i18n.phonenumbers.PhoneMetadata.prototype.setStandardRate = function(a) {
  this.set$Value(30, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasStandardRate = function() {
  return this.has$Value(30);
};
i18n.phonenumbers.PhoneMetadata.prototype.standardRateCount = function() {
  return this.count$Values(30);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearStandardRate = function() {
  this.clear$Field(30);
};
i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecific = function() {
  return this.get$Value(31);
};
i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecificOrDefault = function() {
  return this.get$ValueOrDefault(31);
};
i18n.phonenumbers.PhoneMetadata.prototype.setCarrierSpecific = function(a) {
  this.set$Value(31, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasCarrierSpecific = function() {
  return this.has$Value(31);
};
i18n.phonenumbers.PhoneMetadata.prototype.carrierSpecificCount = function() {
  return this.count$Values(31);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearCarrierSpecific = function() {
  this.clear$Field(31);
};
i18n.phonenumbers.PhoneMetadata.prototype.getSmsServices = function() {
  return this.get$Value(33);
};
i18n.phonenumbers.PhoneMetadata.prototype.getSmsServicesOrDefault = function() {
  return this.get$ValueOrDefault(33);
};
i18n.phonenumbers.PhoneMetadata.prototype.setSmsServices = function(a) {
  this.set$Value(33, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasSmsServices = function() {
  return this.has$Value(33);
};
i18n.phonenumbers.PhoneMetadata.prototype.smsServicesCount = function() {
  return this.count$Values(33);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearSmsServices = function() {
  this.clear$Field(33);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDialling = function() {
  return this.get$Value(24);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDiallingOrDefault = function() {
  return this.get$ValueOrDefault(24);
};
i18n.phonenumbers.PhoneMetadata.prototype.setNoInternationalDialling = function(a) {
  this.set$Value(24, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasNoInternationalDialling = function() {
  return this.has$Value(24);
};
i18n.phonenumbers.PhoneMetadata.prototype.noInternationalDiallingCount = function() {
  return this.count$Values(24);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearNoInternationalDialling = function() {
  this.clear$Field(24);
};
i18n.phonenumbers.PhoneMetadata.prototype.getId = function() {
  return this.get$Value(9);
};
i18n.phonenumbers.PhoneMetadata.prototype.getIdOrDefault = function() {
  return this.get$ValueOrDefault(9);
};
i18n.phonenumbers.PhoneMetadata.prototype.setId = function(a) {
  this.set$Value(9, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasId = function() {
  return this.has$Value(9);
};
i18n.phonenumbers.PhoneMetadata.prototype.idCount = function() {
  return this.count$Values(9);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearId = function() {
  this.clear$Field(9);
};
i18n.phonenumbers.PhoneMetadata.prototype.getCountryCode = function() {
  return this.get$Value(10);
};
i18n.phonenumbers.PhoneMetadata.prototype.getCountryCodeOrDefault = function() {
  return this.get$ValueOrDefault(10);
};
i18n.phonenumbers.PhoneMetadata.prototype.setCountryCode = function(a) {
  this.set$Value(10, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasCountryCode = function() {
  return this.has$Value(10);
};
i18n.phonenumbers.PhoneMetadata.prototype.countryCodeCount = function() {
  return this.count$Values(10);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearCountryCode = function() {
  this.clear$Field(10);
};
i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefix = function() {
  return this.get$Value(11);
};
i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefixOrDefault = function() {
  return this.get$ValueOrDefault(11);
};
i18n.phonenumbers.PhoneMetadata.prototype.setInternationalPrefix = function(a) {
  this.set$Value(11, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasInternationalPrefix = function() {
  return this.has$Value(11);
};
i18n.phonenumbers.PhoneMetadata.prototype.internationalPrefixCount = function() {
  return this.count$Values(11);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearInternationalPrefix = function() {
  this.clear$Field(11);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefix = function() {
  return this.get$Value(17);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefixOrDefault = function() {
  return this.get$ValueOrDefault(17);
};
i18n.phonenumbers.PhoneMetadata.prototype.setPreferredInternationalPrefix = function(a) {
  this.set$Value(17, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredInternationalPrefix = function() {
  return this.has$Value(17);
};
i18n.phonenumbers.PhoneMetadata.prototype.preferredInternationalPrefixCount = function() {
  return this.count$Values(17);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredInternationalPrefix = function() {
  this.clear$Field(17);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefix = function() {
  return this.get$Value(12);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixOrDefault = function() {
  return this.get$ValueOrDefault(12);
};
i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefix = function(a) {
  this.set$Value(12, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefix = function() {
  return this.has$Value(12);
};
i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixCount = function() {
  return this.count$Values(12);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefix = function() {
  this.clear$Field(12);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefix = function() {
  return this.get$Value(13);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefixOrDefault = function() {
  return this.get$ValueOrDefault(13);
};
i18n.phonenumbers.PhoneMetadata.prototype.setPreferredExtnPrefix = function(a) {
  this.set$Value(13, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredExtnPrefix = function() {
  return this.has$Value(13);
};
i18n.phonenumbers.PhoneMetadata.prototype.preferredExtnPrefixCount = function() {
  return this.count$Values(13);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredExtnPrefix = function() {
  this.clear$Field(13);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsing = function() {
  return this.get$Value(15);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsingOrDefault = function() {
  return this.get$ValueOrDefault(15);
};
i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixForParsing = function(a) {
  this.set$Value(15, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixForParsing = function() {
  return this.has$Value(15);
};
i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixForParsingCount = function() {
  return this.count$Values(15);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixForParsing = function() {
  this.clear$Field(15);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRule = function() {
  return this.get$Value(16);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRuleOrDefault = function() {
  return this.get$ValueOrDefault(16);
};
i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixTransformRule = function(a) {
  this.set$Value(16, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixTransformRule = function() {
  return this.has$Value(16);
};
i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixTransformRuleCount = function() {
  return this.count$Values(16);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixTransformRule = function() {
  this.clear$Field(16);
};
i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePattern = function() {
  return this.get$Value(18);
};
i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePatternOrDefault = function() {
  return this.get$ValueOrDefault(18);
};
i18n.phonenumbers.PhoneMetadata.prototype.setSameMobileAndFixedLinePattern = function(a) {
  this.set$Value(18, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasSameMobileAndFixedLinePattern = function() {
  return this.has$Value(18);
};
i18n.phonenumbers.PhoneMetadata.prototype.sameMobileAndFixedLinePatternCount = function() {
  return this.count$Values(18);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearSameMobileAndFixedLinePattern = function() {
  this.clear$Field(18);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormat = function(a) {
  return this.get$Value(19, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormatOrDefault = function(a) {
  return this.get$ValueOrDefault(19, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.addNumberFormat = function(a) {
  this.add$Value(19, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.numberFormatArray = function() {
  return this.array$Values(19);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasNumberFormat = function() {
  return this.has$Value(19);
};
i18n.phonenumbers.PhoneMetadata.prototype.numberFormatCount = function() {
  return this.count$Values(19);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearNumberFormat = function() {
  this.clear$Field(19);
};
i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormat = function(a) {
  return this.get$Value(20, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormatOrDefault = function(a) {
  return this.get$ValueOrDefault(20, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.addIntlNumberFormat = function(a) {
  this.add$Value(20, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatArray = function() {
  return this.array$Values(20);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasIntlNumberFormat = function() {
  return this.has$Value(20);
};
i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatCount = function() {
  return this.count$Values(20);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearIntlNumberFormat = function() {
  this.clear$Field(20);
};
i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCode = function() {
  return this.get$Value(22);
};
i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCodeOrDefault = function() {
  return this.get$ValueOrDefault(22);
};
i18n.phonenumbers.PhoneMetadata.prototype.setMainCountryForCode = function(a) {
  this.set$Value(22, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasMainCountryForCode = function() {
  return this.has$Value(22);
};
i18n.phonenumbers.PhoneMetadata.prototype.mainCountryForCodeCount = function() {
  return this.count$Values(22);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearMainCountryForCode = function() {
  this.clear$Field(22);
};
i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigits = function() {
  return this.get$Value(23);
};
i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigitsOrDefault = function() {
  return this.get$ValueOrDefault(23);
};
i18n.phonenumbers.PhoneMetadata.prototype.setLeadingDigits = function(a) {
  this.set$Value(23, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasLeadingDigits = function() {
  return this.has$Value(23);
};
i18n.phonenumbers.PhoneMetadata.prototype.leadingDigitsCount = function() {
  return this.count$Values(23);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearLeadingDigits = function() {
  this.clear$Field(23);
};
i18n.phonenumbers.PhoneMetadata.prototype.getLeadingZeroPossible = function() {
  return this.get$Value(26);
};
i18n.phonenumbers.PhoneMetadata.prototype.getLeadingZeroPossibleOrDefault = function() {
  return this.get$ValueOrDefault(26);
};
i18n.phonenumbers.PhoneMetadata.prototype.setLeadingZeroPossible = function(a) {
  this.set$Value(26, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasLeadingZeroPossible = function() {
  return this.has$Value(26);
};
i18n.phonenumbers.PhoneMetadata.prototype.leadingZeroPossibleCount = function() {
  return this.count$Values(26);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearLeadingZeroPossible = function() {
  this.clear$Field(26);
};
i18n.phonenumbers.PhoneMetadataCollection = function() {
  goog.proto2.Message.call(this);
};
goog.inherits(i18n.phonenumbers.PhoneMetadataCollection, goog.proto2.Message);
i18n.phonenumbers.PhoneMetadataCollection.descriptor_ = null;
i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadata = function(a) {
  return this.get$Value(1, a);
};
i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadataOrDefault = function(a) {
  return this.get$ValueOrDefault(1, a);
};
i18n.phonenumbers.PhoneMetadataCollection.prototype.addMetadata = function(a) {
  this.add$Value(1, a);
};
i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataArray = function() {
  return this.array$Values(1);
};
i18n.phonenumbers.PhoneMetadataCollection.prototype.hasMetadata = function() {
  return this.has$Value(1);
};
i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataCount = function() {
  return this.count$Values(1);
};
i18n.phonenumbers.PhoneMetadataCollection.prototype.clearMetadata = function() {
  this.clear$Field(1);
};
i18n.phonenumbers.NumberFormat.prototype.getDescriptor = function() {
  var a = i18n.phonenumbers.NumberFormat.descriptor_;
  a || (i18n.phonenumbers.NumberFormat.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.NumberFormat, {0:{name:"NumberFormat", fullName:"i18n.phonenumbers.NumberFormat"}, 1:{name:"pattern", required:!0, fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 2:{name:"format", required:!0, fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 3:{name:"leading_digits_pattern", repeated:!0, fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 4:{name:"national_prefix_formatting_rule", 
  fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 6:{name:"national_prefix_optional_when_formatting", fieldType:goog.proto2.Message.FieldType.BOOL, defaultValue:!1, type:Boolean}, 5:{name:"domestic_carrier_code_formatting_rule", fieldType:goog.proto2.Message.FieldType.STRING, type:String}}));
  return a;
};
i18n.phonenumbers.NumberFormat.getDescriptor = i18n.phonenumbers.NumberFormat.prototype.getDescriptor;
i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor = function() {
  var a = i18n.phonenumbers.PhoneNumberDesc.descriptor_;
  a || (i18n.phonenumbers.PhoneNumberDesc.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumberDesc, {0:{name:"PhoneNumberDesc", fullName:"i18n.phonenumbers.PhoneNumberDesc"}, 2:{name:"national_number_pattern", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 9:{name:"possible_length", repeated:!0, fieldType:goog.proto2.Message.FieldType.INT32, type:Number}, 10:{name:"possible_length_local_only", repeated:!0, fieldType:goog.proto2.Message.FieldType.INT32, 
  type:Number}, 6:{name:"example_number", fieldType:goog.proto2.Message.FieldType.STRING, type:String}}));
  return a;
};
i18n.phonenumbers.PhoneNumberDesc.getDescriptor = i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor;
i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor = function() {
  var a = i18n.phonenumbers.PhoneMetadata.descriptor_;
  a || (i18n.phonenumbers.PhoneMetadata.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadata, {0:{name:"PhoneMetadata", fullName:"i18n.phonenumbers.PhoneMetadata"}, 1:{name:"general_desc", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 2:{name:"fixed_line", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 3:{name:"mobile", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 
  4:{name:"toll_free", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 5:{name:"premium_rate", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 6:{name:"shared_cost", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 7:{name:"personal_number", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 8:{name:"voip", fieldType:goog.proto2.Message.FieldType.MESSAGE, 
  type:i18n.phonenumbers.PhoneNumberDesc}, 21:{name:"pager", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 25:{name:"uan", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 27:{name:"emergency", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 28:{name:"voicemail", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 29:{name:"short_code", 
  fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 30:{name:"standard_rate", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 31:{name:"carrier_specific", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 33:{name:"sms_services", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 24:{name:"no_international_dialling", fieldType:goog.proto2.Message.FieldType.MESSAGE, 
  type:i18n.phonenumbers.PhoneNumberDesc}, 9:{name:"id", required:!0, fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 10:{name:"country_code", fieldType:goog.proto2.Message.FieldType.INT32, type:Number}, 11:{name:"international_prefix", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 17:{name:"preferred_international_prefix", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 12:{name:"national_prefix", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 
  13:{name:"preferred_extn_prefix", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 15:{name:"national_prefix_for_parsing", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 16:{name:"national_prefix_transform_rule", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 18:{name:"same_mobile_and_fixed_line_pattern", fieldType:goog.proto2.Message.FieldType.BOOL, defaultValue:!1, type:Boolean}, 19:{name:"number_format", repeated:!0, fieldType:goog.proto2.Message.FieldType.MESSAGE, 
  type:i18n.phonenumbers.NumberFormat}, 20:{name:"intl_number_format", repeated:!0, fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.NumberFormat}, 22:{name:"main_country_for_code", fieldType:goog.proto2.Message.FieldType.BOOL, defaultValue:!1, type:Boolean}, 23:{name:"leading_digits", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 26:{name:"leading_zero_possible", fieldType:goog.proto2.Message.FieldType.BOOL, defaultValue:!1, type:Boolean}}));
  return a;
};
i18n.phonenumbers.PhoneMetadata.getDescriptor = i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor;
i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor = function() {
  var a = i18n.phonenumbers.PhoneMetadataCollection.descriptor_;
  a || (i18n.phonenumbers.PhoneMetadataCollection.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadataCollection, {0:{name:"PhoneMetadataCollection", fullName:"i18n.phonenumbers.PhoneMetadataCollection"}, 1:{name:"metadata", repeated:!0, fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneMetadata}}));
  return a;
};
i18n.phonenumbers.PhoneMetadataCollection.getDescriptor = i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor;
i18n.phonenumbers.PhoneNumber = function() {
  goog.proto2.Message.call(this);
};
goog.inherits(i18n.phonenumbers.PhoneNumber, goog.proto2.Message);
i18n.phonenumbers.PhoneNumber.descriptor_ = null;
i18n.phonenumbers.PhoneNumber.prototype.getCountryCode = function() {
  return this.get$Value(1);
};
i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeOrDefault = function() {
  return this.get$ValueOrDefault(1);
};
i18n.phonenumbers.PhoneNumber.prototype.setCountryCode = function(a) {
  this.set$Value(1, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasCountryCode = function() {
  return this.has$Value(1);
};
i18n.phonenumbers.PhoneNumber.prototype.countryCodeCount = function() {
  return this.count$Values(1);
};
i18n.phonenumbers.PhoneNumber.prototype.clearCountryCode = function() {
  this.clear$Field(1);
};
i18n.phonenumbers.PhoneNumber.prototype.getNationalNumber = function() {
  return this.get$Value(2);
};
i18n.phonenumbers.PhoneNumber.prototype.getNationalNumberOrDefault = function() {
  return this.get$ValueOrDefault(2);
};
i18n.phonenumbers.PhoneNumber.prototype.setNationalNumber = function(a) {
  this.set$Value(2, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasNationalNumber = function() {
  return this.has$Value(2);
};
i18n.phonenumbers.PhoneNumber.prototype.nationalNumberCount = function() {
  return this.count$Values(2);
};
i18n.phonenumbers.PhoneNumber.prototype.clearNationalNumber = function() {
  this.clear$Field(2);
};
i18n.phonenumbers.PhoneNumber.prototype.getExtension = function() {
  return this.get$Value(3);
};
i18n.phonenumbers.PhoneNumber.prototype.getExtensionOrDefault = function() {
  return this.get$ValueOrDefault(3);
};
i18n.phonenumbers.PhoneNumber.prototype.setExtension = function(a) {
  this.set$Value(3, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasExtension = function() {
  return this.has$Value(3);
};
i18n.phonenumbers.PhoneNumber.prototype.extensionCount = function() {
  return this.count$Values(3);
};
i18n.phonenumbers.PhoneNumber.prototype.clearExtension = function() {
  this.clear$Field(3);
};
i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZero = function() {
  return this.get$Value(4);
};
i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZeroOrDefault = function() {
  return this.get$ValueOrDefault(4);
};
i18n.phonenumbers.PhoneNumber.prototype.setItalianLeadingZero = function(a) {
  this.set$Value(4, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasItalianLeadingZero = function() {
  return this.has$Value(4);
};
i18n.phonenumbers.PhoneNumber.prototype.italianLeadingZeroCount = function() {
  return this.count$Values(4);
};
i18n.phonenumbers.PhoneNumber.prototype.clearItalianLeadingZero = function() {
  this.clear$Field(4);
};
i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZeros = function() {
  return this.get$Value(8);
};
i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZerosOrDefault = function() {
  return this.get$ValueOrDefault(8);
};
i18n.phonenumbers.PhoneNumber.prototype.setNumberOfLeadingZeros = function(a) {
  this.set$Value(8, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasNumberOfLeadingZeros = function() {
  return this.has$Value(8);
};
i18n.phonenumbers.PhoneNumber.prototype.numberOfLeadingZerosCount = function() {
  return this.count$Values(8);
};
i18n.phonenumbers.PhoneNumber.prototype.clearNumberOfLeadingZeros = function() {
  this.clear$Field(8);
};
i18n.phonenumbers.PhoneNumber.prototype.getRawInput = function() {
  return this.get$Value(5);
};
i18n.phonenumbers.PhoneNumber.prototype.getRawInputOrDefault = function() {
  return this.get$ValueOrDefault(5);
};
i18n.phonenumbers.PhoneNumber.prototype.setRawInput = function(a) {
  this.set$Value(5, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasRawInput = function() {
  return this.has$Value(5);
};
i18n.phonenumbers.PhoneNumber.prototype.rawInputCount = function() {
  return this.count$Values(5);
};
i18n.phonenumbers.PhoneNumber.prototype.clearRawInput = function() {
  this.clear$Field(5);
};
i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSource = function() {
  return this.get$Value(6);
};
i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSourceOrDefault = function() {
  return this.get$ValueOrDefault(6);
};
i18n.phonenumbers.PhoneNumber.prototype.setCountryCodeSource = function(a) {
  this.set$Value(6, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasCountryCodeSource = function() {
  return this.has$Value(6);
};
i18n.phonenumbers.PhoneNumber.prototype.countryCodeSourceCount = function() {
  return this.count$Values(6);
};
i18n.phonenumbers.PhoneNumber.prototype.clearCountryCodeSource = function() {
  this.clear$Field(6);
};
i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCode = function() {
  return this.get$Value(7);
};
i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCodeOrDefault = function() {
  return this.get$ValueOrDefault(7);
};
i18n.phonenumbers.PhoneNumber.prototype.setPreferredDomesticCarrierCode = function(a) {
  this.set$Value(7, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasPreferredDomesticCarrierCode = function() {
  return this.has$Value(7);
};
i18n.phonenumbers.PhoneNumber.prototype.preferredDomesticCarrierCodeCount = function() {
  return this.count$Values(7);
};
i18n.phonenumbers.PhoneNumber.prototype.clearPreferredDomesticCarrierCode = function() {
  this.clear$Field(7);
};
i18n.phonenumbers.PhoneNumber.CountryCodeSource = {UNSPECIFIED:0, FROM_NUMBER_WITH_PLUS_SIGN:1, FROM_NUMBER_WITH_IDD:5, FROM_NUMBER_WITHOUT_PLUS_SIGN:10, FROM_DEFAULT_COUNTRY:20};
i18n.phonenumbers.PhoneNumber.prototype.getDescriptor = function() {
  var a = i18n.phonenumbers.PhoneNumber.descriptor_;
  a || (i18n.phonenumbers.PhoneNumber.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumber, {0:{name:"PhoneNumber", fullName:"i18n.phonenumbers.PhoneNumber"}, 1:{name:"country_code", required:!0, fieldType:goog.proto2.Message.FieldType.INT32, type:Number}, 2:{name:"national_number", required:!0, fieldType:goog.proto2.Message.FieldType.UINT64, type:Number}, 3:{name:"extension", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 4:{name:"italian_leading_zero", 
  fieldType:goog.proto2.Message.FieldType.BOOL, type:Boolean}, 8:{name:"number_of_leading_zeros", fieldType:goog.proto2.Message.FieldType.INT32, defaultValue:1, type:Number}, 5:{name:"raw_input", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 6:{name:"country_code_source", fieldType:goog.proto2.Message.FieldType.ENUM, defaultValue:i18n.phonenumbers.PhoneNumber.CountryCodeSource.UNSPECIFIED, type:i18n.phonenumbers.PhoneNumber.CountryCodeSource}, 7:{name:"preferred_domestic_carrier_code", 
  fieldType:goog.proto2.Message.FieldType.STRING, type:String}}));
  return a;
};
i18n.phonenumbers.PhoneNumber.ctor = i18n.phonenumbers.PhoneNumber;
i18n.phonenumbers.PhoneNumber.ctor.getDescriptor = i18n.phonenumbers.PhoneNumber.prototype.getDescriptor;
/*

 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
i18n.phonenumbers.metadata = {};
i18n.phonenumbers.metadata.countryCodeToRegionCodeMap = {1:"US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "), 7:["RU", "KZ"], 20:["EG"], 27:["ZA"], 30:["GR"], 31:["NL"], 32:["BE"], 33:["FR"], 34:["ES"], 36:["HU"], 39:["IT", "VA"], 40:["RO"], 41:["CH"], 43:["AT"], 44:["GB", "GG", "IM", "JE"], 45:["DK"], 46:["SE"], 47:["NO", "SJ"], 48:["PL"], 49:["DE"], 51:["PE"], 52:["MX"], 53:["CU"], 54:["AR"], 55:["BR"], 56:["CL"], 57:["CO"], 58:["VE"], 60:["MY"], 61:["AU", 
"CC", "CX"], 62:["ID"], 63:["PH"], 64:["NZ"], 65:["SG"], 66:["TH"], 81:["JP"], 82:["KR"], 84:["VN"], 86:["CN"], 90:["TR"], 91:["IN"], 92:["PK"], 93:["AF"], 94:["LK"], 95:["MM"], 98:["IR"], 211:["SS"], 212:["MA", "EH"], 213:["DZ"], 216:["TN"], 218:["LY"], 220:["GM"], 221:["SN"], 222:["MR"], 223:["ML"], 224:["GN"], 225:["CI"], 226:["BF"], 227:["NE"], 228:["TG"], 229:["BJ"], 230:["MU"], 231:["LR"], 232:["SL"], 233:["GH"], 234:["NG"], 235:["TD"], 236:["CF"], 237:["CM"], 238:["CV"], 239:["ST"], 240:["GQ"], 
241:["GA"], 242:["CG"], 243:["CD"], 244:["AO"], 245:["GW"], 246:["IO"], 247:["AC"], 248:["SC"], 249:["SD"], 250:["RW"], 251:["ET"], 252:["SO"], 253:["DJ"], 254:["KE"], 255:["TZ"], 256:["UG"], 257:["BI"], 258:["MZ"], 260:["ZM"], 261:["MG"], 262:["RE", "YT"], 263:["ZW"], 264:["NA"], 265:["MW"], 266:["LS"], 267:["BW"], 268:["SZ"], 269:["KM"], 290:["SH", "TA"], 291:["ER"], 297:["AW"], 298:["FO"], 299:["GL"], 350:["GI"], 351:["PT"], 352:["LU"], 353:["IE"], 354:["IS"], 355:["AL"], 356:["MT"], 357:["CY"], 
358:["FI", "AX"], 359:["BG"], 370:["LT"], 371:["LV"], 372:["EE"], 373:["MD"], 374:["AM"], 375:["BY"], 376:["AD"], 377:["MC"], 378:["SM"], 380:["UA"], 381:["RS"], 382:["ME"], 383:["XK"], 385:["HR"], 386:["SI"], 387:["BA"], 389:["MK"], 420:["CZ"], 421:["SK"], 423:["LI"], 500:["FK"], 501:["BZ"], 502:["GT"], 503:["SV"], 504:["HN"], 505:["NI"], 506:["CR"], 507:["PA"], 508:["PM"], 509:["HT"], 590:["GP", "BL", "MF"], 591:["BO"], 592:["GY"], 593:["EC"], 594:["GF"], 595:["PY"], 596:["MQ"], 597:["SR"], 598:["UY"], 
599:["CW", "BQ"], 670:["TL"], 672:["NF"], 673:["BN"], 674:["NR"], 675:["PG"], 676:["TO"], 677:["SB"], 678:["VU"], 679:["FJ"], 680:["PW"], 681:["WF"], 682:["CK"], 683:["NU"], 685:["WS"], 686:["KI"], 687:["NC"], 688:["TV"], 689:["PF"], 690:["TK"], 691:["FM"], 692:["MH"], 800:["001"], 808:["001"], 850:["KP"], 852:["HK"], 853:["MO"], 855:["KH"], 856:["LA"], 870:["001"], 878:["001"], 880:["BD"], 881:["001"], 882:["001"], 883:["001"], 886:["TW"], 888:["001"], 960:["MV"], 961:["LB"], 962:["JO"], 963:["SY"], 
964:["IQ"], 965:["KW"], 966:["SA"], 967:["YE"], 968:["OM"], 970:["PS"], 971:["AE"], 972:["IL"], 973:["BH"], 974:["QA"], 975:["BT"], 976:["MN"], 977:["NP"], 979:["001"], 992:["TJ"], 993:["TM"], 994:["AZ"], 995:["GE"], 996:["KG"], 998:["UZ"]};
i18n.phonenumbers.metadata.countryToMetadata = {AC:[, [, , "(?:[01589]\\d|[46])\\d{4}", , , , , , , [5, 6]], [, , "6[2-467]\\d{3}", , , , "62889", , , [5]], [, , "4\\d{4}", , , , "40123", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AC", 247, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:0[1-9]|[1589]\\d)\\d{4}", , , , "542011", , , [6]], , , [, , , , , , , , 
, [-1]]], AD:[, [, , "(?:1|6\\d)\\d{7}|[136-9]\\d{5}", , , , , , , [6, 8, 9]], [, , "[78]\\d{5}", , , , "712345", , , [6]], [, , "690\\d{6}|[36]\\d{5}", , , , "312345", , , [6, 9]], [, , "180[02]\\d{4}", , , , "18001234", , , [8]], [, , "[19]\\d{5}", , , , "912345", , , [6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AD", 376, "00", , , , , , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[136-9]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["1"]], [, "(\\d{3})(\\d{3})(\\d{3})", 
"$1 $2 $3", ["6"]]], , [, , , , , , , , , [-1]], , , [, , "1800\\d{4}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AE:[, [, , "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]], [, , "[2-4679][2-8]\\d{6}", , , , "22345678", , , [8], [7]], [, , "5[024-68]\\d{7}", , , , "501234567", , , [9]], [, , "400\\d{6}|800\\d{2,9}", , , , "800123456"], [, , "900[02]\\d{5}", , , , "900234567", , , [9]], [, , "700[05]\\d{5}", , , , 
"700012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AE", 971, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], [, "(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "600[25]\\d{5}", , , , "600212345", , , [9]], , , [, , , , , , , , , [-1]]], AF:[, [, , "[2-7]\\d{8}", 
, , , , , , [9], [7]], [, , "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}", , , , "234567890", , , , [7]], [, , "7(?:[014-9]\\d|2[89]|3[01])\\d{6}", , , , "701234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AF", 93, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], 
[, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AG:[, [, , "(?:268|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}", , , , "2684601234", , , , [7]], [, , "268(?:464|7(?:1[3-9]|2\\d|3[246]|64|[78][0-689]))\\d{4}", , , , "2684641234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", 
, , , "5002345678"], [, , "26848[01]\\d{4}", , , , "2684801234", , , , [7]], "AG", 1, "011", "1", , , "1|([457]\\d{6})$", "268$1", , , , , [, , "26840[69]\\d{4}", , , , "2684061234", , , , [7]], , "268", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AI:[, [, , "(?:264|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "2644(?:6[12]|9[78])\\d{4}", , , , "2644612345", , , , [7]], [, , "264(?:235|476|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}", , , , "2642351234", , 
, , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "AI", 1, "011", "1", , , "1|([2457]\\d{6})$", "264$1", , , , , [, , , , , , , , , [-1]], , "264", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AL:[, [, , "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", , , , , , 
, [6, 7, 8, 9], [5]], [, , "(?:[2358](?:[16-9]\\d[2-9]|[2-5][2-9]\\d)|4(?:[2-57-9][2-9]|6\\d)\\d)\\d{4}", , , , "22345678", , , [8], [5, 6, 7]], [, , "6(?:[689][2-9]|7[2-6])\\d{6}", , , , "662123456", , , [9]], [, , "800\\d{4}", , , , "8001234", , , [7]], [, , "900[1-9]\\d\\d", , , , "900123", , , [6]], [, , "808[1-9]\\d\\d", , , , "808123", , , [6]], [, , "700[2-9]\\d{4}", , , , "70021234", , , [8]], [, , , , , , , , , [-1]], "AL", 355, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,4})", "$1 $2", 
["80|9"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AM:[, [, , "(?:[1-489]\\d|55|60|77)\\d{6}", , , , , , , [8], [5, 6]], [, , "(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}", 
, , , "10123456", , , , [5, 6]], [, , "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}", , , , "77123456"], [, , "800\\d{5}", , , , "80012345"], [, , "90[016]\\d{5}", , , , "90012345"], [, , "80[1-4]\\d{5}", , , , "80112345"], [, , , , , , , , , [-1]], [, , "60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|90)\\d{4}", , , , "60271234"], "AM", 374, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], [, "(\\d{2})(\\d{6})", 
"$1 $2", ["1|47"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AO:[, [, , "[29]\\d{8}", , , , , , , [9]], [, , "2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}", , , , "222123456"], [, , "9[1-49]\\d{7}", , , , "923123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AO", 244, "00", , , , , 
, , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AR:[, [, , "11\\d{8}|(?:[2368]|9\\d)\\d{9}", , , , , , , [10, 11], [6, 7, 8]], [, , "(?:2(?:646[0-46-9]|9(?:45[02-69]|54[2-8]))|3(?:4(?:3(?:5[0-7]|6[1-69])|5(?:4[0-4679]|[56][024-6]))|585[013-7]|7(?:(?:1[15]|81)[46]|77[2-8])|8(?:(?:21|4[16]|9[12])[46]|35[124-6]|5(?:5[0-46-9]|6[0-246-9])|6(?:5[2-8]|9[46])|86[0-68])))\\d{5}|(?:2(?:284|657|9(?:20|66))|3(?:4(?:8[27]|92)|755|878))[2-7]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|4[24])|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:(?:26|62)2|3(?:02|2[03])|477|9(?:42|83))|3(?:4(?:[47]6|62|89)|5(?:41|64)|873))[2-6]\\d{5}|(?:(?:11[2-7]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-7]|[346][45])|80[45]|9(?:[17][4-6]|44|8[45]|9[3-6]))|3(?:364|4(?:1[2-7]|2[4-6]|[38]4)|5(?:1[2-8]|3[4-6]|8[46])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-6]|34|5[34]|7[24-6]|8[3-5])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:329|4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])|888))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|[24]5|5[25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}", 
, , , "1123456789", , , [10], [6, 7, 8]], [, , "9(?:2(?:646[0-46-9]|9(?:45[02-69]|54[2-8]))|3(?:4(?:3(?:5[0-7]|6[1-69])|5(?:4[0-4679]|[56][024-6]))|585[013-7]|7(?:(?:1[15]|81)[46]|77[2-8])|8(?:(?:21|4[16]|9[12])[46]|35[124-6]|5(?:5[0-46-9]|6[0-246-9])|6(?:5[2-8]|9[46])|86[0-68])))\\d{5}|9(?:2(?:284|657|9(?:20|66))|3(?:4(?:8[27]|92)|755|878))[2-7]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|4[24])|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:(?:26|62)2|3(?:02|2[03])|477|9(?:42|83))|3(?:4(?:[47]6|62|89)|5(?:41|64)|873))[2-6]\\d{5}|(?:675\\d|9(?:11[2-7]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-7]|[346][45])|80[45]|9(?:[17][4-6]|44|8[45]|9[3-6]))|3(?:364|4(?:1[2-7]|2[4-6]|[38]4)|5(?:1[2-8]|3[4-6]|8[46])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-6]|34|5[34]|7[24-6]|8[3-5]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:329|4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])|888))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|[24]5|5[25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}", 
, , , "91123456789", , , , [6, 7, 8]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "60[04579]\\d{7}", , , , "6001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AR", 54, "00", "0", , , "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", 
"9$1", , , [[, "(\\d{3})", "$1", ["[09]|1(?:[02]|1[02-5])"]], [, "(\\d{2})(\\d{4})", "$1-$2", ["[2-7]|8[0-7]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[2-7]|8[013-8]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["2[0-8]|[3-7]"]], [, "(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", 
"2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5(?:[24-6]|3[2-5]))|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], 
"0$1", , 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], [, "(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", 
"9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5(?:[24-6]|3[2-5]))|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], 
"0$1"], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1"]], [[, "(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", 
"2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5(?:[24-6]|3[2-5]))|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", , 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], 
"0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], [, "(\\d)(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", 
"9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5(?:[24-6]|3[2-5]))|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"]], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3-$4", ["91"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3-$4", 
["9"]]], [, , , , , , , , , [-1]], , , [, , "810\\d{7}", , , , , , , [10]], [, , "810\\d{7}", , , , "8101234567", , , [10]], , , [, , , , , , , , , [-1]]], AS:[, [, , "(?:[58]\\d\\d|684|900)\\d{7}", , , , , , , [10], [7]], [, , "6846(?:22|33|44|55|77|88|9[19])\\d{4}", , , , "6846221234", , , , [7]], [, , "684(?:2(?:5[2468]|72)|7(?:3[13]|70))\\d{4}", , , , "6847331234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , 
, , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "AS", 1, "011", "1", , , "1|([267]\\d{6})$", "684$1", , , , , [, , , , , , , , , [-1]], , "684", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AT:[, [, , "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 
11, 12, 13], [3]], [, , "1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}", , , , "1234567890", , , , [3]], [, , "6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}", , , , "664123456", , , [7, 8, 9, 10, 11, 12, 13]], 
[, , "800\\d{6,10}", , , , "800123456", , , [9, 10, 11, 12, 13]], [, , "9(?:0[01]|3[019])\\d{6,10}", , , , "900123456", , , [9, 10, 11, 12, 13]], [, , "8(?:10|2[018])\\d{6,10}|828\\d{5}", , , , "810123456", , , [8, 9, 10, 11, 12, 13]], [, , , , , , , , , [-1]], [, , "5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", , , , "780123456", , , [5, 6, 7, 8, 9, 10, 11, 12, 13]], "AT", 43, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], [, "(\\d{3})(\\d{2})", "$1 $2", 
["517"], "0$1"], [, "(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], [, "(\\d{6})", "$1", ["1"]], [, "(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], [[, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], [, "(\\d{2})(\\d{3,5})", 
"$1 $2", ["5[079]"], "0$1"], [, "(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AU:[, [, , "1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|(?:[2-478]\\d\\d|550)\\d{6}|1\\d{4,7}", 
, , , , , , [5, 6, 7, 8, 9, 10]], [, , "(?:[237]\\d{5}|8(?:51(?:0(?:0[03-9]|[1247]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-6])|1(?:1[69]|[23]\\d|4[0-4]))|(?:[6-8]\\d{3}|9(?:[02-9]\\d\\d|1(?:[0-57-9]\\d|6[0135-9])))\\d))\\d{3}", , , , "212345678", , , [9], [8]], [, , "483[0-3]\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-2457-9]|9[0-27-9])\\d{6}", , , , "412345678", , , [9]], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]], [, 
, "13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}", , , , "1300123456", , , [6, 8, 10]], [, , , , , , , , , [-1]], [, , "(?:14(?:5(?:1[0458]|[23][458])|71\\d)|550\\d\\d)\\d{4}", , , , "550123456", , , [9]], "AU", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0", , , "0|(183[12])", , "0011", , [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["13"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["19"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["180", "1802"]], [, "(\\d{4})(\\d{3,4})", 
"$1 $2", ["19"]], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|[45]"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|[45]"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], 
"(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], [, , "16\\d{3,7}", , , , "1612345", , , [5, 6, 7, 8, 9]], 1, , [, , "1[38]00\\d{6}|1(?:345[0-4]|802)\\d{3}|13\\d{4}", , , , , , , [6, 7, 8, 10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AW:[, [, , "(?:[25-79]\\d\\d|800)\\d{4}", , , , , , , [7]], [, , "5(?:2\\d|8[1-9])\\d{4}", , , , "5212345"], [, , "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}", , , , "5601234"], 
[, , "800\\d{4}", , , , "8001234"], [, , "900\\d{4}", , , , "9001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:28\\d|501)\\d{4}", , , , "5011234"], "AW", 297, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AX:[, [, , "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|(?:[147]\\d|3[0-46-9]|50)\\d{4,8}", , , , , , , [5, 6, 7, 8, 9, 10]], [, , "18[1-8]\\d{3,6}", 
, , , "181234567", , , [6, 7, 8, 9]], [, , "(?:4[0-8]|50)\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10]], [, , "800\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AX", 358, "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "0", , , "0", , "00", , , , [, , , , , , , , , [-1]], , "18", [, , , , , , , , , [-1]], [, , "(?:10|[23][09])\\d{4,8}|60(?:[12]\\d{5,6}|6\\d{7})|7(?:(?:1|3\\d)\\d{7}|5[03-9]\\d{3,7})|20[2-59]\\d\\d", 
, , , "10112345"], , , [, , , , , , , , , [-1]]], AZ:[, [, , "(?:365\\d{3}|900200)\\d{3}|(?:[12457]\\d|60|88)\\d{7}", , , , , , , [9], [7]], [, , "365(?:[0-46-9]\\d|5[0-35-9])\\d{4}|(?:1[28]\\d|2(?:[045]2|1[24]|2[2-4]|33|6[23]))\\d{6}", , , , "123123456", , , , [7]], [, , "36554\\d{4}|(?:4[04]|5[015]|60|7[07])\\d{7}", , , , "401234567"], [, , "88\\d{7}", , , , "881234567"], [, , "900200\\d{3}", , , , "900200123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AZ", 
994, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[1-9]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[12]|365", "[12]|365", "[12]|365(?:[0-46-9]|5[0-35-9])"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[3-8]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[12]|365", "[12]|365", 
"[12]|365(?:[0-46-9]|5[0-35-9])"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[3-8]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BA:[, [, , "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", , , , , , , [8, 9], [6]], [, , "(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", , , , "30212345", , , [8], [6]], [, , 
"6(?:0(?:3\\d|40)|[1-356]\\d|44[0-6]|71[137])\\d{5}", , , , "61123456"], [, , "8[08]\\d{6}", , , , "80123456", , , [8]], [, , "9[0246]\\d{6}", , , , "90123456", , , [8]], [, , "8[12]\\d{6}", , , , "82123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BA", 387, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})", "$1-$2", ["[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-356]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", 
"$1 $2 $3 $4", ["6"], "0$1"]], [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-356]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "70(?:3[0146]|[56]0)\\d{4}", , , , "70341234", , , [8]], , , [, , , , , , , , , [-1]]], BB:[, [, , "(?:246|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}", 
, , , "2464123456", , , , [7]], [, , "246(?:2(?:[356]\\d|4[0-57-9]|8[0-79])|45\\d|69[5-7]|8(?:[2-5]\\d|83))\\d{4}", , , , "2462501234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "(?:246976|900[2-9]\\d\\d)\\d{4}", , , , "9002123456", , , , [7]], [, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "24631\\d{5}", , , , "2463101234", , , , [7]], "BB", 1, "011", "1", , , "1|([2-9]\\d{6})$", "246$1", , , , , [, , , 
, , , , , , [-1]], , "246", [, , , , , , , , , [-1]], [, , "246(?:292|367|4(?:1[7-9]|3[01]|44|67)|7(?:36|53))\\d{4}", , , , "2464301234", , , , [7]], , , [, , , , , , , , , [-1]]], BD:[, [, , "[13469]\\d{9}|8[0-79]\\d{7,8}|[2-7]\\d{8}|[2-9]\\d{7}|[3-689]\\d{6}|[57-9]\\d{5}", , , , , , , [6, 7, 8, 9, 10]], [, , "(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:4(?:31\\d\\d|[46]23)|5(?:222|32[37]))\\d{3}(?:\\d{2})?|(?:3(?:42[47]|529|823)|4(?:027|525|658)|(?:56|73)2|6257|9[35]1)\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[01367]|7[15]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|8(?:4[12]|[5-7]2)|9(?:[024]2|81))\\d{4}|(?:2[45]\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:25|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[569]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:0|217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}", 
, , , "27111234"], [, , "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", , , , "1812345678", , , [10]], [, , "80[03]\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "96(?:0[469]|1[0-47]|3[389]|6[69]|7[78])\\d{6}", , , , "9604123456", , , [10]], "BD", 880, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-7]|[459]1"], "0$1"], [, "(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], 
"0$1"], [, "(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]"], "0$1"], [, "(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BE:[, [, , "4\\d{8}|[1-9]\\d{7}", , , , , , , [8, 9]], [, , "80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", , , , "12345678", , , [8]], [, , "4(?:5[56]|6[0135-8]|[79]\\d|8[3-9])\\d{6}", , , , "470123456", , , [9]], [, , "800[1-9]\\d{4}", , 
, , "80012345", , , [8]], [, , "(?:70(?:2[0-57]|3[0457]|44|69|7[0579])|90(?:0[0-35-8]|1[36]|2[0-3568]|3[0135689]|4[2-68]|5[1-68]|6[0-378]|7[23568]|9[34679]))\\d{4}", , , , "90012345", , , [8]], [, , "7879\\d{4}", , , , "78791234", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BE", 32, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", 
"$1 $2 $3 $4", ["[15-8]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "78(?:0[57]|1[0458]|2[25]|3[5-8]|48|[56]0|7[078])\\d{4}", , , , "78102345", , , [8]], , , [, , , , , , , , , [-1]]], BF:[, [, , "[025-7]\\d{7}", , , , , , , [8]], [, , "2(?:0(?:49|5[23]|6[56]|9[016-9])|4(?:4[569]|5[4-6]|6[56]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}", , , , "20491234"], [, , "(?:0[17]|5[1-8]|[67]\\d)\\d{6}", , , , "70123456"], 
[, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BF", 226, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BG:[, [, , "[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", , , , , , , [6, 7, 8, 9], [4, 5]], [, , "2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", 
, , , "2123456", , , [6, 7, 8], [4, 5]], [, , "43[07-9]\\d{5}|(?:48|8[7-9]\\d|9(?:8\\d|9[69]))\\d{6}", , , , "48123456", , , [8, 9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "90\\d{6}", , , , "90123456", , , [8]], [, , "700\\d{5}", , , , "70012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BG", 359, "00", "0", , , "0", , , , [[, "(\\d{6})", "$1", ["1"]], [, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], 
"0$1"], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], [[, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{4})", 
"$1 $2", ["43[1-6]|70[1-9]"], "0$1"], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BH:[, [, , "[136-9]\\d{7}", , , , , , , [8]], [, , "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9]|88)|9[69][69])|7(?:1(?:11|78)|7\\d\\d))\\d{4}", , , , "17001234"], [, , "(?:3(?:[1-4679]\\d|5[013-69]|8[0-47-9])\\d|6(?:3(?:00|33|6[16])|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}", , , , "36001234"], [, , "80\\d{6}", , , , "80123456"], [, , "(?:87|9[014578])\\d{6}", , , , "90123456"], [, , "84\\d{6}", , , , "84123456"], [, 
, , , , , , , , [-1]], [, , , , , , , , , [-1]], "BH", 973, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[047]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BI:[, [, , "(?:[267]\\d|31)\\d{6}", , , , , , , [8]], [, , "22\\d{6}", , , , "22201234"], [, , "(?:29|31|6[189]|7[125-9])\\d{6}", , , , "79561234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], "BI", 257, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BJ:[, [, , "[2689]\\d{7}", , , , , , , [8]], [, , "2(?:02|1[037]|2[45]|3[68])\\d{5}", , , , "20211234"], [, , "(?:6\\d|9[013-9])\\d{6}", , , , "90011234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
[, , "857[58]\\d{4}", , , , "85751234"], "BJ", 229, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "81\\d{6}", , , , "81123456"], , , [, , , , , , , , , [-1]]], BL:[, [, , "(?:590|69\\d)\\d{6}", , , , , , , [9]], [, , "590(?:2[7-9]|5[12]|87)\\d{4}", , , , "590271234"], [, , "69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}", , , , "690001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , 
, , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BL", 590, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BM:[, [, , "(?:441|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "441(?:2(?:02|23|[3479]\\d|61)|[46]\\d\\d|5(?:4\\d|60|89)|824)\\d{4}", , , , "4412345678", , , , [7]], [, , "441(?:[37]\\d|5[0-39])\\d{5}", , , , "4413701234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", 
, , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "BM", 1, "011", "1", , , "1|([2-8]\\d{6})$", "441$1", , , , , [, , , , , , , , , [-1]], , "441", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BN:[, [, , "[2-578]\\d{6}", , , , , , , [7]], [, , "22[0-7]\\d{4}|(?:2[013-9]|[3-5]\\d)\\d{5}", , , , "2345678"], [, , "(?:22[89]|[78]\\d\\d)\\d{4}", 
, , , "7123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BN", 673, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BO:[, [, , "(?:[2-467]\\d\\d|8001)\\d{5}", , , , , , , [8, 9], [7]], [, , "(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", 
, , , "22123456", , , [8], [7]], [, , "[67]\\d{7}", , , , "71234567", , , [8]], [, , "8001[07]\\d{4}", , , , "800171234", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BO", 591, "00(?:1\\d)?", "0", , , "0(1\\d)?", , , , [[, "(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"], , "0$CC $1"], [, "(\\d{8})", "$1", ["[67]"], , "0$CC $1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"], , "0$CC $1"]], , [, , , , , , , , , [-1]], , , [, , "8001[07]\\d{4}", 
, , , , , , [9]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BQ:[, [, , "(?:[34]1|7\\d)\\d{5}", , , , , , , [7]], [, , "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|50)\\d)\\d{3}", , , , "7151234"], [, , "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}", , , , "3181234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BQ", 599, "00", , , , , , , , , , [, , , , , , , , , [-1]], , 
"[347]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BR:[, [, , "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", , , , , , , [8, 9, 10, 11]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", , , , "1123456789", , , [10], [8]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", , , , "11961234567", , , [10, 11], [8, 9]], [, , "800\\d{6,7}", , , , "800123456", , , [9, 10]], 
[, , "300\\d{6}|[59]00\\d{6,7}", , , , "300123456", , , [9, 10]], [, , "300\\d{7}|[34]00\\d{5}|4(?:02|37)0\\d{4}", , , , "40041234", , , [8, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BR", 55, "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "0", , , "0(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", , , [[, "(\\d{3,6})", "$1", ["1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], 
[, "(\\d{4})(\\d{4})", "$1-$2", ["[2-57]", "[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"]], [, "(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], [, "(\\d{5})(\\d{4})", "$1-$2", ["9"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], 
[, "(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]], [, , , , , , , , , [-1]], , , [, , "4020\\d{4}|[34]00\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BS:[, [, , "(?:242|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , 
"242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-4]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}", , , , "2423456789", , , , [7]], [, , "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}", , , , "2423591234", , , , [7]], [, , "242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , , [7]], [, , "900[2-9]\\d{6}", , , , "9002123456"], 
[, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "BS", 1, "011", "1", , , "1|([3-8]\\d{6})$", "242$1", , , , , [, , , , , , , , , [-1]], , "242", [, , , , , , , , , [-1]], [, , "242225[0-46-9]\\d{3}", , , , "2422250123"], , , [, , , , , , , , , [-1]]], BT:[, [, , "[17]\\d{7}|[2-8]\\d{6}", , , , , , , [7, 8], [6]], [, , "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", , , , "2345678", , , [7], [6]], [, , "(?:1[67]|77)\\d{6}", 
, , , "17123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BT", 975, "00", , , , , , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[2-7]"]], [, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], [, , , , 
, , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BW:[, [, , "90\\d{5}|(?:[2-6]|7\\d)\\d{6}", , , , , , , [7, 8]], [, , "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013])|4(?:6[03]|7[1267]|9[0-5])|5(?:3[0389]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}", , , , "2401234", , , [7]], [, , "77200\\d{3}|7(?:[1-6]\\d|7[014-8])\\d{5}", , , , "71123456", , , [8]], [, , , , , , , , , [-1]], [, , "90\\d{5}", , , , "9012345", 
, , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "79(?:1(?:[01]\\d|20)|2[0-2]\\d)\\d{3}", , , , "79101234", , , [8]], "BW", 267, "00", , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["90"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[2-6]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BY:[, [, , "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", 
, , , , , , [6, 7, 8, 9, 10, 11], [5]], [, , "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", , , , "152450911", , , [9], [5, 6, 7]], [, , "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}", , , , "294911911", , , [9]], [, , "800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}", , , , "8011234567"], [, , "(?:810|902)\\d{7}", , , , "9021234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , 
, , , [-1]], [, , "249\\d{6}", , , , "249123456", , , [9]], "BY", 375, "810", "8", , , "0|80?", , "8~10", , [[, "(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], [, "(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], [, "(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], 
"8 0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , "800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BZ:[, [, , "(?:0800\\d|[2-8])\\d{6}", , , , , , , [7, 11]], [, , "(?:236|732)\\d{4}|[2-578][02]\\d{5}", , , , "2221234", , , [7]], [, , "6[0-35-7]\\d{5}", , , , "6221234", , , [7]], [, , "0800\\d{7}", , , , 
"08001234123", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BZ", 501, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], [, "(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CA:[, [, , "(?:[2-8]\\d|90)\\d{8}", , , , , , , [10], [7]], [, , "(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", 
, , , "5062345678", , , , [7]], [, , "(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", , , , "5062345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}", , , , "5002345678"], [, , "600[2-9]\\d{6}", , , , "6002012345"], "CA", 
1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CC:[, [, , "1(?:[0-79]\\d|8[0-24-9])\\d{7}|(?:[148]\\d\\d|550)\\d{6}|1\\d{5,7}", , , , , , , [6, 7, 8, 9, 10]], [, , "8(?:51(?:0(?:02|31|60)|118)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", , , , "891621234", , , [9], [8]], [, , "483[0-3]\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-2457-9]|9[0-27-9])\\d{6}", 
, , , "412345678", , , [9]], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]], [, , "13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}", , , , "1300123456", , , [6, 8, 10]], [, , , , , , , , , [-1]], [, , "(?:14(?:5(?:1[0458]|[23][458])|71\\d)|550\\d\\d)\\d{4}", , , , "550123456", , , [9]], "CC", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0", , , "0|([59]\\d{7})$", "8$1", "0011", , , , [, , , , , , , , , [-1]], , , [, , , 
, , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CD:[, [, , "[189]\\d{8}|[1-68]\\d{6}", , , , , , , [7, 9]], [, , "12\\d{7}|[1-6]\\d{6}", , , , "1234567"], [, , "88\\d{5}|(?:8[0-2459]|9[017-9])\\d{7}", , , , "991234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CD", 243, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", 
["[1-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CF:[, [, , "(?:[27]\\d{3}|8776)\\d{4}", , , , , , , [8]], [, , "2[12]\\d{6}", , , , "21612345"], [, , "7[0257]\\d{6}", , , , "70012345"], [, , , , , , , , , [-1]], [, , "8776\\d{4}", , , , "87761234"], [, , , , , , , , , [-1]], [, , , , , , , , , 
[-1]], [, , , , , , , , , [-1]], "CF", 236, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CG:[, [, , "222\\d{6}|(?:0\\d|80)\\d{7}", , , , , , , [9]], [, , "222[1-589]\\d{5}", , , , "222123456"], [, , "0[14-6]\\d{7}", , , , "061234567"], [, , , , , , , , , [-1]], [, , "80(?:0\\d\\d|11[0-4])\\d{4}", , , , "800123456"], [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CG", 242, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["801"]], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CH:[, [, , "8\\d{11}|[2-9]\\d{8}", , , , , , , [9, 12]], [, , "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", , , , "212345678", 
, , [9]], [, , "7[35-9]\\d{7}", , , , "781234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "90[016]\\d{6}", , , , "900123456", , , [9]], [, , "84[0248]\\d{6}", , , , "840123456", , , [9]], [, , "878\\d{6}", , , , "878123456", , , [9]], [, , , , , , , , , [-1]], "CH", 41, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", 
"$1 $2 $3 $4 $5", ["8"], "0$1"]], , [, , "74[0248]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , "5[18]\\d{7}", , , , "581234567", , , [9]], , , [, , "860\\d{9}", , , , "860123456789", , , [12]]], CI:[, [, , "[02-9]\\d{7}", , , , , , , [8]], [, , "(?:2(?:0[023]|1[02357]|[23][045]|4[03-5])|3(?:0[06]|1[069]|[2-4][07]|5[09]|6[08]))\\d{5}", , , , "21234567"], [, , "97[0-3]\\d{5}|(?:0[1-9]|[457]\\d|6[014-9]|8[4-9]|95)\\d{6}", , , , "01234567"], [, , , , , , , , , [-1]], [, , 
, , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CI", 225, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[02-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CK:[, [, , "[2-8]\\d{4}", , , , , , , [5]], [, , "(?:2\\d|3[13-7]|4[1-5])\\d{3}", , , , "21234"], [, , "[5-8]\\d{4}", , , , "71234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, 
, , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CK", 682, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["[2-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CL:[, [, , "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", , , , , , , [9, 10, 11]], [, , "(?:2(?:1962|3(?:2\\d\\d|300))|80[1-9]\\d\\d)\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2-9])\\d{7}", , , , "221234567", , , [9]], [, , "(?:2(?:1962|3(?:2\\d\\d|300))|80[1-9]\\d\\d)\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2-9])\\d{7}", 
, , , "221234567", , , [9]], [, , "(?:123|8)00\\d{6}", , , , "800123456", , , [9, 11]], [, , , , , , , , , [-1]], [, , "600\\d{7,8}", , , , "6001234567", , , [10, 11]], [, , , , , , , , , [-1]], [, , "44\\d{7}", , , , "441234567", , , [9]], "CL", 56, "(?:0|1(?:1[0-69]|2[0-57]|5[13-58]|69|7[0167]|8[018]))0", , , , , , , 1, [[, "(\\d{4})", "$1", ["1(?:[03-589]|21)|[29]0|78"]], [, "(\\d{5})(\\d{4})", "$1 $2", ["21"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [, "(\\d)(\\d{4})(\\d{4})", 
"$1 $2 $3", ["2[23]"], "($1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], [[, "(\\d{5})(\\d{4})", "$1 $2", ["21"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", 
["2[23]"], "($1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], [, , , , , , , , , [-1]], , , [, , "600\\d{7,8}", , , , , , , [10, 11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CM:[, [, , "(?:[26]\\d\\d|88)\\d{6}", 
, , , , , , [8, 9]], [, , "2(?:22|33|4[23])\\d{6}", , , , "222123456", , , [9]], [, , "6[5-9]\\d{7}", , , , "671234567", , , [9]], [, , "88\\d{6}", , , , "88012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CM", 237, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CN:[, [, , "1[1279]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-68]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", , , , , , , [7, 8, 9, 10, 11, 12], [5, 6]], [, , "(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|21(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))\\d{5}|(?:43[35]|754)\\d{7,8}|8(?:078\\d{7}|51\\d{7,8})|(?:10|(?:2|85)1|43[35]|754)(?:100\\d\\d|95\\d{3,4})|(?:2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[1-9]\\d{6})|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[1-9]\\d{5})|9(?:[0-46-9]\\d{5}|5\\d{3,5}))", 
, , , "1012345678", , , [7, 8, 9, 10, 11], [5, 6]], [, , "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|5[0-35-9]|6[25-7]|7[0-35-8]|9[189])\\d{8}", , , , "13123456789", , , [11]], [, , "(?:(?:10|21)8|8)00\\d{7}", , , , "8001234567", , , [10, 12]], [, , "16[08]\\d{5}", , , , "16812345", , , [8]], [, , "400\\d{7}|950\\d{7,8}|(?:10|2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}", 
, , , "4001234567", , , [7, 8, 9, 10, 11], [5, 6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CN", 86, "00|1(?:[12]\\d|79|9[0235-7])\\d\\d00", "0", , , "0|(1(?:[12]\\d|79|9[0235-7])\\d\\d)", , "00", , [[, "(\\d{5,6})", "$1", ["96"]], [, "(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "(?:10|2[0-57-9])(?:100|9[56])"], "0$1", "$CC $1"], [, "(\\d{3})(\\d{4})", "$1 $2", ["[1-9]", "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])", "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"]], 
[, "(\\d{4})(\\d{4})", "$1 $2", ["16[08]"]], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", 
"85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], 
"0$1", "$CC $1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[1-9]", "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])", "26|3(?:[0268]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9])|(?:34|85[23])[0-8]|(?:1|58)[1-9]|(?:63|95)[06-9]|(?:33|85[23]9)[0-46-9]|(?:10|2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])", 
"26|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:1|58|85[23]10)[1-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"]], 
[, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1], 
[, "(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"], , "$CC $1"], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", , 1]], [[, "(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "(?:10|2[0-57-9])(?:100|9[56])"], "0$1", "$CC $1"], [, "(\\d{3})(\\d{5,6})", 
"$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", 
"85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], 
"0$1", "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 
"$CC $1", 1], [, "(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"], , "$CC $1"], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", , 1]], [, , , , , , , , , [-1]], , , [, , "(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}", , , , , , , [10, 11, 12]], [, , , , , , , , , [-1]], , , [, , , , , , , 
, , [-1]]], CO:[, [, , "(?:1\\d|3)\\d{9}|[124-8]\\d{7}", , , , , , , [8, 10, 11], [7]], [, , "[124-8][2-9]\\d{6}", , , , "12345678", , , [8], [7]], [, , "3(?:0[0-5]|1\\d|2[0-3]|5[01])\\d{7}", , , , "3211234567", , , [10]], [, , "1800\\d{7}", , , , "18001234567", , , [11]], [, , "19(?:0[01]|4[78])\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CO", 57, "00(?:4(?:[14]4|56)|[579])", "0", , , "0([3579]|4(?:[14]4|56))?", , , , [[, 
"(\\d)(\\d{7})", "$1 $2", ["1[2-79]|[25-8]|(?:18|4)[2-9]"], "($1)", "0$CC $1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3"], , "0$CC $1"], [, "(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1(?:80|9)", "1(?:800|9)"], "0$1"]], [[, "(\\d)(\\d{7})", "$1 $2", ["1[2-79]|[25-8]|(?:18|4)[2-9]"], "($1)", "0$CC $1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3"], , "0$CC $1"], [, "(\\d)(\\d{3})(\\d{7})", "$1 $2 $3", ["1(?:80|9)", "1(?:800|9)"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
, , [, , , , , , , , , [-1]]], CR:[, [, , "(?:8\\d|90)\\d{8}|[24-8]\\d{7}", , , , , , , [8, 10]], [, , "210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}", , , , "22123456", , , [8]], [, , "6500[01]\\d{3}|5(?:0[01]|7[0-3])\\d{5}|(?:6[0-4]|7[0-3]|8[3-9])\\d{6}", , , , "83123456", , , [8]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "90[059]\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:210[0-6]|4\\d{3}|5100)\\d{4}", , , , "40001234", , , [8]], 
"CR", 506, "00", , , , "(19(?:0[0-2468]|1[09]|20|66|77|99))", , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[24-7]|8[3-9]"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CU:[, [, , "[27]\\d{6,7}|[34]\\d{5,7}|5\\d{7}", , , , , , , [6, 7, 8], [4, 5]], [, , "(?:3[23]|48)\\d{4,6}|(?:31|4[36])\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}", , , , "71234567", , , , [4, 
5]], [, , "5\\d{7}", , , , "51234567", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CU", 53, "119", "0", , , "0", , , , [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], [, "(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], [, "(\\d)(\\d{7})", "$1 $2", ["5"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CV:[, [, , "[2-59]\\d{6}", 
, , , , , , [7]], [, , "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}", , , , "2211234"], [, , "(?:[34][36]|5[1-389]|9\\d)\\d{5}", , , , "9911234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CV", 238, "0", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-59]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CW:[, [, 
, "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", , , , , , , [7, 8]], [, , "9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}", , , , "94351234"], [, , "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}", , , , "95181234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "60[0-2]\\d{4}", , , , "6001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CW", 599, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], 
[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], , [, , "955\\d{5}", , , , "95581234", , , [8]], 1, "[69]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CX:[, [, , "1(?:[0-79]\\d|8[0-24-9])\\d{7}|(?:[148]\\d\\d|550)\\d{6}|1\\d{5,7}", , , , , , , [6, 7, 8, 9, 10]], [, , "8(?:51(?:0(?:01|30|59)|117)|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", , , , "891641234", , , [9], [8]], [, , "483[0-3]\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-2457-9]|9[0-27-9])\\d{6}", 
, , , "412345678", , , [9]], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]], [, , "13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}", , , , "1300123456", , , [6, 8, 10]], [, , , , , , , , , [-1]], [, , "(?:14(?:5(?:1[0458]|[23][458])|71\\d)|550\\d\\d)\\d{4}", , , , "550123456", , , [9]], "CX", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0", , , "0|([59]\\d{7})$", "8$1", "0011", , , , [, , , , , , , , , [-1]], , , [, , , 
, , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CY:[, [, , "(?:[279]\\d|[58]0)\\d{6}", , , , , , , [8]], [, , "2[2-6]\\d{6}", , , , "22345678"], [, , "9[4-79]\\d{6}", , , , "96123456"], [, , "800\\d{5}", , , , "80001234"], [, , "90[09]\\d{5}", , , , "90012345"], [, , "80[1-9]\\d{5}", , , , "80112345"], [, , "700\\d{5}", , , , "70012345"], [, , , , , , , , , [-1]], "CY", 357, "00", , , , , , , , [[, "(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]], , [, , , , , , , , , [-1]], 
, , [, , , , , , , , , [-1]], [, , "(?:50|77)\\d{6}", , , , "77123456"], , , [, , , , , , , , , [-1]]], CZ:[, [, , "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", , , , , , , [9, 10, 11, 12]], [, , "(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}", , , , "212345678", , , [9]], [, , "(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}", , , , "601123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "9(?:0[05689]|76)\\d{6}", , , , "900123456", , , [9]], [, , "8[134]\\d{7}", , , , "811234567", , , [9]], [, , "70[01]\\d{6}", 
, , , "700123456", , , [9]], [, , "9[17]0\\d{6}", , , , "910123456", , , [9]], "CZ", 420, "00", , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "9(?:5\\d|7[2-4])\\d{6}", , , , "972123456", , , [9]], , , [, , "9(?:3\\d{9}|6\\d{7,10})", , , , "93123456789"]], DE:[, [, , "[2579]\\d{5,14}|49(?:[05]\\d{10}|[46][1-8]\\d{4,9})|49(?:[0-25]\\d|3[1-689]|7[1-7])\\d{4,8}|49(?:[0-2579]\\d|[34][1-9]|6[0-8])\\d{3}|49\\d{3,4}|(?:1|[368]\\d|4[0-8])\\d{3,13}", 
, , , , , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [2, 3]], [, , "(?:32|49[4-6]\\d)\\d{9}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}", 
, , , "30123456", , , [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [2, 3, 4]], [, , "15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}", , , , "15123456789", , , [10, 11]], [, , "800\\d{7,12}", , , , "8001234567890", , , [10, 11, 12, 13, 14, 15]], [, , "(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", , , , "9001234567", , , [10, 11]], [, , "180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", , , , "18012345", , , [7, 8, 9, 10, 11, 12, 13, 14]], [, , "700\\d{8}", , , , "70012345678", , , [11]], [, , , , , , , , , [-1]], "DE", 49, 
"00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], [, "(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], [, "(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], 
"0$1"], [, "(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], [, "(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], [, "(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], [, "(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], [, "(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], [, "(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], [, "(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], [, "(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], 
[, "(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"], [, "(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], [, "(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], [, "(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], , [, , "16(?:4\\d{1,10}|[89]\\d{1,11})", , , , "16412345", , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]], [, , "18(?:1\\d{5,11}|[2-9]\\d{8})", 
, , , "18500123456", , , [8, 9, 10, 11, 12, 13, 14]], , , [, , "1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}", , , , "177991234567", , , [12, 13]]], DJ:[, [, , "(?:2\\d|77)\\d{6}", , , , , , , [8]], [, , "2(?:1[2-5]|7[45])\\d{5}", , , , "21360003"], [, , "77\\d{6}", , , , "77831001"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DJ", 253, 
"00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], DK:[, [, , "[2-9]\\d{7}", , , , , , , [8]], [, , "(?:[2-7]\\d|8[126-9]|9[1-36-9])\\d{6}", , , , "32123456"], [, , "(?:[2-7]\\d|8[126-9]|9[1-36-9])\\d{6}", , , , "32123456"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, 
, , , , , , , , [-1]], "DK", 45, "00", , , , , , , 1, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], DM:[, [, , "(?:[58]\\d\\d|767|900)\\d{7}", , , , , , , [10], [7]], [, , "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4]|70[1-3])\\d{4}", , , , "7674201234", , , , [7]], [, , "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-7])\\d{4}", , , , "7672251234", , , , [7]], [, , 
"8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "DM", 1, "011", "1", , , "1|([2-7]\\d{6})$", "767$1", , , , , [, , , , , , , , , [-1]], , "767|8001", [, , "80014\\d{5}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], DO:[, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}", 
, , , "8092345678", , , , [7]], [, , "8[024]9[2-9]\\d{6}", , , , "8092345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "DO", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "8[024]9", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], DZ:[, [, , "(?:[1-4]|[5-79]\\d|80)\\d{7}", 
, , , , , , [8, 9]], [, , "9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[0135689])\\d{6}", , , , "12345678"], [, , "67[0-6]\\d{6}|(?:5[4-6]|6[569]|7[7-9])\\d{7}", , , , "551234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "80[3-689]1\\d{5}", , , , "808123456", , , [9]], [, , "80[12]1\\d{5}", , , , "801123456", , , [9]], [, , , , , , , , , [-1]], [, , "98[23]\\d{6}", , , , "983123456", , , [9]], "DZ", 213, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", 
["[1-4]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], EC:[, [, , "1800\\d{6,7}|(?:[2-7]|9\\d)\\d{7}", , , , , , , [8, 9, 10, 11], [7]], [, , "[2-7][2-7]\\d{6}", , , , "22123456", , , [8], [7]], [, , "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-37-9]|[89]\\d)\\d{6}", , , , "991234567", , 
, [9]], [, , "1800\\d{6,7}", , , , "18001234567", , , [10, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[2-7]890\\d{4}", , , , "28901234", , , [8]], "EC", 593, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-7]"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-7]"]], 
[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], EE:[, [, , "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d\\d|900)\\d{4}", , , , , , , [7, 8, 10]], [, , "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", , , , "3212345", , , [7]], [, , "(?:5\\d|8[1-4])\\d{6}|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", , , , "51234567", 
, , [7, 8]], [, , "800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}", , , , "80012345"], [, , "(?:40\\d\\d|900)\\d{4}", , , , "9001234", , , [7, 8]], [, , , , , , , , , [-1]], [, , "70[0-2]\\d{5}", , , , "70012345", , , [8]], [, , , , , , , , , [-1]], "EE", 372, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-4])", "[45]|8(?:00[1-9]|[1-4])"]], 
[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["80"]]], , [, , , , , , , , , [-1]], , , [, , "800[2-9]\\d{3}", , , , , , , [7]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], EG:[, [, , "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", , , , , , , [8, 9, 10], [6, 7]], [, , "(?:15\\d|57[23])\\d{5,6}|(?:13[23]|(?:2[2-4]|3)\\d|4(?:0[2-5]|[578][23]|64)|5(?:0[2-7]|5\\d)|6[24-689]3|8(?:2[2-57]|4[26]|6[237]|8[2-4])|9(?:2[27]|3[24]|52|6[2356]|7[2-4]))\\d{6}", 
, , , "234567890", , , [8, 9], [6, 7]], [, , "1[0-25]\\d{8}", , , , "1001234567", , , [10]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "EG", 20, "00", "0", , , "0", , , , [[, "(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], [, "(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[189]"], "0$1"]], , [, , 
, , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], EH:[, [, , "[5-8]\\d{8}", , , , , , , [9]], [, , "528[89]\\d{5}", , , , "528812345"], [, , "692[12]\\d{5}|(?:6(?:[0-7]\\d|8[0-247-9]|9[013-9])|7(?:0[06-8]|6[1267]|7[0-27]))\\d{6}", , , , "650123456"], [, , "80\\d{7}", , , , "801234567"], [, , "89\\d{7}", , , , "891234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "5924[0-2]\\d{4}", , , , "592401234"], "EH", 212, "00", "0", 
, , "0", , , , , , [, , , , , , , , , [-1]], , "528[89]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ER:[, [, , "[178]\\d{6}", , , , , , , [7], [6]], [, , "(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}", , , , "8370362", , , , [6]], [, , "(?:17[1-3]|7\\d\\d)\\d{4}", , , , "7123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ER", 291, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", 
"$1 $2 $3", ["[178]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ES:[, [, , "(?:51|[6-9]\\d)\\d{7}", , , , , , , [9]], [, , "96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}", , , , "810123456"], [, , "9(?:6906(?:09|10)|7390\\d\\d)\\d\\d|(?:6\\d|7[1-48])\\d{7}", , , , "612345678"], [, 
, "[89]00\\d{6}", , , , "800123456"], [, , "80[367]\\d{6}", , , , "803123456"], [, , "90[12]\\d{6}", , , , "901123456"], [, , "70\\d{7}", , , , "701234567"], [, , , , , , , , , [-1]], "ES", 34, "00", , , , , , , , [[, "(\\d{4})", "$1", ["905"]], [, "(\\d{6})", "$1", ["[79]9"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", 
["[5-9]"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "51\\d{7}", , , , "511234567"], , , [, , , , , , , , , [-1]]], ET:[, [, , "(?:11|[2-59]\\d)\\d{7}", , , , , , , [9], [7]], [, , "(?:11(?:1(?:1[124]|2[2-57]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[78]|2[69]|39|4[5-7]|5[1-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}", 
, , , "111112345", , , , [7]], [, , "9\\d{8}", , , , "911234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ET", 251, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-59]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], FI:[, [, , "(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}|[1-35689]\\d{4}", , , , , , , 
[5, 6, 7, 8, 9, 10]], [, , "(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}", , , , "131234567", , , [5, 6, 7, 8, 9]], [, , "(?:4[0-8]|50)\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10]], [, , "800\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FI", 358, "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "0", , , "0", , "00", , [[, "(\\d{5})", "$1", ["75[12]"], "0$1"], 
[, "(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], [, "(\\d{6})", "$1", ["11"]], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[12]0|7)0|[368]"], "0$1"], [, "(\\d{2})(\\d{4,8})", "$1 $2", ["[12457]"], "0$1"]], [[, "(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[12]0|7)0|[368]"], "0$1"], [, "(\\d{2})(\\d{4,8})", "$1 $2", ["[12457]"], "0$1"]], [, , , , , , , , , [-1]], 1, "1[03-79]|[2-9]", [, , "20(?:2[023]|9[89])\\d{1,6}|60[12]\\d{5,6}|(?:606|7(?:1|3\\d))\\d{7}|(?:[1-3]00|75[03-9])\\d{3,7}"], 
[, , "(?:10|[23][09])\\d{4,8}|60(?:[12]\\d{5,6}|6\\d{7})|7(?:(?:1|3\\d)\\d{7}|5[03-9]\\d{3,7})|20[2-59]\\d\\d", , , , "10112345"], , , [, , , , , , , , , [-1]]], FJ:[, [, , "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", , , , , , , [7, 11]], [, , "603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", , , , "3212345", , , [7]], [, , "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", , , , "7012345", , , [7]], [, , "0800\\d{7}", , , , "08001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , 
, , , [-1]], [, , , , , , , , , [-1]], "FJ", 679, "0(?:0|52)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], FK:[, [, , "[2-7]\\d{4}", , , , , , , [5]], [, , "[2-47]\\d{4}", , , , "31234"], [, , "[56]\\d{4}", , , , "51234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , 
, , , , , [-1]], [, , , , , , , , , [-1]], "FK", 500, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], FM:[, [, , "[39]\\d{6}", , , , , , , [7]], [, , "(?:3[2357]0[1-9]|9[2-6]\\d\\d)\\d{3}", , , , "3201234"], [, , "(?:3[2357]0[1-9]|9[2-7]\\d\\d)\\d{3}", , , , "3501234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FM", 691, 
"00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[39]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], FO:[, [, , "(?:[2-8]\\d|90)\\d{4}", , , , , , , [6]], [, , "(?:20|[34]\\d|8[19])\\d{4}", , , , "201234"], [, , "(?:[27][1-9]|5\\d)\\d{4}", , , , "211234"], [, , "80[257-9]\\d{3}", , , , "802123"], [, , "90(?:[13-5][15-7]|2[125-7]|99)\\d\\d", , , , "901123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:6[0-36]|88)\\d{4}", 
, , , "601234"], "FO", 298, "00", , , , "(10(?:01|[12]0|88))", , , , [[, "(\\d{6})", "$1", ["[2-9]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], FR:[, [, , "[1-9]\\d{8}", , , , , , , [9]], [, , "[1-5]\\d{8}", , , , "123456789"], [, , "700\\d{6}|(?:6\\d|7[3-9])\\d{7}", , , , "612345678"], [, , "80[0-5]\\d{6}", , , , "801234567"], [, , "8[129]\\d{7}", , , , "891123456"], [, , "884\\d{6}", , , , "884012345"], [, , 
, , , , , , , [-1]], [, , "9\\d{8}", , , , "912345678"], "FR", 33, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["10"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["1"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], [, , , , , , , , , [-1]], , , 
[, , , , , , , , , [-1]], [, , "80[6-9]\\d{6}", , , , "806123456"], , , [, , , , , , , , , [-1]]], GA:[, [, , "(?:0\\d|[2-7])\\d{6}", , , , , , , [7, 8]], [, , "01\\d{6}", , , , "01441234", , , [8]], [, , "(?:0[2-7]|[2-7])\\d{6}", , , , "06031234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GA", 241, "00", , , , , , , , [[, "(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", 
"$1 $2 $3 $4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GB:[, [, , "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", , , , , , , [7, 9, 10], [4, 5, 6, 8]], [, , "(?:1(?:(?:1(?:3[0-58]|4[0-5]|5[0-26-9]|6[0-4]|[78][0-49])|3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|80[04589])))|2(?:0[01378]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d|7(?:(?:26(?:6[13-9]|7[0-7])|442\\d|50(?:2[0-3]|[3-68]2|76))\\d|6888[2-46-8]))\\d\\d", 
, , , "1212345678", , , [9, 10], [4, 5, 6, 7, 8]], [, , "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", , , , "7400123456", , , [10]], [, , "80[08]\\d{7}|800\\d{6}|8001111", , , , "8001234567"], [, , "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", , , , "9012345678", , , [7, 10]], [, , , , , , , , , [-1]], [, , 
"70\\d{8}", , , , "7012345678", , , [10]], [, , "56\\d{8}", , , , "5612345678", , , [10]], "GB", 44, "00", "0", " x", , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], 
"0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[024-9])", "[25]|7(?:0|6(?:[04-9]|2[356]))"], "0$1"], [, "(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], , [, , "76(?:0[0-2]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}", , , , "7640123456", , , [10]], 1, , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , 
, , , , , , , [-1]]], GD:[, [, , "(?:473|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}", , , , "4732691234", , , , [7]], [, , "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}", , , , "4734031234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", 
, , , "5002345678"], [, , , , , , , , , [-1]], "GD", 1, "011", "1", , , "1|([2-9]\\d{6})$", "473$1", , , , , [, , , , , , , , , [-1]], , "473", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GE:[, [, , "(?:[3-57]\\d\\d|800)\\d{6}", , , , , , , [9], [6, 7]], [, , "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}", , , , "322123456", , , , [6, 7]], [, , "5(?:0(?:0[05]|55)\\d|1111|2222|3333|5200|75(?:00|7[78])|8(?:58[89]|888))\\d{4}|(?:5(?:[14]4|5[0157-9]|68|7[0147-9]|9[1-35-9])|790)\\d{6}", 
, , , "555123456"], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "706\\d{6}", , , , "706123456"], "GE", 995, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], , [, , , , , , , , , 
[-1]], , , [, , "706\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GF:[, [, , "[56]94\\d{6}", , , , , , , [9]], [, , "594(?:[023]\\d|1[01]|4[03-9]|5[6-9]|6[0-3]|80|9[014])\\d{4}", , , , "594101234"], [, , "694(?:[0-249]\\d|3[0-48])\\d{4}", , , , "694201234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GF", 594, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", 
["[56]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GG:[, [, , "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", , , , , , , [7, 9, 10], [6]], [, , "1481[25-9]\\d{5}", , , , "1481256789", , , [10], [6]], [, , "7(?:(?:781|839)\\d|911[17])\\d{5}", , , , "7781123456", , , [10]], [, , "80[08]\\d{7}|800\\d{6}|8001111", , , , "8001234567"], [, , "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", , , , "9012345678", 
, , [7, 10]], [, , , , , , , , , [-1]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , "56\\d{8}", , , , "5612345678", , , [10]], "GG", 44, "00", "0", , , "0|([25-9]\\d{5})$", "1481$1", , , , , [, , "76(?:0[0-2]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}", , , , "7640123456", , , [10]], , , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]], GH:[, [, , "(?:[235]\\d{3}|800)\\d{5}", , , , , , , [8, 9], [7]], [, , "3(?:[167]2[0-6]|22[0-5]|32[0-3]|4(?:2[013-9]|3[01])|52[0-7]|82[0-2])\\d{5}|3(?:[0-8]8|9[28])0\\d{5}|3(?:0[237]|[1-9]7)\\d{6}", 
, , , "302345678", , , [9], [7]], [, , "56[01]\\d{6}|(?:2[0346-8]|5[0457])\\d{7}", , , , "231234567", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GH", 233, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[237]|80"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [[, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], 
[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "800\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GI:[, [, , "(?:[25]\\d\\d|629)\\d{5}", , , , , , , [8]], [, , "2190[0-2]\\d{3}|2(?:00\\d|16[24-7]|2(?:2[2457]|50))\\d{4}", , , , "20012345"], [, , "(?:5[46-8]\\d|629)\\d{5}", , , , "57123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , 
, [-1]], "GI", 350, "00", , , , , , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["2"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GL:[, [, , "(?:19|[2-689]\\d)\\d{4}", , , , , , , [6]], [, , "(?:19|3[1-7]|6[14689]|8[14-79]|9\\d)\\d{4}", , , , "321000"], [, , "(?:[25][1-9]|4[2-9])\\d{4}", , , , "221234"], [, , "80\\d{4}", , , , "801234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3[89]\\d{4}", 
, , , "381234"], "GL", 299, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-689]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GM:[, [, , "[2-9]\\d{6}", , , , , , , [7]], [, , "(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:54[0-7]|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}", , , , "5661234"], [, , "(?:[23679]\\d|5[0-3])\\d{5}", , , , "3012345"], [, , , , , , , , , [-1]], [, , , , , , , , , 
[-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GM", 220, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GN:[, [, , "(?:30|6\\d\\d|722)\\d{6}", , , , , , , [8, 9]], [, , "30(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])\\d{4}", , , , "30241234", , , [8]], [, , "6[02356]\\d{7}", , , , "601123456", , , [9]], [, , , , , , , , , 
[-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "722\\d{6}", , , , "722123456", , , [9]], "GN", 224, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GP:[, [, , "(?:590|69\\d)\\d{6}", , , , , , , [9]], [, , "590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}", 
, , , "590201234"], [, , "69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}", , , , "690001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GP", 590, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GQ:[, [, , "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", , , , , , 
, [9]], [, , "33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}", , , , "333091234"], [, , "(?:222|55[015])\\d{6}", , , , "222123456"], [, , "80\\d[1-9]\\d{5}", , , , "800123456"], [, , "90\\d[1-9]\\d{5}", , , , "900123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GQ", 240, "00", , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , 
, , , , , , [-1]], , , [, , , , , , , , , [-1]]], GR:[, [, , "(?:[268]\\d|[79]0)\\d{8}", , , , , , , [10]], [, , "2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}", , , , "2123456789"], 
[, , "6(?:8[57-9]|9\\d)\\d{7}", , , , "6912345678"], [, , "800\\d{7}", , , , "8001234567"], [, , "90[19]\\d{7}", , , , "9091234567"], [, , "8(?:0[16]|12|25)\\d{7}", , , , "8011234567"], [, , "70(?:0[3-8]0|707)\\d{5}", , , , "7003000123"], [, , , , , , , , , [-1]], "GR", 30, "00", , , , , , , , [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]]], 
, [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GT:[, [, , "(?:1\\d{3}|[2-7])\\d{7}", , , , , , , [8, 11]], [, , "[267][2-9]\\d{6}", , , , "22456789", , , [8]], [, , "[3-5]\\d{7}", , , , "51234567", , , [8]], [, , "18[01]\\d{8}", , , , "18001112222", , , [11]], [, , "19\\d{9}", , , , "19001112222", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GT", 502, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", 
"$1 $2", ["[2-7]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GU:[, [, , "(?:[58]\\d\\d|671|900)\\d{7}", , , , , , , [10], [7]], [, , "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}", , , , "6713001234", 
, , , [7]], [, , "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}", , , , "6713001234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], 
"GU", 1, "011", "1", , , "1|([3-9]\\d{6})$", "671$1", , 1, , , [, , , , , , , , , [-1]], , "671", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GW:[, [, , "[49]\\d{8}|4\\d{6}", , , , , , , [7, 9]], [, , "443\\d{6}", , , , "443201234", , , [9]], [, , "9(?:5\\d|6[569]|77)\\d{6}", , , , "955012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "40\\d{5}", , , , "4012345", , , [7]], "GW", 245, 
"00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["40"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GY:[, [, , "(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}", , , , , , , [7]], [, , "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}", , , , "2201234"], [, , "6\\d{6}", , , , "6091234"], [, , "(?:289|862)\\d{4}", 
, , , "2891234"], [, , "9008\\d{3}", , , , "9008123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GY", 592, "001", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-46-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], HK:[, [, , "8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}", , , , , , , [5, 6, 7, 8, 9, 11]], [, , "(?:384[0-24]|58(?:0[1-8]|1[2-9]))\\d{4}|(?:2(?:[13-8]\\d|2[013-9]|9[0-24-9])|3(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69]|89))\\d{5}", 
, , , "21234567", , , [8]], [, , "(?:46(?:0[0-6]|1[0-2]|4[0-57-9])|5730|(?:626|848)[01]|707[1-5]|929[03-9])\\d{4}|(?:5(?:[1-59][0-46-9]|6[0-4689]|7[0-2469])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", , , , "51234567", , , [8]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "900(?:[0-24-9]\\d{7}|3\\d{1,4})", , , , "90012345678", , , [5, 6, 7, 8, 11]], [, , , , , , , , , [-1]], [, , "8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", 
, , , "81123456", , , [8]], [, , , , , , , , , [-1]], "HK", 852, "00(?:30|5[09]|[126-9]?)", , , , , , "00", , [[, "(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], , [, , "7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}", 
, , , "71123456", , , [8]], , , [, , , , , , , , , [-1]], [, , "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", , , , "30161234", , , [8]], , , [, , , , , , , , , [-1]]], HN:[, [, , "8\\d{10}|[237-9]\\d{7}", , , , , , , [8, 11]], [, , "2(?:2(?:0[019]|1[1-36]|[23]\\d|4[04-6]|5[57]|6[24]|7[0135689]|8[01346-9]|9[0-2])|4(?:07|2[3-59]|3[13-689]|4[0-68]|5[1-35])|5(?:0[78]|16|4[03-5]|5\\d|6[014-6]|74|80)|6(?:[056]\\d|17|2[07]|3[04]|4[0-378]|[78][0-8]|9[01])|7(?:6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}", 
, , , "22123456", , , [8]], [, , "[37-9]\\d{7}", , , , "91234567", , , [8]], [, , "8002\\d{7}", , , , "80021234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "HN", 504, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], [, , , , , , , , , [-1]], , , [, , "8002\\d{7}", , , , , , , [11]], [, , , , , , , , , [-1]], 
, , [, , , , , , , , , [-1]]], HR:[, [, , "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", , , , , , , [6, 7, 8, 9]], [, , "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}", , , , "12345678", , , [8, 9], [6, 7]], [, , "9(?:751\\d{5}|8\\d{6,7})|9(?:01|[1259]\\d|7[0679])\\d{6}", , , , "921234567", , , [8, 9]], [, , "80[01]\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "6[01459]\\d{6}|6[01]\\d{4,5}", , , , "611234", , , [6, 7, 8]], [, , , , , , , , , [-1]], [, , "7[45]\\d{6}", 
, , , "74123456", , , [8]], [, , , , , , , , , [-1]], "HR", 385, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], [, "(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", 
["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "62\\d{6,7}|72\\d{6}", , , , "62123456", , , [8, 9]], , , [, , , , , , , , , [-1]]], HT:[, [, , "[2-489]\\d{7}", , , , , , , [8]], [, , "2(?:2\\d|5[1-5]|81|9[149])\\d{5}", , , , "22453300"], [, , "[34]\\d{7}", , , , "34101234"], [, , "8\\d{7}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}", , , , "98901234"], "HT", 509, "00", 
, , , , , , , [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-489]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], HU:[, [, , "[2357]\\d{8}|[1-9]\\d{7}", , , , , , , [8, 9], [6, 7]], [, , "(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", , , , "12345678", , , [8], [6, 7]], [, , "(?:[257]0|3[01])\\d{7}", , , , "201234567", , , [9]], [, , "[48]0\\d{6}", , , , "80123456", , , [8]], [, , "9[01]\\d{6}", 
, , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "21\\d{7}", , , , "211234567", , , [9]], "HU", 36, "00", "06", , , "06", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57-9]"], "06 $1"]], , [, , , , , , , , , [-1]], , , [, , "[48]0\\d{6}", , , , , , , [8]], [, , "38\\d{7}", , , , "381234567", 
, , [9]], , , [, , , , , , , , , [-1]]], ID:[, [, , "(?:(?:007803|8\\d{4})\\d|[1-36])\\d{6}|[1-9]\\d{8,10}|[2-9]\\d{7}", , , , , , , [7, 8, 9, 10, 11, 12, 13], [5, 6]], [, , "2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}", 
, , , "218350123", , , [7, 8, 9, 10, 11], [5, 6]], [, , "8[1-35-9]\\d{7,10}", , , , "812345678", , , [9, 10, 11, 12]], [, , "007803\\d{7}|(?:177\\d|800)\\d{5,7}", , , , "8001234567", , , [8, 9, 10, 11, 13]], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , "804\\d{7}", , , , "8041234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ID", 62, "00[189]", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [, "(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], 
"(0$1)"], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [, "(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], [[, "(\\d)(\\d{3})(\\d{3})", 
"$1 $2 $3", ["15"]], [, "(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [, "(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], [, , , 
, , , , , , [-1]], , , [, , "(?:007803\\d|8071)\\d{6}", , , , , , , [10, 13]], [, , "(?:1500|8071\\d{3})\\d{3}", , , , "8071123456", , , [7, 10]], , , [, , , , , , , , , [-1]]], IE:[, [, , "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", , , , , , , [7, 8, 9, 10], [5, 6]], [, , "(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8[0-46-9])|5[23679]|6[4-6]|7[14]|9[04])\\d{7}", , , , "2212345", , , , [5, 6]], [, , "8(?:22|[35-9]\\d)\\d{6}", 
, , , "850123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , "15(?:1[2-8]|[2-8]0|9[089])\\d{6}", , , , "1520123456", , , [10]], [, , "18[59]0\\d{6}", , , , "1850123456", , , [10]], [, , "700\\d{6}", , , , "700123456", , , [9]], [, , "76\\d{7}", , , , "761234567", , , [9]], "IE", 353, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], [, "(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", 
["1"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], [, "(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , "18[59]0\\d{6}", 
, , , , , , [10]], [, , "818\\d{6}", , , , "818123456", , , [9]], , , [, , "8[35-9]5\\d{7}", , , , "8551234567", , , [10]]], IL:[, [, , "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", , , , , , , [7, 8, 9, 10, 11, 12]], [, , "153\\d{8,9}|[2-489]\\d{7}", , , , "21234567", , , [8, 11, 12], [7]], [, , "5(?:(?:[0-389][2-9]|4[1-9]|6\\d)\\d|5(?:01|2[2-6]|3[23]|4[45]|5[05689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", , , , "502345678", , , [9]], [, , "1(?:255|80[019]\\d{3})\\d{3}", , , , "1800123456", , 
, [7, 10]], [, , "1212\\d{4}|1(?:200|9(?:0[01]|19))\\d{6}", , , , "1919123456", , , [8, 10]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [, , "78(?:33|55|77|81)\\d{5}|7(?:18|2[23]|3[237]|47|6[58]|7\\d|82|9[235-9])\\d{6}", , , , "771234567", , , [9]], "IL", 972, "0(?:0|1[2-9])", "0", , , "0", , , , [[, "(\\d{4})(\\d{3})", "$1-$2", ["125"]], [, "(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], [, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", 
"$1-$2-$3", ["[57]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], [, "(\\d{4})(\\d{6})", "$1-$2", ["159"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], [, "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], , [, , , , , , , , , [-1]], , , [, , "1700\\d{6}", , , , , , , [10]], [, , "1599\\d{6}", , , , "1599123456", , , [10]], , , [, , "151\\d{8,9}", , , , "15112340000", , , [11, 12]]], IM:[, [, , "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", , , , , , , [10], 
[6]], [, , "1624[5-8]\\d{5}", , , , "1624756789", , , , [6]], [, , "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}", , , , "7924123456"], [, , "808162\\d{4}", , , , "8081624567"], [, , "8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}", , , , "9016247890"], [, , , , , , , , , [-1]], [, , "70\\d{8}", , , , "7012345678"], [, , "56\\d{8}", , , , "5612345678"], "IM", 44, "00", "0", , , "0|([5-8]\\d{5})$", "1624$1", , , , , [, , , , , , , , , [-1]], , "74576|(?:16|7[56])24", [, , 
, , , , , , , [-1]], [, , "3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}", , , , "5512345678"], , , [, , , , , , , , , [-1]]], IN:[, [, , "(?:00800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", , , , , , , [8, 9, 10, 11, 12, 13], [6, 7]], [, , "782[0-6][2-7]\\d{5}|(?:170[24]|2(?:80[13468]|90\\d)|380\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:11|2[02]|33|4[04]|79|80)[2-7]\\d{7}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[13-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1-5]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[0189])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}", 
, , , "7410410123", , , [10], [6, 7, 8]], [, , "(?:6(?:1279|350[0-6])|7(?:3(?:1(?:11|7[02-8])|411)|4[47](?:11|7[02-8])|5111|700[02-9]|88(?:11|7[02-9])|9(?:313|79[07-9]))|8(?:079[04-9]|(?:16|2[014]|3[126]|6[136]|7[78]|8[34]|91)7[02-8]))\\d{5}|7(?:28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7])[089]\\d{5}|(?:6(?:0(?:0[0-3569]|26|33)|2(?:[06]\\d|3[02589]|8[0-479]|9[0-79])|3(?:0[0-79]|5[1-9]|6[0-4679]|7[0-24-9]|[89]\\d)|9(?:0[019]|13))|7(?:0\\d\\d|19[0-5]|2(?:[0235-79]\\d|[14][017-9]|8[0-59])|3(?:[05-8]\\d|1[089]|2[5-8]|3[017-9]|4[07-9]|9[016-9])|4(?:0\\d|1[015-9]|[29][89]|39|[47][089]|8[389])|5(?:[0346-8]\\d|1[07-9]|2[04-9]|5[017-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589]|[6-9]\\d)|7(?:0[289]|[1-9]\\d)|8(?:[0-79]\\d|8[089])|9(?:[089]\\d|7[02-8]))|8(?:0(?:[01589]\\d|6[67]|7[02-8])|1(?:[0-57-9]\\d|6[089])|2(?:[014][089]|[235-9]\\d)|3(?:[03-57-9]\\d|[126][089])|[45]\\d\\d|6(?:[02457-9]\\d|[136][089])|7(?:0[07-9]|[1-69]\\d|[78][089])|8(?:[0-25-9]\\d|3[089]|4[0489])|9(?:[02-9]\\d|1[0289]))|9\\d{3})\\d{6}", 
, , , "8123456789", , , [10]], [, , "00800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))", , , , "1800123456"], [, , "186[12]\\d{9}", , , , "1861123456789", , , [13]], [, , "1860\\d{7}", , , , "18603451234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IN", 91, "00", "0", , , "0", , , , [[, "(\\d{7})", "$1", ["575"]], [, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], , , 1], [, "(\\d{4})(\\d{4,5})", 
"$1 $2", ["180", "1800"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], , , 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", 
"1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|(?:55|61)2|7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:1(?:29|60|8[06])|261|552|788[01])[2-7]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])"], 
"0$1", , 1], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|[4-8])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|[4-8])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|[4-8])|7(?:1(?:[013-8]|9[6-9])|3179)|807(?:1|9[1-3])|(?:1552|7(?:28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], 
"0$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], , , 1], [, "(\\d{2})(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3 $4", ["0"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], , , 1]], [[, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], , , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 
, , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], , , 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", 
"1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|(?:55|61)2|7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:1(?:29|60|8[06])|261|552|788[01])[2-7]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])"], 
"0$1", , 1], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|[4-8])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|[4-8])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|[4-8])|7(?:1(?:[013-8]|9[6-9])|3179)|807(?:1|9[1-3])|(?:1552|7(?:28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], 
"0$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], , , 1], [, "(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], , , 1]], [, , , , , , , , , [-1]], , , [, , "1(?:600\\d{6}|800\\d{4,9})|(?:00800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"], [, , "140\\d{7}", , , , "1409305260", , , [10]], , , [, , , , , , , , , [-1]]], IO:[, [, , "3\\d{6}", , , , , , , [7]], [, , "37\\d{5}", , , , "3709100"], [, 
, "38\\d{5}", , , , "3801234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IO", 246, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], IQ:[, [, , "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", , , , , , , [8, 9, 10], [6, 7]], [, , "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", , , , 
"12345678", , , [8, 9], [6, 7]], [, , "7[3-9]\\d{8}", , , , "7912345678", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IQ", 964, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , 
, , , [-1]], , , [, , , , , , , , , [-1]]], IR:[, [, , "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", , , , , , , [4, 5, 6, 7, 10], [8]], [, , "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|2(?:121|[2689]0\\d)|30[0-2]\\d|4(?:111|40\\d))\\d{4}", , , , "2123456789", , , [6, 7, 10], [4, 5, 8]], [, , "9(?:(?:0(?:[1-35]\\d|44)|(?:[13]\\d|2[0-2])\\d)\\d|9(?:(?:[0-2]\\d|44)\\d|5[15]0|8(?:1\\d|88)|9(?:0[013]|1[0134]|21|77|9[6-9])))\\d{5}", 
, , , "9123456789", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "993\\d{7}", , , , "9932123456", , , [10]], "IR", 98, "00", "0", , , "0", , , , [[, "(\\d{4,5})", "$1", ["96"], "0$1"], [, "(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], 
, [, , , , , , , , , [-1]], , , [, , "9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))", , , , , , , [4, 5, 10]], [, , "96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])", , , , "9601", , , [4, 5]], , , [, , , , , , , , , [-1]]], IS:[, [, , "(?:38\\d|[4-9])\\d{6}", , , , , , , [7, 9]], [, , "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-245]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|87[23])\\d{4}", 
, , , "4101234", , , [7]], [, , "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[027-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-8]\\d|9[0-3])|8(?:2[0-59]|[3469]\\d|5[1-9]|8[28]))\\d{4}", , , , "6111234"], [, , "800\\d{4}", , , , "8001234", , , [7]], [, , "90\\d{5}", , , , "9011234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "49\\d{5}", , , , "4921234", , , [7]], "IS", 354, "00|1(?:0(?:01|[12]0)|100)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], [, 
"(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "809\\d{4}", , , , "8091234", , , [7]], , , [, , "(?:689|8(?:7[0189]|80)|95[48])\\d{4}", , , , "6891234", , , [7]]], IT:[, [, , "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", , , , , , , [6, 7, 8, 9, 10, 11, 12]], [, , "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", 
, , , "0212345678", , , [6, 7, 8, 9, 10, 11]], [, , "3[1-9]\\d{8}|3[2-9]\\d{7}", , , , "3123456789", , , [9, 10]], [, , "80(?:0\\d{3}|3)\\d{3}", , , , "800123456", , , [6, 9]], [, , "(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{3}|[17])\\d{3}", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], "IT", 
39, "00", , , , , , , , [[, "(\\d{4,5})", "$1", ["1(?:0|9[246])", "1(?:0|9(?:2[2-9]|[46]))"]], [, "(\\d{6})", "$1", ["1(?:1|92)"]], [, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[245])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]], [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], [, "(\\d{3})(\\d{3})(\\d{3,4})", 
"$1 $2 $3", ["1[4679]|[38]"]], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]"]], [, "(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[245])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]], [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], 
[, "(\\d{4})(\\d{4})", "$1 $2", ["894"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1[4679]|[38]"]], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]"]], [, "(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], [, , , , , , , , , [-1]], 1, , [, , "848\\d{6}", , , , , , , [9]], [, , , , , , , , , [-1]], , , [, , "3[2-8]\\d{9,10}", 
, , , "33101234501", , , [11, 12]]], JE:[, [, , "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", , , , , , , [10], [6]], [, , "1534[0-24-8]\\d{5}", , , , "1534456789", , , , [6]], [, , "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}", , , , "7797712345"], [, , "80(?:07(?:35|81)|8901)\\d{4}", , , , "8007354567"], [, , "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}", , , , "9018105678"], [, , , , , , , , , [-1]], [, , "701511\\d{4}", , , , "7015115678"], 
[, , "56\\d{8}", , , , "5612345678"], "JE", 44, "00", "0", , , "0|([0-24-8]\\d{5})$", "1534$1", , , , , [, , "76(?:0[0-2]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}", , , , "7640123456"], , , [, , , , , , , , , [-1]], [, , "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}", , , , "5512345678"], , , [, , , , , , , , , [-1]]], JM:[, [, , "(?:[58]\\d\\d|658|900)\\d{7}", , , , , , , [10], [7]], [, , "(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:5(?:02|1[0-468]|2[35]|63)|6(?:0[1-3579]|1[0237-9]|[23]\\d|40|5[06]|6[2-589]|7[05]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}", 
, , , "8765230123", , , , [7]], [, , "(?:658295|876(?:(?:2[14-9]|[348]\\d)\\d|5(?:0[13-9]|17|[2-57-9]\\d|6[0-24-9])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}", , , , "8762101234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "JM", 1, "011", "1", , , "1", , , , , , [, , , , , , , , 
, [-1]], , "658|876", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], JO:[, [, , "900\\d{5}|(?:(?:[268]|7\\d)\\d|32|53)\\d{6}", , , , , , , [8, 9]], [, , "(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[57][023]|6[03])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:[029]0|7[08]))\\d{4}", 
, , , "62001234", , , [8]], [, , "7(?:55[0-49]|(?:7[025-9]|[89][0-25-9])\\d)\\d{5}", , , , "790123456", , , [9]], [, , "80\\d{6}", , , , "80012345", , , [8]], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , "85\\d{6}", , , , "85012345", , , [8]], [, , "70\\d{7}", , , , "700123456", , , [9]], [, , , , , , , , , [-1]], "JO", 962, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", 
["70"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [, , "74(?:66|77)\\d{5}", , , , "746612345", , , [9]], , , [, , , , , , , , , [-1]], [, , "8(?:10|8\\d)\\d{5}", , , , "88101234", , , [8]], , , [, , , , , , , , , [-1]]], JP:[, [, , "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", , , , , , , [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], [, , "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", 
, , , "312345678", , , [9]], [, , "[7-9]0[1-9]\\d{7}", , , , "9012345678", , , [10]], [, , "00(?:(?:37|66)\\d{6,13}|(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d)|(?:120|800\\d)\\d{6}", , , , "120123456"], [, , "990\\d{6}", , , , "990123456", , , [9]], [, , , , , , , , , [-1]], [, , "60\\d{7}", , , , "601234567", , , [9]], [, , "50[1-9]\\d{7}", , , , "5012345678", , , [10]], "JP", 81, "010", "0", , , "0", , , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["007", "0077", "00777", "00777[01]"]], [, "(\\d{3})(\\d{3})(\\d{3})", 
"$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [, "(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[78]|96)|477|51[24]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[78]|96[2457-9])|477|51[24]|636[2-57-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]"], 
"0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[279]|49|6[0-24-689]|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", 
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[0468][01]|[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|2[01]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|6(?:[0-24]|5[0-3589]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", 
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[0468][01]|[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|2[01]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|6(?:[0-24]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]", 
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[0468][01]|[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|2[01]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|6(?:[0-24]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], 
"0$1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[29][2-9]|5[3-9]|7[2-4679]|8(?:[246-9]|3[3-8]|5[2-9])", "[14]|[29][2-9]|5[3-9]|7[2-4679]|8(?:[246-9]|3(?:[3-6][2-9]|7|8[2-5])|5[2-9])"], "0$1"], [, "(\\d{4})(\\d{2})(\\d{3,4})", "$1-$2-$3", ["007"]], [, "(\\d{4})(\\d{2})(\\d{4})", "$1-$2-$3", ["008"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[2579]|80"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{4})(\\d{4,5})", 
"$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{5})(\\d{5,6})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{6})(\\d{6,7})", "$1-$2-$3", ["0"]]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [, "(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[78]|96)|477|51[24]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]", 
"1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[78]|96[2457-9])|477|51[24]|636[2-57-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[279]|49|6[0-24-689]|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", 
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[0468][01]|[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|2[01]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|6(?:[0-24]|5[0-3589]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", 
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[0468][01]|[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|2[01]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|6(?:[0-24]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]", 
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[0468][01]|[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|2[01]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|6(?:[0-24]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], 
"0$1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[29][2-9]|5[3-9]|7[2-4679]|8(?:[246-9]|3[3-8]|5[2-9])", "[14]|[29][2-9]|5[3-9]|7[2-4679]|8(?:[246-9]|3(?:[3-6][2-9]|7|8[2-5])|5[2-9])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[2579]|80"], "0$1"]], [, , "20\\d{8}", , , , "2012345678", , , [10]], , , [, , "00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66)\\d{6,13}"], [, , "570\\d{6}", , , , "570123456", 
, , [9]], , , [, , , , , , , , , [-1]]], KE:[, [, , "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", , , , , , , [7, 8, 9, 10]], [, , "(?:4[245]|5[2-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|51|66)\\d{6,7}", , , , "202012345", , , [7, 8, 9]], [, , "(?:1(?:0[0-2]|1[01])|7\\d\\d)\\d{6}", , , , "712123456", , , [9]], [, , "800[24-8]\\d{5,6}", , , , "800223456", , , [9, 10]], [, , "900[02-9]\\d{5}", , , , "900223456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , 
[-1]], [, , , , , , , , , [-1]], "KE", 254, "000", "0", , , "0", , , , [[, "(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KG:[, [, , "8\\d{9}|(?:[235-8]\\d|99)\\d{7}", , , , , , , [9, 10], [5, 6]], [, , "(?:3(?:1(?:[256]\\d|3[1-9]|47)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", 
, , , "312123456", , , [9], [5, 6]], [, , "8801\\d{5}|(?:2(?:0[0-35]|2\\d)|5(?:0[0-57-9]|[124-7]\\d)|7(?:[07]\\d|55)|99[05-9])\\d{6}", , , , "700123456", , , [9]], [, , "800\\d{6,7}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KG", 996, "00", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], [, "(\\d{3})(\\d{3})(\\d)(\\d{2,3})", 
"$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KH:[, [, , "1\\d{9}|[1-9]\\d{7,8}", , , , , , , [8, 9, 10], [6, 7]], [, , "23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})", , , , "23756789", , , [8, 9], [6, 7]], [, , "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", 
, , , "91234567", , , [8, 9]], [, , "1800(?:1\\d|2[019])\\d{4}", , , , "1800123456", , , [10]], [, , "1900(?:1\\d|2[09])\\d{4}", , , , "1900123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KH", 855, "00[14-9]", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , 
, , [-1]]], KI:[, [, , "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", , , , , , , [5, 8]], [, , "(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}", , , , "31234"], [, , "73140\\d{3}|(?:630[01]|730[0-5])\\d{4}|[67]200[01]\\d{3}", , , , "72001234", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", , , , "30010000", 
, , [8]], "KI", 686, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KM:[, [, , "[3478]\\d{6}", , , , , , , [7]], [, , "7[4-7]\\d{5}", , , , "7712345"], [, , "[34]\\d{6}", , , , "3212345"], [, , , , , , , , , [-1]], [, , "8\\d{6}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KM", 269, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]], 
, [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KN:[, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "869(?:2(?:29|36)|302|4(?:6[015-9]|70))\\d{4}", , , , "8692361234", , , , [7]], [, , "869(?:5(?:5[6-8]|6[5-7])|66\\d|76[02-7])\\d{4}", , , , "8697652917", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", 
, , , "5002345678"], [, , , , , , , , , [-1]], "KN", 1, "011", "1", , , "1|([2-7]\\d{6})$", "869$1", , , , , [, , , , , , , , , [-1]], , "869", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KP:[, [, , "85\\d{6}|(?:19\\d|2)\\d{7}", , , , , , , [8, 10], [6, 7]], [, , "(?:2\\d|85)\\d{6}", , , , "21234567", , , [8], [6, 7]], [, , "19[1-3]\\d{7}", , , , "1921234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , 
, , , , [-1]], [, , , , , , , , , [-1]], "KP", 850, "00|99", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KR:[, [, , "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", 
, , , , , , [5, 6, 8, 9, 10, 11, 12, 13, 14], [3, 4, 7]], [, , "(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}", , , , "22123456", , , [5, 6, 8, 9, 10], [3, 4, 7]], [, , "10[01]\\d{6}|1(?:0[2-9]|[126-9]\\d)\\d{6,7}", , , , "1020000000", , , [9, 10]], [, , "00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|80)\\d{7}", , , , "801234567", , , [9, 11, 12, 13, 14]], [, , "60[2-9]\\d{6}", , , , "602345678", , , [9]], [, , , , , , , , , [-1]], [, , "50\\d{8,9}", , , , "5012345678", 
, , [10, 11]], [, , "70\\d{8}", , , , "7012345678", , , [10]], "KR", 82, "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "0", , , "0(8(?:[1-46-8]|5\\d\\d))?", , , , [[, "(\\d{5})", "$1", ["1[016-9]1", "1[016-9]11", "1[016-9]114"], "0$1"], [, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["1"]], [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1", 
"0$CC-$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"], [, "(\\d{5})(\\d{3})(\\d{3})", "$1 $2 $3", ["003", "0030"]], [, "(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1", "0$CC-$1"], [, "(\\d{5})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{5})(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], [[, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"], 
[, "(\\d{4})(\\d{4})", "$1-$2", ["1"]], [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1", "0$CC-$1"]], [, , "15\\d{7,8}", , , , "1523456789", , , [9, 10]], , , [, , "00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})", 
, , , , , , [11, 12, 13, 14]], [, , "1(?:5(?:22|44|66|77|88|99)|6(?:[07]0|44|6[16]|88)|8(?:00|33|55|77|99))\\d{4}", , , , "15441234", , , [8]], , , [, , , , , , , , , [-1]]], KW:[, [, , "(?:18|[2569]\\d\\d)\\d{5}", , , , , , , [7, 8]], [, , "2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", , , , "22345678", , , [8]], [, , "(?:52(?:22|5[25])|6(?:222|444|70[013-9]|888|93[039])|9(?:11[01]|333|702))\\d{4}|(?:5(?:[05]\\d|1[0-7]|6[56])|6(?:0[034679]|5[015-9]|6\\d|7[67]|9[069])|9(?:0[09]|22|4[01479]|55|6[0679]|7[1-9]|8[057-9]|9\\d))\\d{5}", 
, , , "50012345", , , [8]], [, , "18\\d{5}", , , , "1801234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KW", 965, "00", , , , , , , , [[, "(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["[25]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KY:[, [, , "(?:345|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], 
[, , "345(?:2(?:22|44)|444|6(?:23|38|40)|7(?:4[35-79]|6[6-9]|77)|8(?:00|1[45]|25|[48]8)|9(?:14|4[035-9]))\\d{4}", , , , "3452221234", , , , [7]], [, , "345(?:32[1-9]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|9(?:1[67]|2[2-9]|3[689]))\\d{4}", , , , "3453231234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "(?:345976|900[2-9]\\d\\d)\\d{4}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , 
, , , , [-1]], "KY", 1, "011", "1", , , "1|([2-9]\\d{6})$", "345$1", , , , , [, , "345849\\d{4}", , , , "3458491234"], , "345", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KZ:[, [, , "33622\\d{5}|(?:7\\d|80)\\d{8}", , , , , , , [10], [5, 6]], [, , "(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}", 
, , , "7123456789", , , , [5, 6]], [, , "7(?:0[0-25-8]|47|6[02-4]|7[15-8]|85)\\d{7}", , , , "7710009998"], [, , "800\\d{7}", , , , "8001234567"], [, , "809\\d{7}", , , , "8091234567"], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567"], [, , "751\\d{7}", , , , "7511234567"], "KZ", 7, "810", "8", , , "8", , "8~10", , , , [, , , , , , , , , [-1]], , "33|7", [, , "751\\d{7}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LA:[, [, , "(?:2\\d|3)\\d{8}|(?:[235-8]\\d|41)\\d{6}", 
, , , , , , [8, 9, 10], [6]], [, , "(?:2[13]|[35-7][14]|41|8[1468])\\d{6}", , , , "21212862", , , [8], [6]], [, , "20(?:[29]\\d|5[24-689]|7[6-8])\\d{6}", , , , "2023123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LA", 856, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["3"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{3})(\\d{3})", 
"$1 $2 $3 $4", ["2"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "30\\d{7}", , , , "301234567", , , [9]], , , [, , , , , , , , , [-1]]], LB:[, [, , "[7-9]\\d{7}|[13-9]\\d{6}", , , , , , , [7, 8]], [, , "(?:(?:[14-69]\\d|8[02-9])\\d|7(?:[2-57]\\d|62|8[0-7]|9[04-9]))\\d{4}", , , , "1123456", , , [7]], [, , "(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[1-3]))\\d{5}", , , , "71123456"], [, , , , , , , , , [-1]], [, , "9[01]\\d{6}", , , , "90123456", , , [8]], [, , "80\\d{6}", 
, , , "80123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LB", 961, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LC:[, [, , "(?:[58]\\d\\d|758|900)\\d{7}", , , , , , , [10], [7]], [, , "758(?:4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|638)\\d{4}", 
, , , "7584305678", , , , [7]], [, , "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[01]))\\d{4}", , , , "7582845678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "LC", 1, "011", "1", , , "1|([2-7]\\d{6})$", "758$1", , , , , [, , , , , , , , , [-1]], , "758", [, , , , , , , , , 
[-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LI:[, [, , "90\\d{5}|(?:[2378]|6\\d\\d)\\d{6}", , , , , , , [7, 9]], [, , "(?:2(?:01|1[27]|22|3\\d|6[02-578]|96)|3(?:33|40|7[0135-7]|8[048]|9[0269]))\\d{4}", , , , "2345678", , , [7]], [, , "756\\d{4}|(?:6(?:499|5[0-3]\\d|6(?:0[0-7]|10|2[06-9]|39))|7[37-9])\\d{5}", , , , "660234567"], [, , "80(?:02[28]|9\\d\\d)\\d\\d", , , , "8002222", , , [7]], [, , "90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", , , , "9002222", , , [7]], [, , , , , , 
, , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LI", 423, "00", "0", , , "0|(10(?:01|20|66))", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[237-9]"], , "$CC $1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "870(?:28|87)\\d\\d", , , , "8702812", , , [7]], , , [, , "697(?:56|[78]\\d)\\d{4}", , , , "697861234", , , [9]]], LK:[, 
[, , "(?:[1-7]\\d|[89]1)\\d{7}", , , , , , , [9], [7]], [, , "(?:[189]1|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}", , , , "112345678", , , , [7]], [, , "7[0-25-8]\\d{7}", , , , "712345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LK", 94, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], , [, , , , 
, , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "1973\\d{5}", , , , "197312345"], , , [, , , , , , , , , [-1]]], LR:[, [, , "(?:2|33|5\\d|77|88)\\d{7}|[45]\\d{6}", , , , , , , [7, 8, 9]], [, , "(?:2\\d{3}|33333)\\d{4}", , , , "21234567", , , [8, 9]], [, , "(?:(?:330|555|(?:77|88)\\d)\\d|4[67])\\d{5}|5\\d{6}", , , , "770123456", , , [7, 9]], [, , , , , , , , , [-1]], [, , "332(?:02|[34]\\d)\\d{4}", , , , "332021234", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , 
, , [-1]], "LR", 231, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[45]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3578]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LS:[, [, , "(?:[256]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "2\\d{7}", , , , "22123456"], [, , "[56]\\d{7}", , , , "50123456"], [, , "800[256]\\d{4}", , , 
, "80021234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LS", 266, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LT:[, [, , "(?:[3469]\\d|52|[78]0)\\d{6}", , , , , , , [8]], [, , "(?:3[1478]|4[124-6]|52)\\d{6}", , , , "31234567"], [, , "6\\d{7}", , , , "61234567"], [, , "800\\d{5}", , , , "80012345"], 
[, , "9(?:0[0239]|10)\\d{5}", , , , "90012345"], [, , "808\\d{5}", , , , "80812345"], [, , "700\\d{5}", , , , "70012345"], [, , , , , , , , , [-1]], "LT", 370, "00", "8", , , "[08]", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-79]"], "(8-$1)", , 1], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", , 1], [, "(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", , 1], [, "(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", , 1]], , [, , , , , , , , , [-1]], , , [, , , , 
, , , , , [-1]], [, , "70[67]\\d{5}", , , , "70712345"], , , [, , , , , , , , , [-1]]], LU:[, [, , "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11]], [, , "(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}", , , , "27123456"], [, , "6(?:[269][18]|5[158]|7[189]|81)\\d{6}", , , , "628123456", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "90[015]\\d{5}", , , , "90012345", , , [8]], 
[, , "801\\d{5}", , , , "80112345", , , [8]], [, , , , , , , , , [-1]], [, , "20(?:1\\d{5}|[2-689]\\d{1,7})", , , , "20201234", , , [4, 5, 6, 7, 8, 9, 10]], "LU", 352, "00", , , , "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{3})", 
"$1 $2 $3", ["20[2-689]"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", 
["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LV:[, [, , "(?:[268]\\d|90)\\d{6}", , , , , , , [8]], [, , "6\\d{7}", , , , "63123456"], [, , "2\\d{7}", , , , "21234567"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , "81\\d{6}", , , , "81123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LV", 371, "00", , , , , , , , [[, 
"(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LY:[, [, , "(?:[2569]\\d|71)\\d{7}", , , , , , , [9], [7]], [, , "(?:2[13-5]|5[1347]|6[1-479]|71)\\d{7}", , , , "212345678", , , , [7]], [, , "9[1-6]\\d{7}", , , , "912345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LY", 218, "00", "0", 
, , "0", , , , [[, "(\\d{2})(\\d{7})", "$1-$2", ["[25-79]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MA:[, [, , "[5-8]\\d{8}", , , , , , , [9]], [, , "5(?:29|38)[89]0\\d{4}|5(?:2(?:[015-7]\\d|2[2-9]|3[2-57]|4[2-46-8]|8[235-7]|90)|3(?:[0-4]\\d|[57][2-9]|6[2-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}", , , , "520123456"], [, , "692[12]\\d{5}|(?:6(?:[0-7]\\d|8[0-247-9]|9[013-9])|7(?:0[06-8]|6[1267]|7[0-27]))\\d{6}", , 
, , "650123456"], [, , "80\\d{7}", , , , "801234567"], [, , "89\\d{7}", , , , "891234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "5924[0-2]\\d{4}", , , , "592401234"], "MA", 212, "00", "0", , , "0", , , , [[, "(\\d{5})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29|38)[89]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], [, "(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|892"], "0$1"], [, "(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], [, "(\\d{3})(\\d{6})", 
"$1-$2", ["[5-7]"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MC:[, [, , "870\\d{5}|(?:[349]|6\\d)\\d{7}", , , , , , , [8, 9]], [, , "(?:870|9[2-47-9]\\d)\\d{5}", , , , "99123456", , , [8]], [, , "4(?:4\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}", , , , "612345678"], [, , "90\\d{6}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MC", 377, 
"00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[39]"]], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[39]"]], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], [, , , , , , , , , [-1]], 
, , [, , "870\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MD:[, [, , "(?:[235-7]\\d|[89]0)\\d{6}", , , , , , , [8]], [, , "(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}", , , , "22212345"], [, , "(?:562|6\\d\\d|7(?:[189]\\d|6[07]|7[457-9]))\\d{5}", , , , "62112345"], [, , "800\\d{5}", , , , "80012345"], [, , "90[056]\\d{5}", , , , "90012345"], [, , "808\\d{5}", , , , "80812345"], [, , , , , , , , , [-1]], [, , "3[08]\\d{6}", , , , "30123456"], "MD", 373, "00", 
"0", , , "0", , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "803\\d{5}", , , , "80312345"], , , [, , , , , , , , , [-1]]], ME:[, [, , "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", , , , , , , [8, 9], [6]], [, , "(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:[01][2467]|2[2-467]))\\d{5}", , , , "30234567", 
, , [8], [6]], [, , "6(?:00|3[024]|6[0-25]|[7-9]\\d)\\d{5}", , , , "67622901", , , [8]], [, , "80(?:[0-2578]|9\\d)\\d{5}", , , , "80080002"], [, , "9(?:4[1568]|5[178])\\d{5}", , , , "94515151", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "78[1-49]\\d{5}", , , , "78108780", , , [8]], "ME", 382, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "77[1-9]\\d{5}", , , , "77273012", 
, , [8]], , , [, , , , , , , , , [-1]]], MF:[, [, , "(?:590|69\\d)\\d{6}", , , , , , , [9]], [, , "590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}", , , , "590271234"], [, , "69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}", , , , "690001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MF", 590, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , 
, , , , , , [-1]]], MG:[, [, , "[23]\\d{8}", , , , , , , [9], [7]], [, , "2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[35]|8[268]|9[245])\\d{5}", , , , "202123456", , , , [7]], [, , "3[2-49]\\d{7}", , , , "321234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "22\\d{7}", , , , "221234567"], "MG", 261, "00", "0", , , "0|([24-9]\\d{6})$", "20$1", , , [[, "(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], , [, 
, , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MH:[, [, , "329\\d{4}|(?:[256]\\d|45)\\d{5}", , , , , , , [7]], [, , "(?:247|528|625)\\d{4}", , , , "2471234"], [, , "(?:(?:23|54)5|329|45[56])\\d{4}", , , , "2351234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "635\\d{4}", , , , "6351234"], "MH", 692, "011", "1", , , "1", , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], 
, [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MK:[, [, , "[2-578]\\d{7}", , , , , , , [8], [6, 7]], [, , "(?:2(?:[23]\\d|5[0-24578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}", , , , "22012345", , , , [6, 7]], [, , "7(?:(?:[0-25-8]\\d|3[2-4]|9[23])\\d|4(?:21|60))\\d{4}", , , , "72345678"], [, , "800\\d{5}", , , , "80012345"], [, , "5[02-9]\\d{6}", , , , "50012345"], 
[, , "8(?:0[1-9]|[1-9]\\d)\\d{5}", , , , "80123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MK", 389, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ML:[, [, , "(?:[246-9]\\d|50)\\d{6}", , , , , , , [8]], 
[, , "2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}", , , , "20212345"], [, , "2(?:079|17\\d)\\d{4}|(?:50|[679]\\d|8[239])\\d{6}", , , , "65012345"], [, , "80\\d{6}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ML", 223, "00", , , , , , , , [[, "(\\d{4})", "$1", ["67[057-9]|74[045]", "67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], 
[[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], [, , , , , , , , , [-1]], , , [, , "80\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MM:[, [, , "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", , , , , , , [6, 7, 8, 9, 10], [5]], [, , "(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[2-469]|39|46|6[25]|7[0-3]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|2[246]|39|46|62|7[0-3]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[0-3])|3(?:20\\d|4(?:70|83)|56)|420\\d|5470)|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|247[23]|3(?:20\\d|470)|4(?:2[04]\\d|47[23])|7(?:(?:3\\d|8[01459])\\d|4(?:39|60|7[013]))))\\d{4}|5(?:2(?:2\\d{5,6}|47[023]\\d{4})|(?:347[23]|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[0-2])|8(?:20\\d|47[02])|9(?:20\\d|47[01]))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:2\\d|4[1-9]|51)\\d|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|[35]2\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}", 
, , , "1234567", , , [6, 7, 8, 9], [5]], [, , "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|6[7-9]\\d|7(?:3|[5-9]\\d)|8(?:8[7-9]|9\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6]|9(?:[089]|[5-7]\\d\\d))\\d)\\d{4}|9[69]1\\d{6}|9[68]\\d{6}", , , , "92123456", , , [7, 8, 9, 10]], [, , "80080(?:[01][1-9]|2\\d)\\d{3}", , , , "8008001234", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "1333\\d{4}|[12]468\\d{4}", , , , "13331234", , , [8]], "MM", 
95, "00", "0", , , "0", , , , [[, "(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], [, "(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", 
"$1 $2 $3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], [, "(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MN:[, [, , "[12]\\d{7,9}|[57-9]\\d{7}", , , , , , , [8, 9, 10], [4, 5, 6]], [, , "[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}|(?:11(?:3\\d|4[568])|(?:(?:21|5[0568])\\d|70[0-5])\\d)\\d{4}|[12]2(?:[1-3]\\d{5,6}|7\\d{6})", , , , "50123456", , 
, , [4, 5, 6]], [, , "(?:8(?:[05689]\\d|3[01])|9(?:[014-9]\\d|20|3[0-4]))\\d{5}", , , , "88123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "7(?:100|5(?:0[0579]|1[015]|[389]5|[57][57])|(?:6[0167]|7\\d|8[01])\\d)\\d{4}", , , , "75153456", , , [8]], "MN", 976, "001", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[57-9]"]], [, "(\\d{3})(\\d{5,6})", "$1 $2", 
["[12]2[1-3]"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MO:[, [, , "(?:28|[68]\\d)\\d{6}", , , , , , , [8]], [, , "(?:28[2-57-9]|8(?:11|[2-57-9]\\d))\\d{5}", , , , "28212345"], [, , "6(?:[2356]\\d\\d|8(?:[02][5-9]|[1478]\\d|[356][0-4]))\\d{4}", 
, , , "66123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MO", 853, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MP:[, [, , "[58]\\d{9}|(?:67|90)0\\d{7}", , , , , , , [10], [7]], [, , "670(?:2(?:3[3-7]|56|8[5-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", 
, , , "6702345678", , , , [7]], [, , "670(?:2(?:3[3-7]|56|8[5-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", , , , "6702345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "MP", 1, "011", "1", , , "1|([2-9]\\d{6})$", "670$1", , 1, , , [, , , , , , , , , [-1]], , 
"670", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MQ:[, [, , "(?:596|69\\d)\\d{6}", , , , , , , [9]], [, , "596(?:0[0-7]|10|2[7-9]|3[05-9]|4[0-46-8]|[5-7]\\d|8[09]|9[4-8])\\d{4}", , , , "596301234"], [, , "69(?:6(?:[0-47-9]\\d|5[0-6]|6[0-4])|727)\\d{4}", , , , "696201234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MQ", 596, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", 
"$1 $2 $3 $4", ["[56]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MR:[, [, , "(?:[2-4]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "(?:25[08]|35\\d|45[1-7])\\d{5}", , , , "35123456"], [, , "[2-4][0-46-9]\\d{6}", , , , "22123456"], [, , "800\\d{5}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MR", 222, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", 
"$1 $2 $3 $4", ["[2-48]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MS:[, [, , "66449\\d{5}|(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "664491\\d{4}", , , , "6644912345", , , , [7]], [, , "66449[2-6]\\d{4}", , , , "6644923456", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", 
, , , "5002345678"], [, , , , , , , , , [-1]], "MS", 1, "011", "1", , , "1|(4\\d{6})$", "664$1", , , , , [, , , , , , , , , [-1]], , "664", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MT:[, [, , "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "2(?:0(?:[19]\\d|3[1-4]|6[059])|[1-357]\\d\\d)\\d{4}", , , , "21001234"], [, , "(?:7(?:210|[79]\\d\\d)|9(?:2(?:1[01]|31)|69[67]|8(?:1[1-3]|89|97)|9\\d\\d))\\d{4}", , , , "96961234"], [, , "800[3467]\\d{4}", 
, , , "80071234"], [, , "5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}", , , , "50037123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3550\\d{4}", , , , "35501234"], "MT", 356, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], , [, , "7117\\d{4}", , , , "71171234"], , , [, , , , , , , , , [-1]], [, , "501\\d{5}", , , , "50112345"], , , [, , , , , , , , , [-1]]], MU:[, [, , "(?:[2-468]|5\\d)\\d{6}", , , , , , , [7, 8]], [, , "(?:2(?:[03478]\\d|1[0-7]|6[0-79])|4(?:[013568]\\d|2[4-7])|54(?:[34]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", 
, , , "54480123"], [, , "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|5(?:2[589]|4[3489]|7\\d|8[0-689]|9[0-8])\\d{5}", , , , "52512345", , , [8]], [, , "80[0-2]\\d{4}", , , , "8001234", , , [7]], [, , "30\\d{5}", , , , "3012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3(?:20|9\\d)\\d{4}", , , , "3201234", , , [7]], "MU", 230, "0(?:0|[24-7]0|3[03])", , , , , , "020", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["5"]]], , [, , , , 
, , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MV:[, [, , "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", , , , , , , [7, 10]], [, , "(?:3(?:0[0-3]|3[0-59])|6(?:[57][02468]|6[024-68]|8[024689]))\\d{4}", , , , "6701234", , , [7]], [, , "46[46]\\d{4}|(?:7[2-9]|9[13-9])\\d{5}", , , , "7712345", , , [7]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], "MV", 960, "0(?:0|19)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[3467]|9[13-9]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "4[05]0\\d{4}", , , , "4001234", , , [7]], , , [, , , , , , , , , [-1]]], MW:[, [, , "1\\d{6}(?:\\d{2})?|(?:[23]1|77|88|99)\\d{7}", , , , , , , [7, 9]], [, , "(?:1[2-9]|21\\d\\d)\\d{5}", , , , "1234567"], [, , "111\\d{6}|(?:77|88|99)\\d{7}", , , , "991234567", 
, , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "31\\d{7}", , , , "310123456", , , [9]], "MW", 265, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[17-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MX:[, [, , "(?:1(?:[01467]\\d|[2359][1-9]|8[1-79])|[2-9]\\d)\\d{8}", , , , , , , [10, 11], [7, 8]], [, , "(?:2(?:0[01]|2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7}", 
, , , "2001234567", , , [10], [7, 8]], [, , "(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7}", 
, , , "12221234567", , , , [7, 8]], [, , "8(?:00|88)\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , "300\\d{7}", , , , "3001234567", , , [10]], [, , "500\\d{7}", , , , "5001234567", , , [10]], [, , , , , , , , , [-1]], "MX", 52, "0[09]", "01", , , "0(?:[12]|4[45])|1", , "00", , [[, "(\\d{5})", "$1", ["53"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], , , 1], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", 
"$2 $3 $4", ["1(?:33|5[56]|81)"], , , 1], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], , , 1]], [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], , , 1], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], , , 1], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], , , 1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MY:[, [, 
, "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", , , , , , , [8, 9, 10], [6, 7]], [, , "(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}", , , , "323856789", , , [8, 9], [6, 7]], [, , "1(?:4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:0[3-9]|1[01]))|(?:[2379][2-9]|4[235-9]|(?:59|6)\\d)\\d|8(?:1[23]|[236]\\d|4[06]|5[7-9]|7[016-9]|8[01]|9[0-8]))\\d{5}", 
, , , "123456789", , , [9, 10]], [, , "1[378]00\\d{6}", , , , "1300123456", , , [10]], [, , "1600\\d{6}", , , , "1600123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "154(?:6(?:0\\d|1[0-3])|8(?:[25]1|4[0189]|7[0-4679]))\\d{4}", , , , "1546012345", , , [10]], "MY", 60, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[37][2-9]|8[1-9])|8"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", 
"$1-$2 $3", ["3"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1[36-8]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MZ:[, [, , "(?:2|8\\d)\\d{7}", , , , , , , [8, 9]], [, , "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", , , , "21123456", , , [8]], [, , "8[2-7]\\d{7}", , , , "821234567", , , [9]], 
[, , "800\\d{6}", , , , "800123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MZ", 258, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-7]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NA:[, [, , "[68]\\d{7,8}", , , , , , , [8, 9]], [, , "6(?:1(?:[02-4]\\d\\d|17)|2(?:17|54\\d|69|70)|3(?:17|2[0237]\\d|34|6[289]|7[01]|81)|4(?:17|(?:27|41|5[25])\\d|69|7[01])|5(?:17|2[236-8]\\d|69|7[01])|6(?:17|26\\d|38|42|69|7[01])|7(?:17|(?:2[2-4]|30)\\d|6[89]|7[01]))\\d{4}|6(?:1(?:2[2-7]|3[01378]|4[0-4]|69|7[014])|25[0-46-8]|32\\d|4(?:2[0-27]|4[016]|5[0-357])|52[02-9]|62[56]|7(?:2[2-69]|3[013]))\\d{4}", 
, , , "61221234"], [, , "(?:60|8[1245])\\d{7}", , , , "811234567", , , [9]], [, , "80\\d{7}", , , , "800123456", , , [9]], [, , "8701\\d{5}", , , , "870123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8(?:3\\d\\d|86)\\d{5}", , , , "88612345"], "NA", 264, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", 
"$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NC:[, [, , "[2-57-9]\\d{5}", , , , , , , [6]], [, , "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}", , , , "201234"], [, , "(?:5[0-4]|[79]\\d|8[0-79])\\d{4}", , , , "751234"], [, , , , , , , , , [-1]], [, , "36\\d{4}", , , , "366711"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NC", 687, "00", , , , , , , , [[, "(\\d{3})", "$1", ["5[6-8]"]], 
[, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[2-57-9]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[2-57-9]"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NE:[, [, , "[0289]\\d{7}", , , , , , , [8]], [, , "2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}", , , , "20201234"], [, , "(?:8[014589]|9\\d)\\d{6}", , , , "93123456"], [, , "08\\d{6}", , , , "08123456"], [, , "09\\d{6}", 
, , , "09123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NE", 227, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[01]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NF:[, [, , "[13]\\d{5}", , , , , , , [6], [5]], [, , "(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}", , , , "106609", , , , [5]], [, , "3[58]\\d{4}", 
, , , "381234", , , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NF", 672, "00", , , , "([0-258]\\d{4})$", "3$1", , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["1"]], [, "(\\d)(\\d{5})", "$1 $2", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NG:[, [, , "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", , , , , , , [7, 8, 10, 11, 12, 
13, 14], [5, 6]], [, , "(?:(?:[1-356]\\d|4[02-8]|7[0-79]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[0-3578])\\d{5}", , , , "18040123", , , [7, 8], [5, 6]], [, , "(?:707[0-3]|8(?:01|19)[01])\\d{6}|(?:70[1-689]|8(?:0[2-9]|1[0-8])|90[1-35-9])\\d{7}", , , , "8021234567", , , [10]], [, , "800\\d{7,11}", , , , "80017591759", , , [10, 11, 12, 13, 14]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NG", 234, "009", 
"0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], [, "(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "700\\d{7,11}", , 
, , "7001234567", , , [10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]]], NI:[, [, , "(?:1800|[25-8]\\d{3})\\d{4}", , , , , , , [8]], [, , "2\\d{7}", , , , "21234567"], [, , "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}", , , , "81234567"], [, , "1800\\d{4}", , , , "18001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NI", 505, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], 
, [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NL:[, [, , "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}", , , , , , , [5, 6, 7, 8, 9, 10]], [, , "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}", , , , "101234567", 
, , [9]], [, , "6[1-58]\\d{7}", , , , "612345678", , , [9]], [, , "800\\d{4,7}", , , , "8001234", , , [7, 8, 9, 10]], [, , "90[069]\\d{4,7}", , , , "9061234", , , [7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:85|91)\\d{7}", , , , "851234567", , , [9]], "NL", 31, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["1[238]|[34]"]], [, "(\\d{2})(\\d{3,4})", "$1 $2", ["14"]], [, "(\\d{6})", "$1", ["1"]], [, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", 
"$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-57-9]"], "0$1"]], [[, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", 
"$1 $2 $3", ["[1-57-9]"], "0$1"]], [, , "66\\d{7}", , , , "662345678", , , [9]], , , [, , "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d", , , , , , , [5, 6]], [, , "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", , , , "14020", , , [5, 6, 9]], , , [, , , , , , , , , [-1]]], NO:[, [, , "(?:0|[2-9]\\d{3})\\d{4}", , , , , , , [5, 8]], [, , "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", 
, , , "21234567", , , [8]], [, , "(?:4[015-8]|5[89]|9\\d)\\d{6}", , , , "40612345", , , [8]], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "NO", 47, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[489]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-7]"]]], 
, [, , , , , , , , , [-1]], 1, "[02-689]|7[0-8]", [, , , , , , , , , [-1]], [, , "(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", , , , "02000"], , , [, , "81[23]\\d{5}", , , , "81212345", , , [8]]], NP:[, [, , "9\\d{9}|[1-9]\\d{7}", , , , , , , [8, 10], [6, 7]], [, , "1[0-6]\\d{6}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-79])[2-6]\\d{5}", , , , "14567890", , , [8], [6, 7]], [, , "9(?:6[0-3]|7[245]|8[0-24-68])\\d{7}", , , , "9841234567", , , [10]], [, , , , , , , , , 
[-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NP", 977, "00", "0", , , "0", , , , [[, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [, "(\\d{2})(\\d{6})", "$1-$2", ["[1-8]|9(?:[1-579]|6[2-6])"], "0$1"], [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NR:[, [, , "(?:444|55\\d|888)\\d{4}", , , , , , , [7]], [, , "(?:444|888)\\d{4}", 
, , , "4441234"], [, , "55[4-9]\\d{4}", , , , "5551234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NR", 674, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[458]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NU:[, [, , "(?:[47]|888\\d)\\d{3}", , , , , , , [4, 7]], [, , "[47]\\d{3}", , , , "7012", , , [4]], [, , "888[4-9]\\d{3}", 
, , , "8884012", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NU", 683, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NZ:[, [, , "[28]\\d{7,9}|[346]\\d{7}|(?:508|[79]\\d)\\d{6,7}", , , , , , , [8, 9, 10], [7]], [, , "24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", 
, , , "32345678", , , [8], [7]], [, , "2[0-28]\\d{8}|2[0-27-9]\\d{7}|21\\d{6}", , , , "211234567"], [, , "508\\d{6,7}|80\\d{6,8}", , , , "800123456"], [, , "90\\d{6,7}", , , , "900123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , "70\\d{7}", , , , "701234567", , , [9]], [, , , , , , , , , [-1]], "NZ", 64, "0(?:0|161)", "0", , , "0", , "00", , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", 
"$1 $2 $3", ["2(?:10|74)|[59]|80"], "0$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["2[028]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7|86"], "0$1"]], , [, , "[28]6\\d{6,7}", , , , "26123456", , , [8, 9]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], OM:[, [, , "(?:[279]\\d{3}|500)\\d{4}|8007\\d{4,5}", , , , , , , [7, 8, 9]], [, , "2[2-6]\\d{6}", , , , "23123456", , , [8]], [, , "90[1-9]\\d{5}|(?:7[129]|9[1-9])\\d{6}", 
, , , "92123456", , , [8]], [, , "500\\d{4}|8007\\d{4,5}", , , , "80071234"], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "OM", 968, "00", , , , , , , , [[, "(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], [, "(\\d{2})(\\d{6})", "$1 $2", ["2"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[79]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PA:[, [, , "(?:[1-57-9]|6\\d)\\d{6}", 
, , , , , , [7, 8]], [, , "(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|[68][58]|7[0167]|9[39])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[026-9])|3(?:[089]\\d|1[014-7]|2[0-35]|33|4[0-579]|55|6[068]|7[06-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[05]|7[0-24-9]|8[7-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}", , , , "2001234", , , [7]], [, , "(?:1[16]1|21[89]|6(?:[02-9]\\d|1[0-6])\\d|8(?:1[01]|7[23]))\\d{4}", 
, , , "61234567"], [, , "800\\d{4}", , , , "8001234", , , [7]], [, , "(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", , , , "8601234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PA", 507, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["6"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PE:[, [, , "(?:[14-8]|9\\d)\\d{7}", , , , , , 
, [8, 9], [6, 7]], [, , "19(?:[02-68]\\d|1[035-9]|7[0-689]|9[1-9])\\d{4}|(?:1[0-8]|4[1-4]|5[1-46]|6[1-7]|7[2-46]|8[2-4])\\d{6}", , , , "11234567", , , [8], [6, 7]], [, , "9\\d{8}", , , , "912345678", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "805\\d{5}", , , , "80512345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , "80[24]\\d{5}", , , , "80212345", , , [8]], [, , , , , , , , , [-1]], "PE", 51, "19(?:1[124]|77|90)00", "0", " Anexo ", , "0", , , , [[, "(\\d{3})(\\d{5})", 
"$1 $2", ["80"], "(0$1)"], [, "(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PF:[, [, , "[48]\\d{7}|4\\d{5}", , , , , , , [6, 8]], [, , "4(?:[09][4-689]\\d|4)\\d{4}", , , , "40412345"], [, , "8[7-9]\\d{6}", , , , "87123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PF", 689, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[48]"]]], , [, , , , , , , , , [-1]], , , [, , "44\\d{4}", , , , , , , [6]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PG:[, [, , "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", , , , , , , [7, 8]], [, , "(?:64[1-9]|7730|85[02-46-9])\\d{4}|(?:3[0-2]|4[257]|5[34]|77[0-24]|9[78])\\d{5}", 
, , , "3123456"], [, , "775\\d{5}|(?:7[0-689]|81)\\d{6}", , , , "70123456", , , [8]], [, , "180\\d{4}", , , , "1801234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "2(?:0[0-47]|7[568])\\d{4}", , , , "2751234", , , [7]], "PG", 675, "00|140[1-3]", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, 
, , , , , , , , [-1]]], PH:[, [, , "1800\\d{7,9}|(?:2|[89]\\d{4})\\d{5}|[2-8]\\d{8}|[28]\\d{7}", , , , , , , [6, 8, 9, 10, 11, 12, 13], [4, 5, 7]], [, , "(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|2\\d{5}(?:\\d{2})?|8[2-8]\\d{7}", , , , "21234567", , , [6, 8, 9, 10], [4, 5, 7]], [, , "(?:81[37]|9(?:0[5-9]|1[0-24-9]|2[0-35-9]|[35]\\d|4[235-9]|6[0-25-8]|7[1-9]|8[19]|9[4-9]))\\d{7}", , , , "9051234567", , , [10]], [, , "1800\\d{7,9}", , , , "180012345678", , 
, [11, 12, 13]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PH", 63, "00", "0", , , "0", , , , [[, "(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], [, "(\\d{5})(\\d{4})", 
"$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PK:[, 
[, , "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[025-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", , , , , , , [8, 9, 10, 11, 12], [5, 6, 7]], [, , "(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", , , , "2123456789", , , 
[9, 10], [5, 6, 7, 8]], [, , "3(?:[014]\\d|2[0-5]|3[0-7]|55|64)\\d{7}", , , , "3012345678", , , [10]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , , , , , , , , [-1]], [, , "122\\d{6}", , , , "122044444", , , [9]], [, , , , , , , , , [-1]], "PK", 92, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["[89]0"], "0$1"], [, "(\\d{4})(\\d{5})", "$1 $2", ["1"]], [, "(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], 
"(0$1)"], [, "(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], [, "(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", 
"$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}", , , , "21111825888", , , [11, 12]], , , [, , , , , , , , , [-1]]], 
PL:[, [, , "[1-57-9]\\d{6}(?:\\d{2})?|6\\d{5,8}", , , , , , , [6, 7, 8, 9]], [, , "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", , , , "123456789", , , [7, 9]], [, , "(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", , , , "512345678", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "70[01346-8]\\d{6}", , , , "701234567", , , [9]], [, , "801\\d{6}", , , , "801234567", , , [9]], [, , , , , , , , , [-1]], [, 
, "39\\d{7}", , , , "391234567", , , [9]], "PL", 48, "00", , , , , , , , [[, "(\\d{5})", "$1", ["19"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["11|64"]], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["39|45|5[0137]|6[0469]|7[02389]|8[08]"]], [, 
"(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-8]|9[145]"]]], , [, , "64\\d{4,7}", , , , "641234567"], , , [, , , , , , , , , [-1]], [, , "804\\d{6}", , , , "804123456", , , [9]], , , [, , , , , , , , , [-1]]], PM:[, [, , "[45]\\d{5}", , , , , , , [6]], [, , "(?:4[1-3]|50)\\d{4}", , , , "430123"], [, , "(?:4[02-4]|5[05])\\d{4}", , , , "551234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PM", 508, 
"00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PR:[, [, , "(?:[589]\\d\\d|787)\\d{7}", , , , , , , [10], [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], 
[, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "PR", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "787|939", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PS:[, [, , "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", , , , , , , [8, 9, 10], [7]], [, , "(?:22[2-47-9]|42[45]|82[01458]|92[369])\\d{5}", , , , "22234567", , , [8], [7]], [, , "5[69]\\d{7}", , , , "599123456", , , [9]], [, , "1800\\d{6}", 
, , , "1800123456", , , [10]], [, , , , , , , , , [-1]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PS", 970, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PT:[, [, , "(?:[26-9]\\d|30)\\d{7}", 
, , , , , , [9]], [, , "2(?:[12]\\d|[35][1-689]|4[1-59]|6[1-35689]|7[1-9]|8[1-69]|9[1256])\\d{6}", , , , "212345678"], [, , "9(?:[1-36]\\d\\d|480)\\d{5}", , , , "912345678"], [, , "80[02]\\d{6}", , , , "800123456"], [, , "(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}", , , , "760123456"], [, , "80(?:8\\d|9[1579])\\d{5}", , , , "808123456"], [, , "884[0-4689]\\d{5}", , , , "884123456"], [, , "30\\d{7}", , , , "301234567"], "PT", 351, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{4})", 
"$1 $2 $3", ["2[12]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "70(?:7\\d|8[17])\\d{5}", , , , "707123456"], , , [, , "600\\d{6}", , , , "600110000"]], PW:[, [, , "(?:[25-8]\\d\\d|345|488|900)\\d{4}", , , , , , , [7]], [, , "(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}", , , , "2771234"], [, , "(?:6[2-4689]0|77\\d|88[0-4])\\d{4}", , , , "6201234"], [, , , , , , , , , [-1]], [, 
, , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PW", 680, "01[12]", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PY:[, [, , "59\\d{4,6}|(?:[2-46-9]\\d|5[0-8])\\d{4,7}", , , , , , , [6, 7, 8, 9], [5]], [, , "(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-46-8])|7(?:4[0-4]|6[1-578]|75|8[0-8])|858)\\d{5,6}", 
, , , "212345678", , , [7, 8, 9], [5, 6]], [, , "9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}", , , , "961456789", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8700[0-4]\\d{4}", , , , "870012345", , , [9]], "PY", 595, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6[347]|7[46-8]|85"], 
"(0$1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["9"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "[2-9]0\\d{4,7}", , , , "201234567"], , , [, , , , , , , , , [-1]]], QA:[, [, , "800\\d{4}|(?:2|[3-7]\\d)\\d{6}", , , , , , , [7, 8]], [, , "4[04]\\d{6}", , , , "44123456", 
, , [8]], [, , "[35-7]\\d{7}", , , , "33123456", , , [8]], [, , "800\\d{4}", , , , "8001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "QA", 974, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["2[126]|8"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], , [, , "2(?:[12]\\d|61)\\d{4}", , , , "2123456", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], RE:[, [, , "(?:26|[68]\\d)\\d{7}", 
, , , , , , [9]], [, , "262\\d{6}", , , , "262161234"], [, , "69(?:2\\d\\d|3(?:0[0-46]|1[013]|2[0-2]|3[0-39]|4\\d|5[05]|6[0-26]|7[0-27]|8[0-8]|9[0-479]))\\d{4}", , , , "692123456"], [, , "80\\d{7}", , , , "801234567"], [, , "89[1-37-9]\\d{6}", , , , "891123456"], [, , "8(?:1[019]|2[0156]|84|90)\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RE", 262, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[268]"], "0$1"]], , [, , , , , 
, , , , [-1]], 1, "262|69|8", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], RO:[, [, , "(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}", , , , , , , [6, 9]], [, , "[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d", , , , "211234567"], [, , "7120\\d{5}|7(?:[02-7]\\d|1[01]|8[03-8]|99)\\d{6}", , , , "712034567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "90[036]\\d{6}", , , , "900123456", , , [9]], [, , "801\\d{6}", , , , "801123456", , , [9]], [, 
, , , , , , , , [-1]], [, , , , , , , , , [-1]], "RO", 40, "00", "0", " int ", , "0", , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], [, "(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[237-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "37\\d{7}", , , , "372123456", , , [9]], , , [, , , , , , , , , [-1]]], RS:[, [, , "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", 
, , , , , , [6, 7, 8, 9, 10, 11, 12], [4, 5]], [, , "(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", , , , "10234567", , , [7, 8, 9, 10, 11, 12], [4, 5, 6]], [, , "6(?:[0-689]|7\\d)\\d{6,7}", , , , "601234567", , , [8, 9, 10]], [, , "800\\d{3,9}", , , , "80012345"], [, , "(?:78\\d|90[0169])\\d{3,7}", , , , "90012345", , , [6, 7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RS", 381, "00", "0", , , "0", 
, , , [[, "(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], [, "(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7[06]\\d{4,10}", , , , "700123456"], , , [, , , , , , , , , [-1]]], RU:[, [, , "[347-9]\\d{9}", , , , , , , [10], [7]], [, , "(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}", , , , "3011234567", 
, , , [7]], [, , "9\\d{9}", , , , "9123456789"], [, , "80[04]\\d{7}", , , , "8001234567"], [, , "80[39]\\d{7}", , , , "8091234567"], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567"], [, , , , , , , , , [-1]], "RU", 7, "810", "8", , , "8", , "8~10", , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1-$2-$3", ["[0-79]"]], [, "(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], 
"8 ($1)", , 1], [, "(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[3489]"], 
"8 ($1)", , 1]], [[, "(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", , 1], [, "(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], 
"8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[3489]"], "8 ($1)", , 1]], [, , , , , , , , , [-1]], 1, "3[04-689]|[489]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], RW:[, [, , "(?:06|[27]\\d\\d|[89]00)\\d{6}", , , , , , , [8, 9]], [, , "(?:06|2[258]\\d)\\d{6}", , , , "250123456"], [, , "7[238]\\d{7}", , , , "720123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , 
, [9]], [, , "900\\d{6}", , , , "900123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RW", 250, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SA:[, [, , "92\\d{7}|(?:[15]|8\\d)\\d{8}", 
, , , , , , [9, 10], [7]], [, , "1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", , , , "112345678", , , [9], [7]], [, , "5(?:[013-689]\\d|7[0-36-8])\\d{6}", , , , "512345678", , , [9]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "925\\d{6}", , , , "925012345", , , [9]], [, , "920\\d{6}", , , , "920012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SA", 966, "00", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["9"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", 
["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "811\\d{7}", , , , "8110123456", , , [10]], , , [, , , , , , , , , [-1]]], SB:[, [, , "(?:[1-6]|[7-9]\\d\\d)\\d{4}", , , , , , , [5, 7]], [, , "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", , , , "40123", , , [5]], [, , "48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}", 
, , , "7421234"], [, , "1[38]\\d{3}", , , , "18123", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "5[12]\\d{3}", , , , "51123", , , [5]], "SB", 677, "0[01]", , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SC:[, [, , "8000\\d{3}|(?:[249]\\d|64)\\d{5}", , , , , , , [7]], [, , "4[2-46]\\d{5}", , , , "4217123"], 
[, , "2[5-8]\\d{5}", , , , "2510123"], [, , "8000\\d{3}", , , , "8000000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "971\\d{4}|(?:64|95)\\d{5}", , , , "6412345"], "SC", 248, "010|0[0-2]", , , , , , "00", , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SD:[, [, , "[19]\\d{8}", , , , , , , [9]], [, , "1(?:5[3-7]|8[35-7])\\d{6}", , , , 
"153123456"], [, , "(?:1[0-2]|9[0-3569])\\d{7}", , , , "911231234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SD", 249, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SE:[, [, , "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", , 
, , , , , [6, 7, 8, 9, 10, 12]], [, , "10[1-8]\\d{6}|90[1-9]\\d{4,6}|(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d{5,7}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}", 
, , , "8123456", , , [7, 8, 9]], [, , "7[02369]\\d{7}", , , , "701234567", , , [9]], [, , "20\\d{4,7}", , , , "20123456", , , [6, 7, 8, 9]], [, , "649\\d{6}|9(?:00|39|44)[1-8]\\d{3,6}", , , , "9001234567", , , [7, 8, 9, 10]], [, , "77[0-7]\\d{6}", , , , "771234567", , , [9]], [, , "75[1-8]\\d{6}", , , , "751234567", , , [9]], [, , , , , , , , , [-1]], "SE", 46, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1"], [, "(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44)"], 
"0$1"], [, "(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1"], [, "(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1"], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], 
"0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["7"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1"]], [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["20"]], [, "(\\d{3})(\\d{4})", 
"$1 $2", ["9(?:00|39|44)"]], [, "(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"]], [, "(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1 $2 $3", ["9(?:00|39|44)"]], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"]], 
[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["8"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["9"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]"]]], [, , "74[02-9]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
, , [, , "(?:25[245]|67[3-68])\\d{9}", , , , "254123456789", , , [12]]], SG:[, [, , "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", , , , , , , [8, 10, 11]], [, , "6[1-9]\\d{6}", , , , "61234567", , , [8]], [, , "89(?:[01]\\d|2[4-8])\\d{4}|(?:8[1-8]|9[0-8])\\d{6}", , , , "81234567", , , [8]], [, , "(?:18|8)00\\d{7}", , , , "18001234567", , , [10, 11]], [, , "1900\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3[12]\\d{6}", , , , "31234567", , , [8]], 
"SG", 65, "0[0-3]\\d", , , , , , , , [[, "(\\d{4,5})", "$1", ["1[0135-7]|77"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8[1-9]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [[, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8[1-9]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [, , , , , 
, , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7000\\d{7}", , , , "70001234567", , , [11]], , , [, , , , , , , , , [-1]]], SH:[, [, , "(?:[256]\\d|8)\\d{3}", , , , , , , [4, 5]], [, , "2(?:[0-57-9]\\d|6[4-9])\\d\\d", , , , "22158"], [, , "[56]\\d{4}", , , , "51234", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "262\\d\\d", , , , "26212", , , [5]], "SH", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], 1, "[256]", 
[, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SI:[, [, , "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", , , , , , , [5, 6, 7, 8]], [, , "(?:[1-357][2-8]|4[24-8])\\d{6}", , , , "12345678", , , [8], [7]], [, , "65(?:1\\d|55|[67]0)\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", , , , "31234567", , , [8]], [, , "80\\d{4,6}", , , , "80123456", , , [6, 7, 8]], [, , "89[1-3]\\d{2,5}|90\\d{4,6}", , , , "90123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:59\\d\\d|8(?:1(?:[67]\\d|8[01389])|2(?:0\\d|2[0378]|8[0-2489])|3[389]\\d))\\d{4}", 
, , , "59012345", , , [8]], "SI", 386, "00|10(?:22|66|88|99)", "0", , , "0", , "00", , [[, "(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SJ:[, [, , "0\\d{4}|(?:[4589]\\d|79)\\d{6}", 
, , , , , , [5, 8]], [, , "79\\d{6}", , , , "79123456", , , [8]], [, , "(?:4[015-8]|5[89]|9\\d)\\d{6}", , , , "41234567", , , [8]], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "SJ", 47, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "79", [, , , , , , , , , [-1]], [, , "(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", 
, , , "02000"], , , [, , "81[23]\\d{5}", , , , "81212345", , , [8]]], SK:[, [, , "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", , , , , , , [6, 7, 9]], [, , "(?:2(?:16|[2-9]\\d{3})|[3-5][1-8]\\d{3})\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d", , , , "221234567"], [, , "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|[45]\\d)\\d{6}", , , , "912123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "9(?:00|[78]\\d)\\d{6}", , , , "900123456", , , [9]], [, , "8[5-9]\\d{7}", , , , "850123456", 
, , [9]], [, , , , , , , , , [-1]], [, , "6(?:02|5[0-4]|9[0-6])\\d{6}", , , , "690123456", , , [9]], "SK", 421, "00", "0", , , "0", , , , [[, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], [, "(\\d{4})(\\d{3})", "$1 $2", ["909", "9090"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", 
"$1/$2 $3 $4", ["[3-5]"], "0$1"]], [[, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], [, , "9090\\d{3}", , , , "9090123", , , [7]], , , [, , "9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}", 
, , , , , , [7, 9]], [, , "96\\d{7}", , , , "961234567", , , [9]], , , [, , , , , , , , , [-1]]], SL:[, [, , "(?:[2378]\\d|99)\\d{6}", , , , , , , [8], [6]], [, , "22\\d{6}", , , , "22221234", , , , [6]], [, , "(?:25|3[0134]|7[5-9]|8[08]|99)\\d{6}", , , , "25123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SL", 232, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{6})", "$1 $2", ["[237-9]"], "(0$1)"]], , [, , , 
, , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SM:[, [, , "(?:0549|[5-7]\\d)\\d{6}", , , , , , , [8, 10], [6]], [, , "0549(?:8[0157-9]|9\\d)\\d{4}", , , , "0549886377", , , [10], [6]], [, , "6[16]\\d{6}", , , , "66661212", , , [8]], [, , , , , , , , , [-1]], [, , "7[178]\\d{6}", , , , "71123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "5[158]\\d{6}", , , , "58001110", , , [8]], "SM", 378, "00", , , , "([89]\\d{5})$", 
"0549$1", , , [[, "(\\d{6})", "$1", ["[89]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SN:[, [, , "(?:[378]\\d{4}|93330)\\d{4}", , , , , , , [9]], [, , "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}", , , , 
"301012345"], [, , "7(?:[06-8]\\d|21|90)\\d{6}", , , , "701234567"], [, , "800\\d{6}", , , , "800123456"], [, , "88[4689]\\d{6}", , , , "884123456"], [, , "81[02468]\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "93330\\d{4}|3(?:392|9[01]\\d)\\d{5}", , , , "933301234"], "SN", 221, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SO:[, [, , "[346-9]\\d{8}|[12679]\\d{7}|(?:[1-4]\\d|59)\\d{5}|[1348]\\d{5}", , , , , , , [6, 7, 8, 9]], [, , "(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|59)\\d{5}|(?:[134]\\d|8[125])\\d{4}", , , , "4012345", , , [6, 7]], [, , "28\\d{5}|(?:6[1-9]|79)\\d{6,7}|(?:15|24|(?:3[59]|4[89]|8[08])\\d|60|7[1-8]|9(?:0[67]|[2-9]))\\d{6}", , , , "71123456", , , [7, 8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , 
, , [-1]], [, , , , , , , , , [-1]], "SO", 252, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], [, "(\\d{6})", "$1", ["[134]"]], [, "(\\d)(\\d{6})", "$1 $2", ["1|2[0-79]|3[0-46-8]|4[0-7]|59"]], [, "(\\d)(\\d{7})", "$1 $2", ["24|[67]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79[0-8]|90"]], [, "(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[1-35-9]|799|9[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , 
, [-1]]], SR:[, [, , "(?:[2-5]|68|[78]\\d)\\d{5}", , , , , , , [6, 7]], [, , "(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}", , , , "211234"], [, , "(?:7[124-7]|8[125-9])\\d{5}", , , , "7412345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "56\\d{4}", , , , "561234", , , [6]], "SR", 597, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], [, "(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], [, "(\\d{3})(\\d{4})", 
"$1-$2", ["[6-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SS:[, [, , "[19]\\d{8}", , , , , , , [9]], [, , "18\\d{7}", , , , "181234567"], [, , "(?:12|9[1257])\\d{7}", , , , "977123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SS", 211, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], , [, 
, , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ST:[, [, , "(?:22|9\\d)\\d{5}", , , , , , , [7]], [, , "22\\d{5}", , , , "2221234"], [, , "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}", , , , "9812345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ST", 239, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], , [, , , , , , , , , [-1]], , , [, 
, , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SV:[, [, , "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", , , , , , , [7, 8, 11]], [, , "2[1-6]\\d{6}", , , , "21234567", , , [8]], [, , "[67]\\d{7}", , , , "70123456", , , [8]], [, , "800\\d{4}(?:\\d{4})?", , , , "8001234", , , [7, 11]], [, , "900\\d{4}(?:\\d{4})?", , , , "9001234", , , [7, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SV", 503, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", 
"$1 $2", ["[89]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SX:[, [, , "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "7215(?:4[2-8]|8[239]|9[056])\\d{4}", , , , "7215425678", , , , [7]], [, , "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}", , , , "7215205678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", 
, , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "SX", 1, "011", "1", , , "1|(5\\d{6})$", "721$1", , , , , [, , , , , , , , , [-1]], , "721", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SY:[, [, , "[1-39]\\d{8}|[1-5]\\d{7}", , , , , , , [8, 9], [6, 7]], [, , "[12]1\\d{6,7}|(?:1(?:[2356]|4\\d)|2[235]|3(?:[13]\\d|4)|4[13]|5[1-3])\\d{6}", 
, , , "112345678", , , , [6, 7]], [, , "9(?:22|[3-589]\\d|6[024-9])\\d{6}", , , , "944567890", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SY", 963, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", , 1]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , 
, , , , , , [-1]]], SZ:[, [, , "0800\\d{4}|(?:[237]\\d|900)\\d{6}", , , , , , , [8, 9]], [, , "[23][2-5]\\d{6}", , , , "22171234", , , [8]], [, , "7[6-9]\\d{6}", , , , "76123456", , , [8]], [, , "0800\\d{4}", , , , "08001234", , , [8]], [, , "900\\d{6}", , , , "900012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "70\\d{6}", , , , "70012345", , , [8]], "SZ", 268, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], [, "(\\d{5})(\\d{4})", "$1 $2", ["9"]]], , 
[, , , , , , , , , [-1]], , , [, , "0800\\d{4}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TA:[, [, , "8\\d{3}", , , , , , , [4]], [, , "8\\d{3}", , , , "8999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TA", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "8", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 
TC:[, [, , "(?:[58]\\d\\d|649|900)\\d{7}", , , , , , , [10], [7]], [, , "649(?:712|9(?:4\\d|50))\\d{4}", , , , "6497121234", , , , [7]], [, , "649(?:2(?:3[129]|4[1-7])|3(?:3[1-389]|4[1-8])|4[34][1-3])\\d{4}", , , , "6492311234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "64971[01]\\d{4}", , , , "6497101234", , , , [7]], 
"TC", 1, "011", "1", , , "1|([2-479]\\d{6})$", "649$1", , , , , [, , , , , , , , , [-1]], , "649", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TD:[, [, , "(?:22|[69]\\d|77)\\d{6}", , , , , , , [8]], [, , "22(?:[37-9]0|5[0-5]|6[89])\\d{4}", , , , "22501234"], [, , "(?:6[023568]|77|9\\d)\\d{6}", , , , "63012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TD", 235, "00|16", 
, , , , , "00", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TG:[, [, , "[279]\\d{7}", , , , , , , [8]], [, , "2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}", , , , "22212345"], [, , "(?:7[09]|9[0-36-9])\\d{6}", , , , "90112345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TG", 
228, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TH:[, [, , "1\\d{8,9}|(?:[2-57]|[689]\\d)\\d{7}", , , , , , , [8, 9, 10]], [, , "(?:2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", , , , "21234567", , , [8]], [, , "(?:14|6[1-6]|[89]\\d)\\d{7}", , , , "812345678", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , "1900\\d{6}", , , , 
"1900123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "6[08]\\d{7}", , , , "601234567", , , [9]], "TH", 66, "00[1-9]", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["14|[3-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TJ:[, [, , "(?:00|[3-59]\\d|77|88)\\d{7}", , 
, , , , , [9], [3, 5, 6, 7]], [, , "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}", , , , "372123456", , , , [3, 5, 6, 7]], [, , "41[18]\\d{6}|(?:00|5[05]|77|88|9\\d)\\d{7}", , , , "917123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TJ", 992, "810", "8", , , "8", , "8~10", , [[, "(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"], , , 1], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[34]7|91[78]"], 
, , 1], [, "(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3"], , , 1], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0457-9]"], , , 1]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TK:[, [, , "[2-47]\\d{3,6}", , , , , , , [4, 5, 6, 7]], [, , "(?:2[2-4]|[34]\\d)\\d{2,5}", , , , "3101"], [, , "7[2-4]\\d{2,5}", , , , "7290"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , 
, , , , , [-1]], "TK", 690, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TL:[, [, , "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", , , , , , , [7, 8]], [, , "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", , , , "2112345", , , [7]], [, , "7[3-8]\\d{6}", , , , "77212345", , , [8]], [, , "80\\d{5}", , , , "8012345", , , [7]], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , "70\\d{5}", , , , "7012345", , , 
[7]], [, , , , , , , , , [-1]], "TL", 670, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TM:[, [, , "[1-6]\\d{7}", , , , , , , [8]], [, , "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}", , , , "12345678"], [, , "6[1-9]\\d{6}", , , , "66123456"], [, , , , 
, , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TM", 993, "810", "8", , , "8", , "8~10", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TN:[, [, , "[2-57-9]\\d{7}", 
, , , , , , [8]], [, , "81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}", , , , "30010123"], [, , "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-6])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}", , , , "20123456"], [, , "8010\\d{4}", , , , "80101234"], [, , "88\\d{6}", , , , "88123456"], [, , "8[12]10\\d{4}", , , , "81101234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TN", 216, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, 
, , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TO:[, [, , "(?:0800|[5-8]\\d{3})\\d{3}|[2-8]\\d{4}", , , , , , , [5, 7]], [, , "(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", , , , "20123", , , [5]], [, , "(?:6(?:3[02]|85|90)|7(?:[2-46]0|[578]\\d)|8[46-9]\\d)\\d{4}", , , , "7715123", , , [7]], [, , "0800\\d{3}", , , , "0800222", , , [7]], [, , "55[04]\\d{4}", , , , "5501234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TO", 676, "00", , 
, , , , , , [[, "(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], [, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[5-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TR:[, [, , "(?:[2-58]\\d\\d|900)\\d{7}|4\\d{6}", , , , , , , [7, 10]], [, , "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}", , , , "2123456789", 
, , [10]], [, , "56161\\d{5}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", , , , "5012345678", , , [10]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "(?:8[89]8|900)\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , "592(?:21[12]|461)\\d{4}", , , , "5922121234", , , [10]], [, , , , , , , , , [-1]], "TR", 90, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d)(\\d{3})", "$1 $2 $3", ["444"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[0589]|90"], "0$1", , 
1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", , 1]], [[, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[0589]|90"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], 
"(0$1)", , 1]], [, , "512\\d{7}", , , , "5123456789", , , [10]], , , [, , "444\\d{4}", , , , , , , [7]], [, , "(?:444|850\\d{3})\\d{4}", , , , "4441444"], , , [, , , , , , , , , [-1]]], TT:[, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "868(?:2(?:01|1[89]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}", , , , "8682211234", , , , [7]], [, , "868(?:2(?:6[6-9]|[7-9]\\d)|[37](?:0[1-9]|1[02-9]|[2-9]\\d)|4[6-9]\\d|6(?:20|78|8\\d))\\d{4}", , , , "8682911234", 
, , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "TT", 1, "011", "1", , , "1|([2-46-8]\\d{6})$", "868$1", , , , , [, , , , , , , , , [-1]], , "868", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "868619\\d{4}", , , , "8686191234", , , , [7]]], TV:[, [, , "(?:2|7\\d\\d|90)\\d{4}", , , , , , , 
[5, 6, 7]], [, , "2[02-9]\\d{3}", , , , "20123", , , [5]], [, , "(?:7[01]\\d|90)\\d{4}", , , , "901234", , , [6, 7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TV", 688, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TW:[, [, , "(?:[24589]|7\\d)\\d{8}|[2-8]\\d{7}|2\\d{6}", , , , , , , [7, 8, 9, 10]], [, , "24\\d{6,7}|(?:6412|8(?:2(?:3\\d|66)|36[24-9]))\\d{4}|(?:2[235-8]\\d|3[2-9]|4(?:[239]\\d|[78])|5[2-8]|6[235-79]|7[1-9]|8[7-9])\\d{6}", 
, , , "221234567", , , [8, 9]], [, , "9[0-8]\\d{7}", , , , "912345678", , , [9]], [, , "80[0-79]\\d{6}", , , , "800123456", , , [9]], [, , "20(?:[013-9]\\d\\d|2)\\d{4}", , , , "203123456", , , [7, 9]], [, , , , , , , , , [-1]], [, , "99\\d{7}", , , , "990123456", , , [9]], [, , "70\\d{8}", , , , "7012345678", , , [10]], "TW", 886, "0(?:0[25-79]|19)", "0", "#", , "0", , , , [[, "(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], [, "(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[25][2-8]|[346]|7[1-9]|8[237-9]"], 
"0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[258]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "50[0-46-9]\\d{6}", , , , "500123456", , , [9]], , , [, , , , , , , , , [-1]]], TZ:[, [, , "(?:[26-8]\\d|41|90)\\d{7}", , , , , , , [9]], [, , "2[2-8]\\d{7}", , , , "222345678"], [, , "(?:6[2-9]|7[13-9])\\d{7}", , , , "621234567"], [, , "80[08]\\d{6}", 
, , , "800123456"], [, , "90\\d{7}", , , , "900123456"], [, , "8(?:40|6[01])\\d{6}", , , , "840123456"], [, , , , , , , , , [-1]], [, , "41\\d{7}", , , , "412345678"], "TZ", 255, "00[056]", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "(?:8(?:[04]0|6[01])|90\\d)\\d{6}"], [, , , , , , , , , [-1]], , , [, 
, , , , , , , , [-1]]], UA:[, [, , "[89]\\d{9}|[3-9]\\d{8}", , , , , , , [9, 10], [5, 6, 7]], [, , "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}", , , , "311234567", , , [9], [5, 6, 7]], [, , "(?:50|6[36-8]|7[1-3]|9[1-9])\\d{7}", , , , "501234567", , , [9]], [, , "800[1-8]\\d{5,6}", , , , "800123456"], [, , "900[239]\\d{5,6}", , , , "900212345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "89[1-579]\\d{6}", , , , "891234567", , , [9]], "UA", 380, "00", "0", , , "0", , "0~0", , [[, "(\\d{3})(\\d{3})(\\d{3})", 
"$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["4[45][0-5]|5(?:0|6[37])|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]", "4[45][0-5]|5(?:0|6(?:3[14-7]|7))|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]"], "0$1"], [, "(\\d{4})(\\d{5})", "$1 $2", ["[3-6]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], 
, [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], UG:[, [, , "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", , , , , , , [9], [5, 6, 7]], [, , "(?:20(?:(?:(?:[0147]\\d|5[0-4])\\d|2(?:40|[5-9]\\d)|3(?:0[67]|2[0-4])|810)\\d|6(?:00[0-2]|[15-9]\\d\\d|30[0-4]))|[34]\\d{5})\\d{3}", , , , "312345678", , , , [5, 6, 7]], [, , "7260\\d{5}|7(?:[0157-9]\\d|20|4[0-4])\\d{6}", , , , "712345678"], [, , "800[1-3]\\d{5}", , , , "800123456"], [, , "90[1-3]\\d{6}", 
, , , "901123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UG", 256, "00[057]", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], US:[, [, , "[2-9]\\d{9}", , , , , , , [10], [7]], [, , "(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[017]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-28]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}", 
, , , "2015550123", , , , [7]], [, , "(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[017]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-28]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}", 
, , , "2015550123", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "US", 1, "011", "1", , , "1", , , 1, [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-9]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], , , 1]], [[, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-9]"]]], [, , , , , , , , , [-1]], 1, , [, 
, , , , , , , , [-1]], [, , "710[2-9]\\d{6}", , , , "7102123456"], , , [, , , , , , , , , [-1]]], UY:[, [, , "(?:[249]\\d\\d|80)\\d{5}|9\\d{6}", , , , , , , [7, 8]], [, , "(?:2\\d|4[2-7])\\d{6}", , , , "21231234", , , [8], [7]], [, , "9[1-9]\\d{6}", , , , "94231234", , , [8]], [, , "80[05]\\d{4}", , , , "8001234", , , [7]], [, , "90[0-8]\\d{4}", , , , "9001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UY", 598, "0(?:0|1[3-9]\\d)", "0", " int. ", , 
"0", , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["8|90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[24]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], UZ:[, [, , "[679]\\d{8}", , , , , , , [9]], [, , "78(?:1(?:13|2[02]|50)|2(?:10|2[139]|98)|77[01])\\d{4}|(?:6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|1[12]\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}", 
, , , "669050123"], [, , "(?:6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:0\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07])))|9[0-57-9]\\d{3})\\d{4}", 
, , , "912345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UZ", 998, "810", "8", , , "8", , "8~10", , [[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[679]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VA:[, [, , "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", , , , , , , [6, 7, 8, 9, 
10, 11, 12]], [, , "06698\\d{1,6}", , , , "0669812345", , , [6, 7, 8, 9, 10, 11]], [, , "3[1-9]\\d{8}|3[2-9]\\d{7}", , , , "3123456789", , , [9, 10]], [, , "80(?:0\\d{3}|3)\\d{3}", , , , "800123456", , , [6, 9]], [, , "(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{3}|[17])\\d{3}", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", 
, , , "5512345678", , , [10]], "VA", 39, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "06698", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "3[2-8]\\d{9,10}", , , , "33101234501", , , [11, 12]]], VC:[, [, , "(?:[58]\\d\\d|784|900)\\d{7}", , , , , , , [10], [7]], [, , "784(?:266|3(?:6[6-9]|7\\d|8[0-24-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}", , , , "7842661234", , , , [7]], [, , "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4]))\\d{4}", , , , "7844301234", 
, , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "VC", 1, "011", "1", , , "1|([2-7]\\d{6})$", "784$1", , , , , [, , , , , , , , , [-1]], , "784", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VE:[, [, , "[89]00\\d{7}|(?:[24]\\d|50)\\d{8}", , , , , , , [10], [7]], [, , "(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|50[01])\\d{7}", 
, , , "2121234567", , , , [7]], [, , "4(?:1[24-8]|2[46])\\d{7}", , , , "4121234567"], [, , "800\\d{7}", , , , "8001234567"], [, , "900\\d{7}", , , , "9001234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "VE", 58, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{7})", "$1-$2", ["[24589]"], "0$1", "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VG:[, [, , "(?:284|[58]\\d\\d|900)\\d{7}", 
, , , , , , [10], [7]], [, , "284496[0-5]\\d{3}|284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}", , , , "2842291234", , , , [7]], [, , "284496[6-9]\\d{3}|284(?:3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|99)|54[0-57])\\d{4}", , , , "2843001234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "VG", 1, "011", 
"1", , , "1|([2-578]\\d{6})$", "284$1", , , , , [, , , , , , , , , [-1]], , "284", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VI:[, [, , "[58]\\d{9}|(?:34|90)0\\d{7}", , , , , , , [10], [7]], [, , "340(?:2(?:0[12]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:22|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|27|7\\d)|884|998)\\d{4}", , , , "3406421234", , , , [7]], [, , "340(?:2(?:0[12]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:22|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|27|7\\d)|884|998)\\d{4}", 
, , , "3406421234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "VI", 1, "011", "1", , , "1|([2-9]\\d{6})$", "340$1", , 1, , , [, , , , , , , , , [-1]], , "340", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VN:[, [, , "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", 
, , , , , , [7, 8, 9, 10]], [, , "2(?:0[3-9]|1[0-689]|2[0-25-9]|3[2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|8[2-79]|9[0-4679])\\d{7}", , , , "2101234567", , , [10]], [, , "(?:52[238]|8(?:79|9[689])|99[013-9])\\d{6}|(?:3\\d|5[689]|7[06-9]|8[1-68]|9[0-8])\\d{7}", , , , "912345678", , , [9]], [, , "1(?:228\\d{4}|800\\d{4,6})", , , , "1800123456", , , [8, 9, 10]], [, , "1900\\d{4,6}", , , , "1900123456", , , [8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "672\\d{6}", , , , "672012345", 
, , [9]], "VN", 84, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[17]99"], "0$1", , 1], [, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["69"], "0$1", , 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], , , 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[69]"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1", , 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", , 1], [, "(\\d{3})(\\d{4})(\\d{3})", 
"$1 $2 $3", ["2"], "0$1", , 1]], [[, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], , , 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[69]"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1", , 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", , 1], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", , 1]], [, , , , , , , , , [-1]], , , [, , "[17]99\\d{4}|69\\d{5,6}", , , , , , , [7, 8]], [, , "(?:[17]99|80\\d)\\d{4}|69\\d{5,6}", 
, , , "1992000", , , [7, 8]], , , [, , , , , , , , , [-1]]], VU:[, [, , "(?:[23]\\d|[48]8)\\d{3}|(?:[57]\\d|90)\\d{5}", , , , , , , [5, 7]], [, , "(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", , , , "22123", , , [5]], [, , "57[2-5]\\d{4}|(?:5[0-689]|7[013-7])\\d{5}", , , , "5912345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "90[1-9]\\d{4}", , , , "9010123", , , [7]], "VU", 678, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", 
"$1 $2", ["[579]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:3[03]|900\\d)\\d{3}", , , , "30123"], , , [, , , , , , , , , [-1]]], WF:[, [, , "(?:[45]0|68|72|8\\d)\\d{4}", , , , , , , [6]], [, , "(?:50|68|72)\\d{4}", , , , "501234"], [, , "(?:50|68|72|8[23])\\d{4}", , , , "501234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "WF", 681, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", 
"$1 $2 $3", ["[4-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "[48]0\\d{4}", , , , "401234"]], WS:[, [, , "[2-6]\\d{4}|8\\d{5}(?:\\d{4})?|[78]\\d{6}", , , , , , , [5, 6, 7, 10]], [, , "(?:[2-5]\\d|6[1-9])\\d{3}", , , , "22123", , , [5]], [, , "(?:7[25-7]|8(?:[3-7]|9\\d{3}))\\d{5}", , , , "7212345", , , [7, 10]], [, , "800\\d{3}", , , , "800123", , , [6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , 
, , , , , [-1]], "WS", 685, "0", , , , , , , , [[, "(\\d{5})", "$1", ["[2-6]"]], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["8"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], XK:[, [, , "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", , , , , , , [8, 9]], [, , "(?:2[89]|39)0\\d{6}|[23][89]\\d{6}", , , , "28012345"], [, , "4[3-79]\\d{6}", , , , "43201234", , , [8]], [, , "800\\d{5}", , , , "80001234", , 
, [8]], [, , "900\\d{5}", , , , "90001234", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "XK", 383, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], YE:[, [, , "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", 
, , , , , , [7, 8, 9], [6]], [, , "17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-68])\\d{5}", , , , "1234567", , , [7, 8], [6]], [, , "7[0137]\\d{7}", , , , "712345678", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "YE", 967, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7[24-68]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , 
, , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], YT:[, [, , "80\\d{7}|(?:26|63)9\\d{6}", , , , , , , [9]], [, , "269(?:0[67]|5[01]|6\\d|[78]0)\\d{4}", , , , "269601234"], [, , "639(?:0[0-79]|1[019]|[267]\\d|3[09]|[45]0|9[04-79])\\d{4}", , , , "639012345"], [, , "80\\d{7}", , , , "801234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "YT", 262, "00", "0", , , "0", , , , , , [, , , 
, , , , , , [-1]], , "269|63", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ZA:[, [, , "[1-9]\\d{8}|8\\d{4,7}", , , , , , , [5, 6, 7, 8, 9]], [, , "(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}", , , , "101234567", , , [9]], [, , "8[1-4]\\d{3,7}|(?:6\\d|7[0-46-9]|85)\\d{7}", , , , "711234567"], [, , "80\\d{7}", , , , "801234567", , , [9]], [, , "(?:86[2-9]|9[0-2]\\d)\\d{6}", , , , "862345678", , , [9]], [, , "860\\d{6}", , , , "860123456", , , [9]], [, , , 
, , , , , , [-1]], [, , "87\\d{7}", , , , "871234567", , , [9]], "ZA", 27, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "861\\d{6}", , , , "861123456", , , [9]], , , [, , , , , , , , , [-1]]], ZM:[, [, , "800\\d{6}|(?:21|76|9\\d)\\d{7}", 
, , , , , , [9], [6]], [, , "21[1-8]\\d{6}", , , , "211234567", , , , [6]], [, , "(?:76|9[5-8])\\d{7}", , , , "955123456"], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ZM", 260, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[1-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", 
["[28]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ZW:[, [, , "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", , , , , , , [5, 6, 7, 8, 9, 10], [3, 4]], [, , "(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}", 
, , , "1312345", , , , [3, 4]], [, , "7(?:1[2-9]|[378][1-9])\\d{6}", , , , "712345678", , , [9]], [, , "80(?:[01]\\d|20|8[0-8])\\d{3}", , , , "8001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", , , , "8686123456", , , [10]], "ZW", 263, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], [, "(\\d)(\\d{3})(\\d{2,4})", 
"$1 $2 $3", ["[49]"], "0$1"], [, "(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], [, "(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], 
[, "(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], [, "(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 800:[, [, , "\\d{8}", , , , , , , [8]], [, , , , , , , , 
, [-1]], [, , , , , , , , , [-1]], [, , "\\d{8}", , , , "12345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 800, , , , , , , , 1, [[, "(\\d{4})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 808:[, [, , "\\d{8}", , , , , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , 
"\\d{8}", , , , "12345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 808, , , , , , , , 1, [[, "(\\d{4})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 870:[, [, , "[35-7]\\d{8}", , , , , , , [9]], [, , , , , , , , , [-1]], [, , "(?:[356]\\d|7[6-8])\\d{7}", , , , "301234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , 
, , , , [-1]], "001", 870, , , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 878:[, [, , "10\\d{10}", , , , , , , [12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "10\\d{10}", , , , "101234567890"], "001", 878, , , , , , , , 1, [[, "(\\d{2})(\\d{5})(\\d{5})", 
"$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 881:[, [, , "[67]\\d{8}", , , , , , , [9]], [, , , , , , , , , [-1]], [, , "[67]\\d{8}", , , , "612345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 881, , , , , , , , , [[, "(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[67]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , 
, , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 882:[, [, , "1\\d{6,11}|3\\d{6}(?:\\d{2,5})?", , , , , , , [7, 8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [, , "3(?:37\\d\\d|42)\\d{4}|3(?:2|47|7\\d{3})\\d{7}", , , , "3421234", , , [7, 9, 10, 12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|3(?:45|9\\d{3})\\d{7}", , 
, , "390123456789"], "001", 882, , , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["34[57]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], [, "(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[13]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
, , [, , "348[57]\\d{7}", , , , "34851234567", , , [11]]], 883:[, [, , "51\\d{7}(?:\\d{3})?", , , , , , , [9, 12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "51[013]0\\d{8}|5100\\d{5}", , , , "510012345"], "001", 883, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["510"]], [, "(\\d{4})(\\d{4})(\\d{4})", 
"$1 $2 $3", ["5"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 888:[, [, , "\\d{11}", , , , , , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 888, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "\\d{11}", 
, , , "12345678901"], , , [, , , , , , , , , [-1]]], 979:[, [, , "\\d{9}", , , , , , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "\\d{9}", , , , "123456789"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 979, , , , , , , , 1, [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]]};
/*

 Copyright (C) 2010 The Libphonenumber Authors.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
i18n.phonenumbers.PhoneNumberUtil = function() {
  this.regionToMetadataMap = {};
};
goog.addSingletonGetter(i18n.phonenumbers.PhoneNumberUtil);
i18n.phonenumbers.Error = {INVALID_COUNTRY_CODE:"Invalid country calling code", NOT_A_NUMBER:"The string supplied did not seem to be a phone number", TOO_SHORT_AFTER_IDD:"Phone number too short after IDD", TOO_SHORT_NSN:"The string supplied is too short to be a phone number", TOO_LONG:"The string supplied is too long to be a phone number"};
i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ = 1;
i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ = 2;
i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_ = 17;
i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ = 3;
i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_ = 250;
i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ = "ZZ";
i18n.phonenumbers.PhoneNumberUtil.COLOMBIA_MOBILE_TO_FIXED_LINE_PREFIX_ = "3";
i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_ = {54:"9"};
i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_ = [52, 54, 55];
i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN = "+";
i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ = "*";
i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ = ";ext=";
i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ = "tel:";
i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_ = ";phone-context=";
i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_ = ";isub=";
i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS = {0:"0", 1:"1", 2:"2", 3:"3", 4:"4", 5:"5", 6:"6", 7:"7", 8:"8", 9:"9", "\uff10":"0", "\uff11":"1", "\uff12":"2", "\uff13":"3", "\uff14":"4", "\uff15":"5", "\uff16":"6", "\uff17":"7", "\uff18":"8", "\uff19":"9", "\u0660":"0", "\u0661":"1", "\u0662":"2", "\u0663":"3", "\u0664":"4", "\u0665":"5", "\u0666":"6", "\u0667":"7", "\u0668":"8", "\u0669":"9", "\u06f0":"0", "\u06f1":"1", "\u06f2":"2", "\u06f3":"3", "\u06f4":"4", "\u06f5":"5", "\u06f6":"6", "\u06f7":"7", 
"\u06f8":"8", "\u06f9":"9"};
i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_ = {0:"0", 1:"1", 2:"2", 3:"3", 4:"4", 5:"5", 6:"6", 7:"7", 8:"8", 9:"9", "+":i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN, "*":"*", "#":"#"};
i18n.phonenumbers.PhoneNumberUtil.ALPHA_MAPPINGS_ = {A:"2", B:"2", C:"2", D:"3", E:"3", F:"3", G:"4", H:"4", I:"4", J:"5", K:"5", L:"5", M:"6", N:"6", O:"6", P:"7", Q:"7", R:"7", S:"7", T:"8", U:"8", V:"8", W:"9", X:"9", Y:"9", Z:"9"};
i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_ = {0:"0", 1:"1", 2:"2", 3:"3", 4:"4", 5:"5", 6:"6", 7:"7", 8:"8", 9:"9", "\uff10":"0", "\uff11":"1", "\uff12":"2", "\uff13":"3", "\uff14":"4", "\uff15":"5", "\uff16":"6", "\uff17":"7", "\uff18":"8", "\uff19":"9", "\u0660":"0", "\u0661":"1", "\u0662":"2", "\u0663":"3", "\u0664":"4", "\u0665":"5", "\u0666":"6", "\u0667":"7", "\u0668":"8", "\u0669":"9", "\u06f0":"0", "\u06f1":"1", "\u06f2":"2", "\u06f3":"3", "\u06f4":"4", "\u06f5":"5", "\u06f6":"6", 
"\u06f7":"7", "\u06f8":"8", "\u06f9":"9", A:"2", B:"2", C:"2", D:"3", E:"3", F:"3", G:"4", H:"4", I:"4", J:"5", K:"5", L:"5", M:"6", N:"6", O:"6", P:"7", Q:"7", R:"7", S:"7", T:"8", U:"8", V:"8", W:"9", X:"9", Y:"9", Z:"9"};
i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_ = {0:"0", 1:"1", 2:"2", 3:"3", 4:"4", 5:"5", 6:"6", 7:"7", 8:"8", 9:"9", A:"A", B:"B", C:"C", D:"D", E:"E", F:"F", G:"G", H:"H", I:"I", J:"J", K:"K", L:"L", M:"M", N:"N", O:"O", P:"P", Q:"Q", R:"R", S:"S", T:"T", U:"U", V:"V", W:"W", X:"X", Y:"Y", Z:"Z", a:"A", b:"B", c:"C", d:"D", e:"E", f:"F", g:"G", h:"H", i:"I", j:"J", k:"K", l:"L", m:"M", n:"N", o:"O", p:"P", q:"Q", r:"R", s:"S", t:"T", u:"U", v:"V", w:"W", x:"X", y:"Y", z:"Z", 
"-":"-", "\uff0d":"-", "\u2010":"-", "\u2011":"-", "\u2012":"-", "\u2013":"-", "\u2014":"-", "\u2015":"-", "\u2212":"-", "/":"/", "\uff0f":"/", " ":" ", "\u3000":" ", "\u2060":" ", ".":".", "\uff0e":"."};
i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_ = /[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/;
i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION = "-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e";
i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ = "0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9";
i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ = "A-Za-z";
i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ = "+\uff0b";
i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN = new RegExp("[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]+");
i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN = new RegExp("^[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]+");
i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]+";
i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN = new RegExp("([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "])");
i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_ = new RegExp("[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]");
i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_ = /[\\\/] *x/;
i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_ = new RegExp("[^" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + "#]+$");
i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_ = /(?:.*?[A-Za-z]){3}.*/;
i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{" + i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ + "}";
i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ = "[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]*(?:[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + "]*[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]){3,}[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]*";
i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ = " ext. ";
i18n.phonenumbers.PhoneNumberUtil.CAPTURING_EXTN_DIGITS_ = "([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{1,7})";
i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERNS_FOR_PARSING_ = i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + i18n.phonenumbers.PhoneNumberUtil.CAPTURING_EXTN_DIGITS_ + "|[ \u00a0\\t,]*(?:e?xt(?:ensi(?:o\u0301?|\u00f3))?n?|\uff45?\uff58\uff54\uff4e?|\u0434\u043e\u0431|[;,x\uff58#\uff03~\uff5e]|int|anexo|\uff49\uff4e\uff54)[:\\.\uff0e]?[ \u00a0\\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.CAPTURING_EXTN_DIGITS_ + "#?|[- ]+([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{1,5})#";
i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_ = new RegExp("(?:" + i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERNS_FOR_PARSING_ + ")$", "i");
i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_ = new RegExp("^" + i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ + "$|^" + i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ + "(?:" + i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERNS_FOR_PARSING_ + ")?$", "i");
i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_ = /\D+/;
i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_ = /(\$\d)/;
i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_ = /\$NP/;
i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_ = /\$FG/;
i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_ = /\$CC/;
i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_ = /^\(?\$1\)?$/;
i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY = "001";
i18n.phonenumbers.PhoneNumberFormat = {E164:0, INTERNATIONAL:1, NATIONAL:2, RFC3966:3};
i18n.phonenumbers.PhoneNumberType = {FIXED_LINE:0, MOBILE:1, FIXED_LINE_OR_MOBILE:2, TOLL_FREE:3, PREMIUM_RATE:4, SHARED_COST:5, VOIP:6, PERSONAL_NUMBER:7, PAGER:8, UAN:9, VOICEMAIL:10, UNKNOWN:-1};
i18n.phonenumbers.PhoneNumberUtil.MatchType = {NOT_A_NUMBER:0, NO_MATCH:1, SHORT_NSN_MATCH:2, NSN_MATCH:3, EXACT_MATCH:4};
i18n.phonenumbers.PhoneNumberUtil.ValidationResult = {IS_POSSIBLE:0, IS_POSSIBLE_LOCAL_ONLY:4, INVALID_COUNTRY_CODE:1, TOO_SHORT:2, INVALID_LENGTH:5, TOO_LONG:3};
i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber = function(a) {
  var b = a.search(i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_);
  0 <= b ? (a = a.substring(b), a = a.replace(i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_, ""), b = a.search(i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_), 0 <= b && (a = a.substring(0, b))) : a = "";
  return a;
};
i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber = function(a) {
  return a.length < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_, a);
};
i18n.phonenumbers.PhoneNumberUtil.normalize = function(a) {
  return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, a) ? i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, !0) : i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a);
};
i18n.phonenumbers.PhoneNumberUtil.normalizeSB_ = function(a) {
  var b = i18n.phonenumbers.PhoneNumberUtil.normalize(a.toString());
  a.clear();
  a.append(b);
};
i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly = function(a) {
  return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS, !0);
};
i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly = function(a) {
  return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_, !0);
};
i18n.phonenumbers.PhoneNumberUtil.convertAlphaCharactersInNumber = function(a) {
  return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, !1);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfGeographicalAreaCode = function(a) {
  var b = this.getMetadataForRegion(this.getRegionCodeForNumber(a));
  return null != b && (b.hasNationalPrefix() || a.hasItalianLeadingZero()) && this.isNumberGeographical(a) ? this.getLengthOfNationalDestinationCode(a) : 0;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfNationalDestinationCode = function(a) {
  if (a.hasExtension()) {
    var b = a.clone();
    b.clearExtension();
  } else {
    b = a;
  }
  b = this.format(b, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).split(i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_);
  0 == b[0].length && b.shift();
  return 2 >= b.length ? 0 : this.getNumberType(a) == i18n.phonenumbers.PhoneNumberType.MOBILE && (a = i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken(a.getCountryCodeOrDefault()), "" != a) ? b[2].length + a.length : b[1].length;
};
i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken = function(a) {
  return i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_[a] || "";
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedRegions = function() {
  return goog.array.filter(Object.keys(i18n.phonenumbers.metadata.countryToMetadata), function(a) {
    return isNaN(a);
  });
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedGlobalNetworkCallingCodes = function() {
  var a = goog.array.filter(Object.keys(i18n.phonenumbers.metadata.countryToMetadata), function(a) {
    return !isNaN(a);
  });
  return goog.array.map(a, function(a) {
    return parseInt(a, 10);
  });
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedCallingCodes = function() {
  var a = Object.keys(i18n.phonenumbers.metadata.countryCodeToRegionCodeMap);
  return goog.array.join(this.getSupportedGlobalNetworkCallingCodes(), goog.array.map(a, function(a) {
    return parseInt(a, 10);
  }));
};
i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_ = function(a) {
  return null != a && (1 != a.possibleLengthCount() || -1 != a.possibleLengthArray()[0]);
};
i18n.phonenumbers.PhoneNumberUtil.descHasData_ = function(a) {
  return null != a && (a.hasExampleNumber() || i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(a) || a.hasNationalNumberPattern());
};
i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_ = function(a) {
  var b = [];
  goog.object.forEach(i18n.phonenumbers.PhoneNumberType, function(c) {
    if (c != i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE && c != i18n.phonenumbers.PhoneNumberType.UNKNOWN) {
      var d = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(a, c);
      i18n.phonenumbers.PhoneNumberUtil.descHasData_(d) && b.push(c);
    }
  });
  return b;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForRegion = function(a) {
  return this.isValidRegionCode_(a) ? i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(this.getMetadataForRegion(a)) : [];
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForNonGeoEntity = function(a) {
  a = this.getMetadataForNonGeographicalRegion(a);
  return null == a ? [] : i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(a);
};
i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_ = function(a, b, c) {
  for (var d = new goog.string.StringBuffer, e, f, g = a.length, h = 0; h < g; ++h) {
    e = a.charAt(h), f = b[e.toUpperCase()], null != f ? d.append(f) : c || d.append(e);
  }
  return d.toString();
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formattingRuleHasFirstGroupOnly = function(a) {
  return 0 == a.length || i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_.test(a);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberGeographical = function(a) {
  var b = this.getNumberType(a);
  return b == i18n.phonenumbers.PhoneNumberType.FIXED_LINE || b == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE || goog.array.contains(i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_, a.getCountryCodeOrDefault()) && b == i18n.phonenumbers.PhoneNumberType.MOBILE;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isValidRegionCode_ = function(a) {
  return null != a && isNaN(a) && a.toUpperCase() in i18n.phonenumbers.metadata.countryToMetadata;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.hasValidCountryCallingCode_ = function(a) {
  return a in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.format = function(a, b) {
  if (0 == a.getNationalNumber() && a.hasRawInput()) {
    var c = a.getRawInputOrDefault();
    if (0 < c.length) {
      return c;
    }
  }
  c = a.getCountryCodeOrDefault();
  var d = this.getNationalSignificantNumber(a);
  if (b == i18n.phonenumbers.PhoneNumberFormat.E164) {
    return this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.E164, d, "");
  }
  if (!this.hasValidCountryCallingCode_(c)) {
    return d;
  }
  var e = this.getRegionCodeForCountryCode(c), f = this.getMetadataForRegionOrCallingCode_(c, e);
  e = this.maybeGetFormattedExtension_(a, f, b);
  d = this.formatNsn_(d, f, b);
  return this.prefixNumberWithCountryCallingCode_(c, b, d, e);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatByPattern = function(a, b, c) {
  var d = a.getCountryCodeOrDefault(), e = this.getNationalSignificantNumber(a);
  if (!this.hasValidCountryCallingCode_(d)) {
    return e;
  }
  var f = this.getRegionCodeForCountryCode(d);
  f = this.getMetadataForRegionOrCallingCode_(d, f);
  var g = this.chooseFormattingPatternForNumber_(c, e);
  if (null != g) {
    c = g.clone();
    g = g.getNationalPrefixFormattingRuleOrDefault();
    if (0 < g.length) {
      var h = f.getNationalPrefixOrDefault();
      0 < h.length ? (g = g.replace(i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_, h).replace(i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_, "$1"), c.setNationalPrefixFormattingRule(g)) : c.clearNationalPrefixFormattingRule();
    }
    e = this.formatNsnUsingPattern_(e, c, b);
  }
  a = this.maybeGetFormattedExtension_(a, f, b);
  return this.prefixNumberWithCountryCallingCode_(d, b, e, a);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithCarrierCode = function(a, b) {
  var c = a.getCountryCodeOrDefault(), d = this.getNationalSignificantNumber(a);
  if (!this.hasValidCountryCallingCode_(c)) {
    return d;
  }
  var e = this.getRegionCodeForCountryCode(c), f = this.getMetadataForRegionOrCallingCode_(c, e);
  e = this.maybeGetFormattedExtension_(a, f, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
  d = this.formatNsn_(d, f, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, b);
  return this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, d, e);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegionOrCallingCode_ = function(a, b) {
  return i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == b ? this.getMetadataForNonGeographicalRegion(a) : this.getMetadataForRegion(b);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithPreferredCarrierCode = function(a, b) {
  return this.formatNationalNumberWithCarrierCode(a, 0 < a.getPreferredDomesticCarrierCodeOrDefault().length ? a.getPreferredDomesticCarrierCodeOrDefault() : b);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNumberForMobileDialing = function(a, b, c) {
  var d = a.getCountryCodeOrDefault();
  if (!this.hasValidCountryCallingCode_(d)) {
    return a.hasRawInput() ? a.getRawInputOrDefault() : "";
  }
  var e = "";
  a = a.clone();
  a.clearExtension();
  var f = this.getRegionCodeForCountryCode(d), g = this.getNumberType(a), h = g != i18n.phonenumbers.PhoneNumberType.UNKNOWN;
  if (b == f) {
    e = g == i18n.phonenumbers.PhoneNumberType.FIXED_LINE || g == i18n.phonenumbers.PhoneNumberType.MOBILE || g == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE, "CO" == f && g == i18n.phonenumbers.PhoneNumberType.FIXED_LINE ? e = this.formatNationalNumberWithCarrierCode(a, i18n.phonenumbers.PhoneNumberUtil.COLOMBIA_MOBILE_TO_FIXED_LINE_PREFIX_) : "BR" == f && e ? e = 0 < a.getPreferredDomesticCarrierCodeOrDefault().length ? this.formatNationalNumberWithPreferredCarrierCode(a, "") : "" : 
    d == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ ? (b = this.getMetadataForRegion(b), e = this.canBeInternationallyDialled(a) && this.testNumberLength_(this.getNationalSignificantNumber(a), b) != i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL)) : e = (f == i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY || ("MX" == f || "CL" == 
    f || "UZ" == f) && e) && this.canBeInternationallyDialled(a) ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
  } else {
    if (h && this.canBeInternationallyDialled(a)) {
      return c ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.E164);
    }
  }
  return c ? e : i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(e);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryCallingNumber = function(a, b) {
  if (!this.isValidRegionCode_(b)) {
    return this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
  }
  var c = a.getCountryCodeOrDefault(), d = this.getNationalSignificantNumber(a);
  if (!this.hasValidCountryCallingCode_(c)) {
    return d;
  }
  if (c == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
    if (this.isNANPACountry(b)) {
      return c + " " + this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
    }
  } else {
    if (c == this.getCountryCodeForValidRegion_(b)) {
      return this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
    }
  }
  var e = this.getMetadataForRegion(b), f = e.getInternationalPrefixOrDefault(), g = "";
  i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_, f) ? g = f : e.hasPreferredInternationalPrefix() && (g = e.getPreferredInternationalPrefixOrDefault());
  e = this.getRegionCodeForCountryCode(c);
  e = this.getMetadataForRegionOrCallingCode_(c, e);
  d = this.formatNsn_(d, e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
  e = this.maybeGetFormattedExtension_(a, e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
  return 0 < g.length ? g + " " + c + " " + d + e : this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL, d, e);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatInOriginalFormat = function(a, b) {
  if (a.hasRawInput() && !this.hasFormattingPatternForNumber_(a)) {
    return a.getRawInputOrDefault();
  }
  if (!a.hasCountryCodeSource()) {
    return this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
  }
  switch(a.getCountryCodeSource()) {
    case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN:
      var c = this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
      break;
    case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD:
      c = this.formatOutOfCountryCallingNumber(a, b);
      break;
    case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN:
      c = this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).substring(1);
      break;
    default:
      var d = this.getRegionCodeForCountryCode(a.getCountryCodeOrDefault()), e = this.getNddPrefixForRegion(d, !0);
      c = this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
      if (null != e && 0 != e.length && !this.rawInputContainsNationalPrefix_(a.getRawInputOrDefault(), e, d) && (d = this.getMetadataForRegion(d), e = this.getNationalSignificantNumber(a), d = this.chooseFormattingPatternForNumber_(d.numberFormatArray(), e), null != d)) {
        e = d.getNationalPrefixFormattingRuleOrDefault();
        var f = e.indexOf("$1");
        0 >= f || (e = e.substring(0, f), e = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(e), 0 != e.length && (c = d.clone(), c.clearNationalPrefixFormattingRule(), c = this.formatByPattern(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, [c])));
      }
  }
  d = a.getRawInputOrDefault();
  null != c && 0 < d.length && (e = i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(c), f = i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(d), e != f && (c = d));
  return c;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.rawInputContainsNationalPrefix_ = function(a, b, c) {
  a = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a);
  if (goog.string.startsWith(a, b)) {
    try {
      return this.isValidNumber(this.parse(a.substring(b.length), c));
    } catch (d) {
    }
  }
  return !1;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.hasFormattingPatternForNumber_ = function(a) {
  var b = a.getCountryCodeOrDefault(), c = this.getRegionCodeForCountryCode(b);
  b = this.getMetadataForRegionOrCallingCode_(b, c);
  if (null == b) {
    return !1;
  }
  a = this.getNationalSignificantNumber(a);
  return null != this.chooseFormattingPatternForNumber_(b.numberFormatArray(), a);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryKeepingAlphaChars = function(a, b) {
  var c = a.getRawInputOrDefault();
  if (0 == c.length) {
    return this.formatOutOfCountryCallingNumber(a, b);
  }
  var d = a.getCountryCodeOrDefault();
  if (!this.hasValidCountryCallingCode_(d)) {
    return c;
  }
  c = i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(c, i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_, !0);
  var e = this.getNationalSignificantNumber(a);
  if (3 < e.length) {
    var f = c.indexOf(e.substring(0, 3));
    -1 != f && (c = c.substring(f));
  }
  f = this.getMetadataForRegion(b);
  if (d == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
    if (this.isNANPACountry(b)) {
      return d + " " + c;
    }
  } else {
    if (null != f && d == this.getCountryCodeForValidRegion_(b)) {
      d = this.chooseFormattingPatternForNumber_(f.numberFormatArray(), e);
      if (null == d) {
        return c;
      }
      d = d.clone();
      d.setPattern("(\\d+)(.*)");
      d.setFormat("$1$2");
      return this.formatNsnUsingPattern_(c, d, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
    }
  }
  e = "";
  null != f && (e = f.getInternationalPrefixOrDefault(), e = i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_, e) ? e : f.getPreferredInternationalPrefixOrDefault());
  f = this.getRegionCodeForCountryCode(d);
  f = this.getMetadataForRegionOrCallingCode_(d, f);
  f = this.maybeGetFormattedExtension_(a, f, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
  return 0 < e.length ? e + " " + d + " " + c + f : this.prefixNumberWithCountryCallingCode_(d, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL, c, f);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNationalSignificantNumber = function(a) {
  if (!a.hasNationalNumber()) {
    return "";
  }
  var b = "" + a.getNationalNumber();
  return a.hasItalianLeadingZero() && a.getItalianLeadingZero() && 0 < a.getNumberOfLeadingZerosOrDefault() ? Array(a.getNumberOfLeadingZerosOrDefault() + 1).join("0") + b : b;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.prefixNumberWithCountryCallingCode_ = function(a, b, c, d) {
  switch(b) {
    case i18n.phonenumbers.PhoneNumberFormat.E164:
      return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + c + d;
    case i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL:
      return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + " " + c + d;
    case i18n.phonenumbers.PhoneNumberFormat.RFC3966:
      return i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + "-" + c + d;
    default:
      return c + d;
  }
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsn_ = function(a, b, c, d) {
  b = 0 == b.intlNumberFormatArray().length || c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL ? b.numberFormatArray() : b.intlNumberFormatArray();
  b = this.chooseFormattingPatternForNumber_(b, a);
  return null == b ? a : this.formatNsnUsingPattern_(a, b, c, d);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.chooseFormattingPatternForNumber_ = function(a, b) {
  for (var c, d = a.length, e = 0; e < d; ++e) {
    c = a[e];
    var f = c.leadingDigitsPatternCount();
    if (0 == f || 0 == b.search(c.getLeadingDigitsPattern(f - 1))) {
      if (f = new RegExp(c.getPattern()), i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, b)) {
        return c;
      }
    }
  }
  return null;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsnUsingPattern_ = function(a, b, c, d) {
  var e = b.getFormatOrDefault(), f = new RegExp(b.getPattern()), g = b.getDomesticCarrierCodeFormattingRuleOrDefault();
  c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL && null != d && 0 < d.length && 0 < g.length ? (b = g.replace(i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_, d), e = e.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, b), a = a.replace(f, e)) : (b = b.getNationalPrefixFormattingRuleOrDefault(), a = c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL && null != b && 0 < b.length ? a.replace(f, e.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, b)) : a.replace(f, e));
  c == i18n.phonenumbers.PhoneNumberFormat.RFC3966 && (a = a.replace(new RegExp("^" + i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_), ""), a = a.replace(new RegExp(i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_, "g"), "-"));
  return a;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumber = function(a) {
  return this.getExampleNumberForType(a, i18n.phonenumbers.PhoneNumberType.FIXED_LINE);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForType = function(a, b) {
  if (!this.isValidRegionCode_(a)) {
    return null;
  }
  var c = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(this.getMetadataForRegion(a), b);
  try {
    if (c.hasExampleNumber()) {
      return this.parse(c.getExampleNumber(), a);
    }
  } catch (d) {
  }
  return null;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForNonGeoEntity = function(a) {
  var b = this.getMetadataForNonGeographicalRegion(a);
  if (null != b && (b = goog.array.find([b.getMobile(), b.getTollFree(), b.getSharedCost(), b.getVoip(), b.getVoicemail(), b.getUan(), b.getPremiumRate()], function(a, b) {
    return a.hasExampleNumber();
  }), null != b)) {
    try {
      return this.parse("+" + a + b.getExampleNumber(), "ZZ");
    } catch (c) {
    }
  }
  return null;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeGetFormattedExtension_ = function(a, b, c) {
  return a.hasExtension() && 0 != a.getExtension().length ? c == i18n.phonenumbers.PhoneNumberFormat.RFC3966 ? i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + a.getExtension() : b.hasPreferredExtnPrefix() ? b.getPreferredExtnPrefix() + a.getExtensionOrDefault() : i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ + a.getExtensionOrDefault() : "";
};
i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_ = function(a, b) {
  switch(b) {
    case i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE:
      return a.getPremiumRate();
    case i18n.phonenumbers.PhoneNumberType.TOLL_FREE:
      return a.getTollFree();
    case i18n.phonenumbers.PhoneNumberType.MOBILE:
      return a.getMobile();
    case i18n.phonenumbers.PhoneNumberType.FIXED_LINE:
    case i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE:
      return a.getFixedLine();
    case i18n.phonenumbers.PhoneNumberType.SHARED_COST:
      return a.getSharedCost();
    case i18n.phonenumbers.PhoneNumberType.VOIP:
      return a.getVoip();
    case i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER:
      return a.getPersonalNumber();
    case i18n.phonenumbers.PhoneNumberType.PAGER:
      return a.getPager();
    case i18n.phonenumbers.PhoneNumberType.UAN:
      return a.getUan();
    case i18n.phonenumbers.PhoneNumberType.VOICEMAIL:
      return a.getVoicemail();
    default:
      return a.getGeneralDesc();
  }
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberType = function(a) {
  var b = this.getRegionCodeForNumber(a);
  b = this.getMetadataForRegionOrCallingCode_(a.getCountryCodeOrDefault(), b);
  if (null == b) {
    return i18n.phonenumbers.PhoneNumberType.UNKNOWN;
  }
  a = this.getNationalSignificantNumber(a);
  return this.getNumberTypeHelper_(a, b);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberTypeHelper_ = function(a, b) {
  return this.isNumberMatchingDesc_(a, b.getGeneralDesc()) ? this.isNumberMatchingDesc_(a, b.getPremiumRate()) ? i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE : this.isNumberMatchingDesc_(a, b.getTollFree()) ? i18n.phonenumbers.PhoneNumberType.TOLL_FREE : this.isNumberMatchingDesc_(a, b.getSharedCost()) ? i18n.phonenumbers.PhoneNumberType.SHARED_COST : this.isNumberMatchingDesc_(a, b.getVoip()) ? i18n.phonenumbers.PhoneNumberType.VOIP : this.isNumberMatchingDesc_(a, b.getPersonalNumber()) ? i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER : 
  this.isNumberMatchingDesc_(a, b.getPager()) ? i18n.phonenumbers.PhoneNumberType.PAGER : this.isNumberMatchingDesc_(a, b.getUan()) ? i18n.phonenumbers.PhoneNumberType.UAN : this.isNumberMatchingDesc_(a, b.getVoicemail()) ? i18n.phonenumbers.PhoneNumberType.VOICEMAIL : this.isNumberMatchingDesc_(a, b.getFixedLine()) ? b.getSameMobileAndFixedLinePattern() || this.isNumberMatchingDesc_(a, b.getMobile()) ? i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE : i18n.phonenumbers.PhoneNumberType.FIXED_LINE : 
  !b.getSameMobileAndFixedLinePattern() && this.isNumberMatchingDesc_(a, b.getMobile()) ? i18n.phonenumbers.PhoneNumberType.MOBILE : i18n.phonenumbers.PhoneNumberType.UNKNOWN : i18n.phonenumbers.PhoneNumberType.UNKNOWN;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegion = function(a) {
  if (null == a) {
    return null;
  }
  a = a.toUpperCase();
  var b = this.regionToMetadataMap[a];
  if (null == b) {
    b = new goog.proto2.PbLiteSerializer;
    var c = i18n.phonenumbers.metadata.countryToMetadata[a];
    if (null == c) {
      return null;
    }
    b = b.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(), c);
    this.regionToMetadataMap[a] = b;
  }
  return b;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForNonGeographicalRegion = function(a) {
  return this.getMetadataForRegion("" + a);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatchingDesc_ = function(a, b) {
  var c = a.length;
  return 0 < b.possibleLengthCount() && -1 == goog.array.indexOf(b.possibleLengthArray(), c) ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(b.getNationalNumberPatternOrDefault(), a);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumber = function(a) {
  var b = this.getRegionCodeForNumber(a);
  return this.isValidNumberForRegion(a, b);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumberForRegion = function(a, b) {
  var c = a.getCountryCodeOrDefault(), d = this.getMetadataForRegionOrCallingCode_(c, b);
  if (null == d || i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY != b && c != this.getCountryCodeForValidRegion_(b)) {
    return !1;
  }
  c = this.getNationalSignificantNumber(a);
  return this.getNumberTypeHelper_(c, d) != i18n.phonenumbers.PhoneNumberType.UNKNOWN;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumber = function(a) {
  if (null == a) {
    return null;
  }
  var b = a.getCountryCodeOrDefault();
  b = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[b];
  return null == b ? null : 1 == b.length ? b[0] : this.getRegionCodeForNumberFromRegionList_(a, b);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumberFromRegionList_ = function(a, b) {
  for (var c = this.getNationalSignificantNumber(a), d, e = b.length, f = 0; f < e; f++) {
    d = b[f];
    var g = this.getMetadataForRegion(d);
    if (g.hasLeadingDigits()) {
      if (0 == c.search(g.getLeadingDigits())) {
        return d;
      }
    } else {
      if (this.getNumberTypeHelper_(c, g) != i18n.phonenumbers.PhoneNumberType.UNKNOWN) {
        return d;
      }
    }
  }
  return null;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForCountryCode = function(a) {
  a = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a];
  return null == a ? i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ : a[0];
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodesForCountryCode = function(a) {
  a = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a];
  return null == a ? [] : a;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForRegion = function(a) {
  return this.isValidRegionCode_(a) ? this.getCountryCodeForValidRegion_(a) : 0;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForValidRegion_ = function(a) {
  var b = this.getMetadataForRegion(a);
  if (null == b) {
    throw Error("Invalid region code: " + a);
  }
  return b.getCountryCodeOrDefault();
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNddPrefixForRegion = function(a, b) {
  var c = this.getMetadataForRegion(a);
  if (null == c) {
    return null;
  }
  c = c.getNationalPrefixOrDefault();
  if (0 == c.length) {
    return null;
  }
  b && (c = c.replace("~", ""));
  return c;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNANPACountry = function(a) {
  return null != a && goog.array.contains(i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_], a.toUpperCase());
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isAlphaNumber = function(a) {
  if (!i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(a)) {
    return !1;
  }
  a = new goog.string.StringBuffer(a);
  this.maybeStripExtension(a);
  return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, a.toString());
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumber = function(a) {
  a = this.isPossibleNumberWithReason(a);
  return a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForType = function(a, b) {
  var c = this.isPossibleNumberForTypeWithReason(a, b);
  return c == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || c == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLength_ = function(a, b) {
  return this.testNumberLengthForType_(a, b, i18n.phonenumbers.PhoneNumberType.UNKNOWN);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLengthForType_ = function(a, b, c) {
  var d = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, c), e = 0 == d.possibleLengthCount() ? b.getGeneralDesc().possibleLengthArray() : d.possibleLengthArray();
  d = d.possibleLengthLocalOnlyArray();
  if (c == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE) {
    if (i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, i18n.phonenumbers.PhoneNumberType.FIXED_LINE))) {
      c = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, i18n.phonenumbers.PhoneNumberType.MOBILE), i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(c) && (e = e.concat(0 == c.possibleLengthCount() ? b.getGeneralDesc().possibleLengthArray() : c.possibleLengthArray()), goog.array.sort(e), 0 == d.length ? d = c.possibleLengthLocalOnlyArray() : (d = d.concat(c.possibleLengthLocalOnlyArray()), goog.array.sort(d)));
    } else {
      return this.testNumberLengthForType_(a, b, i18n.phonenumbers.PhoneNumberType.MOBILE);
    }
  }
  if (-1 == e[0]) {
    return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH;
  }
  a = a.length;
  if (-1 < goog.array.indexOf(d, a)) {
    return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
  }
  b = e[0];
  return b == a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : b > a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT : e[e.length - 1] < a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG : -1 < goog.array.indexOf(e, a, 1) ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberWithReason = function(a) {
  return this.isPossibleNumberForTypeWithReason(a, i18n.phonenumbers.PhoneNumberType.UNKNOWN);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForTypeWithReason = function(a, b) {
  var c = this.getNationalSignificantNumber(a), d = a.getCountryCodeOrDefault();
  if (!this.hasValidCountryCallingCode_(d)) {
    return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_COUNTRY_CODE;
  }
  var e = this.getRegionCodeForCountryCode(d);
  d = this.getMetadataForRegionOrCallingCode_(d, e);
  return this.testNumberLengthForType_(c, d, b);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberString = function(a, b) {
  try {
    return this.isPossibleNumber(this.parse(a, b));
  } catch (c) {
    return !1;
  }
};
i18n.phonenumbers.PhoneNumberUtil.prototype.truncateTooLongNumber = function(a) {
  if (this.isValidNumber(a)) {
    return !0;
  }
  var b = a.clone(), c = a.getNationalNumberOrDefault();
  do {
    if (c = Math.floor(c / 10), b.setNationalNumber(c), 0 == c || this.isPossibleNumberWithReason(b) == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT) {
      return !1;
    }
  } while (!this.isValidNumber(b));
  a.setNationalNumber(c);
  return !0;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.extractCountryCode = function(a, b) {
  var c = a.toString();
  if (0 == c.length || "0" == c.charAt(0)) {
    return 0;
  }
  for (var d, e = c.length, f = 1; f <= i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ && f <= e; ++f) {
    if (d = parseInt(c.substring(0, f), 10), d in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap) {
      return b.append(c.substring(f)), d;
    }
  }
  return 0;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeExtractCountryCode = function(a, b, c, d, e) {
  if (0 == a.length) {
    return 0;
  }
  a = new goog.string.StringBuffer(a);
  var f;
  null != b && (f = b.getInternationalPrefix());
  null == f && (f = "NonMatch");
  f = this.maybeStripInternationalPrefixAndNormalize(a, f);
  d && e.setCountryCodeSource(f);
  if (f != i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY) {
    if (a.getLength() <= i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) {
      throw Error(i18n.phonenumbers.Error.TOO_SHORT_AFTER_IDD);
    }
    b = this.extractCountryCode(a, c);
    if (0 != b) {
      return e.setCountryCode(b), b;
    }
    throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
  }
  if (null != b) {
    f = b.getCountryCodeOrDefault();
    var g = "" + f, h = a.toString();
    if (goog.string.startsWith(h, g) && (g = new goog.string.StringBuffer(h.substring(g.length)), h = b.getGeneralDesc(), h = new RegExp(h.getNationalNumberPatternOrDefault()), this.maybeStripNationalPrefixAndCarrierCode(g, b, null), g = g.toString(), !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(h, a.toString()) && i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(h, g) || this.testNumberLength_(a.toString(), b) == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG)) {
      return c.append(g), d && e.setCountryCodeSource(i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN), e.setCountryCode(f), f;
    }
  }
  e.setCountryCode(0);
  return 0;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.parsePrefixAsIdd_ = function(a, b) {
  var c = b.toString();
  if (0 == c.search(a)) {
    var d = c.match(a)[0].length, e = c.substring(d).match(i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN);
    if (e && null != e[1] && 0 < e[1].length && "0" == i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(e[1])) {
      return !1;
    }
    b.clear();
    b.append(c.substring(d));
    return !0;
  }
  return !1;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripInternationalPrefixAndNormalize = function(a, b) {
  var c = a.toString();
  if (0 == c.length) {
    return i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY;
  }
  if (i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(c)) {
    return c = c.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN, ""), a.clear(), a.append(i18n.phonenumbers.PhoneNumberUtil.normalize(c)), i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN;
  }
  c = new RegExp(b);
  i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(a);
  return this.parsePrefixAsIdd_(c, a) ? i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD : i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripNationalPrefixAndCarrierCode = function(a, b, c) {
  var d = a.toString(), e = d.length, f = b.getNationalPrefixForParsing();
  if (0 == e || null == f || 0 == f.length) {
    return !1;
  }
  var g = new RegExp("^(?:" + f + ")");
  if (e = g.exec(d)) {
    f = new RegExp(b.getGeneralDesc().getNationalNumberPatternOrDefault());
    var h = i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, d), k = e.length - 1;
    b = b.getNationalPrefixTransformRule();
    if (null == b || 0 == b.length || null == e[k] || 0 == e[k].length) {
      if (h && !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, d.substring(e[0].length))) {
        return !1;
      }
      null != c && 0 < k && null != e[k] && c.append(e[1]);
      a.set(d.substring(e[0].length));
    } else {
      d = d.replace(g, b);
      if (h && !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, d)) {
        return !1;
      }
      null != c && 0 < k && c.append(e[1]);
      a.set(d);
    }
    return !0;
  }
  return !1;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripExtension = function(a) {
  var b = a.toString(), c = b.search(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_);
  if (0 <= c && i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(b.substring(0, c))) {
    for (var d = b.match(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_), e = d.length, f = 1; f < e; ++f) {
      if (null != d[f] && 0 < d[f].length) {
        return a.clear(), a.append(b.substring(0, c)), d[f];
      }
    }
  }
  return "";
};
i18n.phonenumbers.PhoneNumberUtil.prototype.checkRegionForParsing_ = function(a, b) {
  return this.isValidRegionCode_(b) || null != a && 0 < a.length && i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(a);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.parse = function(a, b) {
  return this.parseHelper_(a, b, !1, !0);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.parseAndKeepRawInput = function(a, b) {
  if (!this.isValidRegionCode_(b) && 0 < a.length && a.charAt(0) != i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) {
    throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
  }
  return this.parseHelper_(a, b, !0, !0);
};
i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_ = function(a, b) {
  if (1 < a.length && "0" == a.charAt(0)) {
    b.setItalianLeadingZero(!0);
    for (var c = 1; c < a.length - 1 && "0" == a.charAt(c);) {
      c++;
    }
    1 != c && b.setNumberOfLeadingZeros(c);
  }
};
i18n.phonenumbers.PhoneNumberUtil.prototype.parseHelper_ = function(a, b, c, d) {
  if (null == a) {
    throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
  }
  if (a.length > i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_) {
    throw Error(i18n.phonenumbers.Error.TOO_LONG);
  }
  var e = new goog.string.StringBuffer;
  this.buildNationalNumberForParsing_(a, e);
  if (!i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(e.toString())) {
    throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
  }
  if (d && !this.checkRegionForParsing_(e.toString(), b)) {
    throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
  }
  d = new i18n.phonenumbers.PhoneNumber;
  c && d.setRawInput(a);
  a = this.maybeStripExtension(e);
  0 < a.length && d.setExtension(a);
  var f = this.getMetadataForRegion(b);
  a = new goog.string.StringBuffer;
  var g = 0, h = e.toString();
  try {
    g = this.maybeExtractCountryCode(h, f, a, c, d);
  } catch (k) {
    if (k.message == i18n.phonenumbers.Error.INVALID_COUNTRY_CODE && i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(h)) {
      if (h = h.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN, ""), g = this.maybeExtractCountryCode(h, f, a, c, d), 0 == g) {
        throw k;
      }
    } else {
      throw k;
    }
  }
  0 != g ? (e = this.getRegionCodeForCountryCode(g), e != b && (f = this.getMetadataForRegionOrCallingCode_(g, e))) : (i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(e), a.append(e.toString()), null != b ? (g = f.getCountryCodeOrDefault(), d.setCountryCode(g)) : c && d.clearCountryCodeSource());
  if (a.getLength() < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) {
    throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);
  }
  null != f && (b = new goog.string.StringBuffer, e = new goog.string.StringBuffer(a.toString()), this.maybeStripNationalPrefixAndCarrierCode(e, f, b), f = this.testNumberLength_(e.toString(), f), g = i18n.phonenumbers.PhoneNumberUtil.ValidationResult, f != g.TOO_SHORT && f != g.IS_POSSIBLE_LOCAL_ONLY && f != g.INVALID_LENGTH && (a = e, c && 0 < b.toString().length && d.setPreferredDomesticCarrierCode(b.toString())));
  c = a.toString();
  a = c.length;
  if (a < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) {
    throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);
  }
  if (a > i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_) {
    throw Error(i18n.phonenumbers.Error.TOO_LONG);
  }
  i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_(c, d);
  d.setNationalNumber(parseInt(c, 10));
  return d;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.buildNationalNumberForParsing_ = function(a, b) {
  var c = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);
  if (0 <= c) {
    var d = c + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_.length;
    if (a.charAt(d) == i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) {
      var e = a.indexOf(";", d);
      0 < e ? b.append(a.substring(d, e)) : b.append(a.substring(d));
    }
    d = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_);
    b.append(a.substring(0 <= d ? d + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_.length : 0, c));
  } else {
    b.append(i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(a));
  }
  c = b.toString();
  d = c.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_);
  0 < d && (b.clear(), b.append(c.substring(0, d)));
};
i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_ = function(a) {
  var b = new i18n.phonenumbers.PhoneNumber;
  b.setCountryCode(a.getCountryCodeOrDefault());
  b.setNationalNumber(a.getNationalNumberOrDefault());
  0 < a.getExtensionOrDefault().length && b.setExtension(a.getExtensionOrDefault());
  a.getItalianLeadingZero() && (b.setItalianLeadingZero(!0), b.setNumberOfLeadingZeros(a.getNumberOfLeadingZerosOrDefault()));
  return b;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatch = function(a, b) {
  if ("string" == typeof a) {
    try {
      var c = this.parse(a, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_);
    } catch (g) {
      if (g.message != i18n.phonenumbers.Error.INVALID_COUNTRY_CODE) {
        return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
      }
      if ("string" != typeof b) {
        var d = this.getRegionCodeForCountryCode(b.getCountryCodeOrDefault());
        if (d != i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_) {
          try {
            c = this.parse(a, d);
          } catch (h) {
            return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
          }
          c = this.isNumberMatch(c, b);
          return c == i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : c;
        }
      }
      try {
        c = this.parseHelper_(a, null, !1, !1);
      } catch (h) {
        return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
      }
    }
  } else {
    c = a.clone();
  }
  if ("string" == typeof b) {
    try {
      var e = this.parse(b, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_);
      return this.isNumberMatch(a, e);
    } catch (g) {
      return g.message != i18n.phonenumbers.Error.INVALID_COUNTRY_CODE ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER : this.isNumberMatch(b, c);
    }
  } else {
    e = b.clone();
  }
  c = i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(c);
  e = i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(e);
  if (c.hasExtension() && e.hasExtension() && c.getExtension() != e.getExtension()) {
    return i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
  }
  d = c.getCountryCodeOrDefault();
  var f = e.getCountryCodeOrDefault();
  if (0 != d && 0 != f) {
    return c.equals(e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH : d == f && this.isNationalNumberSuffixOfTheOther_(c, e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
  }
  c.setCountryCode(0);
  e.setCountryCode(0);
  return c.equals(e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : this.isNationalNumberSuffixOfTheOther_(c, e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNationalNumberSuffixOfTheOther_ = function(a, b) {
  var c = "" + a.getNationalNumber(), d = "" + b.getNationalNumber();
  return goog.string.endsWith(c, d) || goog.string.endsWith(d, c);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.canBeInternationallyDialled = function(a) {
  var b = this.getMetadataForRegion(this.getRegionCodeForNumber(a));
  if (null == b) {
    return !0;
  }
  a = this.getNationalSignificantNumber(a);
  return !this.isNumberMatchingDesc_(a, b.getNoInternationalDialling());
};
i18n.phonenumbers.PhoneNumberUtil.matchesEntirely = function(a, b) {
  var c = "string" == typeof a ? b.match("^(?:" + a + ")$") : b.match(a);
  return c && c[0].length == b.length ? !0 : !1;
};
i18n.phonenumbers.PhoneNumberUtil.matchesPrefix = function(a, b) {
  var c = "string" == typeof a ? b.match("^(?:" + a + ")") : b.match(a);
  return c && goog.string.startsWith(b, c[0]) ? !0 : !1;
};
i18n.phonenumbers.AsYouTypeFormatter = function(a) {
  this.DIGIT_PLACEHOLDER_ = "\u2008";
  this.DIGIT_PATTERN_ = new RegExp(this.DIGIT_PLACEHOLDER_);
  this.currentOutput_ = "";
  this.formattingTemplate_ = new goog.string.StringBuffer;
  this.currentFormattingPattern_ = "";
  this.accruedInput_ = new goog.string.StringBuffer;
  this.accruedInputWithoutFormatting_ = new goog.string.StringBuffer;
  this.ableToFormat_ = !0;
  this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = this.inputHasFormatting_ = !1;
  this.phoneUtil_ = i18n.phonenumbers.PhoneNumberUtil.getInstance();
  this.positionToRemember_ = this.originalPosition_ = this.lastMatchPosition_ = 0;
  this.prefixBeforeNationalNumber_ = new goog.string.StringBuffer;
  this.shouldAddSpaceAfterNationalPrefix_ = !1;
  this.extractedNationalPrefix_ = "";
  this.nationalNumber_ = new goog.string.StringBuffer;
  this.possibleFormats_ = [];
  this.defaultCountry_ = a;
  this.defaultMetadata_ = this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_);
};
i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ = " ";
i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_ = new i18n.phonenumbers.PhoneMetadata;
i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_.setInternationalPrefix("NA");
i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_ = new RegExp("^[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*(\\$\\d[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*)+$");
i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_ = /[- ]/;
i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ = 3;
i18n.phonenumbers.AsYouTypeFormatter.prototype.getMetadataForRegion_ = function(a) {
  a = this.phoneUtil_.getCountryCodeForRegion(a);
  a = this.phoneUtil_.getRegionCodeForCountryCode(a);
  a = this.phoneUtil_.getMetadataForRegion(a);
  return null != a ? a : i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.maybeCreateNewTemplate_ = function() {
  for (var a = this.possibleFormats_.length, b = 0; b < a; ++b) {
    var c = this.possibleFormats_[b], d = c.getPatternOrDefault();
    if (this.currentFormattingPattern_ == d) {
      return !1;
    }
    if (this.createFormattingTemplate_(c)) {
      return this.currentFormattingPattern_ = d, this.shouldAddSpaceAfterNationalPrefix_ = i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(c.getNationalPrefixFormattingRule()), this.lastMatchPosition_ = 0, !0;
    }
  }
  return this.ableToFormat_ = !1;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.getAvailableFormats_ = function(a) {
  for (var b = this.isCompleteNumber_ && 0 == this.extractedNationalPrefix_.length && 0 < this.currentMetadata_.intlNumberFormatCount() ? this.currentMetadata_.intlNumberFormatArray() : this.currentMetadata_.numberFormatArray(), c = b.length, d = 0; d < c; ++d) {
    var e = b[d];
    0 < this.extractedNationalPrefix_.length && this.phoneUtil_.formattingRuleHasFirstGroupOnly(e.getNationalPrefixFormattingRuleOrDefault()) && !e.getNationalPrefixOptionalWhenFormatting() && !e.hasDomesticCarrierCodeFormattingRule() || (0 != this.extractedNationalPrefix_.length || this.isCompleteNumber_ || this.phoneUtil_.formattingRuleHasFirstGroupOnly(e.getNationalPrefixFormattingRuleOrDefault()) || e.getNationalPrefixOptionalWhenFormatting()) && i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_.test(e.getFormatOrDefault()) && 
    this.possibleFormats_.push(e);
  }
  this.narrowDownPossibleFormats_(a);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.narrowDownPossibleFormats_ = function(a) {
  for (var b = [], c = a.length - i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_, d = this.possibleFormats_.length, e = 0; e < d; ++e) {
    var f = this.possibleFormats_[e];
    if (0 == f.leadingDigitsPatternCount()) {
      b.push(this.possibleFormats_[e]);
    } else {
      var g = Math.min(c, f.leadingDigitsPatternCount() - 1);
      f = f.getLeadingDigitsPattern(g);
      0 == a.search(f) && b.push(this.possibleFormats_[e]);
    }
  }
  this.possibleFormats_ = b;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.createFormattingTemplate_ = function(a) {
  var b = a.getPatternOrDefault();
  this.formattingTemplate_.clear();
  a = this.getFormattingTemplate_(b, a.getFormatOrDefault());
  return 0 < a.length ? (this.formattingTemplate_.append(a), !0) : !1;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.getFormattingTemplate_ = function(a, b) {
  var c = "999999999999999".match(a)[0];
  if (c.length < this.nationalNumber_.getLength()) {
    return "";
  }
  c = c.replace(new RegExp(a, "g"), b);
  return c = c.replace(RegExp("9", "g"), this.DIGIT_PLACEHOLDER_);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.clear = function() {
  this.currentOutput_ = "";
  this.accruedInput_.clear();
  this.accruedInputWithoutFormatting_.clear();
  this.formattingTemplate_.clear();
  this.lastMatchPosition_ = 0;
  this.currentFormattingPattern_ = "";
  this.prefixBeforeNationalNumber_.clear();
  this.extractedNationalPrefix_ = "";
  this.nationalNumber_.clear();
  this.ableToFormat_ = !0;
  this.inputHasFormatting_ = !1;
  this.originalPosition_ = this.positionToRemember_ = 0;
  this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = !1;
  this.possibleFormats_ = [];
  this.shouldAddSpaceAfterNationalPrefix_ = !1;
  this.currentMetadata_ != this.defaultMetadata_ && (this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_));
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigit = function(a) {
  return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(a, !1);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitAndRememberPosition = function(a) {
  return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(a, !0);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitWithOptionToRememberPosition_ = function(a, b) {
  this.accruedInput_.append(a);
  b && (this.originalPosition_ = this.accruedInput_.getLength());
  this.isDigitOrLeadingPlusSign_(a) ? a = this.normalizeAndAccrueDigitsAndPlusSign_(a, b) : (this.ableToFormat_ = !1, this.inputHasFormatting_ = !0);
  if (!this.ableToFormat_) {
    if (!this.inputHasFormatting_) {
      if (this.attemptToExtractIdd_()) {
        if (this.attemptToExtractCountryCallingCode_()) {
          return this.attemptToChoosePatternWithPrefixExtracted_();
        }
      } else {
        if (this.ableToExtractLongerNdd_()) {
          return this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.attemptToChoosePatternWithPrefixExtracted_();
        }
      }
    }
    return this.accruedInput_.toString();
  }
  switch(this.accruedInputWithoutFormatting_.getLength()) {
    case 0:
    case 1:
    case 2:
      return this.accruedInput_.toString();
    case 3:
      if (this.attemptToExtractIdd_()) {
        this.isExpectingCountryCallingCode_ = !0;
      } else {
        return this.extractedNationalPrefix_ = this.removeNationalPrefixFromNationalNumber_(), this.attemptToChooseFormattingPattern_();
      }
    default:
      if (this.isExpectingCountryCallingCode_) {
        return this.attemptToExtractCountryCallingCode_() && (this.isExpectingCountryCallingCode_ = !1), this.prefixBeforeNationalNumber_.toString() + this.nationalNumber_.toString();
      }
      if (0 < this.possibleFormats_.length) {
        var c = this.inputDigitHelper_(a), d = this.attemptToFormatAccruedDigits_();
        if (0 < d.length) {
          return d;
        }
        this.narrowDownPossibleFormats_(this.nationalNumber_.toString());
        return this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.ableToFormat_ ? this.appendNationalNumber_(c) : this.accruedInput_.toString();
      }
      return this.attemptToChooseFormattingPattern_();
  }
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChoosePatternWithPrefixExtracted_ = function() {
  this.ableToFormat_ = !0;
  this.isExpectingCountryCallingCode_ = !1;
  this.possibleFormats_ = [];
  this.lastMatchPosition_ = 0;
  this.formattingTemplate_.clear();
  this.currentFormattingPattern_ = "";
  return this.attemptToChooseFormattingPattern_();
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.getExtractedNationalPrefix_ = function() {
  return this.extractedNationalPrefix_;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.ableToExtractLongerNdd_ = function() {
  if (0 < this.extractedNationalPrefix_.length) {
    var a = this.nationalNumber_.toString();
    this.nationalNumber_.clear();
    this.nationalNumber_.append(this.extractedNationalPrefix_);
    this.nationalNumber_.append(a);
    a = this.prefixBeforeNationalNumber_.toString();
    var b = a.lastIndexOf(this.extractedNationalPrefix_);
    this.prefixBeforeNationalNumber_.clear();
    this.prefixBeforeNationalNumber_.append(a.substring(0, b));
  }
  return this.extractedNationalPrefix_ != this.removeNationalPrefixFromNationalNumber_();
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.isDigitOrLeadingPlusSign_ = function(a) {
  return i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN.test(a) || 1 == this.accruedInput_.getLength() && i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN.test(a);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToFormatAccruedDigits_ = function() {
  for (var a = this.nationalNumber_.toString(), b = this.possibleFormats_.length, c = 0; c < b; ++c) {
    var d = this.possibleFormats_[c], e = d.getPatternOrDefault();
    if ((new RegExp("^(?:" + e + ")$")).test(a) && (this.shouldAddSpaceAfterNationalPrefix_ = i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(d.getNationalPrefixFormattingRule()), d = a.replace(new RegExp(e, "g"), d.getFormat()), d = this.appendNationalNumber_(d), i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(d) == this.accruedInputWithoutFormatting_)) {
      return d;
    }
  }
  return "";
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.appendNationalNumber_ = function(a) {
  var b = this.prefixBeforeNationalNumber_.getLength();
  return this.shouldAddSpaceAfterNationalPrefix_ && 0 < b && this.prefixBeforeNationalNumber_.toString().charAt(b - 1) != i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ ? this.prefixBeforeNationalNumber_ + i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ + a : this.prefixBeforeNationalNumber_ + a;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.getRememberedPosition = function() {
  if (!this.ableToFormat_) {
    return this.originalPosition_;
  }
  for (var a = 0, b = 0, c = this.accruedInputWithoutFormatting_.toString(), d = this.currentOutput_.toString(); a < this.positionToRemember_ && b < d.length;) {
    c.charAt(a) == d.charAt(b) && a++, b++;
  }
  return b;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChooseFormattingPattern_ = function() {
  var a = this.nationalNumber_.toString();
  return a.length >= i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ ? (this.getAvailableFormats_(a), a = this.attemptToFormatAccruedDigits_(), 0 < a.length ? a : this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.accruedInput_.toString()) : this.appendNationalNumber_(a);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputAccruedNationalNumber_ = function() {
  var a = this.nationalNumber_.toString(), b = a.length;
  if (0 < b) {
    for (var c = "", d = 0; d < b; d++) {
      c = this.inputDigitHelper_(a.charAt(d));
    }
    return this.ableToFormat_ ? this.appendNationalNumber_(c) : this.accruedInput_.toString();
  }
  return this.prefixBeforeNationalNumber_.toString();
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.isNanpaNumberWithNationalPrefix_ = function() {
  if (1 != this.currentMetadata_.getCountryCode()) {
    return !1;
  }
  var a = this.nationalNumber_.toString();
  return "1" == a.charAt(0) && "0" != a.charAt(1) && "1" != a.charAt(1);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.removeNationalPrefixFromNationalNumber_ = function() {
  var a = this.nationalNumber_.toString(), b = 0;
  if (this.isNanpaNumberWithNationalPrefix_()) {
    b = 1, this.prefixBeforeNationalNumber_.append("1").append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.isCompleteNumber_ = !0;
  } else {
    if (this.currentMetadata_.hasNationalPrefixForParsing()) {
      var c = new RegExp("^(?:" + this.currentMetadata_.getNationalPrefixForParsing() + ")");
      c = a.match(c);
      null != c && null != c[0] && 0 < c[0].length && (this.isCompleteNumber_ = !0, b = c[0].length, this.prefixBeforeNationalNumber_.append(a.substring(0, b)));
    }
  }
  this.nationalNumber_.clear();
  this.nationalNumber_.append(a.substring(b));
  return a.substring(0, b);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractIdd_ = function() {
  var a = this.accruedInputWithoutFormatting_.toString(), b = new RegExp("^(?:\\" + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + "|" + this.currentMetadata_.getInternationalPrefix() + ")");
  b = a.match(b);
  return null != b && null != b[0] && 0 < b[0].length ? (this.isCompleteNumber_ = !0, b = b[0].length, this.nationalNumber_.clear(), this.nationalNumber_.append(a.substring(b)), this.prefixBeforeNationalNumber_.clear(), this.prefixBeforeNationalNumber_.append(a.substring(0, b)), a.charAt(0) != i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN && this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), !0) : !1;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractCountryCallingCode_ = function() {
  if (0 == this.nationalNumber_.getLength()) {
    return !1;
  }
  var a = new goog.string.StringBuffer, b = this.phoneUtil_.extractCountryCode(this.nationalNumber_, a);
  if (0 == b) {
    return !1;
  }
  this.nationalNumber_.clear();
  this.nationalNumber_.append(a.toString());
  a = this.phoneUtil_.getRegionCodeForCountryCode(b);
  i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == a ? this.currentMetadata_ = this.phoneUtil_.getMetadataForNonGeographicalRegion(b) : a != this.defaultCountry_ && (this.currentMetadata_ = this.getMetadataForRegion_(a));
  this.prefixBeforeNationalNumber_.append("" + b).append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_);
  this.extractedNationalPrefix_ = "";
  return !0;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.normalizeAndAccrueDigitsAndPlusSign_ = function(a, b) {
  if (a == i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) {
    var c = a;
    this.accruedInputWithoutFormatting_.append(a);
  } else {
    c = i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS[a], this.accruedInputWithoutFormatting_.append(c), this.nationalNumber_.append(c);
  }
  b && (this.positionToRemember_ = this.accruedInputWithoutFormatting_.getLength());
  return c;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitHelper_ = function(a) {
  var b = this.formattingTemplate_.toString();
  if (0 <= b.substring(this.lastMatchPosition_).search(this.DIGIT_PATTERN_)) {
    var c = b.search(this.DIGIT_PATTERN_);
    a = b.replace(this.DIGIT_PATTERN_, a);
    this.formattingTemplate_.clear();
    this.formattingTemplate_.append(a);
    this.lastMatchPosition_ = c;
    return a.substring(0, this.lastMatchPosition_ + 1);
  }
  1 == this.possibleFormats_.length && (this.ableToFormat_ = !1);
  this.currentFormattingPattern_ = "";
  return this.accruedInput_.toString();
};
i18n.phonenumbers.shortnumbermetadata = {};
i18n.phonenumbers.shortnumbermetadata.countryCodeToRegionCodeMap = {0:"AC AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR ST SV SX SY SZ TC TD TG TH TJ TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW".split(" ")};
i18n.phonenumbers.shortnumbermetadata.countryToMetadata = {AC:[, [, , "9\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "AC", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], AD:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[0268]", , , , "110"], [, , , , , , , , , [-1]], , , , "AD", , , , , , , , , , , , , , , , , , [, , "11[0268]", , 
, , "110"], , [, , "11[0268]", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], AE:[, [, , "[149]\\d{2,3}", , , , , , , [3, 4]], , , [, , "112|99[7-9]", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "AE", , , , , , , , , , , , , , , , , , [, , "112|99[7-9]", , , , "112", , , [3]], , [, , "112|445[16]|99[7-9]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "445\\d", , , , "4450", , , [4]]], AF:[, [, , "[14]\\d\\d(?:\\d{2})?", 
, , , , , , [3, 5]], , , [, , "1(?:02|19)", , , , "102", , , [3]], [, , , , , , , , , [-1]], , , , "AF", , , , , , , , , , , , , , , , , , [, , "1(?:02|19)", , , , "102", , , [3]], , [, , "1(?:02|19)|40404", , , , "102"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]], AG:[, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "AG", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", 
, , , "911"], , [, , "176|9(?:11|99)", , , , "176"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]], AI:[, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "AI", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "176|911", , , , "176"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]], AL:[, [, , "[15]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1(?:2|6[01]\\d\\d)|2[7-9]|3[15]|41)", 
, , , "112", , , [3, 6]], [, , "5\\d{4}", , , , "50000", , , [5]], , , , "AL", , , , , , , , , , , , , , , , , , [, , "1(?:12|2[7-9])", , , , "112", , , [3]], , [, , "1(?:1(?:6(?:000|1(?:06|11|23))|8\\d\\d)|65\\d|89[12])|5\\d{4}|1(?:[1349]\\d|2[2-9])", , , , "110"], [, , , , , , , , , [-1]], [, , "123", , , , "123", , , [3]], , [, , "131|5\\d{4}", , , , "131", , , [3, 5]]], AM:[, [, , "[148]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "10[1-3]", , , , "101", , , [3]], [, , , , , , , , , [-1]], , , 
, "AM", , , , , , , , , , , , , , , , , , [, , "10[1-3]", , , , "101", , , [3]], , [, , "(?:1|8[1-7])\\d\\d|40404", , , , "100"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]], AO:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[235]", , , , "112"], [, , , , , , , , , [-1]], , , , "AO", , , , , , , , , , , , , , , , , , [, , "11[235]", , , , "112"], , [, , "11[235]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
, [, , , , , , , , , [-1]]], AR:[, [, , "[01389]\\d{1,4}", , , , , , , [2, 3, 4, 5]], , , [, , "000|1(?:0[0-35-7]|1[0245]|2[15]|9)|911", , , , "19", , , [2, 3]], [, , , , , , , , , [-1]], , , , "AR", , , , , , , , , , , , , , , , , , [, , "10[017]|911", , , , "100", , , [3]], , [, , "000|1(?:0[0-35-7]|1[02-5]|2[15]|9)|3372|89338|911", , , , "19"], [, , , , , , , , , [-1]], [, , "893\\d\\d", , , , "89300", , , [5]], , [, , "(?:337|893\\d)\\d", , , , "3370", , , [4, 5]]], AS:[, [, , "[49]\\d\\d(?:\\d{2})?", 
, , , , , , [3, 5]], , , [, , "911", , , , "911", , , [3]], [, , , , , , , , , [-1]], , , , "AS", , , , , , , , , , , , , , , , , , [, , "911", , , , "911", , , [3]], , [, , "40404|911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "404\\d\\d", , , , "40400", , , [5]]], AT:[, [, , "1\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "116\\d{3}|1(?:[12]2|33|44)", , , , "112"], [, , , , , , , , , [-1]], , , , "AT", , , , , , , , , , , , , , , , , , [, , "1(?:[12]2|33|44)", 
, , , "112", , , [3]], , [, , "116(?:00[06]|1(?:17|23))|1(?:[12]2|33|44)", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], AU:[, [, , "[0-27]\\d{2,7}", , , , , , , [3, 4, 5, 6, 7, 8]], , , [, , "000|1(?:06|12|258885|55\\d)|733", , , , "000", , , [3, 4, 7]], [, , "1(?:2(?:34|456)|9\\d{4,6})", , , , "1234", , , [4, 5, 6, 7, 8]], , , , "AU", , , , , , , , , , , , , , , , , , [, , "000|1(?:06|12)", , , , "000", , , [3]], , [, , "000|1(?:06|1(?:00|2|9[46])|2(?:[23]\\d|(?:4|5\\d)\\d{2,3}|8(?:[013-9]\\d|2))|555|9\\d{4,6})|225|7(?:33|67)", 
, , , "000"], [, , "1(?:1[09]\\d|24733)|225|767", , , , "225", , , [3, 4, 6]], [, , "1(?:258885|55\\d)", , , , "1550", , , [4, 7]], , [, , "19\\d{4,6}", , , , "190000", , , [6, 7, 8]]], AW:[, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "100|911", , , , "100"], [, , , , , , , , , [-1]], , , , "AW", , , , , , , , , , , , , , , , , , [, , "100|911", , , , "100"], , [, , "1(?:00|76)|911", , , , "100"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]], AX:[, [, , "[17]\\d\\d(?:\\d{2})?", 
, , , , , , [3, 5]], , , [, , "112", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "AX", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "112|75[12]\\d\\d", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], AZ:[, [, , "[148]\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:0[1-3]|12)", , , , "101", , , [3]], [, , , , , , , , , [-1]], , , , "AZ", , , , , , , , , , , , , , , , , , [, , "1(?:0[1-3]|12)", , , , "101", , , [3]], 
, [, , "1(?:0[1-3]|12)|(?:404|880)0", , , , "101"], [, , , , , , , , , [-1]], [, , "(?:404|880)\\d", , , , "4040", , , [4]], , [, , "(?:404|880)\\d", , , , "4040", , , [4]]], BA:[, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:16\\d{3}|2[2-4])", , , , "122", , , [3, 6]], [, , , , , , , , , [-1]], , , , "BA", , , , , , , , , , , , , , , , , , [, , "12[2-4]", , , , "122", , , [3]], , [, , "1(?:16(?:00[06]|1(?:1[17]|23))|2(?:0[0-7]|[2-5]|6[0-26])|(?:[3-5]|7\\d)\\d\\d)|1(?:18|2[78])\\d\\d?", 
, , , "122"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], BB:[, [, , "[2-689]\\d\\d", , , , , , , [3]], , , [, , "[2359]11", , , , "211"], [, , , , , , , , , [-1]], , , , "BB", , , , , , , , , , , , , , , , , , [, , "[2359]11", , , , "211"], , [, , "[2-689]11", , , , "211"], [, , , , , , , , , [-1]], [, , "[468]11", , , , "411"], , [, , , , , , , , , [-1]]], BD:[, [, , "[1579]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "10[0-26]|[19]99", , , , "100", , , [3]], 
[, , , , , , , , , [-1]], , , , "BD", , , , , , , , , , , , , , , , , , [, , "10[0-2]|[19]99", , , , "100", , , [3]], , [, , "1(?:0(?:[0-369]|5[1-4]|7[0-4]|8[0-29])|1[16-9]|2(?:[134]|2[0-5])|3(?:1\\d?|6[3-6])|5[2-9])|5012|786|9594|[19]99|1(?:0(?:50|6\\d)|33|4(?:0|1\\d))\\d", , , , "100"], [, , , , , , , , , [-1]], [, , "1(?:11|2[13])|(?:501|959)\\d|786", , , , "111", , , [3, 4]], , [, , "959\\d", , , , "9590", , , [4]]], BE:[, [, , "[1-9]\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, 
, "1(?:0[0-25-8]|1[02]|7(?:12|77)|813)|(?:116|8)\\d{3}", , , , "100"], [, , "1(?:2[03]|40)4|(?:1(?:[24]1|3[01])|[2-79]\\d\\d)\\d", , , , "1204", , , [4]], , , , "BE", , , , , , , , , , , , , , , , , , [, , "1(?:0[01]|12)", , , , "100", , , [3]], , [, , "1(?:0[0-8]|1(?:[027]|6117)|2(?:12|3[0-24])|313|414|5(?:1[05]|5[15]|66|95)|6(?:1[167]|36|6[16])|7(?:0[07]|1[27-9]|22|33|65|7[017])|81[39])|[2-9]\\d{3}|1(?:1600|45)0|1(?:[2-4]9|78)9|1[2-4]0[47]", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , 
, , , [-1]], , [, , "[2-9]\\d{3}", , , , "2000", , , [4]]], BF:[, [, , "1\\d", , , , , , , [2]], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "BF", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], BG:[, [, , "1\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "1(?:1(?:2|6\\d{3})|50|6[06])", , , , "112"], [, , , , , , , , , [-1]], , , , "BG", , , , , , , , , , 
, , , , , , , , [, , "1(?:12|50|6[06])", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:000|111))|50|6[06])", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], BH:[, [, , "[0189]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "(?:0[167]|81)\\d{3}|[19]99", , , , "199"], [, , "9[148]\\d{3}", , , , "91000", , , [5]], , , , "BH", , , , , , , , , , , , , , , , , , [, , "[19]99", , , , "199", , , [3]], , [, , "1(?:[02]\\d|12|4[01]|51|8[18]|9[169])|99[02489]|(?:0[167]|8[158]|9[148])\\d{3}", 
, , , "100"], [, , , , , , , , , [-1]], [, , "0[67]\\d{3}|88000|98555", , , , "06000", , , [5]], , [, , "88000|98555", , , , "88000", , , [5]]], BI:[, [, , "[16-9]\\d{2,3}", , , , , , , [3, 4]], , , [, , "11[237]|611", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "BI", , , , , , , , , , , , , , , , , , [, , "11[237]", , , , "112", , , [3]], , [, , "1(?:1\\d|5[2-9]|6[0-256])|611|7(?:10|77|979)|8[28]8|900", , , , "110"], [, , , , , , , , , [-1]], [, , "611|7(?:10|77)|888|900", , , , "611", 
, , [3]], , [, , "(?:71|90)0", , , , "710", , , [3]]], BJ:[, [, , "[17]\\d{2,3}", , , , , , , [3, 4]], , , [, , "11[78]|7[3-5]\\d\\d", , , , "117"], [, , , , , , , , , [-1]], , , , "BJ", , , , , , , , , , , , , , , , , , [, , "11[78]", , , , "117", , , [3]], , [, , "1(?:1[78]|2[02-5]|60)|7[0-5]\\d\\d", , , , "117"], [, , , , , , , , , [-1]], [, , "12[02-5]", , , , "120", , , [3]], , [, , , , , , , , , [-1]]], BL:[, [, , "1\\d", , , , , , , [2]], , , [, , "18", , , , "18"], [, , , , , , , , , [-1]], 
, , , "BL", , , , , , , , , , , , , , , , , , [, , "18", , , , "18"], , [, , "18", , , , "18"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], BM:[, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "BM", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "176|911", , , , "176"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]], BN:[, [, , "9\\d\\d", , , , , , , [3]], 
, , [, , "99[135]", , , , "991"], [, , , , , , , , , [-1]], , , , "BN", , , , , , , , , , , , , , , , , , [, , "99[135]", , , , "991"], , [, , "99[135]", , , , "991"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], BO:[, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "11[089]", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "BO", , , , , , , , , , , , , , , , , , [, , "11[089]", , , , "110", , , [3]], , [, , "11[089]|40404", , , , "110"], [, 
, , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "404\\d\\d", , , , "40400", , , [5]]], BQ:[, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "112|911", , , , "112"], [, , , , , , , , , [-1]], , , , "BQ", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112"], , [, , "1(?:12|76)|911", , , , "112"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]], BR:[, [, , "[1-69]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:00|12|28|8[015]|9[0-47-9])|4(?:57|82\\d)|911", 
, , , "100", , , [3, 4]], [, , , , , , , , , [-1]], , , , "BR", , , , , , , , , , , , , , , , , , [, , "1(?:12|28|9[023])|911", , , , "112", , , [3]], , [, , "1(?:0(?:[02]|3(?:1[2-579]|2[13-9]|3[124-9]|4[1-3578]|5[1-468]|6[139]|8[149]|9[168])|5[0-35-9]|6(?:0|1[0-35-8]?|2[0145]|3[0137]?|4[37-9]?|5[0-35]|6[016]?|7[137]?|8[5-8]|9[1359]))|1[25-8]|2[357-9]|3[024-68]|4[12568]|5\\d|6[0-8]|8[015]|9[0-47-9])|2(?:7(?:330|878)|85959?)|(?:32|91)1|4(?:0404?|57|828)|55555|6(?:0\\d{4}|10000)|(?:133|411)[12]", , 
, , "100"], [, , "102|273\\d\\d|321", , , , "102", , , [3, 5]], [, , "151|(?:278|555)\\d\\d|4(?:04\\d\\d?|11\\d|57)", , , , "151", , , [3, 4, 5]], , [, , "285\\d{2,3}|321|40404|(?:27[38]\\d|482)\\d|6(?:0\\d|10)\\d{3}", , , , "321"]], BS:[, [, , "9\\d\\d", , , , , , , [3]], , , [, , "91[19]", , , , "911"], [, , , , , , , , , [-1]], , , , "BS", , , , , , , , , , , , , , , , , , [, , "91[19]", , , , "911"], , [, , "91[19]", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , 
, , , , , [-1]]], BT:[, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "11[023]", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "BT", , , , , , , , , , , , , , , , , , [, , "11[023]", , , , "110", , , [3]], , [, , "11[0-6]|40404", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "404\\d\\d", , , , "40400", , , [5]]], BW:[, [, , "[19]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "99[7-9]", , , , "997", , , [3]], [, , , , , , , , , [-1]], , , , "BW", 
, , , , , , , , , , , , , , , , , [, , "99[7-9]", , , , "997", , , [3]], , [, , "13123|99[7-9]", , , , "997"], [, , , , , , , , , [-1]], [, , "131\\d\\d", , , , "13100", , , [5]], , [, , "131\\d\\d", , , , "13100", , , [5]]], BY:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "1(?:0[1-3]|12)", , , , "101"], [, , , , , , , , , [-1]], , , , "BY", , , , , , , , , , , , , , , , , , [, , "1(?:0[1-3]|12)", , , , "101"], , [, , "1(?:0[1-79]|1[246]|35|5[1-35]|6[89]|7[5-7]|8[58]|9[1-7])", , , , "101"], [, , 
, , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], BZ:[, [, , "9\\d\\d?", , , , , , , [2, 3]], , , [, , "9(?:0|11)", , , , "90"], [, , , , , , , , , [-1]], , , , "BZ", , , , , , , , , , , , , , , , , , [, , "9(?:0|11)", , , , "90"], , [, , "9(?:0|11)", , , , "90"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CA:[, [, , "[1-9]\\d\\d(?:\\d\\d(?:\\d(?:\\d{2})?)?)?", , , , , , , [3, 5, 6, 8]], , , [, , "112|[29]11", , , , "112", , , [3]], 
[, , , , , , , , , [-1]], , , , "CA", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112", , , [3]], , [, , "112|30000\\d{3}|[1-35-9]\\d{4,5}|[2-9]11", , , , "112"], [, , , , , , , , , [-1]], [, , "[235-7]11", , , , "211", , , [3]], , [, , "300\\d{5}|[1-35-9]\\d{4,5}", , , , "10000", , , [5, 6, 8]]], CC:[, [, , "[01]\\d\\d", , , , , , , [3]], , , [, , "000|112", , , , "000"], [, , , , , , , , , [-1]], , , , "CC", , , , , , , , , , , , , , , , , , [, , "000|112", , , , "000"], , [, , "000|112", 
, , , "000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CD:[, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "1(?:1[348]|77|88)", , , , "113", , , [3]], [, , , , , , , , , [-1]], , , , "CD", , , , , , , , , , , , , , , , , , [, , "1(?:1[348]|77|88)", , , , "113", , , [3]], , [, , "1(?:1[348]|23|77|88)|40404", , , , "113"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]], CF:[, [, 
, "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[78]|22\\d)", , , , "117"], [, , , , , , , , , [-1]], , , , "CF", , , , , , , , , , , , , , , , , , [, , "1(?:1[78]|220)", , , , "117"], , [, , "1(?:1[478]|220)", , , , "114"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CG:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[178]", , , , "111"], [, , , , , , , , , [-1]], , , , "CG", , , , , , , , , , , , , , , , , , [, , "11[78]", , , , "117"], , [, , "11[126-8]", 
, , , "111"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CH:[, [, , "[1-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1(?:[278]|6\\d{3})|4[47])|5200", , , , "112", , , [3, 4, 6]], [, , "1(?:14|8[01589])\\d|543|83111", , , , "543", , , [3, 4, 5]], , , , "CH", , , , , , , , , , , , , , , , , , [, , "1(?:1[278]|44)", , , , "112", , , [3]], , [, , "1(?:0[78]\\d\\d|1(?:[278]|45|6(?:000|111))|4(?:[03-57]|1[45])|6(?:00|[1-46])|8(?:02|1[189]|50|7|8[08]|99))|[2-9]\\d{2,4}", 
, , , "112"], [, , "1(?:4[035]|6[1-46])|1(?:41|60)\\d", , , , "140", , , [3, 4]], [, , "5(?:200|35)", , , , "535", , , [3, 4]], , [, , "[2-9]\\d{2,4}", , , , "200", , , [3, 4, 5]]], CI:[, [, , "[14]\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[01]|[78]0)", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "CI", , , , , , , , , , , , , , , , , , [, , "1(?:1[01]|[78]0)", , , , "110", , , [3]], , [, , "1(?:1[01]|[78]0)|4443", , , , "110"], [, , , , , , , , , [-1]], [, , "444\\d", , , , "4440", 
, , [4]], , [, , "444\\d", , , , "4440", , , [4]]], CK:[, [, , "9\\d\\d", , , , , , , [3]], , , [, , "99[689]", , , , "996"], [, , , , , , , , , [-1]], , , , "CK", , , , , , , , , , , , , , , , , , [, , "99[689]", , , , "996"], , [, , "99[689]", , , , "996"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CL:[, [, , "[1-9]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:213|3[1-3])|434\\d|911", , , , "131", , , [3, 4]], [, , "1(?:211|3(?:13|[348]0|5[01]))|(?:1(?:[05]6|[48]1|9[18])|2(?:01\\d|[23]2|77|88)|3(?:0[59]|13|3[279]|66)|4(?:[12]4|36\\d|4[017]|55)|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d", 
, , , "1060", , , [4, 5]], , , , "CL", , , , , , , , , , , , , , , , , , [, , "13[1-3]|911", , , , "131", , , [3]], , [, , "1(?:00|21[13]|3(?:13|[348]0|5[01])|4(?:0[02-6]|17|[379])|818|919)|2(?:0(?:01|122)|22[47]|323|777|882)|3(?:0(?:51|99)|132|3(?:29|[37]7)|665)|43656|5(?:(?:00|415)4|5(?:66|77)|995)|6(?:131|222|366|699)|7878|8(?:011|11[28]|482|889)|9(?:01|1)1|13\\d|4(?:[13]42|243|4(?:02|15|77)|554)|(?:1(?:[05]6|98)|339|6(?:07|[35])0|9(?:[12]0|33))0", , , , "100"], [, , "(?:200|333)\\d", , , , "2000", 
, , [4]], [, , , , , , , , , [-1]], , [, , "13(?:13|[348]0|5[01])|(?:1(?:[05]6|[28]1|4[01]|9[18])|2(?:0(?:0|1\\d)|[23]2|77|88)|3(?:0[59]|13|3[2379]|66)|436\\d|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d|4(?:[1-3]4|4[017]|55)\\d", , , , "1060", , , [4, 5]]], CM:[, [, , "[18]\\d{1,3}", , , , , , , [2, 3, 4]], , , [, , "1(?:1[37]|[37])", , , , "13", , , [2, 3]], [, , , , , , , , , [-1]], , , , "CM", , , , , , , , , , , , , , , , , , [, , "1(?:1[37]|[37])", 
, , , "13", , , [2, 3]], , [, , "1(?:1[37]|[37])|8711", , , , "13"], [, , , , , , , , , [-1]], [, , "871\\d", , , , "8710", , , [4]], , [, , "871\\d", , , , "8710", , , [4]]], CN:[, [, , "[19]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [, , "1(?:1[09]|20)", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "CN", , , , , , , , , , , , , , , , , , [, , "1(?:1[09]|20)", , , , "110", , , [3]], , [, , "1(?:00\\d\\d|1[09]|20)|95\\d{3,4}", , , , "110"], [, , "100\\d\\d|95\\d{3,4}", , , , "10000", 
, , [5, 6]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CO:[, [, , "[148]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "1(?:1[29]|23|32|56)", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "CO", , , , , , , , , , , , , , , , , , [, , "1(?:1[29]|23|32|56)", , , , "112", , , [3]], , [, , "1(?:06|1[2569]|2[357]|3[27]|4[467]|5[36]|6[45]|95)|40404|85432", , , , "106"], [, , , , , , , , , [-1]], [, , "(?:40|85)4\\d\\d", , , , "40400", , , [5]], , [, , "(?:40|85)4\\d\\d", , , , "40400", 
, , [5]]], CR:[, [, , "[1359]\\d{2,3}", , , , , , , [3, 4]], , , [, , "112|911", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "CR", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112", , , [3]], , [, , "1(?:0(?:00|15|2[2-4679])|1(?:1[0-35-9]|2|37|[46]6|7[57]|8[79]|9[0-379])|2(?:00|[12]2|34|55)|3(?:21|33)|4(?:0[06]|1[4-6])|5(?:15|5[15])|693|7(?:00|1[7-9]|2[02]|[67]7)|975)|3855|5(?:0(?:30|49)|510)|911", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "(?:385|5(?:0[34]|51))\\d", 
, , , "3850", , , [4]]], CU:[, [, , "[12]\\d\\d(?:\\d{3,4})?", , , , , , , [3, 6, 7]], , , [, , "10[4-7]|(?:116|204\\d)\\d{3}", , , , "104"], [, , , , , , , , , [-1]], , , , "CU", , , , , , , , , , , , , , , , , , [, , "10[4-6]", , , , "104", , , [3]], , [, , "1(?:0[4-7]|1(?:6111|8)|40)|2045252", , , , "104"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CV:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "13[0-2]", , , , "130"], [, , , , , , , , , [-1]], , , , "CV", 
, , , , , , , , , , , , , , , , , [, , "13[0-2]", , , , "130"], , [, , "13[0-2]", , , , "130"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CW:[, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "112|911", , , , "112"], [, , , , , , , , , [-1]], , , , "CW", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112"], , [, , "1(?:12|76)|911", , , , "112"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]], CX:[, [, , "[01]\\d\\d", 
, , , , , , [3]], , , [, , "000|112", , , , "000"], [, , , , , , , , , [-1]], , , , "CX", , , , , , , , , , , , , , , , , , [, , "000|112", , , , "000"], , [, , "000|112", , , , "000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CY:[, [, , "1\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "1(?:1(?:2|6\\d{3})|99)", , , , "112"], [, , , , , , , , , [-1]], , , , "CY", , , , , , , , , , , , , , , , , , [, , "1(?:12|99)", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:000|111))|99)", 
, , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CZ:[, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1(?:2|6(?:00[06]|1(?:11|23)))|5[0568])", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "CZ", , , , , , , , , , , , , , , , , , [, , "1(?:12|5[0568])", , , , "112", , , [3]], , [, , "1(?:1(?:2|8\\d)|(?:2|3\\d)\\d{2,3}|5[0568]|99)|1(?:16|4)\\d{3}", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , 
, , [-1]]], DE:[, [, , "1\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "11(?:[02]|6\\d{3})", , , , "110"], [, , , , , , , , , [-1]], , , , "DE", , , , , , , , , , , , , , , , , , [, , "11[02]", , , , "110", , , [3]], , [, , "11(?:[025]|6(?:00[06]|1(?:1[17]|23)))", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], DJ:[, [, , "1\\d", , , , , , , [2]], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "DJ", , , , , , , , , , , , , , , , , 
, [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], DK:[, [, , "1\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "11(?:[24]|6\\d{3})", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "DK", , , , , , , , , , , , , , , , , , [, , "11[24]", , , , "112", , , [3]], , [, , "1(?:1(?:[2-48]|6(?:00[06]|111))|8(?:[08]1|1[0238]|28|30|5[13]))", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , 
, [-1]], , [, , , , , , , , , [-1]]], DM:[, [, , "[39]\\d\\d", , , , , , , [3]], , , [, , "333|9(?:11|99)", , , , "333"], [, , , , , , , , , [-1]], , , , "DM", , , , , , , , , , , , , , , , , , [, , "333|9(?:11|99)", , , , "333"], , [, , "333|9(?:11|99)", , , , "333"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], DO:[, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "112|911", , , , "112"], [, , , , , , , , , [-1]], , , , "DO", , , , , , , , , , , , , , , , , , [, 
, "112|911", , , , "112"], , [, , "112|911", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], DZ:[, [, , "[17]\\d\\d?", , , , , , , [2, 3]], , , [, , "1[47]", , , , "14", , , [2]], [, , , , , , , , , [-1]], , , , "DZ", , , , , , , , , , , , , , , , , , [, , "1[47]", , , , "14", , , [2]], , [, , "1[47]|730", , , , "14"], [, , , , , , , , , [-1]], [, , "730", , , , "730", , , [3]], , [, , "730", , , , "730", , , [3]]], EC:[, [, , "[19]\\d\\d", , , , , , 
, [3]], , , [, , "1(?:0[12]|12)|911", , , , "101"], [, , , , , , , , , [-1]], , , , "EC", , , , , , , , , , , , , , , , , , [, , "1(?:0[12]|12)|911", , , , "101"], , [, , "1(?:0[12]|12)|911", , , , "101"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], EE:[, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1(?:[02]|6\\d{3})|2(?:05|28)|3(?:014|3(?:21|5\\d?)|660)|492|5(?:1[03]|410|501)|6(?:112|333|644)|7(?:012|127|89)|8(?:10|8[57])|9(?:0[134]|14))", , , , 
"110"], [, , "1(?:18(?:00|[12458]\\d?)|2(?:0(?:[02-46-8]\\d?|1[0-36])|1(?:[0-4]\\d?|6[06])|2(?:[0-4]\\d?|5[25])|[367]|4(?:0[04]|[12]\\d?|4[24]|54)|55[12457])|3(?:0(?:[02]\\d?|1[13578]|3[356])|1[1347]|2[02-5]|3(?:[01347]\\d?|2[023]|88)|4(?:[35]\\d?|4[34])|5(?:3[134]|5[035])|666)|4(?:2(?:00|4\\d?)|4(?:0[01358]|1[024]|50|7\\d?)|900)|5(?:0[0-35]|1(?:[1267]\\d?|5[0-7]|82)|2(?:[014-6]\\d?|22)|330|4(?:[35]\\d?|44)|5(?:00|[1-69]\\d?)|9(?:[159]\\d?|[38]0|77))|6(?:1(?:00|1[19]|[35-9]\\d?)|2(?:2[26]|[68]\\d?)|3(?:22|36|6[36])|5|6(?:[0-359]\\d?|6[0-26])|7(?:00|55|7\\d?|8[89])|9(?:00|1\\d?|69))|7(?:0(?:[023]\\d?|1[0578])|1(?:00|2[034]|[4-9]\\d?)|2(?:[07]\\d?|20|44)|7(?:[0-57]\\d?|9[79])|8(?:0[08]|2\\d?|8[0178])|9(?:00|97))|8(?:1[127]|8[1268]|9[269])|9(?:0(?:[02]\\d?|69|9[0269])|1[1-3689]|21))", 
, , , "123", , , [3, 4, 5]], , , , "EE", , , , , , , , , , , , , , , , , , [, , "11[02]", , , , "110", , , [3]], , [, , "1(?:1(?:[02-579]|6(?:000|111)|8(?:[09]\\d|[1-8]))|2[36-9]|3[7-9]|4[05-7]|5[6-8]|6[05]|7[3-6]|8[02-7]|9[3-9])|1(?:2[0-245]|3[0-6]|4[1-489]|5[0-59]|6[1-46-9]|7[0-27-9]|8[189]|9[0-2])\\d\\d?", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "1(?:18[1258]|2(?:0(?:1[036]|[46]\\d?)|166|21|4(?:0[04]|1\\d?|5[47])|[67])|3(?:0(?:1[13-578]|2\\d?|3[56])|1[15]|2[045]|3(?:[13]\\d?|2[13])|43|5(?:00|3[34]|53))|44(?:0[0135]|14|50|7\\d?)|5(?:05|1(?:[12]\\d?|5[1246]|8[12])|2(?:[01]\\d?|22)|3(?:00|3[03])|4(?:15|5\\d?)|500|9(?:5\\d?|77|80))|6(?:1[35-8]|226|3(?:22|3[36]|66)|644|7(?:00|7\\d?|89)|9(?:00|69))|7(?:01[258]|1(?:00|[15]\\d?)|2(?:44|7\\d?)|8(?:00|87|9\\d?))|8(?:1[128]|8[56]|9(?:[26]\\d?|77))|90(?:2\\d?|69|92))", 
, , , "126", , , [3, 4, 5]]], EG:[, [, , "[13]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "1(?:2[23]|80)", , , , "122", , , [3]], [, , , , , , , , , [-1]], , , , "EG", , , , , , , , , , , , , , , , , , [, , "1(?:2[23]|80)", , , , "122", , , [3]], , [, , "1(?:2[23]|[69]\\d{3}|80)|34400", , , , "122"], [, , , , , , , , , [-1]], [, , "344\\d\\d", , , , "34400", , , [5]], , [, , "344\\d\\d", , , , "34400", , , [5]]], EH:[, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:[59]|77)", , , , "15"], 
[, , , , , , , , , [-1]], , , , "EH", , , , , , , , , , , , , , , , , , [, , "1(?:[59]|77)", , , , "15"], , [, , "1(?:[59]|77)", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], ER:[, [, , "[12]\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "11[2-46]|(?:12[47]|20[12])\\d{3}", , , , "112"], [, , , , , , , , , [-1]], , , , "ER", , , , , , , , , , , , , , , , , , [, , "1(?:1[2-46]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99", , , , "112"], , [, , "1(?:1[2-6]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99", 
, , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], ES:[, [, , "[0-379]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "0(?:16|6[57]|8[58])|1(?:006|12|[3-7]\\d\\d)|(?:116|20\\d)\\d{3}", , , , "016", , , [3, 4, 6]], [, , "[12]2\\d{1,4}|90(?:5\\d|7)|(?:118|2(?:[357]\\d|80)|3[357]\\d)\\d\\d|[79]9[57]\\d{3}", , , , "120"], , , , "ES", , , , , , , , , , , , , , , , , , [, , "08[58]|112", , , , "085", , , [3]], , [, , "0(?:1[0-26]|6[0-257]|8[058]|9[12])|1(?:0[03-57]\\d{1,3}|1(?:2|6(?:000|111)|8\\d\\d)|2\\d{1,4}|[3-9]\\d\\d)|2(?:2\\d{1,4}|80\\d\\d)|90(?:5[124578]|7)|1(?:3[34]|77)|(?:2[01]\\d|[79]9[57])\\d{3}|[23][357]\\d{3}", 
, , , "010"], [, , "0(?:[16][0-2]|80|9[12])|21\\d{4}", , , , "010", , , [3, 6]], [, , "1(?:3[34]|77)|[12]2\\d{1,4}", , , , "120"], , [, , "(?:2[0-2]\\d|3[357]|[79]9[57])\\d{3}|2(?:[2357]\\d|80)\\d\\d", , , , "22000", , , [5, 6]]], ET:[, [, , "9\\d\\d?", , , , , , , [2, 3]], , , [, , "9(?:11?|2|39?|9[17])", , , , "91"], [, , , , , , , , , [-1]], , , , "ET", , , , , , , , , , , , , , , , , , [, , "9(?:11?|2|39?|9[17])", , , , "91"], , [, , "9(?:07|11?|2|39?|45|9[17])", , , , "91"], [, , , , , , , , 
, [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], FI:[, [, , "[17]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [, , "11(?:2|6\\d{3})", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "FI", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "11(?:2|6111)|75[12]\\d\\d", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], FJ:[, [, , "[0-579]\\d(?:\\d(?:\\d{2})?)?", , , , , , , [2, 3, 5]], , , [, , "91[17]", 
, , , "911", , , [3]], [, , , , , , , , , [-1]], , , , "FJ", , , , , , , , , , , , , , , , , , [, , "91[17]", , , , "911", , , [3]], , [, , "0(?:1[34]|8[1-4])|1(?:0[1-3]|[25]9)|2[289]|30|40404|91[137]|[45]4|75", , , , "22"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "404\\d\\d", , , , "40400", , , [5]]], FK:[, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "FK", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , 
"1\\d\\d|999", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], FM:[, [, , "[39]\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "320\\d{3}|911", , , , "911"], [, , , , , , , , , [-1]], , , , "FM", , , , , , , , , , , , , , , , , , [, , "(?:32022|91)1", , , , "911"], , [, , "(?:32022|91)1", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], FO:[, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "11[24]", , , 
, "112", , , [3]], [, , , , , , , , , [-1]], , , , "FO", , , , , , , , , , , , , , , , , , [, , "11[24]", , , , "112", , , [3]], , [, , "11[248]|1(?:4[124]|71|8[7-9])\\d", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], FR:[, [, , "[1-8]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]], , , [, , "1(?:0(?:07|[13]3)|1[02459]|[578]|9[167])|224|(?:3370|74)0|(?:116\\d|3[01])\\d\\d", , , , "15"], [, , "(?:118|[4-8]\\d)\\d{3}|36665", , , , "36665", , , [5, 6]], , , , 
"FR", , , , , , , , , , , , , , , , , , [, , "1(?:12|[578])", , , , "15", , , [2, 3]], , [, , "1(?:0\\d\\d|1(?:[02459]|6(?:000|111)|8\\d{3})|[578]|9[167])|2(?:0(?:00|2)0|24)|[3-8]\\d{4}|3\\d{3}|6(?:1[14]|34)|7(?:0[06]|22|40)", , , , "15"], [, , "10(?:[134]4|2[23]|99)|202\\d|3(?:646|9[07]0)|634|70[06]|(?:106|61)[14]", , , , "611", , , [3, 4]], [, , "118777|224|6(?:1[14]|34)|7(?:0[06]|22|40)|20(?:0\\d|2)\\d", , , , "224", , , [3, 4, 5, 6]], , [, , "114|[3-8]\\d{4}", , , , "114", , , [3, 5]]], GA:[, 
[, , "1\\d(?:\\d{2})?", , , , , , , [2, 4]], , , [, , "18|1(?:3\\d|73)\\d", , , , "18"], [, , , , , , , , , [-1]], , , , "GA", , , , , , , , , , , , , , , , , , [, , "1(?:3\\d\\d|730|8)", , , , "18"], , [, , "1(?:3\\d\\d|730|8)", , , , "18"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GB:[, [, , "[1-46-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:05|1(?:2|6\\d{3})|7[56]\\d|8000)|2(?:20\\d|48)|4444|999", , , , "105"], [, , , , , , , , , [-1]], , , , "GB", 
, , , , , , , , , , , , , , , , , [, , "112|999", , , , "112", , , [3]], , [, , "1(?:0[015]|1(?:[12]|6(?:000|1(?:11|23))|8\\d{3})|2(?:[1-3]|50)|33|4(?:1|7\\d)|571|7(?:0\\d|[56]0)|800\\d|9[15])|2(?:0202|1300|2(?:02|11)|3(?:02|336|45)|4(?:25|8))|3[13]3|4(?:0[02]|35[01]|44[45]|5\\d)|(?:[68]\\d|7[089])\\d{3}|15\\d|2[02]2|650|789|9(?:01|99)", , , , "100"], [, , , , , , , , , [-1]], [, , "1(?:(?:25|7[56])\\d|571)|2(?:02(?:\\d{2})?|[13]3\\d\\d|48)|4444|901", , , , "202", , , [3, 4, 5]], , [, , "(?:125|2(?:020|13\\d)|(?:7[089]|8[01])\\d\\d)\\d", 
, , , "1250", , , [4, 5]]], GD:[, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "GD", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "176|911", , , , "176"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]], GE:[, [, , "[014]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "0(?:11|33)|11[1-3]|[01]22", , , , "011", , , [3]], [, , , , , , , , , [-1]], , , , "GE", , , , , , , , , , , , , , , , , 
, [, , "0(?:11|33)|11[1-3]|[01]22", , , , "011", , , [3]], , [, , "0(?:11|33)|11[1-3]|40404|[01]22", , , , "011"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]], GF:[, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], , , , "GF", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , 
[-1]]], GG:[, [, , "[19]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "112|999", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "GG", , , , , , , , , , , , , , , , , , [, , "112|999", , , , "112", , , [3]], , [, , "1(?:0[01]|1[12]|23|41|55|9[05])|999|1(?:1[68]\\d\\d|47|800)\\d", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GH:[, [, , "[14589]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "19[1-3]|999", , , , "191", , , [3]], [, , , , , , , , 
, [-1]], , , , "GH", , , , , , , , , , , , , , , , , , [, , "19[1-3]|999", , , , "191", , , [3]], , [, , "19[1-3]|40404|(?:54|83)00|999", , , , "191"], [, , , , , , , , , [-1]], [, , "404\\d\\d|(?:54|83)0\\d", , , , "5400", , , [4, 5]], , [, , "404\\d\\d|(?:54|83)0\\d", , , , "5400", , , [4, 5]]], GI:[, [, , "[158]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:00|1[25]|23|4(?:1|7\\d)|5[15]|9[02-49])|555|(?:116\\d|80)\\d\\d", , , , "100", , , [3, 4, 6]], [, , "8[1-69]\\d\\d", , , , "8100", , 
, [4]], , , , "GI", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[09])", , , , "112", , , [3]], , [, , "1(?:00|1(?:[25]|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|23|4(?:1|7[014])|5[015]|9[02-49])|555|8[0-79]\\d\\d|8(?:00|4[0-2]|8[0-589])", , , , "100"], [, , "150|87\\d\\d", , , , "150", , , [3, 4]], [, , "1(?:00|1(?:5|8\\d\\d)|23|51|9[2-4])|555|8(?:00|4[0-2]|8[0-589])", , , , "100", , , [3, 5]], , [, , , , , , , , , [-1]]], GL:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "112", , , , "112"], [, , , 
, , , , , , [-1]], , , , "GL", , , , , , , , , , , , , , , , , , [, , "112", , , , "112"], , [, , "112", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GM:[, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:1[6-8]|[6-8])", , , , "16"], [, , , , , , , , , [-1]], , , , "GM", , , , , , , , , , , , , , , , , , [, , "1(?:1[6-8]|[6-8])", , , , "16"], , [, , "1(?:1[6-8]|[6-8])", , , , "16"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , 
, , , , , [-1]]], GN:[, [, , "4\\d{4}", , , , , , , [5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "GN", , , , , , , , , , , , , , , , , , [, , , , , , , , , [-1]], , [, , "40404", , , , "40404"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400"], , [, , "404\\d\\d", , , , "40400"]], GP:[, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], , , , "GP", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", 
, , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GR:[, [, , "1\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "1(?:00|1(?:2|6\\d{3})|66|99)", , , , "100"], [, , , , , , , , , [-1]], , , , "GR", , , , , , , , , , , , , , , , , , [, , "1(?:00|12|66|99)", , , , "100", , , [3]], , [, , "1(?:00|1(?:2|6(?:000|1(?:11|23)))|66|99)", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GT:[, [, , "[14]\\d{2,4}", , , , 
, , , [3, 4, 5]], , , [, , "1(?:10|2[03])", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "GT", , , , , , , , , , , , , , , , , , [, , "1(?:10|2[03])", , , , "110", , , [3]], , [, , "110|40404|1(?:2|[57]\\d)\\d", , , , "110"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]], GU:[, [, , "9\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "GU", , , , , , , , , , , , , , , , , , [, , "911", 
, , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GW:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[378]", , , , "113"], [, , , , , , , , , [-1]], , , , "GW", , , , , , , , , , , , , , , , , , [, , "11[378]", , , , "113"], , [, , "11[378]", , , , "113"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GY:[, [, , "[019]\\d{2,3}", , , , , , , [3, 4]], , , [, , "91[1-3]", , , , "911", , , [3]], 
[, , , , , , , , , [-1]], , , , "GY", , , , , , , , , , , , , , , , , , [, , "91[1-3]", , , , "911", , , [3]], , [, , "0(?:02|(?:17|80)1|444|7(?:[67]7|9)|9(?:0[78]|[2-47]))|1(?:443|5[568])|91[1-3]", , , , "002"], [, , , , , , , , , [-1]], [, , "144\\d", , , , "1440", , , [4]], , [, , "144\\d", , , , "1440", , , [4]]], HK:[, [, , "[19]\\d{2,6}", , , , , , , [3, 4, 5, 6, 7]], , , [, , "112|99[29]", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "HK", , , , , , , , , , , , , , , , , , [, , "112|99[29]", 
, , , "112", , , [3]], , [, , "1(?:0(?:(?:[0136]\\d|2[14])\\d{0,3}|8[138])|12|2(?:[0-3]\\d{0,4}|(?:58|8[13])\\d{0,3})|7(?:[135-9]\\d{0,4}|219\\d{0,2})|8(?:0(?:(?:[13]|60\\d)\\d|8)|1(?:0\\d|[2-8])|2(?:0[5-9]|(?:18|2)2|3|8[128])|(?:(?:3[0-689]\\d|7(?:2[1-389]|8[0235-9]|93))\\d|8)\\d|50[138]|6(?:1(?:11|86)|8)))|99[29]|10[0139]", , , , "100"], [, , , , , , , , , [-1]], [, , "109|1(?:08|85\\d)\\d", , , , "109", , , [3, 4, 5]], , [, , "992", , , , "992", , , [3]]], HN:[, [, , "[14]\\d\\d(?:\\d{2})?", , 
, , , , , [3, 5]], , , [, , "199", , , , "199", , , [3]], [, , , , , , , , , [-1]], , , , "HN", , , , , , , , , , , , , , , , , , [, , "199", , , , "199", , , [3]], , [, , "199|40404", , , , "199"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]], HR:[, [, , "[19]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]], , , [, , "1(?:12|9[2-4])|9[34]|1(?:16\\d|39)\\d\\d", , , , "93", , , [2, 3, 5, 6]], [, , "118\\d\\d", , , , "11800", , , [5]], , , 
, "HR", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[2-4])|9[34]", , , , "93", , , [2, 3]], , [, , "1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|3977|9(?:[2-5]|87))|9[34]", , , , "93"], [, , , , , , , , , [-1]], [, , "139\\d\\d", , , , "13900", , , [5]], , [, , "139\\d\\d", , , , "13900", , , [5]]], HT:[, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "11[48]", , , , "114", , , [3]], [, , , , , , , , , [-1]], , , , "HT", , , , , , , , , , , , , , , , , , [, , "11[48]", , , , "114", 
, , [3]], , [, , "11[48]|40404", , , , "114"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]], HU:[, [, , "1\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "1(?:0[457]|1(?:2|6\\d{3}))", , , , "104"], [, , , , , , , , , [-1]], , , , "HU", , , , , , , , , , , , , , , , , , [, , "1(?:0[457]|12)", , , , "104", , , [3]], , [, , "1(?:0[457]|1(?:2|6(?:000|1(?:11|23))))", , , , "104"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
, [, , , , , , , , , [-1]]], ID:[, [, , "[178]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "11[02389]", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "ID", , , , , , , , , , , , , , , , , , [, , "11[02389]", , , , "110", , , [3]], , [, , "1(?:1[02389]|40\\d\\d)|71400|89887", , , , "110"], [, , , , , , , , , [-1]], [, , "(?:714|898)\\d\\d", , , , "71400", , , [5]], , [, , "714\\d\\d", , , , "71400", , , [5]]], IE:[, [, , "[159]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:2|6\\d{3})|999", 
, , , "112", , , [3, 6]], [, , "5[37]\\d{3}", , , , "53000", , , [5]], , , , "IE", , , , , , , , , , , , , , , , , , [, , "112|999", , , , "112", , , [3]], , [, , "11(?:2|6(?:00[06]|1(?:1[17]|23)))|999|(?:1(?:18|9)|5[0137]\\d)\\d\\d", , , , "112"], [, , "51\\d{3}", , , , "51000", , , [5]], [, , "51210", , , , "51210", , , [5]], , [, , "51210|(?:118|5[037]\\d)\\d\\d", , , , "11800", , , [5]]], IL:[, [, , "[12]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:0[0-2]|12)", , , , "100", , , [3]], [, , 
, , , , , , , [-1]], , , , "IL", , , , , , , , , , , , , , , , , , [, , "1(?:0[0-2]|12)", , , , "100", , , [3]], , [, , "1(?:0[0-2]|1(?:[013-9]\\d|2)|[2-9]\\d\\d)|2407|(?:104|27)00", , , , "100"], [, , , , , , , , , [-1]], [, , "104\\d\\d", , , , "10400", , , [5]], , [, , "104\\d\\d", , , , "10400", , , [5]]], IM:[, [, , "[189]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [, , "999", , , , "999", , , [3]], [, , , , , , , , , [-1]], , , , "IM", , , , , , , , , , , , , , , , , , [, , "999", , , 
, "999", , , [3]], , [, , "1\\d\\d(?:\\d{3})?|8(?:6444|9887)|999", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "8(?:64|98)\\d\\d", , , , "86400", , , [5]]], IN:[, [, , "[12578]\\d{2,8}", , , , , , , [3, 4, 5, 6, 7, 8, 9]], , , [, , "1(?:0[0-248]|1[289]|21|[39][89]|4[01]|6(?:1|6\\d?)|8[12])|777|800|1[05]5\\d|1(?:07|51|94)\\d\\d?|(?:1(?:[05]5\\d|70)\\d|261)\\d|1(?:0[369]|10|29|3[126]|9[0-256])\\d", , , , "100", , , [3, 4, 5, 6]], [, , "11[67]\\d{4}|56161561", , , , "1160000", 
, , [7, 8]], , , , "IN", , , , , , , , , , , , , , , , , , [, , "1(?:0[0-28]|12|298)|2611", , , , "100", , , [3, 4]], , [, , "1(?:0(?:[0-248]|3[39]|5(?:010|6)|6[3468]|7(?:[01357]|[28]0?|4[01])|9[0135-9])|1(?:00|[289])|2(?:1|98)|3(?:11|2[0-2]|63|[89])|4[01]|5(?:1(?:0[0-36]|[127])|54)|6(?:1|6[01]?)|7000|8[12]|9(?:0[013-59]|12|25|4[4-9]\\d?|50|6[1347]|[89]))|2611|5(?:0(?:0(?:0\\d|1|20?)|325|5[2-79]\\d{3,5})|1(?:234|555|717|818|96[49])|2(?:0(?:0[01]|[14]0)|151|555|666|888|9(?:06|99\\d?))|3(?:0[01]0|131|553|(?:66|77)6)|(?:464|55[05])\\d{1,3}|6(?:070|3[68]|43)|717\\d)|777|800|5(?:05(?:0|1\\d)|221|3(?:03|3[23]))\\d{1,4}|5(?:(?:04|88)0|2(?:2[0267]|3[16])|4(?:1[04]|20|3[02])|5(?:3[16]|67)|6(?:06|[67]\\d)|787|9(?:64|90))\\d\\d?|(?:1(?:05[79]|(?:1[67][0-2]|802)\\d|55[23])\\d|5(?:(?:00(?:0\\d|1)|(?:304|616)\\d\\d)\\d|1(?:0[12]|4[2-4])|2(?:2[3589]|3(?:1\\d{3}|2)|4[04]|7[78])|4(?:[02]4|32\\d{4}|4[04]|99)|5(?:1[25]|[36]5|4[45]|93)|7(?:(?:17\\d|57)\\d\\d|[27]7|88)|8(?:3[4-69]|4[01]|5[58]|88(?:8\\d\\d|9)|99)|9(?:0(?:0|2\\d{3})|55|6[67]|77|88)))\\d", 
, , , "100"], [, , "5(?:14(?:2[5-9]|[34]\\d)|757555)", , , , "51425", , , [5, 7]], [, , "1(?:(?:1[67]\\d\\d|70)\\d\\d|55330|909)|5(?:300\\d|6161(?:17[89]|561))|1(?:[19][89]|21|4[01])", , , , "118", , , [3, 4, 5, 6, 7, 8]], , [, , "1(?:39|90[019])|5(?:14(?:2[5-9]|[34]\\d)|6161(?:17[89]|561)|757555)", , , , "139", , , [3, 4, 5, 7, 8]]], IQ:[, [, , "[1479]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:0[04]|15|22)", , , , "100", , , [3]], [, , , , , , , , , [-1]], , , , "IQ", , , , , , , , , , , , 
, , , , , , [, , "1(?:0[04]|15|22)", , , , "100", , , [3]], , [, , "1(?:0[04]|15|22)|4432|71117|9988", , , , "100"], [, , , , , , , , , [-1]], [, , "(?:443|711\\d|998)\\d", , , , "4430", , , [4, 5]], , [, , "(?:443|711\\d|998)\\d", , , , "4430", , , [4, 5]]], IR:[, [, , "[129]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1[0-68]|2[0-59]|9[0-579])|911", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "IR", , , , , , , , , , , , , , , , , , [, , "1(?:1[025]|25)|911", , , , "110", , , [3]], 
, [, , "1(?:1[0-68]|2[0-59]|3[346-8]|4(?:[0147]|[289]0)|5(?:0[14]|1[02479]|2[0-3]|39|[49]0|65)|6(?:[16]6|[27]|90)|8(?:03|1[18]|22|3[37]|4[28]|88|99)|9[0-579])|20(?:[09]0|1(?:[038]|1[079]|26|9[69])|2[01])|9(?:11|9(?:0009|90))", , , , "110"], [, , "1(?:5[0-469]|8[0-489])\\d", , , , "1500", , , [4]], [, , "(?:1(?:5[0-469]|8[0-489])|99(?:0\\d\\d|9))\\d", , , , "1500", , , [4, 6]], , [, , "990\\d{3}", , , , "990000", , , [6]]], IS:[, [, , "1\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , 
"1(?:12|71\\d)", , , , "112", , , [3, 4]], [, , , , , , , , , [-1]], , , , "IS", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "1(?:1(?:[28]|61(?:16|23))|4(?:00|1[145]|4[0146])|55|7(?:00|17|7[07-9])|8(?:[02]0|1[16-9]|88)|900)", , , , "112"], [, , , , , , , , , [-1]], [, , "14(?:0\\d|41)", , , , "1400", , , [4]], , [, , "1(?:415|90\\d)", , , , "1415", , , [4]]], IT:[, [, , "[14]\\d{2,6}", , , , , , , [3, 4, 5, 6, 7]], , , [, , "1(?:1(?:[2358]|6\\d{3})|87)", , , , "112", 
, , [3, 6]], [, , "(?:12|4(?:[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d", , , , "1200", , , [4, 5, 7]], , , , "IT", , , , , , , , , , , , , , , , , , [, , "11[2358]", , , , "112", , , [3]], , [, , "1(?:0\\d{2,3}|1(?:[2-57-9]|6(?:000|111))|3[39]|4(?:82|9\\d{1,3})|5(?:00|1[58]|2[25]|3[03]|44|[59])|60|8[67]|9(?:[01]|2[2-9]|4\\d|696))|4(?:2323|5045)|(?:1(?:2|92[01])|4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|5[05])\\d\\d", 
, , , "43000", , , [5, 7]]], JE:[, [, , "[129]\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "112|999", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "JE", , , , , , , , , , , , , , , , , , [, , "112|999", , , , "112", , , [3]], , [, , "1(?:00|1(?:2|8\\d{3})|23|4(?:[14]|28|7\\d)|5\\d|7(?:0[12]|[128]|35?)|808|9[0135])|23[2-4]|999", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], JM:[, [, , "[19]\\d\\d", , , , , , , [3]], , , [, 
, "11[029]|911", , , , "110"], [, , , , , , , , , [-1]], , , , "JM", , , , , , , , , , , , , , , , , , [, , "11[029]|911", , , , "110"], , [, , "1(?:1[029]|76)|911", , , , "110"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]], JO:[, [, , "[19]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "1(?:12|9[127])|911", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "JO", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[127])|911", , , , "112", , , [3]], , [, , 
"1(?:09|1[0-2]|9[0-24-79])|9(?:0903|11|8788)", , , , "109"], [, , , , , , , , , [-1]], [, , "9(?:09|87)\\d\\d", , , , "90900", , , [5]], , [, , "9(?:09|87)\\d\\d", , , , "90900", , , [5]]], JP:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[09]", , , , "110"], [, , , , , , , , , [-1]], , , , "JP", , , , , , , , , , , , , , , , , , [, , "11[09]", , , , "110"], , [, , "11[09]", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], KE:[, [, , "[1-9]\\d{2,4}", 
, , , , , , [3, 4, 5]], , , [, , "1(?:1(?:[246]|9\\d)|5(?:01|2[127]|6[26]\\d))|999", , , , "112"], [, , "909\\d\\d", , , , "90900", , , [5]], , , , "KE", , , , , , , , , , , , , , , , , , [, , "11[24]|999", , , , "112", , , [3]], , [, , "1(?:0(?:[07-9]|1[0-25]|400)|1(?:[024-6]|9[0-579])|2[1-3]|3[01]|4[14]|5(?:[01][01]|2[0-24-79]|33|4[05]|5[59]|6(?:00|29|6[67]))|(?:6[035]\\d|[78])\\d|9(?:[02-9]\\d\\d|19))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99))\\d\\d|9(?:09\\d\\d|99)|8988", 
, , , "100"], [, , , , , , , , , [-1]], [, , "1(?:(?:04|6[35])\\d\\d|3[01]|4[14]|5(?:1\\d|2[25]))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99)|909)\\d\\d|898\\d", , , , "130"], , [, , "1(?:(?:04|6[035])\\d\\d|4[14]|5(?:01|55|6[26]\\d))|40404|8988|909\\d\\d", , , , "141"]], KG:[, [, , "[14]\\d{2,3}", , , , , , , [3, 4]], , , [, , "10[1-3]", , , , "101", , , [3]], [, , , , , , , , , [-1]], , , , "KG", , , , , , , , , , , , , , , , , , [, , "10[1-3]", , , , "101", , , [3]], , [, 
, "10[1-3]|4040", , , , "101"], [, , , , , , , , , [-1]], [, , "404\\d", , , , "4040", , , [4]], , [, , "404\\d", , , , "4040", , , [4]]], KH:[, [, , "[146]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "11[7-9]|666", , , , "117", , , [3]], [, , , , , , , , , [-1]], , , , "KH", , , , , , , , , , , , , , , , , , [, , "11[7-9]|666", , , , "117", , , [3]], , [, , "11[7-9]|40404|666", , , , "117"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", 
, , [5]]], KI:[, [, , "[17]\\d{2,3}", , , , , , , [3, 4]], , , [, , "19[2-5]", , , , "192", , , [3]], [, , , , , , , , , [-1]], , , , "KI", , , , , , , , , , , , , , , , , , [, , "19[2-5]", , , , "192", , , [3]], , [, , "1(?:05[0-259]|88|9[2-5])|777|10[0-8]", , , , "100"], [, , "103", , , , "103", , , [3]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], KM:[, [, , "1\\d", , , , , , , [2]], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "KM", , , , , , , , , , , , , , , , , 
, [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], KN:[, [, , "[39]\\d\\d", , , , , , , [3]], , , [, , "333|9(?:11|99)", , , , "333"], [, , , , , , , , , [-1]], , , , "KN", , , , , , , , , , , , , , , , , , [, , "333|9(?:11|99)", , , , "333"], , [, , "333|9(?:11|99)", , , , "333"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], KP:[, [, , "[18]\\d\\d", , , , , , , [3]], , , [, 
, "11[29]|819", , , , "112"], [, , , , , , , , , [-1]], , , , "KP", , , , , , , , , , , , , , , , , , [, , "11[29]|819", , , , "112"], , [, , "11[29]|819", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], KR:[, [, , "1\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:1[27-9]|28|330|82)", , , , "112", , , [3, 4]], [, , , , , , , , , [-1]], , , , "KR", , , , , , , , , , , , , , , , , , [, , "11[29]", , , , "112", , , [3]], , [, , "1(?:[016-9]114|3(?:2|3[039]|45|66|88|9[18]))|1(?:0[01]|1[0247-9]|2[01389]|82)", 
, , , "100"], [, , , , , , , , , [-1]], [, , "1[016-9]1\\d\\d|1(?:0[01]|14)", , , , "100", , , [3, 5]], , [, , , , , , , , , [-1]]], KW:[, [, , "[18]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "112", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "KW", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "1[0-7]\\d|89887", , , , "100"], [, , , , , , , , , [-1]], [, , "898\\d\\d", , , , "89800", , , [5]], , [, , , , , , , , , [-1]]], KY:[, [, , "9\\d\\d", , , , 
, , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "KY", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], KZ:[, [, , "[134]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:0[1-3]|12)", , , , "101", , , [3]], [, , , , , , , , , [-1]], , , , "KZ", , , , , , , , , , , , , , , , , , [, , "1(?:0[1-3]|12)", , , , "101", , , [3]], , [, , "1(?:0[1-4]|12)|(?:3040|404)0", 
, , , "101"], [, , , , , , , , , [-1]], [, , "(?:304\\d|404)\\d", , , , "4040", , , [4, 5]], , [, , "(?:304\\d|404)\\d", , , , "4040", , , [4, 5]]], LA:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "19[015]", , , , "190"], [, , , , , , , , , [-1]], , , , "LA", , , , , , , , , , , , , , , , , , [, , "19[015]", , , , "190"], , [, , "19[015]", , , , "190"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LB:[, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "1(?:12|40|75)|999", 
, , , "112"], [, , , , , , , , , [-1]], , , , "LB", , , , , , , , , , , , , , , , , , [, , "1(?:12|40|75)|999", , , , "112"], , [, , "1(?:12|40|75)|999", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LC:[, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "LC", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , 
, , , , , [-1]], , [, , , , , , , , , [-1]]], LI:[, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[278]|44)", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "LI", , , , , , , , , , , , , , , , , , [, , "1(?:1[278]|44)", , , , "112", , , [3]], , [, , "1(?:1(?:[278]|45)|4[3-57]|50|75|81[18])", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LK:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[02689]", , , , "110"], [, , , , , , , , , [-1]], 
, , , "LK", , , , , , , , , , , , , , , , , , [, , "11[02689]", , , , "110"], , [, , "11[024-9]", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LR:[, [, , "[3489]\\d{2,3}", , , , , , , [3, 4]], , , [, , "355|911", , , , "355", , , [3]], [, , , , , , , , , [-1]], , , , "LR", , , , , , , , , , , , , , , , , , [, , "355|911", , , , "355", , , [3]], , [, , "355|4040|8(?:400|933)|911", , , , "355"], [, , , , , , , , , [-1]], [, , "(?:404|8(?:40|93))\\d", 
, , , "4040", , , [4]], , [, , "(?:404|8(?:40|93))\\d", , , , "4040", , , [4]]], LS:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[257]", , , , "112"], [, , , , , , , , , [-1]], , , , "LS", , , , , , , , , , , , , , , , , , [, , "11[257]", , , , "112"], , [, , "11[257]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LT:[, [, , "[01]\\d(?:\\d(?:\\d{3})?)?", , , , , , , [2, 3, 6]], , , [, , "0(?:11?|22?|33?)|1(?:0[1-3]|1(?:2|6\\d{3}))", , , , "01"], 
[, , , , , , , , , [-1]], , , , "LT", , , , , , , , , , , , , , , , , , [, , "0(?:11?|22?|33?)|1(?:0[1-3]|12)", , , , "01", , , [2, 3]], , [, , "0(?:11?|22?|33?)|1(?:0[1-3]|1(?:2|6(?:000|1(?:11|23))))", , , , "01"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LU:[, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:[23]|6\\d{3})", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "LU", , , , , , , , , , , , , , , , , , [, , "11[23]", , , , "112", 
, , [3]], , [, , "11(?:[23]|6(?:000|111))|1(?:18|[25]\\d|3)\\d\\d", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LV:[, [, , "[018]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]], , , [, , "0[1-3]|11(?:[023]|6\\d{3})", , , , "01", , , [2, 3, 6]], [, , "1180|821\\d\\d", , , , "1180", , , [4, 5]], , , , "LV", , , , , , , , , , , , , , , , , , [, , "0[1-3]|11[023]", , , , "01", , , [2, 3]], , [, , "0[1-4]|1(?:1(?:[02-4]|6(?:000|111)|8[0189])|(?:5|65)5|77)|821[57]4", 
, , , "01"], [, , "1181", , , , "1181", , , [4]], [, , "165\\d", , , , "1650", , , [4]], , [, , , , , , , , , [-1]]], LY:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "19[013]", , , , "190"], [, , , , , , , , , [-1]], , , , "LY", , , , , , , , , , , , , , , , , , [, , "19[013]", , , , "190"], , [, , "19[013]", , , , "190"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MA:[, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:[59]|77)", , , , "15"], [, , , , , , 
, , , [-1]], , , , "MA", , , , , , , , , , , , , , , , , , [, , "1(?:[59]|77)", , , , "15"], , [, , "1(?:[59]|77)", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MC:[, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], , , , "MC", , , , , , , , , , , , , , , , , , [, , "1(?:12|[578])", , , , "15"], , [, , "1(?:12|41|[578])", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , 
, , , , , , [-1]]], MD:[, [, , "[19]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:2|6\\d{3})|90[1-3]", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "MD", , , , , , , , , , , , , , , , , , [, , "112|90[1-3]", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:000|1(?:11|23))|8\\d\\d?|99)|90[04-9])|90[1-3]|1(?:4\\d\\d|6[0-389]|9[1-4])\\d", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], ME:[, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , 
, [, , "1(?:12|2[2-4])", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "ME", , , , , , , , , , , , , , , , , , [, , "1(?:12|2[2-4])", , , , "112", , , [3]], , [, , "1(?:1(?:(?:[013-57-9]|6\\d\\d)\\d|2)|[249]\\d{3}|5999|8(?:0[089]|1[0-8]|888))|1(?:[02-5]\\d\\d|60[06]|700)|12\\d", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MF:[, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], , , , "MF", , , , , , 
, , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MG:[, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:1[78]|[78])", , , , "17"], [, , , , , , , , , [-1]], , , , "MG", , , , , , , , , , , , , , , , , , [, , "1(?:1[78]|[78])", , , , "17"], , [, , "1(?:1[78]|[78])", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MH:[, [, , "9\\d\\d", , 
, , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "MH", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MK:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "1(?:12|9[2-4])", , , , "112"], [, , , , , , , , , [-1]], , , , "MK", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[2-4])", , , , "112"], , [, , "1(?:12|9[2-4])", , , , "112"], [, , , , , , , , , 
[-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], ML:[, [, , "[136-8]\\d{1,4}", , , , , , , [2, 3, 4, 5]], , , [, , "1[578]|(?:352|67)00|7402|(?:677|744|8000)\\d", , , , "15", , , [2, 4, 5]], [, , "(?:12|800)2\\d|3(?:52(?:11|2[02]|3[04-6]|99)|7574)", , , , "1220", , , [4, 5]], , , , "ML", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15", , , [2]], , [, , "1(?:1(?:[013-9]\\d|2)|2(?:1[02-469]|2[13])|[578])|350(?:35|57)|67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)|800[0-2][12]|3(?:52|[67]\\d)\\d\\d", 
, , , "15"], [, , "37(?:433|575)|7400|8001\\d", , , , "7400", , , [4, 5]], [, , "3503\\d|(?:3[67]\\d|800)\\d\\d", , , , "35030", , , [5]], , [, , "374(?:0[24-9]|[1-9]\\d)|7400|3(?:6\\d|75)\\d\\d", , , , "7400", , , [4, 5]]], MM:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "199", , , , "199"], [, , , , , , , , , [-1]], , , , "MM", , , , , , , , , , , , , , , , , , [, , "199", , , , "199"], , [, , "199", , , , "199"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], 
MN:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "10[0-3]", , , , "100"], [, , , , , , , , , [-1]], , , , "MN", , , , , , , , , , , , , , , , , , [, , "10[0-3]", , , , "100"], , [, , "10[0-3]", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MO:[, [, , "9\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "MO", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , 
, [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MP:[, [, , "9\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "MP", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MQ:[, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], , , , "MQ", , , , , , , , , , , , , , , , , , [, , 
"1(?:12|[578])", , , , "15"], , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MR:[, [, , "1\\d", , , , , , , [2]], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "MR", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MS:[, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|99)", , , , "911"], 
[, , , , , , , , , [-1]], , , , "MS", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MT:[, [, , "1\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "11(?:2|6\\d{3})", , , , "112"], [, , , , , , , , , [-1]], , , , "MT", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "11(?:2|6(?:000|1(?:11|23)))", , , , "112"], [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MU:[, [, , "[189]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "11[45]|99[59]", , , , "114", , , [3]], [, , , , , , , , , [-1]], , , , "MU", , , , , , , , , , , , , , , , , , [, , "11[45]|99[59]", , , , "114", , , [3]], , [, , "1\\d{2,4}|(?:8\\d\\d|99)\\d", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MV:[, [, , "[14]\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:02|1[89])", , , , "102", , , [3]], 
[, , , , , , , , , [-1]], , , , "MV", , , , , , , , , , , , , , , , , , [, , "1(?:02|1[89])", , , , "102", , , [3]], , [, , "1(?:[0-37-9]|[4-6]\\d)\\d|4040|1[45]1", , , , "100"], [, , , , , , , , , [-1]], [, , "1[45]1", , , , "141", , , [3]], , [, , , , , , , , , [-1]]], MW:[, [, , "[189]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "199|99[7-9]", , , , "199", , , [3]], [, , , , , , , , , [-1]], , , , "MW", , , , , , , , , , , , , , , , , , [, , "199|99[7-9]", , , , "199", , , [3]], , [, , "199|80400|99[7-9]", 
, , , "199"], [, , , , , , , , , [-1]], [, , "804\\d\\d", , , , "80400", , , [5]], , [, , "804\\d\\d", , , , "80400", , , [5]]], MX:[, [, , "[0579]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "0(?:6[0568]|80)|911", , , , "060", , , [3]], [, , "(?:530\\d|776)\\d", , , , "7760", , , [4, 5]], , , , "MX", , , , , , , , , , , , , , , , , , [, , "0(?:6[0568]|80)|911", , , , "060", , , [3]], , [, , "0[1-9]\\d|53053|7766|911", , , , "010"], [, , , , , , , , , [-1]], [, , "0(?:[249]0|[35][01])", , , , "020", 
, , [3]], , [, , , , , , , , , [-1]]], MY:[, [, , "[1369]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "112|999", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "MY", , , , , , , , , , , , , , , , , , [, , "112|999", , , , "112", , , [3]], , [, , "1(?:0[01348]|1(?:[02]|1[128]|311)|2(?:0[125]|[13-6]|2\\d{0,2})|(?:3[1-35-79]|7[45])\\d\\d?|5(?:454|5\\d\\d?|77|888|999?)|8(?:18?|2|8[18])|9(?:[124]\\d?|68|71|9[0679]))|66628|99[1-469]|13[5-7]|(?:1(?:0[569]|309|5[12]|7[136-9]|9[03])|3[23679]\\d\\d)\\d", 
, , , "100"], [, , "666\\d\\d", , , , "66600", , , [5]], [, , , , , , , , , [-1]], , [, , "(?:3[23679]\\d|666)\\d\\d", , , , "32000", , , [5]]], MZ:[, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[79]|9[78])", , , , "117", , , [3]], [, , , , , , , , , [-1]], , , , "MZ", , , , , , , , , , , , , , , , , , [, , "1(?:1[79]|9[78])", , , , "117", , , [3]], , [, , "1(?:[02-5]\\d\\d|1[79]|9[78])", , , , "117"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], NA:[, 
[, , "[19]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "10111", , , , "10111", , , [5]], [, , , , , , , , , [-1]], , , , "NA", , , , , , , , , , , , , , , , , , [, , "10111", , , , "10111", , , [5]], , [, , "(?:10|93)111|(?:1\\d|9)\\d\\d", , , , "900"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], NC:[, [, , "[135]\\d{1,3}", , , , , , , [2, 3, 4]], , , [, , "1(?:0(?:00|1[23]|3[0-2]|8\\d)|[5-8])|363\\d|577", , , , "15"], [, , , , , , , , , [-1]], , , , "NC", , , 
, , , , , , , , , , , , , , , [, , "1[5-8]", , , , "15", , , [2]], , [, , "1(?:0(?:0[06]|1[02-46]|20|3[0-25]|42|5[058]|77|88)|[5-8])|3631|5[6-8]\\d", , , , "15"], [, , "5(?:67|88)", , , , "567", , , [3]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], NE:[, [, , "[1-3578]\\d(?:\\d(?:\\d{3})?)?", , , , , , , [2, 3, 6]], , , [, , "1[578]|723\\d{3}", , , , "15", , , [2, 6]], [, , , , , , , , , [-1]], , , , "NE", , , , , , , , , , , , , , , , , , [, , "1[578]|723141", , , , "15", , , [2, 6]], 
, [, , "1(?:0[01]|1[12]|2[034]|3[013]|[46]0|55?|[78])|222|333|555|723141|888", , , , "15"], [, , , , , , , , , [-1]], [, , "1(?:0[01]|1[12]|2[034]|3[013]|[46]0|55)|222|333|555|888", , , , "100", , , [3]], , [, , , , , , , , , [-1]]], NF:[, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|55|77)", , , , "911"], [, , , , , , , , , [-1]], , , , "NF", , , , , , , , , , , , , , , , , , [, , "9(?:11|55|77)", , , , "911"], , [, , "9(?:11|55|77)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , 
, , [-1]], , [, , , , , , , , , [-1]]], NG:[, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "199", , , , "199", , , [3]], [, , , , , , , , , [-1]], , , , "NG", , , , , , , , , , , , , , , , , , [, , "199", , , , "199", , , [3]], , [, , "199|40700", , , , "199"], [, , , , , , , , , [-1]], [, , "407\\d\\d", , , , "40700", , , [5]], , [, , "407\\d\\d", , , , "40700", , , [5]]], NI:[, [, , "[12467]\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[58]|2[08])|737\\d", , , , "115"], [, , , , 
, , , , , [-1]], , , , "NI", , , , , , , , , , , , , , , , , , [, , "1(?:1[58]|2[08])", , , , "115", , , [3]], , [, , "1(?:1[58]|200)|4878|7(?:010|373)|12[0158]|(?:19|[267]1)00", , , , "115"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], NL:[, [, , "[1349]\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "11(?:2|6\\d{3})|911", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "NL", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112", 
, , [3]], , [, , "1(?:1(?:2|6(?:00[06]|1(?:11|23)))|2(?:0[0-4]|3[34]|44)|3[03-9]\\d|400|8(?:[02-9]\\d|1[0-79]))|[34]000|911", , , , "112"], [, , , , , , , , , [-1]], [, , "120\\d", , , , "1200", , , [4]], , [, , "[34]00\\d", , , , "3000", , , [4]]], NO:[, [, , "1\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "11(?:[023]|6\\d{3})", , , , "110", , , [3, 6]], [, , , , , , , , , [-1]], , , , "NO", , , , , , , , , , , , , , , , , , [, , "11[023]", , , , "110", , , [3]], , [, , "1(?:1(?:[0239]|61(?:1[17]|23))|2[048]|4(?:12|[59])|7[57]|90)", 
, , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], NP:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "1(?:0[0-3]|12)", , , , "100"], [, , , , , , , , , [-1]], , , , "NP", , , , , , , , , , , , , , , , , , [, , "1(?:0[0-3]|12)", , , , "100"], , [, , "1(?:0[0-3]|12)", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], NR:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[0-2]", , , , "110"], [, , , , , , , , , [-1]], 
, , , "NR", , , , , , , , , , , , , , , , , , [, , "11[0-2]", , , , "110"], , [, , "1(?:1[0-2]|23|92)", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], NU:[, [, , "[019]\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "NU", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "01[05]|101|999", , , , "010"], [, , , , , , , , , [-1]], [, , "010", , , , "010"], , [, , , , , , , , , [-1]]], NZ:[, [, , 
"\\d{3,4}", , , , , , , [3, 4]], , , [, , "111", , , , "111", , , [3]], [, , "018", , , , "018", , , [3]], , , , "NZ", , , , , , , , , , , , , , , , , , [, , "111", , , , "111", , , [3]], , [, , "018|1(?:(?:1|37)1|(?:23|94)4|7[03]7)|[2-57-9]\\d{2,3}|6(?:161|26[0-3]|742)", , , , "018"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "018|(?:1(?:23|37|7[03]|94)|6(?:[12]6|74))\\d|[2-57-9]\\d{2,3}", , , , "018"]], OM:[, [, , "9\\d{3}", , , , , , , [4]], , , [, , "999\\d", , , , "9990"], [, 
, , , , , , , , [-1]], , , , "OM", , , , , , , , , , , , , , , , , , [, , "9999", , , , "9999"], , [, , "9999", , , , "9999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PA:[, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "PA", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "10[2-4]|911", , , , "102"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PE:[, 
[, , "1\\d\\d", , , , , , , [3]], , , [, , "1(?:05|1[67])", , , , "105"], [, , , , , , , , , [-1]], , , , "PE", , , , , , , , , , , , , , , , , , [, , "1(?:05|1[67])", , , , "105"], , [, , "1(?:05|1[67])", , , , "105"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PF:[, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], , , , "PF", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, 
, , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PG:[, [, , "[01]\\d{2,6}", , , , , , , [3, 4, 5, 6, 7]], , , [, , "000|11[01]", , , , "000", , , [3]], [, , , , , , , , , [-1]], , , , "PG", , , , , , , , , , , , , , , , , , [, , "000|11[01]", , , , "000", , , [3]], , [, , "000|1(?:1[01]|5\\d\\d|6\\d{2,5})", , , , "000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "16\\d{2,5}", , , , "1600", , , [4, 5, 6, 7]]], PH:[, [, , "[19]\\d\\d", , , , , , , [3]], 
, , [, , "11[27]|911", , , , "112"], [, , , , , , , , , [-1]], , , , "PH", , , , , , , , , , , , , , , , , , [, , "11[27]|911", , , , "112"], , [, , "11[27]|911", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PK:[, [, , "1\\d{1,3}", , , , , , , [2, 3, 4]], , , [, , "1(?:1(?:2\\d?|5)|[56])", , , , "15"], [, , , , , , , , , [-1]], , , , "PK", , , , , , , , , , , , , , , , , , [, , "1(?:1(?:22?|5)|[56])", , , , "15"], , [, , "1(?:1(?:22?|5)|[56])", , 
, , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PL:[, [, , "[19]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [, , "11(?:2|6\\d{3})|99[7-9]", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "PL", , , , , , , , , , , , , , , , , , [, , "112|99[7-9]", , , , "112", , , [3]], , [, , "1(?:1(?:2|61(?:11|23)|891[23])|9\\d{3})|9(?:8[4-7]|9[1-9])|11[68]000", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], 
PM:[, [, , "[13]\\d(?:\\d{2})?", , , , , , , [2, 4]], , , [, , "1[578]", , , , "15", , , [2]], [, , , , , , , , , [-1]], , , , "PM", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15", , , [2]], , [, , "1[578]|3103", , , , "15"], [, , , , , , , , , [-1]], [, , "310\\d", , , , "3100", , , [4]], , [, , , , , , , , , [-1]]], PR:[, [, , "9\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "PR", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], 
, [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PS:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "1(?:0[0-2]|66)", , , , "100"], [, , , , , , , , , [-1]], , , , "PS", , , , , , , , , , , , , , , , , , [, , "10[0-2]", , , , "100"], , [, , "1(?:0[0-2]|44|66|99)", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PT:[, [, , "1\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "11(?:[25]|6\\d{3})", 
, , , "112"], [, , , , , , , , , [-1]], , , , "PT", , , , , , , , , , , , , , , , , , [, , "11[25]", , , , "112", , , [3]], , [, , "11(?:[2578]|6(?:000|111))", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PW:[, [, , "9\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "PW", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
, [, , , , , , , , , [-1]]], PY:[, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "128|911", , , , "128"], [, , , , , , , , , [-1]], , , , "PY", , , , , , , , , , , , , , , , , , [, , "128|911", , , , "128"], , [, , "1[1-4]\\d|911", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], QA:[, [, , "[129]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "999", , , , "999", , , [3]], [, , , , , , , , , [-1]], , , , "QA", , , , , , , , , , , , , , , , , , [, , "999", 
, , , "999", , , [3]], , [, , "999|(?:1|20|9[27]\\d)\\d\\d", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], RE:[, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], , , , "RE", , , , , , , , , , , , , , , , , , [, , "1(?:12|[578])", , , , "15"], , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], RO:[, [, , "[18]\\d\\d(?:\\d(?:\\d{2})?)?", 
, , , , , , [3, 4, 6]], , , [, , "11(?:2|6\\d{3})", , , , "112", , , [3, 6]], [, , "(?:1(?:18\\d|[24])|8[48])\\d\\d", , , , "1200", , , [4, 6]], , , , "RO", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "1(?:1(?:2|6111|8932)|[24]\\d\\d|9(?:21|3[02]|5[178]))|8[48]\\d\\d|11(?:60|83)00", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "(?:1[24]|8[48])\\d\\d", , , , "1200", , , [4]]], RS:[, [, , "[19]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]], , , [, 
, "112|9[2-4]", , , , "92", , , [2, 3]], [, , , , , , , , , [-1]], , , , "RS", , , , , , , , , , , , , , , , , , [, , "112|9[2-4]", , , , "92", , , [2, 3]], , [, , "1[189]\\d{1,4}|9[2-4]", , , , "92"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], RU:[, [, , "[01]\\d\\d?", , , , , , , [2, 3]], , , [, , "112|(?:0|10)[1-3]", , , , "01"], [, , , , , , , , , [-1]], , , , "RU", , , , , , , , , , , , , , , , , , [, , "112|(?:0|10)[1-3]", , , , "01"], , [, , "112|(?:0|10)[1-4]", 
, , , "01"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], RW:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "112", , , , "112"], [, , , , , , , , , [-1]], , , , "RW", , , , , , , , , , , , , , , , , , [, , "112", , , , "112"], , [, , "112", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SA:[, [, , "[19]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:2|6\\d{3})|9(?:11|37|9[7-9])", , , , "112", , , [3, 6]], [, , 
, , , , , , , [-1]], , , , "SA", , , , , , , , , , , , , , , , , , [, , "112|9(?:11|9[79])", , , , "112", , , [3]], , [, , "1(?:1(?:00|2|6111)|410|9(?:00|1[89]|9(?:099|22|91)))|9(?:0[24-79]|11|3[379]|40|66|8[5-9]|9[02-9])", , , , "112"], [, , "141\\d", , , , "1410", , , [4]], [, , "1(?:10|41)\\d|90[24679]", , , , "902", , , [3, 4]], , [, , , , , , , , , [-1]]], SB:[, [, , "[127-9]\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "SB", , , , , , , , , , , , , 
, , , , , [, , "999", , , , "999"], , [, , "1(?:[02]\\d|1[12]|[35][01]|[49][1-9]|6[2-9]|7[7-9]|8[0-8])|269|777|835|9(?:[01]1|22|33|55|77|88|99)", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SC:[, [, , "[19]\\d{2,3}", , , , , , , [3, 4]], , , [, , "999", , , , "999", , , [3]], [, , , , , , , , , [-1]], , , , "SC", , , , , , , , , , , , , , , , , , [, , "999", , , , "999", , , [3]], , [, , "1(?:0\\d|1[027]|2[0-8]|3[13]|4[0-2]|[59][15]|6[1-9]|7[124-6]|8[158])|9(?:6\\d\\d|99)", 
, , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SD:[, [, , "9\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "SD", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SE:[, [, , "[1-37-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "112|(?:116\\d|900)\\d\\d", , , , "112", , , [3, 5, 6]], [, , 
"11811[89]|72\\d{3}", , , , "72000", , , [5, 6]], , , , "SE", , , , , , , , , , , , , , , , , , [, , "112|90000", , , , "112", , , [3, 5]], , [, , "11(?:[25]|313|6(?:00[06]|1(?:1[17]|23))|7[0-8])|2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|9(?:0(?:00|51)0|12)|(?:11(?:4|8[02-46-9])|7\\d\\d|90[2-4])\\d\\d|(?:118|90)1(?:[02-9]\\d|1[013-9])", , , , "112"], [, , , , , , , , , [-1]], [, , "2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|912", , , , "220", , , [3]], , [, , "7\\d{4}", , , , "70000", 
, , [5]]], SG:[, [, , "[179]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "99[359]", , , , "993", , , [3]], [, , , , , , , , , [-1]], , , , "SG", , , , , , , , , , , , , , , , , , [, , "99[359]", , , , "993", , , [3]], , [, , "1(?:[0136]\\d\\d|[57]\\d{2,3}|[89](?:0[1-9]|[1-9]\\d))|77222|99[02-9]", , , , "990"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "772\\d\\d", , , , "77200", , , [5]]], SH:[, [, , "[19]\\d{2,3}", , , , , , , [3, 4]], , , [, , "9(?:11|99)", , , , "911", , , [3]], 
[, , , , , , , , , [-1]], , , , "SH", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911", , , [3]], , [, , "1\\d{2,3}|9(?:11|99)", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SI:[, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:(?:0|6\\d)\\d\\d|[23]|8\\d\\d?)", , , , "112"], [, , , , , , , , , [-1]], , , , "SI", , , , , , , , , , , , , , , , , , [, , "11[23]", , , , "112", , , [3]], , [, , "1(?:1(?:00[146]|[23]|6(?:000|1(?:11|23))|8(?:[08]|99))|9(?:059|1(?:0[12]|16)|5|70|87|9(?:00|[149])))|19(?:08|81)[09]", 
, , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SJ:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[023]", , , , "110"], [, , , , , , , , , [-1]], , , , "SJ", , , , , , , , , , , , , , , , , , [, , "11[023]", , , , "110"], , [, , "11[023]", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SK:[, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1(?:2|6\\d{3})|5[058])", , , , "112", , , [3, 6]], [, 
, , , , , , , , [-1]], , , , "SK", , , , , , , , , , , , , , , , , , [, , "1(?:12|5[058])", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:000|111)|8[0-8])|[248]\\d{3}|5[0589])", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SL:[, [, , "[069]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "(?:01|99)9", , , , "019", , , [3]], [, , , , , , , , , [-1]], , , , "SL", , , , , , , , , , , , , , , , , , [, , "(?:01|99)9", , , , "019", , , [3]], , [, , "(?:01|99)9|60400", 
, , , "019"], [, , , , , , , , , [-1]], [, , "604\\d\\d", , , , "60400", , , [5]], , [, , "604\\d\\d", , , , "60400", , , [5]]], SM:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[358]", , , , "113"], [, , , , , , , , , [-1]], , , , "SM", , , , , , , , , , , , , , , , , , [, , "11[358]", , , , "113"], , [, , "11[358]", , , , "113"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SN:[, [, , "[12]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]], , , [, , "1(?:515|[78])|2(?:00|1)\\d{3}", 
, , , "17", , , [2, 4, 5, 6]], [, , "2(?:0[246]|[468])\\d{3}", , , , "24000", , , [5, 6]], , , , "SN", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17", , , [2]], , [, , "1(?:1[69]|(?:[246]\\d|51)\\d)|2(?:0[0-246]|[12468])\\d{3}|1[278]", , , , "12"], [, , "2(?:01|2)\\d{3}", , , , "22000", , , [5, 6]], [, , "1[46]\\d\\d", , , , "1400", , , [4]], , [, , "2[468]\\d{3}", , , , "24000", , , [5]]], SO:[, [, , "[57-9]\\d\\d", , , , , , , [3]], , , [, , "555|888|999", , , , "555"], [, , , , , , 
, , , [-1]], , , , "SO", , , , , , , , , , , , , , , , , , [, , "555|888|999", , , , "555"], , [, , "555|777|888|999", , , , "555"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SR:[, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "115", , , , "115", , , [3]], [, , , , , , , , , [-1]], , , , "SR", , , , , , , , , , , , , , , , , , [, , "115", , , , "115", , , [3]], , [, , "1\\d{2,3}", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , 
, , , , , [-1]]], ST:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "112", , , , "112"], [, , , , , , , , , [-1]], , , , "ST", , , , , , , , , , , , , , , , , , [, , "112", , , , "112"], , [, , "112", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SV:[, [, , "[49]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "911", , , , "911", , , [3]], [, , , , , , , , , [-1]], , , , "SV", , , , , , , , , , , , , , , , , , [, , "911", , , , "911", , , [3]], , [, 
, "40404|911", , , , "911"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]], SX:[, [, , "9\\d\\d", , , , , , , [3]], , , [, , "919", , , , "919"], [, , , , , , , , , [-1]], , , , "SX", , , , , , , , , , , , , , , , , , [, , "919", , , , "919"], , [, , "919", , , , "919"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SY:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[023]", , , , "110"], [, , , 
, , , , , , [-1]], , , , "SY", , , , , , , , , , , , , , , , , , [, , "11[023]", , , , "110"], , [, , "11[023]", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SZ:[, [, , "9\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "SZ", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TC:[, [, , "9\\d\\d", 
, , , , , , [3]], , , [, , "9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "TC", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TD:[, [, , "1\\d", , , , , , , [2]], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "TD", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, 
, , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TG:[, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[78]|7[127])", , , , "117", , , [3]], [, , , , , , , , , [-1]], , , , "TG", , , , , , , , , , , , , , , , , , [, , "1(?:1[78]|7[127])", , , , "117", , , [3]], , [, , "1(?:011|1[078]|7[127])", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TH:[, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1(?:00|2[03]|3[3479]|7[67]|9[0246])|578|6(?:44|6[79]|88|9[16])|88\\d|9[19])|1[15]55", 
, , , "191"], [, , "1(?:113|2[23]\\d|5(?:09|56))", , , , "1113", , , [4]], , , , "TH", , , , , , , , , , , , , , , , , , [, , "1(?:669|9[19])", , , , "191"], , [, , "1(?:0[0-2]|1(?:0[03]|1[1-35]|2[0358]|3[03-79]|4[02-489]|5[04-9]|6[04-79]|7[03-9]|8[027-9]|9[02-79])|2(?:22|3[89]|66)|3(?:18|2[23]|3[013]|5[56]|6[45]|73)|477|5(?:0\\d|4[0-37-9]|5[1-8]|6[01679]|7[12568]|8[0-24589]|9[013589])|6(?:0[0-29]|2[03]|4[3-6]|6[1-9]|7[0257-9]|8[0158]|9[014-9])|7(?:[14]9|7[27]|90)|888|9[19])", , , , "100"], [, , 
"1(?:1(?:03|1[15]|2[58]|3[056]|4[02-49]|5[046-9]|7[03-589]|9[579])|5(?:0[0-8]|4[0-378]|5[1-478]|7[156])|6(?:20|4[356]|6[1-68]|7[057-9]|8[015]|9[0457-9]))|1(?:1[68]|26|3[1-35]|5[689]|60|7[17])\\d", , , , "1103", , , [4]], [, , "114[89]", , , , "1148", , , [4]], , [, , , , , , , , , [-1]]], TJ:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "1(?:0[1-3]|12)", , , , "101"], [, , , , , , , , , [-1]], , , , "TJ", , , , , , , , , , , , , , , , , , [, , "1(?:0[1-3]|12)", , , , "101"], , [, , "1(?:0[1-3]|12)", 
, , , "101"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TL:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[25]", , , , "112"], [, , , , , , , , , [-1]], , , , "TL", , , , , , , , , , , , , , , , , , [, , "11[25]", , , , "112"], , [, , "1(?:0[02]|1[25]|2[0138]|72|9[07])", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TM:[, [, , "0\\d", , , , , , , [2]], , , [, , "0[1-3]", , , , "01"], [, , , , , , , , , [-1]], 
, , , "TM", , , , , , , , , , , , , , , , , , [, , "0[1-3]", , , , "01"], , [, , "0[1-3]", , , , "01"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TN:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "19[078]", , , , "190"], [, , , , , , , , , [-1]], , , , "TN", , , , , , , , , , , , , , , , , , [, , "19[078]", , , , "190"], , [, , "19[078]", , , , "190"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TO:[, [, , "9\\d\\d", , , , 
, , , [3]], , , [, , "9(?:11|22|33|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "TO", , , , , , , , , , , , , , , , , , [, , "9(?:11|22|33|99)", , , , "911"], , [, , "9(?:11|22|33|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TR:[, [, , "[1-9]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:1[02]|22|3[126]|4[04]|5[15-9]|6[18]|77|83)", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "TR", , , , , , , , , , , , , , , , , , [, , "1(?:1[02]|55)", 
, , , "110", , , [3]], , [, , "1(?:1(?:[0239]|811)|2[126]|3(?:[12]|37?|[58]6|65?)|4(?:[014]|71)|5(?:07|[135689]|78?)|6(?:[02]6|[138]|99?)|7[0-79]|8(?:[0-578]|63?|95?))|2(?:077|268|4(?:17|23)|5(?:7[26]|82)|6[14]4|8\\d\\d|9(?:30|89))|3(?:0(?:05|72)|353|4(?:06|30|64)|502|674|747|851|9(?:1[29]|60))|4(?:0(?:25|3[12]|[47]2)|3(?:3[13]|[89]1)|439|5(?:43|55)|717|832)|5(?:145|290|[4-6]\\d\\d|772|833|9(?:[06]1|92))|6(?:236|6(?:12|39|8[59])|769)|7890|8(?:688|7(?:28|65)|85[06])|9(?:159|290)", , , , "110"], [, 
, "(?:285|542)0", , , , "2850", , , [4]], [, , , , , , , , , [-1]], , [, , "1(?:3(?:37|65)|44|578|699|8(?:3|63|95))|(?:1(?:3[58]|47|50|6[02])|2(?:07|26|4[12]|5[78]|6[14]|8\\d|9[38])|3(?:0[07]|[38]5|4[036]|50|67|74|9[16])|4(?:0[2-47]|3[389]|[48]3|5[45]|71)|5(?:14|29|[4-6]\\d|77|83|9[069])|6(?:23|6[138]|76)|789|8(?:68|7[26]|85)|9(?:15|29))\\d", , , , "144", , , [3, 4]]], TT:[, [, , "9\\d\\d", , , , , , , [3]], , , [, , "99[09]", , , , "990"], [, , , , , , , , , [-1]], , , , "TT", , , , , , , , , , 
, , , , , , , , [, , "99[09]", , , , "990"], , [, , "99[09]", , , , "990"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TV:[, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "TV", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "1\\d\\d|911", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TW:[, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[0289]|92\\d)", 
, , , "110"], [, , "10[56]", , , , "105", , , [3]], , , , "TW", , , , , , , , , , , , , , , , , , [, , "11[029]", , , , "110", , , [3]], , [, , "1(?:0[4-6]|1[02389]|6[5-8]|9(?:1[0-29]|22|5[057]|68|8[05]|9[15689]))", , , , "104"], [, , "1(?:65|9(?:19|50|85|98))", , , , "165"], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TZ:[, [, , "[149]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "11[12]|999", , , , "111", , , [3]], [, , , , , , , , , [-1]], , , , "TZ", , , , , , , , , , , , , , , 
, , , [, , "11[12]|999", , , , "111", , , [3]], , [, , "11[12]|46400|999", , , , "111"], [, , , , , , , , , [-1]], [, , "464\\d\\d", , , , "46400", , , [5]], , [, , "464\\d\\d", , , , "46400", , , [5]]], UA:[, [, , "[189]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:0[1-3]|1(?:2|6\\d{3}))", , , , "101", , , [3, 6]], [, , , , , , , , , [-1]], , , , "UA", , , , , , , , , , , , , , , , , , [, , "1(?:0[1-3]|12)", , , , "101", , , [3]], , [, , "1(?:0[1-49]|1(?:2|6(?:000|1(?:11|23))|8\\d\\d?)|(?:[278]|5\\d)\\d)|[89]00\\d\\d?|151|1(?:06|4\\d|6)\\d\\d", 
, , , "101"], [, , , , , , , , , [-1]], [, , "(?:118|[89]00)\\d\\d?", , , , "1180", , , [4, 5]], , [, , , , , , , , , [-1]]], UG:[, [, , "9\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "UG", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], US:[, [, , "[1-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "112|[69]11", , , , "112", , , [3]], 
[, , "24280|(?:381|968)35|4(?:3355|7553|8221)|5(?:(?:489|934)2|5928)|72078|(?:323|960)40|(?:276|414)63|(?:2(?:520|744)|7390|9968)9|(?:693|732|976)88|(?:3(?:556|825)|5294|8623|9729)4|(?:3378|4136|7642|8961|9979)6|(?:4(?:6(?:15|32)|827)|(?:591|720)8|9529)7", , , , "24280", , , [5]], , , , "US", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112", , , [3]], , [, , "11(?:2|5[1-47]|[68]\\d|7[0-57]|98)|[2-9]\\d{3,5}|[2-9]11", , , , "112"], [, , "2(?:3333|(?:4224|7562|900)2|56447|6688)|3(?:1010|2665|7404)|40404|560560|6(?:0060|22639|5246|7622)|7(?:0701|3822|4666)|8(?:(?:3825|7226)5|4816)|99099", 
, , , "23333", , , [5, 6]], [, , "336\\d\\d|[2-9]\\d{3}|[2356]11", , , , "211", , , [3, 4, 5]], , [, , "[2-9]\\d{4,5}", , , , "20000", , , [5, 6]]], UY:[, [, , "[19]\\d{2,3}", , , , , , , [3, 4]], , , [, , "128|911", , , , "128", , , [3]], [, , , , , , , , , [-1]], , , , "UY", , , , , , , , , , , , , , , , , , [, , "128|911", , , , "128", , , [3]], , [, , "1(?:0[4-9]|1[2368]|2[0-3568]|787)|911", , , , "104"], [, , "178\\d", , , , "1780", , , [4]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], 
UZ:[, [, , "[04]\\d(?:\\d(?:\\d{2})?)?", , , , , , , [2, 3, 5]], , , [, , "0(?:0[1-3]|[1-3]|50)", , , , "01", , , [2, 3]], [, , , , , , , , , [-1]], , , , "UZ", , , , , , , , , , , , , , , , , , [, , "0(?:0[1-3]|[1-3]|50)", , , , "01", , , [2, 3]], , [, , "0(?:0[1-3]|[1-3]|50)|45400", , , , "01"], [, , , , , , , , , [-1]], [, , "454\\d\\d", , , , "45400", , , [5]], , [, , "454\\d\\d", , , , "45400", , , [5]]], VA:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[2358]", , , , "112"], [, , , , , , 
, , , [-1]], , , , "VA", , , , , , , , , , , , , , , , , , [, , "11[2358]", , , , "112"], , [, , "11[2358]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], VC:[, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "VC", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], 
VE:[, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "1(?:12|71)|911", , , , "112"], [, , , , , , , , , [-1]], , , , "VE", , , , , , , , , , , , , , , , , , [, , "1(?:12|71)|911", , , , "112"], , [, , "1(?:12|71)|911", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], VG:[, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "VG", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , 
"9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], VI:[, [, , "9\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "VI", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], VN:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[3-5]", , , , "113"], [, , , , , , , , , [-1]], , , , "VN", , , 
, , , , , , , , , , , , , , , [, , "11[3-5]", , , , "113"], , [, , "11[3-5]", , , , "113"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], VU:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "112", , , , "112"], [, , , , , , , , , [-1]], , , , "VU", , , , , , , , , , , , , , , , , , [, , "112", , , , "112"], , [, , "112", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], WF:[, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", 
, , , "15"], [, , , , , , , , , [-1]], , , , "WF", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], WS:[, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "9(?:11|9[4-69])", , , , "911"], [, , , , , , , , , [-1]], , , , "WS", , , , , , , , , , , , , , , , , , [, , "9(?:11|9[4-69])", , , , "911"], , [, , "1(?:1[12]|2[0-6])|9(?:11|9[4-79])", , , , "111"], [, , , , , , , , , [-1]], 
[, , "12[0-6]", , , , "120"], , [, , , , , , , , , [-1]]], XK:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "1(?:12|9[2-4])", , , , "112"], [, , , , , , , , , [-1]], , , , "XK", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[2-4])", , , , "112"], , [, , "1(?:12|9[2-4])", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], YE:[, [, , "1\\d\\d", , , , , , , [3]], , , [, , "19[1459]", , , , "191"], [, , , , , , , , , [-1]], , , , "YE", , , , , , , , , , , 
, , , , , , , [, , "19[1459]", , , , "191"], , [, , "19[1459]", , , , "191"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], YT:[, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:12|5)", , , , "15"], [, , , , , , , , , [-1]], , , , "YT", , , , , , , , , , , , , , , , , , [, , "1(?:12|5)", , , , "15"], , [, , "1(?:12|5)", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], ZA:[, [, , "[134]\\d{2,4}", , , , , , , [3, 4, 
5]], , , [, , "1(?:01\\d\\d|12)", , , , "112", , , [3, 5]], [, , "41(?:348|851)", , , , "41348", , , [5]], , , , "ZA", , , , , , , , , , , , , , , , , , [, , "1(?:01(?:11|77)|12)", , , , "112", , , [3, 5]], , [, , "1(?:0(?:1(?:11|77)|20|7)|1[12]|77(?:3[237]|[45]7|6[279]|9[26]))|[34]\\d{4}", , , , "107"], [, , "3(?:078[23]|7(?:064|567)|8126)|4(?:394[16]|7751|8837)|4[23]699", , , , "30782", , , [5]], [, , "111", , , , "111", , , [3]], , [, , "[34]\\d{4}", , , , "30000", , , [5]]], ZM:[, [, , "[19]\\d\\d", 
, , , , , , [3]], , , [, , "112|99[139]", , , , "112"], [, , , , , , , , , [-1]], , , , "ZM", , , , , , , , , , , , , , , , , , [, , "112|99[139]", , , , "112"], , [, , "112|99[139]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], ZW:[, [, , "[139]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "112|9(?:5[023]|61|9[3-59])", , , , "112", , , [3]], [, , "3[013-57-9]\\d{3}", , , , "30000", , , [5]], , , , "ZW", , , , , , , , , , , , , , , , , , [, , 
"112|99[3-59]", , , , "112", , , [3]], , [, , "11[2469]|3[013-57-9]\\d{3}|9(?:5[023]|6[0-25]|9[3-59])", , , , "112"], [, , , , , , , , , [-1]], [, , "114|9(?:5[023]|6[0-25])", , , , "114", , , [3]], , [, , , , , , , , , [-1]]]};
/*

 Copyright (C) 2018 The Libphonenumber Authors.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
i18n.phonenumbers.ShortNumberInfo = function() {
  this.regionToMetadataMap = {};
};
goog.addSingletonGetter(i18n.phonenumbers.ShortNumberInfo);
i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_ = ["BR", "CL", "NI"];
i18n.phonenumbers.ShortNumberInfo.ShortNumberCost = {TOLL_FREE:0, STANDARD_RATE:1, PREMIUM_RATE:2, UNKNOWN_COST:3};
i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodesForCountryCode_ = function(a) {
  return (a = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a]) ? a : [];
};
i18n.phonenumbers.ShortNumberInfo.prototype.regionDialingFromMatchesNumber_ = function(a, b) {
  var c = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
  return goog.array.contains(c, b);
};
i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumberForRegion = function(a, b) {
  if (!this.regionDialingFromMatchesNumber_(a, b)) {
    return !1;
  }
  var c = this.getMetadataForRegion_(b);
  if (!c) {
    return !1;
  }
  var d = this.getNationalSignificantNumber_(a).length;
  return goog.array.contains(c.getGeneralDesc().possibleLengthArray(), d);
};
i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumber = function(a) {
  var b = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
  a = this.getNationalSignificantNumber_(a).length;
  for (var c = 0; c < b.length; c++) {
    var d = this.getMetadataForRegion_(b[c]);
    if (d && (d = d.getGeneralDesc().possibleLengthArray(), goog.array.contains(d, a))) {
      return !0;
    }
  }
  return !1;
};
i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumberForRegion = function(a, b) {
  if (!this.regionDialingFromMatchesNumber_(a, b)) {
    return !1;
  }
  var c = this.getMetadataForRegion_(b);
  if (!c) {
    return !1;
  }
  var d = this.getNationalSignificantNumber_(a), e = c.getGeneralDesc();
  if (!this.matchesPossibleNumberAndNationalNumber_(d, e)) {
    return !1;
  }
  c = c.getShortCode();
  return this.matchesPossibleNumberAndNationalNumber_(d, c);
};
i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumber = function(a) {
  var b = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault()), c = this.getRegionCodeForShortNumberFromRegionList_(a, b);
  return 1 < b.length && null != c ? !0 : this.isValidShortNumberForRegion(a, c);
};
i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCostForRegion = function(a, b) {
  var c = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost;
  if (!this.regionDialingFromMatchesNumber_(a, b)) {
    return c.UNKNOWN_COST;
  }
  var d = this.getMetadataForRegion_(b);
  if (!d) {
    return c.UNKNOWN_COST;
  }
  var e = this.getNationalSignificantNumber_(a);
  return goog.array.contains(d.getGeneralDesc().possibleLengthArray(), e.length) ? this.matchesPossibleNumberAndNationalNumber_(e, d.getPremiumRate()) ? c.PREMIUM_RATE : this.matchesPossibleNumberAndNationalNumber_(e, d.getStandardRate()) ? c.STANDARD_RATE : this.matchesPossibleNumberAndNationalNumber_(e, d.getTollFree()) || this.isEmergencyNumber(e, b) ? c.TOLL_FREE : c.UNKNOWN_COST : c.UNKNOWN_COST;
};
i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCost = function(a) {
  var b = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost, c = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
  if (0 === c.length) {
    return b.UNKNOWN_COST;
  }
  if (1 === c.length) {
    return this.getExpectedCostForRegion(a, c[0]);
  }
  for (var d = b.TOLL_FREE, e = 0; e < c.length; e++) {
    var f = this.getExpectedCostForRegion(a, c[e]);
    switch(f) {
      case b.PREMIUM_RATE:
        return b.PREMIUM_RATE;
      case b.UNKNOWN_COST:
        d = b.UNKNOWN_COST;
        break;
      case b.STANDARD_RATE:
        d !== b.UNKNOWN_COST && (d = b.STANDARD_RATE);
        break;
      case b.TOLL_FREE:
        break;
      default:
        throw Error("Unrecognized cost for region: " + f);
    }
  }
  return d;
};
i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodeForShortNumberFromRegionList_ = function(a, b) {
  if (0 === b.length) {
    return null;
  }
  if (1 === b.length) {
    return b[0];
  }
  for (var c = this.getNationalSignificantNumber_(a), d = 0; d < b.length; d++) {
    var e = b[d], f = this.getMetadataForRegion_(e);
    if (f && this.matchesPossibleNumberAndNationalNumber_(c, f.getShortCode())) {
      return e;
    }
  }
  return null;
};
i18n.phonenumbers.ShortNumberInfo.prototype.getSupportedRegions = function() {
  return goog.array.filter(Object.keys(i18n.phonenumbers.shortnumbermetadata.countryToMetadata), function(a) {
    return isNaN(a);
  });
};
i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumber = function(a) {
  a = this.getMetadataForRegion_(a);
  if (!a) {
    return "";
  }
  a = a.getShortCode();
  return a.hasExampleNumber() ? a.getExampleNumber() || "" : "";
};
i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumberForCost = function(a, b) {
  var c = this.getMetadataForRegion_(a);
  if (!c) {
    return "";
  }
  var d = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost, e = null;
  switch(b) {
    case d.TOLL_FREE:
      e = c.getTollFree();
      break;
    case d.STANDARD_RATE:
      e = c.getStandardRate();
      break;
    case d.PREMIUM_RATE:
      e = c.getPremiumRate();
  }
  return e && e.hasExampleNumber() ? e.getExampleNumber() || "" : "";
};
i18n.phonenumbers.ShortNumberInfo.prototype.connectsToEmergencyNumber = function(a, b) {
  return this.matchesEmergencyNumberHelper_(a, b, !0);
};
i18n.phonenumbers.ShortNumberInfo.prototype.isEmergencyNumber = function(a, b) {
  return this.matchesEmergencyNumberHelper_(a, b, !1);
};
i18n.phonenumbers.ShortNumberInfo.prototype.getMetadataForRegion_ = function(a) {
  if (!a) {
    return null;
  }
  a = a.toUpperCase();
  var b = this.regionToMetadataMap[a];
  if (null == b) {
    b = new goog.proto2.PbLiteSerializer;
    var c = i18n.phonenumbers.shortnumbermetadata.countryToMetadata[a];
    if (null == c) {
      return null;
    }
    b = b.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(), c);
    this.regionToMetadataMap[a] = b;
  }
  return b;
};
i18n.phonenumbers.ShortNumberInfo.prototype.matchesEmergencyNumberHelper_ = function(a, b, c) {
  var d = i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(a);
  if (i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(d)) {
    return !1;
  }
  a = this.getMetadataForRegion_(b);
  if (null == a || !a.hasEmergency()) {
    return !1;
  }
  d = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d);
  b = c && !goog.array.contains(i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_, b);
  c = a.getEmergency().getNationalNumberPatternOrDefault();
  return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(c, d) || b && i18n.phonenumbers.PhoneNumberUtil.matchesPrefix(c, d);
};
i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecific = function(a) {
  var b = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
  b = this.getRegionCodeForShortNumberFromRegionList_(a, b);
  a = this.getNationalSignificantNumber_(a);
  b = this.getMetadataForRegion_(b);
  return !!b && this.matchesPossibleNumberAndNationalNumber_(a, b.getCarrierSpecific());
};
i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecificForRegion = function(a, b) {
  if (!this.regionDialingFromMatchesNumber_(a, b)) {
    return !1;
  }
  var c = this.getNationalSignificantNumber_(a), d = this.getMetadataForRegion_(b);
  return !!d && this.matchesPossibleNumberAndNationalNumber_(c, d.getCarrierSpecific());
};
i18n.phonenumbers.ShortNumberInfo.prototype.isSmsServiceForRegion = function(a, b) {
  if (!this.regionDialingFromMatchesNumber_(a, b)) {
    return !1;
  }
  var c = this.getMetadataForRegion_(b), d = this.getNationalSignificantNumber_(a);
  return !!c && this.matchesPossibleNumberAndNationalNumber_(d, c.getSmsServices());
};
i18n.phonenumbers.ShortNumberInfo.prototype.getNationalSignificantNumber_ = function(a) {
  if (!a.hasNationalNumber()) {
    return "";
  }
  var b = "" + a.getNationalNumber();
  return a.hasItalianLeadingZero() && a.getItalianLeadingZero() && 0 < a.getNumberOfLeadingZerosOrDefault() ? Array(a.getNumberOfLeadingZerosOrDefault() + 1).join("0") + b : b;
};
i18n.phonenumbers.ShortNumberInfo.prototype.matchesPossibleNumberAndNationalNumber_ = function(a, b) {
  return 0 < b.possibleLengthArray().length && !goog.array.contains(b.possibleLengthArray(), a.length) ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(b.getNationalNumberPatternOrDefault(), a.toString());
};
Object.defineProperty(exports, "__esModule", {value:!0});
exports["default"] = i18n.phonenumbers;
module.exports = exports["default"];


},{}]},{},[1])(1)
});

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],27:[function(require,module,exports){
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],28:[function(require,module,exports){
AuditService.$inject = ['api'];
function AuditService(api) {
  var service = this;
  service.getAudit = getAudit;
  service.getModels = getModels;

  function getAudit(payload){
    return api
      .request('/audit/all', payload);
  }

  function getModels(){
    return api
      .request('/audit/models');
  }
}

angular
  .module('app')
  .service('AuditService', AuditService);

},{}],29:[function(require,module,exports){
/** AUTH REDIRECT :: RUN
 *
 *    Observe API requests and Routing changes and
 *     present a simple, scalable solution for
 *     permissions.
 *
 *  @author  David "oodavid" King
 */
AuthRedirectRun.$inject = ['$state', '$q', 'api', '$transitions', 'AuthService', 'swalService', 'alertService', 'AuthRedirectService', 'UserService', 'DepartmentService', '$timeout'];
function AuthRedirectRun($state, $q, api, $transitions, AuthService, swalService, alertService, AuthRedirectService, UserService, DepartmentService, $timeout) {

  // Handle 2FA configuration needed
  api.addErrorHandler(307, AuthHandleApi307);

  // Handle common API errors
  api.addErrorHandler(401, AuthHandleApi401);
  api.addErrorHandler(453, AuthHandleApi453);

  // Router :: Require a user to access dashboard routes
  $transitions.onStart({ to: 'issuer.dashboard.**' }, AuthRequireUserAndDepartment);
  $transitions.onStart({ to: 'issuer.mfa.**' }, AuthRequireUserAndDepartment);

  // Router :: Require NO user to access login / registration pages
  $transitions.onStart({ to: 'issuer.sign-up' }, AuthRequireNoUser);
  $transitions.onStart({ to: 'issuer.login' }, AuthRequireNoUser);
  $transitions.onStart({ to: 'issuer.login_redirect' }, AuthRequireNoUser);
  $transitions.onStart({ to: 'issuer.forgotten_password' }, AuthRequireNoUser);

  // API :: 307 :: If admin issuer enables MFA in a department, all other issuers need to set up MFA in order to continue using the dashboard in that department
  function AuthHandleApi307() {
    if ($state.current !== 'issuer.mfa.mfa-setup') {
      $timeout(function(){
        $state.go('issuer.mfa.mfa-setup',  null, { location: 'replace' }); // Redirect
      });
    }
  }

  // API :: 401 :: Our token has been invalidated, the API will no longer obey the token
  function AuthHandleApi401(err, endpoint) {
    AuthService.reset(); // Reset
    console.log('401 error returned by ' + (endpoint.path || endpoint));
    // Unless we're checking our token validity or trying to reset our password, force the user back to the sign in screen
    if (endpoint.path !== '/issuer_login/whoami' && endpoint.path !== '/organization/reset_password_request') {
      swalService.showAlert('issuerMustLogin'); // Show a message
      $timeout(function(){
        $state.go('issuer.login'); // Redirect
      });
    }
  }

  // API :: 453 :: The user doesn't have permission to do this (453 is a custom code for ACMS)
  function AuthHandleApi453(err, endpoint) {
    alertService.alert('Whoops!', '<h4>You don\'t have permission to do this.</h4>\
                                    <p>Contact your Accredible account admin for access.</p>\
                                    <p><a href="https://help.accredible.com/s/article/how-to-use-team-members-and-permissions?language=en_US" target="_blank"><i class="help"></i> Understanding Team Permissions</a></p>');
  }

  // Router :: Check the user when
  function AuthRequireUserAndDepartment($transition){
    return $q
      .all([
        UserService.getUser(),
        DepartmentService.getDepartment()
      ])
      .then(function(data){
        AuthRedirectService.cacheState($transition.to(), $transition.params('to')); // Store the current state, for redirects
        
        var user = data[0];
        var department = data[1];
        // We must have a user
        if(angular.equals({}, user)){
          if($transition.from().name.indexOf('issuer.dashboard.') === 0){
            swalService.showAlert('issuerMustLogin'); // We were on an authenticated route, so a warning message is appropriate
          }
          return $state.target('issuer.login');
        }
        // We must have an department
        if(angular.equals({}, department)){
          return $state.target('issuer.select-department');
        }
      });
  }

  // Router :: Redirect login routes when authenticated
  function AuthRequireNoUser($transition){
    return UserService
      .getUser()
      .then(function(user){
        // If we have a verified user... go to the dashboard!
        if(!angular.equals({}, user) && user.verified){
          return $state.target('issuer.dashboard.home');
        }
      });
  }

}

angular
  .module('app')
  .run(AuthRedirectRun);

},{}],30:[function(require,module,exports){
/** AUTH REDIRECT SERVICE
 *
 *    When attempting to access the dashboard with an
 *     invalid token we store the desired state. After
 *     any auth issues have been resolved, we can then
 *     redirect the user to their expected destination.
 *
 *    See:
 *      PermissionsRun
 *      LoginRouteCtrl
 *      SelectDepartmentRouteCtrl
 */
AuthRedirectService.$inject = ['$state', '$timeout'];
function AuthRedirectService($state, $timeout) {
  var service = this;
  service.cacheState = cacheState;
  service.go = go;

  var cache = false;

  // Store the arguments for later. Any subsequent call to `go` will use these arguments
  function cacheState(state, params, options){
    // Don't redirect a user to sign in on the cache
    if(state != 'issuer.login'){
      options = options || {};
      options.reload = true;
      cache = [ state, params, options ];
    }
  }

  // Go to a given state, or use the cache override
  function go(state, params, options){
    if(!cache){
      $timeout(function(){
        $state.go(state, params, options); // Act like state.go
      });
    } else {
      $state.go.apply(null, cache); // Act like state.go, but use the cached redirect arguments
      cache = false;
    }
  }

}

angular
  .module('app')
  .service('AuthRedirectService', AuthRedirectService);

},{}],31:[function(require,module,exports){

/** BILLING - SERVICE
 *
 *      Exposes information about the payment
 *       plans and addons available to the issuer
 *
 *    @author   David "odavid" King
 *    @author   Andrew Bateman (refactored to start to remove dependancy on 'pricing.features')
 */
BillingService.$inject = ['api', 'ENV', 'stripe', '$q', 'swalService', 'AnalyticsService', 'AuthService', 'moment', '$filter'];
function BillingService(api, ENV, stripe, $q, swalService, AnalyticsService, AuthService, moment, $filter){
  var service = this;

  service.getPricing = getPricing;
  service.getYearlyReport = getYearlyReport;
  service.getPlansAndAddOns = getPlansAndAddOns;
  service.getSummary = getSummary;
  service.makePurchase = makePurchase;
  service.getSavedCard = getSavedCard;
  service.updateCreditCard = updateCreditCard;
  service.getPaymentSchedule = getPaymentSchedule;
  service.getInvoicesAndPlan = getInvoicesAndPlan;
  service.getManageBillingUrl = getManageBillingUrl;

  // TODO: This needs to be superseded by allowances
  var pricing = {}; // The pricing object
  // Listen to the Auth object for our current pricing state
  function getPricing(){
    return AuthService
      .getAuth()
      .then(function(auth){
        cherrypickAuthProperties(auth);
        return pricing;
      });
  }
  AuthService.on('change', function(auth){
    cherrypickAuthProperties(auth);
  });
  function cherrypickAuthProperties(auth){
    angular.copy(auth.pricing || {}, pricing);
  }

  function getYearlyReport(id){
    return api
      .request('/billing/yearly_report', {id: id})
      .then(function(response) {
        return response;
      });
  }

  // Initialize Stripe
  stripe.setPublishableKey(ENV.stripeKey);

  var addOns;
  function getPlansAndAddOns() {
    return api
      .request('/billing/all_plans') // This is '/stripe/all_plans'
      .then(function(response) {
        addOns = response.addons;
        return response;
      });
  }

  function resolveDate(value) {
    return $filter('date')(new Date(value * 1000), 'yyyy-MM-dd');
  }

  function getSummary(plan, addonList, coupon_code) {
    return $q(function (resolve, reject) {
      return api
        .extendedRequest('/billing/get_billing_summary', {
          plan: plan,
          coupon_code: coupon_code,
          addons: addonList,
        })
        // The response isn't in the format that we can fully understand, hence the data massage...
        .then(function (extendedResponse) {
          // Date of next payment
          var nextDate = resolveDate(extendedResponse.data.invoice.next_payment_attempt);
          // One month from today
          var oneMonthsTime = moment().add(1, 'months').format('YYYY-MM-DD');
          // Categorise list items into this month's and next month's
          var thisMonth = [];
          var nextMonth = [];
          var lineItems = extendedResponse.data.invoice.lines.data;
          lineItems.forEach(function (item) {
            if (resolveDate(item.period.end) > oneMonthsTime) {
              nextMonth.push(item);
            } else {
              thisMonth.push(item);
            }
          });
          // Handle initial subscription
          if (extendedResponse.data.invoice.subscription_proration_date && thisMonth.length > 0 && nextMonth.length == 0) {
            nextMonth = thisMonth;
            thisMonth = [];
          }
          angular.forEach(addOns, function (addOn) {
            // Add free add ons to invoice
            if (addOn.active && !addOn.purchased) {
              nextMonth.push({ description: '1 x ' + addOn.title + ' (free)', amount: 0, currency: 'usd' });
            }
          });
          // Discount next month's items if there is an active discount code
          // For some reason Stripe does not do this, although its amount due takes the discount into account
          var percentOff = null;
          if (extendedResponse.data.invoice.discount) {
            percentOff = extendedResponse.data.invoice.discount.coupon.percent_off.toFixed(1);
            nextMonth.forEach(function (item) {
              if (item.discountable) {
                item.amount = item.amount * ((100 - percentOff) / 100);
                item.description += ' (with ' + percentOff + '% off)';
              }
            });
          }
          // Calculate the monthly cost
          var monthlyCost = 0;
          nextMonth.forEach(function (item) {
            monthlyCost += item.amount;
          });
          // Update the extended response
          extendedResponse.data.invoice.nextDate = nextDate;
          extendedResponse.data.invoice.lines.thisMonth = thisMonth;
          extendedResponse.data.invoice.lines.nextMonth = nextMonth;
          extendedResponse.data.invoice.percentOff = percentOff;
          extendedResponse.data.invoice.monthlyCost = monthlyCost;
          // Return the updated, extendedResponse
          resolve(extendedResponse);
        });
    });
  }

  function makePurchase(plan, addonList, coupon_code, card){
    if(!plan){
      return $q.reject('no plan');
    }
    var summary;
    // Start a promise chain
    return getSummary(plan, addonList, coupon_code)
      .then(function(extendedResponse){
        summary = extendedResponse.data;
        // Save the card (if possible / needed)
        if(card){
          return updateCreditCardWithoutFeedback(card);
        }
      })
      .then(function(){
        // Make the purchase
        return api.request('/billing/create_update_subscription', {
          plan: plan,
          coupon_code: coupon_code,
          addons: addonList,
        });
      })
      .then(function(response){
        var yearlyCost = (summary.invoice.monthlyCost * 12) / 100; // We want the monthly cost in cents as an annual cost in dollars
        AnalyticsService.trackPurchase(response.issuer.stripe_customer_id, yearlyCost);
        // Return the original response
        return response;
      })
      .catch(function(error){
        swalService.showAlert('updateSubscriptionError', error.data.data);
      });
  }

  function getSavedCard() {
    return api.request('/billing/card_detail')
      .then(function(response) {
        return {
          last4: response.data,
          brand: brands[response.brand.toLowerCase()],
        };
      })
      .catch(angular.noop);
  }

  function updateCreditCard(card) {
    return updateCreditCardWithoutFeedback(card)
      .then(function(){
        swalService.showAlert('updateCardSuccess');
      })
      .catch(function(error){
        swalService.showAlert('updateCardError', error.data.data);
      });
  }

  function updateCreditCardWithoutFeedback(card) {
    // If the user enters "2018" we might receive "202018"... fix it
    if (card && card.exp_year && card.exp_year > 9999) {
      card.exp_year = parseInt((card.exp_year + '').substr(-4), 10);
    }
    return stripe.card.createToken(card)
      .then(function(response) {
        return api.request('/billing/update_card', {
          customer: {
            stripe_token: response.id,
            address: {
              country: card.address_country,
              state: card.address_state,
            },
          }
        });
      });
  }

  function getPaymentSchedule() {
    return api.request('/billing/payment_schedule')
      .then(function(response){
        return response;
    });
  }

  function getManageBillingUrl(redirectUrl) {
    var params = {};
    if (redirectUrl) {
      params.redirect_to = redirectUrl;
    }
    return api.request('/billing/manage_billing', params);
  }

  function getInvoicesAndPlan() {
    return api.request('/billing/invoices/all')
      .then(function(response){
        return response.data;
    });
  }

  var brands = {
    'visa': 'visa',
    'mastercard': 'mastercard',
    'discover': 'discover',
    'american express': 'amex',
  };
}

angular
  .module('app')
  .service('BillingService', BillingService);

},{}],32:[function(require,module,exports){
CampaignsSmsService.$inject = ['api'];
function CampaignsSmsService(api) {
  var service = this;
  service.getSmsAccessRequest = getSmsAccessRequest;
  service.sendSmsAccessRequest = sendSmsAccessRequest;

  function getSmsAccessRequest(id){
    return api
      .request('/issuer/organizations/get_sms_configuration', { id: id });
  }

  function sendSmsAccessRequest(id){
    return api
      .request('/issuer/organizations/sms_configuration', {id: id});
  }
}

angular
  .module('app')
  .service('CampaignsSmsService', CampaignsSmsService);

},{}],33:[function(require,module,exports){
ContractsService.$inject = ['$q', 'api'];
function ContractsService($q, api) {
  var service = this;

  service.contracts = null;

  service.getContracts = getContracts;
  service.getContract = getContract;

  function getContracts() {
    return api
      .request('/contracts/all_contracts')
      .then(function(response) {
          service.contracts = response.contracts;
          return service.contracts;
        });
  }

  function selectContract(id) {
    return service.contracts.filter(function(contract) {
      return contract.id === id;
    })[0];
  }

  function getContract(id) {
    if (service.contracts) {
      return $q.resolve(selectContract(id));
    } else {
      return getContracts()
        .then(function() {
          return selectContract(id);
        });
    }
  }
}

angular.module('app').service('ContractsService', ContractsService);

},{}],34:[function(require,module,exports){
/** (CURRENT) DEPARTMENT SERVICE
 *
 *    The current department that the session is
 *     linked to / acting on.
 *
 *    Listens for changes in the AuthService,
 *     then plucks out the data that relates to the
 *     current department.
 *
 *    GOTCHAS / COMPLICATIONS
 *
 *    BE has coupled a `Branding` object with the
 *     Department object on a 1-to-1 basis. When
 *     saving the Department we also need to make
 *     a parallel request to save the Branding,
 *     which (extra confusingly) is actually
 *     bundled into the original Department object
 *     that BE returned to us in the first place.
 *
 *    Life is hard, but then you die. So it's got
 *     that going for it.
 */
DepartmentService.$inject = ['api', 'AuthService'];
function DepartmentService(api, AuthService) {
  var service = this;

  service.getDepartment = getDepartment;
  service.updateDepartment = updateDepartment;
  service.switchDepartment = switchDepartment;
  service.deleteDepartment = deleteDepartment;

  var department = {}; // The active / selected department

  function getDepartment(){
    return AuthService
      .getAuth()
      .then(function(auth){
        cherrypickAuthProperties(auth);
        return department;
      });
  }

  function updateDepartment(updatedDepartmentObject) {
    return api
      .request('/department/update', { issuer: updatedDepartmentObject })
      .then(function(response) {
        cherrypickAuthProperties(response.issuer); // The response is in the "auth" style, use the cherrypicker
        return department;
      });
  }

  function switchDepartment(department_id){
    return api
      .request('/issuer_login/select_department', {
        department_id: department_id,
      }).then(function(response) {
        localStorage.setItem('department', response.issuer.department.id);
        return response;
      });
  }

  function deleteDepartment(department_id){
    return api
      .request('/departments/delete', {
        id: department_id,
      });
  }

  AuthService.on('change', function(auth){
    cherrypickAuthProperties(auth);
  });

  function cherrypickAuthProperties(auth){
    angular.copy(auth.department || {}, department);
  }

}

angular
  .module('app')
  .service('DepartmentService', DepartmentService);

},{}],35:[function(require,module,exports){
DepartmentAnalyticsService.$inject = ['api', '_', '$q', 'moment', '$filter', 'AuthService'];
function DepartmentAnalyticsService(api, _, $q, moment, $filter, AuthService) {
  var service = this;
  service.getSummary = getSummary;
  service.getRecipientFunnel = getRecipientFunnel;
  service.getEngagementEventCounts = getEngagementEventCounts;
  service.getShareCounts = getShareCounts;
  service.getOverview = getOverview;
  service.getCredentialsIssuedChartData = getCredentialsIssuedChartData;
  service.getCredentialsOpenedChartData = getCredentialsOpenedChartData;
  service.getCredentialsViewsChartData = getCredentialsViewsChartData;
  service.getCredentialsSharesChartData = getCredentialsSharesChartData;

  service.getCredentialsIssuedCount = getCredentialsIssuedCount;
  service.getCredentialsOpenedCount = getCredentialsOpenedCount;
  service.getCredentialsViewsCount = getCredentialsViewsCount;
  service.getCredentialsSharesCount = getCredentialsSharesCount;

  service.getRecipientFunnel = getRecipientFunnel;
  service.getEventsLog = getEventsLog;
  service.exportEvents = exportEvents;
  service.reset = reset;
  service.getDepartmentIssuanceReport = getDepartmentIssuanceReport;
  service.getShareStats = getShareStats;

  var currentDepartmentId;
  AuthService
    .getAuth()
    .then(function(response) {
      currentDepartmentId = response.department.id;
    });


  // TODO: Remove this once getSummary is no longer used
  // This is used to map the sharing services to their human-readable names.
  // Originally a list of the addThis services lifted from https://www.addthis.com/services,
  // but now supplemented with others from GetSocial
  var sharingServices = {
    // addThis
    'facebook_like': 'Facebook Like',
    'foursquare': 'Foursquare',
    'google_plusone': 'Google +1',
    'google_plus': 'Google +',
    'pinterest': 'Pinterest Pin It',
    '100zakladok': '100zakladok',
    'addressbar': 'Address Bar',
    'adfty': 'Adfty',
    'adifni': 'Adifni',
    'advqr': 'ADV QR',
    'amazonwishlist': 'Amazon',
    'amenme': 'Amen Me!',
    'aim': 'AOL Lifestream',
    'aolmail': 'AOL Mail',
    'apsense': 'APSense',
    'atavi': 'Atavi',
    'baidu': 'Baidu',
    'balatarin': 'Balatarin',
    'beat100': 'Beat100',
    'bitly': 'Bit.ly',
    'bizsugar': 'BizSugar',
    'bland': 'Bland takkinn',
    'blogger': 'Blogger',
    'blogkeen': 'Blogkeen',
    'blogmarks': 'Blogmarks',
    'bobrdobr': 'Bobrdobr',
    'bonzobox': 'BonzoBox',
    'bookmarkycz': 'Bookmarky.cz',
    'bookmerkende': 'Bookmerken',
    'box': 'Box',
    'buffer': 'Buffer',
    'camyoo': 'Camyoo',
    'care2': 'Care2',
    'foodlve': 'Cherry Share',
    'citeulike': 'CiteULike',
    'cleanprint': 'CleanPrint',
    'cleansave': 'CleanSave',
    'cloob': 'Cloob',
    'technerd': 'Communicate',
    'link': 'Copy Link',
    'cosmiq': 'COSMiQ',
    'cssbased': 'CSS Based',
    'delicious': 'Delicious',
    'diary_ru': 'Diary.ru',
    'digg': 'Digg',
    'diggita': 'Diggita',
    'diigo': 'Diigo',
    'douban': 'Douban',
    'draugiem': 'Draugiem.lv',
    'edcast': 'EdCast',
    'efactor': 'EFactor',
    'email': 'Email',
    'mailto': 'Email App',
    'evernote': 'Evernote',
    'exchangle': 'Exchangle',
    'stylishhome': 'FabDesign',
    'fabulously40': 'Fabulously40',
    'facebook': 'Facebook',
    'messenger': 'Facebook Messenger',
    'facenama': 'Facenama',
    'informazione': 'Fai Informazione',
    'thefancy': 'Fancy',
    'fashiolista': 'Fashiolista',
    'favable': 'FAVable',
    'faves': 'Fave',
    'favorites': 'Favorites',
    'favoritus': 'Favoritus',
    'financialjuice': 'Financial Juice',
    'flipboard': 'Flipboard',
    'folkd': 'Folkd',
    'thefreedictionary': 'FreeDictionary',
    'gg': 'GG',
    'gmail': 'Gmail',
    'govn': 'Go.vn',
    'google': 'Google Bookmark',
    'google_classroom': 'Google Classroom',
    'googleplus': 'Google Plus',
    'googletranslate': 'Google Translate',
    'google_plusone_share': 'Google+',
    'hackernews': 'Hacker News',
    'hatena': 'Hatena',
    'hedgehogs': 'Hedgehogs',
    'historious': 'historious',
    'hootsuite': 'Hootsuite',
    'houzz': 'Houzz',
    'w3validator': 'HTML Validator',
    'indexor': 'Indexor',
    'instapaper': 'Instapaper',
    'iorbix': 'iOrbix',
    'jappy': 'Jappy Ticker',
    'kaixin': 'Kaixin Repaste',
    'kakao': 'Kakao',
    'ketnooi': 'Ketnooi',
    'kik': 'Kik',
    'kindleit': 'Kindle It',
    'kledy': 'Kledy',
    'lidar': 'LiDAR Online',
    'lineme': 'LINE',
    'linkedin': 'LinkedIn Shares',
    'linkuj': 'Linkuj.cz',
    'livejournal': 'LiveJournal',
    'mymailru': 'Mail.ru',
    'margarin': 'mar.gar.in',
    'markme': 'Markme',
    'meinvz': 'meinVZ',
    'memonic': 'Memonic',
    'memori': 'Memori.ru',
    'mendeley': 'Mendeley',
    'meneame': 'Meneame',
    'mixi': 'Mixi',
    'moemesto': 'Moemesto.ru',
    'mrcnetworkit': 'mRcNEtwORK',
    'myspace': 'Myspace',
    'myvidster': 'myVidster',
    'n4g': 'N4G',
    'naszaklasa': 'Nasza-klasa',
    'netvibes': 'Netvibes',
    'netvouz': 'Netvouz',
    'newsmeback': 'NewsMeBack',
    'newsvine': 'Newsvine',
    'nujij': 'Nujij',
    'nurses_lounge': 'Nurses Lounge',
    'odnoklassniki_ru': 'Odnoklassniki',
    'oknotizie': 'OKNOtizie',
    'openthedoor': 'OpenTheDoor',
    'hotmail': 'Outlook',
    'oyyla': 'Oyyla',
    'pafnetde': 'pafnet.de',
    'pdfmyurl': 'PDFmyURL',
    'pinboard': 'Pinboard',
    'pinterest_share': 'Pinterest',
    'plurk': 'Plurk',
    'pocket': 'Pocket',
    'posteezy': 'Posteezy',
    'print': 'Print',
    'printfriendly': 'PrintFriendly',
    'pusha': 'Pusha',
    'qrsrc': 'QRSrc.com',
    'quantcast': 'Quantcast',
    'qzone': 'Qzone',
    'reddit': 'Reddit',
    'rediff': 'Rediff MyPage',
    'renren': 'Renren',
    'researchgate': 'ResearchGate',
    'retellity': 'Retellity',
    'safelinking': 'Safelinking',
    'scoopit': 'Scoop.it',
    'sinaweibo': 'Sina Weibo',
    'skype': 'Skype',
    'skyrock': 'Skyrock Blog',
    'slack': 'Slack',
    'smiru': 'SMI',
    'sms': 'SMS',
    'sodahead': 'SodaHead',
    'spinsnap': 'SpinSnap',
    'startaid': 'Startaid',
    'startlap': 'Startlap',
    'studivz': 'studiVZ',
    'stuffpit': 'Stuffpit',
    'stumbleupon': 'StumbleUpon',
    'stumpedia': 'Stumpedia',
    'supbro': 'SUP BRO',
    'surfingbird': 'Surfingbird',
    'svejo': 'Svejo',
    'symbaloo': 'Symbaloo',
    'taringa': 'Taringa!',
    'telegram': 'Telegram',
    'tencentqq': 'Tencent QQ',
    'tencentweibo': 'Tencent Weibo',
    'thisnext': 'ThisNext',
    'trello': 'Trello',
    'tuenti': 'Tuenti',
    'tumblr': 'Tumblr',
    'twitter': 'Twitter',
    'typepad': 'Typepad',
    'urlaubswerkde': 'Urlaubswerk',
    'viadeo': 'Viadeo',
    'viber': 'Viber',
    'virb': 'Virb',
    'visitezmonsite': 'Visitez Mon Site',
    'vk': 'Vkontakte',
    'vkrugudruzei': 'vKruguDruzei',
    'voxopolis': 'VOXopolis',
    'vybralisme': 'vybrali SME',
    'wanelo': 'Wanelo',
    'internetarchive': 'Wayback Machine',
    'sharer': 'WebMoney',
    'wechat': 'WeChat',
    'whatsapp': 'WhatsApp',
    'domaintoolswhois': 'Whois Lookup',
    'wishmindr': 'WishMindr',
    'wordpress': 'WordPress',
    'wykop': 'Wykop',
    'xing': 'XING',
    'yahoomail': 'Yahoo Mail',
    'yammer': 'Yammer',
    'yookos': 'Yookos',
    'yoolink': 'Yoolink',
    'yorumcuyum': 'Yorumcuyum',
    'youmob': 'YouMob',
    'yummly': 'Yummly',
    'yuuby': 'Yuuby',
    'zakladoknet': 'Zakladok.net',
    'ziczac': 'ZicZac',
    'zingme': 'ZingMe',
    // GetSocial
    'instagram': 'Instagram',
    'kakaostory': 'KakaoStory',
    'line': 'Line',
    'snapchat': 'SnapChat',
    'vkontakte': 'VKontakte',
    'youtube': 'YouTube',
  };

  var summaryCache; // Used to cache summary data
  var summaryPayload; // Last used payload
  function getSummary(payload) {
    var tempPayload = angular.copy(payload);
    delete tempPayload.page;
    return $q(function(resolve) {
      // Only get data from BE if there isn't any or the new payload is
      // different to the previous one (excluding the issuer_token which may change)
      if (!summaryCache || !_.isEqual(_.omit(tempPayload, ['issuer_token']), _.omit(summaryPayload, ['issuer_token']))) {
        summaryPayload = angular.copy(tempPayload); // Remember the payload
        api
          .request('/analytics/summary', tempPayload)
          .then(function(response) {
            // The API gives us summary.engagement, which is a mismatch of views, downloads, embeds, shares etc.
            // ...here we isolate the `_shared` values into their own object
            response.shared = {};
            _.each(response.engagement, function(value, key) {
              if (key.slice(-7) == '_shared') {
                var cleanKey = key.slice(0, -7); // trim off the `_shared` suffix
                value['id'] = cleanKey;
                value['name'] = sharingServices[cleanKey] || cleanKey;
                response.shared[cleanKey] = value;
                if (key != 'linkedin_shared') {
                  delete response.engagement[key];
                }
              }
            });
            summaryCache = response;
            resolve(summaryCache);
          })
          .catch(function() {
            reject();
          });
      } else {
        resolve(summaryCache);
      }
    });
  }

  var overviewCache; // Used to cache overview data
  var overviewPayload; // Last used payload
  function getOverview(payload, dontShowAxes) {
    var tempPayload = angular.copy(payload);
    delete tempPayload.page;
    return $q(function(resolve) {
      // Only get data from BE if there isn't any or the new payload
      // is different to the previous one (excluding the issuer_token which may change)
      if (!overviewCache || !_.isEqual(_.omit(tempPayload, ['issuer_token']), _.omit(overviewPayload, ['issuer_token']))) {
        overviewPayload = angular.copy(tempPayload); // Remember the payload
        api
          .request('/analytics/overview', tempPayload)
          .then(function(response) {
            overviewCache = response;
            var charts = drawCharts(overviewCache, !dontShowAxes, !payload.start_date);
            resolve(charts);
          })
          .catch(function() {
            reject();
          });
      } else {
        var charts = drawCharts(overviewCache, !dontShowAxes, !payload.start_date);
        resolve(charts);
      }
    });
  }


  var credentialsIssuedCountCache; // Used to cache summary data
  var credentialsIssuedCountPayload; // Last used payload
  function getCredentialsIssuedCount(payload) {
    var tempPayload = angular.copy(payload);
    delete tempPayload.page;

    return $q(function(resolve) {
      // Only get data from BE if there isn't any or the new payload
      // is different to the previous one (excluding the issuer_token which may change)
      if (!credentialsIssuedCountCache ||
            !_.isEqual(_.omit(tempPayload, ['issuer_token']), _.omit(credentialsIssuedCountPayload, ['issuer_token']))) {

        credentialsIssuedCountPayload = angular.copy(tempPayload); // Remember the payload

        api
          .request('/internal/organization/analytics/published_credentials_count', tempPayload)
          .then(function(response) {
            credentialsIssuedCountCache = {
              data: response,
            };

            resolve(credentialsIssuedCountCache);
          });
      } else {
        resolve(credentialsIssuedCountCache);
      }
    });
  }

  var credentialsOpenedCountCache; // Used to cache summary data
  var credentialsOpenedCountPayload; // Last used payload
  function getCredentialsOpenedCount(payload) {
    var tempPayload = Object.assign(angular.copy(payload), { by_opened: true });
    delete tempPayload.page;

    return $q(function(resolve) {
      // Only get data from BE if there isn't any or the new payload
      // is different to the previous one (excluding the issuer_token which may change)
      if (!credentialsOpenedCountCache ||
        !_.isEqual(_.omit(tempPayload, ['issuer_token']), _.omit(credentialsOpenedCountPayload, ['issuer_token']))) {

        credentialsOpenedCountPayload = angular.copy(tempPayload); // Remember the payload

        api
          .request('/internal/organization/analytics/published_credentials_count', tempPayload)
          .then(function(response) {
            credentialsOpenedCountCache = {
              data: response,
            };

            resolve(credentialsOpenedCountCache);
          });
      } else {
        resolve(credentialsOpenedCountCache);
      }
    });
  }

  var credentialsViewsCountCache; // Used to cache summary data
  var credentialsViewsCountPayload; // Last used payload
  function getCredentialsViewsCount(payload) {
    var tempPayload = angular.copy(payload);
    delete tempPayload.page;

    return $q(function(resolve) {
      // Only get data from BE if there isn't any or the new payload
      // is different to the previous one (excluding the issuer_token which may change)
      if (!credentialsViewsCountCache ||
        !_.isEqual(_.omit(tempPayload, ['issuer_token']), _.omit(credentialsViewsCountPayload, ['issuer_token']))) {

        credentialsViewsCountPayload = angular.copy(tempPayload); // Remember the payload

        api
          .request('/internal/organization/analytics/credentials_views_count', tempPayload)
          .then(function(response) {
            credentialsViewsCountCache = {
              data: response,
            };

            resolve(credentialsViewsCountCache);
          });
      } else {
        resolve(credentialsViewsCountCache);
      }
    });
  }

  var credentialsSharesCountCache; // Used to cache summary data
  var credentialsSharesCountPayload; // Last used payload
  function getCredentialsSharesCount(payload) {
    var tempPayload = angular.copy(payload);
    delete tempPayload.page;

    return $q(function(resolve) {
      // Only get data from BE if there isn't any or the new payload
      // is different to the previous one (excluding the issuer_token which may change)
      if (!credentialsSharesCountCache ||
        !_.isEqual(_.omit(tempPayload, ['issuer_token']), _.omit(credentialsSharesCountPayload, ['issuer_token']))) {

        credentialsSharesCountPayload = angular.copy(tempPayload); // Remember the payload

        api
          .request('/internal/organization/analytics/credentials_shared_count', tempPayload)
          .then(function(response) {
            credentialsSharesCountCache = {
              data: response,
            };

            resolve(credentialsSharesCountCache);
          });
      } else {
        resolve(credentialsSharesCountCache);
      }
    });
  }

  var credentialsIssuedChartDataCache; // Used to cache summary data
  var credentialsIssuedChartDataPayload; // Last used payload
  function getCredentialsIssuedChartData(payload) {
    var tempPayload = angular.copy(payload);
    delete tempPayload.page;

    return $q(function(resolve) {
      // Only get data from BE if there isn't any or the new payload
      // is different to the previous one (excluding the issuer_token which may change)
      if (!credentialsIssuedChartDataCache ||
            !_.isEqual(_.omit(tempPayload, ['issuer_token']), _.omit(credentialsIssuedChartDataPayload, ['issuer_token']))) {

        credentialsIssuedChartDataPayload = angular.copy(tempPayload); // Remember the payload

        api
          .request('/internal/organization/analytics/published_credentials_chart', tempPayload)
          .then(function(response) {
            var totalCredentialsIssued = _.reduce(response, function(prev, cur) { return prev + cur; });

            credentialsIssuedChartDataCache = {
              data: response,
              totalCount: totalCredentialsIssued,
              chart: formatChart(response)
            };

            resolve(credentialsIssuedChartDataCache);
          });
      } else {
        resolve(credentialsIssuedChartDataCache);
      }
    });
  }

  var credentialsOpenedChartDataCache; // Used to cache summary data
  var credentialsOpenedChartDataPayload; // Last used payload
  function getCredentialsOpenedChartData(payload) {
    var tempPayload = Object.assign(angular.copy(payload), { by_opened: true });
    delete tempPayload.page;

    return $q(function(resolve) {
      // Only get data from BE if there isn't any or the new payload
      // is different to the previous one (excluding the issuer_token which may change)
      if (!credentialsOpenedChartDataCache ||
        !_.isEqual(_.omit(tempPayload, ['issuer_token']), _.omit(credentialsOpenedChartDataPayload, ['issuer_token']))) {

        credentialsOpenedChartDataPayload = angular.copy(tempPayload); // Remember the payload

        api
          .request('/internal/organization/analytics/published_credentials_chart', tempPayload)
          .then(function(response) {
            var totalCredentialsOpened = _.reduce(response, function(prev, cur) { return prev + cur; });

            credentialsOpenedChartDataCache = {
              data: response,
              totalCount: totalCredentialsOpened
            };

            resolve(credentialsOpenedChartDataCache);
          });
      } else {
        resolve(credentialsOpenedChartDataCache);
      }
    });
  }

  var credentialsViewsChartDataCache; // Used to cache summary data
  var credentialsViewsChartDataPayload; // Last used payload
  function getCredentialsViewsChartData(payload) {
    var tempPayload = angular.copy(payload);
    delete tempPayload.page;

    return $q(function(resolve) {
      // Only get data from BE if there isn't any or the new payload
      // is different to the previous one (excluding the issuer_token which may change)
      if (!credentialsViewsChartDataCache ||
        !_.isEqual(_.omit(tempPayload, ['issuer_token']), _.omit(credentialsViewsChartDataPayload, ['issuer_token']))) {

        credentialsViewsChartDataPayload = angular.copy(tempPayload); // Remember the payload

        api
          .request('/internal/organization/analytics/credentials_views_chart', tempPayload)
          .then(function(response) {
            var totalCredentialsViews = _.reduce(response, function(prev, cur) { return prev + cur; });

            credentialsViewsChartDataCache = {
              data: response,
              totalCount: totalCredentialsViews,
              chart: formatChart(response)
            };

            resolve(credentialsViewsChartDataCache);
          });
      } else {
        resolve(credentialsViewsChartDataCache);
      }
    });
  }

  var credentialsSharesChartDataCache; // Used to cache summary data
  var credentialsSharesChartDataPayload; // Last used payload
  function getCredentialsSharesChartData(payload) {
    var tempPayload = angular.copy(payload);
    delete tempPayload.page;

    return $q(function(resolve) {
      // Only get data from BE if there isn't any or the new payload
      // is different to the previous one (excluding the issuer_token which may change)
      if (!credentialsSharesChartDataCache ||
        !_.isEqual(_.omit(tempPayload, ['issuer_token']), _.omit(credentialsSharesChartDataPayload, ['issuer_token']))) {

        credentialsSharesChartDataPayload = angular.copy(tempPayload); // Remember the payload

        api
          .request('/internal/organization/analytics/credentials_shared_chart', tempPayload)
          .then(function(response) {
            var totalCredentialsShares = _.reduce(response, function(prev, cur) { return prev + cur; });

            credentialsSharesChartDataCache = {
              data: response,
              totalCount: totalCredentialsShares,
              chart: formatChart(response)
            };

            resolve(credentialsSharesChartDataCache);
          });
      } else {
        resolve(credentialsSharesChartDataCache);
      }
    });
  }

  var recipientFunnelCache; // Used to cache funnel data
  var recipientFunnelPayload; // Last used payload
  function getRecipientFunnel(payload) {
    var tempPayload = angular.copy(payload);
    delete tempPayload.page;
    return $q(function(resolve) {
      // Only get data from BE if there isn't any or the new payload is different to the previous one (excluding the issuer_token which may change)
      if (!recipientFunnelCache || !_.isEqual(_.omit(tempPayload, ['issuer_token']), _.omit(recipientFunnelPayload, ['issuer_token']))) {
        recipientFunnelPayload = angular.copy(tempPayload); // Remember the payload
        api
          .request('/internal/organization/analytics/recipient_funnel', tempPayload)
          .then(function(response) {
            recipientFunnelCache = response;
            resolve(recipientFunnelCache);
          });
      } else {
        resolve(recipientFunnelCache);
      }
    });
  }

  var engagementEventCountsCache; // Used to cache event counts
  var engagementEventCountsPayload; // Last used payload
  function getEngagementEventCounts(payload) {
    var tempPayload = angular.copy(payload);
    delete tempPayload.page;
    return $q(function(resolve) {
      // Only get data from BE if there isn't any or the new payload is different to the previous one (excluding the issuer_token which may change)
      if (!engagementEventCountsCache || !_.isEqual(_.omit(tempPayload, ['issuer_token']), _.omit(engagementEventCountsPayload, ['issuer_token']))) {
        engagementEventCountsPayload = angular.copy(tempPayload); // Remember the payload
        api
          .request('/internal/organization/analytics/engagement_events', tempPayload)
          .then(function(response) {
            engagementEventCountsCache = response;
            resolve(engagementEventCountsCache);
          });
      } else {
        resolve(engagementEventCountsCache);
      }
    });
  }

  var shareCountsCache; // Used to cache event counts
  var shareCountsPayload; // Last used payload
  function getShareCounts(payload) {
    var tempPayload = angular.copy(payload);
    delete tempPayload.page;
    return $q(function(resolve) {
      // Only get data from BE if there isn't any or the new payload is different to the previous one (excluding the issuer_token which may change)
      if (!shareCountsCache || !_.isEqual(_.omit(tempPayload, ['issuer_token']), _.omit(shareCountsPayload, ['issuer_token']))) {
        shareCountsPayload = angular.copy(tempPayload); // Remember the payload
        api
          .request('/internal/organization/analytics/sharing_events', tempPayload)
          .then(function(response) {
            shareCountsCache = response;
            resolve(shareCountsCache);
          });
      } else {
        resolve(shareCountsCache);
      }
    });
  }

  function getEventsLog(payload) {
    return api.request('/analytics/log', payload)
      .then(function(response) {
        return response;
      });
  }

  function exportEvents(payload) {
    return api.request('/analytics/csv', payload);
  }

  function normaliseData(source, dataPointCount, newData) {
    var dates = Object.keys(source);
    var firstDate = moment(dates[0], 'YYYY-MM-DD'); // Use the first date returned
    var lastDate = moment(dates[dates.length - 1], 'YYYY-MM-DD'); // Use the last date returned
    // Calculate the day range
    var dayRange = lastDate.diff(firstDate, 'days');
    // Massage the data so that there are the required number of (roughly) equal date slices
    var truncatedStep;
    var adjustmentPeriod;
    if (dataPointCount < dayRange) { // More days than requested data points
      var step = dayRange / (dataPointCount - 1); // dataPointCount - 1 as, for example, 30 data points require 29 steps
      truncatedStep = Math.floor(step);
      var stepDifference = step - truncatedStep;
      adjustmentPeriod = stepDifference ? Math.ceil(1 / stepDifference) : 0; // No difference means no adjustment
    } else { // Less days than requested data points
      dataPointCount = dayRange + 1;
      truncatedStep = 1;
      adjustmentPeriod = 0;
    }
    var currentDate = firstDate;
    var slicedDates = [];
    for (var index = 0; index < dataPointCount - 1; index++) {
      slicedDates.push(currentDate.format('YYYY-MM-DD'));
      currentDate.add(truncatedStep + (adjustmentPeriod ? (index % adjustmentPeriod === 0 ? 1 : 0) : 0), 'days'); // Only adjust period when required
    }
    slicedDates.push(lastDate.format('YYYY-MM-DD'));
    // Map values to sliced dates
    var dateIndex = 0;
    var values = [];
    var cachedValue;
    slicedDates.forEach(function(slicedDate) {
      while (slicedDate >= dates[dateIndex]) {
        cachedValue = source[dates[dateIndex]];
        dateIndex++;
      }
      values.push(cachedValue);
    });

    var firstValue;
    var lastValue;
    var range;
    var stepString;
    var stepSize;

    if (newData) {
      // NEW: Calculate the vertical scale step size

      Object.keys(source).forEach(function(k) {
        range = Math.max(range || 0, source[k]);
      });

      stepSize = Math.ceil(range / 6.0);
    } else {
      // Calculate the vertical scale step size
      firstValue = source[dates[0]] || 0;
      lastValue = source[dates[dates.length - 1]] || 0;
      range = lastValue - firstValue;
      stepString = Math.round(range / 6).toString();
      stepSize = parseInt(stepString.charAt(0)) * Math.pow(10, stepString.length - 1) || 1;
    }
    // Process the labels on the horizontal scale to make them less busy
    var currentYear = '';
    var currentMonth = '';
    var dateLabels = [];
    if (dayRange >= 31) {
      // Convert dates to months with year
      for (index = 0; index < slicedDates.length; index++) {
        var newMonthYear = moment(slicedDates[index], 'YYYY-MM-DD').format('DD,MMM,YY').split(',');
        dateLabels.push(['', '', newMonthYear[0], newMonthYear[1], newMonthYear[2] !== currentYear ? '\'' + newMonthYear[2] : '']);
        currentYear = newMonthYear[2];
      }
    } else {
      // Convert dates to days
      for (index = 0; index < slicedDates.length; index++) {
        var newMonth = moment(slicedDates[index], 'YYYY-MM-DD').format('MMM');
        var newDay = moment(slicedDates[index], 'YYYY-MM-DD').format('DD');
        if (newMonth !== currentMonth) {
          dateLabels.push(['', newDay, newMonth]);
          currentMonth = newMonth;
        } else {
          dateLabels.push(['', newDay, '']);
        }
      }
    }
    return { dates: dateLabels, values: values, verticalStepSize: stepSize };
  }

  function buildChartNew(labels, values, verticalStepSize) {
    return {
      labels: labels,
      data: values,
      options: {
        scales: {
          yAxes: [
            {
              id: 'y-axis-1',
              stacked: false,
              display: false,
              gridLines: {
                display: false,
                drawBorder: false
              },
              ticks: {
                min: 0,
                beginAtZero: true,
                stepSize: verticalStepSize,
                fontColor: '#cccccc', // Match $framework-grey-3
                fontFamily: '"Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif',
                display: false,
                callback: function(value) {
                  return $filter('number')(value) + '   ';
                }
              }
            },
            {
              id: 'y-axis-2',
              stacked: true,
              display: false,
              gridLines: {
                display: true,
                drawBorder: true
              },
              ticks: {
                beginAtZero: true,
                min: 0,
                stepSize: verticalStepSize * 2,
                fontColor: '#cccccc', // Match $framework-grey-3
                fontFamily: '"Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif',
                display: false,
                callback: function(value) {
                  return $filter('number')(value) + '   ';
                }
              }
            }
          ]
        }
      }
    };
  }

  function buildChart(type, labels, values, borderColor, backgroundColor, showAxes) {
    var chartData = {
      labels: labels,
      data: values,
      overrides: {
        borderColor: [ borderColor ],
        backgroundColor: [ backgroundColor ],
        label: 'Credentials',
        borderWidth: 3,
        pointRadius: 0,
        borderCapStyle: 'round'
      },
      options: {
        legend: { display: type === 'referralClick' },
        maintainAspectRatio: false,
        spanGaps: false,
        tooltips: {
          enabled: false
        },
        hover: {
          mode: null
        },
        elements: {
          line: {
            tension: 0.000001,
            fill: false,
          }
        },
        plugins: {
          filler: {
            propagate: false
          },
        },
        scales: {
          xAxes: [{
            gridLines: {
              display: showAxes,
              drawBorder: false,
              drawOnChartArea: false
            },
            ticks: {
              fontColor: '#cccccc', // Match $framework-grey-3
              fontFamily: '"Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif',
              maxRotation: 0, // turns off rotation
              autoSkip: true,
              display: showAxes
            }
          }],
        }
      }
    };

    // Add referral chart styling overrides if building the referral click chart type
    // Seerate y-axis logic as we need to evaluate an array of arrays for referral clicks to determin beginAtZero and stepSize
    if (type === 'referralClick') {
      chartData.colors = ['rgb(159,204,0)', 'rgb(250,109,33)', '#0000FF'];
      // referralClick data will always be in a certain order so we can remove content that has no values
      chartData.series = [];
      if (chartData.data[0].length > 0) {
        chartData.series.push('Course Signup Page');
      }
      if (chartData.data[1].length > 0) {
        chartData.series.push('Issuer Website');
      }
      if (chartData.data[2].length > 0) {
        chartData.series.push('Course Website');
      }

      // Remove the empty arrays from chartData.data
      chartData.data = chartData.data.filter(function(el){
        return el.length >= 1;
      });

      chartData.options.legend = { display: true };

      chartData.options.scales.yAxes = [{
        stacked: false,
        display: true,
        gridLines: {
          display: showAxes,
          drawBorder: false
        },
        ticks: {
          beginAtZero: !(values[0][0] > 0) && !(values[1][0] > 0) && !(values[2][0] > 0),
          fontColor: '#cccccc', // Match $framework-grey-3
          fontFamily: '"Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif',
          display: showAxes,
          callback: function(value) {
            return $filter('number')(value) + '   ';
          }
        }
    }];

    } else if (type === 'credentialViews') {
      chartData.options.scales.yAxes = [{
        stacked: false,
        display: true,
        gridLines: {
          display: showAxes,
          drawBorder: false
        },
        ticks: {
          beginAtZero: !(values[0] > 0),
          fontColor: '#cccccc', // Match $framework-grey-3
          fontFamily: '"Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif',
          display: showAxes,
          callback: function(value) {
            return $filter('number')(value) + '   ';
          }
        }
    }];
    }
    return chartData;
  }

  function drawCharts(overview, showAxes, allTime) {
    var charts = [];
    var totals = [];
    var recipientCredentialViews = formatDatesAndValues(overview.recipient_credential_views);
    var referralClicks = formatDatesAndValues(overview.referral_clicks);

    // Get the total recipient credential views for the timeframe
    totals.push(recipientCredentialViews.values[recipientCredentialViews.values.length - 1] - (allTime ? 0 : recipientCredentialViews.values[0]));
    // Build chart objects and add to charts array
    charts.push(buildChart('credentialViews', recipientCredentialViews.dates, recipientCredentialViews.values, 'rgba(51, 150, 220, 1)', 'rgba(51, 150, 220, 0.1)', showAxes));
    charts.push(buildChart('referralClick', referralClicks.dates, referralClicks.values, 'rgba(51, 150, 220, 1)', 'rgba(51, 150, 220, 0.1)', showAxes));
    return { charts: charts, totals: totals };
  }

  function preprocessResponseData(data) {
    var datasets = Object.keys(data);

    // Get all months in timestamp format
    var output = {
      dates: Object.keys(data[datasets[0]]).map(function(el) {
        return new Date(el).getTime();
      }).sort(function (a, b){
        return a - b;
      }),
    };

    // Create arrays from all the values
    datasets.forEach(function(el) {
      // Populate output with the categories
      output[el] = Object.values(data[el]).sort(function (a, b){
        return a - b;
      });
    });

    return output;
  }

  function formatDatesAndValues(data) {
    // Before we can format the data we should preprocess it into a more usable format
    var processedData = preprocessResponseData(data);

    var dates = processedData.dates.map(function(el) {
      return epochDateToGraphDate(el);
    });

    return {
      dates: dates,
      // If we are processing referral clicks values should be an array of arrays in fixed order if its recipient views values will be just an array
      values: processedData.course_visit ? [angular.copy(processedData.course_visit), angular.copy(processedData.issuer_url_click), angular.copy(processedData.website_visit)] : angular.copy(processedData.recipient_view_certificate),
    };
  }

  // Convert epoch timestamp into date string array e.g. ['', '', '12', 'Aug', '20'] - needs the two empty strings as "padding" to display correctly on the x-axis
  function epochDateToGraphDate(date) {
    // Create array with the initial padding empty strings
    var dateArray = ['', ''];
    // Add the rest of the date strings to the array and return it
    var formattedDate = dateArray.concat(new Date(date).toLocaleDateString('en-GB', { year: '2-digit', month: 'short' }).split(' '));
    // Add "'" to the year
    formattedDate[3] = '\'' + formattedDate[3];
    return formattedDate;
 }

  function formatChart(response) {
    var data = normaliseData(response, 30, true);
    var chart = buildChartNew(
      data.dates,
      data.values,
      data.verticalStepSize,
      true
    );
    return chart;
  }

  function reset() {
    summaryCache = null;
    summaryPayload = null;
    overviewCache = null;
    overviewPayload = null;
    credentialsIssuedCountCache = null;
    credentialsIssuedCountPayload = null;
    credentialsOpenedCountCache = null;
    credentialsOpenedCountPayload = null;
    credentialsViewsCountCache = null;
    credentialsViewsCountPayload = null;
    credentialsSharesCountCache = null;
    credentialsSharesCountPayload = null;
    credentialsOpenedChartDataCache = null;
    credentialsOpenedChartDataPayload = null;
    credentialsViewsChartDataCache = null;
    credentialsViewsChartDataPayload = null;
    credentialsSharesChartDataCache = null;
    credentialsSharesChartDataPayload = null;
    recipientFunnelCache = null;
    recipientFunnelPayload = null;
    engagementEventCountsCache = null;
    engagementEventCountsPayload = null;
    shareCountsCache = null;
    shareCountsPayload = null;
  }

  // Nullify cache when changing department
  AuthService.on('change', function(auth) {
    if (auth.department && auth.department.id !== currentDepartmentId) {
      currentDepartmentId = auth.department.id;
      reset();
    }
  });

  // Get simple department metrics
  function getDepartmentIssuanceReport() {
    return api.request('/internal/department_issuance_report');
  }

  // Get sharing stats for service
  function getShareStats(service) {
    return api.request('/internal/department_share_feed?feed=<feed>', {
      feed: service
    });
  }
}

angular
  .module('app')
  .service('DepartmentAnalyticsService', DepartmentAnalyticsService);

},{}],36:[function(require,module,exports){
/** DEPARTMENTS SERVICE
 *
 *    For accessing the departments that the user
 *     has access to.
 *
 *    Why do we force a refresh of the auth object?
 *     because the creation of departments MAY
 *     affect our Auth state - notably permissions.
 */
DepartmentsService.$inject = ['$rootScope', '$q', 'api', 'AuthService'];
function DepartmentsService($rootScope, $q, api, AuthService) {
  var service = this;

  service.getDepartments = getDepartments;
  service.getDepartment = getDepartment;
  service.upsertDepartment = upsertDepartment;

  function getDepartments(){
    return api
      .request('/departments/all')
      .then(function(response){
        $rootScope.$broadcast('hotjarAndPosthogDepartments', response.departments);
        return response.departments;
      });
  }

  function getDepartment(id){
    if (id === 'new') {
      return $q.resolve({ name: null, url: null, logo: null });
    }
    return api
      .request('/departments/read', { id: id })
      .then(function(response){
        return response.department;
      });
  }

  function upsertDepartment(department) {
    var method = department.id ? '/departments/update' : '/departments/create';
    return api
      .request(method, { department: department })
      .then(function(response) {
        AuthService.refresh(); // See block comment
        return response.department;
      });
  }

}

angular
  .module('app')
  .service('DepartmentsService', DepartmentsService);

},{}],37:[function(require,module,exports){
/** EMAIL - SERVICE
 *
 *      Abstracts the logic for dealing with email settings and templates
 *
 *  @author   David "odavid" King
 */
(function() {
  angular.module('app')
    .service('EmailService', ['$q', '$timeout', 'api', 'swalService', 'alertService', 'AnalyticsService', 'attributeService', '_',
      function($q, $timeout, api, swalService, alertService, AnalyticsService, attributeService, _) {
        this.getSettings = getSettings;
        this.updateSettings = updateSettings;
        this.getTemplateKinds = getTemplateKinds;
        this.getTemplates = getTemplates;
        this.getTemplate = getTemplate;
        this.upsertTemplate = upsertTemplate;
        this.canDelete = canDelete;
        this.canCopy = canCopy;
        this.canModifyTemplates = canModifyTemplates;
        this.deleteTemplate = deleteTemplate;
        this.resetTemplate = resetTemplate;
        this.sendPreview = sendPreview;

        function getSettings() {
          return api.request('/email_settings/get_settings')
            .then(function(response) {
              return response.email_setting;
            });
        }

        function updateSettings(settings) {
          return $q(function(resolve, reject) {
            api.request('/email_settings/upsert', {
                email_setting: settings
              })
              .then(function(response) {
                angular.copy(response.email_setting, settings); // Update the settings object that was passed to us **
                return settings;
              })
              .then(function(settings) {
                // Validate the from_email address
                if (settings.from_email) {
                  return api.request('/email_settings/confirm_from_email', {
                      email: settings.from_email
                    })
                    .then(function(response) {
                      if (!response.verified) {
                        return 'verifySenderEmailSent';
                      } else {
                        return 'updateEmailSettingsSuccess';
                      }
                    });
                } else {
                  return 'updateEmailSettingsSuccess';
                }
              })
              .then(function(alertKey) {
                AnalyticsService.trackEvent('Emails > Email Settings Updated');
                swalService.showAlert(alertKey); // Notify
                $timeout(function() { // The timeout is required as this function is asychronously messing with the passed in form settings here **
                  resolve(settings); // Return the updated object
                }, 1000);
              })
              .catch(function(err) {
                swalService.showAlert('updateEmailSettingsFailure');
                reject(err);
              });
          });
          // With regards to the comment below, Deepender preferred to keep a separate request - '/email_settings/confirm_from_email'
          // Bug :: Deepender to refactor `/email_settings/upsert` so that we don't need to make a separate, needless request to `/email_settings/send_ses_email`
          // with this in place, the the above code should be:
          /*
          return api.request('/email_settings/upsert', { email_setting: settings })
            .then(function(response){
              angular.copy(response.email_setting, settings); // Update the settings object that was passed to us
              if(settings.from_email && settings.from_email_verified == false){
                swalService.showAlert('verifySenderEmailSent');
              } else {
                swalService.showAlert('updateEmailSettingsSuccess');
              }
              return settings;
            })
            .catch(function(err){
              swalService.showAlert('updateEmailSettingsFailure');
            });
          });
          */
        }

        function getTemplateKinds() {
          return api.request('/email_templates/template_kinds')
            .then(function(response) {
              return response.kinds;
            });
        }

        function getTemplates() {
          return api.request('/email_templates/all')
            .then(function(response) {
              return response.email_templates;
            });
        }

        function getTemplate(template_id_or_kind, language) {
          var data = {};
          if ($.isNumeric(template_id_or_kind)) {
            data.id = template_id_or_kind;
          } else {
            data.kind = template_id_or_kind;
          }
          if (language) {
            data.language = language;
          }
          return api.request('/email_templates/show', data)
            .then(function(response) {
              return parseAttributes(response.email_template);
            });
        }

        function upsertTemplate(template) {
          return $q(function(resolve, reject) {
            var method = '/email_templates/' + (template.id ? 'update' : 'create');
            var data = {
              email_template: template
            };
            if (template.id) {
              data.id = template.id; // When updating, we need to hoist the id (API decision, not mine)
            }
            api.request(method, data)
              .then(function(response) {
                AnalyticsService.trackEvent('Emails > Created or Updated Email Template');
                swalService.showAlert('upsertEmailTemplateSuccess'); // Notify
                parseAttributes(response.email_template)
                  .then(function(updatedTemplate){
                    angular.copy(updatedTemplate, template); // Update the template object that was passed to us
                    resolve(template); // Return the updated template
                  });
              })
              .catch(function(err) {
                swalService.showAlert('upsertEmailTemplateFailure');
                reject(err);
              });
          });
        }
        var copyableKinds = [
          'certificate_received',
          'badge_received',
          'certificate_and_badge_received',
          'credential_expiry_warning',
          'credential_expired',
        ];

        function canCopy(template) {
          return copyableKinds.indexOf(template.kind) !== -1;
        }

        function canDelete(template) {
          return template.id && !template.default;
        }

        /**
         * Check if user can modify email templates based on verification status
         */
        function canModifyTemplates(organization, pricing, requireVerificationFeature) {
          var isNotVerified = !organization.verified;
          var isNotCustomPlan = pricing.plan !== 'custom';
          var flagEnabled = requireVerificationFeature;

          var shouldBlock = isNotVerified && isNotCustomPlan && flagEnabled;
          return !shouldBlock;
        }

        function deleteTemplate(template) {
          return alertService
            .confirm('Delete Template', 'Delete the template named <strong>' + template.name + '</strong>?', 'delete-template')
            .then(function(){
              return api.request('/email_templates/delete', { id: template.id })
                .then(function(response){
                  return swalService.showAlert('deleteEmailTemplateSuccess');
                })
                .catch(function(){
                  swalService.showAlert('deleteEmailTemplateFailure');
                  throw new Error('Error Deleting Email Template');
                });
            });
        }

        function resetTemplate(template) {
          return alertService
            .confirm('Reset Template', 'Reset the template named <strong>' + template.name + '</strong>? This action cannot be undone.', 'RESET-EMAIL-TEMPLATE')
            .then(function(){
              return api.request('/email_templates/delete', { id: template.id })
                .then(function(response){
                  return swalService.showAlert('resetEmailTemplateSuccess');
                })
                .catch(function(){
                  swalService.showAlert('resetEmailTemplateFailure');
                  throw new Error('Error Resetting Email Template');
                });
            });
        }

        function sendPreview(template, email) {
          return api.request('/email_templates/send_preview', {
              id: template.id,
              kind: template.kind,
              email: email
            })
            .then(function(response) {
              AnalyticsService.trackEvent('Emails > Email Preview Sent');
              swalService.showAlert('previewEmailSentSuccess');
            })
            .catch(function(err) {
              swalService.showAlert('previewEmailSentFailure');
            });
        }

        function parseAttributes(template) {
          return attributeService
            .getAttributesList()
            .then(function(attributes){
              // 1 - Parse the email-attributes
              template.attributes = [];
              angular.forEach(template.email_attributes, function(attribute) {
                template.attributes.push({
                  tag: '[' + attribute.name + ']',
                  type: attribute.kind,
                  required: attribute.required,
                });
              });
              delete template.email_attributes;
              // 2 - Merge all other attributes
              angular.forEach(attributes, function(attribute) {
                if(!_.find(template.attributes, { tag: attribute.tag })){
                  template.attributes.push({
                    tag: attribute.tag,
                    type: attribute.kind,
                    required: false,
                  });
                }
              });
              // 3 - Sort
              // template.attributes = _.sortBy(template.attributes, ['tag']);
              // ...
              return template;
            });
        }

      }
    ]);
})();



/*

            // DEBUG


            function getTemplateKinds(){
                return $q(function(resolve, reject){
                    resolve([
                        // These can be copied, and applied as Group-level overrides
                        { kind: 'credential_received',          canCopy: true, },
                        { kind: 'credential_expiry_warning',    canCopy: true, },
                        { kind: 'credential_expired',           canCopy: true, },
                        // These cannot be copied, they are global
                        { kind: 'credential_verification_code', canCopy: false, },
                        { kind: 'name_change_request_received', canCopy: false, },
                        { kind: 'name_change_request_approved', canCopy: false, },
                        { kind: 'name_change_request_denied',   canCopy: false, },
                        // These are only ever exposed to the Accredible account, we dogfood this system
                        { kind: 'password_reset',               canCopy: false, },
                    ]);
                });
            }


            function getTemplate(template_id){
                return $q(function(resolve, reject){
                    resolve({
                        id: template_id,
                        kind: 'credential_received', // There should only be one `default:true`
                        default: true,               // ...for any given `kind`
                        name: 'Credential received',
                        updated_at: "2017-02-24T07:29:46.000Z",
                        content: ['<h1>Hello World</h1>'],
                    });
                });
            }


            function getTemplates(){
                return $q(function(resolve, reject){
                    resolve([
                        // Defaults
                        { id: 1,    kind: 'credential_received',          name: 'Credential received',           default: true, updated_at: "2017-02-24T07:29:46.000Z", },
                        { id: 2,    kind: 'credential_expiry_warning',    name: 'Credential is about to expire', default: true, updated_at: "2017-02-24T07:29:46.000Z", },
                        { id: 3,    kind: 'credential_expired',           name: 'Credential has expired',        default: true, updated_at: "2017-02-24T07:29:46.000Z", },
                        { id: 4,    kind: 'credential_verification_code', name: 'Credential verification code',  default: true, updated_at: "2017-02-24T07:29:46.000Z", },
                        { id: null, kind: 'name_change_request_received', name: 'Name change request received',  default: true, },
                        { id: null, kind: 'name_change_request_approved', name: 'Name change request accepted',  default: true, },
                        { id: null, kind: 'name_change_request_denied', name: 'Name change request rejected',  default: true, },
                        // Custom
                        { id: 5,    kind: 'credential_received',          name: 'Credential received',           default: false, updated_at: "2017-02-24T07:29:46.000Z", },
                        { id: 6,    kind: 'credential_received',          name: 'Credential received',           default: false, updated_at: "2017-02-24T07:29:46.000Z", },
                        { id: 7,    kind: 'credential_received',          name: 'Credential received',           default: false, updated_at: "2017-02-24T07:29:46.000Z", },
                        { id: 8,    kind: 'credential_expiry_warning',    name: 'Credential is about to expire', default: false, updated_at: "2017-02-24T07:29:46.000Z", },
                        { id: 9,    kind: 'credential_expired',           name: 'Credential has expired',        default: false, updated_at: "2017-02-24T07:29:46.000Z", },
                        { id: 10,   kind: 'credential_verification_code', name: 'Credential verification code',  default: false, updated_at: "2017-02-24T07:29:46.000Z", },
                    ]);
                });
            }


            function getSettings(){
                return $q(function(resolve, reject){
                    resolve({
                        content: {
                            outer_header: '<p><img src="https://s3.amazonaws.com/accredible-api-templates/1489577010348.png" width="195" height="30"></p>',
                            inner_header: '<p><br></p>',
                            inner_footer: '<p><br></p>\n<h1>I\'m outta here</h1>\n<p>Chuck your legal blurb here. I think you might need your address by default...?</p>',
                            outer_footer: '<p>800 W El Camino Real, Suite 180, Mountain View, CA,USA, 94040</p>',
                        },
                        advanced: true,
                        style: {
                            "outer": {
                                "background_color": "#fafafa",
                                "color": "#aaaaaa"
                            },
                            "inner": {
                                "background_color": "#ffffff",
                                "border_style": "solid", // not editable, but still used
                                "border_color": "#dedede",
                                "border_radius": "4px",
                                "border_width": "1px",
                                "color": "#444444"
                            },
                            "header": {
                                "color": "#ffffff",
                                "background_color": "#3b777e"
                            },
                            "footer": {
                                "color": "#aaaaaa",
                                "background_color": "#e9e9e9"
                            },
                            // Advanced
                            "p": {
                                "font_family": "Arial, Helvetica, sans-serif",
                                "font_size": "16px"
                            },
                            "li": {
                                "font_family": "Arial, Helvetica, sans-serif",
                                "font_size": "14px"
                            },
                            "blockquote": {
                                "font_family": "Arial, Helvetica, sans-serif",
                                "font_size": "14px",
                                "border_left_color": "#3b777e"
                            },
                            "h1": {
                                "font_family": "Arial, Helvetica, sans-serif",
                                "font_size": "30px"
                            },
                            "h2": {
                                "font_family": "Arial, Helvetica, sans-serif",
                                "font_size": "26px"
                            },
                            "h3": {
                                "font_family": "Arial, Helvetica, sans-serif",
                                "font_size": "20px"
                            },
                            "hr": {
                                "border_top_style": "solid",
                                "border_top_width": "1px",
                                "border_top_color": "#dedede"
                            },
                            "a": {
                                "color": "#4184F3",
                            },
                            "button": {
                                "background_color": "#444444",
                                "color": "#ffffff",
                                "border_radius": "6px"
                            }
                        }
                    });
                });
            }
*/

},{}],38:[function(require,module,exports){
/** FEATURES SERVICE
 *
 *    Features are behind a paywall.
 *
 *    Listens for changes in the AuthService,
 *     then plucks out the features that are available
 *     to the issuer.
 */
FeaturesService.$inject = ['api', 'AuthService'];
function FeaturesService(api, AuthService) {
  var service = this;
  service.getFeatures = getFeatures;
  service.getFeature = getFeature;

  var features = {};

  function getFeatures(){ // From 'issuer.organization.pricing' of '/organization/details'
    return AuthService
      .getAuth()
      .then(function(auth){
        cherrypickAuthProperties(auth);
        return features;
      });
  }

  function getFeature(feature){
    return features[feature];
  }

  AuthService.on('change', function(auth){
    cherrypickAuthProperties(auth);
  });

  function cherrypickAuthProperties(auth){
    if(auth.pricing && auth.pricing.features){
      angular.copy(auth.pricing.features, features);
    } else {
      angular.copy(getBlankFeatures(), features);
    }
    // BE uses `null` and `false` interchangeably, fix this
    // Handle features with string values (eg: pathways_plan)
    angular.forEach(features, function (feature, key) {
      // Skip the campaigns_plan feature because it's a string and we need to handle it differently
      // The My Campaigns link should only show up if the feature flag is enabled and the plan is connect or growth
      if(key !== 'campaigns_plan') {
        features[key] = !!feature;
      }
    });
  }

  // Returns the expected API response for null features
  function getBlankFeatures(){
    return {
      directory: false, // Embeddable Verification Directory
      branding_package: false, // Original and version 2 of white labelling
      spotlight_directory: false, // Employment Directory on a custom domain
      manage_departments: false, // Can the organization add departments?
      is_customer: false, // Is the organization a current customer?
      premium_whitelabel: false, // Fully customize appearance
      digital_wallet_passes: false, // Digital wallet passes for recipients,
      premium_integrations: false,
      transcript_letter: false,
      stacked_credentials: false,
      job_market_insights: false,
      custom_marketing_message: false,
      audit_log: false,
      analytics_engagement: false,
      analytics_marketing: false,
      collections: false,
      pathways: false,
      pathways_plan: false,
      recipient_ux_settings: false,
      campaigns_plan: false,
      ace_endorsements: false,
    };
  }
}

angular
  .module('app')
  .service('FeaturesService', FeaturesService);

},{}],39:[function(require,module,exports){
/** First Time User Experience - DIRECTIVE
 *
 *    Automatically adds interactivity to DOM elements
 *     such as .message elements. Simply, the
 *     dismiss button will dismiss the element and
 *     store the FTUE state in the database, this
 *     prevents the DOM element from being shown with
 *     subsequent visits.
 *
 *    Example
 *      <div acc-ftue="welcome">
 *        ...
 *        <i class="dismiss"></i>
 *      </div>
 *
 *    @author   David "oodavid" King
 */
ftueDirective.$inject = ['FtueService'];
function ftueDirective(FtueService){
  var directive = {
    restrict: 'A',
    link: link
  };

  var ftue = {};
  var promise = FtueService
    .get()
    .then(function(myFtue){
      ftue = myFtue;
    });

  return directive;

  function link(scope, element, attrs) {
    var key = attrs.accFtue;
    // Wait for the object to initialize
    promise
      .then(function(){
        // If we've already dismissed this message, it shouldn't be visible
        if (ftue[key] === true) {
          element.css('display', 'none');
        } else {
          // Great, add the dismissal logic
          element.find('i.dismiss, .close').addClass('clickable').bind('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            // Save the changes
            FtueService.set(key, true);
          });
        }
      });
    // Wait for changes and hide (including above)
    var initializing = true;
    scope.$watch(
      function() {
        return ftue[key];
      },
      function(newValue, oldValue) {
        if (initializing) {
          initializing = false;
        } else {
          if (newValue === true) {
            hide(element);
          } else {
            show(element);
          }
        }
      }
    );
  }
  // An animated hide and show
  function hide(element) {
    $(element).animate({
      opacity: 0
    }, 'fast', function() {
      $(element).slideUp('slow');
    });
  }

  function show(element) {
    $(element).slideDown('slow', function() {
      $(element).animate({
        opacity: 1
      }, 'fast');
    });
  }
}

angular
  .module('app')
  .directive('accFtue', ftueDirective);

},{}],40:[function(require,module,exports){
FtueService.$inject = ['api', 'AuthService'];
function FtueService(api, AuthService) {
  var service = this;
  service.get = get;
  service.set = set;
  service.reset = reset;

  var ftue = {};

  function get(){
    return AuthService
      .getAuth()
      .then(function(auth){
        cherrypickAuthProperties(auth);
        return ftue;
      });
  }

  function set(key, value) {
    if (!ftue[key] || ftue[key] !== value) { // Only if it's changed
      ftue[key] = value;
      api.request("/issuer_login/update", {
        login_issuer_params: {
          first_time_user_experience: JSON.stringify(ftue)
        }
      });
    }
  }

  function reset() {
    angular.copy({}, ftue);
    return api.request("/issuer_login/update", {
      login_issuer_params: {
        first_time_user_experience: JSON.stringify(ftue)
      }
    });
  };

  AuthService.on('change', function(auth){
    cherrypickAuthProperties(auth);
  });

  function cherrypickAuthProperties(auth){
    if(auth.user && auth.user.first_time_user_experience){
      angular.copy(auth.user.first_time_user_experience, ftue);
    } else {
      angular.copy({}, ftue);
    }
  }
}

angular
  .module('app')
  .service('FtueService', FtueService);

},{}],41:[function(require,module,exports){
GainsightPXService.$inject = ['$rootScope', 'AuthService', 'ENV'];
function GainsightPXService($rootScope, AuthService, ENV) {
  var service = this;
  service.init = init;
  service.identify = identify;

  function init() {
    if (ENV.gainsightTagKey) {
      var scriptEl = document.createElement('script');
      scriptEl.type = 'text/javascript';

      scriptEl.innerHTML = '(function(n,t,a,e,co){var i="aptrinsic";n[i]=n[i]||function(){ (n[i].q=n[i].q||[]).push(arguments)},n[i].p=e;n[i].c=co; var r=t.createElement("script");r.async=!0,r.src=a+"?a="+e; var c=t.getElementsByTagName("script")[0];c.parentNode.insertBefore(r,c) })(window,document,"https://web-sdk.aptrinsic.com/api/aptrinsic.js","' + ENV.gainsightTagKey + '");';

      var script = document.getElementsByTagName('script')[0];
      script.parentNode.insertBefore(scriptEl, script);
    }
  }

  function identify() {
    if (ENV.gainsightTagKey) {
      return AuthService
        .getAuth()
        .then(function(issuer) {
          var user = issuer.user;
          var account = issuer.department;
          var permissions = issuer.permissions;

          return aptrinsic('identify', {
              id: user.id,
              firstName: user.name,
              email: user.email,
              admin: permissions.admin,
            },
            {
              id: account.id,
              name: account.name,
            });
        });
    }
  }
}

angular
  .module('app')
  .service('GainsightPXService', GainsightPXService);

},{}],42:[function(require,module,exports){
GroupService.$inject = ['api', 'AnalyticsService'];
function GroupService(api, AnalyticsService){
  var service = this;
  service.fetchGroup = fetchGroup;
  service.upsert = upsert;
  service.destroy = destroy;

  function fetchGroup(id) {
    return api
      .request('/groups/read', {
        id: id
      })
      .then(function(response) {
        // Remove empty or null values
        if (response.group && response.group.learning_outcomes) {
          response.group.learning_outcomes = response.group.learning_outcomes.filter(function(el) {
            return el;
          });
        }

        return response.group;
      });
  }

  function upsert(group){
    if(group.id){
      return update(group);
    } else {
      return create(group);
    }
  }

  function update(group) {
    var processedGroup = prefilterGroup(angular.copy(group)); // Copy the object to prevent pollution of the original
    var payload = {
      id: processedGroup.id,
      group: processedGroup,
    };
    return api
      .request('/groups/update', payload)
      .then(function(response) {
        AnalyticsService.trackEvent('Groups > Update Group');
        return response.group;
      });
  }

  function create(group) {
    var processedGroup = prefilterGroup(angular.copy(group)); // Copy the object to prevent pollution of the original
    return api
      .request('/groups/create', {
        group: processedGroup
      })
      .then(function(response) {
        AnalyticsService.trackEvent('Groups > Add Group');
        return response.group;
      });
  }

  function destroy(group) {
    return api
      .request('/groups/delete', {
        id: group.id
      })
      .then(function(response) {
        AnalyticsService.trackEvent('Groups > Delete Group');
        return response.group;
      });
  }

  // The prefilter ensures only the allowed fields are
  //  passed to the API. It also stringifies the learning
  //  outcomes and stacked-group logic.
  var allowedFields = [
    'id',
    'background',
    'name',
    'course_name',
    'course_description',
    'language',
    'is_linkedin_education_section',
    'published_on',
    'attach_pdf',
    'api_usage',
    'meta_achievement',
    'learning_outcomes',
    'meta_achievement_logic',
    'credential_received_email_id',
    'credential_expiry_warning_email_id',
    'credential_expired_email_id',
    'credential_renewal_email_id',
    'from_name',
    'from_email',
    'reply_to_name',
    'reply_to_email',
    'reminder_email',
    'from_email_verified',
    'block_credential',
    'integration_publish_automatically',
    'integration_threshold_kind',
    'integration_threshold_value',
    'integration_minimum_enrollment_time',
    'generate_private_credential',
    'transcript',
    'allow_email',
    'show_on_issuer_page',
    'show_on_coursefinder',
    'meta_tags',
    'spiderable',
    'tags',
    'allow_duplicate_credentials',
    'custom_message',
    'custom_message_show',
    'custom_message_recipient_only',
    'show_job_insights',
    'auto_expiry',
    'certificate_design',
    'badge_design',
    'job_insights',
    'signup_url',
    'course_link',
    'issuer_url',
    'signup_url_show',
    'course_link_show',
    'organization_link_show',
    'primary_design_id'
  ];
  function prefilterGroup(group) {
    var cleanGroup = {};
    for (var a = 0, al = allowedFields.length; a < al; a++) {
      var key = allowedFields[a];
      if (group.hasOwnProperty(key)) {
        cleanGroup[key] = group[key];
        // "undefined" should be "null"
        if (angular.isUndefined(cleanGroup[key])) {
          cleanGroup[key] = null;
        }
      }
    }
    // Learning outcomes must be a stringified JSON array
    if (cleanGroup.learning_outcomes) {
      if (Array.isArray(cleanGroup.learning_outcomes)) {
        cleanGroup.learning_outcomes = JSON.stringify(cleanGroup.learning_outcomes);
      } else {
        delete cleanGroup.learning_outcomes;
      }
    }
    // Meta Achievement Logic must be a stringified JSON array
    if (cleanGroup.meta_achievement_logic) {
      if (Array.isArray(cleanGroup.meta_achievement_logic)) {
        cleanGroup.meta_achievement_logic = JSON.stringify(cleanGroup.meta_achievement_logic);
      } else {
        delete cleanGroup.meta_achievement_logic;
      }
    }
    // Massage design object ids into explicit fields
    if (group.hasOwnProperty('certificate_design')) {
      cleanGroup.certificate_design_id = (group.certificate_design && group.certificate_design.id) || null;
    }
    if (group.hasOwnProperty('badge_design')) {
      cleanGroup.badge_design_id = (group.badge_design && group.badge_design.id) || null;
    }
    // Done
    return cleanGroup;
  }
}

angular
  .module('app')
  .service('GroupService', GroupService);

},{}],43:[function(require,module,exports){
GroupDefaultsService.$inject = ['api'];
function GroupDefaultsService(api) {
  var service = this;
  service.getDefaults = getDefaults;
  service.getNewGroupDefaults = getNewGroupDefaults;

  function getDefaults(){
    return api
      .request('/groups/default_settings')
      .then(function(response){
        var group = response.group;
        return group;
      });
  }

  function getNewGroupDefaults(){
    return getDefaults()
      .then(function(group){
        delete group.id; // Remove the id
        delete group.name; // ...and the unique name
        return group;
      });
  }
}

angular
  .module('app')
  .service('GroupDefaultsService', GroupDefaultsService);

},{}],44:[function(require,module,exports){
GroupsService.$inject = ['api'];
function GroupsService(api) {
  var service = this;
  service.getGroups = getGroups;

  function getGroups(){
    return api
      .request('/groups/compact_list')
      .then(function(response){
        return response.groups;
      });
  }

}

angular
  .module('app')
  .service('GroupsService', GroupsService);

},{}],45:[function(require,module,exports){
GTMService.$inject = ['ENV'];
function GTMService(ENV) {
  var service = this;
  service.init = init;

  function init() {
    // Inject Google Tag Manager script into header only on production
    if (ENV.type === 'production' && location.hostname !== 'localhost') {
      var scriptEl = document.createElement('script');
      scriptEl.type = 'text/javascript';
      scriptEl.async = true;

      scriptEl.innerHTML = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n" +
        "  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n" +
        "  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n" +
        "  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n" +
        "  })(window,document,'script','dataLayer','GTM-MQ86D29');";

      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(scriptEl, s);
    }
  }

}

angular
  .module('app')
  .service('GTMService', GTMService);

},{}],46:[function(require,module,exports){
HotjarService.$inject = ['$rootScope', '$q', 'ENV'];
function HotjarService($rootScope, $q, ENV) {
  var service = this;
  service.init = init;
  service.setUserAttributes = setUserAttributes;
  service.getIssuer = getIssuer;
  service.getDepartments = getDepartments;

  function init() {
    // Inject Hotjar script into header only on production
    if (ENV.type === 'production' && location.hostname !== 'localhost') {
      var scriptEl = document.createElement('script');
      scriptEl.type = 'text/javascript';
      scriptEl.async = true;

      // prod
      scriptEl.innerHTML = "(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:2524761,hjsv:6};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');";

      // dev
      // scriptEl.innerHTML = "(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:2574908,hjsv:6};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');";

      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(scriptEl, s);

      this.setUserAttributes();
    }
  }

  function setUserAttributes() {
    $q.all([getIssuer(), getDepartments()]).then(function(data) {
      var issuer = data[0];
      var departments = data[1];

      var features = [];
      for (var prop in issuer.pricing.features) {
        if (issuer.pricing.features[prop]) {
          features.push(prop);
        }
      }

      var numberOfgroups = 0;
      for (var i = 0; i < departments.length - 1; i++) {
        numberOfgroups += departments[i].total_groups;
      }

      window.hj('identify', issuer.user.id || null, {
        corporation_id: issuer.pricing.corporation_id,
        role: issuer.permissions.admin ? 'admin' : 'member',
        plan: issuer.pricing.plan,
        num_groups: numberOfgroups,
        num_depts: departments.length,
        email: issuer.user.email,
        features: features.join(', '),
      });
    });
  }

  function getIssuer() {
    var promise = $q(function(resolve) {
      var unsubscribe = $rootScope.$on('hotjarAndPosthogIssuer', function(event, issuer) {
        resolve(issuer);
        unsubscribe();
      });
    });
    return promise;
  }

  function getDepartments() {
    var promise = $q(function(resolve) {
      var unsubscribe = $rootScope.$on('hotjarAndPosthogDepartments', function(event, departments) {
        resolve(departments);
        unsubscribe();
      });
    });
    return promise;
  }
}

angular
  .module('app')
  .service('HotjarService', HotjarService);

},{}],47:[function(require,module,exports){
LegacyCredentialService.$inject = ['$q', 'api'];
function LegacyCredentialService($q, api) {
  var service = this;

  service.deleteCredentials = deleteCredentials;
  service.updateCredential = updateCredential;
  service.updateCredentialName = updateCredentialName;
  service.updateCredentialEmail = updateCredentialEmail;
  service.getSingleCredential = getSingleCredential;
  service.resendEmail = resendEmail;
  service.generateCredentials = generateCredentials;
  service.sendPreview = sendPreview;

  function deleteCredentials(credentials) {
    var toDelete = [];
    for (var i = credentials.length - 1; i >= 0; i--) {
      if (credentials[i].selected) {
        toDelete.push(credentials[i].id);
        credentials.splice(i, 1);
      }
    }
    return api.request('/credentials/delete', {
        credential_ids: toDelete
      })
      .then(function(response) {
        return credentials;
      });
  }

  function updateCredential(credential) {
    return api.request('/credentials/update', {
        id: credential.id,
        credential: {
          license_id: credential.license_id,
          issued_on: credential.issued_on,
          expired_on: credential.expired_on,
          private: credential.private,
          grade: credential.grade,
          recipient: credential.recipient,
          custom: credential.custom,
        }
      })
      .then(function(response) {
        return response.credential;
      });
  }

  function updateCredentialName(credentialId, name) {
    return api.request('/credentials/update', {
        id: credentialId,
        credential: {
          recipient: {
            name: name
          }
        }
      })
      .then(function(response) {
        return response.credential;
      });
  }

  function updateCredentialEmail(credentialId, email) {
    return api.request('/credentials/update', {
        id: credentialId,
        credential: {
          recipient: {
            email: email
          }
        }
      })
      .then(function(response) {
        return response.credential;
      });
  }

  function getSingleCredential(credential_id) {
    return api.request('/credentials/read', {
        id: credential_id
      })
      .then(function(response) {
        return response.credential;
      });
  }

  function resendEmail(credentials) {
    var toSend = [];
    for (var i = credentials.length - 1; i >= 0; i--) {
      if (credentials[i].selected && credentials[i].approve) {
        toSend.push(credentials[i].id);
      }
      credentials[i].selected = false;
    }
    return api.request('/credentials/resend_email', {
        credential_ids: toSend
      })
      .then(function(response) {
        return response.credentials;
      });
  }

  var brandNewCerts = [];
  function generateCredentials(credentials) {
    var requests = [];

    angular.forEach(credentials, function(credential) {
      var payload = angular.copy(credential);
      payload.approve = false;
      payload.custom_id = true; // Lets the API know we're using ids for the attribute_values rather than names
      payload.custom_attributes = JSON.stringify(payload.custom_attributes);
      requests.push(
        api.request('/credentials/create', {
          credential: payload
        })
      );
    });

    var promise = $q.all(requests)
      .then(function(resultArray) {
        brandNewCerts = [];
        for (var i = resultArray.length - 1; i >= 0; i--) {
          brandNewCerts.push(resultArray[i].credential);
        }
        return resultArray;
      });
    return promise;
  }

  function sendPreview(template, recipientName, recipientEmail, sendEmail) {
    var credential = {
      name: template.course_name ? template.course_name : 'Example Course',
      description: template.course_description ? template.course_description : 'This course provides an introduction to example. The recipient has proved their competency in example. They also demonstrated proficiency in example subject.',
      recipient: {
        name: recipientName,
        email: recipientEmail
      },
      group_id: template.id,
      approve: true
    };
    if (template.custom_attributes && template.custom_attributes.length > 0) {
      credential.custom_attributes = {};
      for (var i = template.custom_attributes.length - 1; i >= 0; i--) {
        if (template.custom_attributes[i].indexOf('img_') > -1) {
          // can set custom sizes if desired later
          var width = 720,
            height = 180;
          credential.custom_attributes[template.custom_attributes[i]] = 'https://placehold.it/' + width + 'x' + height + '?text=' + template.custom_attributes[i];
        } else {
          credential.custom_attributes[template.custom_attributes[i]] = template.custom_attributes[i];
        }
      }
    }
    credential.custom_attributes = JSON.stringify(credential.custom_attributes);
    // this one is approve == true
    return api.request('/credentials/create', {
        credential: credential,
        example: true,
        suppress_email: !sendEmail
      })
      .then(function(response) {
        return response.credential;
      });
  }

}

angular
  .module('app')
  .service('LegacyCredentialService', LegacyCredentialService);

},{}],48:[function(require,module,exports){
NpsRun.$inject = ['$q', 'api', 'OrganizationService', 'UserService', 'BillingService'];
function NpsRun($q, api, OrganizationService, UserService, BillingService) {

  // Listen to certain requests
  api.on('/credentials/publish', handleApiPromise);

  // Handle the response
  function handleApiPromise(apiPromise){
    $q.all([
        apiPromise,
        OrganizationService.getOrganization(),
        UserService.getUser(),
        BillingService.getPricing(),
      ])
      .then(function(responses){
        var organization = responses[1];
        var user = responses[2];
        var billing = responses[3];
        // `delighted` must be available on the window object
        if(window.delighted){
          delighted.survey({
            email: user.email,
            name: user.name,
            properties: {
              corporation: organization.name,
              corporation_id: organization.id,
              id: user.id,
              paid_customer: !!(billing.plan), // BOOLEAN
            }
          });
        }
      });
  }
}

angular
  .module('app')
  .run(NpsRun);

},{}],49:[function(require,module,exports){
/** PERMISSIONS SERVICE
 *
 *    Each user has different permission levels.
 *
 *    Listens for changes in the AuthService,
 *     then plucks out the permissions available
 *     to the the current user.
 */
PermissionsService.$inject = ['api', 'AuthService', 'FlipperFeaturesService'];
function PermissionsService(api, AuthService, FlipperFeaturesService) {
  var service = this;
  service.getPermissions = getPermissions;
  service.getPermission = getPermission;
  service.getAllPermissions = getAllPermissions;
  service.getBlankPermissions = getBlankPermissions;
  service.isOrganizationAdmin = isOrganizationAdmin;
  service.isDepartmentAdmin = isDepartmentAdmin;
  service.isDeveloper = isDeveloper;
  service.getKind = getKind;
  service.getAccessLevel = getAccessLevel;

  var permissions = {};
  var featureFlags = {};

  function getPermissions() {
    return AuthService.getAuth()
      .then(function(auth){
        if(Object.keys(auth).length === 0){
          return auth;
        }
        return loadFeatureFlags(auth);
      })
      .then(setupPermissions);
  }

  function loadFeatureFlags(auth) {
    return FlipperFeaturesService.getFlipperFeatures(auth.department.id).then(
      function (ff) {
        featureFlags = ff;
        return auth;
      }
    );
  }

  function setupPermissions(auth) {
    cherrypickAuthProperties(auth);
    return permissions;
  }

  function getPermission(permission) {
    return permissions[permission] == null ? true : permissions[permission]; // If there is no permission, grant access
  }

  function getKind() {
    return permissions.kind;
  }

  function getAccessLevel() {
    return permissions.access_level;
  }

  function isOrganizationAdmin() {
    if (!featureFlags.issuer_hierarchy) { return !!permissions.admin; }
    return permissions.admin === true && permissions.kind === 'account-wide';
  }

  function isDepartmentAdmin() {
    if (!featureFlags.issuer_hierarchy) { return false; }
    return permissions.admin === true && permissions.kind === 'department-specific';
  }

  function isDeveloper() {
    if (!featureFlags.issuer_hierarchy) { return false; }
    return permissions.access_level === 'developer';
  }

  AuthService.on('change', function(auth){
    cherrypickAuthProperties(auth);
  });

  function cherrypickAuthProperties(auth){
    if(auth.permissions){
      angular.copy(auth.permissions, permissions);
    } else {
      angular.copy(getBlankPermissions(), permissions);
    }
    permissions.edit_groups = permissions.role === 'editor';    // BE uses a `role` of "viewer" or "editor" meaning: "can the user create and edit groups and credentials"

    permissions.edit_credentials = permissions.edit_groups ||
      (featureFlags.credential_issuer_role && permissions.role === 'credential_issuer');
    permissions.attributes = permissions.credential_attributes; // BE refuses to use the key `attributes` - fix that
    permissions.groups = permissions.groups_permitted;          // BE refuses to use the key `groups` - fix that too
    delete permissions.credential_attributes;
    delete permissions.role;
    delete permissions.groups_permitted;
    delete permissions.billing; // This is part of `admin` access
    delete permissions.created_org; // BE sends this flag to show if the user was "not invited" to the organization, it's not a permission
    delete permissions.verified;    // BE sends this flag to show if the user has "verified" their email address, it's not a permission
    // Legacy V1 "carte-blanche" grants. When `issuer_hierarchy` is ON these must NOT run —
    // permissions come solely from the backend whoami response. When the flag is OFF we preserve
    // the historical behavior below unchanged.
    if(!featureFlags.issuer_hierarchy){
      // If the user has `team` or `admin` permissions, they get carte-blanche access.
      // Deliberately NOT swapped to `isOrganizationAdmin()`. This grants the baseline
      // bundle to anyone team-level-or-above, so it is not an org-admin-only gate. A Department
      // Admin is >= a team member and should keep these features; swapping here would under-grant them.
      if(permissions.team || permissions.admin){
        permissions.designs = true;
        permissions.emails = true;
        permissions.credential_attributes = true;
        permissions.analytics = true;
        permissions.settings = true;
        permissions.directory = true;
        permissions.spotlight_directory = true;
        permissions.api = true;
        permissions.is_customer = true; // This is not passed from BE
      }
      // Deliberately NOT swapped to `isOrganizationAdmin()`. "Manage Team Members" applies
      // to Department Admins too (scoped to their department), so a DA must keep `team = true`.
      // Swapping would set `team = false` for a DA, dropping them below a plain team member.
      if(permissions.admin){
        permissions.team = true;
      }
    }
  }

  // Returns the expected api RESPONSE for a new user
  function getBlankPermissions(){
    return {
      // The auth.permissions returned by /issuer_login/whoami (BE /organization/details) are...
      admin: false, // Administrator / Organization permissions
      analytics: true,
      api: false, // Access the API
      billing: true,
      created_org: true,
      credential_attributes: true,
      designs: true,
      directory: true, // Embeddable Verification Directory
      emails: true,
      spotlight_directory: false, // Employment Directory on a custom domain
      group_ids: true,
      role: 'editor',
      settings: true,
      switch_department: true,
      team: false, // Manage the current Department Team
      verified: false,
      // These aren't returned by BE
      groups_permitted: true,
      blocked: false,
      is_customer: false, // Is an active customer?
    };
  }

  // Try to keep these roughly in order of importance
  var allPermissions = [
    {
      id: 'admin',
      name: 'Administrator Access',
      description: 'Complete access to all features and settings',
      icon: 'verified',
    },
    {
      id: 'team',
      name: 'Manage Team Members',
      description: 'Invite and edit team members and permissions',
      icon: 'user',
    },
    {
      id: 'api',
      name: 'Manage Integrations',
      description: 'Access integrations API keys',
      icon: 'api',
    },
    {
      id: 'settings',
      name: 'Department Settings',
      description: 'Edit department settings',
      icon: 'account',
    },
    {
      id: 'designs',
      name: 'Certificate Design Templates',
      description: 'Create, edit and delete certificate design templates',
      icon: 'certificate',
    },
    {
      id: 'emails',
      name: 'Email Templates',
      description: 'Create, edit and delete email templates',
      icon: 'email',
    },
    {
      id: 'attributes',
      name: 'Attribute Management',
      description: 'Create, edit and delete custom attributes',
      icon: 'tags',
    },
    {
      id: 'analytics',
      name: 'Analytics',
      description: 'Access analytics',
      icon: 'analytics-summary',
    },
    {
      id: 'directory',
      name: 'Recipient Directory',
      description: 'Access and edit the recipient directory',
      icon: 'search',
    },
    {
      id: 'spotlight_directory',
      name: 'Spotlight Directory',
      description: 'Access and edit the Spotlight directory',
      icon: 'verified',
    },
    {
      id: 'is_customer',
      name: 'Active Customer',
      description: 'You are an active customer.',
      icon: 'billing',
    },
  ];

  // Returns all available permissions
  function getAllPermissions(){
    return allPermissions;
  }
}

angular
  .module('app')
  .service('PermissionsService', PermissionsService);

},{}],50:[function(require,module,exports){
PostHogService.$inject = ['$rootScope', '$q', 'ENV'];
function PostHogService($rootScope, $q, ENV) {
  var service = this;
  service.init = init;
  service.identifyUser = identifyUser;
  service.getIssuer = getIssuer;
  service.getDepartments = getDepartments;
  service.logout = logout;

  function init() {
    // Inject PostHog script into header only on production
    // TODO(Fred): 'green' is specified here temporarily for testing
    if ((ENV.type === 'production' || ENV.name === 'red') && location.hostname !== 'localhost') {
      var scriptEl = document.createElement('script');
      scriptEl.type = 'text/javascript';
      scriptEl.async = true;

      // prod
      scriptEl.innerHTML = '!function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="init Ce Os As Te Cs Fs capture Ye calculateEventProperties Ls register register_once register_for_session unregister unregister_for_session qs getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey canRenderSurveyAsync identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty zs js createPersonProfile Us Rs Bs opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing Ds debug L Ns getPageViewId captureTraceFeedback captureTraceMetric".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);'
        + 'posthog.init(\'phc_qq8pF1vvGKhrD21B4ZS9bBPaIgLyM78vXRlkyQdIfKy\', {'
          + 'api_host: \'https://us.i.posthog.com\','
          + 'defaults: \'2025-05-24\','
          + 'person_profiles: \'identified_only\','
          + 'session_recording: { recordCrossOriginIframes: true},'
      + '})';

      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(scriptEl, s);

      this.identifyUser();
    }
  }

  function identifyUser() {
    $q.all([getIssuer(), getDepartments()]).then(function(data) {
      var issuer = data[0];
      var departments = data[1];

      var features = [];
      for (var prop in issuer.pricing.features) {
        if (issuer.pricing.features[prop]) {
          features.push(prop);
        }
      }

      var numberOfgroups = 0;
      for (var i = 0; i < departments.length - 1; i++) {
        numberOfgroups += departments[i].total_groups;
      }

      if (window.postHog) {
        window.postHog.identify(issuer.user.id, {
          corporation_id: issuer.pricing.corporation_id,
          role: issuer.permissions.admin ? 'admin' : 'member',
          plan: issuer.pricing.plan,
          num_groups: numberOfgroups,
          num_depts: departments.length,
          name: issuer.user.name,
          email: issuer.user.email,
          features: features.join(', '),
        });
      }
    });
  }

  function getIssuer() {
    var promise = $q(function(resolve) {
      var unsubscribe = $rootScope.$on('hotjarAndPosthogIssuer', function(event, issuer) {
        resolve(issuer);
        unsubscribe();
      });
    });
    return promise;
  }

  function getDepartments() {
    var promise = $q(function(resolve) {
      var unsubscribe = $rootScope.$on('hotjarAndPosthogDepartments', function(event, departments) {
        resolve(departments);
        unsubscribe();
      });
    });
    return promise;
  }

  function logout() {
    if (window.postHog) {
      window.postHog.reset();
    }
  }
}

angular
  .module('app')
  .service('PostHogService', PostHogService);

},{}],51:[function(require,module,exports){
ProfitWellRun.$inject = ['AuthService', 'ENV'];
function ProfitWellRun(AuthService, ENV) {
  AuthService.on('change', function(auth){
    if(auth && auth.stripe_customer_id){
      if(ENV.type === 'production'){
        profitwell('user_id', auth.stripe_customer_id);      
      }
    }
  });
}

angular
  .module('app')
  .run(ProfitWellRun);

},{}],52:[function(require,module,exports){
SmtpSettingsService.$inject = ['api'];
function SmtpSettingsService(api) {
  var service = this;
  service.get = getSmtpSettings;
  service.update = updateSmtpSettings;
  service.test = testSmtpSettings;

  function getSmtpSettings(payload){
    return api
      .request('/settings/email/smtp/get', payload)
      .then(function(response) {
        return response;
      });
  }

  function updateSmtpSettings(payload){
    return api
      .request('/settings/email/smtp/put', payload)
      .then(function(response) {
        return response;
      });
  }

  function testSmtpSettings(emailTo){
    return api
      .request('/settings/email/smtp-test', { emailTo: emailTo });
  }

}

angular
  .module('app')
  .service('SmtpSettingsService', SmtpSettingsService);

},{}],53:[function(require,module,exports){
/** STATE CACHE :: RUN
 *
 *    Observe Routing changes and inject state cache.
 *
 *  @author  Andrew Bateman
 */
StateCacheRun.$inject = ['$transitions', '$state', '$q', 'StateCacheService'];
function StateCacheRun($transitions, $state, $q, StateCacheService) {

  // REINSTATE - Where the route is specified (see StateCacheService), this decorates the url with 'reinstate=true',
  // clears the state cache on re-entry and captures the scroll position of the window
  function injectStateCache(transition){
    return $q(function(resolve, reject) {
      var transitionTarget = transition.to().name;
      var normalisedTransitionTarget = StateCacheService.normaliseRoute(transitionTarget);
      var result = null;
      if (StateCacheService.hasActiveStateCache(normalisedTransitionTarget)) {
        if (!transition.params().reinstate) {
          var newParams = {};
          angular.copy(transition.params(), newParams);
          newParams['reinstate'] = true;
          // Clear cache for normalisedTransitionTarget
          StateCacheService.clear(normalisedTransitionTarget);
          result = $state.target(transitionTarget, newParams);
        } else {
          // This is required for sub-routes such as 'grid' and 'list'
          StateCacheService.storeRouteView(transitionTarget);
        }
      } else {
        var transitionSource = StateCacheService.normaliseRoute(transition.from().name);
        if (StateCacheService.hasActiveStateCache(transitionSource)) {
          // Cache the vertical window scroll
          StateCacheService.updateCacheField('scroll', window.scrollY, transitionSource);
        }
      }
      resolve(result);
    });
  }

  $transitions.onStart({ to: 'issuer.dashboard.**' }, injectStateCache);
}

angular
  .module('app')
  .run(StateCacheRun);

},{}],54:[function(require,module,exports){
StateCacheService.$inject = ['$state'];
function StateCacheService($state) {
  var service = this;

  // REINSTATE - This centralises all the functionality required to store and retrieve state for a route

  // These are all the routes with active state caches. The route requires the 'reinstate' param adding to the url
  var cachedRoutes = {};

  service.normaliseRoute = normaliseRoute;
  service.hasActiveStateCache = hasActiveStateCache;
  service.storeRouteView = storeRouteView;
  service.recallRouteView = recallRouteView;
  service.clear = clear;
  service.getCache = getCache;
  service.setCache = setCache;
  service.resolveCache = resolveCache;
  service.updateCacheField = updateCacheField;
  service.preloadCache = preloadCache;

  // Remove sub-route part from route
  function normaliseRoute(route) {
    var parsedRoute = route.split('.');
    var view = parsedRoute.pop();
    return view === 'list' || view === 'grid' ? parsedRoute.join('.') : route;
  }

  function hasActiveStateCache(route) {
    return cachedRoutes[route];
  }

  function storeRouteView(route) {
    var parsedRoute = route.split('.');
    var view = parsedRoute.pop();
    var normalisedRoute = parsedRoute.join('.');
    if (normalisedRoute !== route) {
      // Cache route view
      sessionStorage.setItem(normalisedRoute + '>view', view);
    }
  }

  function recallRouteView(normalisedRoute) {
    return sessionStorage.getItem(normalisedRoute + '>view');
  }

  function clear(key) {
    sessionStorage.removeItem(key);
    // Remove cached route view, if any
    sessionStorage.removeItem(key + '>view');
  }

  function getCache(key) {
    var value = sessionStorage.getItem(key || normaliseRoute($state.current.name));
    return value == null ? null : JSON.parse(value);
  }

  function setCache(data, key) {
    var value = JSON.stringify(data);
    sessionStorage.setItem(key || normaliseRoute($state.current.name), value);
  }

  function resolveCache(data) {
    var cachedData = service.getCache();
    if (cachedData) {
      return cachedData;
    }
    service.setCache(data);
    return data;
  }

  function updateCacheField(fieldKey, fieldValue, key) {
    var cachedData = service.getCache(key);
    if (cachedData) {
      cachedData[fieldKey] = fieldValue;
      service.setCache(cachedData, key);
    }
  }

  function preloadCache(route, data) {
    var value = JSON.stringify(data);
    sessionStorage.setItem(route, value);
  }
}

angular
  .module('app')
  .service('StateCacheService', StateCacheService);

},{}],55:[function(require,module,exports){
TagsService.$inject = ['api'];
function TagsService(api) {
  var service = this;
  service.getAllTags = getAllTags;

  function getAllTags(){
    return api
      .request('/tags/all')
      .then(function(response){
        return response.tags;
      });
  }
}

angular
  .module('app')
  .service('TagsService', TagsService);

},{}],56:[function(require,module,exports){
/** TOOLTIP FILTERS
 *
 *    These filters allow us to pipe objects into filters
 *     to use with the [tooltip] custom directive.
 *
 *    They will return a sensible string based on the
 *     properties of the object, for example:
 *
 *       <i class="help" tooltip="{{ credential | tooltipCredentialStatus }}"></i>
 *
 *     ...may show one of the following tooltips:
 *
 *       "Credential is Unpublished"
 *       "Recipient Email Bounced"
 *       "Credential is Published"
 *       "Credential has Expired"
 *
 *    See also `iconFilters.js` for similar logic
 *
 *    @author   David "oodavid" King
 *    @author   Andrew Bateman
 */
angular.module('app')
  .filter("tooltipCredentialStatus", function() {
    return function(credential) {
      if (credential) {
        if (credential.expired) {
          return 'Credential has Expired';
        } else if (credential.bounced_email) {
          return 'Recipient Email Bounced:\n' + (credential.bounce_reason ? credential.bounce_reason : 'Reason unknown') ;
        } else {
          if (credential.approve) {
            return 'Credential is Published';
          } else {
            return 'Credential is Unpublished';
          }
        }
      } else {
        return 'Status';
      }
    };
  })

  .filter("tooltipCredentialEngagement", function() {
    return function(credential) {
      if (credential) {
        if (credential.recipient_engaged) {
          return 'Recipient engaged Credential';
        } else {
          return 'Recipient has not engaged Credential';
        }
      } else {
        return 'Engagement';
      }
    };
  })

  .filter("tooltipCredentialRecipientOpened", function() {
    return function(credential) {
      if (credential) {
        if (credential.recipient_opened) {
          return 'Recipient viewed credential';
        } else {
          return 'Recipient has not viewed credential yet';
        }
      } else {
        return 'Recipient View';
      }
    };
  })

  .filter("tooltipCredentialLinkedin", function() {
    return function(credential) {
      if (credential) {
        if (credential.linkedin_engaged || credential.is_added_to_linkedin) {
          return 'Credential added to LinkedIn';
        } else {
          return 'Credential not added to LinkedIn';
        }
      } else {
        return 'LinkedIn';
      }
    };
  })

  .filter("tooltipCredentialPrivate", function() {
    return function(credential) {
      if (credential) {
        if (credential.private) {
          return 'Credential is Private';
        } else {
          return 'Credential is Public';
        }
      } else {
        return 'Credential is Private';
      }
    };
  });

},{}],57:[function(require,module,exports){
/** TRANSLATE :: RUN
 *
 *    Observe Routing changes and make sure we're using English as the language.
 *
 *  @author  Alan Heppenstall
 */
TranslateRun.$inject = ['$transitions', 'languageService'];
function TranslateRun($transitions, languageService) {
  $transitions.onFinish({ to: 'issuer.dashboard.**' }, function($transition){
    languageService.setLocale('en');
  });
}

angular
  .module('app')
  .run(TranslateRun);

},{}],58:[function(require,module,exports){
/** USAGE SERVICE
 *
 *  Access an organization's usage stats
 *
 */
UsageService.$inject = ['api'];
function UsageService(api) {
  var service = this;

  service.getUsage = getUsage;

  function getUsage(startDate, endDate) {
    return api.request('/usage/get', {
        start_date: startDate, // YYYY-MM-DD
        end_date: endDate, // YYYY-MM-DD
      });
  }

}

angular
  .module('app')
  .service('UsageService', UsageService);

},{}],59:[function(require,module,exports){
/** USER SERVICE
 *
 *    Listens for changes in the AuthService,
 *     then plucks out the data that relates to the
 *     current user
 */
UserService.$inject = ['api', 'AuthService'];
function UserService(api, AuthService) {
  var service = this;
  service.getUser = getUser;

  var user = {};

  function getUser(){
    return AuthService
      .getAuth()
      .then(function(auth){
        cherrypickAuthProperties(auth);
        return user;
      });
  }

  AuthService.on('change', function(auth){
    cherrypickAuthProperties(auth);
  });

  function cherrypickAuthProperties(auth){
    angular.copy(auth.user || {}, user);
    if(!angular.equals({}, user)){
      user.was_invited = auth.permissions ? (!auth.permissions.created_org || false) : false; // BE sends this flag to show if the user was "not invited" to the organization, it's a user property, not a permission
    }
  }
}

angular
  .module('app')
  .service('UserService', UserService);

},{}],60:[function(require,module,exports){
IssuerNavbarCtrl.$inject = ['$scope', '$state', 'resolvedUser', 'resolvedOrganization', 'resolvedDepartment', 'resolvedDepartments', 'resolvedPermissions', 'resolvedFeatures', 'resolvedFlipperFeatures', 'FlipperFeaturesService', 'alertService', 'DepartmentService', 'DepartmentsService', '$timeout', 'ENV', 'PermissionsService'];
function IssuerNavbarCtrl($scope, $state, resolvedUser, resolvedOrganization, resolvedDepartment, resolvedDepartments, resolvedPermissions, resolvedFeatures, resolvedFlipperFeatures, FlipperFeaturesService,  alertService, DepartmentService, DepartmentsService, $timeout, ENV, PermissionsService) {
  var ctrl = this;

  ctrl.organization = resolvedOrganization;
  ctrl.department = resolvedDepartment;
  ctrl.departments = resolvedDepartments;
  ctrl.user = resolvedUser;
  ctrl.permissions = resolvedPermissions;
  ctrl.features = resolvedFeatures;
  ctrl.flipperFeatures = resolvedFlipperFeatures;
  ctrl.selectDepartment = selectDepartment;
  ctrl.updateDepartments = updateDepartments;
  ctrl.isOrganizationAdmin = PermissionsService.isOrganizationAdmin;
  ctrl.accessLevel = PermissionsService.getAccessLevel;
  ctrl.isIssuerHierarchy = !!resolvedFlipperFeatures.issuer_hierarchy;
  ctrl.spotLightPermission = ctrl.isIssuerHierarchy ? 'spotlight_directory' : 'admin';
  ctrl.integrationsPermission = ctrl.isIssuerHierarchy ? 'api' : 'settings';

  var unsubscribe = $scope.$on('departments:refresh', function(event, data) {
    if (data.action === 'create') {
      resolvedDepartments.push(data.department);
    } else if (data.action === 'delete') {
      resolvedDepartments = resolvedDepartments.filter(function(resolvedDepartment) {
        return resolvedDepartment.id !== data.department.id;
      });
    }
    
    ctrl.departments = resolvedDepartments;
  });

  $scope.$on('$destroy', function() {
    unsubscribe();
  });

  // Switch to the given department and redirect to the dashboard
  function selectDepartment(department) {
    alertService
      .confirm('Switch Department?', '<p>Switch to <strong>' + department.name + '</strong>?</p>')
      .then(function () {
        DepartmentService.switchDepartment(department.id)
          .then(function () {
            $timeout(function(){
              FlipperFeaturesService.getFlipperFeatures(department.id).then(function(flipperFeatures){
                if(flipperFeatures.v2_homepage && $state.current.name === 'issuer.dashboard.home') {
                  window.location.reload();
                }
                else {
                  $state.go('issuer.dashboard.home');
                }
              });
            });
          })
          .catch(function () {
            alertService
              .alert('Could not switch to this department');
          });
      })
      .catch(function () {
        // Handle cancel rejection
      });
  }

  // Update resolvedDepartments to reflect any changes that have been made - this is called everytime the departments menu is shown
  function updateDepartments() {
    DepartmentsService
      .getDepartments()
      .then(function(departments) {
        resolvedDepartments = departments;
        ctrl.departments = resolvedDepartments;
      });
  }

  FlipperFeaturesService.on('change', function(flipperFeatures){
    ctrl.flipperFeatures = flipperFeatures;
  });
}

angular
  .module('app')
  .controller('IssuerNavbarCtrl', IssuerNavbarCtrl);

},{}],61:[function(require,module,exports){
var sandboxBannerComponent = {
  controller: sandboxBannerComponentController,
  templateUrl: '/app/_layout/sandbox-banner/sandbox-banner.html',
};

sandboxBannerComponentController.$inject = ['ENV'];
function sandboxBannerComponentController(ENV) {
  var ctrl = this;

  // Only show the banner on the sandbox environment
  ctrl.isSandbox = ENV.name === 'sandbox';
}

angular
  .module('app')
  .component('sandboxBanner', sandboxBannerComponent);

},{}],62:[function(require,module,exports){
/** CHOOSE GROUP MODAL & Service
 *
 *      In your view
 *          <choose-group-modal></choose-group-modal>
 *
 *      In your controller
 *          Require the chooseGroupModalService
 *          Use the controller method like so:
 *
 *          chooseGroupModalService.show(true).then().catch().finally();
 *
 *      @author   Andrew Bateman
 */
(function () {
  angular
    .module('app')
    // Custom Directive
    .directive('chooseGroupModal', ['chooseGroupModalService', function () {
      return {
        restrict: 'E',
        replace: true,
        scope: {}, // Don't allow controller access to parent scope!
        templateUrl: '/app/_modals/chooseGroupModal.html',
        controller: ['$scope', 'chooseGroupModalService', function ($scope, chooseGroupModalService) {
          $scope.data = chooseGroupModalService.data;
          $scope.hide = chooseGroupModalService.hide;
          $scope.updatePagination = chooseGroupModalService.updatePagination;
          $scope.doShow = chooseGroupModalService.doShow;
          $scope.doSelect = chooseGroupModalService.doSelect;
          $scope.loadGroups = chooseGroupModalService.loadGroups;
          $scope.$on('$destroy', function () {
            $scope.hide();
          });
        }]
      };
    }])
    // Custom Service "glue"
    .service('chooseGroupModalService', ['$q', '$filter', 'api', '_', 'CertificateService', function ($q, $filter, api) {
      // Scope buster
      var that = this;
      // Exposed variables (these can be watched)
      this.data = {
        visible: false,
        groups: false,
        loading: false,
        pagination: {
          from: 0,
          to: 0,
          visible: 0,
          total: 0,
          prev: false,
          next: false,
          active: false,
        },
        form: {
          page_size: 8,
          page: ''
        }
      };
      var deferred;

      // Show the form, returns a promise when finished
      this.show = function (operation) {
        // Be visible, reset the form
        that.data.visible = true;
        that.data.designs = false; // No designs yet
        that.data.operation = operation;
        that.doShow(true);
        // Return a promise, triggered when the form is completed
        deferred = $q.defer();
        return deferred.promise;
      };
      // Show Groups
      this.doShow = function (show) {
        that.data.show = show;
        that.data.loading = false;
        that.data.pagination = {
          from: 0,
          to: 0,
          visible: 0,
          total: 0,
          prev: false,
          next: false
        };
        that.data.form = {
          page_size: 8,
          page: '',
          group_identifier: ''
        };
        that.loadGroups();
      };
      // Load a page of groups
      this.loadGroups = function () {
        that.data.loading = true;
        api
          .request('/groups/all', that.data.form)
          .then(function (response) {
            // AnalyticsService.trackEvent('Choose Group');
            that.data.loading = false;
            that.data.groups = response.groups;
            that.data.meta = response.meta;
          })
          .catch(function (err) {
            that.data.loading = false;
            that.data.groups = [];
            that.data.error = 'Failure! ' + JSON.stringify(err);
          });
      };
      this.doSelect = function (group) {
        that.data.visible = false;
        deferred.resolve(group);
      };
      this.hide = function () {
        that.data.visible = false;
        if (deferred) {
          deferred.reject();
        }
      };
      // Update the page number
      this.updatePagination = function (event) {
        that.data.form.page = event.page;
        that.loadGroups();
      };
    }]);
})();

},{}],63:[function(require,module,exports){
/** CREATED GROUP MODAL & SERVICE
 *
 *      Exposes a modal to send an example credential
 *
 *      In your view
 *          <created-group-modal></created-group-modal>
 *
 *      In your controller
 *          Require the createdGroupModalService
 *          Use the controller method like so:
 *
 *         createdGroupModalService.show();
 *
 *      @author   Andrew Bateman
 */
(function() {
  angular
    .module('app')
    // Custom Directive
    .directive('createdGroupModal', [
      function() {
        return {
          restrict: 'E',
          replace: true,
          scope: {}, // Don't allow controller access to parent scope!
          templateUrl: '/app/_modals/createdGroupModal.html',
          controller: [
            '$scope',
            'createdGroupModalService',
            function($scope, createdGroupModalService) {
              $scope.data = createdGroupModalService.data;
              $scope.hide = createdGroupModalService.hide;
              $scope.returnToSettings = createdGroupModalService.returnToSettings;
              $scope.addCredentials = createdGroupModalService.addCredentials;
              $scope.$on('$destroy', function() {
                $scope.hide();
              });
            }
          ]
        };
      }
    ])
    // Custom Service "glue"
    .service('createdGroupModalService', [
      '$state', '$timeout',
      function($state, $timeout) {
        // Scope buster
        var that = this;

        // Exposed variables (these can be watched)
        this.data = {
          visible: false,
          group: null
        };

        // Return to settings
        this.returnToSettings = function() {
          $timeout(function(){
            $state.go(
              'issuer.dashboard.group.edit',
              { id: this.data.group.id },
              { reload: false, location: 'replace' }
            );
          });
        };

        // Add credentials
        this.addCredentials = function() {
          $timeout(function(){
            $state.go('issuer.dashboard.upload-credentials', { group:this.data.group.id, intention:'create' });
          });
        };

        // Show the modal
        this.show = function(group) {
          this.data.group = group;
          this.data.visible = true;
        };

        // Hide the modal
        this.hide = function() {
          that.data.group = null;
          this.data.visible = false;
        };
      }
    ]);
})();

},{}],64:[function(require,module,exports){
/** CREDENTIAL EXPIRY MODAL & Service
 *
 *      Exposes a modal "form" to expire a credential, or
 *       group of credentials.
 *
 *      In your view
 *          <credential-expiry-modal></credential-expiry-modal>
 *
 *      In your controller
 *          Require the credentialExpiryModalService
 *          Use the controller method like so:
 *
 *          credentialExpiryModalService.show({ ...payload... })
 *              .then().catch().finally();
 *
 *          The payload should be something suitable for the API endpoint used below
 *
 *      @author   David "oodavid" King
 */
(function() {
  angular
    .module('app')
    // Custom Directive
    .directive('credentialExpiryModal', [
      function() {
        return {
          restrict: 'E',
          replace: true,
          scope: {}, // Don't allow controller access to parent scope!
          templateUrl: '/app/_modals/credentialExpiryModal.html',
          controller: ['$scope', 'credentialExpiryModalService', function($scope, credentialExpiryModalService) {
            $scope.data = credentialExpiryModalService.data;
            $scope.hide = credentialExpiryModalService.hide;
            $scope.doExpire = credentialExpiryModalService.doExpire;
            $scope.$on('$destroy', function() {
              $scope.hide();
            });
          }]
        };
      }
    ])
    // Custom Service "glue"
    .service('credentialExpiryModalService', ['$q', '$filter', 'api', '_', function($q, $filter, api, _) {
      // Scope buster
      var that = this;
      // Exposed variables (these can be watched)
      this.data = {
        visible: false,
        when: 'never',
        date: Date.parse('tomorrow').toString('yyyy-MM-dd'),
        totalUpdated: 0,
        publishComplete: false,
        options: [
          { value: 'never',  html: 'Never' },
          { value: 'now',    html: 'Immediately' },
          { value: 'future', html: 'A Later Date' },
        ],
      };
      var deferred;
      var payload;
      // Show the form, returns a promise when finished
      this.show = function(myPayload, single_expiry_date) {
        // Reset the data
        that.data.visible = true; // Be visible
        that.data.single_date = single_expiry_date;
        that.data.when = ''; // Reset to none selected
        that.data.date = Date.parse('tomorrow').toString('yyyy-MM-dd'); // Reset to tomorrow
        // If the current single expiry date is in the future, reset to this
        if (that.data.single_date && that.data.single_date != 'none' && that.data.single_date > that.data.date) {
          that.data.date = that.data.single_date;
        }
        that.data.error = false;
        that.data.totalUpdated = 0; // Unknown quantity
        that.data.publishComplete = false; // Not yet finished
        // Store the payload
        payload = myPayload;
        // Return a promise, triggered when the form is completed
        deferred = $q.defer();
        return deferred.promise;
      };
      this.doExpire = function(formCtrl) {
        if (that.data.when != '' && that.data.when != 'current') {
          formCtrl.$setSubmitted();
          // Update the payload
          payload['status'] = 'expired';
          if (that.data.when == 'never') {
            payload['expired_on'] = null; // Never
          } else if (that.data.when == 'now') {
            payload['expired_on'] = 'expire_now'; // Now
          } else {
            payload['expired_on'] =  that.data.date; // In the future
          }
          // And submit
          api.request('/credentials/change_status', payload)
            .then(function(response) {
              // Count the number updated - this is the length of response which is a simple array of credentuial ids
              that.data.totalUpdated = response.length;
              that.data.publishComplete = true;
              deferred.resolve();
            })
            .catch(function(/* err */) {
              // Boo!
              that.data.publishComplete = true;
              that.data.totalUpdated = 0;
              deferred.reject();
            });
        } else {
          formCtrl.$setPristine();
          that.data.error = true;
        }
      };
      this.hide = function(formCtrl) {
        that.data.visible = false;
        that.data.single_date = null;
        if (formCtrl) {
          formCtrl.$setPristine();
        }
        if (deferred) {
          deferred.reject();
        }
      };
    }]);
})();

},{}],65:[function(require,module,exports){
/** DOWNLOAD CSV MODAL & SERVICE
 *
 *      Exposes a modal to download a CSV
 *
 *      In your view
 *          <download-csv-modal></download-csv-modal>
 *
 *      In your controller
 *          Require the downloadCsvModalService
 *          Use the controller method like so:
 *
 *          downloadCsvModalService.show(payload);
 *
 *      @author   David "oodavid" King
 */
(function() {
  angular
    .module('app')
    // Custom Directive
    .directive('downloadCsvModal', [function() {
      return {
        restrict: 'E',
        replace: true,
        scope: {}, // Don't allow controller access to parent scope!
        templateUrl: '/app/_modals/downloadCsvModal.html',
        controller: ['$scope', 'downloadCsvModalService', function($scope, downloadCsvModalService) {
          $scope.data = downloadCsvModalService.data;
          $scope.hide = downloadCsvModalService.hide;
          $scope.doSubmit = downloadCsvModalService.doSubmit;
          $scope.$on("$destroy", function() {
            $scope.hide();
          });
        }]
      };
    }])
    // Custom Service "glue"
    .service('downloadCsvModalService', ['api', 'swalService', 'alertService', 'AnalyticsService', function(api, swalService, alertService, AnalyticsService) {
      // Scope buster
      var that = this;
      var payload;
      // Exposed variables (these can be watched)
      this.data = {
        visible: false,
        email: null, // Bound to the form controller
      };
      // Submit the form
      this.doSubmit = function(formCtrl) {
        payload.email = that.data.email;
        api.request("/credentials/export_as_csv", payload)
          .then(function(response) {
            AnalyticsService.trackEvent('All Credentials > Export CSV of Credentials');
            that.hide(); // Close when complete
            alertService.alert('Generating CSV', 'After a few minutes you will receive an email with the CSV file for these Credentials.');
          })
          .catch(function(err) {
            that.hide(); // Close when complete
            swalService.showAlert('unknownFailure');
          });
      };
      // Show the modal
      this.show = function(myPayload) {
        payload = myPayload;
        this.data.visible = true;
        this.data.email = null;
      };
      // Hide the modal
      this.hide = function() {
        this.data.visible = false;
      };
    }]);
})();

},{}],66:[function(require,module,exports){
/** DOWNLOAD PDFS MODAL & SERVICE
 *
 *      Exposes a modal to download PDFs
 *
 *      In your view
 *          <download-pdfs-modal></download-pdfs-modal>
 *
 *      In your controller
 *          Require the downloadPdfsModalService
 *          Use the controller method like so:
 *
 *          downloadPdfsModalService.show(payload, message);
 *
 *      @author   David "oodavid" King
 */
(function() {
  angular
    .module('app')
    // Custom Directive
    .directive('downloadPdfsModal', [function() {
      return {
        restrict: 'E',
        replace: true,
        scope: {}, // Don't allow controller access to parent scope!
        templateUrl: '/app/_modals/downloadPdfsModal.html',
        controller: ['$scope', 'downloadPdfsModalService', function($scope, downloadPdfsModalService) {
          $scope.data = downloadPdfsModalService.data;
          $scope.hide = downloadPdfsModalService.hide;
          $scope.doSubmit = downloadPdfsModalService.doSubmit;
          $scope.$on("$destroy", function() {
            $scope.hide();
          });
        }]
      };
    }])
    // Custom Service "glue"
    .service('downloadPdfsModalService', ['api', 'swalService', 'alertService', 'AnalyticsService', function(api, swalService, alertService, AnalyticsService) {
      // Scope buster
      var that = this;
      var payload;
      // Exposed variables (these can be watched)
      this.data = {
        visible: false,
        message: false,
        email: null, // Bound to the form controller
      };
      // Submit the form
      this.doSubmit = function (formCtrl) {
        payload.email = that.data.email;
        api.request('/credentials/download_as_pdf', payload)
          .then(function (response) {
            AnalyticsService.trackEvent('All Credentials > Download PDFs for Credentials');
            that.hide(); // Close when complete
            var message = that.data.validCount > 1 ?
              'After a few minutes you will receive an email with a link to download the Certificate PDFs file for these Credentials.' :
              'After a few minutes you will receive an email with a link to download the Certificate PDF file for this Credential.';
            alertService.alert('Generating ZIP', message);
          })
          .catch(function (err) {
            that.hide(); // Close when complete
            swalService.showAlert('unknownFailure');
          });
      };
      // Show the modal
      this.show = function (myPayload, validCount, invalidCount) {
        payload = myPayload;
        this.data.visible = true;
        this.data.validCount = validCount;
        this.data.invalidCount = invalidCount;
        this.data.email = null;
      };
      // Hide the modal
      this.hide = function() {
        this.data.visible = false;
      };
    }]);
})();

},{}],67:[function(require,module,exports){
/** EXAMPLE CREDENTIAL MODAL & SERVICE
 *
 *      Exposes a modal to send an example credential
 *
 *      In your view
 *          <example-credential-modal></example-credential-modal>
 *
 *      In your controller
 *          Require the exampleCredentialModalService
 *          Use the controller method like so:
 *
 *          exampleCredentialModalService.show();
 *
 *      @author   Andrew Bateman
 */
(function() {
  angular
    .module('app')
    // Custom Directive
    .directive('exampleCredentialModal', [
      function() {
        return {
          restrict: 'E',
          replace: true,
          scope: {}, // Don't allow controller access to parent scope!
          templateUrl: '/app/_modals/exampleCredentialModal.html',
          controller: [
            '$scope',
            'exampleCredentialModalService',
            function($scope, exampleCredentialModalService) {
              $scope.data = exampleCredentialModalService.data;
              $scope.hide = exampleCredentialModalService.hide;
              $scope.requestExampleCredential = exampleCredentialModalService.doRequestExampleCredential;
              $scope.$on('$destroy', function() {
                $scope.hide();
              });
            }
          ]
        };
      }
    ])
    // Custom Service "glue"
    .service('exampleCredentialModalService', [
      'api',
      function(api) {
        // Scope buster
        var that = this;

        function requestExampleCredential(type) {
          return api.request('/credentials/request_example', {
            default_type: type
          });
        }

        function getSingleCredential(credential_id) {
          return api
            .request('/credentials/read', {
              id: credential_id
            })
            .then(function(response) {
              return response.credential;
            });
        }

        // Exposed variables (these can be watched)
        this.data = {
          visible: false,
          user: null,
          step: 'request_example',
          type: null,
          showError: false
        };

        this.doRequestExampleCredential = function(type) {
          that.data.type = type;
          if (that.data.type != 'badge' && that.data.type != 'certificate') {
            that.data.showError = true;
          } else {
            that.data.showError = false;
            requestExampleCredential(that.data.type)
              .then(function(response) {
                if (response.credential_id) {
                  getSingleCredential(response.credential_id)
                    .then(function(credential) {
                      that.data.credential = credential;
                      that.data.step = 'sent_example';
                    })
                    .catch(function() {
                      // If, for some reason, the credential is not returned, just exit and let the user carry on
                      that.hide();
                    });
                } else {
                  that.data.step = 'send_error';
                }
              })
              .catch(function() {
                that.data.step = 'send_error';
              });
          }
        };

        // Show the modal
        this.show = function(user){
          this.data.user = user;
          this.data.visible = true;
        };

        // Hide the modal
        this.hide = function() {
          that.data.type = null;
          that.data.step = 'request_example';
          this.data.visible = false;
        };
      }
    ]);
})();

},{}],68:[function(require,module,exports){
'use strict';
/** ISSUER PAGE PREVIEW MODAL & SERVICE
 *
 *      Exposes a modal to preview the issuer page so custom settings can be reviewed
 *
 *      In your view
 *          <issuer-page-preview-modal></issuer-page-preview-modal>
 *
 *      In your controller
 *          Require the IssuerPagePreviewModalService
 *          Use the controller method like so:
 *
 *          IssuerPagePreviewModalService.show(social_media);
 *
 *      @author   Andrew Bateman
 */
(function () {
  angular
    .module('app')
    // Custom Directive
    .directive('issuerPagePreviewModal', function () {
      return {
        restrict: 'E',
        replace: true,
        scope: {}, // Don't allow controller access to parent scope!
        templateUrl: '/app/_modals/issuerPagePreviewModal.html',
        controller: ['$scope', 'IssuerPagePreviewModalService', function ($scope, IssuerPagePreviewModalService) {
          $scope.data = IssuerPagePreviewModalService.data;
          $scope.hide = IssuerPagePreviewModalService.hide;
          $scope.$on('$destroy', function () {
            $scope.hide();
          });
        }]
      };
    })
    // Custom Service "glue"
    .service('IssuerPagePreviewModalService', function () {
      // Scope buster
      var that = this;

      // Exposed variables (these can be watched)
      this.data = {
        visible: false,
        department: null
      };
      // Show the modal
      this.show = function (formData, department) {
        this.data.visible = true;
        this.data.department = formData;
        this.data.department.whitelabel_logo = department.whitelabel_logo;
        this.data.department.whitelabel_active = department.whitelabel_active;
      };
      // Hide the modal
      this.hide = function () {
        this.data.visible = false;
      };
    });
})();

},{}],69:[function(require,module,exports){
/** 
 *
 *      In your view
 *          <new-sms-access-modal></new-sms-access-modal>
 *
 *      In your controller
 *          Require the newSmsAccessModalService
 *          Use the controller method like so:
 *
 *          newSmsAccessModalService.show(id, onSuccessCallback);
 *

 */
(function () {
    angular
      .module('app')
      .directive('newSmsAccessModal', [function () {
        return {
          restrict: 'E',
          replace: true,
          scope: {},
          templateUrl: '/app/_modals/newSmsAccessModal.html',
          controller: ['$scope', 'newSmsAccessModalService', function ($scope, newSmsAccessModalService) {
            $scope.data = newSmsAccessModalService.data;
            $scope.hide = newSmsAccessModalService.hide;
            $scope.submitForm = newSmsAccessModalService.submitForm;
            $scope.$on('$destroy', function () {
              $scope.hide();
            });
          }]
        };
      }])
      .service('newSmsAccessModalService', ['CampaignsSmsService', 'alertService', function (CampaignsSmsService, alertService) {
        this.data = {
            visible: false,
            opened: false,
            consentOptIn: false,
            consentUsCanada: false,
            loading: false,
            departmentId: null,
            onSuccess: null,
        };

        this.show = function (id, onSuccessCallback) {
          if(!this.data.opened) {
            this.data.departmentId = id;
            this.data.onSuccess = onSuccessCallback;
            this.data.visible = true;  
            this.data.opened = true;  
            // Reset checkboxes when showing modal
            this.data.consentOptIn = false;
            this.data.consentUsCanada = false;
            this.data.loading = false;
          }
        };
        
        this.hide = function () {
          this.data.departmentId = null;
          this.data.onSuccess = null;
          this.data.visible = false;
          this.data.opened = false;
          this.data.loading = false;
        };

        this.submitForm = function () {
          if (this.data.consentOptIn && this.data.consentUsCanada) {
            this.data.loading = true;
            
            CampaignsSmsService.sendSmsAccessRequest(this.data.departmentId)
              .then(function(response) {
                alertService.success('Success', 'Sms access request submitted successfully');
                // Call the callback with the response before hiding
                if (this.data.onSuccess && angular.isFunction(this.data.onSuccess)) {
                  this.data.onSuccess(response);
                }
                this.hide();
              }.bind(this))
              .catch(function() {
                this.data.loading = false;
                alertService.warning('Error', 'There was an error submitting your request. Please try again later.');
              }.bind(this));
          }
        };
      }]);
  })();

},{}],70:[function(require,module,exports){
/** ORGANIZATION SETTINGS MODAL & Service
 *
 *      Exposes a modal "form" to update the organization settings.
 *
 *      In your view
 *          <organization-settings-modal></organization-settings-modal>
 *
 *      In your controller
 *          Require the organizationSettingsModalService
 *          Use the controller method like so:
 *
 *          organizationSettingsModalService.show(organizationSettings)
 *              .then().catch().finally();
 *
 *      @author   Andrew Bateman
 */
(function() {
  angular
    .module('app')
    // Custom Directive
    .directive('organizationSettingsModal', [
      function() {
        return {
          restrict: 'E',
          replace: true,
          scope: {}, // Don't allow controller access to parent scope!
          templateUrl: '/app/_modals/organizationSettingsModal.html',
          controller: ['$scope', 'organizationSettingsModalService', function($scope, organizationSettingsModalService) {
            $scope.data = organizationSettingsModalService.data;
            $scope.hide = organizationSettingsModalService.hide;
            $scope.doSubmit = organizationSettingsModalService.doSubmit;
            $scope.$on('$destroy', function() {
              $scope.hide();
            });
          }]
        };
      }
    ])
    // Custom Service "glue"
    .service('organizationSettingsModalService', ['OrganizationService', 'alertService', 'AuthService', '$q', function(OrganizationService, alertService, AuthService, $q) {
      // Scope buster
      var that = this;
      // Exposed variables (these can be watched)
      this.data = {
        visible: false,
        organization: null
      };
      var deferred;
      // Show the form, returns a promise when finished
      this.show = function(organization) {
        // Reset the data
        that.organization = organization; // Cache original settings
        that.data.organization = angular.copy(that.organization);
        that.data.visible = true;
        deferred = $q.defer();
        return deferred.promise;
      };
      this.doSubmit = function(formCtrl){
        OrganizationService
          .updateOrganization(that.data.organization)
            .then(function(updatedOrganization) {
              alertService.alert('Organization Settings Saved Successfully');
              AuthService.refresh();
              that.hide(updatedOrganization);
            })
            .catch(function() {
              alertService.alert('Something went wrong', 'Sorry, we couldn\'t save your changes');
            })
            .finally(function() {
              formCtrl.$setPristine();
            });
      };
      this.hide = function(updatedOrganization) {
        that.data.visible = false;
        deferred.resolve(updatedOrganization || that.organization);
      };
    }]);
})();

},{}],71:[function(require,module,exports){
/** SHARE PAGE - MODAL & SERVICE
 *
 *      Exposes a modal that allows the user to copy
 *      the recipient SSO link to the clipboard
 *
 *      In your view
 *          <recipient-link-modal></srecipient-link-modal>
 *
 *      In your controller
 *          Require the recipientLinkModalService
 *          Use the controller method like so:
 *
 *          recipientLinkModalService.show(ssoLink);
 *
 *      @author   Andrew Bateman
 */
(function () {
  angular
    .module('app')
    // Custom Directive
    .directive('recipientLinkModal', [function () {
      return {
        restrict: 'E',
        replace: true,
        scope: {}, // Don't allow controller access to parent scope!
        templateUrl: '/app/_modals/recipientLinkModal.html',
        controller: ['$scope', 'recipientLinkModalService', function ($scope, recipientLinkModalService) {
          $scope.data = recipientLinkModalService.data;
          $scope.hide = recipientLinkModalService.hide;
          $scope.$on('$destroy', function () {
            $scope.hide();
          });
        }]
      };
    }])
    // Custom Service "glue"
    .service('recipientLinkModalService', function () {
      // Scope buster
      // var that = this;
      // Exposed variables (these can be watched)
      var that = this;
      this.data = {
        visible: false,
        ssoLink: '',
        copyCallback: null
      };
      // Show the modal
      this.show = function (ssoLink) {
        this.data.visible = true; // Be visible
        this.data.ssoLink = ssoLink; // Set URL
        this.data.copyCallback = function() {
          that.hide();
        };
      };
      this.hide = function () {
        this.data.visible = false;
      };
    });
})();

},{}],72:[function(require,module,exports){
'use strict';
/** SEARCH & SHARE PREVIEW MODAL & SERVICE
 *
 *      Exposes a modal to preview search and share so custom settings can be reviewed
 *
 *      In your view
 *          <search-share-preview-modal></search-share-preview-modal>
 *
 *      In your controller
 *          Require the SearchSharePreviewModalService
 *          Use the controller method like so:
 *
 *          SearchSharePreviewModalService.show(social_media);
 *
 *      @author   Alan Heppenstall
 */
(function() {
  angular
    .module('app')
    // Custom Directive
    .directive('searchSharePreviewModal', function() {
      return {
        restrict: 'E',
        replace: true,
        scope: {}, // Don't allow controller access to parent scope!
        templateUrl: '/app/_modals/searchSharePreviewModal.html',
        controller: ['$scope', 'SearchSharePreviewModalService', function($scope, SearchSharePreviewModalService) {
          $scope.data = SearchSharePreviewModalService.data;
          $scope.hide = SearchSharePreviewModalService.hide;
          $scope.$on("$destroy", function() {
            $scope.hide();
          });
        }]
      };
    })
    // Custom Service "glue"
    .service('SearchSharePreviewModalService', function() {
      // Scope buster
      var that = this;

      // Exposed variables (these can be watched)
      this.data = {
        visible: false,
        social_media: null
      };
      // Show the modal
      this.show = function(social_media) {
        this.data.visible = true;
        this.data.social_media = social_media;
      };
      // Hide the modal
      this.hide = function() {
        this.data.visible = false;
      };
    });
})();

},{}],73:[function(require,module,exports){
/** SEND PREVIEW EMAIL MODAL & SERVICE
 *
 *      Exposes a modal to send a preview of an email template
 *
 *      In your view
 *          <send-preview-email-modal></send-preview-email-modal>
 *
 *      In your controller
 *          Require the sendPreviewEmailModalService
 *          Use the controller method like so:
 *
 *          SendPreviewEmailModalService.show({ ...template... });
 *
 *      @author   David "oodavid" King
 */
(function() {
  angular
    .module('app')
    // Custom Directive
    .directive('sendPreviewEmailModal', [function() {
      return {
        restrict: 'E',
        replace: true,
        scope: {}, // Don't allow controller access to parent scope!
        templateUrl: '/app/_modals/sendPreviewEmailModal.html',
        controller: ['$scope', 'SendPreviewEmailModalService', function($scope, SendPreviewEmailModalService) {
          $scope.data = SendPreviewEmailModalService.data;
          $scope.hide = SendPreviewEmailModalService.hide;
          $scope.doSubmit = SendPreviewEmailModalService.doSubmit;
          $scope.$on("$destroy", function() {
            $scope.hide();
          });
        }]
      };
    }])
    // Custom Service "glue"
    .service('SendPreviewEmailModalService', ['EmailService', function(EmailService) {
      // Scope buster
      var that = this;
      // Exposed variables (these can be watched)
      this.data = {
        visible: false,
        template: false,
        email: null, // Bound to the form controller
      };
      // Submit the form
      this.doSubmit = function(formCtrl) {
        var template = that.data.template;
        var email = that.data.email;
        EmailService.sendPreview(template, email)
          .then(function() {
            that.hide(); // Close when complete
          });
      };
      // Show the modal
      this.show = function(template) {
        this.data.visible = true;
        this.data.template = template;
        this.data.email = null;
      };
      // Hide the modal
      this.hide = function() {
        this.data.visible = false;
      };
    }]);
})();

},{}],74:[function(require,module,exports){
/** SHARE PREVIEW - MODAL & SERVICE
 *
 *      Exposes a modal that allows the user to copy
 *      a provided url to the clipboard
 *
 *      In your view
 *          <share-preview-modal></share-preview-modal>
 *
 *      In your controller
 *          Require the sharePreviewModalService
 *          Use the controller method like so:
 *
 *          sharePreviewModalService.show(url);
 *
 *      @author   Andrew Bateman
 */
(function () {
  angular
    .module('app')
    // Custom Directive
    .directive('sharePreviewModal', [function () {
      return {
        restrict: 'E',
        replace: true,
        scope: {}, // Don't allow controller access to parent scope!
        templateUrl: '/app/_modals/sharePreviewModal.html',
        controller: ['$scope', 'sharePreviewModalService', function ($scope, sharePreviewModalService) {
          $scope.data = sharePreviewModalService.data;
          $scope.hide = sharePreviewModalService.hide;
          $scope.check = sharePreviewModalService.check;
          $scope.$on('$destroy', function () {
            $scope.hide();
          });
        }]
      };
    }])
    // Custom Service "glue"
    .service('sharePreviewModalService', ['ENV', function (ENV) {
      // Exposed variables (these can be watched)
      this.data = {
        visible: false,
        pageUrl: '',
        exampleUrl: 'https://' + (ENV.prefix === '' ? 'www.' : ENV.prefix) + 'credential.net/example'
      };
      // Show the modal
      this.show = function (url) {
        this.data.visible = true; // Be visible
        this.data.pageUrl = url;
      };
      this.hide = function () {
        this.data.visible = false;
      };
    }]);
})();

},{}],75:[function(require,module,exports){
'use strict';
/** TWITTER TWEET PREVIEW MODAL & SERVICE
 *
 *      Exposes a modal to preview a Tweet so custom settings can be reviewed
 *
 *      In your view
 *          <tweet-preview-modal></tweet-preview-modal>
 *
 *      In your controller
 *          Require the TweetPreviewModalService
 *          Use the controller method like so:
 *
 *          TweetPreviewModalService.show(twitter);
 *
 *      @author   Alan Heppenstall
 */
(function() {
  angular
    .module('app')
    // Custom Directive
    .directive('tweetPreviewModal', function() {
      return {
        restrict: 'E',
        replace: true,
        scope: {}, // Don't allow controller access to parent scope!
        templateUrl: '/app/_modals/tweetPreviewModal.html',
        controller: ['$scope', 'TweetPreviewModalService', function($scope, TweetPreviewModalService) {
          $scope.data = TweetPreviewModalService.data;
          $scope.hide = TweetPreviewModalService.hide;
          $scope.$on('$destroy', function() {
            $scope.hide();
          });
        }]
      };
    })
    // Custom Service "glue"
    .service('TweetPreviewModalService', ['ENV', function(ENV) {
      // Scope buster
      var that = this;

      // Exposed variables (these can be watched)
      this.data = {
        visible: false,
        twitter: null,
        exampleUrl: 'https://' + (ENV.prefix === '' ? 'www.' : ENV.prefix) + 'credential.net/example'
      };
      // Show the modal
      this.show = function(twitter) {
        this.data.visible = true;
        this.data.twitter = twitter;
      };
      // Hide the modal
      this.hide = function() {
        this.data.visible = false;
      };
    }]);
})();

},{}],76:[function(require,module,exports){
/** UPDATE DEPARTMENT ALLOWANCE MODAL & Service
 *
 *      Exposes a modal "form" to update the allowance for a department.
 *
 *      In your view
 *          <update-department-allowance-modal></update-department-allowance-modal>
 *
 *      In your controller
 *          Require the updateDepartmentAllowanceModalService
 *          Use the controller method like so:
 *
 *          updateDepartmentAllowanceModalService.show(issuerId)
 *              .then().catch().finally();
 *
 *      @author   Andrew Bateman
 */
(function() {
  angular
    .module('app')
    // Custom Directive
    .directive('updateDepartmentAllowanceModal', [
      function() {
        return {
          restrict: 'E',
          replace: true,
          scope: {}, // Don't allow controller access to parent scope!
          templateUrl: '/app/_modals/updateDepartmentAllowanceModal.html',
          controller: ['$scope', 'updateDepartmentAllowanceModalService', function($scope, updateDepartmentAllowanceModalService) {
            $scope.data = updateDepartmentAllowanceModalService.data;
            $scope.hide = updateDepartmentAllowanceModalService.hide;
            $scope.doSubmit = updateDepartmentAllowanceModalService.doSubmit;
            $scope.$on('$destroy', function() {
              $scope.hide();
            });
          }]
        };
      }
    ])
    // Custom Service "glue"
    .service('updateDepartmentAllowanceModalService', ['OrganizationService', 'alertService', '$q', 'moment', function(OrganizationService, alertService, $q, moment) {
      // Scope buster
      var that = this;
      // Exposed variables (these can be watched)
      this.data = {
        visible: false,
        organization: null,
        newCreditAllowance: null,
      };

      var deferred;
      // Show the form, returns a promise when finished
      this.show = function(department, organization, billingV2Enabled) {
        // Reset the data
        that.data.department = angular.copy(department);
        that.data.organization = angular.copy(organization);
        that.data.billingV2Enabled = angular.copy(billingV2Enabled);
        that.data.allowanceResetDate = that.data.billingV2Enabled ? that.data.organization.cycle_end_at : moment(that.data.organization.subscription_created_at, 'YYYY-MM-DD').add(1, 'years').format('YYYY-MM-DD');
        that.data.visible = true;
        if (that.data.billingV2Enabled) {
          if (that.data.department.credits_allowance == null) {
            that.data.newCreditAllowance = null;
          } else {
            that.data.newCreditAllowance = that.data.department.credits_allowance + that.data.department.credits_used;
          }
        } else {
          that.data.newCreditAllowance = that.data.department.credits_allowance;
        }
        deferred = $q.defer();
        return deferred.promise;
      };

      this.doSubmit = function(formCtrl){
        // Validation: can't set less than used (positive values only)
        if (that.data.billingV2Enabled && that.data.newCreditAllowance > 0 && that.data.department.credits_used > that.data.newCreditAllowance) {
          alertService.alert('Something went wrong', 'Sorry, You can\'t set new allowance less than credits used for this department!');
          return;
        }

        // Calculate credits_allowance for billingV2
        if (that.data.billingV2Enabled) {
          if (that.data.newCreditAllowance == null) {
            that.data.department.credits_allowance = null;
          } else {
            that.data.department.credits_allowance = that.data.newCreditAllowance - that.data.department.credits_used;
          }
        }

        OrganizationService
          .updateDepartmentAllowance(that.data.department, that.data.department.credits_allowance)
            .then(function() {
              alertService.alert('Department allowance updated successfully');
              that.hide(that.data.department.credits_allowance);
            })
            .catch(function() {
              alertService.alert('Something went wrong', 'Sorry, we couldn\'t save your changes');
            })
            .finally(function() {
              formCtrl.$setPristine();
            });
      };
      this.hide = function(newAllowance) {
        that.data.visible = false;
        deferred.resolve(newAllowance);
      };
    }]);
})();

},{}],77:[function(require,module,exports){
/** UPSERT ATTRIBUTE MODAL & SERVICE
 *
 *      Exposes a modal that allows the issuer to add or
 *       edit their attributes.
 *
 *      In your view
 *          <upsert-attribute-modal></upsert-attribute-modal>
 *
 *      In your controller
 *          Require the upsertAttributeModalService
 *          Use the controller method like so:
 *
 *          upsertAttributeModalService.show({ ...attribute..., ...callback... });
 *
 *      @author  Jake Ford
 *      @author  David "oodavid" King (refactor)
 */
(function() {
  angular
    .module('app')
    // Custom Directive
    .directive('upsertAttributeModal', ['upsertAttributeModalService', function(upsertAttributeModalService) {
      return {
        restrict: 'E',
        replace: true,
        scope: {}, // Don't allow controller access to parent scope!
        templateUrl: '/app/_modals/upsertAttributeModal.html',
        controller: ['$scope', function($scope) {
          $scope.data = upsertAttributeModalService.data;
          $scope.hide = upsertAttributeModalService.hide;
          $scope.generateTag = upsertAttributeModalService.generateTag;
          $scope.doSave = upsertAttributeModalService.doSave;
          /*
          callback = function(attribute) {
            $scope.hide();
            if (upsertAttributeModalService.data.callback) {
              upsertAttributeModalService.data.callback(attribute);
            }
          };
          */
          $scope.$on("$destroy", function() {
            $scope.hide();
          });
        }]
      };
    }])
    // Custom Service "glue"
    .service('upsertAttributeModalService', ['attributeService', '_', function(attributeService, _) {
      // Scope buster
      var service = this;
      // Exposed variables (these can be watched)
      service.data = {
        visible: false,
        attribute: null,
      };
      var originalAttribute;
      var callback;
      var update;
      // Show the modal
      service.show = function(myAttribute, myCallback, myUpdate) {
        callback = myCallback;
        update = myUpdate;
        originalAttribute = myAttribute;
        service.data.visible = true;
        if (!_.isEmpty(originalAttribute)) {
          service.data.attribute = angular.copy(originalAttribute); // Edit Attribute (don't pollute)
        } else {
          service.data.attribute = { // NEW Attribute
            id: null,
            name: null,
            type: 'text',
            tag: '',
          };
        }
        service.data.validTypes = attributeService.getValidTypes();
      };
      // Generate the tag from the name
      service.generateTag = function(){
        var key = attributeService.nameToKey(service.data.attribute.name);
        if (key) {
          service.data.attribute.tag = '[custom.' + key + ']';
        } else {
          service.data.attribute.tag = '';
        }
      };
      // Save the attribute
      service.doSave = function(formCtrl) {
        var suppressAlerts = callback ? true : false;
        attributeService.upsert(service.data.attribute, suppressAlerts)
          .then(function(attribute) {
            angular.copy(attribute, originalAttribute); // Update the original object
            // Trigger the callback
            if(callback){
              callback(attribute);
            }
            // Run the update
            if(update){
              update();
            }
            // Close
            service.hide();
          });
      };
      // Hide the modal
      service.hide = function() {
        service.data.visible = false;
      };
    }]);
})();

},{}],78:[function(require,module,exports){
/** DASHBOARD.ACCREDIBLE.COM - APP
 *
 *    The app bundle contains our application logic.
 *    The libraries bundle contains 3rd party scripts and libraries.
 */

require('./app.module.js');
require('../env/ENV.js');
require('./app.routing.js');
require('./app.run.js');

// Shared
require('../shared/_services/api.service.js');
require('../shared/i18n/language.config.js');
require('../shared/i18n/language.service.js');
require('../shared/i18n/languageName.filter.js');
require('../shared/onEnterDirective.js');
require('../shared/history/history.factory.js');
require('../shared/basicFilters.js');
require('../shared/font-menu/font-menu.component.js');
require('../shared/animations/animations.js');
require('../shared/iconFilters.js');
require('../shared/scrollBlockingDirective.js');
require('../shared/recaptcha.config.js');
require('../shared/hotkeys/hotkeys.directive.js');
require('../shared/cacheBusterDecorator.js');
require('../shared/alert/legacySwalService.js');
require('../shared/alert/alert.service.js');
require('../shared/_services/emitter.service.js');
require('../shared/_services/csv.service.js');
require('../shared/_services/url.service.js');
require('../shared/trackingService.js');
require('../shared/_services/fileSize.service.js');
require('../shared/fullscreen-upload/fullscreen-upload.directive.js');
require('../shared/tooltip/tooltip.directive.js');
require('../shared/unsaved-changes/unsaved-changes.directive.js');
require('../shared/submit-validate/submit-validate.directive.js');
require('../shared/save-button/save-button.directive.js');
require('../shared/save-status/save-status.component.js');
require('../shared/permissions/permissions.directive.js');
require('../shared/_services/analytics.service.js');
require('../shared/_services/support.service.js');
require('../shared/_services/attribute.service.js');
require('../shared/_services/param.service.js');
require('../shared/_services/svg.service.js');
require('../shared/attributeFilters.js');
require('../shared/copyToClipboardDirective.js');
require('../shared/select-attribute/select-attribute.component.js');
require('../shared/meta-tags/meta-tags.controller');
require('../shared/meta-tags/meta-tags.run');
require('../shared/meta-tags/meta-tags.service.js');
require('../shared/onboardingServiceAndCtrl.js');
require('../shared/badge/badge.component.js');
require('../shared/certificate/certificate.component.js');
require('../shared/avatar/avatar.component.js');
require('../shared/validate-attribute-name/validate-attribute-name.directive.js');
require('../shared/validate-email/validate-email.directive.js');
require('../shared/validate-emails/validate-emails.directive.js');
require('../shared/validate-no-html/validate-no-html.directive.js');
require('../shared/validate-email-verified-sender/validate-email-verified-sender.directive.js');
require('../shared/validate-group-name-unique/validate-group-name-unique.directive.js');
require('../shared/validate-image/validate-image.directive.js');
require('../shared/validate-linkedin-id/validate-linkedin-id.directive.js');
require('../shared/validate-twitter-handle/validate-twitter-handle.directive.js');
require('../shared/validate-url/validate-url.directive.js');
require('../shared/validate-domain/validate-domain.directive.js');
require('../shared/validate-match/validate-match.directive.js');
require('../shared/validate-px/validate-px.directive.js');
require('../shared/validation/validation.component.js');
require('../shared/button-color/button-color.directive.js');
require('../shared/input-by-type/input-by-type.directive.js');
require('../shared/input-radios/input-radios.component.js');
require('../shared/input-checkboxes/input-checkboxes.component.js');
require('../shared/input-binary-filter/input-binary-filter.component.js');
require('../shared/input-date/input-date.component.js');
require('../shared/input-color/input-color.component.js');
require('../shared/input-tabs/input-tabs.component.js');
require('../shared/input-tags/input-tags.component.js');
require('../shared/input-search-tags/input-search-tags.component.js');
require('../shared/input-typeahead/input-typeahead.component.js');
require('../shared/input-typeahead/typeahead.service.js');
require('../shared/input-language/input-language.component.js');
require('../shared/input-image/input-image.component.js');
require('../shared/input-file/input-file.component.js');
require('../shared/input-tel/input-tel.component.js');
require('../shared/input-wysiwyg/input-wysiwyg.component.js');
require('../shared/input-recaptcha/input-recaptcha.component.js');
require('../shared/toggle/toggle.component.js');
require('../shared/upload-file/upload-file.directive.js');
require('../shared/order-by/order-by.component.js');
require('../shared/paginate/paginate.component.js');
require('../shared/pricing-plan/pricing-plan.component.js');
require('../shared/pricing-addons/pricing-addons.component.js');
require('../shared/pricing-summary/pricing-summary.component.js');
require('../shared/payment/payment.component.js');
require('../shared/img-onload/img-onload.directive.js');
require('../shared/_services/img.service.js');
require('../shared/loadingDirective.js');
require('../shared/selectable/selectable.component.js');
require('../shared/select-row/select-row.component.js');
require('../shared/select-all/select-all.component.js');
require('../shared/fonts/font.service.js');
require('../shared/vendor.factories.js');
require('../shared/link-filter/link-filter.component.js');
require('../shared/router-scroll/router-scroll.run.js');
require('../shared/scroll-spy/scroll-spy.run.js');
require('../shared/loading-bar/loading-bar.js');
require('../shared/auto-grow/auto-grow.directive.js');
require('../shared/fullscreen/fullscreen.component.js');
require('../shared/router-class/router-class.directive.js');
require('../shared/help-guide/help-guide.js');
require('../shared/group-appearance/group-appearance.component.js');
require('../shared/rating-meter/rating-meter.component.js');
require('../shared/dropdown/dropdown.component.js');
require('../shared/cookie-consent/cookie-consent.component.js');
require('../shared/external-links/external-links.directive.js');
require('../shared/collapsing/collapsing.directive.js');
require('../shared/embolden.filter.js');
require('../shared/jobs/jobs.component.js');
require('../shared/input-image-uploader/input-image-uploader.component.js');
require('../shared/overflow-tooltip/overflow-tooltip.directive.js');
require('../shared/filter-container/filter-container.component.js');
require('../shared/pager/pager.component.js');
require('../shared/scale-text/scale-text.directive.js');
require('../shared/_services/certificate.service.js');
require('../shared/_services/pathway.service.js');
require('../shared/fade-and-reveal/fade-and-reveal.component.js');
require('../shared/new-feature-indicator/new-feature-indicator.component.js');
require('../shared/embed-app/embed-app.component.js');
require('../shared/embed-app/embedApp.service.js');
require('../shared/embed-app/iframe-onload.directive.js');
require('../shared/_services/organization.service.js');
require('../shared/_services/flipperFeatures.service.js');
require('../shared/_services/auth.service.js');

// Auth
require('./_js/user.service.js');
require('./_js/permissions.service.js');
require('./_js/features.service.js');
require('./_js/authRedirect.service.js');
require('./_js/authRedirect.run.js');

// Signup, Login, Registration
require('./auth/sign-up/sign-up.controller.js');
require('./auth/verify_email/VerifyEmailRouteCtrl.js');
require('./auth/verify_email/VerifyEmailStatusRouteCtrl.js');
require('./auth/login/LoginRouteCtrl.js');
require('./auth/jwt_login/JWTLoginRouteCtrl.js');
require('./auth/claim_login/ClaimLoginRouteCtrl.js');
require('./auth/forgotten_password/ForgottenPasswordRouteCtrl.js');
require('./auth/reset_password/ResetPasswordRouteCtrl.js');
require('./auth/select-department/select-department.component.js');
require('./auth/select-department/SelectDepartmentRouteCtrl.js');
require('./auth/logout/LogoutRouteCtrl.js');

// Nav
require('./_layout/navbar/IssuerNavbarCtrl.js');
require('./_layout/sandbox-banner/sandbox-banner.component.js');

// Common Services & Logic
require('./_js/department.service.js');
require('./_js/departments.service.js');
require('./_js/groups.service.js');
require('./_js/group.service.js');
require('./_js/legacyCredential.service.js');
require('./_js/ftue.service.js');
require('./_js/ftue.directive.js');
require('./_js/translate.run.js');
require('./_js/stateCache.service.js');
require('./_js/stateCache.run.js');
require('./_js/tooltip.filters.js');
require('./_js/groupDefaults.service.js');
require('./_js/tags.service.js');
require('./_js/profitwell.run.js');
require('./_js/usage.service.js');
require('./_js/billing.service.js');
require('./_js/contracts.service.js');
require('./_js/email.service.js');
require('./_js/audit.service.js');
require('./_js/departmentAnalytics.service.js');
require('./_js/campaignsSms.service.js');
require('./_js/nps.run.js');
require('./_js/smtpSettings.service.js');
require('./_js/hotjar.service.js');
require('./_js/posthog.service.js');
require('./_js/gainsightPX.service.js');
require('./_js/gtm.service.js');

// Home
require('./home/homeCtrl.js');
require('./home/MfaStatus.service.js');

// Groups / Group
require('./groups/groupsCtrl.js');
require('./groups/group/groupCtrl.js');
require('./groups/group/groupNavCtrl.js');
require('./groups/group/eligibleCoursesFilter.js');

// Credentials / Credential
require('./credentials/credentialsCtrl.js');
require('./credentials/credential/credentialCtrl.js');

// Name Change Requests
require('./name-change-requests/NameChangeRequestsCtrl.js');
require('./name-change-requests/NameChangeRequests.service.js');

// Add / Upload Credentials
require('./credentials/upload-credentials/uploadCredentialsCtrl.js');
require('./credentials/upload-credentials/uploadCredentialsService.js');
require('./credentials/create-credentials-form/createCredentialsFormCtrl.js');

// Audit
require('./audit/auditCtrl.js');

// Group Overview
require('./group-overview/group-overview.controller.js');

// Designs
require('./designs/designsCtrl.js');

// Design Selector
require('./design-selector/design-selector.directive.js');

// Badge Design Editor
require('./badge-editor/badge-editor.directive.js');
require('../shared/svg-editor/svg-editor.component.js');

// Certificate Design Editor
require('./certificate-editor/certificate-editor-modal.js');
require('../shared/certificate-editor/certificate-editor.directive.js');

// Credential Preview Modal
require('./credential-preview/credential-preview.component.js');

// Pathways
require('./pathways/pathwaysCtrl.js');

// Pathway Builder
require('./pathway-builder/pathway-insert.component.js');
require('./pathway-builder/pathway-node.component.js');
require('./pathway-builder/pathway-builder-modal.js');
require('./pathway-builder/pathway-node-condition-modal.js');

// Email Settings
require('./email-settings/emailDynamicCssDirective.js');
require('./email-settings/emailSettingsCtrl.js');
require('./email-settings/forms/generalSettingsV2EmbedCtrl.js');
require('./email-settings/forms/supportContactV2EmbedCtrl.js');
require('./email-settings/emailNavFeatureCtrl.js');
require('./email-settings/email-appearance/emailAppearanceCtrl.js');
require('./email-settings/smtp-settings/smtpSettingsCtrl.js');
require('./email-settings/smtp-settings/smtpSettingsV2EmbedCtrl.js');
require('./email-settings/email-templates/emailTemplatesCtrl.js');
require('./email-settings/email-templates/email-template/emailTemplateCtrl.js');
require('./email-settings/email-templates/emailTemplatesV2EmbedCtrl.js');
require('./email-settings/email-appearance/emailAppearanceV2EmbedCtrl.js');

// Email Campaigns
require('./email-settings/emailCampaignsCtrl.js');

// Find Campaigns
require('./email-settings/find-campaigns/findCampaignsCtrl.js');

// New Email Templates
require('./email-settings/new-email-templates/newEmailTemplatesCtrl.js');

// Organization
require('./departments/organizationDepartmentsCtrl.js');
require('./departments/department/organizationDepartmentCtrl.js');
require('./usage/organizationUsageCtrl.js');

// Department Settings
require('./department/departmentCtrl.js');
require('./department/recipient-directory/recipientDirectoryCtrl.js');
require('./department/employment-directory/employment-directory.controller.js');
require('./department/employment-directory/employment-directory.service.js');
require('./department/api-settings/apiSettingsCtrl.js');
require('./department/api-settings/apiSettings.service.js');
require('./department/recipient-experience/settingsRecipientExperienceCtrl.js');

// My Account
require('./my-account/MyAccountRouteCtrl.js');

// Attribute Management
require('./attributes/attributesCtrl.js');

// Billing
require('./billing/billingCtrl.js');
require('./billing/status/billingStatusCtrl.js');
require('./billing/payment/billingPaymentCtrl.js');
require('./billing/purchase/billingPurchaseCtrl.js');
require('./billing/checkout/billingCheckoutCtrl.js');
require('./invoices/invoicesCtrl.js');

// Contracts
require('./contracts/contractsCtrl.js');
require('./contracts/contract/contractCtrl.js');

// Quickstart
require('./quickstart/QuickstartCtrl.js');

// Message
require('./static/message/messageRoute.controller.js');

// Verification
require('./verification/verificationCtrl.js');

// Modals
require('./_modals/exampleCredentialModal.js');
require('./_modals/createdGroupModal.js');
require('./_modals/upsertAttributeModal.js');
require('./_modals/credentialExpiryModal.js');
require('./_modals/downloadCsvModal.js');
require('./_modals/downloadPdfsModal.js');
require('./_modals/sendPreviewEmailModal.js');
require('./_modals/tweetPreviewModal.js');
require('./_modals/searchSharePreviewModal.js');
require('./_modals/issuerPagePreviewModal.js');
require('./_modals/chooseGroupModal.js');
require('./_modals/recipientLinkModal.js');
require('./_modals/sharePreviewModal.js');
require('./_modals/organizationSettingsModal.js');
require('./_modals/updateDepartmentAllowanceModal.js');
require('./_modals/newSmsAccessModal.js');

// Evidence
require('../shared/evidence/evidenceCtrl.js');
require('../shared/evidence/evidenceItemDirective.js');
require('../shared/evidence/evidenceModalService.js');
require('../shared/evidence/evidence.service.js');
require('../shared/evidence/url/urlEvidenceDirective.js');
require('../shared/evidence/file/fileEvidenceDirective.js');
require('../shared/evidence/grade/gradeEvidenceDirective.js');
require('../shared/evidence/badge/badgeEvidenceDirective.js');
require('../shared/evidence/miriada/miriadaGradeEvidenceDirective.js');
require('../shared/evidence/miriada/miriadaOutlineEvidenceDirective.js');
require('../shared/evidence/miriada/miriadaParticipationEvidenceDirective.js');
require('../shared/evidence/miriada/miriadaPerformanceEvidenceDirective.js');
require('../shared/evidence/miriada/miriadaTeacherOutlineEvidenceDirective.js');
require('../shared/evidence/project/projectEvidenceDirective.js');
require('../shared/evidence/table/tableEvidenceDirective.js');
require('../shared/evidence/transcript/transcriptEvidenceDirective.js');
require('../shared/evidence/text/staticTextEvidenceDirective.js');
require('../shared/evidence/portfolio/portfolioEvidenceDirective.js');
require('../shared/evidence/video/videoEmbedEvidenceDirective.js');
require('../shared/evidence/video/videoEvidenceDirective.js');
require('../shared/evidence/duration/durationEvidenceDirective.js');
require('../shared/evidence/language-grade/languageGradeEvidenceDirective.js');
require('../shared/evidence/partials/accEvidenceInsightsDirective.js');
require('../shared/evidence/partials/trustedDirective.js');
require('../shared/evidence/partials/evidenceEditMenuDirective.js');
require('../shared/evidence/partials/issuerEvidenceMenuDirective.js');

},{"../env/ENV.js":156,"../shared/_services/analytics.service.js":157,"../shared/_services/api.service.js":158,"../shared/_services/attribute.service.js":159,"../shared/_services/auth.service.js":160,"../shared/_services/certificate.service.js":161,"../shared/_services/csv.service.js":162,"../shared/_services/emitter.service.js":165,"../shared/_services/fileSize.service.js":167,"../shared/_services/flipperFeatures.service.js":168,"../shared/_services/img.service.js":169,"../shared/_services/organization.service.js":171,"../shared/_services/param.service.js":172,"../shared/_services/pathway.service.js":173,"../shared/_services/support.service.js":174,"../shared/_services/svg.service.js":175,"../shared/_services/url.service.js":176,"../shared/alert/alert.service.js":178,"../shared/alert/legacySwalService.js":179,"../shared/animations/animations.js":180,"../shared/attributeFilters.js":181,"../shared/auto-grow/auto-grow.directive.js":182,"../shared/avatar/avatar.component.js":183,"../shared/badge/badge.component.js":184,"../shared/basicFilters.js":185,"../shared/button-color/button-color.directive.js":186,"../shared/cacheBusterDecorator.js":187,"../shared/certificate-editor/certificate-editor.directive.js":188,"../shared/certificate/certificate.component.js":193,"../shared/collapsing/collapsing.directive.js":194,"../shared/cookie-consent/cookie-consent.component.js":195,"../shared/copyToClipboardDirective.js":196,"../shared/dropdown/dropdown.component.js":197,"../shared/embed-app/embed-app.component.js":198,"../shared/embed-app/embedApp.service.js":199,"../shared/embed-app/iframe-onload.directive.js":200,"../shared/embolden.filter.js":201,"../shared/evidence/badge/badgeEvidenceDirective.js":202,"../shared/evidence/duration/durationEvidenceDirective.js":203,"../shared/evidence/evidence.service.js":204,"../shared/evidence/evidenceCtrl.js":205,"../shared/evidence/evidenceItemDirective.js":206,"../shared/evidence/evidenceModalService.js":207,"../shared/evidence/file/fileEvidenceDirective.js":208,"../shared/evidence/grade/gradeEvidenceDirective.js":209,"../shared/evidence/language-grade/languageGradeEvidenceDirective.js":210,"../shared/evidence/miriada/miriadaGradeEvidenceDirective.js":211,"../shared/evidence/miriada/miriadaOutlineEvidenceDirective.js":212,"../shared/evidence/miriada/miriadaParticipationEvidenceDirective.js":213,"../shared/evidence/miriada/miriadaPerformanceEvidenceDirective.js":214,"../shared/evidence/miriada/miriadaTeacherOutlineEvidenceDirective.js":215,"../shared/evidence/partials/accEvidenceInsightsDirective.js":216,"../shared/evidence/partials/evidenceEditMenuDirective.js":217,"../shared/evidence/partials/issuerEvidenceMenuDirective.js":218,"../shared/evidence/partials/trustedDirective.js":219,"../shared/evidence/portfolio/portfolioEvidenceDirective.js":220,"../shared/evidence/project/projectEvidenceDirective.js":221,"../shared/evidence/table/tableEvidenceDirective.js":222,"../shared/evidence/text/staticTextEvidenceDirective.js":223,"../shared/evidence/transcript/transcriptEvidenceDirective.js":224,"../shared/evidence/url/urlEvidenceDirective.js":225,"../shared/evidence/video/videoEmbedEvidenceDirective.js":226,"../shared/evidence/video/videoEvidenceDirective.js":227,"../shared/external-links/external-links.directive.js":228,"../shared/fade-and-reveal/fade-and-reveal.component.js":229,"../shared/filter-container/filter-container.component.js":230,"../shared/font-menu/font-menu.component.js":231,"../shared/fonts/font.service.js":232,"../shared/fullscreen-upload/fullscreen-upload.directive.js":233,"../shared/fullscreen/fullscreen.component.js":234,"../shared/group-appearance/group-appearance.component.js":235,"../shared/help-guide/help-guide.js":236,"../shared/history/history.factory.js":237,"../shared/hotkeys/hotkeys.directive.js":238,"../shared/i18n/language.config.js":240,"../shared/i18n/language.service.js":242,"../shared/i18n/languageName.filter.js":243,"../shared/iconFilters.js":244,"../shared/img-onload/img-onload.directive.js":245,"../shared/input-binary-filter/input-binary-filter.component.js":246,"../shared/input-by-type/input-by-type.directive.js":247,"../shared/input-checkboxes/input-checkboxes.component.js":248,"../shared/input-color/input-color.component.js":249,"../shared/input-date/input-date.component.js":250,"../shared/input-file/input-file.component.js":251,"../shared/input-image-uploader/input-image-uploader.component.js":252,"../shared/input-image/input-image.component.js":253,"../shared/input-language/input-language.component.js":254,"../shared/input-radios/input-radios.component.js":255,"../shared/input-recaptcha/input-recaptcha.component.js":256,"../shared/input-search-tags/input-search-tags.component.js":257,"../shared/input-tabs/input-tabs.component.js":258,"../shared/input-tags/input-tags.component.js":259,"../shared/input-tel/input-tel.component.js":260,"../shared/input-typeahead/input-typeahead.component.js":261,"../shared/input-typeahead/typeahead.service.js":262,"../shared/input-wysiwyg/input-wysiwyg.component.js":263,"../shared/jobs/jobs.component.js":274,"../shared/link-filter/link-filter.component.js":275,"../shared/loading-bar/loading-bar.js":276,"../shared/loadingDirective.js":278,"../shared/meta-tags/meta-tags.controller":279,"../shared/meta-tags/meta-tags.run":280,"../shared/meta-tags/meta-tags.service.js":281,"../shared/new-feature-indicator/new-feature-indicator.component.js":282,"../shared/onEnterDirective.js":283,"../shared/onboardingServiceAndCtrl.js":284,"../shared/order-by/order-by.component.js":285,"../shared/overflow-tooltip/overflow-tooltip.directive.js":286,"../shared/pager/pager.component.js":287,"../shared/paginate/paginate.component.js":288,"../shared/payment/payment.component.js":289,"../shared/permissions/permissions.directive.js":290,"../shared/pricing-addons/pricing-addons.component.js":291,"../shared/pricing-plan/pricing-plan.component.js":292,"../shared/pricing-summary/pricing-summary.component.js":293,"../shared/rating-meter/rating-meter.component.js":294,"../shared/recaptcha.config.js":295,"../shared/router-class/router-class.directive.js":296,"../shared/router-scroll/router-scroll.run.js":297,"../shared/save-button/save-button.directive.js":298,"../shared/save-status/save-status.component.js":299,"../shared/scale-text/scale-text.directive.js":300,"../shared/scroll-spy/scroll-spy.run.js":301,"../shared/scrollBlockingDirective.js":302,"../shared/select-all/select-all.component.js":303,"../shared/select-attribute/select-attribute.component.js":304,"../shared/select-row/select-row.component.js":305,"../shared/selectable/selectable.component.js":306,"../shared/submit-validate/submit-validate.directive.js":307,"../shared/svg-editor/svg-editor.component.js":320,"../shared/toggle/toggle.component.js":321,"../shared/tooltip/tooltip.directive.js":322,"../shared/trackingService.js":323,"../shared/unsaved-changes/unsaved-changes.directive.js":324,"../shared/upload-file/upload-file.directive.js":325,"../shared/validate-attribute-name/validate-attribute-name.directive.js":327,"../shared/validate-domain/validate-domain.directive.js":328,"../shared/validate-email-verified-sender/validate-email-verified-sender.directive.js":329,"../shared/validate-email/validate-email.directive.js":330,"../shared/validate-emails/validate-emails.directive.js":331,"../shared/validate-group-name-unique/validate-group-name-unique.directive.js":332,"../shared/validate-image/validate-image.directive.js":333,"../shared/validate-linkedin-id/validate-linkedin-id.directive.js":334,"../shared/validate-match/validate-match.directive.js":335,"../shared/validate-no-html/validate-no-html.directive.js":336,"../shared/validate-px/validate-px.directive.js":337,"../shared/validate-twitter-handle/validate-twitter-handle.directive.js":338,"../shared/validate-url/validate-url.directive.js":339,"../shared/validation/validation.component.js":340,"../shared/vendor.factories.js":341,"./_js/audit.service.js":28,"./_js/authRedirect.run.js":29,"./_js/authRedirect.service.js":30,"./_js/billing.service.js":31,"./_js/campaignsSms.service.js":32,"./_js/contracts.service.js":33,"./_js/department.service.js":34,"./_js/departmentAnalytics.service.js":35,"./_js/departments.service.js":36,"./_js/email.service.js":37,"./_js/features.service.js":38,"./_js/ftue.directive.js":39,"./_js/ftue.service.js":40,"./_js/gainsightPX.service.js":41,"./_js/group.service.js":42,"./_js/groupDefaults.service.js":43,"./_js/groups.service.js":44,"./_js/gtm.service.js":45,"./_js/hotjar.service.js":46,"./_js/legacyCredential.service.js":47,"./_js/nps.run.js":48,"./_js/permissions.service.js":49,"./_js/posthog.service.js":50,"./_js/profitwell.run.js":51,"./_js/smtpSettings.service.js":52,"./_js/stateCache.run.js":53,"./_js/stateCache.service.js":54,"./_js/tags.service.js":55,"./_js/tooltip.filters.js":56,"./_js/translate.run.js":57,"./_js/usage.service.js":58,"./_js/user.service.js":59,"./_layout/navbar/IssuerNavbarCtrl.js":60,"./_layout/sandbox-banner/sandbox-banner.component.js":61,"./_modals/chooseGroupModal.js":62,"./_modals/createdGroupModal.js":63,"./_modals/credentialExpiryModal.js":64,"./_modals/downloadCsvModal.js":65,"./_modals/downloadPdfsModal.js":66,"./_modals/exampleCredentialModal.js":67,"./_modals/issuerPagePreviewModal.js":68,"./_modals/newSmsAccessModal.js":69,"./_modals/organizationSettingsModal.js":70,"./_modals/recipientLinkModal.js":71,"./_modals/searchSharePreviewModal.js":72,"./_modals/sendPreviewEmailModal.js":73,"./_modals/sharePreviewModal.js":74,"./_modals/tweetPreviewModal.js":75,"./_modals/updateDepartmentAllowanceModal.js":76,"./_modals/upsertAttributeModal.js":77,"./app.module.js":79,"./app.routing.js":80,"./app.run.js":81,"./attributes/attributesCtrl.js":82,"./audit/auditCtrl.js":83,"./auth/claim_login/ClaimLoginRouteCtrl.js":84,"./auth/forgotten_password/ForgottenPasswordRouteCtrl.js":85,"./auth/jwt_login/JWTLoginRouteCtrl.js":86,"./auth/login/LoginRouteCtrl.js":87,"./auth/logout/LogoutRouteCtrl.js":88,"./auth/reset_password/ResetPasswordRouteCtrl.js":89,"./auth/select-department/SelectDepartmentRouteCtrl.js":90,"./auth/select-department/select-department.component.js":91,"./auth/sign-up/sign-up.controller.js":92,"./auth/verify_email/VerifyEmailRouteCtrl.js":93,"./auth/verify_email/VerifyEmailStatusRouteCtrl.js":94,"./badge-editor/badge-editor.directive.js":95,"./billing/billingCtrl.js":96,"./billing/checkout/billingCheckoutCtrl.js":97,"./billing/payment/billingPaymentCtrl.js":98,"./billing/purchase/billingPurchaseCtrl.js":99,"./billing/status/billingStatusCtrl.js":100,"./certificate-editor/certificate-editor-modal.js":101,"./contracts/contract/contractCtrl.js":102,"./contracts/contractsCtrl.js":103,"./credential-preview/credential-preview.component.js":104,"./credentials/create-credentials-form/createCredentialsFormCtrl.js":105,"./credentials/credential/credentialCtrl.js":106,"./credentials/credentialsCtrl.js":107,"./credentials/upload-credentials/uploadCredentialsCtrl.js":108,"./credentials/upload-credentials/uploadCredentialsService.js":109,"./department/api-settings/apiSettings.service.js":110,"./department/api-settings/apiSettingsCtrl.js":111,"./department/departmentCtrl.js":112,"./department/employment-directory/employment-directory.controller.js":113,"./department/employment-directory/employment-directory.service.js":114,"./department/recipient-directory/recipientDirectoryCtrl.js":115,"./department/recipient-experience/settingsRecipientExperienceCtrl.js":116,"./departments/department/organizationDepartmentCtrl.js":117,"./departments/organizationDepartmentsCtrl.js":118,"./design-selector/design-selector.directive.js":119,"./designs/designsCtrl.js":120,"./email-settings/email-appearance/emailAppearanceCtrl.js":121,"./email-settings/email-appearance/emailAppearanceV2EmbedCtrl.js":122,"./email-settings/email-templates/email-template/emailTemplateCtrl.js":123,"./email-settings/email-templates/emailTemplatesCtrl.js":124,"./email-settings/email-templates/emailTemplatesV2EmbedCtrl.js":125,"./email-settings/emailCampaignsCtrl.js":126,"./email-settings/emailDynamicCssDirective.js":127,"./email-settings/emailNavFeatureCtrl.js":128,"./email-settings/emailSettingsCtrl.js":129,"./email-settings/find-campaigns/findCampaignsCtrl.js":130,"./email-settings/forms/generalSettingsV2EmbedCtrl.js":131,"./email-settings/forms/supportContactV2EmbedCtrl.js":132,"./email-settings/new-email-templates/newEmailTemplatesCtrl.js":133,"./email-settings/smtp-settings/smtpSettingsCtrl.js":134,"./email-settings/smtp-settings/smtpSettingsV2EmbedCtrl.js":135,"./group-overview/group-overview.controller.js":136,"./groups/group/eligibleCoursesFilter.js":137,"./groups/group/groupCtrl.js":138,"./groups/group/groupNavCtrl.js":139,"./groups/groupsCtrl.js":140,"./home/MfaStatus.service.js":141,"./home/homeCtrl.js":142,"./invoices/invoicesCtrl.js":143,"./my-account/MyAccountRouteCtrl.js":144,"./name-change-requests/NameChangeRequests.service.js":145,"./name-change-requests/NameChangeRequestsCtrl.js":146,"./pathway-builder/pathway-builder-modal.js":147,"./pathway-builder/pathway-insert.component.js":148,"./pathway-builder/pathway-node-condition-modal.js":149,"./pathway-builder/pathway-node.component.js":150,"./pathways/pathwaysCtrl.js":151,"./quickstart/QuickstartCtrl.js":152,"./static/message/messageRoute.controller.js":153,"./usage/organizationUsageCtrl.js":154,"./verification/verificationCtrl.js":155}],79:[function(require,module,exports){
angular.module('app',
    [
      'ngAnimate',
      'ui.router',
      'ngFileUpload',
      'ngSanitize',
      'ui.bootstrap',
      'angular-stripe',
      'credit-cards',
      'angulartics',
      'angulartics.google.analytics',
      'chart.js',
      'ngMessages',
      'ng-countryflags',
      'isoCurrency',
      // I'm unsure if these are used
      'angular.filter'
    ]);

},{}],80:[function(require,module,exports){
appRoutingConfig.$inject = ['$stateProvider', '$urlRouterProvider', '$urlServiceProvider', '$locationProvider'];
function appRoutingConfig($stateProvider, $urlRouterProvider, $urlServiceProvider, $locationProvider) {

  // HTML5 Mode - removes the hashbang, needs to have server support to work
  $locationProvider.html5Mode(true);

  // Allow optional trailing slashes
  $urlServiceProvider.config.strictMode(false);

  // Alias URLs
  $urlRouterProvider.otherwise('/error/404');
  $urlRouterProvider.when('/', '/issuer/dashboard/');
  $urlRouterProvider.when('/login', '/user');
  $urlRouterProvider.when('/issuer/sign_up', '/user/sign-up');
  $urlRouterProvider.when('/forgot-password/', '/user/forgot-password');
  $urlRouterProvider.when('/reset-password/', '/user/reset-password');
  $urlRouterProvider.when('/issuer/dashboard/settings/linkedin', '/issuer/dashboard/department/social-sharing');
  $urlRouterProvider.when('/issuer/dashboard/settings/recipient_experience', '/issuer/dashboard/department/recipient-experience');
  $urlRouterProvider.when('/issuer/dashboard/settings/directory', '/issuer/dashboard/department/recipient-directory?edit=general-settings');
  $urlRouterProvider.when('/issuer/dashboard/directory', '/issuer/dashboard/department/recipient-directory?edit=general-settings');
  $urlRouterProvider.when('/issuer/dashboard/settings/employment-directory', '/issuer/dashboard/department/employment-directory');
  $urlRouterProvider.when('/issuer/dashboard/settings/team_members', '/issuer/dashboard/team-members');
  $urlRouterProvider.when('/issuer/dashboard/team_members', '/issuer/dashboard/team-members');
  $urlRouterProvider.when('/issuer/dashboard/name_changes', '/issuer/dashboard/name-change-requests');
  $urlRouterProvider.when('/issuer/dashboard/name_changes/settings', '/issuer/dashboard/name-change-requests/settings');
  $urlRouterProvider.when('/issuer/dashboard/certificate_designs', '/issuer/dashboard/designs');
  $urlRouterProvider.when('/issuer/dashboard/organization?edit=conditions', '/issuer/dashboard/dpa-conditions');
  $urlRouterProvider.when('/issuer/dashboard/admin/departments', '/issuer/dashboard/departments');
  $urlRouterProvider.when('/issuer/dashboard/admin/usage', '/issuer/dashboard/usage');
  $urlRouterProvider.when('/issuer/dashboard/email-settings', '/issuer/dashboard/email-settings?edit=general-settings');
  $urlRouterProvider.when('/issuer/dashboard/email-appearance', '/issuer/dashboard/email-settings/email-appearance');
  $urlRouterProvider.when('/issuer/dashboard/email-settings?edit=email-appearance', '/issuer/dashboard/email-settings/email-appearance');
  $urlRouterProvider.when('/issuer/dashboard/email', '/issuer/dashboard/email-templates');
  $urlRouterProvider.when('/issuer/dashboard/group-defaults', '/issuer/dashboard/group/default');

  // Route states
  $stateProvider
    // Unsubscribe
    .state('unsub', {
      url: '/unsubscribe',
      templateUrl: '/app/static/analytics_unsub.html',
      title: 'Unsubscribe from Analytics Emails',
    })
    // Error states
    .state('404', {
      url: '/error/404',
      templateUrl: '/app/static/404.html',
      title: 'Page Not Found',
    })
    .state('500', {
      url: '/error/500',
      component: 'embedApp',
      resolve: cloneAssign(v2Resolvers, {
        asFullPageRoute: function () { return true;},
        asRoute: function () { return false; },
        route: function () { return '500'; },
        department: function () { return null; },
        user: function () { return null; },
      }),
      title: 'Page Not Found',
    })
    .state('not-permitted', {
      url: '/error/not-permitted',
      component: 'embedApp',
      title: 'Access Denied',
      resolve: cloneAssign(v2Resolvers, {
        asFullPageRoute: function () { return true;},
        asRoute: function () { return false; },
        route: function () { return 'not-permitted'; },
        resolvedDepartment: ['DepartmentService', function (DepartmentService) {
          return DepartmentService.getDepartment();
        }],
        resolvedUser: ['UserService', function (UserService) {
          return UserService.getUser();
        }],
      }),
    })
    // Message
    .state('message', {
      url: '/message?title&text',
      templateUrl: '/app/static/message/message.html',
      controller: 'MessageRouteController as $ctrl',
    })
    .state('email-verified', {
      url: '/email-verified',
      component: 'embedApp',
      title: 'Email Verified',
      resolve: cloneAssign(v2Resolvers, {
        asFullPageRoute: function () { return true;},
        asRoute: function () { return false; },
        route: function () { return 'email-verified'; },
        department: function () { return null; },
        user: function () { return null; },
      }),
    })
    .state('code-expired', {
      url: '/code-expired',
      component: 'embedApp',
      title: 'Code Expired',
      resolve: cloneAssign(v2Resolvers, {
        asFullPageRoute: function () { return true;},
        asRoute: function () { return false; },
        route: function () { return 'code-expired'; },
        department: function () { return null; },
        user: function () { return null; },
      }),
    })
    // Data Privacy Agreement Redirect
    .state('dpa', {
      url: '/dpa',
      onEnter: ['$window', function ($window) {
        $window.open('https://www.accredible.com/dpa/', '_self');
      }]
    })
    // Data Privacy Agreement - Legacy as of 2019-09-25
    .state('dpa-legacy', {
      url: '/dpa-legacy',
      templateUrl: '/app/static/dpa.html',
      title: 'Data Processing Agreement - Legacy',
    })

    // Verify Email Address
    .state('verify_email', {
      url: '/verify_email?verificationToken',
      templateUrl: '/app/auth/verify_email/verify_email.html',
      controller: 'VerifyEmailRouteCtrl',
      title: 'Verify Email',
    })
    // Verify Email Address - Success? (this is an inbound link, it has no template)
    .state('verify_email_status', {
      url: 'verify_email/:status?verification_token',
      controller: 'VerifyEmailStatusRouteCtrl',
    })

    // Issuer > Common resolved objects
    .state('issuer', {
      template: '<div ui-view style="overflow-x: hidden"></div>',
      resolve: {
        resolvedUser: ['UserService', function (UserService) {
          return UserService.getUser();
        }],
        resolvedOrganization: ['OrganizationService', function (OrganizationService) {
          return OrganizationService.getOrganization();
        }],
        resolvedDepartment: ['DepartmentService', function (DepartmentService) {
          return DepartmentService.getDepartment();
        }],
        resolvedPermissions: ['PermissionsService', function (PermissionsService) {
          return PermissionsService.getPermissions();
        }],
        resolvedFeatures: ['FeaturesService', function (FeaturesService) {
          return FeaturesService.getFeatures();
        }],
        resolvedPricing: ['BillingService', function (BillingService) {
          return BillingService.getPricing();
        }],
        resolvedFlipperFeatures: ['FlipperFeaturesService', 'resolvedOrganization', function (FlipperFeaturesService, resolvedOrganization) {
          return FlipperFeaturesService.getFlipperFeatures(resolvedOrganization.id);
        }],
      },
    })

    // Login with JWT :: JSON Web Tokens :: allows 3rd party authentication / integration
    // Rails Admin
    .state('issuer.jwt_login', {
      url: '/issuer/jwt?jwt&return_to&forward_to_group',
      controller: 'JWTLoginRouteCtrl',
    })
    // Sign out
    .state('issuer.logout', {
      url: '/logout',
      controller: 'LogoutRouteCtrl',
    })

    // Select Department
    .state('issuer.select-department', {
      url: '/issuer/select-department',
      title: 'Select Department',
      component: 'embedApp',
      onEnter:['$state', 'resolvedFlipperFeatures' , function ($state, resolvedFlipperFeatures) {
        if (!resolvedFlipperFeatures.v2_select_department) {
          $state.go('issuer.select-department-old');
        }
      }],
      resolve: cloneAssign(v2Resolvers, {
        asFullPageRoute: function () { return true;},
        asRoute: function () { return false; },
        asFeatureRoute: function () { return true; },
        asSubRoute: function () { return false; },
        route: function () { return 'select-department'; },
        resolvedFlipperFeatures: ['FlipperFeaturesService', 'resolvedOrganization', function (FlipperFeaturesService, resolvedOrganization) {
          return FlipperFeaturesService.getFlipperFeatures(resolvedOrganization.id);
        }],
      }),
    })

    // Select Department - old
    .state('issuer.select-department-old', {
      url: '/issuer/select-department',
      templateUrl: '/app/auth/select-department/select-department-route.html',
      controller: 'SelectDepartmentRouteCtrl as $ctrl',
      resolve: {
        resolvedDepartments: ['DepartmentsService', function (DepartmentsService) {
          return DepartmentsService.getDepartments();
        }],
      },
      title: 'Select Department',
    })

    /** ISSUER :: DEEP LINKS and STATIC PAGES
     *
     *    These inbound routes are arrived via an email link (or similar)
     */

    // New team member set password
    // An email is sent to invited team members, this claims their token and asks them to set a password
    .state('issuer.claim_login', {
      url: '/issuer/claim?token&org_id',
      title: 'Set Password',
      component: 'embedApp',
      onEnter:['$state', '$stateParams', 'resolvedFlipperFeatures' , function ($state, $stateParams, resolvedFlipperFeatures) {
        if (!resolvedFlipperFeatures.v2_team_member_password) {
          $state.go('issuer.claim_login_old', $stateParams);
        }
      }],
      resolve: cloneAssign(v2Resolvers, {
        asFeatureRoute: function () { return true; },
        asFullPageRoute: function () { return true; },
        asRoute: function () { return false; },
        asSubRoute: function () { return false; },
        route: function () { return 'claim'; },
      }),
    })
    // New team member set password - old route
    .state('issuer.claim_login_old', {
      url: '/issuer/claim?token&org_id',
      templateUrl: '/app/auth/claim_login/claim_login.html',
      controller: 'ClaimLoginRouteCtrl',
      title: 'Set Password',
    })
    // Confirm Recipient Name Change Request
    .state('issuer.confirmUserNameChange', {
      url: '/issuer/confirm_name_change',
      templateUrl: '/app/static/issuer_confirm_user_name_change.html',
      title: 'Certificate Name Change',
    })
    // Rejected Recipient Name Change Request
    .state('issuer.rejectUserNameChange', {
      url: '/issuer/reject_name_change',
      templateUrl: '/app/static/issuer_reject_user_name_change.html',
      title: 'Certificate Name Change',
    })
    // Stale Name Change Request
    .state('issuer.staleUserNameChange', {
      url: '/issuer/stale_name_change',
      templateUrl: '/app/static/issuer_stale_user_name_change.html',
      title: 'Certificate Name Change',
    })
    // Unrecognized Issuer Sign In
    .state('issuer.unrecognized_team_member', {
      url: '/issuer/unrecognized_team_member',
      component: 'embedApp',
      resolve: cloneAssign(v2Resolvers, {
        asFullPageRoute: function () { return true;},
        asRoute: function () { return false; },
        route: function () { return 'unrecognized_team_member'; },
      }),
      title: 'Certificate Name Change',
    })
    // Canvas must be installed at app level
    .state('issuer.canvas_account_level', {
      url: '/issuer/canvas_account_level',
      templateUrl: '/app/static/canvas_account_level.html',
      title: 'Install Canvas at the Account Level',
    })

    /** ISSUER :: DASHBOARD :: ABSTRACT
     *
     *    These routes all require:
     *      An authenticated user
     *      ...who has validated their email
     *      ...and has selected an organization to act as
     */

    .state('issuer.dashboard', {
      abstract: true,
      url: '/issuer/dashboard',
      views: {
        '': {
          templateUrl: '/app/_layout/layout.html',
        },
        'nav@issuer.dashboard': {
          templateUrl: '/app/_layout/navbar/navbar.html',
          controller: 'IssuerNavbarCtrl as $ctrl',
        }
      },
      resolve: { // This has to be resolved here as the endpoint requires the issuer to be signed in to a department
        resolvedFlipperFeatures: ['FlipperFeaturesService', 'resolvedOrganization', function (FlipperFeaturesService, resolvedOrganization) {
          return FlipperFeaturesService.getFlipperFeatures(resolvedOrganization.id);
        }],
        resolvedDepartments: ['DepartmentsService', function (DepartmentsService) {
          return DepartmentsService.getDepartments();
        }],
        resolvedGainsightPXIdentify: ['GainsightPXService', function (GainsightPXService) {
          return GainsightPXService.identify();
        }],
      },
      title: 'Dashboard',
    })

    // Home
    .state('issuer.dashboard.home', {
      url: '/',
      title: 'Dashboard',
      component: 'embedApp',
      onEnter:['$state', 'resolvedFlipperFeatures' , function ($state, resolvedFlipperFeatures) {
        if (!resolvedFlipperFeatures.v2_homepage) {
          $state.go('issuer.dashboard.home_old');
        }
      }],
      resolve: cloneAssign(v2Resolvers, {
        asFeatureRoute: function () { return true; },
        asSubRoute: function () { return false; },
        route: function () { return 'issuer/dashboard'; },
      }),
    })

    // Home old
    .state('issuer.dashboard.home_old', {
      url: '/',
      templateUrl: '/app/home/home.html',
      controller: 'HomeCtrl as $ctrl',
      resolve: {
        // This endpoint is used to show widget that tells the user if he needs to create a credential, group or design
        resolvedHasGroupOrDesign: ['api', 'resolvedOrganization', function (api, resolvedOrganization) {
          return api.request('/issuer/organizations/setup_status', { id: resolvedOrganization.id })
            .then(function (response) {
              return response.organization;
            })
            .catch(function () {
              // Fred: Probably this is not the best way of handling this error, but this is needed in order to not have issues of unhandled promise rejection
              return true;
            });
        }],
        resolvedPricing: ['BillingService', function (BillingService) {
          return BillingService.getPricing();
        }]
      },
      title: 'Dashboard',
    })

    // Group
    .state('issuer.dashboard.group', {
      url: '/group/:id',
      abstract: true,
      templateUrl: '/app/groups/group/group.html',
      controller: 'groupNavCtrl as $ctrl',
      onEnter: ['$state', '$stateParams', function ($state, $stateParams) {
        $state.go('issuer.dashboard.group.info-appearance', $stateParams, { location: 'replace' });
      }],
      resolve: {
        resolvedGroup: ['GroupDefaultsService', 'GroupService', '$stateParams', function (GroupDefaultsService, GroupService, $stateParams) {
          if ($stateParams.id == 'new') {
            return GroupDefaultsService.getNewGroupDefaults();
          } else if ($stateParams.id == 'default') {
            return GroupDefaultsService.getDefaults();
          } else {
            return GroupService.fetchGroup($stateParams.id);
          }
        }],
        resolvedEmailTemplates: ['EmailService', function (EmailService) {
          return EmailService.getTemplates();
        }],
        resolvedGroups: ['GroupsService', function (GroupsService) {
          return GroupsService.getGroups();
        }],
        resolvedAttributes: ['attributeService', function (attributeService) {
          return attributeService.getAttributesList();
        }],
      },
    })
    .state('issuer.dashboard.group.edit', {
      url: '/:edit?clone',
      templateProvider: ['$stateParams', '$templateFactory', 'resolvedFlipperFeatures', function ($stateParams, $templateFactory, resolvedFlipperFeatures) {
        var template = $stateParams.edit;
        if ($stateParams.edit === 'credential-letter') {
          // When the v2_credential_letter flag is on, embed the V2 credential-letter
          // editor; otherwise fall back to the legacy V1 transcript-letter template.
          template = resolvedFlipperFeatures.v2_credential_letter ? 'credential-letter' : 'transcript-letter';
        }
        return $templateFactory.fromUrl('/app/groups/group/forms/' + template + '.html');
      }],
      controller: 'groupCtrl as $ctrl',
      onEnter: ['$state', '$stateParams', 'FeaturesService', 'resolvedGroup', 'resolvedFlipperFeatures', function ($state, $stateParams, FeaturesService, resolvedGroup, resolvedFlipperFeatures) {
        if ($stateParams.edit === 'transcript-letter') {
          $state.go('issuer.dashboard.group.edit', {
            id: resolvedGroup.id,
            edit: 'credential-letter'
          });
          return;
        }

        // Check permissions for transcript-letter
        if ($stateParams.edit === 'transcript-letter' &&
          !FeaturesService.getFeature('transcript_letter')) {
          $state.go('404');
        }
      }],
      title: 'Group Settings',
    })

    // TODO(Matt): This can be used when we replace the all v1 group settings with v2
    // .state('issuer.dashboard.group.info-appearance', {
    //   title: 'Group Settings > Info & Appearance',
    //   url: '/info-appearance',
    //   component: 'embedApp',
    //   resolve: cloneAssign(v2Resolvers, {
    //     asRoute: function () {
    //       return false;
    //     },
    //     asSubRoute: function () {
    //       return true;
    //     },
    //     route: ['$stateParams', function ($stateParams) {
    //       return 'group/' + $stateParams.id + '/info-appearance';
    //     }],
    //   }),
    // })

    // Designs
    .state('issuer.dashboard.designs', {
      url: '/designs?page&search&in_use&kind&size&orientation&languages',
      title: 'Designs',
      reloadOnSearch: false,
      component: 'embedApp',
      onEnter:['$state', 'resolvedFlipperFeatures' , function ($state, resolvedFlipperFeatures) {
        if (!resolvedFlipperFeatures.v2_designs_list) {
          $state.go('issuer.dashboard.designs_old');
        }
      }],
      resolve: cloneAssign(v2Resolvers, {
        asFeatureRoute: function () { return true; },
        asSubRoute: function () { return false; },
        route: function () { return 'designs'; },
      }),
    })

    // Badge Designer
    .state('issuer.dashboard.designs.badge', {
      title: 'Badge Designer',
      url: '/badge/:id',
      onEnter: function () {
        waitForEmbedApp('embed-app').then(function(embedApp) {
          embedApp.classList.add('as-full-page-overlay');
        });
      },
      onExit: function () {
        var embedApp = document.querySelector('embed-app');
        embedApp.classList.remove('as-full-page-overlay');
      }
    })

    // Certificate Designer
    .state('issuer.dashboard.designs.certificate', {
      title: 'Certificate Designer',
      url: '/certificate/:id',
      onEnter: function () {
        waitForEmbedApp('embed-app').then(function(embedApp) {
          embedApp.classList.add('as-full-page-overlay');
        });
      },
      onExit: function () {
        var embedApp = document.querySelector('embed-app');
        embedApp.classList.remove('as-full-page-overlay');
      }
    })

    // Designs old
    .state('issuer.dashboard.designs_old', {
      url: '/designs?create',
      templateUrl: '/app/designs/designs.html',
      controller: 'DesignsCtrl as $ctrl',
      title: 'Designs',
    })

    // Email Settings
    .state('issuer.dashboard.email-settings', {
      abstract: true,
      url: '/email-settings',
      templateUrl: '/app/email-settings/email-settings.html',
      controller: 'EmailNavFeatureCtrl as $ctrl',
      resolve: {
        resolvedPermissions: ['PermissionsService', function (PermissionsService) {
          return PermissionsService.getPermissions();
        }],
        resolvedEmailSettings: ['EmailService', 'resolvedPermissions', 'resolvedFlipperFeatures', function (EmailService, resolvedPermissions, resolvedFlipperFeatures) {
          if (!resolvedPermissions.emails && resolvedFlipperFeatures.issuer_hierarchy) {
            return null;
          }
          return EmailService.getSettings();
        }],
        onEnter: ['$state', 'resolvedPermissions', 'resolvedFlipperFeatures', function ($state, resolvedPermissions, resolvedFlipperFeatures) {
          if (!resolvedPermissions.emails && resolvedFlipperFeatures.issuer_hierarchy) {
            $state.go('not-permitted');
            return;
          }
        }],
      },
    })

    // Emails - General Settings
    .state('issuer.dashboard.email-settings.general-settings', {
      url: '/general-settings',
      title: 'Emails - General Settings',
      templateUrl: '/app/email-settings/forms/general-settings-v2-embed.html',
      controller: 'GeneralSettingsV2EmbedCtrl as $ctrl',
      onEnter: ['$state', 'resolvedFlipperFeatures', function ($state, resolvedFlipperFeatures) {
        if (!resolvedFlipperFeatures.v2_emails_general_settings) {
          $state.go('issuer.dashboard.email-settings.general-settings-old');
        }
      }],
    })

    // Emails - General Settings old
    .state('issuer.dashboard.email-settings.general-settings-old', {
      url: '/general-settings',
      templateUrl: '/app/email-settings/forms/general-settings.html',
      controller: 'EmailSettingsCtrl as $ctrl',
      title: 'Emails - General Settings',
    })

    // Emails - Support Contact
    .state('issuer.dashboard.email-settings.support-contact', {
      url: '/support-contact',
      title: 'Emails - Support Contact',
      templateUrl: '/app/email-settings/forms/support-contact-v2-embed.html',
      controller: 'SupportContactV2EmbedCtrl as $ctrl',
      onEnter: ['$state', 'resolvedFlipperFeatures', function ($state, resolvedFlipperFeatures) {
        if (!resolvedFlipperFeatures.v2_emails_support_contact) {
          $state.go('issuer.dashboard.email-settings.support-contact-old');
        }
      }],
    })

    // Emails - Support Contact old
    .state('issuer.dashboard.email-settings.support-contact-old', {
      url: '/support-contact',
      templateUrl: '/app/email-settings/forms/support-contact.html',
      controller: 'EmailSettingsCtrl as $ctrl',
      title: 'Emails - Support Contact',
    })

    // Emails - SMTP Settings
    .state('issuer.dashboard.email-settings.smtp-settings', {
      url: '/smtp-settings',
      title: 'Emails - SMTP Settings',
      templateUrl: '/app/email-settings/smtp-settings/smtp-settings-v2-embed.html',
      controller: 'SmtpSettingsV2EmbedCtrl as $ctrl',
      onEnter: ['$state', 'resolvedFlipperFeatures', function ($state, resolvedFlipperFeatures) {
        if (!resolvedFlipperFeatures.v2_emails_smtp_overrides) {
          $state.go('issuer.dashboard.email-settings.smtp-settings-old');
        }
      }],
    })

    // / Emails - SMTP Settings old
    .state('issuer.dashboard.email-settings.smtp-settings-old', {
      url: '/smtp-settings',
      templateUrl: '/app/email-settings/smtp-settings/smtp-settings.html',
      controller: 'smtpSettingsCtrl as $ctrl',
      resolve: {
        smtpResponse: ['SmtpSettingsService', function (SmtpSettingsService) {
          return SmtpSettingsService.get();
        }]
      },
      title: 'Emails - SMTP Settings',
    })

    // Emails - Email Appearance
    .state('issuer.dashboard.email-settings.email-appearance', {
      url: '/email-appearance',
      title: 'Email Appearance',
      templateUrl: '/app/email-settings/email-appearance/email-appearance-v2-embed.html',
      controller: 'EmailAppearanceV2EmbedCtrl as $ctrl',
      onEnter: ['$state', 'resolvedFlipperFeatures', function ($state, resolvedFlipperFeatures) {
        if (!resolvedFlipperFeatures.v2_emails_legacy_appearance) {
          $state.go('issuer.dashboard.email-settings.email-appearance-old');
        }
      }],
      reloadOnSearch: false,
    })

    .state('issuer.dashboard.email-settings.email-appearance-old', {
      url: '/email-appearance',
      templateUrl: '/app/email-settings/email-appearance/email-appearance.html',
      controller: 'emailAppearanceCtrl as $ctrl',
      resolve: {
        resolvedEmailSettings: ['EmailService', function (EmailService) {
          return EmailService.getSettings();
        }]
      },
      title: 'Emails - Email Appearance',
    })

    // Emails - Email Campaigns
    .state('issuer.dashboard.email-settings.email-campaigns', {
      url: '/email-campaigns',
      controller: 'EmailCampaignsCtrl as $ctrl',
      templateUrl: '/app/email-settings/email-campaigns/email-campaigns.html',
      reloadOnSearch: false,
      title: 'Email Campaigns',
    })
    .state('issuer.dashboard.email-settings.email-campaigns.essential', {
      url: '/essential-campaigns?page&sort_by&name&goals&channel_types&statuses',
      title: 'Essential Email Templates',
    })

    .state('issuer.dashboard.email-settings.email-campaigns.custom', {
      url: '/custom-campaigns?page&sort_by&name&goals&channel_types&statuses',
      title: 'Custom Email Templates',
    })

    .state('issuer.dashboard.email-settings.email-campaigns.email-campaign-create', {
      title: 'Email Campaigns > Create Email Campaign',
      url: '/create?isDuplicating&campaignId',
      onEnter: function () {
        waitForEmbedApp('embed-app').then(function(embedApp) {
          embedApp.classList.add('as-full-page-overlay');
          embedApp.classList.remove('expand-right');
        });
      },
      onExit: function () {
        var embedApp = document.querySelector('embed-app');
        embedApp.classList.remove('as-full-page-overlay');
        embedApp.classList.add('expand-right');
      },
    })

    .state('issuer.dashboard.email-settings.email-campaigns.email-campaign-edit', {
      title: 'Email Campaigns > Edit Email Campaign',
      url: '/:id',
      onEnter: function () {
        waitForEmbedApp('embed-app').then(function(embedApp) {
          embedApp.classList.add('as-full-page-overlay');
          embedApp.classList.remove('expand-right');
        });
      },
      onExit: ['$state', function ($state) {
        // Allow smooth transition from full-page-overlay mode to other v1 routes
        var nextState = $state.transition.to().name;
        if (!nextState.includes('email-campaigns')) {
          return;
        }

        var embedApp = document.querySelector('embed-app');
        embedApp.classList.remove('as-full-page-overlay');
        embedApp.classList.add('expand-right');
      }],
    })

    .state('issuer.dashboard.email-settings.email-campaigns.email-campaign-details', {
      title: 'Email Campaigns > Email Campaign Details',
      url: '/:id/details'
    })
    .state('issuer.dashboard.email-settings.find-campaigns', {
      url: '/find-campaigns',
      controller: 'FindCampaignsCtrl as $ctrl',
      templateUrl: '/app/email-settings/find-campaigns/find-campaigns.html',
      reloadOnSearch: false,
      title: 'Find Campaigns',
    })

    // Emails - New Email Templates
    .state('issuer.dashboard.email-settings.new-email-templates', {
      url: '/new-email-templates',
      controller: 'NewEmailTemplatesCtrl as $ctrl',
      templateUrl: '/app/email-settings/new-email-templates/new-email-templates.html',
      onEnter:['$state', 'resolvedFlipperFeatures' , function ($state, resolvedFlipperFeatures) {
        if (!resolvedFlipperFeatures.v2_template_editor) {
          $state.go('404');
        }
      }],
      reloadOnSearch: false,
      title: 'Email Templates',
    })

    .state('issuer.dashboard.email-settings.new-email-templates.essential', {
      url: '/essential-templates?page&sort_by&name&language&status',
      title: 'Essential Email Templates',
    })

    .state('issuer.dashboard.email-settings.new-email-templates.custom', {
      url: '/custom-templates?page&sort_by&name&language&status',
      title: 'Custom Email Templates',
    })

    .state('issuer.dashboard.email-settings.new-email-templates.essential-template', {
      url: '/essential-template/:id',
      title: 'Essential Email Template',
      onEnter: function () {
        waitForEmbedApp('embed-app').then(function(embedApp) {
          embedApp.classList.add('as-full-page-overlay');
          embedApp.classList.remove('expand-right');
        });
      },
      onExit: function () {
        var embedApp = document.querySelector('embed-app');
        embedApp.classList.remove('as-full-page-overlay');
        embedApp.classList.add('expand-right');
      },
    })

    .state('issuer.dashboard.email-settings.new-email-templates.email-template-create', {
      title: 'Email Templates > Create Email Template',
      url: '/create?isCloning&templateId',
      onEnter: function () {
        waitForEmbedApp('embed-app').then(function(embedApp) {
          embedApp.classList.add('as-full-page-overlay');
          embedApp.classList.remove('expand-right');
        });
      },
      onExit: function () {
        var embedApp = document.querySelector('embed-app');
        embedApp.classList.remove('as-full-page-overlay');
        embedApp.classList.add('expand-right');
      },
    })

    .state('issuer.dashboard.email-settings.new-email-templates.email-template-edit', {
      title: 'Email Templates > Edit Email Template',
      url: '/:id',
      onEnter: function () {
        waitForEmbedApp('embed-app').then(function(embedApp) {
          embedApp.classList.add('as-full-page-overlay');
          embedApp.classList.remove('expand-right');
        });
      },
      onExit: ['$state', function ($state) {
        // Allow smooth transition from full-page-overlay mode to other v1 routes
        var nextState = $state.transition.to().name;
        if (!nextState.includes('new-email-templates')) {
          return;
        }

        var embedApp = document.querySelector('embed-app');
        embedApp.classList.remove('as-full-page-overlay');
        embedApp.classList.add('expand-right');
      }],
    })

   // Emails - Legacy Email Templates
   .state('issuer.dashboard.email-settings.email-templates', {
    url: '/email-templates?language&sort&dir',
    title: 'Email Templates',
    templateUrl: '/app/email-settings/email-templates/email-templates-v2-embed.html',
    controller: 'EmailTemplatesV2EmbedCtrl as $ctrl',
    onEnter: ['$state', 'resolvedFlipperFeatures', function ($state, resolvedFlipperFeatures) {
      if (!resolvedFlipperFeatures.v2_emails_legacy_templates_list) {
        $state.go('issuer.dashboard.email-settings.email-templates-old');
      }
    }],
    reloadOnSearch: false,
  })
    
    .state('issuer.dashboard.email-settings.email-templates-old', {
      url: '/email-templates?language&sort&dir',
      templateUrl: '/app/email-settings/email-templates/email-templates.html',
      controller: 'EmailTemplatesCtrl as $ctrl',
      resolve: {
        resolvedTemplates: ['EmailService', function (EmailService) {
          return EmailService.getTemplates();
        }]
      },
      reloadOnSearch: false,
      title: 'Email Templates',
    })

    // Emails - Legacy Email Template Builder
    // Top-level state (child of issuer.dashboard, NOT email-settings) so its URL is
    // /issuer/dashboard/email-template/:templateIdOrKind. The `route` resolver includes the
    // id/kind so the embedded V2 app loads straight into the editor (/email-template/:id).
    .state('issuer.dashboard.email-template', {
      url: '/email-template/:templateIdOrKind?copy',
      title: 'Email Template',
      component: 'embedApp',
      onEnter: ['$state', '$stateParams', 'resolvedFlipperFeatures', function ($state, $stateParams, resolvedFlipperFeatures) {
        if (!resolvedFlipperFeatures.v2_emails_legacy_templates_editor) {
          $state.go('issuer.dashboard.email-template-old', $stateParams, { location: 'replace' });
        }
      }],
      resolve: cloneAssign(v2Resolvers, {
        asFeatureRoute: function () { return true; },
        asSubRoute: function () { return false; },
        route: ['$stateParams', function ($stateParams) { return 'email-template/' + $stateParams.templateIdOrKind; }],
      }),
    })

    // Emails - Legacy Email Template Builder old
    .state('issuer.dashboard.email-template-old', {
      url: '/email-template/:templateIdOrKind?copy',
      title: 'Email Template',
      templateUrl: '/app/email-settings/email-templates/email-template/email-template.html',
      controller: 'EmailTemplateCtrl as $ctrl',
      resolve: {
        resolvedTemplate: ['EmailService', '$stateParams', function (EmailService, $stateParams) {
          return EmailService.getTemplate($stateParams.templateIdOrKind);
        }],
        resolvedEmailSettings: ['EmailService', function (EmailService) {
          return EmailService.getSettings();
        }]
      },
    })

    // Group Overview
    //   This view exists to be consumed by integrations like Bridge.
    //   It provides a viewer of a Group with quick access to information and links to actions.
    //   This view is intended to be embedded within integrations so is small and links to new windows.
    //   It can't be a child of the group abstract because we need a blank view.
    .state('issuer.dashboard.group-overview', {
      url: '/group/:id/overview',
      views: {
        '@issuer': {
          templateUrl: '/app/group-overview/group-overview.html',
          controller: 'GroupOverviewCtrl as $ctrl',
        }
      },
      resolve: {
        resolvedGroup: ['GroupService', '$stateParams', function (GroupService, $stateParams) {
          if ($stateParams.id == 'new') {
            return {}; // A blank group object
          } else {
            return GroupService.fetchGroup($stateParams.id);
          }
        }]
      },
      title: 'Group Overview',
    })



    // Billing
    .state('issuer.dashboard.billing', {
      abstract: true,
      url: '/billing?migrateFromLegacy',
      templateUrl: '/app/billing/billing.html',
      controller: 'BillingCtrl as $ctrl',
      resolve: {
        resolvedPricing: ['BillingService', function (BillingService) {
          return BillingService.getPricing();
        }],
      },
      onEnter: ['$state', 'resolvedFlipperFeatures', 'PermissionsService', function ($state, resolvedFlipperFeatures, PermissionsService) {
        if (resolvedFlipperFeatures.issuer_hierarchy && !PermissionsService.isOrganizationAdmin()) {
          $state.go('not-permitted');
        }
      }],
      title: 'Billing',
    })
    .state('issuer.dashboard.billing.status', {
      url: '/status',
      title: 'Billing > Status',
      // Takes over the dashboard view so the V1 billing layout (billing.html) is not rendered around the V2 app.
      views: {
        '@issuer.dashboard': {
          component: 'embedApp',
        },
      },
      onEnter: ['$state', 'resolvedFlipperFeatures', function ($state, resolvedFlipperFeatures) {
        if (!resolvedFlipperFeatures.v2_billing_dashboard) {
          $state.go('issuer.dashboard.billing.status_old');
        }
      }],
      resolve: cloneAssign(v2Resolvers, {
        asFeatureRoute: function () { return true; },
        asFullPageRoute: function () { return true; },
        route: function () { return 'billing/status'; },
      }),
    })
    // Billing status old
    .state('issuer.dashboard.billing.status_old', {
      url: '/status',
      templateUrl: '/app/billing/status/status.html',
      controller: 'BillingStatusCtrl as $ctrl',
      resolve: {
        resolvedYearlyReport: ['resolvedDepartment', 'BillingService', function (resolvedDepartment, BillingService) {
          return BillingService.getYearlyReport(resolvedDepartment.id);
        }],
      },
      title: 'Billing > Status',
    })
    .state('issuer.dashboard.billing.purchase', {
      url: '/purchase',
      templateUrl: '/app/billing/purchase/purchase.html',
      controller: 'BillingPurchaseCtrl as $ctrl',
      resolve: {
        resolvedPlansAndAddOns: ['BillingService', function (BillingService) {
          return BillingService.getPlansAndAddOns();
        }],
      },
      onEnter: ['$state', 'resolvedFlipperFeatures', 'resolvedPricing', function ($state, resolvedFlipperFeatures, resolvedPricing) {
        if (resolvedFlipperFeatures.packaging && resolvedPricing.plan !== 'custom') {
          $state.go('issuer.dashboard.billing.checkout', { plan: resolvedPricing.plan }, { location: 'replace' });
        }
      }],
      title: 'Billing > Purchase',
    })
    .state('issuer.dashboard.billing.checkout', {
      url: '/checkout?plan',
      templateUrl: '/app/billing/checkout/checkout.html',
      controller: 'BillingCheckoutCtrl as $ctrl',
      onEnter:['$state', 'resolvedFlipperFeatures', 'resolvedPricing', '$stateParams' , function ($state, resolvedFlipperFeatures, resolvedPricing, $stateParams) {
        if (resolvedPricing.plan === 'custom') {
          $state.go('404');
        }

        if (!resolvedFlipperFeatures.packaging) {
          $state.go('issuer.dashboard.billing.purchase');
        }

        // Add plan query param if missing
        if (!$stateParams.status && !$stateParams.plan && resolvedPricing.plan) {
          $state.go('issuer.dashboard.billing.checkout', { plan: resolvedPricing.plan }, { location: 'replace' });
        }
      }],
      title: 'Billing > Checkout',
    })

    .state('issuer.dashboard.billing.checkout.payment-status', {
      url: '/payment?status&upgrade',
      title: 'Billing > Checkout > Payment Status',
    })

    .state('issuer.dashboard.billing.payment', {
      url: '/payment',
      templateUrl: '/app/billing/payment/payment.html',
      controller: 'BillingPaymentCtrl as $ctrl',
      onEnter:['$state', 'resolvedFlipperFeatures', function ($state, resolvedFlipperFeatures) {
        if (resolvedFlipperFeatures.stripe_billing_page) {
          $state.go('issuer.dashboard.billing.status');
        }
      }],
      title: 'Billing > Payment Method',
    })

    // Invoices
    .state('issuer.dashboard.invoices', {
      url: '/invoices',
      title: 'Invoices',
      component: 'embedApp',
      onEnter: ['$state', 'resolvedFlipperFeatures', function ($state, resolvedFlipperFeatures) {
        if (!resolvedFlipperFeatures.v2_billing_dashboard) {
          $state.go('issuer.dashboard.invoices_old');
        }
      }],
      resolve: cloneAssign(v2Resolvers, {
        asFeatureRoute: function () { return true; },
        asFullPageRoute: function () { return true; },
        route: function () { return 'billing/invoices'; },
      }),
    })

    // Invoices old
    .state('issuer.dashboard.invoices_old', {
      url: '/invoices',
      templateUrl: '/app/invoices/invoices.html',
      controller: 'InvoicesCtrl as $ctrl',
      resolve: {
        resolvedInvoicesAndPlan: ['BillingService', function (BillingService) {
          return BillingService.getInvoicesAndPlan();
        }]
      },
      title: 'Invoices',
    })

    // Contracts
    .state('issuer.dashboard.contracts', {
      url: '/contracts',
      title: 'Contracts',
      component: 'embedApp',
      onEnter: ['$state', 'resolvedFlipperFeatures', function ($state, resolvedFlipperFeatures) {
        if (!resolvedFlipperFeatures.v2_billing_dashboard) {
          $state.go('issuer.dashboard.contracts_old');
        }
      }],
      resolve: cloneAssign(v2Resolvers, {
        asFeatureRoute: function () { return true; },
        asFullPageRoute: function () { return true; },
        route: function () { return 'billing/contracts'; },
      }),
    })
    .state('issuer.dashboard.contract', {
      url: '/contract/:id',
      title: 'Contract',
      component: 'embedApp',
      onEnter: ['$state', '$stateParams', 'resolvedFlipperFeatures', function ($state, $stateParams, resolvedFlipperFeatures) {
        if (!resolvedFlipperFeatures.v2_billing_dashboard) {
          $state.go('issuer.dashboard.contract_old', $stateParams);
        }
      }],
      resolve: cloneAssign(v2Resolvers, {
        asFeatureRoute: function () { return true; },
        asFullPageRoute: function () { return true; },
        route: ['$stateParams', function ($stateParams) { return 'billing/contract/' + $stateParams.id; }],
      }),
    })

    // Contracts old
    .state('issuer.dashboard.contracts_old', {
      url: '/contracts',
      templateUrl: '/app/contracts/contracts.html',
      controller: 'contractsCtrl as $ctrl',
      resolve: {
        resolvedContracts: ['ContractsService', function (ContractsService) {
          return ContractsService.getContracts();
        }]
      },
      title: 'Contracts',
    })
    .state('issuer.dashboard.contract_old', {
      url: '/contract/:id',
      templateUrl: '/app/contracts/contract/contract.html',
      controller: 'contractCtrl as $ctrl',
      resolve: {
        resolvedContract: ['$stateParams', 'ContractsService', function ($stateParams, ContractsService) {
          return ContractsService.getContract(parseInt($stateParams.id));
        }]
      },
      title: 'Contract',
    })

    // Attributes
    .state('issuer.dashboard.attributes', {
      url: '/attributes',
      title: 'Attributes',
      component: 'embedApp',
      onEnter:['$state', 'resolvedFlipperFeatures' , function ($state, resolvedFlipperFeatures) {
        if (!resolvedFlipperFeatures.v2_attributes) {
          $state.go('issuer.dashboard.attributes_old');
        }
      }],
      resolve: cloneAssign(v2Resolvers, {
        asFeatureRoute: function () { return true; },
        asSubRoute: function () { return false; },
        route: function () { return 'attributes'; },
      }),
    })

    // Attributes old
    .state('issuer.dashboard.attributes_old', {
      url: '/attributes',
      templateUrl: '/app/attributes/attributes.html',
      controller: 'AttributesCtrl',
      title: 'Attributes',
    })

    // Departments overview
    .state('issuer.dashboard.departments', {
      url: '/departments',
      title: 'Departments Overview',
      component: 'embedApp',
      onEnter:['$state', 'resolvedFlipperFeatures' , function ($state, resolvedFlipperFeatures) {
        if (!resolvedFlipperFeatures.v2_departments_overview) {
          $state.go('issuer.dashboard.departments-old');
        }
      }],
      resolve: cloneAssign(v2Resolvers, {
        asFeatureRoute: function () { return true; },
        asSubRoute: function () { return false; },
        route: function () { return 'departments'; },
      }),
    })


    // Departments overview old
    .state('issuer.dashboard.departments-old', {
      url: '/departments',
      templateUrl: '/app/departments/departments.html',
      controller: 'organizationDepartmentsCtrl as $ctrl',
      title: 'Departments Overview',
    })

    // Edit/Add Department (today it's only used to add a new department)
    .state('issuer.dashboard.departments-old.department', {
      url: '/departments/:id',
      templateUrl: '/app/departments/department/department.html',
      controller: 'OrganizationDepartmentCtrl as $ctrl',
      resolve: {
        resolvedDepartment: ['$stateParams', 'DepartmentsService', function ($stateParams, DepartmentsService) {
          return DepartmentsService.getDepartment($stateParams.id);
        }],
      },
      title: 'Manage Department',
    })

    // My Account - User information and update
    .state('issuer.dashboard.my_account', {
      url: '/my-account',
      title: 'Your Account',
      component: 'embedApp',
      onEnter:['$state', 'resolvedFlipperFeatures' , function ($state, resolvedFlipperFeatures) {
        if (!resolvedFlipperFeatures.v2_my_account) {
          $state.go('issuer.dashboard.my_account_old');
        }
      }],
      resolve: cloneAssign(v2Resolvers, {
        asFeatureRoute: function () { return true; },
        asSubRoute: function () { return false; },
        route: function () { return 'my-account'; },
      }),
    })

    // My Account - old
    .state('issuer.dashboard.my_account_old', {
      url: '/my-account',
      templateUrl: '/app/my-account/my-account.html',
      controller: 'MyAccountRouteCtrl as $ctrl',
      title: 'Your Account',
    })

    // Quickstart
    .state('issuer.dashboard.quickstart', {
      url: '/quickstart',
      templateUrl: '/app/quickstart/quickstart.html',
      controller: 'QuickstartCtrl as $ctrl',
      title: 'Quickstart',
    })

    // GROUP > Legacy Routes (they MAY be used on external links)
    .state('issuer.dashboard.group.certificate_design', {
      url: '/certificate_design',
      redirectTo: 'issuer.dashboard.group.edit',
    })
    .state('issuer.dashboard.group.badge_design', {
      url: '/badge_design',
      redirectTo: 'issuer.dashboard.group.edit',
    })
    .state('issuer.dashboard.group.blockchain', {
      url: '/blockchain',
      redirectTo: 'issuer.dashboard.group.edit',
    })
    .state('issuer.dashboard.group.email_templates', {
      url: '/email_templates',
      redirectTo: 'issuer.dashboard.group.edit',
    })

    // V2 Embed routes ----------------------------------------

    // Error states
    .state('verify-email-error', {
      title: 'Verify Email Error',
      url: '/verify_email/error',
      component: 'embedApp',
      resolve: cloneAssign(v2SignInResolvers, {
        route: function () {
          return '/user/verify-email-error';
        },
      }),
    })

    // Login and Sign up
    // (Joao): Not changing 'issuer.login' name because of compatibility reasons
    .state('issuer.login', {
      title: 'User',
      url: '/user',
      component: 'embedApp',
      resolve: cloneAssign(v2SignInResolvers, {
        // asFeatureRoute will enable the route 'user' as the starting point for the navigation in v2
        asFeatureRoute: function () {
          return true;
        },
        route: function () {
          return 'user';
        },
      })
    })
    .state('issuer.login.sign-up', {
      title: 'Sign Up',
      url: '/sign-up',
    })
    .state('issuer.login.internal-sign-up', {
      title: 'Sign Up',
      url: '/internal-sign-up-9627156',
    })
    // Forgot Password
    .state('issuer.login.forgot-password', {
      title: 'Forgot Password',
      url: '/forgot-password',
    })
    // Reset Password
    .state('issuer.login.reset-password', {
      title: 'Reset Password',
      url: '/reset-password/:token',
    })
    // Locked Account
    .state('issuer.login.locked-account', {
      title: 'Locked Account',
      url: '/locked-account',
    })
    // MFA sign in
    .state('issuer.login.mfa-sign-in', {
      title: 'MFA Sign In',
      url: '/mfa-sign-in',
    })
    // MFA lost device
    .state('issuer.login.mfa-lost-device', {
      title: 'MFA Lost device',
      url: '/mfa-lost-device',
    })

    // MFA setup
    .state('issuer.mfa', {
      title: 'User',
      url: '/user',
      component: 'embedApp',
      resolve: cloneAssign(v2Resolvers, {
        asRoute: function () {
          return false;
        },
        asFeatureRoute: function () {
          return true;
        },
        asFullPageRoute: function () {
          return true;
        },
        route: function () {
          return 'user';
        },
      }),
    })
    .state('issuer.mfa.mfa-setup', {
      title: 'MFA Setup',
      url: '/mfa-setup',
    })
    .state('issuer.mfa.mfa-configure', {
      title: 'MFA Configure',
      url: '/mfa-configure',
    })

    // Verification
    .state('issuer.dashboard.verification', {
      title: 'Verification',
      url: '/verification',
      component: 'embedApp',
      resolve: cloneAssign(v2Resolvers, {
        route: function () { return 'verification'; },
      }),
    })

    // Team Members
    .state('issuer.dashboard.team-members', {
      title: 'Team Members',
      url: '/team-members',
      component: 'embedApp',
      resolve: cloneAssign(v2Resolvers, {
        // asFeatureRoute will enable the route 'team-members' as the starting point for the navigation in v2
        asFeatureRoute: function () {
          return true;
        },
        asSubRoute: function () {
          return false;
        },
        route: function () { return 'team-members'; },
      }),
    })
    .state('issuer.dashboard.team-members.add', {
      title: 'Team Members > Add Team Member',
      url: '/add'
    })
    .state('issuer.dashboard.team-members.edit', {
      title: 'Team Members > Edit Team Member',
      url: '/:id'
    })

    // Analytics
    .state('issuer.dashboard.analytics', {
      title: 'Analytics',
      url: '/insights',
      component: 'embedApp',
      resolve: cloneAssign(v2Resolvers, {
        asFeatureRoute: function () {
          return true;
        },
        asFullPageRoute: function () { return true; },
        route: function () {
          return 'insights';
        },
        resolvedGroup: ['GroupService', '$stateParams', function (GroupService, $stateParams) {
          var filters;
          if ($stateParams.filters) {
            try {
              filters = angular.fromJson(decodeURIComponent($stateParams.filters));
            }
            catch(err) {
              filters = {};
            }
          } else {
            filters = {};
          }
          return filters.group_id ? GroupService.fetchGroup(filters.group_id) : null;
        }],
      }),
    })
    .state('issuer.dashboard.analytics.overview', {
      title: 'Analytics > Overview',
      url: '/overview',
    })
    .state('issuer.dashboard.analytics.influencers', {
      title: 'Analytics > Influencers',
      url: '/marketing/influencers?start_date&end_date&group_ids&page_size&page&sort_column&sort_order&channels&influencer_name&group_collection_id',
    })
    .state('issuer.dashboard.analytics.recipient-activity', {
      title: 'Analytics > Recipient activity',
      url: '/recipient-activity?start_date&end_date&group_ids&page_size&page&grouping&group_collection_id',
    })
    .state('issuer.dashboard.analytics.recipient-activity-print', {
      title: 'Analytics > Recipient activity',
      url: '/recipient-activity/print?start_date&end_date&group_ids&page_size&page&grouping&group_collection_id',
    })
    .state('issuer.dashboard.analytics.recipient-engagement', {
      title: 'Analytics > Engagement',
      url: '/engagement?start_date&end_date&group_ids&group_collection_id',
    })
    .state('issuer.dashboard.analytics.recipient-engagement-print', {
      title: 'Analytics > Engagement',
      url: '/engagement/print?start_date&end_date&group_ids&group_collection_id',
    })
    .state('issuer.dashboard.analytics.spotlight-directories', {
      title: 'Analytics > Spotlight Directories',
      url: '/spotlight-directories?start_date&end_date&directoryId&page&grouping',
    })
    .state('issuer.dashboard.analytics.recipient-careers', {
      title: 'Analytics > Recipient Careers',
      url: '/recipient-careers?group_ids&collection_ids',
    })
    .state('issuer.dashboard.analytics.skill-frameworks', {
      title: 'Analytics > Skill Frameworks',
      url: '/skill-frameworks',
    })
    .state('issuer.dashboard.analytics.earner-outcomes', {
      title: 'Analytics > Earner Outcomes',
      url: '/earner-outcomes?group_ids&group_collection_ids',
    })
    .state('issuer.dashboard.analytics.recommendations', {
      title: 'Analytics > Recommendations',
      url: '/recommendations?start_date&end_date&location',
    })
    .state('issuer.dashboard.analytics.market-reach', {
      title: 'Analytics > Marketing',
      url: '/marketing?start_date&end_date&group_ids&group_collection_id',
    })
    .state('issuer.dashboard.analytics.market-reach-print', {
      title: 'Analytics > Marketing',
      url: '/marketing/print?start_date&end_date&group_ids&group_collection_id',
    })
    .state('issuer.dashboard.analytics.logs', {
      title: 'Analytics > Logs',
      url: '/logs?start_date&end_date&group_ids&page&group_collection_id',
    })
    .state('issuer.dashboard.analytics.audit-logs', {
      title: 'Analytics > Audit Logs',
      url: '/audit-logs?start_date&end_date&audit_type&audit_id',
    })
    .state('issuer.dashboard.analytics.pathways', {
      title: 'Analytics > Pathways',
      url: '/pathways?pathwayId&versionId&name&sequenceId&type&pathwayVersionId',
    })
    .state('issuer.dashboard.analytics.email-campaigns', {
      title: 'Analytics > Email Campaigns',
      url: '/email-campaigns?start_date&end_date',
    })
    .state('issuer.dashboard.analytics.departments-usage', {
      title: 'Analytics > Departments Usage',
      url: '/departments',
    })
    .state('issuer.dashboard.analytics.referral-calculator', {
      url: '/marketing/referral-calculator',
      title: 'Analytics > Referral Calculator',
    })

    // Credentials
    .state('issuer.dashboard.credentials', {
      title: 'Credentials List',
      url: '/credentials?job_id', // add queryParams if needed
      reloadOnSearch: false,
      component: 'embedApp',
      resolve: cloneAssign(v2Resolvers, {
        // asFeatureRoute will enable the route 'credentials' as the starting point for the navigation in v2
        asFeatureRoute: function () {
          return true;
        },
        asSubRoute: function () {
          return false;
        },
        route: function () {
          return 'credentials';
        },
      }),
    })
    .state('issuer.dashboard.credentials.view', {
      title: 'Credential View',
      url: '/:id',
    })
    .state('issuer.dashboard.credentials.name-change-request', {
      title: 'Name Change Requests',
      url: '/name-change-requests',
    })

    // Create credential via form
    .state('issuer.dashboard.credentials.create-credentials-form-v2-fill', {
      title: 'Create Credentials via form',
      url: '/create-via-form/fill?groupId',
    })
    .state('issuer.dashboard.credentials.create-credentials-form-v2-summary', {
      title: 'Create Credentials via form',
      url: '/create-via-form/summary?groupId',
    })

    // Create credentials single group
    .state('issuer.dashboard.credentials.create-single-group-upload', {
      title: 'Create Credentials Single Group Upload',
      url: '/create/single-group/upload?groupId',
    })
    .state('issuer.dashboard.credentials.create-single-group-assign', {
      title: 'Create Credentials Single Group Assign',
      url: '/create/single-group/assign?groupId',
    })
    .state('issuer.dashboard.credentials.create-single-group-validate', {
      title: 'Create Credentials Single Group Validate',
      url: '/create/single-group/validate?groupId',
    })
    .state('issuer.dashboard.credentials.create-single-group-create', {
      title: 'Create Credentials Single Group Create',
      url: '/create/single-group/create?groupId',
    })
    .state('issuer.dashboard.credentials.create-single-group-summary', {
      title: 'Create Credentials Single Group Summary',
      url: '/create/single-group/summary',
    })

    // Update credentials single group
    .state('issuer.dashboard.credentials.update-single-group-upload', {
      title: 'Update Credentials Single Group Upload',
      url: '/update/single-group/upload?groupId',
    })
    .state('issuer.dashboard.credentials.update-single-group-assign', {
      title: 'Update Credentials Single Group Assign',
      url: '/update/single-group/assign?groupId',
    })
    .state('issuer.dashboard.credentials.update-single-group-validate', {
      title: 'Update Credentials Single Group Validate',
      url: '/update/single-group/validate?groupId',
    })
    .state('issuer.dashboard.credentials.update-single-group-create', {
      title: 'Update Credentials Single Group Create',
      url: '/update/single-group/create?groupId',
    })
    .state('issuer.dashboard.credentials.update-single-group-summary', {
      title: 'Update Credentials Single Group Summary',
      url: '/update/single-group/summary',
    })

    // Create credentials multiple groups
    .state('issuer.dashboard.credentials.create-multiple-groups-upload', {
      title: 'Create Credentials Multiple Groups Upload',
      url: '/create/multiple-groups/upload',
    })
    .state('issuer.dashboard.credentials.create-multiple-groups-assign', {
      title: 'Create Credentials Multiple Groups Assign',
      url: '/create/multiple-groups/assign',
    })
    .state('issuer.dashboard.credentials.create-multiple-groups-validate', {
      title: 'Create Credentials Multiple Groups Validate',
      url: '/create/multiple-groups/validate',
    })
    .state('issuer.dashboard.credentials.create-multiple-groups-create', {
      title: 'Create Credentials Multiple Groups Create',
      url: '/create/multiple-groups/create',
    })
    .state('issuer.dashboard.credentials.create-multiple-groups-summary', {
      title: 'Create Credentials Multiple Groups Summary',
      url: '/create/multiple-groups/summary',
    })

    // Update credentials multiple groups
    .state('issuer.dashboard.credentials.update-multiple-groups-upload', {
      title: 'Update Credentials Multiple Groups Upload',
      url: '/update/multiple-groups/upload',
    })
    .state('issuer.dashboard.credentials.update-multiple-groups-assign', {
      title: 'Update Credentials Multiple Groups Assign',
      url: '/update/multiple-groups/assign',
    })
    .state('issuer.dashboard.credentials.update-multiple-groups-validate', {
      title: 'Update Credentials Multiple Groups Validate',
      url: '/update/multiple-groups/validate',
    })
    .state('issuer.dashboard.credentials.update-multiple-groups-create', {
      title: 'Update Credentials Multiple Groups Create',
      url: '/update/multiple-groups/create',
    })
    .state('issuer.dashboard.credentials.update-multiple-groups-summary', {
      title: 'Update Credentials Multiple Groups Summary',
      url: '/update/multiple-groups/summary',
    })

    // Department settings
    .state('issuer.dashboard.department', {
      title: 'Department Settings > Recipients Experience',
      url: '/department',
      component: 'embedApp',
      resolve: cloneAssign(v2Resolvers, {
        // asFeatureRoute will enable the route 'department' as the starting point for the navigation in v2
        asFeatureRoute: function () {
          return true;
        },
        asFullPageRoute: function () { return true; },
        route: function () {
          return 'department';
        },
      }),
    })
    .state('issuer.dashboard.department.general-settings', {
      title: 'Department Settings > General Settings',
      url: '/general-settings'
    })
    .state('issuer.dashboard.department.branding-settings', {
      title: 'Department Settings > Branding Settings',
      url: '/branding-settings'
    })
    .state('issuer.dashboard.department.recipients-experience', {
      title: 'Department Settings > Recipients Experience',
      url: '/recipients-experience',
    })
    .state('issuer.dashboard.department.recipient-support', {
      title: 'Department Settings > Recipient Support',
      url: '/recipient-support',
    })
    .state('issuer.dashboard.department.market-my-courses', {
      title: 'Department Settings > Market My Courses',
      url: '/market-my-courses',
    })
    .state('issuer.dashboard.department.security', {
      title: 'Department Settings > Security',
      url: '/security',
    })
    .state('issuer.dashboard.department.api-settings', {
      title: 'Department Settings > API Settings',
      url: '/api-settings',
    })
    .state('issuer.dashboard.department.api-settings.api-key', {
      title: 'Department Settings > API Settings > API Key',
      url: '/:id'
    })
    .state('issuer.dashboard.department.api-settings.create', {
      title: 'Department Settings > API Settings > Add API Key',
      url: '/create'
    })

    // Department Skills Configuration
    .state('issuer.dashboard.department.skills-configuration', {
      title: 'Department Settings > Skills Configuration',
      url: '/skills-configuration'
    })
    .state('issuer.dashboard.department.skills-configuration.view-framework', {
      title: 'Department Settings > Skills Configuration > Framework Details',
      url: '/framework/:id?versionId'
    })

    // Department Skills Configuration - Add External Framework
    .state('issuer.dashboard.department.skills-configuration.add-external-framework', {
      title: 'Department Settings > Skills Configuration > Add External Framework',
      url: '/add-external-framework',
    })
    .state('issuer.dashboard.department.skills-configuration.add-external-framework.selection', {
      title: 'Department Settings > Skills Configuration > Add External Framework > Selection',
      url: '/selection'
    })
    .state('issuer.dashboard.department.skills-configuration.add-external-framework.preview', {
      title: 'Department Settings > Skills Configuration > Add External Framework > Preview',
      url: '/preview'
    })
    .state('issuer.dashboard.department.skills-configuration.add-external-framework.confirm', {
      title: 'Department Settings > Skills Configuration > Add External Framework > Confirm',
      url: '/confirm'
    })

    // Department Skills Configuration - Add Custom Framework
    .state('issuer.dashboard.department.skills-configuration.add-custom-framework', {
      title: 'Department Settings > Skills Configuration > Add Custom Framework',
      url: '/add-custom-framework?skillFrameworkId&versionId',
    })

    // Department Skills Configuration - Update Custom Framework
    .state('issuer.dashboard.department.skills-configuration.update-custom-framework', {
      title: 'Department Settings > Skills Configuration > Update Custom Framework',
      url: '/framework/:id/update-custom?versionId'
    })

    // Department Skills Configuration - Apply Framework Update
    .state('issuer.dashboard.department.skills-configuration.apply-update', {
      title: 'Department Settings > Skills Configuration > Apply Update',
      url: '/apply-update?skillFrameworkId',
    })
    .state('issuer.dashboard.department.skills-configuration.apply-update.updated-framework', {
      title: 'Department Settings > Skills Configuration > Apply Update > Updated Framework',
      url: '/updated-framework'
    })
    .state('issuer.dashboard.department.skills-configuration.apply-update.impact', {
      title: 'Department Settings > Skills Configuration > Apply Update > Impact & Publish',
      url: '/impact'
    })

    // Department Skills Configuration - Migrate Framework
    .state('issuer.dashboard.department.skills-configuration.migrate', {
      title: 'Department Settings > Skills Configuration > Migrate',
      url: '/migrate'
    })
    .state('issuer.dashboard.department.skills-configuration.migrate.select-framework', {
      title: 'Department Settings > Skills Configuration > Migrate > Select Framework',
      url: '/select-framework'
    })
    .state('issuer.dashboard.department.skills-configuration.migrate.select-groups', {
      title: 'Department Settings > Skills Configuration > Migrate > Select Groups',
      url: '/select-groups'
    })
    .state('issuer.dashboard.department.skills-configuration.migrate.assign-skills', {
      title: 'Department Settings > Skills Configuration > Migrate > Assign Skills',
      url: '/:id/assign-skills'
    })
    .state('issuer.dashboard.department.skills-configuration.migrate.confirm', {
      title: 'Department Settings > Skills Configuration > Migrate > Confirm',
      url: '/:id/confirm'
    })

    // Department Recipient Directory
    .state('issuer.dashboard.department.recipient-directory', {
      title: 'Department Settings > Recipient Directory',
      url: '/recipient-directory?edit',
      params: {
        edit: { value: 'general-settings' },
      },
      onEnter: ['$state', '$transition$', 'resolvedFlipperFeatures', function ($state, $transition$, resolvedFlipperFeatures) {
        if (!resolvedFlipperFeatures.v2_verification_directory) {
          $state.go('issuer.dashboard.recipient-directory-old', { edit: $transition$.params().edit });
        }
      }],
    })

    // Department Recipient Directory old
    .state('issuer.dashboard.recipient-directory-old', {
      url: '/department/recipient-directory?edit',
      params: {
        edit: { value: 'general-settings' },
      },
      templateProvider: ['$stateParams', '$templateFactory', function ($stateParams, $templateFactory) {
        return $templateFactory.fromUrl('/app/department/recipient-directory/forms/' + $stateParams.edit + '.html');
      }],
      controller: 'RecipientDirectoryCtrl',
      resolve: {
        resolvedSettings: ['api', function (api) {
          return api.request('/verification-directory/get_settings')
            .then(function (response) {
              return response.verification_directory;
            });
        }],
        resolvedGroups: ['GroupsService', function (GroupsService) {
          return GroupsService.getGroups();
        }],
      },
      onEnter: ['$state', '$transition$', 'resolvedFlipperFeatures', function ($state, $transition$, resolvedFlipperFeatures) {
        if (resolvedFlipperFeatures.v2_verification_directory) {
          $state.go('issuer.dashboard.department.recipient-directory', { edit: $transition$.params().edit });
        }
      }],
      title: 'Recipient Directory',
    })

    // Integrations
    .state('issuer.dashboard.integrations', {
      title: 'Integrations',
      url: '/integrations',
      component: 'embedApp',
      resolve: cloneAssign(v2IntegrationsResolvers, {
        asFeatureRoute: function () {
          return true;
        },
        asSubRoute: function () {
          return false;
        },
        route: function () { return 'integrations'; },
      }),
    })

    // Integration details
    .state('issuer.dashboard.integrations.integration', {
      title: 'Integrations > Integration Details',
      url: '/details/:kind',
    })

    // Skilljar Integration
    .state('issuer.dashboard.integrations.skilljar', {
      title: 'Skilljar Integration',
      url: '/skilljar',
    })

    // Skilljar Integration > Account Configuration
    .state('issuer.dashboard.integrations.skilljar.account-configuration', {
      title: 'Skilljar Integration > Account Configuration',
      url: '/account-configuration',
    })

    // Skilljar Integration > Credential Issuance
    .state('issuer.dashboard.integrations.skilljar.credential-issuance', {
      title: 'Skilljar Integration > Credential Issuance',
      url: '/credential-issuance?domain&page&sort_by&search',
    })

    // BenchPrep Integration > Credential Issuance
    .state('issuer.dashboard.integrations.benchprep-credential-issuance', {
      title: 'BenchPrep Integration > Credential Issuance',
      url: '/benchprep/credential-issuance/:id?page&sort_by&search',
    })

    // Zoom Credential Issuance
    .state('issuer.dashboard.zoom-credential-issuance', {
      title: 'Zoom Credential Issuance',
      url: '/integrations/zoom/credential-issuance?eventType&hostId&page&pageToken',
      reloadOnSearch: false,
      component: 'embedApp',
      resolve: cloneAssign(v2IntegrationsResolvers, {
        asFeatureRoute: function () {
          return true;
        },
        asSubRoute: function () {
          return true;
        },
        queryParams: [
          'zoomIssuanceParams', function(zoomIssuanceParams) {
            return zoomIssuanceParams;
          }
        ],
        route: function () { return 'integrations'; },
      }),
    })

    .state('issuer.dashboard.zoom-credential-issuance.select-host', {
      title: 'Zoom Credential Issuance > Select Host',
      url: '/select-host',
    })

    // Zoom Credential Issuance > Manage Credential Issuance
    .state('issuer.dashboard.zoom-credential-issuance.manage', {
      title: 'Zoom Credential Issuance > Manage Credential Issuance',
      url: '/:id',
    })

    // Integrations Blackboard - this route loads v2 inside of Blackboard Learn
    .state('issuer.blackboard-lti', {
      url: '/integrations/blackboard/lti?code&state&error&details&message&resource_link_id',
      component: 'embedApp',
      resolve: cloneAssign(v2IntegrationsResolvers, {
        asRoute: function () { return false; },
        asFullPageRoute: function () { return true; },
        queryParams: [
          'ltiStateParams', function (ltiStateParams) {
            return ltiStateParams;
          }
        ],
        route: function () { return 'integrations/blackboard/lti'; }
      }),
    })

    // Integrations Canvas/Course Settings - this route loads v2 inside of Canvas
    .state('issuer.canvas-lti', {
      url: '/integrations/canvas/lti?code&state&error&details&message',
      component: 'embedApp',
      resolve: cloneAssign(v2IntegrationsResolvers, {
        asRoute: function () { return false; },
        asFullPageRoute: function () { return true; },
        queryParams: [
          'ltiStateParams', function(ltiStateParams) {
            return ltiStateParams;
          }
        ],
        route: function () { return 'integrations/canvas/lti/course-settings'; },
      }),
    })

    // Integrations Canvas/Admin Settings - this route loads v2 inside of Canvas
    .state('issuer.canvas-lti-admin', {
      url: '/integrations/canvas/lti/admin-settings?state&error&details&message',
      component: 'embedApp',
      resolve: cloneAssign(v2IntegrationsResolvers, {
        asRoute: function () { return false; },
        asFullPageRoute: function () { return true; },
        queryParams: [
          'ltiStateParams', function(ltiStateParams) {
            return ltiStateParams;
          }
        ],
        route: function() { return 'integrations/canvas/lti/admin-settings'; },
      }),
    })

    // Integrations Canvas/Admin Settings/Oauth Redirect - this route loads v2 inside of Canvas
    .state('issuer.canvas-lti-oauth-redirect', {
      url: '/integrations/canvas/lti/admin-settings/oauth-redirect?code&state&error&details&message',
      component: 'embedApp',
      resolve: cloneAssign(v2IntegrationsResolvers, {
        asRoute: function () { return false; },
        asFullPageRoute: function () { return true; },
        queryParams: [
          'ltiStateParams', function(ltiStateParams) {
            return ltiStateParams;
          }
        ],
        route: function() { return 'integrations/canvas/lti/admin-settings/oauth-redirect'; },
      }),
    })

    // Integrations LTI 1.3/Tool Settings
    .state('issuer.lti-v1p3', {
      url: '/integrations/:kind/lti?code&state&error&lti_tool_setting_id&details&message',
      component: 'embedApp',
      resolve: cloneAssign(v2IntegrationsResolvers, {
        asRoute: function () { return false; },
        asFullPageRoute: function () { return true; },
        queryParams: [
          'ltiStateParams', function(ltiStateParams) {
            return ltiStateParams;
          }
        ],
        route: ['$stateParams', function ($stateParams) {
          return 'integrations/'+ $stateParams.kind +'/lti/tool-settings';
        }],
      }),
    })

    // Integrations LTI 1.3 OAuth2 Callback
    .state('issuer.lti-v1p3-oauth2-callback', {
      url: '/integrations/:kind/lti/oauth2-callback?code&state&error&error_description',
      component: 'embedApp',
      resolve: cloneAssign(v2IntegrationsResolvers, {
        asRoute: function () { return false; },
        asFullPageRoute: function () { return true; },
        queryParams: [
          'ltiStateParams', function(ltiStateParams) {
            return ltiStateParams;
          }
        ],
        route: ['$stateParams', function ($stateParams) {
          return 'integrations/'+ $stateParams.kind +'/lti/oauth2-callback';
        }],
      }),
    })

    // Global Settings
    .state('issuer.dashboard.global-settings', {
      url: '/global-settings',
      title: 'Global Settings',
      component: 'embedApp',
      resolve: cloneAssign(v2Resolvers, {
        asFeatureRoute: function () { return true; },
        asSubRoute: function () { return true; },
        route: function () { return 'global-settings'; },
      }),
    })

    // Global Settings - Skills Configuration
    .state('issuer.dashboard.global-settings.skills-configuration', {
      title: 'Global Settings > Skills Configuration',
      url: '/skills-configuration'
    })
    .state('issuer.dashboard.global-settings.skills-configuration.view-framework', {
      title: 'Global Settings > Skills Configuration > Framework Details',
      url: '/framework/:id?versionId'
    })

    // Global Settings - Add External Framework
    .state('issuer.dashboard.global-settings.skills-configuration.add-external-framework', {
      title: 'Global Settings > Skills Configuration > Add External Framework',
      url: '/add-external-framework',
    })
    .state('issuer.dashboard.global-settings.skills-configuration.add-external-framework.selection', {
      title: 'Global Settings > Skills Configuration > Add External Framework > Selection',
      url: '/selection'
    })
    .state('issuer.dashboard.global-settings.skills-configuration.add-external-framework.preview', {
      title: 'Global Settings > Skills Configuration > Add External Framework > Preview',
      url: '/preview'
    })
    .state('issuer.dashboard.global-settings.skills-configuration.add-external-framework.confirm', {
      title: 'Global Settings > Skills Configuration > Add External Framework > Confirm',
      url: '/confirm'
    })

    // Global Settings - Add Custom Framework
    .state('issuer.dashboard.global-settings.skills-configuration.add-custom-framework', {
      title: 'Global Settings > Skills Configuration > Add Custom Framework',
      url: '/add-custom-framework?skillFrameworkId&versionId',
    })

    // Global Settings - Update Custom Framework
    .state('issuer.dashboard.global-settings.skills-configuration.update-global-custom-framework', {
      title: 'Global Settings > Skills Configuration > Update Custom Framework',
      url: '/framework/:id/update-custom?versionId'
    })

    // Pathways
    .state('issuer.dashboard.pathways', {
      url: '/pathways',
      component: 'embedApp',
      resolve: cloneAssign(v2Resolvers, {
        asFeatureRoute: function () {
          return true;
        },
        asFullPageRoute: function () { return true; },
        route: function () { return 'pathways'; },
      }),
      title: 'Pathways',
    })

    .state('issuer.dashboard.pathways.track-list', {
      url: '/track-list?name&page&publish_status',
      title: 'Pathway Tracks',
    })

    // Pathway
    .state('issuer.dashboard.pathways.pathway', {
      title: 'Pathways > Pathway',
      url: '/create?isCloning&pathwayUuid&pathwayVersionUuid',
      onEnter: function () {
        waitForEmbedApp('embed-app').then(function(embedApp) {
          embedApp.classList.add('as-full-page-overlay');
        });
      },
      onExit: function () {
        var embedApp = document.querySelector('embed-app');
        embedApp.classList.remove('as-full-page-overlay');
      }
    })

    // Pathway
    .state('issuer.dashboard.pathways.pathway-edit', {
      title: 'Pathways > Pathway',
      url: '/:id/version/:versionId?isPublishing&createFromPublished',
      onEnter: function () {
        waitForEmbedApp('embed-app').then(function(embedApp) {
          embedApp.classList.add('as-full-page-overlay');
        });
      },
      onExit: function () {
        var embedApp = document.querySelector('embed-app');
        embedApp.classList.remove('as-full-page-overlay');
      }
    })

    .state('issuer.dashboard.pathways.pathway-eligible-list', {
      title: 'Pathways > Eligible List',
      url: '/:id/version/:versionId/eligible-list?searchTerm&page&sort&group&status&order',
    })

    .state('issuer.dashboard.pathways.pathway-track', {
      title: 'Pathways > Pathway Track',
      url: '/create-pathway-track',
      onEnter: function () {
        waitForEmbedApp('embed-app').then(function(embedApp) {
          embedApp.classList.add('as-full-page-overlay');
        });
      },
      onExit: function () {
        var embedApp = document.querySelector('embed-app');
        embedApp.classList.remove('as-full-page-overlay');
      }
    })

    .state('issuer.dashboard.pathways.pathway-track-edit', {
      title: 'Pathways > Pathway Track',
      url: '/pathway-track/:id',
      onEnter: function () {
        waitForEmbedApp('embed-app').then(function(embedApp) {
          embedApp.classList.add('as-full-page-overlay');
        });
      },
      onExit: function () {
        var embedApp = document.querySelector('embed-app');
        embedApp.classList.remove('as-full-page-overlay');
      }
    })

    .state('issuer.dashboard.pathways.pathway-track-preview', {
      title: 'Pathways > Pathway Track Preview',
      url: '/pathway-track/:id/preview?view',
      onEnter: function () {
        waitForEmbedApp('embed-app').then(function(embedApp) {
          embedApp.classList.add('as-full-page-overlay');
        });
      },
      onExit: function () {
        var embedApp = document.querySelector('embed-app');
        embedApp.classList.remove('as-full-page-overlay');
      }
    })

    // Directories
    .state('issuer.dashboard.directories', {
      url: '/directories',
      component: 'embedApp',
      resolve: cloneAssign(v2Resolvers, {
        asFeatureRoute: function () {
          return true;
        },
        route: function () {
          return 'directories';
        },
      }),
      title: 'Directories',
    })

    // Directories details
    .state('issuer.dashboard.directories.directory', {
      title: 'Directory settings',
      url: '/:id',
    })

    // Directory marketing content
    .state('issuer.dashboard.directories.directory.marketing-content', {
      title: 'Directory settings - Marketing Content',
      url: '/marketing-content',
    })

    // Groups
    .state('issuer.dashboard.groups', {
      title: 'Groups List',
      url: '/groups?page&searchTerm&appearance&languages&collections&tags&skillFramework',
      reloadOnSearch: false,
      component: 'embedApp',
      resolve: cloneAssign(v2Resolvers, {
        asFeatureRoute: function () {
          return true;
        },
        asSubRoute: function () {
          return true;
        },
        route: function () {
          return 'groups';
        },
      }),
    })

  // Collections
  .state('issuer.dashboard.collections', {
      title: 'Collections List',
      url: '/collections',
      component: 'embedApp',
      resolve: cloneAssign(v2Resolvers, {
        asFeatureRoute: function () {
          return true;
        },
        asFullPageRoute: function () { return true; },
        route: function () {
          return 'collections';
        },
      }),
    })
  .state('issuer.dashboard.collections.list', {
      title: 'Collections List',
      url: '?name&public&page&sort&order&create',
    });
}

angular
  .module('app')
  .config(appRoutingConfig)
  .config(['$qProvider', function ($qProvider) { // Suppress unhandled rejection error
    $qProvider.errorOnUnhandledRejections(false);
  }]);

var v2SignInResolvers = {
  app: function () { return 'dashboard'; },
  asFullPageRoute: function () { return true; },
  queryParams: function () { return ''; },
};

var v2Resolvers = {
  app: function () {
    return 'dashboard';
  },
  asFeatureRoute: function () {
    return false;
  },
  asRoute: function () {
    return true;
  },
  department: ['resolvedDepartment', function (resolvedDepartment) {
    return resolvedDepartment;
  }],
  user: ['resolvedUser', function (resolvedUser) {
    return resolvedUser;
  }],
  resolvedUrlParams: ['$location', function($location){
    return $location.search();
  }],
  queryParams: [
    'resolvedUrlParams', function (resolvedUrlParams) {
      return resolvedUrlParams;
    }
  ],
};

var v2IntegrationsResolvers = {
  zoomIssuanceParams: [
    '$stateParams', function ($stateParams) {
      var searchParams = new URLSearchParams();
      var params = ['eventType', 'hostId', 'page', 'pageToken'];
      params.forEach(function (param) {
        if ($stateParams[param]) {
          searchParams.append(param, $stateParams[param]);
        }
      });
      return searchParams.toString();
    }
  ],
  ltiStateParams: [
    '$stateParams', function ($stateParams) {
      var searchParams = new URLSearchParams();
      var params = ['state', 'code', 'error', 'details', 'message', 'error_description', 'lti_tool_setting_id', 'resource_link_id'];
      params.forEach(function (param) {
        if ($stateParams[param]) {
          searchParams.append(param, $stateParams[param]);
        }
      });
      return searchParams.toString();
    }
  ],
  app: function () { return 'dashboard'; },
  asRoute: function () { return true; },
  queryParams: ['$location', function ($location) {
    var searchParams = $location.search();
    var urlParams = Object.keys(searchParams).map(function (key) {
      return key + '=' + searchParams[key];
    }).join('&');
    return urlParams || '';
  }],
  department: ['resolvedDepartment', function (resolvedDepartment) {
    return resolvedDepartment;
  }],
  user: ['resolvedUser', function (resolvedUser) {
    return resolvedUser;
  }]
};

var cloneAssign = function(resolversObject, overrides) {
  var newResolvers = angular.copy(resolversObject);
  Object.assign(newResolvers, overrides);
  return newResolvers;
};

function waitForEmbedApp(selector) {
  return new Promise(function(resolve) {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    var observer = new MutationObserver(function(mutations) {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

},{}],81:[function(require,module,exports){
appRun.$inject = ['$rootScope', '$state', '$transitions', 'HotjarService', 'PostHogService', 'GainsightPXService', 'GTMService'];
function appRun($rootScope, $state, $transitions, HotjarService, PostHogService, GainsightPXService, GTMService) {
  // Attach the $state to rootScope - Why? DK
  $rootScope.$state = $state;

  // Runs every time the state changes
  function stateChangeSuccess($transition) {
    // Modals sticking around
    angular.element('.modal').remove();
    angular.element('.modal-backdrop').remove();
    angular.element('body').removeClass('modal-open');
  }

  // Watch for changes
  $transitions.onSuccess({}, stateChangeSuccess);
  stateChangeSuccess();

  GTMService.init();
  HotjarService.init();
  PostHogService.init();
  GainsightPXService.init();
}

angular
  .module('app')
  .run(appRun);

},{}],82:[function(require,module,exports){
/** SETTINGS : ATTRIBUTES
 *
 *
 *
 *    @author   Jake Ford
 */
angular.module('app')
  .controller('AttributesCtrl', ['$scope', 'attributeService', 'upsertAttributeModalService', 'csv', 'AnalyticsService', function($scope, attributeService, upsertAttributeModalService, csv, AnalyticsService) {

    // Read the attributes from the service
    $scope.attributes = [];
    attributeService.getAttributesList(true)
      .then(function(attributes) {
        $scope.attributes = attributes;
      });
    $scope.validTypes = attributeService.getValidTypes();


    // Delete an attribute
    $scope.doDelete = function(attribute) {
      attributeService.delete(attribute);
    };

    // Edit an attribute
    $scope.showAttributeModal = function(attribute) {
      upsertAttributeModalService.show(attribute);
    };

    // Generates a CSV
    $scope.downloadCsv = function() {
      AnalyticsService.trackEvent('Attributes > Downloaded CSV Template');
      csv.generate();
    };

  }]);

},{}],83:[function(require,module,exports){
AuditCtrl.$inject = ['AuditService', 'alertService', '$filter', 'encodeService', 'supportService', 'resolvedUser'];
function AuditCtrl(AuditService, alertService, $filter, encodeService, supportService, resolvedUser) {
  var ctrl = this;

  ctrl.supportService = supportService;
  ctrl.log;
  ctrl.meta;
  ctrl.loading = false;
  ctrl.applyFilters = applyFilters;
  ctrl.resetFilters = resetFilters;
  ctrl.updatePagination = updatePagination;
  // ctrl.updateOrderBy = updateOrderBy; // Unused
  ctrl.showChanges = showChanges;
  ctrl.showRawChanges = showRawChanges;
  ctrl.setTeamMemberFilter = setTeamMemberFilter;

  // Get started
  applyFilters();

  // Load the models
  ctrl.models = [];
  AuditService
    .getModels()
    .then(function(models){
      ctrl.models = models;
    });

  // Filter
  ctrl.filters = {
    page: 0,
    // order: null, // Unused
    auditable_type: null, // Model
    auditable_id: null, // Model ID
    user: null,
    start_date: null,
    end_date: null,
  };

  // Actions, past-tense
  var actions = {
    'create': 'Created',
    'update': 'Updated',
    'destroy': 'Deleted',
  };

  // Apply Filters
  function applyFilters(){
    ctrl.loading = true;
    AuditService
      .getAudit(ctrl.filters)
      .then(function(response){
        ctrl.log = response.log;
        ctrl.meta = response.meta;
        ctrl.loading = false;
        // Parse the logs
        angular.forEach(ctrl.log, function(entry){
          // Store the original
          entry.raw = angular.copy(entry);
          // Get a list of changed columns
          entry.columns = entry.audited_changes ? Object.keys(entry.audited_changes).join(', ') : null;
          // Make the action human-readable
          entry.action_human = actions[entry.action];
          // Tweak the data depending on the Model
          switch(entry.auditable_type) {
            case 'Credential':
              entry.state = 'issuer.dashboard.credential';
              entry.stateParams = { id:entry.auditable_id };
              break;
            case 'Group':
              entry.state = 'issuer.dashboard.group.edit';
              entry.stateParams = { id:entry.auditable_id };
              break;
            case 'Email_Template':
              entry.state = 'issuer.dashboard.email-template';
              entry.stateParams = { templateIdOrKind:entry.auditable_id };
              break;
            case 'Organization':
              entry.state = 'issuer.dashboard.organization.edit';
              entry.stateParams = { };
              break;
          }
          // Tweak the `user`
          entry.user = {};
          switch(entry.user_type) {
            case 'IssuerLogin':
              if(resolvedUser.id === entry.user_id){
                entry.user.name = 'You';
                entry.user.tooltip = entry.username;
              } else {
                entry.user.name = entry.username;
                entry.user.state = 'issuer.dashboard.team-members.team-member';
                entry.user.stateParams = { id: entry.user_id };
              }
              break;
            case 'User':
              entry.user.name = 'The Recipient';
              break;
            case 'Organization':
              entry.user.name = 'The API';
              entry.user.state = 'issuer.dashboard.department.api-and-integrations';
              break;
            case 'Sidekiq':
            case 'rails_api':
            default:
              entry.user.name = 'The System';
              break;
          }
        });
      });
    }

    // Resets the filter
    var originalFilters = angular.copy(ctrl.filters);
    function resetFilters(){
      ctrl.filters = angular.copy(originalFilters);
      applyFilters();
    }

    // Update the page number
    function updatePagination(event) {
      ctrl.filters.page = event.page;
      applyFilters();
    }

    // Update the order by (unused)
    /*
    function updateOrderBy(event){
      ctrl.filters.order = event.order;
      ctrl.filters.page = 0;
      applyFilters();
    }
    */

    // Show the full list of changes
    function showChanges($event, entry){
      var html = entryToTable(entry);
      alertService
        .alert('Audit Data', html)
        .then(function(){
          $event.target.focus(); // Return focus to the button, so we can see where we were
        });
    }

    // Show the full list of changes (raw)
    function showRawChanges($event, entry){
      var html = entryToPre(entry.raw);
      alertService
        .alert('Raw Audit Data', html)
        .then(function(){
          $event.target.focus(); // Return focus to the button, so we can see where we were
        });
    }

    // Sets the team member
    function setTeamMemberFilter($event){
      ctrl.filters.user = $event.selection.id;
      applyFilters();
    }

    // Converts an `audited_changes` object to <pre>
    function entryToPre(entry){
      var pre = encodeService.encode($filter('json')(entry));
      return '<pre>'+pre+'</pre>';
    }

    // Converts an `audited_changes` object to <table>
    function entryToTable(entry){
      var html;
      if(!entry.audited_changes){
        html = '<p><strong>Changes were recorded but can\'t be previewed here.</strong></p><p>Internal data or custom attributes have been updated. If you need to retrieve this record, contact Accredible support.</p>';
      } else {
        html = '<table class="table bordered">';
        if(entry.action === 'update'){
          html += '<thead><tr><th class="table-key">Key</th><th>Old Value</th><th>New Value</th></tr></thead><tbody>';
          angular.forEach(entry.audited_changes, function(change, key){
            html += '<tr><td class="text-overflow">'+encode(key)+'</td><td>'+encode(change[0])+'</td><td>'+encode(change[1])+'</td></tr>';
          });
          html += '</tbody>';
        } else {
          html += '<thead><tr><th class="table-key">Key</th><th>Value</th></tr></thead><tbody>';
          angular.forEach(entry.audited_changes, function(value, key){
            html += '<tr><td class="text-overflow">'+encode(key)+'</td><td>'+encode(value)+'</td></tr>';
          });
          html += '</tbody>';
        }
        html += '</table>';
      }
      return html;
    }

    // Encode
    function encode(value){
      // null and boolean
      if(value === null || value === false || value === true){
        return '<code>'+value+'</code>';
      }
      // numbers
      if($.isNumeric(value)){
        return encodeService.encode(value);
      }
      // Does it look like an object or array?
      try {
        var o = JSON.parse(value);
        var pre = encodeService.encode($filter('json')(o));
        return '<pre class="no-margin">'+pre+'</pre>';
      } catch(e){
        // Probably not an object or array :D
      }
      // Just encode
      return encodeService.encode(value);
    }

}

angular
  .module('app')
  .controller('AuditCtrl', AuditCtrl);

},{}],84:[function(require,module,exports){
/** CLAIM SIGN IN AND ADD PASSWORD
 *
 *    Users can be invited to the system, they receive
 *     an email directing them to claim their account.
 *    This route asks them to set their password which
 *     is set as part of the authentication request.
 *
 *    @author   David "oodavid" King
 *    @author   Andrew Bateman (merged in set password functionality)
 */
angular.module('app')
  .controller('ClaimLoginRouteCtrl', ['$stateParams', '$scope', '$state', '$timeout', 'AuthService', 'AuthRedirectService', 'swalService',
    function($stateParams, $scope, $state, $timeout, AuthService, AuthRedirectService, swalService) {

      if (!$stateParams.token) {
        $timeout(function(){
          $state.go('issuer.login');
        });
      }

      $scope.setPassword = {};

      $scope.savePassword = function(formCtrl) {
        var token = $stateParams.token;
        var department_id = $stateParams.org_id;
        AuthService
          .authenticateWithInviteToken(token, department_id, $scope.setPassword.password)
          .then(function(auth) {
            swalService.showAlert('savePasswordSuccess');

            if (auth && auth.user) {
              AuthRedirectService.go('issuer.dashboard.home');
            } else {
              throw('No user returned');
            }
          })
          .catch(function(err) {
            if (err.status === 400 && err.data && err.data.errors) {
              $scope.passwordErrors = err.data.errors.password;
            } else {
              console.log('Error: ', err);
              swalService.showAlert('credentialTokenFailure');
            }
            formCtrl.$setPristine(); // Reset the form
          });
      };
    }
  ]);

},{}],85:[function(require,module,exports){
/** FORGOTTEN PASSWORD ROUTE CONTROLLER
 *
 *    See also:
 *      ResetPasswordRouteCtrl
 *
 *      @author  David "oodavid" King
 */
angular.module('app')
  .controller('ForgottenPasswordRouteCtrl', ['$scope', 'AuthService', 'swalService',
    function($scope, AuthService, swalService) {

      // Expose the form object
      $scope.email;
      $scope.captcha;

      // Send the email
      $scope.sendResetEmail = function(formCtrl) {
        AuthService
          .sendPasswordResetEmail($scope.email, $scope.captcha)
          .then(function(issuer){
            swalService.showAlert('resetEmailSuccess');
          })
          .catch(function(errors){
            if (errors.status === 404) {
              swalService.showAlert('resetEmailFailure');
            } else {
              swalService.showAlert('unknownFailure', '005');
            }
            formCtrl.$setPristine(); // Reset the form
          });
      };

    }]);

},{}],86:[function(require,module,exports){
/** JSON WEB TOKEN (JWT) - ISSUER CONTROLLER
 *
 *      This Controller results in a Redirect.
 *
 *      We decided that the JWT Authentication mechanism is
 *      useful enough that we should cater for issuers. It's
 *      used in the Canvas LMS integration.
 *
 *  @author  Alan Heppenstall
 */
angular.module('app')
  .controller('JWTLoginRouteCtrl', ['$state', '$stateParams', '$window', '$location', 'AuthService', 'swalService', '$timeout',
    function($state, $stateParams, $window, $location, AuthService, swalService, $timeout) {

    // Hoist the ui-router variables
    var jwt = $stateParams.jwt;
    var return_to = $stateParams.return_to;
    var forward_to_group = $stateParams.forward_to_group;

    // Require jwt
    if (jwt) {
      AuthService
        .authenticateWithJWT(jwt)
        .then(function(response) {
          // Head to the issuer dashboard
          if (forward_to_group) {
            $timeout(function(){
              $state.go('issuer.dashboard.group-overview', { id: forward_to_group });
            });
          } else {
            $timeout(function(){
              $state.go('issuer.dashboard.home');
            });
          }
        })
        .catch(function(err) {
          // Single Sign On Failed
          if (return_to) {
            // Ensure that the user is aware of where they're being redirected to.
            swalService.showAlert('urlRedirect', return_to);
          } else {
            $timeout(function(){
              $state.go('issuer.login'); // Go to sign in as a fallback
            });
          }
        });
    } else {
      // We don't have a token - go to sign in as a fallback
      $timeout(function(){
        $state.go('issuer.login');
      });
    }

  }]);

},{}],87:[function(require,module,exports){
angular.module('app')
  .controller('LoginRouteCtrl', ['$scope', 'AuthService', 'AuthRedirectService', 'swalService',
    function($scope, AuthService, AuthRedirectService, swalService) {

      // Expose the form object
      $scope.email;
      $scope.password;

      // Sign in
      $scope.signIn = function(formCtrl){
        AuthService
          .authenticateWithEmailAndPassword($scope.email, $scope.password)
          .then(function(auth){
            if (auth && auth.user) {
              AuthRedirectService.go('issuer.dashboard.home');
            } else if (AuthService.verificationToken) {
              AuthRedirectService.go('verify_email', { verificationToken: AuthService.verificationToken });
            } else {
              throw('No user returned');
            }
          })
          .catch(function(err){
            if (err.status == 429) {
              swalService.showAlert('issuerLoginThrottled');
            } else {
              console.log('Error: ', err);
              swalService.showAlert('issuerLoginFailure');
            }
            formCtrl.$setPristine(); // Reset the form
          });
      };
    }
  ]);

},{}],88:[function(require,module,exports){
angular.module('app')
  .controller('LogoutRouteCtrl', ['$state', 'AuthService', 'PostHogService',
    function($state, AuthService, PostHogService) {

      // Just sign out
      AuthService
        .logout()
        .finally(function(){
          PostHogService.logout();
          $state.go('issuer.login');
        });
    }
  ]);

},{}],89:[function(require,module,exports){
/** RESET PASSWORD ROUTE CONTROLLER
 *
 *    See also:
 *      ForgottenPasswordRouteCtrl
 *
 *      @author  David "oodavid" King
 */
angular.module('app')
  .controller('ResetPasswordRouteCtrl', ['$scope', '$state', 'AuthService', 'swalService', '$stateParams', '$timeout', '$location',
    function($scope, $state, AuthService, swalService, $stateParams, $timeout, $location) {

      // Expose the form object
      $scope.password;
      $scope.passwordConfirm;

      $scope.incorrectToken = false;

      if ($stateParams.resetToken) {
        sessionStorage.setItem('reset_token', $stateParams.resetToken);
        $location.replace('/issuer/reset/');
      } else if (!sessionStorage.getItem('reset_token')) {
        $scope.incorrectToken = true;
      }

      // Send the email
      $scope.sendResetEmail = function(formCtrl) {
        if ($scope.incorrectToken) {
          $timeout(function(){
            $state.go('issuer.forgotten_password');
          });
        } else {
        AuthService
          .passwordReset(sessionStorage.getItem('reset_token'), $scope.password)
          .then(function(){
              swalService.showAlert('resetPasswordSuccess');
              sessionStorage.removeItem('reset_token');
              $timeout(function(){
                $state.go('issuer.login');
              });
          })
          .catch(function(errors){
            if (errors.status === 400 && errors.data && errors.data.errors) {
              $scope.passwordErrors = errors.data.errors.password;
            } else if (errors.status === 401 || errors.status === 404) {
              swalService.showAlert('issuerResetTokenWrong');
              sessionStorage.removeItem('reset_token');
              $state.go('issuer.forgotten_password');
              $scope.incorrectToken = true;
            } else {
              swalService.showAlert('unknownFailure', '003');
            }
            formCtrl.$setPristine(); // Reset the form
          });
        }
      };

    }]);

},{}],90:[function(require,module,exports){
SelectDepartmentRouteCtrl.$inject = ['$state', 'resolvedUser', 'resolvedDepartments', 'DepartmentService', 'AuthRedirectService', 'supportService', 'alertService'];
function SelectDepartmentRouteCtrl($state, resolvedUser, resolvedDepartments, DepartmentService, AuthRedirectService, supportService, alertService) {
  var ctrl = this;

  ctrl.departments = resolvedDepartments;
}

angular
  .module('app')
  .controller('SelectDepartmentRouteCtrl', SelectDepartmentRouteCtrl);

},{}],91:[function(require,module,exports){
var selectDepartmentComponent = {
  controller: selectDepartmentComponentController,
  bindings: {
    departments: '<'
  },
  templateUrl: '/app/auth/select-department/select-department.html',
};

selectDepartmentComponentController.$inject = ['DepartmentsService', 'DepartmentService', 'AuthRedirectService', 'alertService', '$state'];
function selectDepartmentComponentController(DepartmentsService, DepartmentService, AuthRedirectService, alertService, $state) {
  var ctrl = this;

  ctrl.$onInit = $onInit;
  ctrl.loaded = false;
  ctrl.switchDepartment = switchDepartment;

  function $onInit(){
    console.log('departments', ctrl.departments);
    // DepartmentsService
    //   .getDepartments()
    //   .then(function(departments){
    //     ctrl.departments = departments;
    //     ctrl.loaded = true;
    //   });
  }

  // Switch to the given department and redirect to the dashboard
  function switchDepartment(department){
    DepartmentService
      .switchDepartment(department.id)
      .then(function(/* issuer */){
        AuthRedirectService.go('issuer.dashboard.home');
        alertService.close(); // This may or may not be open
      })
      .catch(function(){
        alertService
          .alert('We could not switch to this department');
      });
  }

}

angular
  .module('app')
  .component('selectDepartment', selectDepartmentComponent);

},{}],92:[function(require,module,exports){
angular.module('app')
  .controller('SignUpCtrl', ['$state', '$stateParams', '$window', '$timeout', 'swalService', 'AuthService', 'AnalyticsService', 'emailService',
    function($state, $stateParams, $window, $timeout, swalService, AuthService, AnalyticsService, emailService) {

      var ctrl = this;

      ctrl.register = register;

      // Expose the data
      ctrl.payload = {
        contact_first_name: ($stateParams.first_name || null),
        contact_last_name: ($stateParams.last_name || null),
        email: ($stateParams.email || null),
        phone_number: null,
        password: null,
        name: ($stateParams.org_name || null),
        url: ($stateParams.org_url || null),
        found_accredible: null,
        number_of_recipients: null,
        job_role: null,
        source: ($stateParams.source || null),
      };

      // If we've been given an email, we can prepopulate the (organisation) name and url. Careful not to overwrite
      if(ctrl.payload.email){
        ctrl.payload.name = ctrl.payload.name || parseEmailToName(ctrl.payload.email);
        ctrl.payload.url  = ctrl.payload.url || parseEmailToUrl(ctrl.payload.email);
      }

      // Register
      function register(formCtrl) {
        // Crack on
        AuthService.
          register(ctrl.payload)
            .then(function(response) {
              AnalyticsService.trackEvent('Issuer > Sign Up');
              AnalyticsService.trackSignup();
              $timeout(function() {
                $state.go('verify_email', { verificationToken: response.verification_token });
              }, 1000); // Wait for a second to make sure password managers don't interfere with the route transition
            })
            .catch(function(err) {
              if (err && err.status === 400 && err.data && err.data.errors && err.data.errors.password) {
                ctrl.passwordErrors = err.data.errors.password;
              } else if (err && err.status == 434){
                // 434 is a special error code from the API that says this is a freemail signup
                var redirectToSalesForm = function() {
                  $window.location = "https://www.accredible.com/contact/";
                };
                swalService.confirm(
                  "Unable to sign up with a personal email address. Please use your work email address.",
                  redirectToSalesForm,
                  "Unable to Sign Up",
                  "Submit Sales Request",
                  null,
                  "Update email address"
                );
              } else if (err.data && err.data.errors && err.data.errors.email) {
                swalService.showAlert('issuerSignUpFailureEmailTaken');
              } else if (err.data) {
                swalService.showAlert('issuerSignUpFailure', JSON.stringify(err.data.errors));
              } else {
                swalService.showAlert('requestTimeout');
              }
            })
            .finally(function() {
              formCtrl.$setPristine(); // Reset the form
            });
      }

      // Automatically populates the organization name and organization domain from the user's email address
      ctrl.populateOrganization = function(emailCtrl, nameCtrl, urlCtrl){
        var email = emailCtrl.$viewValue;
        var name = parseEmailToName(email);
        var url = parseEmailToUrl(email);
        if(nameCtrl.$untouched && name){
          nameCtrl.$setViewValue(name);
          nameCtrl.$render();
          nameCtrl.$setPristine();
        }
        if(urlCtrl.$untouched && url){
          urlCtrl.$setViewValue(url);
          urlCtrl.$render();
          urlCtrl.$setPristine();
        }
      };

      function parseEmailToName(email){
        var parsed = emailService.parse(email);
        if(parsed && parsed.local){
          var name = parsed.domain.hostname.split('.')[0]; // accredible.com -> accredible
          name = name.charAt(0).toUpperCase() + name.substr(1).toLowerCase(); // accredible -> Accredible
          return name;
        }
      }
      function parseEmailToUrl(email){
        var parsed = emailService.parse(email);
        if(parsed && parsed.local){
          return parsed.domain.hostname;
        }
      }

      // Number of recipient options
      ctrl.recipients = [
        { name: "less than 100" },
        { name: "100 - 1,000" },
        { name: "1,000 - 5,000" },
        { name: "5,000- 10,000" },
        { name: "10,000 - 50,000" },
        { name: "50,000+" }
      ];

      // Job roles
      ctrl.job_roles = [
        {name: "CEO / Founder / Director / President", group: "Executive" },
        {name: "Chancellor / Dean / Provost", group: "Executive" },
        {name: "Education Director / Head of Learning / Program Coordinator", group: "Education" },
        {name: "Head of Certification", group: "Education" },
        {name: "CTO / CIO / IT Director / Technical Manager", group: "IT" },
        {name: "Developer / Technical Support", group: "IT" },
        {name: "Marketing Director / Marketing Manager", group: "Marketing" },
        {name: "Marketing Assistant / Marketer", group: "Marketing" },
        {name: "Admin / Assistant / Associate / Researcher", group: "Admin" },
        {name: "Student/Learner", group: "Other" },
        {name: "Other", group: "Other" }
      ];

      // List of possible referrers
      ctrl.referrers = [
        { name: "Google or Web Search", group: "Web" },
        { name: "Blog Article", group: "Web" },
        { name: "eBook", group: "Web" },
        { name: "Blackboard", group: "Integrations" },
        { name: "Canvas", group: "Integrations" },
        { name: "Caveon Scorpion", group: "Integrations" },
        { name: "D2L Brightspace", group: "Integrations" },
        { name: "Kajabi", group: "Integrations" },
        { name: "Kryterion Webassessor", group: "Integrations" },
        { name: "LearnDash", group: "Integrations" },
        { name: "Microsoft Azure", group: "Integrations" },
        { name: "Moodle", group: "Integrations" },
        { name: "Thinkific", group: "Integrations" },
        { name: "Wordpress", group: "Integrations" },
        { name: "Zapier", group: "Integrations" },
        { name: "Zoom", group: "Integrations" },
        { name: "LinkedIn", group: "Social Media" },
        { name: "Twitter", group: "Social Media" },
        { name: "Facebook", group: "Social Media" },
        { name: "Received an Email", group: "Advertising" },
        { name: "Saw an Advertisement", group: "Advertising" },
        { name: "Talked to a Sales Person", group: "Advertising" },
        { name: "Referral", group: "Advertising" },
        { name: "Viewed a Credential", group: "Other" },
        { name: "Event", group: "Other" },
        { name: "Other Website", group: "Other" },
        { name: "Other", group: "Other" },
      ];

    }
  ]);

},{}],93:[function(require,module,exports){
angular.module('app')
  .controller('VerifyEmailRouteCtrl', ['$scope', '$stateParams', 'AuthService', 'AnalyticsService', 'swalService', '$timeout',
    function($scope, $stateParams, AuthService, AnalyticsService, swalService, $timeout) {
      // Resend a verification email
      $scope.resendVerification = function(){
        AuthService
          .resendVerificationEmail($stateParams.verificationToken)
          .then(function(response) {
            AnalyticsService.trackEvent('Issuer > Resend Verification Email');
            swalService.showAlert('issuerVerificationEmailResent');
          })
          .catch(function(err) {
            swalService.showAlert('unknownFailure', '001');
          });
      };

    }
  ]);

},{}],94:[function(require,module,exports){
angular.module('app')
  .controller('VerifyEmailStatusRouteCtrl', ['$state', '$stateParams', 'resolvedUser', 'AnalyticsService', 'swalService', '$timeout',
    function($state, $stateParams, resolvedUser, AnalyticsService, swalService, $timeout) {

      // Is our token verified?
      var isVerified = resolvedUser.verified;

      // Show an alert, when necessary
      if ($stateParams.status == 'success' && isVerified) {
        AnalyticsService.trackEvent('Issuer > Verification Email Success');
        swalService.showAlert('issuerVerificationEmailSuccess');
        $timeout(function(){
          $state.go('issuer.dashboard.home');
        });
      } else if ($stateParams.status == 'error' && !isVerified) {
        AnalyticsService.trackEvent('Issuer > Verification Email Failure');
        swalService.showAlert('issuerVerificationEmailFailure');
        $timeout(function(){
          $state.go('verify_email', { verificationToken: $stateParams.verification_token });
        });
      }
    }
  ]);

},{}],95:[function(require,module,exports){
/** BADGE EDITOR
 *
 *   Requires: ../shared/svg-editor/svg-editor.component.js
 *
 *   <badge-editor></badge-editor>
 *
 *   @author Andrew Bateman
 */

 // Component
badgeEditorDirective.$inject = [];
function badgeEditorDirective() {
  return {
    restrict: 'E', // Element only
    templateUrl: '/app/badge-editor/badge-editor.html',
    controller: badgeEditorComponentController,
    scope: {}
  };
}

BadgeEditorService.$inject = ['$q', '$window', '$timeout', '$filter', '$state', 'AnalyticsService', 'CertificateService', 'swalService', 'svgProcessor', 'attributeService'];
function BadgeEditorService($q, $window, $timeout, $filter, $state, AnalyticsService, CertificateService, swalService, svgProcessor, attributeService) {
  var service = this;

  service.data = {
    visible: false,
    saving: false,
    design: null,
    existingDesigns: [], // An empty array to inform the svg editor component that existing designs will be loaded
    attributeGroups: null
  };

  service.open = open;
  service.close = close;
  service.save = save;
  service.setNameChanged = setNameChanged;

  var badgeSVG = null;

  function setNameChanged() {
    service.data.nameChanged = (service.data.design.name !== service.data.original_name);
  }

  var inputDesign = null;
  var deferred;
  // Promise to open the editor with the given design
  function open(design) {
    inputDesign = angular.copy(design);
    deferred = $q.defer();
    // Get existing badges
    var form = {
      page_size: 1000,
      page: '',
      order: 'designs.updated_at DESC',
      kind: 'badge',
    };
    CertificateService
      .getDesigns(form)
      .then(function (response) {
        service.data.existingDesigns = response.designs;
      });
    // Get attributes
    attributeService
      .getNestedAttributes()
      .then(function(attributes) {
        service.data.attributeGroups = attributes;
      });
    // Show the editor
    service.data.visible = true;
    if (design) {
      design.svg = svgProcessor.sanitize(design.svg);
      service.data.design = design;
    } else {
      service.data.design = {};
    }
    service.data.original_name = service.data.design.name;
    setNameChanged();
    // Push a dummy state to represent the editor pop-up in the browser history
    $window.history.pushState({ editor: true }, 'Badge Designer');
    // When that state is popped, run the editor close functionality
    $window.onpopstate = function() {
      var closed = close();
      if (!closed) {
        $window.history.pushState({ editor: true }, 'Badge Designer'); // Put the dummy state back
      }
    };
    // If service.data.design.svg is null, the svg-editor changes it to an SVG stubb
    badgeSVG = null;
    $timeout(function() {
      badgeSVG = service.data.design.svg; // Remember the SVG that the editor starts with
    });
    // Return the promise, resolved when the editor is closed
    return deferred.promise;
  }

  function close(destination) {
    if (!service.data.saving) {
      if (service.data.design.svg !== badgeSVG || service.data.nameChanged) {
        var translate = $filter('translate');
        var message = translate('unsaved.changes-single-form'); // Notify
        message += '\n\n' + translate('unsaved.leave-confirm'); // Action
        if ($window.confirm(message)) {
          service.data.design = inputDesign;
          doCloseEditor(destination);
          return true;
        } else {
          return false;
        }
      } else {
        service.data.design = inputDesign;
        doCloseEditor(destination);
        return true;
      }
    } else {
      return false;
    }
  }

  function doCloseEditor(destination) {
    badgeSVG = null;
    // Remove the dummy state if it's still there
    if ($window.history.state && $window.history.state.editor) {
      $window.onpopstate = null;
      $window.history.back();
    }
    if (deferred && deferred.resolve){
      deferred.resolve(service.data.design);
    }
    service.data.visible = false;
    service.data.design = null;
    if (destination) {
      $timeout(function() { // To make sure we have returned to the editor's source page before redirecting
        $state.go(destination);
      });
    }
  }

  function save(formCtrl) {
    service.data.saving = true;
    service.data.design.kind = 'badge'; // Make sure the kind is set for new badges
    service.data.design.svg = svgProcessor.sanitize(service.data.design.svg);
    service.data.design.svg = svgProcessor.insertFonts(service.data.design.svg);
    service.data.design.svg = svgProcessor.xmlify(service.data.design.svg);
    CertificateService
      .upsert(service.data.design)
      .then(function(response) {
        service.data.design = response;
        AnalyticsService.trackEvent('Badge Design Editor > Design Saved');
        formCtrl.saveSuccess();
        service.data.saving = false;
        doCloseEditor();
      })
      .catch(function(err) {
        swalService.showAlert('badgeDesignUpdateFailure');
      })
      .finally(function(){
        formCtrl.$setPristine();
      });
  }
}

badgeEditorComponentController.$inject = ['$scope', '$element', 'BadgeEditorService', 'swalService', 'DepartmentService', 'FlipperFeaturesService'];
function badgeEditorComponentController($scope, $element, BadgeEditorService, swalService, DepartmentService, FlipperFeaturesService) {
  $scope.data = BadgeEditorService.data;
  $scope.close = BadgeEditorService.close;
  $scope.save = BadgeEditorService.save;
  $scope.setNameChanged = BadgeEditorService.setNameChanged;
  $scope.data.nameChanged = false;
  $scope.changes = false; // This is updated by the svg editor component
  $scope.showQRCodeTab = false;

  // TODO(Salim): Delete this code after FF is removed
  var ctrl = this;
  ctrl.$onInit = $onInit;


  $element.on('goto', function(event, destination) {
    $scope.close(destination);
  });

  // TODO(Salim): Delete this code after FF is removed
  function $onInit() {
    DepartmentService.getDepartment().then(function(department) {
      FlipperFeaturesService.getFlipperFeatures(department.id).then(function(features) {
        $scope.showQRCodeTab = features.custom_attributes_badges;
      })
    })
  }

  function confirmThenSave(formCtrl) {
    swalService.confirm(
      'This template is used by ' + $scope.data.design.credentials_count + ' existing credentials. Saving now will change the badge appearance for those credentials.',
      function (confirmed) {
        if (confirmed) {
          $scope.save(formCtrl);
        } else {
          formCtrl.$submitted = false;
        }
      },
      'Change Existing Credentials?',
      'Update design',
      '#4fba6a',
      'Cancel',
      true
    );
  }

  $scope.saveDesign = function(formCtrl) {
    if (!$scope.data.design.name) {
      swalService.showAlert('badgeDesignNeedsNameError');
      formCtrl.$submitted = false;
    } else {
      // Confirm the effects on existing credentials
      if ($scope.data.design.credentials_count > 0) {
        confirmThenSave(formCtrl);
      } else {
        $scope.save(formCtrl);
      }
    }
  };

  $scope.nameChange = function() {
    $scope.setNameChanged();
  };
}

angular
  .module('app')
  .service('BadgeEditorService', BadgeEditorService)
  .directive('badgeEditor', badgeEditorDirective);


},{}],96:[function(require,module,exports){
BillingCtrl.$inject = ['resolvedPricing', 'resolvedFlipperFeatures'];
function BillingCtrl(resolvedPricing, resolvedFlipperFeatures) {
  var ctrl = this;
  ctrl.plan = resolvedPricing.plan;
  ctrl.flipperFeatures = resolvedFlipperFeatures;
  ctrl.isCustomPlan = ctrl.plan === 'custom';
  ctrl.showPackaging = ctrl.flipperFeatures.packaging;
  ctrl.showStripeBillingPage = ctrl.flipperFeatures.stripe_billing_page;
}

angular
  .module('app')
  .controller('BillingCtrl', BillingCtrl);


},{}],97:[function(require,module,exports){
BillingCheckoutCtrl.$inject = ['resolvedPricing', 'resolvedFlipperFeatures', 'resolvedDepartment', 'resolvedUser', '$location'];
function BillingCheckoutCtrl(resolvedPricing, resolvedFlipperFeatures, resolvedDepartment, resolvedUser, $location) {
  var ctrl = this;
  ctrl.plan = resolvedPricing.plan;
  ctrl.flipperFeatures = resolvedFlipperFeatures;
  ctrl.department = angular.copy(resolvedDepartment);
  ctrl.user = resolvedUser;

  var locationUrl = $location.path();
  var startIndex = locationUrl.search('checkout');
  ctrl.route = startIndex > 0 ? locationUrl.slice(startIndex) : 'checkout';

  if (Object.keys($location.search()).length) {
    var searchParams = new URLSearchParams($location.search());
    ctrl.queryParams = searchParams.toString();
  }
}

angular
  .module('app')
  .controller('BillingCheckoutCtrl', BillingCheckoutCtrl);


},{}],98:[function(require,module,exports){
BillingPaymentCtrl.$inject = ['$state', 'BillingService', 'resolvedPricing'];
function BillingPaymentCtrl($state, BillingService, resolvedPricing) {
  var ctrl = this;
  ctrl.card;
  ctrl.plan = resolvedPricing.plan;
  ctrl.doSubmit = doSubmit;
  function doSubmit(formCtrl){
    BillingService.updateCreditCard(ctrl.card)
      .then(function(){
        formCtrl.$setPristine(); // Tidy the form
        $state.reload();
      })
      .catch(function() {
        formCtrl.$setPristine(); // Tidy the form
      });
  }
}

angular
  .module('app')
  .controller('BillingPaymentCtrl', BillingPaymentCtrl);

},{}],99:[function(require,module,exports){
BillingPurchaseCtrl.$inject = ['BillingService', 'resolvedPlansAndAddOns', 'alertService', '$state'];
function BillingPurchaseCtrl(BillingService, resolvedPlansAndAddOns, alertService, $state) {
  var ctrl = this;

  // Sourced from external components
  ctrl.card;
  ctrl.coupon_code;

  ctrl.doSubmit = doSubmit;
  ctrl.doClose = doClose;
  ctrl.isUpdated = false;
  ctrl.setUpdated = setUpdated;
  ctrl.setPlanUpgraded = setPlanUpgraded;
  ctrl.setAddOnsUpgraded = setAddOnsUpgraded;

  ctrl.plans = resolvedPlansAndAddOns.plans;
  ctrl.addOns = resolvedPlansAndAddOns.addons;

  // Make Spotlight non-purchasable going forward
  if (ctrl.addOns.spotlight_directory && !ctrl.addOns.spotlight_directory.purchased) {
    ctrl.addOns.spotlight_directory['non_purchasable'] = true;
  }

  function doSubmit(formCtrl) {
    var selectedPlanId;
    var addOnlist = {};
    angular.forEach(ctrl.plans, function(plan, key) {
      if (plan.inBasket) {
        selectedPlanId = key;
      }
    });
    angular.forEach(ctrl.addOns, function(addon, key) {
      addOnlist[key] = addon.inBasket || addon.purchased;
    });
    BillingService
      .makePurchase(selectedPlanId, addOnlist, ctrl.coupon_code, ctrl.card)
      .then(function(){
        formCtrl.$setPristine(); // Tidy the form
        var message =
        '<p class="text-center"><img src="/images/upgrade_success.png" width="160"></p>\
        <p>Your purchase was successful. Thank you for your order.</p>\
        <p>You will receive an email shortly that includes a receipt.</p>';
        alertService
          .confirm('Plan Updated', message, 'View Billing Status', false)
          .then(function(){
            $state.transitionTo('issuer.dashboard.billing.status', null, { reload: true });
          });
      })
      .catch(function() {
        formCtrl.$setPristine(); // Tidy the form
      });
  }

  function doClose(){
    $state.transitionTo('issuer.dashboard.billing.status');
  }

  function setUpdated(updated) {
    ctrl.isUpdated = updated;
  }

  function setPlanUpgraded(upgraded) {
    ctrl.isPlanUpgraded = upgraded;
  }

  function setAddOnsUpgraded(upgraded) {
    ctrl.areAddOnsUpgraded = upgraded;
  }
}

angular
  .module('app')
  .controller('BillingPurchaseCtrl', BillingPurchaseCtrl);

},{}],100:[function(require,module,exports){
angular.module('app')
  .controller('BillingStatusCtrl', ['$scope', 'resolvedYearlyReport', 'resolvedDepartment', 'resolvedPricing', 'resolvedFlipperFeatures', 'BillingService', 'supportService',
    function($scope, resolvedYearlyReport, resolvedDepartment, resolvedPricing, resolvedFlipperFeatures, BillingService, supportService) {
      var ctrl = this;
      $scope.supportService = supportService;

      ctrl.plan = resolvedPricing.plan;

      ctrl.flipperFeatures = resolvedFlipperFeatures;
      ctrl.isCustomPlan = ctrl.plan === 'custom';
      ctrl.isTrialPlan = ctrl.plan === 'trial';
      ctrl.showPackaging = ctrl.flipperFeatures.packaging;

      ctrl.showStripeBillingPage = ctrl.flipperFeatures.stripe_billing_page;
      ctrl.showManageBilling = ctrl.showStripeBillingPage && !ctrl.isCustomPlan && !ctrl.isTrialPlan;

      ctrl.credentials_published_this_year = resolvedYearlyReport.issuer.credentials_published_this_year;
      ctrl.recipients_created_this_year = resolvedYearlyReport.issuer.recipients_created_this_year;
      ctrl.legacy_remaining_credits = resolvedDepartment.certificate_left;

      ctrl.last_payment = {};
      ctrl.next_payment = {};

      BillingService.getPaymentSchedule().then(function(response){
        ctrl.last_payment.amount = response.last_charge;
        ctrl.last_payment.currenct = response.last_charge_currency;
        ctrl.last_payment.date = response.last_charge_date;
        ctrl.next_payment.amount = response.next_charge;
        ctrl.next_payment.currenct = response.next_charge_currency;
        ctrl.next_payment.date = response.next_charge_date;
      });
      
      ctrl.manageBillingUrl = '';
      ctrl.manageBillingUrlError = false;
      ctrl.isLoadingStripeUrl = false;

      function fetchManageBillingUrl() {
        ctrl.isLoadingStripeUrl = true;
        ctrl.manageBillingUrlError = false;
        var redirectUrl = '';
        return BillingService.getManageBillingUrl(redirectUrl)
          .then(function(response){
            ctrl.manageBillingUrl = response.portal;
            ctrl.manageBillingUrlError = false;
            ctrl.isLoadingStripeUrl = false;
          })
          .catch(function(){
            ctrl.manageBillingUrlError = true;
            ctrl.isLoadingStripeUrl = false;
          });
      }

      ctrl.retryManageBillingUrl = fetchManageBillingUrl;

      if (ctrl.showManageBilling) {
        fetchManageBillingUrl();
      }
    }
  ]);

},{}],101:[function(require,module,exports){
// Service
CertificateEditorService.$inject = ['$q', 'CertificateService', '$injector'];
function CertificateEditorService($q, CertificateService, $injector){
  var service = this;

  service.data = {
    visible: false,
    group: null, // ??
    saving: false,
    design: null,
  };

  service.open = open;
  service.close = close;

  var inputDesign = null;
  var deferred;
  var originalDesign;
  // Promise to open the editor with the given design
  function open(idObjectOrFalsey){
    inputDesign = angular.copy(idObjectOrFalsey);
    deferred = $q.defer();
    // Request the design object, then open
    CertificateService
      .get(idObjectOrFalsey)
      .then(function(design){
        service.data.visible = true;
        if (!idObjectOrFalsey) { // Start with a blank canvas
          // Remove the blocks
          design.blocks = [];
          // Remove the background
          design.background = null;
          // Remove bleeds
          design.background_bleeds = false;
        }
        originalDesign = design;
        service.data.design = angular.copy(design);
        service.data.original_name = service.data.design.name;
        // Show the editor
        service.data.visible = true;
        //setNameChanged();
      })
      .catch(function(err){
        deferred.reject(err);
      });
    // Return the promise, resolved when the editor is closed
    return deferred.promise;
  }

  function close(newDesign){
    if (newDesign) {
      if (!newDesign.id) {
        newDesign = inputDesign;
      }
    } else {
      if (originalDesign && originalDesign.id) {
        newDesign = originalDesign;
      }
    }
    if (deferred && deferred.resolve) {
      deferred.resolve(newDesign);
    }
    service.data.visible = false;
    service.data.design = null;
  }
  // Close when routing
  if ($injector.has('$transitions')) {
    var $transitions = $injector.get('$transitions');
    $transitions.onSuccess({}, function($transition) {
      close(false);
    });
  }
}

// Modal
function certificateEditorModal(){
  return {
    restrict: 'E',
    replace: true,
    scope: {}, // Don't allow controller access to parent scope!
    templateUrl: '/app/certificate-editor/certificate-editor-modal.html',
    controller: ['$scope', 'CertificateEditorService', function($scope, CertificateEditorService) {
      $scope.data = CertificateEditorService.data;
      $scope.close = CertificateEditorService.close;
      $scope.doExpire = CertificateEditorService.doExpire;
    }]
  };
}

angular
  .module('app')
  .service('CertificateEditorService', CertificateEditorService)
  .directive('certificateEditorModal', certificateEditorModal);

},{}],102:[function(require,module,exports){
/** CONTRACT
 *
 *    @author   Andrew Bateman
 */
angular.module('app').controller('contractCtrl', ['resolvedContract',
  function(resolvedContract) {
    var ctrl = this;

    ctrl.contract = resolvedContract;

    if (ctrl.contract.line_items.length > 0 && !ctrl.contract.currency) {
      ctrl.contract.total = 0.00;
      for (var index = 0; index < ctrl.contract.line_items.length; index++) {
        ctrl.contract.total += parseFloat(ctrl.contract.line_items[index].amount);
      }
      ctrl.contract.currency = ctrl.contract.line_items[0].currency;
    }
  }
]);

},{}],103:[function(require,module,exports){
/** CONTRACTS
 *
 *    @author   Andrew Bateman
 */
angular.module('app').controller('contractsCtrl', ['resolvedContracts', 'moment',
  function(resolvedContracts, moment) {
    var ctrl = this;

    ctrl.contracts = resolvedContracts;

    ctrl.viewableStatus = viewableStatus;

    function viewableStatus(contract) {
      // BE statuses: draft, won, lost, quote, cancelled
      // contract.status = contract.status || 'won'; // Workaround for missing status

      if (contract.status !== 'won' && contract.status !== 'lost') {
        return contract.status.charAt(0).toUpperCase() + contract.status.substr(1).toLowerCase();
      }
      if (contract.status === 'lost') {
        return 'Not Agreed';
      }
      var today = new Date();
      var startDate = new Date(contract.start_date);
      var endDate = new Date(contract.end_date);
      if (today < startDate) {
        return 'Pending';
      } else if (today < endDate) {
        if (today > moment(contract.end_date, 'YYYY-MM-DD').subtract(30, 'days').toDate()) {
          return 'Approaching Expiry';
        } else {
          return 'Active';
        }
      } else if (!contract.end_date) {
        return 'Active';
      } else {
        return 'Expired';
      }
    }
  }
]);

},{}],104:[function(require,module,exports){
/** CREDENTIAL PREVIEW
 *
 *   <credential-preview></credential-preview>
 *
 *   @author Andrew Bateman
 */

 // Component
 var credentialPreviewComponent = {
  controller: credentialPreviewComponentController,
  bindings: {},
  templateUrl: '/app/credential-preview/credential-preview.html',
};

// Service
CredentialPreviewService.$inject = ['emitter', 'LegacyCredentialService', 'AnalyticsService', '$q', '$sce', '$timeout', 'alertService'];
function CredentialPreviewService(emitter, LegacyCredentialService, AnalyticsService, $q, $sce, $timeout, alertService) {
  var service = this;

  // Become an emitter
  emitter.addEmitterLogicTo(service);

  service.data = {
    visible: false,
    step: null,
    group: null,
    name: 'Jordan Smith',
    email: 'jordan@example.com',
    sent_group_id: null,
    sent_name: null,
    sent_email: null,
    url: null,
    entered_details: false,
    loading: false
  };

  service.open = open;
  service.close = close;
  service.makePreview = makePreview;
  service.monitorFormState = monitorFormState;
  service.showPreviewModal = showPreviewModal;

  var deferred;

  function showPreview() {
    service.data.step = 'preview';
    service.data.loading = true;
    $timeout(function() {
      angular.element('#credential-preview').on('load', function() {
        service.trigger('loaded'); // Send an event to the controller to inform it that the iframe has loaded
      });
    });
  }

  function makePreview() {
    if (service.data.sent_group_id !== service.data.group.id || service.data.sent_name !== service.data.name || service.data.sent_email !== service.data.email) {
      service.data.step = 'loading';
      LegacyCredentialService
        .sendPreview(service.data.group, service.data.name, service.data.email, service.data.entered_details)
        .then(function (response) {
          AnalyticsService.trackEvent('Credential > Preview Sent');
          service.data.url = $sce.trustAsResourceUrl(response.url);
          service.data.sent_group_id = service.data.group.id;
          service.data.sent_name = service.data.name;
          service.data.sent_email = service.data.email;
          showPreview();
        })
        .catch(function () {
          service.data.step = 'error';
        });
    } else {
      showPreview();
    }
  }

  function open(group) {
    service.data.group = group;
    service.data.visible = true;
    makePreview();
  }

  function close() {
    service.data.visible = false;
    deferred.resolve();
  }

  var formDirty;
  function monitorFormState($element, $scope) {
    formDirty =  false;
    function setDirty(event, dirty) {
      formDirty = dirty;
    }
    $element.on('formdirty', setDirty); // The 'formdirty' event is raised by the <save-status> component
    $scope.$on('$destroy', function() {
      $element.off('formdirty', setDirty);
    });
  }

  function showPreviewModal(group) {
    deferred = $q.defer();

    if (formDirty) {
      alertService
        .confirm(
          'Unsaved Changes',
          'You have unsaved changes that will not appear in the credential preview.',
          'preview-anyway'
        )
        .then(function() {
          open(group);
        })
        .catch(function() {
          // Handle cancel rejection
          deferred.reject();
        });
    } else {
      open(group);
    }

    return deferred.promise;
  }
}

// Controller
credentialPreviewComponentController.$inject = ['CredentialPreviewService', 'sharePreviewModalService', '$scope'];
function credentialPreviewComponentController(CredentialPreviewService, sharePreviewModalService, $scope) {
  var ctrl = this;

  ctrl.data = CredentialPreviewService.data;
  ctrl.close = CredentialPreviewService.close;
  ctrl.makePreview = CredentialPreviewService.makePreview;

  ctrl.enterDetails = function() {
    if (!ctrl.data.entered_details) {
      ctrl.data.name = '';
      ctrl.data.email = '';
    }
    ctrl.data.step = 'details';
  };

  ctrl.viewCredential = function() {
    ctrl.data.entered_details = true;
    ctrl.makePreview();
  };

  ctrl.sharePreview = function() {
    sharePreviewModalService.show(ctrl.data.url.toString());
  };

  ctrl.$onDestroy = function() {
    ctrl.close();
  };

  // Receive an event to from the service that the iframe has loaded
  CredentialPreviewService.on('loaded', function() {
    $scope.$apply(function() {
      ctrl.data.loading = false;
    });
  });
}

angular
  .module('app')
  .service('CredentialPreviewService', CredentialPreviewService)
  .component('credentialPreview', credentialPreviewComponent);


},{}],105:[function(require,module,exports){

angular.module('app')
  .controller('CreateCredentialsFormCtrl', ['$scope', 'api', 'LegacyCredentialService', 'AnalyticsService', '$state', 'resolvedGroup', 'attributeService', 'alertService', 'resolvedDepartment', '$timeout', 'EmbedAppService',
    function($scope, api, LegacyCredentialService, AnalyticsService, $state, resolvedGroup, attributeService, alertService, resolvedDepartment, $timeout, EmbedAppService) {

      // The interface shouldn't lead the issuer to this page unless they can create credentials, silently redirect if needed
      if (!resolvedGroup || !resolvedGroup.can_create_credential) {
        $timeout(function(){
          $state.go('issuer.dashboard.group.edit', { id: resolvedGroup.id, edit: 'information-and-appearance' });
        });
      }

      // Read the attributes from the service
      $scope.attributes = [];
      attributeService.getAttributesList(false, 'embedded')
        .then(function(attributes) {
          $scope.attributes = attributes;
        });

      // Hoist some variables
      $scope.group = resolvedGroup;
      $scope.department = resolvedDepartment;
      $scope.courseFields = {}; // API groups need somewhere to put data
      $scope.method; // Upload method `form` or `upload`
      $scope.step = 'input'; // Which step are we on? `input`, `validating`, `review`, `processing`, `success`
      $scope.numberUploaded; // Number of credentials we uploaded

      // Sets the input method, resetting as we go
      var setStep = function(step) {
        $scope.step = step;
      };

      // By default we just show required attributes on the credentials form
      $scope.formInput = {
        showOptional: false
      };

      //  Create Credentials :: Step 0 - Reset
      //
      //  Copied from uploadCredentials.js and modified so the behaviour
      //  for this branch is similar -JF
      //
      function reset(skipConfirm) {
        if (skipConfirm) {
          $timeout(function(){
            $state.go('issuer.dashboard.upload-credentials', { group: $scope.group.id, intention: 'create' });
          });
        } else {
          alertService.confirm('Are you sure you would like to reset?')
            .then(function() {
              $timeout(function(){
                $state.go('issuer.dashboard.upload-credentials', { group: $scope.group.id, intention: 'create' });
              });
            });
        }
      }
      $scope.reset = reset;

      $scope.credentials = []; // Array of manually-added credentials
      $scope.resetForm = function() {
        setStep('input');
        $scope.disableFormSubmit = false;
        $scope.credentials.length = 0;
        $scope.addCredentialRow();
      };
      $scope.addCredentialRow = function() {
        $scope.credentials.push({
          credential: {
            issued_on: 'today', // This is the only value we can confidently default
          },
          recipient: {},
          custom: {},
        });
      };
      $scope.removeCredentialRow = function(index) {
        if ($scope.credentials.length > 1) {
          $scope.credentials.splice(index, 1);
        }
      };
      $scope.doCreateFromForm = function(formCtrl) {
        var parsed = parseFormCredentials();
        setStep('validating');
        LegacyCredentialService.generateCredentials(parsed)
          .then(function() {
            AnalyticsService.trackEvent('Add Credentials > Form Submission');
            setStep('success');
            $scope.numberUploaded = parsed.length;
          })
          .catch(function(errors) {
            // Show errors
            var errorsHtml = api.parseErrorsToHtml(errors, true);
            alertService.alert('Credentials could not be added', errorsHtml);
            setStep('input');
            formCtrl.$setPristine(); // Reset the form
          });
      };
      // Converts the { credential } object (with 'dot.notation' keys) into a structured object
      var parseFormCredentials = function() {
        var parsed = [];
        angular.forEach($scope.credentials, function(credential) {
          // Copy the credential
          var tmp = angular.copy(credential);
          // Add the group details
          tmp.group_id = $scope.group.id;
          tmp.name = $scope.group.course_name || $scope.courseFields.course_name;
          tmp.description = $scope.group.course_description || $scope.courseFields.course_description;
          // Copy the CREDENTIAL values up to the root object
          angular.forEach(tmp.credential, function(value, key) {
            tmp[key] = value;
          });
          delete tmp.credential;
          // Update
          parsed.push(tmp);
        });
        return parsed;
      };
      // Filter: is this a visible field?
      var visibleTags = ['recipient.name', 'recipient.email', 'credential.issued_on', 'credential.expired_on', 'credential.license_id', 'recipient.id'];
      $scope.isAttributeVisible = function(attribute) {
        return visibleTags.indexOf(attribute.tagName) !== -1 || attribute.parent == 'custom'; // Whitelist, or "custom" attribute
      };
      // Filter: is this a required field?
      var requiredTags = ['recipient.name', 'recipient.email', 'credential.issued_on'];
      var additionalTags = [];
      if ($scope.group.auto_expiry) {
        additionalTags.push('credential.expired_on');
      }
      $scope.isAttributeRequired = function(attribute) {
        return requiredTags.indexOf(attribute.tagName) !== -1; // Whitelist
      };
      // Filter: is this NOT a required field?
      $scope.isAttributeNotRequired = function(attribute) {
        return requiredTags.indexOf(attribute.tagName) === -1 && additionalTags.indexOf(attribute.tagName) === -1; // Blacklist
      };
      // Filter: is this an additional field?
      $scope.isAttributeAdditional = function(attribute) {
        return additionalTags.indexOf(attribute.tagName) !== -1; // Whitelist
      };
      // Filter: is this attribute read only? - just credential.id right now
      var readOnlyTags = ['credential.id', 'credential.url', 'issuer.name', 'group.course_name', 'group.course_description'];
      $scope.isAttributeWriteable = function(attribute) {
        return readOnlyTags.indexOf(attribute.tagName) === -1; // Blacklist
      };

      // Reset to use the form by default
      $scope.resetForm();

      $scope.setCredentialsListData = function(group) {
        var data = {
          filters: {
            status: { field: 'approve', value: false },
            selectedGroups: [{ id: group.id, name: group.name }],
            sort: { active: 'issued_on', direction: 'desc' },
          }
        };
        EmbedAppService.setData(data);
      }
    }
  ]);

},{}],106:[function(require,module,exports){
angular.module('app').controller('CredentialCtrl', [
  '$scope',
  'resolvedCredential',
  'resolvedGroup',
  '$state',
  '$stateParams',
  'credentialExpiryModalService',
  'swalService',
  'AnalyticsService',
  'LegacyCredentialService',
  'api',
  'attributeService',
  'languageService',
  'recipientLinkModalService',
  'ENV',
  'StateCacheService',
  '$timeout',
  function (
    $scope,
    resolvedCredential,
    resolvedGroup,
    $state,
    $stateParams,
    credentialExpiryModalService,
    swalService,
    AnalyticsService,
    LegacyCredentialService,
    api,
    attributeService,
    languageService,
    recipientLinkModalService,
    ENV,
    StateCacheService,
    $timeout
  ) {
    $scope.credential = resolvedCredential;
    $scope.group = resolvedGroup; // This seems to be necessary for the group template to load in
    $scope.groupId = $stateParams.groupId;
    $scope.credentialsSubRoute = StateCacheService.recallRouteView('issuer.dashboard.credentials') || 'list'; // REINSTATE - the sub-route to return to
    $scope.view = 'certificate';

    $scope.verifyUrl = 'https://' + ENV.prefix + 'verify.accredible.com/input?type=id&value=' + $scope.credential.id + '&custom=' + $scope.credential.is_custom;
    if($scope.credential.private){
      $scope.verifyUrl += '&key=' + $scope.credential.private_key;
    }
    var credentialNetUrl = 'https://' + (ENV.prefix === '' ? 'www.' : ENV.prefix) + 'credential.net';
    $scope.walletUrl = credentialNetUrl + '/profile/' + $scope.credential.username + '/wallet';
    $scope.issuerUrl = credentialNetUrl + '/issuer/' + $scope.credential.issuer.id;
    $scope.groupUrl  = credentialNetUrl + '/group/' + $scope.credential.group.id;

    if ($scope.credential.grade) {
      $scope.credential.grade = parseFloat($scope.credential.grade);
    }

    // We need to specify the language selected by the group - use english if this isn't set
    languageService.setLocale(resolvedGroup.language || 'en');

    // Read the attributes from the service
    $scope.attributes = [];
    attributeService.getAttributesList(false, 'embedded').then(function(attributes) {
      $scope.attributes = attributes;
      // When `parent="credential"`, we COPY those values to their own object for simpler access (see HTML)
      $scope.credential.credential = {};
      angular.forEach($scope.attributes, function(attribute) {
        if (attribute.parent == 'credential') {
          $scope.credential.credential[attribute.key] =
            $scope.credential[attribute.key];
        }
      });
      // Now, watch that new object, and copy any changes to their original place
      $scope.$watchCollection('credential.credential', function() {
        angular.forEach($scope.attributes, function(attribute) {
          if (attribute.parent == 'credential') {
            $scope.credential[attribute.key] =
              $scope.credential.credential[attribute.key];
          }
        });
      });
    });

    // Filter: is this a visible field?
    var visibleTags = [
      'recipient.id',
      'recipient.name',
      'recipient.email',
      'credential.issued_on',
      'credential.expired_on',
      'credential.license_id',
      'credential.grade'
    ];
    $scope.isAttributeVisible = function(attribute) {
      return (
        visibleTags.indexOf(attribute.tagName) !== -1 ||
        attribute.parent == 'custom'
      ); // Whitelist, or "custom" attribute
    };

    // Filter: is this a required field?
    var requiredTags = [
      'recipient.name',
      'recipient.email',
      'credential.issued_on'
    ];
    $scope.isAttributeRequired = function(attribute) {
      return requiredTags.indexOf(attribute.tagName) !== -1; // Whitelist
    };

    // Update is pretty simple
    $scope.updateCredential = function(formCtrl) {
      LegacyCredentialService.updateCredential($scope.credential)
        .then(function() {
          AnalyticsService.trackEvent('Credential > Update Credential');
          swalService.showAlert('editCredentialSuccess');
          $state.reload();
        })
        .catch(function(err) {
          if (err.status === 422) {
            if (err.data.errors.expired_on) {
              swalService.showAlert('editCredentialExpiryInvalid');
            } else if (err.data.errors.grade) {
              swalService.showAlert('editCredentialGradeInvalid');
            } else {
              swalService.showAlert('editCredentialInvalid', api.parseErrorsToString(err, true));
            }
          } else {
            swalService.showAlert('editCredentialInvalid', err.status);
          }
          formCtrl.$setPristine(); // Reset the form
          formCtrl.$setDirty(); // Then mark it as dirty as the value wasn't saved
        });
    };

    $scope.publishCredential = function(credential) {
      swalService.confirm(
        'Publishing this Credential will also notify the student via email.',
        function() {
          // Now publish
          api
            .request('/credentials/publish', {
              credential_ids: [credential.id]
            })
            .then(function(response) {
              AnalyticsService.trackEvent('Credential > Publish Credential');
              var numCredentials = _.at(response, 'credential_ids.length')[0]; // Use "at" so we don't have to check the existence of each property
              swalService.showAlert('issuerPublishSuccess', response);
              // Now update our local data
              credential.approve = true;
            })
            .catch(function(err) {
              if (err.status == 402) {
                swalService.showAlert('issuerPublishFailureCredits');
              } else if (err.status !== 453) {
                swalService.showAlert('issuerPublishFailureGeneral');
              }
            });
        },
        'Publish Credential',
        'Confirm',
        '#37bdb1',
        null,
        true
      );
    };

    $scope.expireCredential = function(credential) {
      credentialExpiryModalService
        .show({
          credential_ids: [credential.id]
        },
        credential.expired_on || 'none') // Distinguish between non-single selection and no expiry date
        .then(function() {
          AnalyticsService.trackEvent('Credential > Expire Credential');
          // Now refresh our local data
          LegacyCredentialService.getSingleCredential(credential.id).then(function(response) {
            $scope.credential.credential = response;
            $scope.credential.expired = response.expired; // Explicitly set expired to update on screen message
          });
        });
    };

    $scope.resendCredential = function(credential) {
      var confirmFunction = function() {
        credential.selected = true;
        LegacyCredentialService.resendEmail([credential])
          .then(function() {
            AnalyticsService.trackEvent('Credential > Resend Credential');
            swalService.showAlert('issuerResendSuccess');
          })
          .catch(function(err) {
            if (err.status !== 453) {
              swalService.showAlert('issuerResendFailure');
            }
          });
      };
      swalService.confirm(
        'Are you sure you want to send an email to the selected student?',
        confirmFunction,
        'Email Credential',
        'Yes, send email',
        '#2F9A4A',
        null,
        true
      );
    };

    $scope.deleteCredential = function(credential) {
      var confirmFunction = function() {
        credential.selected = true;
        LegacyCredentialService.deleteCredentials([credential])
          .then(function(response) {
            AnalyticsService.trackEvent('Credential > Delete Credential');
            swalService.showAlert('issuerCredentialsDeletedSuccess');
            $timeout(function(){
              $state.go('issuer.dashboard.credentials.list', { group: $scope.groupId });
            });
          })
          .catch(function(err) {
            if (err.status === 453) {
              swalService.showAlert(
                'missingPermissions',
                'delete Credentials'
              );
            } else {
              swalService.showAlert('issuerDeleteCredentialsFailure');
            }
          });
      };
      swalService.confirm(
        'Deleting these Credentials will also remove them from the recipient\'s account.',
        confirmFunction,
        null,
        'Confirm',
        null,
        null,
        true
      );
    };

    $scope.getSSOLink = function() {
      api
        .request('/credentials/get_recipient_sso_link', {
          credential_id: $scope.credential.id
        })
        .then(function(response) {
          recipientLinkModalService.show(response.link);
        })
        .catch(function() {
            swalService.showAlert('issuerGetSSOLinkErrorTryLater');
        });
    };

    // Do we own this Credential?
    $scope.ownCredential = function() {
      return false;
    };
    // Can we edit this Credential? Actually, in this case this only allows us to delete evidence items.
    $scope.canEditCredential = function() {
      return true;
    };
  }
]);

},{}],107:[function(require,module,exports){
CredentialsCtrl.$inject = ['$state', '$stateParams', '$window', 'resolvedGroup', 'api', 'swalService', 'credentialExpiryModalService', 'downloadPdfsModalService', 'downloadCsvModalService', '_', 'AnalyticsService', 'alertService', 'attributeService', 'chooseGroupModalService', 'NameChangeRequestsService', 'StateCacheService', '$timeout', 'DepartmentAnalyticsService', 'resolvedDepartment'];
function CredentialsCtrl($state, $stateParams, $window, resolvedGroup, api, swalService, credentialExpiryModalService, downloadPdfsModalService, downloadCsvModalService, _, AnalyticsService, alertService, attributeService, chooseGroupModalService, NameChangeRequestsService, StateCacheService, $timeout, DepartmentAnalyticsService, resolvedDepartment) {
  var ctrl = this;

  // Scoped variables up top, a quick reference point for our designers
  ctrl.loading = true; // Are we busy making a request?
  ctrl.error = false; // Have we an error message? (FALSE or "error message")
  ctrl.credentials = []; // Array of visible credentials
  ctrl.selection = false; // What is selected? false, [ id, id, id ] or 'everything'
  ctrl.canPublish = false; // Can we publish the selected credentials?
  ctrl.canResendEmail = false; // Can we resend the email for the selected credentials?
  ctrl.canDownloadPDFs = false; // Can we download the selected credential PDFs?
  ctrl.canDownloadCSV = false; // Can we download the selected credential CSV?
  ctrl.canExpire = false; // Can we expire the selected credentials?
  ctrl.canDelete = false; // Can we delete the selected credentials?
  ctrl.canMoveCredentials = false; // Can we move the selected credentials?
  ctrl.emptyPayload = true; // Is the payload empty?
  ctrl.intention = $stateParams.intention; // The "intention" from the URL
  ctrl.modal = false; // Which modal to show?
  ctrl.group = resolvedGroup; // This is only set on the "Group Credentials" route
  ctrl.meta = false; // Meta data from the response

  // Filter start states
  ctrl.showSearch = true;
  ctrl.showDates = true;
  ctrl.showStatus = true;
  ctrl.showEngagement = true;

  ctrl.department = resolvedDepartment;

  // To make the text search useful we need the attributes - we specifically whitelist them and then use the attributes service to grab custom attribute keys
  ctrl.attributes = ['private:true','private:false'];
  attributeService.getAttributesList(false , 'embedded').then(function(result){
    for (var i = result.length - 1; i >= 0; i--) {
      if (result[i].parent == 'custom') {
        ctrl.attributes.push(result[i].key + ':');
      }
    }
  });

  // Name Change Requests
  ctrl.pendingNameChangeRequests = 0;
  NameChangeRequestsService
    .search({ page_size: 1, page: 0, order: null })
    .then(function(response) {
      ctrl.pendingNameChangeRequests = response.meta.total_count;
    });

  // Our search / filter form - it should be linked to the form models
  ctrl.form = StateCacheService.resolveCache({ // REINSTATE - loads the cached state or returns the object passed in
    page_size: 50,
    page: '',
    start_date: '',
    end_date: '',
    text: '',
    custom_attribute: {},
    status: '',
    linkedin: '',
    engagement: '',
    order: '',
    job_id: $stateParams.job_id,
  });

  // Status
  ctrl.statusOptions = [
    { value: '',            title: 'Any' },
    { value: 'published',   title: 'Published' },
    { value: 'expired',     title: 'Expired' },
    { value: 'bounced',     title: 'Bounced' },
    { value: 'unpublished', title: 'Unpublished' },
  ];

  // Engagement
  ctrl.engagementOptions = [
    { value: '',            title: 'Any' },
    { value: 'linkedin',    title: 'Has shared on LinkedIn' },
    { value: 'notlinkedin', title: 'Has not shared on LinkedIn' },
    { value: 'engaged',     title: 'Has engaged' },
    { value: 'notengaged',  title: 'Has not engaged' },
  ];

  var cachedScroll = ctrl.form.scroll; // REINSTATE - locally cache the state-cached scroll and clear the filter value
  ctrl.form.scroll = null;

  // Job attributes
  ctrl.completed_time = $stateParams.completed_time;
  ctrl.username = $stateParams.username;

  // Functional methods
  ctrl.doSubmitForm = submitForm;
  ctrl.doResetForm = doResetForm;
  ctrl.removeGroupFilter = removeGroupFilter;
  ctrl.removeJobFilter = removeJobFilter;
  ctrl.hideModal = hideModal;
  ctrl.doPublish = doPublish;
  ctrl.doResendEmail = doResendEmail;
  ctrl.doDownloadPDFs = doDownloadPDFs;
  ctrl.doDownloadCSV = doDownloadCSV;
  ctrl.doMoveCredentials = doMoveCredentials;
  ctrl.showExpireModal = showExpireModal;
  ctrl.doDelete = doDelete;
  ctrl.updatePagination = updatePagination;
  ctrl.updateOrderBy = updateOrderBy;
  ctrl.updateSelection = updateSelection;
  // The route may include an intention, these dictate the initial form values
  switch (ctrl.intention) {
    case 'unpublished':
      ctrl.form.status = 'unpublished';
      break;
    case 'recentlyExpired':
      ctrl.form.status = 'expired';
      break;
  }
  // Begin by submitting the form
  submitForm();
  // Dismisses the intention and modifies the route
  function dismissIntention() {
    ctrl.intention = null;
    $timeout(function(){
      $state.go('.', {
        intention: null
      }, {
        location: 'replace',
        reload: false,
      });
    });
  }
  /** SEARCH FORM
   *
   *        ctrl.form      Are the variables we allow the user to interact with on the form,
   *                          they will be dirtied as the user changes the values.
   *        var payload      This is an abstraction of ctrl.form. Simply the
   *                          API uses different variable names and we even abstract multiple
   *                          variables into a single "state" for credentials. See "getPayload"
   */
  // Returns a payload to be used with the API
  function getPayload() {
    // Clone the form into an object for manipulation
    var payload = {};
    angular.copy(ctrl.form, payload);
    // Add the group_id (if available)
    payload.group_id = ctrl.group ? ctrl.group.id : '';
    // Parse the text search for custom_attribute style parameters
    payload.custom_attribute = {};
    if (payload.hasOwnProperty('text') && payload.text.length > 0){
      // Comma separated search params
      var searchStrings = payload.text.split(',');
      for (var i = searchStrings.length - 1; i >= 0; i--) {
        // Each search param is name:value
        var splitSearchString = searchStrings[i].split(':');
        if(splitSearchString.length == 2){
          // Add the param to the search query
          payload.custom_attribute[splitSearchString[0].trim()] = splitSearchString[1].trim();
          // Remove the param from the text field
          payload.text = payload.text.replace(searchStrings[i], '');
        }
      }
      // Strip any remaining commas out of the text field that's left
      payload.text = payload.text.replace(',', '');
    }
    // Remove NULL or '' values (keeping BOOLEAN and non-empty STRINGS)
    payload = _.omitBy(payload, function(v) {
      return (v === null || v === '');
    });
    // Deal with API oddities
    switch (payload.status) {
      case 'published':
        payload.published = true;
        break;
      case 'expired':
        payload.expired = true;
        break;
      case 'bounced':
        payload.bounced_email = true;
        break;
      case 'unpublished':
        payload.unapproved = true;
        break;
    }
    delete payload.status;
    // Linkedin?
    if (payload.hasOwnProperty('linkedin')) {
      payload.is_added_to_linkedin = payload.linkedin;
      delete payload.linkedin;
    }
    // Engagement?
    if (payload.hasOwnProperty('engagement')) {
      payload.recipient_engaged = payload.engagement;
      delete payload.engagement;
    }
    // Return the clean and ready payload object
    return payload;
  }
  // Submits the form
  function submitForm(opts) {
    // We may want to reset the Page number
    if (opts && opts.resetPage) {
      ctrl.form.page = 0;
    }
    // Get the payload
    var payload = getPayload();
    // Is the payload empty?
    ctrl.emptyPayload = _(payload)
      .omit(['page_size', 'page', 'group_id', 'custom_attribute', 'job_id']) // Ignore the page, page_size, group_id, custom_attribute and job_id values
      .omitBy(function(prop) { return !prop; }) // Remove empty values
      .isEmpty(); // Is the new object empty? {}
    // Make the request, update the scope, return the promise
    ctrl.loading = true;
    return api.request('/credentials/all', payload)
      .then(function(response) {
        AnalyticsService.trackEvent('All Credentials > Search Credentials');
        ctrl.loading = false;
        ctrl.credentials = response.issuer.credentials;
        ctrl.meta = response.meta;
        $timeout(function() {
          $window.scrollTo(0, cachedScroll || 0); // Scroll to cached value or scroll to the top
          cachedScroll = null; // Clear locally cached value
        });
        StateCacheService.setCache(ctrl.form); // REINSTATE - cache the new form values
      })
      .catch(function(err) {
        ctrl.loading = false;
        ctrl.credentials = [];
        ctrl.error = 'Failure! ' + JSON.stringify(err);
      });
  }
  // Resets the form
  function doResetForm() {
    dismissIntention();
    // Reset all values apart from the page-size
    _(ctrl.form).forEach(function(value, key) {
      if (key != 'page_size') {
        ctrl.form[key] = '';
      }
    });
    StateCacheService.setCache(ctrl.form); // REINSTATE - cache the new form values
    // ...then submit
    return submitForm({ resetPage: true });
  }
  // Removes an item from the form and submits
  function removeGroupFilter() {
    ctrl.form.page = 0;
    StateCacheService.setCache(ctrl.form); // REINSTATE - cache the new page value
    $timeout(function(){
      $state.go($state.current.name, { group:null }, { reload:false, location:'replace' }); // Update the URL
    });
  }
  // Removes the spreadsheet upload job id from the form and submits
  function removeJobFilter() {
    ctrl.form.page = 0;
    StateCacheService.setCache(ctrl.form); // REINSTATE - cache the new page value
    $timeout(function(){
      $state.go($state.current.name, { job_id:null, completed_time:null, username:null }, { reload:false }); // Update the URL
    });
  }
  // Update the page number
  function updatePagination(event){
    ctrl.form.page = event.page;
    submitForm();
  }
  // Update the order by
  function updateOrderBy(event){
    ctrl.form.order = event.order;
    submitForm({ resetPage: true });
  }
  // Update the order by
  function updateSelection(event){
    ctrl.selection = event.selection;
    updateActions();
  }
  /** SELECTION ACTIONS
   *
   *    WIP
   */
  // Call this after changing the selection to update the available actions
  function updateActions() {
    ctrl.canPublish = false;
    ctrl.canResendEmail = false;
    ctrl.canDownloadPDFs = false;
    ctrl.canDownloadCSV = false;
    ctrl.canMoveCredentials = false;
    ctrl.canDelete = false;
    ctrl.canExpire = false;
    if (ctrl.selection === 'everything') {
      ctrl.canPublish = true;
      ctrl.canResendEmail = true;
      ctrl.canDownloadCSV = true;
      ctrl.canMoveCredentials = !!ctrl.group; // We don't allow credentials from multiple groups that are spread across multiple pages to be moved into a single group
      ctrl.canDownloadPDFs = false; // We don't want the user to request 1,000's of PDFs
      ctrl.canDelete = true; // Not just yet! We need the issuer to be able to recover from this
      ctrl.canExpire = false; // Not just yet.
    } else if (ctrl.selection) {
       // We can delete, download or move anything
      ctrl.canDelete = true;
      ctrl.canDownloadCSV = true;
      ctrl.canMoveCredentials = true;
      // Reference all selected Credentials
      var selectedCredentials = _.filter(ctrl.credentials, function(credential){
        return ctrl.selection.indexOf(credential.id) != -1;
      });
      // If we've anything selected and unpublished - we can publish
      ctrl.canPublish = _.some(selectedCredentials, {
        'approve': false
      });
      // We can resend email to those with a published credential
      ctrl.canResendEmail = _.some(selectedCredentials, {
        'approve': true,
        'expired': false
      });
      // We can download the PDF to published Credentials WITH a Certificate Design (INCLUDING expired certs!)
      ctrl.canDownloadPDFs = _.some(selectedCredentials, {
        'approve': true
      }) && _.some(selectedCredentials, function(credential) {
        return credential.certificate_design_id;
      });
      // We can always set an expiry date, even if the credential is not published (approved)
      ctrl.canExpire = true;
    }
  }
  // Returns a payload. For multi-page selections we use a normal payload object, otherwise just an array of selected credential IDs
  function getPayloadForActions(singleCredential) {
    if (singleCredential) {
      // Use only the Id of the individual credential passed in
      return {
        'credential_ids': [ singleCredential.id ]
      };
    } else if (ctrl.selection === 'everything') {
      // Use the payload, but strip out the order and pagination, add an extra flag for the API
      var payload = getPayload();
      delete payload.order;
      delete payload.page;
      delete payload.page_size;
      payload.search = true;
      return payload;
    } else {
      // Use the selected credential ids
      return {
        'credential_ids': ctrl.selection
      };
    }
  }

  function hideModal() {
    ctrl.modal = false;
  }

  function doPublish(singleCredential) {
    if (singleCredential || ctrl.canPublish) {
      var message = [];
      // Will we email them?
      if(resolvedGroup && !resolvedGroup.allow_email) {
        message.push('Heads Up! Recipient Email notifications are turned off for this Group.');
      } else {
        message.push('Publishing will notify the recipients via Email.');
      }
      // ...
      alertService
        .confirm('Publish Credentials?', message)
        .then(function(){
          var payload = getPayloadForActions(singleCredential);
          return api.request('/credentials/publish', payload);
        })
        .then(function(response) {
          AnalyticsService.trackEvent('All Credentials > Publish Credentials');
          swalService.showAlert('issuerPublishSuccess', response);
          DepartmentAnalyticsService.reset();
          submitForm();
        })
        .catch(function(err) {
          if (err.status == 402) {
            swalService.showAlert('issuerPublishFailureCredits');
          }
        });
    }
  }

  function doResendEmail(singleCredential) {
    if (singleCredential || ctrl.canResendEmail) {
      // If we have email turned on
      if (!resolvedGroup || resolvedGroup.allow_email) {
        var message = 'Are you sure you want to send a reminder email to the selected Credential Recipients?';
        alertService
          .confirm('Resend Email?', message)
          .then(function(){
            var payload = getPayloadForActions(singleCredential);
            return api.request('/credentials/resend_email', payload);
          })
          .then(function(response) {
            AnalyticsService.trackEvent('All Credentials > Resend Email for Credentials');
            var numCredentials = _.at(response, 'credential_ids.length')[0]; // Use "at" so we don't have to check the existence of each property
            swalService.showAlert('issuerResendSuccess', numCredentials);
          })
          .catch(function(err) {
            if(err.status){
              swalService.showAlert('issuerResendFailure');
            }
          });
      } else {
        alertService.alert('Recipient Emails are turned off for this Group', 'Turn email on in your Group settings to be able to deliver email.');
      }
    }
  }

  function doDownloadPDFs() {
    if (ctrl.canDownloadPDFs) {
      // Create a message to explain
      var numSelected = ctrl.selection.length;
      var numWithCertificates = _.filter(ctrl.credentials, function(credential){
        return ctrl.selection.indexOf(credential.id) != -1 && credential.approve == true && credential.expired == false && credential.certificate_design_id;
      }).length;
      var numWithoutCertificates = numSelected - numWithCertificates;
      var message = 'You will receive a zip file of ' + numWithCertificates + ' Certificate PDFs.';
      if (numWithoutCertificates) {
        message += '\n\n' + numWithoutCertificates + ' of the selected Credentials will not be included in the zip. They may be unpublished, expired, or the Group does not have a Certificate Design.';
      }
      // Grab the payload and open the modal
      var payload = getPayloadForActions();
      downloadPdfsModalService.show(payload, message);
    }
  }

  function doDownloadCSV() {
    if (ctrl.canDownloadCSV) {
      var payload = getPayloadForActions();
      downloadCsvModalService.show(payload);
    }
  }

  function showExpireModal(singleCredential) {
    var payload = getPayloadForActions(singleCredential);
    // If singleCredential is not passed in, but only one credential is selected, get that credential
    if (!singleCredential && payload.credential_ids.length == 1) {
      singleCredential = ctrl.credentials.filter(function(credential) {
        return credential.id == payload.credential_ids[0];
      })[0];
    }
    // If only one credential get it's expiry date
    var single_expiry_date;
    if (singleCredential) {
      single_expiry_date = singleCredential.expired_on || 'none'; // Distinguish between non-single selection and no expiry date
    }
    credentialExpiryModalService.show(payload, single_expiry_date)
      .then(function() {
        submitForm();
      });
  }

  function doDelete(singleCredential) {
    if (singleCredential || ctrl.canDelete) {
      // Warn
      var message = 'Deleting the selected Credentials will remove them from recipients\' accounts.';
      alertService
        .confirm('Delete Credentials?', message)
        .then(function(){
          var payload = getPayloadForActions(singleCredential);
          return api.request('/credentials/delete', payload);
        })
        .then(function(response) {
          AnalyticsService.trackEvent('All Credentials > Delete Credentials');
          var numCredentials = _.at(response, 'credential_ids.length')[0]; // Use `at` so we don't have to check the existence of each property
          swalService.showAlert('issuerCredentialsDeletedSuccess', numCredentials);
          submitForm();
        })
        .catch(function(err) {
          if(err.status){
            swalService.showAlert('issuerDeleteCredentialsFailure');
          }
        });
    }
  }

  function doMoveCredentials() {
    if (ctrl.canMoveCredentials){
      chooseGroupModalService.show('move').then(function(group) {
        var message = [];
        if (ctrl.selection === 'everything') {
          message.push(
            'Move <strong>all</strong> credentials from group <strong>' +
            ctrl.group.name + '</strong> to <strong>' + group.name + '</strong>.'
          );
        } else {
          message.push(
            'Move <strong>' + ctrl.selection.length + '</strong> ' +
            (ctrl.selection.length === 1 ? 'credential' : 'credentials') + ' to <strong>' + group.name + '</strong>.'
          );
        }
        message.push(
          '<div class="message warning">\
            <p>\
              Information such as course name, description and certificate/badge design will be updated with the new group\'s settings.\
            </p>\
          </div>'
        );
        alertService
          .confirm('Move Credentials to a Different Group?', message, 'move_credentials')
          .then(function () {
            var payload = {
              group_id: group.id,
              credential_ids: ctrl.selection, // Credential id array or 'everything'
              source_group_id: ctrl.selection === 'everything' ? ctrl.group.id : null
            };
            api.request('/credentials/move', payload)
              .then(function (response) {
                alertService.alert('Credentials Moved Successfully', 'The selected credentials have been moved to <strong>' + group.name + '</strong>.<br/><br/> You may want to resend these credentials since they were updated.');
                submitForm();
              })
              .catch(function (err) {
                swalService.showAlert('unknownFailure');
              });
          })
          .catch(function (rejection) {
            // Handle cancel rejection
          });
      })
      .catch(function(rejection) {
        // Handle cancel rejection
      });
    }
  }

  function doCreateCredentials(group) {
    if (!group.can_create_credential) {
      alertService
        .confirm(
          'This Group has no Design',
          [
            'You can create Credentials in this Group after you:',
            ' <strong><i class="certificate"></i> Add a Certificate Design</strong> or <strong><i class="badge-icon"></i> Add a Badge Design</strong>',
            'Would you like to do that now?',
          ]
        )
        .then(function () {
          $timeout(function(){
            $state.go('issuer.dashboard.group.edit', { id: group.id, edit: 'information-and-appearance' });
          });
        })
        .catch(function(rejection) {
          // Handle cancel rejection
          $timeout(function(){
            $state.go('issuer.dashboard.credentials.list', { group: null }, { reload: true });
          });
        });
    } else {
      $timeout(function(){
        $state.go('issuer.dashboard.upload-credentials', { group: group.id, intention: 'create' });
      });
    }
  }

  ctrl.credentialIdTooltip = function(credential) {
    return 'Secure hash: ' + credential.encoded_id + (credential.license_id ? '\nLicense Id: ' + credential.license_id : '');
  };

  // Show the "choose group" modal if the intention is to create credentials
  if($stateParams.intention == 'create'){
    chooseGroupModalService
      .show('create')
      .then(function(group) {
        doCreateCredentials(group);
      })
      .catch(function(rejection) {
        // Handle cancel rejection
        dismissIntention();
      });
  }
}

angular
  .module('app')
  .controller('CredentialsCtrl', CredentialsCtrl);

},{}],108:[function(require,module,exports){

(function() {
  angular.module('app')
    .controller('UploadCredentialsCtrl', ['$scope', '$stateParams', '$window', '$q', 'resolvedDepartment', 'resolvedGroup', 'resolvedUser', '_', 'attributeService', '$filter', '$timeout', 'uploadCredentialsService', 'alertService', 'fileSize', 'csv', 'AnalyticsService', 'EmbedAppService',
      function($scope, $stateParams, $window, $q, resolvedDepartment, resolvedGroup, resolvedUser, _, attributeService, $filter, $timeout, uploadCredentialsService, alertService, fileSize, csv, AnalyticsService, EmbedAppService) {

        // Hoist
        $scope.group = resolvedGroup;
        $scope.user = resolvedUser;
        $scope.department = resolvedDepartment;
        $scope.intention = $stateParams.intention; // The "intention" from the URL

        // Our main methods
        $scope.reset = reset;
        $scope.setStep = setStep;
        $scope.analyseFile = analyseFile;
        $scope.reviewColumnMap = reviewColumnMap;
        $scope.importSpreadsheet = importSpreadsheet;

        // Needed for API Groups (urgh)
        if (!$scope.group.course_name || !$scope.group.course_description) {
          $scope.course_name = "";
          $scope.course_description = "";
        }

        // Which step are we on?
        $scope.step = 'upload'; // upload, map, review, success

        function setStep(step) {
          var intention = $scope.intention.charAt(0).toUpperCase() + $scope.intention.slice(1);
          AnalyticsService.trackEvent('Import Credentials > ' + intention + ' > ' + step);
          $scope.step = step;
          $window.scrollTo(0, 0);
        }

        // Generates a CSV
        $scope.downloadCsv = function() {
          AnalyticsService.trackEvent('Import Credentials > Downloaded CSV Template');
          csv.generate();
        };

        // Step 0 - Reset
        function reset(skipConfirm) {
          if (skipConfirm) {
            setStep('upload');
          } else {
            alertService.confirm('Are you sure you would like to reset?')
              .then(function() {
                setStep('upload');
              });
          }
        }

        // Step 1 - Analyse the uploaded file
        function analyseFile(fileName, s3Bucket, s3Key, fileSizeBytes) {
          // Taylor the alert message to the size of the upload
          var alertMessage = '<p>Please wait while we analyze your spreadsheet.</p>'; // If tiny, this is all you see
          if (fileSizeBytes > fileSize.parse('0.5 MB')) {
            alertMessage += '<p>Your uploaded file is <strong>' + fileSize.human(fileSizeBytes) + '</strong>. This may take a moment.</p>'; // When larger, tell them to hang on
          }
          if (fileSizeBytes > fileSize.parse('2 Mb')) {
            alertMessage += '<p>Larger uploads take longer to analyze.</p>'; // When huge, warn that it will take a long time
          }
          // Analyse the file, show a progress alert
          var analysisPromise = uploadCredentialsService.analyseFile($scope.group.id, fileName, s3Bucket, s3Key);
          var alertPromise = alertService.progress('Validating Spreadsheet', alertMessage);
          // `race` resolves or rejects as soon as ANY of the promises resolves or rejects
          //  why is this useful? The isser can click cancel on the alert, or the upload can complete
          $q.race([
              analysisPromise,
              alertPromise,
            ])
            .then(function(spreadsheet) {
              alertService.close();
              setSpreadsheet(spreadsheet);
              setStep('map');
            })
            .catch(function(errors) {
              if (errors == 'user pressed cancel') {
                return; // Quietly close
              }
              var htmlErrors = parseErrorsIntoHtml(errors);
              alertService.alert('We could not analyze this file', htmlErrors);
            });
        }

        // Step 2 - Set the column map
        function reviewColumnMap() {
          // Taylor the alert message to the size of the upload
          var alertMessage = '<p>Please wait while we analyse your column assignments.</p>';
          // Analyse the file, show a progress alert
          var setMapPromise = uploadCredentialsService.reviewColumnMap(getColumnMap());
          var alertPromise = alertService.progress('Mapping Spreadsheet Columns', alertMessage);
          // `race` resolves or rejects as soon as ANY of the promises resolves or rejects
          //  why is this useful? The isser can click cancel on the alert, or the upload can complete
          $q.race([
              setMapPromise,
              alertPromise,
            ])
            .then(function(review) {
              alertService.close();
              setReview(review);
              setStep('review');
            })
            .catch(function(errors) {
              if (errors == 'user pressed cancel') {
                return; // Don't show any messages, but tidy up if needed
              }
              var htmlErrors = parseErrorsIntoHtml(errors);
              alertService.alert('We could not review the column map', htmlErrors);
            });
        }


        // Step 3 - Job progress (promise)
        var longPollPromise;

        function cancelLongPoll() {
          if (longPollPromise) {
            $timeout.cancel(longPollPromise);
          }
        }

        function longPollForProgress(jobId) {
          cancelLongPoll(); // Cancel any existing long poll
          return $q(function(resolve, reject) {
            var doLongPoll = function() {
              uploadCredentialsService.getImportProgress(jobId)
                .then(function(response) {
                  if (response.hasOwnProperty('total')) { // An "in progress" response has `processed` and `total` keys. Just check for `total`
                    alertService.setProgress(response.processed, response.total);
                    longPollPromise = $timeout(doLongPoll, 2500); // Check again in a moment
                  } else {
                    resolve(response);
                  }
                })
                .catch(function(err) {
                  reject(err);
                });
            };
            doLongPoll(); // And begin
          });
        }

        // Step 3 - Create the Credentials
        function importSpreadsheet() {
          // Taylor the alert message to the size of the upload
          var alertMessage = '<div class="message info text-left"><p><i class="email"></i> We will send you an email when this is complete.</p></div><div class="message text-left"><p>Please wait while we process any updates or create new credentials.<br>You may navigate away or leave this window.</p></div>';
          // Analyse the file, show a progress alert, long poll the job
          var createPromise = uploadCredentialsService.importSpreadsheet(getReviewConfirmation())
            .then(function(response) {
              return longPollForProgress(response.job_id);
            });
          var alertPromise = alertService.open({
            title: 'Processing Credentials',
            content: alertMessage
          });
          // `race` resolves or rejects as soon as ANY of the promises resolves or rejects
          //  why is this useful? The isser can click cancel on the alert, or the upload can complete
          $q.race([
              createPromise,
              alertPromise,
            ])
            .then(function(success) {
              alertService.close();
              setSuccess(success);
              setStep('success');
            })
            .catch(function(errors) {
              if (errors == 'user pressed cancel') {
                return; // Don't show any messages, but tidy up if needed
              }
              var htmlErrors = parseErrorsIntoHtml(errors);
              alertService.alert('We could not import this spreadsheet', htmlErrors);
            })
            .finally(function() {
              cancelLongPoll(); // Make sure no long-polling is running
            });
        }

        // Utility :: Parse errors
        // There is no defined structure for errors from BE, so this utility
        //  function massages the various known structures into a unified format.
        function parseErrors(errorResponse){
          if(errorResponse.data){
            if(angular.isArray(errorResponse.data.errors)){
              return errorResponse.data.errors; // { errors: [ ... ] }
            } else if (angular.isArray(errorResponse.data)) {
              return errorResponse.data; // [ ... ]
            } else if (angular.isString(errorResponse.data.error)) {
              return [ errorResponse.data.error ]; // { error: ... }
            } else if (angular.isString(errorResponse.data)) {
              return [ errorResponse.data ]; // ...
            }
          }
        }
        // ...wraps the above with HTML tags
        function parseErrorsIntoHtml(errorResponse){
          var errors = parseErrors(errorResponse);
          if(errors){
            return '<p>' + errors.join('</p><p>') + '</p>';
          }
        }

        /** COLUMN MAPPING :: ATTRIBUTES
         *
         *      Column mapping requires access to the attributes,
         *       make sure they're loaded.
         */
        var pristineAttributes; // A pristine set of attributes from the service
        $scope.attributes = [];
        $scope.getAttributeName = getAttributeName;
        $scope.getAttributeGroup = getAttributeGroup;
        $scope.isDateAttribute = isDateAttribute;
        $scope.isUidAttribute = isUidAttribute;
        $scope.attributeIsAllocated = attributeIsAllocated;

        // For rendering the attribute selection
        var evidenceFields = [];

        attributeService.getAttributesList(false, 'embedded')
          .then(function(attributes) {
            pristineAttributes = angular.copy(attributes);
            uploadCredentialsService
              .getEvidenceFields()
              .then(function(response){
                evidenceFields = response.csv;
                resetAttributes();
              });
          });

        function resetAttributes() {
          if (pristineAttributes) {
            $scope.attributes = [];
            // Massage (whitelist)
            for (var a = 0, al = pristineAttributes.length; a < al; a++) {
              var attribute = pristineAttributes[a];
              if (['recipient', 'credential', 'custom'].indexOf(attribute.parent) !== -1 && attribute.tagName != 'credential.grade') {
                $scope.attributes.push(attribute);
              }
            }
            // Add an evidence and reference
            addNameAttributes();
            addGradeAttributes();
            addEvidenceAttributes(1);
            addReferenceAttributes(1);
            // Now deal with the BE response
            parseSpreadsheetAttributes();
          }
        }

        function getAttributeName(attribute) {
          return $filter('attributeName')(attribute);
        }

        function getAttributeGroup(attribute) {
          return $filter('capitalize')(attribute.parent) + ' Attributes';
        }

        function attributeIsAllocated(attribute) {
          if (attribute == $scope.spreadsheet.columns[activeIndex].attribute) {
            return false; // Don't disable yourself
          }
          return _.some($scope.spreadsheet.columns, {
            'attribute': attribute,
            mapped: true
          });
        }

        function isDateAttribute(attribute) {
          return attribute && attribute.type == 'date';
        }

        function isUidAttribute(attribute) {
          return attribute && attribute.type == 'text';
        }
        // Converts any BE attribute best-guess "strings" with a useful {attribute} object
        function parseSpreadsheetAttributes() {
          if ($scope.attributes.length && $scope.spreadsheet.columns) {
            for (var c = 0, cl = $scope.spreadsheet.columns.length; c < cl; c++) {
              var column = $scope.spreadsheet.columns[c];
              if (typeof column.attribute == 'string') {
                automaticallyCreateAttributes(column.attribute);
                column.attribute = _.find($scope.attributes, {
                  'tagName': column.attribute
                }); // Replace the `attribute.tag` with the full {attribute} object - or null
                column.mapped = true;
              } else {
                column.attribute = null;
              }
            }
          }
        }
        // Makes sure that any "incremental" attributes are available in the attributes array
        function automaticallyCreateAttributes(tagName) {
          var m = /^(evidence|reference)(\d+)/g.exec(tagName);
          if (m) {
            if (m[1] == 'evidence') {
              addEvidenceAttributes(m[2]);
            } else if (m[1] == 'reference') {
              addReferenceAttributes(m[2]);
            }
          }
        }
        // Adds the non-standardised first-name and last-name
        function addNameAttributes() {
          if (!_.find($scope.attributes, {
              'tagName': 'recipient.first_name'
            })) {
            $scope.attributes.push({
              name: 'Recipient First Name',
              parent: 'recipient',
              tagName: 'recipient.first_name',
            });
            $scope.attributes.push({
              name: 'Recipient Last Name',
              parent: 'recipient',
              tagName: 'recipient.last_name',
            });
          }
        }
        // Adds extended grade attributes
        function addGradeAttributes() {
          if (!_.find($scope.attributes, {
              'tagName': 'grade.grade'
            })) {
            $scope.attributes.push({
              name: 'Grade',
              parent: 'grade',
              tagName: 'grade.grade',
            });
            $scope.attributes.push({
              name: 'Grade - Insight',
              parent: 'grade',
              tagName: 'grade.insight',
            });
            $scope.attributes.push({
              name: 'Grade - Hidden',
              parent: 'grade',
              tagName: 'grade.hidden',
            });
          }
        }
        // Adds an evidence to the attributes
        function addEvidenceAttributes(num) {
          num++; // Include the *next* evidence
          for (var i = 1; i <= num; i++) { // This makes sure all evidences are added
            // Only if they don't already exist
            if (!_.find($scope.attributes, { 'tagName': 'evidence' + i + '.description' })) {
              for (var index = 0; index < evidenceFields.length; index++) {
                var field = evidenceFields[index];
                $scope.attributes.push({
                  name: 'Evidence ' + i + ' - ' + field,
                  parent: 'evidence',
                  tagName: 'evidence' + i + '.' + field.toLowerCase(),
                });
              }
            }
          }
        }
        // Adds a reference to the attributes
        function addReferenceAttributes(num) {
          num++; // Include the *next* reference
          for (var i = 1; i <= num; i++) { // This makes sure all references are added
            // Only if they don't already exist
            if (!_.find($scope.attributes, {
                'tagName': 'reference' + i + '.referee_name'
              })) {
              $scope.attributes.push({
                name: 'Reference ' + i + ' - Referee Name',
                parent: 'reference',
                tagName: 'reference' + i + '.referee_name',
              });
              $scope.attributes.push({
                name: 'Reference ' + i + ' - Referee URL',
                parent: 'reference',
                tagName: 'reference' + i + '.referee_url',
              });
              $scope.attributes.push({
                name: 'Reference ' + i + ' - Comment',
                parent: 'reference',
                tagName: 'reference' + i + '.comment',
              });
            }
          }
        }

        /** COLUMN MAPPING
         *
         *      The bulk of our logic is related to the column
         *       mapping interface. Sinces it's unique to this
         *       view I've not bothered to make a component of
         *       it. We may want to do that in the future.
         */
        $scope.spreadsheet = {};
        $scope.editColumn = editColumn;
        $scope.getColumnState = getColumnState;
        $scope.isColumnActive = isColumnActive;
        $scope.editNextColumn = editNextColumn;
        $scope.totalColumns = 0;
        $scope.unmappedColumns = 0;
        var activeIndex = false;

        // Parses and sets the spreadsheet object, ready for mapping
        function setSpreadsheet(spreadsheet) {
          $scope.spreadsheet = spreadsheet;
          // Flag every column as "unmapped" - ie: the user has not interacted with this
          for (var c = 0, cl = $scope.spreadsheet.columns.length; c < cl; c++) {
            var column = $scope.spreadsheet.columns[c];
            column.mapped = false;
          }
          // Reset the attributes, this may update the `mapped` flag
          resetAttributes();
          // Some tallys
          $scope.rows = new Array($scope.spreadsheet.meta.visible_rows); // This helps with ng-repeat
          $scope.totalColumns = $scope.spreadsheet.columns.length;
          // Edit the first unmapped column
          activeIndex = false;
          var firstUnmappedColumn = _.findIndex($scope.spreadsheet.columns, { mapped: false });
          if(firstUnmappedColumn !== -1){
            editColumn(firstUnmappedColumn);
          } else {
            editColumn($scope.spreadsheet.columns.length-1);
            editNextColumn(); // All columns are mapped, this simulates the final column being assigned
          }
        }

        // Returns the column map for submit
        function getColumnMap() {
          var map = {
            group_id: $scope.group.id,
            job_id: $scope.spreadsheet.job_id,
            reviewColumnMap: [],
            intention: $scope.intention,
            course_name: $scope.course_name,
            course_description: $scope.course_description,
          };
          for (var c = 0, cl = $scope.spreadsheet.columns.length; c < cl; c++) {
            var column = $scope.spreadsheet.columns[c];
            var tmp = {};
            tmp.attribute = (column.attribute && column.attribute.tagName) || false;
            tmp.title = column.title;
            if (column.attribute && column.date_format) {
              tmp.date_format = column.date_format;
            }
            map.reviewColumnMap.push(tmp);
          }
          return map;
        }

        // How many columns are unmapped?
        $scope.$watch('spreadsheet.columns', function(newVal) {
          $scope.unmappedColumns = 0;
          if (newVal && newVal.length) {
            for (var a = 0, al = newVal.length; a < al; a++) {
              if (!newVal[a].mapped) {
                $scope.unmappedColumns++;
              }
            }
          }
        }, true);

        function isColumnActive(index) {
          return index == activeIndex;
        }

        function getColumnState(index) {
          if (index == activeIndex) {
            return 'active';
          } else {
            return $scope.spreadsheet.columns[index].mapped ? 'mapped' : 'unmapped';
          }
        }

        // Track the active column
        function editColumn(index) {
          // Parse the attribute we have just assigned
          if ($scope.spreadsheet.columns[activeIndex] && $scope.spreadsheet.columns[activeIndex].attribute) {
            automaticallyCreateAttributes($scope.spreadsheet.columns[activeIndex].attribute.tagName);
          }
          // Edit the new column
          activeIndex = index;
          var column = $scope.spreadsheet.columns[activeIndex];
          // Scroll to the center of the element, if we can
          var myContainer = $('#column-mapping');
          var myScrollTo = $('#column-mapping thead tr:first-child th:nth-child(' + (index + 1) + ')');
          if (myScrollTo.length) {
            myContainer.animate({
              scrollLeft: myContainer.scrollLeft() + myScrollTo.offset().left - myContainer.offset().left - (myContainer.width() / 2) + (myScrollTo.width() / 2) + parseInt(myScrollTo.css('border-spacing'))
            });
          }
          // The BE does a best-guess for attributes, but the user can override this.
          // Make sure that this doesn't cause double-allocation.
          var attribute = column.attribute;
          column.attribute = null; // Temporarily unassign the attribute
          if (attribute && !attributeIsAllocated(attribute)) {
            column.attribute = attribute; // Reassign if it's not in use by another column
          }
        }

        function editNextColumn() {
          var column = $scope.spreadsheet.columns[activeIndex];
          column.mapped = true; // User has clicked "OK" so we know the column is mapped
          // Find the next unmapped column (usually just +1)
          var cl = $scope.spreadsheet.columns.length;
          var c = activeIndex + 1 == cl ? 0 : activeIndex + 1; // This just means "if we're on the last column, start searching from the beginning"
          for (c; c < cl; c++) {
            if ($scope.spreadsheet.columns[c].mapped == false) {
              editColumn(c);
              return;
            }
          }
          activeIndex = -1; // Deselect if we didn't select the next column
        }

        /** REVIEW
         *
         *      The review stage is a simple series of confirmations
         *       however there is a small amount of logic that binds
         *       some of the confirmations bound together, for example:
         *
         *          You cannot "createShouldPublish" without "create"
         *          You cannot "acceptUpdateWarnings" without "update"
         *
         *      So I watch each variable and automatically modify
         *       any other variables that no longer make sense.
         */
        //
        $scope.review = {}; // The review object, as returned by BE
        $scope.confirm = {}; // The issuer's confirm flags, see: `setReview()`
        $scope.duplicates = false; // Duplicates detected in the csv data

        // Parses and sets the review object
        function setReview(review) {
          $scope.review = review;
          // Re-order error messages to make ones containg 'duplicat' appear first
          if ($scope.review.errors) {
            var duplicateMessages = [];
            var nonDuplicateMessages = []
            for (var index = 0; index < $scope.review.errors.messages.length; index++) {
              var message = $scope.review.errors.messages[index];
              if (message.indexOf('duplicat') > -1) {
                duplicateMessages.push(message);
              } else {
                nonDuplicateMessages.push(message);
              }
            }
            $scope.duplicates = duplicateMessages.length > 0;
            $scope.review.errors.messages = duplicateMessages.concat(nonDuplicateMessages);
          }
          // How many credits does this use?
          var creditsRequired = 0;
          creditsRequired += (review.create && review.create.credits) || 0;
          creditsRequired += (review.update && review.update.credits) || 0;
          $scope.sufficientCredit = creditsRequired <= $scope.department.certificate_left;
          // Default flags
          $scope.confirm.acceptErrors = true; // Always true
          $scope.confirm.create = false;
          $scope.confirm.createShouldPublish = false;
          $scope.confirm.acceptCreateWarnings = false;
          $scope.confirm.update = false;
          $scope.confirm.acceptUpdateWarnings = false;
        }

        // returns the confirmation object for submit
        function getReviewConfirmation() {
          var tmp = angular.copy($scope.confirm);
          tmp.group_id = $scope.group.id;
          tmp.job_id = $scope.spreadsheet.job_id;
          tmp.course_name = $scope.course_name;
          tmp.course_description = $scope.course_description;
          return tmp;
        }

        // "create" and "createShouldPublish"
        $scope.$watch('confirm.create', function(newVal) {
          if (!newVal && $scope.confirm.createShouldPublish) {
            $scope.confirm.createShouldPublish = false; // The user doesn't want to `create`, thus unflag `createShouldPublish`
          }
          if (!newVal && $scope.confirm.acceptCreateWarnings) {
            $scope.confirm.acceptCreateWarnings = false; // The user doesn't want to `update`, thus unflag `acceptCreateWarnings`
          }
          if (newVal && !$scope.review.create.warnings) {
            $scope.confirm.acceptCreateWarnings = true; // There are no warnings to accept. Set the flag anyhow for our interface to consume
          }
        });
        $scope.$watch('confirm.createShouldPublish', function(newVal) {
          if (newVal && !$scope.confirm.create) {
            $scope.confirm.create = true; // The user selected `acceptCreateWarnings`, it stands to reason they want to `create`
          }
        });
        $scope.$watch('confirm.acceptCreateWarnings', function(newVal) {
          if (newVal && !$scope.confirm.create) {
            $scope.confirm.create = true; // The user selected `acceptCreateWarnings`, it stands to reason they want to `create`
          }
        });
        // "update" and "acceptUpdateWarnings"
        $scope.$watch('confirm.update', function(newVal) {
          if (!newVal && $scope.confirm.acceptUpdateWarnings) {
            $scope.confirm.acceptUpdateWarnings = false; // The user doesn't want to `update`, thus unflag `acceptUpdateWarnings`
          }
          if (newVal && !$scope.review.update.warnings) {
            $scope.confirm.acceptUpdateWarnings = true; // There are no warnings to accept. Set the flag anyhow for our interface to consume
          }
        });
        $scope.$watch('confirm.acceptUpdateWarnings', function(newVal) {
          if (newVal && !$scope.confirm.update) {
            $scope.confirm.update = true; // The user selected `acceptUpdateWarnings`, it stands to reason they want to `update`
          }
        });

        // Submit Logic
        $scope.canImportSpreadsheet = function() {
          return ($scope.confirm.update || $scope.confirm.create) // Update or Create
            &&
            (!$scope.confirm.create || ($scope.confirm.create && $scope.confirm.acceptCreateWarnings)) // ...accepting create errors
            &&
            (!$scope.confirm.update || ($scope.confirm.update && $scope.confirm.acceptUpdateWarnings)); // ...accepting update errors
        };

        // Lists
        $scope.reviewWarningsLimit = 4;
        $scope.showAllWarnings = function() {
          $scope.reviewWarningsLimit = Infinity;
        };
        $scope.reviewErrorsLimit = 4;
        $scope.showAllErrors = function() {
          $scope.reviewErrorsLimit = Infinity;
        };

        /** SUCCESS
         *
         *      Excellent, all is said and done, show the success page
         */
        $scope.success = {}; // The success object, as returned by BE

        // Parses and sets the success object
        function setSuccess(success) {
          $scope.success = success;
        }

        $scope.setCredentialsListData = function(spreadsheet) {
          var data = {
            filters: {
              jobId: spreadsheet.job_id,
            }
          };
          EmbedAppService.setData(data);
        }
      }
    ]);
})();

},{}],109:[function(require,module,exports){
/** IMPORT CREDENTIALS - SERVICE
 *
 *      Logic for dealing with Importing Credential Spreadsheets
 *
 *  @author   David "odavid" King
 */
(function() {
  angular.module('app')
    .service('uploadCredentialsService', ['$q', 'api',
      function($q, api) {
        this.analyseFile = analyseFile;
        this.reviewColumnMap = reviewColumnMap;
        this.importSpreadsheet = importSpreadsheet;
        this.getImportProgress = getImportProgress;
        this.getEvidenceFields = getEvidenceFields;

        function analyseFile(groupId, fileName, s3Bucket, s3Key) {
          return api
            .request('/csv/analyze_csv_data', {
              group_id: groupId,
              file_name: fileName,
              s3_bucket: s3Bucket,
              s3_key: s3Key,
            });
        }

        function reviewColumnMap(columnMap) {
          return api.request('/csv/review_csv_column_map', columnMap) // Where columnMap: { group_id: ..., job_id: ..., reviewColumnMap: [] }
            .then(function(review) {
              // Remove empty warnings and errors
              if (review.create && review.create.warnings && review.create.warnings.messages && review.create.warnings.messages.length == 0) {
                delete review.create.warnings;
              }
              if (review.update && review.update.warnings && review.update.warnings.messages && review.update.warnings.messages.length == 0) {
                delete review.update.warnings;
              }
              if (review.errors && review.errors.messages && review.errors.messages.length == 0) {
                delete review.errors;
              }
              // Remove create and update if there's nothing there
              if (review.create && !review.create.warnings && !review.create.credentials) {
                delete review.create;
              }
              if (review.update && !review.update.warnings && !review.update.credentials) {
                delete review.update;
              }
              if (review.update) {
                delete review.update.errors; // Be always sends this as NULL, not sure why
              }
              return review;
            });
        }

        function importSpreadsheet(reviewConfirmation) { // Where reviewConfirmation: { group_id: ..., job_id: ..., create: BOOL, createShouldPublish: BOOL, update: BOOL }
          return api.request('/csv/import_csv', reviewConfirmation);
        }

        function getImportProgress(jobId) {
          return api.request('/csv/check_import_sheet_progress', {
            job_id: jobId
          });
        }

        function getEvidenceFields() {
          return api.request('/csv/evidence_items_field_csv_upload');
        }
      }
    ]);
})();

},{}],110:[function(require,module,exports){
/** API SETTINGS SERVICE - SERVICE
 *
 *  @author   David "odavid" King
 */
(function() {
  angular.module('app')
    .service('ApiSettingsService', ['$q', 'api', 'DepartmentService', 'ENV',
      function($q, api, DepartmentService, ENV) {
        this.getApiKeySettings = getApiKeySettings;
        this.updateApiSettings = updateApiSettings;
        this.getApiKeys = getApiKeys;

        function getApiKeys() {
          return $q(function(resolve, reject) {
            api
            .request('/integrations/api_key')
            .then(function(response) {
              resolve(response);
            })
            .catch(function(error) {
              reject(error);
            });
          });
        }

        function getApiKeySettings(){
          return $q.all([
            api.request('/integrations/api_key'),
            api.request('/api_settings/api_keys'),
            DepartmentService.getDepartment(),
          ])
            .then(function(data){
              var obj = data[0];
              obj.automatic_publishing = !data[2].sandbox_mode; // The API has an inverted opinion about this value
              obj.api_keys = angular.copy(data[1].api_keys);
              return obj;
            });
        }

        // Now API and integration settings have been separated the functionality for the update api settings has been moved into it's own function
        function updateApiSettings(automaticPublishing){
          var promises = [];
          // Save the `sandbox_mode` flag
          var org = api.request('/department/update', { issuer: { sandbox_mode: !automaticPublishing } });
          promises.push(org);
          // Run all
          return $q.all(promises)
            .then(function(){
              return true;
            });
        }
      }
    ]);
})();

},{}],111:[function(require,module,exports){
/** SETTINGS : API SETTINGS
 *
 *    Allows the issuer to view, create and delete API keys
 */
angular.module('app')
  .controller('SettingsApiSettingsCtrl', ['$scope', '$stateParams', '$state', 'resolvedIntegrations', 'resolvedDepartments', 'ApiSettingsService', 'swalService', 'api', 'AnalyticsService', 'alertService',
    function($scope, $stateParams, $state, resolvedIntegrations, resolvedDepartments, ApiSettingsService, swalService, api, AnalyticsService, alertService) {

      // Assign values from response data
      $scope.automaticPublishing = resolvedIntegrations.automatic_publishing;
      $scope.apiKeyList = resolvedIntegrations.api_keys;
      $scope.departmentList = resolvedDepartments;
      $scope.updatePermissionDefaults = updatePermissionDefaults;

      // If the user is creating a new API key we set creating to true
      $scope.creating = $stateParams.view === 'details' && !$stateParams.id;

      // If the user is viewing details for an existing API key we should get the details from the apiKeyList
      if ($stateParams.view === 'details') {
        $scope.apiPermissions = {};

        // If we're viewing an existing api key
        if ($stateParams.id) {
          // Find the keys details in the apiKeyList
          $scope.currentApiKey = $scope.apiKeyList.find(function (apiKey) {
            return apiKey.access_token === $stateParams.id;
          });
          // If key does not exist in the apiKeyList then redirect the user to the list view
          if (!$scope.currentApiKey) {
            $state.go('issuer.dashboard.department-settings.api-settings', { view: 'list', id: null });
          }
          // If we are creating a new key we setup the default currentApiKey
        } else if (!$stateParams.id) {
          $scope.currentApiKey = {};
        }
        // Set the permissions values
        $scope.updatePermissionDefaults();
      }


      // If the user is not viewing API key details we should not have a id parameter in the url
      if ($stateParams.view !== 'details') {
        $state.go('issuer.dashboard.department-settings.api-settings', { view: $stateParams.view, id: null });
      }

      //*** Shared functions ***//
      $scope.deleteApiKeyById = function(selectedApiKey) {
        // If the keys name is null replace it with Default API Key
        if (!selectedApiKey.name) {
          selectedApiKey.name = 'Default API Key';
        }

        // Check how many account wide keys exist for this organization
        var accountWideKeys = $scope.apiKeyList.filter(function(key) {
          return key.kind === 'account-wide';
        }).length;

        // If user is trying to delete an account wide key, check it isn't the last one
        if (selectedApiKey.kind === 'account-wide' && accountWideKeys === 1) {
            // This is the last account wide key and cannot be deleted
            alertService
              .alert(
                'This API key cannot be deleted',
                [
                  ' <strong>' + selectedApiKey.name + '</strong>' + ' is the last ' + '<strong>' + 'account wide API key' + '</strong>' +' and cannot be deleted.',
                  'Please add another ' + '<strong>' + 'account wide API key' + '</strong>' + ' if you wish to delete this API key.'
                ]
              );
        } else {
          // Not the last account wide key
          alertService
            .confirmWithCheckbox(
              'Delete API Key?',
              [
                'Are you sure you want to delete ' + selectedApiKey.name + '?',
              ],
              'Delete',
              'cancel',
              700,
              [{
                content: 'Any integration or API requests still using '+ '<em>this</em>' + ' key will no longer work.',
                value: false,
                id: 1,
              },
              {
                content: 'This key can not be reinstated once deleted.',
                value: false,
                id: 2,
              },
              ]
            )
            .then(function() {
              return api.request('/api_settings/api_keys/delete', { id: selectedApiKey.access_token });
            })
            .then(function() {
              // If successful remove the deleted key from the array
              $scope.apiKeyList = $scope.apiKeyList.filter(function(apiKey) {
                return apiKey.access_token !== selectedApiKey.access_token;
              });
              if ($stateParams.view === 'details') {
                $state.go('issuer.dashboard.department-settings.api-settings', { view: 'list', id: null });
              }
              swalService.showAlert('deleteApiKeySuccess');
            })
            .catch(function(err) {
              if (err) {
                // Popup closes and user sent back to list view no need to error handle
                swalService.showAlert('deleteApiKeyError');
              }
            });
        }
      };


      //*** Settings view functions ***//
      // Submit API settings update - this logic is taken from when api and integration settings were combined
      $scope.onSubmitApiSettings = function(formCtrl) {
        ApiSettingsService
          .updateApiSettings($scope.automaticPublishing)
          .then(function(response) {
            formCtrl.$setPristine(); // TODO: Fix: Updates all integrations, but only resets the current form
            AnalyticsService.trackEvent('Settings > Integrations Updated');
            swalService.showAlert('issuerSettingsSuccess');
          })
          .catch(function(err) {
            formCtrl.$setPristine(); // TODO: Fix: Updates all integrations, but only resets the current form
            swalService.showAlert('unknownFailure', '001');
          });
      };


      //*** List view functions ***//
      $scope.goToApiDetails = function(api) {
        $state.go('issuer.dashboard.department-settings.api-settings', { view: 'details', id: api.access_token });
      };

      $scope.goToCreateApiKey = function() {
        // Go to create api route
        $state.go('issuer.dashboard.department-settings.api-settings', { view: 'details', id: null });
      };


      //*** Details view functions ***//
      // Update default values in form
      // This function doesn't use $scope so we can hoist it to the top of the file to call it during setup
      function updatePermissionDefaults() {
        $scope.apiPermissions = {
          restricted: '',
          permission: '',
          fullPermission: '',
        };

        if ($scope.currentApiKey.organization_name && $scope.currentApiKey.kind === 'department-specific') {
          $scope.apiPermissions.fullPermission = $scope.departmentList.filter(function (department) {
            return department.id === +$scope.currentApiKey.organization_name || department.name === $scope.currentApiKey.organization_name;
          })[0].name;
          // Truncate department name if it is long
          $scope.apiPermissions.permission = truncateString($scope.apiPermissions.fullPermission, 25);
          $scope.apiPermissions.restricted = 'Restricted to ';
        } else if ($scope.currentApiKey.kind === 'account-wide') {
          $scope.apiPermissions.fullPermission = $scope.apiPermissions.permission = 'Account-wide';
          $scope.apiPermissions.restricted = '';
        }
      }

      // Submit new API Key
      $scope.onSubmitAPIKey = function(formCtrl) {
        // Check form is valid
        if (formCtrl.$valid) {
          // Create the request body object
          var requestData = {
            name: $scope.currentApiKey.name,
            kind: $scope.currentApiKey.kind,
            organization_id: $scope.currentApiKey.organization_name || null,
          };

          api.request('/api_settings/api_keys/create', {
            api_key: requestData
          }).then(function() {
            formCtrl.$setPristine(); // Tidy the form
            swalService.showAlert('createApiKeySuccess');
            // If successful redirect back to list view
            $state.go('issuer.dashboard.department-settings.api-settings', { view: 'list', id: null });
          }).catch(function(err) {
            swalService.showAlert('createApiKeyError');
            formCtrl.$setPristine(); // Tidy the form - removes saving spinner
          });
        }
      };

      // Cancel creating new API key
      $scope.discardNewApi = function() {
        // Return to api list
        $state.go('issuer.dashboard.department-settings.api-settings', { view: 'list', id: null });
      };

      // Utility function
      function truncateString(str, num) {
        if (str.length <= num) {
          return str;
        }
        return str.slice(0, num) + '...';
      }

    }]);

},{}],112:[function(require,module,exports){
departmentCtrl.$inject = ['$state', 'resolvedPermissions', 'resolvedDepartment'];
function departmentCtrl($state, resolvedPermissions, resolvedDepartment) {
  var ctrl = this;

  // These auto-open sub menus on load
  ctrl.whiteLabelling = $state.current.name === 'issuer.dashboard.department.branding-settings' || $state.current.name === 'issuer.dashboard.department.email-appearance' || $state.current.name === 'issuer.dashboard.department.social-sharing';
  ctrl.recipientDirectory = $state.current.name === 'issuer.dashboard.department.recipient-directory';

  ctrl.permissions = resolvedPermissions;
  ctrl.department = resolvedDepartment;
}

angular
  .module('app')
  .controller('departmentCtrl', departmentCtrl);

},{}],113:[function(require,module,exports){
EmploymentDirectoryCtrl.$inject = ['resolvedSettings', 'resolvedPermissions', 'resolvedDepartment', 'resolvedGroups', '_', 'EmploymentDirectoryService'];
function EmploymentDirectoryCtrl(resolvedSettings, resolvedPermissions, resolvedDepartment, resolvedGroups, _, EmploymentDirectoryService) {
  var ctrl = this;
  ctrl.settings = resolvedSettings;
  ctrl.permissions = resolvedPermissions;
  ctrl.department = resolvedDepartment;
  ctrl.groups = resolvedGroups;

  ctrl.settings.default_privacy = ctrl.settings.default_privacy || 'private';
  ctrl.doSaveSettings = doSaveSettings;
  ctrl.recipientVisiblityOptions = [
    { value: 'private', title: 'Private' },
    { value: 'public',  title: 'Public' },
  ];
  ctrl.showInstructions = false;

  // Normalise non_selectable_groups for use with the typeahead component
  function groupIdToName(id) {
    id = parseInt(id); // Shouldn't need to do this
    var group = _.find(ctrl.groups, {
      id: id
    }) || {};
    return group.name || '?';
  }
  if (ctrl.settings.non_selectable_groups) {
    ctrl.non_selectable_groups = ctrl.settings.non_selectable_groups.map(function(groupId) {
      return {
        id: groupId,
        name: groupIdToName(groupId)
      };
    });
  } else {
    ctrl.non_selectable_groups = [];
  }
  if (ctrl.settings.whitelisted_group_ids) {
    ctrl.whitelisted_group_ids = ctrl.settings.whitelisted_group_ids.map(function(groupId) {
      return {
        id: groupId,
        name: groupIdToName(groupId)
      };
    });
  } else {
    ctrl.whitelisted_group_ids = [];
  }

  // Blacklist
  // Add a group (from the typeahead)
  ctrl.addBlacklistedGroup = function(event) {
    for (var g = 0, gl = ctrl.non_selectable_groups.length; g < gl; g++) {
      if (ctrl.non_selectable_groups[g].id === event.selection.id) {
        return; // Group already exists
      }
    }
    ctrl.non_selectable_groups.push({
      id: event.selection.id,
      name: event.selection.name
    });
  };
  // Remove a group
  ctrl.removeBlacklistedGroup = function(index) {
    ctrl.non_selectable_groups.splice(index, 1);
  };

  // Whitelist
  // Add a group (from the typeahead)
  ctrl.addWhitelistedGroup = function(event) {
    for (var g = 0, gl = ctrl.whitelisted_group_ids.length; g < gl; g++) {
      if (ctrl.whitelisted_group_ids[g].id === event.selection.id) {
        return; // Group already exists
      }
    }
    ctrl.whitelisted_group_ids.push({
      id: event.selection.id,
      name: event.selection.name
    });
  };
  // Remove a group
  ctrl.removeWhitelistedGroup = function(index) {
    ctrl.whitelisted_group_ids.splice(index, 1);
  };

  function doSaveSettings(formCtrl){
    // Convert lists back to a simple arrays of ids
    ctrl.settings.non_selectable_groups = ctrl.non_selectable_groups.map(function(group) {
      return group.id;
    });
    ctrl.settings.whitelisted_group_ids = ctrl.whitelisted_group_ids.map(function(group) {
      return group.id;
    });
    EmploymentDirectoryService
      .saveSettings(ctrl.settings)
      .then(function(){
        // alert('done!');
      })
      .finally(function(){
        formCtrl.$setPristine(); // Always reset the form
      });
  }
}

angular
  .module('app')
  .controller('EmploymentDirectoryCtrl', EmploymentDirectoryCtrl);

},{}],114:[function(require,module,exports){
EmploymentDirectoryService.$inject = ['api', 'swalService'];
function EmploymentDirectoryService(api, swalService) {
  var service = this;
  service.getSettings = getSettings;
  service.saveSettings = saveSettings;

  function getSettings(){
    return api
      .request('/employment_directory/get_settings')
      .then(function(response){
        // The backend uses the same serializer for the dashboard as the public employment directory, which isn't great.
        // This makes `get_settings` and `upsert` asymmetrical, so here I am, once more massaging data in what should be a simple operation.
        return {
          visible: response.employment_directory.visible,
          domain: response.employment_directory.domain,
          default_privacy: response.employment_directory.default_privacy,
          credential_visibility: response.employment_directory.credential_visibility,
          accredible_setup_complete: response.employment_directory.accredible_setup_complete,
          non_selectable_groups: response.employment_directory.non_selectable_groups,
          whitelisted_group_ids: response.employment_directory.whitelisted_group_ids,
          name_search_enabled: response.employment_directory.filters.name,
          groups_search_enabled: response.employment_directory.filters.groups,
          location_search_enabled: response.employment_directory.filters.location,
          skills_search_enabled: response.employment_directory.filters.skills,
          availability_search_enabled: response.employment_directory.filters.availability,
        };
      });
  }
  function saveSettings(data){
    return api
      .request('/employment_directory/upsert', { employment_directory: data })
      .then(function(){
        swalService.showAlert('employmentDirectorySavedSuccess');
      });
  }
}

angular
  .module('app')
  .service('EmploymentDirectoryService', EmploymentDirectoryService);

},{}],115:[function(require,module,exports){
/** SETTINGS : RECIPIENT DIRECTORY
 *
 *     This allows the issuer to control the settings and
 *      appearance of the recipient verification directory
 *
 *    @author   Jake Ford
 *    @author   David "oodavid" King
 */
angular.module('app')
  .controller('RecipientDirectoryCtrl', ['$scope', 'attributeService', 'resolvedDepartment', 'resolvedSettings', 'resolvedGroups', 'api', '_', 'AnalyticsService',
    function($scope, attributeService, resolvedDepartment, resolvedSettings, resolvedGroups, api, _, AnalyticsService) {

    // Hoist
    $scope.groups = resolvedGroups;
    $scope.department = resolvedDepartment;
    $scope.settings = resolvedSettings;

    // Normalise blacklisted_groups for use with the typeahead component
    function groupIdToName(id) {
      id = parseInt(id);
      var group = _.find($scope.groups, {
        id: id
      }) || {};
      return group.name || '?';
    }
    if ($scope.settings.blacklisted_groups) {
      $scope.blacklisted_groups = $scope.settings.blacklisted_groups.map(function(groupId) {
        return {
          id: groupId,
          name: groupIdToName(groupId)
        };
      });
    } else {
      $scope.blacklisted_groups = [];
    }

    // Read the attributes from the service
    $scope.attributes = [];
    $scope.fields = {};
    attributeService.getAttributesList(false, 'embedded')
      .then(function(attributes) {
        $scope.attributes = attributes;
        // Transform :: Convert the attributes into simple values (for the form)
        angular.forEach($scope.attributes, function(attribute) {
          // Make sure the parent object exists
          $scope.fields[attribute.parent] = $scope.fields[attribute.parent] || {};
          // Default values
          if ($scope.isAttributeVisible(attribute)) {
            var value = (attribute.tagName == 'recipient.name' || attribute.tagName == 'group.course_name') ? 2 : 0;
            $scope.fields[attribute.parent][attribute.key] = value;
          }
        });
        // Overwrite with the saved data
        angular.forEach($scope.settings.fields, function(field) {
          var value = field.search ? 2 : 1;
          if ($scope.fields.hasOwnProperty(field.parent) && $scope.fields[field.parent].hasOwnProperty(field.key)) {
            $scope.fields[field.parent][field.key] = value;
          }
        });
      });

    // Options for the field selection
    $scope.visibleSearchable = [{
        value: 1,
        html: '<i class="public"></i> Visible',
      },
      {
        value: 2,
        html: '<i class="search"></i> Searchable',
      },
    ];
    $scope.hiddenVisibleSearchable = [{
        value: 0,
        html: '<i class="private"></i> Hidden',
      },
      {
        value: 1,
        html: '<i class="public"></i> Visible',
      },
      {
        value: 2,
        html: '<i class="search"></i> Searchable',
      },
    ];
    $scope.hiddenVisible = [{
        value: 0,
        html: '<i class="private"></i> Hidden',
      },
      {
        value: 1,
        html: '<i class="public"></i> Visible',
      },
    ];

    // Filter: is this a visible field?
    var visibleTags = ['recipient.name', 'recipient.email', 'group.course_name', 'credential.id', 'credential.issued_on', 'credential.expired_on'];
    $scope.isAttributeVisible = function(attribute) {
      return attribute.type != 'image' // No images (how do you search that?)
        &&
        (visibleTags.indexOf(attribute.tagName) !== -1 || attribute.parent == 'custom'); // Whitelisted, or "custom" attribute
    };

    // Transform :: Make sure the blacklisted_groups aren't blank
    $scope.settings.blacklisted_groups = $scope.settings.blacklisted_groups || [];

    // Transform :: Remove some unused keys
    delete $scope.settings.id;
    delete $scope.settings.department_name;
    delete $scope.settings.course_names;

    // Blacklist
    // Add a group (from the typeahead)
    $scope.addBlacklistedGroup = function(event) {
      for (var g = 0, gl = $scope.blacklisted_groups.length; g < gl; g++) {
        if ($scope.blacklisted_groups[g].id === event.selection.id) {
          return; // Group already exists
        }
      }
      $scope.blacklisted_groups.push({
        id: event.selection.id,
        name: event.selection.name,
      });
    };
    // Remove a group
    $scope.removeBlacklistedGroup = function(index) {
      $scope.blacklisted_groups.splice(index, 1);
    };

    // The link is only active when we have a saved value for `settings.visible` - see also save logic
    $scope.isDirectoryActive = $scope.settings.visible;

    // Temporary Embed Settings
    $scope.width = 800;
    $scope.height = 600;

    // Settings
    $scope.doSaveSettings = function(formCtrl) {
      // Massage the fields, ready for the BE
      $scope.settings.fields = [];
      angular.forEach($scope.attributes, function(attribute) {
        if ($scope.fields[attribute.parent][attribute.key]) {
          // Copy the attribute
          var tmp = angular.copy(attribute);
          // Massage the data
          delete tmp.credential_count;
          tmp.search = ($scope.fields[attribute.parent][attribute.key] == 2);
          // Store
          $scope.settings.fields.push(tmp);
        }
        $scope.settings.blacklisted_groups = $scope.blacklisted_groups.map(function(group) {
          return group.id;
        });
      });
      // Now save
      api.request('/verification-directory/upsert', {
          verification_directory: $scope.settings
        })
        .finally(function() {
          AnalyticsService.trackEvent('Settings > Directory Updated');
          formCtrl.$setPristine(); // Tidy the form
          $scope.isDirectoryActive = $scope.settings.visible; // Update our flag
        });
    };

  }]);

},{}],116:[function(require,module,exports){
/** SETTINGS : RECIPIENT EXPERIENCE
 *
 *    Allows the issuer to customize which features are private, public and disabled for recipients.
 *
 *    @author   Alan Heppenstall
 *    @author   David 'oodavid' King (refactor)
 *    @author   Andrew Bateman (updated to match new credential.net)
 */

angular.module('app')
  .controller('SettingsRecipientExperienceCtrl', ['$scope', 'DepartmentService', 'swalService', 'alertService', 'AnalyticsService', 'resolvedDepartment',
    function ($scope, DepartmentService, swalService, alertService, AnalyticsService, resolvedDepartment) {

      $scope.anyPubliclyDisabledOrPrivateOptions = anyPubliclyDisabledOrPrivateOptions;
      $scope.disabled = disabled;
      $scope.supportContact = resolvedDepartment.support_contact_email;
      $scope.autoApproveMode = resolvedDepartment.name_changes_auto_approve;

      // Feature options: public, requires login or disabled
      $scope.recipientFeatureOptions = [
        { value: 'public', name: 'Public' },
        { value: 'private', name: 'Auth' },
        { value: 'disabled', name: 'Disabled' },
      ];

      // Feature options: requires login or disabled
      $scope.recipientFeaturePrivateOptions = [
        { value: 'private', name: 'Auth' },
        { value: 'disabled', name: 'Disabled' },
      ];

      // Functions
      var default_recipient_functions = [
        'change_privacy',
        'add_to_linkedin',
        'transcript_viewable',
        'embed',
        'email_share',
        'download_pdf',
        'download_pdf_print',
        'download_badge',
        'change_name',
        'add_evidence',
        'request_reference',
        'sharing',
      ];

      // Expose parts of the Department to the view
      $scope.form = {
        recipient_functions: resolvedDepartment.recipient_functions || {}, // Default the value to an empty object
        certificate_expiry_message: resolvedDepartment.certificate_expiry_message,
      };

      // Default the recipient_functions to `public`
      for (var f = 0, fl = default_recipient_functions.length; f < fl; f++) {
        var key = default_recipient_functions[f];
        $scope.form.recipient_functions[key] = $scope.form.recipient_functions[key] || 'public';
      }

      // The state of the sidebar preview
      $scope.showing = 'public'; // `public` or `owner`

      // A mock User for the sidebar
      $scope.user = {
        name: 'Alan Heppenstall',
        email: 'alan@accredible.com',
      };

      // Save the changes
      $scope.doSubmit = function (formController) {
        // Keep the payload tidy
        var payload = angular.copy($scope.form);
        // Add the name_changes_auto_approve value to the payload as it is outside the form
        payload.name_changes_auto_approve = $scope.autoApproveMode;
        // Submit
        DepartmentService
          .updateDepartment(payload)
          .then(function (response) {
            formController.$setPristine();
            AnalyticsService.trackEvent('Settings > Recipient Experience Updated');
            alertService.alert('Recipient Experience Updated', 'Your recipient experience settings have been updated.');
          })
          .catch(function (err) {
            formController.$setPristine();
            swalService.showAlert('unknownFailure', '001');
          });
      };

      // Is the menu-item visible?
      $scope.isItemVisible = function (key) {
        if ($scope.showing === 'public') {
          return !$scope.form.recipient_functions[key] || $scope.form.recipient_functions[key] === 'public';
        } else if ($scope.showing === 'owner') {
          return !$scope.form.recipient_functions[key] || $scope.form.recipient_functions[key] !== 'disabled';
        }
      };
      // Are _any_ of the passed items visibile?
      $scope.isAnyItemVisible = function () {
        for (var a = 0, al = arguments.length; a < al; a++) {
          var key = arguments[a];
          if ($scope.isItemVisible(key)) {
            return true;
          }
        }
        return false;
      };

      $scope.options = {
        sharing: true,
        addToLinkedIn: true,
        pdfDownload: true,
        pdfPrintDownload: true,
        badgeDownload: true,
        emailShare: true,
        embed: true,
        transcriptDownload: true,
        changePrivacy: true,
        changeName: true,
        addToBackPack: true,
        editCustomCredential: true
      };

      function anyPrivateOptions() {
        for (var f = 0, fl = default_recipient_functions.length; f < fl; f++) {
          var key = default_recipient_functions[f];
          if ($scope.form.recipient_functions[key] === 'private') {
            return true;
          }
        }
        return false;
      }

      // Any publicly disabled or private options
      function anyPubliclyDisabledOrPrivateOptions() {
        return $scope.showing !== 'owner' && ($scope.isItemVisible('change_privacy') || $scope.isItemVisible('change_name') || anyPrivateOptions());
      }

      // Disable specified public functions if not own credential
      var publiclyDisabled = ['changePrivacy', 'changeName', 'addEvidence', 'requestReference'];

      function disabled(option) {
        return $scope.showing !== 'owner' && (publiclyDisabled.indexOf(option) !== -1);
      }

    }
  ]);

},{}],117:[function(require,module,exports){

angular.module('app')
  .controller('OrganizationDepartmentCtrl', [ 'DepartmentsService', 'resolvedDepartment', 'alertService', '$state',
    function(DepartmentsService, resolvedDepartment, alertService, $state) {

      var ctrl = this;

      ctrl.department = resolvedDepartment;
      ctrl.doSubmit = doSubmit;

      function doSubmit(formCtrl){
        DepartmentsService
        .upsertDepartment(ctrl.department)
        .then(function(department){
          var url = ctrl.department.url; // THe url is not returned
          ctrl.department = department; // Update the local object
          ctrl.department.url = url;
          return alertService.alert('Department Added', 'A new department called <strong>' + department.name + '</strong> has been created.');
        })
        .then(function(){
          // BE doesn't let us EDIT departments - dump the user elsewhere
          $state.go('issuer.dashboard.departments', null, { reload: true, inherit: false });
        })
        .catch(function(err){
          alertService.alert('We couldn\'t save the Department', 'Please try again');
        })
        .finally(function(){
          formCtrl.$setPristine();
        });
      }

      /*
      // UNUSED - to manage the team members of the department

      ctrl.addTeamMember = addTeamMember;
      ctrl.removeTeamMember = removeTeamMember;
      function addTeamMember($event){
        if(!ctrl.department.team){
          ctrl.department.team = [];
        }
        ctrl.department.team.push($event.selection);
      }

      function removeTeamMember(index){
        ctrl.department.team.splice(index, 1);
      }
      */

    }
  ]);

},{}],118:[function(require,module,exports){
organizationDepartmentsCtrl.$inject = ['$state', 'resolvedOrganization', 'resolvedDepartment', 'resolvedPricing', 'resolvedDepartments', 'DepartmentService', 'resolvedFlipperFeatures', 'FlipperFeaturesService', 'alertService', 'updateDepartmentAllowanceModalService', '$timeout'];

function organizationDepartmentsCtrl($state, resolvedOrganization, resolvedDepartment, resolvedPricing, resolvedDepartments, DepartmentService, resolvedFlipperFeatures, FlipperFeaturesService, alertService, updateDepartmentAllowanceModalService, $timeout) {
  var ctrl = this;

  ctrl.organization = resolvedOrganization;
  ctrl.department = resolvedDepartment;
  ctrl.departments = resolvedDepartments;
  ctrl.flipperFeatures = resolvedFlipperFeatures;

  // Expose functions
  ctrl.selectDepartment = selectDepartment;
  ctrl.deleteDepartment = deleteDepartment;
  ctrl.showDepartmentSettings = showDepartmentSettings;
  ctrl.showDepartmentTeam = showDepartmentTeam;
  ctrl.showDepartmentGroups = showDepartmentGroups;
  ctrl.showDepartmentCredentials = showDepartmentCredentials;
  ctrl.showUpdateDepartmentAllowance = showUpdateDepartmentAllowance;

  ctrl.billingV2Enabled = resolvedPricing.features.billing_v2;
  ctrl.canCreateDepartment = resolvedPricing.features.allow_organization_creation;
  ctrl.isGrowthPlan = resolvedPricing.features.corporation_plan === 'growth';

  ctrl.tooltipText = ctrl.canCreateDepartment ? ''
      : 'Department limit reached. To create additional departments, please use the link to contact CS about upgrading';

  // Switch to the given department and redirect to the dashboard
  function selectDepartment(department) {
    alertService
      .confirm('Switch Department?', '<p>Switching to <strong>' + department.name + '</strong> allows you to manage the Groups,<br>Designs and Recipients in this Department.</p><p>Would you like to switch now?</p>')
      .then(function () {
        DepartmentService.switchDepartment(department.id)
          .then(function () {
            $timeout(function(){
              FlipperFeaturesService.getFlipperFeatures(department.id);
              $state.go('issuer.dashboard.department.general-settings', { edit: 'department' });
            });
          })
          .catch(function () {
            alertService
              .alert('Could not switch to this department');
          });
      })
      .catch(function () {
        // Handle cancel rejection
      });
  }

  // Actually delete the department
  function doDeleteDepartment(department) {
    alertService
      .confirm(
        'Delete Department?',
        [
          'Deleting <strong>' + department.name + '</strong> removes all information associated with this department.',
          'Are you sure you want to do this?'
        ],
        'delete'
      )
      .then(function () {
        DepartmentService.deleteDepartment(department.id)
          .then(function () {
            alertService
              .alert('Department Deleted', ' <strong>' + department.name + '</strong> has been deleted.')
              .then(function() {
                $timeout(function(){
                  FlipperFeaturesService.getFlipperFeatures(department.id);
                  $state.go('.', null, { reload: true });
                });
              });
          })
          .catch(function () {
            alertService
              .alert(
                'Department could not be Deleted',
                'If this problem persists, please <a href="https://help.accredible.com/kb-tickets/new" target="_blank">contact support</a>.'
              );
              return;
          });
      })
      .catch(function () {
        // Handle cancel rejection
      });
  }

  // Prompt to delete department
  function deleteDepartment(department) {
    if (department.total_credentials > 0) {
      alertService
        .alert(
          'Cannot Delete Department',
          [
            ' <strong>' + department.name +  '</strong> contains <strong>' + department.total_credentials + '</strong> ' + (department.total_credentials > 1 ? 'credentials.' : 'credential.'),
            'Before deleting a department you must first delete all its credentials.'
          ]
        );
      return;
    }
    if (ctrl.department.id === department.id) {
      var newIndex = 0;
      for (var index = 0; index < ctrl.departments.length; index++ ) {
        if (ctrl.departments[index].id === department.id) {
          if (index === 0) {
            newIndex = 1;
          } else {
            newIndex = index - 1;
          }
          break;
        }
      }
      var newDepartment = ctrl.departments[newIndex];
      DepartmentService.switchDepartment(newDepartment.id)
        .then(function () {
          doDeleteDepartment(department);
        })
        .catch(function () {
          alertService
            .alert('Could not switch to new department');
        });
    } else {
      doDeleteDepartment(department);
    }
  }

  // Switch to the given department and redirect to settings
  function showDepartmentSettings(department) {
    if (department.id === ctrl.department.id) {
      $timeout(function(){
        $state.go('issuer.dashboard.department.general-settings', { edit: 'department' });
      });
    } else {
      alertService
        .confirm('Switch Department?', '<p>To view the settings of <strong>' + department.name + '</strong> you must first switch to this Department.</p><p>Would you like to switch now?</p>')
        .then(function () {
          DepartmentService.switchDepartment(department.id)
            .then(function () {
              $timeout(function(){
                FlipperFeaturesService.getFlipperFeatures(department.id);
                $state.go('issuer.dashboard.department.general-settings', { edit: 'department' });
              });
            })
            .catch(function () {
              alertService
                .alert('Could not switch to this department');
            });
        })
        .catch(function () {
          // Handle cancel rejection
        });
    }
  }

  // Switch to the given department and redirect to team members
  function showDepartmentTeam(department) {
    if (department.id === ctrl.department.id) {
      $timeout(function(){
        $state.go('issuer.dashboard.team-members');
      });
    } else {
      alertService
        .confirm('Switch Department?', '<p>To manage the team members of <strong>' + department.name + '</strong> you must first switch to this Department.</p><p>Would you like to switch now?</p>')
        .then(function () {
          DepartmentService.switchDepartment(department.id)
            .then(function () {
              $timeout(function(){
                FlipperFeaturesService.getFlipperFeatures(department.id);
                $state.go('issuer.dashboard.team-members');
              });
            })
            .catch(function () {
              alertService
                .alert('Could not switch to new department');
            });
        })
        .catch(function () {
          // Handle cancel rejection
        });
    }
  }

  // Switch to the given department and redirect to groups
  function showDepartmentGroups(department) {
    if (department.id === ctrl.department.id) {
      $timeout(function(){
        $state.go('issuer.dashboard.groups');
      });
    } else {
      alertService
        .confirm('Switch Department?', '<p>To view the groups of <strong>' + department.name + '</strong> you must first switch to this Department.</p><p>Would you like to switch now?</p>')
        .then(function () {
          DepartmentService.switchDepartment(department.id)
            .then(function () {
              $timeout(function(){
                FlipperFeaturesService.getFlipperFeatures(department.id);
                $state.go('issuer.dashboard.groups');
              });
            })
            .catch(function () {
              alertService
                .alert('Could not switch to new department');
            });
        })
        .catch(function () {
          // Handle cancel rejection
        });
    }
  }

  // Switch to the given department and redirect to credentials
  function showDepartmentCredentials(department) {
    if (department.id === ctrl.department.id) {
      $timeout(function(){
        $state.go('issuer.dashboard.credentials');
      });
    } else {
      alertService
        .confirm('Switch Department?', '<p>To view the credentials of <strong>' + department.name + '</strong> you must first switch to this Department.</p><p>Would you like to switch now?</p>')
        .then(function () {
          DepartmentService.switchDepartment(department.id)
            .then(function () {
              $timeout(function(){
                FlipperFeaturesService.getFlipperFeatures(department.id);
                $state.go('issuer.dashboard.credentials');
              });
            })
            .catch(function () {
              alertService
                .alert('Could not switch to new department');
            });
        })
        .catch(function () {
          // Handle cancel rejection
        });
    }
  }

  // Show modal to update organization settings
  function showUpdateDepartmentAllowance(department) {
    updateDepartmentAllowanceModalService
      .show(department, ctrl.organization, ctrl.billingV2Enabled)
      .then(function(newAllowance) {
        if (newAllowance !== undefined) {
          department.credits_allowance = newAllowance;
        }
      });
  }
}

angular
  .module('app')
  .controller('organizationDepartmentsCtrl', organizationDepartmentsCtrl);

},{}],119:[function(require,module,exports){
/** BADGE EDITOR
 *
 *   <design-selector></design-selector>
 *
 *   @author Andrew Bateman
 */

 // Component
designSelectorDirective.$inject = [];
function designSelectorDirective() {
  return {
    restrict: 'E', // Element only
    templateUrl: '/app/design-selector/design-selector.html',
    controller: designSelectorComponentController,
    scope: {}
  };
}

DesignSelectorService.$inject = ['$q', '$window', '$timeout', 'CertificateService', 'languageService'];
function DesignSelectorService($q, $window, $timeout, CertificateService, languageService) {
  var service = this;

  service.data = {
    visible: false,
    languageOptions: [],
    selectedLanguage: null,
    form: {
      page_size: 20,
      page: '',
      order: 'designs.updated_at DESC',
      kind: '', // badge, certificate
      languages: [],
    }
  };

  service.open = open;
  service.close = close;
  service.select = select;
  service.loadDesigns = loadDesigns;

  function loadDesigns() {
    service.data.loading = true;
    service.data.designs = null;
    service.data.meta = null;
    service.data.form.languages = service.data.selectedLanguage && service.data.selectedLanguage !== 'all' ? [service.data.selectedLanguage]: [];
    CertificateService.getDesigns(service.data.form)
      .then(function (response) {
        service.data.loading = false;
        service.data.designs = response.designs;
        service.data.meta = response.meta;
        service.data.languageOptions = getLanguagesOptions(response.languages);
        $window.scrollTo(0, 0); // Scroll to the top
      })
      .catch(function (err) {
        service.data.loading = false;
      });
  }

  function getLanguagesOptions(languages) {
    var options = [];
    languages.forEach(function (languageCode){
      var language = languageService.getLanguageFromCodeNoDefault(languageCode);
      if (language) {
        language.languageDescription = getLanguageFullDescription(language);
        options.push(language);
      }
    });

    return options.sort( function(lang1, lang2) {
      return lang1.languageDescription > lang2.languageDescription ? 1 : -1; });
  }

  function getLanguageFullDescription(language) {
    return language.description.concat(language.value !== 'en' && language.value !== 'en-gb' ? ' - ' + language.name : '');
  }

  var deferred;
  // Promise to open the editor with the given design
  function open(kind) {
    deferred = $q.defer();
    // Show the selector
    service.data.visible = true;
    service.data.form.kind = kind;
    service.data.selectedLanguage = null;
    loadDesigns();
    // Return the promise, resolved when the editor is closed
    return deferred.promise;
  }

  function close() {
    // Hide the selector
    service.data.visible = false;
    deferred.resolve();
  }

  function select(design) {
    if (design === 'create') {
      $timeout(function() { // Close the selector after the editor has opened, to make it look seamless :-)
        service.data.visible = false;
      }, 500);
      deferred.resolve({ create: true, kind: service.data.form.kind });
    } else {
      service.data.visible = false;
      deferred.resolve(design);
    }
  }
}

designSelectorComponentController.$inject = ['$scope', 'DesignSelectorService'];
function designSelectorComponentController($scope, DesignSelectorService) {
  $scope.data = DesignSelectorService.data;
  $scope.close = DesignSelectorService.close;
  $scope.select = DesignSelectorService.select;
  $scope.updatePagination = updatePagination;
  $scope.loadDesigns = DesignSelectorService.loadDesigns;

  function updatePagination(event) {
    $scope.data.form.page = event.page;
    DesignSelectorService.loadDesigns();
  }

}

angular
  .module('app')
  .service('DesignSelectorService', DesignSelectorService)
  .directive('designSelector', designSelectorDirective);

},{}],120:[function(require,module,exports){
DesignsCtrl.$inject = ['$window', '$state', '$stateParams', '$timeout', '$scope', '_', 'CertificateService', 'CertificateEditorService', 'BadgeEditorService', 'alertService', 'languageService', 'DepartmentService', 'FlipperFeaturesService', 'ENV'];
function DesignsCtrl($window, $state, $stateParams, $timeout, $scope, _, CertificateService, CertificateEditorService, BadgeEditorService, alertService, languageService, DepartmentService, FlipperFeaturesService, ENV ){
  var ctrl = this;

  // Scoped variables up top, a quick reference point for our designers
  ctrl.loading;
  ctrl.designs;
  ctrl.meta;
  ctrl.emptyPayload = true; // Is the payload empty?
  ctrl.languagesOptions = [];
  ctrl.sizeOptions = [ { label: 'A4', value: 'a4' }, { label: 'A8', value: 'a8' }, { label: 'US Letter', value: 'us-letter'} ];

  // Our search / filter form - it should be linked to the form models
  ctrl.form = {
    page_size: 20,
    page: '',
    design_identifier: '', // Fulltext search
    order: 'designs.updated_at DESC',
    in_use: '',
    kind: '', // badge, certificate
    size: [], // a4, a8, us-letter
    orientation: '', // landscape, portrait,
    languages: [], // Available languages on designs,
    languageFilterQuery: '', // Query to filter language options
  };
  // Functional methods
  ctrl.updatePagination = updatePagination;
  ctrl.applyFilters = applyFilters;
  ctrl.clearFilters = clearFilters;
  ctrl.credentialKindUpdate =credentialKindUpdate;
  ctrl.toggleLanguage = toggleLanguage;
  ctrl.toggleSize = toggleSize;
  ctrl.sizeReset = sizeReset;
  ctrl.isSandboxEnvironment = ENV.type === 'sandbox';
  ctrl.dashboardUrl = 'https://' + ENV.prefix + 'dashboard.accredible.com';

  // Begin by submitting the form
  submitForm();

  // Helper variable for language options creation.
  var isFirstLoad = true;

  // Returns a POST object to be used with the API
  function getPayloadFromForm() {
    // Clone the form into the POST object for manipulation
    var payload = angular.copy(ctrl.form);

    if(payload.size && payload.size.length === 0) {
      payload.size = null;
    }

    // Remove NULL or '' values (keeping BOOLEAN and non-empty STRINGS)
    payload = _.omitBy(payload, function (v) {
      return v === null || v === '';
    });
    // Make sure the certificate_design_id is numerical
    if (payload.certificate_design_id) {
      payload.certificate_design_id = parseInt(payload.certificate_design_id);
    }
    return payload;
  }
  // Submits the form
  function submitForm(opts) {
    // We may want to reset the Page number
    if (opts && opts.resetPage) {
      ctrl.form.page = 0;
    }
    // Get the payload
    var payload = getPayloadFromForm();
    // Is the payload empty?
    ctrl.emptyPayload = _(payload)
      .omit(['page_size', 'page', 'order']) // Ignore the page, page_size and order values
      .omitBy(function (prop) { return !prop; }) // Remove empty values
      .isEmpty(); // Is the new object empty? {}
    // Make the request, update the scope, return the promise
    ctrl.loading = true;
    return CertificateService.getDesigns(payload)
      .then(function (response) {
        ctrl.loading = false;
        ctrl.designs = response.designs;
        ctrl.meta = response.meta;
        $window.scrollTo(0, 0); // Scroll to the top
        createLanguageOptions(response.languages);
      })
      .catch(function (err) {
        ctrl.loading = false;
      });
  }

  // Resets the form
  function doResetForm() {
    // Reset all values apart from the page-size
    _(ctrl.form).forEach(function (value, key) {
      if (key != 'page_size') {
        ctrl.form[key] = '';
      }
    });
    // ...then submit
    return submitForm({
      resetPage: true
    });
  }

  // Update the page number
  function updatePagination(event) {
    ctrl.form.page = event.page;
    submitForm();
  }

  // Create language options
  function createLanguageOptions(languagesCodes) {
    ctrl.form.languages = [];
    var newLanguages = [];
    //get languages object from each language code
    languagesCodes.forEach(function(languageCode) {
      var lang = languageService.getLanguageFromCodeNoDefault(languageCode);
      if (lang) {
        newLanguages.push({ value: lang.value, title: lang.description })
      }
    });
    // Set selected state from previous languageOptions
    ctrl.languagesOptions.forEach(function (languageOption) {
        if (languageOption.selected) {
          newLanguages.forEach(function(newLanguageOption) {
            if(newLanguageOption.value === languageOption.value) {
              newLanguageOption.selected = true;
              ctrl.form.languages.push(newLanguageOption.value);
            }
          })
        }
    });
    ctrl.languagesOptions = newLanguages;

  }

  function toggleSize(option) {
    option.selected = !option.selected;
    var index = ctrl.form.size.indexOf(option.value);
    if (index === -1) {
      ctrl.form.size.push(option.value);
    } else {
      ctrl.form.size.splice(index, 1);
    }
    ctrl.applyFilters();
  }

  function toggleLanguage(option) {
    option.selected = !option.selected;
    var index = ctrl.form.languages.indexOf(option.value);
    if (index === -1) {
      ctrl.form.languages.push(option.value);
    } else {
      ctrl.form.languages.splice(index, 1);
    }
    ctrl.applyFilters();
  }

  // Action filters
  ctrl.form.in_use = null;
  ctrl.form.kind = null;
  ctrl.form.size = [];
  ctrl.form.orientation = null;

  function applyFilters(){
    submitForm({ resetPage: true });
  }

  ctrl.inUseReset = function() {};
  ctrl.kindReset = function() {};
  ctrl.binaryFilterReset = function() {};

  function sizeReset() {
    ctrl.sizeOptions.forEach(function(sizeOption){
      sizeOption.selected = false;
    });
    ctrl.form.size = [];
  };
  ctrl.orientationReset = function() {};

  function resetPageAttributes() {
    sizeReset();
    ctrl.binaryFilterReset();
    ctrl.form.orientation = null;
    ctrl.orientationReset();
  }

  function clearFilters() {
    ctrl.form.design_identifier = '';
    ctrl.form.in_use = null;
    ctrl.form.languages = [];
    ctrl.inUseReset();
    ctrl.form.kind = null;
    ctrl.kindReset();
    resetPageAttributes();
    ctrl.languagesOptions.forEach(function(lang) { lang.selected = false});
    applyFilters();
  }

  function credentialKindUpdate() {
    $timeout(function() { // Defer to the next digest cycle
      if (ctrl.form.kind !== 'certificate') {
        resetPageAttributes();
      }
      applyFilters();
    });
  }

  // These were needlessly being instantiated at the routing level
  ctrl.designs = []; // resolvedDesigns;
  ctrl.shared = {
    newDesign: {
      name: ''
    }
  };
  ctrl.selected = {
    design: null
  };
  ctrl.search = {
    design: null
  };

  ctrl.destroyDesign = function(design) {
    if (design.groups.length > 0) {
      alertService
        .alert(
          'Design cannot be deleted',
          [
            (design.name == null ? 'This design' : ' <strong>' + design.name + '</strong>') +
            ' is being used by <strong>' + design.groups.length + '</strong> ' +
            (design.groups.length == 1 ? 'group': 'groups') + '.',
            'To delete this design, remove it from ' +
            (design.groups.length == 1 ? 'this group': 'those groups') + ' first.'
          ]);
    } else {
      alertService
        .confirm(
          'Delete design?',
          [
            'If you delete ' + (design.name == null ? 'this design' : '<strong>' + design.name + '</strong>') +
            ', you will no longer be able to assign it to a group.',
            'None of your existing credentials will be affected.',
            'Are you sure you want to delete it?'
          ],
          'delete'
        )
        .then(function(){
          return CertificateService.destroy(design);
        })
        .then(function(){
          submitForm(); // Reload
        })
        .catch(function(err) {
          // Stop unhandled rejection
        });
    }
  };

  ctrl.editDesign = function (originalDesign) {
    if (originalDesign === 'certificate' || originalDesign.kind === 'certificate') {
      if (originalDesign === 'certificate') {
        originalDesign = null;
      }
      CertificateEditorService
        .open(originalDesign)
        .then(function (updatedDesign) {
          // Did we create or edit?
          if (!originalDesign) {
            doResetForm(); // Just reset, the new design will appear up-top
          } else if (updatedDesign) {
            // _.merge(originalDesign, updatedDesign); // Update the design, keeping the additional data only available to this page
            submitForm();
          }
        });
    } else if (originalDesign === 'badge' || originalDesign.kind === 'badge') {
      if (originalDesign === 'badge') {
        originalDesign = null;
      } else {
        // Adding credentials_count to the badge design causes the credential appearance
        // update modal to trigger when saving in the badge editor
        originalDesign.credentials_count = 0;
        originalDesign.groups.forEach(function(group) {
          originalDesign.credentials_count += group.credentials_count;
        });
      }
      BadgeEditorService
        .open(originalDesign)
        .then(function (updatedDesign) {
          // Did we create or edit?
          if (!originalDesign) {
            doResetForm(); // Just reset, the new design will appear up-top
          } else if (updatedDesign) {
            // _.merge(originalDesign, updatedDesign); // Update the design, keeping the additional data only available to this page
            submitForm();
          }
        });
    }
  };

  // Act on create parameter (if there is one)
  var create = $stateParams.create;
  if (create) {
    $state.go('issuer.dashboard.designs', { create: null }, { reload: false, location: 'replace', notify: false });
    $timeout(function() { // Timeout may not be needed
      ctrl.editDesign(create);
    });
  }

}

angular
  .module('app')
  .controller('DesignsCtrl', DesignsCtrl);

},{}],121:[function(require,module,exports){
angular
  .module('app')
  .controller('emailAppearanceCtrl', ['resolvedDepartment', 'resolvedEmailSettings', 'resolvedFeatures', '$timeout', 'EmailService', 'fontService', 'AuthService',
    function (resolvedDepartment, resolvedEmailSettings, resolvedFeatures, $timeout, EmailService, fontService, AuthService) {
      var ctrl = this;

      ctrl.department = resolvedDepartment;
      ctrl.settings = angular.copy(resolvedEmailSettings); // ...ditto
      ctrl.features = resolvedFeatures;
      ctrl.doSubmit = doSubmit;
      ctrl.fonts = fontService.getFonts({ type: 'system', include: ctrl.settings.style.outer.font.name });
      ctrl.redactorOptions = {
        plugins: [
          'alignment',
          'video',
          'acmsImage', // Use this instead of the native `image` button
          'acmsSocialImages', // Insert social links
        ],
      };

      // This monkey patch is to work around <input-wysiwyg> messing with the form state
      var mainFormCtrl;
      ctrl.resetForm = function (form) {
        mainFormCtrl = form;
        $timeout(function() {
          mainFormCtrl.$setPristine(); // Reset the form
        }, 1000);
      };

      // Save the settings
      function doSubmit(formCtrl) {
        EmailService
          .updateSettings(ctrl.settings) // This is updating ctrl.settings by side-effect
          .then(function() {
            // Update the resolved data
            angular.copy(ctrl.settings, resolvedEmailSettings);
            ctrl.settings.style.outer.font = ctrl.fonts[ctrl.settings.style.outer.font.name]; // Make sure the object is up-to-date
            if (!ctrl.department.has_updated_email_appearance_settings) {
              // Inform the Home page whether or not the email appearance has changed
              AuthService.refresh();
            }
          })
          .finally(function() {
            formCtrl.$setPristine(); // Reset the form
          });
      }

      // All fonts
      // ...make sure the style font matches our fontService (falling back to Arial)
      if (!ctrl.settings.style.outer.font || !ctrl.fonts[ctrl.settings.style.outer.font.name]) {
        ctrl.settings.style.outer.font = ctrl.fonts['Arial']; // Default to Arial
      } else {
        ctrl.settings.style.outer.font = ctrl.fonts[ctrl.settings.style.outer.font.name]; // Make sure the object is up-to-date
      }

      // Border Styles
      ctrl.borderStyles = [ 'solid', 'dotted', 'dashed' ];

      // Example content
      ctrl.exampleBlock = '<h1>Heading 1</h1>\
<p>H1 should only be used once in your email to convey the main point. This helps maintain the narrative after the recipient opens the email.</p>\
<hr>\
<h2>Heading 2</h2>\
<p>H2 and H3 can be used to divide your content into sections.</p>\
<ul>\
    <li>Lists can relay a lot of info</li>\
    <li>They are easily skimmed</li>\
    <li>Use them for snippets of information\
        <ul>\
            <li>List items can be nested</li>\
            <li>Inside other lists</li>\
        </ul>\
    </li>\
</ul>\
<p>\
    Finally, you can\
    <a href="http://google.com">link to google.com</a>\
    or any website\
</p>\
<hr>\
<h3>Heading 3</h3>\
<p>You can also create links that are styled like buttons. A CTA (Call-to-action) is the primary action you want the email recipient to take.</p>\
<p class="cta text-center"><a href="">Call To Action (CTA) Link</a></p>';
    }

  ]);

},{}],122:[function(require,module,exports){
angular
  .module('app')
  .controller('EmailAppearanceV2EmbedCtrl', ['resolvedDepartment', 'resolvedUser', '$location',
    function(resolvedDepartment, resolvedUser, $location) {
      var ctrl = this;

      ctrl.asFeatureRoute = true;
      ctrl.asSubRoute = false;
      ctrl.department = angular.copy(resolvedDepartment);
      ctrl.user = resolvedUser;
      ctrl.route = 'email-appearance';

      if (Object.keys($location.search()).length) {
        var searchParams = new URLSearchParams($location.search());
        ctrl.queryParams = searchParams.toString();
      }
    }
  ]);

},{}],123:[function(require,module,exports){
angular.module('app')
  .controller('EmailTemplateCtrl', ['$scope', '$state', '$stateParams', '_', 'EmailService', 'resolvedPricing', 'resolvedTemplate', 'resolvedEmailSettings', 'SendPreviewEmailModalService', 'HistoryFactory', 'resolvedDepartment', 'resolvedOrganization', 'FlipperFeaturesService', 'alertService',
    function($scope, $state, $stateParams, _, EmailService, resolvedPricing, resolvedTemplate, resolvedEmailSettings, SendPreviewEmailModalService, HistoryFactory, resolvedDepartment, resolvedOrganization, FlipperFeaturesService, alertService) {
      var ctrl = this;

      ctrl.attributes = angular.copy(resolvedTemplate.attributes);
      ctrl.requiredAttributes = ctrl.attributes.filter(function (attribute) { return attribute.required === true;});
      ctrl.department = angular.copy(resolvedDepartment);
      ctrl.plan = resolvedPricing.plan;

      // TODO (JOAO) Remove this once the feature flag is removed
      ctrl.requireVerificationFeature = false;
      FlipperFeaturesService.getFlipperFeatures(resolvedDepartment.id).then(function(features) {
        ctrl.requireVerificationFeature = features.require_verified_corporation_for_legacy_email_templates || false;
      });

      ctrl.canCreateTemplates = function() {
        return EmailService.canModifyTemplates(resolvedOrganization, resolvedPricing, ctrl.requireVerificationFeature);
      };

      delete resolvedTemplate.attributes;
      ctrl.template = resolvedTemplate;
      ctrl.settings = resolvedEmailSettings;

      ctrl.attributeInUse = attributeInUse;
      ctrl.doSubmit = doSubmit;
      ctrl.onEmailContentChange = onEmailContentChange;

      ctrl.doSendPreview = doSendPreview;
      ctrl.doClose = doClose;
      ctrl.canDelete = EmailService.canDelete;
      ctrl.doDelete = doDelete;
      ctrl.doReset = doReset;

      ctrl.doUndo = doUndo;
      ctrl.doRedo = doRedo;

      // Options for the WYSIWYG
      ctrl.redactorOptions = {
        attributes: ctrl.attributes,
        toolbarFixedTopOffset: 42, // This manual value is the height for the naviation
        plugins: [
          'alignment',
          'video',
          'textdirection',
          'acmsAttributes', // Our [custom.attributes]
          'acmsImage', // Use this instead of the native `image` button
          'acmsCta', // A quick way to apply `call-to-action` styles
          'acmsSocialImages', // Insert social links
        ],
      };

      // Run the validation check on every time content changes
      function onEmailContentChange () {
        ctrl.requiredAttributes.forEach(function(attribute) {
          attribute.valid = attributeInUse(attribute);
        });
      }

      // Is a given attribute in use?
      function attributeInUse (attribute) {
        if(ctrl.template && ctrl.template.content){
          var inUse = ctrl.template.content.indexOf(attribute.tag) > -1;
          attribute.valid = (!attribute.required || inUse) ? true : null; // Use `null` to force the form to be invalid
          return inUse;
        }
      }
      // If we're passed a `copy` flag...
      if ($stateParams.copy) {
        delete ctrl.template.id; // Unset the `id` from the template, saving will generate this
        ctrl.template.default = false; // It cannot be a default template
      }
      // Saving the data
      function doSubmit(formCtrl) {
        if (!ctrl.canCreateTemplates()) {
          alertService.alert(
            'Email Template Modification Requires Verification',
            '<p>Custom email templates are available only to verified organizations. Your organization <strong>is not verified yet</strong>. Complete verification to enable this feature, or contact your Customer Success Manager for help.</p>' +
            '<p style="margin-top: 16px;"><a href="https://accredible.my.site.com/helpcenter/s/issuer-verification-form?language=en_US" target="_blank" class="button primary">Complete Verification Form</a></p>', 
            480);
          formCtrl.saveError();
          return;
        }

        return EmailService
          .upsertTemplate(ctrl.template)
          .finally(function() {
            formCtrl.$setPristine(); // Reset the form
            doClose();
          });
      }
      // Send a preview
      function doSendPreview() {
        SendPreviewEmailModalService.show(ctrl.template);
      }
      // Close
      function doClose () {
        $state.transitionTo('issuer.dashboard.email-settings.email-templates');
      }
      // Delete the template
      function doDelete() {
        EmailService.deleteTemplate(ctrl.template)
          .then(function() {
            doClose(); // This page is dead, redirect
          });
      }
      // Reset the template
      function doReset(formCtrl) {
        EmailService.resetTemplate(ctrl.template)
          .then(function() {
            formCtrl.$setPristine(); // Reset the form
          })
          .finally(function() {
            doClose(); // This page is dead, redirect
          });
      }
      // History
      var History = new HistoryFactory(ctrl.template);
      ctrl.canUndo = History.canUndo;
      ctrl.canRedo = History.canRedo;
      function doUndo() {
        History.undo();
      }
      function doRedo() {
        History.redo();
      }
      var saveState = function() {
        History.save(); // Saves the current state to the history object
      };
      var debouncedSaveState = _.debounce(saveState, 300); // The debounce helps keep the history object tracking very minute changes
      $scope.$watch('template', debouncedSaveState, true); // Deeply watch
    }
  ]);


},{}],124:[function(require,module,exports){
angular.module('app')
  .controller('EmailTemplatesCtrl', ['EmailService', 'resolvedPricing', 'resolvedTemplates', 'SendPreviewEmailModalService','languageService', '$log', 'resolvedDepartment', 'resolvedOrganization', 'FlipperFeaturesService', 'alertService',
    function (EmailService, resolvedPricing, resolvedTemplates, SendPreviewEmailModalService, languageService, $log, resolvedDepartment, resolvedOrganization, FlipperFeaturesService, alertService) {
      var ctrl = this;

      ctrl.selectedLanguage = null;
      ctrl.allLanguagesOption = 'all';
      ctrl.templates = resolvedTemplates;
      ctrl.filteredTemplates = ctrl.templates;
      ctrl.templateKinds = [];
      ctrl.department = angular.copy(resolvedDepartment);
      ctrl.plan = resolvedPricing.plan;

      // TODO (JOAO) Remove this once the feature flag is removed
      ctrl.requireVerificationFeature = false;
      FlipperFeaturesService.getFlipperFeatures(resolvedDepartment.id).then(function(features) {
        ctrl.requireVerificationFeature = features.require_verified_corporation_for_legacy_email_templates || false;
      });

      ctrl.canCreateTemplates = function() {
        return EmailService.canModifyTemplates(resolvedOrganization, resolvedPricing, ctrl.requireVerificationFeature);
      };

      ctrl.handleTemplateSelection = function(event) {
        if (!ctrl.canCreateTemplates()) {
          event.preventDefault();
          event.stopPropagation();

          alertService.alert(
            'Organization verification required',
            '<p>Custom email templates are available only to verified organizations. Your organization <strong>is not verified yet</strong>. Complete verification to enable this feature, or contact your Customer Success Manager for help.</p>' +
            '<p style="margin-top: 16px;"><a href="https://accredible.my.site.com/helpcenter/s/issuer-verification-form?language=en_US" target="_blank" class="button primary">Issuer Verification Form</a></p>',
            480
          );
        }
      };

      EmailService.getTemplateKinds()
        .then(function (templateKinds) {
          ctrl.templateKinds = templateKinds;
        });

      // Function to extract all available languages from templates
      ctrl.getLanguagesFromTemplates = function() {
        ctrl.languages = Object.values(ctrl.templates
          .filter(function(template) {
            return languageService.getLanguageFromCodeNoDefault(template.language);
          })
          .reduce(function(languagesAcc, template) {
            var language = languageService.getLanguageFromCodeNoDefault(template.language);
            languagesAcc[language.value] = language;
            return languagesAcc;
          }, {})).sort( function(lang1, lang2) {
          var lang1Description = lang1.description.concat(' (').concat(lang1.name).concat(')');
          var lang2Description = lang2.description.concat(' (').concat(lang2.name).concat(')');
          return lang1Description > lang2Description ? 1 : -1; });
      };

      //Call the function to extract languages
      ctrl.getLanguagesFromTemplates();

      // Function to filter templates when a language is selected
      ctrl.filterTemplatesByLanguage = function(selectedLanguage) {
        var isSelectedLanguageAvailable = ctrl.templates.find(function(template) { return template.language === selectedLanguage; });
        if (isSelectedLanguageAvailable && selectedLanguage !== ctrl.allLanguagesOption) {
          ctrl.filteredTemplates = ctrl.templates.filter(function(template) {
           return template.language === selectedLanguage;
          });
        } else {
          ctrl.selectedLanguage = ctrl.allLanguagesOption;
          ctrl.filteredTemplates = ctrl.templates;
        }
      };

      // Can we copy this template?
      ctrl.canCopy = EmailService.canCopy;

      // Send a preview
      ctrl.doSendPreview = function (template) {
        SendPreviewEmailModalService.show(template);
      };

      // Delete a template
      ctrl.canDelete = EmailService.canDelete;
      ctrl.doDelete = function (template) {
        EmailService.deleteTemplate(template)
          .then(function () {
            for (var t = 0, tl = ctrl.templates.length; t < tl; t++) {
              if (ctrl.templates[t] == template) {
                ctrl.templates.splice(t, 1); // Remove it
                // Recalculate filters and filtered templates
                ctrl.getLanguagesFromTemplates();
                ctrl.filterTemplatesByLanguage(ctrl.selectedLanguage);
                break;
              }
            }
          })
          .catch(function(err){
            $log.error(err);
          });
      };
    }
  ]);

},{}],125:[function(require,module,exports){
angular
  .module('app')
  .controller('EmailTemplatesV2EmbedCtrl', ['resolvedDepartment', 'resolvedUser', '$location',
    function(resolvedDepartment, resolvedUser, $location) {
      var ctrl = this;

      ctrl.asFeatureRoute = true;
      ctrl.asSubRoute = false;
      ctrl.department = angular.copy(resolvedDepartment);
      ctrl.user = resolvedUser;
      ctrl.route = 'email-templates';

      if (Object.keys($location.search()).length) {
        var searchParams = new URLSearchParams($location.search());
        ctrl.queryParams = searchParams.toString();
      }
    }
  ]);

},{}],126:[function(require,module,exports){
angular
  .module('app')
  .controller('EmailCampaignsCtrl', ['resolvedDepartment', 'resolvedUser', '$location',
    function(resolvedDepartment, resolvedUser, $location) {
      var ctrl = this;

      ctrl.department = angular.copy(resolvedDepartment); 
      ctrl.user = resolvedUser;

      // Ensure route is persisted even after page reload
      var locationUrl = $location.path();
      var startIndex = locationUrl.search('email-campaigns');

      ctrl.route = startIndex > 0 ? locationUrl.slice(startIndex) : 'email-campaigns';

      if (Object.keys($location.search()).length) {
        var searchParams = new URLSearchParams($location.search());
        ctrl.queryParams = searchParams.toString();
      }
    }
]);
},{}],127:[function(require,module,exports){
/** EMAIL STYLE :: DIRECTIVE
 *
 *      Renders our email settings style object as CSS
 *
 *          <div email-dynamic-css="settings.style"></div>
 *
 *      @author   David "oodavid" King
 */
(function() {
  angular
    .module('app')
    .directive('emailDynamicCss', [function() {
      var controller = ['$scope', 'fontService', function($scope, fontService) {
        $scope.styleSheet = '';
        // Watch
        $scope.$watch('emailDynamicCss', function(newVal) {
          var css = '';
          angular.forEach(newVal, function(props, selector) {
            // Expand the selector
            var expandedSelector = '#email-template ' + selector; // Assume tag, ie: `p`
            if (selector == 'cta') {
              // V1 CTA markup is `p.cta a`; V2 moved the `cta` class onto the anchor (`a.cta`).
              // Theme both so a revert to V1 still styles CTA buttons authored in either format.
              expandedSelector = '#email-template p.cta a, #email-template a.cta';
            } else if (selector == 'text_sm') {
              expandedSelector = '#email-template p.text-sm'; // Small Text is actually `p.text-sm`
            } else if (selector == 'outer') {
              expandedSelector = '#email-template';
            } else if (selector == 'inner') {
              expandedSelector = '#email-inner';
            } else if (selector == 'inner_header') {
              expandedSelector = '#email-inner-header';
            } else if (selector == 'inner_footer') {
              expandedSelector = '#email-inner-footer';
            }
            // Apply the properties
            css += expandedSelector + ' { '; // #email-template h1 {
            angular.forEach(props, function(value, prop) {
              // Skip "visible"
              if (prop == 'visible') {
                return;
              }
              // Special cases
              if (prop == 'font') {
                css += 'font-family: ' + value.family + '; ';
              } else if (prop == 'border') {
                css += 'border: ' + value.width + ' solid ' + value.color + '; ';
                if (value.top == false) {
                  css += 'border-top: none; ';
                }
                if (value.right == false) {
                  css += 'border-right: none; ';
                }
                if (value.bottom == false) {
                  css += 'border-bottom: none; ';
                }
                if (value.left == false) {
                  css += 'border-left: none; ';
                }
              } else {
                prop = prop.replace(/_/g, '-'); // background_color >> background-color
                css += prop + ': ' + value + '; '; // background-color: #ABCDEF;
              }
            });
            css += '} '; // }
          });
          // This is a little workaround for the border radius being applied to a container, while we have unclipped contents with a background color
          var innerRadius = parseInt(newVal.inner.border_radius) - parseInt(newVal.inner.border.width) + 'px';
          css += ' #email-inner-header, #email-inner-content, #email-inner-footer { border-radius: ' + innerRadius + '; } ';
          // Inner header and footer elements use a flat color for all tags
          css += ' #email-inner-header > div *, #email-inner-footer > div * { color: inherit !important; } ';
          // Make sure we have the font loaded
          fontService.loadFont(newVal.outer.font.name);
          // And apply
          $scope.styleSheet = css;
        }, true); // ...watch deeply
      }];
      return {
        restrict: 'A',
        scope: {
          'emailDynamicCss': '='
        },
        replace: true,
        template: '<style ng-bind-html="styleSheet | trustedHtml"></style>',
        controller: controller,
      };
    }]);
})();

},{}],128:[function(require,module,exports){
angular
  .module('app')
  .controller('EmailNavFeatureCtrl', ['resolvedFlipperFeatures', 'resolvedFeatures', 'resolvedDepartment', 'resolvedUser', '$location',
    function (resolvedFlipperFeatures, resolvedFeatures, resolvedDepartment, resolvedUser, $location) {
      var ctrl = this;
      ctrl.flipperFeatures = resolvedFlipperFeatures;
      ctrl.resolvedFeatures = resolvedFeatures;
      ctrl.department = resolvedDepartment;

      // When the v2_emails_menu flipper is ON, the whole Emails section is handed
      // off to V2 full-page (the same pattern as Analytics). V2 renders its own
      // side menu and handles all sub-routing; the embed-app keeps V2 in sync with
      // the current URL via asFeatureRoute.
      ctrl.user = resolvedUser;
      ctrl.app = 'dashboard';
      ctrl.route = 'email-settings';

      if (Object.keys($location.search()).length) {
        var searchParams = new URLSearchParams($location.search());
        ctrl.queryParams = searchParams.toString();
      }
    }
  ]);

},{}],129:[function(require,module,exports){
angular
  .module('app')
  .controller('EmailSettingsCtrl', ['$window', 'resolvedDepartment', 'resolvedPricing', 'resolvedEmailSettings', 'DepartmentService', 'EmailService', 'alertService','FlipperFeaturesService', 'newSmsAccessModalService', 'CampaignsSmsService',
    function ($window,resolvedDepartment, resolvedPricing, resolvedEmailSettings, DepartmentService, EmailService, alertService, FlipperFeaturesService, newSmsAccessModalService, CampaignsSmsService) {
      var ctrl = this;

      ctrl.department = angular.copy(resolvedDepartment); // Don't pollute
      ctrl.settings = angular.copy(resolvedEmailSettings); // ...ditto
      ctrl.pricing = angular.copy(resolvedPricing);
      ctrl.doSubmit = doSubmit;
      ctrl.showSmsAccessModal = showSmsAccessModal;
      ctrl.supportContactShow = false;
      ctrl.isGrowthPlan = ctrl.pricing.features.corporation_plan === 'growth';
      ctrl.smsRequestStatus = 'initial'; // initial(null), requested, active
      ctrl.salesforcePageUrl = 'https://help.accredible.com/s/sms-feature-request-form';

      FlipperFeaturesService.getFlipperFeatures(ctrl.department.id).then(function(features) {
        ctrl.emailCampaignAdoption = features.email_campaign_adoption;
        ctrl.smsFeatureEnabled = features.campaign_sms_channel;

        checkSmsAccessRequest();
      });

      if ( ctrl.settings.support_contact_name || ctrl.settings.support_contact_email || ctrl.settings.support_contact_phone ) {
        ctrl.supportContactShow = true;
      }

      // Show SMS Access Modal
      function showSmsAccessModal() {
        newSmsAccessModalService.show(ctrl.department.id, function(response) {
          ctrl.smsRequestStatus = response.status;
          $window.open(ctrl.salesforcePageUrl, '_blank');
        });
      }

      // Check and request SMS access if conditions are met
      function checkSmsAccessRequest() {
        if (ctrl.smsFeatureEnabled && ctrl.isGrowthPlan) {
          CampaignsSmsService.getSmsAccessRequest(ctrl.department.id).then(function(response) {
            ctrl.smsRequestStatus = response.status || 'initial';
          }).catch(function() {
            ctrl.smsRequestStatus = 'initial';
          });
        }
      }

      // Save the settings
      function doSubmit(formCtrl) {
        EmailService
          .updateSettings(ctrl.settings)
          .then(function(){
            // Update the resolved data
            angular.copy(ctrl.settings, resolvedEmailSettings);
            // Update the department email, if changed
            if(ctrl.department.email !== resolvedDepartment.email){
              var payload = { email: ctrl.department.email };
              return DepartmentService
                .updateDepartment(payload)
                .then(function(){
                  resolvedDepartment.email = ctrl.department.email;
                })
                .catch(function(err) {
                  if (err.status == 422 && err.data && err.data.errors && err.data.errors.email) {
                    return alertService.alert('Email Already in Use', 'The email address you\'re trying to use is already in use on Accredible. Please use another email address.');
                  } else {
                    return alertService.alert('Could not update Account', 'Please try again, or contact support.');
                  }
                });
            }
          })
          .finally(function () {
            formCtrl.$setPristine(); // Reset the form
          });
      }
    }

  ]);

},{}],130:[function(require,module,exports){
angular
  .module('app')
  .controller('FindCampaignsCtrl', ['resolvedDepartment', 'resolvedUser', '$location',
    function(resolvedDepartment, resolvedUser, $location) {
      var ctrl = this;

      ctrl.department = angular.copy(resolvedDepartment); 
      ctrl.user = resolvedUser;

      // Ensure route is persisted even after page reload
      var locationUrl = $location.path();
      var startIndex = locationUrl.search('find-campaigns');

      ctrl.route = startIndex > 0 ? locationUrl.slice(startIndex) : 'find-campaigns';

      if (Object.keys($location.search()).length) {
        var searchParams = new URLSearchParams($location.search());
        ctrl.queryParams = searchParams.toString();
      }
    }
]);
},{}],131:[function(require,module,exports){
angular
  .module('app')
  .controller('GeneralSettingsV2EmbedCtrl', ['resolvedDepartment', 'resolvedUser', '$location',
    function(resolvedDepartment, resolvedUser, $location) {
      var ctrl = this;

      ctrl.asFeatureRoute = true;
      ctrl.asSubRoute = true;
      ctrl.department = angular.copy(resolvedDepartment);
      ctrl.user = resolvedUser;
      ctrl.route = 'email-settings/general-settings';

      if (Object.keys($location.search()).length) {
        var searchParams = new URLSearchParams($location.search());
        ctrl.queryParams = searchParams.toString();
      }
    }
  ]);

},{}],132:[function(require,module,exports){
angular
  .module('app')
  .controller('SupportContactV2EmbedCtrl', ['resolvedDepartment', 'resolvedUser', '$location',
    function(resolvedDepartment, resolvedUser, $location) {
      var ctrl = this;

      ctrl.asFeatureRoute = true;
      ctrl.asSubRoute = true;
      ctrl.department = angular.copy(resolvedDepartment);
      ctrl.user = resolvedUser;
      ctrl.route = 'email-settings/support-contact';

      if (Object.keys($location.search()).length) {
        var searchParams = new URLSearchParams($location.search());
        ctrl.queryParams = searchParams.toString();
      }
    }
  ]);

},{}],133:[function(require,module,exports){
angular
  .module('app')
  .controller('NewEmailTemplatesCtrl', ['resolvedDepartment', 'resolvedUser', '$location',
    function(resolvedDepartment, resolvedUser, $location) {
      var ctrl = this;

      ctrl.department = angular.copy(resolvedDepartment); 
      ctrl.user = resolvedUser;

      // Ensure route is persisted even after page reload
      var locationUrl = $location.path();
      var startIndex = locationUrl.search('new-email-templates');

      ctrl.route = startIndex > 0 ? locationUrl.slice(startIndex) : 'new-email-templates';

      if (Object.keys($location.search()).length) {
        var searchParams = new URLSearchParams($location.search());
        ctrl.queryParams = searchParams.toString();
      }
    }
]);
},{}],134:[function(require,module,exports){
smtpSettingsCtrl.$inject = ['$scope', '$timeout', 'smtpResponse', 'SmtpSettingsService', 'alertService', 'api', 'DepartmentService', 'FlipperFeaturesService'];
function smtpSettingsCtrl($scope, $timeout, smtpResponse, SmtpSettingsService, alertService, api, DepartmentService, FlipperFeaturesService) {

  var ctrl = this;

  ctrl.data = angular.copy(smtpResponse); // Don't pollute the original
  // Assign to the scope so that the enabled can be watched
  $scope.data = ctrl.data;

  ctrl.testEmail = null;

  ctrl.doSubmit = doSubmit;
  ctrl.sendTestEmail = sendTestEmail;

  ctrl.smtpProviderOptions = {
    'microsoft365': 'Microsoft 365',
  };

  ctrl.microsoft365MailServer = {
    server: 'smtp.office365.com',
    port: 587,
    encryption: 'tls',
    authentication: 'xoauth2',
  };

  DepartmentService.getDepartment().then(function(department) {
    FlipperFeaturesService.getFlipperFeatures(department.id).then(function(features) {
      $scope.microsoftSmtpOauthFF = features.microsoft_smtp_oauth;
    });
  });

  // Save the settings
  function doSubmit(formCtrl) {
    // Hidden hardcoded value for now, eventually we will support other auth methods
    if(ctrl.data.smtp_auth_type === 'oauth2') {
      ctrl.data.oauth_provider.auth_method = 'client_secret_post';
    }
    SmtpSettingsService
      .update({ smtp_settings: ctrl.data.smtp_settings, oauth_provider: ctrl.data.oauth_provider, smtp_auth_type: ctrl.data.smtp_auth_type, smtp_provider: ctrl.data.smtp_provider })
      .then(function(){
        // Update the resolved data
        angular.copy(ctrl.data, smtpResponse);
        angular.copy(ctrl.data.oauth_provider, smtpResponse.oauth_provider);
        ctrl.data.smtp_auth_type = smtpResponse.smtp_auth_type;
        ctrl.data.smtp_provider = smtpResponse.smtp_provider;
        alertService.alert('SMTP Settings Updated', 'Your SMTP settings have been updated.');
      })
      .finally(function () {
        formCtrl.$setPristine(); // Reset the form
      })
      .catch(function (err) {
        var message = ['Please contact support.'];
        if (err.status === 422) {
          message.push(' <small>The following errors were reported:<br/><strong>' + api.parseErrorsToString(err, true) + '</strong></small>'); // The leading space is required
        }
        alertService.alert('Could not update SMTP Settings', message);
      });
  }

  // Send test email
  function sendTestEmail() {
    SmtpSettingsService
      .test(ctrl.testEmail)
      .then(function (response) {
        if (response.status) {
          alertService.open({
            title: 'Email sent successfully',
            content: '<p class="text-center"><img class="alert-image" width="120px" src="/images/email.png"></p>\
                      <p class="text-center">An email has been successfully sent to <strong>' + ctrl.testEmail + '</strong><br/>from <strong>' + ctrl.data.smtp_settings.senderName + '</strong> (' + ctrl.data.smtp_settings.senderEmail + ').</p>',
            ok: 'ok'
          });
        } else {
          alertService.alert('Email failed to send', 'Please try again.');
        }
      })
      .catch(function (err) {
        var message = ['Please contact support.'];
        if (err.status === 422) {
          message.push(' <small>The following errors were reported:<br/><strong>' + api.parseErrorsToString(err, true) + '</strong></small>'); // The leading space is required
        }
        alertService.alert('Email failed to send', message);
      });
  }

  $scope.formBuster = {}; // A MEGA hacky way of gaining access to the form controller. Appropriated from David ;-)

  $scope.$watch('data', function() { 
    if (!ctrl.data.smtp_settings.enabled) {
      angular.copy(smtpResponse.smtp_settings, ctrl.data.smtp_settings); // Revert to saved settings
      if (ctrl.data.smtp_settings.enabled) {
        ctrl.data.smtp_settings.enabled = false; // Reinstate the false value
        $scope.formBuster.formCtrl.$setDirty(); // Dirty the form as the enabled has been changed
      } else {
        $scope.formBuster.formCtrl.$setPristine(); // Reset the form
      }
    }
  });

  $scope.$watch('data.smtp_auth_type', function() { 
    if(ctrl.data.smtp_auth_type !== 'oauth2') {
      ctrl.data.smtp_auth_type = 'basic_auth';
      ctrl.data.smtp_provider = null;
    }
    else {
      ctrl.data.smtp_provider = 'microsoft365';
      ctrl.data.smtp_settings.server = ctrl.microsoft365MailServer.server;
      ctrl.data.smtp_settings.port = ctrl.microsoft365MailServer.port;
      ctrl.data.smtp_settings.encryption = ctrl.microsoft365MailServer.encryption;
      ctrl.data.smtp_settings.authentication = ctrl.microsoft365MailServer.authentication;
    }
  });

  $timeout(function() {
    if ($scope.formBuster.formCtrl) { // Force the form to be pristine even if the empty field values supplied by BE are invalid
      $scope.formBuster.formCtrl.$setPristine(); // Reset the form
    }
  });
}

angular
  .module('app')
  .controller('smtpSettingsCtrl', smtpSettingsCtrl);

},{}],135:[function(require,module,exports){
angular
  .module('app')
  .controller('SmtpSettingsV2EmbedCtrl', ['resolvedDepartment', 'resolvedUser', '$location',
    function(resolvedDepartment, resolvedUser, $location) {
      var ctrl = this;

      ctrl.asFeatureRoute = true;
      ctrl.asSubRoute = true;
      ctrl.department = angular.copy(resolvedDepartment);
      ctrl.user = resolvedUser;
      ctrl.route = 'email-settings/smtp-settings';

      if (Object.keys($location.search()).length) {
        var searchParams = new URLSearchParams($location.search());
        ctrl.queryParams = searchParams.toString();
      }
    }
  ]);

},{}],136:[function(require,module,exports){
GroupOverviewCtrl.$inject = ['resolvedGroup', 'EmbedAppService'];
function GroupOverviewCtrl(resolvedGroup, EmbedAppService) {
  var ctrl = this;
  ctrl.group = resolvedGroup;

  ctrl.setCredentialsListData = function (group) {
    var data = {
      filters: {
        selectedGroups: [{ id: group.id, name: group.name }],
      }
    };
    EmbedAppService.setData(data);
  }
}

angular
  .module('app')
  .controller('GroupOverviewCtrl', GroupOverviewCtrl);

},{}],137:[function(require,module,exports){

angular.module('app')
  .filter('eligibleCourses', function() {
    return function(courses, requirementRow, metaCertId) {
      var filteredCourse = [];

      angular.forEach(courses, function(course) {
        var notInRow = true;
        for (var i = requirementRow.length - 1; i >= 0; i--) {
          if (requirementRow[i].id === course.id) {
            notInRow = false;
          }
        }
        if (notInRow && course.id !== metaCertId) {
          this.push(course);
        }
      }, filteredCourse);

      return filteredCourse;
    };
  });

},{}],138:[function(require,module,exports){
groupCtrl.$inject = ['$state', '$stateParams', 'resolvedUser', 'resolvedOrganization', 'resolvedDepartment', 'resolvedGroup', 'resolvedGroups', 'resolvedEmailTemplates', 'GroupService', '_', 'api', 'resolvedAttributes', 'DesignSelectorService', 'CertificateEditorService', 'BadgeEditorService', 'createdGroupModalService', 'supportService', 'CredentialPreviewService', 'FeaturesService', 'swalService', 'FlipperFeaturesService'];
function groupCtrl($state, $stateParams, resolvedUser, resolvedOrganization, resolvedDepartment, resolvedGroup, resolvedGroups, resolvedEmailTemplates, GroupService, _, api, resolvedAttributes, DesignSelectorService, CertificateEditorService, BadgeEditorService, createdGroupModalService, supportService, CredentialPreviewService, FeaturesService, swalService, FlipperFeaturesService) {

  var ctrl = this;

  ctrl.id = $stateParams.id; // 'new', 'default', 12345
  ctrl.isDefault = ($stateParams.id == 'default');
  ctrl.isCloning = $stateParams.clone;
  ctrl.supportService = supportService;
  ctrl.swalservice = swalService;
  ctrl.user = resolvedUser;
  ctrl.organization = resolvedOrganization;
  ctrl.department = resolvedDepartment;
  ctrl.resolvedGroup = resolvedGroup; // The saved group data
  ctrl.group = parseResolvedGroup(); // ...copied, and potentially dirty / unsaved
  ctrl.group.primary_design = getInitialPrimaryDesignValue(ctrl.group); // Set the primary_design value based on the group primary_design_id, certificate_design and badge_design property values
  ctrl.groups = resolvedGroups;
  ctrl.doSubmit = doSubmit;
  ctrl.doSubmitWithNullToggle = doSubmitWithNullToggle;
  ctrl.emailSettingOverridesNullify = emailSettingOverridesNullify;
  ctrl.doSubmitWithNullToggleFunction = doSubmitWithNullToggleFunction;
  ctrl.showPreviewModal = showPreviewModal;
  ctrl.jobTitles = [
    {name: "Academic"},
    {name: "Accountant"},
    {name: "Financial Accounting"},
    {name: "Accounts Payable"},
    {name: "Accounts Receivable"},
    {name: "System Administrator"},
    {name: "Office Administration"},
    {name: "Business Administration"},
    {name: "Project Administrator"},
    {name: "Financial Administrator"},
    {name: "Advertising"},
    {name: "Financial Advisor"},
    {name: "Agency"},
    {name: "Data Analyst"},
    {name: "Analyst"},
    {name: "Business Analyst"},
    {name: "Animation"},
    {name: "Apprenticeships"},
    {name: "Solutions Architect"},
    {name: "Technical Architect"},
    {name: "Architect"},
    {name: "Architectural Design"},
    {name: "Sales Assistant"},
    {name: "Executive Assistant"},
    {name: "Project Assistant"},
    {name: "Office Assistant"},
    {name: "Sales Associate"},
    {name: "Quality Assurance"},
    {name: "Assurance"},
    {name: "Auditor"},
    {name: "Autocad"},
    {name: "Babysitter"},
    {name: "Commercial Banking"},
    {name: "Barista"},
    {name: "Big Data"},
    {name: "Bookkeeper"},
    {name: "Brand Manager"},
    {name: "Building"},
    {name: "Building Operator"},
    {name: "Building Industry"},
    {name: "Bus Driver"},
    {name: "Business Objects"},
    {name: "New Business Development"},
    {name: "Business Science"},
    {name: "Business Development Manager"},
    {name: "Community Care"},
    {name: "Live In Care"},
    {name: "Caregiver"},
    {name: "Case Manager"},
    {name: "Casual"},
    {name: "Caterer"},
    {name: "Ceo"},
    {name: "Cfo"},
    {name: "Supply Chain"},
    {name: "Change Management"},
    {name: "Charities"},
    {name: "Chauffeur"},
    {name: "Chef"},
    {name: "Chief Executive"},
    {name: "Civil Engineer"},
    {name: "Clean Energy"},
    {name: "Cleaner"},
    {name: "Clerical"},
    {name: "Clerk"},
    {name: "Clinical Psychology"},
    {name: "Coaching"},
    {name: "Coach Driver"},
    {name: "Coal"},
    {name: "Collections Manager"},
    {name: "Commercial Manager"},
    {name: "Community Development"},
    {name: "Community Engagement"},
    {name: "Community Health"},
    {name: "Compliance Manager"},
    {name: "Computer Engineering"},
    {name: "Construction Manager"},
    {name: "Construction Management"},
    {name: "Industrial Construction"},
    {name: "IT Consultant"},
    {name: "Consulting"},
    {name: "Management Consultant"},
    {name: "Content Manager"},
    {name: "Quality Control"},
    {name: "Inventory Control"},
    {name: "Project Controls"},
    {name: "Financial Controller"},
    {name: "Cook"},
    {name: "Coordinator"},
    {name: "Program Coordinator"},
    {name: "Project Coordinator"},
    {name: "Corporate Finance"},
    {name: "Council"},
    {name: "Counselling"},
    {name: "Courier"},
    {name: "Cpa"},
    {name: "Customer Support"},
    {name: "Cyber Security"},
    {name: "Data Scientist"},
    {name: "Data Processing"},
    {name: "Delivery Driver"},
    {name: "Dentist"},
    {name: "Graphic Design"},
    {name: "Designer"},
    {name: "Graphic Designer"},
    {name: "Web Designer"},
    {name: "Ui Designer"},
    {name: "Industrial Design"},
    {name: "Structural Design"},
    {name: "Front Desk"},
    {name: "Front End Developer"},
    {name: "Web Developer"},
    {name: "Java Developer"},
    {name: "Education Development"},
    {name: "Digital Marketing"},
    {name: "Digital Media"},
    {name: "Digital"},
    {name: "Direct Sales"},
    {name: "Director"},
    {name: "Finance Director"},
    {name: "Director Of Operations"},
    {name: "Marketing Director"},
    {name: "Dispatch"},
    {name: "Diving"},
    {name: "Doctor"},
    {name: "Driving"},
    {name: "Taxi Driver"},
    {name: "Truck Driver"},
    {name: "Editor"},
    {name: "Electrical Engineering"},
    {name: "Electrician"},
    {name: "Electronics"},
    {name: "Energy Market"},
    {name: "Nuclear Energy"},
    {name: "Renewable Energy"},
    {name: "Systems Engineer"},
    {name: "Mechanical Engineer"},
    {name: "Project Engineering"},
    {name: "Field Engineer"},
    {name: "Software Engineer"},
    {name: "Software Test Engineer"},
    {name: "Estimator"},
    {name: "Event Planning"},
    {name: "Events Manager"},
    {name: "Marketing Executive"},
    {name: "Exploration"},
    {name: "Facilities Manager"},
    {name: "Facilities Management"},
    {name: "Family Support"},
    {name: "Field Sales"},
    {name: "Film"},
    {name: "Food Preparation"},
    {name: "Fraud Prevention"},
    {name: "Fundraiser"},
    {name: "Gas"},
    {name: "Genetics"},
    {name: "Github"},
    {name: "Government"},
    {name: "Green"},
    {name: "Occupational Health"},
    {name: "Health Research"},
    {name: "Mental Health"},
    {name: "Public Health"},
    {name: "Health Promotion"},
    {name: "Heritage"},
    {name: "Home Working"},
    {name: "Housekeeper"},
    {name: "Hr Manager"},
    {name: "Human Rights"},
    {name: "Illustrator"},
    {name: "Information Technology"},
    {name: "Information Science"},
    {name: "Instrumentation"},
    {name: "International Travel"},
    {name: "Investigator"},
    {name: "IT Manager"},
    {name: "IT Security"},
    {name: "IT Support"},
    {name: "Labourer"},
    {name: "Labouring"},
    {name: "Landscaping"},
    {name: "Lawyer"},
    {name: "Machine Learning"},
    {name: "Litigation"},
    {name: "Lpn"},
    {name: "Maid"},
    {name: "Maintenance Manager"},
    {name: "Marketing Manager"},
    {name: "Store Manager"},
    {name: "Security Manager"},
    {name: "Operations Manager"},
    {name: "Product Manager"},
    {name: "Risk Management"},
    {name: "Project Manager"},
    {name: "Production Manager"},
    {name: "Quality Manager"},
    {name: "Service Manager"},
    {name: "Wealth Management"},
    {name: "Office Manager"},
    {name: "Procurement Manager"},
    {name: "Property Manager"},
    {name: "Relationship Manager"},
    {name: "Marine"},
    {name: "Market Researcher"},
    {name: "Market Research"},
    {name: "Mba"},
    {name: "Social Media"},
    {name: "Medical Researcher"},
    {name: "Merchandising"},
    {name: "Mining"},
    {name: "Miner"},
    {name: "Mysql"},
    {name: "Nanny"},
    {name: "Special Needs"},
    {name: "Non Profit"},
    {name: "Nurse"},
    {name: "Psychiatric Nurse"},
    {name: "Oil"},
    {name: "Process Operator"},
    {name: "Packing"},
    {name: "Packaging"},
    {name: "Temporary Part Time"},
    {name: "Pharmaceutical"},
    {name: "Pharmacology"},
    {name: "Phd"},
    {name: "Photographer"},
    {name: "Physics"},
    {name: "Pilot"},
    {name: "Pipeline"},
    {name: "Planning Resource"},
    {name: "Platform"},
    {name: "Policy"},
    {name: "Politics"},
    {name: "Pre Sales"},
    {name: "Printing"},
    {name: "Procurement"},
    {name: "Product Testing"},
    {name: "Programmer"},
    {name: "Proofreading"},
    {name: "Psychologist"},
    {name: "Public Relations"},
    {name: "Public Service"},
    {name: "Purchasing"},
    {name: "Qa"},
    {name: "Qa Tester"},
    {name: "Receptionist"},
    {name: "Recruiter"},
    {name: "Sales Representative"},
    {name: "Research Scientist"},
    {name: "Rigging"},
    {name: "Runner"},
    {name: "Software Sales"},
    {name: "Sales Support"},
    {name: "Saturday"},
    {name: "Secretary"},
    {name: "Social Service"},
    {name: "Shipping"},
    {name: "Software Testing"},
    {name: "Startup"},
    {name: "Summer"},
    {name: "Supervisor"},
    {name: "Surveying"},
    {name: "Sustainability"},
    {name: "Technician"},
    {name: "Temporary"},
    {name: "Testing"},
    {name: "Translator"},
    {name: "Tv"},
    {name: "Undergraduate"},
    {name: "Underwriter"},
    {name: "Vet"},
    {name: "Volunteer"},
    {name: "Voluntary"},
    {name: "Waitress"},
    {name: "Writing"},
    {name: "Youth"},
    {name: "Youtube"},
  ];

  ctrl.customMessageEnabled = FeaturesService.getFeature('custom_marketing_message');
  if (!ctrl.customMessageEnabled) {
    ctrl.group.custom_message_show = false;
  }

  function showPreviewModal() {
    CredentialPreviewService.showPreviewModal(ctrl.group);
  }

  // Parses the resolvedGroup - performing any data massage as necessary
  function parseResolvedGroup(){
    // Don't pollute the resolve
    var group = angular.copy(resolvedGroup);
    // Are we cloning a group?
    if (ctrl.isCloning) {
      delete group.id; // ...then we don't need the id
      delete group.name; // ...or the unique name
      delete group.credentials_count; // ...nor the count
    }

    // Now we explicitly save course_link on Visibility we can't do this any more...
    // Fall back to the department URL
    // group.course_link = group.course_link || resolvedDepartment.url;

    // Convert auto_expiry to string
    if (group.auto_expiry) {
      group.auto_expiry = group.auto_expiry.toString();
    }

    // And return
    return group;
  }

  /** DO SUBMIT
   *
   * This is a somewhat unusual submit function; it plucks
   *  out JUST the inputs available to the form that triggered
   *  the method. It builds up an object of the same structure,
   *  then submits JUST those values.
   *
   * Why do this? The page has multiple forms, each linked to
   *  different parts of the `ctrl.group` object. The user must
   *  purposfully submit each form. We DON'T want to send the
   *  entire object, as this may include modified values from
   *  other, dirty forms.
   */
  function doSubmit(formCtrl){
    // Submit only the fields visible on this form
    var data = pluckFormValues(formCtrl);
    // Wrangle primary_design, if we have one
    if (data.primary_design) {
      // Add the primary_design_id to the submission data
      data.primary_design_id = addPrimaryDesignIdFromPrimaryDesign(data);
      // primary_design is not required in the request body so we remove it
      delete data.primary_design;
    }
    // Creating a NEW group?
    if(!ctrl.group.id){
      data = _.merge({}, angular.copy(resolvedGroup), data); // Include the default values, but don't overwrite
    }

    if (ctrl.id === 'default' || ctrl.id === 'new') {
      data.show_on_coursefinder = true;
    }

    // Always need an id
    data.id = ctrl.group.id;
    // Now submit
    GroupService.upsert(data)
      .then(function (response) {
        _.merge(resolvedGroup, data); // Update the resolvedGroup to match the modified values
        // Always update `can_create_credential`
        resolvedGroup.can_create_credential = ctrl.group.can_create_credential = response.can_create_credential;
        // Always update `allow_duplicate_credentials`
        ctrl.allow_duplicate_credentials = response.allow_duplicate_credentials;
        ctrl.generate_private_credential = response.generate_private_credential;
        // If we created a NEW group...
        if(response.id !== resolvedGroup.id){
          // Always update `id`
          resolvedGroup.id = response.id;
          ctrl.group.id = response.id;
          // Alert
          createdGroupModalService.show(response);
          // Update the route
          ctrl.isCloning = false;
          $state.go('.', { id:response.id, clone:null }, { location: 'replace', reload: false });
        }
        // Notify the form
        formCtrl.saveSuccess();
      })
      .catch(function(e){
        switch (Object.keys(e.data.errors)[0]) {
          case 'allow_duplicate_credentials':
            ctrl.group.allow_duplicate_credentials = true;
            swalService.showAlert('groupDuplicatesError');
            break;
        }
        // Always prepare the form status for any error on the response
        formCtrl.saveError();
      });
  }

  // References only the values that have been used on the form
  function pluckFormValues(formCtrl){
    var data = {};
    angular.forEach(formCtrl, function(value, key){
      if(typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.hasOwnProperty('$$attr') && value.$$attr.hasOwnProperty('ngModel')){
        var modelName = value.$$attr.ngModel; // Something like "$ctrl.group.course_name" or "$ctrl.group.certificate_design.id"
        var modelPath = modelName.substr(12); // Something like "name" or "design.id"
        _.set(data, modelPath, value.$modelValue);
      }
    });
    return data;
  }

  function addPrimaryDesignIdFromPrimaryDesign(data) {
    if (data.primary_design === 'badge') {
      return data.badge_design.id;
    } else {
      return data.certificate_design.id;
    }
  }
  /*
    This function is used to determine the initial value for the ctrl.group.primary_design. This is property is only used in the DOM to select the correct radio input under the group designs
  */
  function getInitialPrimaryDesignValue(group) {
    if (group.certificate_design && group.badge_design) {
      // If we have both a certificate_design and badge_design we need to decide if the primary_design should be a certificate or badge
      if (group.primary_design_id) {
        // If we do have a primary_design_id we can compare it to the badge_ids and certificate_design ids
        if (group.badge_design.id === group.primary_design_id) {
          // If the primary_design_id matches the badge_design_id the primary_design is a badge
          return 'badge';
        }
      } else {
        // If we don't have the primary_design_id we default to the certificate
        return 'certificate';
      }
    } else if (group.badge_design && !group.certificate_design) {
      // If we only have the badge_design the primary_design should be a badge
      return 'badge';
    } else if (!group.badge_design && !group.certificate_design) {
      return null;
    }
    // In all other cases the primary_design radio should be set to certificate
    return 'certificate';
  }

  /** DO SUBMIT... WITH NULL TOGGLE
   *
   * If the `nullToggle` value is `false` then all
   *  inputs within the formCtrl will be set to null
   *  before falling back to the normal routine.
   */
  function doSubmitWithNullToggle(formCtrl, nullToggle){
    if(!nullToggle){
      // Make all values null
      angular.forEach(formCtrl, function(value, key){
        if(typeof value === 'object'){
          if(value.hasOwnProperty('$modelValue')){ value.$modelValue = null; }
          if(value.hasOwnProperty('$viewValue')){  value.$viewValue = null; }
          if(value.hasOwnProperty('$render')){     value.$render(); }
        }
      });
    }
    return doSubmit(formCtrl);
  }
  function emailSettingOverridesNullify(fieldName) {
    var result = false;
    if (fieldName) {
      if (!ctrl.usingCustomEmailTemplates) {
        result = result || ['myCredentialReceived', 'myCredentialExpiryWarning', 'myCredentialExpired', 'myCredentialRenewed'].indexOf(fieldName) > -1;
      }
      if (!ctrl.usingCustomEmailSender) {
        result = result || ['myFromName', 'myFromEmail', 'myReplyToName', 'myReplyToEmail'].indexOf(fieldName) > -1;
      }
    }
    return result;
  }
  function doSubmitWithNullToggleFunction(formCtrl, nullToggleFunction) {
    formCtrl.$getControls().forEach(function(obj) {
      if (nullToggleFunction(obj.$name)) {
        if (obj.hasOwnProperty('$modelValue')) {
          obj.$modelValue = null;
        }
        if (obj.hasOwnProperty('$viewValue')) {
          obj.$viewValue = null;
        }
        if (obj.hasOwnProperty('$render')) {
          obj.$render();
        }
      }
    });
    return doSubmit(formCtrl);
  }

  /** HAS APPEARANCE
   *
   *    Returns boolean if we have a badge or certificate
   */
  ctrl.hasAppearance = hasAppearance;
  function hasAppearance() {
    return ctrl.group.certificate_design || ctrl.group.badge_design;
  }

  /** CERTIFICATE DESIGN
   *
   *  Edit Certificate Design
   *    Opens the editor
   *
   */
  ctrl.editCertificate = function(ngModel){
    var certificate = ngModel.$viewValue || ngModel.$modelValue;
    CertificateEditorService
      .open(certificate)
      .then(function(newCertificate){
        updateDesign(ngModel, newCertificate);
      });
  };

  /** BADGE DESIGN **/

  ctrl.editBadge = function(ngModel){
    var badge = ngModel.$viewValue || ngModel.$modelValue;
    BadgeEditorService
      .open(badge)
      .then(function (updatedBadge) {
        updateDesign(ngModel, updatedBadge);
      });
  };

  ctrl.selectDesign = function(kind, ngModel) {
    DesignSelectorService
      .open(kind, resolvedGroup.id)
      .then(function(design){
        if (design === 'create') {
          if (kind === 'badge') {
            ctrl.editBadge(ngModel);
          } else {
            ctrl.editCertificate(ngModel);
          }
        } else {
          updateDesign(ngModel, design);
        }
      });
  };

  ctrl.removeDesign = function(ngModel) {
    updateDesign(ngModel, null);
  };

  function updateDesign(ngModel, design) {
    ngModel.$setViewValue(design);
    ngModel.$render();
    ctrl.group.primary_design = getInitialPrimaryDesignValue(ctrl.group);
  }

  /** EMAIL SENDER INFORMATION
   *
   * Simply, the user can toggle a switch and make
   *  all values `null`, this custom submit handler
   *  does just that, then passes the request to the
   *  normal routine above.
   */
  ctrl.usingCustomEmailSender = !!(ctrl.group.from_email || ctrl.group.from_name || ctrl.group.reply_to_email || ctrl.group.reply_to_name);

  /** EMAIL TEMPLATES
   */
  ctrl.usingCustomEmailTemplates = !!(resolvedGroup.credential_received_email_id || resolvedGroup.credential_expiry_warning_email_id || resolvedGroup.credential_expired_email_id || resolvedGroup.credential_renewal_email_id);
  ctrl.emailTemplates = resolvedEmailTemplates;
  // Filter to show only the templates relevant to "Credential Received"
  ctrl.credentialReceivedFilter = function(template) {
    return template.default == false && ['certificate_received', 'badge_received', 'certificate_and_badge_received'].indexOf(template.kind) != -1;
  };

  /** STACKED CREDENTIAL
   *
   * Wholesale cut and paste from previous modal with a
   *  few modifications to force it to work with ngModel
   *
   *  Ideal candidate for a custom input
   */
  ctrl.meta_requirements = parseRequirementsFromGroup(ctrl.group);
  ctrl.hasOrCondition = false; // Used to suppress 'Electives are not supported.' message
  for (var index = 0; index < ctrl.meta_requirements.length; index++) {
    ctrl.hasOrCondition = ctrl.hasOrCondition || ctrl.meta_requirements[index].length > 1;
  }
  ctrl.meta_requirements_count = 0;
  ctrl.stackableGroups = getStackedCredentialEligibleGroups();
  ctrl.addRequirementRow = addRequirementRow;
  ctrl.addRequirement = addRequirement;
  ctrl.removeRequirement = removeRequirement;
  updateRequirementsCount();
  function findCourseById(id) {
    for (var i = ctrl.groups.length - 1; i >= 0; i--) {
      if (ctrl.groups[i].id === id) {
        return {
          name: ctrl.groups[i].name,
          id: ctrl.groups[i].id
        };
      }
    }
  }
  function parseRequirementsFromGroup(group) {
    var meta_requirements = [];
    if (group.meta_achievement_logic) {
      for (var i = 0; i < group.meta_achievement_logic.length; i++) {
        meta_requirements.push([]);
        for (var j = 0; j < group.meta_achievement_logic[i].length; j++) {
          meta_requirements[i].push(findCourseById(group.meta_achievement_logic[i][j]));
        }

      }
    }
    return meta_requirements;
  }
  function updateRequirementsCount() {
    ctrl.meta_requirements_count = 0;
    for (var ml = ctrl.meta_requirements.length, m = 0; m < ml; m++) {
      var row = ctrl.meta_requirements[m];
      for (var rl = row.length, r = 0; r < rl; r++) {
        ctrl.meta_requirements_count++;
      }
    }
  }
  // Returns all groups { name, id }
  function getStackedCredentialEligibleGroups(){
    var groups = [];
    for (var i = ctrl.groups.length - 1; i >= 0; i--) {
      groups.push({
        name: ctrl.groups[i].name,
        id: ctrl.groups[i].id
      });
    }
    return groups;
  }
  // editable and displayable requirements
  function updateRequirementsInputCtrl(inputCtrl) {
    // Rebuild the id-based structure
    var value = [];
    for (var ml = ctrl.meta_requirements.length, m = 0; m < ml; m++) {
      var row = ctrl.meta_requirements[m];
      var tmp = [];
      for (var rl = row.length, r = 0; r < rl; r++) {
        tmp.push(row[r].id);
      }
      if (tmp.length) {
        value.push(tmp);
      }
    }
    // Update the controller
    inputCtrl.$setViewValue(value);
    inputCtrl.$setDirty();
    inputCtrl.$render();
    // Update the count
    updateRequirementsCount();
  }
  function removeRequirementRow(row) {
    var index = ctrl.meta_requirements.indexOf(row);
    ctrl.meta_requirements.splice(index, 1);
  }
  function addRequirementRow() {
    ctrl.meta_requirements.push([]);
  }
  function addRequirement(inputCtrl, row, requirement) {
    row.push(requirement);
    updateRequirementsInputCtrl(inputCtrl);
  }
  function removeRequirement(inputCtrl, row, requirement) {
    var index = row.indexOf(requirement);
    row.splice(index, 1);
    if (row.length === 0) {
      removeRequirementRow(row);
    }
    updateRequirementsInputCtrl(inputCtrl);
  }

  /* TRANSCRIPT LETTER
  */
  ctrl.letterType = 'credential';

  ctrl.usingTranscript = !!(ctrl.group.transcript);

  // WYSIWYG options
  ctrl.redactorOptions = {
    attributes: resolvedAttributes,
    toolbarFixedTopOffset: 42, // This manual value is the height for the naviation
    plugins: [
      'alignment',
      'video',
      'table',
      'textdirection',
      'acmsAttributes', // Our [custom.attributes]
      'acmsImage', // Use this instead of the native `image` button
    ],
  };

  /* ALLOW DUPLICATES
  */

  ctrl.allow_duplicate_credentials = ctrl.group.allow_duplicate_credentials;

  /* GENERATE PRIVATE CREDENTIALS
  */

  ctrl.generate_private_credential = ctrl.group.generate_private_credential;

  /* LEARNING OUTCOMES
  */

  ctrl.jobCount = 0;
  ctrl.retrievedJobs = false;
  ctrl.onJobs = onJobs;
  ctrl.updateJobInsights = updateJobInsights;

  function onJobs($event){
    ctrl.jobCount = $event.jobCount;
    ctrl.retrievedJobs = true;
  }
  function updateJobInsights($event){
    if (ctrl.group.job_insights){
      ctrl.group.job_insights['job_title'] = $event.selection.name;
    }else{
      ctrl.group.job_insights = {job_title: $event.selection.name};
    }
  }
}

angular
  .module('app')
  .controller('groupCtrl', groupCtrl);

},{}],139:[function(require,module,exports){
groupNavCtrl.$inject = ['$stateParams', '$element', '$scope', 'resolvedUser', 'resolvedGroup', 'StateCacheService', 'DesignSelectorService', 'BadgeEditorService', 'CredentialPreviewService', 'alertService', '$rootScope', 'CertificateEditorService', 'resolvedDepartment',  'EmbedAppService','FeaturesService', 'FlipperFeaturesService', 'resolvedOrganization', 'resolvedFlipperFeatures', '$location'];
function groupNavCtrl($stateParams, $element, $scope, resolvedUser, resolvedGroup, StateCacheService, DesignSelectorService, BadgeEditorService, CredentialPreviewService, alertService, $rootScope, CertificateEditorService, resolvedDepartment, EmbedAppService, FeaturesService, FlipperFeaturesService, resolvedOrganization, resolvedFlipperFeatures, $location) {

  var ctrl = this;

  ctrl.id = $stateParams.id; // 'new', 'default', 12345

  // When the v2_groups_menu flipper is ON, the whole Group settings section is handed
  // off to V2 full-page (the same pattern as Analytics/Emails). V2 renders its own side
  // menu and handles all sub-routing; the embed-app keeps V2 in sync via asFeatureRoute.
  ctrl.flipperFeatures = resolvedFlipperFeatures;
  ctrl.app = 'dashboard';
  
  // Seed V2 from the active :edit param so a hard refresh keeps the same tab
  // (e.g. endorsement) instead of resetting to information-and-appearance.
  ctrl.route = 'group/' + $stateParams.id + '/' + ($stateParams.edit || 'information-and-appearance');

  if (Object.keys($location.search()).length) {
    var searchParams = new URLSearchParams($location.search());
    ctrl.queryParams = searchParams.toString();
  }
  ctrl.isDefault = ($stateParams.id == 'default');
  ctrl.showEndorsement = FeaturesService.getFeature('ace_endorsements');
  ctrl.isNew = ($stateParams.id == 'new');
  ctrl.isCloning = $stateParams.clone;
  ctrl.advanced = ($stateParams.edit != null && $stateParams.edit != 'information-and-appearance');
  ctrl.user = resolvedUser;
  ctrl.department = resolvedDepartment;
  ctrl.group = angular.copy(resolvedGroup); // Don't pollute
  ctrl.showPreviewModal = showPreviewModal;
  ctrl.groupsSubRoute = StateCacheService.recallRouteView('issuer.dashboard.groups') || 'grid'; // REINSTATE - the sub-route to return to

  ctrl.letterType = 'credential-letter';

  // Listen for the dirty state of the contained form
  CredentialPreviewService.monitorFormState($element, $scope);

  function showPreviewModal() {
    CredentialPreviewService.showPreviewModal(ctrl.group);
  }

  ctrl.setCredentialsListData = function (group) {
    var data = {
      filters: {
        selectedGroups: [{ id: group.id, name: group.name }],
      }
    };
    EmbedAppService.setData(data);
  };
}

angular
  .module('app')
  .controller('groupNavCtrl', groupNavCtrl);

},{}],140:[function(require,module,exports){
GroupsCtrl.$inject = ['$window', '$timeout', 'api', '_', 'GroupService', 'alertService', 'AnalyticsService', 'TagsService', 'StateCacheService', 'resolvedDepartment', 'EmbedAppService'];
function GroupsCtrl($window, $timeout, api, _, GroupService, alertService, AnalyticsService, TagsService, StateCacheService, resolvedDepartment, EmbedAppService) {
  var ctrl = this;

  // Scoped variables up top, a quick reference point for our designers
  ctrl.groups = []; // Array of visible groups
  ctrl.meta = false; // Meta data from the response
  ctrl.emptyPayload = true; // Is the payload empty?

  ctrl.department = resolvedDepartment;

  // Our search / filter form - it should be linked to the form models
  ctrl.filter = StateCacheService.resolveCache({ // REINSTATE - loads the cached state or returns the object passed in
    page_size: 30,
    page: null,
    group_identifier: null,
    order: null,
    tags: null,
    appearance: null,
  });

  var cachedScroll = ctrl.filter.scroll; // REINSTATE - locally cache the state-cached scroll and clear the filter value
  ctrl.filter.scroll = null;

  // Flags
  ctrl.noGroups = false;
  ctrl.oneGroup = false;

  // Methods
  ctrl.doSubmitForm = submitForm;
  ctrl.updatePagination = updatePagination;
  ctrl.updateOrderBy = updateOrderBy;
  ctrl.applyFilters = applyFilters;
  ctrl.clearFilters = clearFilters;

  // Design Type
  ctrl.designTypeOptions = [
    { value: null,          title: 'All' },
    { value: 'certificate', title: 'Certificate' },
    { value: 'badge',       title: 'Badge' },
    { value: 'both',        title: 'Certificate & Badge' },
    { value: 'none',        title: 'No Design' },
  ];

  // Begin by submitting the form
  submitForm(null, true);

  // Returns a payload
  function getPayload() {
    // Clone the form into the POST object for manipulation
    var payload = angular.copy(ctrl.filter);
    // Make sure the certificate_design_id is numerical - This is not being used
    // if (payload.certificate_design_id) {
    //   payload.certificate_design_id = parseInt(payload.certificate_design_id);
    // }
    // Convert the appearance into multiple flags for the BE
    if(payload.appearance == 'none'){
     payload.has_design = false;
     payload.has_badge  = false;
     payload.has_no_appearance = true;
    } else {
     payload.has_design = (payload.appearance === 'certificate' || payload.appearance === 'both') ? true : null;
     payload.has_badge  = (payload.appearance === 'badge'       || payload.appearance === 'both') ? true : null;
     payload.has_no_appearance = null;
    }
    delete payload.appearance;
    // Remove NULL or '' or [] values (keeping BOOLEAN and non-empty STRINGS)
    payload = _.omitBy(payload, function(v) {
      return v === null || v === '';
    });
    // ...
    return payload;
  }

  // Submits the form
  function submitForm(opts, firstLoad) {
    // We may want to reset the Page number
    if (opts && opts.resetPage) {
      ctrl.filter.page = 0;
    }
    // Get the payload
    var payload = getPayload();
     // Is the payload empty?
    ctrl.emptyPayload = _(payload)
      .omit(['page_size', 'page', 'order']) // Ignore the page, page_size and order values
      .omitBy(function (prop) { return !prop; }) // Remove empty values
      .isEmpty(); // Is the new object empty? {}
    // Action in progress flags
    ctrl.loading = true;
    // Get intial groups data
    api
      .request('/groups/all', payload)
      .then(function(response) {
        AnalyticsService.trackEvent('Groups > Search Group');
        ctrl.loading = false;
        angular.forEach(response.groups, function(group){
          group.completeness = getGroupCompleteness(group);
        });
        ctrl.groups = response.groups;
        ctrl.meta = response.meta;
        if (firstLoad) {
          ctrl.noGroups = ctrl.groups.length === 0;
          ctrl.oneGroup = ctrl.groups.length === 1;
        }
        $timeout(function() {
          $window.scrollTo(0, cachedScroll || 0); // Scroll to cached value or scroll to the top
          cachedScroll = null; // Clear locally cached value
        });
        StateCacheService.setCache(ctrl.filter); // REINSTATE - cache the new filter values
      })
      .catch(function(err) {
        ctrl.loading = false;
        console.log('failure', err);
        ctrl.groups = [];
        ctrl.error = 'Failure! ' + JSON.stringify(err);
      });
  }

  // Update the page number
  function updatePagination(event) {
    ctrl.filter.page = event.page;
    submitForm();
  }

  // Update the order by
  function updateOrderBy(event){
    ctrl.filter.order = event.order;
    submitForm({
      resetPage: true
    });
  }

  // Apply Filters
  function applyFilters(){
    submitForm({ resetPage: true });
  }

  // Clear filters
  function clearFilters() {
    ctrl.filter.group_identifier = null;
    ctrl.filter.has_design = null;
    ctrl.filter.has_badge = null;
    ctrl.filter.has_no_appearance = null;
    ctrl.filter.tags = null;
    ctrl.filter.appearance = null;
    applyFilters();
  }

  // Has credential
  ctrl.atLeastOneCredential = function() {
    var total = 0;
    for (var i = 0; i < ctrl.groups.length; i++) {
      total += ctrl.groups[i].credentials_count;
    }
    return total > 0;
  };

  // Tags
  ctrl.tagsQuery = '';
  ctrl.tagOptions = [];
  ctrl.tagOptionsOriginal = [];
  TagsService.getAllTags().then(function (tags) {
    ctrl.tagOptions.length = 0;
    angular.forEach(tags, function (tag) {
      ctrl.tagOptions.push({ value: tag, title: tag });
    });
    ctrl.tagOptions = sortAlphabeticallyByTitle(ctrl.tagOptions);
    ctrl.tagOptionsOriginal = sortAlphabeticallyByTitle(ctrl.tagOptions);
  });

  function sortAlphabeticallyByTitle(tagArray) {
    return tagArray.sort(function (a, b) {
      if (a.title < b.title) {
        return -1;
      }
      if (a.title > b.title) {
        return 1;
      }
      return 0;
    });
  }

  ctrl.filterTagsByQueryString = function () {
    if (ctrl.tagsQuery.length === 0) {
      ctrl.tagOptions = ctrl.tagOptionsOriginal.map(function (tag) {
        return tag;
      });
    } else {
      ctrl.tagOptions = ctrl.tagOptions.filter(function (option) {
        return option.title
          .toLowerCase()
          .includes(ctrl.tagsQuery.toLowerCase());
      });
    }
  };


  /** GET PROGRESS
   *
   * How "complete" is a group?
   */
  function getGroupCompleteness(group){
    var completeness = 1; // The group exists
    if(group.certificate_design || group.badge_design){
      completeness ++; // They've added a design
    }
    if(group.learning_outcomes){
      completeness ++; // They've added learning outcomes
    }
    return completeness;
  }

  /** DELETE GROUP
   *
   *    Shortcut to delete a group
   */
  ctrl.deleteGroup = function(group) {
    if (group.credentials_count > 0) {
      alertService
        .alert(
          'Group cannot be deleted',
          [
            ' <strong>' + group.name + ' contains ' + group.credentials_count + ' ' + (group.credentials_count == 1 ? 'credential' : 'credentials') + '</strong>.',
            'To delete this group, delete all of the credentials in it first.'
          ]
        );
    } else {
      alertService
        .confirm(
          'Delete Group?',
          [
            ' <strong>' + group.name + ' </strong> has no credentials, but it may have course information and settings.',
            'Are you sure you want to delete it?'
          ],
          'delete'
        )
        .then(function(){
          return GroupService.destroy(group);
        })
        .then(function(){
          submitForm(); // Reload
        })
        .catch(function(err) {
          // Stop unhandled rejection
        });
    }
  };

  ctrl.setCredentialsListData = function(group) {
    var data = {
      filters: {
        selectedGroups: [{ id: group.id, name: group.name }],
      }
    };
    EmbedAppService.setData(data);
  }
}

angular
  .module('app')
  .controller('GroupsCtrl', GroupsCtrl);

},{}],141:[function(require,module,exports){
MfaStatusService.$inject = ['api'];
function MfaStatusService(api) {
  var service = this;
  service.getMfaStatus = getMfaStatus;

  function getMfaStatus(organizationId){
    return api.request('/security_setting/mfa_status', { id: organizationId });
  }
}

angular.module('app')
  .service('MfaStatusService', MfaStatusService);

},{}],142:[function(require,module,exports){
HomeCtrl.$inject = ['$state', '$scope', 'FtueService', 'alertService', 'AnalyticsService', 'resolvedUser', 'resolvedHasGroupOrDesign', 'resolvedPermissions', 'resolvedPricing', 'resolvedDepartment', 'resolvedDepartments', 'resolvedFeatures', 'NameChangeRequestsService', 'exampleCredentialModalService', 'CertificateEditorService', 'DepartmentAnalyticsService', 'AuthService', 'EmbedAppService', 'MfaStatusService'];
function HomeCtrl($state, $scope, FtueService, alertService, AnalyticsService, resolvedUser, resolvedHasGroupOrDesign, resolvedPermissions, resolvedPricing, resolvedDepartment, resolvedDepartments, resolvedFeatures, NameChangeRequestsService, exampleCredentialModalService, CertificateEditorService, DepartmentAnalyticsService, AuthService, EmbedAppService, MfaStatusService){
  var ctrl = this;

  // Properties
  ctrl.user = resolvedUser;
  ctrl.hasGroup = resolvedHasGroupOrDesign.has_groups;
  ctrl.hasDesign = resolvedHasGroupOrDesign.has_designs;
  ctrl.department = resolvedDepartment;
  ctrl.permissions = resolvedPermissions;
  ctrl.features = resolvedFeatures;
  ctrl.pricing = resolvedPricing;
  ctrl.legacy_remaining_credits = resolvedDepartment.certificate_left;

  ctrl.trackGuideDownload = function() {
    AnalyticsService.trackEvent('Dashboard > Home > Download Guide');
  };

  // Name Change Requests
  ctrl.pendingNameChangeRequests = 0;
  NameChangeRequestsService
    .getNameChangeRequestCount(resolvedDepartment.id)
    .then(function(response) {
      ctrl.pendingNameChangeRequests = response.recipient_name_change_requests.count;
    });

  // We only need to make the following request if user is admin, the banner should only show up for admins
  if (resolvedPermissions.admin) {
    // MFA status to get MFA reset request in order to show banner or not
    ctrl.mfaResetRequests = 0;
    MfaStatusService
      .getMfaStatus(resolvedDepartment.id)
      .then(function(response) {
        ctrl.mfaResetRequests = response.meta.mfa_reset_requests;
      });
  }

  // Prompt when tryin to add credentials before any roups are created
  ctrl.noGroupsPrompt = function() {
    alertService
      .confirm(
        'No Groups',
        [
          'Before you can add Credentials you must first create a Group.'
        ],
        'create'
      )
      .then(function(){
        $state.go('issuer.dashboard.group.edit', { id: 'new', edit: 'information-and-appearance' });
      })
      .catch(function(err) {
        // Stop unhandled rejection
      });
  };

  // Example Credential
  ctrl.sendExampleCredential = function() {
    exampleCredentialModalService.show(ctrl.user);
  };

  // Create a certificate design
  ctrl.createCertificateDesign = function() {
    CertificateEditorService
      .open()
      .then(function(/* design */){
        $state.go('issuer.dashboard.certificate-designs');
      });
  };

  function getTotalCredentials() { // This is not being used
    // ctrl.department['total_credentials'] = resolvedDepartments.filter(function(department) {
    //   return department.id === ctrl.department.id;
    // })[0].total_credentials;
  }

  ctrl.credentials_issued_all_time = 0;
  function getIssuance() {
    ctrl.issuance = null;
    DepartmentAnalyticsService
      .getDepartmentIssuanceReport()
      .then(function (response) {
        ctrl.issuance = response.issuance;
        ctrl.credentials_issued_all_time = ctrl.issuance.credentials_issued_all_time;
      });
  }

  function updateIndicators() {
    if (ctrl.linkedInShares && ctrl.twitterShares) {
      ctrl.sharesDown =
        (ctrl.linkedInShares.before_last_week + ctrl.linkedInShares.last_week) === 0 ||
        (ctrl.twitterShares.before_last_week + ctrl.twitterShares.last_week) === 0 ||
        (ctrl.linkedInShares.last_week / ctrl.linkedInShares.before_last_week) < 1 ||
        (ctrl.twitterShares.last_week / ctrl.twitterShares.before_last_week) < 1;
      ctrl.sharesImproving =
        !ctrl.sharesDown && (
          (ctrl.linkedInShares.last_week / ctrl.linkedInShares.before_last_week) > 1 ||
          (ctrl.twitterShares.last_week / ctrl.twitterShares.before_last_week) > 1
        );
    }
  }

  function getLinkedInShares() {
    ctrl.linkedInShares = null;
    DepartmentAnalyticsService
      .getShareStats('linkedin')
      .then(function (response) {
        ctrl.linkedInShares = response.feed;
        updateIndicators();
      });
  }

  function getLinkedInSearchUrl() {
    // var linkedInSearchString; // If available, use SEO Title, otherwise use issuer name with "Accredible"
    // if (ctrl.department.social_media && ctrl.department.social_media.seo && ctrl.department.social_media.seo.title) {
    //   linkedInSearchString = '"' + ctrl.department.social_media.seo.title
    //                                 .split(/\s?\[.*\]\s?/)
    //                                 .filter(function(string) { return string !== ''; })
    //                                 .join('" "') // Split out attribute tokens
    //                              + '"';
    // } else {
    //   linkedInSearchString = '"' + ctrl.department.name + '" Accredible';
    // }
    // ctrl.linkedInSearchUrl = 'https://www.linkedin.com/search/results/content/?keywords=' + encodeURIComponent(linkedInSearchString);
    var query = '"' + ctrl.department.name + '" AND (badge OR certificate)';
    ctrl.linkedInSearchUrl = 'https://www.linkedin.com/search/results/content/?keywords=' + encodeURIComponent(query) + '&origin=GLOBAL_SEARCH_HEADER';
  }

  function getTwitterShares() {
    ctrl.twitterShares = null;
    DepartmentAnalyticsService
      .getShareStats('twitter')
      .then(function (response) {
        ctrl.twitterShares = response.feed;
        updateIndicators();
      });
  }

  function getTwitterSearchUrl() {
    var twitterSearchString = ctrl.department.whitelabel_domain ?
                              ctrl.department.whitelabel_domain :
                              ctrl.department.social_media && ctrl.department.social_media.twitter && ctrl.department.social_media.twitter.id ?
                              ctrl.department.social_media.twitter.id + '%20credential.net' :
                              null;
    ctrl.twitterSearchUrl = twitterSearchString ? 'https://twitter.com/search?q=' + twitterSearchString : null;
  }

  function authedUpdateWidgets(auth) {
    if (auth.department && auth.department.id === ctrl.department.id) {
      getTotalCredentials();
      getIssuance();
      getLinkedInShares();
      getLinkedInSearchUrl();
      getTwitterShares();
      getTwitterSearchUrl();
    }
  }

  // Update widgets when changing department
  var listener = AuthService.on('change', authedUpdateWidgets);

  // Clean up
  $scope.$on('$destroy', function () {
    AuthService.off(listener);
  });

  // Update widget data on instantiation
  getTotalCredentials();
  getIssuance();
  getLinkedInShares();
  getLinkedInSearchUrl();
  getTwitterShares();
  getTwitterSearchUrl();

  ctrl.setCredentialsListData = function () {
    var data = {
      createCredential: true,
    };
    EmbedAppService.setData(data);
  }
}

angular
  .module('app')
  .controller('HomeCtrl', HomeCtrl);

},{}],143:[function(require,module,exports){
/** BILLING INVOICES
 *
 *      @author   Andrew Bateman
 */
InvoicesCtrl.$inject = ['resolvedInvoicesAndPlan', 'resolvedFlipperFeatures', 'supportService', 'moment'];
function InvoicesCtrl(resolvedInvoicesAndPlan, resolvedFlipperFeatures, supportService, moment) {
  var ctrl = this;
  var allInvoices = resolvedInvoicesAndPlan.invoices;

  ctrl.custom_plan = resolvedInvoicesAndPlan.custom_plan;
  ctrl.flipperFeatures = resolvedFlipperFeatures;
  ctrl.invoices = [];
  ctrl.filter = {
    start_date: null,
    end_date: null,
  };
  ctrl.noInvoices = !allInvoices || allInvoices.length === 0;
  ctrl.hasPackagingEnabled = ctrl.flipperFeatures.packaging;

  ctrl.supportService = supportService;
  ctrl.applyFilter = applyFilter;
  ctrl.clearFilters = clearFilters;
  applyFilter();

  // FE filter
  function applyFilter(){
    angular.copy(allInvoices, ctrl.invoices);
    // After
    if(ctrl.filter.start_date){
      var start_date = moment(ctrl.filter.start_date, 'YYYY-MM-DD').subtract(1, 'days'); // we want "or-equal-to"
      ctrl.invoices = ctrl.invoices.filter(function(invoice){
        var end = moment(invoice.period_end, 'YYYY-MM-DD');
        return end.isAfter(start_date);
      });
    }
    // Before
    if(ctrl.filter.end_date){
      var end_date = moment(ctrl.filter.end_date, 'YYYY-MM-DD').add(1, 'days'); // we want "or-equal-to"
      ctrl.invoices = ctrl.invoices.filter(function(invoice){
        var start = moment(invoice.period_start, 'YYYY-MM-DD');
        return start.isBefore(end_date);
      });
    }
  }

  function clearFilters(){
    ctrl.filter.start_date = null;
    ctrl.filter.end_date = null;
    applyFilter();
  }

}

angular
  .module('app')
  .controller('InvoicesCtrl', InvoicesCtrl);

},{}],144:[function(require,module,exports){
/** My Account Route Controller
 *
 *    This is a small controller to allow the user to view what they can and can not access
 *     on the Accredible Dashboard.
 *
 *    In future, they could request access to features here.
 *
 *    @author   Alan Heppenstall
 *    @editor   Jake "the growler" Ford
 */
angular
  .module('app')
  .controller('MyAccountRouteCtrl', ['$scope', '$state', 'resolvedDepartment', 'resolvedUser', 'resolvedPermissions', 'PermissionsService', 'api',
    function($scope, $state, resolvedDepartment, resolvedUser, resolvedPermissions, PermissionsService, api) {

      var ctrl = this;
      ctrl.user = resolvedUser;
      ctrl.department = resolvedDepartment;
      ctrl.permissions = resolvedPermissions;
      ctrl.allPermissions = PermissionsService.getAllPermissions();

      // Load the groups so we can show the user what they have access to - this is truly awful
      $scope.loading = true;
      api
        .request('/groups/all', { only_custom_attributes: true, page_size: 1000 })
        .then(function(response) {
          $scope.loading = false;
          ctrl.groups = response.groups;
        });

      // Helper :: Does the user have no permissions?
      ctrl.noPermissions = true;
      angular.forEach(ctrl.allPermissions, function(permission){
        if(ctrl.permissions[permission.id]){
          ctrl.noPermissions = false;
        }
      });

    }
  ]);

},{}],145:[function(require,module,exports){
NameChangeRequestsService.$inject = ['api', 'swalService'];
function NameChangeRequestsService(api, swalService) {
  var service = this;
  service.search = search;
  service.getNameChangeRequestCount = getNameChangeRequestCount;
  service.action = action;

  function search(payload){
    return api.request('/name_change_requests/all', payload);
  }

  function getNameChangeRequestCount(organizationId){
    return api.request('/name_change_request_count', { id: organizationId });
  }

  function action(selection, action){
    var payload = {};
    if(selection === 'everything'){
      payload.select_all = true;
    } else {
      payload.ids = selection;
    }
    payload.operation = action;
    return api.request('/name_change_requests/update', payload)
      .then(function(/* response */){
        var alert = (action === 'approve') ? 'nameChangeApproveSuccess' : 'nameChangeDenySuccess';
        swalService.showAlert(alert);
      })
      .catch(function(/* err */){
        var alert = (action === 'approve') ? 'nameChangeApproveError' : 'nameChangeDenyError';
        swalService.showAlert(alert);
      });
  }
}

angular.module('app')
  .service('NameChangeRequestsService', NameChangeRequestsService);

},{}],146:[function(require,module,exports){
NameChangeRequestsCtrl.$inject = ['NameChangeRequestsService'];
function NameChangeRequestsCtrl(NameChangeRequestsService) {
  var ctrl = this;

  ctrl.meta;
  ctrl.selection;
  ctrl.credentials;
  ctrl.loading = true;
  ctrl.form = {
    page_size: 50,
    page: 0,
    order: null,
  };
  ctrl.updatePagination = updatePagination;
  ctrl.updateOrderBy = updateOrderBy;
  ctrl.updateSelection = updateSelection;
  ctrl.actionNameChanges = actionNameChanges;

  submitForm();

  function submitForm(){
    ctrl.loading = true;
    NameChangeRequestsService
      .search(ctrl.form)
      .then(function(response){
        ctrl.meta = response.meta;
        ctrl.credentials = response.credentials;
        ctrl.loading = false;
      });
  }

  function updateOrderBy(event){
    ctrl.form.order = event.order;
    ctrl.form.page = 0;
    submitForm();
  }

  function updatePagination(event){
    ctrl.form.page = event.page;
    submitForm();
  }

  function updateSelection(event){
    ctrl.selection = event.selection;
  }

  function actionNameChanges(action){
    ctrl.loading = true;
    NameChangeRequestsService
      .action(ctrl.selection, action)
      .then(submitForm);
  }

}

angular
  .module('app')
  .controller('NameChangeRequestsCtrl', NameChangeRequestsCtrl);

},{}],147:[function(require,module,exports){
// Service
PathwayBuilderService.$inject = ['$q', 'PathwayService', '$injector', '$filter', '$window', 'HistoryFactory'];
function PathwayBuilderService($q, PathwayService, $injector, $filter, $window, HistoryFactory) {
  var service = this;

  var emptyPathway = {
    name: null,
    groups: [],
    pathways: [],
    nodes: null
  };

  service.settings = PathwayService.settings;

  service.data = {
    visible: false,
    saving: false,
    pathway: angular.copy(emptyPathway),
    pathwayUpdated: false,
    activeElement: null,
    groups: null,
    groupNameFilter: null,
    pathways: null,
    pathwayNameFilter: null,
    history: null,
    prerequisiteId: null,
    previewPrerequisite: null,
    openPathways: []
  };

  service.open = open;
  service.editPathway = editPathway;
  service.replacePathway = replacePathway;
  service.changePathwayKind = changePathwayKind;
  service.getGroupName = getGroupName;
  service.getElementData = getElementData;
  service.close = close;
  service.save = save;
  service.clonePathway = clonePathway;
  service.pathwayContains = pathwayContains;
  service.addNode = addNode;
  service.removeNode = removeNode;
  service.moveNode = moveNode;
  service.checkElementAcceptability = checkElementAcceptability;
  service.nodeContainsElement = nodeContainsElement;
  service.addElementToNode = addElementToNode;
  service.removeElement = removeElement;
  service.clearElements = clearElements;
  service.preventEventPropagation = preventEventPropagation;
  service.selectElement = selectElement;
  service.deselectElement = deselectElement;
  service.selectPrerequisite = selectPrerequisite;
  service.setNodeKind = setNodeKind;
  service.setNodeOptionsRule = setNodeOptionsRule;
  service.loadTemplate = loadTemplate;
  service.createPathwayFromActiveGroup = createPathwayFromActiveGroup;
  service.getPathwayData = getPathwayData;
  service.getPathwayIcon = getPathwayIcon;
  service.saveState = saveState;
  service.undo = undo;
  service.redo = redo;

  service.getPathwayKindName = PathwayService.getPathwayKindName;

  service.filterGroups = filterGroups;
  service.filterPathways = filterPathways;

  var groupHash = {};
  var prefilteredGroups;
  var prefilteredPathways;

  function filteredGroups() {
    var regex = new RegExp(service.data.groupNameFilter, 'i');
    return prefilteredGroups.filter(function(group) {
      return !service.data.groupNameFilter || group.course_name.match(regex);
    });
  }

  function filterGroups() {
    service.data.groups = filteredGroups();
  }

  function loadGroups(data) {
    prefilteredGroups = data;
    filterGroups();
    prefilteredGroups.forEach(function(group) {
      groupHash[group.id] = group;
    });
  }

  function filteredPathways() {
    var regex = new RegExp(service.data.pathwayNameFilter, 'i');
    return prefilteredPathways.filter(function(pathway) {
      return !service.data.pathwayNameFilter || pathway.name.match(regex);
    });
  }

  function filterPathways() {
    service.data.pathways = filteredPathways();
  }

  function loadPathways() {
    prefilteredPathways = PathwayService.getPathways();
    filterPathways();
  }

  function getGroupName(id) {
    return groupHash[id].course_name;
  }

  function getElementData(element) {
    if (element.kind === 'group') {
      var group = groupHash[element.id];
      return { name: group.course_name, badge: group.badge_design, certificate: group.certificate_design };
    }
    return PathwayService.getPathwayData(element.id);
  }

  var currentPathwayState = null;

  var pathwaySaved = false; // A pathway has been saved
  function doLoad(pathwayState, saved) {
    pathwaySaved = pathwaySaved || saved;
    if (pathwayState) {
      currentPathwayState = pathwayState;
      service.data.pathway = currentPathwayState.edit;
      service.data.pathwayUpdated = true;
      updateHistoryObject();
      service.data.history = currentPathwayState.history;
      return false;
    } else {
      console.log('Close pathway editor');
      service.data.openPathways = [];
      currentPathwayState = null;
      service.data.pathway = angular.copy(emptyPathway);
      service.data.history = null;
      service.data.visible = false;
      if (deferred && deferred.resolve){
        deferred.resolve(pathwaySaved);
      }
      return true;
    }
  }

  // Loads a copy of the pathway
  function load(pathway, replace) {
    if (currentPathwayState && !replace) {
      //currentPathwayState.history.off('restoreSnapshot', onRestoreSnapshot);
      service.data.openPathways.push(currentPathwayState);
    }
    doLoad({ original: pathway || PathwayService.stubPathway(), edit: angular.copy(pathway), tracker: {}, history: null }, false);
  }

  var deferred;
  // Promise to open the editor with the given pathway
  function open(id, groups){
    deferred = $q.defer();
    loadGroups(groups);
    loadPathways();
    if (id) {
      load(PathwayService.getPathwayById(id));
    }
    service.data.visible = true;
    pathwaySaved = false;
    // Return the promise, resolved when the editor is closed
    return deferred.promise;
  }

  function close() {
    if (service.data.visible) {
      if (service.data.pathway.nodes && currentPathwayState.history.canUndo()) {
        var translate = $filter('translate');
        var message = translate('unsaved.changes-single-form'); // Notify
        message += '\n\n' + 'Discard changes made to pathway ' + (service.data.pathway.name || 'Untitled') + '?'; // Action
        if ($window.confirm(message)) {
          //currentPathwayState.history.off('restoreSnapshot', onRestoreSnapshot);
          return doLoad(service.data.openPathways.pop(), false);
        } else {
          return false;
        }
      } else {
        return doLoad(service.data.openPathways.pop(), false);
      }
    }
    return true;
  }

  function saveWarningMessage(autoActions, userActions, kind) {
    var message = '';
    if (autoActions.length > 0) {
      message += 'This pathway is not a valid ' + readableKind(kind) + ' pathway.\n\nTo fix this, the editor will...\n';
      message += '• ' + autoActions.join('\n• ');
    }
    if (userActions.length > 0) {
      message += autoActions.length === 0 ? 'This pathway is not a valid ' + readableKind(kind) + ' pathway.\n\nYou will need to...\n': '\n\nYou will then need to...\n';
      message += '• ' + userActions.join('\n• ');
    }
    message += '\n\nOnce this is done, the pathway can be saved.';
    return message;
  }

  function save() {
    var kind = service.data.pathway.kind;
    var validity = checkValidity(kind);
    if (validity.autoActions.length === 0 && validity.userActions.length === 0) {
      PathwayService // No changes needed, just save
        .savePathway(service.data.pathway)
        .then(function(pathwayId) {
          console.log('Saved pathway id', pathwayId);
          doLoad(service.data.openPathways.pop(), true);
        });
    } else if (validity.autoActions.length === 0) {
      $window.alert(saveWarningMessage(validity.autoActions, validity.userActions, kind)); // Report needed user changes
    } else if ($window.confirm(saveWarningMessage(validity.autoActions, validity.userActions, kind))) { // Report all needed changes to user
      // If directed by user, apply changes
      runRemediators(validity.nodeIntegrity);
      // Switch to updated pathway
      currentPathwayState.edit = validity.pathway;
      service.data.pathway = currentPathwayState.edit;
      service.data.pathwayUpdated = true;
      saveState();
    }
  }

  function replacePathway(id) {
    PathwayService
      .get(id)
      .then(load);
  }

  function runRemediators(integrityResults) {
    integrityResults.forEach(function(result) {
      result.remediators.forEach(function(remediator) {
        if (remediator.action) {
          remediator.action();
        }
      });
    });
  }

  function readableKind(kind) {
    return $filter('capitalize')($filter('underscoresToSpaces')(kind));
  }

  function applyPathwayKind(pathway, kind) {
    pathway.kind = kind;
    currentPathwayState.edit = pathway;
    service.data.pathway = currentPathwayState.edit;
    service.data.pathwayUpdated = true;
    saveState();
  }

  function kindChangeMessage(autoActions, userActions, kind) {
    var message = '';
    if (autoActions.length > 0) {
      message += 'In order to change the type of this pathway to ' + readableKind(kind) + ' the editor will...\n';
      message += '• ' + autoActions.join('\n• ');
    }
    if (userActions.length > 0) {
      message += (autoActions.length === 0 ? 'To complete the change of the type of this pathway to ' + readableKind(kind) : '\n\nTo complete the change') + ' you will need to...\n';
      message += '• ' + userActions.join('\n• ');
    }
    return message;
  }

  function checkValidity(pathwayKind, ignoreEmptyNodes) {
    var pathway = angular.copy(service.data.pathway); // Copy the pathway
    var pathwayIntegrity = PathwayService.runFullIntegrityCheck('pathway', pathwayKind, pathway, null, ignoreEmptyNodes); // Check how pathway structure needs to be changed
    runRemediators([pathwayIntegrity]); // Make those changes
    var result = {
      pathway: pathway,
      nodeIntegrity: [],
      autoActions: [],
      userActions: []
    };
    pathway.nodes.forEach(function(node, index) { // Check how structure of the remaining nodes needs to be changed
      result.nodeIntegrity.push(PathwayService.runFullIntegrityCheck('node', pathwayKind, node, index + 1, ignoreEmptyNodes)); // Use '1' based, rather than '0' based, counting
    });
    pathwayIntegrity.remediators.forEach(function(remediator) {
      if (remediator.action) {
        result.autoActions.push(remediator.description);
      } else {
        result.userActions.push(remediator.description);
      }
    });
    result.nodeIntegrity.forEach(function(node) {
      node.remediators.forEach(function(remediator) {
        if (remediator.action) {
          result.autoActions.push(remediator.description);
        } else {
          result.userActions.push(remediator.description);
        }
      });
    });
    return result;
  }

  function changePathwayKind(kind) {
    var validity = checkValidity(kind, true);
    if (validity.autoActions.length === 0 && validity.userActions.length === 0) {
      applyPathwayKind(validity.pathway, kind); // No changes needed, just apply kind
    } else if ($window.confirm(kindChangeMessage(validity.autoActions, validity.userActions, kind))) { // Report needed changes to user
      // If directed by user, apply changes and apply kind
      runRemediators(validity.nodeIntegrity);
      applyPathwayKind(validity.pathway, kind);
    }
  }

  function checkElementAcceptability(nodeIndex, elementType, elementId, destination) {
    if (nodeIndex != null) {
      var result = !nodeContainsElement(nodeIndex, elementType, elementId);
      if (result && service.data.pathway.nodes) {
        var node = service.data.pathway.nodes[nodeIndex];
        switch (service.data.pathway.kind) {
          case 'closed_stack':
          case 'open_stack':
            if (destination === node.options.elements) {
              result = false;
            }
            break;
          case 'milestone':
            break;
          case 'cluster':
            if (destination === node.required.elements) {
              result = false;
            }
            break;
          case 'generic':
            break;
        }
      }
      return result;
    } else if (elementType === 'pathway' && destination === service.data.pathways) {
      return true;
    } else {
      return false;
    }
  }

  function clonePathway(pathwayElement) {
    load(PathwayService.clonePathway(pathwayElement.attr('element-id')));
  }

  function pathwayContains(kind, id) {
    switch (kind) {
      case 'group':
        return service.data.pathway.groups.indexOf($.type(id) === 'string' ? parseInt(id) : id) > -1; // Group ids are currently integers - boo!
      case 'pathway':
        return service.data.pathway.pathways.indexOf(id) > -1;
    }
  }

  function insertNode(node, index) {
    var nodesCopy = angular.copy(service.data.pathway.nodes);
    nodesCopy.splice(index, 0, node);
    service.data.pathway.nodes = nodesCopy;
    saveState();
  }

  function addNode(kind, index, requiredElement) {
    var newNode = PathwayService.newNode(kind);
    if (requiredElement) {
      addElementToNode(index, newNode.required.elements, requiredElement);
    }
    insertNode(newNode, index);
  }

  function removeNode(index) {
    service.data.pathway.nodes.splice(index, 1);
    saveState();
  }

  function moveNode(sourceIndex, targetIndex) {
    if (targetIndex - sourceIndex !== 1) {
      var sourceNode = service.data.pathway.nodes.splice(sourceIndex, 1)[0];
      service.data.pathway.nodes.splice(targetIndex, 0, sourceNode);
      saveState();
    }
  }

  function elementsContains(elements, element) {
    var contains = false;
    var elementId = element.attr('element-id');
    for (var index = 0; index < elements.length; index++) {
      if (elements[index].id == elementId) { // == here as id can be a string or a number, boo!
        contains = true;
        break;
      }
    }
    return contains;
  }

  function nodeContainsElement(nodeIndex, elementKind, elementId) {
    var contains = false;
    if (service.data.pathway.nodes && nodeIndex < service.data.pathway.nodes.length) { // Ignore the last insert point index
      var node = service.data.pathway.nodes[nodeIndex];
      var elements = node.required.elements.concat(node.options.elements);
      for (var index = 0; index < elements.length; index++) {
        if (elements[index].kind === elementKind && elements[index].id === elementId) {
          contains = true;
          break;
        }
      }
    }
    return contains;
  }

  function addElementToTypedPathwayNode(node, destination, element) {
    var pathwayKind = service.data.pathway.kind;
    if ((node.kind === 'award' || pathwayKind.contains('stack')) && destination === node.required.elements) { // Stacks only contain one required element
      var currentElement = destination[0];
      if (currentElement) {
        removePathwayElement(currentElement.kind, currentElement.id);
      }
      destination[0] = element;
    } else {
      destination.push(element);
    }
  }

  function addElementToNode(nodeIndex, destination, element) {
    var node = service.data.pathway.nodes[nodeIndex];
    var type = element.attr('draggable-element');
    //if (!elementsContains(destination, element)) { // Not needed as we no longer allow an element to be used more than once in a pathway
      var category = element.attr('elements');
      var listElement;
      if (category) {
        listElement = removeElement(service.data.pathway.nodes[parseInt(element.attr('node-index'))][category].elements, parseInt(element.attr('element-index')), true);
      }
      if (listElement && node.kind === 'award') {
        listElement.value = 0;
      }
      addElementToTypedPathwayNode(node, destination, listElement || { id: type === 'group' ? parseInt(element.attr('element-id')) : element.attr('element-id'), kind: type, value: node.kind === 'award' ? 0 : 15 });
      switch (type) {
        case 'group':
          service.data.pathway.groups.push(parseInt(element.attr('element-id'))); // Group ids are currently integers - boo!
          break;
        case 'pathway':
          service.data.pathway.pathways.push(element.attr('element-id'));
          break;
      }
      saveState();
    //}
  }

  function removePathwayElement(kind, id) {
    var elementList = kind === 'group' ? service.data.pathway.groups : service.data.pathway.pathways;
    var elementIndex = elementList.indexOf(id);
    elementList.splice(elementIndex, 1);
  }

  function removeElement(list, index, noSave) {
    var removedElement = list.splice(index, 1)[0];
    if (removedElement === service.data.activeElement) {
      service.data.activeElement = null;
    }
    removePathwayElement(removedElement.kind, removedElement.id);
    if (!noSave) {
      saveState();
    }
    return removedElement;
  }

  function clearElements(list) {
    list.elements.forEach(function(element) {
      removePathwayElement(element.kind, element.id);
    });
    list.elements = [];
    if (list.hasOwnProperty('rule')) {
      list.rule = 'Any';
    }
    saveState();
  }

  // Close when routing
  if ($injector.has('$transitions')) {
    var $transitions = $injector.get('$transitions');
    $transitions.onStart({}, function($transition) {
      return close(); // Cancelling the transition still pops the browser history stack
    });
  }

  // Prevent event propagation
  function preventEventPropagation($event) {
    $event.preventDefault();
    $event.stopImmediatePropagation();
  }

  function isWithin(item, x, y) {
    var offset = item.offset();
    var left = offset.left;
    var right = left + item.width();
    var top = offset.top;
    var bottom = top + item.width();
    return x > left && x < right && y > top && y < bottom;
  }

  // Select element
  function selectElement($event, element) {
    if (service.settings.element_info) {
      var target = $($event.target);
      if (!target.closest('[draggable-element]').hasClass('ui-draggable-dragging') && isWithin(target, $event.clientX, $event.clientY)) { // Don't select if dragging
      // Cancel normal behaviours
        preventEventPropagation($event);
        service.data.activeElement = element;
        service.data.prerequisiteId = null;
        // Move prerequisites for open pathways to the start of the list
        // Collect together pathways currently being edited into a list ordered newest to oldest
        var currentEditPathways = [];
        service.data.openPathways.forEach(function(pathwayState) {
          currentEditPathways.unshift(pathwayState.edit);
        });
        currentEditPathways.unshift(currentPathwayState.edit);
        // Get prerequisites with those belonging to the open pathways first
        var prerequisites = PathwayService.prerequisites(currentEditPathways, service.data.activeElement.id);
        service.data.activeElement['prerequisites'] = prerequisites;
        service.data.activeElement['associated_pathways'] = PathwayService.getAssociatedPathways(currentPathwayState.edit.id, service.data.activeElement.id);
      }
    }
  }

  // Deselect group
  function deselectElement() {
    service.data.activeElement = null; // Removes active group information panel
    service.data.prerequisiteId = null; // Removes prerequisite highlight from current pathway
    service.data.previewPrerequisite = null; // Removes prerequisite preview
  }

  function setNodeKind(index, kind) {
    var node = service.data.pathway.nodes[index];
    if (kind === 'award' && node.options.elements.length > 0) {
      var message = 'Changing the type of this node to Award will remove all options items';
      if ($window.confirm(message)) {
        node.kind = kind;
        saveState();
      }
    } else {
      node.kind = kind;
    }
    saveState();
  }

  function setNodeOptionsRule(node, rule) {
    node.options.rule = rule;
    saveState();
  }

  function selectPrerequisite(prerequisite) {
    service.data.prerequisiteId = prerequisite.data.node.id;
    if (prerequisite.data.pathway_id !== currentPathwayState.edit.id) {
      service.data.previewPrerequisite = prerequisite.data;
    } else {
      service.data.previewPrerequisite = null;
    }
  }

  function doLoadTemplate(kind) {
    PathwayService
      .createPathwayFromTemplate(kind)
      .then(function(pathway) {
        load(pathway, true);
        service.data.activeElement = null;
      });
  }

  function loadTemplate(kind) {
    if (currentPathwayState && currentPathwayState.history.canUndo()) {
      var message =
        'There are unsaved changes to pathway ' + ( service.data.pathway.name || 'Untitled pathway' ) +
        '.\n\nDiscard these changes and create a new ' + readableKind(kind) + ' pathway?';
      if ($window.confirm(message)) {
        doLoadTemplate(kind);
      }
    } else {
      doLoadTemplate(kind);
    }
  }

  function editPathway(id) {
    PathwayService
      .getById(id)
      .then(function(pathway) {
        load(pathway);
        service.data.activeElement = null;
      });
  }

  function createPathwayFromActiveGroup() {
    PathwayService
      .createPathwayFromGroupId(service.data.activeElement.id)
      .then(function(pathway) {
        load(pathway);
        service.data.activeElement = null;
      });
  }

  function getPathwayData(id) {
    if (service.data.pathway.id === id) {
      return { kind: service.data.pathway.kind, name: service.data.pathway.name };
    } else {
      return PathwayService.getPathwayData(id);
    }
  }

  function getPathwayIcon(kind) {
    return PathwayService.getPathwayIcon(kind);
  }

  /** HISTORY
   *
   *  Undo, Redo and Restore
   */

  // Saves the state of the pathway
  function saveState() {
    updateHistoryObject();
    currentPathwayState.history.save(); // Save
  }

  // Undo
  function undo() {
    service.data.activeElement = null;
    currentPathwayState.history.undo();
  }

  // Redo
  function redo() {
    service.data.activeElement = null;
    currentPathwayState.history.redo();
  }

  // Updates the history object
  function updateHistoryObject() {
    currentPathwayState.tracker.value = service.data.pathway;
    if (!currentPathwayState.history) {
      createHistoryObject(); // Initialize (once)
    }
  }

  // Creates the history object, and listeners
  function createHistoryObject() {
    currentPathwayState.history = new HistoryFactory(currentPathwayState.tracker);
    currentPathwayState.history.on('restoreSnapshot', onRestoreSnapshot); // This needs unhooking when pushing a new pathway
  }

  // Whenever undo or redo is triggered
  function onRestoreSnapshot() {
    service.data.pathway = angular.copy(currentPathwayState.tracker.value);
    service.data.pathwayUpdated = true;
  }
}

// Modal
function pathwayBuilderModal() {
  return {
    restrict: 'E',
    replace: true,
    scope: {}, // Don't allow controller access to parent scope!
    templateUrl: '/app/pathway-builder/pathway-builder-modal.html',
    controller: ['$scope', '$element', '$timeout', 'PathwayBuilderService', function($scope, $element, $timeout, PathwayBuilderService) {
      $scope.settings = PathwayBuilderService.settings;
      $scope.data = PathwayBuilderService.data;
      $scope.filterGroups = PathwayBuilderService.filterGroups;
      $scope.filterPathways = PathwayBuilderService.filterPathways;
      $scope.editPathway = PathwayBuilderService.editPathway;
      $scope.replacePathway = PathwayBuilderService.replacePathway;
      $scope.changePathwayKind = PathwayBuilderService.changePathwayKind;
      $scope.getGroupName = PathwayBuilderService.getGroupName;
      $scope.addNode = PathwayBuilderService.addNode;
      $scope.removeNode = PathwayBuilderService.removeNode;
      $scope.getElementData = PathwayBuilderService.getElementData;
      // $scope.addGroup = PathwayBuilderService.addGroup;
      $scope.removeElement = PathwayBuilderService.removeElement;
      $scope.preventEventPropagation = PathwayBuilderService.preventEventPropagation;
      $scope.deselectElement = PathwayBuilderService.deselectElement;
      $scope.loadTemplate = PathwayBuilderService.loadTemplate;
      $scope.selectPrerequisite = function(prerequisite) {
        PathwayBuilderService.selectPrerequisite(prerequisite);
        if (!$scope.data.previewPrerequisite) {
          // Scroll to prerequisite node
          var container = $element.find('.drag-container-scroll');
          var elementLeft = $('#'+ $scope.data.prerequisiteId).offset().left + container.scrollLeft() - container.offset().left - 32;
          container.animate({
            scrollLeft: elementLeft
          }, 500);
        }
      };
      $scope.createPathwayFromActiveGroup = function() {
        // Fiddling with the scroll to stop new pathway being drawn out of view
        var container = $element.find('.drag-container-scroll');
        container.scrollTop(0);
        container.scrollLeft(0);
        PathwayBuilderService.createPathwayFromActiveGroup();
      };
      $scope.getPathwayData = PathwayBuilderService.getPathwayData;
      $scope.undo = PathwayBuilderService.undo;
      $scope.redo = PathwayBuilderService.redo;
      $scope.save = PathwayBuilderService.save;
      $scope.close = PathwayBuilderService.close;
      $scope.pathwayContains = PathwayBuilderService.pathwayContains;
      $scope.getPathwayKind = function() {
        return PathwayBuilderService.getPathwayKindName($scope.data.pathway.kind);
      };
      $scope.showSidebar = true;
      $scope.getPathwayIcon = PathwayBuilderService.getPathwayIcon;
      $scope.toggleSidebar = function() {
        $scope.showSidebar = !$scope.showSidebar;
      };
      var scrollAdjust;
      $scope.currentTab = 'templates';
      $scope.activateTab = function(tab) {
        $scope.showSidebar = true;
        $scope.currentTab = tab;
        scrollAdjust = $timeout(adjustDraggablesForScroll);
      };
      var leftScroll = 0;
      var adjustDraggablesForScroll = function() {
        $element.find('.pathway-sidebar [draggable-element="group"], .pathway-sidebar [draggable-element="pathway"]').draggable('option', 'cursorAt', { left: 124 - leftScroll });
      };
      // Bind to scroll when modal is shown, unbind when hidden
      var doAdjustDraggablesForScroll = function(event) {
        leftScroll = $(event.target).scrollLeft();
        if (scrollAdjust) {
          $timeout.cancel(scrollAdjust);
        }
        scrollAdjust = $timeout(adjustDraggablesForScroll, 100);
      };
      $scope.draw = false;
      $scope.$watch(function() {
        return $scope.data.visible;
      }, function(newValue, oldValue) {
        $timeout(function() {
          if (newValue) {
            $element.find('.drag-container').on('scroll', doAdjustDraggablesForScroll);
            $scope.draw = true;
          } else {
            $element.find('.drag-container').off('scroll', doAdjustDraggablesForScroll);
            $scope.nodes = angular.copy($scope.data.pathway.nodes); // Make sure nodes is set to current empty value
            $scope.draw = false;
          }
        });
      });
      // Redraw pathway when data is updated
      var nameChangeTimeout;
      $scope.$watch(function() {
        return $scope.data.pathway;
      }, function(newValue, oldValue) {
        if ($scope.data.visible) {
          // console.log('draw', newValue, oldValue);
          if (!$scope.data.pathwayUpdated) {
            if (newValue && oldValue) {
              // If pathway name changed...
              if (newValue.name !== oldValue.name) {
                // Record changes to the pathway name in the history state
                if (nameChangeTimeout) {
                  $timeout.cancel(nameChangeTimeout);
                }
                nameChangeTimeout = $timeout(function() {
                  $scope.$apply(function() {
                    PathwayBuilderService.saveState();
                  });
                }, 400);
                // console.log('Cancel draw 1');
                // Don't redraw pathway
                return;
              }
              // If node name has changed...
              if (newValue.nodes && oldValue.nodes) {
                var nodeCount = newValue.nodes.length;
                if (nodeCount == oldValue.nodes.length) {
                  for (var index = 0; index < nodeCount; index++) {
                    var newNode = newValue.nodes[index];
                    var oldNode = oldValue.nodes[index];
                    if (newNode.id === oldNode.id && newNode.name !== oldNode.name) {
                      // console.log('Cancel draw 2');
                      // Don't redraw pathway
                      return;
                    }
                  }
                }
              }
            }
          } else {
            $scope.data.pathwayUpdated = false;
          }
          // Draw nodes
          var container = $element.find('.drag-container');
          $scope.draw = false;
          var scrollTop = container.scrollTop();
          var scrollLeft = container.scrollLeft();
          container.find('> div').css({ 'margin-top': -scrollTop, 'margin-left': -scrollLeft });
          container.removeClass('drag-container-scroll');
          $timeout(function() {
            $scope.$apply(function() {
              $scope.draw = true;
              $scope.nodes = newValue.nodes;
              container.addClass('drag-container-scroll');
              container.find('> div').removeAttr('style');
              $timeout(function() {
                container.scrollTop(scrollTop);
                container.scrollLeft(scrollLeft);
              });
            });
          });
        }
      }, true); // Deep watch
    }]
  };
}

// Draggable Element
function draggableElement() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      // Be draggable
      if (attrs.draggableElement) { // Only make draggable if an element kind is specified
        var isSidebarElement = element.closest('.pathway-sidebar').length > 0;
        var insideContainer = false;
        var scrollLeft;
        var scrollTop;
        var container;
        var leftLimit;
        var topLimit;
        element.draggable({
          cursor: 'move',
          revert: 'invalid',
          containment: element.closest('.drag-container'),
          appendTo: attrs.dragContainer,
          handle: attrs.dragHandle,
          helper: attrs.dragCopy ? 'clone' : 'original',
          zIndex: 2,
          create: function(event, ui) {
            if (isSidebarElement) {
              element.draggable('option', 'cursorAt', { left: 124 });
            }
          },
          start: function(event, ui) {
            container = ui.helper.closest('.drag-container');
            var pathway = container.find('.pathway');
            scrollTop = container.scrollTop();
            scrollLeft = container.scrollLeft();
            topLimit = (pathway.outerHeight() > container.height() ? pathway.outerHeight() : container.height()) - 76;
            leftLimit = (container[0].scrollWidth > container.width() ? container[0].scrollWidth + scrollLeft : container.width()) - 248;
            if (isSidebarElement) {
              insideContainer = false;
              scrollTop = container.scrollTop();
              container.find('> div').css({ 'margin-top': -scrollTop, 'margin-left': -scrollLeft });
              container.removeClass('drag-container-scroll');
              ui.helper.css('margin-top', 16);
            }
            // Run apply
            scope.$apply(function() {
              // stuff
            });
          },
          drag: function(event, ui) {
            // stuff
            if (isSidebarElement) {
              if (!insideContainer) {
                var position = ui.helper.position();
                if (position.left > scrollLeft) {
                  container.find('> div').css({ 'margin-top': 0, 'margin-left': 0 });
                  container.addClass('drag-container-scroll');
                  ui.helper.css({ 'margin-top': 16, 'margin-left': -scrollLeft });
                  insideContainer = true;
                }
              }
            } else {
              ui.position.top -= container.scrollTop() - scrollTop;
              ui.position.left -= container.scrollLeft() - scrollLeft;
            }
            if (ui.position.top > topLimit) {
              ui.position.top = topLimit;
            }
            if (ui.position.left > leftLimit) {
              ui.position.left = leftLimit;
            }
          },
          stop: function(event, ui) {
            if (isSidebarElement && !insideContainer) { // This should only occur if the drop was unsuccessful
              container.find('> div').css({ 'margin-top': 0, 'margin-left': 0 });
              container.addClass('drag-container-scroll');
            }
            // Run apply
            scope.$apply(function() {
              // stuff
            });
          }
        });
      }
    }
  };
}

// Droppable Element
droppableElement.$inject = ['PathwayBuilderService'];
function droppableElement(PathwayBuilderService) {
  return {
    restrict: 'A',
    scope: {
      destination: '<?'
    },
    link: function(scope, element, attrs) {
      var accepted = attrs.droppableElement.split(',');
      var nodeIndex = attrs.nodeIndex != null ? parseInt(attrs.nodeIndex) : null; // Can be null when cloning a pathway
      // Be droppable
      element.droppable({
        accept: function(dragging) {
          var draggedKind = dragging.attr('draggable-element');
          var acceptable = false;
          if (accepted.indexOf(draggedKind) > -1) { // Dragged kind is accepted
            if (accepted.indexOf('node') > -1) { // Dropping on insert point
              acceptable = true;
            } else { // Dropping on elements within node
              acceptable = PathwayBuilderService.checkElementAcceptability(nodeIndex, draggedKind, dragging.attr('element-id'), scope.destination);
            }
          }
          return acceptable;
        },
        tolerance: 'pointer',
        // hoverClass: 'acceptable',
        // activate: function(event, ui) {
        //   element.addClass('target-available');
        // },
        // deactivate: function(event, ui) {
        //   element.removeClass('target-available');
        // },
        over: function(event, ui) {
          element.addClass('acceptable');
        },
        out: function(event, ui) {
          element.removeClass('acceptable');
        },
        drop: function(event, ui) {
          var droppable = $(this);
          var dragging = ui.draggable.attr('draggable-element');
          if (dragging === 'node') {
            if (attrs.droppableElement.contains('node')) {
              PathwayBuilderService.moveNode(parseInt(ui.draggable.attr('node-index')), parseInt(droppable.attr('node-index')));
            }
          } else if (dragging === 'group' || dragging === 'pathway') {
            if (attrs.droppableElement.contains('node')) {
              PathwayBuilderService.addNode('open', parseInt(droppable.attr('node-index')), ui.draggable);
            } else if (dragging === 'pathway' && attrs.droppableElement === 'pathway') {
              PathwayBuilderService.clonePathway(ui.draggable);
            } else {
              PathwayBuilderService.addElementToNode(nodeIndex, scope.destination, ui.draggable);
            }
          }
          ui.draggable.css({ left: '', top: ''}); // Required to remove some of draggable's in-line style
        }
      });
    }
  };
}

// Scroll Saver
scrollSaver.$inject = ['$timeout'];
function scrollSaver($timeout) {
  return {
    restrict: 'A',
    scope: {
      switch: '<scrollSaver',
    },
    link: function(scope, element, attrs) {
      var scrollTop = 0;
      var scrollLeft = 0;
      var rememberScroll = true;
      element.on('scroll', function() {
        if (rememberScroll) {
          scrollTop = element.scrollTop();
          scrollLeft = element.scrollLeft();
        }
      });
      scope.$watch(function() {
        return scope.switch;
      }, function(newValue, oldValue) {
        $timeout(function() {
          if (newValue) {
            element.addClass('scrolling');
            element.find('> div').removeAttr('style');
            element.scrollTop(scrollTop);
            element.scrollLeft(scrollLeft);
            rememberScroll = true;
          } else {
            element.find('> div').css({ 'margin-top': -scrollTop, 'margin-left': -scrollLeft });
            element.removeClass('scrolling');
            rememberScroll = false;
          }
        });
      });
    },
  };
}

angular
  .module('app')
  .service('PathwayBuilderService', PathwayBuilderService)
  .directive('pathwayBuilderModal', pathwayBuilderModal)
  .directive('draggableElement', draggableElement)
  .directive('droppableElement', droppableElement)
  .directive('scrollSaver', scrollSaver);

},{}],148:[function(require,module,exports){
/** PATHWAY INSERT - COMPONENT
 *
 *    Renders a pathway node.
 *
 *      <pathway-insert node-index="index"></pathway-insert>
 *
 *    @author   Andrew Bateman
 */

var pathwayInsertComponent = {
  controller: pathwayInsertComponentController,
  bindings: {
    nodeIndex: '<',
    data: '<',
    last: '<',
  },
  templateUrl: '/app/pathway-builder/pathway-insert.html',
};

pathwayInsertComponentController.$inject = ['PathwayBuilderService'];
function pathwayInsertComponentController(PathwayBuilderService) {
  var ctrl = this;

  ctrl.nodeTypes = [];

  var pathwayKind = null;

  ctrl.addNode = PathwayBuilderService.addNode;

  ctrl.$doCheck = function() { // This is not done on $onInit as it needs to react to deep changes in ctrl.data.pathway.kind
    if (ctrl.data.pathway.kind !== pathwayKind) {
      pathwayKind = ctrl.data.pathway.kind;
      if (ctrl.nodeIndex === 0 && pathwayKind !== 'cluster') {
        ctrl.nodeTypes = ['open'];
      } else {
        switch(pathwayKind) {
          case 'closed_stack':
            ctrl.nodeTypes = ['successor'];
            break;
          case 'open_stack':
            ctrl.nodeTypes = ['open'];
            break;
          case 'milestone':
            ctrl.nodeTypes = ['successor', 'award'];
            break;
          case 'cluster':
            ctrl.nodeTypes = [];
            break;
          case 'generic':
            ctrl.nodeTypes = ['open', 'successor', 'award'];
            break;
        }
      }
    }
  };
}

angular
  .module('app')
  .component('pathwayInsert', pathwayInsertComponent);

},{}],149:[function(require,module,exports){
/** PATHWAY NODE CONDITION MODAL & SERVICE
 *
 *      Exposes a modal to set the options rule for a pathway node
 *
 *      In your view
 *          <pathway-node-condition-modal></pathway-node-condition-modal>
 *
 *      In your controller
 *          Require the PathwayNodeConditionModalService
 *          Use the controller method like so:
 *
 *          PathwayNodeConditionModalService.show(node);
 *
 *      @author   Andrew Bateman
 */
(function () {
  angular
    .module('app')
    // Custom Directive
    .directive('pathwayNodeConditionModal', function () {
      return {
        restrict: 'E',
        replace: true,
        scope: {}, // Don't allow controller access to parent scope!
        templateUrl: '/app/pathway-builder/pathway-node-condition-modal.html',
        controller: ['$scope', 'PathwayNodeConditionModalService', 'PathwayService', function ($scope, PathwayNodeConditionModalService, PathwayService) {
          $scope.settings = PathwayService.settings;
          $scope.data = PathwayNodeConditionModalService.data;
          $scope.hide = PathwayNodeConditionModalService.hide;
          $scope.setCondition = PathwayNodeConditionModalService.setCondition;
          $scope.decrement = PathwayNodeConditionModalService.decrement;
          $scope.increment = PathwayNodeConditionModalService.increment;
          $scope.$on('$destroy', function () {
            $scope.hide();
          });
        }]
      };
    })
    // Custom Service "glue"
    .service('PathwayNodeConditionModalService', function () {
      // Scope buster
      var that = this;

      // Exposed variables (these can be watched)
      that.data = {
        visible: false,
        rule: null,
        any: null,
        exactly: null,
        at_least: null,
        at_most: null,
        condition: null,
        error: null
      };

      // Show the modal
      this.show = function (node, setNodeOptionsRule) {
        that.node = node;
        that.setNodeOptionsRule = setNodeOptionsRule; // This allows the state change to be captured
        that.data.visible = true;
        if (node.options.rule) {
          if (node.options.rule.hasOwnProperty('any')) {
            that.data.any = node.options.rule.any;
            that.data.rule_type = 'any';
          } else if (node.options.rule.hasOwnProperty('exactly')) {
            that.data.exactly = node.options.rule.exactly;
            that.data.rule_type = 'exactly';
          } else if (node.options.rule.hasOwnProperty('at_least')) {
            that.data.at_least = node.options.rule.at_least;
            that.data.at_most = node.options.rule.at_most;
            that.data.rule_type = 'at_least';
          } else if (node.options.rule.hasOwnProperty('condition')) {
            that.data.condition = node.options.rule.condition;
            that.data.rule_type = 'condition';
          }
        } else {
          that.data.rule_type = null;
        }
      };
      // Hide the modal
      this.hide = function () {
        this.data.visible = false;
        this.data.any = null;
        this.data.exactly = null;
        this.data.at_least = null;
        this.data.at_most = null;
        this.data.condition = null;
      };

      this.decrement = function(field) {
        if (that.data[field] && that.data[field] > 1) {
          that.data[field]--;
        } else {
          that.data[field] = 1;
        }
      };

      this.increment = function(field) {
        that.data[field]++;
      };

      function nonZeroNumberCheck(field) {
        if (that.data[field] && that.data[field] > 0) {
          that.data.error = null;
          return true;
        } else {
          that.data.error = field;
          return false;
        }
      }

      this.setCondition = function() {
        if (that.data.rule_type) {
          if (that.data.rule_type === 'condition') {
            // Logic check
          } else {
            nonZeroNumberCheck(that.data.rule_type);
          }
        }
        if (!that.data.error) {
          if (that.data.rule_type) {
            var rule = {};
            rule[that.data.rule_type] = that.data[that.data.rule_type];
            if (that.data.rule_type === 'at_least') {
              rule.at_most = that.data.at_most;
            }
            that.setNodeOptionsRule(that.node, rule);
          } else {
            that.setNodeOptionsRule(that.node, null);
          }
          that.hide();
        }
      };
    });
})();

},{}],150:[function(require,module,exports){
/** PATHWAY NODE - COMPONENT
 *
 *    Renders a pathway node.
 *
 *      <pathway-node node="node" data="data"></pathway-node>
 *
 *    @author   Andrew Bateman
 */

var pathwayNodeComponent = {
  controller: pathwayNodeComponentController,
  bindings: {
    node: '<',
    data: '<',
    index: '<?',
    edit: '<?'
  },
  templateUrl: '/app/pathway-builder/pathway-node.html',
};

pathwayNodeComponentController.$inject = ['PathwayBuilderService', 'PathwayNodeConditionModalService'];
function pathwayNodeComponentController(PathwayBuilderService, PathwayNodeConditionModalService) {
  var ctrl = this;

  ctrl.$onInit = onInit;
  ctrl.$onChanges = onChanges;
  ctrl.$onDestroy = onDestroy;

  ctrl.getGroupName = PathwayBuilderService.getGroupName;
  ctrl.getElementData = PathwayBuilderService.getElementData;
  ctrl.removeNode = PathwayBuilderService.removeNode;
  ctrl.removeElement = PathwayBuilderService.removeElement;
  ctrl.clearElements = PathwayBuilderService.clearElements;
  ctrl.selectElement = PathwayBuilderService.selectElement;
  ctrl.selectPrerequisite = PathwayBuilderService.selectPrerequisite;
  ctrl.setNodeKind = PathwayBuilderService.setNodeKind;
  ctrl.setNodeOptionsRule = PathwayBuilderService.setNodeOptionsRule;
  ctrl.getPathwayIcon = getPathwayIcon;
  ctrl.editOptionsCondition = editOptionsCondition;

  ctrl.editName = false;

  function getPathwayIcon(pathwayId) {
    return PathwayBuilderService.getPathwayIcon(PathwayBuilderService.getPathwayData(pathwayId).kind);
  }

  function editOptionsCondition() {
    PathwayNodeConditionModalService.show(ctrl.node, ctrl.setNodeOptionsRule);
  }

  function deactivateNameEdit(event) {
    if (ctrl.editName && !$(event.target).hasClass('node-name')) {
      ctrl.editName = false;
    }
  }

  function resolveElement(element) {
    var resolvedElement = PathwayBuilderService.getElementData(element);
    resolvedElement.kind = element.kind;
    resolvedElement.id = element.id;
    return resolvedElement;
  }

  function onInit() {
    $('body').on('mousedown', deactivateNameEdit);
  }

  function onChanges() {
    ctrl.required_elements = ctrl.node.required.elements.map(resolveElement);
    ctrl.options_elements = ctrl.node.options.elements.map(resolveElement);
  }

  function onDestroy() {
    $('body').off('mousedown', deactivateNameEdit);
  }
}

angular
  .module('app')
  .component('pathwayNode', pathwayNodeComponent);

},{}],151:[function(require,module,exports){
PathwaysCtrl.$inject = ['$timeout', '$window', 'StateCacheService', 'PathwayBuilderService', 'PathwayService', 'resolvedDepartment', 'resolvedGroups', 'resolvedPathways', 'alertService'];
function PathwaysCtrl($timeout, $window, StateCacheService, PathwayBuilderService, PathwayService, resolvedDepartment, resolvedGroups, resolvedPathways, alertService) {
  var ctrl = this;

  ctrl.meta = false; // Meta data from the response
  ctrl.emptyPayload = true; // Is the payload empty?

  ctrl.department = resolvedDepartment;
  ctrl.groups = resolvedGroups; // Array of visible groups
  ctrl.mappedGroups = ctrl.groups.map(function(group) { // Filter-friendly groups
    return {
      name: group.course_name,
      id: group.id
    };
  });
  ctrl.selectedMappedGroups = []; // Filter-selected groups

  // Update pathways with latest data
  function updatePathways(pathways) {
    ctrl.pathways = pathways;
    ctrl.filteredPathways = [];
    ctrl.mappedPathways = ctrl.pathways.map(function(pathway) { // Filter-friendly pathways
      return {
        name: pathway.name,
        id: pathway.id
      };
    });
    ctrl.selectedMappedPathways = []; // Filter-selected pathways
  }

  // View functions

  ctrl.switchGroupMode = switchGroupMode;
  ctrl.switchGroupSelectionMode = switchGroupSelectionMode;
  ctrl.addGroup = addGroup;
  ctrl.removeGroup = removeGroup;

  ctrl.switchPathwayMode = switchPathwayMode;
  ctrl.switchPathwaySelectionMode = switchPathwaySelectionMode;
  ctrl.addPathway = addPathway;
  ctrl.removePathway = removePathway;

  ctrl.applyFilters = applyFilters;
  ctrl.clearFilters = clearFilters;

  ctrl.getPathwayIcon = PathwayService.getPathwayIcon;
  ctrl.getGroup = getGroup;
  ctrl.getPathway= getPathway;
  ctrl.editPathway = editPathway;
  ctrl.deletePathway = deletePathway;

  // Initial load

  updatePathways(resolvedPathways);
  // Search / filter form
  ctrl.filter = StateCacheService.resolveCache({ // REINSTATE - loads the cached state or returns the object passed in
    page_size: 30,
    page: null,
    pathway_name: null,
    groups: null,
    pathways: null
  });
  var cachedScroll = ctrl.filter.scroll; // REINSTATE - locally cache the state-cached scroll and clear the filter value
  ctrl.filter.scroll = null;
  applyFilters();

  // Filter view config
  var groupsSearchThreshold = 10;
  ctrl.searchGroups = ctrl.mappedGroups.length > groupsSearchThreshold;
  ctrl.groupMode = ctrl.searchGroups ? 'search' : 'list';
  var pathwaysSearchThreshold = 10;
  ctrl.searchPathways = ctrl.mappedPathways.length > pathwaysSearchThreshold;
  ctrl.pathwayMode = ctrl.searchPathways ? 'search' : 'list';

  // Utility
  function typeaheadDataFromIds(list, options) {
    return list.map(function(item) {
      return {
        name: options.filter(function(option) {
          return option.id === item;
        })[0].name,
        id: item
      };
    });
  }

  // Group filter functions

  function switchGroupMode(mode) {
    if (ctrl.groupMode !== mode) {
      if (ctrl.groupMode === 'list') { // Going from list to search mode
        ctrl.selectedMappedGroups = typeaheadDataFromIds(ctrl.filter.groups || [], ctrl.mappedGroups);
      }
      ctrl.groupMode = mode;
    }
  }

  ctrl.groupSelectAll = false;
  function switchGroupSelectionMode(mode) {
    if (ctrl.groupSelectAll !== mode) {
      ctrl.groupSelectAll = mode === 'all';
      applyFilters();
    }
  }

  function addGroup(event) {
    if (!ctrl.filter.groups) {
      ctrl.filter.groups = [];
    }
    ctrl.filter.groups.push(event.selection.id);
    ctrl.selectedMappedGroups.push(event.selection);
    applyFilters();
  }

  function removeGroup(group) {
    var groupIndex = ctrl.filter.groups.indexOf(group.id);
    ctrl.filter.groups.splice(groupIndex, 1);
    if (ctrl.filter.groups.length === 0) {
      ctrl.filter.groups = null;
    }
    ctrl.selectedMappedGroups = ctrl.selectedMappedGroups.filter(function(mappedGroup) {
      return mappedGroup.id != group.id;
    });
    applyFilters();
  }

  // Pathway filter functions

  function switchPathwayMode(mode) {
    if (ctrl.pathwayMode !== mode) {
      if (ctrl.pathwayMode === 'list') { // Going from list to search mode
        ctrl.selectedMappedPathways = typeaheadDataFromIds(ctrl.filter.pathways || [], ctrl.mappedPathways);
      }
      ctrl.pathwayMode = mode;
    }
  }

  ctrl.pathwaySelectAll = false;
  function switchPathwaySelectionMode(mode) {
    if (ctrl.pathwaySelectAll !== mode) {
      ctrl.pathwaySelectAll = mode === 'all';
      applyFilters();
    }
  }

  function addPathway(event) {
    if (!ctrl.filter.pathways) {
      ctrl.filter.pathways = [];
    }
    ctrl.filter.pathways.push(event.selection.id);
    ctrl.selectedMappedPathways.push(event.selection);
    applyFilters();
  }

  function removePathway(pathway) {
    var pathwayIndex = ctrl.filter.groups.indexOf(pathway.id);
    ctrl.filter.pathways.splice(pathwayIndex, 1);
    if (ctrl.filter.pathways.length === 0) {
      ctrl.filter.pathways = null;
    }
    ctrl.selectedMappedPathways = ctrl.selectedMappedPathways.filter(function(mappedPathway) {
      return mappedPathway.id != pathway.id;
    });
    applyFilters();
  }

  // Apply Filters
  function applyFilters() {
    submitForm({ resetPage: true });
  }

  // Filter utility
  function pathwayContainsElements(pathway, elementsType, elements, all) {
    // This depends on both arrays not having duplicates, which, as we're dealing with ids, is what we've got
    var intersection = pathway[elementsType].filter(function(item) {
      // checking elements array contains item
      return elements.indexOf(item) !== -1;
    });
    return all ? intersection.length === elements.length : intersection.length > 0;
  }

  // Submits the form
  function submitForm(opts) {
    // We may want to reset the Page number
    if (opts && opts.resetPage) {
      ctrl.filter.page = 0;
    }
    ctrl.filteredPathways = ctrl.pathways.filter(function(pathway) {
      return (
        (!ctrl.filter.pathway_name || pathway.name.match(new RegExp(ctrl.filter.pathway_name, 'i'))) &&
        (!ctrl.filter.groups || pathwayContainsElements(pathway, 'groups', ctrl.filter.groups, ctrl.groupSelectAll)) &&
        (!ctrl.filter.pathways || pathwayContainsElements(pathway, 'pathways', ctrl.filter.pathways, ctrl.pathwaySelectAll))
      );
    });
    $timeout(function() {
      $window.scrollTo(0, cachedScroll || 0); // Scroll to cached value or scroll to the top
      cachedScroll = null; // Clear locally cached value
    });
    StateCacheService.setCache(ctrl.filter); // REINSTATE - cache the new filter values
  }

  // Clear filters
  function clearFilters() {
    angular.forEach(ctrl.filter, function(value, key){
      if (key !== 'page_size') {
        ctrl.filter[key] = null;
      }
    });
    applyFilters();
  }

  // View display functions

  function getGroup(groupId) {
    var group = ctrl.groups.filter(function(group) {
      return group.id === groupId;
    })[0];
    return group || {};
  }

  function getPathway(pathwayId) {
    var pathway = ctrl.pathways.filter(function(pathway) {
      return pathway.id === pathwayId;
    })[0];
    if (pathway) {
      return { name: pathway.name, kind: PathwayService.getPathwayKindName(pathway.kind), icon: PathwayService.getPathwayIcon(pathway.kind) };
    } else {
      return {};
    }
  }

  // View editing functions

  function editPathway(id) {
    PathwayBuilderService
      .open(id, ctrl.groups)
      .then(function(updated) {
        if (updated) {
          updatePathways(PathwayService.getPathways());
          // Dirty pathway filter to ensure checkbox list displays correctly
          ctrl.filter.pathways = angular.copy(ctrl.filter.pathways);
          applyFilters();
        }
      });
  }

  function deletePathway(id) {
    var pathway = getPathway(id);
    return alertService
      .confirm('Delete Pathway', 'Delete the ' + pathway.kind + ' pathway named <strong>' + pathway.name + '</strong>?', 'delete')
      .then(function() {
        PathwayService
          .deletePathway(id)
          .then(function(pathways) {
            updatePathways(pathways);
            // Dirty pathway filter to ensure checkbox list displays correctly
            ctrl.filter.pathways = angular.copy(ctrl.filter.pathways);
            applyFilters();
          });
      });
  }
}

angular
  .module('app')
  .controller('PathwaysCtrl', PathwaysCtrl);

},{}],152:[function(require,module,exports){
QuickstartCtrl.$inject = ['resolvedOrganization', 'resolvedDepartment', 'CertificateService', 'DepartmentsService', 'DepartmentService', 'GroupService', 'api', 'alertService', 'moment', '$state'];
function QuickstartCtrl(resolvedOrganization, resolvedDepartment, CertificateService, DepartmentsService, DepartmentService, GroupService, api, alertService, moment, $state) {
  var ctrl = this;
  ctrl.doSubmit = doSubmit;
  ctrl.form = {
    department: {
      logo: null,
      name: null,
      url: null,
      social_media: {
        twitter: { id: null },
        facebook: null,
        linkedin: null,
      },
    },
    group: {
      course_name: null,
      name: null,
      course_description: null,
      course_link: null,
      language: null,
      tags: null,
      learning_outcomes: null,
      certificate_design: null,
      badge_design: null,
    },
    credential:{
      recipient: {
        name: null,
        email: null,
      },
      group_id: null,
      issued_on: moment().format('YYYY-MM-DD'),
      private: false,
      approve: true,
    },
  };
  ctrl.selected_design_index = null;
  ctrl.certificates;
  ctrl.selectCertificate = selectCertificate;
  ctrl.validateLogo = validateLogo;
  ctrl.badges = [
    'https://s3.amazonaws.com/accredible-api-templates/1533736699161.png',
    'https://s3.amazonaws.com/accredible-api-templates/1533736769889.png',
    'https://s3.amazonaws.com/accredible-api-templates/1533736637114.png',
  ];
  ctrl.addBadge = addBadge;
  ctrl.validateBadge = validateBadge;

  // Audomatically switch to the right department
  if(resolvedOrganization.id !== 13583){
    return alertService
      .alert('Quickstart', '<p>Quickstart only works for Department 11529</p><p><a href="https://api.accredible.com/admin/organization/11529" target="_blank">Open Admin</a></p>')
      .then(function(){
        $state.go('issuer.dashboard.home');
      });
  } else if(resolvedDepartment.id !== 11529){
    return DepartmentService
      .switchDepartment(11529)
      .then(function(){
        $state.reload();
      });
  }

  // Load the Certificate templates
  var originalCertificates = false;
  CertificateService
    .getDesigns({ design_identifier: 'quickstart' })
    .then(function (response) {
      originalCertificates = response.designs;
      ctrl.certificates = angular.copy(originalCertificates);
      applyLogoToCertificates();
    });

  // Selects the Certificate design
  function selectCertificate(index){
    ctrl.selected_design_index = index;
  }

  // When a logo is uploaded...
  var logoProps = false;
  function validateLogo(props){
    logoProps = props;
    applyLogoToCertificates();
  }

  // "Applies" the logo to the designs
  function applyLogoToCertificates(){
    if(logoProps && originalCertificates){
      ctrl.certificates = angular.copy(originalCertificates);
      var src = logoProps.src;
      var naturalWidth = logoProps.naturalWidth;
      var naturalHeight = logoProps.naturalHeight;
      angular.forEach(ctrl.certificates, function(certificate){
        // Maximum dimensions (in %) of the block
        var maxWidth = 20;
        var maxHeight = 11;
        // The new dimensions of the uploaded image
        var newWidth = maxWidth;
        var newHeight = naturalHeight*(maxWidth/naturalWidth);
        if(newHeight > maxHeight){
          newHeight = maxHeight;
          newWidth = naturalWidth*(maxHeight/naturalHeight);
        }
        // Adjust the position
        var left = 50-(newWidth/2);
        var top = 75+((maxHeight-newHeight)/2);
        // Add the logo
        var block = {
          top: top+'%',
          left: left+'%',
          image_url: src,
          image_width: newWidth+'%',
          z_index: 10000,
        };
        certificate.blocks.push(block);
      });
    }
  }

  // Sets the Badge
  function addBadge(fileUrl){
    ctrl.uploadedBadge = fileUrl;
  }

  // Validates the Badge, adding it if valid
  function validateBadge(props){
    var errors = [];
    if(props.ext !== 'png'){
      errors.push('The badge must be a PNG');
    }
    if(props.naturalWidth != props.naturalHeight){
      errors.push('The badge must be square');
    }
    if(props.naturalWidth < 256 || props.naturalHeight < 256){
      errors.push('The badge must be 256 &times; 256 px or more');
    }
    if(errors.length){
      alertService.alert('Whoops', errors);
    } else {
      ctrl.badges.unshift(props.src);
      ctrl.form.group.badge_design.rasterized_content_url = props.src;
    }
  }

  // Does the thing
  function doSubmit(formCtrl){
    // Create the Department
    DepartmentsService.upsertDepartment(ctrl.form.department)
      // ...switch to the Department
      .then(function(department){
        return DepartmentService.switchDepartment(department.id);
      })
      // ...create the Design
      .then(function(){
        if(ctrl.selected_design_index !== null){
          var certificate = ctrl.certificates[ctrl.selected_design_index];
          delete certificate.id;
          return CertificateService.upsert(certificate);
        }
        return null;
      })
      // ...create the Group
      .then(function(design){
        ctrl.form.group.certificate_design = design;
        return GroupService.upsert(ctrl.form.group);
      })
      // ...create the Credential
      .then(function(group){
        ctrl.form.credential.group_id = group.id;
        return api
          .request('/credentials/create', { credential: ctrl.form.credential })
          .then(function(response){
            return response.credential;
          });
      })
      // ...redirect to the Credential
      .then(function(credential){
        formCtrl.$setPristine();
        $state.go('issuer.dashboard.credential', { id: credential.id });
      });
  }

}

angular
  .module('app')
  .controller('QuickstartCtrl', QuickstartCtrl);

},{}],153:[function(require,module,exports){
/** MESSAGE - ROUTE CONTROLLER
 *
 *      A utility view that allows the BE to render a message on the dashboard
 *
 *  @author  David "oodavid" King
 */
MessageRouteController.$inject = ['$stateParams', 'api'];
function MessageRouteController($stateParams, api) {
  var ctrl = this;
  api.request('/frontend/check_text_for_page', {
    text: $stateParams.text,
    title: $stateParams.title,
  }).then(function(response) {
    ctrl.title = response.title;
    ctrl.message = response.value;
  });
}

angular
  .module('app')
  .controller('MessageRouteController', MessageRouteController);

},{}],154:[function(require,module,exports){
angular.module('app')
  .controller('OrganizationUsageCtrl', ['UsageService', 'moment', '$window', '$scope', '_',
    function (UsageService, moment, $window, $scope, _) {

      var ctrl = this;

      ctrl.loading = false;
      ctrl.days = 30;
      ctrl.usage = {};
      var colours = [
        '#30bcb1',
        '#4490cd',
        '#e6194b',
        '#3cb44b',
        '#ffe119',
        '#0082c8',
        '#f58231',
        '#911eb4',
        '#46f0f0',
        '#f032e6',
        '#d2f53c',
        '#fabebe',
        '#008080',
        '#e6beff',
        '#aa6e28',
        '#fffac8',
        '#800000',
        '#aaffc3',
        '#808000',
        '#ffd8b1'
      ];
      ctrl.data = null;

      function round(value, precision) {
        var multiplier = Math.pow(10, precision || 0);
        return Math.round(value * multiplier) / multiplier;
      }

      function dataByDay(startDate, endDate, data) {
        var keyDate = startDate;
        var output = {
          data: [],
          labels: [],
          dates: []
        };
        while (keyDate <= endDate) {
          var departmentIndex = 0;
          data.departments.forEach(function (department) {
            if (!output.data[departmentIndex]) {
              output.data[departmentIndex] = [];
            }
            output.data[departmentIndex].push(department.credentials_published[keyDate] || 0);
            departmentIndex++;
          });
          var theMoment = moment(keyDate, 'YYYY-MM-DD');
          output.labels.push(['', theMoment.format('dd'), theMoment.format('DD')]);
          output.dates.push(keyDate);
          // Add a day to keyDate
          keyDate = moment(keyDate, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
        }
        return output;
      }

      function emailPercentages(data) {
        var output = [
          [],
          [],
          []
        ];
        data.departments.forEach(function (department) {
          var emails = department.emails;
          var bounced = round((emails.bounced / emails.sent) * 100.0, 1).toFixed(1);
          var received = (100.0 - bounced).toFixed(1);
          var engaged = round((emails.engaged / emails.sent) * 100.0, 1).toFixed(1);
          output[0].push(received);
          output[1].push(engaged);
          output[2].push(bounced);
        });
        return output;
      }

      function activeDays(data) {
        var output = {
          data: [],
          labels: []
        };
        data.team_members.forEach(function (team_member) {
          output.data.push(team_member.active_days);
          output.labels.push(team_member.name);
        });
        return output;
      }

      function buildGraphs(startDate, endDate, data) {
        // Credentials Issued
        var departmentNames = data.departments.map(function (department) {
          return department.name;
        });
        var transformed = dataByDay(startDate, endDate, data);
        var departmentCount = transformed.data.length;
        var maxDayTotal = 0;
        for (var dayIndex = 0; dayIndex < transformed.data[0].length; dayIndex++) {
          var dayTotal = 0;
          for (var departmentIndex = 0; departmentIndex < departmentCount; departmentIndex++) {
            dayTotal += transformed.data[departmentIndex][dayIndex];
          }
          if (dayTotal > maxDayTotal) {
            maxDayTotal = dayTotal;
          }
        }
        var dates = transformed.dates;
        ctrl.usage['credentials_published'] = {
          type: 'StackedBar',
          series: departmentNames,
          colors: colours.slice(0, data.departments.length),
          data: transformed.data,
          labels: transformed.labels,
          range: {
            start: startDate,
            end: endDate
          },
          options: {
            legend: {
              display: true,
              position: 'top',
              labels: {
                boxWidth: 12
              }
            },
            scales: {
              xAxes: [{
                barThickness: 20,
                stacked: true,
                gridLines: {
                  display: false
                }
              }],
              yAxes: [{
                stacked: true,
                ticks: {
                  beginAtZero: true,
                  stepSize: maxDayTotal >= 10 ? null : 1 // Don't use a decimal scale for small totals
                }
              }]
            },
            tooltips: {
              callbacks: {
                title: function (tooltipItem, info) {
                  return moment(dates[tooltipItem[0].index], 'YYYY-MM-DD').format('dddd, MMMM D, YYYY');
                }
              }
            }
          }
        };
        // Email Activity
        var emailStats = emailPercentages(data);
        ctrl.usage['email'] = {
          type: 'StackedBar',
          series: ['Received', 'Engaged', 'Bounced'],
          colors: ['#30bcb1', '#4490cd', '#dcbe3e'],
          data: emailStats,
          labels: departmentNames,
          height: (66 * departmentNames.length) + 30,
          options: {
            legend: {
              display: true,
              position: 'top',
              labels: {
                boxWidth: 12
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  beginAtZero: true,
                  max: 100,
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Percentage'
                }
              }],
              yAxes: [{
                barThickness: 20,
                gridLines: {
                  display: false
                }
              }]
            }
          }
        };
        // Sign Ins
        var activeDaysStats = activeDays(data);
        var activeDaysHeight = 24 * activeDaysStats.data.length;
        if (activeDaysHeight < 80) {
          activeDaysHeight = 80;
        }
        ctrl.usage['active_days'] = {
          data: activeDaysStats.data,
          labels: activeDaysStats.labels,
          height: activeDaysHeight,
          colors: {
            backgroundColor: 'rgb(48, 188, 177)',
            borderColor: 'rgb(48, 188, 177)',
            hoverBackgroundColor: 'rgba(48, 188, 177, 0.5)'
          },
          options: {
            scales: {
              xAxes: [{
                ticks: {
                  beginAtZero: true,
                  stepSize: Math.max.apply(false, activeDaysStats.data) >= 10 ? null : 1 // Don't use a decimal scale for small totals
                }
              }],
              yAxes: [{
                barThickness: 10,
                gridLines: {
                  display: false
                }
              }]
            },
            tooltips: {
              mode: 'single',
              callbacks: {
                label: function (tooltipItem, info) {
                  var label = data.team_members[tooltipItem.index].email;
                  return label;
                },
                afterBody: function (info) {
                  var information = info[0];
                  return ['Active days: ' + information.xLabel, 'Last active date: ' + moment(data.team_members[information.index].last_active_date).format('ll')];
                }
              }
            }
          }
        };
      }

      function getUsage() {
        ctrl.loading = true;
        UsageService
          .getUsage(ctrl.startDate, ctrl.endDate)
          .then(function (response) {
            ctrl.data = response;
            buildGraphs(ctrl.startDate, ctrl.endDate, ctrl.data);
            ctrl.loading = false;
          });
      }

      var today = moment();
      ctrl.endDate = today.format('YYYY-MM-DD');
      ctrl.startDate = today.subtract((ctrl.days - 1), 'days').format('YYYY-MM-DD');

      getUsage();

      // Debounced update (for window.resize event)
      var debouncedDrawGraphs = _.debounce(getUsage, 1000, {
        leading: false,
        trailing: true
      });

      // Initialization
      angular.element($window).bind('resize', debouncedDrawGraphs);

      // Tidy up
      $scope.$on('$destroy', function () {
        angular.element($window).unbind('resize', debouncedDrawGraphs);
      });
    }
  ]);

},{}],155:[function(require,module,exports){
VerificationCtrl.$inject = ['resolvedPricing', 'OrganizationService'];
function VerificationCtrl(resolvedPricing, OrganizationService) {
  var ctrl = this;

  ctrl.plan = resolvedPricing.plan;
  ctrl.organization = OrganizationService.getOrganizationImmediate();
}

angular
  .module('app')
  .controller('VerificationCtrl', VerificationCtrl);

},{}],156:[function(require,module,exports){
angular
  .module('app')
  .constant('ENV', {
    name:         'qa',
    prefix:       'qa.',
    type:         'development',
    apiEndpoint:  'https://qa.api.accredible.com/',
    apiVersion:   'v1',
    stripeKey:    'pk_test_cAeVkx5DhTMwelsEudggtgxC',
    getSocialId:  'b9584c5e',
    version:      '26.4.0',
    cachebust:    '26.4.0-1793815588089',
    property:     'dashboard.accredible.com',
    gainsightTagKey: 'AP-EGY1FB9PXTHZ-2-3',

    v2Domains:      {
      dashboard: 'https://qa.v2.dashboard.accredible.com',
      salesCalculator: 'https://qa.calculator.accredible.com',
    }
  });

},{}],157:[function(require,module,exports){
/** ANALYTICS - SERVICE
 *
 *  Track issuer actions:
 *
 *      AnalyticsService.trackEvent('Event -  Description'); // Track a specific event / click on pages
 *
 *  Automatically track page views
 *
 *      If your property is using ui-router then we track additional data about the router state, including errors
 *      If not, then we just track basic information
 *
 *  Angulartics
 *
 *      At the moment, we have disabled angulartics google page tracking (see dashboard.module.js) and are
 *      manually sending google (ga) tracking messages (see trackPage and trackEvent below)
 *
 *  Todo
 *
 *      Figure out how to identify and track other user types (recipient, a.n.other)
 *
 *      Consider simplifying the functionality of angulartics, replacing this:
 *          <a href="" ng-click="addToLinkedin()" analytics-on analytics-event="click" analytics-category="share-button" analytics-label="add-to-linkedin">add to linkedin</a>
 *      ...with:
 *          <a href="" ng-click="addToLinkedin()" analytics>add to linkedin</a>
 */
var clone = require('clone');
AnalyticsService.$inject = ['$rootScope', '$window', '$injector', '$location', 'ENV', 'api'];
function AnalyticsService($rootScope, $window, $injector, $location, ENV, api){
  var service = this;
  service.trackEvent = trackEvent;
  service.trackPage = trackPage;
  service.trackPurchase = trackPurchase;
  service.trackSignup = trackSignup;

  // If we are using ui-router, automatically track page changes
  if($injector.has('$transitions')){
    var $transitions = $injector.get('$transitions');
    $transitions.onSuccess({}, trackRouterSuccess);
    $transitions.onError({}, trackRouterError);
  } else {
    $rootScope.$on('$locationChangeSuccess', trackLocationChange);
  }

  // Track an event
  function trackEvent(description){
    // Track to 3rd party services in production only
    if(ENV.type === 'production'){
      if($window.ga){
        var data = {
          'event': 'custom_' + description,
        };
        $window.dataLayer.push(data);
      }
    }
  }

  // Track a page view
  function trackPage(data){
    // Track page-views to our API in any environment
    api.request('/frontend/log_frontend_analytics', {
      domain: $location.host(),
      env: ENV.name,
      property: ENV.property,
      path: $location.path(),
      data: data,
    });
    // Track to 3rd party services in production only
    if(ENV.type === 'production'){
      if($window.ga){
        $window.ga('send', 'pageview', $location.path());
      }
    }
  }

  // Track a purchase
  function trackPurchase(id, total){
    var data = {
      'transactionId': id,
      'transactionAffiliation': 'ACMS',
      'transactionTotal': total,
      'event': 'successful_purchase',
    };
    if(ENV.type === 'production' && $window.dataLayer){
      $window.dataLayer.push(data);
    } else {
      console.log('Analytics :: Not tracking purchase on this environment. Payload:', data);
    }
  }

  // Track a Signup
  function trackSignup(){
    var data = {
      'event': 'successful_signup',
    };
    if(ENV.type === 'production' && $window.dataLayer){
      $window.dataLayer.push(data);
    } else {
      console.log('Analytics :: Not tracking signup on this environment. Payload:', data);
    }
  }

  // Track a window.location change (non-ui-router)
  function trackLocationChange(event, newUrl, oldUrl){
    trackPage({
      newUrl: newUrl,
      oldUrl: oldUrl,
    });
  }

  // To make sure we don't have any circular references, or deep trees
  var cloneOptions = {
    depth: 5,
    includeNonEnumerable: false,
    circular: true,
  };

  // Track a successful ui-router state change
  function trackRouterSuccess($transition){
    trackPage({
      from: clone($transition.from(), cloneOptions),
      to: clone($transition.to(), cloneOptions),
    });
  }

  // Track an unsuccessful ui-router state change
  function trackRouterError($transition){
    trackPage({
      from: clone($transition.from(), cloneOptions),
      to: clone($transition.to(), cloneOptions),
      error: clone($transition.error(), cloneOptions),
    });
  }

}

AnalyticsServiceRun.$inject = ['AnalyticsService'];
function AnalyticsServiceRun(AnalyticsService){
  // Ensure that the AnalyticsService is instantiated by guaranteeing that it as a dependency of _something_
}

AnalyticsConfig.$inject = ['$injector'];
function AnalyticsConfig($injector){
  // Disable automatic angulartics page tracking, we do our own thing
  if($injector.has('$analyticsProvider')){
    var $analyticsProvider = $injector.get('$analyticsProvider');
    $analyticsProvider.virtualPageviews(false);
    $analyticsProvider.firstPageview(false);
  }
}

angular
  .module('app')
  .config(AnalyticsConfig)
  .service('AnalyticsService', AnalyticsService)
  .run(AnalyticsServiceRun);

},{"clone":12}],158:[function(require,module,exports){
/** (ACCREDIBLE) API
 *
 *    A simple abstraction of the Accredible API
 *
 *    Deals with:
 *      POST and GET Requests to the server
 *        Chained to an authentication routine so that any
 *         early requests wait for authentication to complete
 *      Error Tracking
 *        Something gone wrong?
 *        Errors are logged to an external service
 *
 *    TODO
 *
 *      Cookie Management
 *        Stores authentication cookies
 *        Updates cookies if the API backend requests it
 *        Makes sure invalid cookies are destroyed
 *
 *      Time the requests and pass to our logging service - to dictate API speed improvements
 *      Needs to encompass Authentication and De-Authentication routines
 *      Can Authentication also help define our permissions?
 *      Should this deal with the User object? Or is that a different service? It's pretty tight with Authentication... ponder
 *      Publish an 'authentication' event for other Services to subscribe to (ie: User) - Do at the moment it's required
 *      Use '403 Forbidden' instead of '453 Custom' status code
 *
 *    @author   David "oodavid" King
 */
apiService.$inject = ['$http', '$q', 'ENV', 'emitter'];
function apiService($http, $q, ENV, emitter) {
  var service = this;
  service.getEndpoints = getEndpoints;
  service.getEndpoint = getEndpoint;
  service.getURL = getURL;
  service.addErrorHandler = addErrorHandler;
  service.request = request;
  service.extendedRequest = extendedRequest;
  service.dumpInfo = dumpInfo;
  service.parseErrorsToHtml = parseErrorsToHtml;
  service.parseErrorsToString = parseErrorsToString;

  /** BECOME AN EMITTER
   *
   *    This allows consumers of the API to be notified
   *       of endpoints being triggered, ie:
   *
   *      api.on('/design/create', function(promise){
   *        promise.then().catch().finally();
   *      });
   *
   *    OR
   *
   *      api.one('/design/create', function(promise){
   *        promise.then().catch().finally();
   *      });
   *
   *    See emitter.js for more details
   */
  emitter.addEmitterLogicTo(this);

  /** ENDPOINTS
   *
   *    A comprehensive list of endpoints available to the developer.
   *
   *    The reason for keeping this list is due to the fragmentation
   *     of the authentication tokens. In v1 of the API permissions
   *     are linked to the authentication TYPE, in ADDITION to the
   *     permission flags for the user account.
   *
   *    For the 'auth' column, there are the following values
   *      user_token     - If the user logs in to a Credential (recipient)
   *      issuer_token   - If the user logs in to the Dashboard
   *
   *    Occasionally the API docs request the token be sent in a
   *     HEADER or as a GET parameter. I've made note of these as
   *     I think this is a mistake.
   *
   *    In due course I would like to see v2 adopt a simpler auth
   *     model where there is a single authentication token that
   *     has permissions that can straddle any of the above roles.
   *
   *  VARIABLE SUBSTITUTION
   *
   *    The Backend uses a mix of REST practices, sometimes requiring
   *     the resource id in the URL, and sometimes in the payload.
   *    I have catered for both cases by using variable substition
   *     whereby the API Service will automatically swap out variables
   *     in the endpoint with values from the payload, ie:
   *
   *      '/object/update/<id>' { id: 1234, name: 'new name' }
   *
   *    - becomes -
   *
   *      '/object/update/1234' { name: 'new name' }
   */

  var endpoints = {
    //
    // MULTI-SERVICE AUTHENTICATION
    //
    '/auth/whoami': true,
    '/auth/sign_out': true,
    '/auth/sign_in': true,
    '/user/login/jwt': true, // Should be the same endpoint as above
    '/auth/sign_up': true,
    '/auth/resend_sign_up_email': true,
    '/auth/set_password': true,
    '/auth/send_password_reset_email': true,
    '/auth/reset_password': true,
    '/auth/get_user_detail_from_one_time_token': true,
    //
    // MFA STATUS
    //
    '/security_setting/mfa_status': {
      path: '/issuer/organizations/<id>/security_setting/mfa_status',
      GET: true,
    },
    //
    // PRODUCTS
    //
    '/products/all': {
      path: '/auth/products',
    },
    '/products/validate_domain': true,
    '/products/get': true,
    //
    // ISSUER OR USER AUTHENTICATION
    // ...only the response STRUCTURE defines which is being authenticated... :'(
    //
    '/universal/sso': {
      response: transformGodResponse,
    },
    //
    // ISSUER AUTHENTICATION
    //
    '/issuer_login/whoami': {
      path: '/organization/details',
      response: transformGodResponse,
    },
    '/issuer_login/sign_in': {
      path: '/accounts/issuer_logins/sign_in',
    },
    '/issuer_login/create': {
      path: '/organization/create',
      response: transformGodResponse,
    },
    '/issuer_login/sign_out': {
      path: '/accounts/issuer_logins/sign_out',
      DELETE: true
    },
    '/issuer_login/reset_password': {
      path: '/organization/reset_password_request',
    },
    '/issuer_login/forget_password': {
      path: '/organization/forget_password',
    },
    '/issuer_login/resend_verification_email': {
      path: '/organization/resend_email_verification_code',
    },
    '/issuer_login/select_department': {
      path: '/issuer_login/select_organization',
      payload: function(payload){
        renameProperty(payload, 'department_id', 'organization_id');
      },
      response: transformGodResponse,
    },
    '/issuer_login/update': {
      response: transformGodResponse,
    },
    '/issuer_login/claim_account': {
      response: transformGodResponse,
      payload: function(payload){
        renameProperty(payload, 'department_id', 'org_id');
        renameProperty(payload, 'token', 'key');
      },
    },
    //
    // NEEDS REVIEW (SEE COMMENTS)
    //
    '/department/update': {
      path: '/organization/update',
      response: transformGodResponse,
      // This is ONLY used to set `issuer.sandbox_mode` on the integrations page
      //  let's move this functionality to `/integrations/update_integration`
    },
    //
    // BILLING
    //
    '/billing/all_plans': {
      path: '/stripe/all_plans',
      v2: true,
    },
    '/billing/yearly_report': {
      path: '/organizations/<id>/yearly_report',
      GET: true,
    },
    '/billing/get_billing_summary': {
      path: '/stripe/get_billing_summary',
      v2: true,
    },
    '/billing/create_update_subscription': {
      path: '/stripe/create_update_subscription',
      response: transformGodResponse,
      v2: true,
    },
    '/billing/payment_schedule': {
      path: '/stripe/payment_schedule',
      v2: true,
    },
    '/billing/manage_billing': {
      path: '/stripe/manage_billing',
      v2: true,
      GET: true,
      skipReferrer: true,
    },
    '/billing/update_card': {
      path: '/organization/update_card',
      response: transformGodResponse,
    },
    '/billing/card_detail': {
      path: '/organization/card_detail',
    },
    '/billing/invoices/all': {
      v2: true,
    },
    //
    // BILLING (LEGACY)
    //
    '/billing/legacy/cancel_subscription': {
      path: '/organization/cancel_subscription',
      response: transformGodResponse,
    },
    '/billing/legacy/create_subscription': {
      path: '/organization/create_subscription',
      response: transformGodResponse,
    },
    '/billing/legacy/update_subscription': {
      path: '/organization/update_subscription',
    },
    '/billing/legacy/buy_credit': {
      path: '/organization/buy_credit',
      response: transformGodResponse,
    },
    '/billing/legacy/purchase_history': {
      path: '/stripe/purchase_history',
    },
    //
    // CONTRACTS
    //
    '/contracts/all_contracts': {
      path: '/pricing/get_all_contracts',
    },
    //
    // ANALYTICS
    //
    '/analytics/csv': {
      path: '/organizations/analytics_csv',
    },
    '/analytics/summary': {
      path: '/internal/organization/analytics/marketing_reach',
      GET: true,
    },
    '/analytics/log': {
      path: '/organization/events_log',
    },
    '/analytics/overview': {
      path: '/organization/analytics_extended',
    },
    //
    // CSV
    //
    '/csv/generate': {
      path: '/organization/csv_generation',
    },
    //
    // INTEGRATIONS
    //
    '/integrations/api_key': {
      path: '/organization/api_key',
    },
    //
    // API Settings
    //
    '/api_settings/api_keys': {
      path: '/api_keys',
      GET: true,
    },
    '/api_settings/api_keys/create': {
      path: '/api_keys',
    },
    '/api_settings/api_keys/delete': {
      path: '/api_keys/<id>',
      DELETE: true,
    },

    //
    // TEAM (DEPARTMENT)
    //
    '/team/all': {
      path: '/organization/all_team_members',
      payload: function(payload){
        if(payload.order === 'department_permissions.groups ASC'){
          payload.order = 'organization_permissions.groups ASC';
        }
        if(payload.order === 'department_permissions.groups DESC'){
          payload.order = 'organization_permissions.groups DESC';
        }
      },
    },
    '/team/read': {
      path: '/organization/get_team_member',
    },
    '/team/update': {
      path: '/organization/update_team_member',
    },
    '/team/create': {
      path: '/organization/create_team_member',
    },
    '/team/destroy': {
      path: '/organization/destroy_team_member',
    },
    '/team/resend_invite': {
      path: '/organization/invite_team_member_again',
    },
    '/team/invite_user': false, // Unused
    //
    // NAME CHANGE REQUESTS
    //
    '/name_change_requests/all': {
      path: '/organization/name_change_requests',
    },
    '/name_change_requests/update': {
      path: '/organization/action_name_change_requests',
    },
    '/name_change_request_count': {
      path: '/issuer/organizations/<id>/recipient_name_change_requests/count',
      GET: true,
    },
    //
    // EMAIL SETTINGS
    //
    '/email_settings/send_ses_email': {
      path: '/organization/send_ses_email',
    },
    '/email_settings/confirm_ses_email': {
      path: '/organization/confirm_ses_email',
    },
    '/email_settings/get_settings': {
      path: '/email_setting/get_settings',
    },
    '/email_settings/upsert': {
      path: '/email_setting/upsert',
    },
    '/email_settings/check_from_email_is_confirmed': {
      path: '/email_setting/check_from_email_is_confirmed',
    },
    '/email_settings/confirm_from_email': {
      path: '/email_setting/confirm_from_email',
    },
    '/settings/email/smtp/get': {
      path: '/settings/email/smtp',
      GET: true,
      // mockOn404: function(data) {
      //   return {
      //     smtp_settings: {
      //       enabled: false,
      //       senderName: 'Andrew Bateman',
      //       senderEmail: 'andrew@accredible.com',
      //       username: 'abateman',
      //       password: 'abc',
      //       server: 'smtp.mail.com',
      //       port: 587,
      //       encryption: 'tls'
      //       authentication: 'plain'
      //     }
      //   };
      // }
    },
    '/settings/email/smtp/put': {
      path: '/settings/email/smtp',
      PUT: true,
      // mockOn404: function(data) {
      //   return {
      //     smtp_settings: {
      //       enabled: false,
      //       senderName: 'Andrew Bateman',
      //       senderEmail: 'andrew@accredible.com',
      //       username: 'abateman',
      //       password: 'abc',
      //       server: 'smtp.mail.com',
      //       port: 587,
      //       encryption: 'tls'
      //       authentication: 'plain'
      //     }
      //   };
      // }
    },
    '/settings/email/smtp-test': true,
    // {
    //   mockOn404: function(data) {
    //     return {
    //       status: true
    //     };
    //   }
    // },

    //
    // EMAIL TEMPLATES
    //
    '/email_templates/all': {
      path: '/organization/all_email_templates',
    },
    '/email_templates/template_kinds': true,
    '/email_templates/show': true,
    '/email_templates/update': true,
    '/email_templates/create': true,
    '/email_templates/delete': true,
    '/email_templates/send_preview': true,
    //
    // CREDENTIALS
    //
    '/credentials/request_example': {
      path: '/organization/choose_demo_credential_type',
    },
    '/credentials/all': {
      path: '/organization/all_credential',
    },
    '/credentials/read': {
      path: '/organization/credential/<id>',
      GET: true,
    },
    '/credentials/create': {
      path: '/organization/create_credential',
    },
    '/credentials/update': {
      path: '/organization/update_credential/<id>',
    },
    '/credentials/delete': {
      path: '/delete_credentials',
    },
    '/credentials/get_recipient_sso_link': {
      path: '/organization/get_sso_recipient_link',
    },
    '/credentials/export_as_csv': {
      path: '/organization/export_credentials_csv',
    },
    '/credentials/publish': {
      path: '/organization/publish_credentials',
    },
    '/credentials/download_as_pdf': {
      path: '/organizations/bulk_pdf_download',
    },
    '/credentials/resend_email': {
      path: '/organization/resend_email_credentials',
    },
    '/credentials/change_status': {
      path: '/organization/change_status_credentials',
    },
    '/credentials/move': {
      path: '/organization/change_credentials_group',
    },
    //
    // CERTIFICATE DESIGNS
    //
    '/certificate_designs/all': {
      path: '/organization/all_designs',
    },
    '/certificate_designs/read': {
      path: '/design/<id>',
      GET: true,
    },
    '/certificate_designs/update': {
      path: '/design/update/<id>',
    },
    '/certificate_designs/create': {
      path: '/design/create',
    },
    '/certificate_designs/delete': {
      path: '/design/delete/<id>',
    },
    '/certificate_designs/get_blank_template': {
      path: '/design/get_blank_design',
    },
    '/certificate_designs/public_templates': {
      path: '/organization/static_designs',
    },
    '/design/render_get/<id>': { GET: true },
    '/design/copy_design': false, // Unused
    //
    // GROUPS
    //
    '/groups/all': {
      path: '/organization/all_groups',
    },
    '/groups/read': {
      path: '/groups/show/',
    },
    '/groups/create': {
      path: '/groups',
    },
    '/groups/update': {
      path: '/groups/update/<id>',
    },
    '/groups/delete': {
      path: '/groups/delete/<id>',
    },
    '/groups/compact_list': {
      path: '/organization/all_groups_analytics',
    },
    '/groups/check_group_name_uniqueness': true,
    '/groups/default_settings': {
      path: '/group/default_settings',
    },
    //
    // AUDIT
    //
    '/audit/all': true,
    '/audit/models': true,
    //
    // TAGS
    //
    '/tags/all': true,
    //
    // EMPLOYMENT DIRECTORY
    //
    '/employment_directory/get_settings': true,
    '/employment_directory/upsert': true,
    '/employment_directory/settings': {
      response: function(response){
        renameProperty(response, 'employment_directory.organization_id', 'employment_directory.department_id');
        renameProperty(response, 'employment_directory.organization_name', 'employment_directory.department_name');
      },
    },
    '/employment_directory/<department_id>/profile_search': {
      path: '/directory/<organization_id>/profile_search',
      payload: function(payload){
        renameProperty(payload, 'department_id', 'organization_id');
      },
    },
    '/employment_directory/<department_id>/profile/<id>': {
      path: '/directory/<organization_id>/profile/<id>',
      payload: function(payload){
        renameProperty(payload, 'department_id', 'organization_id');
      },
    },
    //
    // MY PROFILE
    //
    '/my_profile/read': {
      path: '/directory/profile/my_profile',
    },
    '/my_profile/update': {
      path: '/directory/profile/update_profile',
    },
    //
    // VERIFICATION DIRECTORY
    //
    '/verification-directory/get_settings': true,
    '/verification-directory/upsert': true,
    '/verification-directory/settings': {
      response: function(response){
        renameProperty(response, 'verification_directory.organization_name', 'verification_directory.department_name');
      },
      GET: true,
    },
    '/verification-directory/search': true,
    '/organization/directory/<username>': false, // Unused
    //
    // DEMO CREDENTIALS
    //
    '/marketing/create_hubspot_contact': {
      // This is a silly endpoint:
      // a) The API shouldn't expose our infrastructure (hubspot)
      // b) This action is not the job of the FE (it should be a side-effect of another action)
    },
    '/marketing/create_credential': {
      // I dislike the name of this endpoint, what does it do?
    },
    '/marketing/department/public_detail': true,
    '/marketing/department/all_public_groups': true,
    '/marketing/group/public_detail': true,
    //
    // CUSTOM CREDENTIALS (SELF-CERTIFIED CREDENTIALS)
    //
    '/custom_credentials/create': {
      path: '/custom_credential/create',
    },
    '/custom_credentials/show': {
      path: '/custom_credential/show',
    },
    '/custom_credentials/edit': true,
    '/custom_credentials/delete': true,
    '/custom_credentials/credential_id_redirect': true,
    //
    // ORGANIZATIONS
    //
    '/orgs/read': {
      path: '/corporations/show',
      response: function(response){
        renameProperty(response, 'corporation', 'organization');
      },
    },
    '/orgs/update': {
      path: '/corporations/update',
      payload: function(payload){
        renameProperty(payload, 'organization', 'update_corporation_object');
      },
      response: function(response){
        renameProperty(response, 'corporation', 'organization');
      },
    },
    '/organizations/allowance/update': {
      path: '/organizations/<id>/update_allowance',
      PUT: true
    },
    //
    // DEPARTMENTS
    //
    '/departments/all': true,
    '/departments/read': true,
    '/departments/update': true,
    '/departments/create': true,
    '/departments/delete': true,
    //
    // ADMINISTRATORS
    //
    '/administrators/all': true,
    '/administrators/create': true,
    '/administrators/update': true,
    '/administrators/destroy': true,
    '/administrators/resend_invite': {
      path: '/administrators/reinvite',
    },
    //
    // USAGE
    //
    '/usage/get': {
      path: '/corporations/show_department_usage',
    },
    //
    // Utility
    //
    '/utility/is_image': {
      path: '/organization/check_image_link',
    },

    // INTERNAL ENDPOINTS

    // Pathways
    '/internal/pathways/list': { // index
      path: '/internal/pathways',
      GET: true,
      // mockOn404: function(data) {
      //   return {
      //     pathways: []
      //   };
      // }
    },
    '/internal/pathways/get': { // show
      path: '/internal/pathways/<id>',
      GET: true,
    },
    '/internal/pathways/create': { // create
      path: '/internal/pathways',
    },
    '/internal/pathways/update': { // update
      path: '/internal/pathways/<id>',
      PUT: true
    },
    '/internal/pathways/delete': { // update
      path: '/internal/pathways/<id>',
      DELETE: true
    },

    // Collections
    '/internal/collections/list': { // index
      path: '/internal/collections',
      GET: true,
    },
    '/internal/collections/get': { // show
      path: '/internal/collections/<id>',
      GET: true,
    },
    '/internal/collections/create': { // create
      path: '/internal/collections/',
    },
    '/internal/collections/update': { // update
      path: '/internal/collections/<id>',
      PUT: true
    },
    '/internal/collections/delete': { // update
      path: '/internal/collections/<id>',
      DELETE: true
    },
    '/internal/collections/get_recipients': { // recipients
      path: '/internal/collections/<id>/recipients',
      GET: true,
    },
    '/internal/collections/get_recipients_stopped_at': { // recipients_stopped_at
      path: '/internal/collections/<id>/groups/<groupId>/recipients_stopped_at_csv',
      GET: true,
    },

    // Dashboard home screen stats
    '/internal/department_issuance_report': { GET: true },
    '/internal/department_share_feed?feed=<feed>': { GET: true },

    // New analytics
    '/internal/organization/analytics/published_credentials_count': { GET: true },
    '/internal/organization/analytics/credentials_views_count': { GET: true },
    '/internal/organization/analytics/credentials_shared_count': { GET: true },
    '/internal/organization/analytics/published_credentials_chart': { GET: true },
    '/internal/organization/analytics/credentials_views_chart': { GET: true },
    '/internal/organization/analytics/credentials_shared_chart': { GET: true },
    '/internal/organization/analytics/recipient_funnel': { GET: true },
    '/internal/organization/analytics/engagement_events': { GET: true },
    '/internal/organization/analytics/sharing_events': { GET: true },
    // Credential.net collections
    '/internal/departments/get_public_collections': {
      path: '/internal/organizations/<id>/collections',
      GET: true,
    },
    '/internal/collections/get_public': {
      path: '/internal/collections/<id>/public',
      GET: true,
    },
    '/internal/collections/get_user_data': {
      path: '/internal/collections/<id>/user/<username>',
      GET: true,
    },

    //
    //
    // TO REVIEW (BELOW)
    //
    //

    // Public Identity
    '/user/public_identity?username=<username>': true,
    // Utility
    '/typeahead/name_search': true,
    '/get_typeahead_without_auth/name_search': true, // We can search with { collection: 'organizations', query: 'test' } - is this departments or organizations?
    '/typeahead/location_search': true,
    '/directory/get_place_data': true,
    // ...
    // Import Credentials
    '/csv/analyze_csv_data': true,
    '/csv/review_csv_column_map': true,
    '/csv/import_csv': true,
    '/csv/check_import_sheet_progress': true,
    '/csv/evidence_items_field_csv_upload': true,
    // ...
    '/frontend/retrieve_certificate': true,
    '/frontend/log_frontend_analytics': true,
    '/frontend/credential': true,
    '/frontend/credential_id_redirect': true,
    '/frontend/all_grades': { GET: true },
    '/frontend/email': true,
    '/frontend/check_text_for_page': true,
    '/frontend/get_credential_events': true,
    '/frontend/verify_block_transaction': true,
    //'/frontend/branding': { GET: true },
    // Recipient Branding
    '/recipient/settings': { GET: true },
    // User / Recipient Authentication
    '/user/whoami': true,
    '/user/login': true,
    '/user/login/verification_code': true,
    '/user/check_user_verification_login_code': true,
    '/user/logout': true,
    '/user/create': true,
    '/user/update_password': true,
    '/user/forget_password': true,
    '/user/set_new_password': true,
    '/user/get_user_status': true,
    '/user/reset_user_password': true,
    // Other user / recipient endpoints
    '/user/change_email_verification_code': true,
    '/user/change_email': true,
    '/user/update': true,
    '/user/geolocate': { GET: true },
    '/user/make_credentials_public/<id>': true,
    // Attributes
    '/attribute_keys/list': true,
    '/attribute_keys/create': true,
    '/attribute_keys/update': true,
    '/attribute_keys/delete': true,
    // Credential
    '/user/change_name': true,
    '/user/update_credential_privacy': true,
    // Evidence
    '/user/evidence/create': true,
    '/user/evidence/update': true,
    '/user/evidence/delete': true,
    '/user/credentials/reorder_evidence': true,
    // Jobs
    '/internal/job_insights/top_5_companies': true,
    '/internal/job_insights/history': true,
    '/internal/job_insights/search': true,
    // Tracking
    '/analytics/track_link': true,
    '/frontend/store_follow_click': true,
    '/user/linkedin_certificate_shared': true,
    '/user/linkedin_certificate_added': true,
    // ...
    '/user/all_credential': true,
    '/users/add_email_verification_code': true,
    '/users/add_secondary_email': true,
    '/users/delete_secondary_email': true,
    '/users/delete_secondary_email2': true,
    '/user_emails/list_emails': true,
    '/user_emails/change_default_email': true,
    '/users/add_new_email_request': true,
    '/users/resend_verification_email': true,
    '/users/remove_add_email_request':true,
    '/users/login': true,
    '/users/get_credential_pass': { GET: true },
    '/frontend/send_verification_code': true,
    '/frontend/send_user_verification_code': true,
    '/frontend/evidence_insights/<id>': { GET: true },
    // SVG Editor
    '/frontend/convert_svg_to_png': true,
    // ...
    '/group/<id>': true,
    '/group/create': true,
    '/group/update/<id>': true,
    '/group/delete/<id>': true,
    '/group/remove_group': true,
    // ...
    '/role/<id>': true,
    '/role/create': true,
    '/role/update/<id>': true,
    '/role/delete/<id>': true,
    '/role/create_admin_role': true,
    '/role/delete_admin_role': true,
    '/frontend/share_credential_via_email': true,
    '/credential/generate_certificate_pdf': { GET: true },
    '/credential/evidence_item_delete/<id>': true,
    '/credential/directory/notified': { PATCH: true },
    // Various S3 Policies
    '/s3_policy/': true,
    '/s3_policy/templates/': true,
    '/s3_policy/organizations/': true,
    '/s3_policy/evidence/': true,
    // Verify endpoints
    '/verify/verify_credential': true,
    '/frontend/verify_chainpoint_chp_json': { GET: true },
    // Recipient Wallet
    '/user_wallet/get_all_public_credentials': true,
    // Coursefinder
    '/course_finder/search_courses': true, // We're passing `organizations: [...]` - does this make sense now?
    '/credential-net/meta_tags/search': { GET: true },
    // Home
    '/issuer/organizations/setup_status': {
      path: '/issuer/organizations/<id>/setup_status',
      GET: true,
    },
    // FlipperFeatures
    '/issuer/organizations/get_flipper_features': {
      path: '/issuer/organizations/<id>/features',
      GET: true,
    },
    // Campaigns SMS
    '/issuer/organizations/get_sms_configuration': {
      path: '/issuer/organizations/<id>/sms_configuration',
      GET: true,
    },
    '/issuer/organizations/sms_configuration': {
      path: '/issuer/organizations/<id>/sms_configuration'
    }
  };

  /** TRANSFORMS
   *
   *    For development purposes
   *
   *    1 - Allows us to map a NEW endpoint to an OLD endpoint, ie:
   *        `/issuer_login/select_department` is replaced with `/issuer_login/select_organization`
   *    2 - Allows us to transform the payload, ie:
   *        `{ department_id: 2842 }` becomes `{ organization_id: 2842 }`
   *    3 - Allows us to transform the response, ie:
   *        `{ organization: { id: 2842 .... } }` becomes `{ department: { id: 2842 .... } }`
   *
   *    This way we can:
   *      Test our work without demanding immediate changes from BE
   *      Update the FE codebase to use the new nomenclature
   *      Build up a complete todo-list for BE changes
   */

  // TRANSFORMS :: Helper :: Mutates a property
  function renameProperty(data, from, to) {
    var value = _.get(data, from);
    _.set(data, to, value);
    _.unset(data, from);
  }

  // TRANSFORMS :: Shared logic
  function transformGodResponse(response) {
    // Handle normal response
    if (response.issuer) {
      renameProperty(response, 'issuer.department.pricing', 'issuer.pricing');
    }
    // Handle extended response
    if (response.data && response.data.issuer) {
      renameProperty(response.data, 'issuer.department.pricing', 'issuer.pricing');
    }
  }

  /** ADD ERROR HANDLER
   *
   *    The consumer can set
   */
  var errorHandlers = {
    // '401': [ callback, callback ]
  };
  function addErrorHandler(code, callback) {
    if (!errorHandlers[code]) {
      errorHandlers[code] = []; // Instantiate the array if needed
    }
    errorHandlers[code].push(callback);
  }
  function triggerErrorHandlers(err, endpoint) {
    var callbacks = errorHandlers[err.status]; // eg, status=401
    if (callbacks) {
      for (var c = 0, cl = callbacks.length; c < cl; c++) {
        callbacks[c](err, endpoint);
      }
    }
  }

  /** GET URL
   *
   *    Returns the fully expanded URL for an API path
   *    Use sparingly! api.request is probably what you need!
   *
   *      Usage:
   *        api.getURL('/credential/generate_certificate_pdf');
   *
   *    This can also modify the url by replacing variables
   *       available on the {data} object, ie:
   *
   *      /endpoint/<id>
   *      /endpoint/1234
   */
  function getURL(path, data, v2) {
    path = path.replace(/<([^>]*)>/g, function(match, p1, offset, string) {
      if (data[p1]) {
        var value = data[p1]; // Reference the value, because we're about to...
        delete data[p1]; // Remove the variable from the data, it should not be part of the payload
        return encodeURIComponent(value);
      }
      return match;
    });
    var version = v2 ? 'v2' : ENV.apiVersion;
    return ENV.apiEndpoint + version + path;
  }

  /** REQUEST
   *
   *    Uses and returns a PROMISE that:
   *      Waits for initial authentication before being called
   *      Builds up a $http POST or GET request to the server
   *      Deals with common error responses.
   *
   *    Usage:
   *      api.request('/frontend/retrieve_certificate', { email: 'email@eacmf.com' })
   *        .then().catch().finally();
   *
   *      api.extendedRequest('/frontend/retrieve_certificate', { email: 'email@eacmf.com' })
   *        .then().catch().finally();
   *
   *      What is api.extendedRequest ?
   *
   *          The `returnExtendedResponse` argument forces the Service
   *           to reply with the FULL XHR object. Most of the time we
   *           DON'T want to do this as we're just interested in the
   *           response payload. However, sometimes we DO want access
   *           to the `status` and `statusText` properties.
   *
   *          In order to force the consumer code to be more readable
   *           with regards to `returnExtendedResponse` I have
   *           abstracted the parameter into two methods:
   *
   *              api.request
   *              api.extendedRequest
   */
  function requestSubroutine(path, data, returnExtendedResponse) {
    var deferred = $q.defer();
    // Trigger listeners, passing the promise
    service.trigger(path, deferred.promise);
    // I've wrapped the logic in a function so I can bail after rejecting or resolving the promise
    (function() {
      // The endpoint must be valid
      var endpointPath = path;
      if (path.indexOf('/s3_policy/') === 0) {
        endpointPath = path.split('?')[0];
      }

      if (!endpoints[endpointPath]) {
        console.warn('API > ' + path + ' is not a valid endpoint, aborting');
        deferred.reject();
        return false;
      }
      var endpoint = angular.copy(endpoints[endpointPath]);
      // TRANSFORM :: PATH
      if(endpoint.path){
        info('API > Transforming path');
        info('  %c'+path, 'font-weight:bold;');
        info('  %c'+endpoint.path, 'font-weight:bold;');
        path = endpoint.path;
      }
      endpoint.path = path; // Add a copy of the path to the endpoint for reference
      // TRANSFORM :: PAYLOAD
      if(endpoint.payload){
        var newData = angular.copy(data);
        endpoint.payload(newData);
        info('API > Transforming payload for %c'+path, 'font-weight:bold;');
        info('  ', angular.copy(data));
        info('  ', angular.copy(newData));
        data = newData;
      }
      // Build the config object
      var config = {
        method: 'POST',
        url: getURL(path, data, endpoint.v2),
        data: (data || {})
      };
      // Add authorization headers
      if (localStorage.getItem('authorization')) {
        config.headers = {
          'Authorization': localStorage.getItem('authorization'),
          'ACCREDIBLE-DEPARTMENT-ID': localStorage.getItem('department')
        };
      }
      // Add referrer to data (unless skipped)
      if (!endpoint.skipReferrer) {
        config.data['referrer'] = location.host;
      }
      // Special cases
      if (endpoint.GET === true || endpoint.PUT === true || endpoint.PATCH === true || endpoint.DELETE === true) {
        config.method = endpoint.GET ? 'GET' : endpoint.PUT ? 'PUT' : endpoint.PATCH ? 'PATCH' : 'DELETE';
        if (endpoint.GET === true) {
          config.params = config.data;
          delete config.data;
        } else if (endpoint.DELETE) {
          // We don't need the data
          delete config.data;
        }
      }
      // Make the request
      $http(config)
        .then(function(response) {
          if (!returnExtendedResponse) {
            response = response.data; // Most of the time we just need the response.data
          } else {
            // ...but sometimes we allow the full object to be returned, ie: { data: ..., status: 200, statusText: 'OK' }
          }
          // TRANSFORM :: RESPONSE
          if(endpoint.response){
            var newResponse = angular.copy(response);
            endpoint.response(newResponse);
            info('API > Transforming response from %c'+path, 'font-weight:bold;');
            info('  ', angular.copy(response));
            info('  ', angular.copy(newResponse));
            response = newResponse;
          }
          // Return
          deferred.resolve(response);
        })
        .catch(function(err) {
          if (err.status === 429) { // Message that rate limiting has occurred
            alert('Due to high demand, your request could not be processed.');
          } else if (err.status === 404 && endpoint.mockOn404) { // TRANSFORM :: MOCK
            var mockResponse = angular.copy(endpoint.mockOn404(data));
            info('API > Using MOCK response due to 404 from server');
            info('  ', angular.copy(mockResponse));
            deferred.resolve(mockResponse);
            return;
          }
          // Custom error handler?
          triggerErrorHandlers(err, endpoint);
          // Reject
          deferred.reject(err);
        });
    })();
    // Return the promise
    return deferred.promise;
  }
  function request(path, data) {
    return requestSubroutine(path, data, false);
  }
  function extendedRequest(path, data) {
    return requestSubroutine(path, data, true);
  }

  /** DUMP ENDPOINT INFO (UTILITY FUNCTION)
   *
   *    Dumps endpoint information to the console
   *
   *    I've added a bunch of aliases for this method so
   *     you shouldn't have any trouble remembering it.
   *    It loops through ALL endpoints to find anything
   *     that matches your search query, ie:
   *
   *      api.dumpInfo('/frontend/retrieve_certificate');
   *      api.info('certificate');
   *      api.help('/frontend');
   *      api.dump('search');
   *
   *    Alternatively pass nothing to see every endpoint
   *
   *      api.help();
   */
  function dumpInfo(search) {
    log('%c  API INFO  ', 'background-color:#ed143d;color:#FFFFFF;');
    angular.forEach(endpoints, function(endpoint, path) {
      // Does it match?
      if (search && path.indexOf(search) === -1) {
        return;
      }
      // Path
      if (search) {
        var a = path.indexOf(search);
        var b = a + search.length;
        var str = '%c' + path.slice(0, a) + '%c' + path.slice(a, b) + '%c' + path.slice(b);
        log(str, 'font-weight:bold;', 'font-weight:bold;background-color:#ff9632;', 'font-weight:bold;');
      } else {
        log('%c' + path, 'font-weight:bold;');
      }
      // Auth
      if (endpoint.auth) {
        log('    Auth:  ' + endpoint.auth);
      }
    });
  }

  // Getters
  function getEndpoints() {
    return endpoints;
  }
  function getEndpoint(path) {
    return endpoints[path];
  }

  // Error Parsing
  // The BE can return a string, an array of strings, an indexed object containing strings, OR an indexed object containing an array of strings.
  // This is the least readable bit of code I will write today. FML
  function parseErrorsToArray(errors, withoutKeys){
    var errorsArray = [];
    if(angular.isArray(errors.data.errors)){
      // An array of strings
      errorsArray = errors.data.errors;
    } else if(angular.isObject(errors.data.errors)){
      // An indexed object...
      angular.forEach(errors.data.errors, function(error, key){
        if(angular.isArray(error)){
          // ...containing an array
          angular.forEach(error, function(err){
            if (withoutKeys) {
              errorsArray.push(err);
            } else {
              errorsArray.push(key+': '+err);
            }
          });
        } else if(angular.isString(error)){
          // ...containing a string
          if (withoutKeys) {
            errorsArray.push(error);
          } else {
            errorsArray.push(key+': '+error);
          }
        }
      });
    } else if(angular.isString(errors.data.errors)){
      // Just a string
      errorsArray.push(errors.data.errors);
    }
    return errorsArray;
  }
  function parseErrorsToHtml(errors, withoutKeys){
    var errorsArray = parseErrorsToArray(errors, withoutKeys);
    return '<p>'+errorsArray.join('</p><p>')+'</p>';
  }
  function parseErrorsToString(errors, withoutKeys){
    var errorsArray = parseErrorsToArray(errors, withoutKeys);
    return errorsArray.join('\n');
  }

  // Util :: Logging
  function info(){
    if(ENV.type !== 'production'){
      //console.info.apply(console, arguments);
    }
  }
  function log(){
    if(ENV.type !== 'production'){
      console.log.apply(console, arguments);
    }
  }

}

angular
  .module('app')
  .service('api', apiService);


},{}],159:[function(require,module,exports){
/** ATTRIBUTES :: SERVICE
 *
 *  Deals with CRUD operations on Attributes.
 *
 *  @author  David "oodavid" King
 */

attributeService.$inject = ['$q', '$injector', '_', 'api', 'AnalyticsService'];
function attributeService($q, $injector, _, api, AnalyticsService){
  var service = this;
  service.getValidTypes = getValidTypes;
  service.isNameDuplicate = isNameDuplicate;
  service.isNameNonAlpha = isNameNonAlpha;
  service.isNameValidChars = isNameValidChars;
  service.isNameValid = isNameValid;
  service.isNameReserved = isNameReserved;
  service.nameToKey = nameToKey;
  service.getAttributesList = getAttributesList;
  service.getNestedAttributes = getNestedAttributes;
  service.tagsToAttributes = tagsToAttributes;
  service.tagsToAngular = tagsToAngular;
  service.upsert = doUpsert;
  service.delete = doDelete;
  service.parse = parse;

  // The swalService an optional dependency
  var swalService;
  if ($injector.has('swalService')) {
    swalService = $injector.get('swalService');
  } else {
    swalService = {
      showAlert: angular.noop
    };
  }

  /** CACHE
   *
   *      Keep a cache of attributes for quick reference
   *       and two-way-binding fun.
   *
   *      "Dot Notation" is a simple way of keeping our
   *       data clean, allowing the issuer to add anything
   *       as a custom attribute.
   *
   *      This is pre-seeded with defaults.
   *
   *      IMPORTANT NOTE
   *
   *          Default attributes have their `name` translated,
   *           see: attributeFilters.js
   */
  var attributes = [
    // Issuer Defaults
    { parent: 'issuer', key: 'name', type: 'text', },
    // Group Defaults
    { parent: 'group', key: 'course_name', type: 'text', },
    { parent: 'group', key: 'course_description', type: 'text', },
    // Credential Defaults
    { parent: 'credential', key: 'id', type: 'text', help: 'The Accredible ID of the Credential' },
    { parent: 'credential', key: 'license_id', type: 'text', help: 'The Unique ID your organization uses to reference the Credential' },
    { parent: 'credential', key: 'issued_on', type: 'date', },
    { parent: 'credential', key: 'expired_on', type: 'date', },
    { parent: 'credential', key: 'grade', type: 'text', },
    { parent: 'credential', key: 'url', type: 'text', },
    { parent: 'credential', key: 'uuid', type: 'text', },
    // Recipient Defaults
    { parent: 'recipient', key: 'id', type: 'text', help: 'The Unique ID your organization uses to reference the Recipient' },
    { parent: 'recipient', key: 'name', type: 'text', },
    { parent: 'recipient', key: 'email', type: 'email', },
    // These will likely be useful for sending email logic, but are more confusing than not on screens like the design editor
    // { parent: 'credential', key: 'private',                       type: 'boolean', },
    // { parent: 'credential', key: 'complete',                      type: 'boolean', },
    // { parent: 'credential', key: 'allow_supplemental_evidence',   type: 'boolean', },


    // Attributes
    //  ... are dynamic, and look like this:
    // { id: '123', name: 'My Attribute', parent: 'custom', key: 'my_attribute', type: 'text', },
  ];
  // Generate the tags
  angular.forEach(attributes, function(attribute) {
    attribute.tagName = attribute.parent + '.' + attribute.key;
    attribute.tag = '[' + attribute.tagName + ']';
  });

  /** VALID TYPES (FOR CUSTOM ATTRIBUTES*)
   *
   *      The BE allows us to store ANYTHING as the `type`
   *       so we do validation on the FE. We can add new
   *       types as we see fit.
   *
   *      * The DEFAULT attributes don't get validated, which
   *         means they can use undocumented types such as
   *         boolean etc.
   */
  var validTypes = {
    text: 'Text',
    date: 'Date',
    email: 'Email',
    image: 'Image',
    // boolean: 'True/False', // Be careful when reactivating this, FALSEY values are often omitted when submitting via forms
    // url:     'Web Address / URL',
    // number:  'Number',
  };

  function getValidTypes() {
    return validTypes;
  }

  /** SERIALIZERS
   *
   *  This service automatically handles some object serialization.
   *   The BE cannot use `type` as a key due to some Rails conflict,
   *   however I feel that it's the correct key. Furthermore, BE
   *   does NOT store the tokenised version of the attribute. We
   *   do that locally. Example:
   *
   *      Backend Structure
   *          {
   *              id:   123,
   *              name: 'My Custom Attribute',
   *              kind: 'text',
   *          }
   *
   *      Frontend Structure
   *          {
   *              id:      123,
   *              name:    'My Custom Attribute!',
   *              parent:  'custom',
   *              key:     'my_custom_attribute',
   *              type:    'text',
   *              tagName: 'custom.my_custom_attribute',
   *              tag:     '[custom.my_custom_attribute]',
   *          }
   *
   *  NOTES ABOUT KEY GENERATION / VALIDATION
   *
   *      I decided to follow the same conventions as Salesforce as to
   *       what constitutes "valid". That is:
   *
   *          Can contain only underscores and alphanumeric characters
   *          Must begin with a letter
   *          Not include spaces
   *          Not end with an underscore
   *          Not contain two consecutive underscore
   *
   *      You can generate a valid key by passing a string to nameToKey.
   *      Read more about the Salesforce logic here:
   *
   *          https://help.salesforce.com/articleView?id=adding_fields.htm&type=0
   */
  // Converts from `...My Custom Attribute!!` to `my_custom_attribute`
  function nameToKey(name) {
    if (name) {
      var key = name;
      key = key.toLowerCase(); // Drop caps
      key = key.replace(/[^a-z0-9_]+/gi, '_'); // Replace non alphanumerics and _
      key = key.replace(/_+/gi, "_"); // only one _ is left
      key = key.replace(/^[0-9_]+/gi, '_'); // Remove any leading numerics and _
      key = _.trim(key, '_'); // Trim remaining _
      return key;
    }
    return false;
  }
  // Parse for use on FE
  function parse(beAttribute) {
    var attribute = angular.copy(beAttribute);
    attribute.key = nameToKey(attribute.name);
    attribute.type = attribute.kind;
    attribute.parent = 'custom';
    attribute.tagName = attribute.parent + '.' + attribute.key;
    attribute.tag = '[' + attribute.tagName + ']';
    // Validate the type
    if (!validTypes[attribute.type]) {
      attribute.type = 'text'; // Convert to text if it's invalid
      attribute.draft = true;
    }
    // Tidy
    delete attribute.kind;
    // Done
    return attribute;
  }
  // Serialize for storage on BE
  function serialize(attribute) {
    var beAttribute = angular.copy(attribute);
    beAttribute.kind = beAttribute.type;
    // Done
    return beAttribute;
  }

  /** VALIDATOR
   *
   *      This is a "soft" validator, that can run on the FE using known,
   *       cached data. However the BE still may reject the changes on
   *       other grounds (such as having more up-to-date information).
   *
   *      Usage
   *
   *          isNameValid('My Custom Attribute');
   *          isNameValid('My Custom Attribute', 123); // Where 123 is the id of the attribute being modified. Required for the "duplicate key" check to not collide with itself
   */
  function isNameNonAlpha(name) {
    if (!name.match(/[a-z]/i)) {
      return true;
    }
  }

  function isNameValidChars(name) {
    if (name.match(/[^a-z0-9\-\_\ ]/i)) {
      return true;
    }
  }

  function isNameDuplicate(name, id) {
    var key = nameToKey(name);
    var index = _.findIndex(attributes, function(attribute) {
      return attribute.parent == 'custom' // We're only interested in `custom` attributes
        &&
        attribute.key == key // Matching this key
        &&
        attribute.id != id; // But not matching yourself
    });
    if (index !== -1) {
      return true;
    }
  }

  function isNameReserved(name) {
    var blacklist = ['name', 'student name', 'student_name', 'student email', 'email', 'student_email', 'forename', 'surname', 'issue_date', 'issued_date', 'issued_on', 'expired_on', 'expiry_date', 'grade', 'reference', 'referee_name', 'evidence_description', 'evidence_url'];
    var index = _.findIndex(blacklist, function(item) {
      return item == name.toLowerCase();
    });
    if (index !== -1) {
      return true;
    }
  }

  // Runs all validators
  function isNameValid(name, id) {
    return !(isNameNonAlpha(name) && isNameValidChars(name) && isNameDuplicate(name, id) && isNameReserved(name));
  }

  /** GET ATTRIBUTES
   *
   *      Returns a promise for attributes
   *
   *      Only talks to the API once
   */
  var getAttributesPromise;

  function getAttributesList(forceRetrieval, mode) {
    if (!getAttributesPromise || forceRetrieval) {
      getAttributesPromise = api.request('/attribute_keys/list', {mode: mode || 'full'})
        .then(function(response) {
          // Clear the cache of OLD custom credential attributes
          _.remove(attributes, function(attribute) {
            return attribute.parent == 'custom';
          });
          // Add these new custom attributes (creating or updating as needed)
          for (var al = response.attribute_keys.length, a = 0; a < al; a++) {
            var attribute = parse(response.attribute_keys[a]);
            attributes.push(attribute);
          }
          // And return
          return attributes;
        });
    }
    // Return the promise (which may have been resolved already)
    return getAttributesPromise;
  }

  /** GET NESTED ATTRIBUTES
   *
   *      Returns a promise for nested attributes
   *
   *      NB: This object DOES NOT UPDATE when the attributes
   *       array updates. I could create a $rootScope watcher
   *       but at the time of writing I wasn't sure that this
   *       was needed...
   */
  function getNestedAttributes(forceRetrieval) {
    return getAttributesList(forceRetrieval)
      .then(function(response) {
        var nestedAttributes = {};
        for (var al = response.length, a = 0; a < al; a++) {
          var attribute = response[a];
          if (!nestedAttributes[attribute.parent]) {
            nestedAttributes[attribute.parent] = [];
          }
          nestedAttributes[attribute.parent].push(attribute);
        }
        return nestedAttributes;
      });
  }

  /** STRING HELPER :: TAGS TO ATTRIBUTES
   *
   *   Given a string, containing [parent.key] tags, this method
   *    returns an array of related attributes
   */
  function tagsToAttributes(string) {
    var result = [];
    string.replace(/\[([0-9a-z_]+)\.([0-9a-z_]+)\]/ig, function(match, parent, key) {
      var index = _.findIndex(attributes, function(attribute) {
        return attribute.parent == parent && attribute.key == key;
      });
      if (index !== -1) {
        result.push(attributes[index]);
      }
    });
    return result;
  }

  /** STRING HELPER :: TAGS TO ANGULAR
   *
   *   Given a string, this replaces attributes like [course_name]
   *    or [123] to an angular template like {{ credential.course_name }}.
   *
   *   Must cater for the different attribute types (dates)
   */
  function tagsToAngular(string, credentialData, noCurlies) {
    // Look for named, or numerical attributes
    return string.replace(/\[([0-9a-z_]+)\.([0-9a-z_]+)\]/ig, function(match, parent, key) {
      // Build up the angular template
      var tmpl;
      if (parent == 'credential') {
        tmpl = 'data.' + key; // CREDENTIAL data is available at the root level (credential.id)
      } else {
        tmpl = 'data.' + parent + '.' + key; // All other data is available in its own object (recipient.name or custom.log etc.)
      }
      // If we have credential data, then we can infer a custom type from that
      var type = 'text';
      if (parent == 'custom' && credentialData && credentialData.custom_type && credentialData.custom_type[key]) {
        type = credentialData.custom_type[key];
      } else {
        // Otherwise, we can look in the known attributes (ie: defaults)
        var index = _.findIndex(attributes, function(attribute) {
          return attribute.parent == parent && attribute.key == key;
        });
        if (index !== -1) {
          var attribute = attributes[index];
          type = attribute.type;
        }
      }
      // Is it a date?
      if (type == 'date') {
        tmpl += ' | date:(block.date_format ? block.date_format : \'longDate\')';
      }
      // Return
      if (noCurlies) {
        return tmpl;
      }
      return '{{ ' + tmpl + ' }}';
    });
  }

  /** UPSERT
   *
   *      Creates -OR- Updates Attributes
   *
   *      In the presence of an id, we assume it's an Update
   *       without an id, assume Create.
   */
  function doUpsert(attribute, suppressAlerts) {
    var attribute = serialize(attribute);
    return $q(function(resolve, reject) {
      // Can only update custom attributes
      if (attribute.id && attribute.parent != 'custom') {
        if (!suppressAlerts) {
          swalService.showAlert('upsertAttributeFailure', 'Cannot update default attributes');
        }
        reject('Cannot update default attributes');
        return;
      }
      // Validate the attribute name
      if (!isNameValid(attribute.name, attribute.id)) {
        if (!suppressAlerts) {
          swalService.showAlert('upsertAttributeFailure', 'Attribute name is not valid');
        }
        reject('Attribute name is not valid');
        return;
      }
      // Update or Create?
      var method = '/attribute_keys/' + (attribute.id ? 'update' : 'create');
      api.request(method, {
          attribute_key: attribute
        })
        .then(function(response) {
          // Massage
          var attribute = parse(response.attribute_key);
          // Update the cache
          var index = _.findIndex(attributes, {
            'id': attribute.id
          });
          if (index === -1) {
            attributes.push(attribute);
          } else {
            attributes[index] = attribute;
          }

          AnalyticsService.trackEvent('Attributes > Created or Updated Attribute');

          // Notify
          if (!suppressAlerts) {
            swalService.showAlert('upsertAttributeSuccess');
          }
          resolve(attribute);
        })
        .catch(function(err) {
          // Notify
          if (err.status == 422) {
            if (!suppressAlerts) {
              swalService.showAlert('upsertAttributeDuplicate');
            }
          } else {
            if (!suppressAlerts) {
              swalService.showAlert('upsertAttributeFailure');
            }
          }
          reject(err);
        });
    });
  }

  /** DELETE
   *
   *      Deletes an Attribute
   */
  function doDelete(attribute) {
    return $q(function(resolve, reject) {
      api.request('/attribute_keys/delete', {
          id: attribute.id,
        })
        .then(function(response) {
          // Update the cache
          var index = _.findIndex(attributes, {
            'id': attribute.id
          });
          if (index !== -1) {
            attributes.splice(index, 1);
          }
          AnalyticsService.trackEvent('Attributes > Deleted Attribute');
          // Notify
          swalService.showAlert('deleteAttributeSuccess');
          resolve(response);
        })
        .catch(function(err) {
          // Notify
          swalService.showAlert('deleteAttributeFailure');
          reject(err);
        });
    });
  }

}

angular
  .module('app')
  .service('attributeService', attributeService);

},{}],160:[function(require,module,exports){
/** AUTH SERVICE :: ISSUER ONLY
 *
 *    Deals with authentication (of Issuers)
 *
 *    This Service is an emitter. It emits a single event
 *     `change` whenever the auth object changes.
 *
 *      AuthService.on('change', function(auth){ console.log(auth); });
 *        OR
 *      AuthService.one('change', function(auth){ console.log(auth); });
 *
 *    See emitter.js for more details
 *
 *    IMPORTANT NOTES
 *
 *      The values exposed by this service (department,
 *       user, permissions etc.) are LEGACY. Please don't
 *       access these values directly as they will be
 *       removed in due course. Instead use these services:
 *
 *          OrganizationService
 *          DepartmentService
 *          UserService
 *          PermissionsService
 *          FeaturesService
 *
 *    IMPORTANT NOTES
 *
 *      We have different Authentication systems for each
 *       property, or each user "type"... Someday this might
 *       be updated, but sadly no time soon. When that day
 *       comes around, we should merge AuthService and
 *       AuthService into simply AuthService.
 *
 *    NOMENCLATURE
 *
 *      The terms USER and ISSUER-LOGIN are used interchangably
 *       by our API. As are ISSUERS and ORGANIZATIONS.
 *
 *    @author  David "oodavid" King
 */
AuthService.$inject = ['api', '$rootScope', '$q', 'emitter', 'ENV'];
function AuthService(api, $rootScope, $q, emitter, ENV) {
  var service = this;
  service.getAuth = getAuth;
  service.injectAuthentication = injectAuthentication;
  service.authenticateWithEmailAndPassword = authenticateWithEmailAndPassword;
  service.authenticateWithJWT = authenticateWithJWT;
  service.authenticateWithInviteToken = authenticateWithInviteToken;
  service.refresh = refresh;
  service.reset = reset;
  service.logout = logout;
  service.register = register;
  service.resendVerificationEmail = resendVerificationEmail;
  service.sendPasswordResetEmail = sendPasswordResetEmail;
  service.passwordReset = passwordReset;
  service.setPassword = setPassword;

  service.verificationToken = null;

  var auth = {};

  // Become an emitter
  emitter.addEmitterLogicTo(service);

  function storeAuthorization(response) {
    var authorizationHeader = response.headers ? (response.headers('accredible-authorization') || response.headers('authorization')) : null;
    if (authorizationHeader) {
      localStorage.setItem('authorization', authorizationHeader);
    }
  }

  function removeAuthorization() {
    localStorage.removeItem('authorization');
  }

  // Updates the auth object
  function setAuthObject(issuer) {
    if (issuer) {
      // Update auth object
      angular.copy(issuer, auth);

      if (issuer.user) {
        $rootScope.$broadcast('hotjarAndPosthogIssuer', auth);
      }

      if (issuer.department) {
        localStorage.setItem('department', auth.department.id);
      } else {
        localStorage.removeItem('department');
      }

      service.trigger('change', auth);
    }
  }

  function setVerificationToken(response) {
    if (!localStorage.getItem('authorization')) {
      service.verificationToken = null;
      if (response.data && response.data.issuer) {
        service.verificationToken = response.data.issuer.verification_token;
      }
    }
  }

  /** SESSION / FETCH ISSUER / SIGN IN / AUTHENTICATION / LOGIN
   *
   *    Fetch Issuer Returns the auth object. It will make a request
   *     to the API to convert our local authorization into a { auth }
   *     object if / when appropriate.
   *
   *    We allow Issuers to sign in using a number of
   *     mechanisms, this is to reduce friction as much
   *     as possible and give the Issuers a smooth
   *     User-Experience.
   *
   *  STRUCTURAL LOGIC
   *
   *    The following API endpoints all respond with the authorization
   *     and { auth } object, they also dictate the current session,
   *     hence we use common success and error callbacks.
   *
   *        /issuer/whoami
   *        /issuer/login
   *        /issuer/login/jwt
   */

  // Reusable promise for getAuth. This prevents multiple calls to `/issuer_login/whoami`
  var getAuthPromise = false;

  function injectAuthentication(authorization) {
    if (authorization) {
      localStorage.setItem('authorization', authorization);
    }
    // Calls refresh rather than getAuth as we want to force the user data to be retrieved
    return refresh();
  }

  function getAuthSignInHandler(resolve) {
    return function(response) {
      storeAuthorization(response);
      setVerificationToken(response);
      return getAuth()
        .then(function() {
          resolve(auth);
        });
    };
  }

  function getAndStoreAuthHandler(resolve) {
    return function(response) {
      storeAuthorization(response);
      setAuthObject(response.data.issuer);
      resolve(auth);
    };
  }

  // Returns a handler to deal with a successful auth response, which returns the { auth } object
  function getAuthResolveHandler(resolve) {
    return function(response) {
      setAuthObject(response.issuer);
      resolve(auth);
    };
  }

  // Returns a handler to deal with a failed auth response, clearing the session and local issuer data
  function getAuthRejectHandler(reject) {
    return function(err) {
      reset();
      reject(err);
    };
  }

  // Resets the Service
  function reset() {
    getAuthPromise = false;
    removeAuthorization();
    setAuthObject({});
  }

  // Logs the user out
  function logout() {
    var promise = api.request('/issuer_login/sign_out');
    reset(); // We must reset `after` the API request, so that the token is available to the API service
    return promise;
  }

  // Returns a promise for an { auth } object. Request the { auth } object from the API if necessary. Never rejects.
  function getAuth() {
    if(!getAuthPromise){
      getAuthPromise = $q(function(resolve, reject) {
        // If we have no local data, but we DO have a token, ask the API for an { auth } object
        if (angular.equals(auth, {}) && localStorage.getItem('authorization')) {
          api
            .request('/issuer_login/whoami')
            .then(getAuthResolveHandler(resolve), getAuthRejectHandler(resolve)); // By passing `resolve` to both handlers, this never rejects.
        } else {
          resolve(auth); // Otherwise return a pointer to the variable (it may be updated later)
        }
      });
    }
    return getAuthPromise;
  }

  // Forces a refresh of the auth object. Use sparingly. Never Rejects
  function refresh() {
    return $q(function(resolve, reject) {
      api
        .request('/issuer_login/whoami')
        .then(getAuthResolveHandler(resolve), getAuthRejectHandler(resolve)); // By passing `resolve` to both handlers, this never rejects.
    });
  }

  // Authenticate using email and password
  function authenticateWithEmailAndPassword(email, password) {
    // Make sure there isn't an unresolved auth promise
    getAuthPromise = false;
    return $q(function(resolve, reject) {
      api
        .extendedRequest('/issuer_login/sign_in', {
          email: email,
          password: password,
        })
        .then(getAuthSignInHandler(resolve), getAuthRejectHandler(reject));
    });
  }

  // Authenticate using a single-use JSON Web Token - used by Rails Admin, the sign-up email and in the Canvas LMS integration
  function authenticateWithJWT(jwt) {
    return $q(function(resolve, reject) {
        api
          .extendedRequest('/universal/sso', {
            key: jwt,
            object: 'issuer',
          })
          .then(getAndStoreAuthHandler(resolve), getAuthRejectHandler(reject));
      });
  }

  // Team member/Admin invite - via email
  // Authenticate with an invite token - used to save password for new team member
  function authenticateWithInviteToken(token, department_id, password){
    return $q(function(resolve, reject) {
      api
        .extendedRequest('/issuer_login/claim_account', {
          token: token,
          department_id: department_id,
          password: password
        })
        .then(getAndStoreAuthHandler(resolve), getAuthRejectHandler(reject));
    });
  }

  // Sign up - create new issuer -> generates email
  // Creates a new login
  function register(new_issuer_object){
    return $q(function(resolve, reject) {
      api
        .request('/issuer_login/create', {
          'issuer': new_issuer_object,
        })
        .then(getAuthResolveHandler(resolve), getAuthRejectHandler(reject));
    });
  }

  // Resends the registration email
  function resendVerificationEmail(verificationToken) {
    return api
      .request('/issuer_login/resend_verification_email', { verification_token: verificationToken });
  }

  // Sends a password reset email
  function sendPasswordResetEmail(email, captcha) {
    return api
      .request('/issuer_login/forget_password', {
        email: email,
        recaptcha_response: captcha
      });
  }

  // Resets the issuers password
  function passwordReset(reset_token, password) {
    return api
      .request('/issuer_login/reset_password', {
        reset_token: reset_token,
        password: password,
      });
  }

  // Sets the (new) issuers password
  function setPassword(newPassword) {
    return api
      .request('/issuer_login/update', {
        login_issuer_params: {
          password: newPassword
        }
      });
  }

  /** LEGACY :: GOD OBJECT HANDLING
   *
   *    There are a number of endpoints that return the same
   *     "God Object" as these authentication requests.
   *
   *    While this AuthService isn't concerned with any of
   *     this data, there are a number of other services
   *     that depend on the AuthService for this data.
   *
   *    Here we listen for endpoints that are known to
   *     return this object; we update our cache appropriately.
   */
  api.on('/issuer_login/select_department', handleExternalData);
  api.on('/issuer_login/update', handleExternalData);
  api.on('/department/update', handleExternalData);
  api.on('/billing/legacy/create_subscription', handleExternalData);
  api.on('/billing/legacy/buy_credit', handleExternalData);
  api.on('/billing/update_card', handleExternalData);
  api.on('/billing/legacy/cancel_subscription', handleExternalData);
  api.on('/billing/create_update_subscription', handleExternalData);
  function handleExternalData(promise){
    promise
      .then(function(response){
        setAuthObject(response.issuer);
      })
      .catch()
      .finally();
  }
}

angular
  .module('app')
  .service('AuthService', AuthService);

/*

// How to use

// Get the current issuer
AuthService
  .getAuth()
  .then(function(issuer){
    // console.log('logged in with', issuer);
  });

// Login with email and password
AuthService
  .authenticateWithEmailAndPassword('david+41@accredible.com', 'darwin99')
  .then(function(issuer){
    // console.log('logged in with', issuer);
  });

// Login with a JWT
var jwt = {};
AuthService.
  authenticateWithJWT(jwt)
  .then(function(issuer){
    // console.log('logged in with', issuer);
  });

// Creating an account
var new_issuer_object = {"contact_last_name":"King","password":"darwin99","name":"DKCLa","url":"http://oodavid.com","email":"david+"+Math.round(Math.random()*10000)+"@oodavid.com","phone_number":"07939273963","api_agreement_sign":true,"contact_first_name":"David","found_accredible":"Google","sandbox_mode":false};
AuthService
  .register(new_issuer_object)
  .then(function(issuer){
    // console.log('logged in with', issuer);
  });

// Logout
AuthService
  .logout()
  .then(function(){
    // console.log('logged out');
  });

// Resend the verification email
AuthService
  .resendVerificationEmail()
  .then(function(){
    // console.log('sent');
  });

// Request a password reset email
AuthService
  .sendPasswordResetEmail('david+41@accredible.com')
  .then(function(){
    // console.log('sent');
  });

// Reset the password
AuthService
  .passwordReset('password_reset_token', 'darwin99')
  .then(function(issuer){
    // console.log('logged in with', issuer);
  });


// I expect this to emit events

*/

},{}],161:[function(require,module,exports){
CertificateService.$inject = ['$q', 'api', 'swalService', 'AnalyticsService'];
function CertificateService($q, api, swalService, AnalyticsService){
  var service = this;
  service.upsert = upsert;
  service.get = get;
  service.destroy = destroy;
  service.getBlankDesign = getBlankDesign;
  service.getDesigns = getDesigns;

  // Upserts a design
  function upsert(design){
    // design = clean(design); // Clean the object - TODO: Is this needed?
    // Update or Insert?

    var escapedCharacters = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      '\'': '&#39;',
      '/': '&#x2F;'
    };

    var escapedName = String(design.name).replace(/[&<>"'\/]/g, function (s) {
      return escapedCharacters[s];
    });

    var designEscaped = angular.copy(design);
    designEscaped.name = escapedName;

    if (design.id) {
      // Update
      return api
        .request('/certificate_designs/update', { design: designEscaped, id: design.id })
        .then(function(response){
          return response.design;
        });
    } else {
      // Insert
      return api
        .request('/certificate_designs/create', { design: designEscaped })
        .then(function(response){
          return response.design;
        });
    }
  }

  // Returns a design
  function get(idObjectOrFalsey) {
    if(!idObjectOrFalsey){
      // Return a blank design
      return getBlankDesign();
    } else {
      // Request the design from backend. When given a design object, this ensures the latest version is used
      var id = angular.isObject(idObjectOrFalsey) ? idObjectOrFalsey.id : idObjectOrFalsey;
      return api
        .request('/certificate_designs/read', { id: id })
        .then(function(response) {
          return response.design;
        });
    }
  }

  // Deletes a design
  function destroy(idOrDesign) {
    var id = angular.isObject(idOrDesign) ? idOrDesign.id : idOrDesign; // Be flexible with input
    return $q(function(resolve, reject){
      api
        .request('/certificate_designs/delete', { id: id })
        .then(function(response){
          AnalyticsService.trackEvent('Designs > Delete Design');
          resolve();
        })
        .catch(function(err){
          if(err.status === 404){
            resolve(); // The design didn't exist (it was probably already deleted)
          } else {
            swalService.showAlert('certificateDesignInUse');
            reject(err); // The design is still in use
          }
        });
    });
  }

  // Returns a blank design object (possibly from cache, for speed)
  var blankDesign;
  function getBlankDesign() {
    if(blankDesign){
      return $q.resolve(angular.copy(blankDesign)); // From cache
    } else {
      return api
        .request('/certificate_designs/get_blank_template')
        .then(function(response) {
          blankDesign = response.design; // Cache
          return angular.copy(blankDesign);
        });
    }
  }

  // Returns designs for the issuer, or the publically available templates, depending on payload
  function getDesigns(payload, showTemplates) {
    if(showTemplates){
      return api.request('/certificate_designs/public_templates', payload);
    } else {
      return api.request('/certificate_designs/all', payload);
    }
  }

  //
  // SHAME
  //
  // This method makes sure that any additional values or properties don't exist on the design object
  // Artefacts MAY exist from bad FE logic, or bad BE serialization. Who knows!
  //
  function clean(design) {
    var copiedDesign = angular.copy(design); // Don't pollute the original
    var newDesign = {
      'id': copiedDesign.id,
      'svg': copiedDesign.svg,
      'blocks': copiedDesign.blocks,
      'background': copiedDesign.background,
      'name': copiedDesign.name,
      'size': copiedDesign.size || 'us-letter',
      'orientation': copiedDesign.orientation || 'landscape',
      'background_bleeds': copiedDesign.background_bleeds || false,
    };
    if (copiedDesign.blocks && copiedDesign.blocks.length > 0) {
      for (var i = copiedDesign.blocks.length - 1; i >= 0; i--) {
        newDesign.blocks.push(copiedDesign.blocks[i]);
      }
    }
    if (copiedDesign.custom_attributes && copiedDesign.custom_attributes.length > 0) {
      newDesign.custom_attributes = copiedDesign.custom_attributes;
    }
    return newDesign;
  }

}

angular
  .module('app')
  .service('CertificateService', CertificateService);

},{}],162:[function(require,module,exports){
/** CSV - SERVICE
 *
 *      A simple service that can be used to generate CSVs
 *
 *      Usage:
 *
 *          csv.generate();
 *          csv.generate({ ...flags... });
 *          Where `flags` looks like:
 *              {
 *                  evidence_item: true,
 *                  grade:         true
 *              }
 *
 *      @author   David "oodavid" King
 */
require('./download.service.js');

csvService.$inject = ['api', 'downloadService'];
function csvService(api, downloadService){
  var service = this;
  service.generate = generate;
  function generate(flags){
    return api
      .request('/csv/generate', flags)
      .then(function(response) {
        downloadService.download(response.link);
      });
  }
}

angular
  .module('app')
  .service('csv', csvService);

},{"./download.service.js":163}],163:[function(require,module,exports){
/** DOWNLOAD SERVICE
 *
 *    Triggers file-downloads
 *
 *    http://stackoverflow.com/questions/3749231/download-file-using-javascript-jquery
 */
downloadService.$inject = [];
function downloadService(){
  var service = this;
  service.download = download;
  function download(url){
    var hiddenIFrameID = 'hiddenDownloader';
    var iframe = document.getElementById(hiddenIFrameID);
    if (iframe === null) {
      iframe = document.createElement('iframe');
      iframe.id = hiddenIFrameID;
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
    }
    iframe.src = url;
  }
}

angular
  .module('app')
  .service('downloadService', downloadService);

},{}],164:[function(require,module,exports){
/** EMAIL : VALIDATOR
 *
 *    A superior regex to the built-in angularjs validator
 *
 *      http://stackoverflow.com/a/28431112/1122851
 *      http://blog.gerv.net/2011/05/html5_email_address_regexp/
 *
 *    emailService.isValid('david@oodavid.com');
 *    emailService.parse('david@oodavid.com');
 *
 *    @author   David "oodavid" King
 */
require('./url.service.js');

emailService.$inject = ['urlService'];

function emailService(urlService) {
  var service = this;
  service.isValid = isValid;
  service.parse = parse;
  var regexEmail = /^[a-z0-9.!#$%&’*+/=?^_`{|}'~-]+@[a-z0-9](?:[a-z0-9-]{0,253}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,253}[a-z0-9])?)*$/i;

  // Returns bool if an email is valid
  function isValid(value) {
    return !value || regexEmail.test(value);
  }

  // Parses an email address
  function parse(email) {
    if (isValid(email)) {
      var tmp = email.split('@');
      if (tmp.length == 2 && tmp[0].length && tmp[1].length) {
        return {
          local: tmp[0],
          domain: urlService.parse('http://' + tmp[1]),
        };
      }
    }
  }
}

angular
  .module('app')
  .service('emailService', emailService);

},{"./url.service.js":176}],165:[function(require,module,exports){
/** EMITTER - SERVICE
 *
 *      The emitter service allows any object to become an emitter.
 *
 *      Usage:
 *
 *          var o = function(){
 *            emitter.addEmitterLogicTo(this);
 *            setInterval(function(){
 *              this.trigger('someEvent', 1, 2, 3);
 *            }, 1000);
 *            return this;
 *          }();
 *
 *          o.on('someEvent', function(a, b, c){
 *            console.log('triggered every time', a, b, c);
 *          });
 *          o.one('someEvent', function(a, b, c){
 *            console.log('triggered once', a, b, c);
 *          });
 *          o.on('*', function(a, b, c){
 *            console.log('catch-all listener', a, b, c);
 *          });
 *
 *      Notes:
 *
 *          I'm not completely happy with the method naming here.
 *           `addEmitterLogicTo` feels clunky. I'd like to use
 *           prototypical inheritance, but it doesn't gel with our
 *           existing AngularJS code.
 *
 *      @author   David 'oodavid' King
 */
emitterService.$inject = [];
function emitterService(){
  var service = this;
  service.addEmitterLogicTo = addEmitterLogicTo;
  function addEmitterLogicTo(obj) {
    obj.on = on;
    obj.off = off;
    obj.one = one;
    obj.trigger = trigger;
    //
    var callbacks = {};
    var id = 0;
    function on(name, callback) {
      id++;
      if (!callbacks[name]) {
        callbacks[name] = {};
      }
      callbacks[name][id] = callback;
      return {
        name: name,
        id: id
      };
    }
    function off(task) {
      delete callbacks[task.name][task.id];
    }
    // Applies a self-removing callback
    function one(name, callback) {
      var task = on(name, function() {
        callback.apply(this, arguments);
        off(task);
      });
      return task;
    }
    function trigger(name /* all additional arguments are passed to the callback */ ) {
      // Convert the arguments {object} into an array that we can use with `apply`
      var args = [];
      for (var i = 1, il = arguments.length; i < il; i++) { // I'm intentionally skipping the first argument, which is `name`
        args.push(arguments[i]);
      }
      // Trigger callbacks
      angular.forEach(callbacks[name], function(callback){
        callback.apply(this, args);
      });
      // ...and any catch-all listeners
      angular.forEach(callbacks['*'], function(callback){
        callback.apply(this, args);
      });
    }
  }
}

angular.module('app')
  .service('emitter', emitterService);

},{}],166:[function(require,module,exports){
encodeService.$inject = [];
function encodeService(){
  var service = this;
  service.encode = encode;

  var encodeChars = {
    '<': '&lt;',
    '>': '&gt;'
  };
  function encode(string){
    string += ''; // Coerce to string
    return string.replace(/[<>]/g, function(char){
      return encodeChars[char] || char;
    });
  }

}

angular
  .module('app')
  .service('encodeService', encodeService);

},{}],167:[function(require,module,exports){
/** FILE SIZE - SERVICE
 *
 *    A simple service that can juggle between human and
 *     machine file-sizes
 *
 *    Usage:
 *
 *      var bytes    = fileSize.parse('5.1 Mb'); // 5242880
 *      var bytes    = fileSize.parse('100kb');  // 102400
 *      var readable = fileSize.human(5242880);  // '5.0 Mb'
 *      var readable = fileSize.human(12345678); // '11.8 Mb'
 *
 *    @author   David "oodavid" King
 */
fileSizeService.$inject = [];
function fileSizeService(){
  var service = this;
  service.parse = parse;
  service.human = human;

  var units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  // Parse a string into bytes
  function parse(string) {
    string = string.toLowerCase();
    var num = parseFloat(string, 10);
    if (num == string) {
      return Math.round(num);
    }
    for (var u = 0, ul = units.length; u < ul; u++) {
      num *= 1024;
      if (string.indexOf(units[u].toLowerCase()) !== -1) {
        return Math.round(num);
      }
    }
  }
  // Convert bytes into a string
  function human(bytes) {
    var i = -1;
    do {
      bytes = bytes / 1024;
      i++;
    } while (bytes > 1024);
    return Math.max(bytes, 0.1).toFixed(1) + ' ' + units[i];
  }
}

angular.module('app')
  .service('fileSize', fileSizeService);

},{}],168:[function(require,module,exports){
/** FLIPPER FEATURES SERVICE */
FlipperFeaturesService.$inject = ['$q', 'api', 'emitter'];
function FlipperFeaturesService($q, api, emitter) {
  var service = this;
  service.getFlipperFeatures = getFlipperFeatures;

  var flipperFeatures;

  // Become an emitter
  emitter.addEmitterLogicTo(service);

  function getFlipperFeatures(id) {
    return $q(function(resolve) {
      if (!flipperFeatures) {
        api
          .request('/issuer/organizations/get_flipper_features', { id: id })
          .then(function(response) {
            flipperFeatures = response.features;

            service.trigger('change', flipperFeatures);

            resolve(flipperFeatures);
          });
      } else {
        resolve(flipperFeatures);
      }
    });
  }
}

angular
  .module('app')
  .service('FlipperFeaturesService', FlipperFeaturesService);

},{}],169:[function(require,module,exports){
/** IMG - SERVICE
 *
 *    A simple service that can be used to parse image URLs.
 *
 *    Usage:
 *
 *      img.parse('https://s3.amazonaws.com/accredible-api-templates/1517397678529.png')
 *        .then(function(data){
 *          console.log(data);
 *        });
 *
 *    @author   David "oodavid" King
 */
imgService.$inject = ['$q'];
function imgService($q){
  var service = this;
  service.parse = parse;
  // Loads an image and returns details about it
  function parse(src){
    var deferred = $q.defer();
    var img = new Image();
    img.onload = function(){
      deferred.resolve({
        width: this.naturalWidth,
        height: this.naturalHeight,
        src: src,
        ext: src.split('.').pop().toLowerCase(),
      });
      delete img;
    }
    img.error = function(){
      deferred.reject();
      delete img;
    }
    img.src = src;
    return deferred.promise;
  }
}

angular.module('app')
  .service('imgService', imgService);

},{}],170:[function(require,module,exports){
jobsService.$inject = ['api'];
function jobsService(api){
  var service = this;
  service.top5Companies = top5Companies;
  service.history = history;
  service.search = search;

  function getPayload(jobInsights, groupId, countryCode) {
    var payload = {
      job: jobInsights, group_id: groupId
    };
    if (countryCode) {
      payload['country'] = countryCode;
    }
    return payload;
  }

  function top5Companies(jobInsights, groupId, countryCode){
    return api.request('/internal/job_insights/top_5_companies', getPayload(jobInsights, groupId, countryCode));
  }
  function history(jobInsights, groupId, countryCode){
    return api.request('/internal/job_insights/history', getPayload(jobInsights, groupId, countryCode));
  }
  function search(jobInsights, groupId, countryCode){
    return api.request('/internal/job_insights/search', getPayload(jobInsights, groupId, countryCode));
  }
}

angular.module('app')
  .service('jobsService', jobsService);

},{}],171:[function(require,module,exports){
/** ORGANIZATION SERVICE
 *
 *  This horrible service lets you read and update
 *   the organization for the current session.
 *
 *  Why is it horrible? The backend doesn't allow
 *   us to request the organization until we have
 *   selected a... Department?! I don't know why
 *   they are coupled in this way, but I've wasted
 *   too much time trying to get this to work that
 *   I just want to push some functional code.
 *
 *  Anyhow, this is the dance we do:
 *
 *    1  - Automatically "run" the service so that
 *         we can add a listener to the AuthService
 *         before the service is naturally consumed
 *    2a - Keep a reference to the current Department
 *         so that we can detect changes
 *    2b - Whenever the Department changes, re-fire
 *         the `getDepartment` method to make sure
 *         we're up-to-date
 *    3a - When requesting the Organization, first
 *         make sure that we have a Department
 *    3b - If we don't have a Department, return a
 *         pointer to an object that will be updated
 *         when a Department becomes available.
 */
OrganizationService.$inject = ['$q', 'api', 'AuthService'];
function OrganizationService($q, api, AuthService) {
  var service = this;

  service.getOrganization = getOrganization;
  service.getOrganizationImmediate = getOrganizationImmediate;
  service.updateOrganization = updateOrganization;
  service.updateDepartmentAllowance = updateDepartmentAllowance;

  var selectedDepartmentId; // The selected department
  var organization = {}; // The organization

  function getOrganization() {
    return $q(function(resolve) {
      if (selectedDepartmentId) {
        api
          .request('/orgs/read')
          .then(function(response) {
            angular.copy(response.organization, organization);
            resolve(organization);
          }, function(){
            resolve(organization); // Never reject
          });
      } else {
        resolve(organization); // Never reject
      }
    });
  }

  function getOrganizationImmediate(){
    return organization;
  }

  function updateOrganization(organization) {
    return api
      .request('/orgs/update', { organization: organization })
      .then(function(response) {
        angular.copy(response.organization, organization);
        return organization;
      });
  }

  function updateDepartmentAllowance(department, allowance) {
    return api
      .request('/organizations/allowance/update', { id: department.id, allowance: allowance })
      .then(function(response) {
        return response;
      });
  }

  AuthService.on('change', function(auth){
    var newDepartmentId = auth.department && auth.department.id;
    if(newDepartmentId !== selectedDepartmentId){
      selectedDepartmentId = newDepartmentId;
      getOrganization(); // Trigger this to update our local object
    }
  });

}

OrganizationServicePreload.$inject = ['OrganizationService'];
function OrganizationServicePreload(OrganizationService){ /* ...we just want the dependency! */ }

angular
  .module('app')
  .service('OrganizationService', OrganizationService)
  .run(OrganizationServicePreload);

},{}],172:[function(require,module,exports){
paramService.$inject = [];
function paramService(){
  var service = this;

  service.encode = encode;
  service.decode = decode;

  function encode(o){
    try {
      return encodeURIComponent(JSON.stringify(o));
    } catch(e){
      // ...
    }
  }
  function decode(s){
    try {
      return JSON.parse(decodeURIComponent(s));
    } catch(e){
      // ...
    }
  }

}

angular.module('app')
  .service('paramService', paramService);

},{}],173:[function(require,module,exports){
require('../../shared/_services/uuidv4.service.js');

PathwayService.$inject = ['$q', 'api', 'uuidv4'];
function PathwayService($q, api, uuidv4) {
  var service = this;
  service.loadPathways = loadPathways;
  service.getPathwayData = getPathwayData;
  service.getPathwayById = getPathwayById;
  service.getPathways = getPathways;
  service.getPathwayKindName = getPathwayKindName;
  service.getPathwayIcon = getPathwayIcon;
  service.createPathwayFromTemplate = createPathwayFromTemplate;
  service.getById = getById;
  service.clonePathway = clonePathway;
  service.getGroups = getGroups;
  service.stubPathway = stubPathway;
  service.prerequisites = prerequisites;
  service.getAssociatedPathways = getAssociatedPathways;
  service.createPathwayFromGroupId = createPathwayFromGroupId;
  service.newNode = newNode;
  service.savePathway = savePathway;
  service.deletePathway = deletePathway;
  service.runShortIntegrityCheck = runShortIntegrityCheck;
  service.runFullIntegrityCheck = runFullIntegrityCheck;

  // Functionality switches
  service.settings = {
    differentiated_stacks: false,
    generic_pathways: false,
    element_info: false,
    options_rules: {
      any: true,
      value: false,
      conditional: false
    }
  };

  var pathways = [];
  var pathwayHash = {};
  function updatePathwayHash() {
    pathways.forEach(function(pathway) {
      pathwayHash[pathway.id] = pathway;
    });
  }

  function loadPathways(completeFunction) {
    return api
      .request('/internal/pathways/list')
      .then(function(response) {
        pathways = response.pathways;
        updatePathwayHash();
        return completeFunction ? completeFunction() : pathways;
      });
  }

  function getPathwayData(id) {
    var pathway = pathwayHash[id];
    return { kind: pathway.kind, name: pathway.name };
  }

  function getPathwayById(id) {
    return pathways.filter(function(pathway) {
      return pathway.id === id;
    })[0];
  }

  function getPathways() {
    return pathways;
  }

  function getPathwayKindName(kind) {
    switch(kind) {
      case 'closed_stack':
        return service.settings.differentiated_stacks ? 'Closed Stack' : 'Stack';
      case 'open_stack':
        return service.settings.differentiated_stacks ? 'Open Stack' : 'Stack';
      case 'milestone':
        return 'Milestone';
      case 'cluster':
        return 'Cluster';
      case 'generic':
        return 'Generic';
    }
  }

  function getPathwayIcon(kind) {
    switch(kind) {
      case 'closed_stack':
      case 'open_stack':
        return 'pathway-stacked';
      case 'milestone':
        return 'trophy';
      case 'cluster':
        return 'pathway-cluster';
      case 'generic':
        return 'wip';
    }
  }

  function uuidFake() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return s4() + s4() + '-fake-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }

  var templates = [
    {
      id: null,
      kind: 'closed_stack',
      name: '',
      groups: [],
      pathways: [],
      nodes: [
        {
          id: null,
          kind: 'open',
          name: '',
          required: {
            elements: []
          },
          options: {
            rule: null,
            elements: []
          }
        },
        {
          id: null,
          kind: 'successor',
          name: '',
          required: {
            elements: []
          },
          options: {
            rule: null,
            elements: []
          }
        },
        {
          id: null,
          kind: 'successor',
          name: '',
          required: {
            elements: []
          },
          options: {
            rule: null,
            elements: []
          }
        }
      ]
    },
    {
      id: null,
      kind: 'open_stack',
      name: '',
      groups: [],
      pathways: [],
      nodes: [
        {
          id: null,
          kind: 'open',
          name: '',
          required: {
            elements: []
          },
          options: {
            rule: null,
            elements: []
          }
        },
        {
          id: null,
          kind: 'open',
          name: '',
          required: {
            elements: []
          },
          options: {
            rule: null,
            elements: []
          }
        },
        {
          id: null,
          kind: 'open',
          name: '',
          required: {
            elements: []
          },
          options: {
            rule: null,
            elements: []
          }
        }
      ]
    },
    {
      id: null,
      kind: 'milestone',
      name: '',
      groups: [],
      pathways: [],
      nodes: [
        {
          id: null,
          kind: 'open',
          name: '',
          required: {
            elements: []
          },
          options: {
            rule: null,
            elements: []
          }
        },
        {
          id: null,
          kind: 'award',
          name: '',
          required: {
            elements: []
          },
          options: {
            rule: null,
            elements: []
          }
        }
      ]
    },
    {
      id: null,
      kind: 'cluster',
      name: '',
      groups: [],
      pathways: [],
      nodes: [
        {
          id: null,
          kind: 'open',
          name: '',
          required: {
            elements: []
          },
          options: {
            rule: null,
            elements: []
          }
        }
      ]
    }
  ];


  // Node integrity checks

  function singleRequiredElement(node, index) {
    var elements = node.required.elements;
    var result = { success: elements.length === 1 };
    if (!result.success) {
      if (elements.length === 0) {
        result['error'] = 'Required element missing from node ' + index + ' [' + (node.name || 'Untitled') + '].';
        result['remediator'] = { description: 'Add a group or pathway to node ' + index + ' [' + (node.name || 'Untitled') + '].', action: null };
      } else if (elements.length > 1) {
        var removeAllButFirstRequiredElement = function() {
          node.required.elements = [ elements[0] ];
        };
        result['error'] = 'Too many required items in node ' + index + ' [' + (node.name || 'Untitled') + '].';
        result['remediator'] = { description: 'Remove all but the first required item from node ' + index + ' [' + (node.name || 'Untitled') + '].', action: removeAllButFirstRequiredElement };
      }
    }
    return result;
  }

  function hasValidOptionsRule(node, index) {
    var elements = node.options.elements;
    var rule = node.options.rule;
    var result = { success: true };
    if (rule) {
      if (rule.hasOwnProperty('any')) {
        result.success = rule.any < elements.length;
        if (!result.success) {
          result['error'] = 'There are insufficient option items to satisfy the completion criteria in node ' + index + ' [' + (node.name || 'Untitled') + '].';
          result['remediator'] = { description: 'Add options items, or change the completion criteria, in node ' + index + ' [' + (node.name || 'Untitled') + '].', action: null };
        }
      }
      // TODO: Add checks for other rule types here
    }
    return result;
  }

  function noRequiredElements(node, index) {
    var elements = node.required.elements;
    var result = { success: elements.length === 0 };
    if (!result.success) {
      var removeAllRequiredElements = function() {
        node.required.elements = [];
      };
      result['error'] = 'No required items are allowed [' + (node.name || 'Untitled') + '].';
      result['remediator'] = { description: 'Remove all required items from node ' + index + ' [' + (node.name || 'Untitled') + '].', action: removeAllRequiredElements };
    }
    return result;
  }

  function noOptionsElements(node, index) {
    var elements = node.options.elements;
    var result = { success: elements.length === 0 };
    if (!result.success) {
      var removeAllOptionsElements = function() {
        node.options.elements = [];
      };
      result['error'] = 'No options items are allowed in node ' + index + ' [' + (node.name || 'Untitled') + '].';
      result['remediator'] = { description: 'Remove all options items from node ' + index + ' [' + (node.name || 'Untitled') + '].', action: removeAllOptionsElements };
    }
    return result;
  }

  function hasMoreThanOneOptionsElements(node, index) {
    var elements = node.options.elements;
    var result = { success: elements.length > 1 };
    if (!result.success) {
      result['error'] = 'More than one options item is required in node ' + index + ' [' + (node.name || 'Untitled') + '].';
      result['remediator'] = { description: 'Add options items to node ' + index + ' [' + (node.name || 'Untitled') + '].', action: null };
    }
    return result;
  }

  // Pathway integrity checks

  function hasName(pathway) { // This applies to all pathways
    var result = { success: pathway.name && pathway.name !== '' };
    if (!result.success) {
      result['error'] = 'Pathway does not have a name.';
      result['remediator'] = { description: 'Give the pathway a name.', action: null };
    }
    return result;
  }

  function startsWithOpenNode(pathway) { // This applies to all pathways
    var nodes = pathway.nodes;
    var result = { success: nodes.length > 0 && nodes[0].kind === 'open' };
    if (!result.success) {
      var convertFirstNodeToOpen = function() {
        pathway.nodes[0].kind = 'open';
      };
      result['error'] = 'Pathway does not start with an open node.';
      result['remediator'] = { description: 'Make first node \'open\'.', action: convertFirstNodeToOpen };
    }
    return result;
  }

  function noEmptyNodes(pathway) {
    var nodes = pathway.nodes;
    var result = { success: true };
    for (var index = 0; index < nodes.length; index++) {
      var node = nodes[index];
      if (node.required.elements.length === 0 && node.options.elements.length === 0) {
        result.success = false;
        break;
      }
    }
    if (!result.success) {
      result['error'] = 'Pathway has one or more empty nodes.';
      result['remediator'] = { description: 'Make sure all pathway nodes have an assiged group or pathway.', action: null };
    }
    return result;
  }

  function hasMoreThanOneNode(pathway) {
    var nodes = pathway.nodes;
    var result = { success: nodes.length > 1 };
    if (!result.success) {
      result['error'] = 'Pathway requires more than one node.';
      result['remediator'] = { description: 'Add at least one more node.', action: null };
    }
    return result;
  }

  function hasOnlyOneNode(pathway) {
    var nodes = pathway.nodes;
    var result = { success: nodes.length === 1 };
    if (!result.success) {
      var removeAllButFirstNode = function() {
        pathway.nodes = [ nodes[0] ];
      };
      result['error'] = 'Pathway can only contain one node.';
      result['remediator'] = { description: 'Remove all but the first node.', action: removeAllButFirstNode };
    }
    return result;
  }

  function checkNodes(nodes, property, value, is) {
    var result = true;
    var test = is ? function(i) { return nodes[i][property] !== value; } : function(i) { return nodes[i][property] === value; };
    for (var index = 0; index < nodes.length; index++) {
      if (test(index)) {
        result = false;
        break;
      }
    }
    return result;
  }

  function allNodesOpen(pathway) {
    var nodes = pathway.nodes;
    var result = { success: checkNodes(nodes, 'kind', 'open', true) };
    if (!result.success) {
      var makeAllNodesOpen = function() {
        pathway.nodes.forEach(function(node) {
          node.kind = 'open';
        });
      };
      result['error'] = 'Pathway requires all nodes to be open.';
      result['remediator'] = { description: 'Make all nodes \'open\'.', action: makeAllNodesOpen };
    }
    return result;
  }

  function allSubsequentNodesNotOpen(pathway) { // This is true if there is only one node
    var nodes = pathway.nodes;
    var result = { success: checkNodes(nodes.slice(1), 'kind', 'open', false) };
    if (!result.success) {
      var makeAllSubsequentNodesSuccessor = function() {
        pathway.nodes.slice(1).forEach(function(node) {
          node.kind = 'successor';
        });
      };
      result['error'] = 'Pathway requires that only the first node is open.';
      result['remediator'] = { description: 'Make all nodes excluding the first \'successor\' nodes.', action: makeAllSubsequentNodesSuccessor };
    }
    return result;
  }

  function hasNoAwardNodes(pathway) {
    var nodes = pathway.nodes;
    var result = { success: checkNodes(nodes, 'kind', 'award', false) };
    if (!result.success) {
      var removeAwardNodes = function() {
        pathway.nodes = nodes.filter(function(node) {
          return node.kind !== 'award';
        });
      };
      result['error'] = 'Pathway cannot contain award nodes.';
      result['remediator'] = { description: 'Remove all award nodes.', action: removeAwardNodes };
    }
    return result;
  }

  function hasOnlyOneAwardNodeAndEndsWithIt(pathway) {
    var nodes = pathway.nodes;
    var result = {
      success: nodes.filter(function(node) { return node.kind === 'award'; }).length === 1 && nodes[nodes.length - 1].kind === 'award'
    };
    if (!result.success) {
      result['error'] = 'Pathway does not have only one award node at the end.';
      result['remediator'] = { description: 'Make sure that there is only one award node and it is at the end of the pathway.', action: null };
    }
    return result;
  }

  function noNodesWithSameRequiredElement(pathway) {
    var nodes = pathway.nodes;
    var ids = {};
    var result = {
      success: true
    };
    for (var index = 0; index < nodes.length; index++) {
      var required = nodes[index].required.elements;
      for (var i = 0; i < required.length; i++) {
        var element = required[i];
        var id = element.id;
        if (id) {
          if (ids[id]) {
            result.success = false;
            break;
          } else {
            ids[id] = true;
          }
        }
      }
      if (!result.success) {
        break;
      }
    }
    if (!result.success) {
      result['error'] = 'Pathway has more than one node with the same required group or pathway.';
      result['remediator'] = { description: 'Make sure that each group or pathway is only required by one node.', action: null };
    }
    return result;
  }

  var integrityChecks = {
    node: {
      closed_stack: [ singleRequiredElement, noOptionsElements ],
      open_stack: [ singleRequiredElement, noOptionsElements ],
      milestone: [ hasValidOptionsRule ],
      cluster: [ hasValidOptionsRule, noRequiredElements, hasMoreThanOneOptionsElements ],
      generic: [ hasValidOptionsRule ]
    },
    pathway: {
      closed_stack: [ hasName, startsWithOpenNode, noEmptyNodes, hasMoreThanOneNode, hasNoAwardNodes, allSubsequentNodesNotOpen, noNodesWithSameRequiredElement ],
      open_stack: [ hasName, startsWithOpenNode, noEmptyNodes, hasMoreThanOneNode, hasNoAwardNodes, allNodesOpen, noNodesWithSameRequiredElement ],
      milestone: [ hasName, startsWithOpenNode, noEmptyNodes, hasMoreThanOneNode, allSubsequentNodesNotOpen, hasOnlyOneAwardNodeAndEndsWithIt, noNodesWithSameRequiredElement ],
      cluster: [ hasName, startsWithOpenNode, noEmptyNodes, hasOnlyOneNode ],
      generic: [ hasName, startsWithOpenNode, noEmptyNodes, noNodesWithSameRequiredElement ]
    }
  };

  function runShortIntegrityCheck(target, pathwayKind, source, sourceIndex, ignoreEmptyNodes) {
    var checks = integrityChecks[target][pathwayKind];
    var checkResult;
    for (var index = 0; index < checks.length; index++) {
      var check = checks[index];
      if (!ignoreEmptyNodes || check !== noEmptyNodes) {
        checkResult = check(source, sourceIndex);
        if (!checkResult.success) {
          break;
        }
      }
    }
    return checkResult || { success: true };
  }

  function runFullIntegrityCheck(target, pathwayKind, source, sourceIndex, ignoreEmptyNodes) {
    var checks = integrityChecks[target][pathwayKind];
    var checkResult;
    var errors = [];
    var remediators = [];
    for (var index = 0; index < checks.length; index++) {
      var check = checks[index];
      if (!ignoreEmptyNodes || check !== noEmptyNodes) {
        checkResult = check(source, sourceIndex);
        if (!checkResult.success) {
          errors.push(checkResult.error);
          remediators.push(checkResult.remediator);
        }
      }
    }
    return { success: errors.length === 0, errors: errors, remediators: remediators };
  }

  function createPathwayFromTemplate(kind) {
    return $q(function(resolve, reject) {
      var newPathway = templates.filter(function(template) {
        return template.kind === kind;
      })[0];
      newPathway.id = uuidFake(); // Fake UUID - replaced when saved
      newPathway.nodes.forEach(function(node) {
        node.id = uuidv4.generate();
      });
      resolve(newPathway);
    });
  }

  function newNode(kind) {
    return {
      id: uuidv4.generate(),
      kind: kind,
      name: '',
      required: {
        visible: true,
        elements: []
      },
      options: {
        visible: false,
        rule: null,
        elements: []
      }
    };
  }

  function retrievePathwayById(id) {
    return pathways.filter(function(pathway) {
      return pathway.id === id;
    })[0];
  }

  function removePathwayById(id) {
    pathways = pathways.filter(function(pathway) {
      return pathway.id !== id;
    });
  }

  function getById(id) {
    return $q(function(resolve, reject) {
      resolve(retrievePathwayById(id));
    });
  }

  function clonePathway(id) {
    var foundPathway = retrievePathwayById(id);
    var newPathway = null;
    if (foundPathway) {
      newPathway = angular.copy(foundPathway);
      newPathway.id = uuidFake();
      newPathway.name ='';
      newPathway.nodes.forEach(function(node) {
        node.id = uuidv4.generate();
      });
      delete(newPathway.created_at);
      delete(newPathway.updated_at);
    }
    return newPathway;
  }

  var dummyGroups = [
    {
      id: '8d4c88af-b1cc-4801-9c7b-dff1b613b859',
      kind: 'group',
      name: 'Group A'
    },
    {
      id: '6738b3fa-a885-4bb1-8644-a23e4add4791',
      kind: 'group',
      name: 'Group B'
    },
    {
      id: '2d3ca6d1-8275-4f31-8abd-81b0cd9f5ff6',
      kind: 'group',
      name: 'Group C'
    },
    {
      id: '2b8d9059-28dc-4d68-b27c-0ca3fd65c031',
      kind: 'group',
      name: 'Group D'
    },
    {
      id: 'aadfa049-c130-4165-b9e2-cd52f815a29e',
      kind: 'group',
      name: 'Group E'
    },
    {
      id: '2c5c7f8c-427b-4ec8-a3f9-8eedee37194b',
      kind: 'group',
      name: 'Group F'
    },
    {
      id: '9f98c3f6-ce29-46d1-ae6a-7edae65964cb',
      kind: 'group',
      name: 'Group G'
    },
  ];

  function getGroups() {
    return $q(function(resolve, reject) {
      resolve(dummyGroups);
    });
  }

  function stubPathway() {
    return {
      id: uuidFake(),
      kind: 'generic',
      name: '',
      groups: [],
      pathways: [],
      nodes: [
        {
          id: uuidv4.generate(),
          kind: 'open',
          name: '',
          required: {
            elements: []
          },
          options: {
            rule: null,
            elements: []
          }
        }
      ]
    };
  }

  function getAssociatedPathways(currentPathwayId, groupId) {
    return pathways.filter(function(pathway) {
      var containsGroup = false;
      if (pathway.id !== currentPathwayId) {
        var index = 0;
        while (index < pathway.nodes.length && !containsGroup) {
          var node = pathway.nodes[index];
          if (node.kind !== 'award') {
            var isRequired = node.required.elements.filter(function(element) {
              return element.id === groupId;
            }).length > 0;
            var isOption = node.options.elements.filter(function(element) {
              return element.id === groupId;
            }).length > 0;
            containsGroup = isRequired || isOption;
          } else if (node.kind === 'award') {
            containsGroup = node.required.elements[0].id === groupId;
          }
          index++;
        }
      }
      return containsGroup;
    });
  }

  function createPathwayFromGroupId(groupId) {
    return $q(function(resolve, reject) {
      resolve({
        id: uuidFake(),
        kind: 'generic',
        groups: [groupId],
        pathways: [],
        name: '',
        nodes: [
          {
            id: uuidv4.generate(),
            kind: 'open',
            name: '',
            required: {
              elements: [
                {
                  id: groupId,
                  kind: 'group',
                  value: 15
                }
              ]
            },
            options: {
              rule: null,
              elements: []
            }
          }
        ]
      });
    });
  }

  function prerequisites(currentEditPathways, id) {
    var nodes = pathwayNodes(currentEditPathways);
    var prerequisiteNodes = [];
    $.each(nodes, function(nodeId, data) {
      var elements = data.node.required.elements.concat(data.node.options.elements);
      for (var index = 0; index < elements.length; index++) {
        var element = elements[index];
        if (element.id === id && data.previous_id) {
          prerequisiteNodes.push({ data: nodes[data.previous_id], optional: data.node.kind === 'open' });
          break;
        }
      }
    });
    return prerequisiteNodes;
  }

  // Returns a "linked list" of pathway nodes

  function contains(pathwayList, pathway) {
    var result = false;
    for (var index = 0; index < pathwayList.length; index++) {
      if (pathwayList[index].id === pathway.id) {
        result = true;
        break;
      }
    }
    return result;
  }

  function pathwayNodes(currentEditPathways) {
    var collectedPathways = currentEditPathways.concat(pathways.filter(function(pathway) { // Put current edit pathways first
      return !contains(currentEditPathways, pathway);
    }));
    var nodes = {};
    collectedPathways.forEach(function(pathway) {
      var previousNodeId = null;
      for (var index = 0; index < pathway.nodes.length; index++) {
        var node = pathway.nodes[index];
        nodes[node.id] = { pathway_id: pathway.id, previous_id: previousNodeId, node: node, nodeIndex: index };
        previousNodeId = node.id;
      }
    });
    return nodes;
  }

  function hasTemporaryId(obj) {
    return obj.id === '8657ec8e-b2e7-460d-beb5-811ba673d7a0' || String(obj.id).indexOf('-fake-') > 0;
  }

  function saveResponseHandler(response) {
    var pathwayId = response.pathway.id;
    return loadPathways(function() {
      return pathwayId;
    });
  }

  function savePathway(pathway) {
    if (hasTemporaryId(pathway)) {
      return api
        .request('/internal/pathways/create', { pathway: pathway })
        .then(saveResponseHandler);
    } else {
      return api
        .request('/internal/pathways/update', { id: pathway.id, pathway: pathway })
        .then(saveResponseHandler);
    }
  }

  function deletePathway(id) {
    return api
      .request('/internal/pathways/delete', { id: id })
      .then(function() {
        // Reload pathways
        return loadPathways();
      });
  }
}

angular
  .module('app')
  .service('PathwayService', PathwayService);

},{"../../shared/_services/uuidv4.service.js":177}],174:[function(require,module,exports){
/** SUPPORT - SERVICE
 *
 *      Show and hide the support lozenge
 *
 *      Automatically hides if / when the route changes, there is a
 *       minor delay on hiding to prevent flicker in case the
 *       destination route wants to keep the help lozenge visible.
 *
 *          supportService.show();     // Shows the help lozenge
 *          supportService.activate(); // Activates the chat window
 *          supportService.hide();     // Hides the help lozenge. You may never need to do this as it is triggered whenever the route changes
 *
 *      @author   Jake Ford
 *      @author   David "oodavid" King (refactor)
 */
supportService.$inject = ['$window', '$timeout', 'AnalyticsService', '$injector'];
function supportService($window, $timeout, AnalyticsService, $injector){
  var service = this;
  service.hide = hide;
  service.show = show;
  service.activate = activate;

  var hideTimeout;
  var isVisible = false;

  // Hide the Help Lozenge
  function hide() {
    // Has a grace period that can be cancelled by show()
    hideTimeout = $timeout(function() {
      if ($window.zE && isVisible) {
        $window.zE(function() {
          $window.zE.hide();
          isVisible = false;
        });
      }
    }, 300);
  };

  // Show the help lozenge
  function show() {
    // Cancel any hide command that might be waiting to run
    if (hideTimeout) {
      $timeout.cancel(hideTimeout);
    }
    if ($window.zE && !isVisible) {
      $window.zE(function() {
        $window.zE.show();
        isVisible = true;
      });
    }
  };

  // Activate the chat window
  function activate() {
    AnalyticsService.trackEvent('Support > Zendesk Activated');
    if ($window.zE) {
      $window.zE(function() {
        $window.zE.activate({
          hideOnClose: !isVisible, // We want this to reeturn to hidden, if it's currently hidden
        });
      });
    }
  };

  // Hide when changing route - Only when running UI-Router
  if ($injector.has('$transitions')) {
    var $transitions = $injector.get('$transitions');
    $transitions.onStart({}, hide);
  }

}

angular.module('app')
  .service('supportService', supportService);

},{}],175:[function(require,module,exports){
svgService.$inject = ['api'];
function svgService(api){
    var service = this;
    service.rgbToHex = rgbToHex;
    service.getBadgeTemplates = getBadgeTemplates;

    // Regular expression to match the RGB format
    function isValidRgb(rgbString) {
        var rgbRegex = /^rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/;

        return rgbRegex.test(rgbString);
    }

    function rgbToHex(rgbString) {
        if (!isValidRgb(rgbString)) {
            return rgbString;
        }

        // Extract RGB values from the string using regular expression
        var rgbValues = rgbString.match(/\d+/g);

        // Convert each component to its hexadecimal representation
        var hexColor = '#';
        rgbValues.forEach(function (value) {
        hexColor += padWithZero(parseInt(value, 10).toString(16));
        });

        return hexColor.toUpperCase();
    }

    function padWithZero(hexValue) {
        // Pad with leading zeros if needed
        return hexValue.length === 1 ? '0' + hexValue : hexValue;
    }

    function getBadgeTemplates() {
      return api.request('/certificate_designs/public_templates', {
        page_size: 1000, // Get all designs
        page: '',
        design_identifier: '', // Fulltext search
        kind: 'badge' // Only show badge designs
       });
    }

}

angular
  .module('app')
  .service('svgService', svgService);

},{}],176:[function(require,module,exports){
/** URL - SERVICE
 *
 *    A simple service that can be used to parse URLs.
 *
 *    Includes logic that breaks up querystring hashstring
 *     into {key:value} objects - see "query" property
 *      Modified from this answer:
 *        http://stackoverflow.com/a/8486188/1122851
 *
 *    https://mathiasbynens.be/demo/url-regex
 *    https://gist.github.com/dperini/729294
 *
 *    Usage:
 *
 *      urlService.isValid('http://website.com:1234/path/?search=test#hash');
 *      urlService.parse('http://website.com:1234/path/?search=test#hash');
 *
 *    @author   David "oodavid" King
 */

var internalDomains = [
  'accredible.com',
  'credential.net',
  'badge.design',
  'coursefinder.io',
];

urlService.$inject = ['$location'];
function urlService($location){
  var service = this;
  service.isValid = isValid;
  service.parse = parse;
  // Create a re-usable DOM element for parsing
  var parser = document.createElement('a');
  // Validates an URL
  // gruber v2
  // var regexUrl = /^((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))$/i;
  // krijnhoetmer
  // var regexUrl = /^(^|[\s.:;?\-\]<\(])(https?:\/\/[-\w;/?:@&=+$\|\_.!~*\|'()\[\]%#,☺]+[\w/#](\(\))?)(?=$|[\s',\|\(\).:;?\-\[\]>\)])$/i;
  // diegoperini
  var regexUrl = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;
  function isValid(value){
    return !value || regexUrl.test(value);
  }
  // Parse a string into an URL
  function parse(href) {
    parser.href = href;
    // Pull values from our `parser` as it get's reused
    return {
      href: parser.href, // => "http://website.com:1234/path/?search=test#hash"
      protocol: parser.protocol, // => "http:"
      hostname: parser.hostname, // => "website.com"
      port: parser.port, // => "1234"
      pathname: parser.pathname, // => "/path/"
      search: parser.search, // => "?search=test"
      hash: parser.hash, // => "#hash"
      host: parser.host, // => "website.com:1234"
      query: getQuery(), // => { "search": "test" } :: This automatically uses the search or hash string containing the ?=&= structure
      external: isExternal(), // boolean
    };
  }
  // Add the curent domain as "internal"
  internalDomains.push($location.host());
  // Tests if the url is to an external site
  var tmp = [];
  for(var d=0,dl=internalDomains.length; d<dl; d++){
    var domain = internalDomains[d];
    tmp.push('^'+domain+'$');   // Exact match
    tmp.push('\\.'+domain+'$'); // ...plus subdomains
  }
  var regexInternal = new RegExp('('+tmp.join('|')+')', 'i');
  function isExternal(){
    if(parser.hostname && !regexInternal.test(parser.hostname)){
      return true;
    }
    return false;
  }
  // Looks for query-like values in the search or hash, then parses them into a {key:value} object
  function getQuery() {
    var encoded = false;
    var query = {};
    // Try the search, then the hash
    if (parser.search && parser.search.length > 1) {
      encoded = parser.search.substr(1);
    } else if (parser.hash) {
      // Look for a query
      var pos = parser.hash.indexOf('?');
      if (pos !== -1) {
        encoded = parser.hash.substr(pos + 1);
      } else {
        // ...it might be encoded
        pos = parser.hash.indexOf('%3F');
        if (pos !== -1) {
          encoded = parser.hash.substr(pos + 3);
        }
      }
    }
    // Parse the encoded query
    if (encoded) {
      encoded.split('&').forEach(function(part) {
        if (!part) {
          return;
        }
        part = part.split('+').join(' '); // replace every + with space, regexp-free version
        var eq = part.indexOf('=');
        var key = eq > -1 ? part.substr(0, eq) : part;
        var val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : '';
        var from = key.indexOf('[');
        if (from == -1) {
          query[decodeURIComponent(key)] = val;
        } else {
          var to = key.indexOf(']');
          var index = decodeURIComponent(key.substring(from + 1, to));
          key = decodeURIComponent(key.substring(0, from));
          if (!query[key]) {
            query[key] = [];
          }
          if (!index) {
            query[key].push(val);
          } else {
            query[key][index] = val;
          }
        }
      });
    }
    // Lovely
    return query;
  }
}

angular
  .module('app')
  .service('urlService', urlService);

},{}],177:[function(require,module,exports){
uuidv4Service.$inject = [];
function uuidv4Service(){
  var service = this;
  service.generate = generate;

  var crypto = window.crypto || window.msCrypto; // For IE 11 compatibility
  function generate() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, function(c) {
      return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
    });
  }
}

angular
  .module('app')
  .service('uuidv4', uuidv4Service);

},{}],178:[function(require,module,exports){
/** ALERT SERVICE 2 :: PROMISES
 *
 *      We expose 3 alert types:
 *          alert        Shows a message with `ok`
 *          confirm      Shows a message with `cancel` and `ok`
 *          loading      Shows a loading spinner with `cancel`
 *          progress     Shows a progress-bar with `cancel`
 *          confirmWithCheckbox Shows a message with checkboxes that must be checked before 'ok' is enabled
 *
 *      Each type can use any of these styles:
 *          success, error, warning, info, question
 *
 *      The Progress Bar
 *          By default, the loading bar is "magic", it uses the
 *           same logic as `angular-loading-bar` to create an
 *           animated loading bar that never quite completes.
 *          However there is a method that allows you to manually
 *           update the progress bar and message. I have included
 *           logic here that guesses the ETA of the progress
 *           based on the time elapsed and progress percentage.
 *
 *      UI ROUTER
 *          This service prevents the user from navigating away
 *           from a route when an alert is visible. The old
 *           implementation allowed the user to move through
 *           their history (back and forward) buttons, but any
 *           visible alerts would remain visible, and callback
 *           logic would be bound to some non-existent view.
 *
 *      NOTES
 *          The alert service is NOT designed to work with
 *           more complex modals, with <forms> and the like.
 *          Consider a form using with submit-validate, this would
 *           need to layer an alert ON TOP of the modal when
 *           the form contains errors.
 *
 *      REFERENCES
 *          https://github.com/dwmkerr/angular-modal-service
 *          https://limonte.github.io/sweetalert2/
 *
 *      @author   David "oodavid" King
 */

alertService.$inject = ['$q', '$interval', '$injector', '$sce', '$timeout', '$filter'];
function alertService($q, $interval, $injector, $sce, $timeout, $filter) {
  var service = this;

  // Data
  service.data = {
    visible: false,
    title: false, // String OR false
    trustedContent: false, // Do we trust the content HTML?
    content: false, // HTML string OR false
    loading: false, // Spinner?
    progress: false, // Object OR false
    ok: false, // OK text
    triggerOk: triggerOk, // Method
    cancel: false, // Cancel text
    triggerCancel: triggerCancel, // Method
    triggerCheckCheckboxes: setAllCheckboxesChecked, // Method
    checkboxes: [],
    allCheckboxesChecked: false,
  };

  // Methods
  service.close = close;
  service.open = open;
  service.setProgress = setProgress;

  // Helper Methods (abstract to `open`)
  service.alert = alert;
  service.confirm = confirm;
  service.agree = agree;
  service.confirmWithCheckbox = confirmWithCheckbox;
  service.loading = loading;
  service.progress = progress;
  service.warning = warning;
  service.success = success;
  service.info = info;

  var translate = $filter('translate');

  function alert(title, content, width) {
    return open({
      title: title,
      content: content,
      ok: true,
      width: width,
    });
  }

  function confirm(title, content, ok, cancel, width) {
    return open({
      title: title,
      content: content,
      ok: ok == null ? true : ok,
      cancel: cancel == null ? true : cancel,
      width: width,
    });
  }

  function agree(title, content, ok, width) {
    return open({
      title: title,
      content: content,
      ok: ok == null ? true : ok,
      cancel: false,
      width: width,
    });
  }

  function confirmWithCheckbox(title, content, ok, cancel, width, checkboxData) {
    return open({
      title: title,
      content: content,
      ok: ok == null ? true : ok,
      cancel: cancel == null ? true : cancel,
      width: width,
      checkboxes: checkboxData,
    });
  }

  function loading(title, content) {
    return open({
      title: title,
      content: content,
      loading: true,
      cancel: true,
    });
  }

  function progress(title, content) {
    return open({
      title: title,
      content: content,
      loading: true,
      progress: true,
      cancel: true,
    });
  }

  function selectiveTranslate(string) {
    if (!string) {
      return string;
    }
    return (string.indexOf('@:') === 0 ? translate(string.substring(2)) : string).replace(/(?:\r\n|\r|\n)/g, '<br>');
  }

  function expand(validationErrors) {
    var output = '';
    validationErrors.forEach(function(item) {
      var message = '';
      if (item.key === 'minlength') {
        message = translate('validation.not-enough-chars');
      } else if (item.key === 'maxlength') {
        message = translate('validation.too-many-chars');
      } else {
        message = translate('validation.' + item.key, item.translateValues);
      }
      output += '<span>' + item.label + ' - ' + message + '</span><br>';
    });
    return output;
  }

  function warning(title, content, zIndex) {
    return open({
      title: selectiveTranslate(title),
      content: $.isArray(content) ? expand(content) : selectiveTranslate(content),
      infoType: 'warning',
      ok: translate('ok'),
      width: 400,
      zIndex: zIndex,
    });
  }

  function success(title, content) {
    return open({
      title: selectiveTranslate(title),
      content: selectiveTranslate(content),
      infoType: 'success',
      ok: translate('ok'),
      width: 400
    });
  }

  function info(title, content, cancel, cancelAction) {
    return open({
      title: selectiveTranslate(title),
      content: selectiveTranslate(content),
      infoType: 'info',
      cancel: cancelAction ? selectiveTranslate(cancel) : translate('cancel'),
      ok: translate('ok'),
      cancelAction: cancelAction,
      width: 400
    });
  }

  /** MODAL MANAGEMENT
   *
   *      The `alert`, `confirm`, `loading` and `progress`
   *       methods simply abstract to this method.
   */

  var resolve; // The alertService is a singleton, so
  var reject; //  we only keep one resolve and reject

  function open(options) {
    service.data.visible = true;
    service.data.title = options.title || false;
    service.data.trustedContent = options.trustedContent || false;
    service.data.content = parseContent(options.content);
    service.data.ok = (options.ok === true) ? 'ok' : (options.ok || false);
    service.data.cancel = (options.cancel === true) ? 'cancel' : (options.cancel || false);
    service.data.loading = options.loading || false;
    service.data.width = Number.isInteger(options.width) ? options.width + 'px' : 'none';
    service.data.infoType = options.infoType || false;
    service.data.cancelAction = options.cancelAction || false;
    service.data.checkboxes = options.checkboxes || [];
    service.data.zIndex = options.zIndex || null;
    setAllCheckboxesChecked();

    if (options.progress) {
      showProgressBar();
    } else {
      hideProgressBar();
    }
    return $q(function(myResolve, myReject) {
      resolve = function () {
        return myResolve();
      };
      reject = function () {
        return myReject();
      };
    });
  }

  function close() {
    service.data.visible = false;
    stopFakeProgress();
  }

  function triggerOk() {
    close();
    resolve('user pressed ok');
  }

  function triggerCancel() {
    close();
    if (service.data.cancelAction) {
      service.data.cancelAction();
    }
    reject('user pressed cancel');
  }
  /** PARSE CONTENT
   *
   *  We want HTML <p>Message</p>
   *  But may be given simple strings or an array of strings
   */
  function parseContent(content){
    var html = false;
    //
    if(angular.isArray(content)){
      // If the content is an array of strings process each line
      if (!angular.isObject(content[0])) {
        html = '';
        angular.forEach(content, function(line){
          html += toParagraph(line);
        });
        // If the content is an array of objects
      } else if (angular.isObject(content[0])) {
        angular.forEach(content, function(el){
          html += toParagraph(el.content);
        });
      }
    }
    //
    if(angular.isString(content)){
      html = toParagraph(content);
    }
    // Do we have something to return?
    if(html){
      // Do we trust the HTML?
      if(service.data.trustedContent){
        html = $sce.trustAsHtml(html);
      }
    }
    return html;
  }
  var hasOpeningTag = /\s*^<[a-z][\s\S]*>/i; // Checks for an opening tag
  function toParagraph(string){
    if(!hasOpeningTag.test(string)){
      string = '<p>'+string+'</p>';
    }
    return string;
  }
  /** PROGRESS
   *
   *      The progress bar can run "magically" or manually
   *
   *      Fake Progress
   *          The logic on incrementFakeProgress() is taken from
   *           the angular-loading-bar library, it's useful.
   */
  var progressStartTime;

  function hideProgressBar() {
    service.data.progress = false;
    stopFakeProgress();
  }

  function showProgressBar() {
    progressStartTime = false;
    service.data.progress = {
      value: null,
      total: null,
      pct: null,
      eta: null,
    };
    startFakeProgress();
  }

  function setProgress(value, total) {
    if (!service.data.progress) {
      service.data.progress = {}; // What does this signify? The consumer may have used `alertService.alert()` followed by `alertService.setProgress(3, 10)`. Assume they now want a progress bar
    }
    stopFakeProgress();
    service.data.progress.value = value;
    service.data.progress.total = total;
    service.data.progress.pct = service.data.progress.value / service.data.progress.total;
    // Calculate the eta
    if (value > 0 && total > 0) {
      // Once we have our first value, we can start the clock, the next pass will have the estimate
      if (!progressStartTime) {
        progressStartTime = Date.now();
        return;
      }
      var remaining = total - value;
      var elapsedMs = Date.now() - progressStartTime;
      var remainingMs = (elapsedMs / value) * remaining;
      // Humanize!
      var seconds = Math.round(remainingMs / 1000);
      var minutes = Math.floor(seconds / 60);
      seconds = seconds % 60;
      if(seconds){
        seconds = seconds === 1 ? '1 second' : seconds + ' seconds';
      }
      if(minutes){
        minutes = minutes === 1 ? '1 minute' : minutes + ' minute';
      }
      service.data.progress.eta = minutes ? 'About ' + minutes + ' and ' + seconds + ' remaining' : 'About ' + seconds + ' remaining';
    }
  }
  // Fake progress
  var fakeProgressInterval;
  var fakeProgress;

  function startFakeProgress() {
    stopFakeProgress();
    fakeProgress = 0;
    fakeProgressInterval = $interval(function() {
      incrementFakeProgress();
      service.data.progress.pct = fakeProgress;
    }, 200);
  }

  function stopFakeProgress() {
    if (fakeProgressInterval) {
      $interval.cancel(fakeProgressInterval);
    }
  }

  function incrementFakeProgress() {
    if (fakeProgress >= 1) {
      return;
    }
    var rnd = 0;
    var stat = fakeProgress;
    if (stat >= 0 && stat < 0.25) {
      rnd = (Math.random() * (5 - 3 + 1) + 3) / 100; // Start out between 3 - 6% increments
    } else if (stat >= 0.25 && stat < 0.65) {
      rnd = (Math.random() * 3) / 100; // increment between 0 - 3%
    } else if (stat >= 0.65 && stat < 0.9) {
      rnd = (Math.random() * 2) / 100; // increment between 0 - 2%
    } else if (stat >= 0.9 && stat < 0.99) {
      rnd = 0.005; // finally, increment it .5 %
    } else {
      rnd = 0; // after 99%, don't increment:
    }
    fakeProgress += rnd;
  }

  function setAllCheckboxesChecked() {
    if (service.data.checkboxes.length > 0) {
      service.data.allCheckboxesChecked = !service.data.checkboxes.some(function(checkbox) {
        return checkbox.value !== true;
      });
    } else {
      service.data.allCheckboxesChecked = false;
    }
  }

  /** UI ROUTER
   *
   *      If we are using ui-router, prevent
   *       redirects if there is a visible alert
   */
  if ($injector.has('$transitions') && $injector.has('$state') && $injector.has('ENV')) {
    var $transitions = $injector.get('$transitions');
    $transitions.onStart({}, function($transition) {
      // The transitions service has a bug; it sometimes triggers an event from and to the same page.
      if ($transition.from().name == $transition.to().name) {
        return;
      }
      // Don't transition when visible
      if (service.data.visible) {
        return false;
      }
    });
  }
}

var accAlertComponent = {
  controller: accAlertComponentController,
  templateUrl: '/shared/alert/alert.html',
};
accAlertComponentController.$inject = ['alertService', '$scope', '$element', '$injector'];
function accAlertComponentController(alertService, $scope, $element, $injector){
  var ctrl = this;
  ctrl.data = alertService.data;
  ctrl.data.$element = $element;
  ctrl.$onDestroy = onDestroy;

  // If required, manage the focus
  var modalIsolator = null;
  if ($injector.has('FocusManagerService')) {
    $scope.data = ctrl.data; // This is needed so that the ModalIsolator instance can watch $scope.data.visible
    var focusManagerService = $injector.get('FocusManagerService');
    modalIsolator = new focusManagerService.ModalIsolator($scope, $element); // To stop tabbing out of the modal
  }

  function onDestroy() {
    if (modalIsolator) {
      modalIsolator.cleanUp();
      modalIsolator = null;
    }
  }
}

angular
  .module('app')
  .service('alertService', alertService)
  .component('accAlert', accAlertComponent);

},{}],179:[function(require,module,exports){
/** SWEET ALERT SERVICE
 *
 *    @author   Ryan Booth
 */
angular
.module('app')
.factory('swalService', ['$timeout', '$window', '$filter', function($timeout, $window, $filter) {
  // SCROLL DOWN TO ADD / VIEW ALERT MESSAGES
  var swal = $window.swal;

  //so we can translate strings
  var translate = $filter('translate');

  // public methods
  var alertService = {
    showAlert: function(alertKey, errorCode) {
      alertHash[alertKey](errorCode);
    },
    confirm: function(message, callback, title, buttonText, buttonColor, cancelText, closeOnConfirm) {
      $timeout(function() {
        swal({
            title: title ? title : "Are you sure?",
            text: message,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: buttonColor ? buttonColor : "#37BDB1",
            cancelButtonText: cancelText ? cancelText : "Cancel",
            confirmButtonText: buttonText ? buttonText : "Confirm",
            closeOnConfirm: closeOnConfirm !== undefined ? closeOnConfirm : false
          },
          callback
        );
      });
      // See supportError for callback format
    },
    error: error,
  };

  // ACTION ALERTS
  function supportError(title, errorCode) {
    var message = translate('SUPPORT_ERROR_MESSAGE');
    if (errorCode) {
      message = message + "\n\n Error info: " + errorCode;
    }

    $timeout(function() {
      swal({
        title: title,
        text: message,
        type: 'error',
        showCancelButton: true,
        confirmButtonColor: "#37BDB1",
        confirmButtonText: translate('SUPPORT_ERROR_REFRESH'),
        cancelButtonText: translate('SUPPORT_ERROR_EMAIL_SUPPORT'),
        cancelButtonColor: "#d1d1d1",
        closeOnConfirm: true
      }, function(isConfirm) {
        if (isConfirm) {
          $window.location.reload();
        } else {
          $window.location = 'https://help.accredible.com/kb-tickets/new';
        }
      });
    });
  }

  function trigger(title, message, triggeredFunction) {
    $timeout(function() {
      swal({
        title: title,
        text: message,
        type: 'error',
        confirmButtonColor: "#37BDB1"
      }, triggeredFunction);
    });
  }

  // MESSAGE ALERTS
  function success(title, message) {
    $timeout(function() {
      swal({
        title: title,
        text: message,
        type: 'success',
        confirmButtonColor: "#37BDB1",
      });
    });
  }

  function error(title, message) {
    $timeout(function() {
      swal({
        title: title,
        text: message,
        type: 'error',
        allowOutsideClick: true
      });
    });
  }

  function warning(title, message) {
    $timeout(function() {
      swal(title, message, 'warning');
    });
  }

  function info(title, message) {
    $timeout(function() {
      swal(title, message, 'info');
    });
  }

  function genericAlert(title, message, type) {
    $timeout(function() {
      swal({
        title: title,
        text: message,
        type: type,
        confirmButtonColor: "#37BDB1"
      });
    });
  }

  //
  // Store alert messages here
  //
  var alertHash = {
    // Common Auth Errors
    authRequired: function(_) {
      error(
        translate('auth.not_signed_in_title'),
        translate('auth.not_signed_in_message')
      );
    },
    authForgottenPasswordEmailError: function(){
      error(
        translate('auth.forgotten_password_email_error_title'),
        translate('auth.forgotten_password_email_error_message')
      );
    },





    // next new error code is 012
    unknownFailure: function(errorCode) {
      supportError(
        translate('UNKNOWN_FAILURE_MESSAGE'),
        errorCode
      );
    },
    unauthorizedEditError: function(_) {
      error(
        translate('UNAUTHORIZED_HEADER'),
        translate('UNAUTHORIZED_MESSAGE')
      );
    },
    userMustLogin: function(_) {
      error(
        translate('USER_MUST_LOGIN_HEADER'),
        translate('USER_MUST_LOGIN_MESSAGE')
      );
    },
    registrationSuccess: function() {
      success(
        translate('REGISTRATION_ACCOUNT_CREATED'),
        translate('REGISTRATION_ACCOUNT_CREATED_MESSAGE')
      );
    },
    registrationError: function() {
      error(
        translate('REGISTRATION_FAILED')
      );
    },
    resendRegistrationSuccess: function() {
      success(
        translate('REGISTRATION_RESEND_TITLE'),
        translate('REGISTRATION_ACCOUNT_CREATED_MESSAGE')
      );
    },
    resendRegistrationError: function() {
      error(
        translate('REGISTRATION_RESEND_FAILED')
      );
    },
    signInError: function() {
      error(
        translate('LOGIN_FAILED'),
        translate('LOGIN_FAILED_MESSAGE')
      );
    },
    resetPasswordRequestError: function() {
      error(
        translate('PASSWORD_RESET_REQUEST_FAILED'),
        translate('PASSWORD_RESET_REQUEST_FAILED_MESSAGE')
      );
    },
    resetPasswordError: function() {
      error(
        translate('PASSWORD_RESET_FAILED'),
        translate('PASSWORD_RESET_FAILED_MESSAGE')
      );
    },
    /*
    signinFailure: function(_) {
      error(
        translate('CREDENTIAL_LOGIN_SIGN_IN_FAILED'),
        translate('CREDENTIAL_LOGIN_SIGN_IN_FAILED_CHECK_EMAIL')
      );
    },
    */
    credentialTokenFailure: function(_) {
      error(
        translate('CREDENTIAL_TOKEN_FAILURE_HEADER'),
        translate('CREDENTIAL_TOKEN_FAILURE_MESSAGE')
      );
    },
    // Evidence
    upsertEvidenceSuccess: function(errorCode) {
      success(
        translate('SUCCESS'),
        translate('UPSERT_EVIDENCE_SUCCESS_MESSAGE')
      );
    },
    upsertEvidenceFailure: function(errorCode) {
      supportError(
        translate('UPSERT_EVIDENCE_FAILURE_MESSAGE'),
        errorCode
      );
    },
    upsertEvidenceInvalid: function() {
      info(
        translate('UPSERT_EVIDENCE_FAILURE_INVALID_FILE_TYPE')
      );
    },
    deleteEvidenceFailure: function(errorCode) {
      supportError(
        translate('DELETE_EVIDENCE_FAILURE_MESSAGE'),
        errorCode
      );
    },
    deleteEvidenceSuccess: function(_) {
      success(
        translate('DELETE_EVIDENCE_SUCCESS_HEADER'),
        translate('DELETE_EVIDENCE_SUCCESS_MESSAGE')
      );
    },
    savePasswordSuccess: function(_) {
      success(
        translate('USER_SAVE_PASSWORD_SUCCESS_PASSWORD_SAVED'),
        translate('USER_SAVE_PASSWORD_SUCCESS_LOGIN_NEXT_TIME')
      );
    },
    savePasswordFailure: function(errorCode) {
      supportError(
        translate('SAVE_PASSWORD_FAILURE_MESSAGE'),
        errorCode
      );
    },
    shareEmailSuccess: function() {
      success(
        translate('EMAIL_SHARE_SUCCESS_TITLE'),
        translate('EMAIL_SHARE_SUCCESS_MESSAGE')
      );
    },
    contactSuccess: function(_) {
      genericAlert(
        "Thank you for your email",
        "We'll be in touch within 2 working days.",
        "success"
      );
    },
    contactFailure: function(_) {
      genericAlert(
        "Error with email",
        "Please check the form. If the problem persists, try support@accredible.com.",
        "error"
      );
    },
    signOutSuccess: function(_) {
      success(
        translate('SIGN_OUT_SUCCESS_MESSAGE'),
        ""
      );
    },
    resetEmailSuccess: function(_) {
      info(
        translate('RESET_EMAIL_SUCCESS_HEADER'),
        translate('RESET_EMAIL_SUCESS_MESSAGE')
      );
    },
    resetEmailFailure: function(_) {
      error(
        translate('RESET_EMAIL_FAILURE_HEADER'),
        translate('RESET_EMAIL_FAILURE_MESSAGE')
      );
    },
    resetPasswordSuccess: function(_) {
      success(
        translate('RESET_PASSWORD_SUCCESS_HEADER'),
        translate('RESET_PASSWORD_SUCCESS_MESSAGE')
      );
    },
    issuerResetTokenExpired: function(_) {
      error(
        "Please sign in",
        "You have been signed out for your security. Please sign in again."
      );
    },
    issuerResetTokenWrong: function(_) {
      error(
        "Token incorrect",
        "Sorry, but your reset password token is incorrect. Click below to request another token."
      );
    },
    issuerLoginFailure: function(_) {
      error(
        "Sign in failed",
        "Please check your email and password."
      );
    },
    issuerLoginThrottled: function(_) {
      error(
        "Too many incorrect sign in attempts",
        "Please try again in 1 minute."
      );
    },
    issuerSignUpFailure: function(errorCode) {
      error(
        "Error during sign up",
        "Details: \n" + errorCode
      );
    },
    issuerSignUpFailureEmailTaken: function() {
      error(
        "Email already used",
        "This email address is already connected to an account on Accredible."
      );
    },
    issuerPaymentFailure: function(errorCode) {
      error(
        "Error saving payment details",
        "Details: \n" + errorCode
      );
    },
    issuerMustLogin: function(_) {
      error(
        "Not signed in",
        "You may have been signed out for your security. Please sign in again."
      );
    },
    issuerCredentialsDeletedSuccess: function(numCredentials) {
      success(
        "Credentials deleted",
        (numCredentials || "The selected") + " Credentials were deleted."
      );
    },
    issuerCredentialsExpiredSuccess: function(numCredentials) {
      success(
        "Credentials expired",
        (numCredentials || "The selected") + " Credentials have been marked as expired."
      );
    },
    issuerPublishFailureCredits: function() {
      error(
        "Could not Publish Credentials",
        "This action takes you above your plan limit.\n\nGo to Billing to upgrade your plan."
      );
    },
    issuerPublishFailureGeneral: function(errorCode) {
      supportError(
        "Error publishing Credential",
        errorCode
      );
    },
    issuerPublishSuccess: function(publishResponse) {
      var title;
      var message;
      var published = publishResponse.published_count;
      var not_published = publishResponse.input_count - publishResponse.published_count;
      var sending_email = publishResponse.sending_email;
      // Published
      if (published == 1) {
        title = "Credential Published";
        message = "1 Credential has been published.";
      } else {
        title = "Credentials Published";
        message = published + " Credentials have been published.";
      }
      // Email sending is optional at an account level
      if (sending_email) {
        message += "\nAn email will be sent to the recipients now.";
      } else {
        message += "\nAn email will not be sent based on your settings.";
      }
      // Unpublished
      if (not_published == 1) {
        message += "\n\nPlease note that 1 Credential has not been published.";
      } else if (not_published > 1) {
        message += "\n\nPlease note that " + not_published + " Credentials have not been published.";
      }
      // And done
      success(
        title,
        message
      );
    },
    issuerSaveTeamMemberCreated: function() {
      success(
        "Team Member Created"
      );
    },
    issuerSaveTeamMemberSuccess: function() {
      success(
        "Team Member Updated"
      );
    },
    issuerSaveTeamMemberError: function(message) {
      error(
        "Could not save Team Member",
        message
      );
    },
    issuerDeleteTeamMemberError: function() {
      error(
        "Could not delete Team Member"
      );
    },
    issuerResendEmailSuccess: function() {
      success(
        "Invitation Email Re-sent"
      );
    },
    issuerResendEmailError: function() {
      success(
        "Could not re-send Invitation Email"
      );
    },
    issuerResendFailure: function(errorCode) {
      supportError(
        "Error sending emails",
        errorCode
      );
    },
    issuerResendSuccess: function(numCredentials) {
      success(
        "Credential email re-sent",
        (numCredentials || "The selected") + " Credential recipients will be getting an email soon."
      );
    },
    issuerSettingsSuccess: function(_) {
      success(
        "Account Updated",
        "Your account settings have been updated."
      );
    },
    issuerNameChangesSettingsSuccess: function(_) {
      success(
        "Settings Updated",
        "Your Name Change Requests Settings have been updated."
      );
    },
    issuerUploadProcessingError: function(_) {
      error(
        "Upload Failed",
        "There has been an issue processing your spreadsheet, our developers have been notified.\n\nYour CSV file has been saved to our system for analysis.",
        "success"
      );
    },
    issuerDeleteCredentialsFailure: function(errorCode) {
      supportError(
        "Error deleting Credentials",
        errorCode
      );
    },
    issuerExpireCredentialsFailure: function(errorCode) {
      supportError(
        "Error expiring Credentials",
        errorCode
      );
    },
    issuerDeleteEvidenceFailure: function(errorCode) {
      supportError(
        "Error deleting learner evidence",
        errorCode
      );
    },
    requestTimeout: function(_) {
      error(
        translate('REQUEST_TIMEOUT_HEADER'),
        translate('REQUEST_TIMEOUT_MESSAGE')
      );
    },
    issuerGetSSOLinkErrorTryLater: function() {
      error(
        "Could not retrieve Recipient Link at this time",
        "Please try again later"
      );
    },
    // Attributes
    upsertAttributeSuccess: function() {
      success(
        "Attribute saved successfully"
      );
    },
    upsertAttributeDuplicate: function() {
      error(
        "This attribute already exists."
      );
    },
    upsertAttributeFailure: function(message) {
      error(
        "Error saving attribute.",
        message
      );
    },
    deleteAttributeSuccess: function(_) {
      success(
        "Attribute deleted"
      );
    },
    deleteAttributeFailure: function(errorCode) {
      error(
        "Error deleting attribute",
        errorCode
      );
    },
    // Payments
    buyCreditsSuccess: function() {
      success(
        "Purchase successful",
        "Your recipient allowance has been updated."
      );
    },
    updateSubscriptionSuccess: function(_) {
      success(
        "Payment plan updated",
        "Your plan has been changed."
      );
    },
    updateSubscriptionError: function(err) {
      error(
        "Payment plan error",
        err
      );
    },
    updateCardSuccess: function(_) {
      success(
        "Payment details updated",
        "Your card has been saved for future purchases."
      );
    },
    updateCardError: function(err) {
      error(
        "Payment details were not updated",
        err
      );
    },
    createSubscriptionSuccess: function(_) {
      genericAlert(
        "Payment plan registered",
        "Thank you for setting up automatic payments! You can check your account status on this page at any time.",
        "success"
      );
    },
    paymentError: function(err) {
      error(
        "Payment Error",
        err
      );
    },
    subscriptionCancelled: function(_) {
      success(
        "Payment plan cancelled",
        "Your automatic payment plan has been cancelled. You will not be charged again."
      );
    },
    subscriptionCancelledError: function(errorCode) {
      supportError(
        "Error during cancellation",
        errorCode
      );
    },
    // Employment Directory
    employmentDirectorySavedSuccess: function() {
      success(
        "Settings saved successfully",
        "We will be in touch with you once we have reviewed your settings. It may take a few minutes for your changes to take effect."
      );
    },
    // Name change requests
    nameChangeApproveSuccess: function(){
      success(
        "Name Change Requests Approved"
      );
    },
    nameChangeApproveError: function(err){
      error(
        "Name Change Requests were not Approved",
        err
      );
    },
    nameChangeDenySuccess: function(){
      success(
        "Name Change Requests Denied"
      );
    },
    nameChangeDenyError: function(err){
      error(
        "Name Change Requests were not Denied",
        err
      );
    },


    verifySenderEmailSent: function(_) {
      success(
        "Verification email sent",
        "Please check your inbox and follow the instructions to verify your email address.\n\nOnce verified, your Accredible emails will be sent from this address."
      );
    },
    issuerBulkCSVDownloadSuccess: function(emailAddress) {
      success(
        "CSV Generating",
        "After a few minutes " + (emailAddress || "you") + " will receive an email with the CSV file for these Credentials."
      );
    },
    issuerVerificationEmailResent: function(_) {
      success(
        "Verification email resent",
        "Please check your email and follow the link to verify your email address."
      );
    },
    issuerVerificationEmailSuccess: function(_) {
      success(
        "Email Verified"
      );
    },
    issuerVerificationEmailFailure: function(_) {
      error(
        "Try Refreshing the page",
        "If you're not logged in automatically, click 'Resend verification email' to try again."
      );
    },
    cardUpdateSuccess: function(_) {
      genericAlert(
        "New Card Added",
        "Thank you. That card will be charged from now on.",
        "success"
      );
    },
    cardUpdateFailure: function(errorCode) {
      supportError(
        "Error saving card",
        errorCode
      );
    },
    emailAlreadyInUseError: function() {
      error(
        "Email Already in Use",
        "The email address you're trying to use is already in use on Accredible. Please use another email address."
      );
    },
    /*
    uploadImageFailure: function (errorCode) {
      error(
        "That file is not an image",
        errorCode
      );
    },
    employerEmailTaken: function(_) {
      error(
        "Email taken",
        "An account with that email already exists. Please login below if the account is yours."
      );
    },
    employerInvalidToken: function(_) {
      error(
        "Expired Login",
        "Please log back in to your employer account."
      );
    },
    loadMessagesFailure: function (errorCode) {
      supportError(
        "Error retrieving messages",
        errorCode
      );
    },
    sendMessageFailure: function(_) {
      error(
        "Error sending message",
        "Please try again, or copy your message and refresh the page."
      );
    },
    messageBlockedFailure: function(_) {
      error(
        "Messaging blocked",
        "Sorry, this user has blocked incoming messages."
      );
    },
    profileUserInvalidToken: function(_) {
      error(
        "Not Signed In",
        "Sign in to view your messages."
      );
    },
    profileUserNeedsLogin: function(_) {
      error(
        "Not Signed In",
        "Sign in to edit your profile."
      );
    },
    */
    // General / Utility
    formInvalid: function(_) {
      warning(
        translate('FORM_INVALID_PLEASE_CHECK_FORM'),
        translate('FORM_INVALID_REQUIRED')
      );
    },
    // Groups
    newGroupSuccess: function() {
      success(
        "New Group Created",
        "You must add a Certificate Design or Badge Design to the Group before adding Credentials."
      );
    },
    groupSaveSuccess: function() {
      success(
        "Group Saved"
      );
    },
    groupSaveSuccessNeedsDesign: function() {
      success(
        "Group Saved",
        "You must add a Certificate Design or Badge Design to the Group before adding Credentials."
      );
    },
    groupSaveFailure: function() {
      supportError(
        "Error saving Group"
      );
    },
    groupNameUpdateSuccess: function() {
      success(
        "Name updated"
      );
    },
    groupDuplicatesError: function() {
      error(
        " \"Allow Duplicates\" cannot be unchecked, there are already duplicates in the group"
      );
    },
    // Generalised Design Editor
    designDownloadFailure: function() {
      error(
        "Sorry, we could not generate your Badge Design"
      );
    },
    // Certificate Designs
    certificateDesignUpdateFailure: function(errorCode) {
      supportError(
        "Error Saving Certificate Design",
        errorCode
      );
    },
    certificateDesignNeedsNameError: function() {
      info(
        "Name your Certificate Design",
        "Your new Design needs a name, in order to find and edit it later."
      );
    },
    certificateDesignMobileDesignRemoved: function() {
      success(
        "Optional Mobile Design removed"
      );
    },
    certificateDesignNameUpdateSuccess: function() {
      success(
        "Name updated"
      );
    },
    certificateDesignMissing: function() {
      supportError(
        "Design missing",
        "The design you attempted to delete no longer exists."
      );
    },
    certificateDesignInUse: function() {
      error(
        "This design is still in use",
        "Please remove this design from the groups using it before deleting it."
      );
    },
    // Badge Designs
    badgeDesignUpdateSuccess: function() {
      success(
        "Badge Design Updated"
      );
    },
    badgeDesignUpdateFailure: function(errorCode) {
      supportError(
        "Error Saving Badge Design",
        errorCode
      );
    },
    badgeDesignNeedsNameError: function() {
      info(
        "Name your Badge Design",
        "Your new Design needs a name, in order to find and edit it later."
      );
    },
    badgeMakerUpdateFailure: function() {
      error(
        "Error Saving Badge Design"
      );
    },
    // Group :: Email Templates
    groupEmailUpdateSuccess: function() {
      success(
        "Email Templates Updated"
      );
    },
    duplicateIssuerUserFailure: function() {
      error(
        "Email already in use",
        "That email already has a dashboard account. They either exist within your organization already or within another organization. " +
        "Try using a different email or deleting the other account first."
      );
    },
    inviteIssuerUserSuccess: function() {
      success(
        "Invite sent",
        "They should receive the email in the next few minutes."
      );
    },
    inviteIssuerUserFailure: function() {
      supportError(
        "Error sending invite"
      );
    },
    issuerLoginDeleteSuccess: function() {
      success(
        "User Deleted"
      );
    },
    issuerLoginDeleteFailure: function() {
      supportError(
        "Error deleting user"
      );
    },
    issuerLoginAccountUpdateSuccess: function() {
      success(
        "Account Updated"
      );
    },
    issuerLoginAccountUpdateFailure: function() {
      supportError(
        "Error updating account"
      );
    },
    // User Permissions
    missingPermissions: function(errorCode) {
      error(
        "Access Denied",
        "You do not have permission to " + errorCode + ". Ask your administrator if you need this permission."
      );
    },
    // Permission Groups
    permissionGroupCreateSuccess: function() {
      success(
        "Permission Group Created"
      );
    },
    permissionGroupCreateFailure: function() {
      supportError(
        "Error creating Permission Group"
      );
    },
    permissionGroupDuplicateNameError: function() {
      error(
        "Duplicate name",
        "A Permission Group with that name already exists. Please change the name and try again."
      );
    },
    permissionGroupDeleteSuccess: function() {
      success(
        "Permission Group Deleted"
      );
    },
    permissionGroupDeleteFailure: function() {
      supportError(
        "Error deleting Permission Group"
      );
    },
    permissionGroupUpdateSuccess: function() {
      success(
        "Permission Group Saved"
      );
    },
    permissionGroupSaveFailure: function() {
      supportError(
        "Error saving Permission Group"
      );
    },
    // Send Preview
    sendPreviewSuccess: function(email) {
      success(
        "Example Credential Sent",
        "Check " + email + " for your example Credential."
      );
    },
    sendPreviewFailure: function() {
      error(
        "Error sending preview"
      );
    },
    editCredentialSuccess: function() {
      success(
        "Credential Updated"
      );
    },
    editCredentialInvalid: function(errorCode) {
      error(
        'Error saving Credential',
        errorCode
      );
    },
    editCredentialExpiryInvalid: function() {
      warning(
        'To update this credential\'s expiry date you must purchase more credits.'
      );
    },
    editCredentialGradeInvalid: function() {
      error(
        'Credential could not be updated',
        'The grade supplied must be a percentage (0 to 100).'
      );
    },
    editCredentialFailure: function() {
      supportError(
        "Error saving Credential"
      );
    },
    // Email Settings and Templates
    updateEmailSettingsSuccess: function() {
      success('Email Settings Saved');
    },
    updateEmailSettingsFailure: function() {
      error('Error Saving Email Settings');
    },
    upsertEmailTemplateSuccess: function() {
      success('Email Template Saved');
    },
    upsertEmailTemplateFailure: function() {
      error('Error Saving Email Template');
    },
    deleteEmailTemplateSuccess: function() {
      success('Email Template Deleted');
    },
    deleteEmailTemplateFailure: function() {
      error('Error Deleting Email Template');
    },
    resetEmailTemplateSuccess: function() {
      success('Email Template Reset');
    },
    resetEmailTemplateFailure: function() {
      error('Error Resetting Email Template');
    },
    previewEmailSentSuccess: function() {
      success('Email Preview Sent');
    },
    previewEmailSentFailure: function() {
      error('Error Sending Preview Email');
    },

    checkVerificationCodeError: function() {
      error(
        translate('CHECK_VERIFICATION_CODE_HEADER'),
        translate('CHECK_VERIFICATION_CODE_MESSAGE')
      );
    },
    checkVerificationCodeExpired: function() {
      error(
        translate('CHECK_VERIFICATION_CODE_EXPIRED_HEADER'),
        translate('CHECK_VERIFICATION_CODE_EXPIRED_MESSAGE')
      );
    },
    nameChangeSuccess: function() {
      success(
        translate('NAME_CHANGE_SUCCESS_HEADER'),
        translate('NAME_CHANGE_SUCCESS_MESSAGE')
      );
    },
    nameChangeRequestSuccess: function() {
      success(
        translate('NAME_CHANGE_REQUEST_SUCESS_HEADER'),
        translate('NAME_CHANGE_REQUEST_SUCESS_MESSAGE')
      );
    },
    nameChangeStillPending: function() {
      $timeout(function() {
        swal({
          title: translate('NAME_CHANGE_PENDING_TITLE'),
          text: translate('NAME_CHANGE_PENDING_TEXT'),
          type: 'info',
          showCancelButton: true,
          confirmButtonColor: "#37BDB1",
          confirmButtonText: translate('NAME_CHANGE_PENDING_OK'),
          cancelButtonText: translate('SUPPORT_ERROR_EMAIL_SUPPORT'),
          cancelButtonColor: "#d1d1d1",
          closeOnConfirm: true
        }, function(isConfirm) {
          if (isConfirm) {
            // do nothing
          } else {
            $window.location = 'http://help.accredible.com/hc/' + translate('HELP_CODE') + '/requests/new';
          }
        });
      });
    },
    nameChangeError: function(errorCode) {
      supportError(
        translate('ERROR_SENDING_NAME_CHANGE'),
        errorCode
      );
    },
    privacyChangeSuccess: function() {
      success(
        translate('PRIVACY_CHANGE_SUCCESS_HEADER'),
        translate('PRIVACY_CHANGE_SUCCESS_MESSAGE')
      );
    },
    privacyChangeError: function(errorCode) {
      supportError(
        translate('PRIVACY_CHANGE_ERROR_HEADER'),
        errorCode
      );
    },
    ssoEmailChange: function() {
      error(
        translate('SSO_EMAIL_CHANGE_ERROR_HEADER'),
        translate('SSO_EMAIL_CHANGE_ERROR_MESSAGE')
      );
    },
    errorSendingEmailChange: function(errorCode) {
      supportError(
        translate('ERROR_SENDING_NAME_CHANGE'),
        errorCode
      );
    },
    emailChangeSuccess: function() {
      success(
        translate('RECIPIENT_CHANGE_EMAIL_SUCCESS_HEADER'),
        translate('RECIPIENT_CHANGE_EMAIL_SUCCESS_MESSAGE')
      );
    },
    emailChangeCodeError: function() {
      error(
        translate('RECIPIENT_CHANGE_EMAIL_CODE_ERROR_HEADER'),
        translate('RECIPIENT_CHANGE_EMAIL_CODE_ERROR_MESSAGE')
      );
    },
    emailChangeCodeExpired: function() {
      error(
        translate('RECIPIENT_CHANGE_EMAIL_CODE_EXPIRED_HEADER'),
        translate('RECIPIENT_CHANGE_EMAIL_CODE_EXPIRED_MESSAGE')
      );
    },
    retrieveCertificatesSuccess: function() {
      success(
        translate('RETRIEVE_CERTIFICATES_SUCCESS_HEADER'),
        translate('RETRIEVE_CERTIFICATES_SUCCESS_MESSAGE')
      );
    },
    retrieveCertificatesEmailError: function() {
      error(
        translate('RETRIEVE_CERTIFICATES_EMAIL_ERROR_HEADER'),
        translate('RETRIEVE_CERTIFICATES_EMAIL_ERROR_MESSAGE')
      );
    },
    retrieveCertificatesError: function(errorCode) {
      supportError(
        translate('RETRIEVE_CERTIFICATES_ERROR_MESSAGE'),
        errorCode
      );
    },
    exportAnalyticsSuccess: function(email) {
      success(
        'Export successful',
        'An email will be sent to ' + email + ' with the file attached.'
      );
    },
    exportAnalyticsError: function(errorCode) {
      supportError(
        'Analytics export error',
        errorCode
      );
    },
    fileTooLargeError: function(size) {
      error(
        translate('FILE_TOO_LARGE'),
        translate('MAXIMUM_FILE_SIZE', {
          size: size
        })
      );
    },
    fileUploadError: function() {
      error(
        translate('FILE_UPLOAD_ERROR')
      );
    },
    urlRedirect: function(url) {
      $timeout(function() {
        swal({
          title: 'Login Failed',
          text: 'We could not log you in with those details, you can click OK return to: ' + url + '\n Only proceed if you trust the URL.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: "#37BDB1",
          confirmButtonText: 'Proceed',
          cancelButtonText: 'Cancel',
          cancelButtonColor: "#d1d1d1",
          closeOnConfirm: true
        }, function(isConfirm) {
          if (isConfirm) {
            // this URL is sanitized to avoid script injection.
            var sanitizedURL = $window.sanitizeUrl(url);
            $window.location = sanitizedURL;
          } else {
            // do nothing
          }
        });
      });
    },
    // API Keys and settings
    createApiKeySuccess: function() {
      success(
        'New API key created',
        'Your new API key is now ready to use.');
    },
    createApiKeyError: function() {
      error(
        'Error creating API key',
        'Please try again.'
      );
    },
    deleteApiKeySuccess: function() {
      success('API key Deleted');
    },
    deleteApiKeyError: function() {
      error(
        'Error deleting API key',
        'Please try again.'
      );
    },
    /*
    issuerSESEmailTaken: function( ) {
      error(
        "Email already used",
        "The email address you entered is already in use by another Accredible account."
      );
    },
    */
  };

  return alertService;
}]);

},{}],180:[function(require,module,exports){
function slideAnimation(){
  var duration = 300;
  return {
    // ng-view, ng-include, ng-switch, ng-if, ng-repeat
    enter: function(element, doneFn) {
      jQuery(element).hide().slideDown(duration, doneFn);
    },
    leave: function(element, doneFn) {
      jQuery(element).slideUp(duration, doneFn);
    },
    // ng-class (which includes: ng-show, ng-hide)
    addClass: function(element, classesToAdd, doneFn) {
      if(classesToAdd && classesToAdd.indexOf('ng-hide') !== -1){
        jQuery(element).slideUp(duration, doneFn);
      } else {
        doneFn();
      }
    },
    removeClass: function(element, classesToRemove, doneFn) {
      if(classesToRemove && classesToRemove.indexOf('ng-hide') !== -1){
        jQuery(element).hide().slideDown(duration, doneFn);
      } else {
        doneFn();
      }
    },
  };
}

function fadeAnimation(){
  var duration = 400;
  return {
    // ng-view, ng-include, ng-switch, ng-if, ng-repeat
    enter: function(element, doneFn) {
      jQuery(element).hide().fadeIn(duration, doneFn);
    },
    leave: function(element, doneFn) {
      jQuery(element).fadeOut(duration, doneFn);
    },
    // ng-class (which includes: ng-show, ng-hide)
    addClass: function(element, classesToAdd, doneFn) {
      if(classesToAdd && classesToAdd.indexOf('ng-hide') !== -1){
        jQuery(element).fadeOut(duration, doneFn);
      } else {
        doneFn();
      }
    },
    removeClass: function(element, classesToRemove, doneFn) {
      if(classesToRemove && classesToRemove.indexOf('ng-hide') !== -1){
        jQuery(element).hide().fadeIn(duration, doneFn);
      } else {
        doneFn();
      }
    },
  };
}

animationConfig.$inject = ['$animateProvider'];
function animationConfig($animateProvider){
  // Only animate elements with `animate` in the class, this gives us a performance boost:
  //   https://www.bennadel.com/blog/2935-enable-animations-explicitly-for-a-performance-boost-in-angularjs.htm
  $animateProvider.classNameFilter(/animate/i);
}

angular
  .module('app')
  .animation('.animate-slide', [slideAnimation])
  .animation('.animate-fade', [fadeAnimation])
  .config(animationConfig);

},{}],181:[function(require,module,exports){
/** ATTRIBUTE FILTERS
 *
 *    Utility filter that helps render attribute names,
 *     noting the following edge-case:
 *
 *        Default attributes have translated names (see `en.json` etc.)
 *        Custom attributes have user-defined names
 *
 *    @author   David "oodavid" King
 */
angular.module("app")
  // Returns the attribute name if available, or pipes the tag through the translation system
  .filter("attributeName", ["$filter", function($filter) {
    return function(attribute) {
      return attribute.name || $filter('translate')(attribute.tag);
    };
  }]);

},{}],182:[function(require,module,exports){
/** AUTO GROW - DIRECTIVE
 *
 *      Add this to a <textarea> to have the height automatically
 *       adjust to fit the contents.
 *
 *      DK Note - There are issues with the related CSS rules that
 *       adjust the padding, which can result in the content
 *       jumping around.
 *
 *      <textarea auto-grow></textarea>
 *
 *      @author   David "oodavid" King (comment only)
 *      @author   Ryan Booth
 */
autoGrowDirective.$inject = [];
function autoGrowDirective(){
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      element.on('keyup', function(event) {
        element.css('height', 'auto');
        element.css('height', (event.target.scrollHeight) + 'px');
      });
    },
  };
}

angular
  .module('app')
  .directive('autoGrow', autoGrowDirective);

},{}],183:[function(require,module,exports){
/** AVATAR - COMPONENT
 *
 *    Renders a consistent icon represening the user or brand
 *
 *          ███████████
 *        ██           ██
 *       █   ___  _  __  █
 *      █   |   \| |/ /   █
 *      █   | |) | ' <    █
 *      █   |___/|_|\_\   █
 *       █               █
 *        ██           ██
 *          ███████████
 *
 *    Usage
 *
 *      <avatar data="$ctrl.user"></avatar>
 *      <avatar data="$ctrl.brand" class="large"></avatar>
 *      <avatar data="$ctrl.brand" class="large" icon="fallbackiconclass"></avatar>
 *
 *    Where `data` contains an `image` or `name` property
 *
 *    @author   David "oodavid" King
 */

var avatarComponent = {
  controller: avatarComponentController,
  bindings: {
    data: '<',
    icon: '@?', // Fallback icon
  },
  template: '<span ng-if="$ctrl.bgimage" ng-style="{ \'background-image\': \'url(\'+$ctrl.bgimage+\')\' }" role="img" aria-label="{{ $ctrl.name || \'avatar\' }}" aria-hidden="{{ $ctrl.unknownUser }}">&nbsp;</span>\
             <span ng-if="!$ctrl.bgimage && $ctrl.icon" ng-style="{ \'background-color\': $ctrl.bgcolor }" role="img" aria-label="{{ $ctrl.name || \'avatar\' }}" aria-hidden="{{ $ctrl.unknownUser }}"><i class="{{ $ctrl.icon }}"></i></span>\
             <span ng-if="!$ctrl.bgimage && !$ctrl.icon" ng-style="{ \'background-color\': $ctrl.bgcolor }" role="img" aria-label="{{ $ctrl.name || \'avatar\' }}">{{ $ctrl.initials }}</span>',
};

function avatarComponentController() {
  var ctrl = this;
  ctrl.initials;
  ctrl.bgcolor;
  ctrl.bgimage;
  ctrl.name = '';
  ctrl.unknownUser = false;

  var previousData;
  ctrl.$doCheck = function() {
    if (!angular.equals(previousData, ctrl.data)) {
      parseData(ctrl.data);
      previousData = angular.copy(ctrl.data);
    } else if (ctrl.data == null) {
      ctrl.unknownUser = true;
      ctrl.bgimage = '/shared/avatar/unknown_user.png';
    }
  };
  function parseData(data) {
    if (data) {
      ctrl.initials = false;
      ctrl.bgcolor = false;
      ctrl.bgimage = data.image || data.img || data.logo || data.avatar || data.image_address || false;
      ctrl.initials = nameToInitials(data.name);
      ctrl.name = data.name;
    }
    if (!ctrl.bgimage) {
      if (ctrl.initials) {
        ctrl.bgcolor = nameToColor(data.name);
      } else {
        ctrl.unknownUser = true;
        ctrl.bgimage = '/shared/avatar/unknown_user.png';
      }
    }
  }
  function nameToColor(name) {
    if (name) {
      var num = 0;
      for (var n=0,nl=name.length; n<nl; n++) {
        num += name.charCodeAt(n);
      }
      var hue = num % 360; // Convert to a hue
      if (hue) {
        var hsl = 'hsl(' + hue + ', 50%, 50%)'; // Was 50%, 70%
        return hsl;
      }
    }
    return '#dddddd';
  }
  function nameToInitials(name) {
    if (name) {
      var initials = '';
      name = name.trim().split(/\s+/gi);
      name.forEach(function(tmp) {
        initials += tmp[0] || '';
      });
      if (initials) {
        return initials.substring(0, 2); // Max of 2 char
      }
    }
    return null;
  }
}

angular
  .module('app')
  .component('avatar', avatarComponent);

},{}],184:[function(require,module,exports){
/** BADGE COMPONENT
 *
 *    <badge design="design" size="400" use-bitmap="true" data="data"><badge>
 *
 *    size is optional - defaults to 100% width and height of containing element
 *    use-bitmap is optional - if present and 'true', the either the badge_image
 *    (if present in the data) or the rasterized_content_url (from the design)
 *    is rendered rather than the SVG
 *
 *    @author   Andrew Bateman
 */
var badgeComponent = {
  controller: badgeComponentController,
  bindings: {
    design: '<',
    size: '<?',
    useBitmap: '<?',
    data: '<?',
    showReady: '<?'
  },
  templateUrl: '/shared/badge/badge.html',
};

badgeComponentController.$inject = ['$sce', '$timeout', '$element', '$scope', 'svgProcessor', 'fontService', 'ENV'];
function badgeComponentController($sce, $timeout, $element, $scope, svgProcessor, fontService, ENV) {
  var ctrl = this;

  var imagesReady = false;
  var fontsReady = false;
  function reportReady() {
    if (ctrl.showReady && imagesReady && fontsReady) {
      $element.attr('ready', true);
    }
  }

  function scaleText() {
    $timeout(function () {
      // Adjust text nodes in the DOM
      var textNodes = $element.find('foreignObject');
      if (textNodes.length > 0) {
        var fontCheckCount = textNodes.length;
        textNodes.each(function() {
          var textNode = $(this);
          fontService.whenFontLoaded(textNode.css('font-family'), textNode.css('font-weight'), textNode.css('font-style') || 'normal', function() {
            if (svgProcessor.isValidForeignObject(textNode)) {
              $scope.$apply(function() {
                svgProcessor.shrinkTextBoxContentToFit(textNode);
                svgProcessor.verticalAlignTextBoxContent(textNode);
              });
            }
            fontCheckCount--;
            if (fontCheckCount === 0) {
              fontsReady = true;
              reportReady();
            }
          });
        });
      } else {
        fontsReady = true;
        reportReady();
      }
    });
  }

  function insertSVG() {
    // Don't bother if we're display the PNG
    if (!ctrl.useBitmap) {
      var xml = ctrl.design.svg;
      // If required, parallel load all the images in the SVG and record on the badge when they have all loaded
      // This is used to inform standalone.credential.net that the badge is ready
      if (ctrl.showReady) {
        // Find all the image URLs within the badge XML
        var regex = /(?:<image )(.*?)(xlink:href=")(.*?)(?=")/gi;
        var imageUrls = [];
        var url;
        // eslint-disable-next-line no-cond-assign
        while (url = regex.exec(xml)) {
          imageUrls.push(url[3]);
        }
        var imageCount = imageUrls.length;
        if (imageCount > 0) {
          var loadHandler = function(event) {
            event.target.removeEventListener('load', loadHandler, false);
            if (--imageCount === 0) {
              imagesReady = true;
              reportReady();
            }
          };
          imageUrls.forEach(function(src) {
            var img = new Image();
            img.addEventListener('load', loadHandler, false);
            img.src = src;
          });
        } else {
          imagesReady = true;
          reportReady();
        }
      }
      if (ctrl.data) {
        // Replace attributes with data if available
        xml = xml.replace(/\[([0-9a-z_]+)\.([0-9a-z_]+)\]/ig, function(match, parent, key) {
          // TODO: Deal with date substitutions
          if (parent === 'credential') {
            return ctrl.data[key] || ''; // Effectively hide attribute if no data available
          } else {
            var parentObj = ctrl.data[parent];
            if (parentObj) {
              return parentObj[key] || ''; // Effectively hide attribute if no data available
            }
          }
          return match; // Show attribute - shouldn't get here
        });
      }
      xml = svgProcessor.sanitize(xml, ctrl.data ? (ctrl.data.name || ctrl.data.course_name) : null);
      ctrl.badgeSVG = $sce.trustAsHtml(xml);
      scaleText();
    }
  }

  ctrl.$onInit = function() {
    // Only show bitmaps on IE or Edge as they don't support document.fonts which is used to detect when fonts have loaded
    if (!document.fonts) {
      ctrl.useBitmap = true;
    }
    ctrl.size = ctrl.size || '100%';
    // TODO: Make sure that all API calls that return credential data include the 'badge_image' field.
    // Currently, '/v1/user_wallet/get_all_public_credentials' does not, hence the need to construct the url.
    if (ctrl.data && ctrl.data.badge_image) {
      ctrl.badge_url = ctrl.data.badge_image;
    } else if (ctrl.data && ctrl.data.encoded_id) {
      ctrl.badge_url = 'https://pdf.ms.credential.net/badge/image?env=' + ENV.name + '&credential=' + ctrl.data.encoded_id;
    }
  };

  ctrl.$onChanges = function() {
    insertSVG();
  };
}

svgProcessor.$inject = ['fontService', '$sanitize'];
function svgProcessor(fontService, $sanitize) {
  var eventHandlers = [
    'onclick',
    'ondblclick',
    'onmousedown',
    'onmouseup',
    'onmouseover',
    'onmousemove',
    'onmouseout',
    'ondragstart',
    'ondrag',
    'ondragenter',
    'ondragleave',
    'ondragover',
    'ondrop',
    'ondragend',
    'onkeydown',
    'onkeypress',
    'onkeyup',
    'onload',
    'onunload',
    'onabort',
    'onerror',
    'onresize',
    'onscroll',
    'onselect',
    'onchange',
    'onsubmit',
    'onreset',
    'onfocus',
    'onblur',
    'ontouchstart',
    'ontouchmove',
    'ontouchleave',
    'ontouchend',
    'ontouchcancel'
  ];

  this.sanitize = function(svg, title) {
    var content = $('<div>').append($(svg));
    // Remove circular text guides
    var textPaths = content.find('text');
    var siblingPaths = textPaths.siblings('path');
    siblingPaths.remove();
    // Remove all script nodes
    content.find('script').remove();
    // Remove all event handlers
    eventHandlers.forEach(function(eventHandler) {
      content.find('[' + eventHandler + ']').removeAttr(eventHandler);
    });
    content.find('div, style').attr('aria-hidden', true); // Hide internal text and inject title for screen readers
    content.find('svg').first().attr('focusable', false); // To stop IE11 erroneously focussing on our SVG
    var html = content.html();
    if (title) {
      // Inject title for accessibility
      html = html.replace(/^<svg(.*?)>/, '<svg$1><title>' + $sanitize(title) + '</title>');
    }
    return html;
  };

  // Utility - trims quotation marks from a string
  function trimQuotemarks(str){
    return str.replace(/(^["'])|(["']$)/g, '');
  }

  function extractFont(element, svgFonts) {
    var fontFamily = trimQuotemarks(element.style.fontFamily);
    if (!svgFonts[fontFamily]) {
      svgFonts[fontFamily] = {};
    }
    var nearestWeight = fontService.getNearestWeight(fontFamily, element.style.fontWeight);
    var slug = nearestWeight + (element.style.fontStyle === 'italic' && fontService.hasItalicWeight(fontFamily, nearestWeight) ? 'i' : '');
    svgFonts[fontFamily][slug] = true;
  }

  // Ensures the SVG includes all the correct fonts - adapted from svgEditorFontComponentExportCallback in svg-editor-font.component.js
  this.insertFonts = function(svg) {
    // Compile a list of all fonts, weights and styles by looping through all <foreignObject> elements
    var svgFonts = {};
    var content = $('<div>').append($(svg));
    // Text div
    content.find('foreignObject').each(function() {
        extractFont(this, svgFonts);
    });
    // Text on path
    content.find('text').each(function() {
      extractFont(this.parentElement, svgFonts);
    });
    // Create the <style>
    var svgStyle = [];
    angular.forEach(svgFonts, function(fontVariants, fontName) {
      var fontVariantsArray = Object.keys(fontVariants);
      var getCssImportString = fontService.getCssImportString(fontName, fontVariantsArray);
      if (getCssImportString) {
        svgStyle.push(getCssImportString);
      }
    });
    // Make sure the @imports are first
    svgStyle = svgStyle.sort(function(a, b) {
      if (a.indexOf('@import') === 0 && b.indexOf('@import') === 0) {
        return 0;
      }
      if (a.indexOf('@import') === 0 && b.indexOf('@font-face') === 0) {
        return -1;
      }
      if (a.indexOf('@font-face') === 0 && b.indexOf('@import') === 0) {
        return 1;
      }
      if (a.indexOf('@font-face') === 0 && b.indexOf('@font-face') === 0) {
        return 0;
      }
    });
    // Update the <style>
    content.find('style').remove();
    if (svgStyle.length) {
      content.find('svg').prepend($('<style>\n' + svgStyle.join('\n') + '</style>'));
    }
    return content.html();
  };

  // Replace '<br>' with the XML correct '<br/>'
  this.xmlify = function(svg) {
    var regex = /<br\s*[\/]?>/gi;
    return svg.replace(regex, '<br/>');
  };

  this.isValidForeignObject = function(textNode) {
    // A foreignObject should...
    var children = textNode.children();
    // ... only contain one child element
    if (children.length !== 1) {
      console.error('Malformed Badge: foreignObject does not contain exactly one child element');
      return false;
    }
    // ... which should not contain any other foreignObjects
    var containedForeignObjectCount = children[0].querySelectorAll('foreignObject foreignobject').length;
    if (containedForeignObjectCount > 0) {
      console.error('Malformed Badge: foreignObject contains ' + containedForeignObjectCount + ' other foreignObject(s)');
      return false;
    }
    return true;
  };

  this.shrinkTextBoxContentToFit = function(textNode) {
    var adjusted = false;
    var shrinkToFit = textNode.attr('shrink-to-fit');
    var contentDiv = textNode.find('> div');
    contentDiv.css('font-size', ''); // Always remove any existing font size and re-apply it if necessary
    if (shrinkToFit === 'width' || shrinkToFit === 'height') {
      var lineCount;
      var maxHeight;
      if (shrinkToFit === 'width') {
        lineCount = contentDiv.find('div').length || 1; // Each div corresponds to a line
        maxHeight = parseInt(contentDiv.css('line-height')) * lineCount;
      } else {
        maxHeight = parseInt(textNode.attr('height'));
      }
      var fontSize = parseInt(textNode.css('font-size'));
      while (contentDiv.height() > maxHeight) {
        fontSize--;
        contentDiv.css('font-size', fontSize);
        if (shrinkToFit === 'width') { // When fitting to width, the height of the content div needs to match its current line height multiplied by the number of lines
          maxHeight = parseInt(contentDiv.css('line-height')) * lineCount;
        }
        adjusted = true;
      }
    }
    return adjusted;
  };

  this.verticalAlignTextBoxContent = function(textNode) {
    var adjusted = false;
    var verticalAlign = textNode.attr('vertical-align');
    var contentDiv = textNode.find('> div');
    contentDiv.css('padding-top', ''); // Always remove any top padding and re-apply it if necessary
    if (verticalAlign === 'middle' || verticalAlign === 'bottom') {
      var textHeight = textNode.find('> div').height();
      var nodeHeight = parseInt(textNode.attr('height'));
      var remainingHeight = nodeHeight - textHeight;
      if (remainingHeight > 0) {
        contentDiv.css('padding-top', (verticalAlign === 'middle' ? (remainingHeight / 2) : remainingHeight) + 'px' );
      }
      adjusted = true;
    }
    return adjusted;
  };
}

angular
  .module('app')
  .component('badge', badgeComponent)
  .service('svgProcessor', svgProcessor);

},{}],185:[function(require,module,exports){
/** BASIC FILTERS
 *
 *    These filters can be used for any number of common formatting
 *     requirements such as:
 *
 *        Highlighting search strings
 *        Getting permalink URL from a { credential } object
 *        Capitalizing strings
 *
 *    @author   David 'oodavid' King
 */
require('./_services/encode.service.js');

angular
  .module('app')
  // Returns a the URL for a Certificate PDF
  .filter('certficatePdfUrl', ['api', function(api) {
    return function(credential) {
      return api.getURL('/credential/generate_certificate_pdf?credential_id=' + credential.id + '&mode=pdf&key=' + credential.private_key);
    };
  }])
  // Returns a the URL for a Certificate PDF - at print quality
  .filter('certficatePdfPrintUrl', ['api', function(api) {
    return function(credential) {
      return api.getURL('/credential/generate_certificate_pdf?credential_id=' + credential.id + '&mode=print&key=' + credential.private_key);
    };
  }])
  // Returns a the URL for a Baked Badge Image
  .filter('bakedBadgeUrl', ['api', function(api) {
    return function(credential) {
      return api.getURL('/credential/generate_baked_badge?credential_id=' + credential.id + '&key=' + credential.private_key);
    };
  }])
  // Returns the URL for a Credential Recipient Page
  .filter('credentialRecipientUrl', ['ENV', function(ENV) {
    return function(credential) {
      if (credential.url && ENV.type === 'production') {
        return credential.url;
      } else {
        // var domain = 'https://www.credential.net/'; // Production environment
        // if (credential && credential.issuer && credential.issuer.whitelisted_domain) {
        //   domain = credential.issuer.whitelisted_domain; // Whitelabel URL takes precedence
        // } else if (ENV.name !== 'production') {
        //   domain = 'https://'+ENV.name+'.credential.net/'; // Test environment
        // }
        var domain;
        if (credential && credential.issuer && credential.issuer.whitelisted_domain) {
          domain = credential.issuer.whitelisted_domain; // Whitelabel URL takes precedence
        } else {
          domain = 'https://' + (ENV.prefix === '' ? 'www.' : ENV.prefix) + 'credential.net/'; // Domain is based on environment
        }
        var slug = (credential.uuid || credential.encoded_id || credential.id); // Always use the encoded_id, but fallback to the numerical id for belts and braces
        var key = credential.private ? '?key=' + credential.private_key : '';
        return domain + slug + key;
      }
    };
  }])
  // Returns the URL for a Verification Directory
  .filter('directoryUrl', ['ENV', function(ENV) {
    return function(username) {
      var domain = 'https://' + ENV.prefix + 'directory.credential.net/';
      return domain + username;
    };
  }])
  // Returns the URL for a Credential Embed Page
  .filter('credentialEmbedUrl', ['$filter', 'urlService', function($filter, urlService) {
    return function(credential) {
      // Grab the normal Recipient URL
      var recipientUrl = $filter('credentialRecipientUrl')(credential);
      // Prepend with '/embed'
      var link = urlService.parse(recipientUrl);
      // This little '/' dance is because IE parses URLs differently - do'h!
      recipientUrl = recipientUrl.replace(link.pathname, (link.pathname.indexOf('/') === 0 ? '/' : '') + 'embed' + (link.pathname.indexOf('/') !== 0 ? '/' : '') + link.pathname);
      return recipientUrl;
    };
  }])
  // Returns a human URL by stripping out the https://www. part
  .filter('humanUrl', function(){
    return function(string){
      if(string){
        return string.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '');
      }
    };
  })
  // Highlights search matches on a string
  .filter('highlight', ['encodeService', '$sce', function(encodeService, $sce) {
    return function(input, highlight) {
      if (input) {
        input = encodeService.encode(input);
        if (highlight) {
          highlight = encodeService.encode(highlight);
          // Clean the highlight string for regex use - http://stackoverflow.com/a/3561711/1122851
          var clean = highlight.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
          var regex = new RegExp('(' + clean + ')', 'gi');
          var result = input.replace(regex, '<mark>$1</mark>');
          return $sce.getTrustedHtml(result);
        }
        return $sce.getTrustedHtml(input);
      }
      return $sce.getTrustedHtml('');
    };
  }])
  // Capitalizes the first letter in a sentence - http://codepen.io/WinterJoey/pen/sfFaK
  .filter('capitalize', function() {
    return function(input) {
      return (!!input) ? input.replace(/([^\W_]+[^\s-]*) */g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1);
      }) : '';
    };
  })
  // Converts newline to break
  .filter('nl2br', ['encodeService', '$sce', function(encodeService, $sce) {
    return function(input) {
      if (input) {
        input = encodeService.encode(input); // Don't trust the input
        input = input.replace(/\n\r?/g, '<br />'); // Replace newlines with <br>
        return $sce.getTrustedHtml(input); // Trust our new <br> characters
      }
      return;
    };
  }])
  // Converts an object into an array. Useful for using an object with ng-repeat, sort and filter - https://github.com/petebacondarwin/angular-toArrayFilter/blob/master/toArrayFilter.js
  .filter('toArray', function() {
    return function(obj, addKey) {
      if (!angular.isObject(obj)) return obj;
      if (addKey === false) {
        return Object.keys(obj).map(function(key) {
          return obj[key];
        });
      } else {
        return Object.keys(obj).map(function(key) {
          var value = obj[key];
          return angular.isObject(value) ?
            Object.defineProperty(value, '$key', {
              enumerable: false,
              value: key
            }) : {
              $key: key,
              $value: value
            };
        });
      }
    };
  })
  // Trust the HTML, but strip unsafe content (injection etc)
  .filter('trustedHtml', ['$sce', function($sce) {
    return function(input) {
      return $sce.getTrustedHtml(input);
    };
  }])
  // Trust the resource
  .filter('trustedResource', ['$sce', function($sce) {
    return function(url) {
      return $sce.trustAsResourceUrl(url);
    };
  }])
  // Parses a date, in the given format
  .filter('parseDate', ['$filter', function($filter) {
    return function(dateString, inputFormat, outputFormat, invalidString) {
      if (dateString) {
        var day;
        var month;
        var year;
        var regex = /(\d+)\D+(\d+)\D+(\d+)/;
        var m = regex.exec(dateString);
        if (!m) {
          return invalidString || 'Invalid Format';
        }
        switch (inputFormat) {
          case 'DD/MM/YYYY':
            day = m[1];
            month = m[2];
            year = m[3];
            break;
          case 'MM/DD/YYYY':
            day = m[2];
            month = m[1];
            year = m[3];
            break;
          case 'YYYY/MM/DD':
            day = m[3];
            month = m[2];
            year = m[1];
            break;
        }
        if(year && year.length == 2){
          year = 20+year; // 18 = 2018
        }
        var date = new Date(+year, (+month - 1), +day, 12, 0, 0);
        if (date && date.getTime()) {
          return $filter('date')(date, (outputFormat || 'mediumDate'));
        } else {
          return invalidString || 'Invalid Format';
        }
      }
    };
  }])
  // Returns the recipient group page url for a given group
  .filter('groupPageLink', ['ENV', function (ENV) {
    return function (group) {
      var url = 'https://';
      url += (ENV.prefix === '' ? 'www.' : ENV.prefix);
      return url + 'credential.net/group/' + group.id;
    };
  }])
  // Replace spaces with underscores
  .filter('spacesToUnderscores', function () {
    return function (input) {
        return input.replace(/ /g, '_');
    };
  })
  // Replace underscores with spaces
  .filter('underscoresToSpaces', function () {
    return function (input) {
        return input.replace(/_/g, ' ');
    };
  })
  // Absolute (positive) value
  .filter('absolute', function() {
    return function(num) {
      return Math.abs(num);
    };
  })
  // Break on dot
  .filter('breakOnDot', function () {
    return function (input) {
        return input.replace(/\./g, '.<wbr>');
    };
  })
  // Replace all but last 4 characters with '*' cap length at 16 characters
  .filter('mask', function() {
  return function(input) {
    if (input.length > 16) {
      return input.replace(/[\w ](?=[\w ]{4})/g, '*').substring(input.length - 16);
    } else {
      return input.replace(/[\w ](?=[\w ]{4})/g, '*');
    }
  };
});

},{"./_services/encode.service.js":166}],186:[function(require,module,exports){
/** BUTTON COLOR DIRECTIVE
 *
 *    <button type="button" button-color palette="suggestedColors" ng-model="myColor" class="button small">&nbsp;</button>
 *
 *  Styling - _form.scss
 *
 *    @author   David "oodavid" King
 */
angular.module('app')
  .directive('buttonColor', ['$timeout', function($timeout) {
    var update = function(scope, element, color) {
      $timeout(function(){
        $(element).css('background-color', color.toHexString());
        if(scope.onColorMove){
          scope.onColorMove({
            $event: {
              color: color.toHexString(),
            }
          });
        }
      });
    };
    // The directive
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        ngModel: '=',
        palette: '<?',
        onColorMove: '&?',
      },
      link: function(scope, element, attrs, ngModelCtrl) {
        var destroyed = false;
        $(element).spectrum({
          color: '#000',
          showButtons: false,
          showInitial: true,
          // Allow manual input
          preferredFormat: 'hex',
          showInput: true,
          // Palette
          showPalette: false, // Don't show palette of selected colours
          showSelectionPalette: true,
          hideAfterPaletteSelect: true,
          // Events
          move: function(color) {
            update(scope, element, color);
          },
          change: function(color) {
            if (!destroyed) { // To prevent ngModelCtrl.$setViewValue being called after destroy
              update(scope, element, color);
              ngModelCtrl.$setViewValue(color.toHexString());
            }
          },
          beforeShow: function(color) {
            var value = ngModelCtrl.$viewValue || ngModelCtrl.$modelValue;
            $(element).spectrum('option', 'palette', scope.palette || []);
            $(element).spectrum('set', value);
          },
        });
        element.on('$destroy', function() {
          destroyed = true;
          $(element).spectrum('destroy');
        });
        $(element).on('dragstop.spectrum', function(e, color) {
          ngModelCtrl.$setViewValue(color.toHexString());
        });
        ngModelCtrl.$render = function() {
          $(element).css('background-color', ngModelCtrl.$viewValue);
        };
      },
    };
  }]);

},{}],187:[function(require,module,exports){
/** Cache Buster - DECORATOR
 *
 *      Modifies the way that $get loads templates by adding
 *       a cache-busting slug to the end of the URL
 *
 *          https://gist.github.com/ProLoser/6181026
 *
 *      Note! Be careful to blacklist any HTML template that uses
 *       an inline <script> template, ie:
 *
 *          <script type="text/ng-template" id="/tpl.html">
 *              Content of the template.
 *          </script>
 *
 *      @author   Alan Heppenstall
 *      @author   David "oodavid" King
 */
(function() {
  angular
    .module('app')
    .config(['$provide', function($provide) {
      return $provide.decorator('$http', ['$delegate', 'ENV', function($delegate, ENV) {
        var slug = (ENV.type === 'production') ? ENV.cachebust : Date.now();
        var get = $delegate.get;
        $delegate.get = function(url, config) {
          // All .html files, ...but not bootstrap templates (a slug breaks them)
          // if (ENV.name !== 'karma' && url.indexOf('.html') !== -1 && url.indexOf('template/') === -1 && url.indexOf('directive.html') === -1) {
          //   url += (url.indexOf('?') === -1 ? '?v=' : '&v=') + slug;
          // }
          if (url.indexOf('.html') !== -1 && url.indexOf('template/') === -1 && url.indexOf('directive.html') === -1) {
            url += (url.indexOf('?') === -1 ? '?v=' : '&v=') + slug;
          }
          return get(url, config);
        };
        return $delegate;
      }]);
    }]);
})();

},{}],188:[function(require,module,exports){
/** CERTIFICATE EDITOR DIRECTIVE
 *
 *  In your view
 *     <certificate-editor></certificate-editor>
 *
 */


// This SHOULD be better
// This is a quick refactor and didn't want to spend time updating $scope to $ctrl
// Sorry.
require('./directives/autoRemoveAttributesDirective.js');
require('./directives/certificateScaleTextDirective.js');
require('./directives/draggableDirective.js');
require('./directives/resizableDirective.js');

// Preload the template so we don't get any delay
certificateEditorDirectivePreload.$inject = ['$templateCache', '$http'];
function certificateEditorDirectivePreload($templateCache, $http){
  $http.get('/shared/certificate-editor/certificate-editor.html', { cache: $templateCache });
}

// Component
certificateEditorDirective.$inject = [];
function certificateEditorDirective() {
  return {
    restrict: 'E', // Element only
    templateUrl: '/shared/certificate-editor/certificate-editor.html',
    controller: certificateEditorComponentController,
    scope: {
      design: '<',
      onClose: '&'
    }
  };
}
// ...original controller (largely unchanged)
certificateEditorComponentController.$inject = ['$scope', '$timeout', '$window', '$q', '$element', 'CertificateService', 'swalService', 'AnalyticsService', 'fontService', '$uibModal', 'HistoryFactory', 'certificateDimensions', '_', 'attributeService', 'languageService'];
function certificateEditorComponentController($scope, $timeout, $window, $q, $element, CertificateService, swalService, AnalyticsService, fontService, $uibModal, HistoryFactory, certificateDimensions, _, attributeService, languageService) {

  // This is used to allow errorless external embedding
  $scope.authorized = !!(localStorage.getItem('authorization'));

  // Push a dummy state to represent the editor pop-up in the browser history
  $window.history.pushState({ editor: true }, 'Certificate Editor');
  // When that state is popped, run the editor close functionality
  $window.onpopstate = function() {
    var closed = $scope.doClose();
    if (!closed) {
      $window.history.pushState({ editor: true }, 'Certificate Editor'); // Put the dummy state back
    }
  };

  $scope.inputRadiosOptions = [
    { value: 'us-letter', title: 'US-Letter' },
    { value: 'a4', title: 'A4' },
    { value: 'a8', title: 'A8', dataCy: 'a8' }
  ];

  // $scope.design - see Directive scope
  var savedDesign = $scope.design.id ? $scope.design : null; // This gets updated when we save, meaning we can respond with the actual design, when closing
  $scope.isDefault = !$scope.design.id; // Flag dictating whether we're editing a NEW design. Not sure what this does actually.
  $scope.sharedData = {
    selectedBlock: false, // Pointer to the currently active block
    isEditing: false, // Are we editing the selected block?
  };

  $scope.certificateElement = document.querySelector('.certificate-editable');
  // Selected block is handled with this variable to show pixels in the UI but send % to the BE when necessary (text blocks)
  $scope.selectedBlock = {
    element: null,
    isTextBlock: false,
    height : 0,
    width: 0,
    minHeight: 1,
    minWidth: 1,
  };

  $scope.checkTextBlockSize = function(block) {
    if (!block.image_height) {
      $scope.selectedBlock.height = null;
    }
  };

  // The default font
  var defaultColor = '#000000';
  var defaultFont = 'Source Sans Pro';
  var defaultFontWeight = 400;

  // Languages
  $scope.languagesOptions = getLanguagesOptions(Object.values(languageService.getLanguages()));

  /** PARSE DESIGN FROM BACKEND
   *
   *      In order to simplify the "stack" order of the designs
   *       we've decided to no-longer use z-index, but rely on
   *       natural DOM order. This solves a number of problems
   *       that are rather subtle, but thoroughly annoying.
   *
   *      Anyhow, we pre-parse the design to "apply" any z-index
   *       values, how do we do this?
   *          blocks: [
   *              { id: 1, z_index: null },
   *              { id: 2, z_index: null },
   *              { id: 3, z_index: 5 },
   *              { id: 4, z_index: 2 },
   *              { id: 5, z_index: null },
   *              { id: 6, z_index: 0 },
   *              { id: 7, z_index: -3 },
   *              { id: 8, z_index: -3 },
   *              { id: 9, z_index: -3 },
   *          ]
   *      Must become
   *          blocks: [
   *              { id: 1, z_index: null },
   *              { id: 2, z_index: null },
   *              { id: 5, z_index: null },
   *              { id: 7, z_index: -3 },
   *              { id: 8, z_index: -3 },
   *              { id: 9, z_index: -3 },
   *              { id: 6, z_index: 0 },
   *              { id: 4, z_index: 2 },
   *              { id: 3, z_index: 5 },
   *          ]
   *
   *      We also remove any `mobile` blocks
   *
   *      We also need to make sure that all blocks have a font
   *       default value, do that now.
   */
  var parseDesignFromBackend = function() {
    $scope.design.blocks.sort(function(a, b) {
      // Z-Indexes (even with zero, or negative values) must bubble to the top
      var zA = a.hasOwnProperty('z_index') ? a.z_index : false;
      var zB = b.hasOwnProperty('z_index') ? b.z_index : false;
      if (zA !== false || zB !== false && zA != zB) {
        return zA - zB;
      }
      // Otherwise, use id-order
      return a.id - b.id;
    });
    // Used colors
    var colors = {};
    // Remove all `mobile` blocks
    _.remove($scope.design.blocks, { mobile: true });
    $scope.hasQRCode = false;
    // Loop
    for (var b = 0, bl = $scope.design.blocks.length; b < bl; b++) {
      $scope.design.blocks[b]['block_index'] = b;
      var block = $scope.design.blocks[b];
      // Remove the redundant `z-index` and `mobile` values
      delete block.z_index;
      // Apply the default font and font_weight if needed
      if (block.hasOwnProperty('model')) {
        block.font = block.font || defaultFont;
        block.color = block.color || defaultColor;
        var weight = block.font_weight || (block.bold ? 700 : defaultFontWeight);
        block.font_weight = fontService.getNearestWeight(block.font, weight);
        if (!block.image_width){
          block.image_width = (100-(parseFloat(block.left || 0)))+'%';
          delete block.align;
        }
      }
      if (block.qr_code) {
        $scope.hasQRCode = true;
      }
      // Store the color
      colors[block.color] = true;
    }
    // Update the color picker to use these colors
    localStorage.setItem('spectrum.acms', Object.keys(colors).join(',')); // See: inputColorDirective
  };
  parseDesignFromBackend();

  // This is the opposite
  var getDesignPayload = function() {
    // Don't pollute local variables
    var design = angular.copy($scope.design);
    // Loop
    var z = 1;
    angular.forEach(design.blocks, function(block) {
      // Apply z_index values
      //  eventually the BE will not save blocks as seperate objects
      //  and will simply store the entire design as a JSON object, which
      //  will render the need for z_index completely redundant.
      block.z_index = z;
      z++;
    });
    // Return the clean design
    return design;
  };

  // This tracks the user's bleed preference, and starts unset
  var bleedState = null;

  /** HISTORY
   *
   *    Track the design object, and the "state" object
   *
   *    This is closely related to the "unsaved changes"
   *     logic, when triggering undo and redo, we want to:
   *
   *    @author David "oodavid" King
   */
  var History = new HistoryFactory($scope.design, $scope.sharedData);
  $scope.canUndo = History.canUndo;
  $scope.canRedo = History.canRedo;
  function doAction(action) {
    action();
    repairSelectedBlockPointer();
    checkDesktopBackgroundSize(true, true);
    // Reinstate historical bleed state
    bleedState = $scope.design.background_bleeds;
    // Check for QR code
    $scope.hasQRCode = false;
    for (var i = $scope.design.blocks.length - 1; i >= 0; i--) {
      if ($scope.design.blocks[i].qr_code) {
        $scope.hasQRCode = true;
        break;
      }
    }
  }
  $scope.undoAction = function() {
    doAction(History.undo);
  };
  $scope.redoAction = function() {
    doAction(History.redo);
  };
  $scope.pushState = function() {
    History.save(); // Saves the current state to the history object
  };

  /** SAVE
   *
   *    The save function still needs refactoring, it's messy
   *     (and elsewhere), however we need a canSave method.
   *
   *    @author David "oodavid" King
   */
  var saveTime = History.timestamp; // The timestamp for the edit that we have saved (see the save routine for this)
  $scope.canSave = function() {
    return History.timestamp != saveTime;  // If the time that we saved is different to the current History
  };

  /** UNSAVED CHANGES
   *
   *    This (small) hack was to replace the broken unsaved-changes
   *     logic with a fully functional, tested and de-coupled
   *     custom Directive named unsaved-changes.
   *
   *    Take a peek at design_editor.html to see that we have
   *     created a (hidden) form, that registers to the scope as
   *     formCtrl. We access that form controller here and set
   *     the $dirty or $pristine property on the form by watching
   *     the $scope.canSave() method above.
   *
   *    If this returns true, then we make the form $dirty, which
   *     by virtue of our custom unsaved-changes Directive
   *     deals with the blocking confirm / modal.
   *
   *    @author David "oodavid" King
   */
  $scope.formBuster = {}; // A MEGA hacky way of gaining access to the form controller. Have mercy
  $scope.$watch($scope.canSave, function(newVal) {
    // Make sure the formCtrl has registered to the scope
    if ($scope.formBuster && $scope.formBuster.formCtrl) {
      // If it's truthy, make the form $dirty
      if (newVal) {
        $scope.formBuster.formCtrl.$setDirty();
      } else {
        $scope.formBuster.formCtrl.$setPristine();
      }
    }
  });

  function tidyUpHistoryState() {
    // Remove the dummy state if it's still there
    if ($window.history.state && $window.history.state.editor) {
      $window.onpopstate = null;
      $window.history.back();
    }
  }

  // When we click "close", review the unsaved changes
  $scope.doClose = function(){
    // Make sure the formCtrl has registered to the scope
    if ($scope.formBuster && $scope.formBuster.formCtrl) {
      var formScope = angular.element($scope.formBuster.formCtrl.$$element[0]).scope();
      var canClose = formScope.unsavedChangesCanClose();
      if (canClose) {
        var expressionHandler = $scope.onClose();
        expressionHandler($scope.design); // Manually trigger the function passing $scope.design as the only argument
        tidyUpHistoryState();
        return true;
      }
      return false;
    }
    tidyUpHistoryState();
    return true;
  };

  var replaceDesign = function(design, dontSaveChanges) { // dontSaveChanges is used here to allow the bleed setting to be deferred to checkDesktopBackgroundSize
    if (!$scope.design.id && design.id){
      $scope.design.id = design.id;
    }
    $scope.design.size = design.size;
    $scope.design.orientation = design.orientation;
    if (!dontSaveChanges) {
      $scope.design.background_bleeds = design.background_bleeds;
    }
    $scope.design.background = design.background;
    $scope.design.blocks = design.blocks;
    $scope.design.custom_attributes = design.custom_attributes;
    parseDesignFromBackend();
    if (!dontSaveChanges) {
      $scope.pushState();
    }
    $scope.isDefault = false;
  };

  /** SIDEBAR HANDLING
   *
   *    @author Andrew Bateman
   */

  // Start with existing designs visible
  $scope.currentTab = $scope.authorized ? 'myDesigns' : 'document';
  $scope.showSummary = true;
  $scope.showSidebarMain = true;

  $scope.activateTab = function(tab) {
    $scope.currentTab = tab;
    $scope.showSummary = true;
    $timeout(function() {
      $scope.showSidebarMain = true;
    });
  };

  $scope.sidebarColumns = 2;
  $scope.columnSwitching = false;
  $scope.displayColumns = function(count) {
    if (count !== $scope.sidebarColumns) {
      $scope.columnSwitching = true;
      $scope.sidebarColumns = count;
      $timeout(function() {
        $scope.columnSwitching = false;
      });
    }
  };

  function setLanguageDescription(designs) {
    return designs.map(function(design) {
      var language = languageService.getLanguageFromCodeNoDefault(design.language);
      if(language) {
        design.languageDescription = language.description;
      }
      return design;
    });
  }

  function getLanguagesOptions(languages) {
    var options = [];
    languages.forEach(function (language){
        language.languageDescription = getLanguageFullDescription(language);
        options.push(language);
    });

    return options.sort( function(lang1, lang2) {
      return lang1.languageDescription > lang2.languageDescription ? 1 : -1; });
  }
  function getLanguageFullDescription(language) {
    return language.description.concat(language.value !== 'en' && language.value !== 'en-gb' ? ' - ' + language.name : '');
  }

  function categorizeDesigns(designs) {
    var categorizedDesigns = {
      'total': designs.length,
      'a4': {
        landscape: [],
        portrait: []
      },
      'a8': {
        landscape: [],
        portrait: []
      },
      'us-letter': {
        landscape: [],
        portrait: []
      }
    };
    designs.forEach(function(design) {
      categorizedDesigns[design.size][design.orientation].push(design);
    });
    return categorizedDesigns;
  }

  $scope.existingDesigns = {};
  $scope.templateDesigns = {};

  $scope.displayPageSize = 10;
  function loadDesigns(designs, showTemplates) {
    designs.loading = true;
    return CertificateService
      .getDesigns({
        page_size: 1000, // Get all designs
        page: '',
        design_identifier: '', // Fulltext search
        kind: 'certificate' // Only show certificate designs
      }, showTemplates)
      .then(function (response) {
        designs.loading = false;
        response.designs = setLanguageDescription(response.designs);
        designs.designs = categorizeDesigns(response.designs);
        if (showTemplates) {
          designs.attributes = ['a4', 'a8', 'us-letter', 'landscape', 'portrait'];
        } else {
          designs.metadata = response.meta;
        }
      });
  }

  $scope.designInfo = function(design) {
    return design.name;
  };

  function selectDesigns(size, orientation, designs) {
    var filteredDesigns = designs.designs[size][orientation];
    designs.current_page = 1;
    designs.total_pages = Math.ceil(filteredDesigns.length / $scope.displayPageSize);
    designs.size = size;
    designs.orientation = orientation;
    $scope.showSummary = false;
    return filteredDesigns;
  }

  $scope.selectTemplates = function(size, orientation) {
    $scope.filteredTemplateDesigns = selectDesigns(size, orientation, $scope.templateDesigns);
    $scope.selectTemplatePage(1);
  };

  $scope.selectExistingDesigns = function(size, orientation) {
    $scope.filteredExistingDesigns = selectDesigns(size, orientation, $scope.existingDesigns);
  };

  $scope.selectExistingPage = function(pageNumber) {
    $scope.existingDesigns.current_page = pageNumber;
    $scope.existingDesignsFrom = (pageNumber - 1) * $scope.displayPageSize;
  };

  if ($scope.authorized) {
    $q.all([loadDesigns($scope.existingDesigns, false), loadDesigns($scope.templateDesigns, true)])
      .then(function(){
        if ($scope.existingDesigns.designs.total === 0) {
          $scope.currentTab = 'templates';
          $scope.showSummary = true;
        }
      });
  }

  $scope.selectTemplatePage = function(pageNumber) {
    $scope.templateDesigns.current_page = pageNumber;
    $scope.templateDesignsFrom = (pageNumber - 1) * $scope.displayPageSize;
  };

  $scope.selectDesign = function(design) {
    var copiedDesign = angular.copy(design);
    delete copiedDesign.id;
    replaceDesign(copiedDesign, true); // true is used here to defer setting the bleed to checkDesktopBackgroundSize
    checkDesktopBackgroundSize();
  };
  //

  /** BLOCK SELECTION & EDITING
   *
   *    Deals with the currently selected block, and whether
   *     we're editing the selected block.
   *
   *    If these methods are triggered with an $event, we assume
   *     the user has clicked the UI; we then save the change to
   *     the History object for undo/redo and stop propagation.
   *
   *    @author David "oodavid" King
   */

  // Deselect all blocks
  $scope.deselectBlock = function($event) {
    // Remove dimensions info from all blocks
    $scope.certificateElement.querySelectorAll("div[class*='certificate-block']").forEach(function(element) {
      element.querySelector('.resize-dimensions').innerText = '';
    });
    if ($scope.selectedBlock.element) {
      //Stop to observe element for resizing action.
      resizeObserver.unobserve($scope.selectedBlock.element);
      $scope.selectedBlock.element = null;
    }

    // Do the deselect
    if ($scope.sharedData.selectedBlock) {
      $scope.sharedData.selectedBlock.selected = false;
      $scope.sharedData.selectedBlock.edit = false;
      // If this came from a user event, don't propagate
      if ($event && $event.stopImmediatePropagation){
        $event.stopImmediatePropagation();
      }
    }
    $scope.sharedData.selectedBlock = null;
    $scope.sharedData.isEditing = false;
    return false;
  };

  /**
   * When adding a block and trying to call this method right after, a timeout is needed because when doing $scope.selectedBlock.element = document.querySelector....
   * we need to wait for this element to be drawn in the DOM
   */
  $scope.selectBlock = function(block, $event) {
    // If the block is different...
    if (block !== $scope.sharedData.selectedBlock) {
      $scope.deselectBlock();
      $scope.selectedBlock.element = document.querySelector('.block-index-'+ block.block_index);
      $scope.selectedBlock.isTextBlock = !!block.font;
      $scope.sharedData.selectedBlock = block;
      $scope.sharedData.selectedBlock.selected = true;

      if ($event && $event.currentTarget) {
        if ($scope.selectedBlock.isTextBlock) {
          $scope.selectedBlock.width = $event.currentTarget.offsetWidth;
          $scope.selectedBlock.height = $event.currentTarget.offsetHeight;
        }
      }
      updateAvailableFontWeights();

      // If this came from a user event...
      if ($event) {
        $scope.pushState(); // Save the history so that the user can "undo" the selection change
      }
    }

    // If this came from a user event...
    if ($event && $event.stopImmediatePropagation) {
      $event.stopImmediatePropagation(); // Don't propagate
    }

    // Start to observe if the element is resized
    resizeObserver.observe($scope.selectedBlock.element);
  };

  // This observer will trigger when the observable element is resized
  var resizeObserver = new ResizeObserver(function() {
    $scope.$apply(function() {
      showDimensions($scope.selectedBlock.element, false);
    });
  });

  var showDimensions = function(element, isTextBlock) {
    if (isTextBlock) {
      element.querySelector('.resize-dimensions').innerText = $scope.selectedBlock.width + ' x ' + ($scope.selectedBlock.height || $scope.selectedBlock.minHeight);
    } else {
      element.querySelector('.resize-dimensions').innerText = element.offsetWidth + ' x ' + element.offsetHeight;
    }
  };

  // Turns on "isEditing"
  $scope.editBlock = function(block, $event) {
    $scope.selectBlock(block);
    if (!block.custom_image_attribute) {
      $scope.sharedData.isEditing = true;
      $scope.sharedData.selectedBlock.edit = true;
    }
    // If this came from a user event...
    if ($event && $event.stopImmediatePropagation) {
      $event.stopImmediatePropagation(); // Don't propagate
    }
    return false;
  };

  // Clones a block, selects it
  $scope.cloneAndSelectBlock = function(block, $event) {
    var clone = $scope.cloneBlock(block);
    // Select and return the block
    $timeout(function () {
      $scope.selectBlock(clone);
    });
    // If this came from a user event...
    if ($event && $event.stopImmediatePropagation) {
      $event.stopImmediatePropagation(); // Don't propagate
    }
    return false;
  };

  // When the History restores the "state" object, `selectedBlock` becomes an invalid reference, this manually repairs it
  var repairSelectedBlockPointer = function() {
    if ($scope.sharedData.selectedBlock) {
      var block = _.find($scope.design.blocks, function(block) {
        return angular.equals(block, $scope.sharedData.selectedBlock);
      });
      $scope.selectBlock(block);
    } else {
      $scope.deselectBlock();
    }
  };

  // Tells us if a particular block has a date attribute present
  $scope.blockHasDateAttribute = function(block) {
    if ($scope.sharedData.selectedBlock && ($scope.sharedData.selectedBlock.hasOwnProperty('model'))) {
      var attributes = attributeService.tagsToAttributes(block.model);
      for (var i = attributes.length - 1; i >= 0; i--) {
        if (attributes[i].type == 'date') {
          return true;
        }
      }
      return false;
    }
  };

  /** BLOCK UTILITES
   *
   *    These utility functions can be used by the block actions,
   *     or other parts of the controller. They do NOT add the
   *     change to the History object, it expects the consumer
   *     function to deal with that.
   *
   *    @author David "oodavid" King
   */
  // Returns the index of the previous block
  var getPrevIndex = function(block) {
    var i = $scope.design.blocks.indexOf(block);
    for (var b = (i - 1); b >= 0; b--) {
      return b;
    }
    return -1;
  };

  // Returns the index of the next block
  var getNextIndex = function(block) {
    var i = $scope.design.blocks.indexOf(block);
    for (var b = (i + 1), bl = $scope.design.blocks.length; b < bl; b++) {
      return b;
    }
    return -1;
  };

  /** BLOCK ACTIONS
   *
   *    These are the main actions that can be applied to blocks
   *     triggering them adds the change to the History object.
   *
   *    @author David "oodavid" King
   *    @author Jake Ford
   *    @author Ryan Booth
   */

  var rememberedScaling;
  function recycleScaling(block) {
    rememberedScaling = block.scale_to_fit;
    block.scale_to_fit = null;
    $timeout(function() {
      block.scale_to_fit = rememberedScaling;
      rememberedScaling = null;
    });
  }

  $scope.selectFont = function(newFont) {
    $scope.sharedData.selectedBlock.font = newFont.name;
    fontService.loadDesignFonts($scope.design);
    $scope.sharedData.selectedBlock.font_weight = fontService.getNearestWeight(newFont.name, $scope.sharedData.selectedBlock.font_weight);
    updateAvailableFontWeights();
    recycleScaling($scope.sharedData.selectedBlock);
    $scope.pushState();
  };

  $scope.changeWeight = function(block) {
    if (block) {
      // The change of block.font_weight is handled by the UI dropdown
      recycleScaling(block);
      $scope.pushState();
    }
  };

  $scope.italicize = function(block) {
    if (block) {
      block.italic = !block.italic;
      recycleScaling(block);
      $scope.pushState();
    }
  };

  $scope.underline = function(block) {
    if (block) {
      block.underline = !block.underline;
      recycleScaling(block);
      $scope.pushState();
    }
  };

  $scope.align = function(block, align) {
    if (block) {
      block.align = align;
      recycleScaling(block);
      $scope.pushState();
    }
  };

  $scope.verticalAlign = function(block, align) {
    if (block) {
      block.vertical_align = align;
      recycleScaling(block);
      $scope.pushState();
    }
  };

  $scope.toggleUppercase = function(block) {
    if (block) {
      block.uppercase = !block.uppercase;
      recycleScaling(block);
      $scope.pushState();
    }
  };

  $scope.startingChangeFontSize = function(block) {
    if (block) {
      rememberedScaling = block.scale_to_fit;
      block.scale_to_fit = null;
    }
  };

  $scope.stoppingChangeFontSize = function(block) {
    if (block) {
      block.scale_to_fit = rememberedScaling;
      rememberedScaling = null;
      $scope.pushState();
    }
  };

  $scope.toggledScaling = function(block) {
    if (block) {
      // The checkbox handles the toggling of block.scale_to_fit
      $scope.pushState();
    } else {
      // Undo the toggle - this should never be called
      block.scale_to_fit = !block.scale_to_fit;
    }
  };

  $scope.toggledAutoResize = function(block) {
    var element = $scope.selectedBlock.element;
    var parentElement = element.parentElement;
    var fivePctInPixelsWidth = Math.round(5 * parentElement.offsetWidth / 100);
    var fivePctInPixelsHeight = Math.round(5 * parentElement.offsetHeight / 100);
    //if checking auto resize
    if( $scope.selectedBlock.height !== null) {
      $scope.selectedBlock.height = null;
      block.image_height = null;
      block.vertical_align = null;
      // We check if current width is lower than 5% converted to pixels
      if (element.offsetWidth < fivePctInPixelsWidth) {
        $scope.selectedBlock.width = fivePctInPixelsWidth;
        block.image_width = '5%';
      }
      // Now the width and height cannot be lower than 5% converted to pixels
      $scope.selectedBlock.minHeight = fivePctInPixelsHeight;
      $scope.selectedBlock.minWidth = fivePctInPixelsWidth;

      $scope.pushState();
      return;
    }

    // Set manually the closest value equivalent to 5%, which was the height used when creating a new text block
    $scope.selectedBlock.height = fivePctInPixelsHeight;
    block.image_height = ((fivePctInPixelsHeight * 100) / parentElement.offsetHeight) +'%';
    $scope.selectedBlock.minHeight = 1;
    $scope.selectedBlock.minWidth = 1;

    $scope.pushState();
  };

  $scope.setHeightFromInput = function (block) {
    var minHeight = 1;
    $scope.selectedBlock.minHeight = minHeight;

    // Set the height to selectedTextBlock.height or minHeight
    var height = $scope.selectedBlock.height ? $scope.selectedBlock.height : minHeight;
    $scope.selectedBlock.height = height;

    // Calculate height as a percentage of certificate height
    block.image_height = ((height * 100) / $scope.certificateElement.offsetHeight).toFixed(3) + '%';

    $scope.pushState();
  };

  $scope.setWidthFromInput = function (block) {
    // Find the block element by class name
    var blockClassName = '.block-index-' + block.block_index;
    var blockElement = document.querySelector(blockClassName);
    var parentElement = blockElement.parentElement;

    var minWidth = 1;

    // update minWidth based on parent width if height is not selected
    if (!$scope.selectedBlock.height) {
      minWidth = Math.round((5 * parentElement.offsetWidth) / 100);
    }

    // Set the width and minWidth
    var width = $scope.selectedBlock.width ? $scope.selectedBlock.width : minWidth;
    $scope.selectedBlock.minWidth = minWidth;
    $scope.selectedBlock.width = width;

    // Calculate width as a percentage of certificate width
    block.image_width = ((width * 100) / $scope.certificateElement.offsetWidth).toFixed(3) + '%';

    $scope.pushState();
  };


  $scope.canMoveForward = function(block) {
    return (getNextIndex(block) !== -1);
  };
  $scope.moveForward = function(block) {
    if (block) {
      var fromIndex = $scope.design.blocks.indexOf(block);
      var toIndex = getNextIndex(block);
      if (fromIndex !== -1 && toIndex !== -1) {
        $scope.design.blocks[fromIndex] = $scope.design.blocks[toIndex];
        $scope.design.blocks[toIndex] = block;
      }
      $scope.pushState();
    }
  };

  $scope.canMoveBackward = function(block) {
    return (getPrevIndex(block) !== -1);
  };
  $scope.moveBackward = function(block) {
    if (block) {
      var fromIndex = $scope.design.blocks.indexOf(block);
      var toIndex = getPrevIndex(block);
      if (fromIndex !== -1 && toIndex !== -1) {
        $scope.design.blocks[fromIndex] = $scope.design.blocks[toIndex];
        $scope.design.blocks[toIndex] = block;
      }
      $scope.pushState();
    }
  };

  $scope.repairCentering = function(block) {
    if (block) {
      delete block.center;
      if (!block.image_width) {
        block.image_width = '15%';
      }
      $scope.pushState();
    }
  };

  $scope.deleteBlock = function(block) {
    if (block == $scope.sharedData.selectedBlock) {
      $scope.deselectBlock();
    }
    $scope.pushState();
    $scope.design.blocks.splice(block.block_index, 1);
    if (block.qr_code) {
      $scope.hasQRCode = false;
    }
    $scope.design.blocks.forEach(function(block, index) {
      block.block_index = index;
    });
  };

  $scope.cloneBlock = function(block) {
    if (block) {
      var clone = angular.copy(block);
      clone.block_index = $scope.design.blocks.length;
      delete clone.selected;
      delete clone.edit;
      clone.top = plusPercent(clone.top); // Nudge down
      $scope.design.blocks.push(clone);
      $scope.pushState();
      return clone;
    }
  };

  $scope.setDesktopBg = function(fileUrl) {
    $scope.design.background = fileUrl;
    checkDesktopBackgroundSize();
    $scope.pushState();
  };

  $scope.addTextBlock = function(value) {
    //Calculate the closest % value equivalent to 30px, which was the height used when a new text block was created
    var image_height = Math.round(30 * 100 / $scope.certificateElement.offsetHeight) + '%';
    var block = {
      'top': '5%',
      'left': '0%',
      'model': value,
      'font': defaultFont,
      'font_weight': defaultFontWeight,
      'color': defaultColor,
      'font_size': '16px',
      'image_width': '15%',
      'image_height': image_height,
      'scale_to_fit': false,
      'block_index': $scope.design.blocks.length,
      'vertical_align': 'center'
    };
    $scope.design.blocks.push(block);
    // Select and return the block
    $timeout(function () {
      // select the block after it is added to the DOM
      $scope.selectBlock(block);
    });
    $scope.pushState();
    return block;
  };

  $scope.addImageBlock = function(fileUrl) {
    // Create and select the block
    if (fileUrl) {
      var block = {
        'top': '0%',
        'left': '0%',
        'image_url': fileUrl,
        'block_index': $scope.design.blocks.length,
      };
      $scope.design.blocks.push(block);
      // Select and return the block
      $timeout(function () {
        // select the block after it is added to the DOM
        $scope.selectBlock(block);
      });
      $scope.pushState();
      return block;
    }
  };

  $scope.addQRCodeBlock = function() {
    // Create and select the block
    var block = {
      'top': '0%',
      'left': '0%',
      'image_width': '128px', // These pixel values get monkey patched into percentages
      'image_height': '128px', // ...see editor-image-monkey-patch
      'pixel_width': 128,  // The 'pixel_width' and 'pixel_height' values keep a record of the pixel size
      'pixel_height': 128, // of the QR Code so that it can be maintained if the document dimensions change
      'qr_code': true,
      'background_color': '#FFFFFF',
      'foreground_color': '#000000',
      'contrast': 21,
      'block_index': $scope.design.blocks.length,
    };
    $scope.design.blocks.push(block);
    // Select and return the block
    $timeout(function () {
      // select the block after it is added to the DOM
      $scope.selectBlock(block);
    });
    $scope.pushState();
    $scope.hasQRCode = true;
    return block;
  };

  $scope.lineStyles = [
    'dotted',
    'dashed',
    'solid',
    'double',
    'groove',
    'ridge',
    'inset',
    'outset'
  ];

  $scope.addLineBlock = function(orientation) {
    var block = {
      'top': '0',
      'left': '0%',
      'color': defaultColor,
      'line_width': '2px',
      'line_style': 'solid',
      'orientation': orientation,
      'image_width': orientation === 'horizontal' ? '50%' : '3%',
      'image_height': orientation === 'horizontal' ? '3%' : '50%',
      'block_index': $scope.design.blocks.length,
    };
    $scope.design.blocks.push(block);
    // Select and return the block
    $timeout(function () {
      // select the block after it is added to the DOM
      $scope.selectBlock(block);
    });
    $scope.pushState();
    return block;
  };

  $scope.addImageAttributeBlock = function(attributeTag, imageWidth, imageHeight, altText) {
    // Create and select the block
    if (attributeTag) {
      var block = {
        'top': '0%',
        'left': '0%',
        'image_width': imageWidth, // These pixel values get monkey patched into percentages
        'image_height': imageHeight, // ...see editor-image-monkey-patch
        'custom_image_attribute': attributeTag,
        'block_index': $scope.design.blocks.length,
        'alt_text': altText,
      };
      $scope.design.blocks.push(block);
      // Select and return the block
      $timeout(function () {
        // select the block after it is added to the DOM
        $scope.selectBlock(block);
      });
      $scope.pushState();
      return block;
    }
  };

  $scope.addAttributeTag = function(attributeTag) {
    // Do we have a text block selected?
    var block = $scope.sharedData.selectedBlock;
    if (block && block.hasOwnProperty('model')) {
      // Modify the selected block
      block.model += ' ' + attributeTag;
      $scope.pushState();
    } else {
      // Nope? Create one
      return $scope.addTextBlock(attributeTag);
    }
  };

  $scope.setPaper = function(size, orientation) {
    // Set the paper size and orientation, if necessary
    if (size != $scope.design.size || $scope.design.orientation != orientation) {
      $scope.design.size = size;
      $scope.design.orientation = orientation;
      checkDesktopBackgroundSize(true);
      $scope.pushState();
    }
  };

  $scope.toggledBleeds = function() {
    // The checkbox toggles design.background_bleeds
    bleedState = $scope.design.background_bleeds;
    $scope.pushState();
  };

  $scope.bgIsPrintResolution = false; // This gets set to true if the background is correct for printing

  function checkDesktopBackgroundSize(dontSaveChanges, dontSetBleeds) {
    // Check if the background image is "print quality", and thus has a bleed area
    if ($scope.design.background) {
      var printDimensions = certificateDimensions.getDimensions($scope.design.size, $scope.design.orientation, 'print');
      if (printDimensions) {
        var img = new Image();
        img.onload = function() {
          var sameAspectRatio = this.width / printDimensions.width === this.height / printDimensions.height;
          if (this.width >= printDimensions.width && this.height >= printDimensions.height && sameAspectRatio) {
            // If unset, initialise bleedState to what is set on the design
            if (bleedState === null) {
              bleedState = $scope.design.background_bleeds;
            }
            // Correct size? Show bleed
            if (!dontSetBleeds) {
              $scope.design.background_bleeds = bleedState;
            }
            $scope.bgIsPrintResolution = true;
          } else if (this.width > 0.7 * printDimensions.width || this.height == 0.7 * printDimensions.height) {
            // It's High-Rez, but not good enough
            $scope.design.background_bleeds = false;
            $scope.bgIsPrintResolution = false;
          } else {
            // Incorrect size? No bleed
            $scope.design.background_bleeds = false;
            $scope.bgIsPrintResolution = false;
          }
          if (!dontSaveChanges) {
            $scope.pushState();
          }
          // Timeout for async digest
          $timeout(function() {});
        };
        img.src = $scope.design.background;
      }
    } else {
      // No image, no bleeds
      $scope.design.background_bleeds = false;
      if (!dontSaveChanges) {
        $scope.pushState();
      }
    }
  }

  // Default the paper size and orientation (belts and braces)
  var size = $scope.design.size || 'us-letter';
  var orientation = $scope.design.orientation || 'landscape';
  $scope.setPaper(size, orientation);
  checkDesktopBackgroundSize(true);

  /** ATTRIBUTES
   *
   *    Deals with the following two methods
   *
   *        Is the attribute in use?
   *        Add the attribute to the design
   *
   *    @author David "oodavid" King
   */
  $scope.attributeInUse = function(attribute) {
    for (var b = 0, bl = $scope.design.blocks.length; b < bl; b++) {
      var block = $scope.design.blocks[b];
      // Check text blocks
      if (block.model) {
        if (block.model.indexOf(attribute.tag) > -1) {
          return true;
        }
      }
      // Check images
      if (block.custom_image_attribute) {
        if (block.custom_image_attribute == attribute.tag) {
          return true;
        }
      }
    }
    return false;
  };

  var imageDimensionModal;
  $scope.selectAttribute = function(attribute) {
    if (attribute.type == 'image') {
      // The popup wants to know the stage dimensions, and a sensible initial size
      $scope.stage_width = $('#certificate-editor-body .certificate').width();
      $scope.stage_height = $('#certificate-editor-body .certificate').height();
      // Pass an object as primitive values are copied to the modal scope
      $scope.modalImageDimentions = {
        image_width: 240,
        image_height: 120,
        alt_text: '',
      };
      $scope.attribute = attribute;
      // Open a modal to allow the user to select the image size
      imageDimensionModal = $uibModal.open({
        animation: true,
        windowClass: 'bs-to-dialog',
        templateUrl: '/app/_modals/imageDimensionModal.html',
        scope: $scope,
      });
    } else {
      $scope.addAttributeTag(attribute.tag);
    }
  };

  $scope.addImageAttributeBlockFromModal = function() {
    $scope.addImageAttributeBlock($scope.attribute.tag, $scope.modalImageDimentions.image_width + 'px', $scope.modalImageDimentions.image_height + 'px', $scope.modalImageDimentions.alt_text);
    imageDimensionModal.close();
  };

  // Attribute list functionality - derived from the select-attribute directive

  $scope.attributeGroups;

  if ($scope.authorized) {
    // Read the attributes from the service
    attributeService
      .getNestedAttributes()
        .then(function(myAttributes) {
          $scope.attributeGroups = myAttributes;
      });
  }

  // QR Code Support

  $scope.contrastThreshold = 5;
  $scope.contrastGuaranteedThreshold = 10;

  // Utilities
  function luminanace(r, g, b) {
    var a = [r, g, b].map(function (v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow( (v + 0.055) / 1.055, 2.4 );
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
  }

  function contrast(rgb1, rgb2) {
    return (luminanace(rgb1[0], rgb1[1], rgb1[2]) + 0.05) / (luminanace(rgb2[0], rgb2[1], rgb2[2]) + 0.05);
  }

  function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? [
      parseInt(result[1], 16),
      parseInt(result[2], 16),
      parseInt(result[3], 16)
     ] : null;
  }

  // Render color change without saving the model
  $scope.onQRCodeColorUpdate = function($event, layer){
    if (layer) {
      $scope.sharedData.selectedBlock[layer + '_color'] = $event.color;
    }
    $scope.sharedData.selectedBlock.contrast = contrast(hexToRgb($scope.sharedData.selectedBlock.background_color), hexToRgb($scope.sharedData.selectedBlock.foreground_color));
  };

  // Maintain QR Code size if document dimensions are changed
  $scope.onDocumentChange = function() {
    $timeout(function() { // Delay until next digest cycle
      if ($scope.hasQRCode) {
        var qrCodeBlock = _.find($scope.design.blocks, function(block) {
          return block.qr_code;
        });
        var certificate = $element.find('.certificate-editable');
        var widthPct = ((qrCodeBlock.pixel_width / certificate.width()) * 100).toFixed(3) + '%';
        var heightPct = ((qrCodeBlock.pixel_height / certificate.height()) * 100).toFixed(3) + '%';
        qrCodeBlock.image_width = widthPct;
        qrCodeBlock.image_height = heightPct;
        certificate.trigger('documentChange'); // Used by resizableDirective
      }
      checkDesktopBackgroundSize();
      $scope.pushState();
    });
  };

  /** _    _                 _            _____                                  _
   * | |  | |               | |          |  __ \                                | |
   * | |__| | ___ _ __ ___  | |__   ___  | |  | |_ __ __ _  __ _  ___  _ __  ___| |
   * |  __  |/ _ \ '__/ _ \ | '_ \ / _ \ | |  | | '__/ _` |/ _` |/ _ \| '_ \/ __| |
   * | |  | |  __/ | |  __/ | |_) |  __/ | |__| | | | (_| | (_| | (_) | | | \__ \_|
   * |_|  |_|\___|_|  \___| |_.__/ \___| |_____/|_|  \__,_|\__, |\___/|_| |_|___(_)
   *                                                        __/ |
   *                                                       |___/
   *
   *  I'm pretty happy with the refactored code above.
   *
   *  The code below has barely been touched in my review.
   *
   *  In due course the entire Controller will be refactored, with the above logic
   *   acting as a solid foundation.
   *
   *  @author   David "oodavid" King
   */



  /** COLOR SELECTOR OVERRIDE
   *
   *   Wrote in a wrapper that can be styled, but then clicking behaviour
   *    becomes a little wonky. Need this hacky little thing to ensure it
   *    works OK.
   *
   *   @author Jake Ford
   */
  $scope.getTextColor = function() {
    if ($scope.sharedData.selectedBlock.color && $scope.sharedData.selectedBlock.color.length === 7) {
      return String($scope.sharedData.selectedBlock.color);
    }
    return '#404040';
  };

  // Load the certificate fonts
  fontService.loadDesignFonts($scope.design);

  // Default credential data
  $scope.credential = {
    'name': 'Example Course Name',
    'recipient': {
      'name': 'John Doe',
    },
    'issued_on': new Date(),
    'group': {
      'design': $scope.design,
    },
  };

  // Keyboard shortcuts
  angular.element('body').bind('keydown', function($event) {
    // Digest the logic so our scope updates
    $scope.$apply(function() {
      // ESC = Deselect
      if ($event.which === 27) {
        $scope.deselectBlock();
        $event.preventDefault();
        $event.stopImmediatePropagation();
      }
      // All other shortcuts shouldn't occur if an input or textarea is focussed
      if (!document.activeElement || (document.activeElement.tagName !== 'INPUT' && document.activeElement.tagName !== 'TEXTAREA')) {
        // Backspace / Delete = Delete
        if ($event.which === 8 || $event.which === 46) {
          if ($scope.sharedData.selectedBlock && !$scope.sharedData.isEditing) {
            $scope.deleteBlock($scope.sharedData.selectedBlock);
            $event.preventDefault();
            $event.stopImmediatePropagation();
          }
        }
        // Left = Nudge
        else if ($event.which === 37 && $scope.sharedData.selectedBlock && !$scope.sharedData.isEditing) {
          $scope.sharedData.selectedBlock.left = minusPercent($scope.sharedData.selectedBlock.left);
          $event.preventDefault();
          $event.stopImmediatePropagation();
        }
        // Right = Nudge
        else if ($event.which === 39 && $scope.sharedData.selectedBlock && !$scope.sharedData.isEditing) {
          $scope.sharedData.selectedBlock.left = plusPercent($scope.sharedData.selectedBlock.left);
          $event.preventDefault();
          $event.stopImmediatePropagation();
        }
        // Up = Nudge
        else if ($event.which === 38 && $scope.sharedData.selectedBlock && !$scope.sharedData.isEditing) {
          $scope.sharedData.selectedBlock.top = minusPercent($scope.sharedData.selectedBlock.top);
          $event.preventDefault();
          $event.stopImmediatePropagation();
        }
        // Down = Nudge
        else if ($event.which === 40 && $scope.sharedData.selectedBlock && !$scope.sharedData.isEditing) {
          $scope.sharedData.selectedBlock.top = plusPercent($scope.sharedData.selectedBlock.top);
          $event.preventDefault();
          $event.stopImmediatePropagation();
        }
        // Open Bracket [ = Select Custom Attribute (openAttributeSelector doesn't exist, hence disabled)
        /*
        else if ($event.which === 219 && $scope.sharedData.selectedBlock && $scope.sharedData.isEditing && $scope.sharedData.selectedBlock.model) {
            $scope.openAttributeSelector($event);
            $event.preventDefault();
            $event.stopImmediatePropagation();
        }
        */
      }
    });
  });

  /** SAVE
   *
   */
  var confirmThenSave = function(formCtrl) {
    swalService.confirm(
      'This template is used by ' + $scope.design.credentials_count + ' existing credential' + ($scope.design.credentials_count != 1 ? 's' : '') + '. Saving now will change the certificate appearance for ' + ($scope.design.credentials_count != 1 ? 'those credentials' : 'this credential') + '.',
      function(confirmed) {
        if (confirmed) {
          nowSave(formCtrl);
        } else {
          formCtrl.$submitted = false;
        }
      },
      'Change Existing Credential' + ($scope.design.credentials_count != 1 ? 's' : '') + '?',
      'Update design',
      '#4fba6a',
      'Cancel',
      true
    );
  };
  var nowSave = function(formCtrl) {
    var design = getDesignPayload();
    // And save
    CertificateService
      .upsert(design)
      .then(function(response) {
        AnalyticsService.trackEvent('Certificate Design Editor > Design Saved');
        // Update the local object
        replaceDesign(response);
        savedDesign = response;
        // Update the time we saved, based on the History object
        saveTime = History.timestamp;
        // Close the editor
        // #shame taken from the close function
        // var formScope = angular.element($scope.formBuster.formCtrl.$$element[0]).scope();
        var expressionHandler = $scope.onClose();
        expressionHandler(savedDesign); // Manually trigger the function passing formCtrl as the only argument
      })
      .catch(function(err) {
        swalService.showAlert('certificateDesignUpdateFailure');
      })
      .finally(function(){
        formCtrl.$setPristine();
      });
  };

  $scope.saveDesign = function(formCtrl) {
    $scope.deselectBlock();
    if (!$scope.design.name) {
      swalService.showAlert('certificateDesignNeedsNameError');
      formCtrl.$submitted = false;
    } else {
      // Confirm the effects on existing credentials
      if ($scope.design.credentials_count > 0){
        confirmThenSave(formCtrl);
      } else {
        nowSave(formCtrl);
      }
    }
  };

  $scope.getDesktopBgImageScreenSize = function() {
    var size = $scope.design.size || 'us-letter';
    var orientation = $scope.design.orientation || 'landscape';
    var screen = certificateDimensions.getDimensions(size, orientation, 'screen');
    return screen.width + ' x ' + screen.height + ' pixels';
  };
  $scope.getDesktopBgImagePrintSize = function() {
    var size = $scope.design.size || 'us-letter';
    var orientation = $scope.design.orientation || 'landscape';
    var print = certificateDimensions.getDimensions(size, orientation, 'print');
    return print.width + ' x ' + print.height + ' pixels';
  };

  function minusPercent(input) {
    var percent = parseFloat(input);
    // Largest editor paper size is 297mm. At 96 DPI, that's 1122.5px.
    // Therefore each single 1% is 11.2px.
    // Therefore Nudging by 0.1 nudges by 1.12px.
    percent = percent - 0.1;
    if (percent < 0) {
      return '0%';
    } else {
      return percent.toString() + '%';
    }
  }

  function plusPercent(input) {
    var percent = parseFloat(input);
    // Largest editor paper size is 297mm. At 96 DPI, that's 1122.5px.
    // Therefore each single 1% is 11.2px.
    // Therefore Nudging by 0.1 nudges by 1.12px.
    percent = percent + 0.1;
    if (percent > 100) {
      return '100%';
    } else {
      return percent.toString() + '%';
    }
  }

  // Font weights
  $scope.allFontWeights = fontService.getWeights(); // { 100: 'Thin', 200: 'Extra Light' ... }
  $scope.availableFontWeights = []; // [300, 400, 600] - for the selected font
  function updateAvailableFontWeights(){
    if ($scope.sharedData.selectedBlock.font){
      $scope.availableFontWeights = $scope.fonts[$scope.sharedData.selectedBlock.font].weights.filter(function(weight) {
        return Number.isInteger(weight);
      });
    }
  }

  // Font Families that are available to the issuer
  $scope.fonts = fontService.getFonts();

  // Render color changes without saving the model
  $scope.onColorChange = function($event){
    $scope.sharedData.selectedBlock.color = $event.color;
  };

  // Date object
  $scope.exampleDate = new Date();

}

angular
  .module('app')
  .directive('certificateEditor', certificateEditorDirective)
  .run(certificateEditorDirectivePreload);

},{"./directives/autoRemoveAttributesDirective.js":189,"./directives/certificateScaleTextDirective.js":190,"./directives/draggableDirective.js":191,"./directives/resizableDirective.js":192}],189:[function(require,module,exports){
/** AUTO REMOVE ATTRIBUTES
 *
 *    Hitting BACKSPACE or DELETE on the [ or ] characters
 *     will remove the entire [attribute] block from the input.
 *
 *      <textarea auto-remove-attributes>
 *        you can delete [this_attribute] simply enough!
 *      </textarea>
 *
 *  @author  David "oodavid" King
 */
(function() {
  angular
    .module('app')
    .directive('autoRemoveAttributes', ['$timeout', function($timeout) {
      return {
        require: 'ngModel',
        link: function(scope, element, attrs) {
          element.bind("keydown keypress", function($event) {
            // Backspace or Delete
            if ($event.which === 8 || $event.which === 46) {
              // This should only work when we're removing a single character (ie, not an extended selection!)
              if ($event.target.selectionStart === $event.target.selectionEnd) {
                // Assume we have nothing to do
                var start = false;
                var end = false;
                // Grab the caret position and char
                var value = $event.target.value;
                var left = $event.target.selectionStart - ($event.which === 8 ? 1 : 0); // Nudge left when using Backspace
                var right = left + 1;
                var char = value[left];
                // If it's a [ or ] then we can try and match the [attribute]
                if (char === '[') {
                  // Scan right for a matching [
                  for (var i = right, vl = value.length; i < vl; i++) {
                    if (value[i] == ']') {
                      start = left;
                      end = i + 1;
                      break;
                    }
                  }
                } else if (char === ']') {
                  // Scan left for a matching [
                  for (var i = left; i >= 0; i--) {
                    if (value[i] == '[') {
                      start = i;
                      end = right;
                      break;
                    }
                  }
                }
                // Did we get a match?
                if (start !== false && end !== false) {
                  // Validate the [attribute] string
                  var string = value.slice(start, end);
                  var regex = /^[\[\]\w_]*$/i; // Matches all valid chars in an [attribute] string
                  if (string.match(regex)) {
                    // Removing the [attribute] might empty the string, that needs a different approach
                    if (string === value) {
                      $event.target.value = ""; // Clear the value
                    } else {
                      $event.target.value = value.slice(0, start) + value.slice(end); // Clip the value and angular model
                    }
                    scope.block.model = $event.target.value;
                    // Make sure this gets digested
                    $timeout(function() {
                      // Restore the cursor position on the next digest - but only if we have something to focus on
                      if ($event.target.value.length) {
                        $event.target.setSelectionRange(start, start);
                      }
                    }, 0);
                    // Cancel normal behaviours
                    $event.preventDefault();
                    $event.stopImmediatePropagation();
                  }
                }
              }
            }
          });
        }
      };
    }]);
})();

},{}],190:[function(require,module,exports){
/** CERTIFICATE SCALE TEXT
 *
 *
 *
 *  @author  Andrew Bateman
 */
(function() {
  angular
    .module('app')
    .directive('certificateScaleText', ['$interpolate', '$timeout', '$compile', function($interpolate, $timeout, $compile) {
      return {
        restrict : 'A',
        priority : 1,
        terminal : true,
        link: function(scope, element, attr) {
          // Render text to DOM
          $compile(element, null, 1)(scope);
          // Get text to measure - '{' and '}' are removed to prevent XSS
          var text = $interpolate(element.text().replace(/{/g, '').replace(/}/g, ''))(scope);
          // Create canvas
          var canvas = document.createElement('canvas');
          var context = canvas.getContext('2d');
          // Get containing certificate
          var certificate = element.closest('.certificate-editable');
          // Prevent observer firing before initial adjustment
          var initialised = false;
          // Get initial enabled value
          var enabled = attr.certificateScaleText === 'true';
          function adjustFontSize() {
            // Remove any existing font-size styling from the element
            element.css('font-size', '');
            if (enabled) {
              // Get containing block width
              var container = element.closest('.certificate-block');
              var containerWidth = container.width();
              // Get the current pixel font size
              var pixelFontSize = parseFloat(getComputedStyle(container[0]).fontSize);
              // Get current font weight and family
              var fontWeight = element.css('font-weight');
              var fontFamily = element.css('font-family');
              var fontSize = pixelFontSize;
              // Find first font-size that will fit containing block width
              context.font = fontWeight + ' ' + fontSize + 'px ' + fontFamily;
              while (context.measureText(text).width > containerWidth)
              {
                fontSize = fontSize - 1;
                context.font = fontWeight + ' ' + fontSize + 'px ' + fontFamily;
              }
              // Apply calculated font-size, if necessary
              if (fontSize < pixelFontSize) {
                element.css('font-size', fontSize + 'px');
              }
            }
            // Must be initialised now
            initialised = true;
          }
          attr.$observe('certificateScaleText', function(newValue) {
            enabled = (newValue === 'true');
            if (initialised) {
              adjustFontSize();
            }
          });
          certificate.on('change', function(event, el) {
            // Only adjust if the contained element was the one that was changed
            if (el && $.contains(el, element[0])) { // el comes from the resizableDirective. If it isn't present the change was raised by something else and should be ignored
              adjustFontSize();
            }
          });
          $timeout(adjustFontSize);
        }
      };
    }]);
})();

},{}],191:[function(require,module,exports){
/** DRAGGABLE
 *
 *    While we're using jQueryUI.draggable, I've had to add some
 *       additional logic to deal with snapping / smart-guides.
 *
 *    Features:
 *      User can drag any block
 *      Dragging is contained within the parent / <certificate>
 *      Snapping / Smart-Guides
 *
 *    Used by the <certificate> editor.
 *
 *  @author  David "oodavid" King
 */
(function() {
  angular.module('app')
    .directive('draggable', function() {
      var tolerance = 3;

      // Returns the position (as a percentage)
      var getPositionPct = function(jElement, ui) {
        var parentWidth = jElement.parent().width();
        var parentHeight = jElement.parent().height();
        return {
          left: (ui.position.left / parentWidth) * 100,
          top: (ui.position.top / parentHeight) * 100,
        };
      };

      // Contains a list of coordinates we can snap to, and the elements that use that space
      var snap = {
        x: {}, // Each coordinate can contain a number of blocks,
        y: {}, // ...like so:: { '150': [ block1, block2 ] }
      };

      var addSnap = function(axis, value, block) {
        value = Math.round(value); // This makes the snapping more visually reliable when we consider the juggling of px and %
        if (!snap[axis][value]) {
          snap[axis][value] = [];
        }
        if (block) {
          snap[axis][value].push(block);
        }
      };

      var generateSnapGrid = function(jElement) {
        // Reset the object
        snap.x = {};
        snap.y = {};
        // Add the center point
        var centerStageX = jElement.parent().width() / 2;
        var centerStageY = jElement.parent().height() / 2;
        addSnap('x', centerStageX);
        addSnap('y', centerStageY);
        // Loop the siblings, and add their coordinates
        var blocks = jElement.parent().find('.certificate-block:visible').not(jElement); // All visible blocks, excluding the active one
        for (var b = 0, bl = blocks.length; b < bl; b++) {
          var block = $(blocks[b]);
          var pos = block.position();
          addSnap('y', pos.top, block); // Top
          addSnap('y', (pos.top + (block.height() / 2)), block); // Middle
          addSnap('y', (pos.top + block.height()), block); // Bottom
          // HACK - if the element has the insane "center" property applied, then we can't rely on the left, middle and right properties
          if (block.css('left') == '0px' && block.css('right') == '0px') {
            addSnap('x', centerStageX, block); // But we do know they're centered ...so we can add them to the "stage" array
          } else {
            addSnap('x', pos.left, block); // Left
            addSnap('x', (pos.left + (block.width() / 2)), block); // Middle
            addSnap('x', (pos.left + block.width()), block); // Right
          }
        }
      };
      // Clears all snap styles
      var clearSnapStyles = function(jElement) {
        jElement.parent().find('.snapToThis').removeClass('snapToThis');
        jElement.parent().find('.guide-x').hide();
        jElement.parent().find('.guide-y').hide();
      };

      // Snaps the element to our snap guides on either the x or y axis
      var snapOnAxis = function(jElement, ui, axis) {
        var prop = (axis == 'x' ? 'left' : 'top');
        var elDimension = (axis == 'x' ? jElement.width() : jElement.height());
        var closest = {
          distance: tolerance, // The distance
          value: null, // The "left" or "top" value
          snapKey: null, // The Key, something like 150 (pixels)
        };
        for (var snapKey in snap[axis]) {
          if (snap[axis].hasOwnProperty(snapKey)) {
            var dist;
            // Middle
            dist = Math.round(Math.abs(ui.position[prop] + (elDimension / 2) - snapKey));
            if (dist < closest.distance + 0.1) { // Why do we use +0.1? To make "middle" override "left" or "right"
              closest.distance = dist;
              closest.snapKey = snapKey;
              closest.value = snapKey - (elDimension / 2);
            }
            // Top / Left
            dist = Math.round(Math.abs(ui.position[prop] - snapKey));
            if (dist < closest.distance) {
              closest.distance = dist;
              closest.snapKey = snapKey;
              closest.value = snapKey;
            }
            // Bottom / Right
            dist = Math.round(Math.abs(ui.position[prop] + elDimension - snapKey));
            if (dist < closest.distance) {
              closest.distance = dist;
              closest.snapKey = snapKey;
              closest.value = snapKey - elDimension;
            }
          }
        }
        if (closest.snapKey && closest.value) {
          ui.position[prop] = closest.value;
          jElement.parent().find('.guide-' + axis).show().css(prop, (closest.snapKey - 1) + 'px');
          var blocks = snap[axis][closest.snapKey];
          for (var b = 0, bl = blocks.length; b < bl; b++) {
            blocks[b].addClass('snapToThis');
          }
        }
      };

      // DRY
      var addDraggable = function(scope, jElement, attrs) {
        jElement.draggable({
          cursor: 'move',
          containment: jElement.closest('.certificate-editable'),
          axis: scope.block.center ? 'y' : false,
          start: function(event, ui) {
            generateSnapGrid(jElement);
            scope.$apply(function() {
              scope.selectBlock(scope.block, event);
            });
          },
          drag: function(event, ui) {
            // Clear any highlighted elements
            clearSnapStyles(jElement);
            // Snap on x and y
            snapOnAxis(jElement, ui, 'x');
            snapOnAxis(jElement, ui, 'y');
            // Display the position
            var pos = getPositionPct(jElement, ui);
            var x = pos.left.toFixed(2);
            var y = pos.top.toFixed(2);
            jElement.find('.drag-position').text(x + ', ' + y);
          },
          stop: function(event, ui) {
            // Clear any highlighted elements
            clearSnapStyles(jElement);
            //
            scope.$apply(function() {
              var pos = getPositionPct(jElement, ui);
              scope.block.top = pos.top.toFixed(3) + '%';
              scope.block.left = pos.left.toFixed(3) + '%';
              if (attrs.onChange) {
                scope.$eval(attrs.onChange);
              }
              // Hide the position
              jElement.find('.drag-position').text('');
            });
          }
        });
      };

      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          // Be draggable
          addDraggable(scope, element, attrs);
          // Erm... if the centring changes, reset the draggable?
          scope.$watch(function() {
            return scope.block.center;
          }, function(newVal, oldVal) {
            if (newVal !== oldVal) {
              element.draggable('destroy');
              addDraggable(scope, element, attrs);
            }
          });
        }
      };
    });
})();

},{}],192:[function(require,module,exports){
/** RESIZABLE
 *
 *    Used by the <certificate> editor.
 *
 *  @author  Ryan Booth
 *  @author  David "oodavid" King - documentation, tweaks and monkey patch
 */
(function() {

  angular.module('app')
    .directive('resizable', [function() {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          var minSize = getMinSize(scope, attrs.designSize);
          elementResizable(scope, element, attrs, minSize);

          if (scope.block.qr_code) {
            var certificate = element.closest('.certificate-editable');
            certificate.on('documentChange', function() {
              var minSize = getMinSize(scope, attrs.designSize);
              $('.block-index-' + scope.block.block_index).resizable('option', {
                minWidth: minSize,
                minHeight: minSize
              });
              adjustDimensions(scope, element, attrs, 128, 128);
            });
          }
        }
      };
    }]);

  /** MONKEY PATCH!
   *
   *    OK, so we have a requirement for the editor to
   *     always have the width and height defined for
   *     <img> tags, so that we can correctly scale them
   *
   *    Because attribute driven images render a <div>,
   *     this now deals with that edge-case.
   *
   *  @author  David "oodavid" King
   */
  angular.module('app')
    .directive('editorImageMonkeyPatch', ['$timeout', function($timeout) {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          if (element[0].nodeName == 'IMG') {
            element.bind('load', function() {
              adjustDimensions(scope, element, attrs, element.width(), element.height(), 'monkey-patch');
            });
          } else {
            $timeout(function() {
              adjustDimensions(scope, element, attrs, element.width(), element.height(), 'monkey-patch');
            }, 0);
          }
        }
      };
    }]);

  /**
   * At the moment, minimum size is only applicable for QRCode blocks
   */
  function getMinSize(scope, designSize) {
    if (scope.block.qr_code) {
      return designSize === 'a8' ? 105 : 60;
    }
    return null;
  }

  function elementResizable(scope, element, attrs, minSize) {
    return element.resizable({
      containment: element.closest('.certificate-editable'),
      aspectRatio: attrs.aspectRatio === 'true',
      resize: function() {
        // If we are resizing a textBlock we set the height and width on the aux variable selectedBlock
        if(!!scope.block.font) {
          scope.$parent.selectedBlock.width = Math.round(element.width());
          scope.$parent.selectedBlock.height = Math.round(element.height());
        }
      },
      stop: function(event, ui) {
        // Apply the changes
        adjustDimensions(scope, element, attrs, ui.size.width, ui.size.height, 'user-resize');
      },
      minWidth: minSize,
      minHeight: minSize
    });
  }

  function adjustDimensions(scope, element, attrs, width, height, mode) {
    // If we're monkey-patching, don't do anything if we already have a percentage width or height
    if (mode == 'monkey-patch') {
      if (scope.block && scope.block && scope.block.image_width && scope.block.image_width.indexOf('%') !== -1) {
        return;
      }
    }

    // Calculate, and apply the width and height... as percentages
    var parentWidth = element.closest('.certificate-editable').width();
    var parentHeight = element.closest('.certificate-editable').height();
    var widthPct = ((width / parentWidth) * 100).toFixed(3) + '%';
    var heightPct = ((height / parentHeight) * 100).toFixed(3) + '%';

    scope.block.image_width = widthPct;
    if (scope.block.custom_image_attribute || scope.block.qr_code || (scope.block.line_width && scope.block.orientation === 'vertical')) {
      scope.block.image_height = heightPct;
    } else if (scope.block.line_width && scope.block.orientation === 'horizontal') {
      scope.block.image_height = '3%';
    } else {
      delete scope.block.image_height;
    }

    if (scope.block.line_width && scope.block.orientation === 'vertical') {
      scope.block.image_width = '3%';
    }

    var minQRSize = null;
    if (scope.block.qr_code) {
      minQRSize = attrs.designSize === 'a8' ? 105 : 60;
      scope.block.pixel_width = width < minQRSize ? minQRSize : width;
      scope.block.pixel_height = height < minQRSize ? minQRSize : height;
    }

    if (!!scope.block.font) {
      // We don't allow values lower than 1px, so we calculate its % compared to the parent height and width
      enforceMinimumDimensions(1, scope, widthPct, heightPct, parentWidth, parentHeight);
    } else if (scope.block.qr_code) {
      // We don't allow values lower than 105px/60px, so we calculate its % compared to the parent height and width
      enforceMinimumDimensions(minQRSize, scope, widthPct, heightPct, parentWidth, parentHeight);
    }

    // If the user resized the element (rather than programmatically), then we should trigger onChange
    if (mode == 'user-resize' && attrs.onChange) {
      scope.$eval(attrs.onChange);
      element.trigger('change', element); // Used by certificateScaleText directive
    }

    scope.$apply();
  }

  function enforceMinimumDimensions(minSize, scope, widthPct, heightPct, parentWidth, parentHeight) {
    var minWidthPct = minSize * 100 / parentWidth;
    var minHeightPct = minSize * 100 / parentHeight;

    scope.block.image_width = widthPct;
    if (parseInt(widthPct) < minWidthPct) {
      scope.block.image_width = minWidthPct + '%';
    }

    scope.block.image_height = heightPct;
    if (parseInt(heightPct) < minHeightPct) {
      scope.block.image_height = minHeightPct + '%';
    }
  }
})();

},{}],193:[function(require,module,exports){
/** CERTIFICATE
 *
 *    Outputs a certificate
 *
 *          <certificate                design="credential.group.certificate_design"></certificate>
 *          <certificate                design="credential.group.certificate_design" data="credential"></certificate>
 *          <certificate class="square" design="credential.group.certificate_design" data="credential"></certificate>
 *
 *      CSS Note
 *
 *          To render this correctly, be sure to use _certificate.scss
 *           which is available as part of our CSS framework.
 *
 *      Dependencies
 *
 *          This requires the fontService, that will dynamically load
 *           any required fonts.
 *
 *      Generally...
 *
 *          Note that this file also outputs various filters and has a
 *           secondary directive that compiles strings with [attributes]
 *
 *    @author   David "oodavid" King
 */
(function() {
  // Properly escapes user input
  function escapeHtml(unsafe) {
    return unsafe
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
  // Escapes AngularJS templates like {{ constructor.constructor('alert(2)')() }}
  function escapeAngularTemplates(string){
    return string
      .replace('{{', '{​{')  // What you can't see in the replacement string is a `ZWSP` (zero-width space) character between the braces
      .replace('}}', '}​}'); // You can get a ZWSP character by running this in Chrome: `copy(String.fromCodePoint(0x200B))`
  }
  // Call this function and pass in the name of the font you want to check for availability.
  function isFontAvailable(fontName) {
    var failSafes = ['serif', 'sans-serif', 'cursive', 'monospace'];
    if (failSafes.indexOf(fontName.toLowerCase()) > -1) {
      return document.fonts.check('1em ' + fontName); // Didn't use this generally as this always seems to return true, but here it's all we've got
    }
    // creating our in-memory Canvas element where the magic happens
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    // the text whose final pixel size I want to measure
    var text = 'abcdefghijklmnopqrstuvwxyz0123456789';
    // specifying the baseline font
    context.font = '72px monospace';
    // checking the size of the baseline text
    var baselineSize = context.measureText(text).width;
    // specifying the font whose existence we want to check
    context.font = '72px ' + fontName + ', monospace';
    // checking the size of the font we want to check
    var newSize = context.measureText(text).width;
    // removing the Canvas element we created
    canvas = null;
    if (newSize == baselineSize) {
      return false;
    } else {
      return true;
    }
  }
  // Our directives, filters and services
  angular.module('app')
    // Our <certificate> custom directive
    .directive('certificate', ['fontService', 'certificateResponsivity', function(fontService, certificateResponsivity) {
      return {
        restrict: 'E',
        replace: true,
        scope: {
          design: '=?',
          data: '=?'
        },
        templateUrl: '/shared/certificate/certificate.html',
        link: function(scope, element, attrs) {
          // Notify the responsive service
          certificateResponsivity.watch(element);
          scope.$on('$destroy', function() {
            certificateResponsivity.unwatch(element);
          });
          // Load the fonts when ready, or the design changes
          scope.$watch('design', function(newval, oldval) {
            if (newval) {
              fontService.loadDesignFonts(newval);
              certificateResponsivity.resize(element);
            }
          });
        }
      };
    }])
    // Resposive service
    .service('certificateResponsivity', ['_', '$window', function(_, $window) {
      var service = this;
      service.watch = watch;
      service.unwatch = unwatch;
      service.resize = resize;
      // Adds / Removes elements from the watch list, to be resized when the window is adjusted
      var elements = [];
      function watch(element){
        elements.push(element);
      }
      function unwatch(element){
        _.remove(elements, function(o) {
          return o === element;
        });
      }
      // Resizes an element
      function resize(element){
        var container = angular.element(element);
        var cert = container.find('.certificate-inner');
        // Print-mode is not responsive
        if(container.hasClass('print')){
          return;
        }
        // Read the original dimensions
        var originalWidth = cert.width();
        var originalHeight = cert.height();
        if(!originalWidth || !originalHeight){
          return; // Nothing to do
        }
        // Container width
        var containerSize;
        if(container.attr('size')){
          // Use the attribute
          containerSize = container.attr('size');
        } else {
          // Get the "natural" size of the container
          container.css({
            'width': '',
            'height': '',
            'margin': '',
          });
          containerSize = container.parent().width();
        }
        // Defaults
        var width = 100;
        var height = 100;
        var scale = 1;
        var marginTopBottom = 0;
        var marginLeftRight = 0;
        // Render as a square?
        var isSquare = container.hasClass('square') || (originalHeight > originalWidth); // Optional class. Landscape is always rendered square
        // Rendering logic
        if(isSquare){
          if(originalHeight > originalWidth){
            // Portrait
            scale = containerSize / originalHeight;
            width = originalWidth * scale;
            height = containerSize;
            marginLeftRight = (containerSize - width) / 2;
          } else {
            // Landscape
            scale = containerSize / originalWidth;
            width = containerSize;
            height = (originalHeight * scale);
            marginTopBottom = (containerSize - height) / 2;
          }
        } else {
          // Full-width
          scale = containerSize / originalWidth;
          width = containerSize;
          height = originalHeight * scale;
        }
        // Now render
        cert.css({
          'transform': 'scale('+scale+')'
        });
        container.css({
          'width': width+'px',
          'height': height+'px',
          'margin': marginTopBottom+'px '+marginLeftRight+'px',
        });
      }
      // Listens for the window being resized
      var throttledCertificateResize = _.throttle(CertificateResize, 200, { leading: false, trailing: true });
      angular.element($window).on('resize focus', throttledCertificateResize);
      function CertificateResize(){
        angular.forEach(elements, function(el){
          resize(el);
        });
      }
    }])
    // A filter that converts "123px" into "123em" (for fonts)
    .filter('convertFontSizeToEm', function() {
      return function(value) {
        if (value && value.indexOf('px') !== -1) {
          return value.replace('px', 'em');
        }
        return value;
      };
    })
    // A filter that converts "123px" into "123" (for font size dropdown)
    .filter('convertFontSizeToNumber', function() {
      return function(value) {
        if (value && value.indexOf('px') !== -1) {
          return value.replace('px', '');
        }
        return value;
      };
    })
    // Filter that converts a font name into a font-family
    .filter('toFontFamily', ['fontService', function(fontService) {
      var fonts = fontService.getFonts({ allOrganizations: true });
      return function(fontName) {
        if (fonts[fontName]) {
          return fonts[fontName].family;
        }
      };
    }])
    // Filter that replaces attributes like [course_name] with angular variables {{ credential.course_name }}
    .filter('parseAttributes', ['attributeService', function(attributeService) {
      return function(value, data) {
        return attributeService.tagsToAngular(value, data);
      };
    }])
    // A [compile-attributes] directive - converts 'hello [recipient.name]' into 'hello {{ data.recipient.name }}' with variations when there is no data
    .directive('compileAttributes', ['$compile', 'attributeService', '$timeout', '$interval', 'fontService', function($compile, attributeService, $timeout, $interval, fontService) {
      var compiler = function() {
        return {
          post: function(scope, element, attrs) {
            // Escape any malicious code from the input
            var original = escapeAngularTemplates(attrs.compileAttributes);
            // Replace [custom.attributes] with {{ angular }}
            var angular = attributeService.tagsToAngular(original, scope.data);
            // Escape for rendering
            original = escapeHtml(original);
            angular  = escapeHtml(angular);
            // And output
            var template = '<span ng-if="data">' + angular + '</span>';
            template += '<span ng-if="!data">' + original + '</span>';
            element.html($compile(template)(scope));
            var standalone = $('body').hasClass('standalone'); // Look on body tag for 'standalone' class
            // Scaling
            if (attrs.scaling === 'true') {
              element.css('visibility', 'hidden');
              var container = element.parent();
              $timeout(function() { // Delay until next digest cycle
                var containerWidth = container.width();
                var text = element.text();
                var canvas = document.createElement('canvas');
                var context = canvas.getContext('2d');
                var fontWeight = element.css('font-weight');
                var fontFamily = element.css('font-family');
                var fontName = fontFamily.split(',')[0].replace(/^"(.*)"$/, '$1');
                var applyScaling = function() {
                  var computedStyle = getComputedStyle(container[0]);
                  var originalFontSize = parseFloat(computedStyle.fontSize);
                  var fontSize = originalFontSize;
                  context.font = fontWeight + ' ' + fontSize + 'px ' + fontFamily;
                  while (context.measureText(text).width > containerWidth)
                  {
                    fontSize = fontSize - 1;
                    context.font = fontWeight + ' ' + fontSize + 'px ' + fontFamily;
                  }
                  if (fontSize < originalFontSize) {
                    element.css('font-size', Math.floor(fontSize) + 'px');
                  }
                  element.css('visibility', 'visible');
                  if (standalone) {
                    element.trigger('scaledText');
                  }
                };
                if (isFontAvailable(fontName)) {
                  // Scale immediately
                  applyScaling();
                } else {
                  // Wait until font has actually loaded
                  var scaled = false;
                  var interval = $interval(function(count) {
                    if (isFontAvailable(fontName)) {
                      applyScaling();
                      scaled = true;
                    }
                    if (scaled || count >= 9) { // Belt and braces
                      $interval.cancel(interval);
                      if (!scaled) {
                        element.css('visibility', 'visible');
                        if (standalone) {
                          element.trigger('scaledText');
                        }
                      }
                    }
                  }, 200, 10); // Keep trying for 200 * 10 = 2000 (2 seconds)
                }
              });
            }
          }
        };
      };
      return {
        restrict: 'A',
        compile: compiler
      };
    }])
    // A [compile-src-attribute] directive - converts `[custom.logo]` into `ng-src={{ data.custom.logo }}""`
    .directive('compileSrcAttribute', ['$compile', 'attributeService', function($compile, attributeService) {
      return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
          var ngSrc = escapeHtml(attributeService.tagsToAngular(attrs.compileSrcAttribute, scope.data, true));
          element.attr('ng-src', '{{' + ngSrc + '}}'); // Add the dynamic SRC
          element.attr('ng-if', ngSrc); // Only show if we have data
          element.removeAttr('compile-src-attribute'); // Remove the attribute to prevent infinite loop
          element.removeAttr('data-compile-src-attribute'); // ...same with data- prefix
          $compile(element)(scope);
        }
      };
    }])
    // A [compile-qr-code] directive - renders QR Code SVG
    .directive('compileQrCode', ['$timeout', 'QRCode', function($timeout, QRCode) {
      return {
        restrict: 'A',
        scope: {
          block: '=',
          data: '='
        },
        link: function link(scope, element, attrs) {
          if (scope.data.url) {
            $timeout(function() { // Delay until next digest cycle to ensure dimensions are correct
              var svg = QRCode.generateSVG(scope.data.url, {
                ecclevel: 'M', // 'L', 'M', 'Q' and 'H'
                fillcolor: scope.block.background_color,
                textcolor: scope.block.foreground_color,
                margin: 4,
                modulesize: 8
              });
              element.append(svg);
            });
          }
        }
      };
    }])
    // An information utility
    .service('certificateDimensions', [function() {
      var dimensions = {
        'a4': {
          landscape: {
            screen: {
              width: 1123,
              height: 794
            },
            print: {
              width: 3626,
              height: 2598
            },
          },
          portrait: {
            screen: {
              width: 794,
              height: 1123
            },
            print: {
              width: 2598,
              height: 3626
            },
          },
        },
        'a8': {
          landscape: {
            screen: {
              width: 280,
              height: 197
            },
            print: {
              width: 874,
              height: 614
            },
          },
          portrait: {
            screen: {
              width: 197,
              height: 280
            },
            print: {
              width: 614,
              height: 874
            },
          },
        },
        'us-letter': {
          landscape: {
            screen: {
              width: 1056,
              height: 816
            },
            print: {
              width: 3418,
              height: 2668
            },
          },
          portrait: {
            screen: {
              width: 816,
              height: 1056
            },
            print: {
              width: 2668,
              height: 3418
            },
          },
        },
      };
      this.getDimensions = function(paperSize, orientation, media) {
        if (dimensions[paperSize] && dimensions[paperSize][orientation] && dimensions[paperSize][orientation][media]) {
          return dimensions[paperSize][orientation][media];
        }
        return false;
      };
    }]);
})();

                // var fontStatus = fontService.getStatus(fontName);
                // if (window.location.hostname.endsWith('standalone.credential.net')) {
                //   containerWidth = containerWidth * fontStatus.correction;
                // }

                // var originalTextWidth = context.measureText(text).width;

                // var finalTextWidth = context.measureText(text).width;

                // if (!loaded) {
                //   element.text(fontName + ' did not load');
                // }

                // element.attr('log',
                //   'text = ' + text +
                //   ', containerWidth = ' + containerWidth +
                //   'px, fontWeight = ' + fontWeight +
                //   ', fontFamily = ' + fontFamily +
                //   ', originalFontSize = ' + originalFontSize +
                //   'px, originalTextWidth = ' + originalTextWidth +
                //   'px, finalTextWidth = ' + finalTextWidth || 'not set' +
                //   'px, usedFont = ' + usedFont
                // );
                // container.css('visibility', 'visible');

},{}],194:[function(require,module,exports){
/** COLLAPSING
 *
 *      Adds collapsing logic to a nested menu
 */
collapsingDirective.$inject = ['$compile'];
function collapsingDirective($compile){
  return {
    restrict: 'A',
    link: collapsingDirectiveLink,
    scope: {
      isVisible: '<?'
    },
  };
  // Link
  function collapsingDirectiveLink(scope, element, attr, model) {
    scope.isVisible = scope.isVisible || false;
    scope.toggle = function(){
      scope.isVisible = !scope.isVisible;
    };
    // Reference the link, and child list
    var link = element.find('> a');
    var list = element.find('> ul');
    // Add some properties
    link.attr('ng-click', 'toggle()');
    list.attr('ng-show', 'isVisible');
    list.addClass('animate-slide ng-hide');
    link.append('&nbsp;<i ng-class="{ \'dir up\': isVisible, \'dir down\': !isVisible }"></i>');
    // Recompile child elements
    $compile(link)(scope);
    $compile(list)(scope);
  }
}
angular
  .module('app')
  .directive('collapsing', collapsingDirective);


},{}],195:[function(require,module,exports){
var cookieConsentComponent = {
  controller: cookieConsentComponentController,
  templateUrl: '/shared/cookie-consent/cookie-consent.html',
};
cookieConsentComponentController.$inject = ['$element', '$timeout', '$injector'];
function cookieConsentComponentController($element, $timeout, $injector) {
  var ctrl = this;
  ctrl.$onInit = onInit;
  ctrl.dismiss = dismiss;
  ctrl.visible = false;
  function onInit(){
    ctrl.visible = !localStorage.getItem('cookie-consent');
  }
  function dismiss(){
    ctrl.visible = false;
    localStorage.setItem('cookie-consent', true);
  }
}

angular
  .module('app')
  .component('cookieConsent', cookieConsentComponent);

},{}],196:[function(require,module,exports){
/** COPY TO CLIPBOARD - DIRECTIVE
 *
 *      This directive abstracts away the input with a button that copies data to the clipboard and displays feedback to the user.
 *
 *      Usage
 *
 *          <div copy-to-clipboard="string value"></div>
 *          <div copy-to-clipboard="{{ template.value }}}"></div>
 *
 *      @author   Alan Heppenstall
 *      @author   David "oodavid" King
 *      @author   Andrew Bateman (modified for accessibility - no longer uses ngclipboard)
 */
angular.module('app')
  .directive('copyToClipboard', ['$timeout', function($timeout) {
    return {
      restrict: 'A', // Attribute
      scope: {
        copyToClipboard: '@',
        copyCallback: '<?',
        timeout: '<?'
      },
      link: function(scope, element) {
        var ClipboardJS = window.ClipboardJS;
        var button = element.find('button.button');
        var dialog = element.closest('.dialog');
        var clipboard;
        // If inside a dialog, attach the temporary copy container to that rather than the page body which cannot receieve focus.
        if (dialog.length > 0) {
          clipboard = new ClipboardJS(button[0], { container: dialog[0] });
        } else {
          clipboard = new ClipboardJS(button[0]);
        }
        clipboard.on('success', function(e) {
          scope.$apply(function () {
            scope.copiedSuccess(e);
          });
        });
        clipboard.on('error', function(e) {
          scope.$apply(function () {
            scope.copiedError(e);
          });
        });
        element.on('$destroy', function() {
          clipboard.destroy();
        });
      },
      replace: true,
      controller: ['$scope', '$filter', function($scope, $filter) {
        $scope.text = $scope.copyToClipboard;
        $scope.label = $filter('translate')('COPY_TO_CLIPBOARD_COPY_TEXT');
        $scope.copiedSuccess = function(event) {
          $scope.text = null;
          $scope.copiedMessage = $filter('translate')('COPIED_TO_CLIPBOARD');
          $timeout(function() {
            $scope.text = $scope.copyToClipboard;
            $scope.copiedMessage = null;
            if ($scope.copyCallback) {
              $scope.copyCallback();
            }
          }, $scope.timeout || 2000);
        };
        $scope.copiedError = function(event) {
          console.error('CopyToClipbaord - Action:', event.action, 'Trigger:', event.trigger);
        };
      }],
      template: '<div class="input">\
                  <input readonly type="text" placeholder="{{ copiedMessage }}"" ng-value="text" ng-class="{\'temp-success-indicator\': text !== copyToClipboard}">\
                  <button type="button" class="button" data-clipboard-text="{{ copyToClipboard }}" aria-label="{{ label }}">\
                    <i class="copy"></i> {{ "COPY_TO_CLIPBOARD_COPY_TEXT" | translate }}\
                  </button>\
                </div>',
    };
  }]);

},{}],197:[function(require,module,exports){
/** DROPDOWN
 *
 *   <dropdown close="close">
 *     <dropdown-button>Open The Dropdown</dropdown-button>
 *     <dropdown-content>Any content</dropdown-content>
 *   </dropdown>
 *
 *   'close' is optional and provides access to close.hide which can be called to close the menu
 *   'pop-up' is optional and defaults to false
 *   'on-show' optional function that runs as the menu is shown
 *
 */

require('../../shared/_services/uuidv4.service.js');

// Dropdown Container - logic
var dropdownComponent = {
  bindings: {
    close: '<?',
    onClose: '&',
    onShow: '&',
    focusId: '@?',
    label: '@?',
    haspopup: '@?',
    selectedBlock: '=?'
  },
  controller: dropdownComponentController,
};
dropdownComponentController.$inject = ['$element', '$scope', '$timeout', '$injector', 'uuidv4'];
function dropdownComponentController($element, $scope, $timeout, $injector, uuidv4) {
  var ctrl = this;

  ctrl.$postLink = postLink;
  ctrl.isVisible = false;
  ctrl.toggleVisibility = toggleVisibility;
  ctrl.tabInto = tabInto;
  ctrl.$onInit = onInit;

  ctrl.dropdownId = uuidv4.generate();

  var focusManager;
  var adjacentFoci;
  var usingFocusManager = $injector.has('FocusManagerService');
  if (usingFocusManager) {
    focusManager = $injector.get('FocusManagerService');
  }

  function onInit() {
    if (ctrl.close) {
      ctrl.close.hide = hide;
    }
  }

  $scope.$on('$destroy', function () {
    if (ctrl.onClose) {
      ctrl.onClose({ block: ctrl.selectedBlock });
    }
    angular.element(document).off('click', bodyClick);
    angular.element(document).off('keydown', handleKeydown);
    angular.element(document).off('scroll', handleScroll);
    angular.element(window).off('resize', handleResize);
    $element.find('dropdown-content')[0].removeEventListener('blur', checkFocus, true);
  });

  var toggleLocked = false; // To prevent click recursion
  // Toggle visibility
  function toggleVisibility(event) {
    if (toggleLocked) {
      return;
    }
    var innerButton = $element.find('dropdown-button > div [ng-click]');
    if (innerButton.length > 0) { // Ignore toggle if button content has it's own click handler
      event.preventDefault();
      event.stopImmediatePropagation();
      toggleLocked = true;
      innerButton.click();
      $timeout(function() {
        toggleLocked = false;
      }, 2000);
      return;
    }
    if (!tabbedInto) {
      $element.find('dropdown-button > div').blur(); // Hide visual tab cursor
    }
    if (ctrl.isVisible) {
      hide();
    } else {
      show();
    }
  }

  var tabbedInto = false;
  // Tab into menu
  function tabInto(event) {
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      // If there is an embedded button (ng-click) and enter or space has been pressed, click on that. This is used by the responsive menu component
      var embeddedButton = $element.find('dropdown-button > div [ng-click]');
      if (embeddedButton.length > 0) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.stopImmediatePropagation();
          event.preventDefault();
          $timeout(function () { // Delay to next digest cycle
            embeddedButton.click();
          });
        }
      } else {
        event.stopImmediatePropagation();
        event.preventDefault();
        tabbedInto = true;
        toggleVisibility();
      }
    }
  }

  // Hide and Show
  var popUp = false;
  function hide() {
    if (ctrl.isVisible) { // Hide is called externally, so this saves unnecessary processing
      if (ctrl.onClose) {
        ctrl.onClose({ block: ctrl.selectedBlock });
      }
      ctrl.isVisible = false;
      tabbedInto = false;
      popUp = false;
      if (usingFocusManager) {
        var dropdownButton = $element.find('dropdown-button > div');
        dropdownButton.attr('aria-expanded', 'false');
      }
    }
  }
  function show() {
    if (ctrl.onShow) {
      ctrl.onShow({ block: ctrl.selectedBlock  });
    }
    // If required, get adjacent focussable elements
    if (usingFocusManager) {
      var dropdownButton = $element.find('dropdown-button > div');
      dropdownButton.attr('aria-expanded', 'true');
      adjacentFoci = focusManager.getAdjacentFoci(dropdownButton);
    }
    // Calculate whether to pop up or drop down
    var buttonHeight = $element.find('dropdown-button').height();
    var availableHeightAbove = $element.offset().top - angular.element(window).scrollTop();
    var availableHeightBelow = window.innerHeight - (availableHeightAbove + buttonHeight + window.innerHeight*.08);
    popUp = availableHeightAbove > availableHeightBelow;
    ctrl.offset = popUp ? buttonHeight + 'px' : 'auto';
    ctrl.maxHeight = ((popUp ? availableHeightAbove : availableHeightBelow) - 8) + 'px';
    ctrl.isVisible = true;
    scrollToSelection();
  }

  // Utility
  function hideAndDigest() {
    $timeout(hide);
  }

  function checkFocus(event) {
    if (event.relatedTarget && !$.contains($element.find('dropdown-content')[0], event.relatedTarget)) {
      hideAndDigest();
    }
  }

  // When the event target accepts text-input, we don't trigger "close"
  var inputNodes = /textarea|input|select/i;

  // Add and remove global event listeners...
  function postLink() {
    angular.element(document).on('click', bodyClick);
    angular.element(document).on('keydown', handleKeydown);
    angular.element(document).on('scroll', handleScroll);
    angular.element(window).on('resize', handleResize);
    $element.find('dropdown-content')[0].addEventListener('blur', checkFocus, true);
    // addEventListener with 'true' because, as blur doesn't bubble, we're attaching to the event capturing phase.
    // If we need to support IE, we'll need to use 'focusin' as it doesn't support event capturing
    // See https://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
    if (usingFocusManager) { // If using the focus manager, make the div directly within the <dropdown-button> focussable
      var dropdownButton = $element.find('dropdown-button > div');
      dropdownButton.attr('role', 'button');
      dropdownButton.attr('tabindex', '0');
      if (ctrl.haspopup !== 'false') {
        dropdownButton.attr('aria-haspopup', ctrl.haspopup || 'true');
        dropdownButton.attr('aria-expanded', 'false');
        dropdownButton.attr('aria-controls', ctrl.dropdownId);
      }
    }
  }

  // Hide the content when clicking the page, or a link within the dropdown content
  function bodyClick(e) {
    $timeout(function(){
      var element = $element[0];
      var content = $element.find('dropdown-content')[0];
      if (!$.contains(element, e.target)) {
        hideAndDigest(); // The user clicked outside the element
      } else {
        if($.contains(content, e.target)) {
          // The click target was a link or an element inside a link
          if (
            e.target.nodeName.toLowerCase() === 'a'
            || angular.element(e.target).parent().prop('nodeName').toLowerCase() === 'a'
            || angular.element(e.target).parent().parent().prop('nodeName').toLowerCase() === 'a'
          ) {
            hideAndDigest(); // They clicked a link within the content
          }
        }
      }
    });
  }

  // Keyboard navigation - up and down cursor tracking requires 'role="menuitem"' or 'role="option"' attaching to each active element in the menu
  function handleKeydown(event) {
    if (ctrl.isVisible) {
      if (event.target.isContentEditable || inputNodes.test(event.target.nodeName)) {
        return; // Don't close if the target is "text-accepting"
      }
      var activeElement = document.activeElement;
      var content = $element.find('dropdown-content')[0];
      if ($.contains(content, activeElement)) { // Focus in menu content
        switch (event.which) {
          case 9:
            // Tab, if tabbing out of menu, set focus
            event.stopImmediatePropagation();
            event.preventDefault();
            hideAndDigest();
            if (adjacentFoci) {
              if (event.shiftKey) {
                adjacentFoci.previous.focus();
              } else {
                adjacentFoci.next.focus();
              }
            }
            break;
          case 27:
            // Hide, if tapping ESC
            hideAndDigest();
            // if ($.contains(content, activeElement)) { // Focus in menu content
              $element.find('dropdown-button > div').focus(); // Show visual tab cursor
            // } else {
            //   $element.find('dropdown-button > div').blur(); // Hide visual tab cursor
            // }
            break;
          case 32:
            // Select, if pressing SPACE
            event.stopImmediatePropagation();
            event.preventDefault();
            var $activeElement = $(activeElement);
            var url = $activeElement.attr('href');
            // It's not sufficient just to click on the active element
            if (url) {
              if (url.indexOf('mailto:') === 0) {
                window.location = url;
              } else {
                window.open(url, $activeElement.attr('target'));
              }
            } else {
              $activeElement.click();
            }
            break;
          case 38:
            // Up arrow
            focusMenuItem(event, 'previous');
            break;
          case 40:
            // Down arrow
            focusMenuItem(event, 'next');
            break;
        }
      } else {
        hideAndDigest();
      }
    }
  }

  // This is used to prevent menu keyboard and scrolling interaction
  // that would the cause browser to scroll and annoyingly close the menu
  var menuInteraction = false;
  function handleScroll(event) {
    if (menuInteraction) {
      event.preventDefault();
      event.stopImmediatePropagation();
      menuInteraction = false;
    } else {
      if (ctrl.isVisible) {
        hideAndDigest();
      }
    }
  }

  function handleResize() {
    if (ctrl.isVisible) {
      hideAndDigest();
    }
  }

  // Close when routing
  if ($injector.has('$transitions')) {
    var $transitions = $injector.get('$transitions');
    $transitions.onSuccess({}, function($transition) {
      hide();
    });
  }

  // Menu item <a> tags require the role "menuitem" or "option"
  var menuItems = [];

  // Scroll to selection - requires the 'selected' class to be added to a <dropdown-content> element
  function scrollToSelection() {
    $timeout(function() {
      var selection = $element.find('.selected');
      var contentDiv = $element.find('dropdown-content > div');
      menuItems = contentDiv.find('[role="menuitem"],[role="option"]:not([disabled])');
      contentDiv.on('scroll', function() {
        menuInteraction = true;
      });
      if (selection.length > 0) {
        var topPos = selection[0].offsetTop;
        contentDiv.scrollTop(topPos);
      }
      // If tabbing, set highlight to selection
      if (tabbedInto) {
        var link;
        if (selection.length > 0) {
          link = selection.find('a');
        } else {
          var links = contentDiv.find('a[href]:visible');
          link = links.first();
        }
        link.focus();
      }
    });
  }

  // Focus on the required menu item
  function focusMenuItem(event, direction) {
    if (menuItems.length > 0) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var focusIndex = 0;
      var activeElement = document.activeElement;
      var content = $element.find('dropdown-content')[0];
      var focussedItem;
      if ($.contains(content, activeElement)) {
        focussedItem = activeElement;
      } else {
        focussedItem = $element.find('.selected > a')[0];
      }
      for (var itemIndex = 0; itemIndex < menuItems.length; itemIndex++) {
        if (menuItems[itemIndex] === focussedItem) {
          focusIndex = itemIndex;
          break;
        }
      }
      if (direction === 'previous') {
        if (focusIndex > 0) {
          focusIndex--;
        }
      } else if (direction === 'next') {
        if ($.contains(content, activeElement) && focusIndex < menuItems.length - 1) {
          focusIndex++;
        }
      }
      menuItems[focusIndex].focus();
      menuInteraction = true;
    }
  }
}

// Dropdown Button - toggle the visibility
var dropdownButtonComponent = {
  require: {
    dropdown: '^dropdown',
  },
  transclude: true,
  template: '<div ng-click="$ctrl.dropdown.toggleVisibility($event)" ng-keydown="$ctrl.dropdown.tabInto($event)" ng-attr-focus-id="{{ $ctrl.dropdown.focusId }}" ng-transclude></div>',
};

// Dropdown Content - simply obeys the state of the component
var dropdownContentComponent = {
  require: {
    dropdown: '^dropdown',
  },
  transclude: true,
  template: '<div ng-attr-id="{{ $ctrl.dropdown.dropdownId }}" class="animate-slide" ng-if="$ctrl.dropdown.isVisible" ng-style="{ \'max-height\': $ctrl.dropdown.maxHeight, bottom: $ctrl.dropdown.offset }" ng-transclude role="group" ng-attr-aria-label="{{ $ctrl.dropdown.label }}"></div>',
};

angular
  .module('app')
  .component('dropdown', dropdownComponent)
  .component('dropdownButton', dropdownButtonComponent)
  .component('dropdownContent', dropdownContentComponent);

},{"../../shared/_services/uuidv4.service.js":177}],198:[function(require,module,exports){
/** EMBED APP
 *
 *   <embed-app app="dashboard" route="route">
 *   </embed-app>
 *
 *    @author Andrew Bateman
 */
var embedAppComponent = {
  controller: embedAppComponentController,
  bindings: {
    app: '<app',
    route: '<route',
    asRoute: '<asRoute',
    asSubRoute: '<asSubRoute',
    asFeatureRoute: '<asFeatureRoute',
    asFullPageRoute: '<asFullPageRoute',
    asFullPageOverlay: '<asFullPageOverlay',
    queryParams: '<queryParams',
    department: '<department',
    user: '<user',
    apiKeys: '<apiKeys',
  },
  templateUrl: '/shared/embed-app/embed-app.html',
};

embedAppComponentController.$inject = ['$scope', '$sce', '$state', '$window', '$element', '_', 'swalService', 'AuthService', 'AuthRedirectService', 'ENV', 'AnalyticsService', 'PermissionsService', 'alertService', '$timeout', '$location', '$rootScope', '$injector', '$transitions', 'EmbedAppService', 'ApiSettingsService', 'CertificateEditorService', 'BadgeEditorService', 'DesignSelectorService', 'CredentialPreviewService', 'DepartmentService'];

function embedAppComponentController($scope, $sce, $state, $window, $element, _, swalService, AuthService, AuthRedirectService, ENV, AnalyticsService, PermissionsService, alertService, $timeout, $location, $rootScope, $injector, $transitions, EmbedAppService, ApiSettingsService, CertificateEditorService, BadgeEditorService, DesignSelectorService, CredentialPreviewService, DepartmentService) {
  var ctrl = this;
  var authorization = localStorage.getItem('authorization');
  var jwt = authorization ? authorization.substring(7) : null; // Remove 'Bearer ' from the beginning of the authorization

  var OrganizationService = $injector.get('OrganizationService');
  var organization = OrganizationService.getOrganizationImmediate();
  var lastSyncedPath = null;
  var deregisterTransitionHook = null;

  ctrl.$onInit = onInit;
  $scope.$on('$destroy', onDestroy);

  ctrl.getAppUrl = getAppUrl;
  ctrl.messageEventListner = messageEventListener;
  ctrl.enableDesignSelector = false;
  ctrl.enableCertificateEditor = false;
  ctrl.enableBadgeEditor = false;
  ctrl.enableCredentialPreview = false;

  /** @returns {string|null} V2 path within this embed, e.g. department/general-settings */
  function getFeatureRoutePath(fromPath) {
    if (!ctrl.route) {
      return null;
    }
    var path = (fromPath || $location.path()).split('?')[0];
    var marker = '/' + ctrl.route;
    var routeIndex = path.indexOf(marker);
    if (routeIndex === -1) {
      return null;
    }
    return path.substring(routeIndex + 1);
  }

  /** Keep the V2 iframe in sync when V1 changes child states (iframe src is not reloaded). */
  function syncRouteToV2() {
    if (!ctrl.asFeatureRoute) {
      return;
    }

    var iframe = document.querySelector('iframe.host-window');
    if (!iframe || !iframe.contentWindow) {
      return;
    }

    var route = getFeatureRoutePath();
    if (!route || route === lastSyncedPath) {
      return;
    }

    lastSyncedPath = route;
    iframe.contentWindow.postMessage({
      type: 'routing',
      payload: {
        path: route,
        queryParams: $location.search()
      }
    }, ENV.v2Domains[ctrl.app]);
  }

  function onInit() {
    ctrl.url = ctrl.getAppUrl();

    if (ctrl.asRoute) {
      $element.addClass('as-route');
      // We need to add overflow: hidden; to the body when on a full embed page to not have 2 scrolls.
      document.body.style.overflow = 'hidden';
    } else if (ctrl.asSubRoute) {
      $element.addClass('as-sub-route');
      // We need to add overflow: hidden; to the body when on a full embed page to not have 2 scrolls.
      document.body.style.overflow = 'hidden';
    } else if (ctrl.asFullPageRoute) {
      $element.addClass('as-full-page-route');
      // We need to add overflow: hidden; to the body when on a full embed page to not have 2 scrolls.
      document.body.style.overflow = 'hidden';
    } else if (ctrl.asFullPageOverlay) {
      $element.addClass('as-full-page-overlay');
      // We need to add overflow: hidden; to the body when on a full embed page to not have 2 scrolls.
      document.body.style.overflow = 'hidden';
    }

    $window.addEventListener('message', messageEventListener, false);

    if (ctrl.asFeatureRoute) {
      deregisterTransitionHook = $transitions.onSuccess({}, function() {
        syncRouteToV2();
      });
    }
  }

  function onDestroy() {
    $window.removeEventListener('message', messageEventListener, false);
    if (deregisterTransitionHook) {
      deregisterTransitionHook();
      deregisterTransitionHook = null;
    }
    document.body.style.overflow = null;
  }

  function messageEventListener(event) {
    if (event.origin !== ENV.v2Domains[ctrl.app]) {
      return;
    }

    switch (event.data.type) {
      case 'signIn':
        AuthService
          .injectAuthentication(event.data.payload.data)
          .then(function(issuer){
            var isDepartmentMfaEnabled = issuer.department.security_setting && issuer.department.security_setting.mfa_enabled;
            var hasUserMfaConfigured = issuer.user.mfa_settings && issuer.user.mfa_settings.configured;

            // If department has MFA enabled but issuer doesn't have MFA configured send user to MFA setup page
            if (isDepartmentMfaEnabled && !hasUserMfaConfigured) {
              $state.go('issuer.mfa.mfa-setup');
            } else if (issuer && issuer.user) {
              AuthRedirectService.go('issuer.dashboard.home');
            } else {
              throw('No user returned');
            }
          })
          .catch(function(err){
            console.log('Error: ', err);
            swalService.showAlert('issuerLoginFailure');
          });
        break;

      case 'redirect':
        var url = event.data.payload.data;
        window.location.href = url;
        break;

      case 'navigate':
        var stateParams = { id: event.data.payload.id };
        if (event.data.payload.routeParams) {
          Object.assign(stateParams, event.data.payload.routeParams);
        }

        if (event.data.payload.resetQueryParams) {
          $location.search({});
        }

        // V2 already navigated — mark path synced so onSuccess does not post routing back.
        var targetHref = $state.href(event.data.payload.route, stateParams);
        var targetPath = getFeatureRoutePath(targetHref);
        if (targetPath) {
          lastSyncedPath = targetPath;
        }

        if (event.data.payload.isNavigatingFromV2ToV1) {
          $state.go(event.data.payload.route, stateParams, { inherit: false });
        } else {
          $state.go(event.data.payload.route, stateParams, {
            location: 'replace',
            inherit: false,
          });
        }
        break;

      case 'bodyClick':
        document.body.click();
        break;

      case 'trackEvent':
        AnalyticsService.trackEvent(event.data.payload.data);
        break;

      case 'authenticate':
        syncRouteToV2();

        document.querySelector('iframe.host-window').contentWindow.postMessage({
          type: 'auth',
          payload: jwt
        }, ENV.v2Domains[ctrl.app]);
        break;

      case 'processData':
        onProcessData(event.data.payload);
        break;

      case '401':
        AuthService.reset(); // Reset
        swalService.showAlert('issuerMustLogin'); // Show a message
        $state.go('issuer.login'); // Redirect
        break;
    }
  }

  function getAppUrl() {
    var url = ENV.v2Domains[ctrl.app] + '/' + (ctrl.route ? ctrl.route : '') + '?origin=' + $window.location.origin;
    if (ctrl.queryParams) {
      url += '&' + ctrl.queryParams;
    }
    return $sce.trustAsResourceUrl(url);
  }

  /**
   * This method is adapted from another part of the codebase (the permissions.directive.js file)
   * This was because the old code did not support navigating from a link on the
   * V2 dashboard to a link in the V1 dashboard. An example of this happening is in the
   * Analytics overview page, inside the top 5 influencers component
   */
  function showPaywallAlert() {
    var image = '<img src="/images/features/is_customer.png" width="180" height="180">';
    var title = 'This is a Premium Feature';
    var description = '<p>This feature is only available to premium customers.</p><p>To learn more about the available premium features and get a custom quote for a premium plan, see the...</p>';
    var pricingLinkTitle = 'Accredible pricing page';
    var hasBillingPermission = (!!PermissionsService.getPermission('billing'));

    if(!hasBillingPermission){
      description += '<p>Please contact your administrator to enable this feature.</p>';
    }
    description += '<p><a href="https://www.accredible.com/pricing/" target="_blank">' + pricingLinkTitle + '</a></p>';
    var html = '<div class="grid align-middle permissions-modal">';
    html += '<div>'+description+'</div>';
    html += '<div class="cling"><p>'+image+'</p></div>';
    html += '</div>';
    if(hasBillingPermission){
      alertService
        .open({
          title: title,
          content: html,
          ok: 'View your current plan',
          cancel: true,
        })
        .then(function() {
          $timeout(function(){
            $state.go('issuer.dashboard.billing.status');
          });
        })
        .catch(angular.noop);
    } else {
      alertService
        .alert(title, html);
    }
  }

  function onProcessData(payload) {
    switch(payload.action) {
      case 'viewGroupPreview':
        ctrl.enableCredentialPreview = true;
        CredentialPreviewService.showPreviewModal(payload.data.group).then(function() {
          ctrl.enableCredentialPreview = false;
        });
        break;

      case 'selectDesign':
        ctrl.enableDesignSelector = true;
        DesignSelectorService
          .open(payload.data.kind, payload.data.groupId)
          .then(function(design) {
            ctrl.enableDesignSelector = false;
            if (design && design.create) {
              _createDesign(design.kind);
            } else {
              _sendDesignToV2({ action: payload.data.kind === 'badge' ? 'selectedBadgeDesign' : 'selectedCertificateDesign', design: design });
            }
          });
        break;

      case 'editDesign':
        _editDesign(payload.data.design);
        break;

      case 'createDesign':
        _createDesign(payload.data.kind);
        break;

      case 'departmentAction':
        $rootScope.$broadcast('departments:refresh', { action: payload.data.action, department: payload.data.department });
      break;

      case 'getIntegrationsInfo':
        ApiSettingsService
        .getApiKeys()
        .then(function(apiKeys){
          document.querySelector('iframe.host-window').contentWindow.postMessage({
            type: 'data',
            payload: {
              action: payload.action,
              data: {
                apiKey: apiKeys.api_key,
                consumerKey: apiKeys.consumer_key,
                consumerSecret: apiKeys.consumer_secret
              }
            }
          }, ENV.v2Domains[ctrl.app]);
        })
        .catch(function(err) {
          console.log('Error: ', err);
        });
        break;

      case 'getIssuerInfo':
        if (ctrl.department) {
          document.querySelector('iframe.host-window').contentWindow.postMessage({
            type: 'data',
            payload: {
              action: payload.action,
              data: {
                departmentId: ctrl.department.id,
                isAdmin: PermissionsService.getPermission('admin'),
                apiPermission: PermissionsService.getPermission('api'),
                issuerLoginId: ctrl.user.id,
                corporation: organization,
                kind: PermissionsService.getKind(),
                access_level: PermissionsService.getAccessLevel()
              }
            }
          }, ENV.v2Domains[ctrl.app]);
        }
        break;

      case 'credentialsListData':
        var data = EmbedAppService.getData();
        if (data) {
          document.querySelector('iframe.host-window').contentWindow.postMessage({
            type: 'data',
            payload: {
              action: 'credentialsListData',
              data: data,
            },
          }, ENV.v2Domains[ctrl.app]);
          EmbedAppService.setData(null);
        }
        break;

      case 'selectDepartment':
        DepartmentService
        .switchDepartment(payload.data.departmentId)
        .then(function(){
          AuthRedirectService.go('issuer.dashboard.home');
          alertService.close();
        })
        .catch(function(){
          alertService
            .alert('We could not switch to this department');
        });
          break;

      case 'switchDepartment':
        DepartmentService
        .switchDepartment(payload.data.departmentId)
        .then(function(){
          document.querySelector('iframe.host-window').contentWindow.postMessage({
            type: 'data',
            payload: {
              action: 'switchDepartment',
              data: {
                departmentId: payload.data.departmentId,
              },
            },
          }, ENV.v2Domains[ctrl.app]);
        
        })
        .catch(function(){
          alertService
            .alert('We could not switch to this department');
      });
      break;
      }
    }

  function _createDesign(kind) {
    if (kind === 'badge') {
      ctrl.enableBadgeEditor = true;
      BadgeEditorService.open().then(function (badgeDesign) {
        ctrl.enableBadgeEditor = false;
        _sendDesignToV2({ action: 'editedBadgeDesign', design: badgeDesign });
      });
    } else {
      ctrl.enableCertificateEditor = true;
      CertificateEditorService.open().then(function (certificateDesign) {
        ctrl.enableCertificateEditor = false;
        _sendDesignToV2({ action: 'editedCertificateDesign', design: certificateDesign });
      });
    }
  }


  function _editDesign(design) {
    if (design.kind === 'badge') {
      ctrl.enableBadgeEditor = true;
      BadgeEditorService.open(design).then(function (badgeDesign) {
        ctrl.enableBadgeEditor = false;
        _sendDesignToV2({ action: 'editedBadgeDesign', design: badgeDesign });
      });
    } else {
      ctrl.enableCertificateEditor = true;
      CertificateEditorService.open(design).then(function (certificateDesign) {
        ctrl.enableCertificateEditor = false;
        _sendDesignToV2({ action: 'editedCertificateDesign', design: certificateDesign });
      });
    }
  }

  function _sendDesignToV2(design) {
    document.querySelector('iframe.host-window').contentWindow.postMessage({
      type: 'data',
      payload: {
        action: design.action,
        data: design.design
      }
    }, ENV.v2Domains[ctrl.app]);
  }
}

angular
  .module('app')
  .component('embedApp', embedAppComponent);

},{}],199:[function(require,module,exports){
/**
 * This service is to be used when using ui-sref to navigate to a V2 page and data needs to sent to V2
 * Use this service to save that data and then use V2 to get this data using the 'processData' postMessage type.
 *
 * Ex:
 *      1. Navigate using ui-sref
 *         <a ui-sref="issuer.dashboard.V2route"
 *           ng-click="$ctrl.setData(data)">
 *         </a>
 *
 *         function setData(data) {
 *           EmbedAppService.setData(data);
 *         }
 */

EmbedAppService.$inject = [];
function EmbedAppService() {
  var service = this;
  service.getData = getData;
  service.setData = setData;

  var _data = null;

  function getData() {
    return _data;
  }

  function setData(filters) {
    _data = filters;
  }
}

angular
  .module('app')
  .service('EmbedAppService', EmbedAppService);

},{}],200:[function(require,module,exports){
angular
  .module('app')
  .directive('iframeOnload', [function(){
    return {
      scope: {
        callBack: '&iframeOnload'
      },
      link: function(scope, element, attrs){
        element.on('load', function(){
          return scope.callBack();
        })
      }
    }}]);

},{}],201:[function(require,module,exports){
/** EMBOLDEN FILTER
 *
 *    Replaces *Text* with <strong>Text</strong> and _Text_ with <em>Text</em>
 *
 *    @author   Andrew Bateman
 */
require('../shared/_services/encode.service.js');

angular
  .module('app')
  .filter('embolden', ['encodeService', '$sce', function (encodeService, $sce) {
    return function (input) {
      input = encodeService.encode(input); // Don't trust any tags
      input = input.replace(/\*(.*?)\*/g, '<strong>$1</strong>'); // Replace pairs of `*` with a <strong> tag
      input = input.replace(/_(.*?)_/g, '<em>$1</em>'); // Replace pairs of `_` with a <em> tag
      input = input.replace(/@@(.*?)@@/g, '<a>$1</a>'); // Replace pairs of `@@` with a <a> tag
      return $sce.getTrustedHtml(input); // Trust our new tags
    };
  }])
  .directive('translateAndEmbolden', ['$filter', '$sce', '$rootScope', function ($filter, $sce, $rootScope) {
    return {
      restrict: 'A',
      link: function postLink(scope, element, attrs) {
        var translate = $filter('translate');
        var embolden = $filter('embolden');
        function doTranslateAndEmbolden() {
          var message = embolden(translate(attrs.translateAndEmbolden, attrs.translateValues));
          element.html($sce.valueOf(message));
        }
        doTranslateAndEmbolden();
        // Handle language changing
        var unhookMonitorLanguage = $rootScope.$on('$translateChangeSuccess', doTranslateAndEmbolden);
        scope.$on('$destroy', function () {
          unhookMonitorLanguage();
        });
      }
    };
  }]);

},{"../shared/_services/encode.service.js":166}],202:[function(require,module,exports){

angular.module('app')
  .directive('badgeEvidence', function() {

    var linker = function(scope) {
          var evidence = scope.evidence;
    };

    return {
      restrict: 'A',
      link: linker,
      scope: {
        'evidence': '='
      },
      templateUrl: '/shared/evidence/badge/badgeView.html'
    };
  });

},{}],203:[function(require,module,exports){

angular.module('app')
  .directive('durationEvidence', function() {
    return {
      restrict: 'A',
      templateUrl: '/shared/evidence/duration/durationView.html'
    };
  });

},{}],204:[function(require,module,exports){
/** EVIDENCE SERVICE
 *
 *      This service handles various actions for Evidence and
 *       deals with messaging (where appropriate) via the alertService.
 *
 *      Each method returns a promise and automatically handles
 *       success and error responses via the alertService.
 *
 *      @author  David "oodavid" King
 */
EvidenceService.$inject = ['$q', '$timeout', 'api', '_', 'alertService'];
function EvidenceService($q, $timeout, api, _, alertService) {
  var service = this;
  service.upsert = upsertEvidence;
  service.reorder = reorderEvidence;
  service.delete = deleteEvidence;
  service.fetchInsights = fetchInsights;
  service.deleteEvidenceItem = deleteEvidenceItem;

  /** UPSERT
   *
   *      Creates -OR- Updates Evidence for a Credential.
   *
   *      In the presence of an id, we assume it's an Update
   *       without an id, assume Create.
   */
  function upsertEvidence(credential, evidence) {
    return $q(function(resolve, reject) {
      var method = '/user/evidence/' + (evidence.id ? 'update' : 'create');
      api.request(method, {
          credential_id: credential.id,
          evidence_item: evidence,
        })
        .then(function(response) {
          // Update the credential object to reflect the new / updated evidence
          var evidence_item = response.evidence_item || {};
          var index = _.findIndex(credential.evidence_items, {
            'id': evidence_item.id
          });
          if (index === -1) {
            credential.evidence_items.push(evidence_item);
            index = credential.evidence_items.length - 1;
          } else {
            credential.evidence_items[index] = evidence_item;
          }
          // Flag it as "loading" for a couple of seconds, while preview images etc. are generated
          credential.evidence_items[index].loading = true;
          $timeout(function() {
            credential.evidence_items[index].loading = false;
          }, 2000);
          // Notify
          alertService.success('@:SUCCESS', '@:UPSERT_EVIDENCE_SUCCESS_MESSAGE');
          resolve(response);
        })
        .catch(function(err) {
          if (err.data && err.data.errors && err.data.errors.file_content_type) {
            alertService.warning('@:UPSERT_EVIDENCE_FAILURE_INVALID_FILE_TYPE');
          } else {
            alertService.warning('@:DELETE_EVIDENCE_FAILURE_MESSAGE', err.data.errors);
          }
          reject(err);
        });
    });
  }

  /** RE-ORDER
   *
   *      Re-orders the Evidence on a Credential object.
   */
  function reorderEvidence(credential, evidence_items) {
    return $q(function(resolve, reject) {
      api.request('/user/credentials/reorder_evidence', {
          credential_id: credential.id,
          evidence_items: evidence_items,
        })
        .then(function(response) {
          resolve(response);
        })
        .catch(function(err) {
          alertService.warning('Unkown Failure', '002');
          reject(err);
        });
    });
  }

  /** DELETE
   *
   *      Deletes Evidence from a Credential.
   */
  function deleteEvidence(credential, evidence) {
    return $q(function(resolve, reject) {
      api.request('/user/evidence/delete', {
          credential_id: credential.id,
          id: evidence.id,
        })
        .then(function(response) {
          var index = _.findIndex(credential.evidence_items, {
            'id': evidence.id
          });
          if (index !== -1) {
            credential.evidence_items.splice(index, 1);
          }
          alertService.success('@:DELETE_EVIDENCE_SUCCESS_HEADER', '@:DELETE_EVIDENCE_SUCCESS_MESSAGE');
          resolve(response);
        })
        .catch(function(err) {
          alertService.warning('@:DELETE_EVIDENCE_FAILURE_MESSAGE', err);
          reject(err);
        });
    });
  }

  // Fetches evidence insights from the server - second param is just to say that we're showing on a credential
  function fetchInsights(evidence_id) {
    return api
      .request('/frontend/evidence_insights/<id>', {
        id: evidence_id,
        credential_display: true,
      })
      .then(function(response) {
        return response.evidence_item.insight;
      });
  }

  function deleteEvidenceItem(evidence, credential) {
    return api
      .request('/credential/evidence_item_delete/<id>', {
        id: evidence.id,
      })
      .then(function(response) {
        for (var i = credential.evidence_items.length - 1; i >= 0; i--) {
          if (credential.evidence_items[i].id === response.evidence_item.id) {
            credential.evidence_items.splice(i, 1);
          }
        }
        return credential;
      });
  }

}

angular
  .module('app')
  .service('EvidenceService', EvidenceService);

},{}],205:[function(require,module,exports){
/** EVIDENCE CONTROLLER
 *
 *      This controller is applied to the Evidence grid; ie,
 *       "n" Evidence Items.
 *
 *      @author  David "oodavid" King
 */
angular.module('app')
  .controller('EvidenceCtrl', ['$scope', 'EvidenceService', 'trackingService', function($scope, EvidenceService, trackingService) {

    /** ON SORT
     *
     *    Allows the user to sort their Evidence
     */
    $scope.onEvidenceSort = function($item, $part, $index, $helper) {
      var evidence_items = [];
      for (var i = 0; i < $scope.credential.evidence_items.length; i++) {
        $scope.credential.evidence_items[i].position = i + 1;
        evidence_items.push({
          id: $scope.credential.evidence_items[i].id,
          position: i + 1
        });
      }
      EvidenceService.reorder($scope.credential, evidence_items);
    };
  }]);

},{}],206:[function(require,module,exports){
angular.module('app').directive('evidenceItem', [
  '$compile',
  function($compile) {
    var evidenceMap = {
      badge: {
        directive: 'badge-evidence',
        clickable: false
      },
      course_duration: {
        directive: 'duration-evidence',
        clickable: false
      },
      file: {
        directive: 'file-evidence',
        clickable: true
      },
      url: {
        directive: 'url-evidence',
        clickable: true
      },
      url_no_screenshot: {
        directive: 'url-evidence',
        clickable: true
      },
      grade: {
        directive: 'grade-evidence',
        clickable: false
      },
      miriada_custom_reference: {
        directive: 'miriada-performance-evidence',
        clickable: false
      },
      miriada_grade: {
        directive: 'miriada-grade-evidence',
        clickable: false
      },
      miriada_outline: {
        directive: 'miriada-outline-evidence',
        clickable: true
      },
      miriada_participation: {
        directive: 'miriada-participation-evidence',
        clickable: false
      },
      miriada_teacher_outline: {
        directive: 'miriada-teacher-outline-evidence',
        clickable: true
      },
      project: {
        directive: 'project-evidence',
        clickable: true
      },
      static_text: {
        directive: 'static-text',
        clickable: true
      },
      table: {
        directive: 'table-evidence',
        clickable: true
      },
      transcript: {
        directive: 'transcript-evidence',
        clickable: true
      },
      portfolio: {
        directive: 'portfolio-evidence',
        clickable: true
      },
      video: {
        directive: 'video-evidence',
        clickable: true
      },
      video_embed: {
        directive: 'video-embed-evidence',
        clickable: true
      },
      language_grade: {
        directive: 'language-grade-evidence',
        clickable: false
      }
    };

    var linker = function link(scope, element) {
      var evidenceType = evidenceMap[scope.category]
        ? evidenceMap[scope.category].directive
        : 'url-evidence';
      scope.evidence.clickable = evidenceMap[scope.category]
        ? evidenceMap[scope.category].clickable
        : true;

      //show grades with a breakdown as clickable
      if (
        scope.category === 'grade' &&
        scope.evidence.string_object &&
        scope.evidence.string_object.grade_breakup
      ) {
        scope.evidence.clickable = true;
      }

      element.attr(evidenceType, '');
      element.removeAttr('evidence-item');
      $compile(element)(scope);
    };

    return {
      restrict: 'A',
      replace: false,
      scope: {
        category: '=',
        evidence: '=',
        credential: '='
      },
      link: linker
    };
  }
]);

},{}],207:[function(require,module,exports){

angular.module('app')
  .factory('evidenceModalService', ['$uibModal', function($uibModal) {
    var showVideo;
    var evidenceModal;

    var triggerVideoModal = function(scope) {
      showVideo = true;
      evidenceModal = $uibModal.open({
        animation: true,
        windowClass: 'user-modal video-modal',
        templateUrl: '/shared/evidence/video/video_modal.html',
        scope: scope,
        size: 'lg',
        backdrop: 'static',
        ariaLabelledBy: 'modal-title'
      });
    };

    var triggerTranscriptModal = function(scope) {
      evidenceModal = $uibModal.open({
        animation: true,
        windowClass: 'user-modal transcript-modal',
        templateUrl: '/shared/evidence/transcript/transcript_modal.html',
        scope: scope,
        ariaLabelledBy: 'modal-title'
      });
    };

    var triggerGradeModal = function(scope) {
      evidenceModal = $uibModal.open({
        animation: true,
        windowClass: 'user-modal',
        templateUrl: '/shared/evidence/grade/grade_modal.html',
        scope: scope,
        ariaLabelledBy: 'modal-title'
      });
    };

    var triggerPortfolioModal = function(scope) {
      evidenceModal = $uibModal.open({
        animation: true,
        windowClass: 'user-modal portfolio-modal',
        templateUrl: '/shared/evidence/portfolio/portfolio_modal.html',
        scope: scope,
        ariaLabelledBy: 'modal-title'
      });
    };

    var triggerTableModal = function(scope) {
      evidenceModal = $uibModal.open({
        animation: true,
        windowClass: 'user-modal',
        templateUrl: '/shared/evidence/table/table_modal.html',
        scope: scope,
        ariaLabelledBy: 'modal-title'
      });
    };

    var triggerTextModal = function(scope) {
      evidenceModal = $uibModal.open({
        animation: true,
        windowClass: 'user-modal',
        templateUrl: '/shared/evidence/text/static_text_modal.html',
        scope: scope,
        ariaLabelledBy: 'modal-title'
      });
    };

    var triggerVideoEmbedModal = function(scope) {
      showVideo = true;
      evidenceModal = $uibModal.open({
        animation: true,
        windowClass: 'user-modal video-modal',
        templateUrl: '/shared/evidence/video/video_embed_modal.html',
        scope: scope,
        size: 'lg',
        backdrop: 'static',
        ariaLabelledBy: 'modal-title'
      });
    };

    var triggerMiriadaOutlineModal = function(scope) {
      evidenceModal = $uibModal.open({
        animation: true,
        windowClass: 'user-modal',
        templateUrl: '/shared/evidence/miriada/miriada_outline_modal.html',
        scope: scope,
        ariaLabelledBy: 'modal-title'
      });
    };

    var triggerMiriadaTeacherModal = function(scope) {
      evidenceModal = $uibModal.open({
        animation: true,
        windowClass: 'user-modal',
        templateUrl: '/shared/evidence/miriada/miriada_teacher_modal.html',
        scope: scope,
        ariaLabelledBy: 'modal-title'
      });
    };

    var isVideoShowing = function() {
      return showVideo;
    };

    var hideVideo = function() {
      evidenceModal.close();
      showVideo = false;
    };

    // Return the service
    var evidenceModalService = {
      "isVideoShowing": isVideoShowing,
      "hideVideo": hideVideo,
      "triggerVideoModal": triggerVideoModal,
      "triggerTranscriptModal": triggerTranscriptModal,
      "triggerGradeModal": triggerGradeModal,
      "triggerPortfolioModal": triggerPortfolioModal,
      "triggerTableModal": triggerTableModal,
      "triggerTextModal": triggerTextModal,
      "triggerVideoEmbedModal": triggerVideoEmbedModal,
      "triggerMiriadaOutlineModal": triggerMiriadaOutlineModal,
      "triggerMiriadaTeacherModal": triggerMiriadaTeacherModal
    };
    return evidenceModalService;
  }]);

},{}],208:[function(require,module,exports){

angular.module('app')
  .directive('fileEvidence', function() {

    var fileTypeDictionary = {
      'code': {
        'coloring': 'ev-code',
        'icon': 'code',
        'preview': false
      },
      'doc': {
        'coloring': 'ev-doc',
        'icon': 'file',
        'preview': false
      },
      // Show preview of the image
      'img': {
        'coloring': null,
        'icon': null,
        'preview': true
      },
      'pdf': {
        'coloring': 'ev-pdf',
        'icon': 'pdf',
        'preview': false
      },
      'ppt': {
        'coloring': 'ev-pdf', //'ev-ppt',
        'icon': 'analytics-summary',
        'preview': false
      },
      'xls': {
        'coloring': 'ev-spreadsheet',
        'icon': 'spreadsheet',
        'preview': false
      },
      'zip': {
        'coloring': 'ev-zip',
        'icon': 'all-groups',
        'preview': false
      }
    };

    function matchFileType (fileType) {
      var defaultIconFallback = { 'coloring': 'ev-doc', 'icon': 'file' };
      if(fileType) {
        if       (fileType.match(/pdf/i)) {
          return fileTypeDictionary.pdf;
        }
        else if (fileType.match(/powerpoint/i)) {
          return fileTypeDictionary.ppt;
        }
        else if (fileType.match(/word/i)) {
          return fileTypeDictionary.doc;
        }
        else if (fileType.match(/excel/i)) {
          return fileTypeDictionary.xls;
        }
        else if (fileType.match(/image/i)) {
          return fileTypeDictionary.img;
        }
        else if (fileType.match(/text/i)) {
          return fileTypeDictionary.doc;
        }
        else if (fileType.match(/zip/i)) {
          return fileTypeDictionary.zip;
        }
        else {
          return defaultIconFallback;
        }
      } else {
        return defaultIconFallback;
      }
    }

    var linker = function(scope) {
      var evidence = scope.evidence;
      var fileType = matchFileType(evidence.file_type);
      evidence.coloring = fileType.coloring;
      evidence.icon = fileType.icon;
      evidence.preview = fileType.preview;
    };

    return {
      restrict: 'A',
      link: linker,
      scope: {
        'evidence': '='
      },
      templateUrl: '/shared/evidence/file/fileView.html'
    };
  });

},{}],209:[function(require,module,exports){

angular.module('app')
  .directive('gradeEvidence', ['$compile', 'evidenceModalService', function($compile, evidenceModalService) {
    var linker = function(scope) {
      scope.getGradeSlider = function(grade) {
        // (grade_ratio * size_of_curve) + left_side_margin
        var sliderPos = (((grade / 100) * 67) + 15.5)+"%";
        return { left: sliderPos };
      };

      scope.showGradeModal = function () {
        evidenceModalService.triggerGradeModal(scope);
      };
    };

    return {
      restrict: 'A',
      link: linker,
      templateUrl: '/shared/evidence/grade/gradeView.html'
    };
  }]);

},{}],210:[function(require,module,exports){

angular.module('app')
  .directive('languageGradeEvidence', function() {
    return {
      restrict: 'A',
      templateUrl: '/shared/evidence/language-grade/languageGradeView.html'
    };
  });

},{}],211:[function(require,module,exports){

angular.module('app')
  .directive('miriadaGradeEvidence', ['api', function(api) {

    var linker = function(scope) {
      var rawGrades = [];
      // histogram is an array of buckets with the format [label, count]
      var rawHistogram = [[0,0],[10,0],[20,0],[30,0],[40,0],[50,0],[60,0],[70,0],[80,0],[90,0]];
      var maxCount = 1;
      var gradeBucket = Math.min( Math.floor( parseInt(scope.evidence.string_object) / 10 ) * 10, 90 );

      api.request('/frontend/all_grades', { credential_id: scope.credential.id })
        .then(function (response) {
          rawGrades = response.frontend;
          // generate histogram
          var min = 100, max = 0;
          for (var i = rawGrades.length - 1; i >= 0; i--) {
            min = Math.min(min, rawGrades[i]);
            max = Math.max(max, rawGrades[i]);
            var bucket = Math.min( Math.floor(rawGrades[i] / 10), 9 );
            rawHistogram[bucket][1] += 1;
            maxCount = Math.max(maxCount, rawHistogram[bucket][1]);
          }
          if((max - min) > 20) {
            // find the left-most and right-most buckets with counts > 0
            var lastUnemptyBucket = rawHistogram.length, firstUnemptyBucket = 0;
            for (var k = rawHistogram.length - 1; k >= 0; k--) {
              if(rawHistogram[k][1] > 0) {
                lastUnemptyBucket = k + 1;
                break;
              }
            }
            for (var l = 0; l < rawHistogram.length; l++) {
              if(rawHistogram[l][1] > 0) {
                firstUnemptyBucket = l;
                break;
              }
            }
            scope.evidence.histogram = rawHistogram.slice(firstUnemptyBucket, lastUnemptyBucket);
            scope.evidence.histogramLoaded = true;
          } else {
            scope.evidence.justShowGrade = true;
          }
        });

      scope.getBarStyle = function(bucket, index) {
        var numberOfBars = scope.evidence.histogram.length;
        var barHeight, barWidth, barMargin, barLeft;
        barHeight = Math.ceil((bucket[1] / maxCount) * 100);
        barWidth = 80 / numberOfBars;
        if(index === 0) {
          barMargin = 0;
        } else {
          barMargin = 20 / (numberOfBars-1);
        }
        barLeft = index * (barWidth + barMargin);
        return {
          "height": barHeight+"%",
          "width": barWidth+"%",
          "left": barLeft+"%",
          "background-color": bucket[0] === gradeBucket ? 'orange' : '#12A7C1'
        };
      };
    };

    return {
      restrict: 'A',
      link: linker,
      templateUrl: '/shared/evidence/miriada/miriadaGradeView.html'
    };
  }]);

},{}],212:[function(require,module,exports){

angular.module('app')
  .directive('miriadaOutlineEvidence', ['$compile', 'evidenceModalService', function($compile, evidenceModalService) {
    var linker = function(scope) {
      scope.showMiriadaOutlineModal = function () {
        evidenceModalService.triggerMiriadaOutlineModal(scope);
      };
    };

    return {
      restrict: 'A',
      link: linker,
      templateUrl: '/shared/evidence/miriada/miriadaOutlineView.html'
    };
  }]);

},{}],213:[function(require,module,exports){

angular.module('app')
  .directive('miriadaParticipationEvidence', function() {
    return {
      restrict: 'A',
      templateUrl: '/shared/evidence/miriada/studentParticipationView.html'
    };
  });

},{}],214:[function(require,module,exports){

angular.module('app')
  .directive('miriadaPerformanceEvidence', function() {
    return {
      restrict: 'A',
      templateUrl: '/shared/evidence/miriada/studentPerformanceView.html'
    };
  });

},{}],215:[function(require,module,exports){

angular.module('app')
  .directive('miriadaTeacherOutlineEvidence', ['$compile', 'evidenceModalService', function($compile, evidenceModalService) {
    var linker = function(scope) {
      scope.showMiriadaTeacherModal = function () {
        evidenceModalService.triggerMiriadaTeacherModal(scope);
      };
    };

    return {
      restrict: 'A',
      link: linker,
      templateUrl: '/shared/evidence/miriada/miriadaTeacherOutlineView.html'
    };
  }]);

},{}],216:[function(require,module,exports){
/** EVIDENCE INSIGHTS
 *
 *     These are the additional lines of text that accompany
 *      individual Evidence Items.
 */
angular.module('app')
    .directive('accInsights', function() {
        var defaultIcon  = 'icon';
        var insightIcons = {
            'average score': 'graph',
            'count':         'editor-list-ol',        // portfolio - "has 2 items"
            'date':          'date',
            'description':   'editor-align-left',
            'duration':      'time',
            'end_date':      'course-link',
            'items':         'list',        // transcript :: "4 Homework, 1 Exam"
            'percentile':    'credential-engagement', // grade :: "In top 75%"
            'skills':        'list', // HTML, CSS, Java
            'start_date':    'date',
            'time to read':  'time',                  // file :: "Time to Read 18 minutes"
            'word count':    'editor-list-ol',        // file :: "The file has 4737 words"
            'top score':     'trophy',                // transcript :: "Top Score of 80.0 in 1"
        };
        var InsightCtrl = ['$scope', 'EvidenceService', '$state', 'evidenceModalService', function($scope, EvidenceService, $state, evidenceModalService) {
            var vm = this;

            // check for the insight field in the string_object
            var includeInsights = true;
            if($scope.evidence.string_object && $scope.evidence.string_object.insight === false) {
                includeInsights = false;
            }

            if(includeInsights) {
                vm.evidence_url = $scope.evidence.link_url;
                // Load the insight
                EvidenceService.fetchInsights($scope.evidence.id)
                    .then(function(response) {
                        // Sometimes the API returns a non-viable insight, ignore them
                        if(typeof response === 'object'){
                            vm.insights = response;
                            // Reference the icons
                            for(var i = vm.insights.length - 1; i >= 0; i--){
                                var insight = vm.insights[i];
                                insight.icon = insightIcons[insight.type] || defaultIcon;
                            }
                        }
                    });
                // video modal trigger
                vm.showVideoModal = function ($event) {
                    evidenceModalService.triggerVideoModal($scope);
                    $event.preventDefault();
                };
                // table modal trigger
                vm.showTableModal = function ($event) {
                    evidenceModalService.triggerTableModal($scope);
                    $event.preventDefault();
                };
                // transcript modal trigger
                vm.showTranscriptModal = function ($event) {
                    evidenceModalService.triggerTranscriptModal($scope);
                    $event.preventDefault();
                };
                // portfolio modal trigger
                vm.showPortfolioModal = function ($event) {
                    evidenceModalService.triggerPortfolioModal($scope);
                    $event.preventDefault();
                };
                // text modal trigger
                vm.showTextModal = function ($event) {
                    evidenceModalService.triggerTextModal($scope);
                    $event.preventDefault();
                };
                $scope.showVideo = evidenceModalService.isVideoShowing;
            }
        }];
        return {
            restrict: 'A',
            replace: true,
            controller: InsightCtrl,
            controllerAs: 'vm',
            templateUrl: '/shared/evidence/partials/insights.html',
        };
    });

},{}],217:[function(require,module,exports){

angular.module('app')
  .directive('evidenceEditMenu', function() {
    var controller = ['$scope', 'EvidenceService', 'upsertEvidenceModalService',
      function ($scope, EvidenceService, upsertEvidenceModalService) {
        // Edits Evidence in a modal
        $scope.showEditEvidenceModal = function(){
          upsertEvidenceModalService.show($scope.credential, $scope.evidence);
        };
        // Modifies the visiblity of the evidence
        $scope.showEvidence = function(){
          var evidence = angular.copy($scope.evidence);
          evidence.hidden = false;
          EvidenceService.upsert($scope.credential, evidence);
        };
        $scope.hideEvidence = function(){
          var evidence = angular.copy($scope.evidence);
          evidence.hidden = true;
          EvidenceService.upsert($scope.credential, evidence);
        };
        // Deletes the evidence
        $scope.deleteEvidence = function(){
          EvidenceService.delete($scope.credential, $scope.evidence);
        };
      }
    ];
    return {
      restrict: 'A',
      replace: true,
      templateUrl: '/shared/evidence/partials/evidenceEditMenu.html',
      controller: controller,
    };
  });

},{}],218:[function(require,module,exports){

angular.module('app')
  .directive('issuerEvidenceMenu', function() {

    var controller = ['$scope', 'EvidenceService', '$state', 'swalService',
    function ($scope, EvidenceService, $state, swalService) {
      if($state.is('issuer.dashboard.credential')) {
        $scope.showIssuerMenu = true;
      }

      $scope.deleteEvidence = function (evidence, credential) {
        var confirmFunction = function() {
          EvidenceService.deleteEvidenceItem(evidence, credential)
            .then(function(response){
              swalService.showAlert('deleteEvidenceSuccess');
          })
          .catch(function(err){
                swalService.showAlert('issuerDeleteEvidenceFailure');
            });
        };

        swalService.confirm(
          "You are removing this learner's evidence from their certificate. They can still recover their work though.",
          confirmFunction,
          null,
          "Yes, delete it"
        );
      };
    }];

    return {
      restrict: 'A',
      scope: {
        'credential': '=',
        'evidence': '='
      },
      templateUrl: '/shared/evidence/partials/issuerEvidenceMenu.html',
      controller: controller
    };
  });

},{}],219:[function(require,module,exports){

angular.module('app')
  .directive('accredibleTrusted', function() {
    return {
      restrict: 'A',
      scope: {
        trusted: '='
      },
      templateUrl: '/shared/evidence/partials/trusted.html'
    };
    });

},{}],220:[function(require,module,exports){

angular.module('app')
  .directive('portfolioEvidence', ['$compile', 'evidenceModalService', function($compile, evidenceModalService) {
    var linker = function(scope) {
      scope.getBoxStyle = function(count, index) {
        var rows, thisRow, boxHeight, boxWidth, boxMargin, boxLeft, boxTop;
        rows = Math.ceil(count / 4);
        thisRow = Math.floor((index) / 4);
        boxMargin = 10 / 3;

        // (60% - margins) / rows
        boxHeight = (70 - ( (rows-1)*boxMargin )) / rows;
        boxWidth = 80 / 4;
        boxLeft = (index % 4) * (boxWidth + boxMargin);
        boxTop = thisRow * (boxHeight + boxMargin);
        return { "height": boxHeight+"%", "width": boxWidth+"%", "left": boxLeft+"%", "top": boxTop+"%" };
      };

      scope.showPortfolioModal = function ($event) {
        evidenceModalService.triggerPortfolioModal(scope);
        $event.preventDefault();
      };
    };

    return {
      restrict: 'A',
      link: linker,
      templateUrl: '/shared/evidence/portfolio/portfolioView.html'
    };
  }]);

},{}],221:[function(require,module,exports){

angular.module('app')
  .directive('projectEvidence', function() {

    var linker = function(scope) {
          var evidence = scope.evidence;
    };

    return {
      restrict: 'A',
      link: linker,
      scope: {
        'evidence': '='
      },
      templateUrl: '/shared/evidence/project/projectView.html'
    };
  });

},{}],222:[function(require,module,exports){

angular.module('app')
  .directive('tableEvidence', ['$compile', 'evidenceModalService', function($compile, evidenceModalService) {
    var linker = function(scope) {

      scope.showTableModal = function ($event) {
        evidenceModalService.triggerTableModal(scope);
        $event.preventDefault();
      };
    };

    return {
      restrict: 'A',
      link: linker,
      templateUrl: '/shared/evidence/table/tableView.html'
    };
  }]);

},{}],223:[function(require,module,exports){

angular.module('app')
  .directive('staticText', ['$compile', 'evidenceModalService', function($compile, evidenceModalService) {

    var linker = function(scope) {
      scope.showTextModal = function ($event) {
        evidenceModalService.triggerTextModal(scope);
        $event.preventDefault();
      };
    };

    return {
      restrict: 'A',
      link: linker,
      templateUrl: '/shared/evidence/text/staticTextView.html'
    };
  }]);

},{}],224:[function(require,module,exports){

angular.module('app')
  .directive('transcriptEvidence', ['$compile', 'evidenceModalService', function($compile, evidenceModalService) {
    var linker = function(scope) {
      scope.getBarStyle = function(percent, count, index) {
        var barHeight, barWidth, barMargin, barLeft;
        barHeight = percent;
        barWidth = 80 / count;
        if(index === 0) {
          barMargin = 0;
        } else {
          barMargin = 20 / (count-1);
        }
        barLeft = index * (barWidth + barMargin);
        return { "height": barHeight+"%", "width": barWidth+"%", "left": barLeft+"%" };
      };

      scope.showTranscriptModal = function ($event) {
        evidenceModalService.triggerTranscriptModal(scope);
        $event.preventDefault();
      };
    };

    return {
      restrict: 'A',
      link: linker,
      templateUrl: '/shared/evidence/transcript/transcriptView.html'
    };
  }]);

},{}],225:[function(require,module,exports){

angular.module('app')
  .directive('urlEvidence', function() {
    return {
      restrict: 'A',
      templateUrl: '/shared/evidence/url/urlView.html'
    };
  });

},{}],226:[function(require,module,exports){
angular
  .module('app')
  .directive('videoEmbedEvidence', ['$compile', 'evidenceModalService', '$sce', '$http', function($compile, evidenceModalService, $sce, $http) {
    var linker = function(scope, element) {
      var idStart, idLength, videoId;
      // YOUTUBE
      if(scope.evidence.string_object.indexOf('youtube') > -1) {
        // find the youtube video id
        // ex. <iframe width=\"560 \" height=\"315 \" src=\"https: //www.youtube.com/embed/UYFDEVZiFRc\" frameborder=\"0\" allowfullscreen></iframe>
        idStart = scope.evidence.string_object.search('embed/');
        idLength = 11;
        videoId = scope.evidence.string_object.substr(idStart+6, idLength);
        scope.evidence.videoPreviewImage = 'https://img.youtube.com/vi/'+videoId+'/mqdefault.jpg';
        scope.evidence.youtube = true;
      }
      else if(scope.evidence.string_object.indexOf('vimeo') > -1) {
        // find the vimeo video id
        // ex. <iframe src="https://player.vimeo.com/video/36579" width="500" height="281" frameborder="0" allowfullscreen></iframe>
        idStart = scope.evidence.string_object.search('video/');
        idLength = scope.evidence.string_object.indexOf('"', idStart) - (idStart + 6); // characters between video/ and the " (plus 6 for 'video/')
        videoId = scope.evidence.string_object.substr(idStart+6, idLength);
        // call the vimeo API to get the thumbnail
        $http.get('https://vimeo.com/api/v2/video/'+videoId+'.json')
        .then( function (response) {
          scope.evidence.videoPreviewImage = response.data[0].thumbnail_large;
          scope.evidence.vimeo = true;
        });
      }

      scope.showVideoModal = function ($event) {
        evidenceModalService.triggerVideoEmbedModal(scope);
        $event.preventDefault();
      };
      scope.showVideo = evidenceModalService.isVideoShowing;
      scope.hideVideo = evidenceModalService.hideVideo;

      scope.evidence.htmlSafeEmbed = $sce.getTrustedHtml(scope.evidence.string_object);
    };

    return {
      restrict: 'A',
      link: linker,
      templateUrl: '/shared/evidence/video/videoView.html'
    };
  }]);

},{}],227:[function(require,module,exports){

angular.module('app')
  .directive('videoEvidence', ['$compile', 'evidenceModalService', '$sce', function($compile, evidenceModalService, $sce) {
    var linker = function(scope, element) {
      // remove the href from the main evidenceItem link
      element.parent().parent().removeAttr('href');
      // find the youtube video id
      var idStart = scope.evidence.link_url.search('v=');
      scope.evidence.videoId = scope.evidence.link_url.substr(idStart+2, 11);
      scope.evidence.videoUrl = $sce.trustAsResourceUrl('https://www.youtube.com/embed/'+scope.evidence.videoId);
      scope.evidence.videoPreviewImage = "https://img.youtube.com/vi/"+scope.evidence.videoId+"/mqdefault.jpg"

      scope.showVideoModal = function ($event) {
        evidenceModalService.triggerVideoModal(scope);
        $event.preventDefault();
      };
      scope.showVideo = evidenceModalService.isVideoShowing;
      scope.hideVideo = evidenceModalService.hideVideo;
    };

    return {
      restrict: 'A',
      link: linker,
      templateUrl: '/shared/evidence/video/videoView.html'
    };
  }]);

},{}],228:[function(require,module,exports){
/** Links - DIRECTIVE
 *
 *  For all external links:
 *    Protects against tabnapping
 *    Opens in a new tab
 *    Tracks clicks
 *
 *    @author   David "oodavid" King
 */
require('../_services/url.service.js');
linkTrackingDirective.$inject = ['$location', 'api', 'urlService'];
function linkTrackingDirective($location, api, urlService){

  function linkTrackingDirectiveLink(scope, element, attrs) {
    // Protect against tabnapping, open external links in a new tab
    element.bind('click mousedown contextmenu', function(/* event */){
      var link = urlService.parse(element[0].href);
      if(link.external){
        element.attr('rel', 'noopener noreferrer');
        element.attr('target', '_blank');
      }
    });
    // Track clicks
    element.bind('click', function(/* event */) {
      var link = urlService.parse(element[0].href);
      if(link.external){
        var payload = {
          from: $location.absUrl(),
          to: link.href,
          html: getLinkHtml(element),
          aad: link.query.aad,
        };
        api
          .request('/analytics/track_link', payload)
          .catch(function(){});
      }
    });
  }

  function getLinkHtml(element){
    return element
            .html() // Text
            .replace(/^\s+|\s+$/g, '') // ..trimmed
            .substring(0, 256); // ...truncated
  }

  return {
    restrict: 'E',
    link: linkTrackingDirectiveLink,
  };
}

angular
  .module('app')
  .directive('a', linkTrackingDirective);

},{"../_services/url.service.js":176}],229:[function(require,module,exports){
/** FADE AND REVEAL
 *
 *   <fade-and-reveal height="fixed height" fade-only="true">
 *      <!-- html content goes here -->
 *   </fade-and-reveal>
 *
 *    @author Andrew Bateman
 *    @author David "oodavid" King (review)
 */
var fadeAndRevealComponent = {
  controller: fadeAndRevealComponentController,
  bindings: {
    height: '<',
    fadeOnly: '<'
  },
  templateUrl: '/shared/fade-and-reveal/fade-and-reveal.html',
  transclude: true,
};

fadeAndRevealComponentController.$inject = ['$element', '$timeout', '$window', '$scope', '_'];
function fadeAndRevealComponentController($element, $timeout, $window, $scope, _) {
  var ctrl = this;

  var mode = 'fade';

  ctrl.canShowMore = false;
  ctrl.canShowLess = false;
  ctrl.faderVisible = true;

  ctrl.$postLink = postLink;
  ctrl.$onDestroy = onDestroy;
  ctrl.showMore = showMore;
  ctrl.showLess = showLess;

  // Throttled update (for window.resize event)
  var throttledUpdateFlags = _.throttle(updateFlagsWrapper, 1000, { trailing: true });

  // Initialization
  function postLink(){
    $element.find('.fade-and-reveal-content').css({ 'max-height': ctrl.height });
    $timeout(function(){
      setMode('fade');
    });
    angular.element($window).bind('resize', throttledUpdateFlags);
  }

  // Tidy up
  function onDestroy(){
    angular.element($window).unbind('resize', throttledUpdateFlags);
  }

  // Animate the content to show
  function showMore(){
    $element
      .find('.fade-and-reveal-content')
      .animate({ 'max-height': getNaturalHeight() }, 250, function() {
        $timeout(function(){
          setMode('reveal');
          $element.find('.fade-and-reveal-content').css({ 'max-height': '' }); // Now use automatic values, should the user resize the window
        });
      });
  }

  // Animate the content to hide
  function showLess(){
    ctrl.faderVisible = true;
    $element
      .find('.fade-and-reveal-content')
      .css({ 'max-height': getNaturalHeight() })
      .animate({ 'max-height': ctrl.height }, 250, function(){
        $timeout(function(){
          setMode('fade');
        });
      });
  }

  // Sets the state of the element
  function setMode(newMode){
    mode = newMode;
    updateFlags();
  }

  // Update the flags
  function updateFlags(){
    var isTaller = getNaturalHeight() > ctrl.height;
    if(mode === 'fade'){
      ctrl.canShowMore = isTaller;
      ctrl.canShowLess = false;
    } else if(mode === 'reveal'){
      ctrl.canShowMore = false;
      ctrl.canShowLess = isTaller;
    }
    ctrl.faderVisible = ctrl.canShowMore;
    if (ctrl.fadeOnly) {
      ctrl.canShowMore = ctrl.canShowLess = false;
    }
  }

  // Update flags wrapper
  function updateFlagsWrapper() {
    $scope.$apply(updateFlags);
  }

  // Returns the natural height of the contents
  function getNaturalHeight(){
    return $element.find('.fade-and-reveal-content')[0].scrollHeight;
  }

}

angular
  .module('app')
  .component('fadeAndReveal', fadeAndRevealComponent);

},{}],230:[function(require,module,exports){
/** FILTER CONTAINER COMPONENT
 *
 *    <filter-container title="Name" show="initialState"></filter-container>
 *
 */

var filterContainerComponent = {
  bindings: {
    title: '@',
    show: '='
  },
  templateUrl: '/shared/filter-container/filter-container.html',
  transclude: true,
};

angular
  .module('app')
  .component('filterContainer', filterContainerComponent);

},{}],231:[function(require,module,exports){
/** FONT MENU
 *
 *   <font-menu ng-model="fontName" fonts="fonts" select-action="selectFont"></font-menu>
 *
 *   @author Andrew Bateman
 */
var fontMenuComponent = {
  controller: fontMenuComponentController,
  bindings: {
    ngModel: '<',
    fonts: '<',
    selectAction: '<'
  },
  templateUrl: '/shared/font-menu/font-menu.html',
};

fontMenuComponentController.$inject = [];
function fontMenuComponentController() {
  var ctrl = this;
}

angular
  .module('app')
  .component('fontMenu', fontMenuComponent);

},{}],232:[function(require,module,exports){
/** FONT SERVICE
 *
 *    Used for:
 *      Loading fonts related to <certificate> elements
 *      Listing all fonts available to the user
 *
 *    To my chagrin the <credential> designs assume that there
 *     is a default font on the <body> of the page, namely:
 *      "Source Sans Pro"
 *     ...so we must *always* load that, just in case. Pah.
 *
 *    A note about "custom" fonts, we expect these fonts to
 *       be available locally, we manually inject the font
 *       into the <head> with multiple font variations for
 *       decent browser support, read more here:
 *      http://www.456bereastreet.com/archive/201012/font-face_tip_define_font-weight_and_font-style_to_keep_your_css_simple/
 *
 *    ...need to convert "custom" fonts to other formats?
 *      https://transfonter.org/
 *
 *    @author   David "oodavid" King
 */
fontService.$inject = ['_', '$window', '$injector', '$q', '$timeout', 'ENV'];
function fontService(_, $window, $injector, $q, $timeout, ENV) {
  var service = this;
  service.loadFont = loadFont;
  service.loadCredentialFonts = loadCredentialFonts;
  service.loadDesignFonts = loadDesignFonts;
  service.getFonts = getFonts;
  service.getWeights = getWeights;
  service.getNearestWeight = getNearestWeight;
  service.getCssImportString = getCssImportString;
  service.getStatus = getStatus;
  service.whenFontLoaded = whenFontLoaded;
  service.hasItalicWeight = hasItalicWeight;

  var weights = {
    100: 'Thin',
    200: 'Extra Light',
    300: 'Light',
    400: 'Normal',
    500: 'Medium',
    600: 'Semi Bold',
    700: 'Bold',
    800: 'Extra Bold',
    900: 'Black',
  };

  function weightAsNumber(weight) {
    if (Number.isInteger(weight)) { // Already a number
      return weight;
    }
    if (isNaN(weight)) { // Not a number as a string, i.e. 'Normal', 'Bold', etc
      var weightNumber = 400; // Default to 'Normal'
      $.each(weights, function(key, value) {
        if (value.toLowerCase() === weight) {
          weightNumber = key;
        }
      });
      return weightNumber;
    } else { // Is a number as a string
      return parseInt(weight);
    }
  }

  var host = '';
  if ($window.location.hostname === 'localhost') {
    host = 'localhost:1337';
  } else {
    host = $window.location.host;
  }

  var defaultFont = 'Source Sans Pro';

  // All available fonts
  // ...those which have been loaded already get an additional "loaded:true" flag
  var fonts = {
    'Acto':                 { type: 'custom', weights: [300, 400, 500, 600, 700],                                                                                             fallback: 'sans-serif', organization: 411 },
    'Actor':                { type: 'google', weights: [400],                                                                                                                 fallback: 'sans-serif' },
    'Acid Grotesk':         { type: 'custom', weights: [300, 400, 500, 700],                                                                                                  fallback: 'sans-serif', organization: 95324},
    'Aeonik Mono':          { type: 'custom', weights: [300, 400, 500, 600],                                                                                                  fallback: 'sans-serif', organization: 258344},
    'Alegreya SC':          { type: 'google', weights: [400, '400i', 500, '500i', 700, '700i'],                                                                               fallback: 'serif' },
    'Aleo':                 { type: 'google', weights: [300, '300i', 400, '400i', 700, '700i'],                                                                               fallback: 'serif' },
    'Allura':               { type: 'google', weights: [400],                                                                                                                 fallback: 'cursive' },
    'Anton':                { type: 'google', weights: [400],                                                                                                                 fallback: 'sans-serif' },
    'Antonio':              { type: 'custom', weights: [300, 400, 700],                                                                                                       fallback: 'sans-serif' },
    'Archivo':              { type: 'google', weights: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'], fallback: 'sans-serif' },
    'Arial':                { type: 'system', weights: [400, '400i', 700, '700i'],                                                                                            fallback: '\'Helvetica Neue\', Helvetica, sans-serif' },
    'Asap':                 { type: 'google', weights: [400, '400i', 500, '500i', 600, '600i', 700, '700i'],                                                                  fallback: 'sans-serif' },
    'Atkinson Hyperlegible':{ type: 'google', weights: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i'],                           fallback: 'sans-serif' },
    'Avenir Next':          { type: 'custom', weights: [200, '200i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i'],                                        fallback: 'sans-serif', organization: 1566 },
    'Barlow':               { type: 'google', weights: [200, '200i', 300, '300i', 400, '400i', 700, '700i'],                                                                  fallback: 'sans-serif' },
    'Bebas Neue':           { type: 'google', weights: [400],                                                                                                                 fallback: 'sans-serif' },
    'Big Shoulders':        { type: 'google', weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],                                                                         fallback: 'sans-serif' },
    'Bilbo Swash Caps':     { type: 'google', weights: [400],                                                                                                                 fallback: 'cursive' },
    'Bitter':               { type: 'google', weights: [200, '200i', 400, '400i', 600, '600i', 700, '700i'],                                                                  fallback: 'serif' },
    'Brandon Grotesque':    { type: 'custom', weights: [400, 600, 700],                                                                                                       fallback: 'sans-serif' },
    'Bree Serif':           { type: 'google', weights: [400],                                                                                                                 fallback: 'serif' },
    'British Council Sans': { type: 'custom', weights: [400, 700],                                                                                                            fallback: 'sans-serif', organization: 30 },
    'British Council Sans Headline': { type: 'custom', weights: [400],                                                                                                        fallback: 'sans-serif', organization: 30 },
    'Cairo':                { type: 'google', weights: [200, 300, 400, 500, 600, 700, 800, 900],                                                                              fallback: 'sans-serif' },
    'Caveat':               { type: 'google', weights: [400, '400i', 600, '600i', 700, '700i'],                                                                               fallback: 'sans-serif' },
    'Cinzel':               { type: 'google', weights: [400, 700],                                                                                                            fallback: 'serif' },
    'Centra No.1':          { type: 'custom', weights: [100, 400, 500],                                                                                                       fallback: 'sans-serif', organization: 13203 },
    'Charm':                { type: 'google', weights: [400, 700],                                                                                                            fallback: 'cursive' },
    'Chivo':                { type: 'google', weights: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'], fallback: 'sans-serif' },
    'Cormorant Garamond':   { type: 'google', weights: [400, '400i', 600, '600i', 700, '700i'],                                                                               fallback: 'serif' },
    'Cormorant SC':         { type: 'google', weights: [400, '400i', 600, '600i', 700, '700i'],                                                                               fallback: 'serif' },
    'Crimson Text':         { type: 'google', weights: [400, '400i', 600, '600i', 700, '700i'],                                                                               fallback: 'serif' },
    'Dancing Script':       { type: 'google', weights: [400, 700],                                                                                                            fallback: 'cursive' },
    'D-DIN Pro':            { type: 'custom', weights: [400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],                                        fallback: 'sans-serif', organization: 7631 },
    'DM Sans':              { type: 'google', weights: [400, '400i', 500, '500i', 700, '700i'],                                                                               fallback: 'sans-serif' },
    'DM Serif Display':     { type: 'google', weights: [400, '400i'],                                                                                                         fallback: 'serif' },
    'Domine':               { type: 'google', weights: [400, 700],                                                                                                            fallback: 'serif' },
    'EB Garamond':          { type: 'google', weights: [400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i'],                                                     fallback: 'serif' },
    'Encode Sans':          { type: 'google', weights: [300, 400, 600, 700, 800],                                                                                             fallback: 'serif' },
    'Epilogue':             { type: 'google', weights: [400, '400i', 500, '500i', 600, '600i', 700, '700i'],                                                                  fallback: 'sans-serif' },
    'EverydaySans':         { type: 'custom', weights: [300, '300i', 400, '400i', 500, '500i', 700, '700i', 900, '900i'],                                                     fallback: 'sans-serif', organization: 162237 },
    'Felipa':               { type: 'google', weights: [400],                                                                                                                 fallback: 'cursive' },
    'Figtree':              { type: 'google', weights: [300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],                           fallback: 'sans-serif' },
    'Fira Mono':            { type: 'google', weights: [400, 500, 700],                                                                                                       fallback: 'monospace' },
    'Fira Sans':            { type: 'google', weights: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'], fallback: 'serif' },
    'Georgia':              { type: 'system', weights: [400, '400i', 700, '700i'],                                                                                            fallback: '\'Times New Roman\', Times, serif' },
    'Glacial Indifference': { type: 'custom', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'sans-serif', organization: 7631 },
    'Gotham':               { type: 'custom', weights: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 700, '700i', 800, '800i'],                                        fallback: 'sans-serif', organization: 675 },
    'Graphik':              { type: 'custom', weights: [400],                                                                                                                 fallback: 'sans-serif', organization: 13203 },
    'Great Vibes':          { type: 'google', weights: [400],                                                                                                                 fallback: 'cursive' },
    'GT Pressura Mono':     { type: 'custom', weights: [400, 700],                                                                                                            fallback: 'sans-serif', organization: 23259 },
    'Heebo':                { type: 'google', weights: [400, '400i', 600, '600i', 700, '700i'],                                                                               fallback: 'sans-serif' },
    'IBM Plex Sans':        { type: 'google', weights: [300, '300i', 400, '400i', 600, '600i', 700, '700i'],                                                                  fallback: 'sans-serif' },
    'IBM Plex Serif':       { type: 'google', weights: [300, '300i', 400, '400i', 600, '600i', 700, '700i'],                                                                  fallback: 'serif' },
    'IM Fell Great Primer': { type: 'google', weights: [400, '400i'],                                                                                                         fallback: 'serif' },
    'Indie Flower':         { type: 'google', weights: [400, 700],                                                                                                            fallback: 'cursive' },
    'Inter':                { type: 'google', weights: [200, '200i', 300, '300i', 400, '400i', 700, '700i'],                                                                  fallback: 'sans-serif' },
    'Josefin Sans':         { type: 'google', weights: [400, '400i', 600, '600i'],                                                                                            fallback: 'sans-serif' },
    'Jost':                 { type: 'google', weights: [300, '300i', 400, '400i', 600, '600i', 700, '700i'],                                                                  fallback: 'sans-serif' },
    'Lato':                 { type: 'google', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'sans-serif' },
    'Larken':               { type: 'custom', weights: [300, 700],                                                                                                            fallback: 'serif', organization: 147411},
    'Libre Baskerville':    { type: 'google', weights: [400, '400i', 700],                                                                                                    fallback: 'serif' },
    'Libre Caslon Text':    { type: 'google', weights: [400, '400i', 700],                                                                                                    fallback: 'serif' },
    'Lora':                 { type: 'google', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'serif' },
    'Manrope':              { type: 'google', weights: [200, 300, 400, 500, 600, 700, 800],                                                                                   fallback: 'sans-serif' },
    'Manufacturing Consent':{ type: 'google', weights: [400],                                                                                                                 fallback: 'cursive' },
    'Merriweather':         { type: 'google', weights: [300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],                           fallback: 'serif' },
    'Monospace':            { type: 'system', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'monospace' },
    'Montserrat':           { type: 'google', weights: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'], fallback: 'sans-serif' },
    'Museo':                { type: 'custom', weights: [100, 300, 500, 700, 900],                                                                                             fallback: 'serif', organization: 4173 },
    'Neue Rational Condensed Bold': { type: 'custom', weights: [700],                                                                                                         fallback: 'sans-serif', organization: [{id: 7110, environment: 'eu-production'}] },
    'Newsreader':           { type: 'google', weights: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i'],                           fallback: 'serif' },
    'Noto Sans':            { type: 'google', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'sans-serif' },
    'Noto Sans JP':         { type: 'google', weights: [100, 300, 400, 500, 700, 900],                                                                                        fallback: 'sans-serif' },
    'Noto Sans SC':         { type: 'google', weights: [100, 300, 400, 500, 700, 900],                                                                                        fallback: 'sans-serif' },
    'Noto Serif':           { type: 'google', weights: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'], fallback: 'serif' },
    'Noto Serif JP':        { type: 'google', weights: [200, 300, 400, 500, 600, 700, 900],                                                                                   fallback: 'serif' },
    'Nunito':               { type: 'google', weights: [200, '200i', 300, '300i', 400, '400i', 700, '700i'],                                                                  fallback: 'sans-serif' },
    'Nunito Sans':          { type: 'google', weights: [200, '200i', 300, '300i', 400, '400i', 700, '700i'],                                                                  fallback: 'sans-serif' },
    'Open Sans':            { type: 'google', weights: [300, '300i', 400, '400i', 700],                                                                                       fallback: 'sans-serif' },
    'Open Sauce Sans':      { type: 'custom', weights: [300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],                           fallback: 'sans-serif', organization: 147411},
    'Oswald':               { type: 'google', weights: [400],                                                                                                                 fallback: 'sans-serif' },
    'Outfit':               { type: 'google', weights: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'], fallback: 'sans-serif' },
    'Overpass':             { type: 'google', weights: [300, '300i', 400, '400i', 600, '600i', 700, '700i'],                                                                  fallback: 'sans-serif' },
    'Pinyon Script':        { type: 'google', weights: [400, 700],                                                                                                            fallback: 'cursive' },
    'Plain Black Wide':     { type: 'custom', weights: [400],                                                                                                                 fallback: 'cursive' },
    'Playball':             { type: 'google', weights: [400],                                                                                                                 fallback: 'cursive' },
    'Playfair Display':     { type: 'google', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'serif' },
    'Playfair Display SC':  { type: 'google', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'serif' },
    'Plus Jakarta Sans':    { type: 'google', weights: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i'],                           fallback: 'sans-serif' },
    'Poppins':              { type: 'google', weights: [300, '300i', 400, '400i', 700, '700i'],                                                                               fallback: 'sans-serif' },
    'PPFormula':            { type: 'custom', weights: [500],                                                                                                                 fallback: 'sans-serif', organization: 34765 },
    'PPMori':               { type: 'custom', weights: [400],                                                                                                                 fallback: 'sans-serif', organization: 23259 },
    'PP Right Grotesk':     { type: 'custom', weights: [500, 700],                                                                                                            fallback: 'sans-serif', organization: [{id: 37, environment: 'production_eu'}] },
    'PP Telegraf':          { type: 'custom', weights: [400, 500, 600, 800],                                                                                                  fallback: 'sans-serif', organization: 13672 },
    'PT Sans':              { type: 'google', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'sans-serif' },
    'PT Serif':             { type: 'google', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'serif' },
    'Public Sans':          { type: 'google', weights: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i'],                           fallback: 'sans-serif' },
    'Qualtrics Grotesque':  { type: 'custom', weights: [200, 300, 400, 700],                                                                                                  fallback: 'sans-serif' },
    'Questrial':            { type: 'custom', weights: [400],                                                                                                                 fallback: 'sans-serif' },
    'Rajdhani':             { type: 'google', weights: [300, 400, 500, 600, 700],                                                                                             fallback: 'sans-serif' },
    'Raleway':              { type: 'google', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'sans-serif' },
    'Roboto':               { type: 'google', weights: [300, '300i', 400, '400i', 700, '700i'],                                                                               fallback: 'sans-serif' },
    'Roboto Condensed':     { type: 'google', weights: [300, '300i', 400, '400i', 700, '700i'],                                                                               fallback: 'sans-serif' },
    'Roboto Slab':          { type: 'google', weights: [400, '400i', 600, '600i', 700, '700i'],                                                                               fallback: 'serif' },
    'Sacramento':           { type: 'google', weights: [400],                                                                                                                 fallback: 'cursive' },
    'sans-serif':           { type: 'system', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'sans-serif' },
    'Sherman Sans':         { type: 'custom', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'sans-serif', organization: 89366 },
    'Sherman Serif':        { type: 'custom', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'serif', organization: 89366 },
    'Skillsoft Sans':       { type: 'custom', weights: [400, '400i', 500, '500i', 700, '700i'],                                                                               fallback: 'sans-serif', organization: [{id: 3, environment: 'sandbox'}, {id: 8, environment: 'eu-production'}, {id: 29298, environment: 'production'}] },
    'Skillsoft Text':       { type: 'custom', weights: [300, '300i', 400, '400i', 500, '500i', 700, '700i', 900, '900i'],                                                     fallback: 'sans-serif', organization: [{id: 3, environment: 'sandbox'}, {id: 8, environment: 'eu-production'}, {id: 29298, environment: 'production'}] },
    'Source Code Pro':      { type: 'google', weights: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],              fallback: 'monospace' },
    'Source Sans Pro':      { type: 'google', weights: [300, '300i', 400, '400i', 600, '600i', 700, '700i'],                                                                  fallback: 'sans-serif' },
    'Spectral':             { type: 'google', weights: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i'],                           fallback: 'serif' },
    'Syne':                 { type: 'google', weights: [400, 500, 600, 700, 800],                                                                                             fallback: 'sans-serif' },
    'Tangerine':            { type: 'google', weights: [400, 700],                                                                                                            fallback: 'cursive'},
    'Times New Roman':      { type: 'system', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'Times, Baskerville, Georgia, serif' },
    'Titillium Web':        { type: 'google', weights: [200, '200i', 300, '300i', 400, '400i', 700, '700i'],                                                                  fallback: 'sans-serif' },
    'TWK Lausanne':         { type: 'custom', weights: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'], fallback: 'sans-serif', organization: 258344 },
    'UnifrakturMaguntia':   { type: 'google', weights: [400],                                                                                                                 fallback: 'cursive' },
    'Urbanist':             { type: 'google', weights: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'], fallback: 'sans-serif' },
    'Varela Round':         { type: 'google', weights: [400],                                                                                                                 fallback: 'sans-serif' },
    'Verdana':              { type: 'system', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'Geneva, sans-serif' },
    'Work Sans':            { type: 'google', weights: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'], fallback: 'sans-serif' },
  };
  /*
    Consider adding these system font families
    NB: BE might need to install these fonts on the server

      "'Bookman Old Style', serif",
      "Courier, monospace",
      "'Courier New', Courier, monospace",
      "Impact, Charcoal, sans-serif",
      "'Lucida Console', Monaco, monospace",
      "'Lucida Sans Unicode', 'Lucida Grande', sans-serif",
      "'Palatino Linotype', 'Book Antiqua', Palatino, serif;",
      "Tahoma, Geneva, sans-serif",
      "'Times New Roman', Times, serif",
      "'Trebuchet MS', Helvetica, sans-serif",
      "Verdana, Geneva, sans-serif",
  */

  // Add the "name" as a property
  // Add the "family" as a property (combines the fallback and the fontName)
  // Add the "googleFamily" for each - this is the string that google fonts uses to identify the font
  function updateFonts(){
    _(fonts).forEach(function(font, fontName) {
      font.name = fontName;
      font.family = "'" + fontName + "'" + (font.fallback ? (', ' + font.fallback) : '');
      if (font.type == 'google') {
        font.googleFamily = fontName.replace(/\s/g, '+') + ':' + font.weights.join(',') + ':latin,latin-ext';
      }
    });
  }
  updateFonts();

  function getStatus(fontName) {
    return fonts[fontName] || {};
  }

  // Loads a single font, if we haven't already
  function loadFont(fontName){
    var font;
    fontName = fontName.trim();
    // Google fonts
    if (fonts[fontName] && fonts[fontName].type === 'google' && !fonts[fontName].loaded) {
      font = fonts[fontName];
      $('head').prepend('<link href="https://fonts.googleapis.com/css?family=' + fontName.replace(/\s/g, '+') + ':' + font.weights.join(',') + '&display=block" rel="stylesheet">');
      font.loaded = true;
    }
    // Custom fonts
    if (fonts[fontName] && fonts[fontName].type === 'custom' && !fonts[fontName].loaded) {
      font = fonts[fontName];
      $('head').prepend('<style type="text/css">' + getCssImportString(fontName, font.weights) + '</style>');
      font.loaded = true;
    }
    // System fonts
    if (fonts[fontName] && fonts[fontName].type === 'system' && !fonts[fontName].loaded) {
      // Just assume it's there
      font = fonts[fontName];
      font.loaded = true;
    }
  }

  // Loads all fonts used in a credential
  function loadCredentialFonts(credential) {
    if (credential.group && credential.group.certificate_design) {
      loadDesignFonts(credential.group.certificate_design);
    }
  }

  // Load all fonts used in a design
  function loadDesignFonts(design) {
    if (design && design.blocks) {
      for (var bl = design.blocks.length, b = 0; b < bl; b++) {
        if (design.blocks[b].font) {
          loadFont(design.blocks[b].font);
        }
      }
    }
    // See block comment
    loadFont(defaultFont);
  }

  // Whether a font restricted to an organization should be available to the given organization.
  // Supports the legacy format (a single organization id) as well as the environment-scoped format
  // (an array of `{ id, environment }` objects), where the font is only available when both the id
  // and the current environment match - ids are not unique across environments since each
  // environment uses a different database.
  function isOrganizationAllowed(organization, organizationId) {
    // Environment-scoped format
    if (Array.isArray(organization)) {
      return organization.some(function(org) {
        return org.id === organizationId && org.environment === ENV.name;
      });
    }
    // Legacy format: a single organization id
    return organization === organizationId;
  }

  // Returns all available fonts
  function getFonts(opts) {
    opts = opts || {};
    var tmpFonts = angular.copy(fonts);
    // Unless we explicitly choose not to...
    if(!opts.allOrganizations){
      // ...remove any fonts that belong to a different organization
      var organizationId = 0;
      if ($injector.has('OrganizationService')) {
        var OrganizationService = $injector.get('OrganizationService');
        var organization = OrganizationService.getOrganizationImmediate();
        if(organization && organization.id){
          organizationId = organization.id;
        }
      }
      angular.forEach(tmpFonts, function(font, id){
        if(font.organization && !isOrganizationAllowed(font.organization, organizationId)){
          delete tmpFonts[id];
        }
      });
    }
    // Filter by type?
    if(opts.type){
      angular.forEach(tmpFonts, function(font, id){
        if(font.type && font.type !== opts.type){
          delete tmpFonts[id];
        }
      });
    }
    // Include specific, desired fonts
    if(opts.include){
      var font = angular.copy(fonts[opts.include]);
      tmpFonts[opts.include] = font;
    }
    // And return
    return tmpFonts;
  }

  // Returns the weights map
  function getWeights() {
    return weights;
  }

  // Returns the nearest weight for a font (defaulting to `400`)
  // ...useful when chaning the font to a family that has different available weights
  function getNearestWeight(fontName, currentWeight){
    if(!fonts[fontName]){
      fontName = defaultFont; // Fallback
    }
    currentWeight = parseInt(currentWeight, 10);
    var availableWeights = fonts[fontName].weights;
    var minDistance = 900;
    var closestWeight = 400; // The default `normal` value
    angular.forEach(availableWeights, function(value){
      if(Math.abs(value - currentWeight) < minDistance){
        minDistance = Math.abs(value - parseInt(currentWeight));
        closestWeight = value;
      }
    });
    return closestWeight;
  }

  // Returns a CSS @import string, ie:
  //  @import url('https://fonts.googleapis.com/css?family=Roboto:400,100,100italic,300,300italic,400italic,500,500italic,700,700italic,900,900italic');
  function getCssImportString(fontName, fontVariantsArray){
    var font = fonts[fontName];
    if(font){
      if(font.type === 'google'){
        return '@import url(\'https://fonts.googleapis.com/css?family='+encodeURIComponent(fontName)+':'+fontVariantsArray.join(',')+'\');';
      } else if(font.type === 'custom'){
        var cssImportString = '';
        for (var v=0, vl=fontVariantsArray.length; v<vl; v++) {
          var fontVariant = fontVariantsArray[v];
          var fontStyle = fontVariant.toString().includes('i') ? 'italic' : 'normal';
          var fontWeight = fontVariant.toString().replace('i', '');
          // Default to dashboard.accredible.com as the source of custom fonts if the font service is being used outside of a dashboard instance
          var accessibleHost = host.includes('dashboard.accredible.com') ? host : host.includes('localhost') ? 'localhost:1337' : 'dashboard.accredible.com';
          cssImportString +=
            "@font-face {\n" +
            "font-family: \"" + fontName + "\";\n" +
            "font-weight: " + fontWeight + ";\n" +
            "font-style: " + fontStyle + ";\n" +
            "src: url('//" + accessibleHost + "/shared/fonts/" + fontName + "/" + fontName + " - " + fontVariant + ".woff2') format('woff2'),\n" +
            "     url('//" + accessibleHost + "/shared/fonts/" + fontName + "/" + fontName + " - " + fontVariant + ".woff') format('woff'),\n" +
            "     url('//" + accessibleHost + "/shared/fonts/" + fontName + "/" + fontName + " - " + fontVariant + ".ttf') format('truetype'),\n" +
            "     url('//" + accessibleHost + "/shared/fonts/" + fontName + "/" + fontName + " - " + fontVariant + ".svg#svgFontfontName') format('svg'),\n" +
            "}";
          cssImportString += v < vl - 1 ? '\n' : '';
        }
        return cssImportString;
      }
    }
  }

  // Mechanism for checking if a font has loaded and then doing something if it has
  var loadedFonts = {};
  // Assume system fonts are already loaded
  _(fonts).forEach(function(font, fontName) {
    if (font.type === 'system') {
      font.weights.forEach(function(weight) {
        var style = typeof weight == 'number' ? 'normal' : 'talic'; // Italic font weights end in an 'i' so adding 'talic' results in 'italic'
        loadedFonts[fontName + weight + style] = true;
      });
    }
  });

  // Remove quotes from string
  function unquote(string) {
    return string.replace(/\"/g, '');
  }

  var checklist = []; // The list of (font) family, weight, style and actions items for the fonts that are required to have loaded
  var checkCount = 0; // The number of times left to check that a font has loaded
  var checkTimeout = null; // The timeout reference

  // Remove loaded fonts from the checklist, firing the actions as we go
  function checkFontsLoaded() {
    var unloadedChecklist = [];
    checklist.forEach(function(listItem) {
      var fontLoaded = false;
      var iterator = document.fonts.values();
      var fontFace;
      // eslint-disable-next-line no-cond-assign
      while (fontFace = iterator.next().value) {
        var listItemWeight = parseInt(listItem.weight);
        // The test here uses fontFace.weight == listItemWeight, rather than fontFace.weight === listItemWeight as Chrome returns fontFace.weight as a string of the number not the number itself
        if (unquote(fontFace.family) === listItem.family && (fontFace.weight == listItemWeight || (!isNaN(listItemWeight) && fontFace.weight === weights[listItemWeight].toLowerCase())) && fontFace.style === listItem.style && fontFace.status === 'loaded') {
          fontLoaded = true;
          break;
        }
      }
      if (fontLoaded) {
        loadedFonts[listItem.family + listItem.weight + listItem.style] = true;
        listItem.actions.forEach(function(action) {
          action();
        });
      } else {
        unloadedChecklist.push(listItem);
      }
    });
    if (unloadedChecklist.length === 0) {
      checkCount = 0;
    } else {
      checkCount--;
    }
    checklist = unloadedChecklist;
  }

  // Schedule the next check for 100 milliseconds time
  function scheduleCheckFontsLoaded() {
    return $timeout(checkFontsUntilLoaded, 100);
  }

  // Check the fonts loaded and reschedule if there are any retries (checkCount) left
  function checkFontsUntilLoaded() {
    checkFontsLoaded();
    if (checkCount > 0) {
      checkTimeout = scheduleCheckFontsLoaded();
    } else if (checklist.length > 0) {
      console.warn('Failed to load fonts:', checklist.map(function(font) {
        return font.family + ':' + font.weight + ':' + font.style;
      }));
    }
  }

  // Check to see if font family has a particular italic weight
  function hasItalicWeight(fontFamily, fontWeight) {
    return fonts[fontFamily].weights.indexOf(fontWeight + 'i') > -1;
  }

  function whenFontLoaded(family, weight, style, action) { // action cannot be null
    family = unquote(family);
    weight = weightAsNumber(weight);
    if (loadedFonts[family + weight + style]) { // Already loaded
      action();
    } else {
      if (style === 'italic' && !hasItalicWeight(family, weight)) {
        style = 'normal';
      }
      // Is the font already being checked
      var beingChecked = false;
      checklist.forEach(function(listItem) {
        if (listItem.family === family && listItem.weight === weight && listItem.style === style) {
          // It is...
          beingChecked = true;
          // Store action
          listItem.actions.push(action);
        }
      });
      if (!beingChecked) {
        // Not being checked, so add it to the list
        checklist.push({ family: family, weight: weight, style: style, actions: [action] });
      }
      checkCount = 20;
      if (checkTimeout) {
        $timeout.cancel(checkTimeout); // Cancel any pending check
      }
      checkFontsUntilLoaded();
    }
  }
}

angular
  .module('app')
  .service('fontService', fontService);

},{}],233:[function(require,module,exports){
fullscreenUploadDirective.$inject = ['$compile'];
function fullscreenUploadDirective($compile){
  return {
    restrict: 'A',
    link: fullscreenUploadDirectiveLink,
    controller: fullscreenUploadDirectiveController,
    controllerAs: '$upload',
  };

  // When linked, we check the component and add visual aids
  function fullscreenUploadDirectiveLink(scope, element, attrs) {
    // Make sure the correct attributes are set on the element - we don't want to use $compile as this can mess up other components
    if(!attrs['ngfDrop'] || attrs['ngfDrop'] !== '$upload.handleFullscreenUpload($file)'){
      console.warn('[fullscreen-upload] - please add this attribute to the body:\nngf-drop="$upload.handleFullscreenUpload($file)"');
    }
    if(!attrs['ngfDropDisabled'] || attrs['ngfDropDisabled'] !== '$upload.fullscreenUploadDisabled'){
      console.warn('[fullscreen-upload] - please add this attribute to the body:\nngf-drop-disabled="$upload.fullscreenUploadDisabled"');
    }
    // Append our visual aid
    var linkFn = $compile('<div id="fullscreen-upload-dragover"><div><div translate="drop-to-upload"></div></div></div>');
    var content = linkFn(scope);
    element.append(content);
  }
}

// Our controller
fullscreenUploadDirectiveController.$inject = [];
function fullscreenUploadDirectiveController() {
  var ctrl = this;
  ctrl.handleFullscreenUpload = handleFullscreenUpload;
  ctrl.setListener = setListener;
  ctrl.unsetListener = unsetListener;
  ctrl.fullscreenUploadDisabled = true;
  // Passes the file to the listener
  function handleFullscreenUpload($file){
    if(listener){
      listener($file);
    }
  }
  // Listener
  var listener;
  function setListener(callback){
    listener = callback;
    ctrl.fullscreenUploadDisabled = false;
  }
  function unsetListener(callback){
    if(listener == callback){
      listener = null;
      ctrl.fullscreenUploadDisabled = true;
    }
  }
}

angular
  .module('app')
  .directive('fullscreenUpload', fullscreenUploadDirective);

},{}],234:[function(require,module,exports){
/** FULLSCREEN COMPONENT
 *
 *    A full-screen container element
 *    Adds scroll blocking to the body when visible
 *
 *    <fullscreen>your content</fullscreen>
 *
 */
var fullscreenComponent = {
  controller: fullscreenComponentController,
  transclude: true,
  template: '<div ng-transclude></div>',
};

fullscreenComponentController.$inject = [];
function fullscreenComponentController() {
  var ctrl = this;
  // Toggle <body> class when created and destroyed
  ctrl.$onInit = function(){
    $('body').addClass('fullscreen-active');
  }
  ctrl.$onDestroy = function(){
    $('body').removeClass('fullscreen-active');
  }
}

angular
  .module('app')
  .component('fullscreen', fullscreenComponent);

},{}],235:[function(require,module,exports){

/** GROUP APPEARANCE COMPONENT
 *
 *    Shows the unified certificate/badge appearance for a group
 *
 *    <group-appearance group="group" use-bitmap-badge="true"></group-appearance>
 *
 *    use-bitmap-badge is optional - if present and 'true', the rasterized_content_url of the badge is rendered rather than the SVG
 *
 */
var groupAppearanceComponent = {
  bindings: {
    group: '<',
    issuer: '<?',
    useBitmapBadge: '<?'
  },
  templateUrl: '/shared/group-appearance/group-appearance.html',
};

angular
  .module('app')
  .component('groupAppearance', groupAppearanceComponent);

},{}],236:[function(require,module,exports){
/** Help Guide - SERVICE
 *
 *    A simple service to modify the "state"
 *     of the help-guide.
 *
 *    helpGuideService.show();
 *    helpGuideService.hide();
 */
function helpGuideService(){
  var service = this;
  service.data = {
    visible: false,
    available: false,
  };
  service.show = show;
  service.hide = hide;
  service.available = available;
  function show(){
    service.data.visible = true;
  }
  function hide(){
    service.data.visible = false;
  }
  function available(state){
    if(state && service.data.available){
      console.error('Another <help-guide> already exists'); // Throw a warning if we're being notified of multiple <help-guide> elements
    }
    service.data.available = state; // Update the state
  }
}

/** Help Guide - COMPONENT
 *
 *    The container for your help-guide.
 *
 *    See the template and stylesheet for more
 *     details on how this works.
 *
 *    <help-guide>
 *      <h3>This is my help guide</h3>
 *      <p>A Jedi must have the deepest commitment, the most serious mind</p>
 *      <p>Concentraaaaaaate</p>
 *    <help-guide>
 */
var helpGuideComponent = {
  controller: helpGuideComponentController,
  transclude: true,
  templateUrl: '/shared/help-guide/help-guide.html',
};

helpGuideComponentController.$inject = ['helpGuideService'];
function helpGuideComponentController(helpGuideService) {
  var ctrl = this;
  ctrl.data = helpGuideService.data; // contains the visible flag
  ctrl.hide = helpGuideService.hide;
  ctrl.showChat = helpGuideService.chat;
  // Notify the service that the component exists, or not
  ctrl.$onInit = onInit;
  ctrl.$onDestroy = onDestroy;
  function onInit(){
    helpGuideService.available(true);
  }
  function onDestroy(){
    helpGuideService.available(false);
  }
  // Prevents the initial render from animating, see:
  //  https://www.bennadel.com/blog/2765-preventing-animation-during-the-initial-render-of-ngrepeat-in-angularjs.htm
  ctrl.hasLoaded = false;
  ctrl.$postLink = postLink;
  function postLink(){
    ctrl.hasLoaded = true;
  }
}

/** Show Help Guide - DIRECTIVE
 *
 *    Shows the help-guide when clicked.
 *    Hides the element if there is no help-guide available.
 *
 *    Apply to any element.
 *
 *    <button show-help-guide>I need help</button>
 *    <span show-help-guide>I need help</span>
 */
showHelpGuideDirective.$inject = ['$compile', '$timeout', 'helpGuideService'];
function showHelpGuideDirective($compile, $timeout, helpGuideService){
  return {
    restrict: 'A', // Attribute only
    scope: {},
    link: function(scope, element, attrs) {
      // Recompile with different attributes
      scope.data = helpGuideService.data;
      scope.showHelp = helpGuideService.show;
      attrs.$set('ng-if', 'data.available'); // Hide when there's no guide available
      attrs.$set('ng-click', 'showHelp()'); // Show the guide when clicked
      element.removeAttr('show-help-guide'); // Prevent infinite compile
      $compile(element)(scope);
    }
  };
}

angular
  .module('app')
  .service('helpGuideService', helpGuideService)
  .component('helpGuide', helpGuideComponent)
  .directive('showHelpGuide', showHelpGuideDirective);

},{}],237:[function(require,module,exports){
/** HISTORY FACTORY
 *
 *    Instantiate with any number of objects or arrays, make changes
 *     and access undo and redo logic, like so:
 *
 *      var obj = { hello: 'world' };
 *      var arr = [ 'a', 'b', 'c', ];
 *      var objHistory = new HistoryFactory(obj, arr, ...);
 *
 *    @author   David "oodavid" King (Factory refactor)
 *    @author   Ryan Booth (original Service)
 *
 *    https://youtu.be/z0uwB-Zetos
 *
 *    TODO
 *      Is there any benefit to making this run work ONCE per digest..?
 *          Is this a timesaver? A performance improvement?
 *        $rootScope.$watch(function(){ ...Runs once per digest... });
 */
HistoryFactory.$inject = ['_', 'emitter'];
function HistoryFactory(_, emitter){
  return function() {
    var factory = this;

    // Public properties and methods
    factory.timestamp = null; // The timestamp for the current history
    factory.canUndo = canUndo;
    factory.canRedo = canRedo;
    factory.save = save;
    factory.restoreSnapshot = restoreSnapshot;
    factory.undo = undo;
    factory.redo = redo;

    // This is an emitter
    emitter.addEmitterLogicTo(factory);

    // Private
    var subjects = arguments; // We can track multiple objects or arrays
    var history = []; // Each call to "save" makes a copy of every subject on the history
    var currentIndex = 0; // The "current" position on the history stack

    // Begin by saving the current state
    save();

    function canUndo(){
      return currentIndex > 0;
    }

    function canRedo(){
      return currentIndex < history.length - 1;
    }

    function save(){
      var snapshot = {
        timestamp: Date.now(), // The save time
        subjects: [], // Will contains a copy of each of the subjects that we instantiated with
      };
      for(var a = 0, al = subjects.length; a < al; a++){
        snapshot.subjects.push(angular.copy(subjects[a]));
      }
      if(history[currentIndex] && _.isEqual(history[currentIndex].subjects, snapshot.subjects)){
        return; // Do nothing if the new snapshot is the same as the current snapshot
      }
      if(canRedo()){
        history = history.slice(0, currentIndex + 1); // Since we can "redo" we must overwrite that timeline (consider Back To The Future: Part II)
      }
      factory.timestamp = snapshot.timestamp; // Store the time
      history.push(snapshot);
      currentIndex = history.length - 1;
      factory.trigger('save');
    }

    function restoreSnapshot(indexDiff){
      currentIndex += indexDiff;
      var snapshot = history[currentIndex];
      factory.timestamp = snapshot.timestamp; // Update the timestamp
      for(var s = 0, sl = snapshot.subjects.length; s < sl; s++){
        if(snapshot.subjects[s] !== subjects[s]){
          angular.copy(snapshot.subjects[s], subjects[s]);
        }
      }
      factory.trigger('restoreSnapshot');
    }

    function undo(){
      if(canUndo()){
        restoreSnapshot(-1);
        factory.trigger('undo');
      }
    }

    function redo(){
      if(canRedo()){
        restoreSnapshot(+1);
        factory.trigger('redo');
      }
    }

  };
}

angular
  .module('app')
  .factory('HistoryFactory', HistoryFactory);

},{}],238:[function(require,module,exports){
/** Hot Keys - DIRECTIVE
 *
 *    Adds hotkey shortcuts that triggers a "click" event
 *     on elements. Automatically appends the shortcut to
 *     the [tooltip] value (if the element has one)
 *
 *    Doesn't fire when triggered on text-accepting inputs
 *
 *    Example
 *      <button ng-click="alert('saved');" hotkeys="CMD+S">...</button>
 *      <a href="/index.html" hotkeys="CMD+A">...</a>
 *      <a ui-sref="issuer.dashboard" hotkeys="CMD+H">...</a>
 *
 *    Patterns
 *      CMD+SHIFT+A
 *      CMD+S
 *      UP
 *      SHIFT+UP
 *      CMD+ALT+SHIFT+UP
 *
 *    Notes
 *      Use CMD, never CTRL or META
 *      Use ENTER, never RETURN
 *      Use PLUS and MINUS, never + or -
 *
 *    @author   David "oodavid" King
 */
hotkeysDirective.$inject = ['$document'];
function hotkeysDirective($document){
  // All active hotkey elements
  var hotkeys = {};
  // On mac we render ⌘, on everything else we render CTRL
  var cmd = 'CTRL';
  if (navigator.userAgent.indexOf('Mac OS X') !== -1) {
    cmd = '⌘';
  }
  // Map KeyCodes to named keys
  var keyMap = {
    8: 'DEL',
    9: 'TAB',
    13: 'ENTER',
    16: 'SHIFT',
    17: 'CMD',
    18: 'ALT',
    20: 'CAPSLOCK',
    27: 'ESC',
    32: 'SPACE',
    33: 'PAGEUP',
    34: 'PAGEDOWN',
    35: 'END',
    36: 'HOME',
    37: 'LEFT',
    38: 'UP',
    39: 'RIGHT',
    40: 'DOWN',
    45: 'INS',
    46: 'DEL',
    91: 'CMD',
    93: 'CMD',
    187: 'PLUS',
    189: 'MINUS',
    219: '[',
    221: ']',
    224: 'CMD'
  };
  // When the event target accepts text-input, we don't trigger hotkeys
  var inputNodes = /textarea|input|select/i;
  // Customises the hotkey for the platform - CMD becomes ⌘ or CTRL
  var hotkeyStringToHuman = function(hotkeyString) {
    return hotkeyString.replace(/cmd/gi, cmd).toUpperCase();
  };
  // Returns the same combo string every time (by using sort) - this is for internal comparison, not display
  var hotkeyArrayToCombo = function(hotkeyArray) {
    var tmp = hotkeyArray.sort();
    return tmp.join('+').toUpperCase();
  };
  var hotkeyStringToCombo = function(hotkeyString) {
    return hotkeyArrayToCombo(hotkeyString.split('+'));
  };
  // Pulls out the current META, ALT, CTRL, CMD and SHIFT states, as well as the key
  var setKeysByEvent = function(e) {
    // The key being used - either a special character, or an alphanumeric
    var key = false;
    if (keyMap[e.keyCode]) {
      key = keyMap[e.keyCode];
    } else if ((e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 97 && e.keyCode <= 122) || (e.keyCode >= 48 && e.keyCode <= 57)) {
      key = String.fromCharCode(e.which).toUpperCase();
    }
    // Create an array of all active keys
    var keys = [];
    if (e.shiftKey) {
      keys.push('SHIFT');
    }
    if (e.metaKey || e.ctrlKey) {
      keys.push('CMD');
    }
    if (e.altKey) {
      keys.push('ALT');
    }
    if (keys.indexOf(key) === -1) {
      keys.push(key);
    }
    // Build a combo
    var combo = (e.type === 'keydown') ? hotkeyArrayToCombo(keys) : false;
    // Don't fire if the target is "text-accepting"
    if (e.target.isContentEditable || inputNodes.test(e.target.nodeName)) {
      return;
    }
    // Trigger events
    if (e.type === 'keydown') {
      angular.forEach(hotkeys, function(hotkey) {
        if (hotkey.combo === combo) {
          hotkey.element.triggerHandler('mousedown'); // This is the proper
          hotkey.element.triggerHandler('mouseup'); // order of events
          hotkey.element.triggerHandler('click'); // for a natural click
          e.preventDefault(); // Reserve the combo for our app
        }
      });
    }
  };
  // Listeners
  $document.bind('keydown', setKeysByEvent);
  $document.bind('keyup', setKeysByEvent);
  // Elements with the hotkeys attribute are added to the watch list
  var link = function(scope, element, attrs) {
    // Grab the hotkey combo
    var hotkey = attrs.hotkeys;
    var combo = hotkeyStringToCombo(hotkey);
    var human = hotkeyStringToHuman(hotkey);
    // Make sure it's available
    if (hotkeys[combo]) {
      console.warn('HOTKEYS > The hotkey ' + hotkey + ' is already in use by', hotkeys[combo].element[0]);
      return;
    }
    // Add the hotkey, remove when destroyed
    hotkeys[combo] = {
      element: element,
      combo: combo
    };
    element.on('$destroy', function() {
      delete hotkeys[combo];
    });
    // Update the tooltip
    var tooltip = (attrs.tooltip ? attrs.tooltip + ', ' : '') + human;
    // Changed this from attrs.$set('tooltip', tooltip) as the tooltips were not showing in the UI
    attrs.$set('tooltip', tooltip);
  };
  // Attribute only Directive
  return {
    restrict: 'A',
    link: link
  };
}

angular
  .module('app')
  .directive('hotkeys', hotkeysDirective);

},{}],239:[function(require,module,exports){
// This is written by Juri Strumpflohner
// https://github.com/juristr/angular-translate-loader-pluggable
// It is available on npm, but the version (1.3.1) of the library on there is written in TypeScript
// with an angular include that was causing 'WARNING: Tried to load angular more than once.' to be
// shown in the browser. Hence this file.

function translatePluggableLoaderProvider() {
  'use strict';

  var loaders = [];
  var translationTable = {};

  this.useLoader = function (loaderName, options) {
    loaders.push({
      name: loaderName,
      options: options
    });
    return this;
  };

  this.translations = function (language, translations) {
    translationTable[language] = angular.extend({}, translationTable[language], translations);
    return this;
  };

  this.$get = ['$q', '$injector', function ($q, $injector) {
    return function (options) {
      var deferred = $q.defer();

      var loaderInstances = [];

      // lookup in translation table
      loaderInstances.push(function () {
        var deferred = $q.defer();
        deferred.resolve(translationTable[options.key]);
        return deferred.promise;
      }());

      // lookup in loaders
      for (var i = 0; i < loaders.length; i++) {
        var loader = loaders[i];

        // get the loader and resolve it, passing in the required options
        var loaderPromise = $injector.get(loader.name)(angular.extend(options, loader.options));
        loaderInstances.push(loaderPromise);
      }

      $q.all(loaderInstances)
        .then(function (loaders) {
          var result;
          for (var i = 0; i < loaders.length; i++) {
            result = angular.extend({}, result, loaders[i]);
          }
          deferred.resolve(result);
        });

      return deferred.promise;
    };
  }];
}

angular
  .module('pascalprecht.translate')
  .provider('translatePluggableLoader', translatePluggableLoaderProvider);

},{}],240:[function(require,module,exports){
// Module Dependencies
require('angular-translate');
require('angular-translate-loader-static-files');
require('angular-translate-loader-partial');
require('angular-dynamic-locale');
require('./angular-translate-loader-pluggable.js'); // For multiple dictionary support
require('angular-translate-handler-log'); // For debugging
angular.module('app').requires.push('pascalprecht.translate');
angular.module('app').requires.push('tmh.dynamicLocale');

// Constants
require('./language.constants.js');

languageConfig.$inject = ['ENV', 'LANGUAGES', '$translateProvider', 'tmhDynamicLocaleProvider', 'translatePluggableLoaderProvider'];
function languageConfig(ENV, LANGUAGES, $translateProvider, tmhDynamicLocaleProvider, translatePluggableLoaderProvider) {
  // Massage the LANGUAGES into valid format
  var languageKeys = Object.keys(LANGUAGES);
  var languageMaps = {};
  angular.forEach(languageKeys, function(key){
    languageMaps[key+'-*'] = key; // glob-like catch-all
  });
  // Add wildcard to default to 'en' in case the browser language is not found
  // https://github.com/angular-translate/angular-translate/issues/1501
  languageMaps['*'] = 'en';
  // Path to our locale (angular)
  tmhDynamicLocaleProvider.localeLocationPattern('/shared/i18n/data/{{locale}}.js');
  tmhDynamicLocaleProvider.defaultLocale('en');
  // Path to our translations (app)
  // https://angular-translate.github.io/docs/#/guide/12_asynchronous-loading
  //$translatePartialLoaderProvider.addPart('main');
  /**
   * $translateProvider only allows a single loader at a time
   * Using pluggable loader to allow apps to add translation loaders
   * for partials without destroying previous configuration
   */
  // https://stackoverflow.com/questions/35272213/angular-translate-multiple-json-files
  $translateProvider
    .useLoader('translatePluggableLoader')
    .useSanitizeValueStrategy('escape')
    .uniformLanguageTag('bcp47') // Converts en_US, en-US, EN-us etc. to en-us
    .registerAvailableLanguageKeys(languageKeys, languageMaps)
    .fallbackLanguage('en')
    .determinePreferredLanguage();
  // Load the main dictionary
  translatePluggableLoaderProvider.useLoader('$translateStaticFilesLoader', {
    prefix: '/shared/i18n/data/',
    suffix: '.json?' + ENV.cachebust // these don't go through our decorator :(
  });
  // For debugging
  $translateProvider.useMissingTranslationHandlerLog();
}

angular
  .module('app')
  .config(languageConfig);

},{"./angular-translate-loader-pluggable.js":239,"./language.constants.js":241,"angular-dynamic-locale":1,"angular-translate":9,"angular-translate-handler-log":6,"angular-translate-loader-partial":7,"angular-translate-loader-static-files":8}],241:[function(require,module,exports){
angular
  .module('app')
  .constant('LANGUAGES', {
    ar: {
      value: 'ar',
      name: 'عربى',
      description: 'Arabic (General)',
    },
    cs: {
      value: 'cs',
      name: 'Česky',
      description: 'Czech',
    },
    da: {
      value: 'da',
      name: 'Dansk',
      description: 'Danish',
    },
    de: {
      value: 'de',
      name: 'Deutsch',
      description: 'German'
    },
    el: {
      value: 'el',
      name: 'Νέα Ελληνικά',
      description: 'Greek',
    },
    en: {
      value: 'en',
      name: 'English (US)',
      description: 'English (US)',
    },
    'en-gb': {
      value: 'en-gb',
      name: 'English (UK)',
      description: 'English (UK)',
    },
    es: {
      value: 'es',
      name: 'Español',
      description: 'Spanish',
    },
    'es-419': {
      value: 'es-419',
      name: 'Español (Latinoamérica)',
      description: 'Spanish (Latin America)'
    },
    fi: {
      value: 'fi',
      name: 'Suomalainen',
      description: 'Finnish',
    },
    fr: {
      value: 'fr',
      name: 'Français',
      description: 'French',
    },
    he: {
      value: 'he',
      name: 'עברית',
      description: 'Hebrew',
    },
    hi: {
      value: 'hi',
      name: 'हिन्दी',
      description: 'Hindi',
    },
    hr: {
      value: 'hr',
      name: 'Hrvatski',
      description: 'Croatian',
    },
    hu: {
      value: 'hu',
      name: 'Magyar',
      description: 'Hungarian',
    },
    id: {
      value: 'id',
      name: 'Bahasa Indonesia',
      description: 'Indonesian',
    },
    it: {
      value: 'it',
      name: 'Italiano',
      description: 'Italian',
    },
    ja: {
      value: 'ja',
      name: '日本語',
      description: 'Japanese',
    },
    ko: {
      value: 'ko',
      name: '한국어',
      description: 'Korean',
    },
    ms: {
      value: 'ms',
      name: 'Malay',
      description: 'Malay',
    },
    nb: {
      value: 'nb',
      name: 'Norsk Bokmål',
      description: 'Norwegian',
    },
    nl: {
      value: 'nl',
      name: 'Nederlands',
      description: 'Dutch',
    },
    pl: {
      value: 'pl',
      name: 'Polski',
      description: 'Polish',
    },
    'pt-br': {
      value: 'pt-br',
      name: 'Português (Brasil)',
      description: 'Portuguese (Brazil)',
    },
    'pt-pt': {
      value: 'pt-pt',
      name: 'Português (Portugal)',
      description: 'Portuguese (Portugal)'
    },
    ro: {
      value: 'ro',
      name: 'Română',
      description: 'Romanian',
    },
    ru: {
      value: 'ru',
      name: 'Русский',
      description: 'Russian',
    },
    sk: {
      value: 'sk',
      name: 'Slovenský',
      description: 'Slovak'
    },
    sl: {
      value: 'sl',
      name: 'Slovenščina',
      description: 'Slovenian',
    },
    sv: {
      value: 'sv',
      name: 'Svenska',
      description: 'Swedish',
    },
    th: {
      value: 'th',
      name: 'ไทย',
      description: 'Thai',
    },
    tr: {
      value: 'tr',
      name: 'Türk',
      description: 'Turkish',
    },
    vi: {
      value: 'vi',
      name: 'Việtnam',
      description: 'Vietnamese',
    },
    'zh-cn': {
      value: 'zh-cn',
      name: '简体中文',
      description: 'Simplified Chinese'
    },
    'zh-tw': {
      value: 'zh-tw',
      name: '繁體中文',
      description: 'Traditional Chinese',
    },
    'zh-hant-tw': {
      value: 'zh-hant-tw',
      name: '繁體中文（台灣）',
      description: 'Traditional Chinese (Taiwan)',
    },
    // This version of Norwegian isn't selectable from Chrome or Safari, but is from Firefox
    // and so is hidden from the language select but still available via browser language code (no)
    no: {
      value: 'no',
      name: 'Norsk',
      description: 'Norwegian',
      hidden: true,
    },
  });

},{}],242:[function(require,module,exports){
/** LANGUAGE - SERVICE
 *
 *      Change the language used for locale and translations
 *      Get a list of available languages
 *      Convert a language string into a two letter code, ie: `en_UK` => `en`
 *
 *  A VERY IMPORTANT NOTE
 *
 *      Before my time, the angular ngLocale files were manually copied to
 *       a project directory. I do not know the rationale for this decision.
 *
 *      If you upgrade angular, or have issues with locale, consider reviewing
 *       these files:
 *
 *          ./data/en.js
 *          ./data/xx.js
 *
 *      You can find the locales here (don't forget to use correct branch)
 *
 *          https://github.com/angular/angular.js/tree/master/src/ngLocale
 *
 *  @author   David "oodavid" King
 */
languageService.$inject = ['LANGUAGES', '$translate', 'tmhDynamicLocale', '$injector'];
function languageService(LANGUAGES, $translate, tmhDynamicLocale, $injector){
  var service = this;
  service.getTwoLetterCode = getTwoLetterCode;
  service.setLocale = setLocale;
  service.getLocale = getLocale;
  service.getLanguages = getLanguages;
  service.getLanguageFromCode = getLanguageFromCode;
  service.getLanguageFromCodeNoDefault = getLanguageFromCodeNoDefault;
  service.setABDatepickerLocale = setABDatepickerLocale;
  // 2-Letter Codes
  var codes = Object.keys(LANGUAGES);
  // Converts a language to a twoLetterCode
  //   Uses `substring` to convert 'en_US' into 'en' and 'es_es' into 'es' etc.
  function getTwoLetterCode(language) {
    var twoLetterCode = (language || 'en').substring(0, 2);
    if (codes.indexOf(twoLetterCode) === -1) {
      twoLetterCode = 'en'; // Default to 'en'
    }
    return twoLetterCode;
  }
  // Set the locale
  function setLocale(language) {
    var twoLetterCode = getTwoLetterCode(language);
    $translate.use(twoLetterCode); // This is immediate
    setABDatepickerLocale(twoLetterCode); // This is immediate
    return tmhDynamicLocale.set(twoLetterCode); // This returns a promise
  }
  // Return the current locale
  function getLocale(){
    return $translate.use();
  }
  // Returns the available languages
  function getLanguages() {
    return LANGUAGES;
  }
  // Converts a language code to a name
  function getLanguageFromCode(twoLetterCode){
    return LANGUAGES[twoLetterCode] || LANGUAGES['en'];
  }

  function getLanguageFromCodeNoDefault(twoLetterCode){
      return LANGUAGES[twoLetterCode];
  }
  // Resets the ab-datepicker locale
  function setABDatepickerLocale(twoLetterCode){
    // If ab-datepicker module is included and loaded, then this is set.
    if ($injector.has('inputDateAccessibleDirective')) {
      Date.dp_locales = undefined;
      $('#datepicker-language').remove();
      var imported = document.createElement('script');
      imported.id = 'datepicker-language';
      imported.src = '../shared/i18n/data/ab-datepicker/' + twoLetterCode + '.min.js';
      document.head.appendChild(imported);
    }
  }
}

languageServiceRun.$inject = ['$rootScope', 'languageService', 'tmhDynamicLocale'];
function languageServiceRun($rootScope, languageService, tmhDynamicLocale){
  // When the language changes...
  $rootScope.$on('$translateLoadingSuccess', handleLanguageChange);
  $rootScope.$on('$translateChangeSuccess', handleLanguageChange);
  // Make sure our locale matches it! (ie: dates etc.)
  function handleLanguageChange(event, config){
    var twoLetterCode = languageService.getTwoLetterCode(config.language);
    languageService.setABDatepickerLocale(twoLetterCode);
    tmhDynamicLocale.set(twoLetterCode);
  }
}

angular
  .module('app')
  .service('languageService', languageService)
  .run(languageServiceRun);

},{}],243:[function(require,module,exports){
languageNameFilter.$inject = ['languageService'];
function languageNameFilter(languageService){
  return function(twoLetterCode){
    return languageService.getLanguageFromCode(twoLetterCode).name;
  };
}

angular
  .module('app')
  .filter('languageName', languageNameFilter);

},{}],244:[function(require,module,exports){
/** ICON FILTERS
 *
 *    These filters allow us to use icons on the accredible
 *     platform in a simple and consistent manner. The filters
 *     are the logic that complements _icons.scss classes.
 *
 *    Structure
 *      The filters have been written with a strict taxonomy
 *       in mind; if the icon relates to a credential, then
 *       it should accept a credential object. The same would
 *       apply for users, groups, organisations, evidence etc.
 *
 *    Usage
 *      <i class="multiselect" ng-class="myVariable | iconMultiselect"></i>
 *      <i ng-class="myCredentialObject | iconCredentialStatus"></i>
 *      <i ng-class="attribute.type | inputTypeIcon"></i>
 *
 *    See also `tooltip.filters.js` for similar logic
 *
 *    @author   David "oodavid" King
 *    @author   Jake Ford
 *    @author   Andrew Bateman
 */
angular.module('app')

  .filter('iconCredentialStatus', function() {
    return function(credential) {
      if (credential) {
        if (credential.expired) {
          return 'credential-status expired';
        } else if (credential.bounced_email) {
          return 'credential-status bounced';
        } else if (credential.badge_design_id && credential.certificate_design_id) {
          if (credential.approve) {
            return 'credential-status design published';
          } else {
            return 'credential-status design unpublished';
          }
        } else if (credential.badge_design_id) {
          if (credential.approve) {
            return 'credential-status badge-icon published';
          } else {
            return 'credential-status badge-icon unpublished';
          }
        } else if (credential.certificate_design_id) {
          if (credential.approve) {
            return 'credential-status certificate published';
          } else {
            return 'credential-status certificate unpublished';
          }
        }
      } else {
        return 'credential-status';
      }
    };
  })

  .filter('iconCredentialEngagement', function() {
    return function(credential) {
      if (credential) {
        if (credential.recipient_engaged) {
          return 'credential-engagement true';
        } else {
          return 'credential-engagement false';
        }
      } else {
        return 'credential-engagement';
      }
    };
  })

  .filter('iconCredentialRecipientOpened', function() {
    return function(credential) {
      if (credential) {
        if (credential.recipient_opened) {
          return 'credential-recipient-opened true';
        } else {
          return 'credential-recipient-opened false';
        }
      } else {
        return 'credential-recipient_opened';
      }
    };
  })

  .filter('iconCredentialLinkedin', function() {
    return function(credential) {
      if (credential) {
        if (credential.linkedin_engaged || credential.is_added_to_linkedin) {
          return 'credential-linkedin true';
        } else {
          return 'credential-linkedin false';
        }
      } else {
        return 'credential-linkedin';
      }
    };
  })

  .filter('iconCredentialPrivate', function() {
    return function(credential) {
      if (credential) {
        if (credential.private) {
          return 'credential-private true';
        } else {
          return 'credential-private false';
        }
      } else {
        return 'credential-private';
      }
    };
  })

  .filter('iconSelected', function() {
    return function(input) {
      if (input) {
        return 'true';
      }
      return 'false';
    };
  })

  .filter('iconMultiselect', function() {
    return function(input) {
      switch (input) {
        case 'everything':
          return 'everything';
        case 'visible':
          return 'visible';
        case 'some':
          return 'some';
        case 'one':
          return 'one';
        case 'none':
        default:
          return 'none';
      }
    };
  })

  .filter('inputTypeIcon', function() {
    return function(type) {
      switch (type) {
        case 'date':
          return 'date';
        case 'email':
          return 'email';
        case 'image':
          return 'image';
        case 'boolean':
          return 'tick';
        case 'url':
          return 'link';
        case 'text':
          return 'editor-align-left';
        default:
          return 'help';
      }
    };
  });

},{}],245:[function(require,module,exports){
/** IMG ONLOAD - DIRECTIVE
 *
 *      Add this attribute to an <img> element to receive
 *       callback events when loaded. Example:
 *
 *          <img src="https://www.google.com/intl/en_ALL/images/logo.gif" width="100" height="100" img-onload="imgOnload(props)">
 *
 *      @author   David "oodavid" King
 */
function imgOnloadDirective(){
  return {
    restrict: 'A',
    scope: {
      callback: '&imgOnload',
    },
    link: function(scope, element, attrs) {
      element.bind('load', function() {
        var props = {
          naturalWidth: this.naturalWidth,
          naturalHeight: this.naturalHeight,
          width: this.clientWidth,
          height: this.clientHeight,
          src: this.src,
          ext: this.src.split('.').pop().toLowerCase(),
        };
        scope.$apply(function() {
          scope.callback({
            props: props
          });
        });
      });
    },
  };
}

angular
  .module('app')
  .directive('imgOnload', imgOnloadDirective);

},{}],246:[function(require,module,exports){
/** INPUT BINARY FILTER COMPONENT
 *
 *  Requires: ../shared/input-checkboxes/input-checkboxes.component.js
 *
 *  <input-binary-filter ng-model="$ctrl.form.property" change-action="formCtrl.submitValidate" option-labels="[ 'Yes', 'No' ]" option-labels="[ 'right', 'wrong' ]" reset="$ctrl.resetProperty"></input-binary-filter>
 *
 *  @author   Andrew Bateman
 */
var inputBinaryFilterComponent = {
  controller: inputBinaryFilterComponentController,
  bindings: {
    ngModel: '=',
    reset: '=?',
    changeAction: '<',
    optionLabels: '<',
    optionValues: '<?',
  },
  templateUrl: '/shared/input-binary-filter/input-binary-filter.html',
};

inputBinaryFilterComponentController.$inject = [];
function inputBinaryFilterComponentController() {
  var ctrl = this;

  ctrl.$onInit = $onInit;
  ctrl.change = change;

  ctrl.model = [];

  function $onInit() {
    // Initialise binary values
    ctrl.options = [
      { value: ctrl.optionValues ? ctrl.optionValues[0] : true,  title: ctrl.optionLabels[0] },
      { value: ctrl.optionValues ? ctrl.optionValues[1] : false, title: ctrl.optionLabels[1] }
    ];
    // Initialise internal model
    ctrl.model = ctrl.ngModel == null || ctrl.ngModel === '' ? [] : [ctrl.ngModel];
    // If required, expose reset function
    if (ctrl.reset) {
      ctrl.reset = function() {
        ctrl.model = [];
      };
    }
  }

  function change () {
    // Propagate internal model change to external model
    ctrl.ngModel = ctrl.model == null ? null : (ctrl.model.length === 2 ? null : ctrl.model[0]);
    // Run change action
    ctrl.changeAction();
  }
}

angular
  .module('app')
  .component('inputBinaryFilter', inputBinaryFilterComponent);

},{}],247:[function(require,module,exports){
/** INPUT BY TYPE - DIRECTIVE
 *
 *    <input-by-type type="{{ $ctrl.myType }}" name="myName" ng-model="myInput"></input-by-type>
 *    <input-by-type type="{{ $ctrl.myType }}" name="myName" ng-model="myInput" ng-required="true"></input-by-type>
 *    <input-by-type type="{{ $ctrl.myType }}" name="myName" ng-model="myInput" ng-disabled="true"></input-by-type>
 *
 *    Where the myType can be:
 *      text, email, image, date, color, language, boolean
 *
 *    This component is designed to be used in a loop, like so:
 *
 *    <label ng-repeat="field in fields">
 *      {{ field.name }}
 *      <input-by-type type="{{ field.type }}" name="myInput{{$index}}"></input-by-type>
 *    </label>
 *
 *    This was a RIGHT FANNY ON to get working as expected, I kept creating
 *     multiple models, or somehow just messing things up. The only setup
 *     that worked was spawned from the following answers:
 *      http://stackoverflow.com/questions/42683362/custom-directive-fails-to-compile-within-ng-repeat
 *      http://stackoverflow.com/a/21687744/1122851
 *
 *    @author   David "oodavid" King
 */
inputByTypeDirective.$inject = ['$compile', '$interpolate'];
function inputByTypeDirective($compile, $interpolate){
  return {
    restrict: 'E',
    compile: function(element, attrs) {
      return function postLinkFn(scope, element, attrs) {
        var type = $interpolate(attrs.type)(scope); // Convert input-by-type="{{ some.type }}" into a useable value
        var html = getInputByTypeElement(attrs, type);
        var template = angular.element(html);
        element.replaceWith(template);
        $compile(template)(scope);
      };
    },
  };
}

function getInputByTypeElement(attrs, type){
  type = type || 'text';
  var types = {
    text:     '<input type="text"  name="' + attrs.name + '" ng-model="' + attrs.ngModel + '" ng-disabled="' + attrs.ngDisabled + '" ng-required="' + attrs.ngRequired + '" />',
    email:    '<input type="email" name="' + attrs.name + '" ng-model="' + attrs.ngModel + '" ng-disabled="' + attrs.ngDisabled + '" ng-required="' + attrs.ngRequired + '" validate-email />',
    image:    '<input-image        name="' + attrs.name + '" ng-model="' + attrs.ngModel + '" ng-disabled="' + attrs.ngDisabled + '" ng-required="' + attrs.ngRequired + '"></input-image>',
    file:     '<input-file         name="' + attrs.name + '" ng-model="' + attrs.ngModel + '" ng-disabled="' + attrs.ngDisabled + '" ng-required="' + attrs.ngRequired + '"></input-file>',
    date:     '<input-date         name="' + attrs.name + '" ng-model="' + attrs.ngModel + '" ng-disabled="' + attrs.ngDisabled + '" ng-required="' + attrs.ngRequired + '"></input-date>',
    color:    '<input-color        name="' + attrs.name + '" ng-model="' + attrs.ngModel + '" ng-disabled="' + attrs.ngDisabled + '" ng-required="' + attrs.ngRequired + '"></input-color>',
    language: '<input-language     name="' + attrs.name + '" ng-model="' + attrs.ngModel + '" ng-disabled="' + attrs.ngDisabled + '" ng-required="' + attrs.ngRequired + '"></input-language>',
    boolean:  '<input-tabs         name="' + attrs.name + '" ng-model="' + attrs.ngModel + '" ng-disabled="' + attrs.ngDisabled + '" ng-required="' + attrs.ngRequired + '" options="[ { value: true, html: \'True\', }, { value: false, html: \'False\', } ]"></input-tabs>',
  };
  return types[type];
};

angular
  .module('app')
  .directive('inputByType', inputByTypeDirective);

},{}],248:[function(require,module,exports){
/** INPUT CHECKBOXES COMPONENT
 *
 *    var listOptions = [
 *      { value: 1,     title: 'First', },
 *      { value: 'key', title: 'Second', },
 *      { value: 3,     title: 'Third <em>...place?</em>', },
 *    ];
 *    ...OR...
 *    var listOptions = [ 'First', 'Second', 'Third' ];
 *
 *    <input-checkboxes ng-model="myTest" options="listOptions"></input-checkboxes>
 *    <input-checkboxes ng-model="myTest" options="listOptions" all="All The Things"></input-checkboxes>
 *    <input-checkboxes ng-model="myTest" options="listOptions" ng-required="true"></input-checkboxes>
 *    <input-checkboxes ng-model="myTest" options="listOptions" ng-disabled="true"></input-checkboxes>
 *
 *    Notes
 *
 *      This is flexible in the objects it will accept.
 *
 *      The `value` is taken from `value` or `id`. These are equivilent:
 *
 *        { value: 123,     title: 'First', },
 *        { id:    123,     title: 'First', },
 *
 *      The `title` is taken from `title`, `name` or `html`. These are equivilent:
 *
 *        { value: 123,     title: 'First', },
 *        { value: 123,     name:  'First', },
 *        { value: 123,     html:  'First', },
 *
 *      ...and any variation thereof
 *
 *    @author   David "oodavid" King
 */
var inputCheckboxesComponent = {
  controller: inputCheckboxesComponentController,
  bindings: {
    ngModel: '<',
    options: '<',
    all: '@?',
    ngDisabled: '<?',
    ngRequired: '<?',
  },
  require: {
    ngModelCtrl: 'ngModel'
  },
  templateUrl: '/shared/input-checkboxes/input-checkboxes.html',
};

inputCheckboxesComponentController.$inject = [];
function inputCheckboxesComponentController() {
  var ctrl = this;
  ctrl.selectAll = selectAll;
  ctrl.doSelect = doSelect;
  ctrl.state = 'none'; // How many items are selected? 'none', 'one', 'some', 'everything'
  var selection = [];

  ctrl.$onInit = function () {
    handleOptionsChange();
    handleModelChange();
    updateSelectionAndState();
  };

  ctrl.$onChanges = function(changes){
    if(changes.options){
      handleOptionsChange();
    }
    if(changes.ngModel){
      handleModelChange();
    }
  };

  // Massages the options into a simple format we can use
  function handleOptionsChange(){
    if(!ctrl.options){
      return;
    }
    // Don't dirty the original object
    ctrl.options = angular.copy(ctrl.options);
    // Massage arrays into objects
    if(typeof ctrl.options[0] !== 'object'){
      var tmp = [];
      for(var o=0,ol=ctrl.options.length; o<ol; o++){
        tmp.push({
          value: ctrl.options[o],
          title: ctrl.options[o],
        });
      }
      ctrl.options = tmp;
    } else {
      // Massage into { value, title }
      for(var o=0,ol=ctrl.options.length; o<ol; o++){
        var option = angular.copy(ctrl.options[o]);
        option.title = getFirstProperty(option, ['title', 'name', 'html']); // any defined "title" property is used
        option.value = getFirstProperty(option, ['value', 'id', 'title']);  // any defined "value" property is used, falling back to the title
        // Replace with a simple object
        ctrl.options[o] = {
          title: option.title,
          value: option.value,
        };
      }
    }
  }

  // Updates the selection to match the model
  function handleModelChange(){
    if(ctrl.ngModel === 'everything'){
      angular.forEach(ctrl.options, function(option){
        option.selected = true;
      });
    } else {
      angular.forEach(ctrl.options, function(option){
        option.selected = ctrl.ngModel && ctrl.ngModel.indexOf(option.value) !== -1;
      });
      /*
      angular.forEach(ctrl.ngModel, function(value){
        angular.forEach(ctrl.options, function(option){
          if(option.value == value){
            option.selected = true;
          }
        });
      });
      */
    }
  }

  // Toggles `all`
  function selectAll(){
    if(ctrl.state === 'everything'){
      angular.forEach(ctrl.options, function(option){
        option.selected = false;
      });
    } else {
      angular.forEach(ctrl.options, function(option){
        option.selected = true;
      });
    }
    updateSelectionAndState();
    updateViewValue();
  }

  // Toggles an individual option
  function doSelect(option) {
    option.selected = !option.selected;
    updateSelectionAndState();
    updateViewValue();
  }

  // Loops the options to populate the `selection` array and `state`
  function updateSelectionAndState(){
    selection.length = 0;
    angular.forEach(ctrl.options, function(option){
      if(option.selected){
        selection.push(option.value);
      }
    });
    if(selection.length === 0){
      ctrl.state = 'none';
    } else if(selection.length === 1){
      ctrl.state = 'one';
    } else if(selection.length === ctrl.options.length){
      ctrl.state = 'everything';
    } else {
      ctrl.state = 'some';
    }
  }

  // Propagates the value back to the ngModel
  // ...value can be 'everything' or [ value, value, value ]
  function updateViewValue(){
    // BE does not like `everything` as a value, but if we want to reinstate this:
    // if(ctrl.state === 'everything' && ctrl.all){
    //   ctrl.ngModelCtrl.$setViewValue('everything');
    // } else
    if(selection.length) {
      ctrl.ngModelCtrl.$setViewValue(angular.copy(selection));
    } else {
      ctrl.ngModelCtrl.$setViewValue(undefined);
    }
  }

  // UTILITY - returns the first property, allows for `null` as long as the key is defined
  function getFirstProperty(object, props){
    for(var p=0,pl=props.length; p<pl; p++){
      var prop = props[p];
      if(object.hasOwnProperty(prop)){
        return object[prop];
      }
    }
  }
}

angular
  .module('app')
  .component('inputCheckboxes', inputCheckboxesComponent);

},{}],249:[function(require,module,exports){
/** INPUT COLOR COMPONENT
 *
 *    <input-color ng-model="myColor"></input-color>
 *    <input-color ng-model="myColor" ng-required="true"></input-color>
 *    <input-color ng-model="myColor" ng-disabled="true"></input-color>
 *
 *  Styling - _form.scss
 *
 *    @author   David "oodavid" King
 */
var inputColorComponent = {
  controller: inputColorComponentController,
  bindings: {
    ngModel: '<',
    ngRequired: '<?',
    ngDisabled: '<?',
  },
  require: {
    ngModelCtrl: "ngModel"
  },
  templateUrl: '/shared/input-color/input-color.html',
};

inputColorComponentController.$inject = ['$element'];
function inputColorComponentController($element) {
  var ctrl = this;

  ctrl.fakeModel = null; // We want to let the user manually input values
  var fakeModelHex = null; // ...but we parse them into hex values, we need to track changes here!

  ctrl.$onInit = function(){
    $element.find('button').spectrum({
      color: "#000",
      showButtons: false,
      // Allow manual input
      preferredFormat: "hex",
      showInput: true,
      // Palette
      showPalette: true,
      showSelectionPalette: true,
      hideAfterPaletteSelect: true,
      palette: [],
      selectionPalette: [], // Want to set the palette value? Do it manually: localStorage.setItem('spectrum.acms', '#abcdef,#123456');
      localStorageKey: "spectrum.acms",
      // Events
      move: function(color) {
        ctrl.ngModelCtrl.$setViewValue(color.toHexString());
        ctrl.fakeModel = color.toHexString();
        fakeModelHex = color.toHexString();
      },
      beforeShow: function(color) {
        var value = ctrl.ngModel;
        $element.find('button').spectrum("set", value);
        // Alignment fix (nudge)
        angular.element('.sp-container').css({
          'margin-top': '0',
          'margin-left': '0'
        });
      },
      show: function(color) {
        // Alignment fix (nudge)
        angular.element('.sp-container').css({
          'margin-top': '-1px',
          'margin-left': '-1px'
        });
      },
    });
  };

  ctrl.$onChanges = function(changes){
    if(changes.ngModel && changes.ngModel.currentValue != fakeModelHex){
      ctrl.fakeModel = changes.ngModel.currentValue;
    }
  }

  ctrl.$onDestroy = function () {
    $element.find('button').spectrum("destroy");
  };

  ctrl.onInputChange = function(){
    if(ctrl.fakeModel){
      $element.find('button').spectrum('set', ctrl.fakeModel);
      var color = $element.find('button').spectrum('get');
      ctrl.ngModelCtrl.$setViewValue(color.toHexString());
      fakeModelHex = color.toHexString();
    } else {
      ctrl.ngModelCtrl.$setViewValue('');
    }
  }
}

angular
  .module('app')
  .component('inputColor', inputColorComponent);

},{}],250:[function(require,module,exports){
/** INPUT DATE COMPONENT
 *
 *    <input-date ng-model="myDate"></input-date>
 *    <input-date ng-model="myDate" ng-required="true"></input-date>
 *    <input-date ng-model="myDate" ng-disabled="true"></input-date>
 *    <input-date ng-model="myDate" min="today"></input-date>
 *    <input-date ng-model="myDate" max="2 weeks from now"></input-date>
 *
 *  Styling - _form.scss
 *
 *    @author   David "oodavid" King
 *    @edit     Jake Ford
 */

require('datejs');

var inputDateComponent = {
  controller: inputDateComponentController,
  require: {
    ngModelCtrl: 'ngModel'
  },
  bindings: {
    ngModel: '<',
    ngDisabled: '<?',
    min: '@?',
    max: '@?',
    focusId: '@?',
    blockEnter: '@?'
  },
  templateUrl: '/shared/input-date/input-date.html',
};

inputDateComponentController.$inject = ['$filter', '$injector', '$timeout', '$scope', '$element'];
function inputDateComponentController($filter, $injector, $timeout, $scope, $element) {
  var ctrl = this;

  ctrl.fakeModel = null; // We don't want to use a Date object as our model, but uib needs a date object to modify
  ctrl.isOpen = false;
  ctrl.open = function () {
    ctrl.isOpen = true;
  };

  // More options availabel, see: https://angular-ui.github.io/bootstrap/#!#datepicker
  ctrl.dateOptions = {
    startingDay: 1, // Monday should be the first day of the week
  };

  // Our component is ready
  ctrl.$onInit = function () {
    if(ctrl.min){
      ctrl.dateOptions['minDate'] = Date.parse(ctrl.min); // See http://datejs.com for valid formats
    }
    if(ctrl.max){
      ctrl.dateOptions['maxDate'] = Date.parse(ctrl.max); // See http://datejs.com for valid formats
    }
    var value = ctrl.ngModel;
    if (value) {
      var dateVal = stringToDate(value); // Parse the model value into a Date
      var stringVal = dateVal ? dateToString(dateVal) : ''; // Parse that Date back into a String - it may have transformed from 'today' into Date()
      ctrl.fakeModel = dateVal;
      // Set the value, without dirtying - http://stackoverflow.com/a/37491043/1122851
      var tmp = ctrl.ngModelCtrl.$setDirty;
      ctrl.ngModelCtrl.$setDirty = angular.noop;
      ctrl.ngModelCtrl.$setViewValue(stringVal);
      ctrl.ngModelCtrl.$setDirty = tmp;
    }
  };

  // The model was updated
  ctrl.$onChanges = function (changes) {
    if (changes.ngModel) {
      var dateVal = stringToDate(changes.ngModel.currentValue); // ... analyse the value
      if (dateVal != ctrl.fakeModel) {
        ctrl.fakeModel = dateVal; // Apply it if valid. Ignoring it if not; this keeps the datepicker happy as it always has access to a valid date
      }
    }
  };

  // If required, manage the focus
  var focusManagerService;
  if ($injector.has('FocusManagerService')) {
    focusManagerService = $injector.get('FocusManagerService');
  }

  // The user picked a new date
  ctrl.onDatePick = function (/* changes */) {
    var parsed = dateToString(ctrl.fakeModel);
    if (parsed != ctrl.ngModel) {
      ctrl.ngModelCtrl.$setViewValue(parsed);
    }
    if (focusManagerService) {
      focusManagerService.focusElement($element.find('.input > button'));
    }
  };

  // Trap enter key if required
  ctrl.keyPressed = function(event) {
    if (ctrl.blockEnter && event.key === 'Enter') {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  };

  // Helper: Matches valid "yyyy-MM-dd" dates and converts them to a Date() object
  var validRegex = /^(\d{4})-(\d{2})-(\d{2})/; // Will match '2015-05-14' or even '2016-12-30T00:00:00.000Z' etc.
  function stringToDate(stringVal) {
    var dateVal = null;
    if (stringVal) {
      if (stringVal.match && stringVal.match(validRegex) != null) {
        var m = validRegex.exec(stringVal); // ['2015-05-14', '2015', '05', '14']
        // Set the date, at midday
        dateVal = new Date(m[1], (m[2] - 1), m[3]);
      } else {
        // Default to 'today'... at midday
        dateVal = new Date();
        dateVal.setHours(12);
        dateVal.setMinutes(0);
        dateVal.setSeconds(0);
      }
    }
    return dateVal;
  }

  // Helper: Converts a Date() object into a valid "yyyy-MM-dd" date
  function dateToString(dateVal) {
    return $filter('date')(dateVal, 'yyyy-MM-dd');
  }
}

angular
  .module('app')
  .component('inputDate', inputDateComponent);

},{"datejs":13}],251:[function(require,module,exports){
/** INPUT FILE COMPONENT
 *
 *    <input-file ng-model="myTest"></input-file>
 *    <input-file ng-model="myTest" ng-required="true"></input-file>
 *    <input-file ng-model="myTest" ng-disabled="true"></input-file>
 *    <input-file ng-model="myTest" upload-preset="someS3Preset"></input-file>
 *
 *  Styling - _form.scss
 *
 *    @author   David "oodavid" King
 */
var inputFileComponent = {
  controller: inputFileComponentController,
  bindings: {
    ngModel: '=',
    ngDisabled: '<?',
    uploadPreset: '@?',
  },
  require: {
    ngModelCtrl: "ngModel"
  },
  templateUrl: '/shared/input-file/input-file.html',
};

inputFileComponentController.$inject = [];
function inputFileComponentController() {
  var ctrl = this;

  ctrl.$onInit = function(){
    ctrl.uploadPreset = ctrl.uploadPreset || 'issuerFiles';
  }

  ctrl.onFile = function(fileUrl) {
    ctrl.ngModelCtrl.$setViewValue(fileUrl);
  };
}

angular
  .module('app')
  .component('inputFile', inputFileComponent);

},{}],252:[function(require,module,exports){
/** IMAGE UPLOAD COMPONENT
 *
 *    <input-image-uploader ng-model="fileUrl" upload-preset="issuerImage" image-width="1000" image-height="500"></input-image-uploader>
 *
 *    This component wraps upload-file to present a friendly file addition interface.
 *
 *    @author Andrew Bateman
 */

var inputImageUploaderComponent = {
  controller: inputImageUploaderComponentController,
  bindings: {
    ngModel: '=',
    ngDisabled: '<?',
    uploadPreset: '@?',
    imageWidth: '<?',
    imageHeight: '<?',
    imagePurpose: '@?'
  },
  require: {
    ngModelCtrl: 'ngModel'
  },
  templateUrl: '/shared/input-image-uploader/input-image-uploader.html'
};

function inputImageUploaderComponentController() {
  var ctrl = this;

  ctrl.$onInit = $onInit;
  ctrl.setImageUrl = setImageUrl;

  function $onInit() {
    if (!ctrl.imageWidth || !ctrl.imageHeight) {
      ctrl.proportionalHeight = { 'padding-bottom': '100%' };
    } else {
      ctrl.proportionalHeight = { 'padding-bottom': ((ctrl.imageHeight / ctrl.imageWidth) * 100) + '%' };
    }
  }

  function setImageUrl(fileUrl) {
    ctrl.ngModelCtrl.$setViewValue(fileUrl);
  }
}

angular
  .module('app')
  .component('inputImageUploader', inputImageUploaderComponent);

},{}],253:[function(require,module,exports){
/** INPUT IMAGE COMPONENT
 *
 *    <input-image ng-model="myTest"></input-image>
 *    <input-image ng-model="myTest" ng-required="true"></input-image>
 *    <input-image ng-model="myTest" ng-disabled="true"></input-image>
 *
 *  Styling - _form.scss
 *
 *    @author   David "oodavid" King
 */
var inputImageComponent = {
  controller: inputImageComponentController,
  bindings: {
    ngModel: '=',
    ngDisabled: '<?',
    uploadPreset: '@?',
  },
  require: {
    ngModelCtrl: "ngModel"
  },
  templateUrl: '/shared/input-image/input-image.html',
};

inputImageComponentController.$inject = [];
function inputImageComponentController() {
  var ctrl = this;

  ctrl.onFile = function(fileUrl) {
    ctrl.ngModelCtrl.$setViewValue(fileUrl);
  };
}

angular
  .module('app')
  .component('inputImage', inputImageComponent);

},{}],254:[function(require,module,exports){
/** INPUT LANGUAGE COMPONENT
 *
 *    <input-language ng-model="myTest"></input-language>
 *    <input-language ng-model="myTest" ng-required="true"></input-language>
 *    <input-language ng-model="myTest" ng-disabled="true"></input-language>
 *
 *  Styling - _form.scss
 *
 *    @author   David "oodavid" King
 */
var inputLanguageComponent = {
  controller: inputLanguageComponentController,
  bindings: {
    ngModel: '=',
    ngDisabled: '<?',
    ngRequired: '<?',
  },
  templateUrl: '/shared/input-language/input-language.html',
};

inputLanguageComponentController.$inject = ['languageService'];
function inputLanguageComponentController(languageService) {
  var ctrl = this;
  ctrl.options = languageService.getLanguages();

  // Coerce null, i.e. no language specified, to English (en)
  ctrl.$onInit = function(){
    ctrl.ngModel = ctrl.options[ctrl.ngModel || 'en'].value;
  };
}

angular
  .module('app')
  .component('inputLanguage', inputLanguageComponent);

},{}],255:[function(require,module,exports){
/** INPUT RADIOS COMPONENT
 *
 *    var listOptions = [
 *      { value: 1,     title: 'First', },
 *      { value: 'key', title: 'Second', },
 *      { value: 3,     title: 'Third <em>...place?</em>', },
 *    ];
 *    ...OR...
 *    var listOptions = [ 'First', 'Second', 'Third' ];
 *
 *    <input-radios ng-model="myTest" options="listOptions"></input-radios>
 *    <input-radios ng-model="myTest" options="listOptions" ng-required="true"></input-radios>
 *    <input-radios ng-model="myTest" options="listOptions" ng-disabled="true"></input-radios>
 *
 *    Notes
 *
 *      This is flexible in the objects it will accept.
 *
 *      The `value` is taken from `value` or `id`. These are equivilent:
 *
 *        { value: 123,     title: 'First', },
 *        { id:    123,     title: 'First', },
 *
 *      The `title` is taken from `title`, `name` or `html`. These are equivilent:
 *
 *        { value: 123,     title: 'First', },
 *        { value: 123,     name:  'First', },
 *        { value: 123,     html:  'First', },
 *
 *      ...and any variation thereof
 *
 *    @author   Andrew Bateman
 *    @author   David "oodavid" King (review)
 */
var inputRadiosComponent = {
  controller: inputRadiosComponentController,
  bindings: {
    ngModel: '<',
    options: '<',
    ngDisabled: '<?',
    ngRequired: '<?',
  },
  require: {
    ngModelCtrl: 'ngModel',
  },
  templateUrl: '/shared/input-radios/input-radios.html',
};

inputRadiosComponentController.$inject = [];
function inputRadiosComponentController() {
  var ctrl = this;
  ctrl.select = select;
  ctrl.selected = selected;

  ctrl.$onInit = function() {
    handleOptionsChange();
  }

  ctrl.$onChanges = function(changes){
    if(changes.options){
      handleOptionsChange();
    }
  };

  // Massages the options into a simple format we can use
  function handleOptionsChange(){
    if(!ctrl.options){
      return;
    }
    // Don't dirty the original object
    ctrl.options = angular.copy(ctrl.options);
    // Massage arrays into objects
    if(typeof ctrl.options[0] !== 'object'){
      var tmp = [];
      for(var o=0,ol=ctrl.options.length; o<ol; o++){
        tmp.push({
          value: ctrl.options[o],
          title: ctrl.options[o],
        });
      }
      ctrl.options = tmp;
    } else {
      // Massage into { value, title }
      for(var o=0,ol=ctrl.options.length; o<ol; o++){
        var option = angular.copy(ctrl.options[o]);
        option.title = getFirstProperty(option, ['title', 'name', 'html']); // any defined "title" property is used
        option.value = getFirstProperty(option, ['value', 'id', 'title']);  // any defined "value" property is used, falling back to the title
        // Replace with a simple object
        ctrl.options[o] = {
          title: option.title,
          value: option.value,
        };
      }
    }
  }

  // Selects the option
  function select(option){
    ctrl.ngModelCtrl.$setViewValue(option.value);
  }

  // Returns boolean if the option is selected
  function selected(option) {
    return option.value === ctrl.ngModelCtrl.$viewValue;
  }

  // UTILITY - returns the first property, allows for `null` as long as the key is defined
  function getFirstProperty(object, props){
    for(var p=0,pl=props.length; p<pl; p++){
      var prop = props[p];
      if(object.hasOwnProperty(prop)){
        return object[prop];
      }
    }
  }
}

angular
  .module('app')
  .component('inputRadios', inputRadiosComponent);

},{}],256:[function(require,module,exports){
/** INPUT RECAPTCHA COMPONENT
 *
 *    <input-recaptcha ng-model="myRecaptcha" ng-required="true"></input-recaptcha>
 */
require('../recaptcha.config.js');

var inputRecaptchaComponent = {
  controller: inputRecaptchaComponentController,
  require: {
    ngModelCtrl: 'ngModel'
  },
  bindings: {
    ngModel: '<',
    ngRequired: '<',
  },
  templateUrl: '/shared/input-recaptcha/input-recaptcha.html',
};

inputRecaptchaComponentController.$inject = ['$element', '$timeout', 'vcRecaptchaService'];
function inputRecaptchaComponentController($element, $timeout, vcRecaptchaService) {
  var ctrl = this;
  ctrl.$postLink = postLink;
  ctrl.$onChanges = onChanges;
  ctrl.$onInit = onInit;
  ctrl.onRecaptchaCreate = onRecaptchaCreate;
  ctrl.onRecaptchaSuccess = onRecaptchaSuccess;
  ctrl.onRecaptchaExpire = onRecaptchaExpire;

  var widgetId = false;

  function postLink() {
    // This must be a `required` input
    if (!ctrl.ngRequired) {
      console.error('input-recaptcha MUST use ng-required="true"');
    }
    // Label for accessibility
    $timeout(function() {
      $element.find('iframe:visible').attr('title', 'reCAPTCHA');
    }, 500);
  }

  // Events from the component
  function onInit(){
    ctrl.ngModelCtrl.$setViewValue(null); // Must be NULL initially
    ctrl.ngModelCtrl.$setPristine();
    handleModelChange();
  }
  function onChanges(changes){
    handleModelChange();
  }
  function handleModelChange(){
    if(!ctrl.ngModel && widgetId !== false){
      vcRecaptchaService.reload(widgetId);
    }
  }

  // Events from recaptcha
  function onRecaptchaCreate(myWidgetId){
    widgetId = myWidgetId;
  }
  function onRecaptchaSuccess(response){
    ctrl.ngModelCtrl.$setViewValue(response);
  }
  function onRecaptchaExpire(){
    ctrl.ngModelCtrl.$setViewValue(null);
  }
}

angular
  .module('app')
  .component('inputRecaptcha', inputRecaptchaComponent);

},{"../recaptcha.config.js":295}],257:[function(require,module,exports){
/** INPUT SEARCH TAGS COMPONENT
 *
 *    <input-search-tags name="myTags" ng-model="myTags"></input-search-tags>
 *
 *    @author   Andrew Bateman
 */
var inputSearchTagsComponent = {
  controller: inputSearchTagsComponentController,
  bindings: {
    ngModel: '<',
    placeholder: '@?',
  },
  require: {
    ngModelCtrl: 'ngModel'
  },
  templateUrl: '/shared/input-search-tags/input-search-tags.html',
};

inputSearchTagsComponentController.$inject = [];

function inputSearchTagsComponentController() {
  var ctrl = this;

  ctrl.existingTags = [];

  ctrl.addSelectedTag = addSelectedTag;
  ctrl.createTag = createTag;

  ctrl.$onChanges = $onChanges;

  function $onChanges() {
    if (ctrl.ngModel) {
      ctrl.existingTags = ctrl.ngModel.map(function (tag) {
        return {
          id: tag.toLowerCase(),
          name: tag
        };
      });
    } else {
      ctrl.existingTags = [];
    }
  }

  function addTag(id, name) {
    for (var t = 0, tl = ctrl.existingTags.length; t < tl; t++) {
      if (ctrl.existingTags[t].id === id) {
        return; // Tag already exists
      }
    }
    ctrl.existingTags.push({
      id: id,
      name: name,
    });
    if (!ctrl.ngModel) {
      ctrl.ngModel = [];
    }
    ctrl.ngModel.push(name);
    ctrl.ngModelCtrl.$setViewValue(angular.copy(ctrl.ngModel));
  }

  function addSelectedTag(event) {
    if (event.selection) {
      addTag(event.selection.id, event.selection.name);
    }
  }

  function createTag(event) {
    addTag(event.value.toLowerCase(), event.value);
  }
}

angular
  .module('app')
  .component('inputSearchTags', inputSearchTagsComponent);

},{}],258:[function(require,module,exports){
/** INPUT TABS COMPONENT
 *
 *    var tabOptions = [
 *        { value: 1,     html: 'First', },
 *        { value: 'key', html: 'Second', },
 *        { value: 3,     html: 'Third <em>...place?</em>', },
 *    ];
 *
 *    <input-tabs ng-model="myTest" options="tabOptions"></input-tabs>
 *    <input-tabs ng-model="myTest" options="tabOptions" ng-required="true"></input-tabs>
 *    <input-tabs ng-model="myTest" options="tabOptions" ng-disabled="true"></input-tabs>
 *
 *    Notes
 *
 *      This will accept a key of: `html`, `name` or `title`
 *
 *    Styling - _form.scss
 *
 *    @author   David "oodavid" King
 */
var inputTabsComponent = {
  controller: inputTabsComponentController,
  bindings: {
    ngModel: '<',
    options: '<',
    ngDisabled: '<?',
    ngRequired: '<?',
  },
  require: {
    ngModelCtrl: "ngModel"
  },
  templateUrl: '/shared/input-tabs/input-tabs.html',
};

inputTabsComponentController.$inject = [];
function inputTabsComponentController() {
  var ctrl = this;

  ctrl.doSelect = function(value) {
    if (ctrl.ngModel == value && !ctrl.ngRequired) {
      ctrl.ngModelCtrl.$setViewValue(null);
    } else {
      ctrl.ngModelCtrl.$setViewValue(value);
    }
  }
}

angular
  .module('app')
  .component('inputTabs', inputTabsComponent);

},{}],259:[function(require,module,exports){
/** INPUT TAGS COMPONENT
 *
 *    <input-tags ng-model="myTags"></input-tags>
 *    <input-tags ng-model="myTags" ng-required="true"></input-tags>
 *    <input-tags ng-model="myTags" ng-disabled="true"></input-tags>
 *
 *    @author   David "oodavid" King
 */
var inputTagsComponent = {
  controller: inputTagsComponentController,
  bindings: {
    ngModel: '<',
    options: '<',
    ngDisabled: '<?',
    ngRequired: '<?',
    placeholder: '@?',
  },
  require: {
    ngModelCtrl: 'ngModel'
  },
  templateUrl: '/shared/input-tags/input-tags.html',
};

inputTagsComponentController.$inject = [];
function inputTagsComponentController() {
  var ctrl = this;
  ctrl.newTag;
  ctrl.addTag = addTag;
  ctrl.$onInit = $onInit;
  function $onInit(){
    if(Array.isArray(ctrl.ngModel)){
      ctrl.ngModelCtrl.$setViewValue(angular.copy(_.uniq(ctrl.ngModel))); // Make sure there are no dupes
    }
  }
  function addTag(){
    if(ctrl.newTag) {
      // Remove leading or trailing spaces
      ctrl.newTag = ctrl.newTag.trim();
      // If no tag, do nothing
      if (!ctrl.newTag) {
        return;
      }
      if(!Array.isArray(ctrl.ngModel)){
        ctrl.ngModel = [];
      }
      // See if the array already contains the value
      var index = inputTagsIndexOfInsensitive(ctrl.ngModel, ctrl.newTag);
      if(index === -1){
        // Great
        ctrl.ngModel.push(ctrl.newTag);
        ctrl.ngModelCtrl.$setViewValue(angular.copy(ctrl.ngModel));
        ctrl.ngModelCtrl.$setDirty();
        ctrl.ngModelCtrl.$setValidity('duplicateTag', true);
        // Reset the input
        ctrl.newTag = null;
      } else {
        // Duplicate tag
        ctrl.ngModelCtrl.$setValidity('duplicateTag', false);
      }
    } else {
      return;
    }
  }
}

/** INPUT TAGS LIST COMPONENT
 *
 *    <input-tags-list ng-model="myTags"></input-tags-list>
 *    <input-tags-list ng-model="myTags" ng-required="true"></input-tags-list>
 *    <input-tags-list ng-model="myTags" ng-disabled="true"></input-tags-list>
 *
 *    @author   David "oodavid" King
 */
var inputTagsListComponent = {
  controller: inputTagsListComponentController,
  bindings: {
    ngModel: '<',
    options: '<',
    ngDisabled: '<?',
    ngRequired: '<?',
    asChips: '<?'
  },
  require: {
    ngModelCtrl: 'ngModel'
  },
  templateUrl: '/shared/input-tags/input-tags-list.html',
};

inputTagsListComponentController.$inject = [];
function inputTagsListComponentController() {
  var ctrl = this;
  ctrl.removeTag = removeTag;
  function removeTag(tag){
    // See if the array contains the value
    var index = inputTagsIndexOfInsensitive(ctrl.ngModel, tag);
    if(index !== -1){
      // Remove it
      ctrl.ngModel.splice(index, 1);
      if(ctrl.ngModel.length === 0){
        ctrl.ngModel = null;
      }
      ctrl.ngModelCtrl.$setViewValue(angular.copy(ctrl.ngModel));
      ctrl.ngModelCtrl.$setDirty();
    }
  }
}

function inputTagsIndexOfInsensitive(array, value) {
  for (var al = array.length, a = 0; a < al; a++) {
    if (array[a].toLowerCase() === value.toLowerCase()) {
      return a;
    }
  }
  return -1;
}

angular
  .module('app')
  .component('inputTags', inputTagsComponent)
  .component('inputTagsList', inputTagsListComponent);

},{}],260:[function(require,module,exports){
/** INPUT TELEPHONE NUMBER COMPONENT
 *
 *    <input-tel ng-model="telephoneNumber"></input-tel>
 *    <input-tel ng-model="telephoneNumber" ng-required="true"></input-tel>
 *    <input-tel ng-model="telephoneNumber" ng-disabled="true"></input-tel>
 *    <input-tel input-name="myPhoneNumber" error-message="A valid telephone number is required." ng-model="myTelephoneNumber" preferred="US,GB"></input-tel>
 *
 *    This is designed to be used where a valid telephone number is required to be input. It uses a self-contained npm distribution
 *     of the Google libphonenumber library to check the validity of the input based on a selected country code. If the entered
 *     characters are not a valid telephone number nothing is submitted to the server. Telephone numbers are submitted in international
 *     format starting with "+", then the country code followed by a space and then the remainder of the number, e.g. +44 1234
 *     567890. Valid numbers are displayed on the UI in local format, e.g 01234 567890. In addition to ng-model, the component
 *     has three more attributes:
 *
 *      `input-name` - used on the component's internal input
 *      `error-message` - displayed when the number input is not valid
 *      `preferred` - an optional, comma-separated list of preferred country codes that are displayed at the top of the country code dropdown
 *
 *    The component tries to select the correct country code for user's current location automatically via IP location. If this
 *     auto-selection fails the first preferred country code is selected. If there are no preferred country codes, the first one
 *     in the main list is selected. The component expects input present at instantation to be in international format in order
 *     to dectect the country code. If the country code is not detected it defaults to US.
 *
 *    When nothing is entered the component displays a placeholder of a typical national number for the selected country, e.g.
 *     0121 234 5678.
 *
 *    There is currently a cosmetic issue with this control due to the way bootstrap handles dropdowns within a label. Hovering
 *     anywhere inside the label causes the dropdown button to grey and clicking anywhere in the label (outside of the input field)
 *     activates the dropdown menu.
 *
 *    @author   Andrew Bateman
 */
var inputTelComponent = {
  controller: inputTelController,
  bindings: {
    ngModel: '<',
    errorMessage: '@',
    preferred: '@',
    inputName: '@'
  },
  require: {
    ngModelCtrl: 'ngModel'
  },
  templateUrl: '/shared/input-tel/input-tel.html',
};

inputTelController.$inject = ['$scope', '$element', '$http'];
function inputTelController($scope, $element, $http) {
  var ctrl = this;

  ctrl.preferredCountries = null;
  ctrl.selectedCountry = null;
  ctrl.placeholder = null;
  ctrl.countries = [
    {
      'country_code': 'AF',
      'country_name': 'Afghanistan (‫افغانستان‬‎)',
      'dial_code': '+93'
    },
    {
      'country_code': 'AL',
      'country_name': 'Albania (Shqipëri)',
      'dial_code': '+355'
    },
    {
      'country_code': 'DZ',
      'country_name': 'Algeria (‫الجزائر‬‎)',
      'dial_code': '+213'
    },
    {
      'country_code': 'AS',
      'country_name': 'American Samoa',
      'dial_code': '+1684'
    },
    {
      'country_code': 'AD',
      'country_name': 'Andorra',
      'dial_code': '+376'
    },
    {
      'country_code': 'AO',
      'country_name': 'Angola',
      'dial_code': '+244'
    },
    {
      'country_code': 'AI',
      'country_name': 'Anguilla',
      'dial_code': '+1264'
    },
    {
      'country_code': 'AG',
      'country_name': 'Antigua and Barbuda',
      'dial_code': '+1268'
    },
    {
      'country_code': 'AR',
      'country_name': 'Argentina',
      'dial_code': '+54'
    },
    {
      'country_code': 'AM',
      'country_name': 'Armenia (Հայաստան)',
      'dial_code': '+374'
    },
    {
      'country_code': 'AW',
      'country_name': 'Aruba',
      'dial_code': '+297'
    },
    {
      'country_code': 'AU',
      'country_name': 'Australia',
      'dial_code': '+61'
    },
    {
      'country_code': 'AT',
      'country_name': 'Austria (Österreich)',
      'dial_code': '+43'
    },
    {
      'country_code': 'AZ',
      'country_name': 'Azerbaijan (Azərbaycan)',
      'dial_code': '+994'
    },
    {
      'country_code': 'BS',
      'country_name': 'Bahamas',
      'dial_code': '+1242'
    },
    {
      'country_code': 'BH',
      'country_name': 'Bahrain (‫البحرين‬‎)',
      'dial_code': '+973'
    },
    {
      'country_code': 'BD',
      'country_name': 'Bangladesh (বাংলাদেশ)',
      'dial_code': '+880'
    },
    {
      'country_code': 'BB',
      'country_name': 'Barbados',
      'dial_code': '+1246'
    },
    {
      'country_code': 'BY',
      'country_name': 'Belarus (Беларусь)',
      'dial_code': '+375'
    },
    {
      'country_code': 'BE',
      'country_name': 'Belgium (België)',
      'dial_code': '+32'
    },
    {
      'country_code': 'BZ',
      'country_name': 'Belize',
      'dial_code': '+501'
    },
    {
      'country_code': 'BJ',
      'country_name': 'Benin (Bénin)',
      'dial_code': '+229'
    },
    {
      'country_code': 'BM',
      'country_name': 'Bermuda',
      'dial_code': '+1441'
    },
    {
      'country_code': 'BT',
      'country_name': 'Bhutan (འབྲུག)',
      'dial_code': '+975'
    },
    {
      'country_code': 'BO',
      'country_name': 'Bolivia',
      'dial_code': '+591'
    },
    {
      'country_code': 'BA',
      'country_name': 'Bosnia and Herzegovina (Босна и Херцеговина)',
      'dial_code': '+387'
    },
    {
      'country_code': 'BW',
      'country_name': 'Botswana',
      'dial_code': '+267'
    },
    {
      'country_code': 'BR',
      'country_name': 'Brazil (Brasil)',
      'dial_code': '+55'
    },
    {
      'country_code': 'IO',
      'country_name': 'British Indian Ocean Territory',
      'dial_code': '+246'
    },
    {
      'country_code': 'VG',
      'country_name': 'British Virgin Islands',
      'dial_code': '+1284'
    },
    {
      'country_code': 'BN',
      'country_name': 'Brunei',
      'dial_code': '+673'
    },
    {
      'country_code': 'BG',
      'country_name': 'Bulgaria (България)',
      'dial_code': '+359'
    },
    {
      'country_code': 'BF',
      'country_name': 'Burkina Faso',
      'dial_code': '+226'
    },
    {
      'country_code': 'BI',
      'country_name': 'Burundi (Uburundi)',
      'dial_code': '+257'
    },
    {
      'country_code': 'KH',
      'country_name': 'Cambodia (កម្ពុជា)',
      'dial_code': '+855'
    },
    {
      'country_code': 'CM',
      'country_name': 'Cameroon (Cameroun)',
      'dial_code': '+237'
    },
    {
      'country_code': 'CA',
      'country_name': 'Canada',
      'dial_code': '+1'
    },
    {
      'country_code': 'CV',
      'country_name': 'Cape Verde (Kabu Verdi)',
      'dial_code': '+238'
    },
    {
      'country_code': 'BQ',
      'country_name': 'Caribbean Netherlands',
      'dial_code': '+599'
    },
    {
      'country_code': 'KY',
      'country_name': 'Cayman Islands',
      'dial_code': '+1345'
    },
    {
      'country_code': 'CF',
      'country_name': 'Central African Republic (République centrafricaine)',
      'dial_code': '+236'
    },
    {
      'country_code': 'TD',
      'country_name': 'Chad (Tchad)',
      'dial_code': '+235'
    },
    {
      'country_code': 'CL',
      'country_name': 'Chile',
      'dial_code': '+56'
    },
    {
      'country_code': 'CN',
      'country_name': 'China (中国)',
      'dial_code': '+86'
    },
    {
      'country_code': 'CX',
      'country_name': 'Christmas Island',
      'dial_code': '+61'
    },
    {
      'country_code': 'CC',
      'country_name': 'Cocos (Keeling) Islands',
      'dial_code': '+61'
    },
    {
      'country_code': 'CO',
      'country_name': 'Colombia',
      'dial_code': '+57'
    },
    {
      'country_code': 'KM',
      'country_name': 'Comoros (‫جزر القمر‬‎)',
      'dial_code': '+269'
    },
    {
      'country_code': 'CD',
      'country_name': 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)',
      'dial_code': '+243'
    },
    {
      'country_code': 'CG',
      'country_name': 'Congo (Republic) (Congo-Brazzaville)',
      'dial_code': '+242'
    },
    {
      'country_code': 'CK',
      'country_name': 'Cook Islands',
      'dial_code': '+682'
    },
    {
      'country_code': 'CR',
      'country_name': 'Costa Rica',
      'dial_code': '+506'
    },
    {
      'country_code': 'CI',
      'country_name': 'Côte d’Ivoire',
      'dial_code': '+225'
    },
    {
      'country_code': 'HR',
      'country_name': 'Croatia (Hrvatska)',
      'dial_code': '+385'
    },
    {
      'country_code': 'CU',
      'country_name': 'Cuba',
      'dial_code': '+53'
    },
    {
      'country_code': 'CW',
      'country_name': 'Curaçao',
      'dial_code': '+599'
    },
    {
      'country_code': 'CY',
      'country_name': 'Cyprus (Κύπρος)',
      'dial_code': '+357'
    },
    {
      'country_code': 'CZ',
      'country_name': 'Czech Republic (Česká republika)',
      'dial_code': '+420'
    },
    {
      'country_code': 'DK',
      'country_name': 'Denmark (Danmark)',
      'dial_code': '+45'
    },
    {
      'country_code': 'DJ',
      'country_name': 'Djibouti',
      'dial_code': '+253'
    },
    {
      'country_code': 'DM',
      'country_name': 'Dominica',
      'dial_code': '+1767'
    },
    {
      'country_code': 'DO',
      'country_name': 'Dominican Republic (República Dominicana)',
      'dial_code': '+1'
    },
    {
      'country_code': 'EC',
      'country_name': 'Ecuador',
      'dial_code': '+593'
    },
    {
      'country_code': 'EG',
      'country_name': 'Egypt (‫مصر‬‎)',
      'dial_code': '+20'
    },
    {
      'country_code': 'SV',
      'country_name': 'El Salvador',
      'dial_code': '+503'
    },
    {
      'country_code': 'GQ',
      'country_name': 'Equatorial Guinea (Guinea Ecuatorial)',
      'dial_code': '+240'
    },
    {
      'country_code': 'ER',
      'country_name': 'Eritrea',
      'dial_code': '+291'
    },
    {
      'country_code': 'EE',
      'country_name': 'Estonia (Eesti)',
      'dial_code': '+372'
    },
    {
      'country_code': 'ET',
      'country_name': 'Ethiopia',
      'dial_code': '+251'
    },
    {
      'country_code': 'FK',
      'country_name': 'Falkland Islands (Islas Malvinas)',
      'dial_code': '+500'
    },
    {
      'country_code': 'FO',
      'country_name': 'Faroe Islands (Føroyar)',
      'dial_code': '+298'
    },
    {
      'country_code': 'FJ',
      'country_name': 'Fiji',
      'dial_code': '+679'
    },
    {
      'country_code': 'FI',
      'country_name': 'Finland (Suomi)',
      'dial_code': '+358'
    },
    {
      'country_code': 'FR',
      'country_name': 'France',
      'dial_code': '+33'
    },
    {
      'country_code': 'GF',
      'country_name': 'French Guiana (Guyane française)',
      'dial_code': '+594'
    },
    {
      'country_code': 'PF',
      'country_name': 'French Polynesia (Polynésie française)',
      'dial_code': '+689'
    },
    {
      'country_code': 'GA',
      'country_name': 'Gabon',
      'dial_code': '+241'
    },
    {
      'country_code': 'GM',
      'country_name': 'Gambia',
      'dial_code': '+220'
    },
    {
      'country_code': 'GE',
      'country_name': 'Georgia (საქართველო)',
      'dial_code': '+995'
    },
    {
      'country_code': 'DE',
      'country_name': 'Germany (Deutschland)',
      'dial_code': '+49'
    },
    {
      'country_code': 'GH',
      'country_name': 'Ghana (Gaana)',
      'dial_code': '+233'
    },
    {
      'country_code': 'GI',
      'country_name': 'Gibraltar',
      'dial_code': '+350'
    },
    {
      'country_code': 'GR',
      'country_name': 'Greece (Ελλάδα)',
      'dial_code': '+30'
    },
    {
      'country_code': 'GL',
      'country_name': 'Greenland (Kalaallit Nunaat)',
      'dial_code': '+299'
    },
    {
      'country_code': 'GD',
      'country_name': 'Grenada',
      'dial_code': '+1473'
    },
    {
      'country_code': 'GP',
      'country_name': 'Guadeloupe',
      'dial_code': '+590'
    },
    {
      'country_code': 'GU',
      'country_name': 'Guam',
      'dial_code': '+1671'
    },
    {
      'country_code': 'GT',
      'country_name': 'Guatemala',
      'dial_code': '+502'
    },
    {
      'country_code': 'GG',
      'country_name': 'Guernsey',
      'dial_code': '+44'
    },
    {
      'country_code': 'GN',
      'country_name': 'Guinea (Guinée)',
      'dial_code': '+224'
    },
    {
      'country_code': 'GW',
      'country_name': 'Guinea-Bissau (Guiné Bissau)',
      'dial_code': '+245'
    },
    {
      'country_code': 'GY',
      'country_name': 'Guyana',
      'dial_code': '+592'
    },
    {
      'country_code': 'HT',
      'country_name': 'Haiti',
      'dial_code': '+509'
    },
    {
      'country_code': 'HN',
      'country_name': 'Honduras',
      'dial_code': '+504'
    },
    {
      'country_code': 'HK',
      'country_name': 'Hong Kong (香港)',
      'dial_code': '+852'
    },
    {
      'country_code': 'HU',
      'country_name': 'Hungary (Magyarország)',
      'dial_code': '+36'
    },
    {
      'country_code': 'IS',
      'country_name': 'Iceland (Ísland)',
      'dial_code': '+354'
    },
    {
      'country_code': 'IN',
      'country_name': 'India (भारत)',
      'dial_code': '+91'
    },
    {
      'country_code': 'ID',
      'country_name': 'Indonesia',
      'dial_code': '+62'
    },
    {
      'country_code': 'IR',
      'country_name': 'Iran (‫ایران‬‎)',
      'dial_code': '+98'
    },
    {
      'country_code': 'IQ',
      'country_name': 'Iraq (‫العراق‬‎)',
      'dial_code': '+964'
    },
    {
      'country_code': 'IE',
      'country_name': 'Ireland',
      'dial_code': '+353'
    },
    {
      'country_code': 'IM',
      'country_name': 'Isle of Man',
      'dial_code': '+44'
    },
    {
      'country_code': 'IL',
      'country_name': 'Israel (‫ישראל‬‎)',
      'dial_code': '+972'
    },
    {
      'country_code': 'IT',
      'country_name': 'Italy (Italia)',
      'dial_code': '+39'
    },
    {
      'country_code': 'JM',
      'country_name': 'Jamaica',
      'dial_code': '+1876'
    },
    {
      'country_code': 'JP',
      'country_name': 'Japan (日本)',
      'dial_code': '+81'
    },
    {
      'country_code': 'JE',
      'country_name': 'Jersey',
      'dial_code': '+44'
    },
    {
      'country_code': 'JO',
      'country_name': 'Jordan (‫الأردن‬‎)',
      'dial_code': '+962'
    },
    {
      'country_code': 'KZ',
      'country_name': 'Kazakhstan (Казахстан)',
      'dial_code': '+7'
    },
    {
      'country_code': 'KE',
      'country_name': 'Kenya',
      'dial_code': '+254'
    },
    {
      'country_code': 'KI',
      'country_name': 'Kiribati',
      'dial_code': '+686'
    },
    {
      'country_code': 'XK',
      'country_name': 'Kosovo',
      'dial_code': '+383'
    },
    {
      'country_code': 'KW',
      'country_name': 'Kuwait (‫الكويت‬‎)',
      'dial_code': '+965'
    },
    {
      'country_code': 'KG',
      'country_name': 'Kyrgyzstan (Кыргызстан)',
      'dial_code': '+996'
    },
    {
      'country_code': 'LA',
      'country_name': 'Laos (ລາວ)',
      'dial_code': '+856'
    },
    {
      'country_code': 'LV',
      'country_name': 'Latvia (Latvija)',
      'dial_code': '+371'
    },
    {
      'country_code': 'LB',
      'country_name': 'Lebanon (‫لبنان‬‎)',
      'dial_code': '+961'
    },
    {
      'country_code': 'LS',
      'country_name': 'Lesotho',
      'dial_code': '+266'
    },
    {
      'country_code': 'LR',
      'country_name': 'Liberia',
      'dial_code': '+231'
    },
    {
      'country_code': 'LY',
      'country_name': 'Libya (‫ليبيا‬‎)',
      'dial_code': '+218'
    },
    {
      'country_code': 'LI',
      'country_name': 'Liechtenstein',
      'dial_code': '+423'
    },
    {
      'country_code': 'LT',
      'country_name': 'Lithuania (Lietuva)',
      'dial_code': '+370'
    },
    {
      'country_code': 'LU',
      'country_name': 'Luxembourg',
      'dial_code': '+352'
    },
    {
      'country_code': 'MO',
      'country_name': 'Macau (澳門)',
      'dial_code': '+853'
    },
    {
      'country_code': 'MK',
      'country_name': 'Macedonia (FYROM) (Македонија)',
      'dial_code': '+389'
    },
    {
      'country_code': 'MG',
      'country_name': 'Madagascar (Madagasikara)',
      'dial_code': '+261'
    },
    {
      'country_code': 'MW',
      'country_name': 'Malawi',
      'dial_code': '+265'
    },
    {
      'country_code': 'MY',
      'country_name': 'Malaysia',
      'dial_code': '+60'
    },
    {
      'country_code': 'MV',
      'country_name': 'Maldives',
      'dial_code': '+960'
    },
    {
      'country_code': 'ML',
      'country_name': 'Mali',
      'dial_code': '+223'
    },
    {
      'country_code': 'MT',
      'country_name': 'Malta',
      'dial_code': '+356'
    },
    {
      'country_code': 'MH',
      'country_name': 'Marshall Islands',
      'dial_code': '+692'
    },
    {
      'country_code': 'MQ',
      'country_name': 'Martinique',
      'dial_code': '+596'
    },
    {
      'country_code': 'MR',
      'country_name': 'Mauritania (‫موريتانيا‬‎)',
      'dial_code': '+222'
    },
    {
      'country_code': 'MU',
      'country_name': 'Mauritius (Moris)',
      'dial_code': '+230'
    },
    {
      'country_code': 'YT',
      'country_name': 'Mayotte',
      'dial_code': '+262'
    },
    {
      'country_code': 'MX',
      'country_name': 'Mexico (México)',
      'dial_code': '+52'
    },
    {
      'country_code': 'FM',
      'country_name': 'Micronesia',
      'dial_code': '+691'
    },
    {
      'country_code': 'MD',
      'country_name': 'Moldova (Republica Moldova)',
      'dial_code': '+373'
    },
    {
      'country_code': 'MC',
      'country_name': 'Monaco',
      'dial_code': '+377'
    },
    {
      'country_code': 'MN',
      'country_name': 'Mongolia (Монгол)',
      'dial_code': '+976'
    },
    {
      'country_code': 'ME',
      'country_name': 'Montenegro (Crna Gora)',
      'dial_code': '+382'
    },
    {
      'country_code': 'MS',
      'country_name': 'Montserrat',
      'dial_code': '+1664'
    },
    {
      'country_code': 'MA',
      'country_name': 'Morocco (‫المغرب‬‎)',
      'dial_code': '+212'
    },
    {
      'country_code': 'MZ',
      'country_name': 'Mozambique (Moçambique)',
      'dial_code': '+258'
    },
    {
      'country_code': 'MM',
      'country_name': 'Myanmar (Burma) (မြန်မာ)',
      'dial_code': '+95'
    },
    {
      'country_code': 'NA',
      'country_name': 'Namibia (Namibië)',
      'dial_code': '+264'
    },
    {
      'country_code': 'NR',
      'country_name': 'Nauru',
      'dial_code': '+674'
    },
    {
      'country_code': 'NP',
      'country_name': 'Nepal (नेपाल)',
      'dial_code': '+977'
    },
    {
      'country_code': 'NL',
      'country_name': 'Netherlands (Nederland)',
      'dial_code': '+31'
    },
    {
      'country_code': 'NC',
      'country_name': 'New Caledonia (Nouvelle-Calédonie)',
      'dial_code': '+687'
    },
    {
      'country_code': 'NZ',
      'country_name': 'New Zealand',
      'dial_code': '+64'
    },
    {
      'country_code': 'NI',
      'country_name': 'Nicaragua',
      'dial_code': '+505'
    },
    {
      'country_code': 'NE',
      'country_name': 'Niger (Nijar)',
      'dial_code': '+227'
    },
    {
      'country_code': 'NG',
      'country_name': 'Nigeria',
      'dial_code': '+234'
    },
    {
      'country_code': 'NU',
      'country_name': 'Niue',
      'dial_code': '+683'
    },
    {
      'country_code': 'NF',
      'country_name': 'Norfolk Island',
      'dial_code': '+672'
    },
    {
      'country_code': 'KP',
      'country_name': 'North Korea (조선 민주주의 인민 공화국)',
      'dial_code': '+850'
    },
    {
      'country_code': 'MP',
      'country_name': 'Northern Mariana Islands',
      'dial_code': '+1670'
    },
    {
      'country_code': 'NO',
      'country_name': 'Norway (Norge)',
      'dial_code': '+47'
    },
    {
      'country_code': 'OM',
      'country_name': 'Oman (‫عُمان‬‎)',
      'dial_code': '+968'
    },
    {
      'country_code': 'PK',
      'country_name': 'Pakistan (‫پاکستان‬‎)',
      'dial_code': '+92'
    },
    {
      'country_code': 'PW',
      'country_name': 'Palau',
      'dial_code': '+680'
    },
    {
      'country_code': 'PS',
      'country_name': 'Palestine (‫فلسطين‬‎)',
      'dial_code': '+970'
    },
    {
      'country_code': 'PA',
      'country_name': 'Panama (Panamá)',
      'dial_code': '+507'
    },
    {
      'country_code': 'PG',
      'country_name': 'Papua New Guinea',
      'dial_code': '+675'
    },
    {
      'country_code': 'PY',
      'country_name': 'Paraguay',
      'dial_code': '+595'
    },
    {
      'country_code': 'PE',
      'country_name': 'Peru (Perú)',
      'dial_code': '+51'
    },
    {
      'country_code': 'PH',
      'country_name': 'Philippines',
      'dial_code': '+63'
    },
    {
      'country_code': 'PL',
      'country_name': 'Poland (Polska)',
      'dial_code': '+48'
    },
    {
      'country_code': 'PT',
      'country_name': 'Portugal',
      'dial_code': '+351'
    },
    {
      'country_code': 'PR',
      'country_name': 'Puerto Rico',
      'dial_code': '+1'
    },
    {
      'country_code': 'QA',
      'country_name': 'Qatar (‫قطر‬‎)',
      'dial_code': '+974'
    },
    {
      'country_code': 'RE',
      'country_name': 'Réunion (La Réunion)',
      'dial_code': '+262'
    },
    {
      'country_code': 'RO',
      'country_name': 'Romania (România)',
      'dial_code': '+40'
    },
    {
      'country_code': 'RU',
      'country_name': 'Russia (Россия)',
      'dial_code': '+7'
    },
    {
      'country_code': 'RW',
      'country_name': 'Rwanda',
      'dial_code': '+250'
    },
    {
      'country_code': 'BL',
      'country_name': 'Saint Barthélemy',
      'dial_code': '+590'
    },
    {
      'country_code': 'SH',
      'country_name': 'Saint Helena',
      'dial_code': '+290'
    },
    {
      'country_code': 'KN',
      'country_name': 'Saint Kitts and Nevis',
      'dial_code': '+1869'
    },
    {
      'country_code': 'LC',
      'country_name': 'Saint Lucia',
      'dial_code': '+1758'
    },
    {
      'country_code': 'MF',
      'country_name': 'Saint Martin (Saint-Martin (partie française))',
      'dial_code': '+590'
    },
    {
      'country_code': 'PM',
      'country_name': 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
      'dial_code': '+508'
    },
    {
      'country_code': 'VC',
      'country_name': 'Saint Vincent and the Grenadines',
      'dial_code': '+1784'
    },
    {
      'country_code': 'WS',
      'country_name': 'Samoa',
      'dial_code': '+685'
    },
    {
      'country_code': 'SM',
      'country_name': 'San Marino',
      'dial_code': '+378'
    },
    {
      'country_code': 'ST',
      'country_name': 'São Tomé and Príncipe (São Tomé e Príncipe)',
      'dial_code': '+239'
    },
    {
      'country_code': 'SA',
      'country_name': 'Saudi Arabia (‫المملكة العربية السعودية‬‎)',
      'dial_code': '+966'
    },
    {
      'country_code': 'SN',
      'country_name': 'Senegal (Sénégal)',
      'dial_code': '+221'
    },
    {
      'country_code': 'RS',
      'country_name': 'Serbia (Србија)',
      'dial_code': '+381'
    },
    {
      'country_code': 'SC',
      'country_name': 'Seychelles',
      'dial_code': '+248'
    },
    {
      'country_code': 'SL',
      'country_name': 'Sierra Leone',
      'dial_code': '+232'
    },
    {
      'country_code': 'SG',
      'country_name': 'Singapore',
      'dial_code': '+65'
    },
    {
      'country_code': 'SX',
      'country_name': 'Sint Maarten',
      'dial_code': '+1721'
    },
    {
      'country_code': 'SK',
      'country_name': 'Slovakia (Slovensko)',
      'dial_code': '+421'
    },
    {
      'country_code': 'SI',
      'country_name': 'Slovenia (Slovenija)',
      'dial_code': '+386'
    },
    {
      'country_code': 'SB',
      'country_name': 'Solomon Islands',
      'dial_code': '+677'
    },
    {
      'country_code': 'SO',
      'country_name': 'Somalia (Soomaaliya)',
      'dial_code': '+252'
    },
    {
      'country_code': 'ZA',
      'country_name': 'South Africa',
      'dial_code': '+27'
    },
    {
      'country_code': 'KR',
      'country_name': 'South Korea (대한민국)',
      'dial_code': '+82'
    },
    {
      'country_code': 'SS',
      'country_name': 'South Sudan (‫جنوب السودان‬‎)',
      'dial_code': '+211'
    },
    {
      'country_code': 'ES',
      'country_name': 'Spain (España)',
      'dial_code': '+34'
    },
    {
      'country_code': 'LK',
      'country_name': 'Sri Lanka (ශ්‍රී ලංකාව)',
      'dial_code': '+94'
    },
    {
      'country_code': 'SD',
      'country_name': 'Sudan (‫السودان‬‎)',
      'dial_code': '+249'
    },
    {
      'country_code': 'SR',
      'country_name': 'Suriname',
      'dial_code': '+597'
    },
    {
      'country_code': 'SJ',
      'country_name': 'Svalbard and Jan Mayen',
      'dial_code': '+47'
    },
    {
      'country_code': 'SZ',
      'country_name': 'Swaziland',
      'dial_code': '+268'
    },
    {
      'country_code': 'SE',
      'country_name': 'Sweden (Sverige)',
      'dial_code': '+46'
    },
    {
      'country_code': 'CH',
      'country_name': 'Switzerland (Schweiz)',
      'dial_code': '+41'
    },
    {
      'country_code': 'SY',
      'country_name': 'Syria (‫سوريا‬‎)',
      'dial_code': '+963'
    },
    {
      'country_code': 'TW',
      'country_name': 'Taiwan (台灣)',
      'dial_code': '+886'
    },
    {
      'country_code': 'TJ',
      'country_name': 'Tajikistan',
      'dial_code': '+992'
    },
    {
      'country_code': 'TZ',
      'country_name': 'Tanzania',
      'dial_code': '+255'
    },
    {
      'country_code': 'TH',
      'country_name': 'Thailand (ไทย)',
      'dial_code': '+66'
    },
    {
      'country_code': 'TL',
      'country_name': 'Timor-Leste',
      'dial_code': '+670'
    },
    {
      'country_code': 'TG',
      'country_name': 'Togo',
      'dial_code': '+228'
    },
    {
      'country_code': 'TK',
      'country_name': 'Tokelau',
      'dial_code': '+690'
    },
    {
      'country_code': 'TO',
      'country_name': 'Tonga',
      'dial_code': '+676'
    },
    {
      'country_code': 'TT',
      'country_name': 'Trinidad and Tobago',
      'dial_code': '+1868'
    },
    {
      'country_code': 'TN',
      'country_name': 'Tunisia (‫تونس‬‎)',
      'dial_code': '+216'
    },
    {
      'country_code': 'TR',
      'country_name': 'Turkey (Türkiye)',
      'dial_code': '+90'
    },
    {
      'country_code': 'TM',
      'country_name': 'Turkmenistan',
      'dial_code': '+993'
    },
    {
      'country_code': 'TC',
      'country_name': 'Turks and Caicos Islands',
      'dial_code': '+1649'
    },
    {
      'country_code': 'TV',
      'country_name': 'Tuvalu',
      'dial_code': '+688'
    },
    {
      'country_code': 'VI',
      'country_name': 'U.S. Virgin Islands',
      'dial_code': '+1340'
    },
    {
      'country_code': 'UG',
      'country_name': 'Uganda',
      'dial_code': '+256'
    },
    {
      'country_code': 'UA',
      'country_name': 'Ukraine (Україна)',
      'dial_code': '+380'
    },
    {
      'country_code': 'AE',
      'country_name': 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)',
      'dial_code': '+971'
    },
    {
      'country_code': 'GB',
      'country_name': 'United Kingdom',
      'dial_code': '+44'
    },
    {
      'country_code': 'US',
      'country_name': 'United States',
      'dial_code': '+1'
    },
    {
      'country_code': 'UY',
      'country_name': 'Uruguay',
      'dial_code': '+598'
    },
    {
      'country_code': 'UZ',
      'country_name': 'Uzbekistan (Oʻzbekiston)',
      'dial_code': '+998'
    },
    {
      'country_code': 'VU',
      'country_name': 'Vanuatu',
      'dial_code': '+678'
    },
    {
      'country_code': 'VA',
      'country_name': 'Vatican City (Città del Vaticano)',
      'dial_code': '+39'
    },
    {
      'country_code': 'VE',
      'country_name': 'Venezuela',
      'dial_code': '+58'
    },
    {
      'country_code': 'VN',
      'country_name': 'Vietnam (Việt Nam)',
      'dial_code': '+84'
    },
    {
      'country_code': 'WF',
      'country_name': 'Wallis and Futuna (Wallis-et-Futuna)',
      'dial_code': '+681'
    },
    {
      'country_code': 'EH',
      'country_name': 'Western Sahara (‫الصحراء الغربية‬‎)',
      'dial_code': '+212'
    },
    {
      'country_code': 'YE',
      'country_name': 'Yemen (‫اليمن‬‎)',
      'dial_code': '+967'
    },
    {
      'country_code': 'ZM',
      'country_name': 'Zambia',
      'dial_code': '+260'
    },
    {
      'country_code': 'ZW',
      'country_name': 'Zimbabwe',
      'dial_code': '+263'
    },
    {
      'country_code': 'AX',
      'country_name': 'Åland Islands',
      'dial_code': '+358'
    }
  ];

  ctrl.inputNumber = null;

  var countryCode = 'US';
  var foundCountry = ctrl.countries.filter(function (country) {
    return country.country_code === countryCode;
  });
  var defaultCountry = foundCountry[0];

  var selectCountry = function (country) {
    ctrl.selectedCountry = country;
    countryCode = ctrl.selectedCountry.country_code;
    var phoneNumber = phoneUtil.getExampleNumber(countryCode);
    ctrl.placeholder = phoneUtil.format(phoneNumber, PNF.NATIONAL);
  };

  var PNF = require('google-libphonenumber').PhoneNumberFormat;
  var phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();

  var $input;

  // Sort out dirty
  var validateNumber = function () {
    // Parse number with country code
    if (ctrl.inputNumber && ctrl.inputNumber.length > 2) {
      var phoneNumber = phoneUtil.parse(ctrl.inputNumber, countryCode);
      if (phoneUtil.isValidNumberForRegion(phoneNumber, countryCode)) {
        ctrl.inputNumber = phoneUtil.format(phoneNumber, PNF.NATIONAL);
        // Write number in the international format
        ctrl.ngModelCtrl.$setViewValue(phoneUtil.format(phoneNumber, PNF.INTERNATIONAL));
        return true;
      } else {
        ctrl.ngModelCtrl.$setViewValue(null);
        return false;
      }
    } else {
      return false;
    }
  };

  ctrl.touchInput = function () {
    ctrl.ngModelCtrl.$setTouched();
  };

  ctrl.checkInput = function () {
    ctrl.ngModelCtrl.$setDirty();
    if (validateNumber()) {
      $input.removeClass('ng-invalid');
      ctrl.ngModelCtrl.$setValidity('required', true);
    } else {
      $input.addClass('ng-invalid');
      ctrl.ngModelCtrl.$setValidity('required', false);
    }
  };

  ctrl.$onInit = function () {
    // ctrl.ngModel = '+44 1234567890'; // For testing
    if (ctrl.ngModel && ctrl.ngModel !== '') {
      // Get country from model string
      var splitInput = ctrl.ngModel.split(' ');
      var dialCode = splitInput[0];
      var foundCountries = ctrl.countries.filter(function (country) {
        return country.dial_code === dialCode;
      });
      var modelCountry;
      if (foundCountries.length === 0) {
        modelCountry = defaultCountry;
      } else {
        // Different "countries" can have the same country_code, e.g. GG (Guernsey) and UK are both +44!
        for (var foundIndex = 0; foundIndex < foundCountries.length; foundIndex++) {
          var testCountry = foundCountries[foundIndex];
          var testCountryCode = testCountry.country_code;
          var phoneNumber = phoneUtil.parse(ctrl.ngModel, testCountryCode);
          if (phoneUtil.isValidNumberForRegion(phoneNumber, testCountryCode)) {
            modelCountry = testCountry;
            break;
          }
        }
        modelCountry = modelCountry || defaultCountry;
      }
      selectCountry(modelCountry);
    } else {
      // Get country from location
      $http.get('https://freegeoip.net/json/')
        .then(function (response) {
          var locatedCountry = null;
          if (response.data) {
            var locatedCountryCode = response.data.country_code;
            locatedCountry = ctrl.countries.filter(function (item) {
              return item.country_code === locatedCountryCode;
            });
          }
          if (locatedCountry.length === 1) {
            selectCountry(locatedCountry[0]);
          }
        })
        .catch(function (err) {
          console.error(err);
        });
    }

    ctrl.inputNumber = ctrl.ngModel;
    // ctrl.preferred is not bound until this point
    if (ctrl.preferred) {
      var preferred = ctrl.preferred.split(',');
      // Create preferred countries list in specified order
      ctrl.preferredCountries = [];
      for (var preferredIndex = 0; preferredIndex < preferred.length; preferredIndex++) {
        var preferredCountryCode = preferred[preferredIndex];
        var preferredCountry = ctrl.countries.filter(function (country) {
          return country.country_code === preferredCountryCode;
        });
        if (preferredCountry.length === 1) {
          ctrl.preferredCountries.push(preferredCountry[0]);
        }
      }
    }

    if (!ctrl.selectedCountry) {
      if (ctrl.preferredCountries && ctrl.preferredCountries.length > 0) {
        selectCountry(ctrl.preferredCountries[0]);
      } else {
        selectCountry(ctrl.countries[0]);
      }
    }

    $input = $element.find('input');

    validateNumber();

    // Workaround for bootstrap bug that causes the dropdown to open when a surrounding label is clicked
    $input.on('click', function (e) {
      e.preventDefault();
    });
  };

  ctrl.onSelect = function (country) {
    selectCountry(country);
    ctrl.checkInput();
  };

}

angular
  .module('app')
  .component('inputTel', inputTelComponent);

},{"google-libphonenumber":26}],261:[function(require,module,exports){
/** INPUT :: TYPEAHEAD - COMPONENT
 *
 *    <input-typeahead search="groups" on-select="addToGroups($event)"></input-typeahead>
 *    <input-typeahead search="users" on-select="addToUsers($event)"></input-typeahead>
 *    <input-typeahead search="credentials" on-select="addToCredentials($event)"></input-typeahead>
 *    <input-typeahead search="organizations" on-select="addToOrganizations($event)" pre-select-ids="[1,67]" exclude-list="addedOrganizations"></input-typeahead>
 *    <input-typeahead search="tags" on-select="addToTags($event)"></input-typeahead>
 *    <input-typeahead search="teamMembers" exclude-list="existingTeamMembers" on-select="pickTeamMember($event)" blur-action="updateTeamMember($event)" no-clear pre-query="currentTeamMember.name"></input-typeahead>
 *    <input-typeahead search="data" data="$ctrl.skillsData" on-select="$ctrl.addSkill($event)" exclude-list="$ctrl.skillsSelections"></input-typeahead>
 *
 *    pre-select-ids - items with these ids are added on init
 *    exclude-list - items in this list are excluded from the displayed matches and are of the form { name: <name>, id: <id> }
 *    blur-action - this function is executed when focus leaves the typeahead entry field
 *    no-clear - if true, the typeahead entry field is not cleared when it loses focus
 *    pre-query - if supplied, this value is preloaded into the query string and thus initially displayed in the typeahead entry field
 *    data - this is required if the search type is "data" and is of the form [{ name: <name>, id: <id> }, { name: <name>, id: <id> }]
 *
 *    Nomenclature
 *      query - the user input (string)
 *      hint - the predicting text suffix, ie: Typing "New" may show "New|castle" where "castle" is the hint
 *      matches - all matches for the query (renders in the dropdown)
 *      selectedMatch - the match that the user has selected (by tapping [DOWN] on the keyboard)
 *
 *    See TypeaheadService for a list of values for the [search] attribute
 *
 *    Styling - _form.scss
 *              _input-typeahead.scss
 *
 *    @author   David "oodavid" King
 *    @author   Andrew Bateman (organizations and teamMembers)
 */
require('./typeahead.service.js');

var inputTypeaheadComponent = {
  controller: inputTypeaheadComponentController,
  bindings: {
    search: '@',
    data: '<',
    minQueryLength: '<?',
    onSelect: '&',
    blurAction: '&?',
    enterAction: '&?',
    preQuery: '<?',
    excludeList: '<?',
    preSelectIds: '<?',
    location: '<?',
    placeholder: '@?',
    ngModel: '<?',
    ngRequired: '<?',
    focusId: '@?',
    accessId: '@?'
  },
  templateUrl: '/shared/input-typeahead/input-typeahead.html',
};

inputTypeaheadComponentController.$inject = ['$element', '$timeout', '$filter', 'TypeaheadService'];
function inputTypeaheadComponentController($element, $timeout, $filter, TypeaheadService) {
  var that = this;
  that.query = '';
  that.hint = '';
  that.icon = 'search';
  that.onQueryChange = onQueryChange;
  that.onKeyDown = onKeyDown;
  that.onBlur = onBlur;
  that.click = null;
  that.selectMatch = selectMatch;
  that.matches = []; // Everything that matches our query
  that.selectedMatchId = false;
  that.loading = false;
  that.random = Math.round(Math.random()*1000000);
  var cache = {}; // All search objects, including previous matches
  // When ready, get the search cache
  that.$onInit = function() {
    if (that.search === 'data' && that.data) {
      cache = that.data;
    } else {
      var collection = TypeaheadService.getCollection(that.search);
      that.icon = 'search';
      cache = collection.cache;
      that.query = that.preQuery || '';
      if (that.preSelectIds && that.preSelectIds.length > 0) {
        TypeaheadService.search(that.search, '', that.location).then(function(response) {
          var preSelected = response.filter(function(item) {
            return (that.preSelectIds.indexOf(item.id) !== -1);
          });
          // Now select
          that.onSelect({
            $event: {
              selection: preSelected
            }
          });
        });
      }
      $timeout(function() {
        // This needs to be deferred until the initial digest cycle is completed
        that.placeholder = that.placeholder || collection.title;
      });
    }
    if (that.enterAction) {
      that.click = click;
    }
  };
  // Whenever the query changes
  function onQueryChange(){
    clearSelection();
    searchCache();
    if (that.search !== 'data' && (!that.minQueryLength || that.query.length >= that.minQueryLength)) {
      debouncedSearch();
    }
  }
  var tabbed = false; // Tab key pressed (not)
  // Handling Keypresses
  function onKeyDown(event){
    var code = event.which || event.keyCode;
    switch(code){
      case 38: // Up
      case 40: // Down
        var dir = code === 38 ? -1 : 1;
        moveSelection(event, dir);
        break;
      case 9: // Tab
        if (that.matches.length === 0 && that.click) {
          // Handle tabbing to button
          tabbed = true;
        } else {
          hintComplete(event);
        }
        break;
      case 39: // Right
        hintComplete(event);
        break;
      case 13: // Enter
        selectActiveMatch(event);
        break;
      case 27: // Esc
        reset();
        break;
    }
  }
  // Handling blur
  function onBlur(){
    $timeout(function() {
      reset();
      // If there's a blur action, run it
      if (that.blurAction) {
        that.blurAction({
          $event: {
            value: that.query
          }
        });
      }
    }, 250); // Enough time for any click events to work on the dropdown, if clicked
  }

  // Remove exclusions from selected
  function filterExcluded(list) {
    if (list.length > 0 && that.excludeList && that.excludeList.length > 0) {
      var excludeIds = that.excludeList.map(function (item, index) {
        return item.id;
      });
      list = list.filter(function(item) {
        return (excludeIds.indexOf(item.id) === -1);
      });
    }
    return list;
  }

  // Populate the matches array by searching the cache for anything matching our query
  function searchCache(){
    that.matches.length = 0;
    if(that.query){
      var cacheArray = Object.values(cache);
      that.matches = filterExcluded($filter('filter')(cacheArray, that.query));
    }
    updateHint();
    updateExpanded();
  }
  // Search, Debounced
  var debouncedTimeout;
  function debouncedSearch(){
    if(debouncedTimeout){
      $timeout.cancel(debouncedTimeout);
    }
    debouncedTimeout = $timeout(doSearch, 300);
  }
  function doSearch(){
    that.loading = true;
    TypeaheadService
      .search(that.search, that.query, that.location)
      .then(function(response){
        that.matches = filterExcluded(response || []);
        updateHint();
        updateExpanded();
        that.loading = false;
      });
  }

  // Update ARIA Expanded
  function updateExpanded() {
    $element.find('div.input').attr('aria-expanded', that.matches.length > 0);
  }

  // Update Hint
  function updateHint(){
    that.hint = '';
    var hintMatch = getHintMatch();
    if(hintMatch){
      that.hint = that.query + hintMatch.name.substr(that.query.length);
    }
  }
  // Returns the hint match
  function getHintMatch(){
    if(that.query){
      var selection = getSelection();
      if(!selection && that.matches[0]){
        var name = that.matches[0].name;
        if(name.toLowerCase().indexOf(that.query.toLowerCase()) === 0){ // If the first match begins with our query...
          return that.matches[0];
        }
      }
    }
    return false;
  }
  // Complete the input based on the hint
  function hintComplete(event){
    var hintMatch = getHintMatch();
    if(hintMatch){
      var caret = getCaretPosition(event);
      if(caret >= that.query.length){
        that.query = hintMatch.name;
        searchCache();
        setSelection(hintMatch);
        event.preventDefault();
      }
    } else {
      var selection = getSelection();
      if(selection){
        selectActiveMatch(event);
      }
    }
  }
  // Returns the caret position from an event
  function getCaretPosition(event){
    var el = event.target;
    var pos = 0;
    if('selectionStart' in el) {
      pos = el.selectionStart;
    } else if('selection' in document) {
      el.focus();
      var Sel = document.selection.createRange();
      var SelLength = document.selection.createRange().text.length;
      Sel.moveStart('character', -el.value.length);
      pos = Sel.text.length - SelLength;
    }
    return pos;
  }
  // Gets the current selection
  function getSelection(){
    var match = false;
    that.matches.forEach(function(myMatch, myIndex){
      if(myMatch.id === that.selectedMatchId){
        match = myMatch;
      }
    });
    return match;
  }
  // Gets the index of the current selection
  function getSelectionIndex(){
    var index = false;
    that.matches.forEach(function(myMatch, myIndex){
      if(myMatch.id === that.selectedMatchId){
        index = myIndex;
      }
    });
    return index;
  }
  // Clears the selection
  function clearSelection(){
    that.selectedMatchId = false;
  }
  // Sets the selection
  function setSelection(match){
    that.selectedMatchId = match.id;
    scrollIntoView();
  }
  // Move the selection
  function moveSelection(event, dir){
    if(that.matches.length === 0) {
      return;
    }
    var index = getSelectionIndex();
    if(index === false){
      index = (dir === 1) ? 0 : (that.matches.length-1);
    } else {
      index += dir;
    }
    index = (index + that.matches.length) % that.matches.length;
    var match = that.matches[index];
    setSelection(match);
    that.query = match.name;
    that.hint = match.name;
    if (that.accessId) {
      $element.find('div.input > input').attr('aria-activedescendant', that.accessId + '-result-item-' + index);
    }
    event.preventDefault();
  }
  // Scroll into view
  function scrollIntoView(){
    $timeout(function(){
      var myContainer = $element.find('.matches');
      var myScrollTo = $element.find('.selected');
      if (myScrollTo.length) {
        var min = myContainer.scrollTop() + myScrollTo.position().top;
        var max = myContainer.scrollTop() + myScrollTo.position().top - myContainer.height() + myScrollTo.outerHeight(true);
        if(myContainer.scrollTop() > min){
          myContainer.scrollTop(min);
        } else if(myContainer.scrollTop() < max){
          myContainer.scrollTop(max);
        }
      }
    });
  }
  // Click
  function click() {
    var enteredText = that.query;
    if (enteredText !== '') {
      that.enterAction({
        $event: {
          value: enteredText
        }
      });
      that.query = '';
    }
  }
  // Select the active match
  function selectActiveMatch(event){
    var enteredText = that.query;
    // Handle selection...
    var selection = getSelection();
    selectMatch(selection);
    // ...otherwise, if there's a select action, run it
    if (!selection && that.enterAction) {
      that.enterAction({
        $event: {
          value: enteredText
        }
      });
    }
    event.preventDefault();
  }
  // Select a match
  function selectMatch(match){
    // If it's a location search, convert it
    if(match.place_id){
      that.loading = true;
      TypeaheadService
        .lookupGooglePlace(match, that.location)
        .then(function(place){
          // Now select
          that.onSelect({
            $event: {
              selection: place,
            }
          });
          reset();
          updateExpanded();
        });
    } else {
      // Instant
      if (match) { // If there's a valid match
        that.onSelect({
          $event: {
            selection: match,
          }
        });
        if ($element[0].hasAttribute('no-clear')) {
          that.query = match.name;
        }
      }
      reset();
      updateExpanded();
    }
  }

  // Reset the component
  function reset(){
    clearSelection();
    that.matches.length = 0;
    if (!$element[0].hasAttribute('no-clear') && !tabbed) { // Don't clear the query if tabbing to button
      that.query = '';
    }
    tabbed = false; // Cancel any tabbing
    that.hint = '';
    that.loading = false;
  }
}

angular
  .module('app')
  .component('inputTypeahead', inputTypeaheadComponent);

},{"./typeahead.service.js":262}],262:[function(require,module,exports){
/** TYPEAHEAD SERVICE
 *
 *    A service that searches the Accredible API,
 *    or Google Places.
 */
TypeaheadService.$inject = ['$injector', 'api'];
function TypeaheadService($injector, api) {
  var service = this;
  service.getCollection = getCollection;
  service.search = search;
  service.lookupGooglePlace = lookupGooglePlace;

  // Collections
  var collections = {
    // Accredible
    // team:          { search: 'accredible', title: 'Search Team',           auth: true },
    // users:         { search: 'accredible', title: 'Search Users',          auth: true },
    // recipients:    { search: 'accredible', title: 'Search Recipients',     auth: true },
    // credentials:   { search: 'accredible', title: 'Search Credentials',    auth: true },
    // certificates:  { search: 'accredible', title: 'Search Certificates',   auth: true },
    groups:        { search: 'accredible', title: 'Search groups',            auth: true },
    tags:          { search: 'accredible', title: 'Search tags',              auth: true },
    teamMembers:   { search: 'accredible', title: '',                         auth: true },
    organizations: { search: 'accredible', title: 'Specify a provider',       auth: false },
    // Google Places
    // geocode:       { search: 'google', types: 'geocode',       title: 'Location Search',                   },
    // address:       { search: 'google', types: 'address',       title: 'Search for Address',                },
    // establishment: { search: 'google', types: 'establishment', title: 'Search for Business on Google Maps' },
    // regions:       { search: 'google', types: '(regions)',     title: 'Search for Region',                 },
    cities:        { search: 'google', types: '(cities)',      title: 'Search for City' },
  };

  // Returns the collection
  function getCollection(collectionName){
    var collection = collections[collectionName];
    collection.name = collectionName; // Add the `name` as a property
    return collection;
  }

  // We cache searches for typeahead initialization
  function resetCache(){
    angular.forEach(collections, function(collection, key){
      collection.cache = {};
    });
  }
  resetCache();

  // Search Accredible, or Google Places
  function search(collectionName, query, location){
    var collection = getCollection(collectionName);
    if (collection.search === 'accredible') {
      if (collectionName === 'tags') {
        return searchAccredibleTags(collection, query);
      } else {
        return searchAccredible(collection, query);
      }
    } else {
      return searchGooglePlaces(collection, query, location);
    }
  }

  // Search Accredible Tags
  function searchAccredibleTags(collection, query) {
    return api
      .request('/tags/all')
      .then(function searchResponse(response){
        var matchingTags = response.tags.filter(function(tag) {
          return tag.toLowerCase().indexOf(query.toLowerCase()) !== -1;
        });
        // Update the cache
        var formattedTags = [];
        if (matchingTags.length > 0) {
          angular.forEach(matchingTags, function(tag) {
            var formattedTag = { id: tag.toLowerCase(), name: tag };
            collection.cache[tag] = formattedTag;
            formattedTags.push(formattedTag);
          });
        }
        return formattedTags;
      }, angular.noop);
  }

  // Search Accredible
  function searchAccredible(collection, query){
    var endpoint = collection.auth ? '/typeahead/name_search' : '/get_typeahead_without_auth/name_search';
    return api
      .request(endpoint, {
        collection: collection.name,
        query: query,
      })
      .then(function searchResponse(response){
        // Update the cache
        if(response.results){
          angular.forEach(response.results, function(result) {
            collection.cache[result.id] = result;
          });
        }
        // Return the results
        return response.results;
      }, angular.noop);
  }

  // Search Google Places
  function searchGooglePlaces(collection, query, location){
    var payload = {
      types: collection.types,
      input: query
    };
    if (location && location.latitude && location.longitude) {
      payload['latitude'] = location.latitude;
      payload['longitude'] = location.longitude;
      payload['radius'] = 500000; // 500 km
    }
    return api
      .request('/typeahead/location_search', payload)
      .then(function searchResponse(response){
        if(response.predictions){
          angular.forEach(response.predictions, function(prediction) {
            // Massage
            prediction.name = prediction.description;
            delete prediction.description;
            // Cache
            collection.cache[prediction.id] = prediction;
          });
        }
        // Return the results
        return response.predictions;
      }, angular.noop);
  }

  // Convert Google Place id to location data
  function lookupGooglePlace(match, location){
    var payload = { place_id: match.place_id };
    if (location && location.latitude && location.longitude) {
      payload['latitude'] = location.latitude;
      payload['longitude'] = location.longitude;
      payload['radius'] = 500000; // 500 km
    }
    return api
      .request('/directory/get_place_data', payload)
      .then(function(result){
        // Return a mix of both objects
        return {
          name: match.name,
          place_id: match.place_id,
          geo: {
            lat: result.result.geometry.location.lat,
            lng: result.result.geometry.location.lng,
            viewport: result.result.geometry.viewport,
          }
        };
      });
  }

  // Reset the cache if our auth changes (optional enhancement)
  if ($injector.has('AuthService')) {
    var AuthService = $injector.get('AuthService');
    AuthService.on('change', resetCache);
  }

}

angular
  .module('app')
  .service('TypeaheadService', TypeaheadService);

},{}],263:[function(require,module,exports){
// Quickly switch between versions of Redactor by changing this path
require('./redactor-v3/input-wysiwyg.component.js');

},{"./redactor-v3/input-wysiwyg.component.js":264}],264:[function(require,module,exports){
require('./redactor-3/redactor.js');
require('./redactor-3/_plugins/alignment/alignment.js');
require('./redactor-3/_plugins/video/video.js');
require('./redactor-3/_plugins/table/table.js');
require('./redactor-3/_plugins/textdirection/textdirection.js');
require('./plugins/redactor.attributes.js');
require('./plugins/redactor.cta.js');
require('./plugins/redactor.image.js');
require('./plugins/redactor.social_images.js');

/** WYSIWYG COMPONENT
 *
 *    <input-wysiwyg ng-model="htmlContent" ng-required="true"></input-wysiwyg>
 *    <input-wysiwyg ng-model="htmlContent"></input-wysiwyg>
 *    <input-wysiwyg ng-model="htmlContent" ng-disabled="true"></input-wysiwyg>
 *    <input-wysiwyg ng-model="htmlContent" options="redactorOptions"></input-wysiwyg>
 *
 *    Coupled to Redactor v3.X.X
 *      The settings that you can pass are defined by redactor
 *      documentation, it seemed daft to decouple that without
 *      testing the component in the wild.
 *
 *    @author   David "oodavid" King
 */
var inputWysiwygComponent = {
  controller: inputWysiwygComponentController,
  bindings: {
    ngModel: '<',
    ngDisabled: '<?',
    options: '<?',
  },
  require: {
    ngModelCtrl: 'ngModel',
  },
  templateUrl: '/shared/input-wysiwyg/redactor-v3/input-wysiwyg.html',
};

var redactorUid = 0;

inputWysiwygComponentController.$inject = ['_', '$element', '$timeout'];
function inputWysiwygComponentController(_, $element, $timeout) {
  var ctrl = this;

  ctrl.$onInit = onInit;
  ctrl.$onChanges = onChanges;
  ctrl.$onDestroy = onDestroy;

  ctrl.active = false;

  var redactorElement = false;
  var app = false;

  // Create the redactor instance
  function onInit(){
    // Add a unique ID to the element
    var el = $element.find('.input-wysiwyg-inner');
    var id = getUniqueId();
    el.attr('id', id);
    // Get the options (they may be extended with the attribute)
    var redactorOptions = getDefaultOptions();
    if(ctrl.options){
      angular.extend(redactorOptions, ctrl.options);
    }
    // Initialize redactor via the ID
    app = $R('#'+id, redactorOptions);
    applyDisabledToRedactor();
    ctrl.ngModel = convertToFigures(ctrl.ngModel);
    applyModelToRedactor();
    hideToolBar();
  }

  // When there are changes to our model, options or disabled status
  function onChanges(changes){
    if(!app) { return; }
    if(changes.ngDisabled){
      applyDisabledToRedactor();
    }
    if(changes.ngModel){
      applyModelToRedactor();
    }
  }

  // When destroyed
  function onDestroy(){
    if(!redactorElement) return;
    hideToolBar();
  }

  // Get Unique ID
  function getUniqueId(){
    redactorUid ++;
    return 'redactor-'+redactorUid;
  }

  // Apply the disabled flag to Redactor
  function applyDisabledToRedactor(){
    if(ctrl.ngDisabled){
      if(!app.isReadOnly()){
        app.enableReadOnly();
      }
    } else {
      if(app.isReadOnly()){
        app.disableReadOnly();
      }
    }
  }

  // Apply the Model value to Redactor
  function applyModelToRedactor(){
    var html = app.source.getCode();
    if(html !== ctrl.ngModel){
      app.source.setCode(ctrl.ngModel);
    }
  }

  // Apply the Redactor value to the Model
  function applyRedactorToModel() {
    var html = app.source.getCode();
    if(ctrl.ngModel === html){
      return; // Don't propagate changes if the model has the same value as the editor
    }
    try {
      ctrl.ngModel = html; // See: $onChanges for this
      ctrl.ngModelCtrl.$setViewValue(html);
      ctrl.ngModelCtrl.$setDirty();
    } catch (e) {
      // https://trello.com/c/XRGSESIF/58-acms-bug-angular-upgrade-new-errors
    }
  }
  var debouncedApplyRedactorToModel = _.debounce(applyRedactorToModel, 200); // Debouncing helps prevent the model being updated with every keystroke

  // Show / Hide the toolbar (UI)
  function showToolBar() {
    ctrl.active = true;
  }
  function hideToolBar() {
    applyRedactorToModel();
    ctrl.active = false;
  }

  // Returns the default redactor options. They can be extended - see onInit()
  function getDefaultOptions(){
    return {
      overrideStyles: false,
      formatting: [
        'p',
        'blockquote',
        'h1',
        'h2',
        'h3',
      ],
      buttons: [
        'format',
        'bold',
        'italic',
        'lists',
        'link',
        'line',
      ],
      plugins: [
        /*
        'alignment',
        'video',
        'table',
        'textdirection',
        'acmsAttributes', // Our [custom.attributes]
        'acmsImage', // Use this instead of the native `image` button
        'acmsCta', // A quick way to apply `call-to-action` styles
        'acmsSocialImages', // Insert social links
        */
      ],
      toolbarFixedTopOffset: 42, // This manual value is the height for the naviation
      imageResizable: true,
      imagePosition : {
        left: 'text-left',
        right: 'text-right',
        center: 'text-center',
      },
      formattingAdd: {
        'p-small': {
          title: 'Small',
          api: 'module.block.format',
          args: {
            'tag': 'p',
            'class': 'text-sm',
            'type': 'toggle'
          }
        },
        // 'p-cta': {
        //   title: 'Call To Action <strong>Links</strong>',
        //   api: 'module.block.format',
        //   args: {
        //     'tag': 'p',
        //     'class': 'cta',
        //     'type': 'toggle'
        //   }
        // },
      },
      callbacks: {
        changed: function(/* event */) {
          $timeout(function(){
            debouncedApplyRedactorToModel();
          });
        },
        focus: function(/* event */) {
          $timeout(function(){
            showToolBar();
          });
        },
        blur: function(/* event */) {
          $timeout(function(){
            hideToolBar();
          });
        }
      },
    };
  }

  // Redactor v2 wrapped images in `<p>` but v3 uses `<figure>`... replace them
  function convertToFigures(html){
    var dom = $.parseHTML( html );
    var output = ''; // Default to a blank string
    for (var index = 0; index < dom.length; index++) {
      var element = dom[index];
      if (element.nodeType === 3) {
        // Pass text nodes straight through
        output += element.textContent;
      } else {
        var htmlNode = element.outerHTML;
        if (element.tagName === 'P') {
          // Fix images
          output += htmlNode.replace(/<p([^>]*)>(.*?)<img(.*?)>([^<]*?)<\/p>/ig, '<figure$1>$2<img$3>$4</figure>');
        } else if (element.tagName === 'DIV' && element.className.indexOf('video-container') > -1) {
          // Fix videos
          output += htmlNode.replace(/<div class="video-container([^">]*)"><iframe (.*?)<\/div>/ig, '<figure class="redactor-component$1" data-redactor-type="video" tabindex="-1" contenteditable="false"><iframe style="width: 300px; height: 150px;" $2</figure>');
        } else {
          output += htmlNode;
        }
      }
    }
    return output;
  }

}

angular
  .module('app')
  .component('inputWysiwyg', inputWysiwygComponent);

},{"./plugins/redactor.attributes.js":265,"./plugins/redactor.cta.js":266,"./plugins/redactor.image.js":267,"./plugins/redactor.social_images.js":268,"./redactor-3/_plugins/alignment/alignment.js":269,"./redactor-3/_plugins/table/table.js":270,"./redactor-3/_plugins/textdirection/textdirection.js":271,"./redactor-3/_plugins/video/video.js":272,"./redactor-3/redactor.js":273}],265:[function(require,module,exports){
/** WYSIWYG :: ATTRIBUTES PLUGIN
 *
 *      Custom plugin redactor, adds a dropdown list of
 *       [custom.attributes].
 *
 *      @author   David "oodavid" King
 */
(function($R) {
  $R.add('plugin', 'acmsAttributes', {
    // Hoist some variables / modules
    init: function(app){
      this.app = app;
      this.toolbar = app.toolbar;
      this.attributes = app.opts.attributes;
    },
    // Add the dropdown menu to the toolbar
    start: function(){
      var dropdown = {};
      for (var a=0, al=this.attributes.length; a<al; a++) {
        dropdown['attribute' + a] = {
          title: this.attributes[a].tag,
          api: getCallback(this.attributes[a]),
          args: this.attributes[a],
        };
      }
      var $button = this.toolbar.addButton('acmsAttributes', { title: 'Attributes' });
      $button.setIcon('<i class="tags"></i>');
      $button.setDropdown(dropdown);
    },
    // Adds a link
    addLink: function(attribute){
      var link = {
        url: 'http://' + attribute.tag,
        text: trim(this.app.selection.getText()) || attribute.tag,
      };
      this.app.api('module.link.insert', link);
    },
    // Adds an image
    addImage: function(attribute){
      // Insert a blank image
      var id = 'img' + Date.now();
      var data = {};
      data[id] = {
        id: id,
        url: '',
      };
      this.app.api('module.image.insert', data);
      // ...then update the element to have our attribute as a src
      var img = $('[data-image="' + id + '"]');
      img.attr('data-src', attribute.tag)
        .attr('width', 100)
        .attr('height', 100);
      // Make sure it's centred
      img.closest('figure').removeClass('text-right text-justify').addClass('text-center');
    },
    // Adds text
    addText: function(attribute){
      this.app.insertion.insertText(attribute.tag);
    },
  });
  // Utility functions
  var callbacks = {
    'url':     'plugin.acmsAttributes.addLink',
    'image':   'plugin.acmsAttributes.addImage',
    'default': 'plugin.acmsAttributes.addText',
  };
  function getCallback(attribute){
    return callbacks[attribute.type] || callbacks['default'];
  }
  function trim(str) {
    return str.replace(/^\s+|\s+$/gm, '');
  }
})(Redactor);

},{}],266:[function(require,module,exports){
/** WYSIWYG :: CALL-TO-ACTION PLUGIN
 *
 *      Toggles the `.cta` class on the current input
 *
 *      @author   David "oodavid" King
 */
(function($R) {
  $R.add('plugin', 'acmsCta', {
    // Hoist some variables / modules
    init: function(app){
      this.app = app;
      this.block = app.block;
      this.toolbar = app.toolbar;
    },
    // Add the button to the toolbar
    start: function(){
      var data = {
        title: 'Call To Action',
        api: 'plugin.acmsCta.toggle'
      };
      var button = this.toolbar.addButton('acmsCta', data);
      button.setIcon('<i class="choose"></i>');
    },
    // Toggles the CTA class
    toggle: function() {
      this.block.format({
        tag: 'p',
        class: 'cta',
        type: 'toggle',
      });
    }
  });
})(Redactor);

},{}],267:[function(require,module,exports){
/** WYSIWYG :: IMAGE UPLOAD PLUGIN
 *
 *      While redactor has it's own image upload system, I'd rather
 *       consume our tried and tested upload directive. This plugin
 *       creates a custom modal, and does some fruity things to get
 *       Angular to work within the modal
 *
 *      @author   David "oodavid" King
 */
(function($R) {
  $R.add('plugin', 'acmsImage', {
    // Define the modal namespace
    modals: {
      'acmsImageModal': '',
    },
    // Hoist some variables / modules
    init: function(app){
      this.app = app;
      this.toolbar = app.toolbar;
    },
    // Add the button to the toolbar
    start: function(){
      var data = {
        title: 'Image',
        api: 'plugin.acmsImage.open'
      };
      var button = this.toolbar.addButton('acmsImage', data);
      button.setIcon('<i class="re-icon-image"></i>');
    },
    // Opens the modal
    open: function(){
      var options = {
        title: 'Upload an Image',
        width: '600px',
        name: 'acmsImageModal',
        commands: {
          insert: { title: 'Insert' },
          cancel: { title: 'Cancel' },
        },
      };
      this.app.api('module.modal.build', options);
    },
    // Modal Events
    onmodal: {
      acmsImageModal: {
        // When we are opened
        open: function($modal){
          // Add the (custom) file <input>
          var $body = $modal.getBody();
          var $div = $R.dom('<div>');
          $div.html('\
            <div class="modal-section" id="redactor-modal-acmsImage" ng-controller="AcmsImageCtrl">\
              <button type="button" upload-file upload-preset="issuerImage" on-upload="onFile(fileUrl, fileType, fileName, s3Bucket, s3Key)" upload-progress="progressVal" ng-style="{ \'background-size\': progressVal+\'% 100%\' }" style="display: block;">\
              Select an image to upload\
              </button>\
              <img id="redactor-modal-acmsImage-img" ng-src="{{ imgUrl }}" ng-if="imgUrl" style="max-width: 200px; max-height: 200px; margin: 10px auto 0 auto; display: block;">\
            </div>'
          );
          $body.html('');
          $body.append($div);
          // HACK - Compile the new DOM with an Angular controller
          var $rootScope = angular.element(document.querySelector('html')).injector().get('$rootScope');
          var $compile = angular.element(document.querySelector('html')).injector().get('$compile');
          var modalEl = $('#redactor-modal-acmsImage');
          var $scope = $rootScope.$new();
          $compile(modalEl)($scope);
        },
        // When the main "insert" button is clicked
        insert: function($modal){
          // If we have an image URL...
          var src = $('#redactor-modal-acmsImage-img').attr('src');
          if(src){
            var id = 'img' + Date.now();
            var data = {};
            data[id] = {
              id: id,
              url: src,
            };
            this.app.api('module.image.insert', data);
            // Add max-width
            var img = $('[data-image="' + id + '"]');
            img.css('maxWidth', '100%');
            img.closest('figure').removeClass('text-right text-justify').addClass('text-center');
          }
        }
      }
    },
  });
})(Redactor);


angular
  .module('app')
  .controller('AcmsImageCtrl', ['$scope',
    function($scope) {
      $scope.imgUrl = false;
      $scope.onFile = function(fileUrl/*, fileType, fileName, s3Bucket, s3Key*/) {
        $scope.imgUrl = fileUrl;
      };
    }
  ]);

},{}],268:[function(require,module,exports){
/** WYSIWYG :: SOCIAL IMAGES
 *
 *      Inserts a fixed block of HTML with social icons
 *
 *      @author   David "oodavid" King
 */
(function($R) {
  $R.add('plugin', 'acmsSocialImages', {
    // Hoist some variables / modules
    init: function(app){
      this.app = app;
      this.block = app.block;
      this.toolbar = app.toolbar;
    },
    // Add the dropdown to the toolbar
    start: function() {
      var dropdown = {
        iconSet:         { title: 'Icon Set',         api: 'plugin.acmsSocialImages.insert', args: null },
        facebook:        { title: 'Facebook',         api: 'plugin.acmsSocialImages.insert', args: '<a href="[credential.facebook_url]" target="_blank"><img src="https://s3.amazonaws.com/accredible-api-templates/1497343371278.png" width="48"  height="48"></a>' },
        linkedin:        { title: 'LinkedIn',         api: 'plugin.acmsSocialImages.insert', args: '<a href="[credential.linkedin_url]" target="_blank"><img src="https://s3.amazonaws.com/accredible-api-templates/1497343875390.png" width="48"  height="48"></a>' },
        twitter:         { title: 'Twitter',          api: 'plugin.acmsSocialImages.insert', args: '<a href="[credential.twitter_url]" target="_blank"><img src="https://s3.amazonaws.com/accredible-api-templates/1497343258610.png" width="48"  height="48"></a>' },
        facebookLarge:   { title: 'Facebook - Large', api: 'plugin.acmsSocialImages.insert', args: '<a href="[credential.facebook_url]" target="_blank"><img src="https://s3.amazonaws.com/accredible-api-templates/1497006984099.png" width="99"  height="99"></a>' },
        linkedinLarge:   { title: 'LinkedIn - Large', api: 'plugin.acmsSocialImages.insert', args: '<a href="[credential.linkedin_url]" target="_blank"><img src="https://s3.amazonaws.com/accredible-api-templates/1497006843744.png" width="99"  height="99"></a>' },
        twitterLarge:    { title: 'Twitter - Large',  api: 'plugin.acmsSocialImages.insert', args: '<a href="[credential.twitter_url]" target="_blank"><img src="https://s3.amazonaws.com/accredible-api-templates/1497007162922.png" width="99"  height="99"></a>' },
      };
      // Set the `iconSet` args using the other options
      dropdown.iconSet.args = '<p class="text-center">'+dropdown.facebook.args+' '+dropdown.linkedin.args+' '+dropdown.twitter.args+'</p>';
      // Add the button
      var $button = this.toolbar.addButton('acmsSocialImages', { title: 'Social Images' });
      $button.setIcon('<i class="share"></i>');
      $button.setDropdown(dropdown);
    },
    // Insert
    insert: function(html) {
      this.app.insertion.insertHtml(html);
    }
  });
})(Redactor);

},{}],269:[function(require,module,exports){
(function($R)
{
    $R.add('plugin', 'alignment', {
        translations: {
    		en: {
    			"align": "Align",
    			"align-left": "Align Left",
    			"align-center": "Align Center",
    			"align-right": "Align Right",
    			"align-justify": "Align Justify"
    		}
        },
        init: function(app)
        {
            this.app = app;
            this.opts = app.opts;
            this.lang = app.lang;
            this.block = app.block;
            this.toolbar = app.toolbar;
        },
        // public
        start: function()
        {
            var dropdown = {};

    		dropdown.left = { title: this.lang.get('align-left'), api: 'plugin.alignment.set', args: 'left' };
    		dropdown.center = { title: this.lang.get('align-center'), api: 'plugin.alignment.set', args: 'center' };
    		dropdown.right = { title: this.lang.get('align-right'), api: 'plugin.alignment.set', args: 'right' };
    		dropdown.justify = { title: this.lang.get('align-justify'), api: 'plugin.alignment.set', args: 'justify' };

            var $button = this.toolbar.addButton('alignment', { title: this.lang.get('align') });
            $button.setIcon('<i class="re-icon-alignment"></i>');
			$button.setDropdown(dropdown);
        },
        set: function(type)
		{
    		if (type === 'left' && this.opts.direction === 'ltr')
    		{
        		return this._remove();
    		}

    		var args = {
        	    style: { 'text-align': type }
    		};

			this.block.toggle(args);
		},

		// private
		_remove: function()
		{
		    this.block.remove({ style: 'text-align' });
		}
    });
})(Redactor);
},{}],270:[function(require,module,exports){
(function($R)
{
    $R.add('plugin', 'table', {
        translations: {
            en: {
        		"table": "Table",
        		"insert-table": "Insert table",
        		"insert-row-above": "Insert row above",
        		"insert-row-below": "Insert row below",
        		"insert-column-left": "Insert column left",
        		"insert-column-right": "Insert column right",
        		"add-head": "Add head",
        		"delete-head": "Delete head",
        		"delete-column": "Delete column",
        		"delete-row": "Delete row",
        		"delete-table": "Delete table"
        	}
        },
        init: function(app)
        {
            this.app = app;
            this.lang = app.lang;
            this.opts = app.opts;
            this.caret = app.caret;
            this.editor = app.editor;
            this.toolbar = app.toolbar;
            this.component = app.component;
            this.inspector = app.inspector;
            this.insertion = app.insertion;
            this.selection = app.selection;
        },
        // messages
        ondropdown: {
            table: {
                observe: function(dropdown)
                {
                    this._observeDropdown(dropdown);
                }
            }
        },
        onbottomclick: function()
        {
            this.insertion.insertToEnd(this.editor.getLastNode(), 'table');
        },

        // public
        start: function()
        {
			var dropdown = {
    			observe: 'table',
    			'insert-table': {
    				title: this.lang.get('insert-table'),
    				api: 'plugin.table.insert'
    			},
    			'insert-row-above': {
                    title: this.lang.get('insert-row-above'),
    				classname: 'redactor-table-item-observable',
                    api: 'plugin.table.addRowAbove'
    			},
    			'insert-row-below': {
        			title: this.lang.get('insert-row-below'),
        			classname: 'redactor-table-item-observable',
                    api: 'plugin.table.addRowBelow'
    			},
    			'insert-column-left': {
        			title: this.lang.get('insert-column-left'),
        			classname: 'redactor-table-item-observable',
                    api: 'plugin.table.addColumnLeft'
    			},
    			'insert-column-right': {
        			title: this.lang.get('insert-column-right'),
        			classname: 'redactor-table-item-observable',
                    api: 'plugin.table.addColumnRight'
    			},
    			'add-head': {
        			title: this.lang.get('add-head'),
        			classname: 'redactor-table-item-observable',
                    api: 'plugin.table.addHead'
    			},
    			'delete-head': {
        			title: this.lang.get('delete-head'),
        			classname: 'redactor-table-item-observable',
                    api: 'plugin.table.deleteHead'
    			},
    			'delete-column': {
        			title: this.lang.get('delete-column'),
        			classname: 'redactor-table-item-observable',
                    api: 'plugin.table.deleteColumn'
    			},
    			'delete-row': {
        			title: this.lang.get('delete-row'),
        			classname: 'redactor-table-item-observable',
                    api: 'plugin.table.deleteRow'
    			},
    			'delete-table': {
        			title: this.lang.get('delete-table'),
        			classname: 'redactor-table-item-observable',
                    api: 'plugin.table.deleteTable'
    			}
			};
            var obj = {
                title: this.lang.get('table')
            };

			var $button = this.toolbar.addButtonBefore('link', 'table', obj);
			$button.setIcon('<i class="re-icon-table"></i>');
			$button.setDropdown(dropdown);
        },
		insert: function()
		{
            var rows = 2;
			var columns = 3;
			var $component = this.component.create('table');

			for (var i = 0; i < rows; i++)
			{
			    $component.addRow(columns);
			}

			$component =  this.insertion.insertHtml($component);
			this.caret.setStart($component);
		},
        addRowAbove: function()
        {
            var $component = this._getComponent();
            if ($component)
            {
                var current = this.selection.getCurrent();
                var $row = $component.addRowTo(current, 'before');

                this.caret.setStart($row);
            }
        },
        addRowBelow: function()
        {
            var $component = this._getComponent();
            if ($component)
            {
                var current = this.selection.getCurrent();
                var $row = $component.addRowTo(current, 'after');

                this.caret.setStart($row);
            }
        },
        addColumnLeft: function()
        {
            var $component = this._getComponent();
            if ($component)
            {
                var current = this.selection.getCurrent();

                this.selection.save();
                $component.addColumnTo(current, 'left');
                this.selection.restore();
            }
        },
        addColumnRight: function()
        {
            var $component = this._getComponent();
            if ($component)
            {
                var current = this.selection.getCurrent();

                this.selection.save();
                $component.addColumnTo(current, 'right');
                this.selection.restore();
            }
        },
        addHead: function()
        {
            var $component = this._getComponent();
            if ($component)
            {
                this.selection.save();
                $component.addHead();
                this.selection.restore();
            }
        },
        deleteHead: function()
        {
            var $component = this._getComponent();
            if ($component)
            {
                var current = this.selection.getCurrent();
                var $head = $R.dom(current).closest('thead');
                if ($head.length !== 0)
                {
                    $component.removeHead();
                    this.caret.setStart($component);
                }
                else
                {
                    this.selection.save();
                    $component.removeHead();
                    this.selection.restore();
                }
            }
        },
        deleteColumn: function()
        {
            var $component = this._getComponent();
            if ($component)
            {
                var current = this.selection.getCurrent();

                var $currentCell = $R.dom(current).closest('td, th');
                var nextCell = $currentCell.nextElement().get();
                var prevCell = $currentCell.prevElement().get();

                $component.removeColumn(current);

                if (nextCell) this.caret.setStart(nextCell);
                else if (prevCell) this.caret.setEnd(prevCell);
                else this.deleteTable();
            }
        },
        deleteRow: function()
        {
            var $component = this._getComponent();
            if ($component)
            {
                var current = this.selection.getCurrent();

                var $currentRow = $R.dom(current).closest('tr');
                var nextRow = $currentRow.nextElement().get();
                var prevRow = $currentRow.prevElement().get();

                $component.removeRow(current);

                if (nextRow) this.caret.setStart(nextRow);
                else if (prevRow) this.caret.setEnd(prevRow);
                else this.deleteTable();
            }
        },
        deleteTable: function()
        {
            var table = this._getTable();
            if (table)
            {
                this.component.remove(table);
            }
        },

        // private
        _getTable: function()
        {
            var current = this.selection.getCurrent();
            var data = this.inspector.parse(current);
            if (data.isTable())
            {
                return data.getTable();
            }
        },
        _getComponent: function()
        {
            var current = this.selection.getCurrent();
            var data = this.inspector.parse(current);
            if (data.isTable())
            {
                var table = data.getTable();

                return this.component.create('table', table);
            }
        },
        _observeDropdown: function(dropdown)
        {
            var table = this._getTable();
            var items = dropdown.getItemsByClass('redactor-table-item-observable');
            var tableItem = dropdown.getItem('insert-table');
            if (table)
            {
                this._observeItems(items, 'enable');
                tableItem.disable();
            }
            else
            {
                this._observeItems(items, 'disable');
                tableItem.enable();
            }
        },
        _observeItems: function(items, type)
        {
            for (var i = 0; i < items.length; i++)
            {
                items[i][type]();
            }
        }
    });
})(Redactor);
(function($R)
{
    $R.add('class', 'table.component', {
        mixins: ['dom', 'component'],
        init: function(app, el)
        {
            this.app = app;

            // init
            return (el && el.cmnt !== undefined) ? el : this._init(el);
        },

        // public
        addHead: function()
        {
			this.removeHead();

			var columns = this.$element.find('tr').first().children('td, th').length;
			var $head = $R.dom('<thead>');
            var $row = this._buildRow(columns, '<th>');

            $head.append($row);
            this.$element.prepend($head);
        },
        addRow: function(columns)
        {
            var $row = this._buildRow(columns);
            this.$element.append($row);

            return $row;
        },
        addRowTo: function(current, type)
        {
            return this._addRowTo(current, type);
        },
        addColumnTo: function(current, type)
        {
            var $current = $R.dom(current);
            var $currentRow = $current.closest('tr');
            var $currentCell = $current.closest('td, th');

            var index = 0;
            $currentRow.find('td, th').each(function(node, i)
			{
				if (node === $currentCell.get()) index = i;
			});

			this.$element.find('tr').each(function(node)
			{
    			var $node = $R.dom(node);
				var origCell = $node.find('td, th').get(index);
				var $origCell = $R.dom(origCell);

				var $td = $origCell.clone();
				$td.html('<div data-redactor-tag="tbr"></div>');

				if (type === 'right') $origCell.after($td);
				else                  $origCell.before($td);
			});
        },
        removeHead: function()
        {
			var $head = this.$element.find('thead');
			if ($head.length !== 0) $head.remove();
        },
        removeRow: function(current)
        {
            var $current = $R.dom(current);
            var $currentRow = $current.closest('tr');

            $currentRow.remove();
        },
        removeColumn: function(current)
        {
            var $current = $R.dom(current);
            var $currentRow = $current.closest('tr');
            var $currentCell = $current.closest('td, th');

            var index = 0;
            $currentRow.find('td, th').each(function(node, i)
			{
				if (node === $currentCell.get()) index = i;
			});

			this.$element.find('tr').each(function(node)
			{
    			var $node = $R.dom(node);
				var origCell = $node.find('td, th').get(index);
				var $origCell = $R.dom(origCell);

				$origCell.remove();
			});
        },

        // private
        _init: function(el)
        {
            var wrapper, element;
            if (typeof el !== 'undefined')
            {
                var $node = $R.dom(el);
                var node = $node.get();
                var $figure = $node.closest('figure');
                if ($figure.length !== 0)
                {
                    wrapper = $figure;
                    element = $figure.find('table').get();
                }
                else if (node.tagName === 'TABLE')
                {
                    element = node;
                }
            }

            this._buildWrapper(wrapper);
            this._buildElement(element);
            this._initWrapper();
        },
        _addRowTo: function(current, position)
        {
            var $current = $R.dom(current);
            var $currentRow = $current.closest('tr');
            if ($currentRow.length !== 0)
            {
                var columns = $currentRow.children('td, th').length;
                var $newRow = this._buildRow(columns);

                $currentRow[position]($newRow);

                return $newRow;
            }
        },
        _buildRow: function(columns, tag)
        {
            tag = tag || '<td>';

            var $row = $R.dom('<tr>');
            for (var i = 0; i < columns; i++)
            {
                var $cell = $R.dom(tag);
                $cell.attr('contenteditable', true);
                $cell.html('<div data-redactor-tag="tbr"></div>');

                $row.append($cell);
            }

            return $row;
        },
        _buildElement: function(node)
        {
            if (node)
            {
                this.$element = $R.dom(node);
            }
            else
            {
                this.$element = $R.dom('<table>');
                this.append(this.$element);
            }
        },
        _buildWrapper: function(node)
        {
            node = node || '<figure>';

            this.parse(node);
        },
        _initWrapper: function()
        {
            this.addClass('redactor-component');
            this.attr({
                'data-redactor-type': 'table',
                'tabindex': '-1',
                'contenteditable': false
            });

            if (this.app.detector.isIe())
            {
                this.removeAttr('contenteditable');
            }
        }
    });

})(Redactor);
},{}],271:[function(require,module,exports){
(function($R)
{
    $R.add('plugin', 'textdirection', {
        translations: {
    		en: {
    			"change-text-direction": "RTL-LTR",
    			"left-to-right": "Left to Right",
    			"right-to-left": "Right to Left"
    		}
        },
        init: function(app)
        {
            this.app = app;
            this.lang = app.lang;
            this.block = app.block;
            this.toolbar = app.toolbar;
            this.selection = app.selection;
        },
        // public
        start: function()
        {
            var dropdown = {};

    		dropdown.ltr = { title: this.lang.get('left-to-right'), api: 'plugin.textdirection.set', args: 'ltr' };
    		dropdown.rtl = { title: this.lang.get('right-to-left'), api: 'plugin.textdirection.set', args: 'rtl' };

            var $button = this.toolbar.addButton('textdirection', { title: this.lang.get('change-text-direction') });
            $button.setIcon('<i class="re-icon-textdirection"></i>');
			$button.setDropdown(dropdown);
        },
        set: function(type)
		{
    		var block = this.selection.getBlock();
    		if (block && block.tagName === 'LI') {
        		var list = $R.dom(block).parents('ul, ol', '.redactor-in').last();
        		this.block.add({ attr: { dir: type }}, false, list);
    		}
            else {
                this.block.add({ attr: { dir: type }});
            }
		}
    });
})(Redactor);
},{}],272:[function(require,module,exports){
(function($R)
{
    $R.add('plugin', 'video', {
        translations: {
            en: {
                "video": "Video",
                "video-html-code": "Video Embed Code or Youtube/Vimeo Link"
            }
        },
        modals: {
            'video':
                '<form action=""> \
                    <div class="form-item"> \
                        <label for="modal-video-input">## video-html-code ##</label> \
                        <textarea id="modal-video-input" name="video" style="height: 160px;"></textarea> \
                    </div> \
                </form>'
        },
        init: function(app)
        {
            this.app = app;
            this.lang = app.lang;
            this.opts = app.opts;
            this.toolbar = app.toolbar;
            this.component = app.component;
            this.insertion = app.insertion;
            this.inspector = app.inspector;
        },
        // messages
        onmodal: {
            video: {
                opened: function($modal, $form)
                {
                    $form.getField('video').focus();
                },
                insert: function($modal, $form)
                {
                    var data = $form.getData();
                    this._insert(data);
                }
            }
        },
        oncontextbar: function(e, contextbar)
        {
            var data = this.inspector.parse(e.target)
            if (data.isComponentType('video'))
            {
                var node = data.getComponent();
                var buttons = {
                    "remove": {
                        title: this.lang.get('delete'),
                        api: 'plugin.video.remove',
                        args: node
                    }
                };

                contextbar.set(e, node, buttons, 'bottom');
            }

        },

        // public
        start: function()
        {
            var obj = {
                title: this.lang.get('video'),
                api: 'plugin.video.open'
            };

            var $button = this.toolbar.addButtonAfter('image', 'video', obj);
            $button.setIcon('<i class="re-icon-video"></i>');
        },
        open: function()
		{
            var options = {
                title: this.lang.get('video'),
                width: '600px',
                name: 'video',
                handle: 'insert',
                commands: {
                    insert: { title: this.lang.get('insert') },
                    cancel: { title: this.lang.get('cancel') }
                }
            };

            this.app.api('module.modal.build', options);
		},
        remove: function(node)
        {
            this.component.remove(node);
        },

        // private
		_insert: function(data)
		{
    		this.app.api('module.modal.close');

    		if (data.video.trim() === '')
    		{
        	    return;
    		}

            // parsing
            data.video = this._matchData(data.video);

            // inserting
            if (this._isVideoIframe(data.video))
            {
                var $video = this.component.create('video', data.video);
                this.insertion.insertHtml($video);
            }
		},

		_isVideoIframe: function(data)
		{
            return (data.match(/<iframe|<video/gi) !== null);
		},
		_matchData: function(data)
		{
			var iframeStart = '<iframe style="width: 500px; height: 281px;" src="';
			var iframeEnd = '" frameborder="0" allowfullscreen></iframe>';

            if (this._isVideoIframe(data))
			{
				var allowed = ['iframe', 'video', 'source'];
				var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;

                data = data.replace(/<p(.*?[^>]?)>([\w\W]*?)<\/p>/gi, '');
			    data = data.replace(tags, function ($0, $1)
			    {
			        return (allowed.indexOf($1.toLowerCase()) === -1) ? '' : $0;
			    });
			}
            else
            {
    			if (data.match(this.opts.regex.youtube))
    			{
    				data = data.replace(this.opts.regex.youtube, iframeStart + '//www.youtube.com/embed/$1' + iframeEnd);
    			}
    			else if (data.match(this.opts.regex.vimeo))
    			{

    				data = data.replace(this.opts.regex.vimeo, iframeStart + '//player.vimeo.com/video/$2' + iframeEnd);
    			}
			}


			return data;
		}
    });
})(Redactor);
},{}],273:[function(require,module,exports){
/*
    Redactor
    Version 3.3.2
    Updated: November 7, 2019

    http://imperavi.com/redactor/

    Copyright (c) 2009-2019, Imperavi Ltd.
    License: http://imperavi.com/redactor/license/
*/
(function() {
var Ajax = {};

Ajax.settings = {};
Ajax.post = function(options) { return new AjaxRequest('post', options); };
Ajax.get = function(options) { return new AjaxRequest('get', options); };

var AjaxRequest = function(method, options)
{
    var defaults = {
        method: method,
        url: '',
        before: function() {},
        success: function() {},
        error: function() {},
        data: false,
        async: true,
        headers: {}
    };

    this.p = this.extend(defaults, options);
    this.p = this.extend(this.p, Ajax.settings);
    this.p.method = this.p.method.toUpperCase();

    this.prepareData();

    this.xhr = new XMLHttpRequest();
    this.xhr.open(this.p.method, this.p.url, this.p.async);

    this.setHeaders();

    var before = (typeof this.p.before === 'function') ? this.p.before(this.xhr) : true;
    if (before !== false)
    {
        this.send();
    }
};

AjaxRequest.prototype = {
    extend: function(obj1, obj2)
    {
        if (obj2) for (var name in obj2) { obj1[name] = obj2[name]; }
        return obj1;
    },
    prepareData: function()
    {
        if (this.p.method === 'POST' && !this.isFormData()) this.p.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        if (typeof this.p.data === 'object' && !this.isFormData()) this.p.data = this.toParams(this.p.data);
        if (this.p.method === 'GET') this.p.url = (this.p.data) ? this.p.url + '?' + this.p.data : this.p.url;
    },
    setHeaders: function()
    {
        this.xhr.setRequestHeader('X-Requested-With', this.p.headers['X-Requested-With'] || 'XMLHttpRequest');
        for (var name in this.p.headers)
        {
            this.xhr.setRequestHeader(name, this.p.headers[name]);
        }
    },
    isFormData: function()
    {
        return (typeof window.FormData !== 'undefined' && this.p.data instanceof window.FormData);
    },
    isComplete: function()
    {
        return !(this.xhr.status < 200 || this.xhr.status >= 300 && this.xhr.status !== 304);
    },
    send: function()
    {
        if (this.p.async)
        {
            this.xhr.onload = this.loaded.bind(this);
            this.xhr.send(this.p.data);
        }
        else
        {
            this.xhr.send(this.p.data);
            this.loaded.call(this);
        }
    },
    loaded: function()
    {
        if (this.isComplete())
        {
            var response = this.xhr.response;
            var json = this.parseJson(response);
            response = (json) ? json : response;

            if (typeof this.p.success === 'function') this.p.success(response, this.xhr);
        }
        else
        {
            if (typeof this.p.error === 'function') this.p.error(this.xhr.statusText);
        }
    },
    parseJson: function(str)
    {
        try {
            var o = JSON.parse(str);
            if (o && typeof o === 'object')
            {
                return o;
            }

        } catch (e) {}

        return false;
    },
    toParams: function (obj)
    {
        return Object.keys(obj).map(
            function(k){ return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]); }
        ).join('&');
    }
};
var DomCache = [0];
var DomExpando = 'data' + new Date().getTime();
var DomHClass = 'is-hidden';
var DomHMClass = 'is-hidden-mobile';

var Dom = function(selector, context)
{
    return this.parse(selector, context);
};

Dom.ready = function(fn)
{
    if (document.readyState != 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
};

Dom.prototype = {
    get sdom()
    {
        return true;
    },
    get length()
    {
        return this.nodes.length;
    },
    parse: function(selector, context)
    {
        var nodes;
        var reHtmlTest = /^\s*<(\w+|!)[^>]*>/;

        if (!selector)
        {
            nodes = [];
        }
        else if (selector.sdom)
        {
            this.nodes = selector.nodes;
            return selector;
        }
        else if (typeof selector !== 'string')
        {
            if (selector.nodeType && selector.nodeType === 11)
            {
                nodes = selector.childNodes;
            }
            else
            {
                nodes = (selector.nodeType || selector === window) ? [selector] : selector;
            }
        }
        else if (reHtmlTest.test(selector))
        {
            nodes = this.create(selector);
        }
        else
        {
            nodes = this._query(selector, context);
        }

        this.nodes = this._slice(nodes);
    },
    create: function(html)
    {
        if (/^<(\w+)\s*\/?>(?:<\/\1>|)$/.test(html))
        {
            return [document.createElement(RegExp.$1)];
        }

        var elements = [];
        var container = document.createElement('div');
        var children = container.childNodes;

        container.innerHTML = html;

        for (var i = 0, l = children.length; i < l; i++)
        {
            elements.push(children[i]);
        }

        return elements;
    },

    // add
    add: function(nodes)
    {
        this.nodes = this.nodes.concat(this._toArray(nodes));
    },

    // get
    get: function(index)
    {
        return this.nodes[(index || 0)] || false;
    },
    getAll: function()
    {
        return this.nodes;
    },
    eq: function(index)
    {
        return new Dom(this.nodes[index]);
    },
    first: function()
    {
        return new Dom(this.nodes[0]);
    },
    last: function()
    {
        return new Dom(this.nodes[this.nodes.length - 1]);
    },
    contents: function()
    {
        return this.get().childNodes;
    },

    // loop
    each: function(callback)
    {
        var len = this.nodes.length;
        for (var i = 0; i < len; i++)
        {
            callback.call(this, (this.nodes[i].sdom) ? this.nodes[i].get() : this.nodes[i], i);
        }

        return this;
    },

    // traversing
    is: function(selector)
    {
        return (this.filter(selector).length > 0);
    },
    filter: function (selector)
    {
        var callback;
        if (selector === undefined)
        {
            return this;
        }
        else if (typeof selector === 'function')
        {
            callback = selector;
        }
        else
        {
            callback = function(node)
            {
                if (selector instanceof Node)
                {
                    return (selector === node);
                }
                else if (selector && selector.sdom)
                {
                    return ((selector.nodes).indexOf(node) !== -1);
                }
                else
                {
                    node.matches = node.matches || node.msMatchesSelector || node.webkitMatchesSelector;
                    return (node.nodeType === 1) ? node.matches(selector || '*') : false;
                }
            };
        }

        return new Dom(this.nodes.filter(callback));
    },
    not: function(filter)
    {
        return this.filter(function(node)
        {
            return !new Dom(node).is(filter || true);
        });
    },
    find: function(selector)
    {
        var nodes = [];
        this.each(function(node)
        {
            var ns = this._query(selector || '*', node);
            for (var i = 0; i < ns.length; i++)
            {
                nodes.push(ns[i]);
            }
        });

        return new Dom(nodes);
    },
    children: function(selector)
    {
        var nodes = [];
        this.each(function(node)
        {
            if (node.children)
            {
                var ns = node.children;
                for (var i = 0; i < ns.length; i++)
                {
                    nodes.push(ns[i]);
                }
            }
        });

        return new Dom(nodes).filter(selector);
    },
    parent: function(selector)
    {
        var nodes = [];
        this.each(function(node)
        {
            if (node.parentNode) nodes.push(node.parentNode);
        });

        return new Dom(nodes).filter(selector);
    },
    parents: function(selector, context)
    {
        context = this._getContext(context);

        var nodes = [];
        this.each(function(node)
        {
            var parent = node.parentNode;
            while (parent && parent !== context)
            {
                if (selector)
                {
                    if (new Dom(parent).is(selector)) { nodes.push(parent); }
                }
                else
                {
                    nodes.push(parent);
                }

                parent = parent.parentNode;
            }
        });

        return new Dom(nodes);
    },
    closest: function(selector, context)
    {
        context = this._getContext(context);
        selector = (selector.sdom) ? selector.get() : selector;

        var nodes = [];
        var isNode = (selector && selector.nodeType);
        this.each(function(node)
        {
            do {
                if ((isNode && node === selector) || new Dom(node).is(selector)) return nodes.push(node);
            } while ((node = node.parentNode) && node !== context);
        });

        return new Dom(nodes);
    },
    next: function(selector)
    {
         return this._getSibling(selector, 'nextSibling');
    },
    nextElement: function(selector)
    {
        return this._getSibling(selector, 'nextElementSibling');
    },
    prev: function(selector)
    {
        return this._getSibling(selector, 'previousSibling');
    },
    prevElement: function(selector)
    {
        return this._getSibling(selector, 'previousElementSibling');
    },

    // css
    css: function(name, value)
    {
        if (value === undefined && (typeof name !== 'object'))
        {
            var node = this.get();
            if (name === 'width' || name === 'height')
            {
                return (node.style) ? this._getHeightOrWidth(name, node, false) + 'px' : undefined;
            }
            else
            {
                return (node.style) ? getComputedStyle(node, null)[name] : undefined;
            }
        }

        // set
        return this.each(function(node)
        {
            var obj = {};
            if (typeof name === 'object') obj = name;
            else obj[name] = value;

            for (var key in obj)
            {
                if (node.style) node.style[key] = obj[key];
            }
        });
    },

    // attr
    attr: function(name, value, data)
    {
        data = (data) ? 'data-' : '';

        if (value === undefined && (typeof name !== 'object'))
        {
            var node = this.get();
            if (node && node.nodeType !== 3)
            {
                return (name === 'checked') ? node.checked : this._getBooleanFromStr(node.getAttribute(data + name));
            }
            else return;
        }

        // set
        return this.each(function(node)
        {
            var obj = {};
            if (typeof name === 'object') obj = name;
            else obj[name] = value;

            for (var key in obj)
            {
                if (node.nodeType !== 3)
                {
                    if (key === 'checked') node.checked = obj[key];
                    else node.setAttribute(data + key, obj[key]);
                }
            }
        });
    },
    data: function(name, value)
    {
        if (name === undefined)
        {
            var reDataAttr = /^data\-(.+)$/;
            var attrs = this.get().attributes;

            var data = {};
            var replacer = function (g) { return g[1].toUpperCase(); };

            for (var key in attrs)
            {
                if (attrs[key] && reDataAttr.test(attrs[key].nodeName))
                {
                    var dataName = attrs[key].nodeName.match(reDataAttr)[1];
                    var val = attrs[key].value;
                    dataName = dataName.replace(/-([a-z])/g, replacer);

                    if (this._isObjectString(val)) val = this._toObject(val);
                    else val = (this._isNumber(val)) ? parseFloat(val) : this._getBooleanFromStr(val);

                    data[dataName] = val;
                }
            }

            return data;
        }

        return this.attr(name, value, true);
    },
    val: function(value)
    {
        if (value === undefined)
        {
            var el = this.get();
            if (el.type && el.type === 'checkbox') return el.checked;
            else return el.value;
        }

        return this.each(function(node)
        {
            node.value = value;
        });
    },
    removeAttr: function(value)
    {
        return this.each(function(node)
        {
            var rmAttr = function(name) { if (node.nodeType !== 3) node.removeAttribute(name); };
            value.split(' ').forEach(rmAttr);
        });
    },
    removeData: function(value)
    {
        return this.each(function(node)
        {
            var rmData = function(name) { if (node.nodeType !== 3) node.removeAttribute('data-' + name); };
            value.split(' ').forEach(rmData);
        });
    },

    // dataset/dataget
    dataset: function(key, value)
    {
        return this.each(function(node)
        {
            DomCache[this.dataindex(node)][key] = value;
        });
    },
    dataget: function(key)
    {
        return DomCache[this.dataindex(this.get())][key];
    },
    dataindex: function(el)
    {
        var cacheIndex = el[DomExpando];
        var nextCacheIndex = DomCache.length;

        if (!cacheIndex)
        {
            cacheIndex = el[DomExpando] = nextCacheIndex;
            DomCache[cacheIndex] = {};
        }

        return cacheIndex;
    },


    // class
    addClass: function(value)
    {
        return this._eachClass(value, 'add');
    },
    removeClass: function(value)
    {
        return this._eachClass(value, 'remove');
    },
    toggleClass: function(value)
    {
        return this._eachClass(value, 'toggle');
    },
    hasClass: function(value)
    {
        return this.nodes.some(function(node)
        {
            return (node.classList) ? node.classList.contains(value) : false;
        });
    },

    // html & text
    empty: function()
    {
        return this.each(function(node)
        {
            node.innerHTML = '';
        });
    },
    html: function(html)
    {
        return (html === undefined) ? (this.get().innerHTML || '') : this.empty().append(html);
    },
    text: function(text)
    {
        return (text === undefined) ? (this.get().textContent || '') : this.each(function(node) { node.textContent = text; });
    },

    // manipulation
    after: function(html)
    {
        return this._inject(html, function(frag, node)
        {
            if (typeof frag === 'string')
            {
                node.insertAdjacentHTML('afterend', frag);
            }
            else
            {
                var elms = (frag instanceof Node) ? [frag] : this._toArray(frag).reverse();
                for (var i = 0; i < elms.length; i++)
                {
                    node.parentNode.insertBefore(elms[i], node.nextSibling);
                }
            }

            return node;

        });
    },
    before: function(html)
    {
        return this._inject(html, function(frag, node)
        {
            if (typeof frag === 'string')
            {
                node.insertAdjacentHTML('beforebegin', frag);
            }
            else
            {
                var elms = (frag instanceof Node) ? [frag] : this._toArray(frag);
                for (var i = 0; i < elms.length; i++)
                {
                    node.parentNode.insertBefore(elms[i], node);
                }
            }

            return node;
        });
    },
    append: function(html)
    {
        return this._inject(html, function(frag, node)
        {
            if (typeof frag === 'string' || typeof frag === 'number')
            {
                node.insertAdjacentHTML('beforeend', frag);
            }
            else
            {
                var elms = (frag instanceof Node) ? [frag] : this._toArray(frag);
                for (var i = 0; i < elms.length; i++)
                {
                    node.appendChild(elms[i]);
                }
            }

            return node;
        });
    },
    prepend: function(html)
    {
        return this._inject(html, function(frag, node)
        {
            if (typeof frag === 'string' || typeof frag === 'number')
            {
                node.insertAdjacentHTML('afterbegin', frag);
            }
            else
            {
                var elms = (frag instanceof Node) ? [frag] : this._toArray(frag).reverse();
                for (var i = 0; i < elms.length; i++)
                {
                    node.insertBefore(elms[i], node.firstChild);
                }
            }

            return node;
        });
    },
    wrap: function(html)
    {
        return this._inject(html, function(frag, node)
        {
            var wrapper = (typeof frag === 'string' || typeof frag === 'number') ? this.create(frag)[0] : (frag instanceof Node) ? frag : this._toArray(frag)[0];

            if (node.parentNode)
            {
                node.parentNode.insertBefore(wrapper, node);
            }

            wrapper.appendChild(node);

            return new Dom(wrapper);

        });
    },
    unwrap: function()
    {
        return this.each(function(node)
        {
            var $node = new Dom(node);

            return $node.replaceWith($node.contents());
        });
    },
    replaceWith: function(html)
    {
        return this._inject(html, function(frag, node)
        {
            var docFrag = document.createDocumentFragment();
            var elms = (typeof frag === 'string' || typeof frag === 'number') ? this.create(frag) : (frag instanceof Node) ? [frag] : this._toArray(frag);

            for (var i = 0; i < elms.length; i++)
            {
                docFrag.appendChild(elms[i]);
            }

            var result = docFrag.childNodes[0];
            node.parentNode.replaceChild(docFrag, node);

            return result;

        });
    },
    remove: function()
    {
        return this.each(function(node)
        {
            if (node.parentNode) node.parentNode.removeChild(node);
        });
    },
    clone: function(events)
    {
        var nodes = [];
        this.each(function(node)
        {
            var copy = this._clone(node);
            if (events) copy = this._cloneEvents(node, copy);
            nodes.push(copy);
        });

        return new Dom(nodes);
    },

    // show/hide
    show: function()
    {
        return this.each(function(node)
        {
            if (!node.style || !this._hasDisplayNone(node)) return;

            var target = node.getAttribute('domTargetShow');
            var isHidden = (node.classList) ? node.classList.contains(DomHClass) : false;
            var isHiddenMobile = (node.classList) ? node.classList.contains(DomHMClass) : false;
            var type;

            if (isHidden)
            {
                type = DomHClass;
                node.classList.remove(DomHClass);
            }
            else if (isHiddenMobile)
            {
                type = DomHMClass;
                node.classList.remove(DomHMClass);
            }
            else
            {
                node.style.display = (target) ? target : 'block';
            }

            if (type) node.setAttribute('domTargetHide', type);
            node.removeAttribute('domTargetShow');

        }.bind(this));
    },
    hide: function()
    {
        return this.each(function(node)
        {
            if (!node.style || this._hasDisplayNone(node)) return;

            var display = node.style.display;
            var target = node.getAttribute('domTargetHide');

            if (target === DomHClass)
            {
                node.classList.add(DomHClass);
            }
            else if (target === DomHMClass)
            {
                node.classList.add(DomHMClass);
            }
            else
            {
                if (display !== 'block') node.setAttribute('domTargetShow', display);
                node.style.display = 'none';
            }

            node.removeAttribute('domTargetHide');

        });
    },

    // dimensions
    scrollTop: function(value)
    {
        var node = this.get();
        var isWindow = (node === window);
        var isDocument = (node.nodeType === 9);
        var el = (isDocument) ? (document.scrollingElement || document.body.parentNode || document.body || document.documentElement) : node;

        if (value !== undefined)
        {
            if (isWindow) window.scrollTo(0, value);
            else el.scrollTop = value;
            return;
        }

        if (isDocument)
        {
            return (typeof window.pageYOffset != 'undefined') ? window.pageYOffset : ((document.documentElement.scrollTop) ? document.documentElement.scrollTop : ((document.body.scrollTop) ? document.body.scrollTop : 0));
        }
        else
        {
            return (isWindow) ? window.pageYOffset : el.scrollTop;
        }
    },
    offset: function()
    {
        return this._getDim('Offset');
    },
    position: function()
    {
        return this._getDim('Position');
    },
    width: function(value, adjust)
    {
        return this._getSize('width', 'Width', value, adjust);
    },
    height: function(value, adjust)
    {
        return this._getSize('height', 'Height', value, adjust);
    },
    outerWidth: function()
    {
        return this._getInnerOrOuter('width', 'outer');
    },
    outerHeight: function()
    {
        return this._getInnerOrOuter('height', 'outer');
    },
    innerWidth: function()
    {
        return this._getInnerOrOuter('width', 'inner');
    },
    innerHeight: function()
    {
        return this._getInnerOrOuter('height', 'inner');
    },

    // events
    click: function()
    {
        return this._triggerEvent('click');
    },
    focus: function()
    {
        return this._triggerEvent('focus');
    },
    trigger: function(names)
    {
        return this.each(function(node)
        {
            var events = names.split(' ');
            for (var i = 0; i < events.length; i++)
            {
                var ev;
                var opts = { bubbles: true, cancelable: true };

                try {
                    ev = new window.CustomEvent(events[i], opts);
                } catch(e) {
                    ev = document.createEvent('CustomEvent');
                    ev.initCustomEvent(events[i], true, true);
                }

                node.dispatchEvent(ev);
            }
        });
    },
    on: function(names, handler, one)
    {
        return this.each(function(node)
        {
            var events = names.split(' ');
            for (var i = 0; i < events.length; i++)
            {
                var event = this._getEventName(events[i]);
                var namespace = this._getEventNamespace(events[i]);

                handler = (one) ? this._getOneHandler(handler, names) : handler;
                node.addEventListener(event, handler);

                node._e = node._e || {};
                node._e[namespace] = node._e[namespace] || {};
                node._e[namespace][event] = node._e[namespace][event] || [];
                node._e[namespace][event].push(handler);
            }

        });
    },
    one: function(events, handler)
    {
        return this.on(events, handler, true);
    },
    off: function(names, handler)
    {
        var testEvent = function(name, key, event) { return (name === event); };
        var testNamespace = function(name, key, event, namespace) { return (key === namespace); };
        var testEventNamespace = function(name, key, event, namespace) { return (name === event && key === namespace); };
        var testPositive = function() { return true; };

        if (names === undefined)
        {
            // ALL
            return this.each(function(node)
            {
                this._offEvent(node, false, false, handler, testPositive);
            });
        }

        return this.each(function(node)
        {
            var events = names.split(' ');

            for (var i = 0; i < events.length; i++)
            {
                var event = this._getEventName(events[i]);
                var namespace = this._getEventNamespace(events[i]);

                // 1) event without namespace
                if (namespace === '_events') this._offEvent(node, event, namespace, handler, testEvent);
                // 2) only namespace
                else if (!event && namespace !== '_events') this._offEvent(node, event, namespace, handler, testNamespace);
                // 3) event + namespace
                else this._offEvent(node, event, namespace, handler, testEventNamespace);
            }
        });
    },

    // form
    serialize: function(asObject)
    {
        var obj = {};
        var elms = this.get().elements;
        for (var i = 0; i < elms.length; i++)
        {
            var el = elms[i];
            if (/(checkbox|radio)/.test(el.type) && !el.checked) continue;
            if (!el.name || el.disabled || el.type === 'file') continue;

            if (el.type === 'select-multiple')
            {
                for (var z = 0; z < el.options.length; z++)
                {
                    var opt = el.options[z];
                    if (opt.selected) obj[el.name] = opt.value;
                }
            }

            obj[el.name] = (this._isNumber(el.value)) ? parseFloat(el.value) : this._getBooleanFromStr(el.value);
        }

        return (asObject) ? obj : this._toParams(obj);
    },
    ajax: function(success, error)
    {
        if (typeof AjaxRequest !== 'undefined')
        {
            var method = this.attr('method') || 'post';
            var options = {
                url: this.attr('action'),
                data: this.serialize(),
                success: success,
                error: error
            };

            return new AjaxRequest(method, options);
        }
    },

    // private
    _queryContext: function(selector, context)
    {
        context = this._getContext(context);

        return (context.nodeType !== 3 && typeof context.querySelectorAll === 'function') ? context.querySelectorAll(selector) : [];
    },
    _query: function(selector, context)
    {
        if (context)
        {
            return this._queryContext(selector, context);
        }
        else if (/^[.#]?[\w-]*$/.test(selector))
        {
            if (selector[0] === '#')
            {
                var element = document.getElementById(selector.slice(1));
                return element ? [element] : [];
            }

            if (selector[0] === '.')
            {
                return document.getElementsByClassName(selector.slice(1));
            }

            return document.getElementsByTagName(selector);
        }

        return document.querySelectorAll(selector);
    },
    _getContext: function(context)
    {
        context = (typeof context === 'string') ? document.querySelector(context) : context;

        return (context && context.sdom) ? context.get() : (context || document);
    },
    _inject: function(html, fn)
    {
        var len = this.nodes.length;
        var nodes = [];
        while (len--)
        {
            var res = (typeof html === 'function') ? html.call(this, this.nodes[len]) : html;
            var el = (len === 0) ? res : this._clone(res);
            var node = fn.call(this, el, this.nodes[len]);

            if (node)
            {
                if (node.sdom) nodes.push(node.get());
                else nodes.push(node);
            }
        }

        return new Dom(nodes);
    },
    _cloneEvents: function(node, copy)
    {
        var events = node._e;
        if (events)
        {
            copy._e = events;
            for (var name in events._events)
            {
                for (var i = 0; i < events._events[name].length; i++)
                {
                    copy.addEventListener(name, events._events[name][i]);
                }
            }
        }

        return copy;
    },
    _clone: function(node)
    {
        if (typeof node === 'undefined') return;
        if (typeof node === 'string') return node;
        else if (node instanceof Node || node.nodeType) return node.cloneNode(true);
        else if ('length' in node)
        {
            return [].map.call(this._toArray(node), function(el) { return el.cloneNode(true); });
        }
    },
    _slice: function(obj)
    {
        return (!obj || obj.length === 0) ? [] : (obj.length) ? [].slice.call(obj.nodes || obj) : [obj];
    },
    _eachClass: function(value, type)
    {
        return this.each(function(node)
        {
            if (value)
            {
                var setClass = function(name) { if (node.classList) node.classList[type](name); };
                value.split(' ').forEach(setClass);
            }
        });
    },
    _triggerEvent: function(name)
    {
        var node = this.get();
        if (node && node.nodeType !== 3) node[name]();
        return this;
    },
    _getOneHandler: function(handler, events)
    {
        var self = this;
        return function()
        {
            handler.apply(this, arguments);
            self.off(events);
        };
    },
    _getEventNamespace: function(event)
    {
        var arr = event.split('.');
        var namespace = (arr[1]) ? arr[1] : '_events';
        return (arr[2]) ? namespace + arr[2] : namespace;
    },
    _getEventName: function(event)
    {
        return event.split('.')[0];
    },
    _offEvent: function(node, event, namespace, handler, condition)
    {
        for (var key in node._e)
        {
            for (var name in node._e[key])
            {
                if (condition(name, key, event, namespace))
                {
                    var handlers = node._e[key][name];
                    for (var i = 0; i < handlers.length; i++)
                    {
                        if (typeof handler !== 'undefined' && handlers[i].toString() !== handler.toString())
                        {
                            continue;
                        }

                        node.removeEventListener(name, handlers[i]);
                        node._e[key][name].splice(i, 1);

                        if (node._e[key][name].length === 0) delete node._e[key][name];
                        if (Object.keys(node._e[key]).length === 0) delete node._e[key];
                    }
                }
            }
        }
    },
    _getInnerOrOuter: function(method, type)
    {
        return this[method](undefined, type);
    },
    _getDocSize: function(node, type)
    {
        var body = node.body, html = node.documentElement;
        return Math.max(body['scroll' + type], body['offset' + type], html['client' + type], html['scroll' + type], html['offset' + type]);
    },
    _getSize: function(type, captype, value, adjust)
    {
        if (value === undefined)
        {
            var el = this.get();
            if (el.nodeType === 3)      value = 0;
            else if (el.nodeType === 9) value = this._getDocSize(el, captype);
            else if (el === window)     value = window['inner' + captype];
            else                        value = this._getHeightOrWidth(type, el, adjust || 'normal');

            return Math.round(value);
        }

        return this.each(function(node)
        {
            value = parseFloat(value);
            value = value + this._adjustResultHeightOrWidth(type, node, adjust || 'normal');

            new Dom(node).css(type, value + 'px');

        }.bind(this));
    },
    _getHeightOrWidth: function(type, el, adjust)
    {
        if (!el) return 0;

        var name = type.charAt(0).toUpperCase() + type.slice(1);
        var result = 0;
        var style = getComputedStyle(el, null);
        var $el = new Dom(el);
        var $targets = $el.parents().filter(function(node)
        {
            return (node.nodeType === 1 && getComputedStyle(node, null).display === 'none') ? node : false;
        });

        if (style.display === 'none') $targets.add(el);
        if ($targets.length !== 0)
        {
            var fixStyle = 'visibility: hidden !important; display: block !important;';
            var tmp = [];

            $targets.each(function(node)
            {
                var $node = new Dom(node);
                var thisStyle = $node.attr('style');
                if (thisStyle !== null) tmp.push(thisStyle);
                $node.attr('style', (thisStyle !== null) ? thisStyle + ';' + fixStyle : fixStyle);
            });

            result = $el.get()['offset' + name] - this._adjustResultHeightOrWidth(type, el, adjust);

            $targets.each(function(node, i)
            {
                var $node = new Dom(node);
                if (tmp[i] === undefined) $node.removeAttr('style');
                else $node.attr('style', tmp[i]);
            });
        }
        else
        {
            result = el['offset' + name] - this._adjustResultHeightOrWidth(type, el, adjust);
        }

        return result;
    },
    _adjustResultHeightOrWidth: function(type, el, adjust)
    {
        if (!el || adjust === false) return 0;

        var fix = 0;
        var style = getComputedStyle(el, null);
        var isBorderBox = (style.boxSizing === "border-box");

        if (type === 'height')
        {
            if (adjust === 'inner' || (adjust === 'normal' && isBorderBox))
            {
                fix += (parseFloat(style.borderTopWidth) || 0) + (parseFloat(style.borderBottomWidth) || 0);
            }

            if (adjust === 'outer') fix -= (parseFloat(style.marginTop) || 0) + (parseFloat(style.marginBottom) || 0);
        }
        else
        {
            if (adjust === 'inner' || (adjust === 'normal' && isBorderBox))
            {
                fix += (parseFloat(style.borderLeftWidth) || 0) + (parseFloat(style.borderRightWidth) || 0);
            }

            if (adjust === 'outer') fix -= (parseFloat(style.marginLeft) || 0) + (parseFloat(style.marginRight) || 0);
        }

        return fix;
    },
    _getDim: function(type)
    {
        var node = this.get();
        return (node.nodeType === 3) ? { top: 0, left: 0 } : this['_get' + type](node);
    },
    _getPosition: function(node)
    {
        return { top: node.offsetTop, left: node.offsetLeft };
    },
    _getOffset: function(node)
    {
        var rect = node.getBoundingClientRect();
        var doc = node.ownerDocument;
		var docElem = doc.documentElement;
		var win = doc.defaultView;

		return {
			top: rect.top + win.pageYOffset - docElem.clientTop,
			left: rect.left + win.pageXOffset - docElem.clientLeft
		};
    },
    _getSibling: function(selector, method)
    {
        selector = (selector && selector.sdom) ? selector.get() : selector;

        var isNode = (selector && selector.nodeType);
        var sibling;

        this.each(function(node)
        {
            while (node = node[method])
            {
                if ((isNode && node === selector) || new Dom(node).is(selector))
                {
                    sibling = node;
                    return;
                }
            }
        });

        return new Dom(sibling);
    },
    _toArray: function(obj)
    {
        if (obj instanceof NodeList)
        {
            var arr = [];
            for (var i = 0; i < obj.length; i++)
            {
                arr[i] = obj[i];
            }

            return arr;
        }
        else if (obj === undefined) return [];
        else
        {
            return (obj.sdom) ? obj.nodes : obj;
        }
    },
    _toParams: function(obj)
    {
        var params = '';
        for (var key in obj)
        {
            params += '&' + this._encodeUri(key) + '=' + this._encodeUri(obj[key]);
        }

        return params.replace(/^&/, '');
    },
    _toObject: function(str)
    {
        return (new Function("return " + str))();
    },
    _encodeUri: function(str)
    {
        return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
    },
    _isNumber: function(str)
    {
        return !isNaN(str) && !isNaN(parseFloat(str));
    },
    _isObjectString: function(str)
    {
        return (str.search(/^{/) !== -1);
    },
    _getBooleanFromStr: function(str)
    {
        if (str === 'true') return true;
        else if (str === 'false') return false;

        return str;
    },
    _hasDisplayNone: function(el)
    {
        return (el.style.display === 'none') || ((el.currentStyle) ? el.currentStyle.display : getComputedStyle(el, null).display) === 'none';
    }
};
// Unique ID
var uuid = 0;

// Wrapper
var $R = function(selector, options)
{
    return RedactorApp(selector, options, [].slice.call(arguments, 2));
};

// Globals
$R.app = [];
$R.version = '3.3.2';
$R.options = {};
$R.modules = {};
$R.services = {};
$R.classes = {};
$R.plugins = {};
$R.mixins = {};
$R.modals = {};
$R.lang = {};
$R.dom = function(selector, context) { return new Dom(selector, context); };
$R.ajax = Ajax;
$R.Dom = Dom;
$R.keycodes = {
	BACKSPACE: 8,
	DELETE: 46,
	UP: 38,
	DOWN: 40,
	ENTER: 13,
	SPACE: 32,
	ESC: 27,
	TAB: 9,
	CTRL: 17,
	META: 91,
	SHIFT: 16,
	ALT: 18,
	RIGHT: 39,
	LEFT: 37
};
$R.env = {
    'plugin': 'plugins',
    'module': 'modules',
    'service': 'services',
    'class': 'classes',
    'mixin': 'mixins'
};

// jQuery Wrapper
/*eslint-env jquery*/
if (typeof jQuery !== 'undefined')
{
    (function($) { $.fn.redactor = function(options) { return RedactorApp(this.toArray(), options, [].slice.call(arguments, 1)); }; })(jQuery);
}

// Class
var RedactorApp = function(selector, options, args)
{
    var namespace = 'redactor';
    var nodes = (Array.isArray(selector)) ? selector : (selector && selector.nodeType) ? [selector] : document.querySelectorAll(selector);
    var isApi = (typeof options === 'string' || typeof options === 'function');
    var value = [];
    var instance;

    for (var i = 0; i < nodes.length; i++)
    {
        var el = nodes[i];
        var $el = $R.dom(el);

        instance = $el.dataget(namespace);
        if (!instance && !isApi)
        {
            // Initialization
            instance = new App(el, options, uuid);
            $el.dataset(namespace, instance);
            $R.app[uuid] = instance;
            uuid++;
        }

        // API
        if (instance && isApi)
        {
            var isDestroy = (options === 'destroy');
            options = (isDestroy) ? 'stop' : options;

            var methodValue;
            if (typeof options === 'function')
            {
                methodValue = options.apply(instance, args);
            }
            else
            {
                args.unshift(options);
                methodValue = instance.api.apply(instance, args);
            }
            if (methodValue !== undefined) value.push(methodValue);

            if (isDestroy) $el.dataset(namespace, false);
        }
    }

    return (value.length === 0 || value.length === 1) ? ((value.length === 0) ? instance : value[0]) : value;
};

// add
$R.add = function(type, name, obj)
{
    if (typeof $R.env[type] === 'undefined') return;

    // translations
    if (obj.translations)
    {
        $R.lang = $R.extend(true, {}, $R.lang, obj.translations);
    }

    // modals
    if (obj.modals)
    {
        $R.modals = $R.extend(true, {}, $R.modals, obj.modals);
    }

    // mixin
    if (type === 'mixin')
    {
        $R[$R.env[type]][name] = obj;
    }
    else
    {
        // prototype
        var F = function() {};
        F.prototype = obj;

        // mixins
        if (obj.mixins)
        {
            for (var i = 0; i < obj.mixins.length; i++)
            {
                $R.inherit(F, $R.mixins[obj.mixins[i]]);
            }
        }

        $R[$R.env[type]][name] = F;
    }
};

// add lang
$R.addLang = function(lang, obj)
{
    if (typeof $R.lang[lang] === 'undefined')
    {
        $R.lang[lang] = {};
    }

    $R.lang[lang] = $R.extend($R.lang[lang], obj);
};

// create
$R.create = function(name)
{
    var arr = name.split('.');
    var args = [].slice.call(arguments, 1);

    var type = 'classes';
    if (typeof $R.env[arr[0]] !== 'undefined')
    {
        type = $R.env[arr[0]];
        name = arr.slice(1).join('.');
    }

    // construct
    var instance = new $R[type][name]();

    // init
    if (instance.init)
    {
        var res = instance.init.apply(instance, args);

        return (res) ? res : instance;
    }

    return instance;
};

// inherit
$R.inherit = function(current, parent)
{
    var F = function () {};
    F.prototype = parent;
    var f = new F();

    for (var prop in current.prototype)
    {
        if (current.prototype.__lookupGetter__(prop)) f.__defineGetter__(prop, current.prototype.__lookupGetter__(prop));
        else f[prop] = current.prototype[prop];
    }

    current.prototype = f;
    current.prototype.super = parent;

    return current;
};

// error
$R.error = function(exception)
{
    throw exception;
};

// extend
$R.extend = function()
{
    var extended = {};
    var deep = false;
    var i = 0;
    var length = arguments.length;

    if (Object.prototype.toString.call( arguments[0] ) === '[object Boolean]')
    {
        deep = arguments[0];
        i++;
    }

    var merge = function(obj)
    {
        for (var prop in obj)
        {
            if (Object.prototype.hasOwnProperty.call(obj, prop))
            {
                if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') extended[prop] = $R.extend(true, extended[prop], obj[prop]);
                else extended[prop] = obj[prop];
            }
        }
    };

    for (; i < length; i++ )
    {
        var obj = arguments[i];
        merge(obj);
    }

    return extended;
};
$R.opts = {
    animation: true,
    lang: 'en',
    direction: 'ltr',
    spellcheck: true,
    structure: false,
    scrollTarget: false,
    styles: true,
    stylesClass: 'redactor-styles',
    placeholder: false,

    source: true,
    showSource: false,

    inline: false,

    breakline: false,
    markup: 'p',
    enterKey: true,

    clickToEdit: false,
    clickToSave: false,
    clickToCancel: false,

    focus: false,
    focusEnd: false,

    minHeight: false, // string, '100px'
    maxHeight: false, // string, '100px'
    maxWidth: false, // string, '700px'

    plugins: [], // array
    callbacks: {},

    // pre & tab
    preClass: false, // string
    preSpaces: 4, // or false
    tabindex: false, // int
    tabAsSpaces: false, // true or number of spaces
    tabKey: true,

    // autosave
    autosave: false, // false or url
    autosaveName: false,
    autosaveData: false,

    // toolbar
    toolbar: true,
    toolbarFixed: true,
    toolbarFixedTarget: document,
    toolbarFixedTopOffset: 0, // pixels
    toolbarExternal: false, // ID selector
    toolbarContext: true,

    // air
    air: false,

    // formatting
    formatting: ['p', 'blockquote', 'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
    formattingAdd: false,
    formattingHide: false,

    // buttons
    buttons: ['html', 'format', 'bold', 'italic', 'deleted', 'lists', 'image', 'file', 'link'],
    // + 'line', 'redo', 'undo', 'underline', 'ol', 'ul', 'indent', 'outdent'
    buttonsTextLabeled: false,
    buttonsAdd: [],
    buttonsAddFirst: [],
    buttonsAddAfter: false,
    buttonsAddBefore: false,
    buttonsHide: [],
    buttonsHideOnMobile: [],

    // image
    imageUpload: false,
    imageUploadParam: 'file',
    imageData: false,
    imageEditable: true,
    imageCaption: true,
    imageLink: true,
    imagePosition: false,
    imageResizable: false,
    imageFloatMargin: '10px',
    imageFigure: true,
    imageObserve: true,

    // file
    fileUpload: false,
    fileUploadParam: 'file',
    fileData: false,
    fileAttachment: false,

    // upload opts
    uploadData: false,
    dragUpload: true,
    multipleUpload: true,
    clipboardUpload: true,
    uploadBase64: false,

    // link
    linkTarget: false,
    linkTitle: false,
    linkNewTab: false,
    linkNofollow: false,
    linkSize: 30,
    linkValidation: true,

    // clean
    cleanOnEnter: true,
    cleanInlineOnEnter: false,
    paragraphize: true,
    removeScript: true,
    removeNewLines: false,
    removeComments: true,
    replaceTags: {
        'b': 'strong',
        'i': 'em',
        'strike': 'del'
    },

    // paste
    pastePlainText: false,
    pasteLinkTarget: false,
    pasteImages: true,
    pasteLinks: true,
    pasteClean: true,
    pasteKeepStyle: [],
    pasteKeepClass: [],
    pasteKeepAttrs: ['td', 'th'],
    pasteBlockTags: ['pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'table', 'tbody', 'thead', 'tfoot', 'th', 'tr', 'td', 'ul', 'ol', 'li', 'blockquote', 'p', 'figure', 'figcaption'],
    pasteInlineTags: ['a', 'img', 'br', 'strong', 'ins', 'code', 'del', 'span', 'samp', 'kbd', 'sup', 'sub', 'mark', 'var', 'cite', 'small', 'b', 'u', 'em', 'i', 'abbr'],

    // active buttons
    activeButtons: {
        b: 'bold',
        strong: 'bold',
        i: 'italic',
        em: 'italic',
        del: 'deleted',
        strike: 'deleted',
        u: 'underline'
    },
    activeButtonsAdd: {},
    activeButtonsObservers: {},

    // autoparser
    autoparse: true,
    autoparseStart: true,
    autoparsePaste: true,
    autoparseLinks: true,
    autoparseImages: true,
    autoparseVideo: true,

    // shortcodes
    shortcodes: {
        'p.': { format: 'p' },
        'quote.': { format: 'blockquote' },
        'pre.': { format: 'pre' },
        'h1.': { format: 'h1' },
        'h2.': { format: 'h2' },
        'h3.': { format: 'h3' },
        'h4.': { format: 'h4' },
        'h5.': { format: 'h5' },
        'h6.': { format: 'h6' },
        //'1.': { format: 'ol' },
        '*.': { format: 'ul' }
    },
    shortcodesAdd: false, // object

    // shortcuts
    shortcuts: {
        'ctrl+shift+m, meta+shift+m': { api: 'module.inline.clearformat' },
        'ctrl+b, meta+b': { api: 'module.inline.format', args: 'b' },
        'ctrl+i, meta+i': { api: 'module.inline.format', args: 'i' },
        'ctrl+u, meta+u': { api: 'module.inline.format', args: 'u' },
        'ctrl+h, meta+h': { api: 'module.inline.format', args: 'sup' },
        'ctrl+l, meta+l': { api: 'module.inline.format', args: 'sub' },
        'ctrl+k, meta+k': { api: 'module.link.open' },
        'ctrl+alt+0, meta+alt+0': { api: 'module.block.format', args: 'p' },
        'ctrl+alt+1, meta+alt+1': { api: 'module.block.format', args: 'h1' },
        'ctrl+alt+2, meta+alt+2': { api: 'module.block.format', args: 'h2' },
        'ctrl+alt+3, meta+alt+3': { api: 'module.block.format', args: 'h3' },
        'ctrl+alt+4, meta+alt+4': { api: 'module.block.format', args: 'h4' },
        'ctrl+alt+5, meta+alt+5': { api: 'module.block.format', args: 'h5' },
        'ctrl+alt+6, meta+alt+6': { api: 'module.block.format', args: 'h6' },
        'ctrl+shift+7, meta+shift+7': { api: 'module.list.toggle', args: 'ol' },
        'ctrl+shift+8, meta+shift+8': { api: 'module.list.toggle', args: 'ul' }
    },
    shortcutsAdd: false, // object

    // misc
    grammarly: true,
    notranslate: false,

    // private
    bufferLimit: 100,
    emptyHtml: '<p></p>',
    markerChar: '\ufeff',
    imageTypes: ['image/png', 'image/jpeg', 'image/gif'],
    imageAttrs: ['alt', 'title', 'src', 'class', 'width', 'height', 'srcset'],
    inlineTags: ['a', 'span', 'strong', 'strike', 'b', 'u', 'em', 'i', 'code', 'del', 'ins', 'samp', 'kbd', 'sup', 'sub', 'mark', 'var', 'cite', 'small', 'abbr'],
    blockTags: ['pre', 'ul', 'ol', 'li', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',  'dl', 'dt', 'dd', 'div', 'table', 'tbody', 'thead', 'tfoot', 'tr', 'th', 'td', 'blockquote', 'output', 'figcaption', 'figure', 'address', 'section', 'header', 'footer', 'aside', 'article', 'iframe'],
    regex: {
        youtube: /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube\.com\S*[^\w\-\s])([\w\-]{11})(?=[^\w\-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/gi,
        vimeo: /(http|https)?:\/\/(?:www.|player.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?/gi,
        imageurl: /((https?|www)[^\s]+\.)(jpe?g|png|gif)(\?[^\s-]+)?/gi,
        url: /(https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})/gi
    },
    input: true,
    zindex: false,
    modes: {
        "inline": {
            pastePlainText: true,
            pasteImages: false,
            enterKey: false,
            toolbar: false,
            autoparse: false,
            source: false,
            showSource: false,
            styles: false,
            air: false
        },
        "original": {
            styles: false
        }
    }
};
$R.lang['en'] = {
    "format": "Format",
    "image": "Image",
    "file": "File",
    "link": "Link",
    "bold": "Bold",
    "italic": "Italic",
    "deleted": "Strikethrough",
    "underline": "Underline",
    "superscript": "Superscript",
    "subscript": "Subscript",
    "bold-abbr": "B",
    "italic-abbr": "I",
    "deleted-abbr": "S",
    "underline-abbr": "U",
    "superscript-abbr": "Sup",
    "subscript-abbr": "Sub",
    "lists": "Lists",
    "link-insert": "Insert Link",
    "link-edit": "Edit Link",
    "link-in-new-tab": "Open link in new tab",
    "unlink": "Unlink",
    "cancel": "Cancel",
    "close": "Close",
    "insert": "Insert",
    "save": "Save",
    "delete": "Delete",
    "text": "Text",
    "edit": "Edit",
    "title": "Alt",
    "paragraph": "Normal text",
    "quote": "Quote",
    "code": "Code",
    "heading1": "Heading 1",
    "heading2": "Heading 2",
    "heading3": "Heading 3",
    "heading4": "Heading 4",
    "heading5": "Heading 5",
    "heading6": "Heading 6",
    "filename": "Name",
    "optional": "optional",
    "unorderedlist": "Unordered List",
    "orderedlist": "Ordered List",
    "outdent": "Outdent",
    "indent": "Indent",
    "horizontalrule": "Line",
    "upload": "Upload",
    "upload-label": "Drop files here or click to upload",
    "accessibility-help-label": "Rich text editor",
    "caption": "Caption",
    "bulletslist": "Bullets",
    "numberslist": "Numbers",
    "image-position": "Position",
    "none": "None",
    "left": "Left",
    "right": "Right",
    "center": "Center",
    "undo": "Undo",
    "redo": "Redo"
};
$R.buttons = {
    html: {
        title: 'HTML',
        icon: true,
        api: 'module.source.toggle'
    },
    undo: {
        title: '## undo ##',
        icon: true,
        api: 'module.buffer.undo'
    },
    redo: {
        title: '## redo ##',
        icon: true,
        api: 'module.buffer.redo'
    },
    format: {
        title: '## format ##',
        icon: true,
        dropdown: {
            p: {
                title: '## paragraph ##',
                api: 'module.block.format',
                args: {
                    tag: 'p'
                }
            },
            blockquote: {
                title: '## quote ##',
                api: 'module.block.format',
                args: {
                    tag: 'blockquote'
                }
            },
            pre: {
                title: '## code ##',
                api: 'module.block.format',
                args: {
                    tag: 'pre'
                }
            },
            h1: {
                title: '## heading1 ##',
                api: 'module.block.format',
                args: {
                    tag: 'h1'
                }
            },
            h2: {
                title: '## heading2 ##',
                api: 'module.block.format',
                args: {
                    tag: 'h2'
                }
            },
            h3: {
                title: '## heading3 ##',
                api: 'module.block.format',
                args: {
                    tag: 'h3'
                }
            },
            h4: {
                title: '## heading4 ##',
                api: 'module.block.format',
                args: {
                    tag: 'h4'
                }
            },
            h5: {
                title: '## heading5 ##',
                api: 'module.block.format',
                args: {
                    tag: 'h5'
                }
            },
            h6: {
                title: '## heading6 ##',
                api: 'module.block.format',
                args: {
                    tag: 'h6'
                }
            }
        }
    },
    bold: {
        title: '## bold-abbr ##',
        icon: true,
        tooltip: '## bold ##',
        api: 'module.inline.format',
        args: {
            tag: 'b'
        }
    },
    italic: {
        title: '## italic-abbr ##',
        icon: true,
        tooltip: '## italic ##',
        api: 'module.inline.format',
        args: {
            tag: 'i'
        }
    },
    deleted: {
        title: '## deleted-abbr ##',
        icon: true,
        tooltip: '## deleted ##',
        api: 'module.inline.format',
        args: {
            tag: 'del'
        }
    },
    underline: {
        title: '## underline-abbr ##',
        icon: true,
        tooltip: '## underline ##',
        api: 'module.inline.format',
        args: {
            tag: 'u'
        }
    },
    sup: {
        title: '## superscript-abbr ##',
        icon: true,
        tooltip: '## superscript ##',
        api: 'module.inline.format',
        args: {
            tag: 'sup'
        }
    },
    sub: {
        title: '## subscript-abbr ##',
        icon: true,
        tooltip: '## subscript ##',
        api: 'module.inline.format',
        args: {
            tag: 'sub'
        }
    },
    lists: {
        title: '## lists ##',
        icon: true,
        observe: 'list',
        dropdown: {
            observe: 'list',
            unorderedlist: {
                title: '&bull; ## unorderedlist ##',
                api: 'module.list.toggle',
                args: 'ul'
            },
            orderedlist: {
                title: '1. ## orderedlist ##',
                api: 'module.list.toggle',
                args: 'ol'
            },
            outdent: {
                title: '< ## outdent ##',
                api: 'module.list.outdent'
            },
            indent: {
                title: '> ## indent ##',
                api: 'module.list.indent'
            }
        }
    },
    ul: {
        title: '&bull; ## bulletslist ##',
        icon: true,
        api: 'module.list.toggle',
        observe: 'list',
        args: 'ul'
    },
    ol: {
        title: '1. ## numberslist ##',
        icon: true,
        api: 'module.list.toggle',
        observe: 'list',
        args: 'ol'
    },
    outdent: {
        title: '## outdent ##',
        icon: true,
        api: 'module.list.outdent',
        observe: 'list'
    },
    indent: {
        title: '## indent ##',
        icon: true,
        api: 'module.list.indent',
        observe: 'list'
    },
    image: {
        title: '## image ##',
        icon: true,
        api: 'module.image.open'
    },
    file: {
        title: '## file ##',
        icon: true,
        api: 'module.file.open'
    },
    link: {
        title: '## link ##',
        icon: true,
        observe: 'link',
        dropdown: {
            observe: 'link',
            link: {
                title: '## link-insert ##',
                api: 'module.link.open'
            },
            unlink: {
                title: '## unlink ##',
                api: 'module.link.unlink'
            }
        }
    },
    line: {
        title: '## horizontalrule ##',
        icon: true,
        api: 'module.line.insert'
    }
};
var App = function(element, options, uuid)
{
    this.module = {};
    this.plugin = {};
    this.instances = {};

    // start/stop
    this.started = false;
    this.stopped = false;

    // environment
    this.uuid = uuid;
    this.rootElement = element;
    this.rootOpts = options;
    this.dragInside = false;
    this.dragComponentInside = false;
    this.keycodes = $R.keycodes;
    this.namespace = 'redactor';
    this.$win = $R.dom(window);
    this.$doc = $R.dom(document);
    this.$body = $R.dom('body');
    this.editorReadOnly = false;

    // core services
    this.opts = $R.create('service.options', options, element);
    this.lang = $R.create('service.lang', this);

    // build
    this.buildServices();
    this.buildModules();
    this.buildPlugins();

    // start
    this.start();
};

App.prototype = {
    start: function()
    {
        // start
        this.stopped = false;
        this.broadcast('start');
        this.broadcast('startcode');

        if (this.opts.clickToEdit)
        {
            this.broadcast('startclicktoedit');
        }
        else
        {
            this.broadcast('enable');
            if (this.opts.showSource) this.broadcast('startcodeshow');
            this.broadcast('enablefocus');
        }

        // started
        this.broadcast('started');
        this.started = true;
    },
    stop: function()
    {
        this.started = false;
        this.stopped = true;

        this.broadcast('stop');
        this.broadcast('disable');
        this.broadcast('stopped');
    },

    // started & stopped
    isStarted: function()
    {
        return this.started;
    },
    isStopped: function()
    {
        return this.stopped;
    },

    // build
    buildServices: function()
    {
        var core = ['options', 'lang'];
        var bindable = ['uuid', 'keycodes', 'opts', 'lang', '$win', '$doc', '$body'];
        var services = [];
        for (var name in $R.services)
        {
            if (core.indexOf(name) === -1)
            {
                this[name] = $R.create('service.' + name, this);
                services.push(name);
                bindable.push(name);
            }
        }

        // binding
        for (var i = 0; i < services.length; i++)
        {
            var service = services[i];
            for (var z = 0; z < bindable.length; z++)
            {
                var inj = bindable[z];
                if (service !== inj)
                {
                    this[service][inj] = this[inj];
                }
            }
        }
    },
    buildModules: function()
    {
        for (var name in $R.modules)
        {
            this.module[name] = $R.create('module.' + name, this);
            this.instances[name] = this.module[name];
        }
    },
    buildPlugins: function()
    {
        var plugins = this.opts.plugins;
        for (var i = 0; i < plugins.length; i++)
        {
            var name = plugins[i];
            if (typeof $R.plugins[name] !== 'undefined')
            {
                this.plugin[name] = $R.create('plugin.' + name, this);
                this.instances[name] = this.plugin[name];
            }
        }
    },

    // draginside
    isDragInside: function()
    {
        return this.dragInside;
    },
    setDragInside: function(dragInside)
    {
        this.dragInside = dragInside;
    },
    isDragComponentInside: function()
    {
        return this.dragComponentInside;
    },
    setDragComponentInside: function(dragInside)
    {
        this.dragComponentInside = dragInside;
    },
    getDragComponentInside: function()
    {
        return this.dragComponentInside;
    },

    // readonly
    isReadOnly: function()
    {
        return this.editorReadOnly;
    },
    enableReadOnly: function()
    {
        this.editorReadOnly = true;
        this.broadcast('enablereadonly');
        this.component.clearActive();
        this.toolbar.disableButtons();
    },
    disableReadOnly: function()
    {
        this.editorReadOnly = false;
        this.broadcast('disablereadonly');
        this.toolbar.enableButtons();
    },

    // messaging
    callMessageHandler: function(instance, name, args)
    {
        var arr = name.split('.');
        if (arr.length === 1)
        {
            if (typeof instance['on' + name] === 'function')
            {
                instance['on' + name].apply(instance, args);
            }
        }
        else
        {
            arr[0] = 'on' + arr[0];

            var func = this.utils.checkProperty(instance, arr);
            if (typeof func === 'function')
            {
                func.apply(instance, args);
            }
        }
    },
    broadcast: function(name)
    {
        var args = [].slice.call(arguments, 1);
        for (var moduleName in this.instances)
        {
            this.callMessageHandler(this.instances[moduleName], name, args);
        }

        // callback
        return this.callback.trigger(name, args);
    },

    // callback
    on: function(name, func)
    {
        this.callback.add(name, func);
    },
    off: function(name, func)
    {
        this.callback.remove(name, func);
    },

    // api
    api: function(name)
    {
        if (!this.isStarted() && name !== 'start') return;
        if (this.isReadOnly() && name !== 'disableReadOnly') return;

        this.broadcast('state');

        var args = [].slice.call(arguments, 1);
        var arr = name.split('.');

        var isApp = (arr.length === 1);
        var isCallback = (arr[0] === 'on' || arr[0] === 'off');
        var isService = (!isCallback && arr.length === 2);
        var isPlugin = (arr[0] === 'plugin');
        var isModule = (arr[0] === 'module');

        // app
        if (isApp)
        {
            if (typeof this[arr[0]] === 'function')
            {
                return this.callInstanceMethod(this, arr[0], args);
            }
        }
        // callback
        else if (isCallback)
        {
            return (arr[0] === 'on') ? this.on(arr[1], args[0]) : this.off(arr[1], args[0] || undefined);
        }
        // service
        else if (isService)
        {
            if (this.isInstanceExists(this, arr[0]))
            {
                return this.callInstanceMethod(this[arr[0]], arr[1], args);
            }
            else
            {
                $R.error(new Error('Service "' + arr[0] + '" not found'));
            }
        }
        // plugin
        else if (isPlugin)
        {
            if (this.isInstanceExists(this.plugin, arr[1]))
            {
                return this.callInstanceMethod(this.plugin[arr[1]], arr[2], args);
            }
            else
            {
                $R.error(new Error('Plugin "' + arr[1] + '" not found'));
            }
        }
        // module
        else if (isModule)
        {
            if (this.isInstanceExists(this.module, arr[1]))
            {
                return this.callInstanceMethod(this.module[arr[1]], arr[2], args);
            }
            else
            {
                $R.error(new Error('Module "' + arr[1] + '" not found'));
            }
        }

    },
    isInstanceExists: function(obj, name)
    {
        return (typeof obj[name] !== 'undefined');
    },
    callInstanceMethod: function(instance, method, args)
    {
        if (typeof instance[method] === 'function')
        {
            return instance[method].apply(instance, args);
        }
    }
};
$R.add('mixin', 'formatter', {

    // public
    buildArgs: function(args)
    {
        this.args = {
            'class': args['class'] || false,
            'style': args['style'] || false,
            'attr': args['attr'] || false
        };

        if (!this.args['class'] && !this.args['style'] && !this.args['attr'])
        {
            this.args = false;
        }
    },
    applyArgs: function(nodes, selection)
    {
        if (this.args)
        {
            nodes = this[this.type](this.args, false, nodes, selection);
        }
        else
        {
            nodes = this._clearAll(nodes, selection);
        }

        return nodes;
    },
    clearClass: function(tags, nodes)
    {
        this.selection.save();

        var $elements = (nodes) ? $R.dom(nodes) : this.getElements(tags, true);
        $elements.removeAttr('class');

        nodes = this._unwrapSpanWithoutAttr($elements.getAll());

        this.selection.restore();

        return nodes;
    },
    clearStyle: function(tags, nodes)
    {
        this.selection.save();

        var $elements = (nodes) ? $R.dom(nodes) : this.getElements(tags, true);
        $elements.removeAttr('style');

        nodes = this._unwrapSpanWithoutAttr($elements.getAll());

        this.selection.restore();

        return nodes;
    },
    clearAttr: function(tags, nodes)
    {
        this.selection.save();

        var $elements = (nodes) ? $R.dom(nodes) : this.getElements(tags, true);
        this._removeAllAttr($elements);

        nodes = this._unwrapSpanWithoutAttr($elements.getAll());

        this.selection.restore();

        return nodes;
    },
    set: function(args, tags, nodes, selection)
    {
        if (selection !== false) this.selection.save();

        var $elements = (nodes) ? $R.dom(nodes) : this.getElements(tags);

        if (args['class'])
        {
            $elements.removeAttr('class');
            $elements.addClass(args['class']);
        }

        if (args['style'])
        {
            $elements.removeAttr('style');
            $elements.css(args['style']);
            $elements.each(function(node)
            {
                var $node = $R.dom(node);
                $node.attr('data-redactor-style-cache', $node.attr('style'));
            });
        }

        if (args['attr'])
        {
            this._removeAllAttr($elements);
            $elements.attr(args['attr']);
        }

        if (selection !== false) this.selection.restore();

        return $elements.getAll();
    },
    toggle: function(args, tags, nodes, selection)
    {
        if (selection !== false) this.selection.save();

        var $elements = (nodes) ? $R.dom(nodes) : this.getElements(tags);

        if (args['class'])
        {
            $elements.toggleClass(args['class']);
            $elements.each(function(node)
            {
                if (node.className === '') node.removeAttribute('class');
            });
        }

        var params;
        if (args['style'])
        {
            params = args['style'];
            $elements.each(function(node)
            {
                var $node = $R.dom(node);
                for (var key in params)
                {
                    var newVal = params[key];
                    var oldVal = $node.css(key);

                    oldVal = (this.utils.isRgb(oldVal)) ? this.utils.rgb2hex(oldVal) : oldVal.replace(/"/g, '');
                    newVal = (this.utils.isRgb(newVal)) ? this.utils.rgb2hex(newVal) : newVal.replace(/"/g, '');

                    oldVal = this.utils.hex2long(oldVal);
                    newVal = this.utils.hex2long(newVal);

                    var compareNew = (typeof newVal === 'string') ? newVal.toLowerCase() : newVal;
                    var compareOld = (typeof oldVal === 'string') ? oldVal.toLowerCase() : oldVal;

                    if (compareNew === compareOld) $node.css(key, '');
                    else $node.css(key, newVal);
                }

                this._convertStyleQuotes($node);
                if (this.utils.removeEmptyAttr(node, 'style'))
                {
                    $node.removeAttr('data-redactor-style-cache');
                }
                else
                {
                    $node.attr('data-redactor-style-cache', $node.attr('style'));
                }

            }.bind(this));
        }

        if (args['attr'])
        {
            params = args['attr'];
            $elements.each(function(node)
            {
                var $node = $R.dom(node);
                for (var key in params)
                {
                    if ($node.attr(key)) $node.removeAttr(key);
                    else $node.attr(key, params[key]);
                }
            });

        }

        if (selection !== false) this.selection.restore();

        return $elements.getAll();
    },
    add: function(args, tags, nodes, selection)
    {
        if (selection !== false) this.selection.save();

        var $elements = (nodes) ? $R.dom(nodes) : this.getElements(tags);

        if (args['class'])
        {
            $elements.addClass(args['class']);
        }

        if (args['style'])
        {
            var params = args['style'];
            $elements.each(function(node)
            {
                var $node = $R.dom(node);
                $node.css(params);
                $node.attr('data-redactor-style-cache', $node.attr('style'));

                this._convertStyleQuotes($node);

            }.bind(this));
        }

        if (args['attr'])
        {
            $elements.attr(args['attr']);
        }

        if (selection !== false) this.selection.restore();

        return $elements.getAll();
    },
    remove: function(args, tags, nodes, selection)
    {
        if (selection !== false) this.selection.save();

        var $elements = (nodes) ? $R.dom(nodes) : this.getElements(tags);

        if (args['class'])
        {
            $elements.removeClass(args['class']);
            $elements.each(function(node)
            {
                if (node.className === '') node.removeAttribute('class');
            });
        }

        if (args['style'])
        {
            var name = args['style'];
            $elements.each(function(node)
            {
                var $node = $R.dom(node);
                $node.css(name, '');

                if (this.utils.removeEmptyAttr(node, 'style'))
                {
                    $node.removeAttr('data-redactor-style-cache');
                }
                else
                {
                    $node.attr('data-redactor-style-cache', $node.attr('style'));
                }

            }.bind(this));
        }

        if (args['attr'])
        {
            $elements.removeAttr(args['attr']);
        }

        nodes = this._unwrapSpanWithoutAttr($elements.getAll());

        if (selection !== false) this.selection.restore();

        return nodes;
    },

    // private
    _removeAllAttr: function($elements)
    {
        $elements.each(function(node)
        {
            for (var i = node.attributes.length; i-->0;)
            {
                var nodeAttr = node.attributes[i];
                var name = nodeAttr.name;
                if (name !== 'style' && name !== 'class')
                {
                    node.removeAttributeNode(nodeAttr);
                }
            }
        });
    },
    _convertStyleQuotes: function($node)
    {
        var style = $node.attr('style');
        if (style) $node.attr('style', style.replace(/"/g, '\''));
    },
    _clearAll: function(nodes, selection)
    {
        if (selection !== false) this.selection.save();

        for (var i = 0; i < nodes.length; i++)
        {
            var node = nodes[i];
            while (node.attributes.length > 0)
            {
                node.removeAttribute(node.attributes[0].name);
            }
        }

        nodes = this._unwrapSpanWithoutAttr(nodes);

        if (selection !== false) this.selection.restore();

        return nodes;
    },
    _unwrapSpanWithoutAttr: function(nodes)
    {
        var finalNodes = [];
        for (var i = 0; i < nodes.length; i++)
        {
            var node = nodes[i];
            var len = node.attributes.length;
            if (len <= 0 && node.nodeType !== 3 && node.tagName === 'SPAN')
            {
                $R.dom(node).unwrap();
            }
            else
            {
                finalNodes.push(node);
            }
        }

        return finalNodes;
    }
});
$R.add('mixin', 'dom', $R.Dom.prototype);
$R.add('mixin', 'component', {
    get cmnt()
    {
        return true;
    }
});
$R.add('service', 'options', {
    init: function(options, element)
    {
        var $el = $R.dom(element);
        var opts = $R.extend({}, $R.opts, (element) ? $el.data() : {}, $R.options);
        opts = $R.extend(true, opts, options);

        return opts;
    }
});
$R.add('service', 'lang', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;

        // build
        this.vars = this._build(this.opts.lang);
    },

    // public
    rebuild: function(lang)
    {
        this.opts.lang = lang;
        this.vars = this._build(lang);
    },
    extend: function(obj)
    {
        this.vars = $R.extend(this.vars, obj);
    },
    parse: function(str)
    {
        if (str === undefined)
        {
            return '';
        }

        var matches = str.match(/## (.*?) ##/g);
        if (matches)
        {
            for (var i = 0; i < matches.length; i++)
            {
                var key = matches[i].replace(/^##\s/g, '').replace(/\s##$/g, '');
                str = str.replace(matches[i], this.get(key));
            }
        }

        return str;
    },
    get: function(name)
    {
        var str = '';
        if (typeof this.vars[name] !== 'undefined')
        {
            str = this.vars[name];
        }
        else if (this.opts.lang !== 'en' && typeof $R.lang['en'][name] !== 'undefined')
        {
            str = $R.lang['en'][name];
        }

        return str;
    },

    // private
    _build: function(lang)
    {
        var vars = $R.lang['en'];
        if (lang !== 'en')
        {
            vars = ($R.lang[lang] !== undefined) ? $R.lang[lang] : vars;
        }

        return vars;
    }
});
$R.add('service', 'callback', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;

        // local
        this.callbacks = {};

        // build
        if (this.opts.callbacks)
        {
            this._set(this.opts.callbacks, '');
        }
    },
    stop: function()
    {
        this.callbacks = {};
    },
    add: function(name, handler)
    {
        if (!this.callbacks[name]) this.callbacks[name] = [];
        this.callbacks[name].push(handler);
    },
    remove: function(name, handler)
    {
        if (handler === undefined)
        {
            delete this.callbacks[name];
        }
        else
        {
            for (var i = 0; i < this.callbacks[name].length; i++)
            {
                this.callbacks[name].splice(i, 1);
            }

            if (Object.keys(this.callbacks[name]).length === 0) delete this.callbacks[name];
        }
    },
    trigger: function(name, args)
    {
        var value = this._loop(name, args, this.callbacks);
        return (typeof value === 'undefined' && args && args[0] !== false) ? args[0] : value;
    },

    // private
    _set: function(obj, name)
    {
        for (var key in obj)
        {
            var path = (name === '') ? key : name + '.' + key;
            if (typeof obj[key] === 'object')
            {
                this._set(obj[key], path);
            }
            else
            {
                this.callbacks[path] = [];
                this.callbacks[path].push(obj[key]);
            }
        }
    },
    _loop: function(name, args, obj)
    {
        var value;
        for (var key in obj)
        {
            if (name === key)
            {
                for (var i = 0; i < obj[key].length; i++)
                {
                    value = obj[key][i].apply(this.app, args);
                }
            }
        }

        return value;
    }
});
$R.add('service', 'animate', {
    init: function(app)
    {
        this.animationOpt = app.opts.animation;
    },
    start: function(element, animation, options, callback)
    {
        var defaults = {
            duration: false,
            iterate: false,
            delay: false,
            timing: false,
            prefix: 'redactor-'
        };

        defaults = (typeof options === 'function') ? defaults : $R.extend(defaults, options);
        callback = (typeof options === 'function') ? options : callback;

        // play
        return new $R.AnimatePlay(element, animation, defaults, callback, this.animationOpt);
    },
    stop: function(element)
    {
        this.$el = $R.dom(element);
        this.$el.removeClass('redactor-animated');

        var effect = this.$el.attr('redactor-animate-effect');
        this.$el.removeClass(effect);

        this.$el.removeAttr('redactor-animate-effect');
        var hide = this.$el.attr('redactor-animate-hide');
        if (hide)
        {
            this.$el.addClass(hide).removeAttr('redactor-animate-hide');
        }

        this.$el.off('animationend webkitAnimationEnd');
    }
});

$R.AnimatePlay = function(element, animation, defaults, callback, animationOpt)
{
    this.hidableEffects = ['fadeOut', 'flipOut', 'slideUp', 'zoomOut', 'slideOutUp', 'slideOutRight', 'slideOutLeft'];
    this.prefixes = ['', '-webkit-'];

    this.$el = $R.dom(element);
    this.$body = $R.dom('body');
    this.callback = callback;
    this.animation = (!animationOpt) ? this.buildAnimationOff(animation) : animation;
    this.defaults = defaults;

    if (this.animation === 'slideUp')
    {
        this.$el.height(this.$el.height());
    }

    // animate
    return (this.isInanimate()) ? this.inanimate() : this.animate();
};

$R.AnimatePlay.prototype = {
    buildAnimationOff: function(animation)
    {
        return (this.isHidable(animation)) ? 'hide' : 'show';
    },
    buildHideClass: function()
    {
        return 'redactor-animate-hide';
    },
    isInanimate: function()
    {
        return (this.animation === 'show' || this.animation === 'hide');
    },
    isAnimated: function()
    {
        return this.$el.hasClass('redactor-animated');
    },
    isHidable: function(effect)
    {
        return (this.hidableEffects.indexOf(effect) !== -1);
    },
    inanimate: function()
    {
        this.defaults.timing = 'linear';

        var hide;
        if (this.animation === 'show')
        {
            hide = this.buildHideClass();
            this.$el.attr('redactor-animate-hide', hide);
            this.$el.removeClass(hide);
        }
        else
        {
            hide = this.$el.attr('redactor-animate-hide');
            this.$el.addClass(hide).removeAttr('redactor-animate-hide');
        }

        if (typeof this.callback === 'function') this.callback(this);

        return this;
    },
    animate: function()
    {
        var delay = (this.defaults.delay) ? this.defaults.delay : 0;
        setTimeout(function()
        {
            this.$body.addClass('no-scroll-x');
            this.$el.addClass('redactor-animated');
            if (!this.$el.attr('redactor-animate-hide'))
            {
                var hide = this.buildHideClass();
                this.$el.attr('redactor-animate-hide', hide);
                this.$el.removeClass(hide);
            }

            this.$el.addClass(this.defaults.prefix + this.animation);
            this.$el.attr('redactor-animate-effect', this.defaults.prefix + this.animation);

            this.set(this.defaults.duration + 's', this.defaults.iterate, this.defaults.timing);
            this.complete();

        }.bind(this), delay * 1000);

        return this;
    },
    set: function(duration, iterate, timing)
    {
        var len = this.prefixes.length;

        while (len--)
        {
            if (duration !== false || duration === '') this.$el.css(this.prefixes[len] + 'animation-duration', duration);
            if (iterate !== false || iterate === '') this.$el.css(this.prefixes[len] + 'animation-iteration-count', iterate);
            if (timing !== false || timing === '') this.$el.css(this.prefixes[len] + 'animation-timing-function', timing);
        }
    },
    clean: function()
    {
        this.$body.removeClass('no-scroll-x');
        this.$el.removeClass('redactor-animated');
        this.$el.removeClass(this.defaults.prefix + this.animation);
        this.$el.removeAttr('redactor-animate-effect');

        this.set('', '', '');
    },
    complete: function()
    {
        this.$el.one('animationend webkitAnimationEnd', function()
        {
            if (this.$el.hasClass(this.defaults.prefix + this.animation)) this.clean();
            if (this.isHidable(this.animation))
            {
                var hide = this.$el.attr('redactor-animate-hide');
                this.$el.addClass(hide).removeAttr('redactor-animate-hide');
            }

            if (this.animation === 'slideUp') this.$el.height('');
            if (typeof this.callback === 'function') this.callback(this.$el);

        }.bind(this));
    }
};
$R.add('service', 'caret', {
    init: function(app)
    {
        this.app = app;
    },

    // set
    setStart: function(el)
    {
        this._setCaret('Start', el);
    },
    setEnd: function(el)
    {
        this._setCaret('End', el);
    },
    setBefore: function(el)
    {
        this._setCaret('Before', el);
    },
    setAfter: function(el)
    {
        this._setCaret('After', el);
    },

    // is
    isStart: function(el)
    {
        return this._isStartOrEnd(el, 'First');
    },
    isEnd: function(el)
    {
        return this._isStartOrEnd(el, 'Last');
    },

    // set side
    setAtEnd: function(node)
    {
        var data = this.inspector.parse(node);
        var tag = data.getTag();
        var range = document.createRange();
        if (this._isInPage(node))
        {
            if (tag === 'a')
            {
                var textNode = this.utils.createInvisibleChar();
                $R.dom(node).after(textNode);

                range.selectNodeContents(textNode);
                range.collapse(true);
            }
            else
            {
                range.selectNodeContents(node);
                range.collapse(false);
            }

            this.selection.setRange(range);
        }
    },
    setAtStart: function(node)
    {
		var range = document.createRange();
		var data = this.inspector.parse(node);
        if (this._isInPage(node))
        {
            range.setStart(node, 0);
            range.collapse(true);

            if (data.isInline() || this.utils.isEmpty(node))
            {
                var textNode = this.utils.createInvisibleChar();
                range.insertNode(textNode);
                range.selectNodeContents(textNode);
                range.collapse(false);
            }

            this.selection.setRange(range);
        }
    },
    setAtBefore: function(node)
    {
        var data = this.inspector.parse(node);
        var range = document.createRange();
        if (this._isInPage(node))
        {
            range.setStartBefore(node);
            range.collapse(true);

            if (data.isInline())
            {
                var textNode = this.utils.createInvisibleChar();
                node.parentNode.insertBefore(textNode, node);
                range.selectNodeContents(textNode);
                range.collapse(false);
            }

            this.selection.setRange(range);
        }
    },
    setAtAfter: function(node)
    {

        var range = document.createRange();
        if (this._isInPage(node))
        {
            range.setStartAfter(node);
            range.collapse(true);

            var textNode = this.utils.createInvisibleChar();
            range.insertNode(textNode);
            range.selectNodeContents(textNode);
            range.collapse(false);

            this.selection.setRange(range);
        }
    },
    setAtPrev: function(node)
    {
        var prev = node.previousSibling;
        if (prev)
        {
            prev = (prev.nodeType === 3 && this._isEmptyTextNode(prev)) ? prev.previousElementSibling : prev;
            if (prev) this.setEnd(prev);
        }
    },
    setAtNext: function(node)
    {
        var next = node.nextSibling;
        if (next)
        {
            next = (next.nodeType === 3 && this._isEmptyTextNode(next)) ? next.nextElementSibling : next;
            if (next) this.setStart(next);
        }
    },

    // private
    _setCaret: function(type, el)
    {
        var data = this.inspector.parse(el);
        var node = data.getNode();

        if (node)
        {
            this.component.clearActive();
            this['_set' + type](node, data, data.getTag());
        }
    },
    _setStart: function(node, data, tag)
    {
        // 1. text
        if (data.isText())
        {
            this.editor.focus();
            return this.setAtStart(node);
        }
        // 2. ul, ol
        else if (tag === 'ul' || tag === 'ol')
        {
            node = data.findFirstNode('li');

            var item = this.utils.getFirstElement(node);
            var dataItem = this.inspector.parse(item);
            if (item && dataItem.isComponent())
            {
                return this.setStart(dataItem.getComponent());
            }
        }
        // 3. dl
        else if (tag === 'dl')
        {
            node = data.findFirstNode('dt');
        }
        // 4. br / hr
        else if (tag === 'br' || tag === 'hr')
        {
            return this.setBefore(node);
        }
        // 5. th, td
        else if (tag === 'td' || tag === 'th')
        {
            var el = data.getFirstElement(node);
            if (el)
            {
                return this.setStart(el);
            }
        }
        // 6. table
        else if (tag === 'table' || tag === 'tr')
        {
            return this.setStart(data.findFirstNode('th, td'));
        }
        // 7. figure code
        else if (data.isComponentType('code') && !data.isFigcaption())
        {
            var code = data.findLastNode('pre, code');

            this.editor.focus();
            return this.setAtStart(code);
        }
        // 8. table component
        else if (tag === 'figure' && data.isComponentType('table'))
        {
            var table = data.getTable();
            var tableData = this.inspector.parse(table);

            return this.setStart(tableData.findFirstNode('th, td'));
        }
        // 9. non editable components
        else if (!data.isComponentType('table') && data.isComponent() && !data.isFigcaption())
        {
            return this.component.setActive(node);
        }

        this.editor.focus();

        // set
        if (!this._setInline(node, 'Start'))
        {
            this.setAtStart(node);
        }
    },
    _setEnd: function(node, data, tag)
    {
        // 1. text
        if (data.isText())
        {
            this.editor.focus();
            return this.setAtEnd(node);
        }
        // 2. ul, ol
        else if (tag === 'ul' || tag === 'ol')
        {
            node = data.findLastNode('li');

            var item = this.utils.getLastElement(node);
            var dataItem = this.inspector.parse(item);
            if (item && dataItem.isComponent())
            {
                return this.setEnd(dataItem.getComponent());
            }
        }
        // 3. dl
        else if (tag === 'dl')
        {
            node = data.findLastNode('dd');
        }
        // 4. br / hr
        else if (tag === 'br' || tag === 'hr')
        {
            return this.setAfter(node);
        }
        // 5. th, td
        else if (tag === 'td' || tag === 'th')
        {
            var el = data.getLastElement();
            if (el)
            {
                return this.setEnd(el);
            }
        }
        // 6. table
        else if (tag === 'table' || tag === 'tr')
        {
            return this.setEnd(data.findLastNode('th, td'));
        }
        // 7. figure code
        else if (data.isComponentType('code') && !data.isFigcaption())
        {
            var code = data.findLastNode('pre, code');

            this.editor.focus();
            return this.setAtEnd(code);
        }
        // 8. table component
        else if (tag === 'figure' && data.isComponentType('table'))
        {
            var table = data.getTable();
            var tableData = this.inspector.parse(table);

            return this.setEnd(tableData.findLastNode('th, td'));
        }
        // 9. non editable components
        else if (!data.isComponentType('table') && data.isComponent() && !data.isFigcaption())
        {
            return this.component.setActive(node);
        }

        this.editor.focus();

        // set
        if (!this._setInline(node, 'End'))
        {
            // is element empty
            if (this.utils.isEmpty(node))
            {
                return this.setStart(node);
            }

            this.setAtEnd(node);
        }
    },
    _setBefore: function(node, data, tag)
    {
        // text
        if (node.nodeType === 3)
        {
            return this.setAtBefore(node);
        }
        // inline
        else if (data.isInline())
        {
            return this.setAtBefore(node);
        }
        // td / th
        else if (data.isFirstTableCell())
        {
            return this.setAtPrev(data.getComponent());
        }
        else if (tag === 'td' || tag === 'th')
        {
            return this.setAtPrev(node);
        }
        // li
        else if (data.isFirstListItem())
        {
            return this.setAtPrev(data.getList());
        }
        // figcaption
        else if (data.isFigcaption())
        {
            return this.setStart(data.getComponent());
        }
        // component
        else if (!data.isComponentType('table') && data.isComponent())
        {
            return this.setAtPrev(data.getComponent());
        }
        // block
        else if (data.isBlock())
        {
            return this.setAtPrev(node);
        }

        this.editor.focus();
        this.setAtBefore(node);

    },
    _setAfter: function(node, data, tag)
    {
        // text
        if (node.nodeType === 3)
        {
            return this.setAtAfter(node);
        }
        // inline
        else if (data.isInline())
        {
            return this.setAtAfter(node);
        }
        // td / th
        else if (data.isLastTableCell())
        {
            return this.setAtNext(data.getComponent());
        }
        else if (tag === 'td' || tag === 'th')
        {
            return this.setAtNext(node);
        }
        // li
        else if (data.isFirstListItem())
        {
            return this.setAtNext(data.getList());
        }
        // component
        else if (!data.isComponentType('table') && data.isComponent())
        {
            return this.setAtNext(data.getComponent());
        }
        // block
        else if (data.isBlock())
        {
            return this.setAtNext(node);
        }

        this.editor.focus();
        this.setAtAfter(node);
    },
    _setInline: function(node, type)
    {
        // is first element inline (FF only)
        var inline = this._hasInlineChild(node, (type === 'Start') ? 'first' : 'last');
        if (inline)
        {
            if (type === 'Start')
            {
                this.setStart(inline);
            }
            else
            {
                this.setEnd(inline);
            }

            return true;
        }
    },
    _isStartOrEnd: function(el, type)
    {
        var node = this.utils.getNode(el);
        if (!node) return false;

        var data = this.inspector.parse(node);
        node = this._getStartEndNode(node, data, type);

        if (node && (node.nodeType !== 3 && node.tagName !== 'LI'))
        {
            var html = (node.nodeType === 3) ? node.textContent : node.innerHTML;
            html = this.utils.trimSpaces(html);
            if (html === '') return true;
        }

        if (!data.isFigcaption() && data.isComponent() && !data.isComponentEditable())
        {
            return true;
        }

        var offset = this.offset.get(node, true);
        if (offset)
        {
            return (type === 'First') ? (offset.start === 0) : (offset.end === this.offset.size(node, true));
        }
        else
        {
            return false;
        }
    },
    _isInPage: function(node)
    {
        if (node && node.nodeType)
        {
            return (node === document.body) ? false : document.body.contains(node);
        }
        else
        {
            return false;
        }
    },
    _hasInlineChild: function(el, pos)
    {
        var data = this.inspector.parse(el);
        var node = (pos === 'first') ? data.getFirstNode() : data.getLastNode();
        var $node = $R.dom(node);

        if (node && node.nodeType !== 3
            && this.inspector.isInlineTag(node.tagName)
            && !$node.hasClass('redactor-component')
             && !$node.hasClass('non-editable'))
        {
            return node;
        }
    },
    _isEmptyTextNode: function(node)
    {
        var text = node.textContent.trim().replace(/\n/, '');
        text = this.utils.removeInvisibleChars(text);

        return (text === '');
    },
    _getStartEndNode: function(node, data, type)
    {
        if (data.isFigcaption())
        {
            node = data.getFigcaption();
        }
        else if (data.isTable())
        {
            node = data['find' + type + 'Node']('th, td');
        }
        else if (data.isList())
        {
            node = data['find' + type + 'Node']('li');
        }
        else if (data.isComponentType('code'))
        {
            node = data.findLastNode('pre, code');
        }

        return node;
    }
});
var containsNode = function containsNode(node) {
    return document.getSelection().containsNode(node, true);
};

if (!('containsNode' in Selection.prototype)) {
    containsNode = containsNodePolyfill;
}

var containsNodePolyfill = function polyfill(node) {
    var selection = document.getSelection();
    var start = selection.anchorNode.parentNode;
    var finalnode = selection.focusNode.parentNode;
    var rectSelection = selection.getRangeAt(0).getBoundingClientRect();
    var rectBlock = node.getBoundingClientRect();

    if ($R.dom(start).closest(node).length) {
        return true;
    }

    if ($R.dom(finalnode).closest(node).length) {
        return true;
    }

    if (rectSelection.top < rectBlock.top && rectSelection.height > rectBlock.height) {
        return true;
    }

    return false;
};


$R.add('service', 'selection', {
    init: function(app)
    {
        this.app = app;
    },
    // is
    is: function()
    {
        var sel = this.get();
        if (sel)
        {
            var node = sel.anchorNode;
            var data = this.inspector.parse(node);

            return (data.isInEditor() || data.isEditor());
        }

        return false;
    },
    isCollapsed: function()
    {
        var sel = this.get();
        var range = this.getRange();

        if (sel && sel.isCollapsed) return true;
        else if (range && range.toString().length === 0) return true;

        return false;
    },
    isBackwards: function()
    {
        var backwards = false;
        var sel = this.get();

        if (sel && !sel.isCollapsed)
        {
            var range = document.createRange();
            range.setStart(sel.anchorNode, sel.anchorOffset);
            range.setEnd(sel.focusNode, sel.focusOffset);
            backwards = range.collapsed;
            range.detach();
        }

        return backwards;
    },
    isIn: function(el)
    {
        var node = $R.dom(el).get();
        var current = this.getCurrent();

        return (current && node) ? node.contains(current) : false;
    },
    isText: function()
    {
        var sel = this.get();
        if (sel)
        {
            var el = sel.anchorNode;
            var block = this.getBlock(el);
            var blocks = this.getBlocks();

            // td, th or hasn't block
            if ((block && this.inspector.isTableCellTag(block.tagName)) || (block === false && blocks.length === 0))
            {
                return true;
            }
        }

        return false;
    },
    isAll: function(el)
    {
        var node = this.utils.getNode(el);
        if (!node) return false;

        var isEditor = this.editor.isEditor(node);
        var data = this.inspector.parse(node);

        // component
        if (!data.isFigcaption() && this.component.isNonEditable(node) && this.component.isActive(node))
        {
            return true;
        }

        if (isEditor)
        {
            var $editor = this.editor.getElement();
            var output = $editor.html().replace(/<p><\/p>$/i, '');
            var htmlLen = this.getHtml(false).length;
            var outputLen = output.length;

            if (htmlLen !== outputLen)
            {
                return false;
            }
        }

        // editor empty or collapsed
        if ((isEditor && this.editor.isEmpty()) || this.isCollapsed())
        {
            return false;
        }

        // all
        var offset = this.offset.get(node, true);
        var size = this.offset.size(node, true);

        // pre, table, or pre/code in figure
        if (!isEditor && data.isComponentType('code'))
        {
            size = this.getText().trim().length;
        }

        if (offset && offset.start === 0 && offset.end === size)
        {
            return true;
        }

        return false;
    },

    // has
    hasNonEditable: function()
    {
        var selected = this.getHtml();
        var $wrapper = $R.dom('<div>').html(selected);

        return (!this.isCollapsed() && $wrapper.find('.non-editable').length !== 0);
    },

    // set
    setRange: function(range)
    {
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    },
    setAll: function(el)
    {
        var node = this.utils.getNode(el);
        if (!node) return;

        var data = this.inspector.parse(node);

        this.component.clearActive();

        this.editor.focus();
        this.editor.saveScroll();
        this.editor.disableNonEditables();

        if (node && node.tagName === 'TABLE')
        {
            var first = data.findFirstNode('td, th');
            var last = data.findLastNode('td, th');

            $R.dom(first).prepend(this.marker.build('start'));
            $R.dom(last).append(this.marker.build('end'));

            this.restoreMarkers();
        }
        else if (!data.isFigcaption() && this.component.isNonEditable(node))
        {
            this.component.setActive(node);
        }
        else
        {
            if (data.isComponentType('code'))
            {
                node = data.getComponentCodeElement();
                node.focus();
            }

            var range = document.createRange();
            range.selectNodeContents(node);

            this.setRange(range);
        }

        this.editor.enableNonEditables();
        this.editor.restoreScroll();
    },

    // get
    get: function()
    {
        var sel = window.getSelection();
        return (sel.rangeCount > 0) ? sel : null;
    },
    getRange: function()
    {
        var sel = this.get();
        return (sel) ? ((sel.getRangeAt(0)) ? sel.getRangeAt(0) : null) : null;
    },
    getTextBeforeCaret: function(num)
    {
        num = (typeof num === 'undefined') ? 1 : num;

        var el = this.editor.getElement().get();
        var range = this.getRange();
        var text = false;
        if (range)
        {
            range = range.cloneRange();
            range.collapse(true);
            range.setStart(el, 0);
            text = range.toString().slice(-num);
        }

        return text;
    },
    getTextAfterCaret: function(num)
    {
        num = (typeof num === 'undefined') ? 1 : num;

        var el = this.editor.getElement().get();
        var range = this.getRange();
        var text = false;
        if (range)
        {
            var clonedRange = range.cloneRange();
            clonedRange.selectNodeContents(el);
            clonedRange.setStart(range.endContainer, range.endOffset);

            text = clonedRange.toString().slice(0, num);
        }

        return text;
    },
    getPosition: function()
    {
        var range = this.getRange();
        var pos = { top: 0, left: 0, width: 0, height: 0 };
        if (window.getSelection && range.getBoundingClientRect)
        {
            range = range.cloneRange();
            var offset = (range.startOffset-1);
            range.setStart(range.startContainer, (offset < 0) ? 0 : offset);
            var rect = range.getBoundingClientRect();
            pos = { top: rect.top, left: rect.left, width: (rect.right - rect.left) , height: (rect.bottom - rect.top) };
        }

        return pos;
    },
    getCurrent: function()
    {
        var node = false;
        var sel = this.get();
        var component = this.component.getActive();

        if (component)
        {
            node = component;
        }
        else if (sel && this.is())
        {
            var data = this.inspector.parse(sel.anchorNode);
            node = (!data.isEditor()) ? sel.anchorNode : false;
        }

        return node;
    },
    getParent: function()
    {
        var node = false;
        var current = this.getCurrent();
        if (current)
        {
            var parent = current.parentNode;
            var data = this.inspector.parse(parent);

            node = (!data.isEditor()) ? parent : false;
        }

        return node;
    },
    getElement: function(el)
    {
        var node = el || this.getCurrent();
        while (node)
        {
            var data = this.inspector.parse(node);
            if (data.isElement() && data.isInEditor())
            {
                return node;
            }

            node = node.parentNode;
        }

        return false;
    },
    getInline: function(el)
    {
        var node = el || this.getCurrent();
        var inline = false;
        while (node)
        {
            if (this._isInlineNode(node))
            {
                inline = node;
            }

            node = node.parentNode;
        }

        return inline;
    },
    getInlineFirst: function(el)
    {
        var node = el || this.getCurrent();
        while (node)
        {
            if (this._isInlineNode(node))
            {
                return node;
            }

            node = node.parentNode;
        }

        return false;
    },
    getInlineAll: function(el)
    {
        var node = el || this.getCurrent();
        var inlines = [];
        while (node)
        {
            if (this._isInlineNode(node))
            {
                inlines.push(node);
            }

            node = node.parentNode;
        }

        return inlines;
    },
    getBlock: function(el)
    {
        var node = el || this.getCurrent();
        while (node)
        {
            var data = this.inspector.parse(node);
            var isBlock = this.inspector.isBlockTag(node.tagName);

            if (isBlock && data.isInEditor(node))
            {
                return node;
            }

            node = node.parentNode;
        }

        return false;
    },
    getInlinesAllSelected: function(options)
    {
        if (this.isAll()) return [];

        var inlines = this.getInlines({ all: true });
        var textNodes = this.getNodes({ textnodes: true, inline: false });
        var selected = this.getText().replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
        var finalNodes = [];

        if (textNodes.length !== 0)
        {
            return finalNodes;
        }

        if (selected === '')
        {
            finalNodes = inlines;
        }
        else if (inlines.length > 1)
        {
            for (var i = 0; i < inlines.length; i++)
            {
                if (this._isTextSelected(inlines[i], selected))
                {
                    finalNodes.push(inlines[i]);
                }
            }
        }
        else if (inlines.length === 1)
        {
            if (this._isTextSelected(inlines[0], selected))
            {
                finalNodes = inlines;
            }
        }

        finalNodes = (options && options.tags) ? this._filterNodesByTags(finalNodes, options.tags) : finalNodes;

        return finalNodes;
    },
    getInlines: function(options)
    {
        var nodes = this.getNodes();
        var filteredNodes = [];
        for (var i = 0; i < nodes.length; i++)
        {
            var node;
            if (options && options.all)
            {
                node = nodes[i];
                while (node)
                {
                    if (this._isInlineNode(node) && !this._isInNodesArray(filteredNodes, node))
                    {
                        filteredNodes.push(node);
                    }

                    node = node.parentNode;
                }
            }
            else
            {
                node = this.getInline(nodes[i]);
                if (node && !this._isInNodesArray(filteredNodes, node))
                {
                    filteredNodes.push(node);
                }
            }
        }

        // filter
        filteredNodes = (options && options.tags) ? this._filterNodesByTags(filteredNodes, options.tags) : filteredNodes;
        filteredNodes = (options && options.inside) ? this._filterInlinesInside(filteredNodes, options) : filteredNodes;

        return filteredNodes;
    },
    getBlocks: function(options)
    {
        var nodes = this.getNodes();
        var block = this.getBlock();
        nodes = (nodes.length === 0 && block) ? [block] : nodes;

        var filteredNodes = [];
        for (var i = 0; i < nodes.length; i++)
        {
            var node = this.getBlock(nodes[i]);
            var $node = $R.dom(node);
            if ($node.hasClass('non-editable')) continue;

            if (node && !this._isInNodesArray(filteredNodes, node))
            {
                filteredNodes.push(node);
            }
        }

        // filter
        filteredNodes = (options && options.tags) ? this._filterNodesByTags(filteredNodes, options.tags) : filteredNodes;
        filteredNodes = (options && options.first) ? this._filterBlocksFirst(filteredNodes, options) : filteredNodes;

        return filteredNodes;
    },
    getElements: function(options)
    {
        var nodes = this.getNodes({ textnodes: false });
        var block = this.getBlock();
        nodes = (nodes.length === 0 && block) ? [block] : nodes;

        var filteredNodes = [];
        for (var i = 0; i < nodes.length; i++)
        {
            if (!this._isInNodesArray(filteredNodes, nodes[i]))
            {
                filteredNodes.push(nodes[i]);
            }
        }

        // filter
        filteredNodes = (options && options.tags) ? this._filterNodesByTags(filteredNodes, options.tags) : filteredNodes;

        return filteredNodes;
    },
    getNodes: function(options)
    {
        var nodes = [];
        var activeComponent = this.component.getActive();
        if (activeComponent)
        {
            nodes = this._getNodesComponent(activeComponent);
        }
        else if (this.isCollapsed())
        {
            var current = this.getCurrent();
            nodes = (current) ? [current] : [];
        }
        else if (this.is() && !activeComponent)
        {
            nodes = this._getRangeSelectedNodes();
        }

        // filter
        nodes = this._filterServicesNodes(nodes);
        nodes = this._filterEditor(nodes);

        // options
        nodes = (options && options.tags) ? this._filterNodesByTags(nodes, options.tags) : nodes;
        nodes = (options && options.textnodes) ? this._filterNodesTexts(nodes, options) : nodes;
        nodes = (options && !options.textnodes) ? this._filterNodesElements(nodes) : nodes;

        return nodes;
    },

    // text & html
    getText: function()
    {
        var sel = this.get();
        return (sel) ? this.utils.removeInvisibleChars(sel.toString()) : '';
    },
    getHtml: function(clean)
    {
        var html = '';
        var sel = this.get();
        if (sel)
        {
            var container = document.createElement('div');
            var len = sel.rangeCount;
            for (var i = 0; i < len; ++i)
            {
                container.appendChild(sel.getRangeAt(i).cloneContents());
            }

            html = container.innerHTML;
            html = (clean !== false) ? this.cleaner.output(html) : html;
            html = html.replace(/<p><\/p>$/i, '');
        }

        return html;
    },

    // clear
    clear: function()
    {
        this.component.clearActive();
        this.get().removeAllRanges();
    },

    // collapse
    collapseToStart: function()
    {
        var sel = this.get();
        if (sel && !sel.isCollapsed) sel.collapseToStart();
    },
    collapseToEnd: function()
    {
        var sel = this.get();
        if (sel && !sel.isCollapsed) sel.collapseToEnd();
    },

    // save
    saveActiveComponent: function()
    {
        var activeComponent = this.component.getActive();
        if (activeComponent)
        {
            this.savedComponent = activeComponent;
            return true;
        }

        return false;
    },
    restoreActiveComponent: function()
    {
        if (this.savedComponent)
        {
            this.component.setActive(this.savedComponent);
            return true;
        }

        return false;
    },
    save: function()
    {
        this._clearSaved();

        var el = this.getElement();
        var tags = ['TD', 'TH', 'P', 'DIV', 'PRE', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'LI', 'BLOCKQUOTE'];
        if (el && (tags.indexOf(el.tagName) !== -1) && (el.innerHTML === '' || el.innerHTML === '<br>'))
        {
            this.savedElement = el;
        }
        else if (!this.saveActiveComponent())
        {
            this.saved = this.offset.get();
        }
    },
    restore: function()
    {
        if (!this.saved && !this.savedComponent && !this.savedElement) return;

        this.editor.saveScroll();

        if (this.savedElement)
        {
            this.caret.setStart(this.savedElement);
        }
        else if (!this.restoreActiveComponent())
        {
            this.offset.set(this.saved);
        }

        this._clearSaved();
        this.editor.restoreScroll();
    },
    saveMarkers: function()
    {
        this._clearSaved();

        if (!this.saveActiveComponent())
        {
            this.marker.insert();
        }
    },
    restoreMarkers: function()
    {
        this.editor.saveScroll();

        if (!this.restoreActiveComponent())
        {
            this.marker.restore();
        }

        this._clearSaved();
        this.editor.restoreScroll();
    },

    // private
    _getNextNode: function(node)
    {
        if (node.hasChildNodes()) return node.firstChild;

        while (node && !node.nextSibling)
        {
            node = node.parentNode;
        }

        if (!node) return null;

        return node.nextSibling;
    },
    _getNodesComponent: function(component)
    {
        var current = this.getCurrent();
        var data = this.inspector.parse(current);

        return (data.isFigcaption()) ? [data.getFigcaption()] : [component];
    },
    _getRangeSelectedNodes: function()
    {
        var nodes = [];
        var range = this.getRange();
        var node = range.startContainer;
        var startNode = range.startContainer;
        var endNode = range.endContainer;
        var $editor = this.editor.getElement();

        // editor
        if (startNode === $editor.get() && this.isAll())
        {
            nodes = this.utils.getChildNodes($editor);
        }
        // single node
        else if (node == endNode)
        {
            nodes = [node];
        }
        else
        {
            while (node && node != endNode)
            {
                nodes.push(node = this._getNextNode(node));
            }

            node = range.startContainer;
            while (node && node != range.commonAncestorContainer)
            {
                nodes.unshift(node);
                node = node.parentNode;
            }
        }

        return nodes;
    },
    _isInNodesArray: function(nodes, node)
    {
        return (nodes.indexOf(node) !== -1);
    },
    _filterEditor: function(nodes)
    {
        var filteredNodes = [];
        for (var i = 0; i < nodes.length; i++)
        {
            var data = this.inspector.parse(nodes[i]);
            if (data.isInEditor())
            {
                filteredNodes.push(nodes[i]);
            }
        }

        return filteredNodes;
    },
    _filterServicesNodes: function(nodes)
    {
        var filteredNodes = [];
        for (var i = 0; i < nodes.length; i++)
        {
            var $el = $R.dom(nodes[i]);
            var skip = false;

            if (nodes[i] && nodes[i].nodeType === 3 && this.utils.isEmpty(nodes[i])) skip = true;
            if ($el.hasClass('redactor-script-tag')
                || $el.hasClass('redactor-component-caret')
                || $el.hasClass('redactor-selection-marker')
                || $el.hasClass('non-editable')) skip = true;

            if (!skip)
            {
                filteredNodes.push(nodes[i]);
            }
        }

        return filteredNodes;
    },
    _filterNodesTexts: function(nodes, options)
    {
        var filteredNodes = [];
        for (var i = 0; i < nodes.length; i++)
        {
            if (nodes[i].nodeType === 3 || (options.keepbr && nodes[i].tagName === 'BR'))
            {
                var inline = this.getInline(nodes[i]);
                var isInline = (inline && options && options.inline === false);
                if (!isInline)
                {
                    filteredNodes.push(nodes[i]);
                }
            }
        }

        return filteredNodes;
    },
    _filterNodesElements: function(nodes)
    {
        var filteredNodes = [];
        for (var i = 0; i < nodes.length; i++)
        {
            if (nodes[i].nodeType !== 3)
            {
                filteredNodes.push(nodes[i]);
            }
        }

        return filteredNodes;
    },
    _filterNodesByTags: function(nodes, tags, passtexts)
    {
        var filteredNodes = [];
        for (var i = 0; i < nodes.length; i++)
        {
            if (passtexts && nodes[i].nodeType === 3)
            {
                filteredNodes.push(nodes[i]);
            }
            else if (nodes[i].nodeType !== 3)
            {
                var nodeTag = nodes[i].tagName.toLowerCase();
                if (tags.indexOf(nodeTag.toLowerCase()) !== -1)
                {
                    filteredNodes.push(nodes[i]);
                }
            }
        }

        return filteredNodes;
    },
    _filterBlocksFirst: function(nodes)
    {
        var filteredNodes = [];
        for (var i = 0; i < nodes.length; i++)
        {
            var $node = $R.dom(nodes[i]);
            var parent = $node.parent().get();
            var isFirst = ($node.parent().hasClass('redactor-in'));
            var isCellParent = (parent && (parent.tagName === 'TD' || parent.tagName === 'TH'));
            if (isFirst || isCellParent)
            {
                filteredNodes.push(nodes[i]);
            }
        }

        return filteredNodes;
    },
    _filterInlinesInside: function(nodes)
    {
        var filteredNodes = [];
        for (var i = 0; i < nodes.length; i++)
        {
            if (containsNode(nodes[i], true))
            {
                filteredNodes.push(nodes[i]);
            }
        }

        return filteredNodes;
    },
    _isTextSelected: function(node, selected)
    {
        var text = this.utils.removeInvisibleChars(node.textContent);

        return (
            selected === text
            || text.search(selected) !== -1
            || selected.search(new RegExp('^' + this.utils.escapeRegExp(text))) !== -1
            || selected.search(new RegExp(this.utils.escapeRegExp(text) + '$')) !== -1
        );
    },
    _isInlineNode: function(node)
    {
        var data = this.inspector.parse(node);

        return (this.inspector.isInlineTag(node.tagName) && data.isInEditor());
    },
    _clearSaved: function()
    {
        this.saved = false;
        this.savedComponent = false;
        this.savedElement = false;
    }
});
$R.add('service', 'element', {
    init: function(app)
    {
        this.app = app;
        this.rootElement = app.rootElement;

        // local
        this.$element = {};
        this.type = 'inline';
    },
    start: function()
    {
        this._build();
        this._buildType();
    },

    // public
    isType: function(type)
    {
        return (type === this.type);
    },
    getType: function()
    {
        return this.type;
    },
    getElement: function()
    {
        return this.$element;
    },

    // private
    _build: function()
    {
        this.$element = $R.dom(this.rootElement);
    },
    _buildType: function()
    {
        var tag = this.$element.get().tagName;

        this.type = (tag === 'TEXTAREA') ? 'textarea' : this.type;
        this.type = (tag === 'DIV') ? 'div' : this.type;
        this.type = (this.opts.inline) ? 'inline' : this.type;
    }
});
$R.add('service', 'editor', {
    init: function(app)
    {
        this.app = app;

        // local
        this.scrolltop = false;
        this.pasting = false;
    },

    // start
    start: function()
    {
        this._build();
    },

    // focus
    focus: function()
    {
        if (!this.isFocus() && !this._isContenteditableFocus())
        {
            this.saveScroll();
            this.$editor.focus();
            this.restoreScroll();
        }
    },
    startFocus: function()
    {
        this.caret.setStart(this.getFirstNode());
    },
    endFocus: function()
    {
        this.caret.setEnd(this.getLastNode());
    },

    // pasting
    isPasting: function()
    {
        return this.pasting;
    },
    enablePasting: function()
    {
        this.pasting = true;
    },
    disablePasting: function()
    {
        this.pasting = false;
    },

    // scroll
    saveScroll: function()
    {
        this.scrolltop = this._getScrollTarget().scrollTop();
    },
    restoreScroll: function()
    {
        if (this.scrolltop !== false)
        {
            this._getScrollTarget().scrollTop(this.scrolltop);
            this.scrolltop = false;
        }
    },

    // non editables
    disableNonEditables: function()
    {
        this.$noneditables = this.$editor.find('[contenteditable=false]');
        this.$noneditables.attr('contenteditable', true);
    },
    enableNonEditables: function()
    {
        if (this.$noneditables)
        {
            setTimeout(function() { this.$noneditables.attr('contenteditable', false); }.bind(this), 1);
        }
    },

    // nodes
    getFirstNode: function()
    {
        return this.$editor.contents()[0];
    },
    getLastNode: function()
    {
        var nodes = this.$editor.contents();

        return nodes[nodes.length-1];
    },

    // utils
    isSourceMode: function()
    {
        var $source = this.source.getElement();

        return $source.hasClass('redactor-source-open');
    },
    isEditor: function(el)
    {
        var node = $R.dom(el).get();

        return (node === this.$editor.get());
    },
    isEmpty: function(keeplists)
    {
        return this.utils.isEmptyHtml(this.$editor.html(), false, keeplists);
    },
    isFocus: function()
    {
        var $active = $R.dom(document.activeElement);
        var isComponentSelected = (this.$editor.find('.redactor-component-active').length !== 0);

        return (isComponentSelected || $active.closest('.redactor-in-' + this.uuid).length !== 0);
    },
    setEmpty: function()
    {
        this.$editor.html(this.opts.emptyHtml);
    },

    // element
    getElement: function()
    {
        return this.$editor;
    },

    // private
    _build: function()
    {
        var $element = this.element.getElement();
        var editableElement = (this.element.isType('textarea')) ? '<div>' : $element.get();

        this.$editor = $R.dom(editableElement);
    },
    _getScrollTarget: function()
    {
        var $target = this.$doc;
        if (this.opts.toolbarFixedTarget !== document)
        {
            $target = $R.dom(this.opts.toolbarFixedTarget);
        }
        else
        {
            $target = (this.opts.scrollTarget) ? $R.dom(this.opts.scrollTarget) : $target;
        }

        return $target;
    },
    _isContenteditableFocus: function()
    {
        var block = this.selection.getBlock();
        var $blockParent = (block) ? $R.dom(block).closest('[contenteditable=true]').not('.redactor-in') : [];

        return ($blockParent.length !== 0);
    }
});
$R.add('service', 'container', {
    init: function(app)
    {
        this.app = app;
    },
    // public
    start: function()
    {
        this._build();
    },
    getElement: function()
    {
        return this.$container;
    },

    // private
    _build: function()
    {
        var tag = (this.element.isType('inline')) ? '<span>' : '<div>';
        this.$container = $R.dom(tag);
    }
});
$R.add('service', 'source', {
    init: function(app)
    {
        this.app = app;

        // local
        this.$source = {};
        this.content = '';
    },
    // public
    start: function()
    {
        this._build();
        this._buildName();
        this._buildStartedContent();
    },
    getElement: function()
    {
        return this.$source;
    },
    getCode: function()
    {
        return this.$source.val();
    },
    getName: function()
    {
        return this.$source.attr('name');
    },
    getStartedContent: function()
    {
        return this.content;
    },
    setCode: function(html)
    {
        return this.insertion.set(html, true, false);
    },
    isNameGenerated: function()
    {
        return (this.name);
    },
    rebuildStartedContent: function()
    {
        this._buildStartedContent();
    },

    // private
    _build: function()
    {
        var $element = this.element.getElement();
        var isTextarea = this.element.isType('textarea');
        var sourceElement = (isTextarea) ? $element.get() : '<textarea>';

        this.$source = $R.dom(sourceElement);
    },
    _buildName: function()
    {
        var $element = this.element.getElement();

        this.name = $element.attr('name');
        this.$source.attr('name', (this.name) ? this.name : 'content-' + this.uuid);
    },
    _buildStartedContent: function()
    {
        var $element = this.element.getElement();
        var content = (this.element.isType('textarea')) ? $element.val() : $element.html();

        this.content = content.trim();
    }
});
$R.add('service', 'statusbar', {
    init: function(app)
    {
        this.app = app;

        // local
        this.$statusbar = {};
        this.items = [];
    },
    // public
    start: function()
    {
        this.$statusbar = $R.dom('<ul>');
        this.$statusbar.attr('dir', this.opts.direction);
    },
    add: function(name, html)
    {
        return this.update(name, html);
    },
    update: function(name, html)
    {
        var $item;
        if (typeof this.items[name] !== 'undefined')
        {
            $item = this.items[name];
        }
        else
        {
            $item = $R.dom('<li>');
            this.$statusbar.append($item);
            this.items[name] = $item;
        }

        return $item.html(html);
    },
    get: function(name)
    {
        return (this.items[name]) ? this.items[name] : false;
    },
    remove: function(name)
    {
        if (this.items[name])
        {
            this.items[name].remove();
            delete this.items[name];
        }
    },
    getItems: function()
    {
        return this.items;
    },
    removeItems: function()
    {
        this.items = {};
        this.$statusbar.html('');
    },
    getElement: function()
    {
        return this.$statusbar;
    }
});
$R.add('service', 'toolbar', {
    init: function(app)
    {
        this.app = app;

        // local
        this.buttons = [];
        this.dropdownOpened = false;
        this.buttonsObservers = {};
    },
    // public
    start: function()
    {
        if (this.is())
        {
            this.opts.activeButtons = (this.opts.activeButtonsAdd) ? this._extendActiveButtons() : this.opts.activeButtons;
            this.create();
        }
    },
    stopObservers: function()
    {
        this.buttonsObservers = {};
    },
    create: function()
    {
        this.$wrapper = $R.dom('<div>');
        this.$toolbar = $R.dom('<div>');
    },
    observe: function()
    {
        if (!this.is()) return;

        this.setButtonsInactive();

        var button, observer;

        // observers
        for (var name in this.buttonsObservers)
        {
            observer = this.buttonsObservers[name];
            button = this.getButton(name);
            this.app.broadcast('button.' + observer + '.observe', button);
        }

        // inline buttons
        var buttons = this.opts.activeButtons;
        var inlines = this.selection.getInlinesAllSelected();
        var current = this.selection.getInline();
        if (this.selection.isCollapsed() && current)
        {
            inlines.push(current);
        }

        var tags = this._inlinesToTags(inlines);
        for (var key in buttons)
        {
            if (tags.indexOf(key) !== -1)
            {
                button = this.getButton(buttons[key]);
                if (button) {
                    button.setActive();
                }
            }

        }
    },

    // is
    is: function()
    {
        return !(!this.opts.toolbar || (this.detector.isMobile() && this.opts.air));
    },
    isAir: function()
    {
        return (this.is()) ? this.$toolbar.hasClass('redactor-air') : false;
    },
    isFixed: function()
    {
        return (this.is()) ? this.$toolbar.hasClass('redactor-toolbar-fixed') : false;
    },
    isContextBar: function()
    {
        var $bar = this.$body.find('#redactor-context-toolbar-' + this.uuid);
        return $bar.hasClass('open');
    },
    isTarget: function()
    {
        return (this.opts.toolbarFixedTarget !== document);
    },

    // get
    getElement: function()
    {
        return this.$toolbar;
    },
    getWrapper: function()
    {
        return this.$wrapper;
    },
    getDropdown: function()
    {
        return this.dropdownOpened;
    },
    getTargetElement: function()
    {
        return $R.dom(this.opts.toolbarFixedTarget);
    },
    getButton: function(name)
    {
        var $btn = this._findButton('.re-' + name);

        return ($btn.length !== 0) ? $btn.dataget('data-button-instance') : false;
    },
    getButtons: function()
    {
        var buttons = [];
        this._findButtons().each(function(node)
        {
            var $node = $R.dom(node);
            buttons.push($node.dataget('data-button-instance'));
        });

        return buttons;
    },
    getButtonsKeys: function()
    {
        var keys = [];
        this._findButtons().each(function(node)
        {
            var $node = $R.dom(node);
            keys.push($node.attr('data-re-name'));
        });

        return keys;
    },

    // add
    addButton: function(name, btnObj, position, $el, start)
    {
        position = position || 'end';

        var $button = $R.create('toolbar.button', this.app, name, btnObj);
        if (btnObj.observe)
        {
            this.opts.activeButtonsObservers[name] = { observe: btnObj.observe, button: $button };
        }

        if (this.is())
        {
            if (position === 'first') this.$toolbar.prepend($button);
            else if (position === 'after') $el.after($button);
            else if (position === 'before') $el.before($button);
            else this.$toolbar.append($button);
        }

        return $button;
    },
    addButtonFirst: function(name, btnObj)
    {
        return this.addButton(name, btnObj, 'first');
    },
    addButtonAfter: function(after, name, btnObj)
    {
        var $btn = this.getButton(after);

        return ($btn) ? this.addButton(name, btnObj, 'after', $btn) : this.addButton(name, btnObj);
    },
    addButtonBefore: function(before, name, btnObj)
    {
        var $btn = this.getButton(before);

        return ($btn) ? this.addButton(name, btnObj, 'before', $btn) : this.addButton(name, btnObj);
    },
    addButtonObserver: function(name, observer)
    {
        this.buttonsObservers[name] = observer;
    },

    // set
    setButtons: function(buttons)
    {
        this.buttons = buttons;
    },
    setDropdown: function(dropdown)
    {
        this.dropdownOpened = dropdown;
    },
    setButtonsInactive: function()
    {
        var $buttons = this.getButtons();
        for (var i = 0; i < $buttons.length; i++)
        {
            $buttons[i].setInactive();
        }
    },
    setButtonsActive: function()
    {
        var $buttons = this.getButtons();
        for (var i = 0; i < $buttons.length; i++)
        {
            $buttons[i].setActive();
        }
    },

    // disable & enable
    disableButtons: function()
    {
        var $buttons = this.getButtons();
        for (var i = 0; i < $buttons.length; i++)
        {
            $buttons[i].disable();
        }
    },
    enableButtons: function()
    {
        var $buttons = this.getButtons();
        for (var i = 0; i < $buttons.length; i++)
        {
            $buttons[i].enable();
        }

    },

    // private
    _findButton: function(selector)
    {
        return (this.is()) ? this.$toolbar.find(selector) : $R.dom();
    },
    _findButtons: function()
    {
        return (this.is()) ? this.$toolbar.find('.re-button') : $R.dom();
    },
    _extendActiveButtons: function()
    {
        return $R.extend({}, this.opts.activeButtons, this.opts.activeButtonsAdd);
    },
    _inlinesToTags: function(inlines)
    {
        var tags = [];
        for (var i = 0; i < inlines.length; i++)
        {
            tags.push(inlines[i].tagName.toLowerCase());
        }

        return tags;
    }
});
$R.add('class', 'toolbar.button', {
    mixins: ['dom'],
    init: function(app, name, btnObj)
    {
        this.app = app;
        this.opts = app.opts;
        this.lang = app.lang;
        this.$body = app.$body;
        this.toolbar = app.toolbar;
        this.detector = app.detector;

        // local
        this.obj = btnObj;
        this.name = name;
        this.dropdown = false;
        this.tooltip = false;

        // init
        this._init();
    },
    // is
    isActive: function()
    {
        return this.hasClass('redactor-button-active');
    },
    isDisabled: function()
    {
        return this.hasClass('redactor-button-disabled');
    },

    // has
    hasIcon: function()
    {
        return (this.obj.icon && !this.opts.buttonsTextLabeled);
    },

    // set
    setDropdown: function(dropdown)
    {
        this.obj.dropdown = dropdown;
        this.obj.message = false;
        this.dropdown = $R.create('toolbar.dropdown', this.app, this.name, this.obj.dropdown);
        this.attr('data-dropdown', true);
    },
    setMessage: function(message, args)
    {
        this.obj.message = message;
        this.obj.args = args;
        this.obj.dropdown = false;
    },
    setApi: function(api, args)
    {
        this.obj.api = api;
        this.obj.args = args;
        this.obj.dropdown = false;
    },
    setTitle: function(title)
    {
        this.obj.title = this.lang.parse(title);
        this.obj.tooltip = this.obj.title;

        this.attr({ 'alt': this.obj.tooltip, 'aria-label': this.obj.tooltip });
        if (!this.attr('data-re-icon')) this.html(this.obj.title);
    },
    setTooltip: function(tooltip)
    {
        this.obj.tooltip = this.lang.parse(tooltip);
        this.attr({ 'alt': this.obj.tooltip, 'aria-label': this.obj.tooltip });
    },
    setIcon: function(icon)
    {
        if (this.opts.buttonsTextLabeled) return;

        this.obj.icon = true;
        this.$icon = $R.dom(icon);

        this.html('');
        this.append(this.$icon);
        this.attr('data-re-icon', true);
        this.addClass('re-button-icon');
        this.setTooltip(this.obj.title);
        this._buildTooltip();
    },
    setActive: function()
    {
        this.addClass('redactor-button-active');
    },
    setInactive: function()
    {
        this.removeClass('redactor-button-active');
    },

    // hide
    hideTooltip: function()
    {
        this.$body.find('.re-button-tooltip').remove();
    },

    // get
    getDropdown: function()
    {
        return this.dropdown;
    },

    // enable & disable
    disable: function()
    {
        this.addClass('redactor-button-disabled');
    },
    enable: function()
    {
        this.removeClass('redactor-button-disabled');
    },

    // toggle
    toggle: function(e)
    {
        if (e) e.preventDefault();
        if (this.isDisabled()) return;

        if (this.obj.dropdown)
        {
            this.dropdown.toggle(e);
        }
        else if (this.obj.api)
        {
            // broadcast
            this.app.api(this.obj.api, this.obj.args, this.name);
        }
        else if (this.obj.message)
        {
            // broadcast
            this.app.broadcast(this.obj.message, this.obj.args, this.name);
        }

        this.hideTooltip();
    },

    // private
    _init: function()
    {
        // parse
        this._parseTitle();
        this._parseTooltip();

        // build
        this._build();
        this._buildCallback();
        this._buildAttributes();
        this._buildObserver();

        if (this.hasIcon())
        {
            this._buildIcon();
            this._buildTooltip();
        }
        else
        {
            this.html(this.obj.title);
        }
    },
    _parseTooltip: function()
    {
        this.obj.tooltip = (this.obj.tooltip) ? this.lang.parse(this.obj.tooltip) : this.obj.title;
    },
    _parseTitle: function()
    {
        this.obj.title = this.lang.parse(this.obj.title);
    },
    _build: function()
    {
        this.parse('<a>');
        this.addClass('re-button re-' + this.name);
        this.attr('data-re-name', this.name);
        this.dataset('data-button-instance', this);

        if (this.obj.dropdown) this.setDropdown(this.obj.dropdown);
    },
    _buildCallback: function()
    {
        this.on('click', this.toggle.bind(this));
    },
    _buildAttributes: function()
    {
        var attrs = {
            'href': '#',
            'alt': this.obj.tooltip,
            'rel': this.name,
            'role': 'button',
            'aria-label': this.obj.tooltip,
            'tabindex': '-1'
        };

        this.attr(attrs);
    },
    _buildObserver: function()
    {
        if (typeof this.obj.observe !== 'undefined')
        {
            this.toolbar.addButtonObserver(this.name, this.obj.observe);
        }
    },
    _buildIcon: function()
    {
        var icon = this.obj.icon;
        var isHtml = (/(<([^>]+)>)/ig.test(icon));

        this.$icon = (isHtml) ? $R.dom(icon) : $R.dom('<i>');
        if (!isHtml) this.$icon.addClass('re-icon-' + this.name);

        this.append(this.$icon);
        this.attr('data-re-icon', true);
        this.addClass('re-button-icon');
    },
    _buildTooltip: function()
    {
        if (this.detector.isDesktop())
        {
            this.tooltip = $R.create('toolbar.button.tooltip', this.app, this);
        }
    }
});
$R.add('class', 'toolbar.button.tooltip', {
    mixins: ['dom'],
    init: function(app, $button)
    {
        this.app = app;
        this.uuid = app.uuid;
        this.opts = app.opts;
        this.$body = app.$body;
        this.toolbar = app.toolbar;

        // local
        this.$button = $button;
        this.created = false;

        // init
        this._init();
    },
    open: function()
    {
        if (this.$button.hasClass('redactor-button-disabled') || this.$button.hasClass('redactor-button-active')) return;

        this.created = true;
        this.parse('<span>');
        this.addClass('re-button-tooltip re-button-tooltip-' + this.uuid);
        this.$body.append(this);
        this.html(this.$button.attr('alt'));

        var offset = this.$button.offset();
        var position = 'absolute';
        var height = this.$button.height();
        var width = this.$button.width();
        var arrowOffset = 4;

        this.css({
            top: (offset.top + height + arrowOffset) + 'px',
            left: (offset.left + width/2 - this.width()/2) + 'px',
            position: position
        });

        this.show();
    },
    close: function()
    {
        if (!this.created || this.$button.hasClass('redactor-button-disabled')) return;

        this.remove();
        this.created = false;
    },

    // private
    _init: function()
    {
        this.$button.on('mouseover', this.open.bind(this));
        this.$button.on('mouseout', this.close.bind(this));
    }
});
$R.add('class', 'toolbar.dropdown', {
    mixins: ['dom'],
    init: function(app, name, items)
    {
        this.app = app;
        this.uuid = app.uuid;
        this.opts = app.opts;
        this.$win = app.$win;
        this.$doc = app.$doc;
        this.$body = app.$body;
        this.animate = app.animate;
        this.toolbar = app.toolbar;

        // local
        this.name = name;
        this.started = false;
        this.items = (name === 'format') ? $R.extend({}, true, items) : items;
        this.$items = [];
    },
    // public
    toggle: function(e)
    {
        if (!this.started)
        {
            this._build();
        }

        // toggle
        if (this.isOpened() && this.isActive())
        {
            this.close(false);
        }
        else
        {
            this.open(e);
        }
    },
    isOpened: function()
    {
        var $dropdown = this.$body.find('.redactor-dropdown-' + this.uuid + '.open');

        return ($dropdown.length !== 0 && $dropdown.attr('data-re-name') === this.name);
    },
    isActive: function()
    {
        var $dropdown = this.$body.find('#redactor-dropdown-' + this.uuid + '-' + this.name + '.open');
        return ($dropdown.length !== 0);
    },
    getName: function()
    {
        return this.attr('data-re-name');
    },
    getItem: function(name)
    {
        return this.$items[name];
    },
    getItemsByClass: function(classname)
    {
        var result = [];
        for (var key in this.$items)
        {
            if (typeof this.$items[key] === 'object' && this.$items[key].dom && this.$items[key].hasClass(classname))
            {
                result.push(this.$items[key]);
            }
        }

        return result;
    },
    open: function(e)
    {
        this._closeAll();

        this.$btn = this.toolbar.getButton(this.name);
        this.app.broadcast('dropdown.open', e, this, this.$btn);
        this.toolbar.setDropdown(this);

        this.show();
        this.removeClass('redactor-animate-hide');
        this.addClass('open');
        this._observe();

        this.$btn.hideTooltip();
        this.$btn.setActive();

        this.$doc.on('keyup.redactor.dropdown-' + this.uuid, this._handleKeyboard.bind(this));
        this.$doc.on('click.redactor.dropdown-' + this.uuid, this.close.bind(this));

        this.updatePosition();
        this.app.broadcast('dropdown.opened', e, this, this.$btn);

    },
    close: function(e, animate)
    {
        if (e)
        {
            var $el = $R.dom(e.target);
            if (this._isButton(e) || $el.hasClass('redactor-dropdown-not-close') || $el.hasClass('redactor-dropdown-item-disabled'))
            {
                e.preventDefault();
                return;
            }
        }

        this.app.broadcast('dropdown.close', this, this.$btn);
        this.toolbar.setDropdown(false);

        this.$btn.setInactive();
        if (animate === false)
        {
            this._close();
        }
        else
        {
            this.animate.start(this, 'fadeOut', this._close.bind(this));
        }
    },
    updatePosition: function()
    {
        var isFixed = this.toolbar.isFixed();
        var isTarget = this.toolbar.isTarget();

        var btnHeight = this.$btn.height();
        var btnWidth = this.$btn.width();

        var pos = this.$btn.offset();
        var position = 'absolute';
        var topOffset = 2;

        if (isFixed) {
            pos.top = (isTarget) ? this.$btn.offset().top : this.$btn.position().top;
            position = 'fixed';
            topOffset = topOffset + this.opts.toolbarFixedTopOffset;
        }


        var leftOffset = 0;
        var left = (pos.left + leftOffset);
        var width = parseFloat(this.css('width'));
        var winWidth = this.$win.width();
        var leftFix = (winWidth < (left + width)) ? (width - btnWidth) : 0;
        var leftPos = (left - leftFix);
        var top = (pos.top + btnHeight + topOffset);
        leftPos = (leftPos < 0) ? 4 : leftPos;

        this.css({
            maxHeight: '',
            position: position,
            top: top + 'px',
            left: leftPos + 'px'
        });

        // height adaptive
        var heightTolerance = 10;
        var winHeight = this.$win.height();
        var scrollTop = this.$doc.scrollTop();
        var cropHeight = winHeight - (top - scrollTop) - heightTolerance;

        this.css('max-height', cropHeight + 'px');
    },

    // private
    _build: function()
    {
        this.parse('<div>');
        this.attr('dir', this.opts.direction);
        this.attr('id', 'redactor-dropdown-' + this.uuid + '-' + this.name);
        this.attr('data-re-name', this.name);

        this.addClass('redactor-dropdown redactor-dropdown-' + this.uuid + ' redactor-dropdown-' + this.name);
        this.dataset('data-dropdown-instance', this);
        var isDom = (this.items.sdom || typeof this.items === 'string');

        if (isDom) this._buildDom();
        else this._buildItems();

        this.$body.append(this);
        this.started = true;
    },
    _buildDom: function()
    {
        this.html('').append($R.dom(this.items));
    },
    _buildItems: function()
    {
        this.items = (this.name === 'format') ? this._buildFormattingItems() : this.items;

        for (var key in this.items)
        {
            var obj = this.items[key];

            if (key === 'observe')
            {
                this.attr('data-observe', this.items[key]);
            }
            else
            {
                var $item = $R.create('toolbar.dropdown.item', this.app, key, obj, this);

                this.$items[key] = $item;
                this.append($item);
            }
        }
    },
    _buildFormattingItems: function()
    {
        // build the format set
        for (var key in this.items)
        {
            if (this.opts.formatting.indexOf(key) === -1) delete this.items[key];
        }

        // remove from the format set
        if (this.opts.formattingHide)
        {
            for (var key in this.items)
            {
                if (this.opts.formattingHide.indexOf(key) !== -1) delete this.items[key];
            }
        }

        // add to the format set
        if (this.opts.formattingAdd)
        {
            for (var key in this.opts.formattingAdd)
            {
                this.items[key] = this.opts.formattingAdd[key];
            }
        }

        return this.items;
    },
    _handleKeyboard: function(e)
    {
        if (e.which === 27) this.close();
    },
    _isButton: function(e)
    {
        var $el = $R.dom(e.target);
        var $btn = $el.closest('.re-button');

        return ($btn.get() === this.$btn.get());
    },
    _close: function()
    {
        this.$btn.setInactive();
        this.$doc.off('.redactor.dropdown-' + this.uuid);
        this.removeClass('open');
        this.addClass('redactor-animate-hide');
        this.app.broadcast('dropdown.closed', this, this.$btn);
    },
    _closeAll: function()
    {
        this.$body.find('.redactor-dropdown-' + this.uuid + '.open').each(function(node)
        {
            var $node = $R.dom(node);
            var instance =  $node.dataget('data-dropdown-instance');
            instance._close();
        });
    },
    _observe: function()
    {
        var observer = this.attr('data-observe');
        if (observer)
        {
            this.app.broadcast('dropdown.' + observer + '.observe', this);
        }
    }
});
$R.add('class', 'toolbar.dropdown.item', {
    mixins: ['dom'],
    init: function(app, name, obj, dropdown)
    {
        this.app = app;
        this.lang = app.lang;

        // local
        this.dropdown = dropdown;
        this.name = name;
        this.obj = obj;

        // init
        this._init();
    },
    setTitle: function(html)
    {
        this.$span.html(html);
    },
    getTitle: function()
    {
        return this.$span.html();
    },
    enable: function()
    {
        this.removeClass('redactor-dropdown-item-disabled');
    },
    disable: function()
    {
        this.addClass('redactor-dropdown-item-disabled');
    },
    toggle: function(e)
    {
        if (e) e.preventDefault();
        if (this.hasClass('redactor-dropdown-item-disabled')) return;

        if (this.obj.message)
        {
            // broadcast
            this.app.broadcast(this.obj.message, this.obj.args, this.name);
        }
        else if (this.obj.api)
        {
            this.app.api(this.obj.api, this.obj.args, this.name);
        }
    },

    // private
    _init: function()
    {
        this.parse('<a>');
        this.attr('href', '#');
        this.addClass('redactor-dropdown-item-' + this.name);

        if (this.obj.classname)
        {
            this.addClass(this.obj.classname);
        }

        this.attr('data-re-name', this.name);
        this.on('click', this.toggle.bind(this));

        this.$span = $R.dom('<span>');
        this.append(this.$span);
        this.setTitle(this.lang.parse(this.obj.title));
    }
});
$R.add('service', 'cleaner', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;

        // local
        this.storedComponents = [];
        this.storedImages = [];
        this.storedLinks = [];
        this.deniedTags = ['font', 'html', 'head', 'link', 'title', 'body', 'meta', 'applet'];
        this.convertRules = {};
        this.unconvertRules = {};

        // regex
        this.reComments = /<!--[\s\S]*?-->/g;
        this.reSpacedEmpty = /^(||\s||<br\s?\/?>||&nbsp;)$/i;
        this.reScriptTag = /<script(.*?[^>]?)>([\w\W]*?)<\/script>/gi;
    },
    // public
    addConvertRules: function(name, func)
    {
        this.convertRules[name] = func;
    },
    addUnconvertRules: function(name, func)
    {
        this.unconvertRules[name] = func;
    },
    input: function(html, paragraphize, started)
    {
        // pre/code
        html = this.encodePreCode(html);

        // converting entity
        html = html.replace(/\$/g, '&#36;');
        html = html.replace(/&amp;/g, '&');

        // convert to figure
        var converter = $R.create('cleaner.figure', this.app);
        html = converter.convert(html, this.convertRules);

        // store components
        html = this.storeComponents(html);

        // clean
        html = this.replaceTags(html, this.opts.replaceTags);
        html = this._setSpanAttr(html);
        html = this._setStyleCache(html);
        html = this.removeTags(html, this.deniedTags);
        html = (this.opts.removeScript) ? this._removeScriptTag(html) : this._replaceScriptTag(html);
        //html = (this.opts.removeScript) ? this._removeScriptTag(html) : html;
        html = (this.opts.removeComments) ? this.removeComments(html) : html;
        html = (this._isSpacedEmpty(html)) ? this.opts.emptyHtml : html;

        // restore components
        html = this.restoreComponents(html);

        // clear wrapped components
        html = this._cleanWrapped(html);

        // remove image attributes
        var $wrapper = this.utils.buildWrapper(html);
        var imageattrs = ['alt', 'title', 'src', 'class', 'width', 'height', 'srcset'];
        $wrapper.find('img').each(function(node) {
            if (node.attributes.length > 0) {
                var attrs = node.attributes;
                for (var i = attrs.length - 1; i >= 0; i--) {
                    if (attrs[i].name.search(/^data\-/) === -1 && imageattrs.indexOf(attrs[i].name) === -1) {
                        node.removeAttribute(attrs[i].name);
                    }
                }
            }
        });

        // get wrapper html
        html = this.utils.getWrapperHtml($wrapper);

        // paragraphize
        html = (paragraphize) ? this.paragraphize(html) : html;

        return html;
    },
    output: function(html, removeMarkers)
    {
        html = this.removeInvisibleSpaces(html);

        html = html.replace(/&#36;/g, '$');

        // empty
        if (this._isSpacedEmpty(html)) return '';
        if (this._isParagraphEmpty(html)) return '';

        html = this.removeServiceTagsAndAttrs(html, removeMarkers);

        // store components
        html = this.storeComponents(html);

        html = this.removeSpanWithoutAttributes(html);
        html = this.removeFirstBlockBreaklineInHtml(html);

        html = (this.opts.removeScript) ? html : this._unreplaceScriptTag(html);
        html = (this.opts.preClass) ? this._setPreClass(html) : html;
        html = (this.opts.linkNofollow) ? this._setLinkNofollow(html) : html;
        html = (this.opts.removeNewLines) ? this.cleanNewLines(html) : html;

        // restore components
        html = this.restoreComponents(html);

        // convert to figure
        var converter = $R.create('cleaner.figure', this.app);
        html = converter.unconvert(html, this.unconvertRules);

        // final clean up
        html = this.removeEmptyAttributes(html, ['style', 'class', 'rel', 'alt', 'title']);
        html = this.cleanSpacesInPre(html);
        html = this.tidy(html);

        // converting entity
        html = html.replace(/&amp;/g, '&');

        // breakline tidy
        if (this.opts.breakline) {
            html = html.replace(/<br\s?\/?>/gi, "<br>\n");
            html = html.replace(/<br\s?\/?>\n+/gi, "<br>\n");
        }

        // check whitespaces
        html = (html.replace(/\n/g, '') === '') ? '' : html;

        return html;
    },
    paste: function(html)
    {
        // store components
        html = this.storeComponents(html);

        // remove tags
        var deniedTags = this.deniedTags.concat(['iframe']);
        html = this.removeTags(html, deniedTags);

        // remove doctype tag
        html = html.replace(new RegExp("<\!doctype([\\s\\S]+?)>", 'gi'), '');

        // remove style tag
        html = html.replace(new RegExp("<style([\\s\\S]+?)</style>", 'gi'), '');

        // remove br between
        html = html.replace(new RegExp("</p><br /><p", 'gi'), '</p><p');

        // gdocs & word
        var isMsWord = this._isHtmlMsWord(html);

        html = this._cleanGDocs(html);
        html = (isMsWord) ? this._cleanMsWord(html) : html;

        // do not clean
        if (!this.opts.pasteClean)
        {
            // restore components
            html = this.restoreComponents(html);

            return html;
        }

        // plain text
        if (this.opts.pastePlainText)
        {
            // restore components
            html = this.restoreComponents(html);

            return this.pastePlainText(html);
        }

        // remove tags
        var exceptedTags = this.opts.pasteBlockTags.concat(this.opts.pasteInlineTags);
        html = this.removeTagsExcept(html, exceptedTags);

        // links & images
        html = (this.opts.pasteLinks) ? html : this.removeTags(html, ['a']);
        html = (this.opts.pasteImages) ? html : this.removeTags(html, ['img']);

        // build wrapper
        var $wrapper = this.utils.buildWrapper(html);

        // clean attrs
        var $elms = $wrapper.find('*');

        // remove style
        var filterStyle = (this.opts.pasteKeepStyle.length !== 0) ? ',' + this.opts.pasteKeepStyle.join(',') : '';
        $elms.not('[data-redactor-style-cache]' + filterStyle).removeAttr('style');

        // remove class
        var filterClass = (this.opts.pasteKeepClass.length !== 0) ? ',' + this.opts.pasteKeepClass.join(',') : '';
        $elms.not('[data-redactor-style-cache], span.redactor-component' + filterClass).removeAttr('class');

        // remove attrs
        var filterAttrs = (this.opts.pasteKeepAttrs.length !== 0) ? ',' + this.opts.pasteKeepAttrs.join(',') : '';
        $elms.not('img, a, span.redactor-component, [data-redactor-style-cache]' + filterAttrs).each(function(node)
        {
            var attrs = node.attributes;
            for (var i = attrs.length - 1; i >= 0; i--) {
                if (node.attributes[0].name !== 'class') {
                    node.removeAttribute(attrs[i].name);
                }
            }
        });

        // paste link target
        if (this.opts.pasteLinks && this.opts.pasteLinkTarget !== false)
        {
            $wrapper.find('a').attr('target', this.opts.pasteLinkTarget);
        }

        // keep style
        $wrapper.find('[data-redactor-style-cache]').each(function(node)
        {
            var style = node.getAttribute('data-redactor-style-cache');
            node.setAttribute('style', style);
        });

        // remove image attributes
        var imageattrs = this.opts.imageAttrs;
        $wrapper.find('img').each(function(node) {
            if (node.attributes.length > 0) {
                var attrs = node.attributes;
                for (var i = attrs.length - 1; i >= 0; i--) {
                    if (imageattrs.indexOf(attrs[i].name) === -1) {
                        node.removeAttribute(attrs[i].name);
                    }
                }
            }
        });

        // remove empty span
        $wrapper.find('span').each(function(node)
        {
            if (node.attributes.length === 0)
            {
                $R.dom(node).unwrap();
            }
        });

        // remove empty inline
        $wrapper.find(this.opts.inlineTags.join(',')).each(function(node)
        {
            if (node.attributes.length === 0 && this.utils.isEmptyHtml(node.innerHTML))
            {
                $R.dom(node).unwrap();
            }

        }.bind(this));

        // place ul/ol into li
        $wrapper.find('ul, ol').each(function(node)
        {
            var prev = node.previousSibling;
            if (prev && prev.tagName === 'LI')
            {
                var $li = $R.dom(prev);
                $li.find('p').unwrap();
                $li.append(node);
            }
        });

        // get wrapper
        html = this.utils.getWrapperHtml($wrapper);

        // remove paragraphs form lists (google docs bug)
        html = html.replace(/<li><p>/gi, '<li>');
        html = html.replace(/<\/p><\/li>/gi, '</li>');

        // convert lines to br
        if (this.opts.breakline) {
            html = html.replace(/\n/g, '<br>');
        }

        // clean empty p
        html = html.replace(/<p>&nbsp;<\/p>/gi, '<p></p>');
        html = html.replace(/<p><br\s?\/?><\/p>/gi, '<p></p>');

        if (isMsWord)
        {
            html = html.replace(/<p><\/p>/gi, '');
            html = html.replace(/<p>\s<\/p>/gi, '');
        }

        // restore components
        html = this.restoreComponents(html);

        return html;
    },
    pastePlainText: function(html)
    {
        html = (this.opts.pasteLinks) ? this.storeLinks(html) : html;
        html = (this.opts.pasteImages) ? this.storeImages(html) : html;

        html = this.getPlainText(html);
        html = this._replaceNlToBr(html);

        html = (this.opts.pasteLinks) ? this.restoreLinks(html) : html;
        html = (this.opts.pasteImages) ? this.restoreImages(html) : html;

        return html;
    },
    tidy: function(html)
    {
        return html;
    },
    paragraphize: function(html)
    {
        var paragraphize = $R.create('cleaner.paragraphize', this.app);
        html = paragraphize.convert(html);
        return html;
    },

    // get
    getFlatText: function(html)
    {
        var $div = $R.dom('<div>');

        if (!html.nodeType && !html.dom)
        {
            html = html.toString();
            html = html.trim();
            $div.html(html);
        }
        else
        {
            $div.append(html);
        }

        html = $div.get().textContent || $div.get().innerText || '';

        return (html === undefined) ? '' : html;
    },
	getPlainText: function(html)
	{
		html = html.replace(/<!--[\s\S]*?-->/gi, '');
		html = html.replace(/<style[\s\S]*?style>/gi, '');
        html = html.replace(/<p><\/p>/g, '');
		html = html.replace(/<\/div>|<\/li>|<\/td>/gi, '\n');
		html = html.replace(/<\/p>/gi, '\n\n');
		html = html.replace(/<\/H[1-6]>/gi, '\n\n');

		var tmp = document.createElement('div');
		tmp.innerHTML = html;

		html = tmp.textContent || tmp.innerText;

		return html.trim();
	},

    // replace
    replaceTags: function(html, tags)
    {
        if (tags)
        {
            var self = this;
            var keys = Object.keys(tags);
            var $wrapper = this.utils.buildWrapper(html);
            $wrapper.find(keys.join(',')).each(function(node)
            {
                self.utils.replaceToTag(node, tags[node.tagName.toLowerCase()]);
            });

            html = this.utils.getWrapperHtml($wrapper);
        }

        return html;
    },
    replaceNbspToSpaces: function(html)
    {
        return html.replace('&nbsp;', ' ');
    },
    replaceBlocksToBr: function(html)
    {
        html = html.replace(/<\/div>|<\/li>|<\/td>|<\/p>|<\/H[1-6]>/gi, '<br>');

        return html;
    },

    // clean
    cleanNewLines: function(html)
    {
        return html.replace(/\r?\n/g, "");
    },
    cleanSpacesInPre: function(html)
    {
        return html.replace('&nbsp;&nbsp;&nbsp;&nbsp;', '    ');
    },

    // remove
    removeInvisibleSpaces: function(html)
    {
        html = this.utils.removeInvisibleChars(html);
        html = html.replace(/&#65279;/gi, '');

        return html;
    },
    removeNl: function(html)
    {
        html = html.replace(/\n/g, " ");
        html = html.replace(/\s+/g, "\s");

        return html;
    },
    removeBrAtEnd: function(html)
    {
        html = html.replace(/<br\s?\/?>$/gi, ' ');
        html = html.replace(/<br\s?\/?><li/gi, '<li');

        return html;
    },
    removeTags: function(input, denied)
    {
        var re = (denied) ? /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi : /(<([^>]+)>)/gi;
        var replacer = (!denied) ? '' : function ($0, $1)
        {
            return denied.indexOf($1.toLowerCase()) === -1 ? $0 : '';
        };

        return input.replace(re, replacer);
    },
    removeTagsExcept: function(input, except)
    {
        if (except === undefined) return input.replace(/(<([^>]+)>)/gi, '');

        var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;
        return input.replace(tags, function($0, $1)
        {
            return except.indexOf($1.toLowerCase()) === -1 ? '' : $0;
        });
    },
    removeComments: function(html)
    {
        return html.replace(this.reComments, '');
    },
    removeServiceTagsAndAttrs: function(html, removeMarkers)
    {
        var $wrapper = this.utils.buildWrapper(html);
        var self = this;
        if (removeMarkers !== false)
        {
            $wrapper.find('.redactor-selection-marker').each(function(node)
            {
                var $el = $R.dom(node);
                var text = self.utils.removeInvisibleChars($el.text());

                return (text === '') ? $el.remove() : $el.unwrap();
            });
        }

        $wrapper.find('[data-redactor-style-cache]').removeAttr('data-redactor-style-cache');

        return this.utils.getWrapperHtml($wrapper);
    },
    removeSpanWithoutAttributes: function(html)
    {
        var $wrapper = this.utils.buildWrapper(html);
        $wrapper.find('span').removeAttr('data-redactor-span data-redactor-style-cache').each(function(node)
        {
            if (node.attributes.length === 0) $R.dom(node).unwrap();
        });

        return this.utils.getWrapperHtml($wrapper);
    },
    removeFirstBlockBreaklineInHtml: function(html)
    {
        return html.replace(new RegExp('</li><br\\s?/?>', 'gi'), '</li>');
    },
    removeEmptyAttributes: function(html, attrs)
    {
        var $wrapper = this.utils.buildWrapper(html);
        for (var i = 0; i < attrs.length; i++)
        {
            $wrapper.find('[' + attrs[i] + '=""]').removeAttr(attrs[i]);
        }

        return this.utils.getWrapperHtml($wrapper);
    },

    // encode / decode
    encodeHtml: function(html)
    {
        html = html.replace(/<br\s?\/?>/g, "\n");
        html = html.replace(/&nbsp;/g, ' ');
        html = html.replace(/”/g, '"');
        html = html.replace(/“/g, '"');
        html = html.replace(/‘/g, '\'');
        html = html.replace(/’/g, '\'');
        html = this.encodeEntities(html);
        html = html.replace(/\$/g, '&#36;');

        if (this.opts.preSpaces)
        {
            html = html.replace(/\t/g, new Array(this.opts.preSpaces + 1).join(' '));
        }

        return html;
    },
    encodePreCode: function(html)
    {
        var matched = html.match(new RegExp('<code(.*?)>(.*?)<pre(.*?)>(.*?)</pre>(.*?)</code>', 'gi'));
        if (matched !== null)
        {
            for (var i = 0; i < matched.length; i++)
            {
                var arr = matched[i].match(new RegExp('<pre(.*?)>([\\w\\W]*?)</pre>', 'i'));
                html = html.replace(arr[0], this.encodeEntities(arr[0]));
            }
        }

        var $wrapper = this.utils.buildWrapper(html);

        $wrapper.find('code code').replaceWith(this._encodeOuter.bind(this));
        $wrapper.find('code pre').replaceWith(this._encodeOuter.bind(this));
        $wrapper.find('pre pre').replaceWith(this._encodeOuter.bind(this));
        $wrapper.find('code, pre').each(this._encodePreCodeLine.bind(this));

        html = this.utils.getWrapperHtml($wrapper);

        // restore markers
        html = this._decodeMarkers(html);

        return html;
    },
    encodeEntities: function(str)
    {
        str = this.decodeEntities(str);
        str = str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

        return str;
    },
    encodePhpCode: function(html)
    {
        html = html.replace('<?php', '&lt;?php');
        html = html.replace('<?', '&lt;?');
        html = html.replace('?>', '?&gt;');

        return html;
    },
    decodeEntities: function(str)
    {
        return String(str).replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&amp;/g, '&');
    },

    // store / restore
    storeComponents: function(html)
    {
        var matched = this.utils.getElementsFromHtml(html, 'figure', 'table');

        return this._storeMatched(html, matched, 'Components', 'figure');
    },
    restoreComponents: function(html)
    {
        return this._restoreMatched(html, 'Components', 'figure');
    },
    storeLinks: function(html)
    {
        var matched = this.utils.getElementsFromHtml(html, 'a');

        return this._storeMatched(html, matched, 'Links', 'a');
    },
    storeImages: function(html)
    {
        var matched = this.utils.getElementsFromHtml(html, 'img');

        return this._storeMatched(html, matched, 'Images', 'img');
    },
    restoreLinks: function(html)
    {
        return this._restoreMatched(html, 'Links', 'a');
    },
    restoreImages: function(html)
    {
        return this._restoreMatched(html, 'Images', 'img');
    },

    // PRIVATE

    // clean
    _cleanWrapped: function(html)
    {
        html = html.replace(new RegExp('<p><figure([\\w\\W]*?)</figure></p>', 'gi'), '<figure$1</figure>');

        return html;
    },
    _cleanGDocs: function(html)
    {
        // remove google docs markers
        html = html.replace(/<b\sid="internal-source-marker(.*?)">([\w\W]*?)<\/b>/gi, "$2");
        html = html.replace(/<b(.*?)id="docs-internal-guid(.*?)">([\w\W]*?)<\/b>/gi, "$3");

        html = html.replace(/<span[^>]*(font-style:\s?italic;\s?font-weight:\s?bold|font-weight:\s?bold;\s?font-style:\s?italic)[^>]*>([\w\W]*?)<\/span>/gi, '<b><i>$2</i></b>');
        html = html.replace(/<span[^>]*(font-style:\s?italic;\s?font-weight:\s?600|font-weight:\s?600;\s?font-style:\s?italic)[^>]*>([\w\W]*?)<\/span>/gi, '<b><i>$2</i></b>');
        html = html.replace(/<span[^>]*(font-style:\s?italic;\s?font-weight:\s?700|font-weight:\s?700;\s?font-style:\s?italic)[^>]*>([\w\W]*?)<\/span>/gi, '<b><i>$2</i></b>');
        html = html.replace(/<span[^>]*font-style:\s?italic[^>]*>([\w\W]*?)<\/span>/gi, '<i>$1</i>');
        html = html.replace(/<span[^>]*font-weight:\s?bold[^>]*>([\w\W]*?)<\/span>/gi, '<b>$1</b>');
        html = html.replace(/<span[^>]*font-weight:\s?700[^>]*>([\w\W]*?)<\/span>/gi, '<b>$1</b>');
        html = html.replace(/<span[^>]*font-weight:\s?600[^>]*>([\w\W]*?)<\/span>/gi, '<b>$1</b>');

        return html;
    },
    _cleanMsWord: function(html)
    {
        html = html.replace(/<!--[\s\S]+?-->/gi, '');
        html = html.replace(/<(!|script[^>]*>.*?<\/script(?=[>\s])|\/?(\?xml(:\w+)?|img|meta|link|style|\w:\w+)(?=[\s\/>]))[^>]*>/gi, '');
        html = html.replace(/<(\/?)s>/gi, "<$1strike>");
        html = html.replace(/&nbsp;/gi, ' ');
        html = html.replace(/<span\s+style\s*=\s*"\s*mso-spacerun\s*:\s*yes\s*;?\s*"\s*>([\s\u00a0]*)<\/span>/gi, function(str, spaces) {
            return (spaces.length > 0) ? spaces.replace(/./, " ").slice(Math.floor(spaces.length/2)).split("").join("\u00a0") : '';
        });

        // build wrapper
        var $wrapper = this.utils.buildWrapper(html);

        // footnote fix
        $wrapper.find('.MsoFootnoteText').each(function(node) {
            var $node = $R.dom(node);
            var $parent = $node.parent();
            if ($parent.length !== 0 && $parent.attr('style').search(/mso-element:footnote/) !== -1) {
                $node.find('a').attr('id', '_' + $parent.attr('id'));
            }

        });

        $wrapper.find('.MsoFootnoteReference').each(function(node) {
            var $node = $R.dom(node);
            var $parent = $node.parent();
            if ($parent.length !== 0 && $parent.get().tagName === 'A') {
                $parent.attr('id', $parent.attr('name'));
            }

        });

        // build lists
        $wrapper.find('p').each(function(node)
        {
            var $node = $R.dom(node);
            var str = $node.attr('style');
            var matches = /mso-list:\w+ \w+([0-9]+)/.exec(str);
            if (matches)
            {
                $node.data('_listLevel',  parseInt(matches[1], 10));
            }
        });

        // parse Lists
        this._parseWordLists($wrapper);

        $wrapper.find('[align]').removeAttr('align');
        $wrapper.find('[name]').removeAttr('name');
        $wrapper.find('span').each(function(node)
        {
            var $node = $R.dom(node);
            var str = $node.attr('style');
            var matches = /mso-list:Ignore/.exec(str);

            if (matches) $node.remove();
            else $node.unwrap();

        });
        $wrapper.find('[style]').removeAttr('style');
        $wrapper.find("[class^='Mso']").removeAttr('class');
        $wrapper.find('a').filter(function(node) { return !node.hasAttribute('href'); }).unwrap();

        // get wrapper
        html = this.utils.getWrapperHtml($wrapper);
        html = html.replace(/<p[^>]*><\/p>/gi, '');
        html = html.replace(/<li>·/gi, '<li>');
        html = html.trim();

        // remove spaces between
        html = html.replace(/\/(p|ul|ol|h1|h2|h3|h4|h5|h6|blockquote)>\s+<(p|ul|ol|h1|h2|h3|h4|h5|h6|blockquote)/gi, '/$1>\n<$2');

        var result = '';
        var lines = html.split(/\n/);
        for (var i = 0; i < lines.length; i++)
        {
            var space = (lines[i] !== '' && lines[i].search(/>$/) === -1) ? ' ' : '\n';

            result += lines[i] + space;
        }

        return result;
    },
    _parseWordLists: function($wrapper)
    {
        var lastLevel = 0;
        var $item = null;
        var setPnt = false;
        var $list = null;

        $wrapper.find('p').each(function(node) {
            var $node = $R.dom(node);
            var currentLevel = $node.data('_listLevel');
            if (currentLevel === null && $node.hasClass('MsoListParagraphCxSpMiddle')) {
                currentLevel = 1;
            }

            if (currentLevel !== null) {
                var txt = $node.text();
                var listTag = (/^\s*\w+\./.test(txt)) ? '<ol></ol>' : '<ul></ul>';

                if ($node.hasClass('MsoListParagraphCxSpFirst')) {
                    $node.before(listTag);
                    $list = $node.prev();
                }

                if (currentLevel > lastLevel && lastLevel !== 0) {
                    var $list2 = $R.dom(listTag);
                    if ($item) {
                        $item.append($list2);
                        $list = $list2;
                        setPnt = true;
                    }
                }

                $node.find('span').first().unwrap();
                $item = $R.dom('<li>' + $node.html().trim() + '</li>');
                if ($list === null) {
                    $node.before(listTag);
                    $list = $node.prev();
                }
                $list.append($item);
                $node.remove();

                if (setPnt) {
                    $list = $list.parent();
                }

                lastLevel = currentLevel;
                setPnt = false;
            }
            else {
                lastLevel = 0;
            }
        });
    },

    // is
    _isSpacedEmpty: function(html)
    {
        return (html.search(this.reSpacedEmpty) !== -1);
    },
    _isParagraphEmpty: function(html)
    {
        return (html.search(/^<p><\/p>$/i) !== -1);
    },
    _isHtmlMsWord: function(html)
    {
        return html.match(/class="?Mso|style="[^"]*\bmso-|style='[^'']*\bmso-|w:WordDocument/i);
    },

    // set
    _setSpanAttr: function(html)
    {
        var $wrapper = this.utils.buildWrapper(html);
        $wrapper.find('span').attr('data-redactor-span', true);

        return this.utils.getWrapperHtml($wrapper);
    },
    _setStyleCache: function(html)
    {
        var $wrapper = this.utils.buildWrapper(html);
        $wrapper.find('[style]').each(function(node)
        {
            var $el = $R.dom(node);
            $el.attr('data-redactor-style-cache', $el.attr('style'));
        });

        return this.utils.getWrapperHtml($wrapper);
    },
    _setPreClass: function(html)
    {
        var $wrapper = this.utils.buildWrapper(html);
        $wrapper.find('pre').addClass(this.opts.preClass);

        return this.utils.getWrapperHtml($wrapper);
    },
    _setLinkNofollow: function(html)
    {
        var $wrapper = this.utils.buildWrapper(html);
        $wrapper.find('a').attr('rel', 'nofollow');

        return this.utils.getWrapperHtml($wrapper);
    },

    // replace
    _replaceScriptTag: function(html)
    {
        return html.replace(this.reScriptTag, '<script class="redactor-script-tag" $1>$2</script>');
    },
    _unreplaceScriptTag: function(html)
    {
        return html.replace(/<script class="redactor-script-tag"(.*?[^>]?)>([\w\W]*?)<\/script>/gi, '<script$1>$2</script>');
    },
	_replaceNlToBr: function(html)
	{
		return html.replace(/\n/g, '<br />');
	},

    // remove
    _removeScriptTag: function(html)
    {
        return html.replace(this.reScriptTag, '');
    },

    // private
    _storeMatched: function(html, matched, stored, name)
    {
        this['stored' + stored] = [];
        if (matched)
        {
            for (var i = 0; i < matched.length; i++)
            {
                this['stored' + stored][i] = matched[i];
                html = html.replace(matched[i], '####' + name + i + '####');
            }
        }

        return html;
    },
    _restoreMatched: function(html, stored, name)
    {
        if (this['stored' + stored])
        {
            for (var i = 0; i < this['stored' + stored].length; i++)
            {
                html = html.replace('####' + name + i + '####', this['stored' + stored][i]);
            }
        }

        return html;
    },
    _decodeMarkers: function(html)
    {
        var decodedMarkers = '<span id="selection-marker-$1" class="redactor-selection-marker">​</span>';
        return html.replace(/&lt;span\sid="selection-marker-(start|end)"\sclass="redactor-selection-marker"&gt;(.*?[^>]?)&lt;\/span&gt;/g, decodedMarkers);
    },
    _encodeOuter: function(node)
    {
        return this.encodeEntities(node.outerHTML);
    },
    _encodePreCodeLine: function(node)
    {
        var first = node.firstChild;
        if (node.tagName == 'PRE' && (first && first.tagName === 'CODE')) return;

        var encoded = this.decodeEntities(node.innerHTML);
        encoded = encoded.replace(/&nbsp;/g, ' ').replace(/<br\s?\/?>/g, '\n');
        encoded = (this.opts.preSpaces) ? encoded.replace(/\t/g, new Array(this.opts.preSpaces + 1).join(' ')) : encoded;

        node.textContent = encoded;
    }
});
$R.add('class', 'cleaner.figure', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.utils = app.utils;
        this.detector = app.detector;
    },
    // public
    convert: function(html, rules)
    {
        var $wrapper = this.utils.buildWrapper(html);

        // convert
        $wrapper.find('img').each(this._convertImage.bind(this));
        $wrapper.find('hr').each(this._convertLine.bind(this));
        $wrapper.find('iframe').each(this._convertIframe.bind(this));
        $wrapper.find('table').each(this._convertTable.bind(this));
        $wrapper.find('form').each(this._convertForm.bind(this));
        $wrapper.find('figure pre').each(this._convertCode.bind(this));

        // variables
        $wrapper.find('[data-redactor-type=variable]').addClass('redactor-component');

        // widgets
        $wrapper.find('figure').not('.redactor-component, .redactor-figure-code').each(this._convertWidget.bind(this));

        // contenteditable
        $wrapper.find('figure pre').each(this._setContenteditableCode.bind(this));
        $wrapper.find('.redactor-component, .non-editable').attr('contenteditable', false);

        if (this.detector.isIe())
        {
            $wrapper.find('[data-redactor-type=table]').removeAttr('contenteditable');
        }

        $wrapper.find('figcaption, td, th').attr('contenteditable', true);
        $wrapper.find('.redactor-component, figcaption').attr('tabindex', '-1');

        // extra rules
        this._acceptExtraRules($wrapper, rules);

        return this.utils.getWrapperHtml($wrapper);
    },
    unconvert: function(html, rules)
    {
        var $wrapper = this.utils.buildWrapper(html);

        // contenteditable
        $wrapper.find('th, td, figcaption, figure, pre, code, .redactor-component').removeAttr('contenteditable tabindex');

        // remove class
        $wrapper.find('figure').removeClass('redactor-component redactor-component-active redactor-uploaded-figure');

        // unconvert
        $wrapper.find('[data-redactor-type=variable]').removeClass('redactor-component redactor-component-active');
        $wrapper.find('figure[data-redactor-type=line]').unwrap();
        $wrapper.find('figure[data-redactor-type=widget]').each(this._unconvertWidget.bind(this));
        $wrapper.find('figure[data-redactor-type=form]').each(this._unconvertForm.bind(this));
        $wrapper.find('figure[data-redactor-type=table]').each(this._unconvertTable.bind(this));
        $wrapper.find('figure[data-redactor-type=image]').removeAttr('rel').each(this._unconvertImages.bind(this));

        $wrapper.find('img').removeAttr('data-redactor-type').removeClass('redactor-component');
        $wrapper.find('.non-editable').removeAttr('contenteditable');

        // remove types
        $wrapper.find('figure').each(this._removeTypes.bind(this));

        // remove caret
        $wrapper.find('span.redactor-component-caret').remove();

        if (this.opts.breakline)
        {
            $wrapper.find('[data-redactor-tag="br"], [data-redactor-tag="tbr"]').each(function(node) {
                var $node = $R.dom(node);
                var $next = $node.nextElement();
                var tbr = ($node.attr('data-redactor-tag') === 'tbr');

                if (this.utils.isEmptyHtml($node.html())) {
                    $node.html('<br>');
                }
                else if (node.lastChild && node.lastChild.tagName !== 'BR') {
                    if (tbr) {
                        if ($next.length !== 0 && $next.attr('data-redactor-tag')) {
                            node.appendChild(document.createElement('br'));
                        }
                    }
                    else {
                        node.appendChild(document.createElement('br'));
                    }
                }
            }.bind(this)).unwrap();
        }
        else {
            // table markup
            $wrapper.find('[data-redactor-tag="tbr"]').each(function(node) {
                var $node = $R.dom(node);
                $node.removeAttr('data-redactor-tag');

                if (this.opts.markup !== 'div') {
                    var $next = $node.nextElement();
                    if ($next.length !== 0 && $next.attr('data-redactor-tag')) {
                        node.appendChild(document.createElement('br'));
                    }

                    $node.unwrap();
                }

            }.bind(this));
        }

        // extra rules
        this._acceptExtraRules($wrapper, rules);

        html = this.utils.getWrapperHtml($wrapper);
        html = html.replace(/<br\s?\/?>$/, '');

        return html;
    },

    // private
    _convertImage: function(node)
    {
        var $node = $R.dom(node);
        if (this._isNonEditable($node)) return;

        // set id
        if (this.opts.imageObserve && !$node.attr('data-image'))
        {
            $node.attr('data-image', this.utils.getRandomId());
        }

        var $link = $node.closest('a');
        var $figure = $node.closest('figure');
        var isImage = ($figure.children().not('a, img, br, figcaption').length === 0);
        if (!isImage) return;

        if ($figure.length === 0)
        {
            var $parent = ($link.length !== 0) ? $link.closest('p') : $node.closest('p');
            if (this.opts.imageFigure === false && $parent.length !== 0)
            {
                var $el = this.utils.replaceToTag($parent, 'figure');
                $figure = $el;
                $figure.addClass('redactor-replace-figure');
            }
            else
            {
                if ($parent.length !== 0) {
                    $parent.unwrap();
                }

                $figure = ($link.length !== 0) ? $link.wrap('<figure>') : $node.wrap('<figure>');
            }
        }
        else
        {
            if ($figure.hasClass('redactor-uploaded-figure'))
            {
                $figure.removeClass('redactor-uploaded-figure');
            }
            else
            {
                $figure.addClass('redactor-keep-figure');
            }
        }

        this._setFigure($figure, 'image');
    },
    _convertTable: function(node)
    {
        if (this._isNonEditable(node)) return;

        var $figure = this._wrapFigure(node);
        this._setFigure($figure, 'table');
    },
    _convertLine: function(node)
    {
        if (this._isNonEditable(node)) return;

        var $figure = this._wrapFigure(node);
        this._setFigure($figure, 'line');
    },
    _convertForm: function(node)
    {
        if (this._isNonEditable(node)) return;

        var $figure = this.utils.replaceToTag(node, 'figure');
        this._setFigure($figure, 'form');
    },
    _convertIframe: function(node)
    {
        if (this._isNonEditable(node)) return;

        var $node = $R.dom(node);
        if ($node.closest('.redactor-component').length !== 0) return;

        var src = node.getAttribute('src');
        var isVideo = (src && (src.match(this.opts.regex.youtube) || src.match(this.opts.regex.vimeo)));
        var $figure = this._wrapFigure(node);

        if (isVideo)
        {
            this._setFigure($figure, 'video');
        }
    },
    _convertCode: function(node)
    {
        if (this._isNonEditable(node)) return;

        var $figure = this._wrapFigure(node);
        this._setFigure($figure, 'code');
    },
    _convertWidget: function(node)
    {
        if (this._isNonEditable(node)) return;

        var $node = $R.dom(node);
        $node.addClass('redactor-component');
        $node.attr('data-redactor-type', 'widget');
        $node.attr('data-widget-code', encodeURI(node.innerHTML.trim()));
    },

    // unconvert
    _unconvertForm: function(node)
    {
        this.utils.replaceToTag(node, 'form');
    },
    _unconvertTable: function(node)
    {
        var $node = $R.dom(node);
        $node.unwrap();
    },
    _unconvertWidget: function(node)
    {
        var $node = $R.dom(node);
        $node.html(decodeURI($node.attr('data-widget-code')));
        $node.removeAttr('data-widget-code');
    },
    _unconvertImages: function(node)
    {
        var $node = $R.dom(node);
        $node.removeClass('redactor-component');

        var isList = ($node.closest('li').length !== 0);
        var isTable = ($node.closest('table').length !== 0);
        var hasFigcaption = ($node.find('figcaption').length !== 0);

        var style = $node.attr('style');
        var hasStyle = !(style === null || style === '');
        var hasClass = ($node.attr('class') !== '');

        if (isList || (isTable && !hasFigcaption && !hasStyle && !hasClass))
        {
            $node.unwrap();
        }
    },
    _removeTypes: function(node)
    {
        var $node = $R.dom(node);
        var type = $node.attr('data-redactor-type');
        var removed = ['image', 'widget', 'line', 'video', 'code', 'form', 'table'];
        if (type && removed.indexOf(type) !== -1)
        {
            $node.removeAttr('data-redactor-type');
        }

        // keep figure
        if ($node.hasClass('redactor-keep-figure'))
        {
            $node.removeClass('redactor-keep-figure');
        }

        // unwrap figure
        else if (type === 'image' && this.opts.imageFigure === false)
        {
            var hasFigcaption = ($node.find('figcaption').length !== 0);
            if (!hasFigcaption)
            {
                // replace
                if ($node.hasClass('redactor-replace-figure'))
                {
                    $node.removeClass('redactor-replace-figure');
                    this.utils.replaceToTag($node, 'p');
                }
                else
                {
                    $node.unwrap();
                }
            }
        }

        $node.removeClass('redactor-replace-figure');
    },

    // wrap
    _wrapFigure: function(node)
    {
        var $node = $R.dom(node);
        var $figure = $node.closest('figure');

        return ($figure.length === 0) ? $node.wrap('<figure>') : $figure;
    },

    // set
    _setFigure: function($figure, type)
    {
        $figure.addClass('redactor-component');
        $figure.attr('data-redactor-type', type);
    },
    _setContenteditableCode: function(node)
    {
        if (this._isNonEditable(node)) return;

        var $node = $R.dom(node);
        var $code = $node.children('code').first();

        var $el = ($code.length !== 0) ? $code : $node;
        $el.attr('contenteditable', true).attr('tabindex', '-1');
    },

    // utils
    _acceptExtraRules: function($wrapper, rules)
    {
        for (var key in rules)
        {
            if (typeof rules[key] === 'function')
            {
                rules[key]($wrapper);
            }
        }
    },
    _isNonEditable: function(node)
    {
        return ($R.dom(node).closest('.non-editable').length !== 0);
    }
});
$R.add('class', 'cleaner.paragraphize', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.utils = app.utils;
        this.element = app.element;

        // local
        this.stored = [];
        this.remStart = '#####replace';
        this.remEnd = '#####';
        this.paragraphizeTags = ['table', 'div', 'pre', 'form', 'ul', 'ol', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'dl', 'blockquote', 'figcaption',
                'address', 'section', 'header', 'footer', 'aside', 'article', 'object', 'style', 'script', 'iframe', 'select', 'input', 'textarea',
                'button', 'option', 'map', 'area', 'math', 'hr', 'fieldset', 'legend', 'hgroup', 'nav', 'figure', 'details', 'menu', 'summary', 'p'];
    },
    // public
    convert: function(html)
    {
        var value = this._isConverted(html);

        value = (value === true) ? this._convert(html) : value;

        // table
        var $wrapper = this.utils.buildWrapper(value);
        $wrapper.find('td, th').each(function(node) {
            var $node = $R.dom(node);
            this.stored = [];
            var code = this._convert($node.html(), true);
            $node.html(code);
        }.bind(this));

        value = this.utils.getWrapperHtml($wrapper);

        return value;
    },



    // private
    _convert: function(html, tablemarkup)
    {
        // build markup tag
        var markupTag = (this.opts.breakline) ? 'sdivtag' : this.opts.markup;
        if (tablemarkup) {
            markupTag = 'sdivtag';
        }

        // store tags
        html = this._storeTags(html);

        // store comments
        var storeComments = [];
        var commentsMatch = html.match(new RegExp('<!--([\\w\\W]*?)-->', 'gi'));
        if (commentsMatch !== null)
        {
            for (var i = 0; i < commentsMatch.length; i++)
            {
                html = html.replace(commentsMatch[i], '#####xstarthtmlcommentzz' + i + 'xendhtmlcommentzz#####');
                storeComments.push(commentsMatch[i]);
            }
        }

        // remove new lines
        html = html.trim();

        if (this.opts.breakline)
        {
            html = html.replace(new RegExp('\\n#####', 'gi'), '#####');
            html = html.replace(new RegExp('#####\\n', 'gi'), "#####");
            html = html.replace(/<br\s?\/?>\n/gi, "<br>");
        }
        else
        {
            html = html.replace(/[\n]+/g, "\n");
        }

        html = this._trimEmptyLines(html);

        // paragraph and break markers
        html = (this.opts.breakline) ? html : html.replace(/<br\s?\/?>\n/gi, "xbreakmarkerz\n");
        html = html.replace(/(?:\r\n|\r|\n)/g, "xparagraphmarkerz");

        // replace markers
        html = html.replace(/xparagraphmarkerz/gi, "</" + markupTag + ">\n<" + markupTag + ">");
        html = (this.opts.breakline) ? html : html.replace(/xbreakmarkerz/gi, "<br>");

        // wrap all
        html = '<' + markupTag + '>' + html + '</' + markupTag + '>';

        // clean
        html = html.replace(new RegExp('<' + markupTag + '>#####', 'gi'), '#####');
        html = html.replace(new RegExp('#####</' + markupTag + '>', 'gi'), '#####');

        // restore tags
        html = this._restoreTags(html);

        // restore comments
        for (var i = 0; i < storeComments.length; i++)
        {
            html = html.replace('#####xstarthtmlcommentzz' + i + 'xendhtmlcommentzz#####', storeComments[i]);
        }

        var breaklineAttr = 'br';
        if (tablemarkup) {
            breaklineAttr = 'tbr';
        }

        // clean restored
        html = (this.opts.breakline) ? html : html.replace(new RegExp('<' + markupTag + '><br\\s?/?></' + markupTag + '>', 'gi'), '<' + markupTag + '></' + markupTag + '>');
        html = html.replace(new RegExp('<sdivtag>', 'gi'), '<div data-redactor-tag="' + breaklineAttr + '">');
        html = html.replace(new RegExp('sdivtag', 'gi'), 'div');

        return html;
    },
    _storeTags: function(html)
    {
        var self = this;
        var $wrapper = this.utils.buildWrapper(html);

        if (this.opts.breakline)
        {
            $wrapper.find('p').each(function(node)
            {
                var $node = $R.dom(node);
                var isUnwrap = ($node.closest('figure[data-redactor-type=widget],figure[data-redactor-type=form],.non-editable').length === 0);

                if (isUnwrap)
                {
                    $node.append('<br><br>');
                    $node.unwrap();
                }
            });
        }

        $wrapper.find(this.paragraphizeTags.join(', ')).each(function(node, i)
        {
            var replacement = document.createTextNode("\n" + self.remStart + i + self.remEnd + "\n");
            self.stored.push(node.outerHTML);
            node.parentNode.replaceChild(replacement, node);
        });

        return this.utils.getWrapperHtml($wrapper);
    },
    _restoreTags: function(html)
    {
        for (var i = 0; i < this.stored.length; i++)
        {
            this.stored[i] = this.stored[i].replace(/\$/g, '&#36;');
            html = html.replace(this.remStart + i + this.remEnd, this.stored[i]);
        }

        return html;
    },
    _trimEmptyLines: function(html)
    {
        var str = '';
        var arr = html.split("\n");
        for (var i = 0; i < arr.length; i++)
        {
            if (arr[i].trim() !== '')
            {
                str += arr[i] + "\n";
            }
        }

        return str.replace(/\n$/, '');
    },
    _isConverted: function(html)
    {
        if (this._isDisabled(html)) return html;
        else if (this._isEmptyHtml(html)) return this.opts.emptyHtml;
        else return true;
    },
    _isDisabled: function()
    {
        return (this.opts.paragraphize === false || this.element.isType('inline'));
    },
    _isEmptyHtml: function(html)
    {
        return (html === '' || html === '<p></p>' || html === '<div></div>');
    }
});
$R.add('service', 'detector', {
    init: function(app)
    {
        this.app = app;

        // local
        this.userAgent = navigator.userAgent.toLowerCase();
    },
	isWebkit: function()
	{
		return /webkit/.test(this.userAgent);
	},
	isFirefox: function()
	{
		return (this.userAgent.indexOf('firefox') > -1);
	},
	isIe: function(v)
	{
        if (document.documentMode || /Edge/.test(navigator.userAgent)) return 'edge';

		var ie;
		ie = RegExp('msie' + (!isNaN(v)?('\\s'+v):''), 'i').test(navigator.userAgent);
		if (!ie) ie = !!navigator.userAgent.match(/Trident.*rv[ :]*11\./);

		return ie;
	},
	isMobile: function()
	{
		return /(iPhone|iPod|Android)/.test(navigator.userAgent);
	},
	isDesktop: function()
	{
		return !/(iPhone|iPod|iPad|Android)/.test(navigator.userAgent);
	},
	isIpad: function()
	{
		return /iPad/.test(navigator.userAgent);
	}
});
$R.add('service', 'offset', {
    init: function(app)
    {
        this.app = app;
    },
    get: function(el, trimmed)
    {
        var offset = { start: 0, end: 0 };
        var node = this.utils.getNode(el);
        if (!node) return false;

        var isEditor = this.editor.isEditor(node);
        var isIn = (isEditor) ? true : this.selection.isIn(node);
        var range = this.selection.getRange();

        if (!isEditor && !isIn)
        {
            offset = false;
        }
        else if (this.selection.is() && isIn)
        {
            var $startNode = $R.dom(range.startContainer);
            var fix = ($startNode.hasClass('redactor-component')) ? range.startOffset : 0;
            var clonedRange = range.cloneRange();

            clonedRange.selectNodeContents(node);
            clonedRange.setEnd(range.startContainer, range.startOffset);

            var selection = this._getString(range, trimmed);

            offset.start = this._getString(clonedRange, trimmed).length - fix;
            offset.end = offset.start + selection.length + fix;
        }

        return offset;
    },
    set: function(offset, el)
    {
        if (this._setComponentOffset(el)) return;

        this.component.clearActive();
        var node = this.utils.getNode(el);
        if (!node) return;

        var size = this.size(node);
        var charIndex = 0, range = document.createRange();

        offset.end = (offset.end > size) ? size : offset.end;

        range.setStart(node, 0);
        range.collapse(true);

        var nodeStack = [node], foundStart = false, stop = false;
        while (!stop && (node = nodeStack.pop()))
        {
            if (node.nodeType == 3)
            {
                var nextCharIndex = charIndex + node.length;

                if (!foundStart && !this._isFigcaptionNext(node) && offset.start >= charIndex && offset.start <= nextCharIndex)
                {
                    range.setStart(node, offset.start - charIndex);
                    foundStart = true;
                }

                if (foundStart && offset.end >= charIndex && offset.end <= nextCharIndex)
                {
                    range.setEnd(node, offset.end - charIndex);
                    stop = true;
                }

                charIndex = nextCharIndex;
            }
            else
            {
                var i = node.childNodes.length;
                while (i--)
                {
                    nodeStack.push(node.childNodes[i]);
                }
            }
        }

        this.selection.setRange(range);
    },
    size: function(el, trimmed)
    {
        var node = this.utils.getNode(el);
        if (node)
        {
            var range = document.createRange();

            var clonedRange = range.cloneRange();
            clonedRange.selectNodeContents(node);

            return this._getString(clonedRange, trimmed).length;
        }

        return 0;
    },

    // private
    _getString: function(obj, trimmed)
    {
        var str = obj.toString();
        str = (this.editor.isEmpty()) ? str.replace(/\uFEFF/g, '') : str;
        str = (trimmed) ? str.trim() : str;

        return str;
    },
    _setComponentOffset: function(el)
    {
        return (this.component.isNonEditable(el)) ? this.component.setActive(el) : false;
    },
    _isFigcaptionNext: function(node)
    {
        var next = node.nextSibling;
        return (node.nodeValue.trim() === '' && next && next.tagName === 'FIGCAPTION');
    }
});
$R.add('service', 'inspector', {
    init: function(app)
    {
        this.app = app;
    },
    // parse
    parse: function(el)
    {
        return $R.create('inspector.parser', this.app, this, el);
    },

    // text detection
    isText: function(el)
    {
        if (typeof el === 'string' && !/^\s*<(\w+|!)[^>]*>/.test(el))
        {
            return true;
        }

        var node = $R.dom(el).get();
        return (node && node.nodeType === 3); //  && !this.selection.getBlock(el)
    },

    // tag detection
    isInlineTag: function(tag, extend)
    {
        var tags = this._extendTags(this.opts.inlineTags, extend);

        return (this._isTag(tag) && tags.indexOf(tag.toLowerCase()) !== -1);
    },
    isBlockTag: function(tag, extend)
    {
        var tags = this._extendTags(this.opts.blockTags, extend);

        return (this._isTag(tag) && tags.indexOf(tag.toLowerCase()) !== -1);
    },
    isTableCellTag: function(tag)
    {
        return (['td', 'th'].indexOf(tag.toLowerCase()) !== -1);
    },
    isHeadingTag: function(tag)
    {
        return (['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].indexOf(tag.toLowerCase()) !== -1);
    },


    _isTag: function(tag)
    {
        return (tag !== undefined && tag);
    },
    _extendTags: function(tags, extend)
    {
        tags = tags.concat(tags);

        if (extend)
        {
            for (var i = 0 ; i < extend.length; i++)
            {
                tags.push(extend[i]);
            }
        }

        return tags;
    }
});
$R.add('class', 'inspector.parser', {
    init: function(app, inspector, el)
    {
        this.app = app;
        this.uuid = app.uuid;
        this.opts = app.opts;
        this.utils = app.utils;
        this.editor = app.editor;
        this.selection = app.selection;
        this.inspector = inspector;

        // local
        this.el = el;
        this.$el = $R.dom(this.el, '.redactor-in');
        this.node = this.$el.get();

        // comment node
        if (this.node && this.node.nodeType === 8)
        {
            this.node = false;
        }

        this.$component = this.$el.closest('.redactor-component', '.redactor-in');
    },
    // is
    isEditor: function()
    {
        return (this.node === this.editor.getElement().get());
    },
    isInEditor: function()
    {
        return (this.$el.parents('.redactor-in-' + this.uuid).length !== 0);
    },
    isComponent: function()
    {
        return (this.$component.length !== 0);
    },
    isComponentType: function(type)
    {
        return (this.getComponentType() === type);
    },
    isComponentActive: function()
    {
        return (this.isComponent() && this.$component.hasClass('redactor-component-active'));
    },
    isComponentEditable: function()
    {
        var types = ['code', 'table'];
        var type = this.getComponentType();

        return (this.isComponent() && types.indexOf(type) !== -1);
    },
    isFigcaption: function()
    {
        return this.getFigcaption();
    },
    isPre: function()
    {
        return this.getPre();
    },
    isCode: function()
    {
        var $code = this.$el.closest('code');
        var $parent = $code.parent('pre');

        return ($code.length !== 0 && $parent.length === 0);
    },
    isList: function()
    {
        return this.getList();
    },
    isFirstListItem: function()
    {
        return this._getLastOrFirstListItem('first');
    },
    isLastListItem: function()
    {
        return this._getLastOrFirstListItem('last');
    },
    isFirstTableCell: function()
    {
        return this._getLastOrFirstTableCell('first');
    },
    isLastTableCell: function()
    {
        return this._getLastOrFirstTableCell('last');
    },
    isTable: function()
    {
        return (this.isComponentType('table') || this.getTable());
    },
    isHeading: function()
    {
        return this.getHeading();
    },
    isBlockquote: function()
    {
        return this.getBlockquote();
    },
    isDl: function()
    {
        return this.getDl();
    },
    isParagraph: function()
    {
        return this.getParagraph();
    },
    isLink: function()
    {
        return this.getLink();
    },
    isFile: function()
    {
        return this.getFile();
    },
    isText: function()
    {
        return this.inspector.isText(this.el);
    },
    isInline: function()
    {
        var tags = this.opts.inlineTags;

        return (this.isElement()) ? (tags.indexOf(this.node.tagName.toLowerCase()) !== -1) : false;
    },
    isBlock: function()
    {
        var tags = this.opts.blockTags;

        return (this.isElement()) ? (tags.indexOf(this.node.tagName.toLowerCase()) !== -1) : false;
    },
    isElement: function()
    {
        return (this.node && this.node.nodeType && this.node.nodeType !== 3);
    },

    // has
    hasParent: function(tags)
    {
        return (this.$el.closest(tags.join(',')).length !== 0);
    },

    // get
    getNode: function()
    {
        return this.node;
    },
    getTag: function()
    {
        return (this.isElement()) ? this.node.tagName.toLowerCase() : false;
    },
    getComponent: function()
    {
        return (this.isComponent()) ? this.$component.get() : false;
    },
    getComponentType: function()
    {
        return (this.isComponent()) ? this.$component.attr('data-redactor-type') : false;
    },
    getFirstNode: function()
    {
        return this.utils.getFirstNode(this.node);
    },
    getLastNode: function()
    {
        return this.utils.getLastNode(this.node);
    },
    getFirstElement: function()
    {
        return this.utils.getFirstElement(this.node);
    },
    getLastElement: function()
    {
        return this.utils.getLastElement(this.node);
    },
    getFigcaption: function()
    {
        return this._getClosestNode('figcaption');
    },
    getPre: function()
    {
        return this._getClosestNode('pre');
    },
    getCode: function()
    {
        return this._getClosestNode('code');
    },
    getList: function()
    {
        return this._getClosestNode('ul, ol');
    },
    getParentList: function()
    {
        return this._getClosestUpNode('ul, ol');
    },
    getListItem: function()
    {
        return this._getClosestNode('li');
    },
    getTable: function()
    {
        if (this.getComponentType('table'))
        {
            return this.$component.find('table').get();
        }
        else
        {
            return this._getClosestNode('table');
        }
    },
    getTableCell: function()
    {
        var $td = this.$el.closest('td, th');

        return ($td.length !== 0) ? $td.get() : false;
    },
    getComponentCodeElement: function()
    {
        return (this.isComponentType('code')) ? this.$component.find('pre code, pre').last().get() : false;
    },
    getImageElement: function()
    {
        return (this.isComponentType('image')) ? this.$component.find('img').get() : false;
    },
    getParagraph: function()
    {
        return this._getClosestNode('p');
    },
    getHeading: function()
    {
        return this._getClosestNode('h1, h2, h3, h4, h5, h6');
    },
    getDl: function()
    {
        return this._getClosestNode('dl');
    },
    getBlockquote: function()
    {
        return this._getClosestNode('blockquote');
    },
    getLink: function()
    {
        var isComponent = (this.isComponent() && !this.isFigcaption());
        var isTable = this.isComponentType('table');

        if (isTable || !isComponent)
        {
            var $el = this._getClosestElement('a');

            return ($el && !$el.attr('data-file')) ? $el.get() : false;
        }

        return false;
    },
    getFile: function()
    {
        var isComponent = this.isComponent();
        var isTable = this.isComponentType('table');

        if (isTable || !isComponent)
        {
            var $el = this._getClosestElement('a');

            return ($el && $el.attr('data-file')) ? $el.get() : false;
        }

        return false;
    },

    // find
    findFirstNode: function(selector)
    {
        return this.$el.find(selector).first().get();
    },
    findLastNode: function(selector)
    {
        return this.$el.find(selector).last().get();
    },

    // private
    _getLastOrFirstListItem: function(type)
    {
        var list = this.getList();
        var tag = this.getTag();
        if (list && tag === 'li')
        {
            var item = $R.dom(list).find('li')[type]().get();
            if (item && this.node === item)
            {
                return true;
            }
        }

        return false;
    },
    _getLastOrFirstTableCell: function(type)
    {
        var table = this.getTable();
        var tag = this.getTag();
        if (table && (tag === 'td' || tag === 'th'))
        {
            var item = $R.dom(table).find('td, th')[type]().get();
            if (item && this.node === item)
            {
                return true;
            }
        }

        return false;
    },
    _getClosestUpNode: function(selector)
    {
        var $el = this.$el.parents(selector, '.redactor-in').last();

        return ($el.length !== 0) ? $el.get() : false;
    },
    _getClosestNode: function(selector)
    {
        var $el = this.$el.closest(selector, '.redactor-in');

        return ($el.length !== 0) ? $el.get() : false;
    },
    _getClosestElement: function(selector)
    {
        var $el = this.$el.closest(selector, '.redactor-in');

        return ($el.length !== 0) ? $el : false;
    }
});
$R.add('service', 'marker', {
    init: function(app)
    {
        this.app = app;
    },
    build: function(pos, html)
    {
        var marker = document.createElement('span');

        marker.id = 'selection-marker-' + this._getPos(pos);
        marker.className = 'redactor-selection-marker';
        marker.innerHTML = this.opts.markerChar;

        return (html) ? marker.outerHTML : marker;
    },
    buildHtml: function(pos)
    {
        return this.build(pos, true);
    },
    insert: function(side)
    {
        this.remove();

        var atStart = (side !== 'both' && (side === 'start' || this.selection.isCollapsed()));

        if (!this.selection.is()) this.editor.focus();

        var range = this.selection.getRange();
        if (range)
        {
            var start = this.build('start');
            var end = this.build('end');

            var cloned = range.cloneRange();

            if (!atStart)
            {
                cloned.collapse(false);
                cloned.insertNode(end);
            }

            cloned.setStart(range.startContainer, range.startOffset);
            cloned.collapse(true);
            cloned.insertNode(start);

            range.setStartAfter(start);

            if (!atStart)
            {
                range.setEndBefore(end);
            }

            this.selection.setRange(range);

            return start;
        }
    },
    find: function(pos, $context)
    {
        var $editor = this.editor.getElement();
        var $marker = ($context || $editor).find('span#selection-marker-' + this._getPos(pos));

        return ($marker.length !== 0) ? $marker.get() : false;
    },
    restore: function()
    {
        var start = this.find('start');
        var end = this.find('end');

        var range = this.selection.getRange();
        if (!range || !this.selection.is())
        {
            this.editor.focus();
            range = document.createRange();
        }

        if (start)
        {
            var prev = (end) ? end.previousSibling : false;
            var next = start.nextSibling;
            next = (next && next.nodeType === 3 && next.textContent.replace(/[\n\t]/g, '') === '') ? false : next;

            if (!end)
            {
                if (next)
                {
                    range.selectNodeContents(next);
                    range.collapse(true);
                }
                else
                {
                    this._restoreInject(range, start);
                }
            }
            else if (next && next.id === 'selection-marker-end')
            {
                this._restoreInject(range, start);
            }
            else
            {
                if (prev && next)
                {
                    range.selectNodeContents(prev);
                    range.collapse(false);
                    range.setStart(next, 0);
                }
                else if (prev && !next)
                {
                    range.selectNodeContents(prev);
                    range.collapse(false);
                    range.setStartAfter(start);
                }
                else
                {
                    range.setStartAfter(start);
                    range.setEndBefore(end);
                }
            }

            this.selection.setRange(range);

            if (start) start.parentNode.removeChild(start);
            if (end) end.parentNode.removeChild(end);
        }
    },
    remove: function()
    {
        var start = this.find('start');
        var end = this.find('end');

        if (start) start.parentNode.removeChild(start);
        if (end) end.parentNode.removeChild(end);
    },

    // private
    _getPos: function(pos)
    {
        return (pos === undefined) ? 'start' : pos;
    },
    _restoreInject: function(range, start)
    {
        var textNode = this.utils.createInvisibleChar();
        $R.dom(start).after(textNode);

        range.selectNodeContents(textNode);
        range.collapse(false);
    }
});
$R.add('service', 'component', {
    init: function(app)
    {
        this.app = app;

        // local
        this.activeClass = 'redactor-component-active';
    },
    create: function(type, el)
    {
        return $R.create(type + '.component', this.app, el);
    },
    build: function(el)
    {
        var $el = $R.dom(el);
        var component;
        var type = $el.attr('data-redactor-type');
        if (type)
        {
            component = this.create(type, el);
        }

        return (component) ? component : el;
    },
    remove: function(el, caret)
    {
        var $component = $R.dom(el).closest('.redactor-component');
        var type = $component.attr('data-redactor-type');
        var current = $component.parent();
        var data = this.inspector.parse(current);
        var prev = this.utils.findSiblings($component, 'prev');
        var next = this.utils.findSiblings($component, 'next');
        var stop = this.app.broadcast(type + '.delete', $component);
        if (stop !== false)
        {
            $component.remove();

            // callback
            this.app.broadcast(type + '.deleted', $component);
            this.app.broadcast('contextbar.close');
            this.app.broadcast('imageresizer.stop');

            if (caret !== false)
            {
                var cell = data.getTableCell();
                if (cell && this.utils.isEmptyHtml(cell.innerHTML))
                {
                    this.caret.setStart(cell);
                }
                else if (next) this.caret.setStart(next);
                else if (prev) this.caret.setEnd(prev);
                else
                {
                    this.editor.startFocus();
                }
            }

            // is empty
            if (this.editor.isEmpty())
            {
                this.editor.setEmpty();
                this.editor.startFocus();
                this.app.broadcast('empty');
            }
        }
    },
    isNonEditable: function(el)
    {
        var data = this.inspector.parse(el);
        return (data.isComponent() && !data.isComponentEditable());
    },
    isActive: function(el)
    {
        var $component;
        if (el)
        {
            var data = this.inspector.parse(el);
            $component = $R.dom(data.getComponent());

            return $component.hasClass(this.activeClass);
        }
        else
        {
            $component = this._find();

            return ($component.length !== 0);
        }
    },
    getActive: function(dom)
    {
        var $component = this._find();

        return ($component.length !== 0) ? ((dom) ? $component : $component.get()) : false;
    },
    setActive: function(el)
    {
        this.clearActive();
        this.editor.focus();

        var data = this.inspector.parse(el);
        var component = data.getComponent();
        var $component = $R.dom(component);

        if (!data.isFigcaption())
        {
            var $caret = $component.find('.redactor-component-caret');
            if ($caret.length === 0)
            {
                $caret = this._buildCaret();
                $component.prepend($caret);
            }

            this.caret.setAtStart($caret.get());
        }

        $component.addClass(this.activeClass);
    },
    clearActive: function()
    {
        var $component = this._find();

        $component.removeClass(this.activeClass);
        $component.find('.redactor-component-caret').remove();

        this.app.broadcast('imageresizer.stop');
    },
    setOnEvent: function(e, contextmenu)
    {
        this.clearActive();

        var data = this.inspector.parse(e.target);
        if (data.isFigcaption() || data.isComponentEditable())
        {
            return;
        }

        // component
        if (data.isComponent())
        {
            this.setActive(e.target);
            if (contextmenu !== true) e.preventDefault();
        }
    },
    executeScripts: function(scripts)
    {
        if (scripts === undefined)
        {
            var $editor = this.editor.getElement();
            var scripts = $editor.find('[data-redactor-type]').find("script").getAll();
            this.executeScripts.call(this, scripts);
        }
        else
        {
            for (var i = 0; i < scripts.length; i++)
            {
                if (scripts[i].src !== '')
                {
                    var src = scripts[i].src;
                    this.$doc.find('head script[src="' + src + '"]').remove();

                    var $script = $R.dom('<script>');
                    $script.attr('src', src);
                    $script.attr('async defer');
                    $script.get().onload = function()
                    {
                        if (src.search('instagram') !== -1) window.instgrm.Embeds.process();
                        this.executeScripts(scripts.slice(i + 1));
                    }.bind(this);

                    var head = document.getElementsByTagName('head')[0];
                    if (head) head.appendChild($script.get());

                    break;
                }
                else
                {
                    try {
                        eval(scripts[i].innerHTML);
                    } catch (e) {}
                }
            }
        }
    },

    // private
    _find: function()
    {
        return this.editor.getElement().find('.' + this.activeClass);
    },
    _buildCaret: function()
    {
        var $caret = $R.dom('<span>');
        $caret.addClass('redactor-component-caret');
        $caret.attr('contenteditable', true);

        return $caret;
    }
});
$R.add('service', 'insertion', {
    init: function(app)
    {
        this.app = app;
    },
    set: function(html, clean, focus)
    {
        if (html === null) {
            html = '';
        }

        html = (clean !== false) ? this.cleaner.input(html) : html;
        html = (clean !== false) ? this.cleaner.paragraphize(html) : html;

        // set html
        var $editor = this.editor.getElement();
        $editor.html(html);

        // set focus at the end
        if (focus !== false) this.editor.endFocus();

        return html;
    },
    insertNode: function(node, caret)
    {
        this.editor.focus();
        var fragment = (this.utils.isFragment(node)) ? node : this.utils.createFragment(node);

        this._collapseSelection();
        this._insertFragment(fragment);
        this._setCaret(caret, fragment);

        return this._sendNodes(fragment.nodes);
    },
    insertBreakLine: function()
    {
        return this.insertNode(document.createElement('br'), 'after');
    },
    insertNewline: function()
    {
        return this.insertNode(document.createTextNode('\n'), 'after');
    },
    insertText: function(text)
    {
        return this.insertHtml(this.cleaner.getFlatText(text));
    },
    insertChar: function(charhtml)
    {
        return this.insertNode(charhtml, 'after');
    },
    insertRaw: function(html)
    {
        return this.insertHtml(html, false);
    },
    insertToEnd: function(lastNode, type)
    {
        if (!lastNode) return;
        if (lastNode.nodeType === 3 && lastNode.nodeValue.search(/^\n/) !== -1)
        {
            lastNode = lastNode.previousElementSibling;
        }

        var $lastNode = $R.dom(lastNode);
        if ($lastNode.attr('data-redactor-type') === type)
        {
            var tag = (this.opts.breakline) ? '<br>' : '<p>';
            var $newNode = $R.dom(tag);

            $lastNode.after($newNode);
            this.caret.setStart($newNode);
        }
    },
    insertPoint: function(e)
    {
        var range, data;
        var marker = this.marker.build('start');
        var markerInserted = false;
        var x = e.clientX, y = e.clientY;

        if (document.caretPositionFromPoint)
        {
            var pos = document.caretPositionFromPoint(x, y);
            var sel = document.getSelection();

            data = this.inspector.parse(pos.offsetNode);
            if (data.isInEditor())
            {
                range = sel.getRangeAt(0);
                range.setStart(pos.offsetNode, pos.offset);
                range.collapse(true);
                range.insertNode(marker);
                markerInserted = true;
            }
        }
        else if (document.caretRangeFromPoint)
        {
            range = document.caretRangeFromPoint(x, y);

            data = this.inspector.parse(range.startContainer);
            if (data.isInEditor())
            {
                range.insertNode(marker);
                markerInserted = true;
            }
        }

        return markerInserted;
    },
    insertToPoint: function(e, html, point, clean)
    {
        var pointInserted = (point === true) ? true : this.insertPoint(e);
        if (!pointInserted)
        {
            var lastNode = this.editor.getLastNode();
            $R.dom(lastNode).after(this.marker.build('start'));
        }

        this.component.clearActive();
        this.selection.restoreMarkers();

        return this.insertHtml(html, clean);
    },
    insertToOffset: function(start, html)
    {
        this.offset.set({ start: start, end: start });

        return this.insertHtml(html);
    },
    insertHtml: function(html, clean)
    {
        if (!this.opts.input) return;

        // parse
        var parsedInput = this.utils.parseHtml(html);

        // all selection
        if (this.selection.isAll())
        {
            return this._insertToAllSelected(parsedInput);
        }

        // there is no selection
        if (!this.selection.is())
        {
            var $el = $R.dom('<p>');
            var $editor = this.editor.getElement();

            $editor.append($el);
            this.caret.setStart($el);
        }

        // environment
        var isCollapsed = this.selection.isCollapsed();
        var isText = this.selection.isText();
        var current = this.selection.getCurrent();
        var dataCurrent = this.inspector.parse(current);

        // collapse air
        this._collapseSelection();

        // clean
        parsedInput = this._getCleanedInput(parsedInput, dataCurrent, clean);

        // input is figure or component span
        var isFigure = this._isFigure(parsedInput.html);
        var isComponentSpan = this._isComponentSpan(parsedInput.html);
        var isInsertedText = this.inspector.isText(parsedInput.html);
        var fragment, except;

        // empty editor
        if (this.editor.isEmpty())
        {
            return this._insertToEmptyEditor(parsedInput.html);
        }
        // to component
        else if (dataCurrent.isComponent() && !dataCurrent.isComponentEditable())
        {
            return this._insertToWidget(current, dataCurrent, parsedInput.html);
        }
        // component span
        else if (isComponentSpan)
        {
            return this.insertNode(parsedInput.nodes, 'end');
        }
        // inserting figure & split node
        else if (isFigure && !isText && !dataCurrent.isList())
        {
            if (dataCurrent.isInline())
            {
                return this._insertToInline(current, parsedInput);
            }

            fragment = this.utils.createFragment(parsedInput.html);
            this.utils.splitNode(current, fragment);
            this.caret.setEnd(fragment.last);

            return this._sendNodes(fragment.nodes);
        }
        // to code
        else if (dataCurrent.isCode())
        {
            return this._insertToCode(parsedInput, current, clean);
        }
        // to pre
        else if (dataCurrent.isPre())
        {
            return this._insertToPre(parsedInput, clean);
        }
        // to h1-h6 & figcaption
        else if (dataCurrent.isHeading() || dataCurrent.isFigcaption())
        {
            parsedInput.html = (clean !== false) ? this.cleaner.removeTagsExcept(parsedInput.html, ['a']) : parsedInput.html;
            parsedInput.html = (clean !== false) ? this.cleaner.replaceNbspToSpaces(parsedInput.html) : parsedInput.html;

            fragment = this.utils.createFragment(parsedInput.html);

            return this.insertNode(fragment, 'end');
        }
        // text inserting
        else if (isInsertedText)
        {
            if (!isText && this.opts.markup !== 'br' && this._hasBlocksAndImages(parsedInput.nodes))
            {
                parsedInput.html = (clean !== false) ? this.cleaner.paragraphize(parsedInput.html) : parsedInput.html;

                fragment = this.utils.createFragment(parsedInput.html);

                this.utils.splitNode(current, fragment);
                this.caret.setEnd(fragment.last);
                return this._sendNodes(fragment.nodes);
            }

            parsedInput.html = (clean !== false) ? parsedInput.html.replace(/\n/g, '<br>') : parsedInput.html;

            fragment = this.utils.createFragment(parsedInput.html);

            return this.insertNode(fragment.nodes, 'end');
        }
        // uncollapsed
        else if (!isCollapsed && !isFigure)
        {
            parsedInput.html = (clean !== false) ? this.cleaner.paragraphize(parsedInput.html) : parsedInput.html;

            fragment = this.utils.createFragment(parsedInput.html);

            return this.insertNode(fragment, 'end');
        }
        // to inline tag
        else if (dataCurrent.isInline() && !this._isPlainHtml(parsedInput.html))
        {
            return this._insertToInline(current, parsedInput);
        }
        // to blockquote or dt, dd
        else if (dataCurrent.isBlockquote() || dataCurrent.isDl())
        {
            except = this.opts.inlineTags;
            except.concat(['br']);

            parsedInput.html = (clean !== false) ? this.cleaner.replaceBlocksToBr(parsedInput.html) : parsedInput.html;
            parsedInput.html = (clean !== false) ? this.cleaner.removeTagsExcept(parsedInput.html, except) : parsedInput.html;

            fragment = this.utils.createFragment(parsedInput.html);

            return this.insertNode(fragment, 'end');
        }
        // to p
        else if (dataCurrent.isParagraph())
        {
            if (this._isPlainHtml(parsedInput.html))
            {
                return this.insertNode(parsedInput.nodes, 'end');
            }

            parsedInput.html = (clean !== false) ? this.cleaner.paragraphize(parsedInput.html) : parsedInput.html;

            fragment = this.utils.createFragment(parsedInput.html);

            this.utils.splitNode(current, fragment);
            this.caret.setEnd(fragment.last);

            return this._sendNodes(fragment.nodes);
        }
        // to li
        else if (dataCurrent.isList())
        {
            except = this.opts.inlineTags;
            except = except.concat(['br', 'li', 'ul', 'ol', 'img']);

            parsedInput.html = (clean !== false) ? this.cleaner.replaceBlocksToBr(parsedInput.html) : parsedInput.html;
            parsedInput.html = (clean !== false) ? this.cleaner.removeTagsExcept(parsedInput.html, except) : parsedInput.html;
            parsedInput.html = (clean !== false) ? this.cleaner.removeBrAtEnd(parsedInput.html) : parsedInput.html;

            fragment = this.utils.createFragment(parsedInput.html);
            parsedInput.nodes = fragment.nodes;

            if (this._containsTags(parsedInput.html, ['ul', 'ol', 'li']))
            {
                var element = this.selection.getElement(current);
                if (element && element.tagName === 'LI' && this.caret.isStart(element))
                {
                    parsedInput.nodes = $R.dom(fragment.nodes).unwrap('ul, ol').getAll();
                    $R.dom(element).before(parsedInput.nodes);

                    var lastNode = parsedInput.nodes[parsedInput.nodes.length-1];
                    this.caret.setEnd(lastNode);

                    return this._sendNodes(parsedInput.nodes);
                }
                else if (this._isPlainHtml(parsedInput.html))
                {
                    return this.insertNode(fragment, 'end');
                }
                else
                {
                    fragment = this._buildList(parsedInput, element, fragment);

                    this.utils.splitNode(current, fragment, true);
                    this.caret.setEnd(fragment.last);

                    return this._sendNodes(fragment.nodes);
                }
            }
        }

        // other cases
        return this.insertNode(parsedInput.nodes, 'end');
    },

    // private
    _insertToAllSelected: function(parsedInput)
    {
        var insertedHtml = this.set(parsedInput.html);
        var dataInserted = this.utils.parseHtml(insertedHtml);

        return this._sendNodes(dataInserted.nodes);
    },
    _insertToEmptyEditor: function(html)
    {
        html = this.cleaner.paragraphize(html);

        var fragment = this.utils.createFragment(html);
        var $editor = this.editor.getElement();

        $editor.html('');
        $editor.append(fragment.frag);

        this.caret.setEnd(fragment.last);

        return this._sendNodes(fragment.nodes);
    },
    _insertToInline: function(current, parsedInput)
    {
        var fragment = this.utils.createFragment(parsedInput.html);
        this.utils.splitNode(current, fragment, false, true);
        this.caret.setEnd(fragment.last);

        return this._sendNodes(fragment.nodes);
    },
    _insertToCode: function(parsedInput, current, clean)
    {
        parsedInput.html = (clean !== false) ? this.cleaner.encodeHtml(parsedInput.html) : parsedInput.html;
        parsedInput.html = (clean !== false) ? this.cleaner.removeNl(parsedInput.html) : parsedInput.html;

        var fragment = this.utils.createFragment(parsedInput.html);
        var nodes = this.insertNode(fragment, 'end');

        this.utils.normalizeTextNodes(current);

        return nodes;
    },
    _insertToPre: function(parsedInput, clean)
    {
        parsedInput.html = (clean !== false) ? this.cleaner.encodeHtml(parsedInput.html) : parsedInput.html;

        var fragment = this.utils.createFragment(parsedInput.html);

        return this.insertNode(fragment, 'end');
    },
    _insertToWidget: function(current, dataCurrent, html)
    {
        html = (this._isComponentSpan(html)) ? html : this.cleaner.paragraphize(html);

        var fragment = this.utils.createFragment(html);
        var component = dataCurrent.getComponent();
        var $component = $R.dom(component);

        $component.after(fragment.frag);
        $component.remove();

        this.caret.setEnd(fragment.last);

        return this._sendNodes(fragment.nodes);
    },
    _insertFragment: function(fragment)
    {
        var range = this.selection.getRange();
        if (range)
        {
            if (this.selection.isCollapsed())
            {
                var startNode = range.startContainer;
                if (startNode.nodeType !== 3 && startNode.tagName === 'BR')
                {
                    this.caret.setAfter(startNode);
                    startNode.parentNode.removeChild(startNode);
                }
            }
            else
            {
                range.deleteContents();
            }

            range.insertNode(fragment.frag);
        }
    },
    _sendNodes: function(nodes)
    {
        for (var i = 0; i < nodes.length; i++)
        {
            var el = nodes[i];
            var type = (el.nodeType !== 3 && typeof el.getAttribute === 'function') ? el.getAttribute('data-redactor-type') : false;
            if (type)
            {
                this.app.broadcast(type + '.inserted', this.component.build(el));
            }
        }

        if (this.detector.isIe())
        {
            this.editor.getElement().find('[data-redactor-type=table]').attr('contenteditable', true);
        }

        // callback
        this.app.broadcast('inserted', nodes);

        // widget's scripts
        this.component.executeScripts();

        return nodes;
    },
    _setCaret: function(caret, fragment)
    {
        var isLastInline = this._isLastInline(fragment);

        if (caret)
        {
            caret = (isLastInline && caret === 'end') ? 'after' : caret;
            this.caret['set' + this.utils.ucfirst(caret)](fragment.last);
        }
        else if (caret !== false)
        {
            if (isLastInline) this.caret.setAfter(fragment.last);
        }
    },
    _isLastInline: function(fragment)
    {
        if (fragment.last)
        {
            var data = this.inspector.parse(fragment.last);

            return data.isInline();
        }

        return false;
    },
    _getCleanedInput: function(parsedInput, dataCurrent, clean)
    {
        var isPreformatted = (dataCurrent.isCode() || dataCurrent.isPre());

        parsedInput.html = parsedInput.html.replace(/&nbsp;/g, ' ');
        parsedInput.html = (!isPreformatted && clean !== false) ? this.cleaner.input(parsedInput.html) : parsedInput.html;
        parsedInput = (!isPreformatted && clean !== false) ? this.utils.parseHtml(parsedInput.html) : parsedInput;

        return parsedInput;
    },
    _getContainer: function(nodes)
    {
        return $R.dom(this.utils.createTmpContainer(nodes));
    },
    _buildList: function(parsedInput, list, fragment)
    {
        var nodes = parsedInput.nodes;
        var first = nodes[0];

        if (first && first.nodeType !== 3 && first.tagName === 'li')
        {
            var $parent = $R.dom(list);
            var parentListTag = $parent.get().tagName.toLowerCase();
            var $list = $R.dom('<' + parentListTag + ' />');
            $list.append(fragment.nodes);

            return this.utils.createFragment($list.get().outerHTML);
        }

        return fragment;
    },
    _containsTags: function(html, tags)
    {
        return (this._getContainer(html).find(tags.join(',')).length !== 0);
    },
    _collapseSelection: function()
    {
        //if (this.app.isAirToolbar()) this.selection.collapseToEnd();
    },
    _hasFigureOrTable: function(nodes)
    {
        return (this._getContainer(nodes).find('figure, table').length !== 0);
    },
    _hasBlocks: function(nodes)
    {
        return (this._getContainer(nodes).find(this.opts.blockTags.join(',')).length !== 0);
    },
    _hasBlocksAndImages: function(nodes)
    {
        return (this._getContainer(nodes).find(this.opts.blockTags.join(',') + ',img').length !== 0);
    },
    _isPlainHtml: function(html)
    {
        return (this._getContainer(html).find(this.opts.blockTags.join(',') + ', img').length === 0);
    },
    _isFigure: function(html)
    {
        if (this._isHtmlString(html))
        {
            return ($R.dom(html).closest('figure').length !== 0);
        }
    },
    _isComponentSpan: function(html)
    {
        if (this._isHtmlString(html))
        {
            return ($R.dom(html).closest('span.redactor-component').length !== 0);
        }
    },
    _isHtmlString: function(html)
    {
        return !(typeof html === 'string' && !/^\s*<(\w+|!)[^>]*>/.test(html));
    }
});
$R.add('service', 'block', {
    init: function(app) {
        this.app = app;
        this.tags = ['p', 'div', 'blockquote', 'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
    },
    // format
    format: function(args) {

        // params
        this.params = {
            args: false
        };

        // type of applying styles and attributes
        this.params.type = (args.type) ? args.type : 'set'; // add, remove, toggle

        // tag
        this.params.tag = (typeof args === 'string') ? args : (args.tag || this.opts.markup);
        this.params.tag = this.params.tag.toLowerCase();

        // args
        this.params.args = {
            'class': args['class'] || false,
            'style': args['style'] || false,
            'attr': args['attr'] || false
        };

        if (!args['class'] && !args['style'] && !args['attr']) {
            this.params.args = false;
        }

        // format
        return this._format();
    },

    // funcs
    add: function(args, tags) {
        return this._apply('add', args, tags);
    },
    set: function(args, tags) {
        return this._apply('set', args, tags);
    },
    toggle: function(args, tags) {
        return this._apply('toggle', args, tags);
    },
    remove: function(args, tags) {
        return this._apply('remove', args, tags);
    },

    // clear
    clearFormat: function(tags) {
        return this._clear(tags, 'all');
    },
    clearStyle: function(tags) {
        return this._clear(tags, 'style');
    },
    clearClass: function() {
        return this._clear(tags, 'class');
    },
    clearAttr: function() {
        return this._clear(tags, 'attr');
    },

    // format
    _format: function() {

        var nodes = [];

        // collapsed
        this.collapsed = this.selection.isCollapsed();

        // save selection
        this.selection.save();

        // blocks
        var block = this.selection.getBlock();
        var blocks = this._getBlocks();
        var type = (this._isToggleFormatType(blocks)) ? 'toggle' : 'set';
        var replacedTag = this._getReplacedTag(type);

        nodes = this._replaceBlocks(blocks, replacedTag);


        // apply args & clean
        nodes = this._buildNodes(nodes);

        // restore selection
        this._restoreSelection(nodes);

        return nodes;
    },


    // clear
    _clear: function(tags, type, selection, nodes) {
        // save selection
        if (selection !== false) {
		    this.selection.save();
		}

        // get elements
        var $elements = this._getElements(tags, nodes);

        // remove all format
        if (type === 'all') {
            this._removeAllAttr($elements, false);
        }
        // remove style
        else if (type === 'style') {
            $elements.removeAttr('style');
            $elements.removeAttr('data-redactor-style-cache');
        }
        // remove class
        else if (type === 'class') {
            $elements.removeAttr('class');
        }
        // remove attrs
        else if (type === 'attr') {
            this._removeAllAttr($elements);
        }

        // get nodes
        nodes = $elements.getAll();

        // restore selection
        if (selection !== false) {
            this._restoreSelection(nodes);
        }

        return nodes;
    },

    // get
    _getElements: function(tags, nodes) {
        return (nodes) ? $R.dom(nodes) : $R.dom(this._getBlocks(tags));
    },
    _getBlocks: function(tags) {
        var blocks = this.selection.getBlocks({ tags: tags || this.tags });
        var finalBlocks = [];
        for (var i = 0; i < blocks.length; i++) {
            if (blocks[i].tagName === 'DIV' && !blocks[i].getAttribute('data-redactor-tag')) {
                continue;
            }
            else {
                finalBlocks.push(blocks[i]);
            }
        }

        return finalBlocks;
    },

    _getReplacedTag: function(type) {
        if (this.opts.breakline) {
            return (type === 'toggle') ? 'div' : (this.params.tag === 'p') ? 'div' : this.params.tag;
        }
        else {
            return (type === 'toggle') ? this.opts.markup : this.params.tag;
        }
    },

    // is
    _isStandardParagraph: function() {
        return (!this.opts.breakline && this.opts.markup === 'p');
    },
    _isStandardDiv: function() {
        return (!this.opts.breakline && this.opts.markup === 'div');
    },
    _isBreaklineBlock: function(block) {
        return (block && block.tagName === 'DIV' && block.getAttribute('data-redactor-tag') === 'br');
    },
    _isToggleFormatType: function(blocks) {
        var count = 0;
        var len = blocks.length;
        for (var i = 0; i < len; i++) {
            if (blocks[i] && this.params.tag === blocks[i].tagName.toLowerCase()) count++;
        }

        return (count === len);
    },
    _isCurrentBlockOneAndEmpty: function(nodes) {
        return (this.collapsed && nodes.length === 1 && this.utils.isEmpty(nodes[0]));
    },

    // build
    _buildNodes: function(nodes) {
        if (nodes.length > 0) {
            // clean & appliyng styles and attributes
            nodes = this._applyArgs(nodes, false);
            nodes = this._combinePre(nodes);
            nodes = this._cleanBlocks(nodes);
        }

        return nodes;
    },

    // replace
    _replaceBlocks: function(blocks, replacedTag) {
        var nodes = [];

        for (var i = 0; i < blocks.length; i++) {
            var $node = this.utils.replaceToTag(blocks[i], replacedTag);
            nodes.push($node.get());
        }

        return nodes;
    },

    // combine
    _combinePre: function(nodes) {
        var combinedNodes = [];
        for (var i = 0; i < nodes.length; i++) {
            var next = nodes[i].nextElementSibling;
            if (next && nodes[i].tagName === 'PRE' && next.tagName === 'PRE') {
                var $current = $R.dom(nodes[i]);
                var $next = $R.dom(next);
                var newline = document.createTextNode('\n');

                $current.append(newline);
                $current.append($next);
                $next.unwrap('pre');
            }

            combinedNodes.push(nodes[i]);
        }

        return combinedNodes;
    },

    // clean
    _cleanBlocks: function(nodes) {
        var headings = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
        var tags = this.opts.inlineTags;
        for (var i = 0; i < nodes.length; i++) {
            var tag = nodes[i].tagName.toLowerCase();
            var $node = $R.dom(nodes[i]);

            // remove all spans in headings
            if (headings.indexOf(tag) !== - 1) {
                $node.find('span').not('.redactor-component, .non-editable, .redactor-selection-marker').unwrap();
            }
            // remove all inlines in pre
            else if (tag === 'pre') {
                $node.find(tags.join(',')).not('.redactor-selection-marker').unwrap();
            }

            // breakline attr
            if (this.opts.breakline && tag === 'div') {
                $node.attr('data-redactor-tag', 'br');
            }
            else {
                $node.removeAttr('data-redactor-tag');
            }

            // normalize
            this.utils.normalizeTextNodes(nodes[i]);
        }

        return nodes;
    },
    _cleanEmptyClass: function($elements) {
        $elements.each(function(node) {
            if (node.className === '') node.removeAttribute('class');
        });
    },
    _cleanEmptyStyle: function($node) {
         if (this.utils.removeEmptyAttr($node.get(), 'style')) {
            $node.removeAttr('data-redactor-style-cache');
        }
        else {
            $node.attr('data-redactor-style-cache', $node.attr('style'));
        }
    },

    // apply
    _apply: function(type, args, tags, selection, nodes) {
        // save selection
        if (selection !== false) {
		    this.selection.save();
		}

        // get elements
        var $elements = this._getElements(tags, nodes);

        // class
        if (args['class']) {
            if (type === 'set') {
                $elements.removeAttr('class');
                $elements.addClass(args['class']);
            }
            else if (type === 'add') {
                $elements.addClass(args['class']);
            }
            else if (type === 'toggle') {
                $elements.toggleClass(args['class']);
            }
            else if (type === 'remove') {
                $elements.removeClass(args['class']);
            }

            this._cleanEmptyClass($elements);
        }

        // attr
        if (args['attr']) {
            if (type === 'set') {
                this._removeAllAttr($elements);
                $elements.attr(args['attr']);
            }
            else if (type === 'add') {
                $elements.attr(args['attr']);
            }
            else if (type === 'toggle') {
                params = args['attr'];
                $elements.each(function(node) {
                    var $node = $R.dom(node);
                    for (var key in params) {
                        if ($node.attr(key)) $node.removeAttr(key);
                        else $node.attr(key, params[key]);
                    }
                });
            }
            else if (type === 'remove') {
                $elements.removeAttr(args['attr']);
            }
        }

        // style
        if (args['style']) {
            if (type === 'set') {
                $elements.removeAttr('style');
                $elements.css(args['style']);
                $elements.each(function(node) {
                    var $node = $R.dom(node);
                    $node.attr('data-redactor-style-cache', $node.attr('style'));
                });
            }
            else if (type === 'add') {
                var params = args['style'];
                $elements.each(function(node) {
                    var $node = $R.dom(node);
                    $node.css(params);
                    $node.attr('data-redactor-style-cache', $node.attr('style'));
                    this._convertStyleQuotes($node);
                }.bind(this));
            }
            else if (type === 'toggle') {
                var params = args['style'];
                $elements.each(function(node) {
                    var $node = $R.dom(node);
                    for (var key in params) {
                        var newVal = params[key];
                        var oldVal = $node.css(key);

                        oldVal = (this.utils.isRgb(oldVal)) ? this.utils.rgb2hex(oldVal) : oldVal.replace(/"/g, '');
                        newVal = (this.utils.isRgb(newVal)) ? this.utils.rgb2hex(newVal) : newVal.replace(/"/g, '');

                        oldVal = this.utils.hex2long(oldVal);
                        newVal = this.utils.hex2long(newVal);

                        var compareNew = (typeof newVal === 'string') ? newVal.toLowerCase() : newVal;
                        var compareOld = (typeof oldVal === 'string') ? oldVal.toLowerCase() : oldVal;

                        if (compareNew === compareOld) $node.css(key, '');
                        else $node.css(key, newVal);
                    }

                    this._convertStyleQuotes($node);
                    this._cleanEmptyStyle($node);
                }.bind(this));
            }
            else if (type === 'remove') {
                var name = args['style'];
                $elements.each(function(node) {
                    var $node = $R.dom(node);
                    $node.css(name, '');
                    this._cleanEmptyStyle($node);
                }.bind(this));
            }
        }

        // get nodes
        nodes = $elements.getAll();

        // restore selection
        if (selection !== false) {
            this._restoreSelection(nodes);
        }

        return nodes;
    },
    _applyArgs: function(nodes) {
        if (this.params.args) {
            nodes = this._apply(this.params.type, this.params.args, false, false, nodes);
        }
        else {
            nodes = this._clear(false, 'all', false, nodes);
        }

        return nodes;
    },

    // remove
    _removeAllAttr: function($elements, keepStyleAndClass) {
        $elements.each(function(node) {
            var keepAttrs = ['data-redactor-tag', 'data-redactor-style-cache'];
            if (keepStyleAndClass === false) {
                keepAttrs.push('style');
                keepAttrs.push('class');
            }

            for (var i = node.attributes.length; i--> 0;) {
                var nodeAttr = node.attributes[i];
                var name = nodeAttr.name;
                if (keepAttrs.indexOf(name) === -1) {
                    node.removeAttributeNode(nodeAttr);
                }
            }
        });
    },

    // selection
    _restoreSelection: function(nodes) {
        if (this._isCurrentBlockOneAndEmpty(nodes)) {
            this.caret.setStart(nodes[0]);
        }
        else {
            setTimeout(function() { this.selection.restore(); }.bind(this), 1);
        }
    },

    // convert
    _convertStyleQuotes: function($node) {
        var style = $node.attr('style');
        if (style) $node.attr('style', style.replace(/"/g, '\''));
    }
});
$R.add('service', 'inline', {
    mixins: ['formatter'],
    init: function(app)
    {
        this.app = app;

        this.count = 0;
    },
    // public
    format: function(args)
    {
        if (!this._isFormat()) return [];

        // type of applying styles and attributes
        this.type = (args.type) ? args.type : 'set'; // add, remove, toggle
        // tag
        this.tag = (typeof args === 'string') ? args : args.tag;
        this.tag = this.tag.toLowerCase();
        this.tag = this.arrangeTag(this.tag);

        if (typeof args === 'string') this.args = false;
        else this.buildArgs(args);

        if (!this.detector.isIe())
        {
            this.editor.disableNonEditables();
        }

        // format
        var nodes = (this.selection.isCollapsed()) ? this.formatCollapsed() : this.formatUncollapsed();

        if (!this.detector.isIe())
        {
            this.editor.enableNonEditables();
        }

        return nodes;
    },

    // private
    _isFormat: function()
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var isComponent = (data.isComponent() && !data.isComponentType('table') && !data.isFigcaption());

        if (current === false && this.selection.isAll())
        {
            return true;
        }
        else if (!current || data.isPre() || data.isCode() || isComponent)
        {
            return false;
        }

        return true;
    },
    arrangeTag: function(tag)
    {
        var replaced = this.opts.replaceTags;
        for (var key in replaced)
        {
            if (tag === key) tag = replaced[key];
        }

        return tag;
    },
    formatCollapsed: function()
    {
        var nodes = [];
        var inline = this.selection.getInlineFirst();
        var inlines = this.selection.getInlines({ all: true });
        var $inline = $R.dom(inline);
        var $parent, parent, $secondPart, extractedContent;

        // 1) not inline
        if (!inline)
        {
            nodes = this.insertInline(nodes);
        }
        else
        {
            var dataInline = this.inspector.parse(inline);
            var isEmpty = this.utils.isEmptyHtml(inline.innerHTML);

            // 2) inline is empty
            if (isEmpty)
            {
                // 2.1) has same tag
                if (inline.tagName.toLowerCase() === this.tag)
                {
                    // 2.1.1) has same args or hasn't args
                    if (this.hasSameArgs(inline))
                    {
                        this.caret.setAfter(inline);
                        $inline.remove();

                        var el = this.selection.getElement();
                        this.utils.normalizeTextNodes(el);
                    }
                    // 2.1.2) has different args and it is span tag
                    else if (this.tag === 'span')
                    {
                        nodes = this.applyArgs([inline], false);
                        this.caret.setStart(inline);
                    }
                    // 2.1.3) has different args and it is not span tag
                    else
                    {
                       nodes = this.insertInline(nodes);
                    }

                }
                // 2.2) has another tag
                else
                {
                    // 2.2.1) has parent
                    if (dataInline.hasParent([this.tag]))
                    {
                        $parent = $inline.closest(this.tag);
                        parent = $parent.get();
                        if (this.hasSameArgs(parent))
                        {
                            $parent.unwrap();
                            this.caret.setStart(inline);
                        }
                        else
                        {
                            nodes = this.insertInline(nodes);
                        }
                    }
                    // 2.2.2) hasn't parent
                    else
                    {
                        nodes = this.insertInline(nodes);
                    }
                }
            }
            // 3) inline isn't empty
            else
            {
                // 3.1) has same tag
                if (inline.tagName.toLowerCase() === this.tag)
                {
                    // 3.1.1) has same args or hasn't args
                    if (this.hasSameArgs(inline))
                    {
                        // insert break
                        extractedContent = this.utils.extractHtmlFromCaret(inline);
                        $secondPart = $R.dom('<' + this.tag + ' />');
                        $secondPart = this.utils.cloneAttributes(inline, $secondPart);

                        $inline.after($secondPart.append(extractedContent));

                        this.caret.setAfter(inline);
                    }
                    else
                    {
                        nodes = this.insertInline(nodes);
                    }
                }
                // 3.2) has another tag
                else
                {
                    // 3.2.1) has parent
                    if (dataInline.hasParent([this.tag]))
                    {
                        $parent = $inline.closest(this.tag);
                        parent = $parent.get();
                        if (this.hasSameArgs(parent))
                        {
                            // insert break
                            extractedContent = this.utils.extractHtmlFromCaret(parent, parent);
                            $secondPart = $R.dom('<' + this.tag + ' />');
                            $secondPart = this.utils.cloneAttributes(parent, $secondPart);

                            var $breaked, $last;
                            var z = 0;
                            inlines = inlines.reverse();
                            for (var i = 0; i < inlines.length; i++)
                            {
                                if (inlines[i] !== parent)
                                {
                                    $last = $R.dom('<' + inlines[i].tagName.toLowerCase() + '>');
                                    if (z === 0)
                                    {
                                        $breaked = $last;
                                    }
                                    else
                                    {
                                        $breaked.append($last);
                                    }

                                    z++;
                                }
                            }

                            $parent.after($secondPart.append(extractedContent));
                            $parent.after($breaked);

                            this.caret.setStart($last);
                        }
                        else
                        {
                            nodes = this.insertInline(nodes);
                        }
                    }
                    // 3.2.2) hasn't parent
                    else
                    {
                        nodes = this.insertInline(nodes);
                    }
                }
            }
        }

        return nodes;
    },
    insertInline: function(nodes)
    {
        var node = document.createElement(this.tag);
        nodes = this.insertion.insertNode(node, 'start');

        return this.applyArgs(nodes, false);
    },
    hasSameArgs: function(inline)
    {
        if (inline.attributes.length === 0 && this.args === false)
        {
            return true;
        }
        else
        {
            var same = true;
            if (this.args)
            {
                var count = 0;
                for (var key in this.args)
                {
                    var $node = $R.dom(inline);
                    var args = (this.args[key]);
                    var value = this.utils.toParams(args);
                    var nodeAttrValue = $node.attr(key);

                    if (args)
                    {
                        if (key === 'style')
                        {
                            value = value.trim().replace(/;$/, '');

                            var origRules = this.utils.styleToObj($node.attr('style'));
                            var rules = value.split(';');
                            var innerCount = 0;

                            for (var i = 0; i < rules.length; i++)
                            {
                                var arr = rules[i].split(':');
                                var ruleName = arr[0].trim();
                                var ruleValue = arr[1].trim();

                                if (ruleName.search(/color/) !== -1)
                                {
                                    var val = $node.css(ruleName);
                                    if (val && (val === ruleValue || this.utils.rgb2hex(val) === ruleValue))
                                    {
                                        innerCount++;
                                    }
                                }
                                else if ($node.css(ruleName) === ruleValue)
                                {
                                    innerCount++;
                                }
                            }

                            if (innerCount === rules.length && Object.keys(origRules).length === rules.length)
                            {
                                count++;
                            }
                        }
                        else
                        {
                            if (nodeAttrValue === value)
                            {
                                count++;
                            }
                        }
                    }
                    else
                    {
                        if (!nodeAttrValue || nodeAttrValue === '')
                        {
                            count++;
                        }
                    }
                }

                same = (count === Object.keys(this.args).length);
            }

            return same;
        }
    },
    formatUncollapsed: function()
    {
        var inlines = this.selection.getInlines({ all: true, inside: true });

        if (this.detector.isIe()) this.selection.saveMarkers();
        else this.selection.save();

        // convert del / u
        this._convertTags('u');
        this._convertTags('del');

        // convert target tags
        this._convertToStrike(inlines);

        if (this.detector.isIe()) this.selection.restoreMarkers();
        else this.selection.restore();

        // apply strike
        document.execCommand('strikethrough');

        // clear decoration
        this._clearDecoration();

        this.selection.save();

        // revert and set style
        var nodes = this._revertToInlines();
        nodes = this.applyArgs(nodes, false);

        // unwrap if attributes was removed
        for (var i = 0; i < nodes.length; i++)
        {
            var node = nodes[i];
            var tag = node.tagName.toLowerCase();
            var len = node.attributes.length;

            if (tag === this.tag && len === 0 && this.args)
            {
                $R.dom(node).unwrap();
                nodes.splice(i, 1);
            }
        }

        this.selection.restore();

        // clear and normalize
        this._clearEmptyStyle();
        nodes = this._normalizeBlocks(nodes);

        return nodes;
    },
    _convertTags: function(tag)
    {
        if (this.tag !== tag)
        {
            var $editor = this.editor.getElement();
            $editor.find(tag).each(function(node)
            {
                var $el = this.utils.replaceToTag(node, 'span');
                $el.addClass('redactor-convertable-' + tag);
            }.bind(this));
        }
    },
    _revertTags: function(tag)
    {
        var $editor = this.editor.getElement();

        $editor.find('span.redactor-convertable-' + tag).each(function(node)
        {
            var $el = this.utils.replaceToTag(node, tag);
            $el.removeClass('redactor-convertable-' + tag);
            if (this.utils.removeEmptyAttr($el, 'class')) $el.removeAttr('class');

        }.bind(this));
    },
    _convertToStrike: function(inlines)
    {
        var selected = this.selection.getText().replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");

        for (var i = 0; i < inlines.length; i++)
        {
            var tag = this.arrangeTag(inlines[i].tagName.toLowerCase());
            var inline = inlines[i];
            var $inline = $R.dom(inline);
            var hasSameArgs = this.hasSameArgs(inline);

            if (tag === this.tag)
            {
                if (this.tag === 'span' && this._isTextSelected(inline, selected))
                {
                    $inline.addClass('redactor-convertable-apply');
                }
                else if (hasSameArgs && this.tag !== 'a')
                {
                    this._replaceToStrike($inline);
                }
                else if (this.tag === 'span')
                {
                    $inline.addClass('redactor-unconvertable-apply');
                }
                else if (!hasSameArgs)
                {
                    $inline.addClass('redactor-convertable-apply');
                }
            }
        }
    },
    _replaceToStrike: function($el)
    {
        $el.replaceWith(function()
        {
            return $R.dom('<strike>').append($el.contents());
        });
    },
    _revertToInlines: function()
    {
        var nodes = [];
        var $editor = this.editor.getElement();

        if (this.tag !== 'u') $editor.find('u').unwrap();

        // span convertable
        $editor.find('.redactor-convertable-apply').each(function(node)
        {
            var $node = $R.dom(node);
            $node.find('strike').unwrap();

            this._forceRemoveClass($node, 'redactor-convertable-apply');
            nodes.push(node);

        }.bind(this));

        // span unconvertable
        $editor.find('span.redactor-unconvertable-apply').each(function(node)
        {
            var $node = $R.dom(node);
            this._forceRemoveClass($node, 'redactor-unconvertable-apply');

        }.bind(this));

        // strike
        $editor.find('strike').each(function(node)
        {
            var $node = this.utils.replaceToTag(node, this.tag);
            nodes.push($node.get());

        }.bind(this));


        this._revertTags('u');
        this._revertTags('del');

        return nodes;
    },
    _normalizeBlocks: function(nodes)
    {
        var tags = this.opts.inlineTags;
        var blocks = this.selection.getBlocks();
        if (blocks)
        {
            for (var i = 0; i < blocks.length; i++)
            {
                if (blocks[i].tagName === 'PRE')
                {
                    var $node = $R.dom(blocks[i]);
                    $node.find(tags.join(',')).not('.redactor-selection-marker').each(function(inline)
                    {
                        if (nodes.indexOf(inline) !== -1)
                        {
                            nodes = this.utils.removeFromArrayByValue(nodes, inline);
                        }

                        $R.dom(inline).unwrap();
                    }.bind(this));
                }
            }
        }

        return nodes;
    },
    _clearDecoration: function()
    {
        var $editor = this.editor.getElement();
        $editor.find(this.opts.inlineTags.join(',')).each(function(node)
        {
            if (node.style.textDecoration === 'line-through' || node.style.textDecorationLine === 'line-through')
            {
                var $el = $R.dom(node);
                $el.css('textDecorationLine', '');
                $el.css('textDecoration', '');
                $el.wrap('<strike>');
            }
        });
    },
    _clearEmptyStyle: function()
    {
        var inlines = this.getInlines();
        for (var i = 0; i < inlines.length; i++)
        {
            this._clearEmptyStyleAttr(inlines[i]);

            var childNodes = inlines[i].childNodes;
            if (childNodes)
            {
                for (var z = 0; z < childNodes.length; z++)
                {
                    this._clearEmptyStyleAttr(childNodes[z]);
                }
            }
        }
    },
    _clearEmptyStyleAttr: function(node)
    {
        if (node.nodeType !== 3 && this.utils.removeEmptyAttr(node, 'style'))
        {
            node.removeAttribute('style');
            node.removeAttribute('data-redactor-style-cache');
        }
    },
    _forceRemoveClass: function($node, classname)
    {
        $node.removeClass(classname);
        if (this.utils.removeEmptyAttr($node, 'class')) $node.removeAttr('class');
    },
    _isTextSelected: function(node, selected)
    {
        var text = this.utils.removeInvisibleChars(node.textContent);

        return (selected === text || selected.search(new RegExp('^' + this.utils.escapeRegExp(text) + '$')) !== -1);
    },

    getInlines: function(tags)
    {
        return (tags) ? this.selection.getInlines({ tags: tags, all: true }) : this.selection.getInlines({ all: true });
    },
    getElements: function(tags)
    {
        return $R.dom(this.getInlines(tags));
    },
    clearFormat: function()
    {
        this.selection.save();

        var nodes = this.selection.getInlines({ all: true });
        for (var i = 0; i < nodes.length; i++)
        {
            var $el = $R.dom(nodes[i]);
            var inline = this.selection.getInline(nodes[i]);
            if (inline)
            {
                $el.unwrap();
            }
        }

        this.selection.restore();
    }
});
$R.add('service', 'autoparser', {
    init: function(app)
    {
        this.app = app;
    },
    observe: function()
    {
        var $editor = this.editor.getElement();
        var $objects = $editor.find('.redactor-autoparser-object').each(function(node)
        {
           var $node = $R.dom(node);
           $node.removeClass('redactor-autoparser-object');
           if ($node.attr('class') === '') $node.removeAttr('class');
        });

        if ($objects.length > 0)
        {
            $objects.each(function(node)
            {
                var type;
                var $object = false;
                var tag = node.tagName;

                if (tag === 'A') type = 'link';
                else if (tag === 'IMG') type = 'image';
                else if (tag === 'IFRAME') type = 'video';

                if (type)
                {
                    $object = $R.create(type + '.component', this.app, node);
                    this.app.broadcast(type + '.inserted', $object);
                    this.app.broadcast('autoparse', type, $object);
                }

            }.bind(this));
        }
    },
    format: function(e, key)
    {
        if (this._isKey(key))
        {
            this._format(key === this.keycodes.ENTER);
        }
    },
    parse: function(html)
    {
        var tags = ['figure', 'form', 'pre', 'iframe', 'code', 'a', 'img'];
        var stored = [];
        var z = 0;

        // encode
        html = this.cleaner.encodePreCode(html);

        // store tags
        for (var i = 0; i < tags.length; i++)
        {
            var reTags = (tags[i] === 'img') ? '<' + tags[i] + '[^>]*>' : '<' + tags[i] + '([\\w\\W]*?)</' + tags[i] + '>';
            var matched = html.match(new RegExp(reTags, 'gi'));

            if (matched !== null)
            {
                for (var y = 0; y < matched.length; y++)
                {
                    html = html.replace(matched[y], '#####replaceparse' + z + '#####');
                    stored.push(matched[y]);
                    z++;
                }
            }
        }

        // images
        if (this.opts.autoparseImages && html.match(this.opts.regex.imageurl))
        {
            var imagesMatches = html.match(this.opts.regex.imageurl);
            for (var i = 0; i < imagesMatches.length; i++)
            {
                html = html.replace(imagesMatches[i], '<img class="redactor-autoparser-object" src="' + imagesMatches[i] + '">');
            }
        }

        // video
        if (this.opts.autoparseVideo && (html.match(this.opts.regex.youtube) || html.match(this.opts.regex.vimeo)))
        {
            var iframeStart = '<iframe width="500" height="281" src="';
            var iframeEnd = '" frameborder="0" allowfullscreen></iframe>';

            var str, re;
            if (html.match(this.opts.regex.youtube))
            {
                str = '//www.youtube.com/embed/$1';
                re = this.opts.regex.youtube;
            }
            else if (html.match(this.opts.regex.vimeo))
            {
                str = '//player.vimeo.com/video/$2';
                re = this.opts.regex.vimeo;
            }

            var $video = this.component.create('video', iframeStart + str + iframeEnd);

            html = html.replace(re, $video.get().outerHTML);
        }

        // links
        if (this.opts.autoparseLinks && html.match(this.opts.regex.url))
        {
            html = this._formatLinks(html);
        }

        // restore
        html = this._restoreReplaced(stored, html);

        // repeat for nested tags
        html = this._restoreReplaced(stored, html);

        return html;
    },

    // private
    _isKey: function(key)
    {
        return (key === this.keycodes.ENTER || key === this.keycodes.SPACE);
    },
    _format: function(enter)
    {
        var parent = this.selection.getParent();
        var $parent = $R.dom(parent);

        var isNotFormatted = (parent && $parent.closest('figure, pre, code, img, a, iframe').length !== 0);
        if (isNotFormatted || !this.selection.isCollapsed())
        {
            return;
        }

        // add split marker
        var marker = this.utils.createInvisibleChar();
        var range = this.selection.getRange();
        range.insertNode(marker);

        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var $current = $R.dom(current);

        // remove split marker
        marker.parentNode.removeChild(marker);

        if (current && current.nodeType === 3)
        {
            var content = current.textContent;
            var type;

            // images
            if (this.opts.autoparseImages && content.match(this._convertToRegExp(this.opts.regex.imageurl)))
            {
                var isList = data.isList();
                var matches = content.match(this.opts.regex.imageurl);
                var el = (isList) ? undefined : '<figure><img></figure>';

                var $img = this.component.create('image', el);
                $img.setSrc(matches[0]);
                $img.addClass('redactor-autoparser-object');

                content = content.replace(matches[0], $img.get().outerHTML);
                type = 'image';
            }
            // video
            else if (this.opts.autoparseVideo && (content.match(this._convertToRegExp(this.opts.regex.youtube)) || content.match(this._convertToRegExp(this.opts.regex.vimeo))))
            {
                var iframeStart = '<iframe width="500" height="281" src="';
                var iframeEnd = '" frameborder="0" allowfullscreen></iframe>';
                var str, re;

                if (content.match(this.opts.regex.youtube))
                {
                    str = '//www.youtube.com/embed/$1';
                    re = this.opts.regex.youtube;
                }
                else if (content.match(this.opts.regex.vimeo))
                {
                    str = '//player.vimeo.com/video/$2';
                    re = this.opts.regex.vimeo;
                }

                var $video = this.component.create('video', iframeStart + str + iframeEnd);
                $video.addClass('redactor-autoparser-object');

                content = content.replace(re, $video.get().outerHTML);
                type = 'video';
            }
            // links
            else if (this.opts.autoparseLinks && content.match(this._convertToRegExp(this.opts.regex.url)))
            {
                content = this._formatLinks(content, enter);
                type = 'link';
            }

            // replace
            if (type)
            {
                if (enter)
                {
                    this.selection.save();
                    $current.replaceWith(content);
                    this.selection.restore();
                }
                else
                {
                    $current.replaceWith(content);
                }

                // object
                var $editor = this.editor.getElement();
                var $object = $editor.find('.redactor-autoparser-object').removeClass('redactor-autoparser-object');
                $object = (type === 'link') ? $R.create('link.component', this.app, $object) : $object;

                // caret
                if (type === 'link')
                {
                    if (!enter) this.caret.setAfter($object);
                    this.app.broadcast('link.inserted', $object);
                }
                else
                {
                    this.caret.setAfter($object);

                    var $cloned = $object.clone();
                    $object.remove();
                    $object = this.insertion.insertHtml($cloned);
                    $object = this.component.build($object);
                }

                // callback
                this.app.broadcast('autoparse', type, $object);
            }
        }
    },
    _formatLinks: function(content, enter)
    {
        var matches = content.match(this.opts.regex.url);
        var obj = {};
        for (var i = 0; i < matches.length; i++)
        {
            if (enter && matches[i].search(/\.$/) !== -1)
            {
                matches[i] = matches[i].replace(/\.$/, '');
            }

            var href = matches[i], text = href;
            var linkProtocol = (href.match(/(https?|ftp):\/\//i) !== null) ? '' : 'http://';
            var regexB = (["/", "&", "="].indexOf(href.slice(-1)) !== -1) ? "" : "\\b";
            var target = (this.opts.pasteLinkTarget !== false) ? ' target="' + this.opts.pasteLinkTarget + '"' : '';

            text = (text.length > this.opts.linkSize) ? text.substring(0, this.opts.linkSize) + '...' : text;
            text = (text.search('%') === -1) ? decodeURIComponent(text) : text;

            // escaping url
            var regexp = '(' + href.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&") + regexB + ')';
            var classstr = ' class="redactor-autoparser-object"';

            obj[regexp] = '<a href="' + linkProtocol + href.trim() + '"' + target + classstr + '>' + text.trim() + '</a>';
        }

        // replace
        for (var key in obj)
        {
            content = content.replace(new RegExp(key, 'g'), obj[key]);
        }

        return content;
    },
    _restoreReplaced: function(stored, html)
    {
        for (var i = 0; i < stored.length; i++)
        {
            html = html.replace('#####replaceparse' + i + '#####', stored[i]);
        }

        return html;
    },
    _convertToRegExp: function(str)
    {
        return new RegExp(String(str).replace(/^\//, '').replace(/\/ig$/, '').replace(/\/gi$/, '') + '$', 'gi');
    }
});
$R.add('service', 'storage', {
    init: function(app)
    {
        this.app = app;

        // local
        this.data = [];
    },
    // public
    observeImages: function()
    {
        if (this.opts.imageObserve) {
            var $editor = this.editor.getElement();
            var $images = $editor.find('[data-image]');
            $images.each(this._addImage.bind(this));
        }
    },
    observeFiles: function()
    {
        var $editor = this.editor.getElement();
        var $files = $editor.find('[data-file]');

		$files.each(this._addFile.bind(this));
    },
	setStatus: function(url, status)
	{
		this.data[url].status = status;
	},
    getChanges: function()
    {
        var $editor = this.editor.getElement();

        // check status
        for (var key in this.data)
		{
			var data = this.data[key];
			var $el = $editor.find('[data-' + data.type + '="' + data.id + '"]');

			this.setStatus(data.id, ($el.length === 0) ? false : true);
		}

        return this.data;
    },
	add: function(type, node)
	{
        var $node = $R.dom(node);
        var id = $node.attr('data-' + type);

        this.data[id] = { type: type, status: true, node: $node.get(), id: $node.attr('data-' + type) };
	},

    // private
    _addImage: function(node)
    {
        this.add('image', node);
    },
    _addFile: function(node)
    {
        this.add('file', node);
    }
});
$R.add('service', 'utils', {
    init: function(app)
    {
        this.app = app;
    },
    // empty
    isEmpty: function(el)
    {
        var isEmpty = false;
        el = $R.dom(el).get();
        if (el)
        {
            isEmpty = (el.nodeType === 3) ? (el.textContent.trim().replace(/\n/, '') === '') : (el.innerHTML === '');
        }

        return isEmpty;
    },
    isEmptyHtml: function(html, keepbr, keeplists)
    {
        html = this.removeInvisibleChars(html);
        html = html.replace(/&nbsp;/gi, '');
        html = html.replace(/<\/?br\s?\/?>/g, ((keepbr) ? 'br' : ''));
        html = html.replace(/\s/g, '');
        html = html.replace(/^<p>[^\W\w\D\d]*?<\/p>$/i, '');
        html = html.replace(/^<div>[^\W\w\D\d]*?<\/div>$/i, '');

        if (keeplists)
        {
            html = html.replace(/<ul(.*?[^>])>$/i, 'ul');
            html = html.replace(/<ol(.*?[^>])>$/i, 'ol');
        }

        html = html.replace(/<hr(.*?[^>])>$/i, 'hr');
        html = html.replace(/<iframe(.*?[^>])>$/i, 'iframe');
        html = html.replace(/<source(.*?[^>])>$/i, 'source');

        // remove empty tags
        html = html.replace(/<[^\/>][^>]*><\/[^>]+>/gi, '');
        html = html.replace(/<[^\/>][^>]*><\/[^>]+>/gi, '');

        // trim
        html = html.trim();

        return html === '';
    },
    trimSpaces: function(html)
    {
        return html = this.removeInvisibleChars(html.trim());
    },

    // invisible chars
    createInvisibleChar: function()
    {
        return document.createTextNode(this.opts.markerChar);
    },
    searchInvisibleChars: function(str)
    {
        return str.search(/^\uFEFF$/g);
    },
    removeInvisibleChars: function(html)
    {
        return html.replace(/\uFEFF/g, '');
    },
    trimInvisibleChars: function(direction)
    {
        if (!this.selection.isCollapsed()) return;

        var current = this.selection.getCurrent();
        var side = (direction === 'left') ? this.selection.getTextBeforeCaret() : this.selection.getTextAfterCaret();
        var isSpace = (current && current.nodeType === 3 && this.searchInvisibleChars(side) === 0);

        if (isSpace)
        {
            if (direction === 'left')
            {
                $R.dom(current).replaceWith(current.textContent.trim());
            }
            else
            {
                var offset = this.offset.get();
                this.offset.set({ start: offset.start + 1, end: offset.end + 1 });
            }
        }
    },

    // wrapper
    buildWrapper: function(html)
    {
        return $R.dom('<div>').html(html);
    },
    getWrapperHtml: function($wrapper)
    {
        var html = $wrapper.html();
        $wrapper.remove();

        return html;
    },

    // fragment
    createTmpContainer: function(html)
    {
        var $div = $R.dom('<div>');

        if (typeof html === 'string')
        {
            $div.html(html);
        }
        else
        {
            $div.append($R.dom(html).clone(true));
        }

        return $div.get();
    },
    createFragment: function(html)
    {
        var el = this.createTmpContainer(html);
        var frag = document.createDocumentFragment(), node, firstNode, lastNode;
        var nodes = [];
        var i = 0;
        while ((node = el.firstChild))
        {
            i++;
            var n = frag.appendChild(node);
            if (i === 1) firstNode = n;

            nodes.push(n);
            lastNode = n;
        }

        return { frag: frag, first: firstNode, last: lastNode, nodes: nodes };
    },
    isFragment: function(obj)
    {
        return (typeof obj === 'object' && obj.frag);
    },
    parseHtml: function(html)
    {
        var div = this.createTmpContainer(html);

        return { html: div.innerHTML, nodes: div.childNodes };
    },

    splitNode: function(current, nodes, isList, inline)
    {
        nodes = (this.isFragment(nodes)) ? nodes.frag : nodes;

        var element;
        if (inline)
        {
            element = (this.inspector.isInlineTag(current.tagName)) ? current : this.selection.getInline(current);
        }
        else
        {
            element = (this.inspector.isBlockTag(current.tagName)) ? current : this.selection.getBlock(current);
        }

        var $element = $R.dom(element);

        // replace is empty
        if (!inline && this.isEmptyHtml(element.innerHTML, true))
        {
            $element.after(nodes);
            $element.remove();

            return nodes;
        }

        var tag = $element.get().tagName.toLowerCase();
        var isEnd = this.caret.isEnd(element);
        var isStart = this.caret.isStart(element);

        if (!isEnd && !isStart)
        {
            var extractedContent = this.extractHtmlFromCaret(inline);

            var $secondPart = $R.dom('<' + tag + ' />');
            $secondPart = this.cloneAttributes(element, $secondPart);

            $element.after($secondPart.append(extractedContent));
        }

        if (isStart)
        {
            return $element.before(nodes);
        }
        else
        {
            if (isList)
            {
                return $element.append(nodes);
            }
            else
            {
                nodes = $element.after(nodes);

                var html = $element.html();
                html = this.removeInvisibleChars(html);
                html = html.replace(/&nbsp;/gi, '');

                if (html === '') $element.remove();

                return nodes;
            }
        }
    },
    extractHtmlFromCaret: function(inline, element)
    {
        var range = this.selection.getRange();
        if (range)
        {
            element = (element) ? element : ((inline) ? this.selection.getInline() : this.selection.getBlock());
            if (element)
            {
                var clonedRange = range.cloneRange();
                clonedRange.selectNodeContents(element);
                clonedRange.setStart(range.endContainer, range.endOffset);

                return clonedRange.extractContents();
            }
        }
    },
    createMarkup: function(el)
    {
        var markup = document.createElement(this.opts.markup);
        if (this.opts.breakline) markup.setAttribute('data-redactor-tag', 'br');

        var $el = $R.dom(el);

        $el.after(markup);
        this.caret.setStart(markup);
    },
    createMarkupBefore: function(el)
    {
        var markup = document.createElement(this.opts.markup);
        if (this.opts.breakline) markup.setAttribute('data-redactor-tag', 'br');

        var $el = $R.dom(el);

        $el.before(markup);
        this.caret.setEnd(markup);
    },
    getNode: function(el)
    {
        var node = $R.dom(el).get();
        var editor = this.editor.getElement().get();

        return (typeof el === 'undefined') ? editor : ((node) ? node : false);
    },
    findSiblings: function(node, type)
    {
        node = $R.dom(node).get();
        type = (type === 'next') ? 'nextSibling' : 'previousSibling';

        while (node = node[type])
        {
            if ((node.nodeType === 3 && node.textContent.trim() === '') || node.tagName === 'BR')
            {
                continue;
            }

            return node;
        }

        return false;
    },
    getElementsFromHtml: function(html, selector, exclude)
    {
        var div = document.createElement("div");
        div.innerHTML = html;

        var elems = div.querySelectorAll(selector);

        // array map polyfill
        var mapping = function(callback, thisArg)
        {
            if (typeof this.length !== 'number') return;
            if (typeof callback !== 'function') return;

            var newArr = [];
            if (typeof this == 'object')
            {
                for (var i = 0; i < this.length; i++)
                {
                    if (i in this) newArr[i] = callback.call(thisArg || this, this[i], i, this);
                    else return;
                }
            }

            return newArr;
        };

        return mapping.call(elems, function(el)
        {
            var type = el.getAttribute('data-redactor-type');
            if (exclude && type && type === exclude) {}
            else return el.outerHTML;
        });
    },

    // childnodes
    getChildNodes: function(el, recursive, elements)
    {
        el = (el && el.nodeType && el.nodeType === 11) ? el : $R.dom(el).get();

        var nodes = el.childNodes;
        var result = [];
        if (nodes)
        {
            for (var i = 0; i < nodes.length; i++)
            {
                if (elements === true && nodes[i].nodeType === 3) continue;
                else if (nodes[i].nodeType === 3 && this.isEmpty(nodes[i])) continue;

                result.push(nodes[i]);

                if (recursive !== false)
                {
                    var nestedNodes = this.getChildNodes(nodes[i], elements);
                    if (nestedNodes.length > 0)
                    {
                        result = result.concat(nestedNodes);
                    }
                }
            }
        }

        return result;
    },
    getChildElements: function(el)
    {
        return this.getChildNodes(el, true, true);
    },
    getFirstNode: function(el)
    {
        return this._getFirst(this.getChildNodes(el, false));
    },
    getLastNode: function(el)
    {
        return this._getLast(this.getChildNodes(el, false));
    },
    getFirstElement: function(el)
    {
        return this._getFirst(this.getChildNodes(el, false, true));
    },
    getLastElement: function(el)
    {
        return this._getLast(this.getChildNodes(el, false, true));
    },

    // replace
    replaceToTag: function(node, tag)
    {
        var $node = $R.dom(node);
        return $node.replaceWith(function(node)
        {
            var $replaced = $R.dom('<' + tag + '>').append($R.dom(node).contents());
            if (node.attributes)
            {
                var attrs = node.attributes;
                for (var i = 0; i < attrs.length; i++)
                {
                    $replaced.attr(attrs[i].nodeName, attrs[i].value);
                }
            }

            return $replaced;

        });
    },

    // string
    ucfirst: function(str)
    {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },

    // array
    removeFromArrayByValue: function(arr, value)
    {
        var a = arguments, len = a.length, ax;
        while (len > 1 && arr.length)
        {
            value = a[--len];
            while ((ax= arr.indexOf(value)) !== -1)
            {
                arr.splice(ax, 1);
            }
        }

        return arr;
    },

    // attributes
    removeEmptyAttr: function(el, attr)
    {
        var $el = $R.dom(el);

        if (typeof $el.attr(attr) === 'undefined' || $el.attr(attr) === null) return true;
        else if ($el.attr(attr) === '')
        {
            $el.removeAttr(attr);
            return true;
        }

        return false;
    },
    cloneAttributes: function(elFrom, elTo)
    {
        elFrom = $R.dom(elFrom).get();
        elTo = $R.dom(elTo);

        var attrs = elFrom.attributes;
        var len = attrs.length;
        while (len--)
        {
            var attr = attrs[len];
            elTo.attr(attr.name, attr.value);
        }

        return elTo;
    },

    // object
    toParams: function(obj)
    {
        if (typeof obj !== 'object') return obj;

        var keys = Object.keys(obj);
        if (!keys.length) return '';
        var result = '';

        for (var i = 0; i < keys.length; i++)
        {
            var key = keys[i];
            result += key + ':' + obj[key] + ';';
        }

        return result;
    },
    styleToObj: function(str)
    {
        var obj = {};

        if (str)
        {
            var style = str.replace(/;$/, '').split(';');
            for (var i = 0; i < style.length; i++)
            {
                var rule = style[i].split(':');
                obj[rule[0].trim()] = rule[1].trim();
            }
        }

        return obj;
    },
    checkProperty: function(obj)
    {
        var args = (arguments[1] && Array.isArray(arguments[1])) ? arguments[1] : [].slice.call(arguments, 1);

        for (var i = 0; i < args.length; i++)
        {
            if (!obj || (typeof obj[args[i]] === 'undefined'))
            {
                return false;
            }

            obj = obj[args[i]];
        }

        return obj;
    },

    // data
    extendData: function(data, obj)
    {
        for (var key in obj)
        {
            if (key === 'elements')
            {
                var $elms = $R.dom(obj[key]);
                $elms.each(function(node)
                {
                    var $node = $R.dom(node);
                    if (node.tagName === 'FORM')
                    {
                        var serializedData = $node.serialize(true);
                        for (var z in serializedData)
                        {
                            data = this._setData(data, z, serializedData[z]);
                        }
                    }
                    else
                    {
                        var name = ($node.attr('name')) ? $node.attr('name') : $node.attr('id');
                        data = this._setData(data, name, $node.val());
                    }
                }.bind(this));
            }
            else
            {
                data = this._setData(data, key, obj[key]);
            }
        }

        return data;
    },
    _setData: function(data, name, value)
    {
        if (data instanceof FormData) data.append(name, value);
        else data[name] = value;

        return data;
    },

    // normalize
    normalizeTextNodes: function(el)
    {
        el = $R.dom(el).get();
        if (el) el.normalize();
    },

    // color
    isRgb: function(str)
    {
        return (str.search(/^rgb/i) === 0);
    },
    rgb2hex: function(rgb)
    {
        rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);

        return (rgb && rgb.length === 4) ? "#" +
        ("0" + parseInt(rgb[1],10).toString(16)).slice(-2) +
        ("0" + parseInt(rgb[2],10).toString(16)).slice(-2) +
        ("0" + parseInt(rgb[3],10).toString(16)).slice(-2) : '';
    },
    hex2long: function(val)
    {
        if (val.search(/^#/) !== -1 && val.length === 4)
        {
            val = '#' + val[1] + val[1] + val[2] + val[2] + val[3] + val[3];
        }

        return val;
    },

    // escape
    escapeRegExp: function(s)
    {
        return s.replace(/[-\/\\^$*~+?.()|[\]{}]/g, '\\$&');
    },

    // random
    getRandomId: function()
    {
        var id = '';
        var possible = 'abcdefghijklmnopqrstuvwxyz0123456789';

        for (var i = 0; i < 12; i++)
        {
            id += possible.charAt(Math.floor(Math.random() * possible.length));
        }

        return id;
    },

    // private
    _getFirst: function(nodes)
    {
        return (nodes.length !== 0) ? nodes[0] : false;
    },
    _getLast: function(nodes)
    {
        return (nodes.length !== 0) ? nodes[nodes.length-1] : false;
    }
});
$R.add('service', 'progress', {
    init: function(app)
    {
        this.app = app;

        // local
        this.$box = null;
        this.$bar = null;
    },

    // public
    show: function()
    {
        if (!this._is()) this._build();
        this.$box.show();
    },
    hide: function()
    {
        if (this._is())
        {
            this.animate.start(this.$box, 'fadeOut', this._destroy.bind(this));
        }
    },
    update: function(value)
    {
        this.show();
        this.$bar.css('width', value + '%');
    },

    // private
    _is: function()
    {
        return (this.$box !== null);
    },
    _build: function()
    {
        this.$bar = $R.dom('<span />');
        this.$box = $R.dom('<div id="redactor-progress" />');

        this.$box.append(this.$bar);
        this.$body.append(this.$box);
    },
    _destroy: function()
    {
        if (this._is()) this.$box.remove();

        this.$box = null;
        this.$bar = null;
    }
});
$R.add('module', 'starter', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.plugin = app.plugin;
        this.module = app.module;
    },
    // messages
    onstart: function()
    {
        var services = ['element', 'container', 'source', 'editor', 'statusbar', 'toolbar'];
        var modules = ['element', 'container', 'source', 'editor', 'statusbar', 'contextbar', 'input'];

        this._startStop('start', this.app, services);
        this._startStop('start', this.module, modules);
    },
    onstop: function()
    {
        var modules = ['observer', 'element', 'container', 'source', 'editor', 'contextbar'];

        this._startStop('stop', this.module, modules);
    },
    onenable: function()
    {
        var modules = ['observer', 'toolbar'];
        var plugins = this.opts.plugins;

        this._startStop('start', this.module, modules);
        this._startStop('start', this.plugin, plugins);
    },
    ondisable: function()
    {
        var modules = ['observer', 'toolbar'];
        var plugins = this.opts.plugins;

        this._startStop('stop', this.module, modules);
        this._startStop('stop', this.plugin, plugins);
    },

    // private
    _startStop: function(type, obj, arr)
    {
        for (var i = 0; i < arr.length; i++)
        {
            if (typeof obj[arr[i]] !== 'undefined')
            {
                this.app.callInstanceMethod(obj[arr[i]], type);
            }
        }
    }
});
$R.add('module', 'element', {
    init: function(app)
    {
        this.app = app;
        this.uuid = app.uuid;
        this.opts = app.opts;
        this.namespace = app.namespace;
        this.element = app.element;
        this.rootOpts = $R.extend({}, true, $R.options, app.rootOpts);
    },
    // public
    start: function()
    {
        this._build();
        this._buildModes();
        this._buildMarkup();
    },
    stop: function()
    {
        var $element = this.element.getElement();
        $element.removeData(this.namespace + '-uuid');
    },

    // private
    _build: function()
    {
        var $element = this.element.getElement();
        $element.data(this.namespace + '-uuid', this.uuid);
    },
    _buildModes: function()
    {
        var type = this.element.getType();

        if (type === 'inline') this._redefineOptions(this.opts.modes['inline']);
        if (type === 'div') this._redefineOptions(this.opts.modes['original']);

        if (type !== 'inline')
        {
            if (this._isRootOption('styles') && this.rootOpts.styles) this.opts.styles = true;
            if (this._isRootOption('source') && !this.rootOpts.source) this.opts.showSource = false;
        }
    },
    _buildMarkup: function()
    {
        var type = this.element.getType();

        if (type === 'inline')
        {
            this.opts.emptyHtml = '';
        }
        else if (this.opts.breakline)
        {
            this.opts.markup = 'div';
            this.opts.emptyHtml = '<div data-redactor-tag="br">' + this.opts.markerChar + '</div>';
        }
        else
        {
            this.opts.emptyHtml = '<' + this.opts.markup + '></' + this.opts.markup + '>';
        }
    },
    _redefineOptions: function(opts)
    {
        for (var key in opts)
        {
            this.opts[key] = opts[key];
        }
    },
    _isRootOption: function()
    {
        return (typeof this.rootOpts['styles'] !== 'undefined');
    }
});
$R.add('module', 'editor', {
    init: function(app)
    {
        this.app = app;
        this.uuid = app.uuid;
        this.opts = app.opts;
        this.editor = app.editor;
        this.source = app.source;
        this.element = app.element;
        this.component = app.component;
        this.container = app.container;
        this.inspector = app.inspector;
        this.autoparser = app.autoparser;

        // local
        this.placeholder = false;
        this.events = false;
    },
    // messages
    onenable: function()
    {
        this.enable();
    },
    ondisable: function()
    {
        this.disable();
    },
    onenablefocus: function()
    {
        this._enableFocus();
    },
    oncontextmenu: function(e)
    {
        this.component.setOnEvent(e, true);
    },
    onclick: function(e)
    {
        this.component.setOnEvent(e);
    },
    onkeyup: function(e)
    {
        var data = this.inspector.parse(e.target);
        if (!data.isComponent())
        {
            this.component.clearActive();
        }
    },
    onenablereadonly: function()
    {
        this._enableReadOnly();
    },
    ondisablereadonly: function()
    {
        this._disableReadOnly();
    },
    onautoparseobserve: function()
    {
        this.autoparser.observe();
    },
    onplaceholder: {
        build: function()
        {
            this._buildPlaceholder();
        },
        toggle: function()
        {
            this._togglePlacehodler();
        }
    },

    // public
    start: function()
    {
        this._build();
        this._buildEvents();
        this._buildOptions();
        this._buildAccesibility();
    },
    stop: function()
    {
        var $editor = this.editor.getElement();
        var $container = this.container.getElement();

        var classesEditor = ['redactor-in', 'redactor-in-' + this.uuid, 'redactor-structure', 'redactor-placeholder', 'notranslate', this.opts.stylesClass];
        var classesContainer = ['redactor-focus', 'redactor-blur', 'redactor-over', 'redactor-styles-on',
                                'redactor-styles-off', 'redactor-toolbar-on', 'redactor-text-labeled-on', 'redactor-source-view'];

        $editor.removeAttr('spellcheck');
        $editor.removeAttr('dir');
        $editor.removeAttr('contenteditable');
        $editor.removeAttr('placeholder');
        $editor.removeAttr('data-gramm_editor');
        $editor.removeClass(classesEditor.join(' '));

        $container.removeClass(classesContainer.join(' '));

        this._destroyEvents();

        if ($editor.get().classList.length === 0) $editor.removeAttr('class');
    },
    enable: function()
    {
        var $editor = this.editor.getElement();
        var $container = this.container.getElement();

        $editor.addClass('redactor-in redactor-in-' + this.uuid);
        $editor.attr({ 'contenteditable': true });

        if (this.opts.structure)
        {
            $editor.addClass('redactor-structure');
        }

        if (this.opts.toolbar && !this.opts.air && !this.opts.toolbarExternal)
        {
            $container.addClass('redactor-toolbar-on');
        }

        // prevent editing
        this._disableBrowsersEditing();
    },
    disable: function()
    {
        var $editor = this.editor.getElement();
        var $container = this.container.getElement();

        $editor.removeClass('redactor-in redactor-in-' + this.uuid);
        $editor.removeClass('redactor-structure');
        $editor.removeAttr('contenteditable');

        $container.addClass('redactor-toolbar-on');
    },

    // private
    _build: function()
    {
        var $editor = this.editor.getElement();
        var $element = this.element.getElement();
        var $container = this.container.getElement();

        $container.addClass('redactor-blur');

        if (!this.opts.grammarly)
        {
            $editor.attr('data-gramm_editor', false);
        }

        if (this.opts.notranslate)
        {
            $editor.addClass('notranslate');
        }

        if (this.opts.styles)
        {
            $editor.addClass(this.opts.stylesClass);
            $container.addClass('redactor-styles-on');
        }
        else
        {
            $container.addClass('redactor-styles-off');
        }

        if (this.opts.buttonsTextLabeled)
        {
            $container.addClass('redactor-text-labeled-on');
        }

        if (this.element.isType('textarea')) $element.before($editor);
    },
    _buildEvents: function()
    {
        this.events = $R.create('editor.events', this.app);
    },
    _buildOptions: function()
    {
        var $editor = this.editor.getElement();

        $editor.attr('dir', this.opts.direction);

        if (this.opts.tabindex)  $editor.attr('tabindex', this.opts.tabindex);
        if (this.opts.minHeight) $editor.css('min-height', this.opts.minHeight);
        if (this.opts.maxHeight) $editor.css('max-height', this.opts.maxHeight);
        if (this.opts.maxWidth)  $editor.css({ 'max-width': this.opts.maxWidth, 'margin': 'auto' });
    },
    _buildAccesibility: function()
    {
        var $editor = this.editor.getElement();

        $editor.attr({ 'aria-labelledby': 'redactor-voice-' + this.uuid, 'role': 'presentation' });
    },
    _buildPlaceholder: function()
    {
        this.placeholder = $R.create('editor.placeholder', this.app);
    },
    _enableFocus: function()
    {
        if (this.opts.showSource) this._enableFocusSource();
        else this._enableFocusEditor();
    },
    _enableFocusSource: function()
    {
        var $source = this.source.getElement();

        if (this.opts.focus)
        {
            $source.focus();
            $source.get().setSelectionRange(0, 0);
        }
        else if (this.opts.focusEnd)
        {
            $source.focus();
        }
    },
    _enableFocusEditor: function()
    {
        if (this.opts.focus)
        {
            setTimeout(this.editor.startFocus.bind(this.editor), 100);
        }
        else if (this.opts.focusEnd)
        {
            setTimeout(this.editor.endFocus.bind(this.editor), 100);
        }
    },
    _togglePlacehodler: function()
    {
        if (this.placeholder) this.placeholder.toggle();
    },
    _disableBrowsersEditing: function()
    {
        try {
            // FF fix
            document.execCommand('enableObjectResizing', false, false);
            document.execCommand('enableInlineTableEditing', false, false);
            // IE prevent converting links
            document.execCommand("AutoUrlDetect", false, false);

            // IE disable image resizing
            var $editor = this.editor.getElement();
            var el = $editor.get();
            if (el.addEventListener) el.addEventListener('mscontrolselect', function(e) { e.preventDefault(); });
            else el.attachEvent('oncontrolselect', function(e) { e.returnValue = false; });

        } catch (e) {}
    },
    _destroyEvents: function()
    {
        if (this.events)
        {
            this.events.destroy();
        }
    },
    _enableReadOnly: function()
    {
        var $editor = this.editor.getElement();

        this._getEditables($editor).removeAttr('contenteditable');
        $editor.removeAttr('contenteditable');
        $editor.addClass('redactor-read-only');

        if (this.events) this.events.destroy();
    },
    _disableReadOnly: function()
    {
        var $editor = this.editor.getElement();

        this._getEditables($editor).attr({ 'contenteditable': true });
        $editor.removeClass('redactor-read-only');
        $editor.attr({ 'contenteditable': true });

        this._buildEvents();
    },
    _getEditables: function($editor)
    {
        return $editor.find('figcaption, td, th');
    }
});
$R.add('class', 'editor.placeholder', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.editor = app.editor;
        this.element = app.element;

        // build
        this.build();
    },
    build: function()
    {
        var $element = this.element.getElement();
        var $editor = this.editor.getElement();

        if (this.opts.placeholder !== false || $element.attr('placeholder'))
        {
            var text = (this.opts.placeholder !== false) ? this.opts.placeholder : $element.attr('placeholder');
            $editor.attr('placeholder', text);
            this.toggle();
        }
    },
    toggle: function()
    {
        return (this.editor.isEmpty(true)) ? this.show() : this.hide();
    },
    show: function()
    {
        var $editor = this.editor.getElement();
        $editor.addClass('redactor-placeholder');
    },
    hide: function()
    {
        var $editor = this.editor.getElement();
        $editor.removeClass('redactor-placeholder');
    }
});
$R.add('class', 'editor.events', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.$doc = app.$doc;
        this.uuid = app.uuid;
        this.source = app.source;
        this.editor = app.editor;
        this.cleaner = app.cleaner;
        this.container = app.container;
        this.insertion = app.insertion;
        this.inspector = app.inspector;
        this.selection = app.selection;
        this.component = app.component;

        // local
        this.blurNamespace = '.redactor-blur.' + this.uuid;
        this.eventsList = ['paste', 'click', 'contextmenu', 'keydown', 'keyup', 'mouseup', 'touchstart',
                           'cut', 'copy', 'dragenter', 'dragstart', 'drop', 'dragover', 'dragleave'];

        // init
        this._init();
    },
    destroy: function()
    {
        var $editor = this.editor.getElement();

        $editor.off('.redactor-focus');
        this.$doc.off('keyup' + this.blurNamespace + ' mousedown' + this.blurNamespace);

        // all events
        this._loop('off');
    },
    focus: function(e)
    {
        var $container = this.container.getElement();

        if (this.editor.isPasting() || $container.hasClass('redactor-focus')) return;

        $container.addClass('redactor-focus');
        $container.removeClass('redactor-blur');

        this.app.broadcast('observe', e);
        this.app.broadcast('focus', e);

        this.isFocused = true;
        this.isBlured = false;
    },
    blur: function(e)
    {
        var $container = this.container.getElement();
        var $target = $R.dom(e.target);
        var targets = ['.redactor-in-' + this.uuid,  '.redactor-toolbar', '.redactor-dropdown',
        '.redactor-context-toolbar', '#redactor-modal', '#redactor-image-resizer'];

        this.app.broadcast('originalblur', e);
        if (this.app.stopBlur) return;

        if (!this.app.isStarted() || this.editor.isPasting()) return;
        if ($target.closest(targets.join(',')).length !== 0) return;

        if (!this.isBlured && !$container.hasClass('redactor-blur'))
        {
            $container.removeClass('redactor-focus');
            $container.addClass('redactor-blur');
            this.app.broadcast('blur', e);

            this.isFocused = false;
            this.isBlured = true;
        }
    },
    cut: function(e)
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);

        this.app.broadcast('state', e);

        if (this.component.isNonEditable(current))
        {
            this._passSelectionToClipboard(e, data, true);
            e.preventDefault();
        }
    },
    copy: function(e)
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);

        this.app.broadcast('state', e);

        if (this.component.isNonEditable(current))
        {
            this._passSelectionToClipboard(e, data, false);
            e.preventDefault();
        }
    },
    drop: function(e)
    {
        e = e.originalEvent || e;
        e.stopPropagation();
        this._removeOverClass();

        if (this.opts.dragUpload === false)
        {
            e.preventDefault();
            return;
        }

        if (this.app.isDragComponentInside())
        {
            var $dragComponent = $R.dom(this.app.getDragComponentInside());
            var $component = $dragComponent.clone(true);
            this.insertion.insertToPoint(e, $component);

            $dragComponent.remove();

            this.app.setDragComponentInside(false);
            this.app.broadcast('state', e);
            this.app.broadcast('drop', e);
            this.app.broadcast('image.observe', e);

            e.preventDefault();

            return;
        }
        else if (this.app.isDragInside() && this.opts.input)
        {
            this.insertion.insertPoint(e);

            var dt = e.dataTransfer;
            var html = dt.getData('text/html');

            // clear selected
            var range = this.selection.getRange();
            if (range)
            {
                var blocks = this.selection.getBlocks();
                range.deleteContents();

                // remove empty blocks
                for (var i = 0; i < blocks.length; i++)
                {
                    if (blocks[i].innerHTML === '') $R.dom(blocks[i]).remove();
                }
            }

            // paste
            $R.create('input.paste', this.app, e, true, html, true);

            this.app.broadcast('state', e);
            this.app.broadcast('drop', e);

            this.app.setDragInside(false);
            e.preventDefault();

            return;
        }

        this.app.broadcast('state', e);
        this.app.broadcast('paste', e, e.dataTransfer);
        this.app.broadcast('drop', e);

    },
    dragenter: function(e)
    {
        e.preventDefault();
    },
    dragstart: function(e)
    {
        this.app.setDragComponentInside(false);
        this.app.setDragInside(false);

        var data = this.inspector.parse(e.target);
        if (data.isComponent() && !data.isComponentEditable() && !data.isFigcaption())
        {
            this.app.setDragComponentInside(data.getComponent());
        }
        else if (this.selection.is() && !this.selection.isCollapsed())
        {
            // drag starts inside editor
            this.app.setDragInside(true);
            this._setDragData(e);
        }

        this.app.broadcast('dragstart', e);
    },
    dragover: function(e)
    {
        this.app.broadcast('dragover', e);
    },
    dragleave: function(e)
    {
        this.app.broadcast('dragleave', e);
    },
    paste: function(e)
    {
        this.app.broadcast('paste', e);
    },
    contextmenu: function(e)
    {
        // chrome crashes fix
        //this.editor.disableNonEditables();

        //setTimeout(function()
        //{
          //  this.editor.enableNonEditables();
           // this.app.broadcast('contextmenu', e);

        //}.bind(this), 0);
    },
    click: function(e)
    {
        // triple click selection
        if (e.detail === 3)
        {
            e.preventDefault();

            var block = this.selection.getBlock();
            var range = document.createRange();
            range.selectNodeContents(block);
            this.selection.setRange(range)
        }

        // observe bottom click & start click
        var $target = $R.dom(e.target);
        if ($target.hasClass('redactor-in'))
        {
            var top = $target.offset().top;
            var pad = parseFloat($target.css('padding-bottom'));
            var height = $target.height();
            var posHeight = top + height - pad*2;

            if (posHeight < e.pageY)
            {
                this.app.broadcast('bottomclick', e);
            }
        }

        this.app.broadcast('state', e);
        this.app.broadcast('click', e);
    },
    keydown: function(e)
    {
        this.app.broadcast('state', e);
        var stop = this.app.broadcast('keydown', e);
        if (stop === false)
        {
            return e.preventDefault();
        }
    },
    keyup: function(e)
    {
        this.app.broadcast('keyup', e);
    },
    mouseup: function(e)
    {
        this.app.broadcast('observe', e);
        this.app.broadcast('state', e);
    },
    touchstart: function(e)
    {
        this.app.broadcast('observe', e);
        this.app.broadcast('state', e);
    },

    // private
    _init: function()
    {
        var $editor = this.editor.getElement();

        $editor.on('focus.redactor-focus click.redactor-focus', this.focus.bind(this));
        this.$doc.on('keyup' + this.blurNamespace + ' mousedown' + this.blurNamespace, this.blur.bind(this));

        // all events
        this._loop('on');
    },
    _removeOverClass: function()
    {
        var $editor = this.editor.getElement();
        $editor.removeClass('over');
    },
    _loop: function(func)
    {
        var $editor = this.editor.getElement();
        for (var i = 0; i < this.eventsList.length; i++)
        {
            var event = this.eventsList[i] + '.redactor-events';
            var method = this.eventsList[i];

            $editor[func](event, this[method].bind(this));
        }
    },
    _passAllToClipboard: function(e)
    {
        var clipboard = e.clipboardData;
        var content = this.source.getCode();

        clipboard.setData('text/html', content);
        clipboard.setData('text/plain', content.toString().replace(/\n$/, ""));
    },
    _passSelectionToClipboard: function(e, data, remove)
    {
        var clipboard = e.clipboardData;
        var node = data.getComponent();
        var $node = $R.dom(node);
        var $cloned = $node.clone();

        // clean
        $cloned.find('.redactor-component-caret').remove();
        $cloned.removeClass('redactor-component-active');
        $cloned.removeAttr('contenteditable');
        $cloned.removeAttr('tabindex');

        // html
        var content = $cloned.get().outerHTML;

        if (remove) this.component.remove(node);

        clipboard.setData('text/html', content);
        clipboard.setData('text/plain', content.toString().replace(/\n$/, ""));
    },
    _setDragData: function(e)
    {
        e = e.originalEvent || e;

        var dt = e.dataTransfer;
        dt.effectAllowed = 'move';
        dt.setData('text/Html', this.selection.getHtml());
    }
});
$R.add('module', 'container', {
    init: function(app)
    {
        this.app = app;
        this.uuid = app.uuid;
        this.opts = app.opts;
        this.lang = app.lang;
        this.element = app.element;
        this.container = app.container;
    },
    // public
    start: function()
    {
        this._build();
        this._buildAccesibility();
    },
    stop: function()
    {
        var $element = this.element.getElement();
        var $container = this.container.getElement();

        $container.after($element);
        $container.remove();
        $element.show();
    },

    // private
    _build: function()
    {
        var $element = this.element.getElement();
        var $container = this.container.getElement();

        $container.addClass('redactor-box');
        $container.attr('dir', this.opts.direction);

        if (this.element.isType('inline')) $container.addClass('redactor-inline');

        $element.after($container);
        $container.append($element);
    },
    _buildAccesibility: function()
    {
        var $container = this.container.getElement();
        var $label = $R.dom('<span />');

        $label.addClass('redactor-voice-label');
        $label.attr({ 'id': 'redactor-voice-' + this.uuid, 'aria-hidden': false });
        $label.html(this.lang.get('accessibility-help-label'));

        $container.prepend($label);
    }
});
$R.add('module', 'source', {
    init: function(app)
    {
        this.app = app;
        this.uuid = app.uuid;
        this.opts = app.opts;
        this.utils = app.utils;
        this.element = app.element;
        this.source = app.source;
        this.editor = app.editor;
        this.toolbar = app.toolbar;
        this.cleaner = app.cleaner;
        this.component = app.component;
        this.container = app.container;
        this.autoparser = app.autoparser;
        this.selection = app.selection;

        // local
        this.syncedHtml = '';
    },
    // messages
    onstartcode: function()
    {
        var sourceContent = this.source.getStartedContent();
        var $editor = this.editor.getElement();
        var $source = this.source.getElement();

        // autoparse
        if (this.opts.autoparse && this.opts.autoparseStart)
        {
            sourceContent = this.autoparser.parse(sourceContent);
        }

        // started content
        var startContent = this.cleaner.input(sourceContent, true, true);
        var syncContent = this.cleaner.output(startContent);

        // set content
        $editor.html(startContent);
        $source.val(syncContent);

        this.syncedHtml = syncContent;
        this.app.broadcast('placeholder.build');
        this.app.broadcast('autoparseobserve');

        // widget's scripts
        this.component.executeScripts();
    },
    onstartcodeshow: function()
    {
        this.show();
    },
    ontrytosync: function()
    {
        this.sync();
    },
    onhardsync: function()
    {
        var $editor = this.editor.getElement();
        var html = $editor.html();

        html = this.app.broadcast('syncBefore', html);
        html = this.cleaner.output(html);

        this._syncing(html);
    },

    // public
    start: function()
    {
        this._build();
        this._buildClasses();
    },
    stop: function()
    {
        var $element = this.element.getElement();
        var $source = this.source.getElement();

        $element.removeClass('redactor-source redactor-source-open');
        $source.off('input.redactor-source');
        $source.removeAttr('data-gramm_editor');

        if ($source.get().classList.length === 0) $source.removeAttr('class');
        if (!this.source.isNameGenerated()) $element.removeAttr('name');
        if (!this.element.isType('textarea')) $source.remove();

    },
    getCode: function()
    {
        return this.source.getCode();
    },

    // public
    toggle: function()
    {
        if (!this.opts.source) return;

        var $source = this.source.getElement();

        return ($source.hasClass('redactor-source-open')) ? this.hide() : this.show();
    },
    show: function()
    {
        if (!this.opts.source) return;

        var $editor = this.editor.getElement();
        var $source = this.source.getElement();
        var $container = this.container.getElement();

        var html = $source.val();

        if (this.app.isStarted()) html = this.app.broadcast('source.open', html);

        // get height
        var editorHeight = $editor.height();

        $editor.hide();
        $source.height(editorHeight);
        $source.val(html.trim());
        $source.show();
        $source.addClass('redactor-source-open');
        $source.on('input.redactor-source-events', this._onChangedSource.bind(this));
        $source.on('keydown.redactor-source-events', this._onTabKey.bind(this));
        $source.on('focus.redactor-source-events', this._onFocus.bind(this));

        if (this.opts.source.hasOwnProperty('codemirror')) {
            var opts = (typeof this.opts.source.codemirror === 'object') ? this.opts.source.codemirror : {};
            this.codemirror = CodeMirror.fromTextArea($source.get(), opts);
            this.codemirror.setSize(null, editorHeight);
            this.codemirror.on('change', function(cm, changeObj){ cm.save() });
            this.codemirror.on('change', this._onChangedSource.bind(this));
        }
        else {
            $container.addClass('redactor-source-view');
        }

        // buttons
        setTimeout(function()
        {
            this._disableButtons();
            this._setActiveSourceButton();

        }.bind(this), 100);

        if (this.app.isStarted()) this.app.broadcast('source.opened');
    },
    hide: function()
    {
        if (!this.opts.source) return;

        var $editor = this.editor.getElement();
        var $source = this.source.getElement();
        var $container = this.container.getElement();

        var html = $source.val();
        if (this.opts.source.hasOwnProperty('codemirror')) {
            html = this.codemirror.getValue();
            this.codemirror.toTextArea();
        }


        // clean
        html = this.cleaner.input(html, true);
        html = (this.utils.isEmptyHtml(html)) ? this.opts.emptyHtml : html;
        html = this.app.broadcast('source.close', html);

        // buttons
        this._enableButtons();
        this._setInactiveSourceButton();

        $source.hide();
        $source.removeClass('redactor-source-open');
        $source.off('.redactor-source-events');
        $editor.show();
        $editor.html(html);

        $container.removeClass('redactor-source-view');

        setTimeout(function()
        {
            this.editor.startFocus();

            // widget's scripts
            this.component.executeScripts();

        }.bind(this), 0);

        this.app.broadcast('source.closed');
    },
    sync: function()
    {
        var self = this;
        var $editor = this.editor.getElement();
        var html = $editor.html();

        html = this.app.broadcast('syncBefore', html);
        html = this.cleaner.output(html);

        if (this._isSync(html))
        {
            if (this.timeout) clearTimeout(this.timeout);
            this.timeout = setTimeout(function() { self._syncing(html); }, 200);
        }
    },

    // private
    _build: function()
    {
        var $source = this.source.getElement();
        var $element = this.element.getElement();

        $source.hide();

        if (!this.opts.grammarly)
        {
            $source.attr('data-gramm_editor', false);
        }

        if (!this.element.isType('textarea'))
        {
            $element.after($source);
        }
    },
    _buildClasses: function()
    {
        var $source = this.source.getElement();

        $source.addClass('redactor-source');
    },
    _syncing: function(html)
    {
        html = this.app.broadcast('syncing', html);

        var $source = this.source.getElement();
        $source.val(html);

        this.app.broadcast('synced', html);
        this.app.broadcast('changed', html);
    },
    _isSync: function(html)
    {
        if (this.syncedHtml !== html)
        {
            this.syncedHtml = html;
            return true;
        }

        return false;
    },
    _onChangedSource: function()
    {
        var $source = this.source.getElement();
        var html = $source.val();

        this.app.broadcast('changed', html);
        this.app.broadcast('source.changed', html);
    },
    _onTabKey: function(e)
    {
        if (e.keyCode !== 9) return true;

        e.preventDefault();

        var $source = this.source.getElement();
        var el = $source.get();
        var start = el.selectionStart;

        $source.val($source.val().substring(0, start) + "    " + $source.val().substring(el.selectionEnd));
        el.selectionStart = el.selectionEnd = start + 4;
    },
    _onFocus: function()
    {
        this.app.broadcast('sourcefocus');
    },
    _disableButtons: function()
    {
        this.toolbar.disableButtons();
    },
    _enableButtons: function()
    {
        this.toolbar.enableButtons();
    },
    _setActiveSourceButton: function()
    {
        var $btn = this.toolbar.getButton('html');
        $btn.enable();
        $btn.setActive();
    },
    _setInactiveSourceButton: function()
    {
        var $btn = this.toolbar.getButton('html');
        $btn.setInactive();
    }
});
$R.add('module', 'observer', {
    init: function(app)
    {
        this.app = app;
        this.editor = app.editor;

        // local
        this.observerUnit = false;
    },
    // public
    start: function()
    {
        if (window.MutationObserver)
        {
            var $editor = this.editor.getElement();
            var el = $editor.get();
            this.observerUnit = this._build(el);
            this.observerUnit.observe(el, {
                 attributes: true,
                 subtree: true,
                 childList: true,
                 characterData: true,
                 characterDataOldValue: true
            });
        }
    },
    stop: function()
    {
        if (this.observerUnit) this.observerUnit.disconnect();
    },

    // private
    _build: function(el)
    {
        var self = this;
        return new MutationObserver(function(mutations)
        {
            self._observe(mutations[mutations.length-1], el);
        });
    },
    _observe: function(mutation, el)
    {
        if (this.app.isReadOnly() || (mutation.type === 'attributes' && mutation.target === el))
        {
            return;
        }

        this.app.broadcast('observe');
        this.app.broadcast('trytosync');
        this.app.broadcast('placeholder.toggle');
    }
});
$R.add('module', 'clicktoedit', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.source = app.source;
        this.editor = app.editor;
        this.container = app.container;
        this.selection = app.selection;
    },
    // messages
    onstartclicktoedit: function()
    {
        this.start();
    },
    onenablereadonly: function()
    {
        if (!this._isEnabled()) this.stop();
    },
    ondisablereadonly: function()
    {
        if (!this._isEnabled()) this.start();
    },
    onstop: function()
    {
        this.stop();
    },

    // public
    start: function()
    {
        this._build();
    },
    stop: function()
    {
        if (this.buttonSave) this.buttonSave.stop();
        if (this.buttonCancel) this.buttonCancel.stop();

        this._destroy();
        this.app.broadcast('disable');
    },
    enable: function()
    {
        this.app.broadcast('clickStart');

        var isEmpty = this.editor.isEmpty();
        if (!isEmpty) this.selection.saveMarkers();

        this._setFocus();
        this._destroy();
        this.app.broadcast('enable');
        this.buttonSave.enable();
        this.buttonCancel.enable();

        if (!isEmpty) this.selection.restoreMarkers();
        if (isEmpty) this.editor.focus();

        var $container = this.container.getElement();
        $container.addClass('redactor-clicktoedit-enabled');

        this.source.rebuildStartedContent();

        this.app.broadcast('startcode');
        this.app.broadcast('image.observe');
    },
    save: function(e)
    {
        if (e) e.preventDefault();

        var html = this.source.getCode();

        this.app.broadcast('disable');
        this.app.broadcast('clickSave', html);
        this.app.broadcast('clickStop');
        this.app.broadcast('toolbar.removeexternal');
        this._build();
    },
    cancel: function(e)
    {
        if (e) e.preventDefault();

        var html = this.saved;
        var $editor = this.editor.getElement();
        $editor.html(html);

        this.saved = '';

        this.app.broadcast('disable');
        this.app.broadcast('clickCancel', html);
        this.app.broadcast('clickStop');
        this.app.broadcast('toolbar.removeexternal');
        this._build();
    },

    // private
    _build: function()
    {
        // buttons
        this.buttonSave = $R.create('clicktoedit.button', 'save', this.app, this);
        this.buttonCancel = $R.create('clicktoedit.button', 'cancel', this.app, this);

        this.buttonSave.stop();
        this.buttonCancel.stop();

        var $editor = this.editor.getElement();
        var $container = this.container.getElement();

        $editor.on('click.redactor-click-to-edit mouseup.redactor-click-to-edit', this.enable.bind(this));
        $container.addClass('redactor-over');
        $container.removeClass('redactor-clicktoedit-enabled');
    },
    _isEnabled: function()
    {
        return this.container.getElement().hasClass('redactor-clicktoedit-enabled');
    },
    _destroy: function()
    {
        var $editor = this.editor.getElement();
        var $container = this.container.getElement();

        $editor.off('.redactor-click-to-edit');
        $container.removeClass('redactor-over redactor-clicktoedit-enabled');
    },
    _setFocus: function()
    {
        this.saved = this.source.getCode();

        this.buttonSave.start();
        this.buttonCancel.start();
    }
});
$R.add('class', 'clicktoedit.button', {
    init: function(type, app, context)
    {
        this.app = app;
        this.opts = app.opts;
        this.toolbar = app.toolbar;
        this.context = context;

        // local
        this.type = type;
        this.name = (type === 'save') ? 'clickToSave' : 'clickToCancel';
        this.objected = false;
        this.enabled = false;
        this.namespace = '.redactor-click-to-edit';

        // build
        this._build();
    },
    enable: function()
    {
        if (!this.objected) return;

        var data = this.opts[this.name];
        data.api = 'module.clicktoedit.' + this.type;

        this.toolbar.addButton(this.type, data);
        this.enabled = true;
    },
    start: function()
    {
        if (this.objected) return;

        this.$button.off(this.namespace);
        this.$button.show();
        this.$button.on('click' + this.namespace, this.context[this.type].bind(this.context));
    },
    stop: function()
    {
        if (this.objected || !this.enabled) return;

        this.$button.hide();
    },

    // private
    _build: function()
    {
        this.objected = (typeof this.opts[this.name] === 'object');

        if (!this.objected)
        {
            this.$button = $R.dom(this.opts[this.name]);
            this.enabled = true;
        }
    }
});
$R.add('module', 'statusbar', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.element = app.element;
        this.statusbar = app.statusbar;
        this.container = app.container;
    },
    // public
    start: function()
    {
        if (!this.element.isType('inline'))
        {
            var $statusbar = this.statusbar.getElement();
            var $container = this.container.getElement();

            $statusbar.addClass('redactor-statusbar');
            $container.append($statusbar);
        }
    }
});
$R.add('module', 'contextbar', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.uuid = app.uuid;
        this.$win = app.$win;
        this.$doc = app.$doc;
        this.$body = app.$body;
        this.editor = app.editor;
        this.toolbar = app.toolbar;
        this.detector = app.detector;

        // local
        this.$target = (this.toolbar.isTarget()) ? this.toolbar.getTargetElement() : this.$body;
    },
    // messages
    onenablereadonly: function()
    {
        this.stop();
    },
    ondisablereadonly: function()
    {
        this.start();
    },
    oncontextbar: {
        close: function()
        {
            this.close();
        }
    },

    // public
    start: function()
    {
        if (this.opts.toolbarContext)
        {
            var $editor = this.editor.getElement();

            this._build();
            $editor.on('click.redactor-context mouseup.redactor-context', this.open.bind(this));

            if (this.opts.scrollTarget)
            {
                $R.dom(this.opts.scrollTarget).on('scroll.redactor-context', this.close.bind(this));
            }
            else if (this.opts.maxHeight !== false)
            {
                $editor.on('scroll.redactor-context', this.close.bind(this));
            }
        }
    },
    stop: function()
    {
        var $editor = this.editor.getElement();
        $editor.off('.redactor-context');

        this.$doc.off('.redactor-context');
        this.$win.off('.redactor-context');

        if (this.$contextbar) this.$contextbar.remove();
        if (this.opts.scrollTarget)
        {
            $R.dom(this.opts.scrollTarget).off('.redactor-context');
        }
    },
    is: function()
    {
        return (this.$contextbar && this.$contextbar.hasClass('open'));
    },
    set: function(e, node, buttons, position)
    {
        this.$contextbar.html('');
        this.$el = $R.dom(node);

        // buttons
        for (var key in buttons)
        {
            var $btn = $R.create('contextbar.button', this.app, buttons[key]);
            if ($btn.html() !== '')
            {
                this.$contextbar.append($btn);
            }
        }

        // show
        var pos = this._buildPosition(e, this.$el, position);

        this.$contextbar.css(pos);
        this.$contextbar.show();
        this.$contextbar.addClass('open');
        this.$doc.on('click.redactor-context mouseup.redactor-context', this.close.bind(this));
        this.$win.on('resize.redactor-context', this.close.bind(this));
    },
    open: function(e)
    {
        setTimeout(function()
        {
            this.app.broadcast('contextbar', e, this);
        }.bind(this), 0);
    },
    close: function(e)
    {
        if (!this.$contextbar) return;
        if (e)
        {
            var $target = $R.dom(e.target);
            if (this.$el && $target.closest(this.$el).length !== 0)
            {
                return;
            }
        }

        this.$contextbar.hide();
        this.$contextbar.removeClass('open');
        this.$doc.off('.redactor.context');
    },

    // private
    _build: function()
    {
        this.$contextbar = $R.dom('<div>');
        this.$contextbar.attr('id', 'redactor-context-toolbar-' + this.uuid);
        this.$contextbar.attr('dir', this.opts.direction);
        this.$contextbar.addClass('redactor-context-toolbar');
        this.$contextbar.hide();

        this.$target.append(this.$contextbar);
    },
    _buildPosition: function(e, $el, position)
    {
        var top, left;
        var isTarget = this.toolbar.isTarget();
        var offset = (isTarget) ? $el.position() : $el.offset();

        var width = $el.width();
        var height = $el.height();

        var barWidth = this.$contextbar.width();
        var barHeight = this.$contextbar.height();
        var docScrollTop = (isTarget) ? (this.$target.scrollTop() + this.$doc.scrollTop()) : this.$doc.scrollTop();

        var targetOffset = this.$target.offset();
        var leftFix = (isTarget) ? targetOffset.left : 0;
        var topFix = (isTarget) ? targetOffset.top : 0;

        if (!position)
        {
            top = (e.clientY + docScrollTop - barHeight);
            left = (e.clientX - barWidth/2);
        }
        else if (position === 'top')
        {
            top = (offset.top - barHeight);
            left = (offset.left + width/2 - barWidth/2);
        }
        else if (position === 'bottom')
        {
            top = (offset.top + height);
            left = (offset.left + width/2 - barWidth/2);
        }

        if (left < 0) left = 0;

        return { top: (top - topFix) + 'px', left: (left - leftFix) + 'px' };
    }
});
$R.add('class', 'contextbar.button', {
    mixins: ['dom'],
    init: function(app, obj)
    {
        this.app = app;

        // local
        this.obj = obj;

        // init
        this._init();
    },
    // private
    _init: function()
    {
        this.parse('<a>');

        if (typeof this.obj.title !== 'string')
        {
            var url = this.obj.title.attr('href');
            this.attr('href', url);

            if (url.search(/^#/) === -1) {
                this.attr('target', '_blank');
            }

            this.html(this.obj.html || url);
        }
        else
        {
            this.attr('href', '#');

            this._buildTitle();
            this._buildMessage();
        }
    },
    _buildTitle: function()
    {
        this.html(this.obj.title);
    },
    _buildMessage: function()
    {
        if (typeof this.obj.message !== 'undefined' || typeof this.obj.api !== 'undefined')
        {
            this.on('click', this._toggle.bind(this));
        }
    },
    _toggle: function(e)
    {
        e.preventDefault();

        if (this.obj.message)
        {
            this.app.broadcast(this.obj.message, this.obj.args);
        }
        else if (this.obj.api)
        {
            this.app.api(this.obj.api, this.obj.args);
        }
    }
});
$R.add('module', 'toolbar', {
    init: function(app)
    {
        this.app = app;
        this.uuid = app.uuid;
        this.opts = app.opts;
        this.utils = app.utils;
        this.toolbar = app.toolbar;

        // local
        this.buttons = [];
        this.toolbarModule = false;
    },
    // messages
    onsource: {
        open: function()
        {
            if (!this.toolbar.isAir() && this.toolbar.isFixed())
            {
                this.toolbarModule.resetPosition();
            }
        },
        opened: function()
        {
            if (this.toolbar.isAir() && this.toolbarModule)
            {
                this.toolbarModule.createSourceHelper();
            }

            // hide tooltips
            setTimeout(function()
            {
                $R.dom('.re-button-tooltip-' + this.uuid).remove();
            }.bind(this), 100)

        },
        close: function()
        {
            if (this.toolbar.isAir() && this.toolbarModule)
            {
                this.toolbarModule.destroySourceHelper();
            }
        },
        closed: function()
        {
            if (this.toolbar.is() && this.opts.air)
            {
                this.toolbarModule.openSelected();
            }
        }
    },
    ontoolbar: {
        removeexternal: function() {
            if (!this.opts.air && this.opts.toolbarExternal && this.opts.clickToEdit) {
                $R.dom(this.opts.toolbarExternal).html('');
            }
        }
    },
    onobserve: function()
    {
        if (this.toolbar.is())
        {
            this.toolbar.observe();
        }
    },
    onfocus: function()
    {
        this._setExternalOnFocus();
    },
    onsourcefocus: function()
    {
        this._setExternalOnFocus();
    },
    onempty: function()
    {
        if (this.toolbar.isFixed())
        {
            this.toolbarModule.resetPosition();
        }
    },
    onenablereadonly: function()
    {
        if (this.toolbar.isAir())
        {
            this.toolbarModule.close();
        }
    },

    // public
    start: function()
    {
        if (this.toolbar.is())
        {
            this._buildButtons();
            this._initToolbar();
            this._initButtons();
        }
    },
    stop: function()
    {
        if (this.toolbarModule)
        {
            this.toolbarModule.stop();
        }

        // stop dropdowns
        $R.dom('.redactor-dropdown-' + this.uuid).remove();
    },

    // private
    _buildButtons: function()
    {
        this.buttons = this.opts.buttons.concat();

        this._buildImageButton();
        this._buildFileButton();
        this._buildSourceButton();
        this._buildAdditionalButtons();
        this._buildHiddenButtons();
    },
    _buildImageButton: function()
    {
        if (!this.opts.imageUpload && !this.opts.imageManagerJson) this.utils.removeFromArrayByValue(this.buttons, 'image');
    },
    _buildFileButton: function()
    {
        if (!this.opts.fileUpload) this.utils.removeFromArrayByValue(this.buttons, 'file');
    },
    _buildSourceButton: function()
    {
        if (!this.opts.source) this.utils.removeFromArrayByValue(this.buttons, 'html');
    },
    _buildAdditionalButtons: function()
    {
        // end
        if (this.opts.buttonsAdd.length !== 0)
        {
            this.opts.buttonsAdd = this._removeExistButtons(this.opts.buttonsAdd);
            this.buttons = this.buttons.concat(this.opts.buttonsAdd);
        }

        // beginning
        if (this.opts.buttonsAddFirst.length !== 0)
        {
            this.opts.buttonsAddFirst = this._removeExistButtons(this.opts.buttonsAddFirst);
            this.buttons.unshift(this.opts.buttonsAddFirst);
        }

        var index, btns;

        // after
        if (this.opts.buttonsAddAfter !== false)
        {
            index = this.buttons.indexOf(this.opts.buttonsAddAfter.after) + 1;
            btns = this.opts.buttonsAddAfter.buttons;
            for (var i = 0; i < btns.length; i++)
            {
                this.buttons.splice(index+i, 0, btns[i]);
            }
        }

        // before
        if (this.opts.buttonsAddBefore !== false)
        {
            index = this.buttons.indexOf(this.opts.buttonsAddBefore.before)+1;
            btns = this.opts.buttonsAddBefore.buttons;
            for (var i = 0; i < btns.length; i++)
            {
                this.buttons.splice(index-(1-i), 0, btns[i]);
            }
        }
    },
    _buildHiddenButtons: function()
    {
        if (this.opts.buttonsHide.length !== 0)
        {
            var buttons = this.opts.buttonsHide;
            for (var i = 0; i < buttons.length; i++)
            {
                this.utils.removeFromArrayByValue(this.buttons, buttons[i]);
            }
        }
    },
    _removeExistButtons: function(buttons)
    {
        for (var i = 0; i < buttons.length; i++)
        {
            if (this.opts.buttons.indexOf(buttons[i]) !== -1)
            {
                this.utils.removeFromArrayByValue(buttons, buttons[i]);
            }
        }

        return buttons;
    },
    _setExternalOnFocus: function()
    {
        if (!this.opts.air && this.opts.toolbarExternal)
        {
            this.toolbarModule.setExternal();
        }
    },
    _initToolbar: function()
    {
        this.toolbarModule = (this.opts.air) ? $R.create('toolbar.air', this.app) : $R.create('toolbar.standard', this.app);
    },
    _initButtons: function()
    {
        this.toolbar.setButtons(this.buttons);

        for (var i = 0; i < this.buttons.length; i++)
        {
            var name = this.buttons[i];
            if ($R.buttons[name])
            {
                this.toolbar.addButton(name, $R.buttons[name], false, false, true);
            }
        }
    }
});
$R.add('class', 'toolbar.air', {
    init: function(app)
    {
        this.app = app;
        this.uuid = app.uuid;
        this.$doc = app.$doc;
        this.$win = app.$win;
        this.utils = app.utils;
        this.editor = app.editor;
        this.animate = app.animate;
        this.toolbar = app.toolbar;
        this.container = app.container;
        this.inspector = app.inspector;
        this.selection = app.selection;

        // local
        this.clicks = 0;

        // init
        this._init();
    },
    // public
    stop: function()
    {
        var $wrapper = this.toolbar.getWrapper();
        $wrapper.remove();

        var $editor = this.editor.getElement();
        $editor.off('.redactor-air-trigger-' + this.uuid);

        this.$doc.off('.redactor-air-' + this.uuid);
        this.$doc.off('.redactor-air-trigger-' + this.uuid);

        this.toolbar.stopObservers();
    },
    createSourceHelper: function()
    {
        this.$airHelper = $R.dom('<span>');
        this.$airHelper.addClass('redactor-air-helper');
        this.$airHelper.html('<i class="re-icon-html"></i>');
        this.$airHelper.on('click', function(e)
        {
            e.preventDefault();
            this.app.api('module.source.hide');

        }.bind(this));

        var $container = this.container.getElement();
        $container.append(this.$airHelper);
    },
    destroySourceHelper: function()
    {
        if (this.$airHelper) this.$airHelper.remove();
    },
    openSelected: function()
    {
        setTimeout(function()
        {
            if (this._isSelection()) this._open(false);

        }.bind(this), 0);
    },
    close: function()
    {
        this.$doc.off('.redactor-air-' + this.uuid);

        var $toolbar = this.toolbar.getElement();
        $toolbar.removeClass('open');
        $toolbar.hide();
    },

    // private
    _init: function()
    {
        this.toolbar.create();

        var $wrapper = this.toolbar.getWrapper();
        var $toolbar = this.toolbar.getElement();
        var $editor = this.editor.getElement();
        var $container = this.container.getElement();

        $wrapper.addClass('redactor-toolbar-wrapper-air');
        $toolbar.addClass('redactor-air');
        //$toolbar.addClass('redactor-animate-hide');
        $toolbar.hide();

        $wrapper.append($toolbar);
        $container.prepend($wrapper);

        // open selected
        this.openSelected();

        // events
        this.$doc.on('mouseup.redactor-air-trigger-' + this.uuid, this._open.bind(this));
        $editor.on('keyup.redactor-air-trigger-' + this.uuid, this._openCmd.bind(this));
    },
    _isSelection: function()
    {
        return (this.selection.is() && !this.selection.isCollapsed());
    },
    _isOpened: function()
    {
        var $toolbar = this.toolbar.getElement();

        return $toolbar.hasClass('open');
    },
    _open: function(e)
    {
        var target = (e) ? e.target : false;
        var $el = (e) ? $R.dom(e.target) : false;
        var dataTarget = this.inspector.parse(target);
        var isComponent = (dataTarget.isComponent() && !dataTarget.isComponentType('table'));
        var isFigcaption = (dataTarget.isFigcaption());
        var isModalTarget = ($el && $el.closest('.redactor-modal').length !== 0);
        var isButtonCall = (e && $el.closest('.re-button').length !== 0);
        var isDropdownCall = (e && $el.closest('.redactor-dropdown').length !== 0);

        if (isDropdownCall || isButtonCall || isModalTarget || isFigcaption || isComponent || this.toolbar.isContextBar() || !this._isSelection())
        {
            return;
        }

        var pos = this.selection.getPosition();

        setTimeout(function()
        {
            if (this.app.isReadOnly()) return;
            if (this._isSelection()) this._doOpen(pos);

        }.bind(this), 1);

    },
    _openCmd: function()
    {
        if (this.selection.isAll())
        {
            var $toolbar = this.toolbar.getElement();
            var pos = this.selection.getPosition();

            pos.top = (pos.top < 20) ? 0 : pos.top - $toolbar.height();
            pos.height = 0;

            this._doOpen(pos);
        }
    },
    _doOpen: function(pos)
    {
        var $wrapper = this.toolbar.getWrapper();
        var $toolbar = this.toolbar.getElement();
        var $container = this.container.getElement();
        var containerOffset = $container.offset();
        var leftFix = 0;
        var winWidth = this.$win.width();
        var toolbarWidth = $toolbar.width();

        if (winWidth < (pos.left + toolbarWidth))
        {
            var selPos = this.selection.getPosition();
            leftFix = toolbarWidth - selPos.width;
        }

        $wrapper.css({
            left: (pos.left - containerOffset.left - leftFix) + 'px',
            top: (pos.top - containerOffset.top + pos.height + this.$doc.scrollTop()) + 'px'
        });

        this.app.broadcast('airOpen');
        $toolbar.addClass('open');
        $toolbar.show();

        this.$doc.on('click.redactor-air-' + this.uuid, this._close.bind(this));
        this.$doc.on('keydown.redactor-air-' + this.uuid, this._close.bind(this));
        this.app.broadcast('airOpened');
    },
    _close: function(e)
    {
        var $el = (e) ? $R.dom(e.target) : false;
        var isDropdownCall = (e && $el.closest('[data-dropdown], .redactor-dropdown-not-close').length !== 0);
        var isButtonCall = (!isDropdownCall && e && $el.closest('.re-button').length !== 0);

        if (!isButtonCall && (isDropdownCall || !this._isOpened()))
        {
            return;
        }

        // close
        this.app.broadcast('airClose');

        this.close();
        this.app.broadcast('airClosed');
    }
});
$R.add('class', 'toolbar.fixed', {
    init: function(app)
    {
        this.app = app;
        this.uuid = app.uuid;
        this.opts = app.opts;
        this.$doc = app.$doc;
        this.$win = app.$win;
        this.editor = app.editor;
        this.toolbar = app.toolbar;
        this.detector = app.detector;
        this.container = app.container;

        // init
        this._init();
    },
    // public
    stop: function()
    {
        this.$fixedTarget.off('.redactor-toolbar-' + this.uuid);
        this.$win.off('.redactor-toolbar-' + this.uuid);
    },
    reset: function()
    {
        var $toolbar = this.toolbar.getElement();
        var $wrapper = this.toolbar.getWrapper();

        $wrapper.css('height', '');
        $toolbar.removeClass('redactor-toolbar-fixed');
        $toolbar.css({ position: '', top: '', left: '', width: '' });

        var dropdown = this.toolbar.getDropdown();
        if (dropdown) dropdown.updatePosition();
    },

    // private
    _init: function()
    {
        this.$fixedTarget = (this.toolbar.isTarget()) ? this.toolbar.getTargetElement() : this.$win;
        this._doFixed();

        if (this.toolbar.isTarget())
        {
            this.$win.on('scroll.redactor-toolbar-' + this.uuid, this._doFixed.bind(this));
            this.$win.on('resize.redactor-toolbar-' + this.uuid, this._doFixed.bind(this));
        }

        this.$fixedTarget.on('scroll.redactor-toolbar-' + this.uuid, this._doFixed.bind(this));
        this.$fixedTarget.on('resize.redactor-toolbar-' + this.uuid, this._doFixed.bind(this));
    },
    _doFixed: function()
    {
        var $editor = this.editor.getElement();
        var $container = this.container.getElement();
        var $toolbar = this.toolbar.getElement();
        var $wrapper = this.toolbar.getWrapper();

        if (this.editor.isSourceMode())
        {
            return;
        }

        var $targets = $container.parents().filter(function(node)
        {
            return (getComputedStyle(node, null).display === 'none') ? node : false;
        });

        // has hidden parent
        if ($targets.length !== 0) return;

        var isHeight = ($editor.height() < 100);
        var isEmpty = this.editor.isEmpty();

        if (isHeight || isEmpty) {
            this.reset();
            return;
        }

        if (this.editor.isSourceMode()) {
            return;
        }

        var toolbarHeight = $toolbar.height();
        var toleranceEnd = 60;
        var containerOffset = (this.toolbar.isTarget()) ? $container.position() : $container.offset();
        var boxOffset = containerOffset.top;
        var boxEnd = boxOffset + $container.height() - toleranceEnd;
        var scrollOffset = this.$fixedTarget.scrollTop() + this.opts.toolbarFixedTopOffset;
        var top = (!this.toolbar.isTarget()) ? 0 : this.$fixedTarget.offset().top - this.$win.scrollTop();
        if (this.toolbar.isTarget() && this.$fixedTarget.css('position') === 'fixed') {
            var bs = (this.$fixedTarget.hasClass('modal') && this.$fixedTarget.hasClass('fade'));
            var bsFix = (bs) ? $container.closest('.modal-dialog').position().top : 0;
            top = this.$fixedTarget.scrollTop() - bsFix;
        }


        if (scrollOffset > boxOffset && scrollOffset < boxEnd)
        {
            var position = (this.detector.isDesktop()) ? 'fixed' : 'absolute';
            top = (this.detector.isDesktop()) ? top : (scrollOffset - boxOffset);

            if (this.detector.isMobile())
            {
                if (this.fixedScrollTimeout)
                {
                    clearTimeout(this.fixedScrollTimeout);
                }

                $toolbar.hide();
                this.fixedScrollTimeout = setTimeout(function()
                {
                    $toolbar.show();
                }, 250);
            }

            $wrapper.height(toolbarHeight);
            $toolbar.addClass('redactor-toolbar-fixed');

            if ($container.hasClass('redactor-box-fullscreen'))
            {
                $toolbar.css({
                    position: position,
                    top: '0px',
                    width: $container.width() + 'px'
                });
            }
            else
            {
                $toolbar.css({
                    position: position,
                    top: (top + this.opts.toolbarFixedTopOffset) + 'px',
                    width: $container.width() + 'px'
                });
            }

            var dropdown = this.toolbar.getDropdown();
            if (dropdown) dropdown.updatePosition();

            this.app.broadcast('toolbar.fixed');
        }
        else
        {
            this.reset();
            this.app.broadcast('toolbar.unfixed');
        }
    }
});
$R.add('class', 'toolbar.standard', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.uuid = app.uuid;
        this.$body = app.$body;
        this.toolbar = app.toolbar;
        this.container = app.container;

        // local
        this.isExternalMultiple = false;
        this.toolbarFixed = false;

        // init
        this._init();
    },
    // public
    stop: function()
    {
        var $wrapper = this.toolbar.getWrapper();
        $wrapper.remove();

        if (this.toolbarFixed) this.toolbarFixed.stop();
        if (this.opts.toolbarExternal) this._findToolbars();

        this.toolbar.stopObservers();
        this.$body.find('.re-button-tooltip-' + this.uuid).remove();
    },
    setExternal: function()
    {
        this._findToolbars();
        if (this.isExternalMultiple)
        {
            this.$toolbars.hide();
            var $current = this.$external.find('.redactor-toolbar-external-' + this.uuid);
            $current.show();
        }
    },
    resetPosition: function()
    {
        if (this.toolbarFixed) this.toolbarFixed.reset();
    },

    // private
    _init: function()
    {
        this._build();

        if (this.opts.toolbarExternal)
        {
            this._buildExternal();
        }
        else
        {
            this._buildFixed();

            var $toolbar = this.toolbar.getElement();
            $toolbar.show();
        }
    },
    _build: function()
    {
        this.toolbar.create();

        var $wrapper = this.toolbar.getWrapper();
        var $toolbar = this.toolbar.getElement();

        $wrapper.addClass('redactor-toolbar-wrapper');
        $toolbar.addClass('redactor-toolbar');
        $toolbar.hide();
        $wrapper.append($toolbar);

        if (!this.opts.toolbarExternal)
        {
            var $container = this.container.getElement();
            $container.prepend($wrapper);
        }
    },
    _buildExternal: function()
    {
        this._initExternal();
        this._findToolbars();

        if (this.isExternalMultiple)
        {
            this._hideToolbarsExceptFirst();
        }
        else
        {
            var $toolbar = this.toolbar.getElement();
            $toolbar.show();
        }
    },
    _buildFixed: function()
    {
        if (this.opts.toolbarFixed)
        {
            this.toolbarFixed = $R.create('toolbar.fixed', this.app);
        }
    },
    _initExternal: function()
    {
        var $toolbar = this.toolbar.getElement();
        var $wrapper = this.toolbar.getElement();

        $toolbar.addClass('redactor-toolbar-external redactor-toolbar-external-' + this.uuid);

        this.$external = $R.dom(this.opts.toolbarExternal);
        this.$external.append($wrapper);

    },
    _findToolbars: function()
    {
        this.$toolbars = this.$external.find('.redactor-toolbar-external');
        this.isExternalMultiple = (this.$toolbars.length > 1);
    },
    _hideToolbarsExceptFirst: function()
    {
        this.$toolbars.hide();
        var $first = this.$toolbars.first();
        $first.show();
    }
});
$R.add('module', 'line', {
    init: function(app)
    {
        this.app = app;
        this.lang = app.lang;
        this.component = app.component;
        this.inspector = app.inspector;
        this.insertion = app.insertion;
    },
    // messages
    oncontextbar: function(e, contextbar)
    {
        var data = this.inspector.parse(e.target);
        if (data.isComponentType('line'))
        {
            var node = data.getComponent();
            var buttons = {
                "remove": {
                    title: this.lang.get('delete'),
                    api: 'module.line.remove',
                    args: node
                }
            };

            contextbar.set(e, node, buttons, 'bottom');
        }

    },

    // public
    insert: function()
    {
        var line = this.component.create('line');
        this.insertion.insertRaw(line);
    },
    remove: function(node)
    {
        this.component.remove(node);
    }
});
$R.add('class', 'line.component', {
    mixins: ['dom', 'component'],
    init: function(app, el)
    {
        this.app = app;

        // init
        return (el && el.cmnt !== undefined) ? el : this._init(el);
    },
    // private
    _init: function(el)
    {
        var wrapper, element;
        if (typeof el !== 'undefined')
        {
            var $node = $R.dom(el);
            var node = $node.get();

            if (node.tagName === 'HR') element = node;
            else if (node.tagName === 'FIGURE')
            {
                wrapper = node;
                element = $node.find('hr').get();
            }
        }

        this._buildWrapper(wrapper);
        this._buildElement(element);
        this._initWrapper();
    },
    _buildElement: function(node)
    {
        if (node)
        {
            this.$element = $R.dom(node);
        }
        else
        {
            this.$element = $R.dom('<hr>');
            this.append(this.$element);
        }
    },
    _buildWrapper: function(node)
    {
        node = node || '<figure>';

        this.parse(node);
    },
    _initWrapper: function()
    {
        this.addClass('redactor-component');
        this.attr({
            'data-redactor-type': 'line',
            'tabindex': '-1',
            'contenteditable': false
        });
    }
});
$R.add('module', 'link', {
    modals: {
        'link':
            '<form action=""> \
                <div class="form-item"> \
                    <label for="modal-link-url">URL <span class="req">*</span></label> \
                    <input type="text" id="modal-link-url" name="url"> \
                </div> \
                <div class="form-item"> \
                    <label for="modal-link-text">## text ##</label> \
                    <input type="text" id="modal-link-text" name="text"> \
                </div> \
                <div class="form-item form-item-title"> \
                    <label for="modal-link-title">## title ##</label> \
                    <input type="text" id="modal-link-title" name="title"> \
                </div> \
                <div class="form-item form-item-target"> \
                    <label class="checkbox"> \
                        <input type="checkbox" name="target"> ## link-in-new-tab ## \
                    </label> \
                </div> \
            </form>'
    },
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.lang = app.lang;
        this.caret = app.caret;
        this.utils = app.utils;
        this.inline = app.inline;
        this.editor = app.editor;
        this.inspector = app.inspector;
        this.insertion = app.insertion;
        this.selection = app.selection;

        // local
        this.isCurrentLink = false;
        this.currentText = false;
    },
    // messages
    onmodal: {
        link: {
            open: function($modal, $form)
            {
                this._setFormData($form, $modal);
            },
            opened: function($modal, $form)
            {
                this._setFormFocus($form);
            },
            update: function($modal, $form)
            {
                var data = $form.getData();
                if (this._validateData($form, data))
                {
                    this._update(data);
                }
            },
            insert: function($modal, $form)
            {
                var data = $form.getData();
                if (this._validateData($form, data))
                {
                    this._insert(data);
                }
            },
            unlink: function()
            {
                this._unlink();
            }
        }
    },
    onbutton: {
        link: {
            observe: function(button)
            {
                this._observeButton(button);
            }
        }
    },
    ondropdown: {
        link: {
            observe: function(dropdown)
            {
                this._observeUnlink(dropdown);
                this._observeEdit(dropdown);
            }
        }
    },
    oncontextbar: function(e, contextbar)
    {
        var current = this._getCurrent();
        var data = this.inspector.parse(current);
        if (data.isLink() || data.isFile())
        {
            var node = (data.isFile()) ? data.getFile() : data.getLink();
            var $el = $R.dom(node);

            var $point = $R.dom('<a>');
            var url = $el.attr('href');

            $point.text(this._truncateText(url));
            $point.attr('href', url);
            $point.attr('target', '_blank');

            var buttons = {
                "link": {
                    title: $point,
                    html: this._truncateText(url)
                },
                "edit": {
                    title: this.lang.get('edit'),
                    api: 'module.link.open'
                },
                "unlink": {
                    title: this.lang.get('unlink'),
                    api: 'module.link.unlink'
                }
            };

            contextbar.set(e, node, buttons, 'bottom');
        }
    },

    // public
    open: function()
    {
        this.$link = this._buildCurrent();
        this.app.api('module.modal.build', this._getModalData());
    },
    insert: function(data)
    {
        this._insert(data);
    },
    update: function(data)
    {
        this._update(data);
    },
    unlink: function()
    {
        this._unlink();
    },

    // private
    _observeButton: function(button)
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);

        if (data.isPre() || data.isCode())
        {
            button.disable();
        }
        else
        {
            button.enable();
        }
    },
    _observeUnlink: function(dropdown)
    {
        var $item = dropdown.getItem('unlink');
        var links = this._getLinks();

        if (links.length === 0) $item.disable();
        else                    $item.enable();
    },
    _observeEdit: function(dropdown)
    {
        var current = this._getCurrent();
        var $item = dropdown.getItem('link');

        var data = this.inspector.parse(current);
        var title = (data.isLink() || data.isFile()) ? this.lang.get('link-edit') : this.lang.get('link-insert');

        $item.setTitle(title);
    },
    _unlink: function()
    {
        this.app.api('module.modal.close');

        var elms = [];
        var nodes = this._getLinks();

        this.selection.save();
        for (var i = 0; i < nodes.length; i++)
        {
            var $link = $R.create('link.component', this.app, nodes[i]);
            elms.push(this.selection.getElement(nodes[i]));

            $link.unwrap();

            // callback
            this.app.broadcast('link.deleted', $link);
        }
        this.selection.restore();

        // normalize
        for (var i = 0; i < elms.length; i++)
        {
            var el = (elms[i]) ? elms[i] : this.editor.getElement();
            this.utils.normalizeTextNodes(el);
        }

        this._resetCurrent();
    },
    _update: function(data)
    {
        this.app.api('module.modal.close');

        var nodes = this._getLinks();
        this._setLinkData(nodes, data, 'updated');
        this._resetCurrent();

        // callback
        this.app.broadcast('link.changed', nodes);
    },
    _insert: function(data)
    {
        this.app.api('module.modal.close');

        var links = this._getLinks();

        if (!this._insertSingle(links, data))
        {
            this._removeInSelection(links);
            this._insertMultiple(data);
        }

        this._resetCurrent();
    },
    _removeInSelection: function(links)
    {
        this.selection.save();
        for (var i = 0; i < links.length; i++)
        {
            var $link = $R.create('link.component', this.app, links[i]);
            var $clonedLink = $link.clone();
            $link.unwrap();

            // callback
            this.app.broadcast('link.deleted', $clonedLink);
        }
        this.selection.restore();
    },
    _insertMultiple: function(data)
    {
        var range = this.selection.getRange();
        if (range && this._isCurrentTextChanged(data))
        {
            this._deleteContents(range);
        }

        var nodes = this.inline.format({ tag: 'a' });

        this._setLinkData(nodes, data, 'inserted');
    },
    _insertSingle: function(links, data)
    {
        var inline = this.selection.getInline();
        if (links.length === 1 && (links[0].textContext === this.selection.getText()) || (inline && inline.tagName === 'A'))
        {
            var $link = $R.create('link.component', this.app, links[0]);

            $link.setData(data);
            this.caret.setAfter($link);

            // callback
            this.app.broadcast('link.inserted', $link);

            return true;
        }

        return false;
    },
    _setLinkData: function(nodes, data, type)
    {
        data.text = (data.text.trim() === '') ? this._truncateText(data.url) : data.text;

        var isTextChanged = (!this.currentText || this.currentText !== data.text);

        this.selection.save();
        for (var i = 0; i < nodes.length; i++)
        {
            var $link = $R.create('link.component', this.app, nodes[i]);
            var linkData = {};

            if (data.text && isTextChanged) linkData.text = data.text;
            if (data.url) linkData.url = data.url;
            if (data.title !== undefined) linkData.title = data.title;
            if (data.target !== undefined) linkData.target = data.target;

            $link.setData(linkData);

            // callback
            this.app.broadcast('link.' + type, $link);
        }

        setTimeout(this.selection.restore.bind(this.selection), 0);
    },
    _deleteContents: function(range)
    {
        var html = this.selection.getHtml();
        var parsed = this.utils.parseHtml(html);
        var first = parsed.nodes[0];

        if (first && first.nodeType !== 3)
        {
            var tag = first.tagName.toLowerCase();
            var container = document.createElement(tag);

            this.insertion.insertNode(container, 'start');
        }
        else
        {
            range.deleteContents();
        }
    },
    _getModalData: function()
    {
        var commands;
        if (this._isLink())
        {
           commands = {
                update: { title: this.lang.get('save') },
                unlink: { title: this.lang.get('unlink'), type: 'danger' },
                cancel: { title: this.lang.get('cancel') }
            };
        }
        else
        {
            commands = {
                insert: { title: this.lang.get('insert') },
                cancel: { title: this.lang.get('cancel') }
            };
        }

        var modalData = {
            name: 'link',
            title: (this._isLink()) ? this.lang.get('link-edit') : this.lang.get('link-insert'),
            handle: (this._isLink()) ? 'update' : 'insert',
            commands: commands
        };


        return modalData;
    },
    _isLink: function()
    {
        return this.currentLink;
    },
    _isCurrentTextChanged: function(data)
    {
        return (this.currentText && this.currentText !== data.text);
    },
    _buildCurrent: function()
    {
        var current = this._getCurrent();
        var data = this.inspector.parse(current);
        var $link;

        if (data.isLink() || data.isFile())
        {
            this.currentLink = true;

            $link = (data.isFile()) ? data.getFile() : data.getLink();
            $link = $R.create('link.component', this.app, $link);
        }
        else
        {
            this.currentLink = false;

            $link = $R.create('link.component', this.app);
            var linkData = {
                text: this.selection.getText()
            };

            $link.setData(linkData);
        }

        return $link;
    },
    _getCurrent: function()
    {
        return this.selection.getInlinesAllSelected({ tags: ['a'] })[0];
    },
    _getLinks: function()
    {
        var links = this.selection.getInlines({ all: true, tags: ['a'] });
        var arr = [];
        for (var i = 0; i < links.length; i++)
        {
            var data = this.inspector.parse(links[i]);
            if (data.isLink() || data.isFile())
            {
                arr.push(links[i]);
            }
        }

        return arr;
    },
    _resetCurrent: function()
    {
        this.isCurrentLink = false;
        this.currentText = false;
    },
    _truncateText: function(url)
    {
        return (url && url.length > this.opts.linkSize) ? url.substring(0, this.opts.linkSize) + '...' : url;
    },
    _validateData: function($form, data)
    {
        return (data.url.trim() === '') ? $form.setError('url') : true;
    },
    _setFormFocus: function($form)
    {
        $form.getField('url').focus();
    },
    _setFormData: function($form, $modal)
    {
        var linkData = this.$link.getData();
        var data = {
            url: linkData.url,
            text: linkData.text,
            title: linkData.title,
            target: (this.opts.linkTarget || linkData.target)
        };

        if (!this.opts.linkNewTab) $modal.find('.form-item-target').hide();
        if (!this.opts.linkTitle) $modal.find('.form-item-title').hide();

        $form.setData(data);
        this.currentText = $form.getField('text').val();
    }
});
$R.add('class', 'link.component', {
    mixins: ['dom', 'component'],
    init: function(app, el)
    {
        this.app = app;
        this.opts = app.opts;

        // local
        this.reUrl = /^(?:(?:(?:https?|ftp):)?\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

        // init
        return (el && el.cmnt !== undefined) ? el :  this._init(el);
    },

    // public
    setData: function(data)
    {
        for (var name in data)
        {
            this._set(name, data[name]);
        }
    },
    getData: function()
    {
        var names = ['url', 'text', 'target', 'title'];
        var data = {};

        for (var i = 0; i < names.length; i++)
        {
            data[names[i]] = this._get(names[i]);
        }

        return data;
    },

    // private
    _init: function(el)
    {
        var $el = $R.dom(el);
        if (el === undefined)
        {
            this.parse('<a>');
        }
        else
        {
            this.parse($el);
        }
    },
    _set: function(name, value)
    {
        this['_set_' + name](value);
    },
    _get: function(name)
    {
        return this['_get_' + name]();
    },
    _get_target: function()
    {
        return (this.attr('target')) ? this.attr('target') : false;
    },
    _get_url: function()
    {
        return this.attr('href');
    },
    _get_title: function()
    {
        return this.attr('title');
    },
    _get_text: function()
    {
        return this._getContext().text();
    },
    _getContext: function()
    {
        return this._findDeepestChild(this).element;
    },
    _set_target: function(target)
    {
        if (target === false) this.removeAttr('target');
        else if (target)
        {
            this.attr('target', (target === true) ? '_blank' : target);
        }
    },
    _set_text: function(text)
    {
        this._getContext().html(text);
    },
    _set_title: function(title)
    {
        if (!title || title === '') this.removeAttr('title');
        else this.attr('title', title);
    },
    _set_url: function(url)
    {
        if (this.opts.linkValidation)
        {
            url = this._cleanUrl(url);

            if (this._isMailto(url))
            {
                url = 'mailto:' + url.replace('mailto:', '');
            }
            else if (this._isUrl(url) && url.search(/^(ftp|https?)/i) === -1)
            {
                url = 'http://' + url.replace(/(ftp|https?):\/\//i, '');
            }
        }

        this.attr('href', url);
    },
    _isMailto: function(url)
    {
        return (url.search('@') !== -1 && /(ftp|https?):\/\//i.test(url) === false);
    },
    _isUrl: function(url)
    {
        return this.reUrl.test(url);
    },
    _cleanUrl: function(url)
    {
        return url.trim().replace(/[^\W\w\D\d+&\'@#/%?=~_|!:,.;\(\)]/gi, '');
    },
    _findDeepestChild: function(parent)
    {
        var result = {depth: 0, element: parent };

        parent.children().each(function(node)
        {
            var child = $R.dom(node);

            if (node.outerHTML !== parent.html())
            {
                return;
            }
            else
            {
                var childResult = this._findDeepestChild(child);
                if (childResult.depth + 1 > result.depth)
                {
                    result = {
                        depth: 1 + childResult.depth,
                        element: childResult.element
                    };
                }
            }
        }.bind(this));

        return result;
    }
});
$R.add('module', 'modal', {
    init: function(app)
    {
        this.app = app;
        this.lang = app.lang;
        this.$doc = app.$doc;
        this.$win = app.$win;
        this.$body = app.$body;
        this.utils = app.utils;
        this.editor = app.editor;
        this.animate = app.animate;
        this.detector = app.detector;
        this.selection = app.selection;

        // local
        this.$box = false;
        this.$modal = false;
        this.selectionMarkers = false;

        // defaults
        this.defaults = {
            name: false,
            url: false,
            title: false,
            width: '600px',
            height: false,
            handle: false,
            commands: false
        };
    },
    // public
    build: function(data)
    {
        this._open(data);
    },
    close: function()
    {
        this._close();
    },
    stop: function()
    {
        if (this.$box)
        {
            this.$box.remove();
            this.$box = false;
            this.$modal = false;

            this.$doc.off('.redactor.modal');
            this.$win.off('.redactor.modal');
        }

        if (this.$overlay)
        {
            this.$overlay.remove();
        }
    },
    resize: function()
    {
        this.$modal.setWidth(this.p.width);
        this.$modal.updatePosition();
    },

    // private
    _isOpened: function()
    {
        return (this.$modal && this.$modal.hasClass('open'));
    },
    _open: function(data)
    {
        this._buildDefaults(data);

        if (this.p.url) this._openUrl();
        else this._openTemplate();
    },
    _openUrl: function()
    {
        $R.ajax.post({
            url: this.p.url,
            success: this._doOpen.bind(this)
        });
    },
    _openTemplate: function()
    {
        if (typeof $R.modals[this.p.name] !== 'undefined')
        {
            var template = this.lang.parse($R.modals[this.p.name]);
            this._doOpen(template);
        }
    },
    _doOpen: function(template)
    {
        this.stop();

        if (this.selection.isCollapsed())
        {
            this.selection.save();
            this.selectionMarkers = false;
        }
        else
        {
            this.selection.saveMarkers();
            this.selectionMarkers = true;
        }

        if (!this.detector.isDesktop())
        {
            document.activeElement.blur();
        }

        this._createModal(template);

        this._buildModalBox();
        this._buildOverlay();
        this._buildModal();
        this._buildModalForm();
        this._buildModalCommands();

        this._broadcast('open');

        this.$modal.updatePosition();
        this._buildModalTabs();

        this.animate.start(this.$box, 'fadeIn', this._opened.bind(this));
        this.animate.start(this.$overlay, 'fadeIn');

    },
    _opened: function()
    {
        this.$modal.addClass('open');
        this.$box.on('mousedown.redactor.modal', this._close.bind(this));
        this.$doc.on('keyup.redactor.modal', this._handleEscape.bind(this));
        this.$win.on('resize.redactor.modal', this.resize.bind(this));
        this.$modal.getBody().find('input[type=text],input[type=url],input[type=email]').on('keydown.redactor.modal', this._handleEnter.bind(this));

        // fix bootstrap modal focus
        if (window.jQuery) jQuery(document).off('focusin.modal');

        this._broadcast('opened');
    },
    _close: function(e)
    {
        if (!this.$box || !this._isOpened()) return;

        if (e)
        {
            if (!this._needToClose(e.target))
            {
                return;
            }

            e.stopPropagation();
            e.preventDefault();
        }

        if (this.selectionMarkers) this.selection.restoreMarkers();
        else this.selection.restore();

        this.selectionMarkers = false;

        this._broadcast('close');

        this.animate.start(this.$box, 'fadeOut', this._closed.bind(this));
        this.animate.start(this.$overlay, 'fadeOut');
    },
    _closed: function()
    {
        this.$modal.removeClass('open');
        this.$box.off('.redactor.modal');
        this.$doc.off('.redactor.modal');
        this.$win.off('.redactor.modal');

        this._broadcast('closed');
    },
    _createModal: function(template)
    {
        this.$modal = $R.create('modal.element', this.app, template);
    },
    _broadcast: function(message)
    {
        this.app.broadcast('modal.' + message, this.$modal, this.$modalForm);
        this.app.broadcast('modal.' + this.p.name + '.' + message, this.$modal, this.$modalForm);
    },
    _buildDefaults: function(data)
    {
         this.p = $R.extend({}, this.defaults, data);
    },
    _buildModalBox: function()
    {
        this.$box = $R.dom('<div>');
        this.$box.attr('id', 'redactor-modal');
        this.$box.addClass('redactor-animate-hide');
        this.$box.html('');
        this.$body.append(this.$box);
    },
    _buildOverlay: function()
    {
        this.$overlay = $R.dom('#redactor-overlay');
        if (this.$overlay.length === 0)
        {
            this.$overlay = $R.dom('<div>');
            this.$overlay.attr('id', 'redactor-overlay');
            this.$overlay.addClass('redactor-animate-hide');
            this.$body.prepend(this.$overlay);
        }
    },
    _buildModal: function()
    {
        this.$box.append(this.$modal);

        this.$modal.setTitle(this.p.title);
        this.$modal.setHeight(this.p.height);
        this.$modal.setWidth(this.p.width);
    },
    _buildModalCommands: function()
    {
        if (this.p.commands)
        {
            var commands = this.p.commands;
            var $footer = this.$modal.getFooter();
            for (var key in commands)
            {
                var $btn = $R.dom('<button>');

                $btn.html(commands[key].title);
                $btn.attr('data-command', key);

                // cancel
                if (key === 'cancel')
                {
                    $btn.attr('data-action', 'close');
                    $btn.addClass('redactor-button-unstyled');
                }

                // danger
                if (typeof commands[key].type !== 'undefined' && commands[key].type === 'danger')
                {
                    $btn.addClass('redactor-button-danger');
                }

                $btn.on('click', this._handleCommand.bind(this));

                $footer.append($btn);
            }
        }
    },
    _buildModalTabs: function()
    {
        var $body = this.$modal.getBody();
        var $tabs = $body.find('.redactor-modal-tab');
        var $box = $body.find('.redactor-modal-tabs');


        if ($tabs.length > 1)
        {
            $box = ($box.length === 0) ? $R.dom('<div>') : $box.html('');
            $box.addClass('redactor-modal-tabs');

            $tabs.each(function(node, i)
            {
                var $node = $R.dom(node);
                var $item = $R.dom('<a>');
                $item.attr('href', '#');
                $item.attr('rel', i);
                $item.text($node.attr('data-title'));
                $item.on('click', this._showTab.bind(this));

                if (i === 0)
                {
                    $item.addClass('active');
                }

                $box.append($item);

            }.bind(this));

            $body.prepend($box);
        }

        if ($tabs.length === 1) {
            $tabs.show();
        }
    },
    _buildModalForm: function()
    {
        this.$modalForm = $R.create('modal.form', this.app, this.$modal.getForm());
    },
    _showTab: function(e)
    {
        e.preventDefault();

        var $el = $R.dom(e.target);
        var index = $el.attr('rel');
        var $body = this.$modal.getBody();
        var $tabs = $body.find('.redactor-modal-tab');

        $tabs.hide();
        $tabs.eq(index).show();

        $body.find('.redactor-modal-tabs a').removeClass('active');
        $el.addClass('active');

    },
    _needToClose: function(el)
    {
        var $target = $R.dom(el);
        if ($target.attr('data-action') === 'close' || this.$modal.isCloseNode(el) || $target.closest('.redactor-modal').length === 0)
        {
            return true;
        }

        return false;
    },
    _handleCommand: function(e)
    {
        var $btn = $R.dom(e.target).closest('button');
        var command = $btn.attr('data-command');

        if (command !== 'cancel') e.preventDefault();

        this._broadcast(command);
    },
    _handleEnter: function(e)
    {
        if (e.which === 13)
        {
            if (this.p.handle)
            {
                e.preventDefault();
                this._broadcast(this.p.handle);
            }
        }
    },
    _handleEscape: function(e)
    {
        if (e.which === 27) this._close();
    }
});
$R.add('class', 'modal.element', {
    mixins: ['dom'],
    init: function(app, template)
    {
        this.app = app;
        this.opts = app.opts;
        this.$win = app.$win;

        // init
        this._init(template);
    },

    // get
    getForm: function()
    {
        return this.find('form');
    },
    getHeader: function()
    {
        return this.$modalHeader;
    },
    getBody: function()
    {
        return this.$modalBody;
    },
    getFooter: function()
    {
        return this.$modalFooter;
    },

    // set
    setTitle: function(title)
    {
        if (title) this.$modalHeader.html(title);
    },
    setWidth: function(width)
    {
        width = (parseInt(width) >= this.$win.width()) ? '96%' : width;

        this.css('max-width', width);
    },
    setHeight: function(height)
    {
        if (height !== false) this.$modalBody.css('height', height);
    },

    // update
    updatePosition: function()
    {
        var width = this.width();
        this.css({ 'left': '50%', 'margin-left': '-' + (width/2) + 'px' });

        var windowHeight = this.$win.height();
        var height = this.height();
        var marginTop = (windowHeight/2 - height/2);

        if (height < windowHeight && marginTop !== 0)
        {
            this.css('margin-top', marginTop + 'px');
        }
    },

    // is
    isCloseNode: function(el)
    {
        return (el === this.$modalClose.get());
    },

    // private
    _init: function(template)
    {
        this._build();
        this._buildClose();
        this._buildHeader();
        this._buildBody();
        this._buildFooter();
        this._buildTemplate(template);
    },
    _build: function()
    {
        this.parse('<div>');
        this.addClass('redactor-modal');
        this.attr('dir', this.opts.direction);
    },
    _buildClose: function()
    {
        this.$modalClose = $R.dom('<span>');
        this.$modalClose.addClass('redactor-close');

        this.append(this.$modalClose);
    },
    _buildHeader: function()
    {
        this.$modalHeader = $R.dom('<div>');
        this.$modalHeader.addClass('redactor-modal-header');

        this.append(this.$modalHeader);
    },
    _buildBody: function()
    {
        this.$modalBody = $R.dom('<div>');
        this.$modalBody.addClass('redactor-modal-body');

        this.append(this.$modalBody);
    },
    _buildFooter: function()
    {
        this.$modalFooter = $R.dom('<div>');
        this.$modalFooter.addClass('redactor-modal-footer');

        this.append(this.$modalFooter);
    },
    _buildTemplate: function(template)
    {
        this.$modalBody.html(template);
    }
});
$R.add('class', 'modal.form', {
    mixins: ['dom'],
    init: function(app, element)
    {
        this.app = app;

        // build
        this.build(element);
    },

    // public
    build: function(element)
    {
        this.parse(element);
    },
    getData: function()
    {
        var data = {};
        this.find('[name]').each(function(node)
        {
            var $node = $R.dom(node);
            data[$node.attr('name')] = $node.val();
        });

        return data;
    },
    setData: function(data)
    {
        this.find('[name]').each(function(node)
        {
            var $node = $R.dom(node);
            var name = $node.attr('name');
            if (data.hasOwnProperty(name))
            {
                if (node.type && node.type === 'checkbox') node.checked = data[name];
                else $node.val(data[name]);
            }
        });
    },
    getField: function(name)
    {
        return this.find('[name=' + name + ']');
    },
    setError: function(name)
    {
        var $el = this.getField(name);

        $el.addClass('error');
        $el.one(this._getFieldEventName($el.get()), this._clearError);

        return false;
    },

    // private
    _clearError: function()
    {
        return $R.dom(this).removeClass('error');
    },
    _getFieldEventName: function(el)
    {
        return (el.tagName === 'SELECT' || el.type === 'checkbox' || el.type === 'radio') ? 'change' : 'keyup';
    }
});
$R.add('module', 'block', {
    init: function(app)
    {
        this.app = app;
        this.block = app.block;
    },
    // public
    format: function(args)
    {
        var nodes = this.block.format(args);

        // callback
        this.app.broadcast('format', 'block', nodes);
    },
    clearformat: function()
    {
        this.block.clearFormat();
    },
    clearstyle: function()
    {
        this.block.clearStyle();
    },
    clearclass: function()
    {
        this.block.clearClass();
    },
    clearattr: function()
    {
        this.block.clearAttr();
    },
    add: function(args, tags)
    {
        this.block.add(args, tags);
    },
    toggle: function(args, tags)
    {
        this.block.toggle(args, tags);
    },
    set: function(args, tags)
    {
        this.block.set(args, tags);
    },
    remove: function(args, tags)
    {
        this.block.remove(args, tags);
    }
});
$R.add('module', 'inline', {
    init: function(app)
    {
        this.app = app;
        this.inline = app.inline;
    },
    format: function(args)
    {
        var nodes = this.inline.format(args);

        // callback
        this.app.broadcast('format', 'inline', nodes);
    },
    clearformat: function()
    {
        this.inline.clearFormat();
    },
    clearstyle: function()
    {
        this.inline.clearStyle();
    },
    clearclass: function()
    {
        this.inline.clearClass();
    },
    clearattr: function()
    {
        this.inline.clearAttr();
    },
    add: function(args, tags)
    {
        this.inline.add(args, tags);
    },
    toggle: function(args, tags)
    {
        this.inline.toggle(args, tags);
    },
    set: function(args, tags)
    {
        this.inline.set(args, tags);
    },
    remove: function(args, tags)
    {
        this.inline.remove(args, tags);
    }
});
$R.add('module', 'autosave', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.utils = app.utils;
        this.source = app.source;
    },
    // messages
    onsynced: function()
    {
        if (this.opts.autosave)
        {
            this._send();
        }
    },

    // private
    _send: function()
    {
        var name = (this.opts.autosaveName) ? this.opts.autosaveName : this.source.getName();

        var data = {};
        data[name] = this.source.getCode();
        data = this.utils.extendData(data, this.opts.autosaveData);

        $R.ajax.post({
            url: this.opts.autosave,
            data: data,
            success: function(response)
            {
                this._complete(response, name, data);
            }.bind(this)
        });
    },
    _complete: function(response, name, data)
    {
        var callback = (response && response.error) ? 'autosaveError' : 'autosave';
        this.app.broadcast(callback, name, data, response);
    }
});
$R.add('module', 'input', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.utils = app.utils;
        this.editor = app.editor;
        this.keycodes = app.keycodes;
        this.element = app.element;
        this.selection = app.selection;
        this.insertion = app.insertion;
        this.inspector = app.inspector;
        this.autoparser = app.autoparser;

        // local
        this.lastShiftKey = false;
    },
    // messages
    onpaste: function(e, dataTransfer)
    {
        if (!this.opts.input) return;

        return $R.create('input.paste', this.app, e, dataTransfer);
    },
    onkeydown: function(e)
    {
        if (!this.opts.input) return;

        // key
        var key = e.which;

        // shortcuts
        var shortcut = $R.create('input.shortcut', this.app, e);
        if (shortcut.is()) return;

        // select all
        if ((e.ctrlKey || e.metaKey) && !e.altKey && key === 65)
        {
            e.preventDefault();
            return this._selectAll();
        }

        // set empty if all selected
        var keys = [this.keycodes.ENTER, this.keycodes.SPACE, this.keycodes.BACKSPACE, this.keycodes.DELETE];
        var arrowKeys = [this.keycodes.UP, this.keycodes.DOWN, this.keycodes.LEFT, this.keycodes.RIGHT];
        var isKeys = (keys.indexOf(key) !== -1);
        var isArrowKeys = (arrowKeys.indexOf(key) !== -1);
        var isXKey = ((e.ctrlKey || e.metaKey) && key === 88); // x
        var isAlphaKeys = ((!e.ctrlKey && !e.metaKey) && ((key >= 48 && key <= 57) || (key >= 65 && key <= 90)));

        if (this.selection.isAll() && isArrowKeys && (isXKey || (!e.ctrlKey && !e.metaKey && !e.altKey && !e.shiftKey)))
        {
            if (isXKey)
            {
                this.editor.disableNonEditables();
                this.app.broadcast('empty');
                return;
            }

            if (this._isArrowKey(key)) return true;
            if (isKeys) e.preventDefault();

            if (this.element.isType('inline'))
            {
                var $editor = this.editor.getElement();
                $editor.html('');

                this.editor.startFocus();
            }
            else
            {
                this.insertion.set(this.opts.emptyHtml);
            }

            if (isKeys) return;
            else this.app.broadcast('empty');
        }

        // autoparse
        if (this.opts.autoparse)
        {
            this.autoparser.format(e, key);
        }

        // a-z, 0-9 - non editable
        if (isAlphaKeys)
        {
            // has non-editable
            if (this.selection.hasNonEditable())
            {
                e.preventDefault();
                return;
            }
        }

        // enter, shift/ctrl + enter
        if (key === this.keycodes.ENTER)
        {
            return $R.create('input.enter', this.app, e, key);
        }
        // cmd + [
        else if (e.metaKey && key === 219)
        {
            e.preventDefault();
            this.app.api('module.list.outdent');
            return;
        }
        // tab or cmd + ]
        else if (key === this.keycodes.TAB || e.metaKey && key === 221)
        {
            return $R.create('input.tab', this.app, e, key);
        }
        // space
        else if (key === this.keycodes.SPACE)
        {
            return $R.create('input.space', this.app, e, key, this.lastShiftKey);
        }
        // backspace or delete
        else if (this._isDeleteKey(key))
        {
            return $R.create('input.delete', this.app, e, key);
        }
        else if (this._isArrowKey(key))
        {
            return $R.create('input.arrow', this.app, e, key);
        }
    },
    onkeyup: function(e)
    {
        if (!this.opts.input) return;

        // key
        var key = e.which;

        // shift key
        this.lastShiftKey = e.shiftKey;

        // hide context toolbar
        this.app.broadcast('contextbar.close');

        // shortcode
        var shortcode = $R.create('input.shortcode', this.app, e, key);
        if (shortcode.is()) return;

        // is empty
        if (key === this.keycodes.BACKSPACE)
        {
            var $editor = this.editor.getElement();
            var html = this.utils.trimSpaces($editor.html());
            html = html.replace(/<br\s?\/?>/g, '');
            html = html.replace(/<div><\/div>/, '');

            if (html === '')
            {
                e.preventDefault();
                this.editor.setEmpty();
                this.editor.startFocus();
                return;
            }
        }

        if (this.editor.isEmpty())
        {
            this.app.broadcast('empty');
        }
    },

    // public
    start: function()
    {
        // extend shortcuts
        if (this.opts.shortcutsAdd)
        {
            this.opts.shortcuts = $R.extend({}, true, this.opts.shortcuts, this.opts.shortcutsAdd);
        }
    },

    // private
    _selectAll: function()
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var el;

        if (data.isComponentType('table'))
        {
            el = data.getTable();
            this.selection.setAll(el);
            return;
        }
        else if (data.isComponentType('code'))
        {
            el = data.getComponentCodeElement();
            this.selection.setAll(el);
            return;
        }

        this.selection.setAll();
    },
    _isArrowKey: function(key)
    {
        return ([this.keycodes.UP, this.keycodes.DOWN, this.keycodes.RIGHT, this.keycodes.LEFT].indexOf(key) !== -1);
    },
    _isDeleteKey: function(key)
    {
        return (key === this.keycodes.BACKSPACE || key === this.keycodes.DELETE);
    }
});
$R.add('class', 'input.arrow', {
    init: function(app, e, key)
    {
        this.app = app;
        this.opts = app.opts;
        this.utils = app.utils;
        this.caret = app.caret;
        this.offset = app.offset;
        this.marker = app.marker;
        this.editor = app.editor;
        this.keycodes = app.keycodes;
        this.component = app.component;
        this.inspector = app.inspector;
        this.selection = app.selection;

        // local
        this.key = key;

        // init
        this._init(e);
    },
    // private
    _init: function(e)
    {
        if (this._isRightLeftKey() && this._isExitVariable(e)) return;

        if (this._isRightDownKey())
        {
            if (this._isExitOnDownRight(e)) return;
            if (this._selectComponent(e, 'End', 'next')) return;
        }

        if (this._isLeftUpKey())
        {
            if (this._isExitOnUpLeft(e)) return;
            if (this._selectComponent(e, 'Start', 'prev')) return;
        }

        if (this.key === this.keycodes.LEFT) this.utils.trimInvisibleChars('left');
        else if (this.key === this.keycodes.RIGHT) this.utils.trimInvisibleChars('right');

    },
    _isRightDownKey: function()
    {
        return ([this.keycodes.DOWN, this.keycodes.RIGHT].indexOf(this.key) !== -1);
    },
    _isLeftUpKey: function()
    {
        return ([this.keycodes.UP, this.keycodes.LEFT].indexOf(this.key) !== -1);
    },
    _isRightLeftKey: function()
    {
        return ([this.keycodes.RIGHT, this.keycodes.LEFT].indexOf(this.key) !== -1);
    },
    _isExitVariable: function(e)
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var component = data.getComponent();
        if (data.isComponentType('variable') && data.isComponentActive())
        {
            e.preventDefault();
            var func = (this.key === this.keycodes.LEFT) ? 'setBefore' : 'setAfter';
            this.caret[func](component);
            return;
        }
    },
    _isExitOnUpLeft: function(e)
    {
        var current = this.selection.getCurrent();
        var block = this.selection.getBlock(current);
        var data = this.inspector.parse(current);
        var prev = block.previousElementSibling;
        var isStart = this.caret.isStart(block);

        // prev table
        if (isStart && prev && prev.tagName === 'TABLE')
        {
            e.preventDefault();
            this.caret.setEnd(prev);
            return true;
        }
        // figcaption
        else if (data.isFigcaption())
        {
            block = data.getFigcaption();
            isStart = this.caret.isStart(block);

            var $component = $R.dom(block).closest('.redactor-component');
            if (isStart && $component.length !== 0)
            {
                e.preventDefault();
                this.caret.setEnd($component);
                return true;
            }
        }
        // exit table
        else if (data.isTable() && isStart)
        {
            e.preventDefault();
            this.caret.setEnd(block.previousElementSibling);
            return true;
        }
        // component
        else if (!data.isComponentEditable() && data.isComponent() && !data.isComponentType('variable'))
        {
            var component = data.getComponent();
            if (!component.previousElementSibling)
            {
                e.preventDefault();
                this.component.clearActive();

                return this._exitPrevElement(e, data.getComponent());
            }
            else if (component.previousElementSibling)
            {
                e.preventDefault();
                this.component.clearActive();
                this.caret.setEnd(component.previousElementSibling);
                return true;
            }
        }
    },
    _isExitOnDownRight: function(e)
    {
        var $editor = this.editor.getElement();
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var isEndEditor = this.caret.isEnd();
        var block, isEnd;

        // table
        if (data.isTable())
        {
            if (isEnd || isEndEditor)
            {
                return this._exitNextElement(e, data.getComponent());
            }
        }
        // figcaption
        else if (data.isFigcaption())
        {
            block = data.getFigcaption();
            isEnd = this.caret.isEnd(block);

            if (isEnd || isEndEditor)
            {
                return this._exitNextElement(e, data.getComponent());
            }
        }
        // figure/code
        else if (data.isComponentType('code'))
        {
            var component = data.getComponent();
            var pre = $R.dom(data.getComponentCodeElement()).closest('pre');

            isEnd = this.caret.isEnd(block);

            var isNext = (pre && pre.get().nextElementSibling);
            if (isEnd && !isNext)
            {
                return this._exitNextElement(e, component);
            }
        }
        // pre & blockquote & dl
        else if (data.isPre() || data.isBlockquote() || data.isDl())
        {
            if (isEndEditor)
            {
                if (data.isPre()) return this._exitNextElement(e, data.getPre());
                else if (data.isBlockquote()) return this._exitNextElement(e, data.getBlockquote());
                else if (data.isDl()) return this._exitNextElement(e, data.getDl());
            }
        }
        // li
        else if (data.isList())
        {
            var $list = $R.dom(current).parents('ul, ol', $editor).last();
            isEnd = this.caret.isEnd($list);

            if (isEnd || isEndEditor)
            {
                return this._exitNextElement(e, $list.get());
            }
        }
        // component
        else if (data.isComponent() && !data.isComponentType('variable') && data.getTag() !== 'span')
        {
            this.component.clearActive();
            return this._exitNextElement(e, data.getComponent());
        }
    },
    _exitPrevElement: function(e, node)
    {
        e.preventDefault();

        if (node.previousElementSibling) this.caret.setEnd(node.previousElementSibling);
        else this.utils.createMarkupBefore(node);

        return true;
    },
    _exitNextElement: function(e, node)
    {
        e.preventDefault();

        if (node.nextElementSibling) this.caret.setStart(node.nextElementSibling);
        else this.utils.createMarkup(node);

        return true;
    },
    _selectComponent: function(e, caret, type)
    {
        var current = this.selection.getCurrent();
        var block = this.selection.getBlock(current);
        var sibling = this.utils.findSiblings(current, type);
        var siblingBlock = this.utils.findSiblings(block, type);

        if (sibling && this.caret['is' + caret](current))
        {
            this._selectComponentItem(e, sibling, caret);
        }
        else if (siblingBlock && this.caret['is' + caret](block))
        {
            this._selectComponentItem(e, siblingBlock, caret);
        }
    },
    _selectComponentItem: function(e, item, caret)
    {
        if (this.component.isNonEditable(item))
        {
            e.preventDefault();
            this.caret['set' + caret](item);
            return true;
        }
    }
});
$R.add('class', 'input.delete', {
    init: function(app, e, key)
    {
        this.app = app;
        this.opts = app.opts;
        this.caret = app.caret;
        this.utils = app.utils;
        this.editor = app.editor;
        this.marker = app.marker;
        this.keycodes = app.keycodes;
        this.component = app.component;
        this.inspector = app.inspector;
        this.selection = app.selection;
        this.insertion = app.insertion;

        // local
        this.key = key;

        // init
        this._init(e);
    },
    // private
    _init: function(e)
    {
        if (this._removeActiveComponent(e)) return;
        if (this._removeAllSelectedTable(e)) return;

        // is empty
        if (this.key === this.keycodes.BACKSPACE)
        {
            var $editor = this.editor.getElement();
            var html = this.utils.trimSpaces($editor.html());

            if (html === this.opts.emptyHtml)
            {
                e.preventDefault();
                return;
            }
        }

        // variable or non editable prev/next or selection
        if (this._detectVariableOrNonEditable() || this.selection.hasNonEditable())
        {
            e.preventDefault();
            return;
        }

        // all selected
        if (this.selection.isAll())
        {
            e.preventDefault();
            this.insertion.set(this.opts.emptyHtml);
            return;
        }

        // collapsed
        if (this.selection.isCollapsed())
        {
            // next / prev
            if (this.key === this.keycodes.BACKSPACE) this._traverseBackspace(e);
            else if (this.key === this.keycodes.DELETE) this._traverseDelete(e);
        }

        if (this.key === this.keycodes.BACKSPACE) this.utils.trimInvisibleChars('left');

        this._removeUnwantedStyles();
        this._removeEmptySpans();
        this._removeSpanTagsInHeadings();
        this._removeInlineTagsInPre();
    },
    _detectVariableOrNonEditable: function()
    {
        var block = this.selection.getBlock();
        var isBlockStart = this.caret.isStart(block);
        var isBlockEnd = this.caret.isEnd(block);
        var el;

        // backspace
        if (this.key === this.keycodes.BACKSPACE && isBlockStart)
        {
            el = block.previousSibling;
            if (this._isNonEditable(el)) return true;
        }
        // delete
        else if (this.key === this.keycodes.DELETE && isBlockEnd)
        {
            el = block.nextSibling;
            if (this._isNonEditable(el)) return true;
        }

        var current = this.selection.getCurrent();
        var isCurrentStart = this.caret.isStart(current);
        var isCurrentEnd = this.caret.isEnd(current);
        var isCurrentStartSpace = (this.selection.getTextBeforeCaret().trim() === '');
        var isCurrentEndSpace = (this.selection.getTextAfterCaret().trim() === '');

        // backspace
        if (this.key === this.keycodes.BACKSPACE && isCurrentStart && !isCurrentStartSpace)
        {
            el = current.previousSibling;
            if (this._isVariable(el))
            {
                this.caret.setEnd(el);
                return true;
            }
            else if (this._isNonEditable(el)) return true;
        }
        // delete
        else if (this.key === this.keycodes.DELETE && isCurrentEnd && !isCurrentEndSpace)
        {
            el = current.nextSibling;
            if (this._isVariable(el))
            {
                this.caret.setStart(el);
                return true;
            }
            else if (this._isNonEditable(el)) return true;
        }
    },
    _isVariable: function(node)
    {
        return ($R.dom(node).closest('[data-redactor-type="variable"]').length !== 0);
    },
    _isNonEditable: function(node)
    {
        return ($R.dom(node).closest('.non-editable').length !== 0);
    },
    _getBlock: function()
    {
        var $editor = this.editor.getElement();
        var block = this.selection.getBlock();
        var data = this.inspector.parse(block);

        block = (data.isList()) ? $R.dom(block).parents('ul, ol', $editor).last().get() : block;
        block = (data.isDl()) ? data.getDl() : block;
        block = (data.isTable()) ? data.getTable() : block;

        return block;
    },
    _traverseDelete: function(e)
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var block, isEnd, $next;

        // figcaption
        if (data.isFigcaption())
        {
            block = data.getFigcaption();
            isEnd = this.caret.isEnd(block);

            if (isEnd)
            {
                e.preventDefault();
                return;
            }
        }
        // figure/code
        else if (data.isComponentType('code'))
        {
            block = data.getComponent();
            isEnd = this.caret.isEnd(block);

            if (isEnd)
            {
                e.preventDefault();
                return;
            }
        }

        // next
        block = this._getBlock();
        var next = this.utils.findSiblings(block, 'next');
        if (!next) return;

        isEnd = this.caret.isEnd(block);
        var dataNext = this.inspector.parse(next);
        var isNextBlock = (next.tagName === 'P' || next.tagName === 'DIV');

        // figure/code or table
        if (isEnd && dataNext.isComponentEditable())
        {
            e.preventDefault();
            this.component.remove(next, false);
            return;
        }
        // component
        else if (isEnd && dataNext.isComponent())
        {
            e.preventDefault();

            // select component
            this.caret.setStart(next);

            // remove current if empty
            if (this.utils.isEmptyHtml(block.innerHTML))
            {
                $R.dom(block).remove();
            }

            return;
        }
        // combine list
        else if (isEnd && dataNext.isList())
        {
            var $currentList = $R.dom(block);
            $next = $R.dom(next);

            // current list
            if (data.isList())
            {
                e.preventDefault();

                $currentList.append($next);
                $next.unwrap();

                return;
            }
            else
            {
                var $first = $next.children('li').first();
                var $lists = $first.find('ul, ol');

                if ($lists.length !== 0)
                {
                    e.preventDefault();

                    $next.prepend($lists);
                    $lists.unwrap();

                    $currentList.append($first);
                    $first.unwrap();

                    return;
                }
            }
        }
        // block
        else if (isEnd && !data.isList() && !data.isTable() && isNextBlock && !this.utils.isEmptyHtml(block.innerHTML))
        {
            e.preventDefault();

            var $current = $R.dom(block);
            $next = $R.dom(next);

            $current.append($next);
            $next.unwrap();

            return;
        }
    },
    _traverseBackspace: function(e)
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var block, isStart, $prev, $currentList;

        // figcaption
        if (data.isFigcaption())
        {
            block = data.getFigcaption();
            isStart = this.caret.isStart(block);

            if (isStart)
            {
                e.preventDefault();
                return;
            }
        }
        // figure/code
        else if (data.isComponentType('code'))
        {
            block = data.getComponent();
            isStart = this.caret.isStart(block);

            if (isStart && block.previousElementSibling)
            {
                e.preventDefault();
                this.caret.setEnd(block.previousElementSibling);
                return true;
            }
        }

        // prev
        block = this._getBlock();
        var prev = this.utils.findSiblings(block, 'prev');

        if (!prev)
        {
            setTimeout(this._replaceBlock.bind(this), 1);
            return;
        }

        isStart = this.caret.isStart(block);
        var dataPrev = this.inspector.parse(prev);
        var isPrevBlock = (prev.tagName === 'P' || prev.tagName === 'DIV');

        // figure/code or table
        if (isStart && dataPrev.isComponentEditable())
        {
            e.preventDefault();
            this.component.remove(prev, false);
            return;
        }
        // component
        else if (isStart && dataPrev.isComponent())
        {
            e.preventDefault();

            // select component
            this.caret.setStart(prev);

            // remove current if empty
            if (this.utils.isEmptyHtml(block.innerHTML))
            {
                $R.dom(block).remove();
            }

            return;
        }
        // lists
        else if (isStart && data.isList())
        {
            e.preventDefault();

            $currentList = $R.dom(block);
            $prev = $R.dom(prev);

            if (dataPrev.isList())
            {
                $currentList.children('li').first().prepend(this.marker.build('start'));
                $prev.append($currentList);
                $currentList.unwrap();

                this.selection.restoreMarkers();
            }
            else
            {
                var $first = $currentList.children('li').first();
                var first = $first.get();
                var $lists = $first.find('ul, ol');

                var $newnode = this.utils.replaceToTag(first, this.opts.markup);
                if (this.opts.breakline) $newnode.attr('data-redactor-tag', 'br');
                $currentList.before($newnode);
                this.caret.setStart($newnode);

                if ($lists.length !== 0)
                {
                    $currentList.prepend($lists);
                    $lists.unwrap();
                }
            }

            return;
        }
        // block
        else if (isStart && isPrevBlock)
        {
            e.preventDefault();

            if (this.utils.isEmpty(prev)) {
                $prev = $R.dom(prev);
                $prev.remove();
                return;
            }

            var textNode = this.utils.createInvisibleChar();
            var $current = $R.dom(block);
            $prev = $R.dom(prev);

            this.caret.setEnd($prev);

            $current.prepend(textNode);
            $prev.append($current.contents());
            $current.remove();

            return;
        }
    },
    _replaceBlock: function()
    {
        var block = this.selection.getBlock();
        var $block = $R.dom(block);

        if (this.opts.markup === 'p' && block && this._isNeedToReplaceBlock(block))
        {
            var markup = document.createElement(this.opts.markup);

            $block.replaceWith(markup);
            this.caret.setStart(markup);
        }

        if (this.opts.breakline && block && block.tagName === 'DIV')
        {
            $block.attr('data-redactor-tag', 'br');
        }
    },
    _isNeedToReplaceBlock: function(block)
    {
        return (block.tagName === 'DIV' && this.utils.isEmptyHtml(block.innerHTML));
    },
    _removeActiveComponent: function(e)
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var component = data.getComponent();
        if (data.isComponent() && this.component.isActive(component))
        {
            e.preventDefault();
            this.component.remove(component);
            return true;
        }
    },
    _removeAllSelectedTable: function(e)
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var table = data.getTable();
        if (table && this.selection.isAll(table))
        {
            e.preventDefault();
            this.component.remove(table);
            return true;
        }
    },
    _removeUnwantedStyles: function()
    {
        var $editor = this.editor.getElement();

        setTimeout(function()
        {
            var $tags = $editor.find('*[style]');
            $tags.not('img, figure, iframe, [data-redactor-style-cache], [data-redactor-span]').removeAttr('style');

        }, 0);
    },
    _removeEmptySpans: function()
    {
        var $editor = this.editor.getElement();

        setTimeout(function()
        {
            $editor.find('span').each(function(node)
            {
                if (node.attributes.length === 0)
                {
                    $R.dom(node).replaceWith(node.childNodes);
                }
            });

        }, 0);
    },
    _removeSpanTagsInHeadings: function()
    {
        var $editor = this.editor.getElement();

        setTimeout(function()
        {
            $editor.find('h1, h2, h3, h4, h5, h6').each(function(node)
            {
                var $node = $R.dom(node);
                if ($node.closest('figure').length === 0)
                {
                    $node.find('span').not('.redactor-component, .non-editable, .redactor-selection-marker, [data-redactor-style-cache], [data-redactor-span]').unwrap();
                }
            });

        }, 1);
    },
    _removeInlineTagsInPre: function()
    {
        var $editor = this.editor.getElement();
        var tags = this.opts.inlineTags;

        setTimeout(function()
        {
            $editor.find('pre').each(function(node)
            {
                var $node = $R.dom(node);
                if ($node.closest('figure').length === 0)
                {
                    $node.find(tags.join(',')).not('code, .redactor-selection-marker').unwrap();
                }
            });

        }, 1);
    }
});
$R.add('class', 'input.enter', {
    init: function(app, e)
    {
        this.app = app;
        this.opts = app.opts;
        this.utils = app.utils;
        this.caret = app.caret;
        this.editor = app.editor;
        this.insertion = app.insertion;
        this.selection = app.selection;
        this.inspector = app.inspector;

        // init
        this._init(e);
    },
    // private
    _init: function(e)
    {
        // turn off
        if (!this.opts.enterKey) return this._disable(e);

        // callback
        var stop = this.app.broadcast('enter', e);
        if (stop === false) return e.preventDefault();

        // has non-editable
        if (this.selection.hasNonEditable())
        {
            e.preventDefault();
            return;
        }

        // shift enter
        if (e.ctrlKey || e.shiftKey) return this._insertBreak(e);

        // enter & exit
        if (this._isExit(e)) return;

        // traverse
        this._traverse(e);
    },
    _disable: function(e)
    {
        e.preventDefault();
        var range = this.selection.getRange();
        if (range && !range.collapsed) range.deleteContents();
    },
    _insertBreak: function(e)
    {
        e.preventDefault();

        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);

        if ((data.isComponent() && !data.isComponentEditable()) || data.isCode()) return;
        else if (data.isPre()) this.insertion.insertNewline();
        else this.insertion.insertBreakLine();
    },
    _isExit: function(e)
    {
        var $editor = this.editor.getElement();
        var block = this.selection.getBlock();
        var data = this.inspector.parse(block);
        var isEnd = this.caret.isEnd(block);
        var current = this.selection.getCurrent();
        var prev = current.previousSibling;

        // blockquote
        if (data.isBlockquote())
        {
            var isParagraphExit = (isEnd && this._isExitableBlock(block, 'P'));
            var isBreaklineExit = (isEnd && this._isExitableDblBreak(prev));

            if (isParagraphExit || isBreaklineExit)
            {
                return this._exitFromElement(e, ((isBreaklineExit) ? prev : block), data.getBlockquote());
            }
        }
        // pre
        else if (!data.isComponentType('code') && data.isPre())
        {
            if (isEnd)
            {
                var html = block.innerHTML;
                html = this.utils.removeInvisibleChars(html);
                if (html.match(/(\n\n\n)$/) !== null)
                {
                    $R.dom(prev.previousSibling.previousSibling).remove();
                    return this._exitFromElement(e, prev, block);
                }
            }
        }
        // dl
        else if (data.isDl())
        {
            if (isEnd && this._isExitableBlock(block, 'DT'))
            {
                return this._exitFromElement(e, block, data.getDl());
            }
        }
        // li
        else if (data.isList())
        {
            var list = $R.dom(current).parents('ul, ol', $editor).last();

            isEnd = this.caret.isEnd(list);
            if (isEnd && this._isExitableBlock(block, 'LI'))
            {
                return this._exitFromElement(e, block, list);
            }
        }
        else if (data.isComponent() && data.isComponentActive() && !data.isFigcaption() && !data.isComponentEditable())
        {
            return this._exitFromElement(e, false, data.getComponent());
        }
    },
    _isExitableDblBreak: function(prev)
    {
        var next = (prev) ? prev.nextSibling : false;
        if (next)
        {
            var text = this.utils.removeInvisibleChars(next.textContent);

            return (next.nodeType === 3 && text.trim() === '');
        }
    },
    _isExitableBlock: function(block, tag)
    {
        return (block && block.tagName === tag && this.utils.isEmptyHtml(block.innerHTML));
    },
    _exitFromElement: function(e, prev, el)
    {
        e.preventDefault();
        if (prev) $R.dom(prev).remove();
        this.utils.createMarkup(el);

        return true;
    },
    _exitNextElement: function(e, node)
    {
        e.preventDefault();

        if (node.nextSibling) this.caret.setStart(node.nextSibling);
        else this.utils.createMarkup(node);

        return true;
    },
    _traverse: function(e)
    {
        var current = this.selection.getCurrent();
        var isText = this.selection.isText();
        var block = this.selection.getBlock();
        var data = this.inspector.parse(current);
        var blockTag = (block) ? block.tagName.toLowerCase() : false;
        var $variable = $R.dom(current).closest('[data-redactor-type=variable]');
        // variable parent
        if ($variable.length !== 0) {
            this.caret.setAfter($variable);
        }

        // pre
        if (data.isPre())
        {
            e.preventDefault();
            return this.insertion.insertNewline();
        }
        // blockquote
        else if (data.isBlockquote())
        {
            block = this.selection.getBlock(current);
            if (block && block.tagName === 'BLOCKQUOTE')
            {
                e.preventDefault();
                return this.insertion.insertBreakLine();
            }
        }
        // figcaption
        else if (data.isFigcaption())
        {
            block = data.getFigcaption();
            var isEnd = this.caret.isEnd(block);
            var isEndEditor = this.caret.isEnd();
            if (isEnd || isEndEditor)
            {
                return this._exitNextElement(e, data.getComponent());
            }
            else
            {
                e.preventDefault();
                return;
            }
        }
        // dl
        else if (data.isDl())
        {
            e.preventDefault();
            return this._traverseDl(current);
        }
        // breakline
        else if (this.opts.breakline && blockTag === 'div') {
            setTimeout(this._replaceBlock.bind(this), 1);
            return;
        }
        // text
        else if (isText)
        {
            e.preventDefault();
            return this.insertion.insertBreakLine();
        }
        // div / p
        else
        {
            setTimeout(this._replaceBlock.bind(this), 1);
            return;
        }
    },
    _traverseDl: function(current)
    {
        var block = this.selection.getBlock(current);
        var data = this.inspector.parse(block);
        var tag = data.getTag();
        var $el = $R.dom(block);
        var next = $el.get().nextSibling || false;
        var $next = $R.dom(next);
        var nextDd = (next && $next.is('dd'));
        var nextDt = (next && $next.is('dt'));
        var isEnd = this.caret.isEnd(block);

        if (tag === 'dt' && !nextDd && isEnd)
        {
            var dd = document.createElement('dd');
            $el.after(dd);

            this.caret.setStart(dd);
            return;
        }
        else if (tag === 'dd' && !nextDt && isEnd)
        {
            var dt = document.createElement('dt');
            $el.after(dt);

            this.caret.setStart(dt);
            return;
        }

        return this.insertion.insertBreakLine();
    },
    _replaceBlock: function()
    {
        var block = this.selection.getBlock();
        var $block = $R.dom(block);

        if (this.opts.markup === 'p' && block && this._isNeedToReplaceBlock(block))
        {
            var markup = document.createElement(this.opts.markup);

            $block.replaceWith(markup);
            this.caret.setStart(markup);
        }
        else
        {
            if (block)
            {
                if (this.utils.isEmptyHtml(block.innerHTML))
                {
                    this._clearBlock($block, block);
                }
                else
                {
                    var first = this.utils.getFirstNode(block);
                    if (first && first.tagName === 'BR')
                    {
                        $R.dom(first).remove();
                        this.caret.setStart(block);
                    }
                }
            }
        }

        if (block && this._isNeedToCleanBlockStyle(block) && this.opts.cleanOnEnter)
        {
            $block.removeAttr('class style');
        }

        if (this.opts.breakline && block && block.tagName === 'DIV')
        {
            $block.attr('data-redactor-tag', 'br');
        }
    },
    _clearBlock: function($block, block)
    {
        if (this.opts.cleanInlineOnEnter || block.innerHTML === '<br>')
        {
            $block.html('');
        }

        this.caret.setStart(block);
    },
    _isNeedToReplaceBlock: function(block)
    {
        return (block.tagName === 'DIV' && this.utils.isEmptyHtml(block.innerHTML));
    },
    _isNeedToCleanBlockStyle: function(block)
    {
        return (block.tagName === 'P' && this.utils.isEmptyHtml(block.innerHTML));
    }
});
$R.add('class', 'input.paste', {
    init: function(app, e, dataTransfer, html, point)
    {
        this.app = app;
        this.opts = app.opts;
        this.editor = app.editor;
        this.cleaner = app.cleaner;
        this.container = app.container;
        this.inspector = app.inspector;
        this.insertion = app.insertion;
        this.selection = app.selection;
        this.autoparser = app.autoparser;

        // local
        this.pasteHtml = html;
        this.pointInserted = point;
        this.dataTransfer = dataTransfer;

        // init
        this._init(e);
    },
    // private
    _init: function(e)
    {
        var clipboard = this.dataTransfer || e.clipboardData;
        var current = this.selection.getCurrent();
        var dataCurrent = this.inspector.parse(current);

        this.dropPasted = this.dataTransfer;
        this.isRawCode = (dataCurrent.isPre() || dataCurrent.isCode());

        this.editor.enablePasting();
        this.editor.saveScroll();

        if (!this.dropPasted)
        {
            this.selection.saveMarkers();
        }

        if (this.isRawCode || !clipboard)
        {
            var text;
            if (!this.isRawCode && !clipboard && window.clipboardData)
            {
                text = window.clipboardData.getData("text");
            }
            else
            {
                text = clipboard.getData("text/plain");
            }

            e.preventDefault();
            this._insert(e, text);
            return;
        }
        else if (this.pasteHtml)
        {
            e.preventDefault();
            this._insert(e, this.pasteHtml);
        }
        else
        {
            // html / text
            var url = clipboard.getData('URL');
            var html = (this._isPlainText(clipboard)) ? clipboard.getData("text/plain") : clipboard.getData("text/html");

            // safari anchor links
            html = (!url || url === '') ? html : url;

            // file
            if (clipboard.files !== null && clipboard.files.length > 0 && html === '')
            {
                var files = [];
                for (var i = 0; i < clipboard.files.length; i++)
                {
                    var file = clipboard.files[i] || clipboard.items[i].getAsFile();
                    if (file) files.push(file);
                }

                if (files.length > 0)
                {
                    e.preventDefault();
                    this._insertFiles(e, files);
                    return;
                }
            }


            e.preventDefault();
            this._insert(e, html);
        }
    },
    _isPlainText: function(clipboard)
    {
        var text = clipboard.getData("text/plain");
        var html = clipboard.getData("text/html");

        if (text && html)
        {
            var element = document.createElement("div");
            element.innerHTML = html;

            if (element.textContent === text)
            {
                return !element.querySelector(":not(meta)");
            }
        }
        else
        {
            return (text !== null);
        }
    },
    _restoreSelection: function()
    {
        this.editor.restoreScroll();
        this.editor.disablePasting();
        if (!this.dropPasted)
        {
            this.selection.restoreMarkers();
        }
    },
    _insert: function(e, html)
    {
        // pasteBefore callback
        var returned = this.app.broadcast('pasteBefore', html);
        html = (returned === undefined) ? html : returned;

        // clean
        html = html.trim();
        html = (this.isRawCode) ? html : this.cleaner.paste(html);
        html = html.trim();
        html = (this.isRawCode) ? this.cleaner.encodePhpCode(html) : html;

        // paste callback
        returned = this.app.broadcast('pasting', html);
        html = (returned === undefined) ? html : returned;

        this._restoreSelection();

        // stop input
        if (!this.opts.input) return;

        var nodes = [];
        if (this.isRawCode) {
            var textNode = document.createTextNode(html)
            nodes = this.insertion.insertNode(textNode, 'after');

            this.app.broadcast('pasted', nodes);
        }
        else {

            // autoparse
            if (this.opts.autoparse && this.opts.autoparsePaste)
            {
                html = this.autoparser.parse(html);
            }

            nodes = (this.dropPasted) ? this.insertion.insertToPoint(e, html, this.pointInserted) : this.insertion.insertHtml(html);

            // pasted callback
            this.app.broadcast('pasted', nodes);
            this.app.broadcast('autoparseobserve');
        }
    },
    _insertFiles: function(e, files)
    {
        this._restoreSelection();

        // drop or clipboard
        var isImage = (this.opts.imageTypes.indexOf(files[0].type) !== -1);
        var isClipboard = (typeof this.dropPasted === 'undefined');

        if (isImage) this.app.broadcast('dropimage', e, files, isClipboard);
        else this.app.broadcast('dropfile', e, files, isClipboard);
    }
});
$R.add('class', 'input.shortcode', {
    init: function(app, e, key)
    {
        this.app = app;
        this.opts = app.opts;
        this.utils = app.utils;
        this.marker = app.marker;
        this.keycodes = app.keycodes;
        this.selection = app.selection;

        // local
        this.worked = false;

        // init
        if (key === this.keycodes.SPACE) this._init();
    },
    // public
    is: function()
    {
        return this.worked;
    },
    // private
    _init: function()
    {
        var current = this.selection.getCurrent();
        if (current && current.nodeType === 3)
        {
            var text = this.utils.removeInvisibleChars(current.textContent);
            var shortcodes = this.opts.shortcodes;
            for (var name in shortcodes)
            {
                var re = new RegExp('^' + this.utils.escapeRegExp(name));
                var match = text.match(re);
                if (match !== null)
                {
                    if (typeof shortcodes[name].format !== 'undefined')
                    {
                        return this._format(shortcodes[name].format, current, re);
                    }
                }
            }
        }
    },
    _format: function(tag, current, re)
    {
        var marker = this.marker.insert('start');
        current = marker.previousSibling;

        var text = current.textContent;
        text = this.utils.trimSpaces(text);
        text = text.replace(re, '');
        current.textContent = text;

        var api = (tag === 'ul' || tag === 'ol') ? 'module.list.toggle' : 'module.block.format';

        this.app.api(api, tag);
        this.selection.restoreMarkers();

        this.worked = true;
    }
});
$R.add('class', 'input.shortcut', {
    init: function(app, e)
    {
        this.app = app;
        this.opts = app.opts;

        // local
        this.worked = false;

        // based on https://github.com/jeresig/jquery.hotkeys
        this.hotkeys = {
            8: "backspace", 9: "tab", 10: "return", 13: "return", 16: "shift", 17: "ctrl", 18: "alt", 19: "pause",
            20: "capslock", 27: "esc", 32: "space", 33: "pageup", 34: "pagedown", 35: "end", 36: "home",
            37: "left", 38: "up", 39: "right", 40: "down", 45: "insert", 46: "del", 59: ";", 61: "=",
            96: "0", 97: "1", 98: "2", 99: "3", 100: "4", 101: "5", 102: "6", 103: "7",
            104: "8", 105: "9", 106: "*", 107: "+", 109: "-", 110: ".", 111 : "/",
            112: "f1", 113: "f2", 114: "f3", 115: "f4", 116: "f5", 117: "f6", 118: "f7", 119: "f8",
            120: "f9", 121: "f10", 122: "f11", 123: "f12", 144: "numlock", 145: "scroll", 173: "-", 186: ";", 187: "=",
            188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\", 221: "]", 222: "'"
        };

        this.hotkeysShiftNums = {
            "`": "~", "1": "!", "2": "@", "3": "#", "4": "$", "5": "%", "6": "^", "7": "&",
            "8": "*", "9": "(", "0": ")", "-": "_", "=": "+", ";": ": ", "'": "\"", ",": "<",
            ".": ">",  "/": "?",  "\\": "|"
        };

        // init
        this._init(e);
    },
    // public
    is: function()
    {
        return this.worked;
    },
    // private
    _init: function(e)
    {
        // disable browser's hot keys for bold and italic if shortcuts off
        if (this.opts.shortcuts === false)
        {
            if ((e.ctrlKey || e.metaKey) && (e.which === 66 || e.which === 73)) e.preventDefault();
            return;
        }

        // build
        for (var key in this.opts.shortcuts)
        {
            this._build(e, key, this.opts.shortcuts[key]);
        }
    },
    _build: function(e, str, command)
    {
        var keys = str.split(',');
        var len = keys.length;
        for (var i = 0; i < len; i++)
        {
            if (typeof keys[i] === 'string')
            {
                this._handler(e, keys[i].trim(), command);
            }
        }
    },
    _handler: function(e, keys, command)
    {
        keys = keys.toLowerCase().split(" ");

        var special = this.hotkeys[e.keyCode];
        var character = String.fromCharCode(e.which).toLowerCase();
        var modif = "", possible = {};
        var cmdKeys = ["meta", "ctrl", "alt", "shift"];

        for (var i = 0; i < cmdKeys.length; i++)
        {
            var specialKey = cmdKeys[i];
            if (e[specialKey + 'Key'] && special !== specialKey)
            {
                modif += specialKey + '+';
            }
        }

        if (special) possible[modif + special] = true;
        if (character)
        {
            possible[modif + character] = true;
            possible[modif + this.hotkeysShiftNums[character]] = true;

            // "$" can be triggered as "Shift+4" or "Shift+$" or just "$"
            if (modif === "shift+")
            {
                possible[this.hotkeysShiftNums[character]] = true;
            }
        }

        var len = keys.length;
        for (var i = 0; i < len; i++)
        {
            if (possible[keys[i]])
            {

                e.preventDefault();
                this.worked = true;

                if (command.message)
                {
                    this.app.broadcast(command.message, command.args);
                    this.app.broadcast('buffer.trigger');
                }
                else if (command.api)
                {
                    this.app.api(command.api, command.args);
                    this.app.broadcast('buffer.trigger');
                }

                return;
            }
        }
    }
});
$R.add('class', 'input.space', {
    init: function(app, e, key, lastShiftKey)
    {
        this.app = app;
        this.keycodes = app.keycodes;
        this.insertion = app.insertion;
        this.selection = app.selection;

        // local
        this.key = key;
        this.lastShiftKey = lastShiftKey;

        // init
        this._init(e);
    },
    // private
    _init: function(e)
    {
        // has non-editable
        if (this.selection.hasNonEditable())
        {
            e.preventDefault();
            return;
        }

        // shift/ctrl + space
        if (!this.lastShiftKey && this.key === this.keycodes.SPACE && (e.ctrlKey || e.shiftKey) && !e.metaKey)
        {
            e.preventDefault();
            this.insertion.insertChar('&nbsp;');
            return;
        }
    }
});
$R.add('class', 'input.tab', {
    init: function(app, e)
    {
        this.app = app;
        this.opts = app.opts;
        this.inspector = app.inspector;
        this.insertion = app.insertion;
        this.selection = app.selection;

        // init
        this._init(e);
    },
    // private
    _init: function(e)
    {
        // turn off tab
        if (!this.opts.tabKey) return;

        // callback
        var stop = this.app.broadcast('tab', e);
        if (stop === false) return e.preventDefault();

        // traverse
        this._traverse(e);
    },
    _traverse: function(e)
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);

        // hard tab
        if (!data.isComponent() && e.shiftKey)
        {
            return this._insertHardTab(e, 4);
        }

        // list
        if (data.isList())
        {
            e.preventDefault();
            return this.app.api('module.list.indent');
        }
        // pre
        if (data.isPre() || (data.isComponentType('code') && !data.isFigcaption()))
        {
            return this._tabCode(e);
        }

        // tab as spaces
        if (this.opts.tabAsSpaces !== false)
        {
            return this._insertHardTab(e, this.opts.tabAsSpaces);
        }
    },
    _insertHardTab: function(e, num)
    {
        e.preventDefault();
        var node = document.createTextNode(Array(num + 1).join('\u00a0'));
        return this.insertion.insertNode(node, 'end');
    },
    _tabCode: function(e)
    {
        e.preventDefault();

        var node = (this.opts.preSpaces) ? document.createTextNode(Array(this.opts.preSpaces + 1).join('\u00a0')) : document.createTextNode('\t');

        return this.insertion.insertNode(node, 'end');
    }
});
$R.add('module', 'upload', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.lang = app.lang;
        this.utils = app.utils;
        this.editor = app.editor;
        this.progress = app.progress;

        // local
        this.defaults = {
            event: false,
            element: false,
            name: false,
            files: false,
            url: false,
            data: false,
            paramName: false
        };
    },
    // public
    build: function(options)
    {
        this.p = $R.extend(this.defaults, options);
        this.$el = $R.dom(this.p.element);

        if (this.$el.get().tagName === 'INPUT') this._buildInput();
        else                                    this._buildBox();
    },
    send: function(options)
    {
        this.p = $R.extend(this.defaults, options);
        this.$uploadbox = this.editor.getElement();
        this._send(this.p.event, this.p.files);
    },
    complete: function(response, e)
    {
        this._complete(response, e);
    },

    // private
    _buildInput: function()
    {
        this.box = false;
        this.prefix = '';

        this.$uploadbox = $R.dom('<div class="upload-redactor-box" />');

        this.$el.hide();
        this.$el.after(this.$uploadbox);

        if (this.opts.multipleUpload) this.$el.attr('multiple', 'multiple');
        else this.$el.removeAttr('multiple');

        if (this.p.name !== 'file')
        {
            this.$el.attr('accept', 'image/*');
        }

        this._buildPlaceholder();
        this._buildEvents();
    },
    _buildBox: function()
    {
        this.box = true;
        this.prefix = 'box-';

        this.$uploadbox = this.$el;
        this.$uploadbox.attr('ondragstart', 'return false;');

        // events
        this.$uploadbox.on('drop.redactor.upload', this._onDropBox.bind(this));
        this.$uploadbox.on('dragover.redactor.upload', this._onDragOver.bind(this));
        this.$uploadbox.on('dragleave.redactor.upload', this._onDragLeave.bind(this));
    },
    _buildPlaceholder: function()
    {
        this.$placeholder = $R.dom('<div class="upload-redactor-placeholder" />');
        this.$placeholder.html(this.lang.get('upload-label'));
        this.$uploadbox.append(this.$placeholder);
    },
    _buildEvents: function()
    {
        this.$el.on('change.redactor.upload', this._onChange.bind(this));
        this.$uploadbox.on('click.redactor.upload', this._onClick.bind(this));
        this.$uploadbox.on('drop.redactor.upload', this._onDrop.bind(this));
        this.$uploadbox.on('dragover.redactor.upload', this._onDragOver.bind(this));
        this.$uploadbox.on('dragleave.redactor.upload', this._onDragLeave.bind(this));
    },
    _onClick: function(e)
    {
        e.preventDefault();
        this.$el.click();
    },
    _onChange: function(e)
    {
        this._send(e, this.$el.get().files);
    },
    _onDrop: function(e)
    {
        e.preventDefault();

        this._clear();
        this._setStatusDrop();
        this._send(e);
    },
    _onDragOver: function(e)
    {
        e.preventDefault();
        this._setStatusHover();

        return false;
    },
    _onDragLeave: function(e)
    {
        e.preventDefault();
        this._removeStatusHover();

        return false;
    },
    _onDropBox: function(e)
    {
        e.preventDefault();

        this._clear();
        this._setStatusDrop();
        this._send(e);
    },
    _removeStatusHover: function()
    {
        this.$uploadbox.removeClass('upload-redactor-' + this.prefix + 'hover');
    },
    _setStatusDrop: function()
    {
        this.$uploadbox.addClass('upload-redactor-' + this.prefix + 'drop');
    },
    _setStatusHover: function()
    {
        this.$uploadbox.addClass('upload-redactor-' + this.prefix + 'hover');
    },
    _setStatusError: function()
    {
        this.$uploadbox.addClass('upload-redactor-' + this.prefix + 'error');
    },
    _setStatusSuccess: function()
    {
        this.$uploadbox.addClass('upload-redactor-' + this.prefix + 'success');
    },
    _clear: function()
    {
        var classes = ['drop', 'hover', 'error', 'success'];
        for (var i = 0; i < classes.length; i++)
        {
            this.$uploadbox.removeClass('upload-redactor-' + this.prefix + classes[i]);
        }

        this.$uploadbox.removeAttr('ondragstart');
    },
    _send: function(e, files)
    {
        e = e.originalEvent || e;

        files = (files) ? files : e.dataTransfer.files;

        var data = new FormData();
        var name = this._getUploadParam();

        data = this._buildData(name, files, data);
        data = this.utils.extendData(data, this.p.data);

        var stop = this.app.broadcast('upload.start', e, data, files);
        if (stop !== false)
        {
            this._sendData(data, files, e);
        }
    },
    _sendData: function(data, files, e)
    {
        this.progress.show();
        if (typeof this.p.url === 'function')
        {
            var res = this.p.url(data, files, e, this);
            if (!(res instanceof Promise))
            {
                this._complete(res, e);
            }
        }
        else
        {
            $R.ajax.post({
                url: this.p.url,
                data: data,
                before: function(xhr)
                {
                    return this.app.broadcast('upload.beforeSend', xhr);

                }.bind(this),
                success: function(response)
                {
                    this._complete(response, e);
                }.bind(this)
            });
        }
    },
    _getUploadParam: function()
    {
        return (this.p.paramName) ? this.p.paramName : 'file';
    },
    _buildData: function(name, files, data)
    {
        if (files.length === 1)
        {
            data.append(name + '[]', files[0]);
        }
        else if (files.length > 1 && this.opts.multipleUpload !== false)
        {
            for (var i = 0; i < files.length; i++)
            {
                data.append(name + '[]', files[i]);
            }
        }

        return data;
    },
    _complete: function(response, e)
    {
        this._clear();
        this.progress.hide();

        if (response && response.error)
        {
            this._setStatusError();

            this.app.broadcast('upload.' + this.p.name + '.error', response, e);
            this.app.broadcast('upload.error', response);
        }
        else
        {
            this._setStatusSuccess();

            this.app.broadcast('upload.' + this.p.name + '.complete', response, e);
            this.app.broadcast('upload.complete', response);

            setTimeout(this._clear.bind(this), 500);
        }
    }
});
$R.add('class', 'code.component', {
    mixins: ['dom', 'component'],
    init: function(app, el)
    {
        this.app = app;

        // init
        return (el && el.cmnt !== undefined) ? el : this._init(el);
    },

    // private
   _init: function(el)
    {
        var $pre;
        if (typeof el !== 'undefined')
        {
            var $node = $R.dom(el);
            var $wrapper = $node.closest('figure');
            if ($wrapper.length !== 0)
            {
                this.parse($wrapper);
            }
            else
            {
                this.parse('<figure>');
                this.append(el);
            }

            $pre = this.find('pre code, pre').last();
        }
        else
        {
            $pre = $R.dom('<pre>');

            this.parse('<figure>');
            this.append($pre);
        }

        this._initElement($pre);
        this._initWrapper();
    },
    _initElement: function($pre)
    {
        $pre.attr({
            'tabindex': '-1',
            'contenteditable': true
        });
    },
    _initWrapper: function()
    {
        this.addClass('redactor-component');
        this.attr({
            'data-redactor-type': 'code',
            'tabindex': '-1',
            'contenteditable': false
        });
    }
});
$R.add('module', 'form', {
    init: function(app)
    {
        this.app = app;
        this.lang = app.lang;
        this.component = app.component;
        this.inspector = app.inspector;
    },
    // messages
    onform: {
        remove: function(node)
        {
            this._remove(node);
        }
    },
    oncontextbar: function(e, contextbar)
    {
        var data = this.inspector.parse(e.target);
        if (data.isComponentType('form'))
        {
            var node = data.getComponent();
            var buttons = {
                "remove": {
                    title: this.lang.get('delete'),
                    api: 'module.form.remove',
                    args: node
                }
            };

            contextbar.set(e, node, buttons, 'top');
        }

    },

    // private
    _remove: function(node)
    {
        this.component.remove(node);
    }
});
$R.add('class', 'form.component', {
    mixins: ['dom', 'component'],
    init: function(app, el)
    {
        this.app = app;
        this.utils = app.utils;

        // init
        return (el && el.cmnt !== undefined) ? el : this._init(el);
    },
    // private
    _init: function(el)
    {
        if (typeof el !== 'undefined')
        {
            var $node = $R.dom(el);
            var $wrapper = $node.closest('form');
            if ($wrapper.length !== 0)
            {
                var $figure = this.utils.replaceToTag(el, 'figure');
                this.parse($figure);
            }
            else
            {
                this.parse('<figure>');
                this.append(el);
            }
        }
        else
        {
            this.parse('<figure>');
        }

        this._initWrapper();
    },
    _initWrapper: function()
    {
        this.addClass('redactor-component');
        this.attr({
            'data-redactor-type': 'form',
            'tabindex': '-1',
            'contenteditable': false
        });
    }
});
$R.add('module', 'image', {
    modals: {
        'image':
            '<div class="redactor-modal-tab redactor-modal-tab-upload" data-title="## upload ##"><form action=""> \
                <input type="file" name="file"> \
            </form></div>',
        'imageedit':
            '<div class="redactor-modal-group"> \
                <div id="redactor-modal-image-preview" class="redactor-modal-side"></div> \
                <form action="" class="redactor-modal-area"> \
                    <div class="form-item"> \
                        <label for="modal-image-title"> ## title ##</label> \
                        <input type="text" id="modal-image-title" name="title" /> \
                    </div> \
                    <div class="form-item form-item-caption"> \
                        <label for="modal-image-caption">## caption ##</label> \
                        <input type="text" id="modal-image-caption" name="caption" aria-label="## caption ##" /> \
                    </div> \
                    <div class="form-item form-item-align"> \
                        <label>## image-position ##</label> \
                        <select name="align" aria-label="## image-position ##"> \
                            <option value="none">## none ##</option> \
                            <option value="left">## left ##</option> \
                            <option value="center">## center ##</option> \
                            <option value="right">## right ##</option> \
                        </select> \
                    </div> \
                    <div class="form-item form-item-link"> \
                        <label for="modal-image-url">## link ##</label> \
                        <input type="text" id="modal-image-url" name="url" aria-label="## link ##" /> \
                    </div> \
                    <div class="form-item form-item-link"> \
                        <label class="checkbox"><input type="checkbox" name="target" aria-label="## link-in-new-tab ##"> ## link-in-new-tab ##</label> \
                    </div> \
                </form> \
            </div>'
    },
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.lang = app.lang;
        this.caret = app.caret;
        this.utils = app.utils;
        this.editor = app.editor;
        this.storage = app.storage;
        this.component = app.component;
        this.inspector = app.inspector;
        this.insertion = app.insertion;
        this.selection = app.selection;

        // local
        this.justResized = false;
    },
    // messages
    oninsert: function()
    {
        this._observeImages();
    },
    onstarted: function()
    {
        // storage observe
        this.storage.observeImages();

        // resize
        if (this.opts.imageResizable)
        {
            this.resizer = $R.create('image.resize', this.app);
        }

        // observe
        this._observeImages();
    },
    ondropimage: function(e, files, clipboard)
    {
        if (!this.opts.imageUpload) return;

        var options = {
            url: this.opts.imageUpload,
            event: (clipboard) ? false : e,
            files: files,
            name: 'imagedrop',
            data: this.opts.imageData,
            paramName: this.opts.imageUploadParam
        };

        this.app.api('module.upload.send', options);
    },
    onstop: function()
    {
        if (this.resizer) this.resizer.stop();
    },
    onbottomclick: function()
    {
        this.insertion.insertToEnd(this.editor.getLastNode(), 'image');
    },
    onimageresizer: {
        stop: function()
        {
            if (this.resizer) this.resizer.hide();
        }
    },
    onsource: {
        open: function()
        {
            if (this.resizer) this.resizer.hide();
        },
        closed: function()
        {
            this._observeImages();
            if (this.resizer) this.resizer.rebuild();
        }
    },
    onupload: {
        complete: function()
        {
            this._observeImages();
        },
        image: {
            complete: function(response)
            {
                this._insert(response);
            },
            error: function(response)
            {
                this._uploadError(response);
            }
        },
        imageedit: {
            complete: function(response)
            {
                this._change(response);
            },
            error: function(response)
            {
                this._uploadError(response);
            }
        },
        imagedrop: {
            complete: function(response, e)
            {
                this._insert(response, e);
            },
            error: function(response)
            {
                this._uploadError(response);
            }
        },
        imagereplace: {
            complete: function(response)
            {
                this._change(response, false);
            },
            error: function(response)
            {
                this._uploadError(response);
            }
        }
    },
    onmodal: {
        image: {
            open: function($modal, $form)
            {
                this._setUpload($modal, $form);
            }
        },
        imageedit: {
            open: function($modal, $form)
            {
                this._setFormData($modal, $form);
            },
            opened: function($modal, $form)
            {
                this._setFormFocus($form);
            },
            remove: function()
            {
                this._remove(this.$image);
            },
            save: function($modal, $form)
            {
                this._save($modal, $form);
            }
        }
    },
    onimage: {
        observe: function()
        {
            this._observeImages();
        },
        resized: function()
        {
            this.justResized = true;
        }
    },
    oncontextbar: function(e, contextbar)
    {
        if (this.justResized)
        {
            this.justResized = false;
            return;
        }

        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var $img = $R.dom(current).closest('img');

        if (!data.isFigcaption() && data.isComponentType('image') || $img.length !== 0)
        {
            var node = ($img.length !== 0) ? $img.get() : data.getComponent();
            var buttons = {
                "edit": {
                    title: this.lang.get('edit'),
                    api: 'module.image.open'
                },
                "remove": {
                    title: this.lang.get('delete'),
                    api: 'module.image.remove',
                    args: node
                }
            };

            contextbar.set(e, node, buttons);
        }
    },

    // public
    open: function()
    {
        this.$image = this._getCurrent();
        this.app.api('module.modal.build', this._getModalData());
    },
    insert: function(data)
    {
        this._insert(data);
    },
    remove: function(node)
    {
        this._remove(node);
    },

    // private
    _getModalData: function()
    {
        var modalData;
        if (this._isImage() && this.opts.imageEditable)
        {
            modalData = {
                name: 'imageedit',
                width: '800px',
                title: this.lang.get('edit'),
                handle: 'save',
                commands: {
                    save: { title: this.lang.get('save') },
                    remove: { title: this.lang.get('delete'), type: 'danger' },
                    cancel: { title: this.lang.get('cancel') }
                }
            };
        }
        else
        {
            modalData = {
                name: 'image',
                title: this.lang.get('image')
            };
        }

        return modalData;
    },
    _isImage: function()
    {
        return this.$image;
    },
    _getCurrent: function()
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var $img = $R.dom(current).closest('img');

        if ($img.length !== 0) {
            return this.component.create('image', $img);
        }
        else {
            return (data.isComponentType('image') && data.isComponentActive()) ? this.component.create('image', data.getComponent()) : false;
        }
    },
    _insert: function(response, e)
    {
        this.app.api('module.modal.close');

        if (Array.isArray(response))
        {
            var obj = {};
            for (var i = 0; i < response.length; i++)
            {
                obj = $R.extend(obj, response[i]);
            }

            response = obj;
        }
        else if (typeof response === 'string')
        {
            response = { "file": { url: response }};
        }

        if (typeof response === 'object')
        {

            var multiple = 0;
            for (var key in response)
            {
                if (typeof response[key] === 'object') multiple++;
            }

            if (multiple > 1)
            {
                this._insertMultiple(response, e);
            }
            else
            {
                this._insertSingle(response, e);
            }
        }
    },
    _insertSingle: function(response, e)
    {
        for (var key in response)
        {
            if (typeof response[key] === 'object')
            {
                var $img = this._createImageAndStore(response[key]);
                var inserted = (e) ? this.insertion.insertToPoint(e, $img, false, false) : this.insertion.insertHtml($img, false);

                this._removeSpaceBeforeFigure(inserted[0]);

                // set is active
                this.component.setActive(inserted[0]);
                this.app.broadcast('image.uploaded', inserted[0], response);
            }
        }
    },
    _insertMultiple: function(response, e)
    {
        var z = 0;
        var inserted = [];
        var last;
        for (var key in response)
        {
            if (typeof response[key] === 'object')
            {
                z++;

                var $img = this._createImageAndStore(response[key]);

                if (z === 1)
                {
                    inserted = (e) ? this.insertion.insertToPoint(e, $img, false, false) : this.insertion.insertHtml($img, false);
                }
                else
                {
                    var $inserted = $R.dom(inserted[0]);
                    $inserted.after($img);
                    inserted = [$img.get()];

                    this.app.broadcast('image.inserted', $img);
                }

                last = inserted[0];

                this._removeSpaceBeforeFigure(inserted[0]);
                this.app.broadcast('image.uploaded', inserted[0], response);
            }
        }

        // set last is active
        this.component.setActive(last);
    },
    _createImageAndStore: function(item)
    {
        var $img = this.component.create('image');

        $img.addClass('redactor-uploaded-figure');
        $img.setData({
            src: item.url,
            id: (item.id) ? item.id : this.utils.getRandomId()
        });

        // add to storage
        this.storage.add('image', $img.getElement());

        return $img;
    },
    _removeSpaceBeforeFigure: function(img)
    {
        if (!img) return;

        var prev = img.previousSibling;
        var next = img.nextSibling;
        var $prev = $R.dom(prev);
        var $next = $R.dom(next);

        if (this.opts.breakline) {
            if (next && $next.attr('data-redactor-tag') === 'br') {
                $next.find('br').first().remove();
            }
            if (prev && $prev.attr('data-redactor-tag') === 'br') {
                $prev.find('br').last().remove();
            }
        }

        if (prev)
        {
            this._removeInvisibleSpace(prev);
            this._removeInvisibleSpace(prev.previousSibling);
        }
    },
    _removeInvisibleSpace: function(el)
    {
        if (el && el.nodeType === 3 && this.utils.searchInvisibleChars(el.textContent) !== -1)
        {
            el.parentNode.removeChild(el);
        }
    },
    _save: function($modal, $form)
    {
        var data = $form.getData();
        var imageData = {
            title: data.title
        };

        if (this.opts.imageLink) imageData.link = { url: data.url, target: data.target };
        if (this.opts.imageCaption) imageData.caption = data.caption;
        if (this.opts.imagePosition) imageData.align = data.align;

        this.$image.setData(imageData);
        if (this.resizer) this.resizer.rebuild();

        this.app.broadcast('image.changed', this.$image);
        this.app.api('module.modal.close');
    },
    _change: function(response, modal)
    {
        if (typeof response === 'string')
        {
            response = { "file": { url: response }};
        }

        if (typeof response === 'object')
        {
            var $img;
            for (var key in response)
            {
                if (typeof response[key] === 'object')
                {
                    $img = $R.dom('<img>');
                    $img.attr('src', response[key].url);

                    this.$image.changeImage(response[key]);

                    this.app.broadcast('image.changed', this.$image, response);
                    this.app.broadcast('image.uploaded', this.$image, response);

                    this.app.broadcast('hardsync');

                    break;
                }
            }

            if (modal !== false)
            {
                $img.on('load', function() { this.$previewBox.html($img); }.bind(this));
            }
        }
    },
    _uploadError: function(response)
    {
        this.app.broadcast('image.uploadError', response);
    },
    _remove: function(node)
    {
        this.app.api('module.modal.close');
        this.component.remove(node);
    },
    _observeImages: function()
    {
        var $editor = this.editor.getElement();
        var self = this;
        $editor.find('img').each(function(node)
        {
            var $node = $R.dom(node);

            $node.off('.drop-to-replace');
            $node.on('dragover.drop-to-replace dragenter.drop-to-replace', function(e)
            {
                e.preventDefault();
                return;
            });

            $node.on('drop.drop-to-replace', function(e)
            {
                if (!self.app.isDragComponentInside())
                {
                    return self._setReplaceUpload(e, $node);
                }
            });
        });
    },
    _setFormData: function($modal, $form)
    {
        this._buildPreview();
        this._buildPreviewUpload();

        var imageData = this.$image.getData();
        var data = {
            title: imageData.title
        };

        // caption
        if (this.opts.imageCaption) data.caption = imageData.caption;
        else $modal.find('.form-item-caption').hide();

        // position
        if (this.opts.imagePosition) data.align = imageData.align;
        else $modal.find('.form-item-align').hide();

        // link
        if (this.opts.imageLink)
        {
            if (imageData.link)
            {
                data.url = imageData.link.url;
                if (imageData.link.target) data.target = true;
            }
        }
        else $modal.find('.form-item-link').hide();

        $form.setData(data);
    },
    _setFormFocus: function($form)
    {
        $form.getField('title').focus();
    },
    _setReplaceUpload: function(e, $node)
    {
        e = e.originalEvent || e;
        e.stopPropagation();
        e.preventDefault();

        if (!this.opts.imageUpload) return;

        this.$image = this.component.create('image', $node);

        var options = {
            url: this.opts.imageUpload,
            files: e.dataTransfer.files,
            name: 'imagereplace',
            data: this.opts.imageData,
            paramName: this.opts.imageUploadParam
        };

        this.app.api('module.upload.send', options);

        return;
    },
    _setUpload: function($modal, $form)
    {
        if (!this.opts.imageUpload) {
            var $body = $modal.getBody();
            var $tab = $body.find('.redactor-modal-tab-upload');
            $tab.remove();
        }

        var options = {
            url: this.opts.imageUpload,
            element: $form.getField('file'),
            name: 'image',
            data: this.opts.imageData,
            paramName: this.opts.imageUploadParam
        };

        this.app.api('module.upload.build', options);
    },
    _buildPreview: function()
    {
        this.$preview = $R.dom('#redactor-modal-image-preview');

        var imageData = this.$image.getData();
        var $previewImg = $R.dom('<img>');
        $previewImg.attr('src', imageData.src);

        this.$previewBox = $R.dom('<div>');
        this.$previewBox.append($previewImg);

        this.$preview.html('');
        this.$preview.append(this.$previewBox);
    },
    _buildPreviewUpload: function()
    {
        if (!this.opts.imageUpload) return;

        var $desc = $R.dom('<div class="desc">');
        $desc.html(this.lang.get('upload-change-label'));

        this.$preview.append($desc);

        var options = {
            url: this.opts.imageUpload,
            element: this.$previewBox,
            name: 'imageedit',
            data: this.opts.imageData,
            paramName: this.opts.imageUploadParam
        };

        this.app.api('module.upload.build', options);
    }
});
$R.add('class', 'image.component', {
    mixins: ['dom', 'component'],
    init: function(app, el)
    {
        this.app = app;
        this.opts = app.opts;
        this.selection = app.selection;

        // init
        return (el && el.cmnt !== undefined) ? el : this._init(el);
    },
    setData: function(data)
    {
        for (var name in data)
        {
            this._set(name, data[name]);
        }
    },
    getData: function()
    {
        var names = ['src', 'title', 'caption', 'align', 'link', 'id'];
        var data = {};

        for (var i = 0; i < names.length; i++)
        {
            data[names[i]] = this._get(names[i]);
        }

        return data;
    },
    getElement: function()
    {
        return this.$element;
    },
    changeImage: function(data)
    {
        this.$element.attr('src', data.url);
    },


    // private
    _init: function(el)
    {
        var $el = $R.dom(el);
        var $figure = $el.closest('figure');

        if (el === undefined)
        {
            this.$element = $R.dom('<img>');
            this.parse('<figure>');
            this.append(this.$element);
        }
        else if ($figure.length === 0)
        {
            this.parse('<figure>');
            this.$element = $el;
            this.$element.wrap(this);
        }
        else
        {
            this.parse($figure);
            this.$element = this.find('img');
        }

        this._initWrapper();
    },
    _set: function(name, value)
    {
        this['_set_' + name](value);
    },
    _get: function(name)
    {
        return this['_get_' + name]();
    },
    _set_src: function(src)
    {
       this.$element.attr('src', src);
    },
    _set_id: function(id)
    {
        if (this.opts.imageObserve) {
            this.$element.attr('data-image', id);
        }
    },
    _set_title: function(title)
    {
        title = title.trim().replace(/(<([^>]+)>)/ig,"");

        if (title === '')
        {
            this.$element.removeAttr('alt');
        }
        else
        {
            this.$element.attr('alt', title);
        }

    },
    _set_caption: function(caption)
    {
        var $figcaption = this.find('figcaption');
        if ($figcaption.length === 0)
        {
            $figcaption = $R.dom('<figcaption>');
            $figcaption.attr('contenteditable', 'true');

            this.append($figcaption);
        }

        if (caption === '') $figcaption.remove();
        else $figcaption.html(caption);

        return $figcaption;
    },
    _set_align: function(align)
    {
        var imageFloat = '';
        var imageMargin = '';
        var textAlign = '';
        var $el = this;
        var $img = this.find('img');
        var $figcaption = this.find('figcaption');

        if (typeof this.opts.imagePosition === 'object')
        {
            var positions = this.opts.imagePosition;
            for (var key in positions)
            {
                $el.removeClass(positions[key]);
            }

            var alignClass = (typeof positions[align] !== 'undefined') ? positions[align] : false;
            if (alignClass)
            {
                $el.addClass(alignClass);
            }
        }
        else
        {
            var width = $img.width();

            switch (align)
            {
                case 'left':
                    imageFloat = 'left';
                    imageMargin = '0 ' + this.opts.imageFloatMargin + ' ' + this.opts.imageFloatMargin + ' 0';
                break;
                case 'right':
                    imageFloat = 'right';
                    imageMargin = '0 0 ' + this.opts.imageFloatMargin + ' ' + this.opts.imageFloatMargin;
                break;
                case 'center':
                    textAlign = 'center';
                break;
            }

            $el.css({ 'float': imageFloat, width: width + 'px', maxWidth: width + 'px', 'margin': imageMargin, 'text-align': textAlign });
            $el.attr('rel', $el.attr('style'));

            if (align === 'none') {
                $el.css('max-width', '');
                $el.css('width', '');
            }

            if (align === 'center')
            {
                $el.css('max-width', '');
                $el.css('width', '');
                $figcaption.css('text-align', 'center');
            }
            else
            {
                $figcaption.css('text-align', '');
            }
        }
    },
    _set_link: function(data)
    {
        var $link = this._findLink();
        if (data.url === '')
        {
            if ($link) $link.unwrap();

            return;
        }

        if (!$link)
        {
            $link = $R.dom('<a>');
            this.$element.wrap($link);
        }

        $link.attr('href', data.url);

        if (data.target) $link.attr('target', (data.target === true) ? '_blank' : data.target);
        else $link.removeAttr('target');

        return $link;
    },
    _get_src: function()
    {
        return this.$element.attr('src');
    },
    _get_id: function()
    {
        return this.$element.attr('data-image');
    },
    _get_title: function()
    {
        var alt = this.$element.attr('alt');

        return (alt) ? alt : '';
    },
    _get_caption: function()
    {
        var $figcaption = this.find('figcaption');

        if ($figcaption.length === 0)
        {
            return '';
        }
        else
        {
            return $figcaption.html();
        }
    },
    _get_align: function()
    {
        var align = '';
        if (typeof this.opts.imagePosition === 'object')
        {
            align = 'none';
            var positions = this.opts.imagePosition;
            for (var key in positions)
            {
                if (this.hasClass(positions[key]))
                {
                    align = key;
                    break;
                }
            }
        }
        else
        {
            align = (this.css('text-align') === 'center') ? 'center' : this.css('float');
        }

        return align;
    },
    _get_link: function()
    {
        var $link = this._findLink();
        if ($link)
        {
            var target = ($link.attr('target')) ? true : false;

            return {
                url: $link.attr('href'),
                target: target
            };
        }
    },
    _initWrapper: function()
    {
        this.addClass('redactor-component');
        this.attr({
            'data-redactor-type': 'image',
            'tabindex': '-1',
            'contenteditable': false
        });
    },
    _findLink: function()
    {
        var $link = this.find('a').filter(function(node)
        {
            return ($R.dom(node).closest('figcaption').length === 0);
        });

        if ($link.length !== 0)
        {
            return $link;
        }

        return false;
    }
});
$R.add('class', 'image.resize', {
    init: function(app)
    {
        this.app = app;
        this.$doc = app.$doc;
        this.$win = app.$win;
        this.$body = app.$body;
        this.editor = app.editor;
        this.toolbar = app.toolbar;
        this.inspector = app.inspector;

        // init
        this.$target = (this.toolbar.isTarget()) ? this.toolbar.getTargetElement() : this.$body;
        this._init();
    },
    // public
    rebuild: function()
    {
        this._setResizerPosition();
    },
    hide: function()
    {
        this.$target.find('#redactor-image-resizer').remove();
    },
    stop: function()
    {
        var $editor = this.editor.getElement();
        $editor.off('.redactor.image-resize');

        this.$doc.off('.redactor.image-resize');
        this.$win.off('resize.redactor.image-resize');
        this.hide();
    },

    // private
    _init: function()
    {
        var $editor = this.editor.getElement();
        $editor.on('click.redactor.image-resize', this._build.bind(this));

        this.$win.on('resize.redactor.image-resize', this._setResizerPosition.bind(this));
    },
    _build: function(e)
    {
        this.$target.find('#redactor-image-resizer').remove();

        var data = this.inspector.parse(e.target);
        var $editor = this.editor.getElement();

        if (data.isComponentType('image'))
        {
            this.$resizableBox = $editor;
            this.$resizableImage = $R.dom(data.getImageElement());

            this.$resizer = $R.dom('<span>');
            this.$resizer.attr('id', 'redactor-image-resizer');

            this.$target.append(this.$resizer);

            this._setResizerPosition();
            this.$resizer.on('mousedown touchstart', this._set.bind(this));
        }
    },
    _setResizerPosition: function()
    {
        if (this.$resizer)
        {
            var isTarget = this.toolbar.isTarget();
            var targetOffset = this.$target.offset();
            var offsetFix = 7;
            var topOffset = (isTarget) ? (offsetFix - targetOffset.top + this.$target.scrollTop()) : offsetFix;
            var leftOffset = (isTarget) ? (offsetFix - targetOffset.left) : offsetFix;
            var pos = this.$resizableImage.offset();
            var width = this.$resizableImage.width();
            var height = this.$resizableImage.height();
            var resizerWidth =  this.$resizer.width();
            var resizerHeight =  this.$resizer.height();

            this.$resizer.css({ top: Math.round(pos.top + height - resizerHeight + topOffset) + 'px', left: Math.round(pos.left + width - resizerWidth + leftOffset) + 'px' });
        }
    },
    _set: function(e)
    {
        e.preventDefault();

        this.resizeHandle = {
            x : e.pageX,
            y : e.pageY,
            el : this.$resizableImage,
            $figure: this.$resizableImage.closest('figure'),
            ratio: this.$resizableImage.width() / this.$resizableImage.height(),
            h: this.$resizableImage.height()
        };

        e = e.originalEvent || e;

        if (e.targetTouches)
        {
             this.resizeHandle.x = e.targetTouches[0].pageX;
             this.resizeHandle.y = e.targetTouches[0].pageY;
        }

        this.app.broadcast('contextbar.close');
        this.app.broadcast('image.resize', this.$resizableImage);
        this._start();
    },
    _start: function()
    {
        this.$doc.on('mousemove.redactor.image-resize touchmove.redactor.image-resize', this._move.bind(this));
        this.$doc.on('mouseup.redactor.image-resize touchend.redactor.image-resize', this._stop.bind(this));
    },
    _stop: function()
    {
        this.$doc.off('.redactor.image-resize');
        this.app.broadcast('image.resized', this.$resizableImage);
    },
    _move: function(e)
    {
        e.preventDefault();

        e = e.originalEvent || e;

        var height = this.resizeHandle.h;

        if (e.targetTouches) height += (e.targetTouches[0].pageY -  this.resizeHandle.y);
        else height += (e.pageY -  this.resizeHandle.y);

        var width = height * this.resizeHandle.ratio;

        width = Math.round(width);
        height = Math.round(height);

        if (height < 20 || width < 100) return;
        if (this._getResizableBoxWidth() <= width) return;

        // Image Positioning doesn't work in Redactor with image resizing because of this figure CSS. Not even in their demo example: https://imperavi.com/redactor/examples/images-and-files/image-resizing-and-positioning/
        // if (this.resizeHandle.$figure.length !== 0 && this.resizeHandle.$figure.css('max-width') !== '') {
        //     this.resizeHandle.$figure.css('max-width', width + 'px');
        // }

        this.resizeHandle.el.attr({width: width, height: height});
        this.resizeHandle.el.width(width);
        this.resizeHandle.el.height(height);
        this._setResizerPosition();
    },
    _getResizableBoxWidth: function()
    {
        var width = this.$resizableBox.width();
        return width - parseInt(this.$resizableBox.css('padding-left')) - parseInt(this.$resizableBox.css('padding-right'));
    }
});
$R.add('module', 'file', {
    modals: {
        'file':
            '<div class="redactor-modal-tab" data-title="## upload ##"><form action=""> \
                <div class="form-item form-item-title"> \
                    <label for="modal-file-title"> ## filename ## <span class="desc">(## optional ##)</span></label> \
                    <input type="text" id="modal-file-title" name="title" /> \
                </div> \
                <input type="file" name="file"> \
            </form></div>'
    },
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.lang = app.lang;
        this.caret = app.caret;
        this.utils = app.utils;
        this.storage = app.storage;
        this.component = app.component;
        this.inspector = app.inspector;
        this.insertion = app.insertion;
        this.selection = app.selection;
    },
    // messages
    onstarted: function()
    {
        // storage observe
        this.storage.observeFiles();
    },
    ondropfile: function(e, files, clipboard)
    {
        if (!this.opts.fileUpload) return;

        var options = {
            url: this.opts.fileUpload,
            event: (clipboard) ? false : e,
            files: files,
            name: 'filedrop',
            data: this.opts.fileData
        };

        this.app.api('module.upload.send', options);
    },
    onmodal: {
        file: {
            open: function($modal, $form)
            {
                this._setFormData($modal, $form);
                this._setUpload($form);
            },
            opened: function($modal, $form)
            {
                this._setFormFocus($form);

                this.$form = $form;
            }
        }
    },
    onupload: {
        file: {
            complete: function(response)
            {
                this._insert(response);
            },
            error: function(response)
            {
                this._uploadError(response);
            }
        },
        filedrop: {
            complete: function(response, e)
            {
                this._insert(response, e);
            },
            error: function(response)
            {
                this._uploadError(response);
            }
        }
    },

    // public
    open: function()
    {
        this._open();
    },
    insert: function(data)
    {
        this._insert(data);
    },
    remove: function(node)
    {
        this._remove(node);
    },

    // private
    _open: function()
    {
        this.app.api('module.modal.build', this._getModalData());
    },
    _getModalData: function()
    {
        var modalData = {
            name: 'file',
            title: this.lang.get('file')
        };

        return modalData;
    },
    _insert: function(response, e)
    {
        this.app.api('module.modal.close');
        if (typeof response !== 'object') return;

        if (Array.isArray(response))
        {
            var obj = {};
            for (var i = 0; i < response.length; i++)
            {
                obj = $R.extend(obj, response[i]);
            }

            response = obj;
        }

        var multiple = (Object.keys(response).length  > 1);

        if (multiple)
        {
            this._insertMultiple(response, e);
        }
        else
        {
            this._insertSingle(response, e);
        }

        this.$form = false;
    },
    _insertSingle: function(response, e)
    {
        var inserted = [];
        for (var key in response)
        {
            var $file = this._createFileAndStore(response[key]);

            if (this.opts.fileAttachment)
            {
                inserted = this._insertAsAttachment($file);
            }
            else
            {
                inserted = (e) ? this.insertion.insertToPoint(e, $file) : this.insertion.insertRaw($file);
            }

            this.app.broadcast('file.uploaded', inserted[0], response);
        }
    },
    _insertMultiple: function(response, e)
    {
        var z = 0;
        var inserted = [];
        var $last;
        for (var key in response)
        {
            z++;

            var $file = this._createFileAndStore(response[key]);

            if (this.opts.fileAttachment)
            {
                inserted = this._insertAsAttachment($file, response);
            }
            else
            {
                if (z === 1)
                {
                    inserted = (e) ? this.insertion.insertToPoint(e, $file) : this.insertion.insertRaw($file);
                }
                else
                {
                    var $inserted = $R.dom(inserted[0]);
                    $inserted.after($file).after(' ');
                    inserted = [$file.get()];

                    this.app.broadcast('file.inserted', $file);
                }
            }

            $last = $file;
            this.app.broadcast('file.uploaded', inserted[0], response);
        }

        // set caret after last
        if (!this.opts.fileAttachment)
        {
            this.caret.setAfter($last);
        }
    },
    _insertAsAttachment: function($file, response)
    {
        var $box = $R.dom(this.opts.fileAttachment);
        var $wrapper = $file.wrapAttachment();
        $box.append($wrapper);

        var inserted = [$wrapper.get()];
        this.app.broadcast('file.appended', inserted[0], response);

        return inserted;
    },
    _createFileAndStore: function(item)
    {
        var modalFormData = (this.$form) ? this.$form.getData() : false;
        var name = (item.name) ? item.name : item.url;
        var title = (!this.opts.fileAttachment && modalFormData && modalFormData.title !== '') ? modalFormData.title : this._truncateUrl(name);

        var $file = this.component.create('file');
        $file.attr('href', item.url);
        $file.attr('data-file', (item.id) ? item.id : this.utils.getRandomId());
        $file.attr('data-name', item.name);
        $file.html(title);

        // add to storage
        this.storage.add('file', $file);

        return $file;
    },
    _remove: function(node)
    {
        this.selection.save();

        var $file = this.component.create('file', node);
        var stop = this.app.broadcast('file.delete', $file);
        if (stop !== false)
        {
            $file.unwrap();

            this.selection.restore();

            // callback
            this.app.broadcast('file.deleted', $file);
        }
        else
        {
            this.selection.restore();
        }
    },
    _truncateUrl: function(url)
    {
        return (url.search(/^http/) !== -1 && url.length > 20) ? url.substring(0, 20) + '...' : url;
    },
    _setUpload: function($form)
    {
        var options = {
            url: this.opts.fileUpload,
            element: $form.getField('file'),
            name: 'file',
            data: this.opts.fileData,
            paramName: this.opts.fileUploadParam
        };

        this.app.api('module.upload.build', options);
    },
    _setFormData: function($modal, $form)
    {
        if (this.opts.fileAttachment)
        {
            $modal.find('.form-item-title').hide();
        }
        else
        {
            $form.setData({ title: this.selection.getText() });
        }
    },
    _setFormFocus: function($form)
    {
        $form.getField('title').focus();
    },
    _uploadError: function(response)
    {
        this.app.broadcast('file.uploadError', response);
    }
});
$R.add('class', 'file.component', {
    mixins: ['dom', 'component'],
    init: function(app, el)
    {
        this.app = app;
        this.opts = app.opts;

        // init
        return (el && el.cmnt !== undefined) ? el : this._init(el);
    },
    wrapAttachment: function()
    {
        this.$wrapper = $R.dom('<span class="redactor-file-item">');
        this.$remover = $R.dom('<span class="redactor-file-remover">');
        this.$remover.html('&times;');
        this.$remover.on('click', this.removeAttachment.bind(this));

        this.$wrapper.append(this);
        this.$wrapper.append(this.$remover);

        return this.$wrapper;
    },
    removeAttachment: function(e)
    {
        e.preventDefault();

        var stop = this.app.broadcast('file.delete', this, this.$wrapper);
        if (stop !== false)
        {
            this.$wrapper.remove();
            this.app.broadcast('file.deleted', this);
            this.app.broadcast('file.removeAttachment', this);
        }
    },

    // private
    _init: function(el)
    {
        if (el === undefined)
        {
            this.parse('<a>');
        }
        else
        {
            var $a = $R.dom(el).closest('a');
            this.parse($a);
        }
    }
});
$R.add('module', 'buffer', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.editor = app.editor;
        this.offset = app.offset;
        this.keycodes = app.keycodes;
        this.selection = app.selection;

        // local
        this.state = false;
        this.passed = false;
        this.keyPressed = false;
        this.undoStorage = [];
        this.redoStorage = [];
    },
    // messages
    onkeydown: function(e)
    {
        this._listen(e);
    },
    onsyncing: function()
    {
        if (!this.keyPressed)
        {
            this.trigger();
        }

        this.keyPressed = false;
    },
    onbuffer: {
        trigger: function()
        {
            this.trigger();
        }
    },
    onstate: function(e, html, offset)
    {
        if ((e && (e.ctrlKey || e.metaKey)) || (e && (this._isUndo(e) || this._isRedo(e))))
        {
            return;
        }

        this.passed = false;
        this._saveState(html, offset);
    },
    onenable: function()
    {
        this.clear();
    },

    // public
    clear: function()
    {
        this.state = false;
        this.undoStorage = [];
        this.redoStorage = [];
    },
    undo: function()
    {
        this._getUndo();
    },
    redo: function()
    {
        this._getRedo();
    },
    trigger: function()
    {
        if (this.state && this.passed === false) this._setUndo();
    },

    // private
    _saveState: function(html, offset)
    {
        var $editor = this.editor.getElement();

        this.state = {
            html: html || $editor.html(),
            offset: offset || this.offset.get()
        };
    },
    _listen: function(e)
    {
        var key = e.which;
        var ctrl = e.ctrlKey || e.metaKey;
        var cmd = ctrl || e.shiftKey || e.altKey;
        var keys = [this.keycodes.SPACE, this.keycodes.ENTER, this.keycodes.BACKSPACE, this.keycodes.DELETE, this.keycodes.TAB,
                    this.keycodes.LEFT, this.keycodes.RIGHT, this.keycodes.UP, this.keycodes.DOWN];
        // undo
        if (this._isUndo(e)) // z key
        {
            e.preventDefault();
            this.undo();
            return;
        }
        // redo
        else if (this._isRedo(e))
        {
            e.preventDefault();
            this.redo();
            return;
        }
        // spec keys
        else if (!ctrl && keys.indexOf(key) !== -1)
        {
            cmd = true;
            this.trigger();
        }
        // cut & copy
        else if (ctrl && (key === 88 || key === 67))
        {
            cmd = true;
            this.trigger();
        }


        // empty buffer
        if (!cmd && !this._hasUndo())
        {
            this.trigger();
        }

        this.keyPressed = true;
    },
    _isUndo: function(e)
    {
        var key = e.which;
        var ctrl = e.ctrlKey || e.metaKey;

        return (ctrl && key === 90 && !e.shiftKey && !e.altKey);
    },
    _isRedo: function(e)
    {
        var key = e.which;
        var ctrl = e.ctrlKey || e.metaKey;

        return (ctrl && (key === 90 && e.shiftKey || key === 89 && !e.shiftKey) && !e.altKey);
    },
    _setUndo: function()
    {
        var last = this.undoStorage[this.undoStorage.length-1];
        if (typeof last === 'undefined' || last[0] !== this.state.html)
        {
            this.undoStorage.push([this.state.html, this.state.offset]);
            this._removeOverStorage();
        }
    },
    _setRedo: function()
    {
        var $editor = this.editor.getElement();
        var offset = this.offset.get();
        var html = $editor.html();

        this.redoStorage.push([html, offset]);
        this.redoStorage = this.redoStorage.slice(0, this.opts.bufferLimit);
    },
    _getUndo: function()
    {
        if (!this._hasUndo()) return;

        this.passed = true;

        var $editor = this.editor.getElement();
        var buffer = this.undoStorage.pop();

        this._setRedo();

        $editor.html(buffer[0]);
        this.offset.set(buffer[1]);
        this.selection.restore();

        this.app.broadcast('undo', buffer[0], buffer[1]);

    },
    _getRedo: function()
    {
        if (!this._hasRedo()) return;

        this.passed = true;

        var $editor = this.editor.getElement();
        var buffer = this.redoStorage.pop();

        this._setUndo();
        $editor.html(buffer[0]);
        this.offset.set(buffer[1]);

        this.app.broadcast('redo', buffer[0], buffer[1]);
    },
    _removeOverStorage: function()
    {
        if (this.undoStorage.length > this.opts.bufferLimit)
        {
            this.undoStorage = this.undoStorage.slice(0, (this.undoStorage.length - this.opts.bufferLimit));
        }
    },
    _hasUndo: function()
    {
        return (this.undoStorage.length !== 0);
    },
    _hasRedo: function()
    {
        return (this.redoStorage.length !== 0);
    }
});
$R.add('module', 'list', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.utils = app.utils;
        this.block = app.block;
        this.toolbar = app.toolbar;
        this.inspector = app.inspector;
        this.selection = app.selection;
    },
    // messages
    onbutton: {
        list: {
            observe: function(button)
            {
                this._observeButton(button);
            }
        }
    },
    ondropdown: {
        list: {
            observe: function(dropdown)
            {
                this._observeDropdown(dropdown);
            }
        }
    },

    // public
    toggle: function(type)
    {
        var nodes = this._getBlocks();
        var block = this.selection.getBlock();
        var $list = $R.dom(block).parents('ul, ol',  '.redactor-in').last();
        if (nodes.length === 0 && $list.length !== 0)
        {
            nodes = [$list.get()];
        }

        if (block && (block.tagName === 'TD' || block.tagName === 'TH'))
        {
            nodes = this.block.format('div');
        }

        this.selection.saveMarkers();

        nodes = (nodes.length !== 0 && this._isUnformat(type, nodes)) ? this._unformat(type, nodes) : this._format(type, nodes);

        this.selection.restoreMarkers();

        return nodes;
    },
    indent: function()
    {
        var isCollapsed = this.selection.isCollapsed();
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var item = (data.isList()) ? data.getListItem() : false;
        var $item = $R.dom(item);
        var $prev = $item.prevElement();
        var prev = $prev.get();
        var isIndent = (isCollapsed && item && prev && prev.tagName === 'LI');

        if (isIndent)
        {
            this.selection.saveMarkers();

            $prev = $R.dom(prev);
            var $prevChild = $prev.children('ul, ol');
            var $list = $item.closest('ul, ol');

            if ($prevChild.length !== 0)
            {
                $prevChild.append($item);
            }
            else
            {
                var listTag = $list.get().tagName.toLowerCase();
                var $newList = $R.dom('<' + listTag + '>');

                $newList.append($item);
                $prev.append($newList);
            }

            this.selection.restoreMarkers();
        }
    },
    outdent: function()
    {
        var isCollapsed = this.selection.isCollapsed();
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var item = (data.isList()) ? data.getListItem() : false;
        var $item = $R.dom(item);

        if (isCollapsed && item)
        {

            var $listItem = $item.parent();
            var $liItem = $listItem.closest('li', '.redactor-in');
            var $prev = $item.prevElement();
            var $next = $item.nextElement();
            var prev = $prev.get();
            var next = $next.get();
            var nextItems, nextList, $newList, $nextList;
            var isTop = (prev === false);
            var isMiddle = (prev !== false && next !== false);
            var isBottom = (!isTop && next === false);

            this.selection.saveMarkers();

            // out
            if ($liItem.length !== 0)
            {
                if (isMiddle)
                {
                    nextItems = this._getAllNext($item.get());
                    $newList = $R.dom('<' + $listItem.get().tagName.toLowerCase() + '>');

                    for (var i = 0; i < nextItems.length; i++)
                    {
                        $newList.append(nextItems[i]);
                    }

                    $liItem.after($item);
                    $item.append($newList);
                }
                else
                {
                    $liItem.after($item);

                    if ($listItem.children().length === 0)
                    {
                        $listItem.remove();
                    }
                    else
                    {
                        if (isTop) $item.append($listItem);
                    }
                }
            }
            // unformat
            else
            {
                var $container =  this._createUnformatContainer($item);
                var $childList = $container.find('ul, ol').first();

                if (isTop) $listItem.before($container);
                else if (isBottom) $listItem.after($container);
                else if (isMiddle)
                {
                    $newList = $R.dom('<' + $listItem.get().tagName.toLowerCase() + '>');
                    nextItems = this._getAllNext($item.get());

                    for (var i = 0; i < nextItems.length; i++)
                    {
                        $newList.append(nextItems[i]);
                    }

                    $listItem.after($container);
                    $container.after($newList);
                }

                if ($childList.length !== 0)
                {
                    $nextList = $container.nextElement();
                    nextList = $nextList.get();
                    if (nextList && nextList.tagName === $listItem.get().tagName)
                    {
                        $R.dom(nextList).prepend($childList);
                        $childList.unwrap();
                    }
                    else
                    {
                        $container.after($childList);
                    }
                }

                $item.remove();
            }

            this.selection.restoreMarkers();
        }
    },

    // private
    _getAllNext: function(next)
    {
        var nodes = [];

        while (next)
        {
            var $next = $R.dom(next).nextElement();
            next = $next.get();

            if (next) nodes.push(next);
            else return nodes;
        }

        return nodes;
    },
    _isUnformat: function(type, nodes)
    {
        var countLists = 0;
        for (var i = 0; i < nodes.length; i++)
        {
            if (nodes[i].nodeType !== 3)
            {
                var tag = nodes[i].tagName.toLowerCase();
                if (tag === type || tag === 'figure')
                {
                    countLists++;
                }
            }
        }

        return (countLists === nodes.length);
    },
    _format: function(type, nodes)
    {
        var tags = ['p', 'div', 'blockquote', 'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol'];
        var blocks = this._uniteBlocks(nodes, tags);
        var lists = [];

        for (var key in blocks)
        {
            var items = blocks[key];
            var $list = this._createList(type, blocks[key]);

            for (var i = 0; i < items.length; i++)
            {
                var $item;

                // lists
                if (items[i].nodeType !== 3 && (items[i].tagName === 'UL' || items[i].tagName === 'OL'))
                {
                    var $oldList = $R.dom(items[i]);

                    $item = $oldList.contents();
                    $list.append($item);

                    // old is empty
                    if (this.utils.isEmpty($oldList)) $oldList.remove();
                }
                // other blocks or texts
                else
                {
                    $item = this._createListItem(items[i]);
                    this.utils.normalizeTextNodes($item);
                    $list.append($item);
                }
            }

            lists.push($list.get());
        }

        return lists;
    },
    _uniteBlocks: function(nodes, tags)
    {
        var z = 0;
        var blocks = { 0: [] };
        var lastcell = false;
        for (var i = 0; i < nodes.length; i++)
        {
            var $node = $R.dom(nodes[i]);
            var $cell = $node.closest('th, td');

            if ($cell.length !== 0)
            {
                if ($cell.get() !== lastcell)
                {
                    // create block
                    z++;
                    blocks[z] = [];
                }

                if (this._isUniteBlock(nodes[i], tags))
                {
                    blocks[z].push(nodes[i]);
                }
            }
            else
            {
                if (this._isUniteBlock(nodes[i], tags))
                {
                    blocks[z].push(nodes[i]);
                }
                else
                {
                    // create block
                    z++;
                    blocks[z] = [];
                }
            }

            lastcell = $cell.get();
        }

        return blocks;
    },
    _isUniteBlock: function(node, tags)
    {
        return (node.nodeType === 3 || tags.indexOf(node.tagName.toLowerCase()) !== -1);
    },
    _createList: function(type, blocks)
    {
        var last = blocks[blocks.length-1];
        var $last = $R.dom(last);
        var $list = $R.dom('<' + type + '>');
        $last.after($list);

        return $list;
    },
    _createListItem: function(item)
    {
        var $item = $R.dom('<li>');
        if (item.nodeType === 3)
        {
            $item.append(item);
        }
        else
        {
            var $el = $R.dom(item);
            $item.append($el.contents());
            $el.remove();
        }

        return $item;
    },
    _unformat: function(type, nodes)
    {
        if (nodes.length === 1)
        {
            // one list
            var $list = $R.dom(nodes[0]);
            var $items = $list.find('li');

            var selectedItems = this.selection.getNodes({ tags: ['li'] });
            var block = this.selection.getBlock();
            var $li = $R.dom(block).closest('li');
            if (selectedItems.length === 0 && $li.length !== 0)
            {
                selectedItems = [$li.get()];
            }


            // 1) entire
            if (selectedItems.length === $items.length)
            {
                return this._unformatEntire(nodes[0]);
            }

            var pos = this._getItemsPosition($items, selectedItems);

            // 2) top
            if (pos === 'Top')
            {
                return this._unformatAtSide('before', selectedItems, $list);
            }

            // 3) bottom
            else if (pos === 'Bottom')
            {
                selectedItems.reverse();
                return this._unformatAtSide('after', selectedItems, $list);
            }

            // 4) middle
            else if (pos === 'Middle')
            {
                var $last = $R.dom(selectedItems[selectedItems.length-1]);

                var ci = false;

                var $parent = false;
                var $secondList = $R.dom('<' + $list.get().tagName.toLowerCase() + '>');
                $items.each(function(node)
                {
                    if (ci)
                    {
                        var $node = $R.dom(node);
                        if ($node.closest('.redactor-split-item').length === 0 && ($parent === false || $node.closest($parent).length === 0))
                        {
                            $node.addClass('redactor-split-item');
                        }

                        $parent = $node;
                    }

                    if (node === $last.get())
                    {
                        ci = true;
                    }
                });

                $items.filter('.redactor-split-item').each(function(node)
                {
                    var $node = $R.dom(node);
                    $node.removeClass('redactor-split-item');
                    $secondList.append(node);
                });

                $list.after($secondList);

                selectedItems.reverse();
                for (var i = 0; i < selectedItems.length; i++)
                {
                    var $item = $R.dom(selectedItems[i]);
                    var $container = this._createUnformatContainer($item);

                    $list.after($container);
                    $container.find('ul, ol').remove();
                    $item.remove();
                }


                return;
            }

        }
        else
        {
            // unformat all
            for (var i = 0; i < nodes.length; i++)
            {
                if (nodes[i].nodeType !== 3 && nodes[i].tagName.toLowerCase() === type)
                {
                    this._unformatEntire(nodes[i]);
                }
            }
        }
    },
    _unformatEntire: function(list)
    {
        var $list = $R.dom(list);
        var $items = $list.find('li');
        $items.each(function(node)
        {
            var $item = $R.dom(node);
            var $container = this._createUnformatContainer($item);

            $item.remove();
            $list.before($container);

        }.bind(this));

        $list.remove();
    },
    _unformatAtSide: function(type, selectedItems, $list)
    {
        for (var i = 0; i < selectedItems.length; i++)
        {
            var $item = $R.dom(selectedItems[i]);
            var $container = this._createUnformatContainer($item);

            $list[type]($container);

            var $innerLists = $container.find('ul, ol').first();
            $item.append($innerLists);

            $innerLists.each(function(node)
            {
                var $node = $R.dom(node);
                var $parent = $node.closest('li');

                if ($parent.get() === selectedItems[i])
                {
                    $node.unwrap();
                    $parent.addClass('r-unwrapped');
                }

            });

            if (this.utils.isEmptyHtml($item.html())) $item.remove();
        }

        // clear empty
        $list.find('.r-unwrapped').each(function(node)
        {
            var $node = $R.dom(node);
            if ($node.html().trim() === '') $node.remove();
            else $node.removeClass('r-unwrapped');
        });
    },
    _getItemsPosition: function($items, selectedItems)
    {
        var pos = 'Middle';

        var sFirst = selectedItems[0];
        var sLast = selectedItems[selectedItems.length-1];

        var first = $items.first().get();
        var last = $items.last().get();

        if (first === sFirst && last !== sLast)
        {
            pos = 'Top';
        }
        else if (first !== sFirst && last === sLast)
        {
            pos = 'Bottom';
        }

        return pos;
    },
    _createUnformatContainer: function($item)
    {
        var $container = $R.dom('<' + this.opts.markup + '>');
        if (this.opts.breakline) $container.attr('data-redactor-tag', 'br');

        $container.append($item.contents());

        return $container;
    },
    _getBlocks: function()
    {
        return this.selection.getBlocks({ first: true });
    },
    _observeButton: function()
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var isDisabled = (data.isPre() || data.isCode() || data.isFigcaption());

        this._observeButtonsList(isDisabled, ['lists', 'ul', 'ol', 'outdent', 'indent']);

        var itemOutdent = this.toolbar.getButton('outdent');
        var itemIndent = this.toolbar.getButton('indent');

        this._observeIndent(itemIndent, itemOutdent);
    },
    _observeDropdown: function(dropdown)
    {
        var itemOutdent = dropdown.getItem('outdent');
        var itemIndent = dropdown.getItem('indent');

        this._observeIndent(itemIndent, itemOutdent);
    },
    _observeIndent: function(itemIndent, itemOutdent)
    {
        var isCollapsed = this.selection.isCollapsed();
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var item = (data.isList()) ? data.getListItem() : false;
        var $item = $R.dom(item);
        var $prev = $item.prevElement();
        var prev = $prev.get();
        var isIndent = (isCollapsed && item && prev && prev.tagName === 'LI');

        if (itemOutdent)
        {
            if (item && isCollapsed) itemOutdent.enable();
            else itemOutdent.disable();
        }

        if (itemIndent)
        {
            if (item && isIndent) itemIndent.enable();
            else itemIndent.disable();
        }
    },
    _observeButtonsList: function(param, buttons)
    {
        for (var i = 0; i < buttons.length; i++)
        {
            var button = this.toolbar.getButton(buttons[i]);
            if (button)
            {
                if (param) button.disable();
                else button.enable();
            }
        }
    }
});
$R.add('class', 'video.component', {
    mixins: ['dom', 'component'],
    init: function(app, el)
    {
        this.app = app;

        // init
        return (el && el.cmnt !== undefined) ? el : this._init(el);
    },

    // private
    _init: function(el)
    {
        if (typeof el !== 'undefined')
        {
            var $node = $R.dom(el);
            var $wrapper = $node.closest('figure');
            if ($wrapper.length !== 0)
            {
                this.parse($wrapper);
            }
            else
            {
                this.parse('<figure>');
                this.append(el);
            }
        }
        else
        {
            this.parse('<figure>');
        }


        this._initWrapper();
    },
    _initWrapper: function()
    {
        this.addClass('redactor-component');
        this.attr({
            'data-redactor-type': 'video',
            'tabindex': '-1',
            'contenteditable': false
        });
    }
});

$R.add('class', 'widget.component', {
    mixins: ['dom', 'component'],
    init: function(app, el)
    {
        this.app = app;

        // init
        return (el && el.cmnt !== undefined) ? el : this._init(el);
    },
    getData: function()
    {
        return {
            html: this._getHtml()
        };
    },

    // private
    _init: function(el)
    {
        if (typeof el !== 'undefined')
        {
            var $node = $R.dom(el);
            var $figure = $node.closest('figure');
            if ($figure.length !== 0)
            {
                this.parse($figure);
            }
            else
            {
                this.parse('<figure>');
                this.html(el);
            }
        }
        else
        {
            this.parse('<figure>');
        }


        this._initWrapper();
    },
    _getHtml: function()
    {
        var $wrapper = $R.dom('<div>');
        $wrapper.html(this.html());
        $wrapper.find('.redactor-component-caret').remove();

        return $wrapper.html();
    },
    _initWrapper: function()
    {
        this.addClass('redactor-component');
        this.attr({
            'data-redactor-type': 'widget',
            'tabindex': '-1',
            'contenteditable': false
        });
    }
});

    window.Redactor = window.$R = $R;

    // Data attribute load
    window.addEventListener('load', function()
    {
        $R('[data-redactor]');
    });

}());

},{}],274:[function(require,module,exports){
require('../_services/jobs.service.js');

var jobsComponent = {
  controller: jobsComponentController,
  templateUrl: '/shared/jobs/jobs.html',
  bindings: {
    jobInsights: '<jobInsights',
    groupId: '<groupId',
    mode: '<?',
    onJobs: '&?',
    hidden: '<?',

  },
};

jobsComponentController.$inject = ['$filter', 'jobsService', '_', '$scope'];
function jobsComponentController($filter, jobsService, _, $scope) {
  var ctrl = this;
  ctrl.$onInit = function(){
    $scope.$watch(
      function() { return ctrl.jobInsights; },
      function(newValue, oldValue) { $onChanges(); }, true);
  };

  ctrl.setCountry = setCountry;

  ctrl.country = null;
  ctrl.employers = null;
  ctrl.maxEmployerCount = 0;
  ctrl.maxTitleCount = 0;
  ctrl.averageSalary = 0;
  ctrl.jobCount = 0;
  ctrl.location = 'your location';
  ctrl.direction = '';
  ctrl.titles = [];
  ctrl.supportedCountries = {
    au: { name:'Australia', domain: 'https://www.adzuna.com.au', currency: 'aud' },
    at: { name:'Austria', domain: 'https://www.adzuna.at', currency: 'eur' },
    br: { name:'Brazil', domain: 'https://www.adzuna.com.br', currency: 'brl' },
    ca: { name:'Canada', domain: 'https://www.adzuna.ca', currency: 'cad' },
    fr: { name:'France', domain: 'https://www.adzuna.fr', currency: 'eur' },
    de: { name:'Germany', domain: 'https://www.adzuna.de', currency: 'eur' },
    in: { name:'India', domain: 'https://www.adzuna.in', currency: 'inr' },
    it: { name:'Italy', domain: 'https://www.adzuna.it', currency: 'eur' },
    nl: { name:'Netherlands', domain: 'https://www.adzuna.nl', currency: 'eur' },
    nz: { name:'New Zealand', domain: 'https://www.adzuna.co.nz', currency: 'nzd' },
    pl: { name:'Poland', domain: 'https://www.adzuna.pl', currency: 'pln' },
    ru: { name:'Russian Federation', domain: 'https://www.adzuna.ru', currency: 'rub' },
    sg: { name:'Singapore', domain: 'https://www.adzuna.sg', currency: 'sgd' },
    za: { name:'South Africa', domain: 'https://www.adzuna.co.za', currency: 'zar' },
    gb: { name:'United Kingdom', domain: 'https://www.adzuna.co.uk', currency: 'gbp' },
    us: { name:'United States', domain: 'https://www.adzuna.com', currency: 'usd' },
  };
  ctrl.countryList = Object.keys(ctrl.supportedCountries).map(function(countryCode) {
    var countryData = ctrl.supportedCountries[countryCode];
    countryData['code'] = countryCode;
    return countryData;
  });
  ctrl.doughnutLabels = [];
  ctrl.doughnutData = [];

  ctrl.salaryGraph = {
    data: [],
    labels: [],
    colors: {
      backgroundColor: 'rgba(90,90,90, 0.05)',
      borderColor: '#22257c',
      hoverBackgroundColor: '#ff0000'
    },
    options: {
      type: 'line',
      maintainAspectRatio: false,
      responsive: true,
      elements:{
        point:{
          radius: 4,
          borderWidth: 3,
        }
      },
      tooltips: {
        mode: 'single',
        callbacks: {
          label: function (tooltipItem, info) {
            return tooltipItem['yLabel'];
          },
          afterBody: function (info) {
            // can send custom string to be displayed after label
            return [''];
          }
        }
      }
    }
  };
  ctrl.titlesGraph = {
    data: [],
    labels: [],
    colors: {
      backgroundColor: [
        '#22257c',
        '#005e56',
        '#007a4d',
        '#589232',
        '#ffa600',
        '#949494'
      ],
      // borderColor: 'rgb(255, 255, 0)',
      hoverBackgroundColor: [
        '#427076',
        '#418680',
        '#409b79',
        '#82ad65',
        '#febd40',
        '#afafaf'
      ]
    },
    options: {
      maintainAspectRatio: false,
      responsive: true,
      elements:{
        //
      },
      tooltips: {
        mode: 'single',
        callbacks: {
          label: function (tooltipItem, info) {
            return ctrl.titlesGraph.labels[tooltipItem.index];
          },
          afterBody: function (info) {
            // can send custom string to be displayed after label
            return [''];
          }
        }
      }
    }
  };

  ctrl.cleanHtml = function (text){
    return text.replace(/<[^>]+>/g, '');
  };


  // NOTE: Requires WIP data
  ctrl.lastMonthAvgChange = function (){
    if(Object.keys(ctrl.salaryHistory).length === 0 || ctrl.averageSalary === 0 ) { return; }
    var salaryValues = Object.values(ctrl.salaryHistory);
    var length = salaryValues.length;
    var change = (ctrl.averageSalary - salaryValues[ length - 1]) /  salaryValues[ length - 1];
    if (change > 0 )  { ctrl.direction = 'up'; }
    if (change < 0 )  { ctrl.direction = 'down'; }
    if (change === 0 )  { ctrl.direction = ''; }
    ctrl.lastMonthAvgChange = change.toFixed(2);
  }

  function resetValues(){
    ctrl.maxTitleCount = 0;
    ctrl.titles = [];
    ctrl.maxEmployerCount = 0;
    ctrl.employers = [];
    ctrl.jobCount = 0;
    ctrl.lastMonthAvgChange = 0;
    ctrl.averageSalary = 0;
    ctrl.salaryHistory = {};
    ctrl.loading = 3;
  }

  function $onChanges(/* changes */) {
    ctrl.displayJobInsights = ctrl.jobInsights && !_.isEmpty(ctrl.jobInsights) && ctrl.jobInsights.main_skill;
    if (ctrl.displayJobInsights) {
      resetValues();
      jobsService.top5Companies(ctrl.jobInsights, ctrl.groupId, ctrl.country).then(function(response){
        ctrl.country = response.country_code;
        ctrl.location = response.location;
        if (response.data.leaderboard){
          ctrl.employers = response.data.leaderboard;
          ctrl.employers = ctrl.employers.sort(function(a,b) {return (a.count > b.count) ? -1 : ((b.count > a.count) ? 1 : 0);}).slice(0, 5);
          ctrl.maxEmployerCount = Math.max.apply(0, ctrl.employers.map(function(employer) { return employer.count; }));
        }else{
          ctrl.employers = [];
          ctrl.maxEmployerCount = 0;
        }
        ctrl.adzunaDomain = ctrl.supportedCountries[response.country_code].domain;
        --ctrl.loading;
      });
      jobsService.history(ctrl.jobInsights, ctrl.groupId, ctrl.country).then(function(response){
        ctrl.country = response.country_code;
        ctrl.location = response.location;
        var sortedSalaries = {};
        if(response.data.month){
          Object.keys(response.data.month)
            .sort(function(a,b) { return a > b ? 1 : -1; })
            .map(function(key) { sortedSalaries[key] = response.data.month[key]; });
          ctrl.salaryHistory = sortedSalaries;
          ctrl.salaryGraph.data = Object.values(sortedSalaries);
          ctrl.salaryGraph.labels = Object.keys(sortedSalaries);
        }else{
          ctrl.salaryHistory = {};
          ctrl.salaryGraph.data = [];
          ctrl.salaryGraph.labels = [];
        }
        ctrl.salaryHistoryExists = ctrl.salaryGraph.data.length > 0;
        ctrl.adzunaDomain = ctrl.supportedCountries[response.country_code].domain;
        --ctrl.loading;
      });
      jobsService.search(ctrl.jobInsights, ctrl.groupId, ctrl.country).then(function(response){
        ctrl.country = response.country_code;
        ctrl.location = response.location;
        if (response.data.results[0]) {
          ctrl.maxTitleCount = response.data.results[0][1];
          ctrl.titles = response.data.results.slice(0, 5);
          var titles = ctrl.titles.map(function(item) { return ctrl.cleanHtml(item[0]); });
          titles.push('others');
          var values = ctrl.titles.map(function(item) { return item[1]; });
          values.push(100.0 - values.reduce(function(a, b) { return a + b; }));
          ctrl.titlesGraph.data = values;
          ctrl.titlesGraph.labels = titles;
        }else{
          ctrl.maxTitleCount = 0;
          ctrl.titles = [];
          ctrl.titlesGraph.data = [];
          ctrl.titlesGraph.labels = [];
        }
        ctrl.jobCount = response.data.count;
        ctrl.averageSalary = response.data.mean || 0;
        ctrl.adzunaDomain = ctrl.supportedCountries[response.country_code].domain;
        ctrl.onJobs({ $event: { jobCount: ctrl.jobCount } });
        --ctrl.loading;
      });
    }
  }

  function setCountry(country) {
    ctrl.country = country;
    $onChanges();
  }
}

angular
  .module('app')
  .component('jobs', jobsComponent);

},{"../_services/jobs.service.js":170}],275:[function(require,module,exports){
/** LINK FILTER COMPONENT
 *
 *    <link-filter target="my-menu" placeholder="Search Framework"></link-filter>
 *    <any-element id="my-menu">
 *      <a href="#anchor-link-a">Anchor Link a</a>
 *      <a href="#anchor-link-b">Anchor Link b</a>
 *      <a href="#anchor-link-c">Anchor Link c</a>
 *    </any-element>
 *
 *    @author   David "oodavid" King
 */
var linkFilterComponent = {
  controller: linkFilterComponentController,
  bindings: {
    target: '@',
    placeholder: '@',
  },
  templateUrl: '/shared/link-filter/link-filter.html',
};

linkFilterComponentController.$inject = ['$timeout', '$element'];
function linkFilterComponentController($timeout, $element) {
  var ctrl = this;
  ctrl.search;
  ctrl.doSearch = doSearch;
  ctrl.clearSearch = clearSearch;
  ctrl.handleKeyDown = handleKeyDown;

  var sections = [];
  var matches = [];
  var bestMatch;

  // Populating the data
  function populateSearchOnce(){
    if(sections.length){
      return;
    }
    // Get a list of all hash links
    var links = $('#'+ctrl.target+' a[href^="#"]');
    // Get the `text` value for each link
    sections.length = 0;
    links.each(function(linkIndex, linkElement){
      // Basic structure
      var data = {
        link: linkElement,
        fragments: []
      };
      // Add the link text
      data.fragments.push({
        text: $(linkElement).text().toLowerCase(),
        weight: 20,
      });
      // Scan the target content
      var targetId = $(linkElement).attr('href'); // This is naturally a CSS `#id` selector
      var $targetElement = $(targetId);
      if($targetElement.length){
        // Add all titles
        $targetElement.find('h1, h2, h3, h4, h5, h6').each(function(childIndex, childElement){
          data.fragments.push({
            text: childElement.textContent.toLowerCase(),
            weight: (10-parseInt(childElement.tagName.substr(1))), // h1 = 9, h6 = 4
          });
        });
        // Add all input values
        $targetElement.find(':input').each(function(childIndex, childElement){
          data.fragments.push({
            text: ($(childElement).val() || '').toLowerCase(),
            weight: 8,
          });
        });
        // Add all text (yes, we'll have duplicates from the titles above, but that's OK)
        data.fragments.push({
          text: $targetElement[0].textContent.toLowerCase(),
          weight: 1,
        });
      }
      // Add to the main array
      sections.push(data);
    });
  }


  function doSearch(){
    // Remove previous highlights
    $('#'+ctrl.target).removeClass('link-filter');
    for(var s=0,sl=sections.length; s<sl; s++){
      var section = sections[s];
      $(section.link).removeClass('match best-match no-match');
    }
    // Must have a value
    filterValue = ctrl.search.toLowerCase();
    if(!filterValue || !filterValue.length){
      return;
    }
    // Populate the search object
    populateSearchOnce();
    // Reset
    matches.length = 0;
    bestMatch = false;
    // Modify the target menu
    $('#'+ctrl.target).addClass('link-filter');
    // Search
    for(var s=0,sl=sections.length; s<sl; s++){
      var section = sections[s];
      var match = {
        weight: 0,
        link: section.link,
      }
      for(var f=0,fl=section.fragments.length; f<fl; f++){
        var fragment = section.fragments[f];
        if(fragment.text.indexOf(filterValue) > -1){
          match.weight += fragment.weight;
        }
      }
      if(match.weight > 0){
        $(section.link).addClass('match');
        matches.push(match);
        if(!bestMatch || match.weight > bestMatch.weight){
          bestMatch = match;
        }
      } else {
        $(section.link).addClass('no-match');
      }
    }
    // Highlight the best match
    if(bestMatch){
      $(bestMatch.link).addClass('best-match');
    }
  }

  function clearSearch(){
    ctrl.search = "";
    doSearch();
  }

  function handleKeyDown(e){
    switch(e.keyCode){
      case 13: // ENTER
        if(bestMatch){
          $timeout(function(){
            $(bestMatch.link).trigger('click');
          });
        }
        break;
      case 27: // ESC
        clearSearch();
        break;
      case 38: // UP
        console.log('Move Up');
        break;
      case 40: // DOWN
        console.log('Move Down');
        break;
    }
  }





}

angular
  .module('app')
  .component('linkFilter', linkFilterComponent);

},{}],276:[function(require,module,exports){
/** LOADING BAR
 *
 *  This is just an abstraction of pace.js, with config
 *
 *  It's NOT Angular specific, rather it just listens to
 *   to various exposed events (AJAX, Routine etc.) and
 *   renders the loading-bar.
 */
paceOptions = {
  restartOnRequestAfter: 200,
  ajax: {
    trackMethods: ['POST', 'GET'],
    trackWebSockets: false,
    ignoreURLs: [
      'rs.fullstory.com',
      'esp.aptrinsic.com',
      'ws.zoominfo.com',
      'analytics.google.com',
      'i.clarity.ms',
    ]
  }
};
require('./pace.min.js');

},{"./pace.min.js":277}],277:[function(require,module,exports){
/*! pace 1.0.0 */
(function(){var a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X=[].slice,Y={}.hasOwnProperty,Z=function(a,b){function c(){this.constructor=a}for(var d in b)Y.call(b,d)&&(a[d]=b[d]);return c.prototype=b.prototype,a.prototype=new c,a.__super__=b.prototype,a},$=[].indexOf||function(a){for(var b=0,c=this.length;c>b;b++)if(b in this&&this[b]===a)return b;return-1};for(u={catchupTime:100,initialRate:.03,minTime:250,ghostTime:100,maxProgressPerFrame:20,easeFactor:1.25,startOnPageLoad:!0,restartOnPushState:!0,restartOnRequestAfter:500,target:"body",elements:{checkInterval:100,selectors:["body"]},eventLag:{minSamples:10,sampleCount:3,lagThreshold:3},ajax:{trackMethods:["GET"],trackWebSockets:!0,ignoreURLs:[]}},C=function(){var a;return null!=(a="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance.now():void 0)?a:+new Date},E=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||window.msRequestAnimationFrame,t=window.cancelAnimationFrame||window.mozCancelAnimationFrame,null==E&&(E=function(a){return setTimeout(a,50)},t=function(a){return clearTimeout(a)}),G=function(a){var b,c;return b=C(),(c=function(){var d;return d=C()-b,d>=33?(b=C(),a(d,function(){return E(c)})):setTimeout(c,33-d)})()},F=function(){var a,b,c;return c=arguments[0],b=arguments[1],a=3<=arguments.length?X.call(arguments,2):[],"function"==typeof c[b]?c[b].apply(c,a):c[b]},v=function(){var a,b,c,d,e,f,g;for(b=arguments[0],d=2<=arguments.length?X.call(arguments,1):[],f=0,g=d.length;g>f;f++)if(c=d[f])for(a in c)Y.call(c,a)&&(e=c[a],null!=b[a]&&"object"==typeof b[a]&&null!=e&&"object"==typeof e?v(b[a],e):b[a]=e);return b},q=function(a){var b,c,d,e,f;for(c=b=0,e=0,f=a.length;f>e;e++)d=a[e],c+=Math.abs(d),b++;return c/b},x=function(a,b){var c,d,e;if(null==a&&(a="options"),null==b&&(b=!0),e=document.querySelector("[data-pace-"+a+"]")){if(c=e.getAttribute("data-pace-"+a),!b)return c;try{return JSON.parse(c)}catch(f){return d=f,"undefined"!=typeof console&&null!==console?console.error("Error parsing inline pace options",d):void 0}}},g=function(){function a(){}return a.prototype.on=function(a,b,c,d){var e;return null==d&&(d=!1),null==this.bindings&&(this.bindings={}),null==(e=this.bindings)[a]&&(e[a]=[]),this.bindings[a].push({handler:b,ctx:c,once:d})},a.prototype.once=function(a,b,c){return this.on(a,b,c,!0)},a.prototype.off=function(a,b){var c,d,e;if(null!=(null!=(d=this.bindings)?d[a]:void 0)){if(null==b)return delete this.bindings[a];for(c=0,e=[];c<this.bindings[a].length;)e.push(this.bindings[a][c].handler===b?this.bindings[a].splice(c,1):c++);return e}},a.prototype.trigger=function(){var a,b,c,d,e,f,g,h,i;if(c=arguments[0],a=2<=arguments.length?X.call(arguments,1):[],null!=(g=this.bindings)?g[c]:void 0){for(e=0,i=[];e<this.bindings[c].length;)h=this.bindings[c][e],d=h.handler,b=h.ctx,f=h.once,d.apply(null!=b?b:this,a),i.push(f?this.bindings[c].splice(e,1):e++);return i}},a}(),j=window.Pace||{},window.Pace=j,v(j,g.prototype),D=j.options=v({},u,window.paceOptions,x()),U=["ajax","document","eventLag","elements"],Q=0,S=U.length;S>Q;Q++)K=U[Q],D[K]===!0&&(D[K]=u[K]);i=function(a){function b(){return V=b.__super__.constructor.apply(this,arguments)}return Z(b,a),b}(Error),b=function(){function a(){this.progress=0}return a.prototype.getElement=function(){var a;if(null==this.el){if(a=document.querySelector(D.target),!a)throw new i;this.el=document.createElement("div"),this.el.className="pace pace-active",document.body.className=document.body.className.replace(/pace-done/g,""),document.body.className+=" pace-running",this.el.innerHTML='<div class="pace-progress">\n  <div class="pace-progress-inner"></div>\n</div>\n<div class="pace-activity"></div>',null!=a.firstChild?a.insertBefore(this.el,a.firstChild):a.appendChild(this.el)}return this.el},a.prototype.finish=function(){var a;return a=this.getElement(),a.className=a.className.replace("pace-active",""),a.className+=" pace-inactive",document.body.className=document.body.className.replace("pace-running",""),document.body.className+=" pace-done"},a.prototype.update=function(a){return this.progress=a,this.render()},a.prototype.destroy=function(){try{this.getElement().parentNode.removeChild(this.getElement())}catch(a){i=a}return this.el=void 0},a.prototype.render=function(){var a,b,c,d,e,f,g;if(null==document.querySelector(D.target))return!1;for(a=this.getElement(),d="translate3d("+this.progress+"%, 0, 0)",g=["webkitTransform","msTransform","transform"],e=0,f=g.length;f>e;e++)b=g[e],a.children[0].style[b]=d;return(!this.lastRenderedProgress||this.lastRenderedProgress|0!==this.progress|0)&&(a.children[0].setAttribute("data-progress-text",""+(0|this.progress)+"%"),this.progress>=100?c="99":(c=this.progress<10?"0":"",c+=0|this.progress),a.children[0].setAttribute("data-progress",""+c)),this.lastRenderedProgress=this.progress},a.prototype.done=function(){return this.progress>=100},a}(),h=function(){function a(){this.bindings={}}return a.prototype.trigger=function(a,b){var c,d,e,f,g;if(null!=this.bindings[a]){for(f=this.bindings[a],g=[],d=0,e=f.length;e>d;d++)c=f[d],g.push(c.call(this,b));return g}},a.prototype.on=function(a,b){var c;return null==(c=this.bindings)[a]&&(c[a]=[]),this.bindings[a].push(b)},a}(),P=window.XMLHttpRequest,O=window.XDomainRequest,N=window.WebSocket,w=function(a,b){var c,d,e,f;f=[];for(d in b.prototype)try{e=b.prototype[d],f.push(null==a[d]&&"function"!=typeof e?a[d]=e:void 0)}catch(g){c=g}return f},A=[],j.ignore=function(){var a,b,c;return b=arguments[0],a=2<=arguments.length?X.call(arguments,1):[],A.unshift("ignore"),c=b.apply(null,a),A.shift(),c},j.track=function(){var a,b,c;return b=arguments[0],a=2<=arguments.length?X.call(arguments,1):[],A.unshift("track"),c=b.apply(null,a),A.shift(),c},J=function(a){var b;if(null==a&&(a="GET"),"track"===A[0])return"force";if(!A.length&&D.ajax){if("socket"===a&&D.ajax.trackWebSockets)return!0;if(b=a.toUpperCase(),$.call(D.ajax.trackMethods,b)>=0)return!0}return!1},k=function(a){function b(){var a,c=this;b.__super__.constructor.apply(this,arguments),a=function(a){var b;return b=a.open,a.open=function(d,e){return J(d)&&c.trigger("request",{type:d,url:e,request:a}),b.apply(a,arguments)}},window.XMLHttpRequest=function(b){var c;return c=new P(b),a(c),c};try{w(window.XMLHttpRequest,P)}catch(d){}if(null!=O){window.XDomainRequest=function(){var b;return b=new O,a(b),b};try{w(window.XDomainRequest,O)}catch(d){}}if(null!=N&&D.ajax.trackWebSockets){window.WebSocket=function(a,b){var d;return d=null!=b?new N(a,b):new N(a),J("socket")&&c.trigger("request",{type:"socket",url:a,protocols:b,request:d}),d};try{w(window.WebSocket,N)}catch(d){}}}return Z(b,a),b}(h),R=null,y=function(){return null==R&&(R=new k),R},I=function(a){var b,c,d,e;for(e=D.ajax.ignoreURLs,c=0,d=e.length;d>c;c++)if(b=e[c],"string"==typeof b){if(-1!==a.indexOf(b))return!0}else if(b.test(a))return!0;return!1},y().on("request",function(b){var c,d,e,f,g;return f=b.type,e=b.request,g=b.url,I(g)?void 0:j.running||D.restartOnRequestAfter===!1&&"force"!==J(f)?void 0:(d=arguments,c=D.restartOnRequestAfter||0,"boolean"==typeof c&&(c=0),setTimeout(function(){var b,c,g,h,i,k;if(b="socket"===f?e.readyState<2:0<(h=e.readyState)&&4>h){for(j.restart(),i=j.sources,k=[],c=0,g=i.length;g>c;c++){if(K=i[c],K instanceof a){K.watch.apply(K,d);break}k.push(void 0)}return k}},c))}),a=function(){function a(){var a=this;this.elements=[],y().on("request",function(){return a.watch.apply(a,arguments)})}return a.prototype.watch=function(a){var b,c,d,e;return d=a.type,b=a.request,e=a.url,I(e)?void 0:(c="socket"===d?new n(b):new o(b),this.elements.push(c))},a}(),o=function(){function a(a){var b,c,d,e,f,g,h=this;if(this.progress=0,null!=window.ProgressEvent)for(c=null,a.addEventListener("progress",function(a){return h.progress=a.lengthComputable?100*a.loaded/a.total:h.progress+(100-h.progress)/2},!1),g=["load","abort","timeout","error"],d=0,e=g.length;e>d;d++)b=g[d],a.addEventListener(b,function(){return h.progress=100},!1);else f=a.onreadystatechange,a.onreadystatechange=function(){var b;return 0===(b=a.readyState)||4===b?h.progress=100:3===a.readyState&&(h.progress=50),"function"==typeof f?f.apply(null,arguments):void 0}}return a}(),n=function(){function a(a){var b,c,d,e,f=this;for(this.progress=0,e=["error","open"],c=0,d=e.length;d>c;c++)b=e[c],a.addEventListener(b,function(){return f.progress=100},!1)}return a}(),d=function(){function a(a){var b,c,d,f;for(null==a&&(a={}),this.elements=[],null==a.selectors&&(a.selectors=[]),f=a.selectors,c=0,d=f.length;d>c;c++)b=f[c],this.elements.push(new e(b))}return a}(),e=function(){function a(a){this.selector=a,this.progress=0,this.check()}return a.prototype.check=function(){var a=this;return document.querySelector(this.selector)?this.done():setTimeout(function(){return a.check()},D.elements.checkInterval)},a.prototype.done=function(){return this.progress=100},a}(),c=function(){function a(){var a,b,c=this;this.progress=null!=(b=this.states[document.readyState])?b:100,a=document.onreadystatechange,document.onreadystatechange=function(){return null!=c.states[document.readyState]&&(c.progress=c.states[document.readyState]),"function"==typeof a?a.apply(null,arguments):void 0}}return a.prototype.states={loading:0,interactive:50,complete:100},a}(),f=function(){function a(){var a,b,c,d,e,f=this;this.progress=0,a=0,e=[],d=0,c=C(),b=setInterval(function(){var g;return g=C()-c-50,c=C(),e.push(g),e.length>D.eventLag.sampleCount&&e.shift(),a=q(e),++d>=D.eventLag.minSamples&&a<D.eventLag.lagThreshold?(f.progress=100,clearInterval(b)):f.progress=100*(3/(a+3))},50)}return a}(),m=function(){function a(a){this.source=a,this.last=this.sinceLastUpdate=0,this.rate=D.initialRate,this.catchup=0,this.progress=this.lastProgress=0,null!=this.source&&(this.progress=F(this.source,"progress"))}return a.prototype.tick=function(a,b){var c;return null==b&&(b=F(this.source,"progress")),b>=100&&(this.done=!0),b===this.last?this.sinceLastUpdate+=a:(this.sinceLastUpdate&&(this.rate=(b-this.last)/this.sinceLastUpdate),this.catchup=(b-this.progress)/D.catchupTime,this.sinceLastUpdate=0,this.last=b),b>this.progress&&(this.progress+=this.catchup*a),c=1-Math.pow(this.progress/100,D.easeFactor),this.progress+=c*this.rate*a,this.progress=Math.min(this.lastProgress+D.maxProgressPerFrame,this.progress),this.progress=Math.max(0,this.progress),this.progress=Math.min(100,this.progress),this.lastProgress=this.progress,this.progress},a}(),L=null,H=null,r=null,M=null,p=null,s=null,j.running=!1,z=function(){return D.restartOnPushState?j.restart():void 0},null!=window.history.pushState&&(T=window.history.pushState,window.history.pushState=function(){return z(),T.apply(window.history,arguments)}),null!=window.history.replaceState&&(W=window.history.replaceState,window.history.replaceState=function(){return z(),W.apply(window.history,arguments)}),l={ajax:a,elements:d,document:c,eventLag:f},(B=function(){var a,c,d,e,f,g,h,i;for(j.sources=L=[],g=["ajax","elements","document","eventLag"],c=0,e=g.length;e>c;c++)a=g[c],D[a]!==!1&&L.push(new l[a](D[a]));for(i=null!=(h=D.extraSources)?h:[],d=0,f=i.length;f>d;d++)K=i[d],L.push(new K(D));return j.bar=r=new b,H=[],M=new m})(),j.stop=function(){return j.trigger("stop"),j.running=!1,r.destroy(),s=!0,null!=p&&("function"==typeof t&&t(p),p=null),B()},j.restart=function(){return j.trigger("restart"),j.stop(),j.start()},j.go=function(){var a;return j.running=!0,r.render(),a=C(),s=!1,p=G(function(b,c){var d,e,f,g,h,i,k,l,n,o,p,q,t,u,v,w;for(l=100-r.progress,e=p=0,f=!0,i=q=0,u=L.length;u>q;i=++q)for(K=L[i],o=null!=H[i]?H[i]:H[i]=[],h=null!=(w=K.elements)?w:[K],k=t=0,v=h.length;v>t;k=++t)g=h[k],n=null!=o[k]?o[k]:o[k]=new m(g),f&=n.done,n.done||(e++,p+=n.tick(b));return d=p/e,r.update(M.tick(b,d)),r.done()||f||s?(r.update(100),j.trigger("done"),setTimeout(function(){return r.finish(),j.running=!1,j.trigger("hide")},Math.max(D.ghostTime,Math.max(D.minTime-(C()-a),0)))):c()})},j.start=function(a){v(D,a),j.running=!0;try{r.render()}catch(b){i=b}return document.querySelector(".pace")?(j.trigger("start"),j.go()):setTimeout(j.start,50)},"function"==typeof define&&define.amd?define(function(){return j}):"object"==typeof exports?module.exports=j:D.startOnPageLoad&&j.start()}).call(this);
},{}],278:[function(require,module,exports){
/** LOADING - DIRECTIVE
 *
 *      Renders a loading icon
 *
 *          <loading size="100"></loading>
 *
 *      @author   David "oodavid" King
 *      @author   Jake "the growler" Ford (redesign)
 */
(function() {
  angular.module('app')
    .directive('loading', [function() {
      return {
        restrict: 'E',
        replace: false,
        scope: {
          size: '='
        },
        template: '\
                <div class="loading-animation" ng-style="{ \'width\': size + \'px\', \'height\': size + \'px\' }">\
                    <div class="clipping-path">\
                        <span class="spin">\
                        <span class="line"></span>\
                    </span>\
                    </div>\
                    <svg viewBox="0 0 100 100">\
                        <g>\
                            <circle id="logo-circle" cx="75.2%" cy="62%" r="6%"></circle>\
                            <rect id="logo-rect" x="24.5%" y="38.5%" width="51%" height="7.5%"/></rect>\
                        </g>\
                    </svg>\
                </div>',
      };
    }]);
})();

},{}],279:[function(require,module,exports){
/** META TAGS CONTROLLER
 *
 *    Exposes data from the MetaTagsService to the scope
 */
MetaTagsCtrl.$inject = ['$attrs', 'MetaTagsService'];
function MetaTagsCtrl($attrs, MetaTagsService){
  var ctrl = this;
  ctrl.meta = MetaTagsService.getMeta($attrs.autoReset === 'true');
}

angular
  .module('app')
  .controller('MetaTagsCtrl', MetaTagsCtrl);

},{}],280:[function(require,module,exports){
/** META TAGS RUN
 *
 *    Watches for routing changes and updates the metadata
 *
 *    I use `onFinish` as it is invoked just before the
 *     route changes. The route controllers have not yet
 *     fired. Thus, we can set default meta data here,
 *     but the route controller can override them.
 */
metaTagsRun.$inject = ['$location', '$transitions', 'MetaTagsService'];
function metaTagsRun($location, $transitions, MetaTagsService){
  var meta = MetaTagsService.getMeta();

  $transitions.onFinish({}, function($transition){
    var state = $transition.to();
    // Reset
    if ($('head').attr('auto-reset') != 'false') {
      MetaTagsService.reset(); // Don't want to do this if auto-reset is false
    }
    // Prepend the route title (if necessary)
    if(state.title){
      MetaTagsService.setProperty('title', state.title);
    }
  });
}

angular
  .module('app')
  .run(metaTagsRun);

/*

// Tests

// When changing routes, the tags should get reset

// http://localhost:9001/10000005 - the meta object should match a hardcoded hash
// http://localhost:9001/login - the meta object should match a hardcoded hash
// http://localhost:9001/sign_up - the meta object should match a hardcoded hash

*/

},{}],281:[function(require,module,exports){
/** META TAGS SERVICE
 *
 *    Juggles meta data
 */
MetaTagsService.$inject = ['$location', '$timeout'];
function MetaTagsService($location, $timeout){
  var service = this;
  service.getMeta = getMeta;
  service.setDefault = setDefault;
  service.reset = reset;
  service.setProperty = setProperty;
  service.deIndexFromSearch = deIndexFromSearch;

  var meta = {};

  var defaultTitle = $location.host().indexOf('miriada') > -1 ? 'MiríadaX' : 'Accredible : Certificates, Badges and Blockchain.';

  function getMeta(autoReset){
    if (autoReset) {
      reset();
    }
    return meta;
  }

  function setDefault(key, value) {
    if (key === 'title') {
      defaultTitle = value;
    }
    meta[key] = value;
  }

  function reset(){
    var description = $location.host().indexOf('miriada') > -1 ? 'MiríadaX' : 'Accredible : Certificates, Badges and Blockchain.';
    angular.copy({
      spiderable: 'all',
      identity: 'Accredible',
      title: defaultTitle,
      description: description,
      image: 'https://dashboard.accredible.com/images/accredible_logo_symbol.png',
      image_width: 128,
      image_height: 128,
      twittercard_image: 'https://dashboard.accredible.com/images/accredible_logo_symbol.png',
      twitter_site: 'accredible',     // Should always be us
      twitter_username: 'accredible', // Can update to be the issuer, or recipient
      twitter_card: 'summary',        // Automatically set depending on image dimensions (see setProperty)
      twitter_description: null,      // This may exist, the HTML falls back to `description`
      url: $location.absUrl(),
      favicon: '/favicon.ico'
    }, meta);
  }

  function setProperty(key, value, includeDefault){
    if (typeof includeDefault === 'undefined') { includeDefault = true; }

    meta[key] = value;
    // If we're setting the title, append the default
    if(key === 'title' && includeDefault){
      meta[key] += ' : ' + defaultTitle;
    }
    // If we're setting the open graph image, get the dimensions
    if(key === 'image'){
      var seoImage = new Image();
      seoImage.onload = function() {
        meta.image_width = seoImage.naturalWidth || seoImage.width;
        meta.image_height = seoImage.naturalHeight || seoImage.height;
        $timeout(function(){});
      };
      seoImage.src = value;
    }
    // If we're setting the twitter card image, get the dimensions & create the card
    if(key === 'twittercard_image'){
      meta.twitter_card = 'summary';
    } else if(key === 'twittercard_image_large') {
      meta.twitter_card = 'summary_large_image';
      meta.twittercard_image = value;
    }
  }

  function deIndexFromSearch(){
    meta.spiderable = 'noindex';
  }
}

angular
  .module('app')
  .service('MetaTagsService', MetaTagsService);

/*

// Tests

// Get the meta data
var meta = MetaTagsService
  .getMeta();
var metaClone = angular.clone(meta);

// Set the title property
MetaTagsService
  .setProperty('title', 'Testing');

  // I expect the title to have been prepended to the original, with " : " as a delimiter
  meta.title === 'Testing : '+metaClone.title;

// Set the image property
MetaTagsService
  .setProperty('image', 'https://s3.amazonaws.com/accredible-api-templates/1497455580839.jpg');

// Reset
MetaTagsService
  .reset();

  // I expect the meta object to have reverted to the initial values
  angular.equals(meta, metaClone);

*/

},{}],282:[function(require,module,exports){
/** NEW FEATURE INDICATOR
 *
 *   <new-feature-indicator ftue="<key>" image-url="<url>" width="<width>" position="<position>">
 *     <target>
 *        <... any html ...>
 *     </target>
 *     <menu-text>
 *        <... html text ...>
 *     </menu-text>
 *   </new-feature-indicator>
 *
 *   Where:
 *     <key> is the FTUE feature key. Once the indicator pop-up is closed this is set and the indicator will not be displayed again.
 *     <url> is a url to an image that is display on the left of the indicator pop-up.
 *     <width> is thw width of the indicator pop-up.
 *     <position> is optional and is the position of the indicator pop-up relative to the target.
 *        Valid values are 'top', 'left', 'bottom' and 'right'.
 *        If not value is given, the position defaults to 'top'.
 *        If the indicator pop-up will not fit on the screen in the given position, a "best fit" position is automatically chosen.
 *
 *   @author   Andrew Bateman
 */

var newFeatureIndicatorComponent = {
  controller: newFeatureIndicatorComponentController,
  transclude: {
    target: 'target',
    content: 'messageText'
  },
  bindings: {
    ftue: '@',
    imageUrl: '@',
    width: '@',
    position: '@'
  },
  templateUrl: '/shared/new-feature-indicator/new-feature-indicator.html',
};
newFeatureIndicatorComponentController.$inject = ['$element', '$document', '$scope', 'FtueService'];
function newFeatureIndicatorComponentController($element, $document, $scope, FtueService) {
  var ctrl = this;

  ctrl.$postLink = postLink;

  ctrl.placement = null; // This calculated in positionIndicator()

  var $target = null;
  var $indicator = null;
  var indicatorWidth = 0;
  var indicatorHeight = 0;
  var fixedTarget = false; // Is the component in a 'fixed' container?
  var $window = angular.element(window);
  var ftueValues = null;
  // Get existing FTUE state
  FtueService.get().then(function(values) {
    ftueValues = values;
  });

  // Positioning logic
  function positionIndicator() {
    // Bail out if the FTUE value is true - this is to address an issue where a dismissed indicator would be redisplayed on scroll or resize after a page refresh
    if (ftueValues && ftueValues[ctrl.ftue]) {
      return;
    }
    var verticalScrollAdjustment = 0;
    if (!fixedTarget) {
      verticalScrollAdjustment = $window.scrollTop();
    }
    var elementPosition = $element.offset();
    var targetWidth = $target.width();
    var targetHeight = $target.height() + 6;
    // Override position with best fit
    var fits = [];
    var horizontalTopPostion = elementPosition.top - ((indicatorHeight - targetHeight) / 2) - 24;
    var fitsHorizontally = horizontalTopPostion >= 0 && (horizontalTopPostion + indicatorHeight <= $document.height());
    var topTopPosition = elementPosition.top - indicatorHeight - 24;
    var bottomTopPosition = elementPosition.top + targetHeight - 8;
    var verticalLeftPosition = elementPosition.left - (indicatorWidth / 2) + (targetWidth / 2);
    var fitsVertically = verticalLeftPosition >= 0 && (verticalLeftPosition + indicatorWidth <= $document.width());
    if (topTopPosition >= 0 && fitsVertically) {
      fits.push('top');
    }
    if ((bottomTopPosition + indicatorHeight <= $document.height()) && fitsVertically) {
      fits.push('bottom');
    }
    if ((elementPosition.left - indicatorWidth >= 0) && fitsHorizontally) {
      fits.push('left');
    }
    if ((elementPosition.left + targetWidth + indicatorWidth) <= $document.width() && fitsHorizontally) {
      fits.push('right');
    }
    if (fits.length > 0 && fits.indexOf(ctrl.position) === -1) {
      ctrl.placement = fits[0];
    } else {
      ctrl.placement = ctrl.position;
    }
    // Position indicator
    switch (ctrl.placement) {
      case 'top':
        $indicator.css({ 'top': topTopPosition - verticalScrollAdjustment, 'left': verticalLeftPosition });
        break;
      case 'bottom':
        $indicator.css({ 'top': bottomTopPosition - verticalScrollAdjustment, 'left': verticalLeftPosition });
        break;
      case 'left':
        $indicator.css({ 'top': elementPosition.top - ((indicatorHeight - targetHeight) / 2) - 24 - verticalScrollAdjustment, 'left': elementPosition.left - indicatorWidth });
        break;
      case 'right':
        $indicator.css({ 'top': elementPosition.top - ((indicatorHeight - targetHeight) / 2) - 24 - verticalScrollAdjustment, 'left': elementPosition.left + targetWidth });
        break;
    }
    // Hide indicator if element is not visible
    if (!$target.is(':visible')) {
      $indicator.css('display', 'none');
    } else {
      $indicator.css('display', 'block');
    }
  }

  function postLink() {
    $target = $element.find('[ng-transclude="target"]');
    $indicator = $element.find('[acc-ftue]');
    indicatorWidth = parseInt(ctrl.width);
    indicatorHeight = $indicator.height() + 32;
    var $parent = $element.parent();
    var body = angular.element('body')[0];
    while (!fixedTarget && $parent[0] !== body) {
      fixedTarget = $parent.css('position') === 'fixed';
      $parent = $parent.parent();
    }
    ctrl.position = ctrl.position || 'top';
    positionIndicator();
    // Add and remove global event listeners...
    if (!fixedTarget) {
      $document.on('scroll', positionIndicator);
    }
    $window.on('resize', positionIndicator);
  }

  function destroy() {
    if (!fixedTarget) {
      $document.off('scroll', positionIndicator);
    }
    $window.off('resize', positionIndicator);
  }
  // As ctrl.$destroy doesn't seem to get called
  $scope.$on('$destroy', destroy);
}

angular
  .module('app')
  .component('newFeatureIndicator', newFeatureIndicatorComponent);

},{}],283:[function(require,module,exports){
/** ON ENTER - DIRECTIVE
 *
 *      Triggers a callback when the user presses the [ENTER] key.
 *
 *      Overall I'm unsure about it's usage on the ACMS system,
 *       many times it's applied to a <div> as a way to add the
 *       same native functionality that would be given to an
 *       <a> or <button> element - tab to the element and press
 *       [ENTER] to trigger a click event.
 *
 *      Advice: Prefer to use sematic elements. Avoid if possible
 *
 *      Adding acc-on-enter="false" to a form input stops the enter
 *      key press causing a form submit.
 *
 *      @author   David "oodavid" King (comment only)
 */
(function() {
  angular
    .module('app')
    .directive('accOnEnter', function() {
      return function(scope, element, attrs) {
        element.bind('keydown keypress', function(event) {
          if (event.which === 13) {
            if (attrs.accOnEnter) {
              scope.$apply(function() {
                scope.$eval(attrs.accOnEnter);
              });
            }
            event.preventDefault();
          }
        });
      };
    });
})();

},{}],284:[function(require,module,exports){
/** ONBOARDING :: SERVICE and CONTROLLER
 *
 *
 *
 *      @author   David "oodavid" King
 */
(function() {
  angular.module('app')
    .controller('OnboardingCtrl', ['$scope', 'onboarding', 'supportService', function($scope, onboarding, supportService) {
      // Expose data and methods from the service
      $scope.data = onboarding.data;
      $scope.next = onboarding.next;
      $scope.cancel = onboarding.cancel;
      $scope.end = onboarding.end;
      // Support too!
      $scope.supportService = supportService;
    }])
    .service('onboarding', ['$window', '$transitions', '$state', '$q', '$timeout', '$interval', 'ENV', 'FtueService', 'api', '_', 'AnalyticsService', function($window, $transitions, $state, $q, $timeout, $interval, ENV, FtueService, api, _, AnalyticsService) {
      var _this = this;
      // Exposed data
      this.data = {
        active: false,
        name: false,
        recipe: false,
        user: false,
        overlay: {},
        tip: {},
        clickanywhere: false,
      };
      // Hoist the ftue object
      var ftue = {};
      FtueService
        .get()
        .then(function(myFtue){
          ftue = myFtue;
        });

      /** SETTERS
       *
       *
       */
      var recipes = {};
      var users = {};
      this.addRecipe = function(name, recipe) {
        if (recipes[name]) {
          console.error('Recipe "' + name + '" already exists!');
        }
        recipes[name] = recipe;
      };
      this.setUsers = function(_users) {
        users = _users;
      };
      /** GETTERS / STARTER
       *
       *
       */
      // Returns a recipe
      this.getRecipe = function(name) {
        return recipes[name];
      };
      // Returns whether a recipe has already been completed
      this.isRecipeComplete = function(name) {
        return ftue['recipe_'+name];
      };
      // Returns whether a recipe has already been opened
      this.isRecipeOpened = function(name) {
        return ftue['recipe_started_' + name];
      };
      // Starts an onboarding recipe
      this.openRecipe = function(name, username, skipToStep) {
        var recipe = angular.copy(recipes[name]);
        if (recipe) {
          _this.data.active = true;
          _this.data.name = name;
          _this.data.recipe = recipe;
          // Optional user
          _this.data.user = false;
          if (users[username]) {
            _this.data.user = {
              avatar: '/images/staff/' + username + '.jpg',
              name: users[username],
              username: username,
            };
          }
          // Skip some steps?
          if (skipToStep) {
            _this.data.recipe = _this.data.recipe.slice(skipToStep);
          }
          // Flag the steps for the UI
          for (var s = 0, sl = recipe.length; s < sl; s++) {
            recipe[s].active = false; // Currently inactive
            recipe[s].complete = false; // Currently incomplete
          }
          // Track this event
          trackEvent('Open Recipe');
          // Mark the recipie as having been opened before
          FtueService.set('recipe_started_' + _this.data.name, true);
          // Show the first step
          currentStep = -1;
          showNextStep();
          // Digest (just in case)
          $timeout(function() {});
        }
      };
      // Analytics helper
      var trackEvent = function(eventName) {
        AnalyticsService.trackEvent('Onboarding > ' + _this.data.name + ' > ' + eventName);
      };
      /** OVERLAY
       *
       *
       */
      var showOverlay = function(props) {
        _this.data.overlay = props;
        _this.data.overlay.visible = true;
      };
      var hideOverlay = function() {
        _this.data.overlay.visible = false;
      };
      /** STEPS
       *
       *
       */
      var currentStep = -1; // Starts with -1, so we can immediately increment to get the zeroth step
      var markStepComplete = function() {
        if (_this.data.recipe[currentStep]) {
          _this.data.recipe[currentStep].complete = true;
        }
      };
      this.cancel = function(eventMessage) {
        _this.data.active = false;
        hideGuide();
        if (eventMessage) {
          trackEvent('Cancel > ' + eventMessage);
        }
      };
      this.next = function() {
        showNextGuide();
      };
      this.end = function(redirect, eventMessage) {
        _this.cancel(false); // Cancel it
        trackEvent('Redirect > ' + eventMessage);
        if (redirect == 'dashboard') {
          $state.go('issuer.dashboard.home');
        }
      };
      //
      var showNextStep = function() {
        markStepComplete();
        if (_this.data.recipe[currentStep]) {
          _this.data.recipe[currentStep].active = false;
        }
        currentStep++;
        setGuides(_this.data.recipe[currentStep].guides);
        _this.data.recipe[currentStep].active = true;
      };
      /** ROUTES
       *
       *
       */
      var doesRouteMatchNextStep = function(route) {
        // If the current route has no more steps
        if (!guides.length) {
          // ...and the route matches the next step
          var nextStep = _this.data.recipe[currentStep + 1];
          if (nextStep && nextStep.route == route) {
            return true;
          }
        }
        return false;
      };
      // Prevent users navigating away from the prescribed route
      $transitions.onStart({}, function($transition) {
        // The transitions service has a bug; it sometimes triggers an event from and to the same page.
        if ($transition.from().name == $transition.to().name) {
          return;
        }
        // Allow automatic redirects away from the onboarding shortcut URL
        if ($transition.from().name == 'issuer.dashboard.guide' && $transition.from().name == 'issuer.dashboard.guide2') {
          return;
        }
        if (_this.data.active && !doesRouteMatchNextStep($transition.to().name)) {
          if ($window.confirm('You are navigating away from this Guide.\n\nAre you sure you want to leave this page?')) {
            _this.cancel('Navigate Away');
          } else {
            return false; // Prevent the redirect
          }
        }
      });
      // Check for users progressing to the next step
      $transitions.onSuccess({}, function($transition) {
        if (_this.data.active && doesRouteMatchNextStep($transition.to().name)) {
          $timeout(showNextStep, 300); // With a small delay, to allow the UI to render
        }
      });
      /** TIPS
       *
       *
       */
      var tipDelayTimer;
      var hideTip = function() {
        $timeout(function() {
          _this.data.tip.visible = false; // Hide the guide (it may not be used)
          if (tipDelayTimer) {
            $timeout.cancel(tipDelayTimer);
          }
        }, (_this.data.tip.tipDestroyDelay || 0)); // Optional delay to keep the tip onscreen for longer than normal
      };
      var showTip = function(el, text, tipDelay, tipDestroyDelay, placementOverride, clickanywhere) {
        tipDelayTimer = $timeout(function() {
          // Set the initial properties
          _this.data.tip = {
            visible: true,
            onscreen: true, // Assume true for now, the value doesn't matter as initOffscreen() may modify it
            text: text,
            clickanywhere: clickanywhere,
            tipDestroyDelay: tipDestroyDelay,
            // position
            // top
            // left
            // placement
            offscreen: {
              point: null,
              top: null,
              bottom: null,
              // left
            }
          };
          // Adjusts the tip to the position of the element
          var redrawTip = function() {
            var position, top, left, placement, left;
            // Do we have a target element?
            if (!el || !el.length) {
              // No element, center
              position = 'fixed';
              top = '50%';
              left = '50%';
              placement = 'center middle';
            } else {
              // Analyse the target element, and window
              var offset = el.offset();
              var width = el.outerWidth();
              var height = el.outerHeight();
              var middle = $(window).height() / 2; // Middle of the screen EXCLUDING scroll
              position = isElementFixed(el) ? 'fixed' : 'absolute';
              top = offset.top; // Top position, this INCLUDES scroll
              left = offset.left + (width / 2);
              // `fixed` and `absolute` elements have different calculations
              if (position == 'fixed') {
                top -= $(window).scrollTop(); // `fixed` elements must ignore "scroll"
              } else {
                middle += $(window).scrollTop(); // `absolute` elements must consider "scroll" in the placement calculation
              }
              // Calculate the placement - `below right`, `above center`
              var hPlacement = placementOverride || (top + (height * 0.7) <= middle ? 'below' : 'above');
              var vPlacement = (left < 200 ? 'left' : ((left+200) > $(window).width() ? 'right' : 'center'));
              placement = hPlacement + ' ' + vPlacement;
              // The tip can hang above or below the element, these have different `top` values, we want them both
              var topAbove = top;
              var topBelow = top + height;
              // Initial top value should match the initial placement
              top = (hPlacement == 'below' ? topBelow : topAbove);
            }
            // Update the tip
            _this.data.tip.position = position;
            _this.data.tip.top = top;
            _this.data.tip.left = left;
            _this.data.tip.placement = placement;
            _this.data.tip.offscreen.left = left;
          };
          // Redraw the tip
          redrawTip();
          // Adjust for navigation elements that may obscure the tip
          initOffscreen();
        }, (tipDelay || 0)); // Optional delay
      };
      // Call this when a tip is created, it checks the height of the navigation so we can correctly adjust the "tip is offscreen" indicator
      var offscreenTop = 0;
      var offscreenBottom = 30; // Why so large? Think about the browser "status bar" when hovering over a link...
      var initOffscreen = function() {
        // Calculate the off-screen boundary (might have an actionbar and title, or just title)
        var el = $('.actionbar:visible');
        if (!el.length) {
          el = $('.acc-title:visible');
        }
        if (el.length) {
          offscreenTop = el.offset().top + el.outerHeight() + 5; // Was 20px, but that was so precise that rounding errors might result in an element at the VERY TOP of the content being considered "off screen"
          offscreenTop -= $(window).scrollTop(); // factor in any scroll (it's a fixed element)
        } else {
          offscreenTop = 128; // A sensible guess
        }
        // Then make the first check
        checkOffscreen();
      };
      // Offscreen...
      var checkOffscreen = function() {
        if (_this.data.active && _this.data.tip.position == 'absolute') {
          // Check the boundaries
          if (_this.data.tip.top < window.scrollY + offscreenTop) {
            _this.data.tip.onscreen = false; // The tip is off the top of the screen
            _this.data.tip.offscreen.point = 'up';
            _this.data.tip.offscreen.top = offscreenTop;
            _this.data.tip.offscreen.bottom = null;
          } else if (_this.data.tip.top > window.scrollY + window.innerHeight - offscreenBottom) {
            _this.data.tip.onscreen = false; // The tip is off the bottom of the screen
            _this.data.tip.offscreen.point = 'down';
            _this.data.tip.offscreen.top = null;
            _this.data.tip.offscreen.bottom = offscreenBottom;
          } else {
            _this.data.tip.onscreen = true; // The tip is onscreen
          }
        }
        return false; // No change
      };
      // LISTEN :: Check offscreen status when we scroll
      window.addEventListener('scroll', function(e) {
        if (_this.data.active) { // Only if the onboarding is active
          checkOffscreen();
          $timeout(function() {});
        }
      });
      /** GUIDES
       *
       *
       */
      // Sets the current `guides` stack
      var currentGuide = 0; // Just for analytics
      var guides = [];
      var setGuides = function(_guides) {
        currentGuide = 0;
        guides = _guides;
        showNextGuide();
      };
      //
      var autoSkipTimer;
      var hideGuide = function() {
        $('*').off('.onboarding'); // Remove all old '*.onboarding' namespace events (a little overkill, but fine)
        hideTip();
        hideOverlay();
        _this.data.clickanywhere = false;
        if (autoSkipTimer) { // Currently doesn't do anything - search for autoSkipTimer
          $timeout.cancel(autoSkipTimer);
        }
      };
      // Shows the next guide
      var showNextGuide = function() {
        hideGuide();
        // Make sure we have a guide
        if (!guides.length) {
          return;
        }
        var guide = guides.shift();
        currentGuide++;
        trackEvent('Step ' + (currentStep + 1) + '.' + currentGuide);
        // Type == ELEMENT
        if (guide.type == 'element') {
          // Wait for the element to exist
          waitForElement(guide.selector, (guide.maxWait || 60000)) // Default to a maximum wait of 60 seconds
            .then(function(el) {
              // Digest all of this
              $timeout(function() {
                // Warn about multiple elements matching the selector, it's *probably* not wanted behaviour
                if (el && el.length > 1) {
                  console.error('Onboarding > Selector returned multiple elements. Expected just one element.', guide.selector);
                }
                // Warn about multiple elements matching the selector, it's *probably* not wanted behaviour
                if (guide.next == 'click' || guide.next == 'mousedown') {
                  console.error('Onboarding > Avoid `click` or `mousedown` where possible. Prefer `mouseup`.');
                }
                // Show a tip, if we can
                if (guide.text) {
                  showTip(el, guide.text, guide.tipDelay, guide.tipDestroyDelay, guide.placement, (guide.next == 'clickanywhere'));
                }
                // When do we show the next guide?
                if (guide.next == 'exists') {
                  // We were simply waiting for the element to exist, so do it ASAP
                  showNextGuide();
                } else if (guide.next == 'clickanywhere') {
                  // The user can click anywhere on screen
                  _this.data.clickanywhere = true;
                } else if (el) {
                  // The recipe might specify multiple events, or none. Handle it
                  var events = ['$destroy']; // ...we automatically flag the guide as complete if the element is destroyed
                  if (guide.next) {
                    var tmp = guide.next.split(/[\s\,]+/); // Split on spaces or commas
                    Array.prototype.push.apply(events, tmp);
                  }
                  // Use an event namespace, ie: 'click.onboarding' so that we can easily remove them later with jQuery
                  events = events.join('.onboarding ') + '.onboarding';
                  el.one(events, function(e) {
                    console.log(e);
                    showNextGuide();
                    $timeout(function() {}, 0); // Because jQuery events don't trigger digest
                  });
                }
                // If a timeout is set, the guide can be automatically advance
                /* Disabled - there's a few edge cases here: what if the tip is off-screen? what if the user can't read that fast? It goes on. Reinstate with caution
                if(guide.timeout){
                    autoSkipTimer = $timeout(showNextGuide, guide.timeout);
                }
                */
              });
            });
          // Type == API
        } else if (guide.type == 'api') {
          api.one(guide.endpoint, function(promise) {
            promise.then(function() {
              showNextGuide();
            });
          });
          // Type == OVERLAY
        } else if (guide.type == 'overlay') {
          showOverlay(guide.overlay);
          if (guide.overlay.action == 'end') {
            FtueService.set('recipe_' + _this.data.name, true);
            trackEvent('Recipe Complete');
          }
          // Type == MARK STEP COMPLETE
        } else if (guide.type == 'markStepComplete') {
          markStepComplete();
          showNextGuide();
        }
      };
      /** UTILITIES
       *
       *
       */
      // Detects if an element has 'position: fixed' by scanning it's ancestors
      var isElementFixed = function(el) {
        var $el = $(el);
        while (!$el.is(document)) {
          if ($el.css('position') === 'fixed') {
            return true;
          }
          $el = $el.parent();
        }
        return false;
      }
      // Returns a promise that resolves when a CSS selector matches the DOM (ie: the element is available)
      var waitForElement = function(selector, maxTime) {
        var start = Date.now();
        return $q(function(resolve, reject) {
          if (!selector) {
            resolve(null);
          } else {
            var doWait = function() {
              var el = angular.element(selector);
              if (el.length) {
                resolve(el);
              } else {
                if (Date.now() - start > maxTime) { // We've waited longer than the max time
                  reject('Timed Out');
                } else {
                  $timeout(doWait, 200);
                }
              }
            };
            doWait();
          }
        });
      };
      /** DEVELOPMENT ONLY
       *
       *      Expose the service to the window for easy access
       *       during development
       */
      if (ENV.type === 'development') {
        window.onboarding = _this;
      }
    }]);
})();

},{}],285:[function(require,module,exports){
/** ORDER BY - COMPONENT
 *
 *      Include this component within a <th> element
 *        to add `ORDER BY` behaviour to the cell, ie:
 *
 *        <th>
 *          <order-by
 *            column="payload.order"
 *            value="id"
 *            on-order="updateOrderBy($event);">Id</order-by>
 *        </th>
 *
 *      @author   David "oodavid" King
 */
var orderByComponent = {
  controller: orderByComponentController,
  bindings: {
    column: '<',
    value: '@',
    onOrder: '&',
  },
  transclude: true,
  template: '<a href=""><span ng-transclude></span> <i class="sort" ng-class="$ctrl.direction"></i></a>',
};

orderByComponentController.$inject = ['$element', '$timeout'];
function orderByComponentController($element, $timeout) {
  var ctrl = this;
  ctrl.direction = null; // 'asc' or 'desc'
  ctrl.$onInit = function(){
    parseColumn(ctrl.column);
  }
  ctrl.$onChanges = function(changes){
    if(changes.column){
      parseColumn(changes.column.currentValue);
    }
  }
  function parseColumn(column){
    ctrl.direction = null; // Reset
    if(column){
      var tmp = column.split(' '); // Expecting `column.name ASC` or `columnName DESC`
      if(tmp[0] == ctrl.value){
        ctrl.direction = tmp[1].toLowerCase(); // `ASC` to `asc`
      }
    }
  }
  function changeOrder(){
    var order;
    if(ctrl.direction === null){
      ctrl.direction = 'asc';
      order = ctrl.value+' ASC';
    } else if(ctrl.direction === 'asc'){
      ctrl.direction = 'desc';
      order = ctrl.value+' DESC';
    } else {
      ctrl.direction = null;
      order = null;
    }
    ctrl.onOrder({
      $event: {
        order: order,
      }
    });
  }
  ctrl.$postLink = function () {
    // Identify the element that should have the click event...
    var cell = $element.closest('th, td');
    if(cell.length){
      if(cell.attr('ng-click') === undefined){
        cell.attr('ng-click', ''); // Makes sure the cell acts "linky"
      }
    }
    // ...it should be the parent cell, or the element itself
    var clickElement = cell.length ? cell : $element;
    clickElement.bind('click', function(){
      $timeout(changeOrder);
    });
  };
}

angular
  .module('app')
  .component('orderBy', orderByComponent);

},{}],286:[function(require,module,exports){
/** OVERFLOW TOOLTIP DIRECTIVE
 *
 *    <div overflow-tooltip="Some text"></div>
 *
 *    style: see _text.scss
 *
 *    @author   Andrew Bateman
 */
angular.module('app')
  .directive('overflowTooltip', ['$compile', '$sanitize', function($compile, $sanitize) {
    return {
      restrict : 'A',
      priority : 1,
      terminal : true,
      link: function(scope, element, attrs) {
        var text = attrs.overflowTooltip;
        text = $sanitize(text);
        element.text(text);
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        context.font = element.css('font-weight') + ' ' + element.css('font-size') + ' ' + element.css('font-family');
        if (context.measureText(text).width > element.width()) {
          // Add tooltip only if the rendered text is wider than the element
          element.attr('tooltip', text);
        }
        $compile(element, null, 1)(scope);
      }
    };
  }]);

},{}],287:[function(require,module,exports){
/** PAGER COMPONENT
 *
 *    <pager metadata="metadata" select-page="selectPage"></pager>
 *
 *    Requires metadata to include current_page and total_pages
 *
 *    @author   Andrew Bateman
 */
var pagerComponent = {
  bindings: {
    metadata: '<',
    selectPage: '<',
  },
  templateUrl: '/shared/pager/pager.html',
};

angular
  .module('app')
  .component('pager', pagerComponent);

},{}],288:[function(require,module,exports){
/** PAGINATE COMPONENT
 *
 *    Renders `meta` data as pagination.
 *    Allows the user to cycle through the pages, with
 *     with a debounced callback.
 *
 *    <paginate
 *      meta="$ctrl.meta"
 *      disabled="$ctrl.isLoading"
 *      debounce="500"
 *      on-paginate="$ctrl.updatePagination($event)"></paginate>
 *
 *    I added a "delay" to the pagination logic as I
 *     imagine there will be many people who will
 *     repeatedly click the prev / next buttons to cycle
 *     through their data. By using (and cancelling) a
 *     timeout we can avoid needless round-trips to the server.
 *
 *    Because of this, we manually update the "meta"
 *     object to match the data we _expect_ after
 *     a true call to the API. This allows the view to
 *     not have to do anything weird in order to deal
 *     with our strange delay logic. The meta object is
 *     updated with real data as soon as it's available.
 *
 *    META - Should be in the following format:
 *      meta: {
 *        page: 2,       // The current page
 *        page_size: 50, // The number of results per page
 *        total: 921,    // The total number of results
 *      }
 *
 *    @author   David "oodavid" King
 */
var paginateComponent = {
  controller: paginateComponentController,
  bindings: {
    meta: '<',
    disabled: '<?',
    debounce: '@?',
    onPaginate: '&',
  },
  templateUrl: '/shared/paginate/paginate.html',
};

paginateComponentController.$inject = ['$timeout'];
function paginateComponentController($timeout) {
  var ctrl = this;
  ctrl.changePage = changePage;
  ctrl.from;
  ctrl.to;
  ctrl.total;
  ctrl.prev;
  ctrl.next;
  ctrl.$onInit = parseMeta;
  ctrl.$onChanges = parseMeta;
  // Change the page number
  function changePage(pageDiff){
    if(ctrl.meta){
      ctrl.meta.page += pageDiff;
      parseMeta();
      debouncedPaginate();
    }
  }
  // Triggers pagination, with optional debounce
  var paginateTimeout;
  function debouncedPaginate() {
    if(!ctrl.debounce){
      paginate(); // Instant
    } else {
      if(paginateTimeout){
        $timeout.cancel(paginateTimeout);
      }
      paginateTimeout = $timeout(paginate, ctrl.debounce);
    }
  }
  // Triggers pagination
  function paginate(){
    ctrl.onPaginate({
      $event: {
        page: ctrl.meta.page,
      }
    });
  }
  // Parses the meta data
  function parseMeta(){
    if(!ctrl.meta){
      ctrl.from = false;
      ctrl.to = false;
      ctrl.total = false;
      ctrl.prev = false;
      ctrl.next = false;
    } else {
      // Massage - make sure we have a `page` value (old endpoints use `current_page`)
      ctrl.meta.page = ctrl.meta.page || ctrl.meta.current_page;
      // Massage `page_size`
      if(!ctrl.meta.hasOwnProperty('page_size')){
        ctrl.meta.page_size = 20;
        if('credentials_count' in ctrl.meta){
          ctrl.meta.page_size = 50; // All credentials
        } else if('provider_id' in ctrl.meta){
          ctrl.meta.page_size = 10; // Recipient Directory Search
        } else if('next_page' in ctrl.meta){
          ctrl.meta.page_size = 30; // Group Search
        }
      }
      // At this point we have a normalised structure
      var first = (ctrl.meta.page - 1) * ctrl.meta.page_size;
      ctrl.total = ctrl.meta.total || ctrl.meta.total_count;
      ctrl.from = (ctrl.total > 0) ? (first + 1) : 0; // If we have zero results, we don't want to show "1-0 of 0"
      ctrl.to = first + ctrl.meta.page_size;
      if (ctrl.to > ctrl.total) { // Are we "overflowing"?
        ctrl.to = ctrl.total;
      }
      ctrl.prev = ctrl.from > 1;
      ctrl.next = ctrl.to < ctrl.total;
    }
  }
}

angular
  .module('app')
  .component('paginate', paginateComponent);

},{}],289:[function(require,module,exports){
/** PAYMENT - COMPONENT
 *
 *      Renders `payment` component that allows the user
 *       to select an existing payment card, or add a new
 *       payment card.
 *
 *      You can treat this component as an "input".
 *      However, since it has a more complex UI than the
 *       typical input, I've not named it as an input.
 *
 *    Usage
 *
 *      <payment card="$ctrl.card"></payment>
 *
 *    @author   David "oodavid" King
 */
var paymentComponent = {
  controller: paymentComponentController,
  bindings: {
    card: '=',
  },
  require: {
    parentFormCtrl: '^form',
  },
  templateUrl: '/shared/payment/payment.html',
};

paymentComponentController.$inject = ['$timeout', 'BillingService'];

function paymentComponentController($timeout, BillingService) {
  var ctrl = this;
  ctrl.method; // `savedCard` or `newCard`
  ctrl.newCard = { customer: { address: {} } }; // newCard properties follows the stripe documentation https://stripe.com/docs/api/cards/object
  ctrl.savedCard = false; /* { last4, brand } */
  ctrl.loading = true;

  ctrl.$onInit = function () {
    ctrl.loading = true;
    ctrl.setMethod('newCard');
    BillingService
      .getSavedCard()
      .then(function (savedCard) {
        if (savedCard) {
          ctrl.savedCard = savedCard;
          ctrl.setMethod('savedCard');
        } else {
          ctrl.setMethod('newCard');
        }
      })
      .finally(function () {
        ctrl.loading = false;
      });
  }

  ctrl.setMethod = function (method) {
    ctrl.method = method;
    if (method == 'newCard') {
      $timeout(function () {
        $('#myCardNumber').focus();
      });
      ctrl.card = ctrl.newCard;
    } else {
      ctrl.card = false;
    }
  }

  ctrl.countries = [
    { name: 'United States', code: 'US' },
    { name: 'United Kingdom', code: 'GB' },
    { name: 'Canada', code: 'CA' },
    { name: 'France', code: 'FR' },
    { name: 'Italy', code: 'IT' },
    { name: 'Spain', code: 'ES' },
    { name: 'Germany', code: 'DE' },
    { name: 'Afghanistan', code: 'AF' },
    { name: 'Åland Islands', code: 'AX' },
    { name: 'Albania', code: 'AL' },
    { name: 'Algeria', code: 'DZ' },
    { name: 'American Samoa', code: 'AS' },
    { name: 'AndorrA', code: 'AD' },
    { name: 'Angola', code: 'AO' },
    { name: 'Anguilla', code: 'AI' },
    { name: 'Antarctica', code: 'AQ' },
    { name: 'Antigua and Barbuda', code: 'AG' },
    { name: 'Argentina', code: 'AR' },
    { name: 'Armenia', code: 'AM' },
    { name: 'Aruba', code: 'AW' },
    { name: 'Australia', code: 'AU' },
    { name: 'Austria', code: 'AT' },
    { name: 'Azerbaijan', code: 'AZ' },
    { name: 'Bahamas', code: 'BS' },
    { name: 'Bahrain', code: 'BH' },
    { name: 'Bangladesh', code: 'BD' },
    { name: 'Barbados', code: 'BB' },
    { name: 'Belarus', code: 'BY' },
    { name: 'Belgium', code: 'BE' },
    { name: 'Belize', code: 'BZ' },
    { name: 'Benin', code: 'BJ' },
    { name: 'Bermuda', code: 'BM' },
    { name: 'Bhutan', code: 'BT' },
    { name: 'Bolivia', code: 'BO' },
    { name: 'Bosnia and Herzegovina', code: 'BA' },
    { name: 'Botswana', code: 'BW' },
    { name: 'Bouvet Island', code: 'BV' },
    { name: 'Brazil', code: 'BR' },
    { name: 'British Indian Ocean Territory', code: 'IO' },
    { name: 'Brunei Darussalam', code: 'BN' },
    { name: 'Bulgaria', code: 'BG' },
    { name: 'Burkina Faso', code: 'BF' },
    { name: 'Burundi', code: 'BI' },
    { name: 'Cambodia', code: 'KH' },
    { name: 'Cameroon', code: 'CM' },
    { name: 'Cape Verde', code: 'CV' },
    { name: 'Cayman Islands', code: 'KY' },
    { name: 'Central African Republic', code: 'CF' },
    { name: 'Chad', code: 'TD' },
    { name: 'Chile', code: 'CL' },
    { name: 'China', code: 'CN' },
    { name: 'Christmas Island', code: 'CX' },
    { name: 'Cocos (Keeling) Islands', code: 'CC' },
    { name: 'Colombia', code: 'CO' },
    { name: 'Comoros', code: 'KM' },
    { name: 'Congo', code: 'CG' },
    { name: 'Congo, The Democratic Republic of the', code: 'CD' },
    { name: 'Cook Islands', code: 'CK' },
    { name: 'Costa Rica', code: 'CR' },
    { name: 'Cote D\'Ivoire', code: 'CI' },
    { name: 'Croatia', code: 'HR' },
    { name: 'Cuba', code: 'CU' },
    { name: 'Cyprus', code: 'CY' },
    { name: 'Czech Republic', code: 'CZ' },
    { name: 'Denmark', code: 'DK' },
    { name: 'Djibouti', code: 'DJ' },
    { name: 'Dominica', code: 'DM' },
    { name: 'Dominican Republic', code: 'DO' },
    { name: 'Ecuador', code: 'EC' },
    { name: 'Egypt', code: 'EG' },
    { name: 'El Salvador', code: 'SV' },
    { name: 'Equatorial Guinea', code: 'GQ' },
    { name: 'Eritrea', code: 'ER' },
    { name: 'Estonia', code: 'EE' },
    { name: 'Ethiopia', code: 'ET' },
    { name: 'Falkland Islands (Malvinas)', code: 'FK' },
    { name: 'Faroe Islands', code: 'FO' },
    { name: 'Fiji', code: 'FJ' },
    { name: 'Finland', code: 'FI' },
    { name: 'French Guiana', code: 'GF' },
    { name: 'French Polynesia', code: 'PF' },
    { name: 'French Southern Territories', code: 'TF' },
    { name: 'Gabon', code: 'GA' },
    { name: 'Gambia', code: 'GM' },
    { name: 'Georgia', code: 'GE' },
    { name: 'Ghana', code: 'GH' },
    { name: 'Gibraltar', code: 'GI' },
    { name: 'Greece', code: 'GR' },
    { name: 'Greenland', code: 'GL' },
    { name: 'Grenada', code: 'GD' },
    { name: 'Guadeloupe', code: 'GP' },
    { name: 'Guam', code: 'GU' },
    { name: 'Guatemala', code: 'GT' },
    { name: 'Guernsey', code: 'GG' },
    { name: 'Guinea', code: 'GN' },
    { name: 'Guinea-Bissau', code: 'GW' },
    { name: 'Guyana', code: 'GY' },
    { name: 'Haiti', code: 'HT' },
    { name: 'Heard Island and Mcdonald Islands', code: 'HM' },
    { name: 'Holy See (Vatican City State)', code: 'VA' },
    { name: 'Honduras', code: 'HN' },
    { name: 'Hong Kong', code: 'HK' },
    { name: 'Hungary', code: 'HU' },
    { name: 'Iceland', code: 'IS' },
    { name: 'India', code: 'IN' },
    { name: 'Indonesia', code: 'ID' },
    { name: 'Iran, Islamic Republic Of', code: 'IR' },
    { name: 'Iraq', code: 'IQ' },
    { name: 'Ireland', code: 'IE' },
    { name: 'Isle of Man', code: 'IM' },
    { name: 'Israel', code: 'IL' },
    { name: 'Jamaica', code: 'JM' },
    { name: 'Japan', code: 'JP' },
    { name: 'Jersey', code: 'JE' },
    { name: 'Jordan', code: 'JO' },
    { name: 'Kazakhstan', code: 'KZ' },
    { name: 'Kenya', code: 'KE' },
    { name: 'Kiribati', code: 'KI' },
    { name: 'Korea, Democratic People\'S Republic of', code: 'KP' },
    { name: 'Korea, Republic of', code: 'KR' },
    { name: 'Kuwait', code: 'KW' },
    { name: 'Kyrgyzstan', code: 'KG' },
    { name: 'Lao People\'S Democratic Republic', code: 'LA' },
    { name: 'Latvia', code: 'LV' },
    { name: 'Lebanon', code: 'LB' },
    { name: 'Lesotho', code: 'LS' },
    { name: 'Liberia', code: 'LR' },
    { name: 'Libyan Arab Jamahiriya', code: 'LY' },
    { name: 'Liechtenstein', code: 'LI' },
    { name: 'Lithuania', code: 'LT' },
    { name: 'Luxembourg', code: 'LU' },
    { name: 'Macao', code: 'MO' },
    { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
    { name: 'Madagascar', code: 'MG' },
    { name: 'Malawi', code: 'MW' },
    { name: 'Malaysia', code: 'MY' },
    { name: 'Maldives', code: 'MV' },
    { name: 'Mali', code: 'ML' },
    { name: 'Malta', code: 'MT' },
    { name: 'Marshall Islands', code: 'MH' },
    { name: 'Martinique', code: 'MQ' },
    { name: 'Mauritania', code: 'MR' },
    { name: 'Mauritius', code: 'MU' },
    { name: 'Mayotte', code: 'YT' },
    { name: 'Mexico', code: 'MX' },
    { name: 'Micronesia, Federated States of', code: 'FM' },
    { name: 'Moldova, Republic of', code: 'MD' },
    { name: 'Monaco', code: 'MC' },
    { name: 'Mongolia', code: 'MN' },
    { name: 'Montserrat', code: 'MS' },
    { name: 'Morocco', code: 'MA' },
    { name: 'Mozambique', code: 'MZ' },
    { name: 'Myanmar', code: 'MM' },
    { name: 'Namibia', code: 'NA' },
    { name: 'Nauru', code: 'NR' },
    { name: 'Nepal', code: 'NP' },
    { name: 'Netherlands', code: 'NL' },
    { name: 'Netherlands Antilles', code: 'AN' },
    { name: 'New Caledonia', code: 'NC' },
    { name: 'New Zealand', code: 'NZ' },
    { name: 'Nicaragua', code: 'NI' },
    { name: 'Niger', code: 'NE' },
    { name: 'Nigeria', code: 'NG' },
    { name: 'Niue', code: 'NU' },
    { name: 'Norfolk Island', code: 'NF' },
    { name: 'Northern Mariana Islands', code: 'MP' },
    { name: 'Norway', code: 'NO' },
    { name: 'Oman', code: 'OM' },
    { name: 'Pakistan', code: 'PK' },
    { name: 'Palau', code: 'PW' },
    { name: 'Palestinian Territory, Occupied', code: 'PS' },
    { name: 'Panama', code: 'PA' },
    { name: 'Papua New Guinea', code: 'PG' },
    { name: 'Paraguay', code: 'PY' },
    { name: 'Peru', code: 'PE' },
    { name: 'Philippines', code: 'PH' },
    { name: 'Pitcairn', code: 'PN' },
    { name: 'Poland', code: 'PL' },
    { name: 'Portugal', code: 'PT' },
    { name: 'Puerto Rico', code: 'PR' },
    { name: 'Qatar', code: 'QA' },
    { name: 'Reunion', code: 'RE' },
    { name: 'Romania', code: 'RO' },
    { name: 'Russian Federation', code: 'RU' },
    { name: 'RWANDA', code: 'RW' },
    { name: 'Saint Helena', code: 'SH' },
    { name: 'Saint Kitts and Nevis', code: 'KN' },
    { name: 'Saint Lucia', code: 'LC' },
    { name: 'Saint Pierre and Miquelon', code: 'PM' },
    { name: 'Saint Vincent and the Grenadines', code: 'VC' },
    { name: 'Samoa', code: 'WS' },
    { name: 'San Marino', code: 'SM' },
    { name: 'Sao Tome and Principe', code: 'ST' },
    { name: 'Saudi Arabia', code: 'SA' },
    { name: 'Senegal', code: 'SN' },
    { name: 'Serbia and Montenegro', code: 'CS' },
    { name: 'Seychelles', code: 'SC' },
    { name: 'Sierra Leone', code: 'SL' },
    { name: 'Singapore', code: 'SG' },
    { name: 'Slovakia', code: 'SK' },
    { name: 'Slovenia', code: 'SI' },
    { name: 'Solomon Islands', code: 'SB' },
    { name: 'Somalia', code: 'SO' },
    { name: 'South Africa', code: 'ZA' },
    { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
    { name: 'Sri Lanka', code: 'LK' },
    { name: 'Sudan', code: 'SD' },
    { name: 'Suriname', code: 'SR' },
    { name: 'Svalbard and Jan Mayen', code: 'SJ' },
    { name: 'Swaziland', code: 'SZ' },
    { name: 'Sweden', code: 'SE' },
    { name: 'Switzerland', code: 'CH' },
    { name: 'Syrian Arab Republic', code: 'SY' },
    { name: 'Taiwan, Province of China', code: 'TW' },
    { name: 'Tajikistan', code: 'TJ' },
    { name: 'Tanzania, United Republic of', code: 'TZ' },
    { name: 'Thailand', code: 'TH' },
    { name: 'Timor-Leste', code: 'TL' },
    { name: 'Togo', code: 'TG' },
    { name: 'Tokelau', code: 'TK' },
    { name: 'Tonga', code: 'TO' },
    { name: 'Trinidad and Tobago', code: 'TT' },
    { name: 'Tunisia', code: 'TN' },
    { name: 'Turkey', code: 'TR' },
    { name: 'Turkmenistan', code: 'TM' },
    { name: 'Turks and Caicos Islands', code: 'TC' },
    { name: 'Tuvalu', code: 'TV' },
    { name: 'Uganda', code: 'UG' },
    { name: 'Ukraine', code: 'UA' },
    { name: 'United Arab Emirates', code: 'AE' },
    { name: 'United States Minor Outlying Islands', code: 'UM' },
    { name: 'Uruguay', code: 'UY' },
    { name: 'Uzbekistan', code: 'UZ' },
    { name: 'Vanuatu', code: 'VU' },
    { name: 'Venezuela', code: 'VE' },
    { name: 'Viet Nam', code: 'VN' },
    { name: 'Virgin Islands, British', code: 'VG' },
    { name: 'Virgin Islands, U.S.', code: 'VI' },
    { name: 'Wallis and Futuna', code: 'WF' },
    { name: 'Western Sahara', code: 'EH' },
    { name: 'Yemen', code: 'YE' },
    { name: 'Zambia', code: 'ZM' },
    { name: 'Zimbabwe', code: 'ZW' }
  ];

  ctrl.states = [
    { code: 'AL', name: 'Alabama' },
    { code: 'AK', name: 'Alaska' },
    { code: 'AS', name: 'American Samoa' },
    { code: 'AZ', name: 'Arizona' },
    { code: 'AR', name: 'Arkansas' },
    { code: 'CA', name: 'California' },
    { code: 'CO', name: 'Colorado' },
    { code: 'CT', name: 'Connecticut' },
    { code: 'DE', name: 'Delaware' },
    { code: 'DC', name: 'District Of Columbia' },
    { code: 'FM', name: 'Federated States Of Micronesia' },
    { code: 'FL', name: 'Florida' },
    { code: 'GA', name: 'Georgia' },
    { code: 'GU', name: 'Guam' },
    { code: 'HI', name: 'Hawaii' },
    { code: 'ID', name: 'Idaho' },
    { code: 'IL', name: 'Illinois' },
    { code: 'IN', name: 'Indiana' },
    { code: 'IA', name: 'Iowa' },
    { code: 'KS', name: 'Kansas' },
    { code: 'KY', name: 'Kentucky' },
    { code: 'LA', name: 'Louisiana' },
    { code: 'ME', name: 'Maine' },
    { code: 'MD', name: 'Maryland' },
    { code: 'MA', name: 'Massachusetts' },
    { code: 'MI', name: 'Michigan' },
    { code: 'MN', name: 'Minnesota' },
    { code: 'MS', name: 'Mississippi' },
    { code: 'MO', name: 'Missouri' },
    { code: 'MT', name: 'Montana' },
    { code: 'NE', name: 'Nebraska' },
    { code: 'NV', name: 'Nevada' },
    { code: 'NH', name: 'New Hampshire' },
    { code: 'NJ', name: 'New Jersey' },
    { code: 'NM', name: 'New Mexico' },
    { code: 'NY', name: 'New York' },
    { code: 'NC', name: 'North Carolina' },
    { code: 'ND', name: 'North Dakota' },
    { code: 'MP', name: 'Northern Mariana Islands' },
    { code: 'OH', name: 'Ohio' },
    { code: 'OK', name: 'Oklahoma' },
    { code: 'OR', name: 'Oregon' },
    { code: 'PA', name: 'Pennsylvania' },
    { code: 'PR', name: 'Puerto Rico' },
    { code: 'RI', name: 'Rhode Island' },
    { code: 'SC', name: 'South Carolina' },
    { code: 'SD', name: 'South Dakota' },
    { code: 'TN', name: 'Tennessee' },
    { code: 'TX', name: 'Texas' },
    { code: 'UT', name: 'Utah' },
    { code: 'VT', name: 'Vermont' },
    { code: 'VI', name: 'Virgin Islands' },
    { code: 'VA', name: 'Virginia' },
    { code: 'WA', name: 'Washington' },
    { code: 'WV', name: 'West Virginia' },
    { code: 'WI', name: 'Wisconsin' },
    { code: 'WY', name: 'Wyoming' }
  ];
}

angular
  .module('app')
  .component('payment', paymentComponent);

},{}],290:[function(require,module,exports){
/** PERMISSIONS - DIRECTIVE
 *
 *    Checks that the user has the required permissions
 *     to click the element. This will prevent links, or
 *     other click-related actions.
 *
 *    "Permission" may be:
 *      The organization-features that have been paid for
 *      The user-permissions, as granted by their admin
 *
 *    ...each are handled differently, with paywall having
 *     priority over user-permissions.
 *
 *    @author   David "oodavid" King
 */
permissionsDirective.$inject = ['PermissionsService', 'FeaturesService', 'alertService', '$state', '$timeout'];
function permissionsDirective(PermissionsService, FeaturesService, alertService, $state, $timeout){
  return {
    restrict: 'A',
    scope: {
      permissions: '@',
    },
    link: function permissionsDirectiveLink(scope, element, attrs){
      var showPaywall = (FeaturesService.getFeature(scope.permissions) === false);
      var hasPermission = (!!PermissionsService.getPermission(scope.permissions));
      if(showPaywall || !hasPermission){
        // Add a tooltip
        if(showPaywall){
          // element.attr('tooltip', 'This is a premium feature. Click for more information.');
          element.addClass('paywall');
        } else {
          element.attr('tooltip', 'You don\'t have permission to access this. Check "My Account" for details.');
          element.addClass('not-allowed');
        }
        // Prevent default functionality
        removeAttrs(element);
        element.on('focus mouseover', function(e){
          removeAttrs(element);
        });
        element.on('click', function(e){
          removeAttrs(element);
          if(showPaywall){
            showPaywallAlert(scope.permissions);
          }
          e.stopImmediatePropagation();
          e.preventDefault();
        });
      }
    }
  };
  function removeAttrs(element){
    element.removeAttr('ng-click');
    element.removeAttr('onclick');
    element.removeAttr('href');
    element.removeAttr('ui-sref');
  }
  /** NOTA BENE
   *
   * I'm not keen on this approach, adding templates to the swalService
   *  would be the better decision. My initial tests on adding that to
   *  the swalService yielded some gnarly memory leaks *if* the template
   *  URL gave a 404. How? Because on our setup a 404 redirects to the
   *  index.html, which created a whole new angular app... Fun.
   *
   * It's something I'll add soon, but for the sake of this release I'm
   *  resigned to this View logic in a Directive. Apologies.
   *
   * @author David "oodavid" King
   */
  function showPaywallAlert(feature){
    var title = '';
    var description = '';
    var image = '<img src="/images/features/'+feature+'.png" width="180" height="180">';
    var pricingLinkTitle = 'Learn more';
    switch(feature){
      case 'spotlight_directory':
        title = 'The Spotlight Directory is a Premium Feature';
        description += '<p>The Spotlight Directory gives employers and other interested parties a powerful search of your credential recipients.</p>';
        description += '<p>Your recipients can customise their profile after receiving their credentials.</p>';
        description += '<p>This white labelled feature allows you to host the directory on a company subdomain, and even customise the data that your recipients can enter.</p>';
        break;
      case 'directory':
        title = 'The Recipient Directory is a Premium Feature';
        description += '<p>Allow third-party viewers to search all your certificate holders, advertising them as eligible employees or service-providers.</p>';
        description += '<p>Alternatively, configure your directory to show only verified matches for credentials you have issued, easing concerns about security and definitively answering the question &quot;Does this person really have your credential?&quot;</p>';
        break;
      case 'team':
        title = 'Team Member Permissions are a Premium Feature';
        description += '<p>Get help managing your designs, records, and settings by provisioning accounts for as many of your organization\'s team members as you would like.</p>';
        description += '<p>Set specific permission settings for each team member to control access to designs, data, and account features like billing.</p>';
        break;
      case 'branding_package':
        title = 'Branding Package is a Premium Feature';
        description += '<p>Give your credential recipients a branded credential experience, where it appears they never even leave your domain.</p>';
        description += '<p>Accredible will set up a subdomain at certificates.website.com (or any name you prefer) with your logo in the header and footer surrounding your credentials.</p>'
        break;
      case 'premium_whitelabel':
        title = 'Recipient Experience White Labelling is a Premium Feature';
        description += '<p>Give your credential recipients a completely custom experience, where the header, footer and style of the recipient site is tailored to exactly match your website\'s style.</p>';
        description += '<p>Accredible will set up and maintain a subdomain at certificates.website.com (or any name you prefer) so your credential holders see your name first and never forget where to find their credential.</p>';
        break;
      case 'is_customer':
        title = 'This is a Paid Feature';
        description += '<p>Some features are only available for active customers.</p><p>Please sign up for a plan to access this feature.</p>';
        break;
      case 'pathways_plan':
        image = '<img src="/images/features/pathway_completion.svg" width="180" height="180">';
        title = 'Learning Pathways';
        description += '<p>This feature is exclusively available to connect and growth plans. Upgrade now to create learning pathways and take your learning to the next level!</p>';
        description += '<p>By upgrading you will get:</p>' +
          '<ul class="pathways-plan">' +
          '  <li>Create and publish pathways</li>' +
          '  <li>Credential Auto-issuance</li>' +
          '  <li>Completion and advanced insights</li>' +
          '</ul>';
        pricingLinkTitle = 'Accredible pricing page';
        break;
      default:
        image = '<img src="/images/features/is_customer.png" width="180" height="180">';
        title = 'This is a Premium Feature';
        description += '<p>This feature is only available to premium customers.</p><p>To learn more about the available premium features and get a custom quote for a premium plan, see the...</p>';
        pricingLinkTitle = 'Accredible pricing page';
        break;
    }
    var hasBillingPermission = (!!PermissionsService.getPermission('billing'));
    if(!hasBillingPermission){
      description += '<p>Please contact your administrator to enable this feature.</p>';
    }
    description += '<p><a href="https://www.accredible.com/pricing/" target="_blank">' + pricingLinkTitle + '</a></p>';
    var html = '<div class="grid align-middle permissions-modal">';
    html += '<div>'+description+'</div>';
    html += '<div class="cling"><p>'+image+'</p></div>';
    html += '</div>';
    if(hasBillingPermission){
      alertService
        .open({
          title: title,
          content: html,
          ok: 'View your current plan',
          cancel: true,
        })
        .then(function() {
          $timeout(function(){
            $state.go('issuer.dashboard.billing.status');
          });
        })
        .catch(angular.noop);
    } else {
      alertService
        .alert(title, html);
    }
    $timeout(function(){}); // THis wierdness is needed to ensure the alert appears
  }
}

angular
  .module('app')
  .directive('permissions', permissionsDirective);

},{}],291:[function(require,module,exports){
/** PRICING ADDONS - COMPONENT
 *
 *      Renders `pricing-addons` component that allows the
 *       user to select which addons they want.
 *
 *      You can treat this component as an "input".
 *      However, since it has a more complex UI than the
 *       typical input, I've not named it as an input.
 *
 *    Usage
 *
 *      <pricing-addons addons="$ctrl.addons" set-upgraded="$ctrl.setUpgraded"></pricing-addons>
 *
 *    @author   David "oodavid" King
 *    @author   Andrew Bateman (refactored to remove dependancy on 'pricing.features')
 */
var pricingAddonsComponent = {
  controller: pricingAddonsComponentController,
  bindings: {
    addons: '=',
    setUpgraded: '<'
  },
  templateUrl: '/shared/pricing-addons/pricing-addons.html',
};

pricingAddonsComponentController.$inject = [];
function pricingAddonsComponentController() {
  var ctrl = this;

  ctrl.addToBasket = addToBasket;
  ctrl.removeFromBasket = removeFromBasket;
  ctrl.downgrade = false;
  ctrl.showDowngradeNotice = showDowngradeNotice;

  function addOnInBasket() {
    var inBasket = false;
    angular.forEach(ctrl.addons, function (addOn) {
      if (!inBasket && addOn.inBasket) {
        inBasket = true;
      }
    });
    return inBasket;
  }

  function addToBasket(addon) {
    addon.inBasket = true;
    if (ctrl.setUpgraded) {
      ctrl.setUpgraded(true);
    }
  }

  function removeFromBasket(addon) {
    addon.inBasket = false;
    if (ctrl.setUpgraded) {
      ctrl.setUpgraded(addOnInBasket());
    }
  }

  function showDowngradeNotice() {
    ctrl.downgrade = true;
  }
}

angular
  .module('app')
  .component('pricingAddons', pricingAddonsComponent);

},{}],292:[function(require,module,exports){
/** PRICING PLAN - COMPONENT
 *
 *      Renders `pricing-plan` component that allows the
 *       to select which pricing plan they would like to
 *       use.
 *
 *      You can treat this component as an "input".
 *      However, since it has a more complex UI than the
 *       typical input, I've not named it as an input.
 *
 *    Usage
 *
 *      <pricing-plan plans="$ctrl.plans" set-upgraded="$ctrl.setUpgraded"></pricing-plan>
 *
 *    @author   David "oodavid" King
 *    @author   Andrew Bateman (refactored to remove dependancy on 'pricing.features')
 */
var pricingPlanComponent = {
  controller: pricingPlanComponentController,
  bindings: {
    plans: '=',
    setUpgraded: '<'
  },
  templateUrl: '/shared/pricing-plan/pricing-plan.html',
};

pricingPlanComponentController.$inject = [];
function pricingPlanComponentController() {
  var ctrl = this;

  ctrl.currentPlan;
  ctrl.selectedPlan;

  function doSelectPlan(plan) {
    plan.inBasket = true;
    ctrl.selectedPlan = plan;
    if (ctrl.setUpgraded) {
      ctrl.setUpgraded(ctrl.selectedPlan.allowance > ctrl.currentPlan.allowance);
    }
  }

  ctrl.$onInit = function(){
    var activePlan;
    var smallestPlan;
    var validPLans = ['Trial', 'Launch 250', 'Small', 'Growth', 'Standard', 'Expansion'];
    angular.forEach(ctrl.plans, function (plan) {
      plan.legacy = !validPLans.includes(plan.name);
      // Find the smallest plan
      if (plan.price > 0) {
        if (!smallestPlan || plan.price < smallestPlan.price) {
          smallestPlan = plan;
        }
      }
      if (plan.active) {
        activePlan = plan;
        ctrl.currentPlan = activePlan;
        // If active plan is not trial, select it
        if (activePlan.price > 0) {
          doSelectPlan(activePlan);
        }
      }
      plan.isLarge = (plan.price > 2000);
    });
    // If no plan is selected, select the smallest plan
    if (!ctrl.selectedPlan) {
      doSelectPlan(smallestPlan);
    }
  };

  // Update the selected plan
  ctrl.selectPlan = function(plan) {
    if (plan.price > 0) {
      ctrl.selectedPlan.inBasket = false;
      doSelectPlan(plan);
    }
  };
}

angular
  .module('app')
  .component('pricingPlan', pricingPlanComponent);

},{}],293:[function(require,module,exports){
/** PRICING SUMMARY - COMPONENT
 *
 *      Renders `pricing-summary` component that allows the
 *       user to review their picing choicse and apply
 *       a discount code.
 *
 *      You can treat this component as an "input".
 *      However, since it has a more complex UI than the
 *       typical input, I've not named it as an input.
 *
 *    Usage
 *
 *      <pricing-summary plans="$ctrl.plans" addons="$ctrl.addons" coupon-code="$ctrl.coupon_code" set-updated="$ctrl.setUpdated"></pricing-summary>
 *
 *    @author   David "oodavid" King
 *    @author   Andrew Bateman (to handle Stripe 2 invoices)
 *    @author   Andrew Bateman (refactored to remove dependancy on 'pricing.features')
 */
var pricingSummaryComponent = {
  controller: pricingSummaryComponentController,
  bindings: {
    plans: '<',
    addons: '<', // Copied from 'issuer.organization.pricing' of '/organization/details' via 'resolvedPricing', updated by pricing-addons.component
    couponCode: '=',
    setUpdated: '<'
  },
  templateUrl: '/shared/pricing-summary/pricing-summary.html',
};

pricingSummaryComponentController.$inject = ['BillingService', 'moment'];
function pricingSummaryComponentController(BillingService, moment) {
  var ctrl = this;

  ctrl.$onChanges = onChanges;
  ctrl.$doCheck = doCheck; // Because 'plans' and `addons` are objects, the $onChanges event doesn't get called with deep changes
  ctrl.couponCodeChange = couponCodeChange;

  ctrl.isLoading = false;
  ctrl.invoice = {};

  var previousAddonsList;
  var addonlist = {};
  var previousSelectedPlanId;
  var selectedPlanId;

  function doCheck() {
    angular.forEach(ctrl.plans, function(plan, key) {
      if (plan.inBasket) {
        selectedPlanId = key;
      }
    });
    angular.forEach(ctrl.addons, function(addon, key) {
      addonlist[key] = addon.inBasket || addon.purchased;
    });
    if (previousSelectedPlanId != selectedPlanId || !angular.equals(previousAddonsList, addonlist)) {
      updateSummary();
    }
    previousSelectedPlanId = selectedPlanId;
    previousAddonsList = angular.copy(addonlist);
  }

  function onChanges() {
    updateSummary();
  }

  function couponCodeChange() {
    updateSummary();
  }

  function updateSummary() {
    if (selectedPlanId) {
      ctrl.isLoading = true;
      BillingService
        .getSummary(selectedPlanId, addonlist, ctrl.couponCode)
        .then(function (response) {
          ctrl.invoice = response.data.invoice;
          // Today's date
          ctrl.today = moment().format('YYYY-MM-DD');
          // Used to disable the 'Update Account' button
          if (ctrl.setUpdated) {
            ctrl.setUpdated(!!(ctrl.invoice.subscription_proration_date));
          }
          // Update the UI
          ctrl.isLoading = false;
        });
    }
  }
}

angular
  .module('app')
  .component('pricingSummary', pricingSummaryComponent);

},{}],294:[function(require,module,exports){
/** RATING METER COMPONENT
 *
 *    <rating-meter value="value" max="maximum value"></rating-meter>
 *
 *    This component shows a rating (or step-completeness) of "<value> out of <maximum value>".
 *    It is currently designed to use integers, i.e all values are rounded to the nearest integer
 *    and no partially complete "steps" are displayed.
 *
 *    @author Andrew Bateman
 */

var ratingMeterComponent = {
  controller: ratingMeterComponentController,
  bindings: {
    value: '<',
    max: '<'
  },
  templateUrl: '/shared/rating-meter/rating-meter.html'
};

function ratingMeterComponentController() {
  var ctrl = this;
  ctrl.steps = new Array();

  ctrl.$onInit = function() {
    var value = Math.round(ctrl.value);
    var max = Math.round(ctrl.max);
    for (var i = 0; i < max; i++) {
      if (i < value) {
        ctrl.steps.push({ index: i, class: 'active' });
      } else {
        ctrl.steps.push({ index: i, class: 'inactive' });
      }
    }
  };
}

angular.module('app').component('ratingMeter', ratingMeterComponent);

},{}],295:[function(require,module,exports){
// Module Dependencies
require('angular-recaptcha');
angular.module('app').requires.push('vcRecaptcha');

RecaptchaConfig.$inject = ['vcRecaptchaServiceProvider'];
function RecaptchaConfig(vcRecaptchaServiceProvider){
  vcRecaptchaServiceProvider.setSiteKey('6LcOWiETAAAAADQyIj7-BSOG8KNsnYIsV84jJDfM');
  vcRecaptchaServiceProvider.setTheme('light');
}

angular
  .module('app')
  .config(RecaptchaConfig);

},{"angular-recaptcha":4}],296:[function(require,module,exports){
/** ROUTER CLASS - DIRECTIVE
 *
 *      Dynamically sets the "class" of the element
 *       to match the current ui-router route.
 *
 *      Usage:
 *          <body router-class></body>
 *          <div router-class></div>
 */
routerClassDirective.$inject = ['$transitions'];
function routerClassDirective($transitions){
  return {
    restrict: 'A', // Attribute Only
    scope: {}, // isolate
    link: routerClassDirectiveLink,
  };
  var lastClass;
  function routerClassDirectiveLink(scope, element, attrs) {
    $transitions.onSuccess({}, function($transition){
      var newClass = $transition.to().name;
      newClass = newClass.replace(/\./g, '-'); // Strip unusual chars
      if(lastClass){
        element.removeClass(lastClass);
      }
      element.addClass(newClass);
      lastClass = newClass;
    });
  }
}

angular
  .module('app')
  .directive('routerClass', routerClassDirective);

},{}],297:[function(require,module,exports){
routerScrollRun.$inject = ['$transitions'];
function routerScrollRun($transitions){
  // Scroll to the top of the page on view change
  function scrollToTop($transition) {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  $transitions.onSuccess({}, scrollToTop);
}

angular
  .module('app')
  .run(routerScrollRun);

},{}],298:[function(require,module,exports){
/** SAVE BUTTON - DIRECTIVE
 *
 *      Abstracts the various "states" that the save button has, that
 *       reflect the dirty / pristine / submitted / valid / invalid form.
 *
 *      Usage:
 *          <save-button></save-button>
 *
 *      @author   David "oodavid" King
 */
saveButtonDirective.$inject = ['$timeout'];
function saveButtonDirective($timeout){
  return {
    restrict: 'E', // Element Only
    require: '^form',
    scope: {}, // isolate
    templateUrl: '/shared/save-button/save-button.html',
    link: function(scope, element, attrs, formCtrl) {
      scope.formCtrl = formCtrl; // Expose the form Controller to the button
      // See `submit-validate` for showError and showSuccess
    }
  };
}

angular
  .module('app')
  .directive('saveButton', saveButtonDirective);

},{}],299:[function(require,module,exports){
var saveStatusComponent = {
  controller: saveStatusComponentController,
  templateUrl: '/shared/save-status/save-status.html',
  require: {
    parentFormCtrl: '^form',
  }
};

saveStatusComponentController.$inject = ['$scope', '$element'];
function saveStatusComponentController($scope, $element) {
  var ctrl = this;

  // Inform the containing page that the form is (or is not) dirty
  var endWatch = $scope.$watch(
    function() {
      return ctrl.parentFormCtrl.$dirty;
    },
    function(dirty) {
      $element.trigger('formdirty', dirty);
    }
  );

  // Clean up
  ctrl.$onDestroy = function() {
    endWatch();
  };
}

angular
  .module('app')
  .component('saveStatus', saveStatusComponent);

},{}],300:[function(require,module,exports){
/** OVERFLOW TOOLTIP DIRECTIVE
 *
 *    <div scale-text>Text to fit goes here</div>
 *
 *    style: see _text.scss
 *
 *    @author   Andrew Bateman
 */
angular.module('app')
  .directive('scaleText', ['$interpolate', '$window', '_', function($interpolate, $window, _) {
    return {
      restrict : 'A',
      priority : 1,
      terminal : true,
      link: function(scope, element) {
        var text = $interpolate(element.text())(scope);
        element.text(text);
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        var fontWeight = element.css('font-weight');
        var originalFontSize = parseFloat(getComputedStyle(element[0]).fontSize);
        var fontFamily = element.css('font-family');
        function adjustFontSize() {
          var fontSize = originalFontSize;
          context.font = fontWeight + ' ' + fontSize + 'px ' + fontFamily;
          while (context.measureText(text).width > element.width())
          {
            fontSize = fontSize - 1;
            context.font = fontWeight + ' ' + fontSize + 'px ' + fontFamily;
          }
          if (fontSize < originalFontSize) {
            element.css('font-size', Math.floor(fontSize) + 'px');
          } else {
            element.css('font-size', ''); // Removes style previously applied
          }
        }
        adjustFontSize();
        // Debounced update (for window.resize event)
        var debouncedAdjustFontSize = _.debounce(adjustFontSize, 1000, {
          leading: false,
          trailing: true
        });
        // Initialization
        angular.element($window).bind('resize', debouncedAdjustFontSize);
        // Clean up
        scope.$on('$destroy', function() {
          angular.element($window).unbind('resize', debouncedAdjustFontSize);
        });
      }
    };
  }]);

},{}],301:[function(require,module,exports){
scrollSpyRun.$inject = ['$rootScope', 'urlService', '_'];
function scrollSpyRun($rootScope, urlService, _){

  // Watch for hash changes
  $rootScope.$on('$locationChangeStart', scrollSpyHashChangeSmooth);

  // Watch for scolling (throttled, for speed)
  $('body').on("mousewheel DOMMouseScroll", _.throttle(scrollSpyHighlightLinks, 150));

  // Calculates the yOffset for any fixed nav elements
  var yOffset = 0;
  function scrollSpyUpdateOffset(){
    yOffset = 16; // Why 16px? that's our default vertical margin (see: _containers.scss)
    $.each($('.acc-push'), function(index, el){
      yOffset += $(el).height();
    });
  }

  // Adds smooth scrolling for hash change events
  function scrollSpyHashChangeSmooth(event, newUrl, oldUrl){
    scrollSpyUpdateOffset();
    var oldUrl = urlService.parse(oldUrl);
    var newUrl = urlService.parse(newUrl);
    // ...same path, different hash
    if(oldUrl.pathName === newUrl.pathName && oldUrl.hash !== newUrl.hash){
      // Prevent window.location from updating
      event.preventDefault();
      // Get the target element
      var hash = newUrl.hash.replace('#!#', '#') // Cater for SLA hashbang prefix
      var target = $(hash);
      var top = target.offset().top;
      // Scroll smoothly
      $("html, body").animate({ scrollTop: (top-yOffset)+'px' }, scrollSpyHighlightLinks);
      // Highlight the target
      $('.spy-target').removeClass('spy-target');
      target.addClass('spy-target');
    } else {
      // Just highlight
      scrollSpyHighlightLinks();
    }
  }

  // Highlight the visible scroll
  var sections = [];
  function scrollSpyHighlightLinks(){
    scrollSpyUpdateOffset();
    sections.length = 0;
    // All hash links on the page
    var links = $('a[href^="#"]');
    // Get the `offset` value for each target
    links.each(function(linkIndex, linkElement){
      try{
        var targetId = $(linkElement).attr('href').replace('#!#', '#'); // Cater for SLA hashbang prefix
        var $targetElement = $(targetId);
        if($targetElement.length){
          sections.push({
            link: $(linkElement),
            top: $targetElement.offset().top,
          });
        }
      } catch(e){
        // do nothing
      }
    });
    // Sort by `top`
    _.sortBy(sections, [function(section) { return - section.top; }]);
    // Find the first element in view
    var windowTop =$(window).scrollTop() + yOffset + 10; // 10 is wiggle room
    var firstIndex = _.findIndex(sections, function(section) { return section.top > windowTop; });
    if(firstIndex){
      firstIndex --;
    }
    var first = sections[firstIndex];
    // Highlight
    if(first){
      links.removeClass('active');
      first.link.addClass('active');
    }
  }

}

angular
  .module('app')
  .run(scrollSpyRun);

},{}],302:[function(require,module,exports){
/** SCROLL BLOCKING
 *
 *      This script allows the user to scroll any element
 *       with a class of .scroll-blocking WITHOUT scrolling
 *       the page below at the extremeties.
 *
 *          https://youtu.be/S_EWmKb7VVU
 *
 *      @author   David "oodavid" King
 */
$(document).ready(function() {
  $('body').on("mousewheel DOMMouseScroll", function(e) {
    // Find an ancestor with scroll-blocking
    var el = $(e.target).closest('.scroll-blocking');
    if (el.length) {
      if ($('body').css('overflow') != 'hidden') {
        $('body').css('overflow', 'hidden');
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    } else {
      $('body').css('overflow', '');
    }
  });
});

},{}],303:[function(require,module,exports){
/** SELECT ALL - COMPONENT
 *
 *    Allows the user to select all rows
 *
 *    See: <selectable>
 *
 *    @author   David "oodavid" King
 */
var selectAllComponent = {
  controller: selectAllComponentController,
  bindings: {},
  require: {
    selectable: '^selectable'
  },
  template: '<i class="multiselect" ng-class="$ctrl.state | iconMultiselect"></i>',
};

selectAllComponentController.$inject = ['$element', '$timeout'];
function selectAllComponentController($element, $timeout) {
  var ctrl = this;
  ctrl.$onInit = $onInit;
  ctrl.$onDestroy = $onDestroy;
  ctrl.$postLink = $postLink;
  ctrl.state = 'none';

  function toggleSelectAll(){
    ctrl.selectable.toggleSelectAll();
  }
  function $onInit(){
    ctrl.selectable.onStateChange(handleState); // Register with the parent <selectable> component
  }
  function handleState(state){
    ctrl.state = state;
  }
  function $onDestroy(){
    ctrl.selectable.onStateChange(); // Un-register from the parent <selectable> component
  }
  function $postLink(){
    var cell = $element.closest('th, td');
    cell.bind('click', function(event){
      $timeout(toggleSelectAll);
    });
  }
}

angular
  .module('app')
  .component('selectAll', selectAllComponent);

},{}],304:[function(require,module,exports){
/** SELECT ATTRIBUTE - DIRECTIVE
 *
 *      Usage:
 *        <select-attribute
 *          attribute-in-use="attributeInUse(attribute)"
 *          attribute-click="selectAttribute(attribute)">
 *        </select-attribute>
 *
 *      @author   David "oodavid" King
 */

 var selectAttributeComponent = {
  controller: selectAttributeComponentController,
  templateUrl: '/shared/select-attribute/select-attribute.html',
  bindings: {
    inUse: '&?attributeInUse',
    doClick: '&?attributeClick',
  },
};

selectAttributeComponentController.$inject = ['attributeService', 'upsertAttributeModalService'];
function selectAttributeComponentController(attributeService, upsertAttributeModalService) {
  var ctrl = this;

  ctrl.attributeGroups;
  ctrl.attributeInUse = attributeInUse;
  ctrl.selectAttribute = selectAttribute;
  ctrl.addAttribute = addAttribute;

  // Read the attributes from the service
  attributeService
    .getNestedAttributes()
      .then(function(myAttributes) {
        ctrl.attributeGroups = myAttributes;
    });

  // Relay the callback to the consumer method
  function attributeInUse(attribute) {
    return ctrl.inUse({
      attribute: attribute,
    });
  }

  // ...same for the click
  function selectAttribute(attribute) {
    ctrl.doClick({
      attribute: attribute,
    });
  }

  function updateAttributes() {
    attributeService
      .getNestedAttributes(true)
      .then(function (myAttributes) {
        ctrl.attributeGroups = myAttributes;
      });
  }

  // Add an attribute
  function addAttribute() {
    upsertAttributeModalService.show(null, ctrl.selectAttribute, updateAttributes);
  }

}

angular
  .module('app')
  .component('selectAttribute', selectAttributeComponent);






 /*
(function() {
  angular
    .module('app')
    .directive('selectAttribute', ['attributeService', 'upsertAttributeModalService', function(attributeService, upsertAttributeModalService) {
      // Controller logic
      var controller = ['$scope', function($scope) {
        // Read the attributes from the service
        var attributes = [];
        attributeService.getAttributesList()
          .then(function(myAttributes) {
            $scope.attributes = myAttributes;
        });
        // Relay the callback to the consumer method
        $scope.attributeInUse = function(attribute) {
          return $scope.inUse({
            attribute: attribute,
          });
        };
        // ...same for the click
        $scope.selectAttribute = function(attribute) {
          $scope.doClick({
            attribute: attribute,
          });
        };
        // Add an attribute
        $scope.addAttribute = function() {
          upsertAttributeModalService.show(null, $scope.selectAttribute);
        };
      }];
      return {
        restrict: 'A', // Attribute only
        replace: true,
        templateUrl: '/shared/selectAttributeTpl.html',
        scope: {
          inUse: '&?attributeInUse',
          doClick: '&?attributeClick',
        },
        controller: controller,
      };
    }]);
})();

*/

},{}],305:[function(require,module,exports){
/** ROW SELECT - COMPONENT
 *
 *    Allows the user to select a row
 *
 *    See: <selectable>
 *
 *    @author   David "oodavid" King
 */
var selectRowComponent = {
  controller: selectRowComponentController,
  bindings: {
    id: '<',
  },
  require: {
    selectable: '^selectable'
  },
  template: '<i class="select" ng-class="$ctrl.selected | iconSelected"></i>',
};

selectRowComponentController.$inject = ['$element', '$timeout'];
function selectRowComponentController($element, $timeout) {
  var ctrl = this;
  ctrl.$onInit = $onInit;
  ctrl.$onDestroy = $onDestroy;
  ctrl.$postLink = $postLink;

  function $onInit(){
    ctrl.selectable.addId(ctrl.id, handleToggle); // Register with the parent <selectable> component
  }
  function handleToggle(selected){
    ctrl.selected = selected;
    var row = $element.closest('tr');
    if(ctrl.selected){
      row.addClass('selected');
    } else {
      row.removeClass('selected');
    }
  }
  function $onDestroy(){
    ctrl.selectable.removeId(ctrl.id); // Un-register from the parent <selectable> component
  }
  function toggleSelect(){
    ctrl.selectable.toggleRow(ctrl.id); // Notify the parent <selectable> component
  }
  function multiselect(){
    if(ctrl.selectable.multiselect === 'select'){
      ctrl.selectable.selectRow(ctrl.id); // Notify the parent <selectable> component
    } else {
      ctrl.selectable.deselectRow(ctrl.id); // Notify the parent <selectable> component
    }
  }
  function $postLink(){
    var row = $element.closest('tr');
    var cell = $element.closest('th, td');
    // Mousedown on the CHECKBOX cell will trigger multiselect
    // ...see <selectable> for mouseup logic
    ctrl.selectable.multiselect = false;
    cell.bind('mousedown', function(event){
      ctrl.selectable.multiselect = (ctrl.selected ? 'deselect' : 'select');
      $timeout(multiselect);
    });
    row.bind('mouseenter', function(event){
      if(ctrl.selectable.multiselect){
        clearTextSelection();
        $timeout(multiselect);
      }
    });
    // Clicking the row will select
    row.bind('click', function(event){
      if(ctrl.selectable.multiselect){
        return; // Do nothing if we're doing multiselect
      }
      var parentsAndTarget = $(event.target).parentsUntil(event.currentTarget).addBack(); //
      if(parentsAndTarget.filter(':input, a').length > 0){
        return; // Do nothing if we've clicked something interactive, like a link or button etc.
      }
      $timeout(toggleSelect);
    });
  }
  // Clear the text selection (for multiselect)
  function clearTextSelection(){
    if (window.getSelection) {
      if (window.getSelection().empty) {  // Chrome
        window.getSelection().empty();
      } else if (window.getSelection().removeAllRanges) {  // Firefox
        window.getSelection().removeAllRanges();
      }
    } else if (document.selection) {  // IE?
      document.selection.empty();
    }
  }
}

angular
  .module('app')
  .component('selectRow', selectRowComponent);

},{}],306:[function(require,module,exports){
/** SELECTABLE - COMPONENT
 *
 *    Container component that adds row-selection
 *
 *    Usage
 *
 *      <selectable title="Credentials" meta="$ctrl.meta" loading="$ctrl.loading" on-selection="$ctrl.updateSelection($event)">
 *        ...
 *        <th>
 *          <select-all></select-all>
 *        </th>
 *        ...
 *        <tr ng-repeat="row in $ctrl.rows">
 *          <td>
 *            <select-row id="row.id"></select-row>
 *          </td>
 *        </tr>
 *        ...
 *      </selectable>
 *
 *    @author   David "oodavid" King
 */
var selectableComponent = {
  controller: selectableComponentController,
  transclude: true,
  bindings: {
    title: '@',
    meta: '<',
    loading: '<',
    onSelection: '&',
  },
  templateUrl: '/shared/selectable/selectable.html',
};

selectableComponentController.$inject = ['_', '$timeout'];
function selectableComponentController(_, $timeout) {
  var ctrl = this;
  ctrl.$onInit = $onInit;
  ctrl.$onChanges = $onChanges;
  ctrl.addId = addId;
  ctrl.removeId = removeId;
  ctrl.toggleRow = toggleRow;
  ctrl.deselectRow = deselectRow;
  ctrl.selectRow = selectRow;
  ctrl.onStateChange = onStateChange;
  ctrl.toggleSelectAll = toggleSelectAll;
  ctrl.selectEverything = selectEverything;
  ctrl.selectNothing = selectNothing;
  ctrl.numSelected;
  ctrl.state = 'none'; // How many rows are selected? 'none', 'one', 'some', 'visible', 'everything'
  ctrl.multiselect = false; // See: <select-row>

  var ids = {}; // A hash of ids with { id, selected, callback }

  function $onInit(){
    ctrl.onSelection({ $event: { selection: false } }); // Nothing selected
    // See: <select-row>
    $(document).bind('mouseup', function(event){
      $timeout(function(){
        ctrl.multiselect = false;
      });
    });
  }

  function $onChanges(changes){
    if(changes.loading){
      selectNothing();
    }
  }

  // Selection methods
  function toggleRow(id){
    if(ids[id].selected){
      deselectRowSubroutine(id);
    } else {
      selectRowSubroutine(id);
    }
    setState();
  }
  function selectRow(id){
    selectRowSubroutine(id)
    setState();
  }
  function deselectRow(id){
    deselectRowSubroutine(id)
    setState();
  }
  function selectVisible(){
    angular.forEach(ids, function(state, id){
      selectRowSubroutine(id);
    });
    setState();
  }
  function selectNothing(){
    angular.forEach(ids, function(state, id){
      deselectRowSubroutine(id);
    });
    setState();
  }
  function selectEverything(){
    selectVisible();
    setState('everything');
  }
  function toggleSelectAll(){
    if(ctrl.state === 'everything' || ctrl.state === 'visible'){
      selectNothing();
    } else {
      selectVisible();
    }
  }
  // ^ Subroutines
  function selectRowSubroutine(id){
    ids[id].selected = true;
    ids[id].callback(true);
  }
  function deselectRowSubroutine(id){
    ids[id].selected = false;
    ids[id].callback(false);
  }

  // The child components (<select-row> and <select-all>) use these methods to register themselves to this container component
  function addId(id, callback){
    ids[id] = {
      id: id,
      selected: false,
      callback: callback, // the component needs to be notified whenever the value changes, hence the callback
    };
    throttleSetState();
  }
  function removeId(id){
    delete ids[id];
    throttleSetState();
  }
  var stateChangeCallback;
  function onStateChange(callback){
    stateChangeCallback = callback; // Brutal
  }

  // Sets the state and triggers listeners
  function setState(stateOverride){
    var state;
    var tally = _.countBy(ids, 'selected'); // If we're not given a state, guess it based on the selection
    if(!tally.false && tally.true){
      state = 'visible';
    } else if (!tally.true) {
      state = 'none';
    } else if (tally.true === 1) {
      state = 'one';
    } else {
      state = 'some';
    }
    ctrl.numSelected = tally.true;
    // Everything only makes sense if all the visible items are selected
    if (stateOverride === 'everything' && state === 'visible'){
      state = 'everything';
    }
    ctrl.state = state;
    // Pull out the value
    var value;
    if(state === 'none'){
      value = false;
    } else if(state === 'everything'){
      value = 'everything';
    } else {
      value = _(ids).filter({ 'selected': true }).map('id').value(); // Array of ids
    }
    ctrl.onSelection({ $event: { selection: value } });
    // Notify the <select-all> component
    if(stateChangeCallback){
      stateChangeCallback(state);
    }
  }

  // Throttled set state - prevents multiple calls firing in the same digest
  var throttle = false;
  function throttleSetState(){
    if(throttle){
      return;
    }
    throttle = $timeout(function(){
      throttle = false;
      setState();
    });
  }
}

angular
  .module('app')
  .component('selectable', selectableComponent);

},{}],307:[function(require,module,exports){
/** SUBMIT / VALIDATE - DIRECTIVE
 *
 *      Unifies the way that forms are handled on ACMS, use
 *       this as an alternative to `ng-submit` to add some
 *       standardized validaton and feedback. The idea is to
 *       remove our controllers from handling basic validation,
 *       leaving just business logic.
 *
 *      Usage:
 *          <form submit-validate="callback"></form> -- automatically triggered with `formCtrl` as the first argument
 *          <form submit-validate="callback(formCtrl, 'staticVar', localVar)"></form>
 *
 *      Notes:
 *          This caters for nested forms (using `ng-form`).
 *          We use just such a mechanism on the add-credentials
 *           pages, where we have an `ng-form` for each
 *           credential we are adding.
 *
 *      References:
 *          https://gist.github.com/maikeldaloo/5133963
 *          https://github.com/angular/angular.js/blob/07849779ba365f371a8caa3b58e23f677cfdc5ad/src/ng/directive/ngEventDirs.js#L48
 *          ... this one's not overly obvious, but it demonstrates the general method that angular creates the standard ng-eventname="" directives
 *
 *      @author   David "oodavid" King
 *
 *      @todo
 *        SAVE > Consider adding CMD+ENTER to submit the form
 */
submitValidateDirective.$inject = ['$timeout', 'alertService'];
function submitValidateDirective($timeout, alertService) {
  return {
    restrict: 'A', // Attribute only
    require: '^form',
    link: submitValidateLink,
    scope: {
      callback: '&submitValidate',
      ignoreEnter: '<?'
    },
  };
  // Recursive input dirtying
  function dirtyInputsRecursive(formCtrl) {
    formCtrl.$getControls().forEach(function(obj) {
      if (obj.$name) {
        // Dirty the input (or ng-form)
        if (obj.hasOwnProperty('$dirty') && obj.hasOwnProperty('$touched')) {
          obj.$setDirty();
          obj.$setTouched();
        }
        // Recurse into the ng-form
        if (obj.$$controls) {
          dirtyInputsRecursive(obj);
        }
      }
    });
  }
  // Add a submit event when the element is ready
  function submitValidateLink(scope, element, attrs, formCtrl) {
    // Add 'novalidate'
    attrs.$set('novalidate', 'novalidate');
    // If required, ignore enter key presses
    if (scope.ignoreEnter) {
      element.bind('keydown', function(event) {
        // If enter key was pressed on a form element, prevent that key press from submitting the form and click on the element instead
        if (event.key === 'Enter' && event.target !== event.currentTarget) {
          event.preventDefault();
          $(event.target).click();
        }
      });
    }
    // Search DOM for label
    function getLabelFor($el) {
      var id = $el.attr('id');
      var text = null;
      if (id) {
        text = $('label[for="' + id + '"]').text();
      } else {
        id = $el.attr('access-id');
        if (id) {
          text = $('label[id="' + id + '-label"]').text();
        } else {
          text = $el.attr('aria-label');
        }
      }
      return text;
    }
    // From https://stackoverflow.com/questions/6520192/how-to-get-the-text-node-of-an-element
    // Returns the text of the first, non-blank text node or span
    function getFirstNodeText($el) {
      return $el.contents().filter(function() {
        return (this.nodeType == Node.TEXT_NODE && !/^\s+$/.test($(this).text())) || (this.nodeType == Node.ELEMENT_NODE && this.tagName == 'SPAN');
      }).first().text().trim();
    }
    // Collate errors from form (and sub-forms!)
    function collateErrors(formErrors, control) {
      control.$getControls().forEach(function(subControl) {
        if (subControl.$invalid) {
          if (subControl.$$controls) {
            collateErrors(formErrors, subControl);
          } else {
            var detectedError = false;
            var el = subControl.$$element;
            $.each(subControl.$error, function(key, value) {
              if (value && !detectedError) {
                formErrors.push({
                  label: getLabelFor(el) || getFirstNodeText(el.closest('label')),
                  key: key,
                  translateValues: {
                    min: el.attr('min'),
                    max: el.attr('max'),
                    minlength: el.attr('minlength') || el.attr('ng-minlength'),
                    maxlength: el.attr('maxlength') || el.attr('ng-maxlength'),
                    step: el.attr('step'),
                  }
                });
                detectedError = true;
              }
            });
          }
        } else if (subControl.$$element[0].tagName.toLowerCase() === 'input-recaptcha' && !subControl.$viewValue) { // Handle recaptcha
          formErrors.push({ label: getLabelFor(subControl.$$element), key: 'required' });
        }
      });
    }
    // Add a submit event
    element.bind('submit', function(event) {
      // Trigger digest
      $timeout(function() {
        // We want the form to be dirty, but not submitted
        formCtrl.$setPristine();
        formCtrl.$setDirty();
        // Recursive input dirtying
        dirtyInputsRecursive(formCtrl);
        // Quit if invalid
        if (formCtrl.$invalid) {
          var formErrors = [];
          collateErrors(formErrors, formCtrl);
          // ...throw an alert by default
          if(!attrs.hasOwnProperty('noAlert')){
            // z-index should be higher than the forms inside modals
            alertService.warning('@:FORM_INVALID_PLEASE_CHECK_FORM', formErrors, 2000);
          }
          return;
        }
        // Flag the form
        formCtrl.$setSubmitted();
        // Trigger the callback
        if(attrs.submitValidate.indexOf('(') !== -1){
          scope.callback({ formCtrl: formCtrl }); // Using expression binding
        } else {
          var expressionHandler = scope.callback();
          expressionHandler(formCtrl); // Manually trigger the function passing formCtrl as the only argument
        }
      });
    });
    // Add a `submitValidate()` method to the form Controller
    formCtrl.submitValidate = submitValidate;
    function submitValidate(){
      element.triggerHandler('submit');
    }
    // Modify the form Controller, so the consumer can notify us of successes
    // Usage? See <save-button>
    formCtrl.saveSuccess = saveSuccess;
    function saveSuccess(){
      formCtrl.$setPristine();
      formCtrl.$submittedWithError = false;
      formCtrl.showSuccess = true;
      $timeout(function(){
        formCtrl.showSuccess = false;
      }, 1000);
    }
    formCtrl.saveError = saveError;
    function saveError(){
      formCtrl.$submittedWithError = true;
    }
  }
}

angular
  .module('app')
  .directive('submitValidate', submitValidateDirective);

},{}],308:[function(require,module,exports){
var svgEditorArrangeComponent = {
  controller: svgEditorArrangeComponentController,
  require: {
    editor: '^svgEditor'
  },
  bindings: {
    selection: '<',
  },
  templateUrl: '/shared/svg-editor/_js/svg-editor-arrange.html',
};

svgEditorArrangeComponentController.$inject = [];
function svgEditorArrangeComponentController() {
  var ctrl = this;

  ctrl.isVisible = true;
  ctrl.canMoveBackward = false;
  ctrl.canMoveForward = true;
  ctrl.moveBackward = moveBackward;
  ctrl.moveForward = moveForward;

  function moveBackward(){
    var prev = $(ctrl.selection).prev();
    prev.before($(ctrl.selection));
    canMove();
    ctrl.editor.saveState();
  }
  function moveForward(){
    var next = $(ctrl.selection).next();
    next.after($(ctrl.selection));
    canMove();
    ctrl.editor.saveState();
  }

  function canMove(){
    if(ctrl.selection){
      var prev = $(ctrl.selection).prevAll();
      var next = $(ctrl.selection).nextAll();
      ctrl.canMoveBackward = prev.length && prev[0].nodeName !== 'style';
      ctrl.canMoveForward  = next.length;
    } else {
      ctrl.canMoveBackward = false;
      ctrl.canMoveForward = false;
    }
  }

  ctrl.$onChanges = function(changes){
    ctrl.isVisible = !!ctrl.selection;
    canMove();
  }
}

angular
  .module('app')
  .component('svgEditorArrange', svgEditorArrangeComponent);

},{}],309:[function(require,module,exports){
var svgEditorColorsComponent = {
  controller: svgEditorColorsComponentController,
  require: {
    editor: '^svgEditor'
  },
  bindings: {
    selection: '<',
    qrCode: '<',
    palette: '<?'
  },
  templateUrl: '/shared/svg-editor/_js/svg-editor-colors.html',
};

svgEditorColorsComponentController.$inject = ['_', '$timeout', 'svgService'];
function svgEditorColorsComponentController(_, $timeout, svgService) {
  var ctrl = this;
  ctrl.$onChanges = $onChanges;
  ctrl.$onDestroy = $onDestroy;
  // Rendering
  ctrl.isVisible = true;
  // Selection colors
  ctrl.colorGroups = [
    // ...the index matches the [fill-id] of the elements
    // { color: '#abcdef', elements: [el, el, el] }
  ];
  ctrl.onColorChange = onColorChange;
  ctrl.onColorMove = onColorMove;
  ctrl.pickColor = pickColor;

  // When the selection changes, update our local objects
  function $onChanges(changes){
    if(changes.selection){
      ctrl.colorGroups = [];
      // Select
      ctrl.isVisible = ctrl.selection && $(ctrl.selection).find('textPath').length === 0;
      if (ctrl.isVisible) {
        // Extract all child elements with a `fill` attribute (include the element itself)
        var elements = $(ctrl.selection).find('[fill]').addBack('[fill]');
        // Loop and group
        $.each(elements, function(index, element){
          var color = $(element).attr('fill');
          var fillId = $(element).attr('fill-id');

          // What's the deal with [fill-id]? See: https://youtu.be/-RbRBiWA6Vg
          // ...we group by [fill-id] - create it, if necessary
          if(!fillId){
            fillId = _.findIndex(ctrl.colorGroups, { color: color }); // See if we have a matching color, and use the same index
            if(fillId == -1){
              fillId = ctrl.colorGroups.length; // Use a new id if there's no matching color
            }
            $(element).attr('fill-id', fillId);
          }
          // Make sure the color exists
          if(!ctrl.colorGroups[fillId]){
            ctrl.colorGroups.push({ color: color, elements: [] });
          }
          // Add the element to the color
          ctrl.colorGroups[fillId].elements.push(element);
        });
      }
      // Active?
      if (!ctrl.colorGroups.length) {
        ctrl.isVisible = false;
        ctrl.editor.togglePicking(); // Deactivate color picking when control is hidden
      }

    }
    // QR Code
    if (changes.qrCode) {
      updateContrast();
    }
  }

  // Updates the elements AND triggers a change to the ngModel
  function onColorChange(colorGroup) {
    renderColorGroup(colorGroup);
    ctrl.editor.saveState();
  }

  // Updates the elements DELAYING triggering a change to the ngModel until a second after the last onColorMove is received (think of the undo/redo history!)
  // This is done to ensure that if the last change in the editor is a color move, this change is captured
  var colorMoveSaveDelay;
  function onColorMove(colorGroup, event) {
    colorGroup.color = event.color;
    renderColorGroup(colorGroup);
    if (colorMoveSaveDelay) {
      $timeout.cancel(colorMoveSaveDelay);
    }
    colorMoveSaveDelay = $timeout(function() {
      ctrl.editor.saveState();
    }, 1000);
  }

  // Updates the elements to match the color
  function renderColorGroup(colorGroup) {
    angular.forEach(colorGroup.elements, function(element, index){
      $(element).attr('fill', colorGroup.color);
    });

    updateContrast();
  }

  // Pick color from existing object
  function pickColor(colorGroup, $event) {
    ctrl.editor.pickColor($event, function(color) {
      colorGroup.color = svgService.rgbToHex(color);
      onColorChange(colorGroup);
    });
  }

  // QR Code Support
  ctrl.contrastThreshold = 5;
  ctrl.contrastGuaranteedThreshold = 10;

  function updateContrast() {
    if (ctrl.qrCode && ctrl.colorGroups.length === 2) {
      ctrl.contrast = contrast(hexToRgb(ctrl.colorGroups[0].color), hexToRgb(ctrl.colorGroups[1].color));
    }
  }

  // Utilities
  function luminanace(r, g, b) {
    var a = [r, g, b].map(function (v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow( (v + 0.055) / 1.055, 2.4 );
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
  }

  function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? [
      parseInt(result[1], 16),
      parseInt(result[2], 16),
      parseInt(result[3], 16)
    ] : null;
  }

  function contrast(rgb1, rgb2) {
    return (luminanace(rgb1[0], rgb1[1], rgb1[2]) + 0.05) / (luminanace(rgb2[0], rgb2[1], rgb2[2]) + 0.05);
  }

  function $onDestroy() {
    if (colorMoveSaveDelay) {
      $timeout.cancel(colorMoveSaveDelay);
    }
  }
}

angular
  .module('app')
  .component('svgEditorColors', svgEditorColorsComponent);

},{}],310:[function(require,module,exports){
var CUSTOM_IMAGE_ATTRIBUTE = 'custom-image-attribute';

svgEditorContenteditableDirective.$inject = ['$timeout'];
function svgEditorContenteditableDirective($timeout) {
  return {
    restrict: 'A', // Attribute only
    require: '^svgEditor',
    link: svgEditorContenteditableLink,
  };
  function svgEditorContenteditableLink(scope, element, attrs, editorCtrl) {
    var $div;

    // Listen for double-click events
    element.on('dblclick', function(event){
      if($(editorCtrl.selection).is('foreignObject') && !$(editorCtrl.selection).hasClass(CUSTOM_IMAGE_ATTRIBUTE)){
        startEditing();
      }
    });

    // Register a pre-export hook
    editorCtrl.addExportCallback('$', svgEditorContenteditableExportCallback);

    // Make the element editable, add events
    function startEditing(){
      $div = $(editorCtrl.selection).find('> div');
      $div.attr('contenteditable', 'true');
      $div.attr('spellcheck', 'false');
      $div.on('mousedown', preventPropagation);
      $div.on('paste', handlePaste);
      $div.on('blur', stopEditing);
      $div.focus();
    }

    // The inverse of `startEditing`
    function stopEditing(event){
      $div.removeAttr('contenteditable spellcheck');
      $div.off('mousedown paste blur');
      editorCtrl.saveState();
    }

    // Prevent the element from being dragged
    function preventPropagation(event){
      event.stopImmediatePropagation();
    }

    // Pasting should be plain-text only (ie: no formatting)
    function handlePaste(event){
      event.preventDefault();
      event.stopImmediatePropagation();
      var plaintext = event.originalEvent.clipboardData.getData('text/plain');
      document.execCommand('inserttext', false, plaintext);
    }

    // Makes sure the element is clear of any contenteditable specific attributes
    function svgEditorContenteditableExportCallback($myElement){
      $myElement.find('foreignObject > div').each(function(){
        $(this).removeAttr('contenteditable spellcheck');
        $(this).off('mousedown paste blur');
      });
    }

  }
}

angular
  .module('app')
  .directive('svgEditorContenteditable', svgEditorContenteditableDirective);

},{}],311:[function(require,module,exports){
var svgEditorDeleteComponent = {
  controller: svgEditorDeleteComponentController,
  require: {
    editor: '^svgEditor'
  },
  bindings: {
    selection: '<',
  },
  templateUrl: '/shared/svg-editor/_js/svg-editor-delete.html',
};

svgEditorDeleteComponentController.$inject = [];
function svgEditorDeleteComponentController() {
  var ctrl = this;

  ctrl.isVisible = true;
  ctrl.delete = doDelete;

  function doDelete(){
    $(ctrl.selection).remove();
    ctrl.editor.deselect(); // This triggers saveState
  }

  ctrl.$onChanges = function(changes){
    ctrl.isVisible = !!ctrl.selection;
  }
}

angular
  .module('app')
  .component('svgEditorDelete', svgEditorDeleteComponent);

},{}],312:[function(require,module,exports){
var svgEditorDuplicateComponent = {
  controller: svgEditorDuplicateComponentController,
  require: {
    editor: '^svgEditor'
  },
  bindings: {
    selection: '<',
  },
  templateUrl: '/shared/svg-editor/_js/svg-editor-duplicate.html',
};

svgEditorDuplicateComponentController.$inject = [];
function svgEditorDuplicateComponentController() {
  var ctrl = this;

  ctrl.isVisible = true;
  ctrl.duplicate = duplicate;

  function duplicate(){
    var clone = $(ctrl.selection).clone();
    var x = parseInt(clone.attr('x'), 10);
    var y = parseInt(clone.attr('y'), 10);
    clone.attr('x', (x+10));
    clone.attr('y', (y+10));
    ctrl.editor.addElement(clone);
    ctrl.editor.select(clone); // This triggers saveState()
  }

  ctrl.$onChanges = function(changes){
    ctrl.isVisible = !!ctrl.selection;
  }
}

angular
  .module('app')
  .component('svgEditorDuplicate', svgEditorDuplicateComponent);

},{}],313:[function(require,module,exports){
require('../../../shared/_services/download.service.js');

var svgEditorExportComponent = {
  controller: svgEditorExportComponentController,
  require: {
    editor: '^svgEditor'
  },
  templateUrl: '/shared/svg-editor/_js/svg-editor-export.html',
};

svgEditorExportComponentController.$inject = ['$window', '$q', 'api', 'swalService', 'downloadService'];
function svgEditorExportComponentController($window, $q, api, swalService, downloadService){
  var ctrl = this;
  ctrl.isVisible = true;
  ctrl.isBusy = false;
  ctrl.previewInIsolation = previewInIsolation;
  ctrl.downloadSVG = downloadSVG;
  ctrl.downloadPNG = downloadPNG;

  // Download PNG
  function downloadPNG(){
    downloadSub('png_link');
  }

  // Download SVG
  function downloadSVG(){
    downloadSub('svg_link');
  }

  // Download abstraction
  function downloadSub(type){
    ctrl.isBusy = true;
    $q.resolve() // Start a promise chain
      .then(ctrl.editor.beforeExport) // This promise MAY return additional data to send to the endpoint
      .then(function(myPayload){
        var payload = myPayload || {};
        payload.svg = ctrl.editor.getSvgString();
        return api.request('/frontend/convert_svg_to_png', payload);
      })
      .then(function(response){
        downloadService.download(response[type]); // where `type` is "png" or "svg"
      })
      .catch(handleError)
      .finally(reset);
  }

  // Reset the controller
  function reset(){
    ctrl.isBusy = false;
  }

  // Throw a generic error
  function handleError(){
    swalService.showAlert('designDownloadFailure');
  }

  // Rough and ready preview function, to test the SVG rendering in isolation
  function previewInIsolation(){
    var svgValue = ctrl.editor.getSvgString();
    var newWindow = window.open('', 'preview', 'width=450,height=450,scrollbars=0');
    var html = '<html><head></head><body>'+svgValue+'</body></html>';
    newWindow.document.open();
    newWindow.document.write(html);
    newWindow.document.close();
  }

}

angular
  .module('app')
  .component('svgEditorExport', svgEditorExportComponent);

},{"../../../shared/_services/download.service.js":163}],314:[function(require,module,exports){
var svgEditorFontComponent = {
  controller: svgEditorFontComponentController,
  require: {
    editor: '^svgEditor'
  },
  bindings: {
    selection: '<',
    palette: '<?'
  },
  templateUrl: '/shared/svg-editor/_js/svg-editor-font.html',
};

svgEditorFontComponentController.$inject = ['fontService', '$timeout'];
function svgEditorFontComponentController(fontService, $timeout) {
  var ctrl = this;
  ctrl.$onInit = $onInit;
  ctrl.$onChanges = $onChanges;
  ctrl.$onDestroy = $onDestroy;
  // Static data
  ctrl.fonts = fontService.getFonts();
  ctrl.allWeights = fontService.getWeights();
  ctrl.availableWeights = []; // [300, 400, 600] - for the selected font
  // Rendering
  ctrl.isVisible = false;
  // Selection Properties
  ctrl.props = {
    fontFamily: 'Source Sans Pro',
    fontSize: 14,
    fontWeight: 400,
    fontStyle: null, // italic
    color: '#000000',
    textDecoration: null, // underline
    textAlign: null,
    verticalAlign: null,
    letterSpacing: 0,
    lineHeight: 1.5,
    shrinkToFit: null
  };
  // Clone the initial props - used after ctrl.props is mutated
  var defaultProps = angular.copy(ctrl.props);
  var colorChangeSaveDelay;

  // Get available weights
  function getAvailableWeights(fontFamily) {
    return ctrl.fonts[fontFamily].weights.filter(function(weight) { // Filter out italic weights
      return Number.isInteger(weight);
    });
  }

  ctrl.availableWeights = getAvailableWeights(defaultProps.fontFamily); // Populate the availableWeights

  // Methods
  ctrl.selectFont = selectFont;
  ctrl.onPropertyChange = onPropertyChange;
  ctrl.onColorChange = onColorChange;
  ctrl.italicize = italicize;
  ctrl.underline = underline;
  ctrl.align = align;
  ctrl.verticalAlign = verticalAlign;
  ctrl.shrinkToFit = shrinkToFit;
  ctrl.pickColor = pickColor;

  // Registers a pre-export hook to the editor
  function $onInit(){
    ctrl.editor.addExportCallback('$', svgEditorFontComponentExportCallback);
  }

  // When the selection changes
  function $onChanges(changes){
    ctrl.isVisible = ctrl.selection && $(ctrl.selection).is('foreignObject');
    if(ctrl.isVisible){
      var node = $(ctrl.selection)[0];
      ctrl.props = getElementProperties(node);
    }
  }

  // Select new font
  function selectFont(font) {
    ctrl.props.fontFamily = font.name;
    onPropertyChange();
  }

  function onColorChange(event){
    ctrl.props.color = event.color;
    $(ctrl.selection)[0].style.color = ctrl.props.color;
    // Does NOT trigger `onPropertyChange` as we only want to update the one property without updating the model
    // ...if we did update the model, then our Undo/Redo History would have every incremental change to the color
    if (colorChangeSaveDelay) {
      $timeout.cancel(colorChangeSaveDelay);
    }
    colorChangeSaveDelay = $timeout(function() {
      ctrl.editor.saveState();
    }, 1000);
  }
  function italicize(){
    ctrl.props.fontStyle = ctrl.props.fontStyle === 'italic' ? null : 'italic';
    onPropertyChange();
  }
  function underline(){
    ctrl.props.textDecoration = ctrl.props.textDecoration === 'underline' ? null : 'underline';
    onPropertyChange();
  }
  function align(alignment){
    ctrl.props.textAlign = alignment;
    onPropertyChange();
  }
  function verticalAlign(alignment){
    ctrl.props.verticalAlign = alignment;
    onPropertyChange();
  }
  function shrinkToFit(dimension){
    if (ctrl.props.shrinkToFit === dimension) {
      ctrl.props.shrinkToFit = '';
    } else {
      ctrl.props.shrinkToFit = dimension;
      if (dimension === 'height') {
        verticalAlign('middle');
      }
    }
    onPropertyChange();
  }

  // Apply the props to the SVG element
  function onPropertyChange(){
    fontService.loadFont(ctrl.props.fontFamily); // Make sure we have the font loaded
    ctrl.props.fontWeight = fontService.getNearestWeight(ctrl.props.fontFamily, ctrl.props.fontWeight); // Make sure changing the font Family doesn't give us an innapropriate weight
    var selection = $(ctrl.selection);
    selection.css({
      fontFamily: ctrl.props.fontFamily,
      fontSize: ctrl.props.fontSize,
      fontWeight: ctrl.props.fontWeight,
      fontStyle: (ctrl.props.fontStyle === 'italic') ? 'italic' : '',
      color: ctrl.props.color,
      textDecoration: (ctrl.props.textDecoration === 'underline') ? 'underline' : '',
      textAlign: ctrl.props.textAlign || '',
      letterSpacing: (ctrl.props.letterSpacing/1000) + 'em',
      lineHeight: ctrl.props.lineHeight
    });
    selection.attr('vertical-align', ctrl.props.verticalAlign);
    selection.attr('shrink-to-fit', ctrl.props.shrinkToFit);
    ctrl.availableWeights = getAvailableWeights(ctrl.props.fontFamily); // Populate the availableWeights
    ctrl.editor.adjustText(selection);
    ctrl.editor.saveState();
  }

  // Utility - returns the properties of an element, using the default props as a fallback
  function getElementProperties(element){
    var fontFamily = trimQuotemarks(element.style.fontFamily || defaultProps.fontFamily);
    var props = {
      fontFamily:     fontFamily,
      fontSize:       parseInt(element.style.fontSize, 10) || defaultProps.fontSize,
      fontWeight:     fontService.getNearestWeight(fontFamily, element.style.fontWeight), // Make sure the fontWeight is appropriate for the family
      fontStyle:      element.style.fontStyle || defaultProps.fontStyle,
      color:          element.style.color || defaultProps.color,
      textDecoration: element.style.textDecoration || defaultProps.textDecoration,
      textAlign:      element.style.textAlign || defaultProps.textAlign,
      letterSpacing:  (1000*parseFloat(element.style.letterSpacing, 10)) || defaultProps.letterSpacing,
      lineHeight:     parseFloat(element.style.lineHeight, 10) || defaultProps.lineHeight,
      verticalAlign:  $(element).attr('vertical-align') || defaultProps.verticalAlign,
      shrinkToFit:    $(element).attr('shrink-to-fit') || defaultProps.shrinkToFit,
    };
    // This is a hack to get the font weights updating correctly when selecting a text foreignObject
    // I can't currently work out how the svgEditorFontComponentExportCallback that is calling this works - the whole pattern seems over complex
    if ($(element).attr('selection')) {
      $timeout(function() {
        ctrl.availableWeights = getAvailableWeights(props.fontFamily); // Populate the availableWeights
      });
    }
    return props;
  }

  // Ensures the exported SVG @import's all the correct fonts
  function svgEditorFontComponentExportCallback($myElement){
    // 0 - compile a list of all fonts, weights and italics
    var myFonts = {};
    // 1 - loop all <foreignObject> elements
    $myElement.find('foreignObject').each(function() {
      var el = this;
      var elProps = getElementProperties(el);
      if(!myFonts[elProps.fontFamily]){
        myFonts[elProps.fontFamily] = {};
      }
      var slug = elProps.fontWeight + (elProps.fontStyle === 'italic' && fontService.hasItalicWeight(elProps.fontFamily, elProps.fontWeight) ? 'i' : '');
      myFonts[elProps.fontFamily][slug] = true;
    });
    // 2 - create the <style>
    var myStyle = [];
    angular.forEach(myFonts, function(fontVariants, fontName){
      var fontVariantsArray = Object.keys(fontVariants);
      myStyle.push(fontService.getCssImportString(fontName, fontVariantsArray));
    });
    // 2a - put Google fonts first (otherwise the @imports don't work!)
    myStyle = myStyle.sort(function(a, b) {
      if (a.indexOf('@import') === 0 && b.indexOf('@import') === 0) {
        return 0;
      }
      if (a.indexOf('@import') === 0 && b.indexOf('@font-face') === 0) {
        return -1;
      }
      if (a.indexOf('@font-face') === 0 && b.indexOf('@import') === 0) {
        return 1;
      }
      if (a.indexOf('@font-face') === 0 && b.indexOf('@font-face') === 0) {
        return 0;
      }
    });
    // 3 - update the <style>
    $myElement.find('style').remove();
    if(myStyle.length){
      $myElement.prepend($('<style>\n' + myStyle.join('\n') + '</style>'));
    }
  }

  // Utility - trims quotation marks from a string
  function trimQuotemarks(str){
    return str.replace(/(^["'])|(["']$)/g, '');
  }

  // Pick color from existing object
  function pickColor($event) {
    ctrl.editor.pickColor($event, function(color) {
      ctrl.props.color = color;
      onPropertyChange();
    });
  }

  function $onDestroy() {
    if (colorChangeSaveDelay) {
      $timeout.cancel(colorChangeSaveDelay);
    }
  }
}

angular
  .module('app')
  .component('svgEditorFont', svgEditorFontComponent);

},{}],315:[function(require,module,exports){
var svgEditorHistoryComponent = {
  controller: svgEditorHistoryComponentController,
  require: {
    editor: '^svgEditor'
  },
  templateUrl: '/shared/svg-editor/_js/svg-editor-history.html',
};

svgEditorHistoryComponentController.$inject = [];
function svgEditorHistoryComponentController() {
  var ctrl = this;

  ctrl.$onInit = function(){
    ctrl.undo = ctrl.editor.undo;
    ctrl.redo = ctrl.editor.redo;
    ctrl.canUndo = ctrl.editor.History.canUndo;
    ctrl.canRedo = ctrl.editor.History.canRedo;
  };
}

angular
  .module('app')
  .component('svgEditorHistory', svgEditorHistoryComponent);

},{}],316:[function(require,module,exports){
var svgEditorNudgeComponent = {
  controller: svgEditorNudgeComponentController,
  require: {
    editor: '^svgEditor'
  },
  bindings: {
    selection: '<',
  },
  templateUrl: '/shared/svg-editor/_js/svg-editor-nudge.html',
};

svgEditorNudgeComponentController.$inject = [];
function svgEditorNudgeComponentController() {
  var ctrl = this;

  ctrl.nudge = nudge;

  function nudge(axis, dist){
    if(ctrl.selection){

      // console.log('nudge', dir, dist);
      var val = parseInt(ctrl.selection.attr(axis), 10); // 'x' or 'y'
      ctrl.selection.attr(axis, (val+dist)); // ...adjusted
      ctrl.editor.renderSelectionOverlay();
      ctrl.editor.renderSelectionSnapGuides();
    }
  }
}

angular
  .module('app')
  .component('svgEditorNudge', svgEditorNudgeComponent);

},{}],317:[function(require,module,exports){
var svgEditorObjectTypeComponent = {
  controller: svgEditorObjectTypeComponentController,
  require: {
    editor: '^svgEditor'
  },
  bindings: {
    selection: '<',
  },
  templateUrl: '/shared/svg-editor/_js/svg-editor-object-type.html',
};

svgEditorObjectTypeComponentController.$inject = [];
function svgEditorObjectTypeComponentController() {
  var ctrl = this;

  ctrl.isVisible = true;
  ctrl.objectIcon = null;
  ctrl.tooltip = null;

  ctrl.$onChanges = function(changes){
    ctrl.isVisible = !!ctrl.selection;
    if (ctrl.isVisible) {
      ctrl.objectIcon = $(ctrl.selection).is('foreignObject') ? 'text' : $(ctrl.selection).is('image') ? 'image' : 'object';
      ctrl.tooltip = ctrl.objectIcon === 'text' ? 'Text Options' : ctrl.objectIcon === 'image' ? 'Image Options' : 'Object Options';
    } else {
      ctrl.objectIcon = null;
      ctrl.tooltip = null;
    }
  };
}

angular
  .module('app')
  .component('svgEditorObjectType', svgEditorObjectTypeComponent);

},{}],318:[function(require,module,exports){
var svgEditorOpacityComponent = {
  controller: svgEditorOpacityComponentController,
  require: {
    editor: '^svgEditor'
  },
  bindings: {
    selection: '<',
  },
  templateUrl: '/shared/svg-editor/_js/svg-editor-opacity.html',
};

svgEditorOpacityComponentController.$inject = ['$timeout', '$element'];
function svgEditorOpacityComponentController($timeout, $element) {
  var ctrl = this;

  ctrl.isVisible = true;
  ctrl.updateOpacity = updateOpacity;
  ctrl.saveState = saveState;

  ctrl.opacity = 1;

  function updateOpacity(){
    $(ctrl.selection).attr('opacity', (ctrl.opacity/100));
  }

  function saveState(){
    ctrl.editor.saveState();
  }

  ctrl.$onChanges = function(changes){
    ctrl.isVisible = !!ctrl.selection;
    if(ctrl.selection){
      var tmp = parseFloat($(ctrl.selection).attr('opacity'), 10) || 1
      ctrl.opacity = parseInt(tmp * 100);
    }
  }
}

angular
  .module('app')
  .component('svgEditorOpacity', svgEditorOpacityComponent);

},{}],319:[function(require,module,exports){
var svgEditorTextOnPathComponent = {
  controller: svgEditorTextOnPathComponentController,
  require: {
    editor: '^svgEditor'
  },
  bindings: {
    selection: '<'
  },
  templateUrl: '/shared/svg-editor/_js/svg-editor-text-on-path.html',
};

svgEditorTextOnPathComponentController.$inject = ['fontService', '$timeout'];
function svgEditorTextOnPathComponentController(fontService, $timeout) {
  var ctrl = this;

  ctrl.isVisible = true;

  // Methods
  ctrl.updateText = updateText;
  ctrl.saveState = saveState;
  ctrl.onPropertyChange = onPropertyChange;
  ctrl.onColorChange = onColorChange;
  ctrl.pickColor = pickColor;
  ctrl.italicize = italicize;
  ctrl.underline = underline;
  ctrl.anchor = anchor;
  ctrl.setMode = setMode;

  ctrl.selectFont = selectFont;

  ctrl.text = '';

  // Static data
  ctrl.fonts = fontService.getFonts();
  ctrl.allWeights = fontService.getWeights();
  ctrl.availableWeights = []; // [300, 400, 600] - for the selected font

  // Selection Properties
  ctrl.props = {
    fontFamily: 'Source Sans Pro',
    fontSize: 14,
    fontWeight: 400,
    fontStyle: null, // italic
  };
  ctrl.attributes = {
    fill: '#000000',
    textDecoration: null, // underline
    textAnchor: null,
    letterSpacing: 0
  };
  ctrl.mode = null;

  // Clone the initial props - used after ctrl.props is mutated
  var defaultProps = angular.copy(ctrl.props);
  var colorChangeSaveDelay;

  // Get available weights
  function getAvailableWeights(fontFamily) {
    return ctrl.fonts[fontFamily].weights.filter(function(weight) { // Filter out italic weights
      return Number.isInteger(weight);
    });
  }
  ctrl.availableWeights = getAvailableWeights(defaultProps.fontFamily); // Populate the availableWeights

  function updateText() {
    $(ctrl.selection).find('textPath').text(ctrl.text);
  }

  function saveState(){
    ctrl.editor.saveState();
  }

  ctrl.$onChanges = function(changes) {
    var selection = $(ctrl.selection);
    var textPath = selection.find('textPath');
    ctrl.isVisible = ctrl.selection && textPath.length > 0;
    if (ctrl.isVisible) {
      ctrl.text = textPath.text();
      var style = selection[0].style;
      ctrl.props.fontFamily = trimQuotemarks(style.fontFamily);
      ctrl.props.fontSize = parseInt(style.fontSize);
      ctrl.props.fontWeight = parseInt(style.fontWeight);
      ctrl.props.fontStyle = style.fontStyle;
      var textNode = selection.find('text');
      ctrl.attributes.fill = textNode.attr('fill');
      ctrl.attributes.textDecoration = textNode.attr('text-decoration');
      ctrl.attributes.textAnchor =  textNode.attr('text-anchor');
      ctrl.attributes.letterSpacing = parseFloat(textNode.attr('letter-spacing'));
      ctrl.attributes.startOffset = parseInt(textPath.attr('startOffset'));
      var pathId = textPath[0].getAttribute('xlink:href');
      ctrl.mode = pathId.split('_')[1];
    }
  };

  ctrl.$onDestroy = $onDestroy;

  // Select new font
  function selectFont(font) {
    ctrl.props.fontFamily = font.name;
    onPropertyChange();
  }

   // Apply the props to the SVG element
   function onPropertyChange() {
    fontService.loadFont(ctrl.props.fontFamily); // Make sure we have the font loaded
    ctrl.props.fontWeight = fontService.getNearestWeight(ctrl.props.fontFamily, ctrl.props.fontWeight); // Make sure changing the font Family doesn't give us an innapropriate weight
    var selection = $(ctrl.selection);
    selection.css({
      fontFamily: ctrl.props.fontFamily,
      fontSize: ctrl.props.fontSize,
      fontWeight: ctrl.props.fontWeight,
      fontStyle: (ctrl.props.fontStyle === 'italic') ? 'italic' : '',
    });
    var textNode = selection.find('text');
    textNode.attr('fill', ctrl.attributes.fill);
    textNode.attr('text-decoration', ctrl.attributes.textDecoration);
    textNode.attr('text-anchor', ctrl.attributes.textAnchor);
    textNode.attr('letter-spacing', ctrl.attributes.letterSpacing);
    ctrl.availableWeights = getAvailableWeights(ctrl.props.fontFamily); // Populate the availableWeights
    var textPath = selection.find('textPath');
    textPath.attr('startOffset', ctrl.attributes.startOffset + '%');
    var pathId = textPath[0].getAttribute('xlink:href');
    var parsedId = pathId.split('_');
    if (parsedId[1] !== ctrl.mode) {
      ctrl.editor.removeCircularTextGuide(ctrl.selection);
      textPath[0].setAttribute('xlink:href', parsedId[0] + '_' + ctrl.mode);
      ctrl.editor.addCircularTextGuide(ctrl.selection);
    }
    ctrl.editor.saveState();
  }

  function onColorChange(event){
    ctrl.attributes.fill = event.color;
    $(ctrl.selection).find('text').attr('fill', ctrl.attributes.fill);
    // Does NOT trigger `onPropertyChange` as we only want to update the one property without updating the model
    // ...if we did update the model, then our Undo/Redo History would have every incremental change to the color
    if (colorChangeSaveDelay) {
      $timeout.cancel(colorChangeSaveDelay);
    }
    colorChangeSaveDelay = $timeout(function() {
      ctrl.editor.saveState();
    }, 1000);
  }

  function trimQuotemarks(str){
    return str.replace(/(^["'])|(["']$)/g, '');
  }

  // Pick color from existing object
  function pickColor($event) {
    ctrl.editor.pickColor($event, function(color) {
      ctrl.attributes.fill = color;
      onPropertyChange();
    });
  }

  function italicize() {
    ctrl.props.fontStyle = ctrl.props.fontStyle === 'italic' ? null : 'italic';
    onPropertyChange();
  }

  function underline() {
    ctrl.attributes.textDecoration = ctrl.attributes.textDecoration === 'underline' ? null : 'underline';
    onPropertyChange();
  }

  function anchor(position) {
    ctrl.attributes.textAnchor = position;
    onPropertyChange();
  }

  function setMode(mode) {
    ctrl.mode = mode;
    onPropertyChange();
  }

  function $onDestroy() {
    if (colorChangeSaveDelay) {
      $timeout.cancel(colorChangeSaveDelay);
    }
  }
}

angular
  .module('app')
  .component('svgEditorTextOnPath', svgEditorTextOnPathComponent);

},{}],320:[function(require,module,exports){
/** EDITOR
 *
 *    Adds dragging functionality to all children
 *    Adds element snapping
 *
 *    Broadly, the logic is:
 *
 *      editor.mousedown
 *        get element (but don't select it, yet)
 *        generate grid (excluding element)
 *        add document events (for mousemove and mouseup)
 *      document.mousemove
 *        first move? select element
 *        drag element
 *        snap to other elements, showing grid
 *      document.mouseup
 *        stop dragging
 *        clean up document events
 *
 *  @author  David "oodavid" King
 */
require('./_js/svg-editor-arrange.component.js');
require('./_js/svg-editor-duplicate.component.js');
require('./_js/svg-editor-delete.component.js');
require('./_js/svg-editor-font.component.js');
require('./_js/svg-editor-colors.component.js');
require('./_js/svg-editor-history.component.js');
require('./_js/svg-editor-opacity.component.js');
require('./_js/svg-editor-export.component.js');
require('./_js/svg-editor-contenteditable.directive.js');
require('./_js/svg-editor-nudge.component.js');
require('./_js/svg-editor-object-type.component.js');

require('./_js/svg-editor-text-on-path.component.js');

require('../../shared/font-menu/font-menu.component.js');
require('../../shared/basicFilters.js');
require('../../shared/history/history.factory.js');
require('../../shared/button-color/button-color.directive.js');
require('../../shared/fonts/font.service.js');
require('../../shared/save-button/save-button.directive.js');
require('../../shared/alert/legacySwalService.js');
require('../../shared/_services/uuidv4.service.js');

var QR_CODE_SVG_ID = 'acc-badge-qr-code-placeholder';
var CUSTOM_IMAGE_ATTRIBUTE = 'custom-image-attribute';

var svgEditorComponent = {
  controller: svgEditorComponentController,
  require: {
    ngModelCtrl: 'ngModel',
  },
  bindings: {
    ngModel: '=',
    beforeExport: '&?',
    changes: '=',
    existingDesigns: '<',
    attributes: '<',
    showQrCodeTab: '<',
    host: '@?',
    allowExport: '=',
    language: '='
  },
  transclude: true,
  templateUrl: '/shared/svg-editor/svg-editor.html',
};

// Preload the template so we don't get any delay
certificateEditorDirectivePreload.$inject = ['$templateCache', '$http'];
function certificateEditorDirectivePreload($templateCache, $http){
  $http.get(svgEditorComponent.templateUrl, { cache: $templateCache });
}

svgEditorComponentController.$inject = ['HistoryFactory', '$scope', '$timeout', '$element', 'imgService', 'Entities', 'svgProcessor', 'uuidv4', 'languageService', 'OrganizationService', 'FlipperFeaturesService', 'svgService'];
function svgEditorComponentController(HistoryFactory, $scope, $timeout, $element, imgService, Entities, svgProcessor, uuidv4, languageService, OrganizationService, FlipperFeaturesService, svgService) {
  var ctrl = this;
  ctrl.$onInit = $onInit;
  ctrl.$postLink = $postLink;
  ctrl.$onDestroy = $onDestroy;
  ctrl.selection = null;
  ctrl.editingText = false;
  ctrl.badgeColors = [];
  ctrl.badgeTemplates = [];
  ctrl.History = null;
  ctrl.badges_visible = true;
  ctrl.icons_visible = true;
  ctrl.ribbons_visible = false;
  ctrl.language = null;
  ctrl.languageOptions = getLanguagesOptions(Object.values(languageService.getLanguages()));
  ctrl.selectionIsQRCode = false;
  ctrl.selectionIsCustomImageAttribute = false;

  ctrl.allowedAttributes = null;
  ctrl.dateFormat = null;
  ctrl.exampleDate = new Date();

  OrganizationService.getOrganization().then(function(organization) {
    return organization.id;
  }).then(function(organizationId) {
    return FlipperFeaturesService.getFlipperFeatures(organizationId);
  }).then(function(flipperFeatures) {
    ctrl.showNewBadgeBackgrounds = flipperFeatures.modern_design_templates;
    if(ctrl.showNewBadgeBackgrounds) {
      getTemplates();
    }
  });

  // Methods
  ctrl.saveState = saveState;
  ctrl.undo = undo;
  ctrl.redo = redo;
  ctrl.select = select;
  ctrl.deselect = deselect;
  ctrl.addElement = addElement;
  ctrl.addExportCallback = addExportCallback;
  ctrl.getSvgString = getSvgString;
  ctrl.mouseDownStartScale = mouseDownStartScale;
  ctrl.addImageAsset = addImageAsset;
  ctrl.addCustomImageAsset = addCustomImageAsset;
  ctrl.addTextAsset = addTextAsset;
  ctrl.addTextOnPathAsset = addTextOnPathAsset;
  ctrl.addSvgAsset = addSvgAsset;
  ctrl.useExistingBadge = useExistingBadge;
  ctrl.renderSelectionOverlay = renderSelectionOverlay;
  ctrl.renderSelectionSnapGuides = renderSelectionSnapGuides;
  ctrl.pickColor = pickColor;
  ctrl.togglePicking = togglePicking;
  ctrl.adjustText = adjustText;
  ctrl.attributeInUse = attributeInUse;
  ctrl.gotoRoute = gotoRoute;
  ctrl.addAttribute = addAttribute;
  ctrl.addCircularTextGuide = addCircularTextGuide;
  ctrl.removeCircularTextGuide = removeCircularTextGuide;
  ctrl.setBadgeDateFormat = setBadgeDateFormat;
  ctrl.addQRCodeBlock = addQRCodeBlock;
  ctrl.getTemplates = getTemplates;
  ctrl.selectTemplate = selectTemplate;

  // Props
  var $svg;

  // Start with backgrounds visible
  ctrl.showSidebarMain = true;

  ctrl.activateTab = function(tab) {
    ctrl.currentTab = tab;
    $timeout(function() {
      ctrl.showSidebarMain = true;
    });
  };

  ctrl.sidebarColumns = 2;
  ctrl.columnSwitching = false;
  ctrl.displayColumns = function(count) {
    if (count !== ctrl.sidebarColumns) {
      ctrl.columnSwitching = true;
      ctrl.sidebarColumns = count;
      $timeout(function() {
        ctrl.columnSwitching = false;
      });
    }
  };

  // Creates the history object
  // TODO: This must also track the selection
  function $onInit() {
    var value = ctrl.ngModel || ctrl.ngModelCtrl.$modelValue || ctrl.ngModelCtrl.$viewValue;
    if (!value){
      value = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 400 400" width="400" height="400" data-date-format="longDate"></svg>';
    }
    getBadgeDateFormat(value);
    ctrl.ngModelCtrl.$setViewValue(value);
    updateHistoryObject();
    // Are existing designs being supplied?
    ctrl.showExisting = !!(ctrl.existingDesigns);

    ctrl.currentTab = 'existing';

    if (ctrl.showExisting) {
      // Switch to show existing badges, if there are any
      $scope.$watch(
        function () { return ctrl.existingDesigns; },
        function (newValue) {
          if (newValue.length > 0) {
            ctrl.currentTab = 'existing';
            newValue = setLanguageDescription(newValue);
          } else {
            ctrl.currentTab = 'backgrounds';
          }
        }
      );
    }
    // Are attributes being supplied?
    $scope.$watch(
      function () { return ctrl.attributes; },
      function (newValue) {
        if (angular.isObject(newValue)) {
          ctrl.showAttributes = true;
          // Only show attributes of type 'text' or 'date'
          var attributeKeys = Object.keys(ctrl.attributes);
          ctrl.allowedAttributes = attributeKeys.reduce(function(acc, key) {
            acc[key] = ctrl.attributes[key].filter(function(attribute) {
              var allowedTypes = ['text', 'date'];
              // TODO(Salim): refactor after removing FF
              if (ctrl.showQrCodeTab) {
                allowedTypes.push('image');
              }
              return allowedTypes.includes(attribute.type);
            } );
            return acc;
          }, {});
        }
      }
    );
  }

  function getBadgeDateFormat(value) {
    var regex = /<svg (.*?)(data-date-format=")(.*?)(?=")/i;
    var extractedDateFormat = regex.exec(value);
    ctrl.dateFormat = extractedDateFormat ? extractedDateFormat[3] || 'longDate' : 'longDate';
  }

  function getTemplates() {
      svgService.getBadgeTemplates().then(function( templates) {
        ctrl.badgeTemplates = templates.designs;
      });
  }

  function setLanguageDescription(designs) {
    return designs.map(function(design) {
      var language = languageService.getLanguageFromCodeNoDefault(design.language);
      if(language) {
        design['languageDescription'] = language.description;
      }
      return design;
    });
  }

  function getLanguagesOptions(languages) {
    var options = [];
    languages.forEach(function (language){
      language.languageDescription = getLanguageFullDescription(language);
      options.push(language);
    });

    return options.sort( function(lang1, lang2) {
      return lang1.languageDescription > lang2.languageDescription ? 1 : -1;
    });
  }
  function getLanguageFullDescription(language) {
    return language.description.concat(language.value !== 'en' && language.value !== 'en-gb' ? ' - ' + language.name : '');
  }

  // Make sure the text box fits the contained text
  function rationalizeTextBox(event) {
    var textNode = $(event.target).closest('foreignObject');
    if (textNode) {
      adjustText(textNode);
    }
  }

  function adjustText(textNode) {
    if (svgProcessor.isValidForeignObject(textNode)) {
      svgProcessor.shrinkTextBoxContentToFit(textNode);
      svgProcessor.verticalAlignTextBoxContent(textNode);
    }
  }

  // Add attribute
  function addAttribute(attribute) {
    if (replaceSelectedText(attribute.tag)) {
      adjustText($(ctrl.selection));
    } else if (attribute.type === 'image') {
      addCustomImageAsset(attribute.tag);
    } else {
      addTextAsset(attribute.tag);
    }
  }

  // Once the DOM is ready, append the SVG content, add events, reference the SVG
  function $postLink() {
    var value = ctrl.ngModel || ctrl.ngModelCtrl.$modelValue || ctrl.ngModelCtrl.$viewValue;
    $(document).on('keydown', keyDown);
    $element.find('.editor-svg-container').append(value);
    $element.find('.editor-svg-container').on('mousedown', '> svg > *', mouseDownStartDragging);
    $element.find('.editor-svg-container').on('keyup', rationalizeTextBox);
    $element.find('.editor-svg-container').on('paste', rationalizeTextBox);
    $element.find('.editor-canvas-container').on('mousedown', mouseDownDeselect);
    //$element.find('.editor-canvas-container').on('mouseup', getSelection);
    $svg = $element.find('.editor-svg-container > svg');
    // Reapply any dynamic styling
    $svg.find('foreignObject').each(function() {
      var textNode = $(this);
      textNode.css('overflow', ''); // Remove 'overflow: visible' as this isn't needed anymore
      adjustText(textNode);
    });

    checkIfHasQRCode();
  }

  // Clean up when destroyed
  function $onDestroy() {
    $(document).off('keydown', keyDown);
    cleanUp();
  }

  // Add element
  function addElement(newElement){
    $svg.append(newElement);
  }

  // Clean up - tidy props, remove mouse events, refresh the snapCache
  function cleanUp() {
    $(document).off('mousemove', mouseMoveScale);
    $(document).off('mousemove', mouseMoveDraggingResist);
    $(document).off('mousemove', mouseMoveDragging);
    $(document).off('mouseup', mouseUp);
    removeAllSnapGuides();
    calculateSnapCache();
  }

  /** OBJECT MANIPULATION
   *
   *  Move Foreward, Move Backward, Delete and Duplicate
   */

  ctrl.moveBackward = moveBackward;
  ctrl.moveForward = moveForward;
  ctrl.delete = doDelete;
  ctrl.duplicate = duplicate;

  function moveBackward(event) {
    togglePicking();
    var prev = angular.element(ctrl.selection).prev();
    prev.before(angular.element(ctrl.selection));
    canMove();
    saveState();
    // Prevent any other events triggering
    event.stopImmediatePropagation();
  }

  function moveForward(event) {
    togglePicking();
    var next = angular.element(ctrl.selection).next();
    next.after(angular.element(ctrl.selection));
    canMove();
    saveState();
    // Prevent any other events triggering
    event.stopImmediatePropagation();
  }

  function canMove() {
    if(ctrl.selection){
      var prev = angular.element(ctrl.selection).prevAll();
      var next = angular.element(ctrl.selection).nextAll();
      ctrl.canMoveBackward = prev.length && prev[0].nodeName !== 'style';
      ctrl.canMoveForward  = next.length;
    } else {
      ctrl.canMoveBackward = false;
      ctrl.canMoveForward = false;
    }
  }

  function doDelete(event) {
    togglePicking();
    angular.element(ctrl.selection).remove();
    deselect(); // This triggers saveState
    // Prevent any other events triggering
    event.stopImmediatePropagation();
    checkIfHasQRCode();
  }

  function duplicate(event) {
    togglePicking();
    var clone = angular.element(ctrl.selection).clone();
    var x = parseInt(clone.attr('x'), 10);
    var y = parseInt(clone.attr('y'), 10);
    clone.attr('x', (x+10));
    clone.attr('y', (y+10));
    addElement(clone);
    select(clone); // This triggers saveState()
    // Prevent any other events triggering
    event.stopImmediatePropagation();
  }

  function selectTemplate(svg) {
    injectSVG(svg,false);
  }

  /** HISTORY
   *
   *  Undo, Redo and Restore
   */

  // Saves the state of the SVG model and selection
  function saveState() {
    // Update the model
    ctrl.ngModelCtrl.$setViewValue(getSvgString());
    updateHistoryObject();
  }

  // Undo
  function undo() {
    ctrl.History.undo();
    $element.find('.editor-svg-container').removeClass('picking-color');
    ctrl.dateFormat = $svg[0].getAttribute('data-date-format') || 'longDate';
  }

  // Redo
  function redo() {
    ctrl.History.redo();
    $element.find('.editor-svg-container').removeClass('picking-color');
    ctrl.dateFormat = $svg[0].getAttribute('data-date-format') || 'longDate';
  }

  // Updates the history object
  var tracker = {};
  function updateHistoryObject() {
    tracker.value = ctrl.ngModelCtrl.$modelValue || ctrl.ngModelCtrl.$viewValue;
    tracker.language = ctrl.language;
    if (!ctrl.History) {
      createHistoryObject(); // Initialize (once)
    } else {
      ctrl.History.save(); // Save
    }
    ctrl.changes = ctrl.History.canUndo();
  }

  // Creates the history object, and listeners
  function createHistoryObject() {
    ctrl.History = new HistoryFactory(tracker);
    ctrl.History.on('restoreSnapshot', onRestoreSnapshot);
  }

  function injectSVG(svgString, noSelection) {
    // Update the model
    ctrl.ngModelCtrl.$setViewValue(svgString);
    // Replace the SVG
    $svg.remove();
    $element.find('.editor-svg-container').append(svgString);
    $svg = $element.find('.editor-svg-container > svg');
    // Remove 'overflow: visible' from any legacy text objects
    $svg.find('foreignObject').css('overflow', '');
    // Reselect the element
    if (!noSelection) {
      restoreSelection();
    }
  }

  // Whenever undo or redo is triggered
  function onRestoreSnapshot() {
    injectSVG(tracker.value);
    ctrl.language = tracker.language;
    ctrl.changes = ctrl.History.canUndo();
  }

  //
  function useExistingBadge(design) {
    injectSVG(design.svg);
    ctrl.language = design.language;
    saveState();
  }

  /** EXPORT
   *
   *  Editor components can use the `addExportCallback`
   *   to perform just-in-time modifications to the
   *   exported element. For example:
   *
   *  <editor-font> wants to make sure that the correct
   *   @import statements are included in the SVG
   *   <style> element.
   *
   *  These callbacks can act on the DOM element, or the
   *   sring value.
   */
  function getSvgString() {
    // Clone the element
    var $cloneSVG = $svg.clone();
    // Run the callbacks that require $jQuery
    angular.forEach(exportCallbacks.$, function(callback){
      callback($cloneSVG);
    });
    // Grab the string value
    var svgString = $cloneSVG[0].outerHTML;
    delete $cloneSVG;
    // Run the callbacks that require the string
    angular.forEach(exportCallbacks.string, function(callback){
      svgString = callback(svgString);
    });
    // Safari xlink NS issue fix
    svgString = svgString.replace(/NS\d+:href/g, 'xlink:href');
    // And return
    return svgString;
  }

  // Our callbacks
  var exportCallbacks = {
    '$': [],
    'string': [],
  };
  function addExportCallback(mode, callback){
    if(exportCallbacks[mode].indexOf(callback) === -1){ // Don't add the same callback multiple times
      exportCallbacks[mode].push(callback);
    }
  }

  // The default pipeline
  addExportCallback('$', stripAngularHtmlArtefacts);
  addExportCallback('string', closeVoidElements);
  addExportCallback('string', removeNamedEntities);

  /** ADD ASSET
   *
   *  Adds an SVG or Text asset to the stage
   */
  function addImageAsset(fileUrl){
    // Parse the image to get the dimensions
    imgService.parse(fileUrl)
      .then(function(data){
        // Create the image in the same namespace as the containing SVG element
        var ns = $svg.attr('xmlns');
        var image = document.createElementNS(ns, 'image');
        image.setAttributeNS('http://www.w3.org/1999/xlink', 'href', fileUrl);
        // Use jQuery as usual
        var $asset = $(image);
        $asset.attr('viewBox', '0 0 '+data.width+' '+data.height); // <image> elements don't actually use viewBox. We abuse it to store the original dimensions of the image
        // Add it
        addAsset($asset);
      });
  }

  function addCustomImageAsset(textValue) {
    var svgNamespaceURI = $svg.attr('xmlns');
    var foreignObject = document.createElementNS(svgNamespaceURI, 'foreignObject');
    foreignObject.setAttribute('width', 100);
    foreignObject.setAttribute('height', 100);
    foreignObject.setAttribute('class', CUSTOM_IMAGE_ATTRIBUTE);
    foreignObject.setAttribute('style', 'background-color: #ddd; position: relative; font-size: 12px;');

    var htmlNamespaceURI = 'http://www.w3.org/1999/xhtml';
    var contentEl = document.createElementNS(htmlNamespaceURI, 'div');
    contentEl.innerText = textValue;
    foreignObject.appendChild(contentEl);

    var $asset = $(foreignObject);
    addAsset($asset);
  }

  function addTextAsset(textValue) {
    // Create a <foreignObject> in the same namespace as the containing SVG element
    var svgNamespaceURI = $svg.attr('xmlns');
    var foreignObject = document.createElementNS(svgNamespaceURI, 'foreignObject');
    foreignObject.setAttribute('width', 380);
    foreignObject.setAttribute('height', 48);
    foreignObject.setAttribute('style', 'font-size: 30px; color: rgb(102, 102, 102); font-family: "Arial"; font-weight: 400; text-align: center; letter-spacing: 0em; line-height: 1.5;'); // Removed overflow: visible;
    // Create a <div> in the HTML namespace
    var htmlNamespaceURI = 'http://www.w3.org/1999/xhtml';
    var contentEl = document.createElementNS(htmlNamespaceURI, 'div');
    contentEl.setAttribute('xmlns', htmlNamespaceURI);
    // Add the text to the body
    var textEl = document.createTextNode(textValue);
    contentEl.appendChild(textEl);
    // ...and the body to the foreignObject
    foreignObject.appendChild(contentEl);
    // Add it
    var $asset = $(foreignObject);
    addAsset($asset);
  }
  function addTextOnPathAsset(textValue){
    var svgNamespaceURI = $svg.attr('xmlns');
    var svgContainer = document.createElementNS(svgNamespaceURI, 'svg');

    var mode = 0;

    var pathId = uuidv4.generate();
    var paths = [
      {
        id: pathId + '_outer',
        data: 'M100,175c-41.4,0-75-33.6-75-75s33.6-75,75-75s75,33.6,75,75S141.4,175,100,175z' // Anchor top, centre
      },
      {
        id: pathId + '_inner',
        data: 'M100,10c-49.6,0-90,40.4-90,90s40.4,90,90,90s90-40.4,90-90S149.6,10,100,10z' // Anchor bottom, centre
      }
    ];

    var defs = document.createElementNS(svgNamespaceURI, 'defs');
    paths.forEach(function(pathData) {
      var path = document.createElementNS(svgNamespaceURI, 'path');
      path.setAttribute('id', pathData.id);
      path.setAttribute('d', pathData.data);
      path.setAttribute('stroke-dasharray', '5, 5');
      path.setAttribute('style', 'stroke: #737373; fill: none;');
      defs.appendChild(path);
    });

    var currentPathData = paths[mode];

    var text = document.createElementNS(svgNamespaceURI, 'text');
    text.setAttribute('fill', 'rgb(102, 102, 102)');
    text.setAttribute('text-decoration', '');
    text.setAttribute('text-anchor', 'middle'); // start, middle, end - where text starts from
    text.setAttribute('letter-spacing', 0);

    var textPath = document.createElementNS(svgNamespaceURI, 'textPath');
    textPath.setAttribute('xlink:href', '#' + currentPathData.id);
    textPath.setAttribute('startOffset', '50%'); // Used to push text along the path
    var textNode = document.createTextNode(textValue);
    textPath.appendChild(textNode);

    text.appendChild(textPath);

    svgContainer.appendChild(defs);
    svgContainer.appendChild(text);
    svgContainer.setAttribute('viewBox','0 0 200 200');
    svgContainer.setAttribute('width', 200);
    svgContainer.setAttribute('height', 200);
    svgContainer.setAttribute('style', 'font-size: 30px; font-family: "Arial"; font-weight: 400;');


    // Add constructed elements
    var $asset = $(svgContainer);
    addAsset($asset, true);
  }
  function addSvgAsset(event){
    // Clone the SVG element
    var $asset = $(event.currentTarget).find('> svg').clone();
    // Add it
    addAsset($asset);
  }

  function attributeInUse(attribute) {
    return $svg.find('foreignObject > div').text().indexOf(attribute.tag) > -1;
  }

  // Adds an asset to the stage
  function addAsset($asset, isSVG) {
    togglePicking();
    // Scale down, if needed
    var viewBox = $asset.attr('viewBox');
    if (viewBox) {
      viewBox = viewBox.split(/\s+/);
      var width = viewBox[2];
      var height = viewBox[3];
      var proportion = width / height;
      if(width > $svg.width() - 20){
        width = $svg.width() - 20;
        height = width/proportion;
      }
      if(height > $svg.height() - 20){
        height = $svg.height() - 20;
        width = height*proportion;
      }
      $asset.attr('width', Math.round(width));
      $asset.attr('height', Math.round(height));
    }
    // Center to the stage
    var x = ($svg.width()-$asset.attr('width'))/2;
    var y = ($svg.height()-$asset.attr('height'))/2;
    $asset.attr('x', Math.round(x));
    $asset.attr('y', Math.round(y));
    // Append and select
    if (isSVG) {
      // SVG data has to be inserted as a string so that the browser connects the text to the path
      var svgString = $asset[0].outerHTML;
      $svg.append(svgString);
      select($svg.find('> svg').last());
    } else {
      $svg.append($asset);
      select($asset);
    }
  }

  // KEYDOWN
  function keyDown(event) {
    if (event.key.toLowerCase() === 'escape') {
      togglePicking();
    }
  }

  /** MOUSEUP
   *
   *  SCALE, ROTATE, DRAG etc. all use this function.
   */
  function mouseUp(event){
    $timeout(function() {
      if (ctrl.editingText) {
        var selection = $(ctrl.selection);
        adjustText(selection);
      }
      cleanUp();
      saveState();
    });
  }

  /** DESELECT
   *
   *  Mousedown on the SVG background to deselect.
   */
  function mouseDownDeselect() {
    $timeout(function() {
      deselect();
    });
  }

  // Color picking

  var pickerButton;
  var pickedAction;

  function togglePicking(clickedButton) {
    if (pickerButton) {
      pickerButton.removeClass('active');
      $element.find('.editor-svg-container').removeClass('picking-color');
      pickedAction = null;
    }
    if (pickerButton && clickedButton && pickerButton[0] == clickedButton[0]) {
      pickerButton = null;
    } else {
      pickerButton = clickedButton || null;
    }
  }

  function pickColor(event, action) {
    togglePicking(event ? $(event.currentTarget) : null);
    if (pickerButton) {
      pickerButton.addClass('active');
      $element.find('.editor-svg-container').addClass('picking-color');
      pickedAction = action;
    }
  }

  /** DRAG
   *
   *  Mousedown on any direct descendent of the canvas to
   *   start dragging the element.
   */
  var minDragDistance = 3;
  var initialPageX;
  var initialPageY;
  var offsetX;
  var offsetY;

  function mouseDownStartDragging(event){
    if (pickedAction) {
      // Pick color from target
      var element = event.target;
      var elementType = element.tagName.toLowerCase();
      var pickedColor;
      if (elementType === 'path' || elementType === 'polygon') {
        pickedColor = element.getAttribute('fill');
        pickedAction(pickedColor);
      } else if (elementType === 'div') {
        element = element.parentNode;
        elementType = element.tagName.toLowerCase();
        if (elementType === 'foreignobject') {
          pickedColor = $(element).css('color');
          pickedAction(pickedColor);
        }
      } else if (elementType === 'textpath') {
        element = element.parentNode;
        elementType = element.tagName.toLowerCase();
        if (elementType === 'text') {
          pickedColor = element.getAttribute('fill');
          pickedAction(pickedColor);
        }
      }
    } else {
      $timeout(function() {
        cleanUp();
        select($(event.currentTarget));
        calculateOffsetCoordinates(event);
        // Listen for `mousemove` and `mouseup` events on the DOCUMENT
        $(document).on('mousemove', mouseMoveDraggingResist);
        $(document).on('mouseup', mouseUp);
      });
    }

    // Prevent the "deselect" event
    event.stopImmediatePropagation();
  }

  // Store the offset of the mouse against the target
  function calculateOffsetCoordinates(event){
    var x = parseInt(ctrl.selection.attr('x'), 10);
    var y = parseInt(ctrl.selection.attr('y'), 10);
    initialPageX = event.pageX;
    initialPageY = event.pageY;
    offsetX = x - event.pageX;
    offsetY = y - event.pageY;
  }

  // Prevent miniscule movements on the initial drag by requiring a minimum movement distance
  function mouseMoveDraggingResist(event){
    $timeout(function() {
      var dx = event.pageX - initialPageX;
      var dy = event.pageY - initialPageY;
      var dist = Math.sqrt((dx*dx)+(dy*dy));
      if(dist > minDragDistance){
        $(document).off('mousemove', mouseMoveDraggingResist);
        $(document).on('mousemove', mouseMoveDragging);
      }
    });
  }

  // Drag the element
  function mouseMoveDragging(event){
    $timeout(function() {
      var x = event.pageX + offsetX;
      var y = event.pageY + offsetY;
      ctrl.selection.attr('x', x);
      ctrl.selection.attr('y', y);
      // Snapping
      snapElementToAxis(ctrl.selection, 'x');
      snapElementToAxis(ctrl.selection, 'y');
      renderSelectionOverlay();
      renderSelectionSnapGuides();
    });
  }

  /** SCALE
   *
   *  Mousedown on the corner handles to trigger scaling.
   *  This adjusts [width], [height], [x] and [y] attributes.
   */
  var scaleOriginalCoords;
  var scaleDirection;
  function mouseDownStartScale(event, direction){
    $timeout(function() {
      cleanUp();
      // Listen for `mousemove` and `mouseup` events on the DOCUMENT
      $(document).on('mousemove', mouseMoveScale);
      $(document).on('mouseup', mouseUp);
      // Store the original position of the element
      scaleDirection = direction; // tl, tr, br, bl
      scaleOriginalCoords = getElementCoordinates(ctrl.selection);
    });
    // Prevent any other events triggering
    event.stopImmediatePropagation();
  }
  function mouseMoveScale(event){
    $timeout(function() {
      var newX, newY, newWidth, newHeight, proportion;
      // What's the mouse position within the SVG?
      var svgX = Math.round(event.pageX - $svg.offset().left);
      var svgY = Math.round(event.pageY - $svg.offset().top);
      // Snapping
      svgX = snapValueToAxis('x', svgX);
      svgY = snapValueToAxis('y', svgY);
      // Apply proportional constraints?
      var viewBox = ctrl.selection.attr('viewBox');
      if(viewBox){
        if(viewBox){
          viewBox = viewBox.split(/\s+/);
          proportion = viewBox[2]/viewBox[3];
        }
      }
      // Calculate `width` and `x`
      if(scaleDirection.indexOf('r') !== -1){
        newWidth = svgX - scaleOriginalCoords.x.min;
        newX = scaleOriginalCoords.x.min;
      } else {
        newWidth = scaleOriginalCoords.x.max - svgX;
        newX = svgX;
      }
      // Calculate `height` and `y`
      if(scaleDirection.indexOf('b') !== -1){
        if(!proportion){
          newHeight = svgY - scaleOriginalCoords.y.min; // Based on the mouse position
        } else {
          newHeight = Math.round(newWidth / proportion); // As a function of the width
        }
        newY = scaleOriginalCoords.y.min;
      } else {
        if(!proportion){
          newHeight = scaleOriginalCoords.y.max - svgY; // Based on the mouse position
        } else {
          newHeight = Math.round(newWidth / proportion); // As a function of the width
        }
        newY = scaleOriginalCoords.y.max - newHeight;
      }
      // Update the target and overlay
      ctrl.selection.attr('x', newX);
      ctrl.selection.attr('y', newY);
      ctrl.selection.attr('width', newWidth);
      ctrl.selection.attr('height', newHeight);
      renderSelectionOverlay();
      renderSelectionSnapGuides();
    });
  }

  /** ROTATE
   *
   *  Mousedown on the rotate handles to trigger rotation.
   *
   *  This functionality is currently disabled as there's
   *   some logical knock-on that I'm not quite sure how to
   *   handle.
   */
  /*
  ctrl.mouseDownStartRotate = mouseDownStartRotate;
  function mouseDownStartRotate(event, direction){
    $timeout(function() {
      cleanUp();
      // Listen for `mousemove` and `mouseup` events on the DOCUMENT
      $(document).on('mousemove', mouseMoveRotate);
      $(document).on('mouseup', mouseUp);
    });
    // Prevent any other events triggering
    event.stopImmediatePropagation();
  }
  function mouseMoveRotate(event){
    console.log('mouseMoveRotate', Date.now());
    $timeout(function() {
      // Modifies x,y,width,height
      // ctrl.selection.attr('width', event.pageX);
      // ctrl.selection.attr('height', event.pageY);
      renderSelectionOverlay();
      renderSelectionSnapGuides();

      if(ctrl.selection.is('foreignObject')){
        // Simple CSS can handle this
        ctrl.selection.css({
          'transform': 'rotate(315deg)';
          'transform-origin': 'center';
        });
      } else {
        // Not quite sure how to transform nested <svg> elements as they don't accept CSS transform nor SVG [transform]
        // MY CURRENT THINKING
        //   Use <foreignObject> for all assets (image, svg and text)
        //   ...then scale, move and rotate all elements
      }

    });
  }
  */

  /** SELECTION MANAGEMENT
   *
   *    For now
   */

  // Select
  function select($myElement, dontSaveState) {
    if (ctrl.selection != $myElement) {
      removeCircularTextGuide(ctrl.selection);
      ctrl.selection = $myElement;
      $svg.find('> [selection]').removeAttr('selection');
      $myElement.attr('selection', true);
      renderSelectionOverlay();
      calculateSnapCache();
      if(!dontSaveState){
        saveState();
      }
      ctrl.selectionIsCustomImageAttribute = $(ctrl.selection).hasClass(CUSTOM_IMAGE_ATTRIBUTE);
      ctrl.editingText = $(ctrl.selection).is('foreignObject');
      canMove(); // Calcutates stack order
      //ctrl.badgeColors = harvestColors();
      checkIfSelectionIsQRCode();
    }
  }

  // Deselect
  function deselect(dontSaveState){
    if(ctrl.selection){
      $svg.find('> [selection]').removeAttr('selection');
      hideSelectionOverlay();
      cleanUp();
      if(!dontSaveState){
        saveState();
      }
      ctrl.editingText = false;
      ctrl.selectionIsCustomImageAttribute = false;
      ctrl.selection = null;
      checkIfSelectionIsQRCode();
    }
  }

  // Restore selection (based on whichever element has the [selection] attribute)
  function restoreSelection() {
    var $myElement = $svg.find('> [selection]');
    // console.log('restoreSelection', $myElement);
    if($myElement.length){
      select($myElement, true);
    } else {
      deselect(true);
    }
  }

  // Add circular text guide
  function addCircularTextGuide(selection) {
    var paths = selection.find('path:not([id])'); // Check that there isn't already a visible path
    if (paths.length === 0) {
      // Copy a path from the <defs> section of the <svg> and append it to the <svg> itself to make it visible
      var textPaths = selection.find('textPath');
      if (textPaths.length === 1) {
        var pathId = textPaths[0].getAttribute('xlink:href'); // Using javascript functions as jQuery doesn't work here
        if (pathId) {
          var circle = $(pathId)[0].cloneNode(true);
          circle.removeAttribute('id');
          selection[0].appendChild(circle);
        }
      }
    }
  }

  // Updates the selection box to match the target
  function renderSelectionOverlay() {
    var coords = getElementCoordinates(ctrl.selection);
    $element.find('.selection-overlay').show().css({
      left: coords.x.min,
      top: coords.y.min,
      width: (coords.x.max - coords.x.min - 1),  // The -1 is just for pixel-perfect rendering...
      height: (coords.y.max - coords.y.min - 1), // ...so the overlay matches the x and y guides
    });
    addCircularTextGuide(ctrl.selection);
  }

  // Remove circular text guide
  function removeCircularTextGuide(selection) {
    if (selection) {
      var textPaths = selection.find('textPath');
      var paths = selection.find('path:not([id])');
      if (textPaths.length === 1 && paths.length === 1) { // If there's  a textPath and a visible path, remove the path
        paths[0].parentNode.removeChild(paths[0]);
      }
    }
  }

  function hideSelectionOverlay() {
    $element.find('.selection-overlay').hide();
    removeCircularTextGuide(ctrl.selection);
  }

  function setBadgeDateFormat() {
    $svg[0].setAttribute('data-date-format', ctrl.dateFormat);
    saveState();
  }

  /** SNAPPING
   *
   *    We keep a cache of "snap" values on each axis.
   *    For each of these values, we have a list of elements
   *     that use the value, ie:
   *        "elements a, b and c have an edge (or center) on x=100"
   *
   *    We only need to calculate the snap cache when we
   *     START dragging, as we don't expect other elements
   *     to move around.
   */
  var snapCache = {
    tolerance: 3,
    x: {},
    y: {},
  };

  // Loops all the SVG elements and adds the coordinates
  function calculateSnapCache() {
    // Reset the object
    snapCache.x = {};
    snapCache.y = {};
    // Add the canvas itself
    addSnap('x', 0,                              null); // Left
    addSnap('x', Math.round($svg.width()/2),  null); // Middle
    addSnap('x', $svg.width(),                null); // Right
    addSnap('y', 0,                              null); // Top
    addSnap('y', Math.round($svg.height()/2), null); // Middle
    addSnap('y', $svg.height(),               null); // Bottom
    // Add all SVG elements coordinates
    var elements = $svg.find('> *:visible').not(ctrl.selection); // All visible elements, excluding the active one
    for (var e=0, el=elements.length; e<el; e++) {
      var $myElement = $(elements[e]);
      var coords = getElementCoordinates($myElement);
      addSnap('x', coords.x.min, $myElement); // Left
      addSnap('x', coords.x.mid, $myElement); // Middle
      addSnap('x', coords.x.max, $myElement); // Right
      addSnap('y', coords.y.min, $myElement); // Top
      addSnap('y', coords.y.mid, $myElement); // Middle
      addSnap('y', coords.y.max, $myElement); // Bottom
    }
  }

  // Adds a coordinate to the snap grid
  function addSnap(axis, value, $myElement) {
    value = Math.round(value); // This makes the snapping more visually reliable when we consider the juggling of px and %
    if(!snapCache[axis][value]){
      snapCache[axis][value] = [];
    }
    if($myElement){
      snapCache[axis][value].push($myElement);
    }
  }

  // Snaps a `value` to an axis
  function snapValueToAxis(axis, value){
    var bestMatch = {
      distance: snapCache.tolerance,
      snapValue: null, // The `snap` value
    };
    // Loop the axis
    for(var snapValue in snapCache[axis]){
      if(snapCache[axis].hasOwnProperty(snapValue)){
        var dist = Math.round(Math.abs(value - snapValue));
        if(dist < bestMatch.distance){
          bestMatch.distance = dist;
          bestMatch.snapValue = snapValue;
        }
      }
    }
    // Return the snap value, if possible, or the original
    return bestMatch.snapValue || value;
  }

  // Updates the target and snaps it to the nearest axis (within tolerence)
  function snapElementToAxis($myElement, axis){
    var coords = getElementCoordinates($myElement);
    var bestMatch = {
      distance: snapCache.tolerance,
      snapValue: null, // The `snap` value - this may represent snapping to the top, right, bottom, left or middle!
      attrValue: null,  // The `min` value - this will represent the new top or left value (depending on axis)
    };
    for(var snapValue in snapCache[axis]){
      if(snapCache[axis].hasOwnProperty(snapValue)){
        var dist;
        // Middle
        dist = Math.round(Math.abs(coords[axis].mid - snapValue));
        dist -= 0.1; // This means that `middle` overrides `top/left` and `bottom/right`
        if(dist < bestMatch.distance + 0.1){
          bestMatch.distance = dist;
          bestMatch.snapValue = snapValue;
          bestMatch.attrValue = snapValue - (coords[axis].mid - coords[axis].min);
        }
        // Top / Left
        dist = Math.round(Math.abs(coords[axis].min - snapValue));
        if(dist < bestMatch.distance){
          bestMatch.distance = dist;
          bestMatch.snapValue = snapValue;
          bestMatch.attrValue = snapValue;
        }
        // Bottom / Right
        dist = Math.round(Math.abs(coords[axis].max - snapValue));
        if(dist < bestMatch.distance){
          bestMatch.distance = dist;
          bestMatch.snapValue = snapValue;
          bestMatch.attrValue = snapValue - (coords[axis].max - coords[axis].min);
        }
      }
    }
    // If we have a match, update the selection position
    if(bestMatch.attrValue !== null){
      $myElement.attr(axis, bestMatch.attrValue);
    }
  }

  // Renders all snap values for the selection
  function renderSelectionSnapGuides() {
    removeAllSnapGuides();
    var coords = getElementCoordinates(ctrl.selection);
    var axes = ['x', 'y'];
    for(var a=0,al=axes.length; a<al; a++){
      var axis = axes[a];
      angular.forEach(coords[axis], function(value){
        if(snapCache[axis][value]){
          addSnapGuide(axis, value);
        }
      });
    }
  }

  // Renders a guide at a position
  function addSnapGuide(axis, value){
    var $parent = $element.find('.editor-canvas');
    var prop = axis === 'x' ? 'left' : 'top';
    var $guide = $('<div>').addClass('guide-'+axis).css(prop, (value-1)+'px');
    $parent.append($guide);
  }

  // Removes snap guides (both axis)
  function removeAllSnapGuides() {
    $element.find('.guide-x').remove();
    $element.find('.guide-y').remove();
  }

  /** UTILITY
   *
   *  Various miscellaneous functions
   */

  // Gets the coordinates of an element, including the midpoints
  function getElementCoordinates($myElement){
    var x      = parseInt($myElement.attr('x'), 10);
    var y      = parseInt($myElement.attr('y'), 10);
    var width  = parseInt($myElement.attr('width'), 10);
    var height = parseInt($myElement.attr('height'), 10);
    return {
      x: {
        min: Math.floor(x),
        mid: Math.round(x+(width/2)),
        max: Math.ceil(x+width),
      },
      y: {
        min: Math.floor(y),
        mid: Math.round(y+(height/2)),
        max: Math.ceil(y+height),
      },
    };
  }

  // Cleans a string of ng-* attributes, classes and comments
  function stripAngularHtmlArtefacts($myElement){
    $myElement.find('*').addBack().each(function() {
      var el = this;
      // Remove all ng-* attributes
      for(var a=el.attributes.length-1; a>=0; a--){
        var attr = el.attributes[a];
        if(attr && attr.specified){
          if(attr.name.indexOf('ng-') === 0){
            $(el).removeAttr(attr.name);
          }
        }
      }
      // Remove ALL classes (the SVG has no stylesheet, so...)
      // Leave custom image attribute class
      if ($(this).hasClass(CUSTOM_IMAGE_ATTRIBUTE)) {
        $(this).attr('class', CUSTOM_IMAGE_ATTRIBUTE);
      } else {
        $(this).removeAttr('class');
      }
    });
    // Remove <!-- comments -->
    $myElement.find('*').contents().each(function() {
      if(this.nodeType === Node.COMMENT_NODE) {
        $(this).remove();
      }
    });
  }

  // Makes sure all "void" elements are self-closing. ie: <br> becomes <br/>
  var voidTagRegex = /<(area|base|br|col|hr|img|input|link|meta|param|command|keygen|source)\b([^>]*)\/?>/gi;
  function closeVoidElements(svgString){
    return svgString.replace(voidTagRegex, '<$1 $2/>');
  }

  // Replaces named HTML entities with numeric character references. ie: &nbsp; becomes &#160;
  function removeNamedEntities(svgString){
    return Entities.normalizeXML(svgString, 'numeric');
  }

  // //
  // function editingText() {
  //   return ctrl.selection && $(ctrl.selection).is('foreignObject');
  // }

  // Send go to route
  function gotoRoute(destination) {
    $element.trigger('goto', destination);
  }

  // Replace selected text
  function replaceSelectedText(replacementText) {
    var sel, range;
    var replaced = false;
    if (window.getSelection) {
      sel = window.getSelection();
      if ($(sel.anchorNode.parentElement).closest('foreignObject').length > 0 && sel.rangeCount) { // Make sure the selection is inside a foreignObject
        range = sel.getRangeAt(0);
        range.deleteContents();
        range.insertNode(document.createTextNode(replacementText));
        replaced = true;
      }
    } else if (document.selection && document.selection.createRange) { // This is for IE < 9 and may not work
      range = document.selection.createRange();
      range.text = replacementText;
      replaced = true;
    }
    return replaced;
  }

  function addQRCodeBlock() {
    var qrSvgElement = document.createElement('svg');
    qrSvgElement.setAttribute('id', QR_CODE_SVG_ID);
    qrSvgElement.setAttribute('viewBox', '0 0 60 60');
    qrSvgElement.innerHTML = '<rect width="100%" height="100%" fill="#ffffff"></rect><svg x="5" y="5"><g fill="#000000"><path d="M 0 49.582031 L 22.726562 49.582031 L 22.726562 27.234375 L 0 27.234375 Z M 4.542969 31.703125 L 18.179688 31.703125 L 18.179688 45.078125 L 4.542969 45.078125 Z M 4.542969 31.703125 "></path><path d="M 13.636719 36.171875 L 9.089844 36.171875 L 9.089844 40.644531 L 13.636719 40.644531 Z M 13.636719 36.171875 "></path><path d="M 40.910156 45.113281 L 36.359375 45.113281 L 36.359375 49.582031 L 40.910156 49.582031 Z M 40.910156 45.113281 "></path><path d="M 50 45.113281 L 45.453125 45.113281 L 45.453125 49.582031 L 50 49.582031 Z M 50 45.113281 "></path><path d="M 45.453125 31.703125 L 40.910156 31.703125 L 40.910156 27.234375 L 27.273438 27.234375 L 27.273438 49.582031 L 31.816406 49.582031 L 31.816406 36.171875 L 36.359375 36.171875 L 36.359375 40.644531 L 50 40.644531 L 50 27.234375 L 45.453125 27.234375 Z M 45.453125 31.703125 "></path><path d="M 0 22.761719 L 22.726562 22.761719 L 22.726562 0.417969 L 0 0.417969 Z M 4.542969 4.886719 L 18.179688 4.886719 L 18.179688 18.292969 L 4.542969 18.292969 Z M 4.542969 4.886719 "></path><path d="M 13.636719 9.355469 L 9.089844 9.355469 L 9.089844 13.824219 L 13.636719 13.824219 Z M 13.636719 9.355469 "></path><path d="M 27.273438 0.417969 L 27.273438 22.761719 L 50 22.761719 L 50 0.417969 Z M 45.453125 18.292969 L 31.816406 18.292969 L 31.816406 4.886719 L 45.453125 4.886719 Z M 45.453125 18.292969 "></path><path d="M 40.910156 9.355469 L 36.359375 9.355469 L 36.359375 13.824219 L 40.910156 13.824219 Z M 40.910156 9.355469 "></path> </g></svg>';
    var $asset = $(qrSvgElement);
    addAsset($asset, true);

    updateQRCodeStatus(true);
  };

  function checkIfHasQRCode() {
    var hasQRCode = false;
    $svg.find('svg').each(function() {
      hasQRCode = hasQRCode || this.id === QR_CODE_SVG_ID;
    });

    updateQRCodeStatus(hasQRCode);
  }

  function updateQRCodeStatus(status) {
    ctrl.hasQRCode = status;
  }

  function checkIfSelectionIsQRCode() {
    ctrl.selectionIsQRCode = $(ctrl.selection).is('svg#' + QR_CODE_SVG_ID);
  }
}

angular
  .module('app')
  .component('svgEditor', svgEditorComponent)
  .run(certificateEditorDirectivePreload);

},{"../../shared/_services/uuidv4.service.js":177,"../../shared/alert/legacySwalService.js":179,"../../shared/basicFilters.js":185,"../../shared/button-color/button-color.directive.js":186,"../../shared/font-menu/font-menu.component.js":231,"../../shared/fonts/font.service.js":232,"../../shared/history/history.factory.js":237,"../../shared/save-button/save-button.directive.js":298,"./_js/svg-editor-arrange.component.js":308,"./_js/svg-editor-colors.component.js":309,"./_js/svg-editor-contenteditable.directive.js":310,"./_js/svg-editor-delete.component.js":311,"./_js/svg-editor-duplicate.component.js":312,"./_js/svg-editor-export.component.js":313,"./_js/svg-editor-font.component.js":314,"./_js/svg-editor-history.component.js":315,"./_js/svg-editor-nudge.component.js":316,"./_js/svg-editor-object-type.component.js":317,"./_js/svg-editor-opacity.component.js":318,"./_js/svg-editor-text-on-path.component.js":319}],321:[function(require,module,exports){
/** TOGGLE
 *
 *  Renders a toggle switch
 *
 *    <toggle ng-model="myBoolean"></toggle>
 *    <toggle ng-model="myBoolean" ng-disabled="true"></toggle>
 *    <toggle ng-model="myBoolean" ng-disabled="true" change-action="action"></toggle>
 *
 *    @author   David "oodavid" King
 */
var toggleComponent = {
  controller: toggleComponentController,
  bindings: {
    ngModel: '=',
    ngDisabled: '<?',
    changeAction: '&?',
  },
  templateUrl: '/shared/toggle/toggle.html',
};

toggleComponentController.$inject = ['$element', '$scope'];
function toggleComponentController($element, $scope) {
  var ctrl = this;
  ctrl.onChange = onChange;
  ctrl.$onInit = onInit;
  ctrl.$onDestroy = onDestroy;

  function onChange() {
    if (ctrl.changeAction) {
      ctrl.changeAction();
    }
  }

  function keyPressed(event) {
    if (event.key === 'Enter') {
      $scope.$apply(function() {
        ctrl.ngModel = !ctrl.ngModel;
        onChange();
      });
    }
  }

  function onInit() {
    $element.on('keydown', keyPressed);
  }

  function onDestroy() {
    $element.off('keydown', keyPressed);
  }
}

angular
  .module('app')
  .component('toggle', toggleComponent);

},{}],322:[function(require,module,exports){
/** TOOLTIP
 *
 *    I'm not using AngularJS by design - why? Because I don't want
 *       to assign new scopes or events for every element, this will
 *     be pretty damn lightweight in action:
 *
 *      <div tooltip="Hello World!"></div>
 *
 *    Override the automatic placement with the [tooltip-placement]
 *     attribute:
 *
 *      <div tooltip="Hello World!" tooltip-placement="bottom"></div>
 *
 *      CSS Note
 *
 *          To render these correctly, be sure to use _toolip.scss
 *           which is available as part of our CSS framework.
 *
 *    @author   David "oodavid" King
 *    @author   Andrew Bateman (accessibility revisions)
 *
 */
(function() {
  // When we mouseover or focus
  var maskingContainer = null;
  var initiator = null;
  var toolTipEnter = function(e) {
    toolTipLeave(e);
    initiator = e.target;
    // Handle tooltip on dropdown root
    var initiatorParent = angular.element(initiator).parent();
    var initiatorParentTagName = initiatorParent.prop('tagName').toLowerCase() ;
    if ((initiatorParentTagName === 'dropdown-button' && initiatorParent.siblings('dropdown-content').find('> div').length > 0) || initiatorParentTagName === 'dropdown-content') {
      return;
    }
    var target = angular.element(e.target).closest('[tooltip]');
    // Only activate if there isn't a tooltip already or, if it is a toggletip, on the 'toggletipactivate' event
    if (target.attr('hidetooltip') && Boolean(target.attr('hidetooltip').value) || target.siblings().is('#tooltip') || (target.attr('toggletip') && e.type !== 'toggletipactivate' && e.type !== 'mouseenter')) {
      return;
    }
    var $tooltip = angular.element('<span id="tooltip" role="tooltip" aria-live="true"></span>'); // Create tooltip container
    target.append($tooltip); // Insert it into the DOM in context
    var text = target.attr('tooltip');
    var placement = target.attr('tooltip-placement'); // Likely to be null...
    var offset = target.offset();
    var customWidth = target.attr('tooltip-width');
    $tooltip.css({ maxWidth: customWidth + 'px' });
    offset.top -= angular.element(document).scrollTop();
    offset.left -= angular.element(document).scrollLeft();
    var parent = target;
    while (parent[0] !== angular.element('body')[0] && !maskingContainer) {
      var parentOverflow = parent.css('overflow');
      if (parentOverflow === 'auto' || parentOverflow === 'scroll') {
        maskingContainer = parent;
      } else {
        parent = parent.parent();
      }
    }
    maskingContainer = maskingContainer || angular.element('body');
    // Make sure "\\n" are converted to "\n"
    text = text.replace(/\\n/g, '\n');
    // Do nothing if we're in a disabled DOM tree, or we have no text to show
    if (target.closest('[disabled]').length || !text) {
      toolTipLeave();
      return;
    }
    // Reset with text immediately, then we can access the rendered tooltip dimensions
    $tooltip.text(text).removeClass('top right bottom left').css({
      left: 0,
      top: 0
    }).show();
    // Automatic placement
    if (!placement || ['top', 'left', 'bottom', 'right'].indexOf(placement) === -1) {
      placement = 'top';
      var centreX = offset.left + (target.outerWidth() / 2);
      var left = centreX - ($tooltip.outerWidth() / 2);
      var right = centreX + ($tooltip.outerWidth() / 2);
      if (left < maskingContainer.offset().left) {
        placement = 'right';
      } else if (right > maskingContainer.offset().left + maskingContainer.innerWidth()) {
        placement = 'left';
      } else if ((offset.top) - $tooltip.outerHeight() < 10) {
        placement = 'bottom';
      }
    }
    // Now position
    if (placement === 'bottom') {
      $tooltip
        .css({
          left: offset.left - ($tooltip.outerWidth() / 2) + (target.outerWidth() / 2),
          top: offset.top + target.outerHeight()
        });
    } else if (placement === 'right') {
      $tooltip
        .css({
          left: offset.left + target.outerWidth(),
          top: offset.top - ($tooltip.outerHeight() / 2) + (target.outerHeight() / 2)
        });
    } else if (placement === 'left') {
      $tooltip
        .css({
          left: offset.left - $tooltip.outerWidth(),
          top: offset.top + (target.outerHeight() / 2) - ($tooltip.outerHeight() / 2)
        });
    } else if (placement === 'top') {
      $tooltip
        .css({
          left: offset.left - ($tooltip.outerWidth() / 2) + (target.outerWidth() / 2),
          top: offset.top - $tooltip.outerHeight()
        });
    } else {
      $tooltip.hide(); // We shouldn't get here
    }
    // Make sure tooltip doesn't overflow masking container
    var leftOverflow = maskingContainer.offset().left - $tooltip.offset().left;
    var rightOverflow = ($tooltip.offset().left + $tooltip.outerWidth()) - (maskingContainer.offset().left + maskingContainer.innerWidth());
    var overflow = (leftOverflow > 0 ? leftOverflow + 8 : 0) + (rightOverflow > 0 ? rightOverflow + 8 : 0);
    if (overflow > 0) {
      var tooltipWidth = customWidth ? Number(customWidth.value) : 240;
      $tooltip.css('max-width', tooltipWidth - overflow);
    }
    // Style
    target.addClass('has-tooltip');
    $tooltip.addClass(placement);
    // SHAME
    //  The tooltip was never intended to be used as a conveyor of permissions
    //  For want of a refactor of tooltips at large, I have quickly added this
    //  logic to render the tooltip as a "warning"
    $tooltip.removeClass('not-allowed');
    if (target.hasClass('not-allowed')) {
      $tooltip.addClass('not-allowed');
    }
    if (maskingContainer[0] !== angular.element('body')[0]) {
      maskingContainer.on('scroll', toolTipLeave);
    }
  };
  // When we mouseleave
  var toolTipLeave = function(event) {
    angular.element('#tooltip').remove();
    angular.element('.has-tooltip').removeClass('has-tooltip');
    if (maskingContainer && maskingContainer[0] !== angular.element('body')[0]) {
      maskingContainer.off('scroll', toolTipLeave);
    }
    maskingContainer = null;
    // If the tooltip is on a <dropdown-button>, force the menu to open (if it hasn't already)
    if (initiator) {
      if (event && event.type === 'mousedown') {
        var currentInitiator = initiator;
        var initiatorParent = angular.element(currentInitiator).parent();
        // Using setTimeout here to avoid refactoring the entire directive
        if (initiatorParent.prop('tagName').toLowerCase() === 'dropdown-button') {
          // eslint-disable-next-line angular/timeout-service
          setTimeout(function() {
            if (initiatorParent.siblings('dropdown-content').find('> div').length === 0) {
              currentInitiator.click();
            }
          }, 200);
        }
      }
      initiator = null;
    }
  };
  // For speed, tooltips are "pure" jQuery.
  angular.element(document).ready(function() {
    angular.element('body').on('mouseenter', '[tooltip]', toolTipEnter);
    angular.element('body').on('focus', '[tooltip]', toolTipEnter);
    angular.element('body').on('toggletipactivate', '[tooltip]', toolTipEnter);
    angular.element('body').on('mouseleave', '[tooltip]', toolTipLeave);
    angular.element('body').on('blur', '[tooltip]', toolTipLeave);
    angular.element('body').on('mousedown', toolTipLeave);
    angular.element(document).on('scroll', toolTipLeave);
    angular.element('body').on('keydown', function(event) {
      if (event.key === 'Escape') {
        toolTipLeave();
      }
    });
  });
  // To make sure tooltips are correctly tidied up, we need to hide the tooltip if the parent is destroyed
  angular
    .module('app')
    .directive('tooltip', [function() {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          // Add and update label for screen readers, if one isn't already set
          if (!element.attr('aria-label')) {
            element.attr('aria-label', '');
            attrs.$observe('tooltip', function(value) {
              attrs.$set('aria-label', attrs.toggletip ? attrs.toggletip : value);
            });
          }
          if (attrs.toggletip) {
            element.on('click', function() {
              if (element.hasClass('has-tooltip')) {
                toolTipLeave();
              } else {
                element.trigger('toggletipactivate');
              }
            });
          }
          scope.$on('$destroy', function() {
            if (element.hasClass('has-tooltip')) {
              toolTipLeave();
            }
          });
        }
      };
    }]);
})();

},{}],323:[function(require,module,exports){
/** TRACKING SERVICE (ANALYTICS)
 *
 *      This service handles "tracking" events for analytics
 *       purposes. Basically, silent API calls that log clicks
 *       or other actions on the system.
 *
 *      @author  David "oodavid" King
 */
angular.module('app')
  .service('trackingService', ['api', function(api) {

    /** LINKED IN ADD
     *
     *      The user added a credential to their LinkedIn profile
     */
    this.linkedInAdd = function(credential) {
      return api.request('/user/linkedin_certificate_added', {
        credential_id: credential.id,
      });
    };

    /** LINKED IN SHARE
     *
     *      The user shared a credential on their LinkedIn profile
     */
    this.linkedInShare = function(credential) {
      return api.request('/user/linkedin_certificate_shared', {
        credential_id: credential.id,
      });
    };

    /** FOLLOW CLICKED
     *
     *      The user clicked a social network platform related
     *       to a Credential, and thus, related to an issuer.
     */
    this.followClicked = function(platform, credential) {
      return api.request('/frontend/store_follow_click', {
        event: platform,
        credential_id: credential.id,
      });
    };

  }]);

},{}],324:[function(require,module,exports){
/** Unsaved Changes - DIRECTIVE
 *
 *    A simple directive that adds a warning to unsaved forms
 *     when attempting to navigate away from a view.
 *
 *    Example
 *      <form name="formCtrl" unsaved-changes>
 *        <input ... >
 *      </form>
 *
 *    This Directive relies on the angular $dirty property
 *     that is assigned to form elements. In order to properly
 *     handle submitted changes you will need to make sure that
 *     $setPristine(); is triggered on your form after a
 *     successful submit or reset, like so:
 *      formCtrl.$setPristine();
 *
 *    @author   David "oodavid" King
 */
unsavedChangesDirective.$inject = ['$window', '$injector', '$filter', '_'];
function unsavedChangesDirective($window, $injector, $filter, _) {

  // Tracking the active forms
  var allForms = [];
  function trackForm(form){
    allForms.push(form);
  }
  function untrackForm(form){
    _.pull(allForms, form);
  }

  // Handle user navigation - window event
  function unsavedChangesOnBeforeUnload(e) {
    var numDirtyForms = getNumDirtyForms();
    if(numDirtyForms){
      var message = getWarningMessage(numDirtyForms);
      e = e || $window.event;
      if (e) {
        e.returnValue = message; // IE / Firefox
      }
      return message; // Webkit / Safari / Chrome
    }
  }
  $window.onbeforeunload = unsavedChangesOnBeforeUnload;

  // Handle user navigation - via ui-router
  if($injector.has('$transitions')){
    var $transitions = $injector.get('$transitions');
    $transitions.onStart({}, unsavedChangesUiRouterOnStart);
  }
  function unsavedChangesUiRouterOnStart($transition) {
    // NOTE: This doesn't work correctly with browser back as it fires after the history has already been popped
    // Can't see any way of fixing this at the moment
    // The transitions service has a bug; it sometimes triggers an event from and to the same page.
    // console > options > reload: true
    if($transition.from().name == $transition.to().name && angular.equals($transition.params('from'), $transition.params('to'))){
      return true; // OK to close / redirect
    }
    // Prompt the user, if necessary
    var numDirtyForms = getNumDirtyForms();
    if(numDirtyForms){
      var message = getWarningMessage(numDirtyForms);
      if (!$window.confirm(message)) {
        return false; // Don't close / redirect
      }
    }
    return true; // OK to close / redirect
  }

  // Manually run a check on a single form
  function unsavedChangesCanClose(form){
    if(form.$dirty){
      var message = getWarningMessage(1);
      if (!$window.confirm(message)) {
        return false; // Don't close / redirect
      }
    }
    return true; // It's OK to close the form
  }

  // Returns a warning message for the number of forms - pluralisation
  function getWarningMessage(numForms){
    var translate = $filter('translate');
    var message = numForms > 1 ? translate('unsaved.changes-multiple-forms', { numForms: numForms}) : translate('unsaved.changes-single-form'); // Notify
    message += '\n\n' + translate('unsaved.leave-confirm'); // Action
    return message;
  }

  // Returns the number of dirty forms
  function getNumDirtyForms() {
    var dirtyForms = _.filter(allForms, function(form) {
      return form.$dirty;
    });
    return dirtyForms.length;
  }

  // Forms with the unsaved-changes attribute are simply added to our watch list
  function unsavedChangesDirectiveLink(scope, element, attrs, form) {
    // Tracking
    trackForm(form);
    element.on('$destroy', function() {
      untrackForm(form);
    });
    // Add a helper method to the form scope
    scope.unsavedChangesCanClose = function(){
      return unsavedChangesCanClose(form);
    };
  }

  // The directive
  return {
    restrict: 'A', // Attribute only
    require: '^form',
    link: unsavedChangesDirectiveLink,
  };

}

angular
  .module('app')
  .directive('unsavedChanges', unsavedChangesDirective);

},{}],325:[function(require,module,exports){
/** UPLOAD FILE - DIRECTIVE
 *
 *      The file upload Custom Directive abstracts away the logic
 *       of ng-file-upload, dealing with our S3 bucket and the
 *       various common edge-cases. Leaving the designer to create
 *       a nice interace, and keeping our Controllers clean.
 *
 *      Usage
 *
 *          <button class="button" upload-file upload-preset="issuerImage" on-upload="onFile(fileUrl)" upload-progress="progressA" ng-style="{ 'background-size': progressA+'% 100%' }">
 *              Upload an Issuer Image
 *          </button>
 *
 *      NOTES
 *
 *          The progress system uses real data when available, but
 *           falls back to spoofing it. This is similar to the way
 *           the angular-loading-bar works, which is effective.
 *
 *      @author   David "oodavid" King
 */
require('../upload/uploadPresets.constant.js');

(function() {
  angular.module('app')
    .directive('uploadFile', ['uploadPresets', 'swalService', '$compile', 'fileSize', '$document', '$injector', function(uploadPresets, swalService, $compile, fileSize, $document, $injector) {
      // To "seed" our progress estimation, we assume the user has
      //  uploaded a small file (200kb) at 1Mbps.
      var Mbps = 1; // Megabits per second
      var Bpms = Mbps * 0.125 * 1000; // Bytes per Millisecond
      var uploadedBytes = fileSize.parse('3kB'); // Bytes
      var durationMs = uploadedBytes / Bpms; // Milliseconds
      // Then, whenever a file is uploaded, we adjust these values
      //  to get a more accurate reading. This is a similar method
      //  that angular-loading-bar uses. Smoke and Mirrors.
      var adjustUploadSettings = function(bytes, ms) {
        uploadedBytes += bytes;
        durationMs += ms;
        Bpms = uploadedBytes / durationMs;
      };
      // This returns an estimated time to upload
      var estimateUploadTimeMs = function(fileSizeBytes) {
        return (fileSizeBytes / Bpms) + 1500; // Add 1.5s for the HTTP round-trip
      };
      // This returns a estimated progress percentage based on the known
      //  size of the file AND historical upload sizes and times.
      // See https://github.com/oodavid/timestep/blob/master/src/animate/transitions.js
      //  for alternative easing logic
      var esimateProgress = function(fileSizeBytes, timeElapsedMs) {
        var estimatedTotalMs = estimateUploadTimeMs(fileSizeBytes);
        var n = timeElapsedMs / estimatedTotalMs;
        n += 0.05; // Never be 0
        if (n > 1) {
          n = 1;
        }
        n *= 0.9; // Never get to 1
        return n * (2 - n); // EaseOutQuad
      };
      // S3 response with XML, we need a formatter
      var x2js = new window.X2JS();
      // Controller applies to the (transcluded) element
      var controller = ['$scope', '$element', '$timeout', 'api', 'Upload', function($scope, $element, $timeout, api, Upload) {
        $scope.progress = undefined;
        $scope.error = false;
        $scope.preset = uploadPresets[$scope.uploadPreset] || uploadPresets['default'];
        $scope.isDisabled = false;
        //
        // Estimates the progress
        //
        var startTimeMs;
        var progressTimeout;
        var fileSizeBytes;
        var estimateProgress = function() {
          var elapsedTimeMs = Date.now() - startTimeMs;
          $scope.progress = (esimateProgress(fileSizeBytes, elapsedTimeMs) * 100).toFixed(2);
          progressTimeout = $timeout(estimateProgress, 50);
        };
        var startEstimatingProgress = function(myFileSizeBytes) {
          fileSizeBytes = myFileSizeBytes;
          startTimeMs = Date.now();
          $scope.progress = 0;
          estimateProgress();
        };
        var stopEstimatingProgress = function(success) {
          if (progressTimeout) {
            $timeout.cancel(progressTimeout);
            progressTimeout = false;
          }
          if (success) {
            var elapsedTimeMs = Date.now() - startTimeMs;
            adjustUploadSettings(fileSizeBytes, elapsedTimeMs);
          }
        };
        //
        // When clicking, we "reset" the button, but temporarily
        //  disable it to prevent the user machine-gunning the button
        //
        $scope.doClick = function() {
          $element.removeClass('uploading error'); //.blur(); // Removed the blur as it interferes with focus-trapping
          $scope.error = false;
          $scope.isDisabled = true;
          $timeout(function() {
            $scope.isDisabled = false;
          }, 2500);
        };
        //
        // Shows an error message
        //
        var doError = function(err) {
          err = err || 'Unknown error occurred';
          console.error(err);
          $scope.error = err;
          stopEstimatingProgress(false);
          $element.addClass('uploading error');
          $scope.isDisabled = false;
          $timeout(function() {
            $element.removeClass('uploading error');
            $scope.progress = undefined;
          }, 2000);
        };
        //
        // When we have a successful upload
        //
        var doSuccess = function(fileUrl, fileType, fileName, s3Bucket, s3Key, fileSizeBytes) {
          $scope.onUpload({
            fileUrl: fileUrl,
            fileType: fileType,
            fileName: fileName,
            s3Bucket: s3Bucket,
            s3Key: s3Key,
            fileSizeBytes: fileSizeBytes,
          });
          stopEstimatingProgress(true);
          $scope.progress = 100;
          $scope.isDisabled = false;
          $element.removeClass('uploading error');
          $timeout(function() {
            $scope.progress = undefined;
          }, 500);
        };
        //
        // When we select a file
        //
        $scope.onFileSelect = function($file) {
          var displayGenericError = function() {
            swalService.showAlert('fileUploadError');
          };
          // Check for files etc.
          if($file){
            // Once we've acknowledged the event, the user is free to re-click
            $scope.isDisabled = false;
            // Silently ignore incorrect file extentions (crude check)
            var ext = '.'+$file.name.split('.').pop().toLowerCase();
            if($scope.preset.accept && $scope.preset.accept.indexOf(ext) === -1){
              return;
            }
            // Validate the size
            if ($file.size < fileSize.parse($scope.preset.size)) {
              // Now we're uploading...
              $element.addClass('uploading');
              $scope.progress = 0;

              var policyUrl =  $scope.preset.policy + '?content_type=' + $file.type;
              // Grab the S3 policy
              api.request(policyUrl)
                .then(function(s3Params) {
                  //console.log('s3Params', s3Params);
                  var fileKey = s3Params.key;
                  if ($file.name.indexOf('.') !== -1) {
                    fileKey += '.' + $file.name.split('.').pop(); // Add the file extension (it's useful)
                  }
                  // The final Url
                  // var fileUrl = 'https://s3.amazonaws.com/' + s3Params.bucket_name + '/' + fileKey;
                  var fileUrl = s3Params.bucket_file_url_prefix + fileKey;
                  // Run supplied start function
                  if ($scope.onStart) {
                    $scope.onStart();
                  }
                  // Estimate progress
                  startEstimatingProgress($file.size);
                  // IE8 won't get a response, simulate one
                  if ($('body').is('.ie8')) {
                    var delay = estimateUploadTimeMs($file.size);
                    $timeout(function() {
                      doSuccess(fileUrl, $file.type, $file.name, s3Params.bucket_name, fileKey, $file.size);
                    }, delay);
                  }
                  // Upload the file
                  Upload.upload({
                      // url: 'https://' + s3Params.bucket_name + '.s3.amazonaws.com/',
                      url: s3Params.bucket_url,
                      method: 'POST',
                      // data: {
                      //   'key': fileKey,
                      //   'acl': $scope.preset.acl,
                      //   'Content-Type': ($file.type || 'application/octet-stream'),
                      //   'success_action_status': '201',
                      //   'AWSAccessKeyId': s3Params.access_key_id,
                      //   'Policy': s3Params.policy,
                      //   'Signature': s3Params.signature,
                      //   'Filename': $file.name.replace(/ /g, '_').replace(/[\[,\]]/g, ''),
                      // },
                      data: {
                        'key': fileKey,
                        'acl': $scope.preset.acl,
                        'Content-Type': ($file.type || 'application/octet-stream'),
                        'success_action_status': '201',
                        'X-Amz-Credential' : s3Params['x-amz-credential'],
                        'X-Amz-Algorithm': s3Params['x-amz-algorithm'],
                        'X-Amz-Date': s3Params['x-amz-date'],
                        'X-Amz-Signature': s3Params['x-amz-signature'],
                        'Policy': s3Params.policy,
                        'Filename': $file.name.replace(/ /g, '_').replace(/[\[,\]]/g, ''),
                      },
                      file: $file,
                    })
                    .progress(function(evt) {
                      stopEstimatingProgress(false); // No need to estimate, we got real progress
                      $scope.progress = ((evt.loaded / evt.total) * 100).toFixed(2);
                    })
                    .success(function(xmlResponse, status, headers, config) {
                      if (status === 200 || status === 201) {
                        // File was uploaded successfully
                        var jsonResponse = x2js.xml_str2json(xmlResponse);
                        doSuccess(fileUrl, $file.type, $file.name, s3Params.bucket_name, fileKey, $file.size);
                      } else {
                        doError(status);
                        displayGenericError();
                      }
                    })
                    .error(function(err) {
                      doError(err);
                      displayGenericError();
                    });
                })
                .catch(function(err) {
                  doError(err || 'Upload Policy Error');
                  displayGenericError();
                });
            } else {
              swalService.showAlert('fileTooLargeError', $scope.preset.size);
            }
          }
        };
      }];
      // Our Custom Directive hoists some variables into the scope, sets the controller and adds the angular-file-upload attributes
      return {
        restrict: 'A',
        scope: {
          uploadPreset: '@?',
          progress: '=?uploadProgress',
          error: '=?onError',
          onStart: '&?onStart',
          onUpload: '&?onUpload',
          ngDisabled: '=?',
          onUploadFullscreen: '@uploadFullscreen',
        },
        require: '?^fullscreenUpload',
        controller: controller,
        link: function(scope, element, attrs, fullscreenUploadCtrl) {
          if(element[0].tagName === 'button'){
            attrs.$set('type', 'button'); // Force the button `type`
          }
          attrs.$set('ng-disabled', 'ngDisabled || isDisabled'); // ngDisabled MIGHT be available as an attribute, but this is fine either way
          attrs.$set('ng-click', 'doClick()');
          attrs.$set('ngf-select', 'onFileSelect($file)');
          attrs.$set('ngf-drop', 'onFileSelect($file)');
          attrs.$set('ngf-drag-over-class', '\'dragover\'');
          attrs.$set('ngf-accept', 'preset.accept'); // This slows the browser modal down
          attrs.$set('ngf-pattern', 'preset.accept');
          attrs.$set('ngf-drop-available', 'isDropAvailable');
          element.removeAttr('upload-file'); // Prevents compile creating an infinite loop
          element.addClass('upload-file');
          $compile(element)(scope);
          // We might be contained within a fullscreenUpload directive, communicate to it if possible
          // ...this can be disabled by adding upload-fullscreen="false" to the element
          if(fullscreenUploadCtrl && (!attrs['uploadFullscreen'] || attrs['uploadFullscreen'] !== 'false')){
            fullscreenUploadCtrl.setListener(scope.onFileSelect);
            scope.$on('$destroy', function() {
              fullscreenUploadCtrl.unsetListener(scope.onFileSelect);
            });
          }
        },
      };
    }]);
})();

},{"../upload/uploadPresets.constant.js":326}],326:[function(require,module,exports){
/** UPLOAD PRESETS
 *
 *    Settings for the various buckets that we can upload to.
 *
 *    To see which canned ACL rules are available, go to:
 *     http://docs.aws.amazon.com/AmazonS3/latest/dev/acl-overview.html#canned-acl
 *
 *    Don't use mime-types in the 'accept' value as they slow down the browser
 *     file-select modal, clearly because it has to read all the file headers.
 */
angular
  .module('app')
  .constant('uploadPresets', {
    'default': {
      accept: '.png,.jpg,.jpeg,.gif',
      size: '5Mb',
      policy: '/s3_policy/',
      acl: 'public-read',
    },
    'issuerImage': {
      accept: '.png,.jpg,.jpeg,.gif',
      size: '5Mb',
      policy: '/s3_policy/templates/',
      acl: 'public-read',
    },
    'evidence': {
      accept: '',
      size: '20Mb',
      policy: '/s3_policy/evidence/',
      acl: 'public-read',
      folder: 'temp/',
    },
    'issuerSpreadsheet': {
      accept: '.xls,.xlsx,.csv,.txt',
      size: '20Mb',
      policy: '/s3_policy/organizations/',
      acl: 'public-read',
    },
    'issuerFiles': {
      accept: '',
      size: '20Mb',
      policy: '/s3_policy/organizations/',
      acl: 'public-read',
    },
  });

},{}],327:[function(require,module,exports){
/** ATTRIBUTE NAME : VALIDATOR
 *
 *      Validates a CUSTOM attribute name, via the attributeService.
 *
 *      We can pass an (optional) attribute id to make sure we
 *       don't trigger "attribute name already exists" for the
 *       existing attribute.
 *
 *          <input name="myName" type="text" ng-model="attribute.name" validate-attribute-name required>
 *          <input name="myName" type="text" ng-model="attribute.name" validate-attribute-name="attribute.id" required>
 *
 *      @author   David "oodavid" King
 */
validateAttributeNameDirective.$inject = ['attributeService'];
function validateAttributeNameDirective(attributeService){
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      attributeId: '=?validateAttributeName',
    },
    link: validateAttributeNameLink
  };

  function validateAttributeNameLink(scope, elem, attr, ngModel) {
    // Must contain at least one alpha character
    ngModel.$validators.alphaRequired = function(modelValue, viewValue) {
      var value = modelValue || viewValue;
      return value && !attributeService.isNameNonAlpha(value);
    };
    // Must only contain certain characters
    ngModel.$validators.invalidCharacters = function(modelValue, viewValue) {
      var value = modelValue || viewValue;
      return value && !attributeService.isNameValidChars(value);
    };
    // Can't be duplicate. Pass the attribute ID (if we know it)
    ngModel.$validators.duplicateAttribute = function(modelValue, viewValue) {
      var value = modelValue || viewValue;
      return value && !attributeService.isNameDuplicate(value, scope.attributeId);
    };
    // Can't be reserved
    ngModel.$validators.reservedAttribute = function(modelValue, viewValue) {
      var value = modelValue || viewValue;
      return value && !attributeService.isNameReserved(value);
    };
  }
}

angular
  .module('app')
  .directive('validateAttributeName', validateAttributeNameDirective);

},{}],328:[function(require,module,exports){
/** DOMAIN : VALIDATOR
 *
 *      Validates domains. Specifically for CNAME values.
 *
 *      <input type="text" validate-domain>
 *
 *      This will automatically convert URLs into Domains, ie:
 *
 *        http://oodavid.com/
 *          becomes
 *        oodavid.com
 *
 *      @author   David "oodavid" King
 */
validateDomainDirective.$inject = [];
function validateDomainDirective(){
  // http://myregexp.com/examples.html
  var regexDomain = /^([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}$/;
  // My own
  var regexUrlPrefix = /^https?\:\/\//;
  var regexUrlSuffix = /\/.*$/;
  // The parser allows us to strip out http:// and other URL-like characters
  var parseDomain = function(value) {
    if (value) {
      value = value.replace(regexUrlPrefix, '');
      value = value.replace(regexUrlSuffix, '');
      return value;
    }
    return '';
  };
  // The validator runs AFTER the parser
  var getDomainValidator = function() {
    return function(modelValue, viewValue) {
      var value = modelValue || viewValue;
      return !value || regexDomain.test(value);
    };
  };
  // Link
  function validateDomainDirectiveLink(scope, elem, attr, ngModel) {
    ngModel.$parsers.push(parseDomain);
    ngModel.$validators.domain = getDomainValidator();
    if(!attr.placeholder){
      attr.$set('placeholder', 'domain.com'); // Set the placeholder if we don't have one
    }
  }
  // Our directive
  return {
    restrict: 'A',
    require: 'ngModel',
    link: validateDomainDirectiveLink
  };
}

angular
  .module('app')
  .directive('validateDomain', validateDomainDirective);

},{}],329:[function(require,module,exports){
/** EMAIL VERIFIED SENDER : VALIDATOR
 *
 *      Automatically checks with the backend to see if
 *       the email address has been verified (via SES)
 *       to send email.
 *
 *      MUST be used in conjunction with validate-email
 *       otherwise we're not validating the email itself.
 *
 *          <input type="email" validate-email validate-email-verified-sender>
 *
 *      This exposes a custom property on the ngModel:
 *          ngModel.$emailVerified === null       unknown. the input will be empty or invalid
 *          ngModel.$emailVerified === 'loading'  we're busy checking with the API
 *          ngModel.$emailVerified === true       yup, it's validated
 *          ngModel.$emailVerified === false      nope, it's not
 *
 *      @author   David "oodavid" King
 */
validateEmailVerifiedSenderDirective.$inject = ['$q', 'api'];
function validateEmailVerifiedSenderDirective($q, api){
  // Our directive
  return {
    restrict: 'A',
    require: 'ngModel',
    link: validateEmailVerifiedSenderDirectiveLink,
  };
  // Link
  function validateEmailVerifiedSenderDirectiveLink(scope, elem, attr, ngModel) {
    // This MUST be accompanied by validate-email
    if (!attr.hasOwnProperty('validateEmail')) {
      console.warn('Input is missing [validate-email], refusing to implement [validate-email-verified-sender]');
      return;
    }
    ngModel.$emailVerified = null;
    // Debounce / Throttle request to the API
    var checkAPI = _.debounce(function(value) {
      api.request('/email_settings/check_from_email_is_confirmed', {
          email: value
        })
        .then(function(response) {
          ngModel.$emailVerified = response.verified;
        });
    }, 1000);
    // Checks the address and updates the custom ngModel.$emailVerified property
    var checkEmailAddress = function() {
      ngModel.$emailVerified = null;
      if (ngModel.$valid) {
        var value = ngModel.$modelValue || ngModel.$viewValue;
        if (value) {
          ngModel.$emailVerified = 'loading';
          checkAPI(value);
        }
      }
    };
    // Listen for changes (and init)
    scope.$watch(function() {
      return ngModel.$modelValue;
    }, checkEmailAddress);
  }
}

angular
  .module('app')
  .directive('validateEmailVerifiedSender', validateEmailVerifiedSenderDirective);



// Below is my original code that had API throttling and proper async validation
// I decided against it as I wasn't sure where or when we would want to invalidate
//  the form just because the address wasn't verified


/** EMAIL VERIFIED SENDER : VALIDATOR
 *
 *      Performs an asyncronous validation on an inputted
 *       email address that checks with the backend to
 *       see if the address has been verified (via SES)
 *       to be used to send email.
 *
 *      MUST be used in conjunction with validate-email
 *       otherwise we're not validating the email itself
 *
 *      This can run in two modes:
 *
 *          Warn
 *              Never sets an $error / $invalid-ates
 *              <input type="email" validate-email validate-email-verified-sender="warn">
 *
 *          Error
 *              Will set an $error & $invalid-ate if the address has not been verified
 *              <input type="email" validate-email validate-email-verified-sender="error">
 *
 *      Why would you want this?
 *
 *      @author   David "oodavid" King
 * /
(function() {
    angular
        .module('app')
        .directive('validateEmailVerifiedSender', ['$timeout', '$q', 'api', function($timeout, $q, api){
            // Our directive
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function(scope, elem, attr, ngModel) {
                    var showErrors = false;
                    if(attr.validateEmailVerifiedSender === "error"){
                        showErrors = true;
                    } else if(attr.validateEmailVerifiedSender !== "warn"){
                        console.error('validate-email-verified-sender must run in "warn" or "error" mode, check your attributes');
                        return;
                    }
                    // Manual throttling / debouncing
                    var throttle = null;
                    var deferred = $q.defer();
                    // Respond (and tidy up for throttling)
                    var respond = function(isVerified){
                        if(showErrors && isVerified === false){
                            deferred.reject();
                        } else {
                            deferred.resolve();
                        }
                        ngModel.$verified = isVerified; // This is a custom ngModel attribute
                        deferred = $q.defer();
                        throttle = null;
                    };
                    // Runs post-throttle
                    var runLater = function(value) {
                        if(ngModel.$invalid){
                            respond(false); // We're invalid so not bothering to check
                        } else if (value){
                            api.request('/email_settings/send_ses_email', { email: value })
                                .then(function(response){
                                    respond(response.verified);
                                });
                        } else {
                            respond(); // No value is OK, the input may have a "required" flag, in which case the $invalid statement above will catch that
                        }
                    };
                    // The validator
                    ngModel.$asyncValidators.verified = function(modelValue, viewValue) {
                        var value = modelValue || viewValue;
                        ngModel.$verified = 'loading';
                        if(throttle){
                            $timeout.cancel(throttle);
                        }
                        throttle = $timeout(function(){ runLater(value); }, 500);
                        // Return the promise
                        return deferred.promise;
                    };
                }
            };
        }]);
})();

*/

},{}],330:[function(require,module,exports){
/** EMAIL : VALIDATOR
 *
 *    Adds email validation to an input. This updates the built-in
 *     AngularJS logic with a superior regex.
 *
 *      <input type="email" validate-email>
 *
 *    @author   David "oodavid" King
 */
require('../_services/email.service.js');

validateEmailDirective.$inject = ['emailService'];
function validateEmailDirective(emailService){
  // Validator
  function validateEmail(modelValue, viewValue){
    return emailService.isValid(modelValue || viewValue);
  }
  // Link
  function validateEmailDirectiveLink(scope, elem, attr, ngModel) {
    ngModel.$validators.email = validateEmail; // REPLACE the default angular validator with our own
    if (!attr.placeholder) {
      attr.$set('placeholder', '...@...'); // Set the placeholder if we don't have one
    }
  }
  // Our directive
  return {
    restrict: 'A',
    require: 'ngModel',
    link: validateEmailDirectiveLink,
  };
}

angular
  .module('app')
  .directive('validateEmail', validateEmailDirective);

},{"../_services/email.service.js":164}],331:[function(require,module,exports){
/** EMAIL : VALIDATOR
 *
 *    Validates a set of email addresses.
 *
 *    <input type="text" validate-emails>
 *
 *    @author   Alan Heppenstall
 */
require('../_services/email.service.js');

validateEmailsDirective.$inject = ['emailService'];
function validateEmailsDirective(emailService){
  // Link
  function validateEmailsDirectiveLink(scope, elem, attr, ngModel) {
    ngModel.$validators.emails = validateEmailsDirectiveValidator; // REPLACE the default angular validator with our own
    if (!attr.placeholder) {
      attr.$set('placeholder', '...@..., ...@...'); // Set the placeholder if we don't have one
    }
  }
  // The validator
  function validateEmailsDirectiveValidator(modelValue, viewValue) {
    var value = modelValue || viewValue;
    if (value && value.length > 0) {
      var emails = value.split(",");
      for (var i = emails.length - 1; i >= 0; i--) {
        var email = emails[i].trim();
        if (!emailService.isValid(email)) {
          return false;
        }
      }
    }
    return !value || true;
  };
  // Our directive
  return {
    restrict: 'A',
    require: 'ngModel',
    link: validateEmailsDirectiveLink
  };
}

angular
  .module('app')
  .directive('validateEmails', validateEmailsDirective);

},{"../_services/email.service.js":164}],332:[function(require,module,exports){
/** GROUP NAME UNIQUE : VALIDATOR
 *
 *    Performs an asyncronous check to see if a group.name
 *     is avaialble. MUST pass the current group.id as
 *     a parameter in order to prevent the current group
 *     comparing to itself!
 *
 *      <input type="text" validate-group-name-unique="group.id" ng-model-options="{ debounce: 200 }">
 *
 *    @author   David "oodavid" King
 */
validateGroupNameUniqueDirective.$inject = ['$q', 'api'];
function validateGroupNameUniqueDirective($q, api){
  // Our directive
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      validateGroupNameUnique: '='
    },
    link: validateGroupNameUniqueDirectiveLink,
  };
  // Link
  function validateGroupNameUniqueDirectiveLink(scope, element, attrs, ngModelCtrl) {
    ngModelCtrl.$asyncValidators.groupNameInUse = function(modelValue, viewValue) {
      var deferred = $q.defer();
      var value = modelValue || viewValue;
      if (value) {
        api.request("/groups/check_group_name_uniqueness", {
            group_name: value
          })
          .then(function(response) {
            if (response.group_id && response.group_id !== scope.validateGroupNameUnique) {
              deferred.reject();
            } else {
              deferred.resolve();
            }
          })
          .catch(function(err) {
            deferred.reject();
          });
      } else {
        deferred.resolve();
      }
      return deferred.promise;
    };
  }
}

angular
.module('app')
.directive('validateGroupNameUnique', validateGroupNameUniqueDirective);



},{}],333:[function(require,module,exports){
/** IMAGE : VALIDATOR
 *
 *      Passes the image URL to the API that will load the file
 *       and check that the file has an image/* content-type.
 *
 *      Must be used alongside `validate-url` to ensure we
 *       don't hammer the API with URLs that are known to fail
 *
 *          <input type="url" validate-url validate-image>
 *
 *      See also `validateUrl`
 *
 *      Note - I have manually debounced this validator
 *
 *      @author   David "oodavid" King
 */
validateImageDirective.$inject = ['$q', '$timeout', 'api'];
function validateImageDirective($q, $timeout, api){
  return {
    restrict: 'A',
    require: 'ngModel',
    link: validateImageDirectiveLink,
  };
  // Link
  function validateImageDirectiveLink(scope, elm, attr, model) {
    // This MUST be accompanied by validate-url
    if (!attr.hasOwnProperty('validateUrl')) {
      console.warn('Input is missing [validate-url], refusing to implement [validate-image]');
      return;
    }
    // Add the validator
    var pendingValidation = false;
    model.$asyncValidators.image = function(modelValue, viewValue) {
      // Debounced
      if(pendingValidation){
        $timeout.cancel(pendingValidation);
      }
      pendingValidation = $timeout(function() {
        pendingValidation = false;
        return $q(function(resolve, reject) {
          var value = modelValue || viewValue;
          if (!value) {
            resolve();
          } else {
            api.request('/utility/is_image', {
                image: value
              })
              .then(resolve, reject);
          }
        });
      }, 600);
      // Return the $timeout promise
      return pendingValidation;
    };
  }
}
angular
  .module('app')
  .directive('validateImage', validateImageDirective);


},{}],334:[function(require,module,exports){
/** LINKED IN ID : VALIDATOR
 *
 *    Automatically validates and parses LinkedIn IDs taken from:
 *
 *      https://addtoprofile.linkedin.com/
 *
 *    <input validate-linkedin-id="school">
 *    <input validate-linkedin-id="company">
 *
 *    @author   David "oodavid" King
 */
validateLinkedinIdDirective.$inject = ['urlService'];
function validateLinkedinIdDirective(urlService){
  // The parser allows the user to enter any kind of value
  //   ...HOWEVER our model value only knows about the resulting linkedIn id (neat!)
  var parseLinkedInId = function(value) {
    if (value) {
      var parsedUrl = urlService.parse(value);
      if (parsedUrl.hostname.indexOf('linkedin.com') !== 1 && parsedUrl.query._ed) {
        value = parsedUrl.query._ed;
      }
      return value;
    }
    return '';
  };
  // The validator runs AFTER the parser, so simply needs to validate the LinkedIn id
  var validateLinkedInId = function(modelValue, viewValue, expectedLength) {
    var value = modelValue || viewValue;
    return !value || value.length === expectedLength;
  };
  // Link
  function validateLinkedinIdDirectiveLink(scope, elem, attr, ngModel) {
    // School = 109 chars, Company = 130
    var expectedLength = (attr.validateLinkedinId === 'school' ? 109 : 130);
    // Add them
    ngModel.$parsers.push(function(value) {
      return parseLinkedInId(value);
    });
    ngModel.$validators.linkedInId = function(modelValue, viewValue) {
      return validateLinkedInId(modelValue, viewValue, expectedLength);
    };
  }
  // Our directive
  return {
    restrict: 'A',
    require: 'ngModel',
    link: validateLinkedinIdDirectiveLink,
  };
}

angular
  .module('app')
  .directive('validateLinkedinId', validateLinkedinIdDirective);

},{}],335:[function(require,module,exports){
/** MATCH : VALIDATOR
 *
 *      Use to make sure that two input values match
 *
 *      Example - make sure 2 emails match.
 *                Note that the second input doesn't need an ng-model (it's optional)
 *
 *          <input type="email" ng-model="email"       validate-email>
 *          <input type="email" validate-match="email" validate-email>
 *
 *      Example - make sure 2 passwords match.
 *                In this example, I've given the second input an ng-model
 *
 *          <input type="password" ng-model="password">
 *          <input type="password" ng-model="passwordAgain" validate-match="password">
 *
 *      @author   David "oodavid" King
 */
validateMatchDirective.$inject = ['$compile'];
function validateMatchDirective($compile){
  return {
    restrict: 'A',
    require: '?ngModel',
    link: validateMatchDirectiveLink
  };
  // Link
  function validateMatchDirectiveLink(scope, elem, attr, ngModel) {
    // Magic trick - add an ngModel if we need one
    if (!ngModel) {
      elem.attr('ng-model', 'randomModel' + Date.now());
      elem.unbind();
      $compile(elem)(scope);
      // Don't do anything else
      return;
    }
    // This section is reached when we have a model
    var me = attr.ngModel;
    var matchTo = attr.validateMatch;
    scope.$watchGroup([me, matchTo], function(value) {
      ngModel.$setValidity('match', value[0] === value[1]);
    });
  }
}

angular
  .module('app')
  .directive('validateMatch', validateMatchDirective);

},{}],336:[function(require,module,exports){
/** NO HTML : VALIDATOR
 *
 *    Adds no html validation to an input.
 *
 *      <input type="text" validate-no-html>
 *
 *    @author   Andrew Bateman
 */
function validateNoHtmlDirective() {
  // Validator
  function validateNoHtml(modelValue, viewValue) {
    var value = modelValue || viewValue;
    var regexHasHtml = /<[a-z]\W*.*?>/i; // This is pretty good, but will reject a<b and b>c
    return !regexHasHtml.test(value);
  }
  // Link
  function validateNoHtmlDirectiveLink(scope, elem, attr, ngModel) {
    ngModel.$validators.noHtml = validateNoHtml; // REPLACE the default angular validator with our own

  }
  // Our directive
  return {
    restrict: 'A',
    require: 'ngModel',
    link: validateNoHtmlDirectiveLink,
  };
}

angular
  .module('app')
  .directive('validateNoHtml', validateNoHtmlDirective);

},{}],337:[function(require,module,exports){
/** PIXELS : VALIDATOR
 *
 *      Input utility that displays a number in the input,
 *       but the model value includes the "px" suffix.
 *
 *          $scope.pixelWidth = '30px';
 *          <input type="number" validate-px ng-model="pixelWidth"> pixels
 *
 *      @author   David "oodavid" King
 */
validatePxDirective.$inject = [];
function validatePxDirective(){
  return {
    restrict: 'A',
    require: 'ngModel',
    link: validatePxDirectiveLink,
  };
  // Link
  function validatePxDirectiveLink(scope, elem, attrs, ngModelCtrl) {
    ngModelCtrl.$formatters.push(function(value) {
      return parseInt(value);
    });
    ngModelCtrl.$parsers.push(function(value) {
      return value + 'px';
    });
  }
}

angular
  .module('app')
  .directive('validatePx', validatePxDirective);

},{}],338:[function(require,module,exports){
/** TWITTER HANDLE : VALIDATOR
 *
 *    Automatically validates and parses twitter handles
 *     a bespoke validator that I'm rather proud of.
 *
 *      https://twitter.com/oodavid
 *      @oodavid
 *      oodavid
 *
 *    <input type="text" validate-twitter-handle>
 *
 *    @author   David "oodavid" King
 */
validateTwitterHandleDirective.$inject = [];
function validateTwitterHandleDirective(){
  var regexUrl = /twitter\.com\/(#!\/)?\@?([a-zA-Z0-9_]{1,15})/;
  var regexChars = /^\@?([a-zA-Z0-9_]{1,15})$/;
  var regexHandle = /^[a-zA-Z0-9_]{1,15}$/;
  // The parser allows the user to enter any kind of value
  //   ...HOWEVER our model value only knows about the resulting twitter handle (neat!)
  var parseTwitterHandle = function(value) {
    if (value) {
      var matchUrl = value.match(regexUrl);
      if (matchUrl) {
        value = matchUrl[2];
      }
      var matchChars = value.match(regexChars);
      if (matchChars) {
        value = matchChars[1];
      }
      return value;
    }
    return '';
  };
  // The validator runs AFTER the parser, so simply needs to validate the handle
  var validateTwitterHandle = function(modelValue, viewValue) {
    var value = modelValue || viewValue;
    return !value || regexHandle.test(value);
  };
  // Link
  function validateTwitterHandleDirectiveLink(scope, elem, attr, ngModel) {
    ngModel.$parsers.push(parseTwitterHandle);
    ngModel.$validators.twitterHandle = validateTwitterHandle;
    if (!attr.placeholder) {
      attr.$set('placeholder', '@username'); // Set the placeholder if we don't have one
    }
  }
  // Our directive
  return {
    restrict: 'A',
    require: 'ngModel',
    link: validateTwitterHandleDirectiveLink,
  };
}

angular
  .module('app')
  .directive('validateTwitterHandle', validateTwitterHandleDirective);

},{}],339:[function(require,module,exports){
/** URL : VALIDATOR
 *
 *      Not only validates URLs, but automatically
 *       prefixes "http://" where missing.
 *
 *          <input type="url" validate-url>
 *
 *      You can request that the URL is within a certain domain,
 *      This is a pretty relaxed check, but still:
 *
 *          <input type="url" validate-url="facebook.com">
 *
 *      @author   David "oodavid" King
 */
require('../_services/url.service.js');

validateUrlDirective.$inject = ['urlService'];
function validateUrlDirective(urlService){
  // The parser allows the user to enter any kind of value
  //   ...HOWEVER our model value only knows about the resulting url (neat!)
  var parseUrl = function(value) {
    if (value) {
      if (!urlService.isValid(value)) {
        value = 'http://' + value;
      }
      return value;
    }
    return '';
  };
  // The validator runs AFTER the parser, so simply needs to validate the handle
  var getUrlValidator = function(domain) {
    return function(modelValue, viewValue) {
      var value = modelValue || viewValue;
      return !value || (urlService.isValid(value) && (domain ? value.indexOf(domain) > -1 : true));
    };
  };
  // Link
  function validateUrlDirectiveLink(scope, elem, attr, ngModel) {
    var domain = attr.validateUrl;
    ngModel.$parsers.push(parseUrl);
    ngModel.$validators.url = getUrlValidator(domain); // REPLACE the default angular validator with our own
    if (!attr.placeholder) {
      attr.$set('placeholder', 'http://' + (domain ? (domain + '/...') : '')); // Set the placeholder if we don't have one
    }
  }
  // Our directive
  return {
    restrict: 'A',
    require: 'ngModel',
    link: validateUrlDirectiveLink,
  };
}

angular
  .module('app')
  .directive('validateUrl', validateUrlDirective);

},{"../_services/url.service.js":176}],340:[function(require,module,exports){
/** VALIDATION
 *
 *      Renders validation errors
 *
 *      <validation model="formCtrl.myInput">
 *      <validation model="formCtrl.myInput" left-align="true"> - left align the validation message
 */

require('angular-messages');
angular.module('app').requires.push('ngMessages');

var validationComponent = {
  controller: validationComponentController,
  bindings: {
    model: '<',
    leftAlign: '<?'
  },
  templateUrl: '/shared/validation/validation.html',
  transclude: true,
};

validationComponentController.$inject = [];
function validationComponentController(){
  var $ctrl = this;
  $ctrl.$onInit = $onInit;
  $ctrl.attr;

  // Pull out attributes for `min`, `max`... so we can have messages like "the minlength is 8"
  function $onInit(){
    if($ctrl.model){
      var element = $ctrl.model.$$element;
      $ctrl.attr = {
        maxlength: element.attr('maxlength') || element.attr('ng-maxlength'),
        minlength: element.attr('minlength') || element.attr('ng-minlength'),
        min: element.attr('min') || element.attr('ng-min'),
        max: element.attr('max') || element.attr('ng-max'),
        step: element.attr('step') || element.attr('ng-step'),
      };
    }
  }

}

angular
  .module('app')
  .component('validation', validationComponent);

},{"angular-messages":3}],341:[function(require,module,exports){
/** Vendor Factories
 *
 *      If we are using 3rd party libraries, Angular should
 *       be able to reference them as dependencies. This
 *       factories file is a simple way to expose these libs.
 *
 *      http://www.jvandemo.com/how-to-properly-integrate-non-angularjs-libraries-in-your-angularjs-application/
 *
 *      Factories
 *          _         lodash
 *          WebFont   Google Font Loader
 *          swal      Sweet Alerts
 *          moment    Moment.js date logic
 *          GS        GetSocial (share tracking)
 *
 *    @author   David "oodavid" King
 */
(function() {
  angular.module('app')
    // Lodash
    .factory('_', ['$window',
      function($window) {
        return $window._ || false;
      }
    ])
    // Sweet Alerts (swal)
    .factory('swal', ['$window',
      function($window) {
        return $window.swal || false;
      }
    ])
    // Momentjs
    .factory('moment', ['$window',
      function($window) {
        return $window.myMoment || false;
      }
    ])
    // Entities
    .factory('Entities', ['$window',
      function($window) {
        return $window.Entities || false;
      }
    ])
    // MobileDetect
    .factory('MobileDetect', ['$window',
      function($window) {
        return $window.MobileDetect || false;
      }
    ])
    // QRCode
    .factory('QRCode', ['$window',
      function($window) {
        return $window.QRCode || false;
      }
    ])
    // SHA256
    .factory('SHA256', ['$window',
      function($window) {
        return $window.SHA256 || false;
      }
    ])
    // Google Pay API
    .factory('gapi', ['$window',
      function($window) {
        return $window.gapi || false;
      }
    ])
    // GetSocial
    .factory('GS', ['$window',
      function($window) {
        return $window.GS || false;
      }
    ]);
})();

},{}]},{},[78]);
